import { defineComponent as Ee, ref as j, onMounted as rn, onUnmounted as hc, openBlock as P, createElementBlock as L, createElementVNode as T, createBlock as ue, resolveDynamicComponent as Ln, reactive as zt, computed as J, normalizeStyle as Pt, unref as E, toDisplayString as de, renderSlot as tt, createStaticVNode as wh, normalizeClass as se, inject as ce, watch as Ne, nextTick as bt, createVNode as B, createCommentVNode as re, shallowRef as Uo, watchEffect as Bo, readonly as _4, getCurrentScope as tg, onScopeDispose as W4, warn as WC, getCurrentInstance as sn, provide as _t, onBeforeUnmount as Ti, isRef as Bn, onBeforeMount as Ph, mergeProps as $r, onUpdated as Zo, resolveComponent as Ie, withDirectives as Bt, Fragment as nt, withCtx as N, withModifiers as wt, vShow as Cn, toRef as er, Transition as wa, cloneVNode as KC, Text as ng, Comment as GC, h as et, Teleport as K4, createTextVNode as je, useSlots as YC, resolveDirective as va, renderList as Lt, vModelCheckbox as S0, toRefs as ma, withKeys as nn, vModelRadio as ig, onBeforeUpdate as QC, vModelText as G4, toHandlers as ZC, normalizeProps as E0, guardReactiveProps as k0, createSlots as rg, toRaw as ag, triggerRef as Kc, markRaw as og, TransitionGroup as Y4, isVNode as id, render as lv, pushScopeId as yn, popScopeId as bn, useCssVars as xh } from "vue";
import { Anchor as JC, AnchorLink as $C } from "ant-design-vue";
import { ElMessageBox as eS, ElMessage as yi } from "element-plus";
const tS = { class: "captcha-warp" }, nS = Ee({
  name: "zhs-captcha"
}), vd = /* @__PURE__ */ Ee({
  ...nS,
  emits: ["success"],
  setup(e, { expose: t, emit: n }) {
    const r = "script", i = j();
    return t({
      show: () => {
        i.value.click();
      }
    }), rn(() => {
      window.captchaCb = (a) => {
        a.ret === 0 && n("success", a);
      };
    }), hc(() => {
      window.__CaptchaExists__ = null;
    }), (a, o) => (P(), L("div", tS, [
      T("div", {
        id: "CaptchaEl",
        ref_key: "CaptchaEl",
        ref: i,
        "data-appid": "2036785952",
        "data-cbfn": "captchaCb",
        "data-module": "0",
        type: "primary",
        style: { display: "none" }
      }, null, 512),
      (P(), ue(Ln(r), { src: "https://captcha.253.com/Captcha.js" }))
    ]));
  }
});
vd.name = "captcha";
vd.install = (e) => {
  e.component(vd.name, vd);
};
const sg = "data:image/png;base64,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", lg = "data:image/png;base64,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", ug = "data:image/png;base64,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", iS = { class: "empty" }, rS = ["src"], aS = { class: "empty-text" }, oS = { class: "empty__description" }, sS = /* @__PURE__ */ Ee({
  props: {
    type: {
      type: String,
      default: "course"
    },
    width: {
      type: String,
      default: "80px"
    },
    description: {
      type: String,
      default: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9"
    }
  },
  setup(e) {
    const t = e, n = (a) => new URL((/* @__PURE__ */ Object.assign({ "../../../assets/img/empty/empty_course.png": sg, "../../../assets/img/empty/empty_message.png": lg, "../../../assets/img/empty/empty_person.png": ug }))[`../../../assets/img/empty/${a}.png`], self.location).href, r = zt({
      course: n("empty_course"),
      message: n("empty_message"),
      person: n("empty_person")
    }), i = J(() => r[t.type]);
    return (a, o) => (P(), L("div", iS, [
      T("img", {
        class: "empty__image",
        style: Pt({ width: e.width }),
        src: E(i)
      }, null, 12, rS),
      T("div", aS, [
        T("div", oS, de(e.description), 1),
        tt(a.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
});
const Ht = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, bi = /* @__PURE__ */ Ht(sS, [["__scopeId", "data-v-0d7ee6b3"]]);
bi.name = "empty";
bi.install = (e) => {
  e.component(bi.name, bi);
};
const lS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, uS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0Zm-3.428 15.87 2.559 2.559-.845.857-2.571-2.572-2.572 2.572L6 18.429l2.571-2.56L6 13.343l.857-.913L9.43 15 12 12.43l.857.913-2.571 2.528Z",
    "fill-rule": "evenodd",
    fill: "#2DBF79",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#67DEA5",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), cS = [
  uS
];
function cg(e, t) {
  return P(), L("svg", lS, cS);
}
const dS = { render: cg }, fS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: cg,
  default: dS
}, Symbol.toStringTag, { value: "Module" })), hS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, pS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0Zm-12 14.571v4.286h.857v-1.714h1.715v1.714h.857v-4.286h-.857v1.715H2.572V14.57h-.858Zm3.857 0v.857h1.286v3.429h.857v-3.429H9v-.857H5.57Zm3.858 0v4.286h.857v-2.143l.857 2.143H12l.857-2.143v2.143h.857v-4.286h-.857L11.594 18h-.022l-1.286-3.429h-.857Zm5.142 0h.857V18h1.715v.857H14.57v-4.286Z",
    "fill-rule": "evenodd",
    fill: "#93A5C5",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#B6C8E7",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), vS = [
  pS
];
function dg(e, t) {
  return P(), L("svg", hS, vS);
}
const mS = { render: dg }, gS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: dg,
  default: mS
}, Symbol.toStringTag, { value: "Module" })), yS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, bS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0Zm-.021 19.337c.07.34-.035.665-.307.94-.223.192-.468.294-.729.294-.854 0-1.596-1.032-2.278-2.626-.688-.289-1.401-.534-2.068-.705-1.017.672-1.947 1.1-2.706 1.1-.627 0-1.092-.329-1.26-.895-.117-.398-.053-.75.128-.978.273-.381.803-.56 1.574-.56.576 0 1.29.098 2.072.287.482-.349.944-.733 1.354-1.128-.315-1.54-.324-2.783.202-3.46.34-.43.869-.566 1.469-.385.57.169.893.519 1.006.952.22.892-.442 1.987-1.602 3.203.175.682.37 1.296.592 1.841 1.486.682 2.418 1.365 2.553 2.12ZM11.207 12.4c-.018-.09-.088-.17-.348-.246a.572.572 0 0 0-.215-.045.256.256 0 0 0-.216.1c-.22.276-.271 1.01-.128 1.988.653-.774.99-1.456.907-1.797Zm-1.288 4.326a15.29 15.29 0 0 1-.181-.591c-.15.128-.301.255-.451.378.211.066.423.137.632.213Zm-3.872.15c-.505 0-.73.082-.779.136l-.014.027c-.009.02-.01.057.014.145.034.139.108.199.337.199.317 0 .768-.149 1.315-.433a5.914 5.914 0 0 0-.873-.074Zm6.61 2.738c.003 0 .016-.006.044-.028.026-.027.034-.034.035-.043 0-.004 0-.008-.002-.014v-.001c-.039-.2-.352-.511-.914-.858.356.6.684.944.837.944Z",
    "fill-rule": "evenodd",
    fill: "#E65354",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#EF8D8E",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), AS = [
  bS
];
function fg(e, t) {
  return P(), L("svg", yS, AS);
}
const TS = { render: fg }, wS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: fg,
  default: TS
}, Symbol.toStringTag, { value: "Module" })), PS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, xS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0ZM8.143 13.286v6.428H6.857V12h3.429c1.822 0 2.785 1.168 2.785 2.571 0 1.404-.963 2.572-2.785 2.572H9v-1.286h1.286c1.052 0 1.5-.543 1.5-1.286 0-.742-.448-1.285-1.5-1.285H8.143Z",
    "fill-rule": "evenodd",
    fill: "#F07753",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#F89577",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), CS = [
  xS
];
function hg(e, t) {
  return P(), L("svg", PS, CS);
}
const SS = { render: hg }, ES = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: hg,
  default: SS
}, Symbol.toStringTag, { value: "Module" })), kS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, OS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M0 0h13.714l5.143 5.143V24H0V0Zm5.245 13.886h1.431v-1.029H2.571v1.029h1.43L3.99 18h1.244l.012-4.114ZM11.927 18l-1.771-2.557 1.762-2.586h-1.474l-1.055 1.635-.974-1.635H6.892l1.696 2.589L6.726 18h1.536l1.09-1.618L10.407 18h1.52Zm.23-4.126h1.427L13.572 18h1.267l.012-4.126h1.435v-1.017h-4.13v1.018Z",
    "fill-rule": "evenodd",
    fill: "#A8A8A8",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#D5D5D5",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), zS = [
  OS
];
function pg(e, t) {
  return P(), L("svg", kS, zS);
}
const DS = { render: pg }, MS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: pg,
  default: DS
}, Symbol.toStringTag, { value: "Module" })), HS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, IS = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0Zm-9.02 12.857 1.5 6h1.362l1.872-4.368 1.872 4.368h1.362l1.5-6h-1.325l-.998 3.993-1.711-3.993H8.729L7.018 16.85l-.998-3.993H4.694Z",
    "fill-rule": "evenodd",
    fill: "#61A6FF",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#BEDAFE",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), LS = [
  IS
];
function vg(e, t) {
  return P(), L("svg", HS, LS);
}
const BS = { render: vg }, NS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: vg,
  default: BS
}, Symbol.toStringTag, { value: "Module" })), jS = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18",
  height: "18"
}, FS = /* @__PURE__ */ T("g", { style: { opacity: ".6000000238418579", "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M3.6 3.6A3.6 3.6 0 0 1 7.2 0h7.2A3.6 3.6 0 0 1 18 3.6v7.2a3.6 3.6 0 0 1-3.6 3.6h-.02A4 4 0 0 1 10.4 18H4a4 4 0 0 1-4-4V7.6a4 4 0 0 1 3.6-3.98V3.6Zm1.8 0h5a4 4 0 0 1 4 4v5q.746 0 1.273-.527.527-.527.527-1.273V3.6q0-.746-.527-1.273Q15.146 1.8 14.4 1.8H7.2q-.746 0-1.273.527Q5.4 2.854 5.4 3.6Zm1.178 3.6v2.966H3.6v1.254h2.978v2.98h1.258v-2.98H10.8v-1.254H7.836V7.2H6.578Z",
    "fill-rule": "evenodd",
    fill: "currentColor",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), XS = [
  FS
];
function mg(e, t) {
  return P(), L("svg", jS, XS);
}
const RS = { render: mg }, VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: mg,
  default: RS
}, Symbol.toStringTag, { value: "Module" })), US = {
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, qS = /* @__PURE__ */ T("path", {
  d: "M13.61 2.055h-2.79V.992a.133.133 0 0 0-.133-.133h-.93a.133.133 0 0 0-.132.133v1.063h-4.25V.992A.133.133 0 0 0 5.242.86h-.93a.133.133 0 0 0-.132.133v1.063H1.39a.53.53 0 0 0-.53.53V13.61a.53.53 0 0 0 .53.532h12.22a.53.53 0 0 0 .53-.532V2.586a.53.53 0 0 0-.53-.531Zm-.665 10.89H2.055V3.25H4.18v.797c0 .073.06.133.133.133h.93c.072 0 .132-.06.132-.133V3.25h4.25v.797c0 .073.06.133.133.133h.93c.073 0 .132-.06.132-.133V3.25h2.125v9.695Zm-2.523-6.972h-.917a.27.27 0 0 0-.215.11L6.784 9.531 5.71 8.054a.267.267 0 0 0-.215-.11h-.917a.133.133 0 0 0-.108.212l2.099 2.888a.267.267 0 0 0 .431 0l3.53-4.859a.134.134 0 0 0-.108-.212Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), _S = [
  qS
];
function gg(e, t) {
  return P(), L("svg", US, _S);
}
const WS = { render: gg }, KS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: gg,
  default: WS
}, Symbol.toStringTag, { value: "Module" })), GS = {
  class: "icon",
  width: "200",
  height: "199.8",
  viewBox: "0 0 1025 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, YS = /* @__PURE__ */ wh('<path d="M640.467 1023.429c-49.257 0-101.143-8.686-154.172-25.829-77.485-25.029-136.457-33.371-183.885-40-58.286-8.114-108.686-15.2-154.515-49.829-45.714-34.628-79.2-85.714-102.171-156.457C26.181 691.43 12.695 613.486 3.095 506.057c-7.2-81.371-1.828-155.086 16-218.971 17.143-61.257 45.829-114.172 85.258-157.257 40.571-44.229 92-77.829 152.8-99.772C311.667 10.514 372.924.571 438.98.571c21.829 0 44.229 1.143 66.743 3.315 81.143 7.885 148.343 29.143 205.257 64.8 51.2 32.114 96.8 77.371 143.429 142.285 11.885 16.458 27.885 32.458 44.8 49.258 45.143 44.8 101.143 100.571 116.571 204.342 12.8 86.172 10.514 168-6.857 243.2-17.371 75.658-49.029 140.458-93.943 192.458-33.828 39.2-74.286 69.714-120 90.628-47.086 21.6-99.086 32.572-154.514 32.572z" fill="#25467A"></path><path d="M50.981 501.714C18.638 137.83 257.724 28 501.038 51.657c152.115 14.857 234.857 76.686 314.4 187.429 47.772 66.4 134.286 107.428 152.915 232.571 49.6 333.829-148.572 583.429-467.315 480.343-174.171-56.457-256.8-31.543-324.343-82.514-77.142-58.4-108.571-173.6-125.714-367.772z" fill="#FFA726"></path><path d="M640.467 952.571c-41.829 0-86.4-7.542-132.343-22.4C424.81 903.2 362.41 894.514 312.238 887.43c-54.4-7.658-90.4-12.686-121.714-36.229-34.171-25.829-58.857-64.457-77.486-121.714-17.828-54.743-30.4-127.772-39.428-229.715-12.343-140 15.543-248.342 82.971-322.057 32.686-35.657 74.629-62.971 124.572-80.914C328.01 80 381.038 71.429 438.98 71.429c19.543 0 39.657 1.028 59.886 2.971 70.971 6.857 126.4 24.229 174.514 54.286 43.772 27.428 81.943 65.6 123.543 123.657 15.314 21.257 34.171 40 52.457 58.171 41.486 41.257 84.457 83.886 96.457 164.457 22.629 152.458-8.114 290.629-84.343 378.972-55.657 64.571-132.114 98.628-221.028 98.628z"></path><path d="M123.324 417.714a301.714 283.771 0 1 0 603.429 0 301.714 283.771 0 1 0-603.429 0Z" fill="#FBC02D"></path><path d="M726.753 417.714c0 156.686-135.086 283.772-301.715 283.772-102.514 0-193.028-48-247.543-121.486 53.143 44 122.858 70.743 199.315 70.743 166.628 0 301.714-126.972 301.714-283.772 0-60.342-20-116.228-54.171-162.171 62.857 52 102.4 128.114 102.4 212.914z" fill="#F6B12D"></path><path d="M352.353 186.286c10.285 17.828-30.058 32.685-63.772 52.228s-66.514 51.2-76.8 33.372 17.029-54.515 50.743-73.943 79.543-29.486 89.829-11.657z" fill="#FDEFBA"></path><path d="M400.924 547.657c-38.171 0-69.143-30.971-69.143-69.257a13.803 13.803 0 0 1 13.829-13.829c7.314 0 13.485 5.715 13.828 13.029v.8c.343 22.971 19.315 41.257 42.172 40.8 22.4-.343 40.457-18.4 40.8-40.8-.229-7.657 5.828-14.057 13.371-14.286s14.057 5.829 14.286 13.372v.8c0 38.4-30.972 69.371-69.143 69.371zM221.038 367.771c.343 22.972 19.315 41.258 42.172 40.8 22.4-.342 40.457-18.4 40.8-40.8.343-22.971-17.943-41.828-40.8-42.171s-41.829 17.943-42.172 40.8a2.786 2.786 0 0 0 0 1.371zm276.686 0c.343 22.972 19.2 41.258 42.171 40.915 22.4-.343 40.458-18.4 40.915-40.8v-.115c.343-22.971-17.943-41.828-40.8-42.171s-41.829 17.943-42.172 40.8c-.114.457-.114.914-.114 1.371z" fill="#25467A"></path><path d="M207.21 436.914h-55.315c-15.314 0-27.657 12.343-27.657 27.657 0 15.315 12.343 27.658 27.657 27.658h55.315c15.314 0 27.657-12.343 27.657-27.658 0-15.2-12.343-27.657-27.657-27.657zm442.743 0h-55.315c-15.314 0-27.657 12.343-27.657 27.657 0 15.315 12.343 27.658 27.657 27.658h55.315c15.314 0 27.657-12.343 27.657-27.658 0-15.2-12.343-27.657-27.657-27.657z" fill="#FDEFBA"></path><path d="M682.295 744.229c-46.4 27.2-87.771 39.771-73.6 64.114S687.21 851.2 733.61 824s57.485-89.829 43.2-114.057-48 7.086-94.515 34.286z" fill="#F5F5F5"></path>', 9), QS = [
  YS
];
function yg(e, t) {
  return P(), L("svg", GS, QS);
}
const ZS = { render: yg }, JS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: yg,
  default: ZS
}, Symbol.toStringTag, { value: "Module" })), $S = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "30",
  height: "30"
}, eE = /* @__PURE__ */ T("path", {
  d: "M15 0C6.717 0 0 6.717 0 15c0 8.284 6.717 15 15 15 8.284 0 15-6.716 15-15 0-8.283-6.716-15-15-15Zm-.804 7.5a.269.269 0 0 0-.267.268v9.107c0 .147.12.268.267.268h1.608c.147 0 .267-.12.267-.268V7.768a.269.269 0 0 0-.267-.268h-1.608Zm.804 15a1.607 1.607 0 1 1 0-3.215 1.607 1.607 0 0 1 0 3.215Z",
  "fill-rule": "evenodd",
  fill: "currentColor",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), tE = [
  eE
];
function bg(e, t) {
  return P(), L("svg", $S, tE);
}
const nE = { render: bg }, iE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: bg,
  default: nE
}, Symbol.toStringTag, { value: "Module" })), rE = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, aE = /* @__PURE__ */ wh('<path d="M512 878.286c-120.457 0-182.971-23.429-228.571-40.457-22.4-8.343-37.143-13.943-51.543-13.943-1.486 0-3.086.114-4.686.228-21.486 1.715-37.486 2.4-51.657 2.4-36.572 0-62.743-5.257-84.572-17.143-22.742-12.342-39.657-31.771-50.4-57.714C14.857 727.314 0 693.257 0 657.6c0-23.314 6.057-45.6 17.486-65.143-5.943-21.828-6.057-44.914-.115-67.428 6.058-22.515 17.715-42.4 33.715-58.4C50.97 444 56.8 421.6 68.457 401.486s28-36.457 47.772-47.657c5.714-21.943 17.257-41.943 33.6-58.4 16.457-16.458 36.457-27.886 58.4-33.6 11.2-19.658 27.428-36.115 47.657-47.772 19.657-11.314 41.943-17.371 64.571-17.371h.457c15.886-16.115 35.886-27.772 58.4-33.829A128.391 128.391 0 0 1 412.8 158.4c11.429 0 22.857 1.486 33.829 4.571 19.542-11.428 41.828-17.6 65.142-17.6s45.6 6.058 65.143 17.6c10.972-2.971 22.4-4.571 33.829-4.571a127.75 127.75 0 0 1 33.486 4.457c22.514 6.057 42.514 17.714 58.4 33.829h.457c22.628 0 44.914 5.943 64.571 17.371 20.114 11.657 36.457 28 47.657 47.772 21.943 5.714 41.943 17.257 58.4 33.6 16.457 16.457 27.886 36.571 33.6 58.4 19.657 11.2 36.115 27.428 47.772 47.657C966.743 421.6 972.57 444 972.457 466.629c16.114 15.885 27.772 35.885 33.714 58.4s5.943 45.6-.114 67.428c11.429 19.543 17.486 41.829 17.486 65.143 0 35.2-14.514 68.914-39.543 93.143-10.857 28.228-28.571 49.257-52.571 62.743-23.315 13.143-51.429 18.971-90.972 18.971-12.457 0-26.857-.571-43.771-1.828-1.829-.115-3.543-.229-5.257-.229-15.315 0-30.4 4.914-53.258 12.457-44.8 14.972-106.857 35.429-226.171 35.429z" fill="#25467A"></path><path d="M951.771 599.771C962.4 581.6 966.057 559.43 960.23 537.6c-5.829-21.943-20.115-39.314-38.4-49.714 5.6-20.229 3.314-42.629-8-62.286s-29.6-32.686-49.943-38.057c.114-21.029-7.772-42.057-23.772-58.057s-37.028-24-58.057-23.772c-5.257-20.343-18.4-38.628-38.057-49.943s-42.057-13.6-62.286-8c-10.4-18.285-27.771-32.457-49.714-38.4-21.943-5.828-44.114-2.171-62.171 8.458-14.743-14.972-35.2-24.229-57.943-24.229-22.629 0-43.2 9.257-57.943 24.229-18.172-10.629-40.343-14.286-62.172-8.458-21.942 5.829-39.314 20.115-49.714 38.4-20.228-5.6-42.628-3.314-62.286 8-19.657 11.315-32.685 29.6-38.057 49.943-21.028-.114-42.057 7.772-58.057 23.772s-24 37.028-23.771 58.057c-20.343 5.257-38.629 18.4-49.943 38.057s-13.6 42.057-8 62.286c-18.286 10.4-32.457 27.771-38.4 49.714-5.829 21.943-2.172 44.114 8.457 62.171-14.743 14.743-24 35.2-24 57.829 0 44.914 36.457 81.371 81.371 81.371s81.372-36.457 81.372-81.371c0-14.971-4.114-29.029-11.2-41.143 9.943-9.828 17.6-22.4 21.486-36.8 3.885-14.514 3.542-29.143-.115-42.628C233.143 530.17 243.657 520 251.2 506.97c7.543-13.028 10.971-27.2 10.857-41.257 13.6-3.543 26.4-10.628 37.029-21.143 10.628-10.628 17.714-23.428 21.143-37.028 13.942.114 28.228-3.429 41.257-10.857 13.028-7.543 23.085-18.057 30.057-30.286 13.486 3.771 28.114 4 42.628.114 14.515-3.885 26.972-11.428 36.8-21.485 12.115 7.085 26.172 11.2 41.143 11.2 14.972 0 29.029-4.115 41.143-11.2 9.829 9.942 22.4 17.6 36.8 21.485 14.514 3.886 29.143 3.543 42.629-.114 6.857 12.229 17.028 22.743 30.057 30.286 13.028 7.543 27.2 10.971 41.257 10.857 3.543 13.6 10.629 26.4 21.143 37.028s23.428 17.715 37.028 21.143c-.114 13.943 3.429 28.229 10.858 41.257 7.542 13.029 18.057 23.086 30.285 30.058-3.771 13.485-4 28.114-.114 42.628s11.429 26.972 21.486 36.8c-7.086 12.114-11.2 26.172-11.2 41.143 0 44.914 36.457 81.371 81.371 81.371s81.372-36.457 81.372-81.371c-.229-22.629-9.486-43.086-24.458-57.829z" fill="#FFF7EB"></path><path d="M951.314 643.657c0 130.629-38.971 147.086-150.743 139.086-67.314-4.8-102.742 47.428-288.571 47.428s-221.257-59.2-288.571-54.057C111.657 784.8 72.686 774.286 72.686 643.657 72.686 434.4 269.37 264.686 512 264.686S951.314 434.4 951.314 643.657z" fill="#FFF7EB"></path><path d="M881.371 681.486c0 35.657-6.171 69.943-17.714 102.171-17.828 1.486-38.743.914-63.086-.8-40-2.857-68.8 14.514-124.457 28.914 76.115-42.857 122.857-113.6 115.315-210.4-9.258-117.6-90.286-194.628-128.686-219.314C827.886 437.143 881.37 610.514 881.37 681.486z" fill="#FFEDD1"></path><path d="M877.714 733.371c-.685 8-9.371 7.2-9.371-.8v-.914c0-196-118.4-354.971-356.343-354.971S155.657 535.543 155.657 731.657v.572c0 8-8.686 8.8-9.371.8-1.143-12.343-1.715-26.4-1.715-42.4 0-199.315 132.686-346.515 367.429-346.515s367.429 147.2 367.429 346.515c0 16-.572 30.171-1.715 42.742z" fill="#FFE0B2"></path><path d="M473.371 310.171c2.972 35.429.458 56.572-5.485 57.143s-13.257-19.771-16.229-55.2-.457-64.571 5.486-65.143c6.057-.457 13.257 27.772 16.228 63.2zm-90.857 22.172c11.657 33.371 9.943 44.114 4.343 46.286-5.6 2.171-13.143-5.029-24.686-38.4-11.657-33.372-16.457-62.286-10.742-64.458 5.485-2.171 19.542 23.2 31.085 56.572zm-92.8 43.2c12.8 23.314 11.886 32.114 6.629 35.2-5.257 3.2-12.686-.572-25.486-23.886s-18.971-44.686-13.828-47.886c5.257-3.085 19.885 13.258 32.685 36.572zm-67.2 57.486c18.4 19.2 19.772 27.885 15.543 32.342-4.228 4.343-12.343 2.743-30.743-16.457s-29.943-38.285-25.714-42.628c4.229-4.457 22.514 7.543 40.914 26.743zm-47.657 76.8c23.886 11.771 28.114 19.542 25.714 25.028-2.4 5.6-10.742 6.743-34.514-4.914s-41.257-25.714-38.743-31.314c2.286-5.486 23.657-.572 47.543 11.2zm674.286 0c-23.886 11.771-28.114 19.542-25.714 25.028 2.4 5.6 10.742 6.743 34.514-4.914 23.886-11.772 41.257-25.714 38.743-31.314-2.286-5.486-23.657-.572-47.543 11.2zm-47.657-76.8c-18.4 19.2-19.772 27.885-15.543 32.342 4.228 4.343 12.343 2.743 30.743-16.457s29.943-38.285 25.714-42.628c-4.229-4.457-22.514 7.543-40.914 26.743zm-67.2-57.486c-12.8 23.314-11.886 32.114-6.629 35.2 5.257 3.2 12.686-.572 25.486-23.886s18.971-44.686 13.828-47.886c-5.257-3.085-19.885 13.258-32.685 36.572zm-92.8-43.2c-11.657 33.371-9.943 44.114-4.343 46.286 5.6 2.171 13.143-5.029 24.686-38.4 11.657-33.372 16.457-62.286 10.742-64.458-5.485-2.171-19.542 23.2-31.085 56.572zm-90.857-22.172c-2.972 35.429-.458 56.572 5.485 57.143s13.257-19.771 16.229-55.2.457-64.571-5.486-65.143c-6.057-.457-13.257 27.772-16.228 63.2z" fill="#FFE0B2"></path><path d="M512 728.114c-35.314 0-64-28.685-64-64 0-7.085 5.714-12.8 12.8-12.8s12.8 5.715 12.8 12.8c0 21.257 17.143 38.4 38.4 38.4s38.4-17.143 38.4-38.4c0-7.085 5.714-12.8 12.8-12.8s12.8 5.715 12.8 12.8c0 35.315-28.686 64-64 64zm-166.4-166.4c0 21.257 17.143 38.4 38.4 38.4s38.4-17.143 38.4-38.4-17.143-38.4-38.4-38.4c-21.143 0-38.4 17.143-38.4 38.4zm256 0c0 21.257 17.143 38.4 38.4 38.4s38.4-17.143 38.4-38.4-17.143-38.4-38.4-38.4c-21.143 0-38.4 17.143-38.4 38.4z" fill="#25467A"></path><path d="M332.8 625.714h-51.2c-14.171 0-25.6 11.429-25.6 25.6 0 14.172 11.429 25.6 25.6 25.6h51.2c14.171 0 25.6-11.428 25.6-25.6 0-14.171-11.429-25.6-25.6-25.6zm409.6 0h-51.2c-14.171 0-25.6 11.429-25.6 25.6 0 14.172 11.429 25.6 25.6 25.6h51.2c14.171 0 25.6-11.428 25.6-25.6 0-14.171-11.429-25.6-25.6-25.6z" fill="#FF8A80"></path>', 8), oE = [
  aE
];
function Ag(e, t) {
  return P(), L("svg", rE, oE);
}
const sE = { render: Ag }, lE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Ag,
  default: sE
}, Symbol.toStringTag, { value: "Module" })), uE = {
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, cE = /* @__PURE__ */ T("path", {
  d: "M9.867 2.695a.667.667 0 0 1-.667-.667H5a.667.667 0 1 1-1.333 0H1.6a.267.267 0 0 0-.267.267v10.111c0 .147.12.267.267.267h10.8a.267.267 0 0 0 .267-.267V2.295a.267.267 0 0 0-.267-.267h-1.867a.667.667 0 0 1-.666.667ZM4.333.36c.369 0 .667.299.667.667h4.2a.667.667 0 0 1 1.333 0h1.8c.737 0 1.334.597 1.334 1.333v10c0 .737-.597 1.334-1.334 1.334H1.667A1.333 1.333 0 0 1 .333 12.36v-10c0-.736.597-1.333 1.334-1.333h2c0-.368.298-.667.666-.667Zm1.334 5.301h2.666c.369 0 .667.224.667.5s-.298.5-.667.5H5.667c-.369 0-.667-.224-.667-.5s.298-.5.667-.5Zm0 2.671h2.666c.369 0 .667.224.667.5s-.298.5-.667.5H5.667c-.369 0-.667-.224-.667-.5s.298-.5.667-.5Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), dE = [
  cE
];
function Tg(e, t) {
  return P(), L("svg", uE, dE);
}
const fE = { render: Tg }, hE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Tg,
  default: fE
}, Symbol.toStringTag, { value: "Module" })), pE = {
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, vE = /* @__PURE__ */ T("path", {
  d: "M9.867 2.695a.667.667 0 0 1-.667-.667H5a.667.667 0 1 1-1.333 0H1.6a.267.267 0 0 0-.267.267v10.111c0 .147.12.267.267.267h10.8a.267.267 0 0 0 .267-.267V2.295a.267.267 0 0 0-.267-.267h-1.867a.667.667 0 0 1-.666.667ZM4.333.36c.369 0 .667.299.667.667h4.2a.667.667 0 0 1 1.333 0h1.8c.737 0 1.334.597 1.334 1.333v10c0 .737-.597 1.334-1.334 1.334H1.667A1.333 1.333 0 0 1 .333 12.36v-10c0-.736.597-1.333 1.334-1.333h2c0-.368.298-.667.666-.667Zm1.334 5.301h2.666c.369 0 .667.224.667.5s-.298.5-.667.5H5.667c-.369 0-.667-.224-.667-.5s.298-.5.667-.5Zm0 2.671h2.666c.369 0 .667.224.667.5s-.298.5-.667.5H5.667c-.369 0-.667-.224-.667-.5s.298-.5.667-.5Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), mE = [
  vE
];
function wg(e, t) {
  return P(), L("svg", pE, mE);
}
const gE = { render: wg }, yE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: wg,
  default: gE
}, Symbol.toStringTag, { value: "Module" })), bE = {
  width: "14",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, AE = /* @__PURE__ */ T("path", {
  d: "M8.049.775a.6.6 0 1 1 0 1.2H2.353a1 1 0 0 0-1 1v12.366a1 1 0 0 0 1 1h8.474a1 1 0 0 0 1-1V9.158a.6.6 0 0 1 1.2 0v7.383a1 1 0 0 1-1 1H1.153a1 1 0 0 1-1-1V1.775a1 1 0 0 1 1-1h6.896Zm1.46 11.675a.6.6 0 0 1 0 1.2H3.67a.6.6 0 0 1 0-1.2h5.839ZM5.617 8.558a.6.6 0 1 1 0 1.2H3.671a.6.6 0 1 1 0-1.2h1.946Zm7.671-7.165a.6.6 0 0 1 .094.843L9.491 7.1a.6.6 0 0 1-.753.154l-.09-.06a.6.6 0 0 1-.094-.844l3.89-4.862a.6.6 0 0 1 .844-.095Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), TE = [
  AE
];
function Pg(e, t) {
  return P(), L("svg", bE, TE);
}
const wE = { render: Pg }, PE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Pg,
  default: wE
}, Symbol.toStringTag, { value: "Module" })), xE = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "74",
  height: "100"
}, CE = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M36 77v23H13v-6h20v3h-3V77h6Z",
    fill: "currentColor",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M2 4q.098 0 .196-.01t.194-.028q.097-.02.19-.048.095-.029.185-.066.091-.038.178-.084.086-.046.168-.101.082-.055.158-.117.076-.062.145-.132.07-.07.132-.145.062-.076.117-.158.055-.082.1-.168.047-.087.085-.178.037-.09.066-.184.028-.094.048-.19.019-.097.028-.195Q4 2.098 4 2t-.01-.196q-.01-.098-.028-.194-.02-.097-.048-.19-.029-.095-.066-.185-.038-.091-.084-.178Q3.718.971 3.663.89 3.608.807 3.546.73 3.484.655 3.414.586q-.07-.07-.145-.132Q3.193.392 3.11.337q-.082-.055-.168-.1Q2.856.19 2.765.151q-.09-.037-.184-.066-.094-.028-.19-.048Q2.293.02 2.195.01 2.098 0 2 0t-.196.01q-.098.01-.194.028-.097.02-.19.048-.095.029-.185.066-.091.038-.178.084Q.971.282.89.337.807.392.73.454.655.516.586.586.516.656.454.73.392.807.337.89q-.055.082-.1.168-.047.087-.085.178-.037.09-.066.184-.028.094-.048.19-.019.097-.028.195Q0 1.902 0 2t.01.196q.01.098.028.194.02.097.048.19.029.095.066.185.038.091.084.178.046.086.101.168.055.082.117.158.062.076.132.145.07.07.145.132.076.062.158.117.082.055.168.1.087.047.178.085.09.037.184.066.094.028.19.048.097.019.195.028Q1.902 4 2 4Zm16-2q0 .098-.01.196t-.028.194q-.02.097-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028Q16.098 4 16 4t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.054-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.094-.048-.19-.019-.097-.028-.195Q14 2.098 14 2t.01-.196q.01-.098.028-.194.02-.097.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028Q15.902 0 16 0t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.094.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.097-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028Q30.098 4 30 4t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.094-.048-.19-.019-.097-.028-.195Q28 2.098 28 2t.01-.196q.01-.098.028-.194.02-.097.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028Q29.902 0 30 0t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.094.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.097-.048.19-.029.095-.066.185-.038.091-.084.178-.047.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028Q44.098 4 44 4t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.087-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.094-.048-.19-.019-.097-.028-.195Q42 2.098 42 2t.01-.196q.01-.098.028-.194.02-.097.048-.19.029-.095.066-.185.038-.091.084-.178.047-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.081-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028Q43.902 0 44 0t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.094.048.19.019.097.028.195.01.098.01.196Zm12 2q.098 0 .196-.01t.194-.028q.096-.02.19-.048.095-.029.185-.066.091-.038.178-.084.086-.046.168-.101.082-.055.158-.117.076-.062.145-.132.07-.07.132-.145.062-.076.117-.158.055-.082.1-.168.047-.087.085-.178.037-.09.066-.184.028-.094.048-.19.019-.097.028-.195Q60 2.098 60 2t-.01-.196q-.01-.098-.028-.194-.02-.097-.048-.19-.029-.095-.066-.185-.038-.091-.084-.178-.047-.086-.101-.168-.055-.082-.117-.158-.062-.076-.132-.145-.07-.07-.145-.132-.076-.062-.158-.117-.082-.055-.168-.1-.087-.047-.178-.085-.09-.037-.184-.066-.095-.028-.19-.048-.097-.019-.195-.028Q58.098 0 58 0t-.196.01q-.098.01-.194.028-.096.02-.19.048-.095.029-.185.066-.091.038-.178.084-.086.046-.168.101-.082.055-.158.117-.076.062-.145.132-.07.07-.132.145-.062.076-.117.158-.055.082-.1.168-.047.087-.085.178-.037.09-.066.184-.028.094-.048.19-.019.097-.028.195Q56 1.902 56 2t.01.196q.01.098.028.194.02.097.048.19.029.095.066.185.038.091.084.178.047.086.101.168.055.082.117.158.062.076.132.145.07.07.145.132.076.062.158.117.082.055.168.1.087.047.178.085.09.037.184.066.095.028.19.048.097.019.195.028.098.01.196.01Zm16-2q0 .098-.01.196t-.028.194q-.02.097-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.094.028-.19.048-.097.019-.195.028Q72.098 4 72 4t-.196-.01q-.098-.01-.194-.028-.097-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.094-.048-.19-.019-.097-.028-.195Q70 2.098 70 2t.01-.196q.01-.098.028-.194.02-.097.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.094-.028.19-.048.097-.019.195-.028Q71.902 0 72 0t.196.01q.098.01.194.028.097.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.094.048.19.019.097.028.195.01.098.01.196ZM4 18q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.094.028-.19.048-.097.019-.195.028Q2.098 20 2 20t-.196-.01q-.098-.01-.194-.028-.097-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q0 18.098 0 18t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.094-.028.19-.048.097-.019.195-.028Q1.902 16 2 16t.196.01q.098.01.194.028.097.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.054-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q14 18.098 14 18t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q28 18.098 28 18t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.047.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.087-.046-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q42 18.098 42 18t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.047-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.081-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.046.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm12 2q.098 0 .196-.01t.194-.028q.096-.02.19-.048.095-.029.185-.066.091-.038.178-.084.086-.046.168-.101.082-.055.158-.117.076-.062.145-.132.07-.07.132-.145.062-.076.117-.158.055-.082.1-.168.047-.087.085-.178.037-.09.066-.184.028-.095.048-.19.019-.097.028-.195.01-.098.01-.196t-.01-.196q-.01-.098-.028-.194-.02-.096-.048-.19-.029-.095-.066-.185-.038-.091-.084-.178-.047-.086-.101-.168-.055-.082-.117-.158-.062-.076-.132-.145-.07-.07-.145-.132-.076-.062-.158-.117-.082-.055-.168-.1-.087-.047-.178-.085-.09-.037-.184-.066-.095-.028-.19-.048-.097-.019-.195-.028Q58.098 16 58 16t-.196.01q-.098.01-.194.028-.096.02-.19.048-.095.029-.185.066-.091.038-.178.084-.086.046-.168.101-.082.055-.158.117-.076.062-.145.132-.07.07-.132.145-.062.076-.117.158-.055.082-.1.168-.047.087-.085.178-.037.09-.066.184-.028.095-.048.19-.019.097-.028.195-.01.098-.01.196t.01.196q.01.098.028.194.02.096.048.19.029.095.066.185.038.091.084.178.047.086.101.168.055.082.117.158.062.076.132.145.07.07.145.132.076.062.158.117.082.055.168.1.087.047.178.085.09.037.184.066.095.028.19.048.097.019.195.028.098.01.196.01ZM2 36q.098 0 .196-.01t.194-.028q.097-.02.19-.048.095-.029.185-.066.091-.038.178-.084.086-.047.168-.101.082-.055.158-.117.076-.062.145-.132.07-.07.132-.145.062-.076.117-.158.055-.082.1-.168.047-.087.085-.178.037-.09.066-.184.028-.095.048-.19.019-.097.028-.195Q4 34.098 4 34t-.01-.196q-.01-.098-.028-.194-.02-.096-.048-.19-.029-.095-.066-.185-.038-.091-.084-.178-.046-.086-.101-.168-.055-.082-.117-.158-.062-.076-.132-.145-.07-.07-.145-.132-.076-.062-.158-.117-.082-.055-.168-.1-.087-.047-.178-.085-.09-.037-.184-.066-.094-.028-.19-.048-.097-.019-.195-.028Q2.098 32 2 32t-.196.01q-.098.01-.194.028-.097.02-.19.048-.095.029-.185.066-.091.038-.178.084-.086.047-.168.101-.082.055-.158.117-.076.062-.145.132-.07.07-.132.145-.062.076-.117.158-.055.082-.1.168-.047.087-.085.178-.037.09-.066.184-.028.095-.048.19-.019.097-.028.195Q0 33.902 0 34t.01.196q.01.098.028.194.02.096.048.19.029.095.066.185.038.091.084.178.046.086.101.168.055.082.117.158.062.076.132.145.07.07.145.132.076.062.158.117.082.055.168.1.087.047.178.085.09.037.184.066.094.028.19.048.097.019.195.028.098.01.196.01Zm16-2q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.054-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q14 34.098 14 34t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q28 34.098 28 34t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.047.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.087-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q42 34.098 42 34t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.047-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.081-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196ZM4 50q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.094.028-.19.048-.097.019-.195.028Q2.098 52 2 52t-.196-.01q-.098-.01-.194-.028-.097-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q0 50.098 0 50t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.094-.028.19-.048.097-.019.195-.028Q1.902 48 2 48t.196.01q.098.01.194.028.097.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.054-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q14 50.098 14 50t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Zm14 0q0 .098-.01.196t-.028.194q-.02.096-.048.19-.029.095-.066.185-.038.091-.084.178-.046.086-.101.168-.055.082-.117.158-.062.076-.132.145-.07.07-.145.132-.076.062-.158.117-.082.055-.168.1-.087.047-.178.085-.09.037-.184.066-.095.028-.19.048-.097.019-.195.028-.098.01-.196.01t-.196-.01q-.098-.01-.194-.028-.096-.02-.19-.048-.095-.029-.185-.066-.091-.038-.178-.084-.086-.047-.168-.101-.082-.055-.158-.117-.076-.062-.145-.132-.07-.07-.132-.145-.062-.076-.117-.158-.055-.082-.1-.168-.047-.087-.085-.178-.037-.09-.066-.184-.028-.095-.048-.19-.019-.097-.028-.195Q28 50.098 28 50t.01-.196q.01-.098.028-.194.02-.096.048-.19.029-.095.066-.185.038-.091.084-.178.046-.086.101-.168.055-.082.117-.158.062-.076.132-.145.07-.07.145-.132.076-.062.158-.117.082-.055.168-.1.087-.047.178-.085.09-.037.184-.066.095-.028.19-.048.097-.019.195-.028.098-.01.196-.01t.196.01q.098.01.194.028.096.02.19.048.095.029.185.066.091.038.178.084.086.047.168.101.082.055.158.117.076.062.145.132.07.07.132.145.062.076.117.158.055.082.1.168.047.087.085.178.037.09.066.184.028.095.048.19.019.097.028.195.01.098.01.196Z",
    "fill-rule": "evenodd",
    fill: "currentColor",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), SE = [
  CE
];
function xg(e, t) {
  return P(), L("svg", xE, SE);
}
const EE = { render: xg }, kE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: xg,
  default: EE
}, Symbol.toStringTag, { value: "Module" })), OE = {
  width: "16",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, zE = /* @__PURE__ */ T("path", {
  d: "M12.46 0H1.233C.613 0 .11.493.11 1.102v13.77a1.123 1.123 0 0 0 1.815.884l4.225-3.085a1.123 1.123 0 0 1 1.383 0l4.236 3.09c.739.575 1.814.049 1.814-.886V1.102C13.583.493 13.08 0 12.46 0Zm.138 14.875c0 .043-.012.072-.038.097a.158.158 0 0 1-.104.043.123.123 0 0 1-.08-.032l-.013-.01-4.24-3.09a2.121 2.121 0 0 0-1.282-.435c-.462 0-.917.155-1.283.436L1.331 14.97l-.013.01c-.036.029-.062.032-.08.032-.002 0-.143-.006-.143-.14V1.103c0-.064.063-.117.138-.117H12.46c.075 0 .138.053.138.117v13.773ZM9.857 5.749l-1.03 1.03a.445.445 0 0 0-.124.392l.243 1.453c.061.362-.31.639-.627.467l-1.272-.685a.427.427 0 0 0-.402 0l-1.272.687c-.317.17-.688-.106-.627-.467l.243-1.454a.45.45 0 0 0-.124-.392l-1.03-1.029c-.256-.256-.114-.704.24-.757l1.42-.212a.43.43 0 0 0 .326-.243l.635-1.322a.428.428 0 0 1 .777 0l.635 1.322c.063.13.185.222.325.243l1.42.212c.359.052.5.5.244.755Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), DE = [
  zE
];
function Cg(e, t) {
  return P(), L("svg", OE, DE);
}
const ME = { render: Cg }, HE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Cg,
  default: ME
}, Symbol.toStringTag, { value: "Module" })), IE = {
  class: "icon",
  viewBox: "0 0 1040 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "203.125",
  height: "200"
}, LE = /* @__PURE__ */ T("defs", null, null, -1), BE = /* @__PURE__ */ T("path", { d: "m938.808 410.55-81.941 80.38-278.599-273.137v545.882H462.185V217.99l-279.64 273.136-81.355-80.576L520.26 0z" }, null, -1), NE = /* @__PURE__ */ T("path", { d: "M1040.518 1024H0V646.812h115.628v263.251H924.89V647.007h115.627z" }, null, -1), jE = [
  LE,
  BE,
  NE
];
function Sg(e, t) {
  return P(), L("svg", IE, jE);
}
const FE = { render: Sg }, XE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Sg,
  default: FE
}, Symbol.toStringTag, { value: "Module" })), RE = {
  width: "130",
  height: "130",
  xmlns: "http://www.w3.org/2000/svg"
}, VE = /* @__PURE__ */ T("path", {
  d: "M63.444 64.996c20.633 0 37.359-14.308 37.359-31.953 0-17.649-16.726-31.952-37.359-31.952-20.631 0-37.36 14.303-37.358 31.952 0 17.645 16.727 31.953 37.359 31.953zM80.57 75.65H49.434c-26.652 0-48.26 18.477-48.26 41.27v2.664c0 9.316 21.608 9.325 48.26 9.325H80.57c26.649 0 48.256-.344 48.256-9.325v-2.663c0-22.794-21.605-41.271-48.256-41.271z",
  stroke: "#979797"
}, null, -1), UE = [
  VE
];
function Eg(e, t) {
  return P(), L("svg", RE, UE);
}
const qE = { render: Eg }, _E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Eg,
  default: qE
}, Symbol.toStringTag, { value: "Module" })), WE = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "27",
  height: "20"
}, KE = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "m30 0 8.66 15H21.34L30 0Z",
    fill: "currentColor",
    transform: "rotate(90 20 0)",
    style: { opacity: ".30000001192092896", "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "m37 0 8.66 15H28.34L37 0Z",
    fill: "currentColor",
    transform: "rotate(90 27 0)",
    style: { opacity: ".800000011920929", "mix-blend-mode": "passthrough" }
  })
], -1), GE = [
  KE
];
function kg(e, t) {
  return P(), L("svg", WE, GE);
}
const YE = { render: kg }, QE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: kg,
  default: YE
}, Symbol.toStringTag, { value: "Module" })), ZE = {
  class: "icon",
  viewBox: "0 0 1142 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "223.047",
  height: "200"
}, JE = /* @__PURE__ */ T("defs", null, null, -1), $E = /* @__PURE__ */ T("path", { d: "m742.4 0 102.794 113.782h182.744c62.819 0 114.216 51.2 114.216 113.782v682.654c0 62.582-51.397 113.782-114.216 113.782H114.215C51.397 1024 0 972.8 0 910.218V227.564c0-62.582 51.397-113.782 114.215-113.782H296.96L399.754 0H742.4zM571.077 284.436c-159.902 0-285.539 125.164-285.539 284.455s125.637 284.436 285.539 284.436c159.901 0 285.538-125.145 285.538-284.436S730.978 284.436 571.077 284.436zm0 102.4c119.926 0 182.745 62.582 182.745 182.055 0 119.473-62.819 182.036-182.745 182.036S388.332 688.364 388.332 568.89s62.819-182.055 182.745-182.055z" }, null, -1), ek = [
  JE,
  $E
];
function Og(e, t) {
  return P(), L("svg", ZE, ek);
}
const tk = { render: Og }, nk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Og,
  default: tk
}, Symbol.toStringTag, { value: "Module" })), ik = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "40",
  height: "40"
}, rk = /* @__PURE__ */ T("path", {
  d: "m25.43 18.344-4.123 4.283a.664.664 0 0 1-.488.21.664.664 0 0 1-.487-.21l-4.123-4.283a.7.7 0 0 1-.16-.756.761.761 0 0 1 .647-.467h8.243a.758.758 0 0 1 .649.466.698.698 0 0 1-.159.757Z",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), ak = [
  rk
];
function zg(e, t) {
  return P(), L("svg", ik, ak);
}
const ok = { render: zg }, sk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: zg,
  default: ok
}, Symbol.toStringTag, { value: "Module" })), lk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "12",
  height: "12"
}, uk = /* @__PURE__ */ T("path", {
  d: "M12 0H0v3.2h5.6v7.28L3.76 8.64l-.56.56L6 12l2.88-2.8-.56-.56-1.92 1.853V3.2H12V0Zm-.8.8v1.6H.8V.8h10.4Zm-6.4 4H0v.8h4.8v-.8Zm7.2 0H7.2v.8H12v-.8Z",
  "fill-rule": "evenodd",
  fill: "currentColor",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), ck = [
  uk
];
function Dg(e, t) {
  return P(), L("svg", lk, ck);
}
const dk = { render: Dg }, fk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Dg,
  default: dk
}, Symbol.toStringTag, { value: "Module" })), hk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "14",
  height: "14"
}, pk = /* @__PURE__ */ T("path", {
  d: "M12.95 8.167a.525.525 0 0 1 1.05 0v3.864A1.969 1.969 0 0 1 12.032 14H1.968A1.969 1.969 0 0 1 0 12.032V1.968C0 .882.88.001 1.966 0h4.353a.525.525 0 0 1 0 1.05H1.966a.918.918 0 0 0-.916.918v10.064c0 .507.411.918.918.918h10.064a.919.919 0 0 0 .918-.918V8.167Zm-8.34-1.05 6.191-6.19a.875.875 0 0 1 1.237 0l1.485 1.484a.875.875 0 0 1 0 1.238l-6.19 6.19a.525.525 0 0 1-.27.144l-2.42.474a.525.525 0 0 1-.618-.608l.44-2.454a.525.525 0 0 1 .145-.279Zm.86.626-.276 1.536 1.51-.296 5.953-5.953-1.238-1.238-5.95 5.95Z",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), vk = [
  pk
];
function Mg(e, t) {
  return P(), L("svg", hk, vk);
}
const mk = { render: Mg }, gk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Mg,
  default: mk
}, Symbol.toStringTag, { value: "Module" })), yk = {
  width: "14",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, bk = /* @__PURE__ */ T("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ T("path", { d: "M3.114 4.857a2.426 2.426 0 0 0 2.423-2.423A2.426 2.426 0 0 0 3.114.01 2.426 2.426 0 0 0 .69 2.434a2.427 2.427 0 0 0 2.424 2.423Zm0-3.652a1.228 1.228 0 0 1 0 2.454 1.228 1.228 0 0 1 0-2.454Zm2.297 4.17H.819a.804.804 0 0 0-.804.803v5.98c0 .442.361.803.804.803h1.787v1.186a.599.599 0 0 0 1.196 0v-1.186H5.41c.443 0 .803-.36.803-.803v-5.98a.8.8 0 0 0-.801-.803Zm-.393 6.39H1.212V6.57h3.804v5.194h.002Zm5.617-5.042H8.497V2.085h2.012a.599.599 0 0 0 0-1.196H7.586a.286.286 0 0 0-.285.285v12.573c0 .157.128.285.285.285h3.049a.599.599 0 0 0 0-1.196H8.497V7.92h2.138a.599.599 0 0 0 0-1.196ZM12.018 1.487a.952.952 0 1 0 1.903 0 .952.952 0 0 0-1.903 0ZM12.018 7.381a.952.952 0 1 0 1.903 0 .952.952 0 0 0-1.903 0ZM12.018 13.275a.952.952 0 1 0 1.903 0 .952.952 0 0 0-1.903 0Z" })
], -1), Ak = [
  bk
];
function Hg(e, t) {
  return P(), L("svg", yk, Ak);
}
const Tk = { render: Hg }, wk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Hg,
  default: Tk
}, Symbol.toStringTag, { value: "Module" })), Pk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, xk = /* @__PURE__ */ T("path", {
  d: "M7.714 0v1.714H9.43V0h9.428v24H0V0h7.714ZM9.43 3.428V1.714h1.714v1.714H9.429ZM7.714 5.143V3.429H9.43v1.714H7.714ZM9.43 6.857V5.143h1.714v1.714H9.429ZM7.714 8.572V6.857H9.43v1.715H7.714Zm1.715 1.714V8.57h1.714v1.715H9.429ZM7.714 12v-1.714H9.43V12H7.714Z",
  "fill-rule": "evenodd",
  fill: "#F2A955",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), Ck = [
  xk
];
function Ig(e, t) {
  return P(), L("svg", Pk, Ck);
}
const Sk = { render: Ig }, Ek = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Ig,
  default: Sk
}, Symbol.toStringTag, { value: "Module" })), kk = {
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, Ok = /* @__PURE__ */ T("path", {
  d: "M11.5 14h-9a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Zm1-12a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V2Zm-9 8h7v1h-7v-1Zm0-2h7v1h-7V8Zm0-5h4v4h-4V3Zm1 3h2V4h-2v2Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), zk = [
  Ok
];
function Lg(e, t) {
  return P(), L("svg", kk, zk);
}
const Dk = { render: Lg }, Mk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Lg,
  default: Dk
}, Symbol.toStringTag, { value: "Module" })), Hk = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, Ik = /* @__PURE__ */ T("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ T("path", { d: "M8.429 5.512a.797.797 0 1 0 1.594 0 .797.797 0 0 0-1.594 0ZM8.429 8.95a.797.797 0 1 0 1.594 0 .797.797 0 0 0-1.594 0Z" }),
  /* @__PURE__ */ T("path", { d: "M10.997.013H1.002a.998.998 0 0 0-.998.998v9.246c0 .548.447.995.995.995h9.995a.996.996 0 0 0 .995-.995V1.01a.993.993 0 0 0-.992-.998ZM8.932 1.236h1.649c.14 0 .222.158.144.272L9.9 2.692a.174.174 0 0 1-.284 0l-.824-1.184a.172.172 0 0 1 .14-.272Zm-7.954.03c0-.117.096-.213.213-.213h6.07c.116 0 .212.096.212.213v1.783a.214.214 0 0 1-.213.213H1.191a.214.214 0 0 1-.213-.213V1.266Zm9.983 8.73a.214.214 0 0 1-.212.213H1.19a.214.214 0 0 1-.213-.213V7.904c0-.117.096-.213.213-.213h9.558c.116 0 .212.096.212.213v2.092Zm0-3.41a.214.214 0 0 1-.212.212H1.19a.214.214 0 0 1-.213-.213V4.493c0-.117.096-.212.213-.212h9.558c.116 0 .212.095.212.212v2.092Z" })
], -1), Lk = [
  Ik
];
function Bg(e, t) {
  return P(), L("svg", Hk, Lk);
}
const Bk = { render: Bg }, Nk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Bg,
  default: Bk
}, Symbol.toStringTag, { value: "Module" })), jk = {
  width: "18",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, Fk = /* @__PURE__ */ T("g", {
  fill: "currentColor",
  "fill-rule": "nonzero"
}, [
  /* @__PURE__ */ T("path", { d: "m13.375 16.375-3.5-9.125c-.625.25-1.25.25-1.875 0l-3.5 9.125-1.125-.5L7 6.5c-.375-.375-.5-1-.5-1.5 0-1.125.75-2.125 1.875-2.375V.5h1.25v2c1.125.25 1.875 1.25 1.875 2.375 0 .625-.25 1.25-.5 1.625l3.625 9.375-1.25.5Zm-5.25-10.5c.5.375 1.25.375 1.625 0 .375-.25.5-.5.5-.875 0-.75-.5-1.25-1.25-1.25S7.75 4.25 7.75 5c0 .375.125.625.375.875Z" }),
  /* @__PURE__ */ T("path", { d: "M9 16.125A8.109 8.109 0 0 1 .875 8c0-2.25 1-4.5 2.75-6l.875.875A6.659 6.659 0 0 0 2.125 8c0 3.75 3.125 6.875 6.875 6.875S15.875 11.75 15.875 8h1.25c0 4.5-3.625 8.125-8.125 8.125Z" })
], -1), Xk = [
  Fk
];
function Ng(e, t) {
  return P(), L("svg", jk, Xk);
}
const Rk = { render: Ng }, Vk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Ng,
  default: Rk
}, Symbol.toStringTag, { value: "Module" })), Uk = {
  width: "14",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, qk = /* @__PURE__ */ T("path", {
  d: "M12.46 0H1.233C.613 0 .11.493.11 1.102v13.77a1.123 1.123 0 0 0 1.815.884l4.225-3.085a1.123 1.123 0 0 1 1.383 0l4.236 3.09c.739.575 1.814.049 1.814-.886V1.102C13.583.493 13.08 0 12.46 0Zm.138 14.875c0 .043-.012.072-.038.097a.158.158 0 0 1-.104.043.123.123 0 0 1-.08-.032l-.013-.01-4.24-3.09a2.121 2.121 0 0 0-1.282-.435c-.462 0-.917.155-1.283.436L1.331 14.97l-.013.01c-.036.029-.062.032-.08.032-.002 0-.143-.006-.143-.14V1.103c0-.064.063-.117.138-.117H12.46c.075 0 .138.053.138.117v13.773ZM9.857 5.749l-1.03 1.03a.445.445 0 0 0-.124.392l.243 1.453c.061.362-.31.639-.627.467l-1.272-.685a.427.427 0 0 0-.402 0l-1.272.687c-.317.17-.688-.106-.627-.467l.243-1.454a.45.45 0 0 0-.124-.392l-1.03-1.029c-.256-.256-.114-.704.24-.757l1.42-.212a.43.43 0 0 0 .326-.243l.635-1.322a.428.428 0 0 1 .777 0l.635 1.322c.063.13.185.222.325.243l1.42.212c.359.052.5.5.244.755Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), _k = [
  qk
];
function jg(e, t) {
  return P(), L("svg", Uk, _k);
}
const Wk = { render: jg }, Kk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: jg,
  default: Wk
}, Symbol.toStringTag, { value: "Module" })), Gk = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, Yk = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M0 0h13.714l5.143 5.143V24H0V0Zm14.571 12H9.428l-1.714-.857H4.286v8.595H14.57V12Zm-1.285 1.286v.857H5.57v-1.714h2.143l1.714.857h3.858ZM5.57 18.429v-3h7.715v3H5.57Z",
    "fill-rule": "evenodd",
    fill: "#ED932D",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    fill: "#FFB561",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), Qk = [
  Yk
];
function Fg(e, t) {
  return P(), L("svg", Gk, Qk);
}
const Zk = { render: Fg }, Jk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Fg,
  default: Zk
}, Symbol.toStringTag, { value: "Module" })), $k = {
  width: "13",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, eO = /* @__PURE__ */ T("path", {
  d: "M11.1 4.85c-.248 0-.449.2-.449.447V7.58h-6.33c-.012 0-.023.007-.035.008V5.103H7.71a.448.448 0 1 0 0-.895H.932c-.012 0-.023.006-.035.007V2.103h6.838a.448.448 0 1 0 0-.895H.448c-.247 0-.448.2-.448.448v9.813c0 .247.2.448.448.448H11.1c.248 0 .449-.2.449-.448V5.297c0-.248-.201-.448-.449-.448ZM.896 5.095c.012.001.023.007.035.007H3.39v5.919H.897V5.096Zm3.389 5.926V8.468c.012.001.023.007.035.007h6.33v2.546H4.286Zm8.266-9.716h-.86V.447a.448.448 0 0 0-.897 0v.858H9.647a.448.448 0 1 0 0 .895h1.148v1.147a.448.448 0 0 0 .897 0V2.2h.86a.448.448 0 1 0 0-.895Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), tO = [
  eO
];
function Xg(e, t) {
  return P(), L("svg", $k, tO);
}
const nO = { render: Xg }, iO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Xg,
  default: nO
}, Symbol.toStringTag, { value: "Module" })), rO = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, aO = /* @__PURE__ */ wh('<g fill="currentColor" fill-rule="nonzero"><path d="M6.47.57v2.766c0 .33-.165.496-.496.496-.332 0-.497-.165-.497-.496V.57c0-.332.165-.497.497-.497.33 0 .496.165.496.497Z"></path><path d="M6.325.88 4.973 2.233c-.234.235-.468.235-.702 0-.235-.234-.235-.468 0-.702L5.622.178c.235-.234.469-.234.703 0 .234.234.234.468 0 .703Z"></path><path d="M7.01 2.232 5.658.881c-.234-.235-.234-.469 0-.703.234-.234.468-.234.702 0L7.712 1.53c.234.234.234.468 0 .702-.234.235-.468.235-.702 0ZM5.512 11.413V8.648c0-.33.166-.496.497-.496.331 0 .497.165.497.496v2.765c0 .332-.166.497-.497.497-.331 0-.497-.165-.497-.497Z"></path><path d="M5.658 11.103 7.01 9.751c.234-.234.468-.234.702 0 .234.235.234.469 0 .703L6.36 11.806c-.234.234-.468.234-.702 0-.234-.234-.234-.469 0-.703Z"></path><path d="m4.973 9.751 1.352 1.352c.234.234.234.469 0 .703-.234.234-.469.234-.703 0L4.27 10.454c-.234-.234-.234-.468 0-.703.235-.234.469-.234.703 0ZM.57 5.513h2.765c.33 0 .496.165.496.497 0 .33-.165.496-.496.496H.57c-.331 0-.497-.165-.497-.496 0-.332.166-.497.497-.497Z"></path><path d="M.88 5.659 2.232 7.01c.234.235.234.469 0 .703-.234.234-.468.234-.703 0L.178 6.36c-.235-.234-.235-.468 0-.702.234-.234.468-.234.702 0Z"></path><path d="M2.232 4.974.88 6.326c-.234.234-.468.234-.702 0-.235-.235-.235-.469 0-.703l1.351-1.352c.235-.234.469-.234.703 0 .234.234.234.469 0 .703ZM11.413 6.47H8.648c-.331 0-.497-.165-.497-.496 0-.33.166-.496.497-.496h2.765c.33 0 .497.165.497.496 0 .331-.166.497-.497.497Z"></path><path d="M11.102 6.325 9.751 4.974c-.234-.235-.234-.469 0-.703.234-.234.468-.234.702 0l1.352 1.352c.234.234.234.468 0 .702-.234.235-.468.235-.703 0Z"></path><path d="m9.75 7.01 1.353-1.351c.234-.235.468-.235.702 0 .234.234.234.468 0 .702l-1.352 1.352c-.234.234-.468.234-.702 0-.234-.234-.234-.468 0-.703ZM4.98 6.003a.993.993 0 1 0 1.987 0 .993.993 0 0 0-1.987 0Z"></path></g>', 1), oO = [
  aO
];
function Rg(e, t) {
  return P(), L("svg", rO, oO);
}
const sO = { render: Rg }, lO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Rg,
  default: sO
}, Symbol.toStringTag, { value: "Module" })), uO = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, cO = /* @__PURE__ */ T("path", {
  d: "m10.515 10.909.088.007A.546.546 0 0 1 10.515 12H.545l-.088-.007a.546.546 0 0 1 .089-1.084h9.969ZM6.902.432a1.319 1.319 0 0 1 1.676-.23l.028.018.027.02.016.014.56.455.264.215.575.468.037.033c.243.237.379.562.377.9l-.01.145a1.248 1.248 0 0 1-.378.752l.046-.048-1.076 1.31-.01.011-3.65 4.453-.003.004-.003.004-.088.091a1.01 1.01 0 0 1-.442.236l-.003.001-.004.001-.001-.002.001.002-.073.017-1.825.42-.05.009-.05.004-.113-.001a1.027 1.027 0 0 1-.949-.908l-.003-.044v-.044l.001-.02.088-1.852.021.001h.002l-.023-.001v-.012l.086.006.07.005.015.001.018.001H2.04l-.017-.002-.075-.005-.059-.004-.021-.002c.014-.215.1-.419.242-.58l-.012.014.04-.049 1.547-1.886.328-.4L5.6 2.02l.012-.015L6.833.515l-.018.023.331.243.11.08L7.15.775l-.318-.26Zm1.033.667a.227.227 0 0 0-.24.085l-.009.012-.009.011-.012.015-.702.857c.14.266.356.576.629.82l-.082-.081-.899-.31-.155.189-.012.015-.15.183.572.819a17.298 17.298 0 0 1-.607-.78c-.66.808-2.95 3.598-3.278 3.998l-.026.03-.002.036-.07 1.5-.007.118.088-.02c.442-.1 1.305-.3 1.56-.358l.039-.01.016-.019 3.32-4.051c-.48-.11-.823-.258-1.033-.444l1.135.32.2-.243.012-.015.39-.475c-.378.022-.712-.137-1.011-.403l-.082-.08 1.158.403.17-.207.438-.533.022-.025.024-.024.026-.033a.156.156 0 0 0 .022-.08l-.005-.041a.156.156 0 0 0-.042-.071l.005.007-.03-.024-1.293-1.053-.022-.017Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), dO = [
  cO
];
function Vg(e, t) {
  return P(), L("svg", uO, dO);
}
const fO = { render: Vg }, hO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Vg,
  default: fO
}, Symbol.toStringTag, { value: "Module" })), pO = {
  width: "15",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, vO = /* @__PURE__ */ T("path", {
  d: "M7.03 0a7 7 0 0 1 4.972 2.05A6.94 6.94 0 0 1 14.062 7a6.94 6.94 0 0 1-2.06 4.95A7 7 0 0 1 7.032 14a7.002 7.002 0 0 1-4.972-2.05A6.94 6.94 0 0 1 0 7c0-1.871.732-3.63 2.06-4.95A7 7 0 0 1 7.03 0Zm.001 1.004c-1.61 0-3.124.624-4.262 1.757A5.94 5.94 0 0 0 1.004 7a5.94 5.94 0 0 0 1.764 4.238 6.006 6.006 0 0 0 4.263 1.757 6 6 0 0 0 4.262-1.757A5.939 5.939 0 0 0 13.057 7a5.94 5.94 0 0 0-1.764-4.238 6.007 6.007 0 0 0-4.262-1.757Zm-.022 2a.503.503 0 0 1 .524.48v3.013h3.014a.5.5 0 0 1 .043 0l.09.012a.503.503 0 0 1-.133.993H7.533v3.013a.503.503 0 0 1-1.004 0V7.502H3.516a.503.503 0 0 1 0-1.005h3.013V3.484c.011-.26.22-.47.48-.48Z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1), mO = [
  vO
];
function Ug(e, t) {
  return P(), L("svg", pO, mO);
}
const gO = { render: Ug }, yO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: Ug,
  default: gO
}, Symbol.toStringTag, { value: "Module" })), bO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "10",
  height: "10"
}, AO = /* @__PURE__ */ T("path", {
  d: "M6.949.261.608 6.581V6.58a.535.535 0 0 0-.15.285L.008 9.37a.538.538 0 0 0 .633.62l2.478-.484a.538.538 0 0 0 .277-.147L9.737 3.04a.89.89 0 0 0 0-1.264L8.217.261a.899.899 0 0 0-1.268 0ZM1.206 8.788l.282-1.569 6.094-6.073L8.85 2.409 2.752 8.486l-1.546.302Z",
  "fill-rule": "evenodd",
  fill: "#AAA",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), TO = [
  AO
];
function qg(e, t) {
  return P(), L("svg", bO, TO);
}
const wO = { render: qg }, PO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: qg,
  default: wO
}, Symbol.toStringTag, { value: "Module" })), xO = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "18.857",
  height: "24"
}, CO = /* @__PURE__ */ T("g", { style: { "mix-blend-mode": "passthrough" } }, [
  /* @__PURE__ */ T("path", {
    d: "M13.714 0H0v24h18.857V5.143L13.714 0Zm-6.14 15.558.008 2.782a1.648 1.648 0 1 1-1.326-1.617V12.55l6.601-1.648v6.779a1.648 1.648 0 1 1-1.319-1.616V14.57l-3.964.99Zm.009-1.174v-.97l3.956-.988v.969l-3.956.989Zm2.966 3.297a.66.66 0 1 0 1.319 0 .66.66 0 0 0-1.319 0Zm-4.615 1.318a.66.66 0 1 1 0-1.318.66.66 0 0 1 0 1.318Z",
    "fill-rule": "evenodd",
    fill: "#B16ADE",
    style: { "mix-blend-mode": "passthrough" }
  }),
  /* @__PURE__ */ T("path", {
    d: "M18.857 5.143h-5.143V0l5.143 5.143Z",
    style: { "mix-blend-mode": "passthrough" }
  })
], -1), SO = [
  CO
];
function _g(e, t) {
  return P(), L("svg", xO, SO);
}
const EO = { render: _g }, kO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  render: _g,
  default: EO
}, Symbol.toStringTag, { value: "Module" })), OO = /* @__PURE__ */ Ee({
  props: {
    name: {
      required: !0,
      type: String
    },
    size: {
      type: [String, Number],
      default: "1em"
    },
    color: {
      type: String,
      default: "#777777"
    },
    iconClass: String
  },
  setup(e) {
    const t = e, n = J(
      () => typeof t.size == "number" ? `${t.size}px` : t.size
    ), r = /* @__PURE__ */ Object.assign({ "/src/assets/icons/Excel.svg": fS, "/src/assets/icons/Html.svg": gS, "/src/assets/icons/Pdf.svg": wS, "/src/assets/icons/Ppt.svg": ES, "/src/assets/icons/TXT.svg": MS, "/src/assets/icons/Word.svg": NS, "/src/assets/icons/copy.svg": VS, "/src/assets/icons/goal-plan.svg": KS, "/src/assets/icons/hebaodan.svg": JS, "/src/assets/icons/hint_icon.svg": iE, "/src/assets/icons/jiaozi.svg": lE, "/src/assets/icons/other-order.svg": hE, "/src/assets/icons/other.svg": yE, "/src/assets/icons/sum-review.svg": PE, "/src/assets/icons/teacher_card.svg": kE, "/src/assets/icons/teaching-evaluate.svg": HE, "/src/assets/icons/upload.svg": XE, "/src/assets/icons/user.svg": _E, "/src/assets/icons/xiaosanjiao.svg": QE, "/src/assets/icons/\u4E0A\u4F20\u5934\u50CF.svg": nk, "/src/assets/icons/\u4E0B\u62C9.svg": sk, "/src/assets/icons/\u4E0B\u79FB.svg": fk, "/src/assets/icons/\u4FEE\u6539.svg": gk, "/src/assets/icons/\u5206\u914D\u7AE0\u8282.svg": wk, "/src/assets/icons/\u538B\u7F29\u5305.svg": Ek, "/src/assets/icons/\u57FA\u672C\u4FE1\u606F.svg": Mk, "/src/assets/icons/\u5927\u7EB2\u8BE6\u60C5.svg": Nk, "/src/assets/icons/\u5EFA\u8BBE\u89C4\u5212.svg": Vk, "/src/assets/icons/\u6574\u4F53\u60C5\u51B5.svg": Kk, "/src/assets/icons/\u6587\u4EF6\u5939.svg": Jk, "/src/assets/icons/\u6DFB\u52A0\u5185\u5BB9.svg": iO, "/src/assets/icons/\u79FB\u52A8.svg": lO, "/src/assets/icons/\u7F16\u8F91.svg": hO, "/src/assets/icons/\u8BFE\u7A0B\u7ED3\u6784.svg": yO, "/src/assets/icons/\u91CD\u547D\u540D.svg": PO, "/src/assets/icons/\u97F3\u4E50.svg": kO }), i = J(() => {
      const a = `/${t.name}.svg`;
      for (const o in r) {
        const s = r[o];
        if (o.endsWith(a))
          return s;
      }
      throw new Error(`not found svg file:${a}`);
    });
    return (a, o) => (P(), ue(Ln(E(i)), {
      class: se(["svg-icon", e.iconClass]),
      color: e.color,
      width: E(n),
      height: E(n)
    }, null, 8, ["class", "color", "width", "height"]));
  }
});
const qi = /* @__PURE__ */ Ht(OO, [["__scopeId", "data-v-62938f7d"]]);
qi.name = "svg-icon";
qi.install = (e) => {
  e.component(qi.name, qi);
};
var Ir = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Kg(e) {
  var t = e.default;
  if (typeof t == "function") {
    var n = function() {
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Gg = { exports: {} }, Q4 = { exports: {} }, Yg = function(t, n) {
  return function() {
    for (var i = new Array(arguments.length), a = 0; a < i.length; a++)
      i[a] = arguments[a];
    return t.apply(n, i);
  };
}, zO = Yg, Nl = Object.prototype.toString;
function Z4(e) {
  return Nl.call(e) === "[object Array]";
}
function p8(e) {
  return typeof e > "u";
}
function DO(e) {
  return e !== null && !p8(e) && e.constructor !== null && !p8(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function MO(e) {
  return Nl.call(e) === "[object ArrayBuffer]";
}
function HO(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
function IO(e) {
  var t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && e.buffer instanceof ArrayBuffer, t;
}
function LO(e) {
  return typeof e == "string";
}
function BO(e) {
  return typeof e == "number";
}
function Qg(e) {
  return e !== null && typeof e == "object";
}
function X1(e) {
  if (Nl.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function NO(e) {
  return Nl.call(e) === "[object Date]";
}
function jO(e) {
  return Nl.call(e) === "[object File]";
}
function FO(e) {
  return Nl.call(e) === "[object Blob]";
}
function Zg(e) {
  return Nl.call(e) === "[object Function]";
}
function XO(e) {
  return Qg(e) && Zg(e.pipe);
}
function RO(e) {
  return typeof URLSearchParams < "u" && e instanceof URLSearchParams;
}
function VO(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function UO() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function J4(e, t) {
  if (!(e === null || typeof e > "u"))
    if (typeof e != "object" && (e = [e]), Z4(e))
      for (var n = 0, r = e.length; n < r; n++)
        t.call(null, e[n], n, e);
    else
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && t.call(null, e[i], i, e);
}
function v8() {
  var e = {};
  function t(i, a) {
    X1(e[a]) && X1(i) ? e[a] = v8(e[a], i) : X1(i) ? e[a] = v8({}, i) : Z4(i) ? e[a] = i.slice() : e[a] = i;
  }
  for (var n = 0, r = arguments.length; n < r; n++)
    J4(arguments[n], t);
  return e;
}
function qO(e, t, n) {
  return J4(t, function(i, a) {
    n && typeof i == "function" ? e[a] = zO(i, n) : e[a] = i;
  }), e;
}
function _O(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var ta = {
  isArray: Z4,
  isArrayBuffer: MO,
  isBuffer: DO,
  isFormData: HO,
  isArrayBufferView: IO,
  isString: LO,
  isNumber: BO,
  isObject: Qg,
  isPlainObject: X1,
  isUndefined: p8,
  isDate: NO,
  isFile: jO,
  isBlob: FO,
  isFunction: Zg,
  isStream: XO,
  isURLSearchParams: RO,
  isStandardBrowserEnv: UO,
  forEach: J4,
  merge: v8,
  extend: qO,
  trim: VO,
  stripBOM: _O
}, ru = ta;
function uv(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Jg = function(t, n, r) {
  if (!n)
    return t;
  var i;
  if (r)
    i = r(n);
  else if (ru.isURLSearchParams(n))
    i = n.toString();
  else {
    var a = [];
    ru.forEach(n, function(l, u) {
      l === null || typeof l > "u" || (ru.isArray(l) ? u = u + "[]" : l = [l], ru.forEach(l, function(f) {
        ru.isDate(f) ? f = f.toISOString() : ru.isObject(f) && (f = JSON.stringify(f)), a.push(uv(u) + "=" + uv(f));
      }));
    }), i = a.join("&");
  }
  if (i) {
    var o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}, WO = ta;
function Ch() {
  this.handlers = [];
}
Ch.prototype.use = function(t, n, r) {
  return this.handlers.push({
    fulfilled: t,
    rejected: n,
    synchronous: r ? r.synchronous : !1,
    runWhen: r ? r.runWhen : null
  }), this.handlers.length - 1;
};
Ch.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
Ch.prototype.forEach = function(t) {
  WO.forEach(this.handlers, function(r) {
    r !== null && t(r);
  });
};
var KO = Ch, GO = ta, YO = function(t, n) {
  GO.forEach(t, function(i, a) {
    a !== n && a.toUpperCase() === n.toUpperCase() && (t[n] = i, delete t[a]);
  });
}, $g = function(t, n, r, i, a) {
  return t.config = n, r && (t.code = r), t.request = i, t.response = a, t.isAxiosError = !0, t.toJSON = function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  }, t;
}, V2, cv;
function ey() {
  if (cv)
    return V2;
  cv = 1;
  var e = $g;
  return V2 = function(n, r, i, a, o) {
    var s = new Error(n);
    return e(s, r, i, a, o);
  }, V2;
}
var U2, dv;
function QO() {
  if (dv)
    return U2;
  dv = 1;
  var e = ey();
  return U2 = function(n, r, i) {
    var a = i.config.validateStatus;
    !i.status || !a || a(i.status) ? n(i) : r(e(
      "Request failed with status code " + i.status,
      i.config,
      null,
      i.request,
      i
    ));
  }, U2;
}
var q2, fv;
function ZO() {
  if (fv)
    return q2;
  fv = 1;
  var e = ta;
  return q2 = e.isStandardBrowserEnv() ? function() {
    return {
      write: function(r, i, a, o, s, l) {
        var u = [];
        u.push(r + "=" + encodeURIComponent(i)), e.isNumber(a) && u.push("expires=" + new Date(a).toGMTString()), e.isString(o) && u.push("path=" + o), e.isString(s) && u.push("domain=" + s), l === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(r) {
        var i = document.cookie.match(new RegExp("(^|;\\s*)(" + r + ")=([^;]*)"));
        return i ? decodeURIComponent(i[3]) : null;
      },
      remove: function(r) {
        this.write(r, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), q2;
}
var _2, hv;
function JO() {
  return hv || (hv = 1, _2 = function(t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  }), _2;
}
var W2, pv;
function $O() {
  return pv || (pv = 1, W2 = function(t, n) {
    return n ? t.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : t;
  }), W2;
}
var K2, vv;
function ez() {
  if (vv)
    return K2;
  vv = 1;
  var e = JO(), t = $O();
  return K2 = function(r, i) {
    return r && !e(i) ? t(r, i) : i;
  }, K2;
}
var G2, mv;
function tz() {
  if (mv)
    return G2;
  mv = 1;
  var e = ta, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return G2 = function(r) {
    var i = {}, a, o, s;
    return r && e.forEach(r.split(`
`), function(u) {
      if (s = u.indexOf(":"), a = e.trim(u.substr(0, s)).toLowerCase(), o = e.trim(u.substr(s + 1)), a) {
        if (i[a] && t.indexOf(a) >= 0)
          return;
        a === "set-cookie" ? i[a] = (i[a] ? i[a] : []).concat([o]) : i[a] = i[a] ? i[a] + ", " + o : o;
      }
    }), i;
  }, G2;
}
var Y2, gv;
function nz() {
  if (gv)
    return Y2;
  gv = 1;
  var e = ta;
  return Y2 = e.isStandardBrowserEnv() ? function() {
    var n = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), i;
    function a(o) {
      var s = o;
      return n && (r.setAttribute("href", s), s = r.href), r.setAttribute("href", s), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return i = a(window.location.href), function(s) {
      var l = e.isString(s) ? a(s) : s;
      return l.protocol === i.protocol && l.host === i.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), Y2;
}
var Q2, yv;
function bv() {
  if (yv)
    return Q2;
  yv = 1;
  var e = ta, t = QO(), n = ZO(), r = Jg, i = ez(), a = tz(), o = nz(), s = ey();
  return Q2 = function(u) {
    return new Promise(function(f, d) {
      var h = u.data, p = u.headers, y = u.responseType;
      e.isFormData(h) && delete p["Content-Type"];
      var m = new XMLHttpRequest();
      if (u.auth) {
        var b = u.auth.username || "", x = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
        p.Authorization = "Basic " + btoa(b + ":" + x);
      }
      var D = i(u.baseURL, u.url);
      m.open(u.method.toUpperCase(), r(D, u.params, u.paramsSerializer), !0), m.timeout = u.timeout;
      function S() {
        if (!!m) {
          var v = "getAllResponseHeaders" in m ? a(m.getAllResponseHeaders()) : null, H = !y || y === "text" || y === "json" ? m.responseText : m.response, V = {
            data: H,
            status: m.status,
            statusText: m.statusText,
            headers: v,
            config: u,
            request: m
          };
          t(f, d, V), m = null;
        }
      }
      if ("onloadend" in m ? m.onloadend = S : m.onreadystatechange = function() {
        !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(S);
      }, m.onabort = function() {
        !m || (d(s("Request aborted", u, "ECONNABORTED", m)), m = null);
      }, m.onerror = function() {
        d(s("Network Error", u, null, m)), m = null;
      }, m.ontimeout = function() {
        var H = "timeout of " + u.timeout + "ms exceeded";
        u.timeoutErrorMessage && (H = u.timeoutErrorMessage), d(s(
          H,
          u,
          u.transitional && u.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          m
        )), m = null;
      }, e.isStandardBrowserEnv()) {
        var C = (u.withCredentials || o(D)) && u.xsrfCookieName ? n.read(u.xsrfCookieName) : void 0;
        C && (p[u.xsrfHeaderName] = C);
      }
      "setRequestHeader" in m && e.forEach(p, function(H, V) {
        typeof h > "u" && V.toLowerCase() === "content-type" ? delete p[V] : m.setRequestHeader(V, H);
      }), e.isUndefined(u.withCredentials) || (m.withCredentials = !!u.withCredentials), y && y !== "json" && (m.responseType = u.responseType), typeof u.onDownloadProgress == "function" && m.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && m.upload && m.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(H) {
        !m || (m.abort(), d(H), m = null);
      }), h || (h = null), m.send(h);
    });
  }, Q2;
}
var Xi = ta, Av = YO, iz = $g, rz = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Tv(e, t) {
  !Xi.isUndefined(e) && Xi.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function az() {
  var e;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (e = bv()), e;
}
function oz(e, t, n) {
  if (Xi.isString(e))
    try {
      return (t || JSON.parse)(e), Xi.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
var Sh = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: az(),
  transformRequest: [function(t, n) {
    return Av(n, "Accept"), Av(n, "Content-Type"), Xi.isFormData(t) || Xi.isArrayBuffer(t) || Xi.isBuffer(t) || Xi.isStream(t) || Xi.isFile(t) || Xi.isBlob(t) ? t : Xi.isArrayBufferView(t) ? t.buffer : Xi.isURLSearchParams(t) ? (Tv(n, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : Xi.isObject(t) || n && n["Content-Type"] === "application/json" ? (Tv(n, "application/json"), oz(t)) : t;
  }],
  transformResponse: [function(t) {
    var n = this.transitional, r = n && n.silentJSONParsing, i = n && n.forcedJSONParsing, a = !r && this.responseType === "json";
    if (a || i && Xi.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? iz(o, this, "E_JSON_PARSE") : o;
      }
    return t;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  }
};
Sh.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
Xi.forEach(["delete", "get", "head"], function(t) {
  Sh.headers[t] = {};
});
Xi.forEach(["post", "put", "patch"], function(t) {
  Sh.headers[t] = Xi.merge(rz);
});
var $4 = Sh, sz = ta, lz = $4, uz = function(t, n, r) {
  var i = this || lz;
  return sz.forEach(r, function(o) {
    t = o.call(i, t, n);
  }), t;
}, Z2, wv;
function ty() {
  return wv || (wv = 1, Z2 = function(t) {
    return !!(t && t.__CANCEL__);
  }), Z2;
}
var Pv = ta, J2 = uz, cz = ty(), dz = $4;
function $2(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var fz = function(t) {
  $2(t), t.headers = t.headers || {}, t.data = J2.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = Pv.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), Pv.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(i) {
      delete t.headers[i];
    }
  );
  var n = t.adapter || dz.adapter;
  return n(t).then(function(i) {
    return $2(t), i.data = J2.call(
      t,
      i.data,
      i.headers,
      t.transformResponse
    ), i;
  }, function(i) {
    return cz(i) || ($2(t), i && i.response && (i.response.data = J2.call(
      t,
      i.response.data,
      i.response.headers,
      t.transformResponse
    ))), Promise.reject(i);
  });
}, Zi = ta, ny = function(t, n) {
  n = n || {};
  var r = {}, i = ["url", "method", "data"], a = ["headers", "auth", "proxy", "params"], o = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], s = ["validateStatus"];
  function l(d, h) {
    return Zi.isPlainObject(d) && Zi.isPlainObject(h) ? Zi.merge(d, h) : Zi.isPlainObject(h) ? Zi.merge({}, h) : Zi.isArray(h) ? h.slice() : h;
  }
  function u(d) {
    Zi.isUndefined(n[d]) ? Zi.isUndefined(t[d]) || (r[d] = l(void 0, t[d])) : r[d] = l(t[d], n[d]);
  }
  Zi.forEach(i, function(h) {
    Zi.isUndefined(n[h]) || (r[h] = l(void 0, n[h]));
  }), Zi.forEach(a, u), Zi.forEach(o, function(h) {
    Zi.isUndefined(n[h]) ? Zi.isUndefined(t[h]) || (r[h] = l(void 0, t[h])) : r[h] = l(void 0, n[h]);
  }), Zi.forEach(s, function(h) {
    h in n ? r[h] = l(t[h], n[h]) : h in t && (r[h] = l(void 0, t[h]));
  });
  var c = i.concat(a).concat(o).concat(s), f = Object.keys(t).concat(Object.keys(n)).filter(function(h) {
    return c.indexOf(h) === -1;
  });
  return Zi.forEach(f, u), r;
};
const hz = [
  [
    "axios@0.21.4",
    "D:\\workspace\\hikeboot-h5"
  ]
], pz = "axios@0.21.4", vz = "axios@0.21.4", mz = !1, gz = "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==", yz = "/axios", bz = {}, Az = {
  type: "version",
  registry: !0,
  raw: "axios@0.21.4",
  name: "axios",
  escapedName: "axios",
  rawSpec: "0.21.4",
  saveSpec: null,
  fetchSpec: "0.21.4"
}, Tz = [
  "/"
], wz = "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz", Pz = "0.21.4", xz = "D:\\workspace\\hikeboot-h5", Cz = {
  name: "Matt Zabriskie"
}, Sz = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, Ez = {
  url: "https://github.com/axios/axios/issues"
}, kz = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], Oz = {
  "follow-redirects": "^1.14.0"
}, zz = "Promise based HTTP client for the browser and node.js", Dz = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, Mz = "https://axios-http.com", Hz = "dist/axios.min.js", Iz = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], Lz = "MIT", Bz = "index.js", Nz = "axios", jz = {
  type: "git",
  url: "git+https://github.com/axios/axios.git"
}, Fz = {
  build: "NODE_ENV=production grunt build",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  examples: "node ./examples/server.js",
  fix: "eslint --fix lib/**/*.js",
  postversion: "git push && git push --tags",
  preversion: "npm test",
  start: "node ./sandbox/server.js",
  test: "grunt test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
}, Xz = "./index.d.ts", Rz = "dist/axios.min.js", Vz = "0.21.4", Uz = {
  _args: hz,
  _from: pz,
  _id: vz,
  _inBundle: mz,
  _integrity: gz,
  _location: yz,
  _phantomChildren: bz,
  _requested: Az,
  _requiredBy: Tz,
  _resolved: wz,
  _spec: Pz,
  _where: xz,
  author: Cz,
  browser: Sz,
  bugs: Ez,
  bundlesize: kz,
  dependencies: Oz,
  description: zz,
  devDependencies: Dz,
  homepage: Mz,
  jsdelivr: Hz,
  keywords: Iz,
  license: Lz,
  main: Bz,
  name: Nz,
  repository: jz,
  scripts: Fz,
  typings: Xz,
  unpkg: Rz,
  version: Vz
};
var iy = Uz, e3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  e3[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var xv = {}, qz = iy.version.split(".");
function ry(e, t) {
  for (var n = t ? t.split(".") : qz, r = e.split("."), i = 0; i < 3; i++) {
    if (n[i] > r[i])
      return !0;
    if (n[i] < r[i])
      return !1;
  }
  return !1;
}
e3.transitional = function(t, n, r) {
  var i = n && ry(n);
  function a(o, s) {
    return "[Axios v" + iy.version + "] Transitional option '" + o + "'" + s + (r ? ". " + r : "");
  }
  return function(o, s, l) {
    if (t === !1)
      throw new Error(a(s, " has been removed in " + n));
    return i && !xv[s] && (xv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, s, l) : !0;
  };
};
function _z(e, t, n) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var r = Object.keys(e), i = r.length; i-- > 0; ) {
    var a = r[i], o = t[a];
    if (o) {
      var s = e[a], l = s === void 0 || o(s, a, e);
      if (l !== !0)
        throw new TypeError("option " + a + " must be " + l);
      continue;
    }
    if (n !== !0)
      throw Error("Unknown option " + a);
  }
}
var Wz = {
  isOlderVersion: ry,
  assertOptions: _z,
  validators: e3
}, ay = ta, Kz = Jg, Cv = KO, Sv = fz, Eh = ny, oy = Wz, au = oy.validators;
function sf(e) {
  this.defaults = e, this.interceptors = {
    request: new Cv(),
    response: new Cv()
  };
}
sf.prototype.request = function(t) {
  typeof t == "string" ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = Eh(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var n = t.transitional;
  n !== void 0 && oy.assertOptions(n, {
    silentJSONParsing: au.transitional(au.boolean, "1.0.0"),
    forcedJSONParsing: au.transitional(au.boolean, "1.0.0"),
    clarifyTimeoutError: au.transitional(au.boolean, "1.0.0")
  }, !1);
  var r = [], i = !0;
  this.interceptors.request.forEach(function(d) {
    typeof d.runWhen == "function" && d.runWhen(t) === !1 || (i = i && d.synchronous, r.unshift(d.fulfilled, d.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(d) {
    a.push(d.fulfilled, d.rejected);
  });
  var o;
  if (!i) {
    var s = [Sv, void 0];
    for (Array.prototype.unshift.apply(s, r), s = s.concat(a), o = Promise.resolve(t); s.length; )
      o = o.then(s.shift(), s.shift());
    return o;
  }
  for (var l = t; r.length; ) {
    var u = r.shift(), c = r.shift();
    try {
      l = u(l);
    } catch (f) {
      c(f);
      break;
    }
  }
  try {
    o = Sv(l);
  } catch (f) {
    return Promise.reject(f);
  }
  for (; a.length; )
    o = o.then(a.shift(), a.shift());
  return o;
};
sf.prototype.getUri = function(t) {
  return t = Eh(this.defaults, t), Kz(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
ay.forEach(["delete", "get", "head", "options"], function(t) {
  sf.prototype[t] = function(n, r) {
    return this.request(Eh(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
ay.forEach(["post", "put", "patch"], function(t) {
  sf.prototype[t] = function(n, r, i) {
    return this.request(Eh(i || {}, {
      method: t,
      url: n,
      data: r
    }));
  };
});
var Gz = sf, ep, Ev;
function sy() {
  if (Ev)
    return ep;
  Ev = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, ep = e, ep;
}
var tp, kv;
function Yz() {
  if (kv)
    return tp;
  kv = 1;
  var e = sy();
  function t(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    var r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    var i = this;
    n(function(o) {
      i.reason || (i.reason = new e(o), r(i.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var r, i = new t(function(o) {
      r = o;
    });
    return {
      token: i,
      cancel: r
    };
  }, tp = t, tp;
}
var np, Ov;
function Qz() {
  return Ov || (Ov = 1, np = function(t) {
    return function(r) {
      return t.apply(null, r);
    };
  }), np;
}
var ip, zv;
function Zz() {
  return zv || (zv = 1, ip = function(t) {
    return typeof t == "object" && t.isAxiosError === !0;
  }), ip;
}
var Dv = ta, Jz = Yg, R1 = Gz, $z = ny, eD = $4;
function ly(e) {
  var t = new R1(e), n = Jz(R1.prototype.request, t);
  return Dv.extend(n, R1.prototype, t), Dv.extend(n, t), n;
}
var Ua = ly(eD);
Ua.Axios = R1;
Ua.create = function(t) {
  return ly($z(Ua.defaults, t));
};
Ua.Cancel = sy();
Ua.CancelToken = Yz();
Ua.isCancel = ty();
Ua.all = function(t) {
  return Promise.all(t);
};
Ua.spread = Qz();
Ua.isAxiosError = Zz();
Q4.exports = Ua;
Q4.exports.default = Ua;
(function(e) {
  e.exports = Q4.exports;
})(Gg);
const uy = /* @__PURE__ */ Wg(Gg.exports), tD = "data:image/jpeg;base64,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", nD = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABHNCSVQICAgIfAhkiAAAAlJJREFUWIXtmD9r20AYhx9djOtR0JIpFcqQSUsXQ0OXdkuh0HyCZG8ptFCvwnhtwS7F3ZPPEGg3ZwktZEgyaMpQ4WRKG7omJbE6SE6t88knS7aiIQ8IfL5X9/70uz/cHUyPDbSBAyCY0XMQtWln0BOjM0NRSU87q7jDAsSNOjoVRTgnP5204mzFyz6wDpjTfqkCM2rLV+Sx0zQgu+fPSJiMybjIVC7KY299DuKGrEu5Uo1F2fZ5uDfElPMZcsSb4+N7i1e1jWAQvACeAPdzJj0H9gxh7FwPlraajvFXEx+MFmICW17/PfAhpyAdDdexPk6oVwtseSdfIVibm6wYxjfXefg8oTImUMDQuaLEAQRrUW9pMZpeUBWcXM5bkopf1cva55UVOXfcwQVxulmgphiLV7UNXYyIZuutkCa3IFxKbgttbkHGda7XbeM6Fq5j0etm3iFpc4usLRfFncC83AnMS0UX0Ou2pS1FiL//I/a790U9k5+9epddHWC0vH4wKcB1rFwJWl5/Yr3rWPLnj28WSsTYZljbxUld9HP/+0032/XHLNdX84oDeCqVj/QCXyeMoe7/cbhcX02OS4/J+KF9twxdbAIvCQ9ItlTX0TpYAH8S/v8E+GVwUMUR8BbKN4shdO7RsFCGLobQsV3CmwR/tMJoef3f5D/7ZuXcdawHkwIEsFeQGBXa3MIQxk4RSlSkyS3OKhfbRYhRcT1Y2tLFiOhc2ihAj0wjxT1NKa8+Ytysg9ELRTjZSCsOFFvRphdUF8Tp5jyu384qF9uKq46J/ANFbBoSlU+6eAAAAABJRU5ErkJggg==", iD = "data:image/png;base64,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", rD = "data:image/png;base64,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", aD = "data:image/png;base64,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", oD = "data:image/png;base64,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", sD = "data:image/png;base64,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", cy = "data:image/png;base64,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", dy = "data:image/png;base64,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", fy = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAXl0lEQVR4Xu2de5QcVZ3Hf7/qmUzEIESEEVbWFUEXNEB4CSHJdHUCma6e6eoJy+CDt4qAi0eDrm8MenyuhPW1CIgiu8oSDpmpnunqCcl09SQE9nhAVvGx62N9HjCyu2ISQ4ZM129PTYgGqFd31a26NfnNXznpe7+/7/3e++nuqq66hZDgn1FvXki2nUdUlgLRCYDwogTLcykA6Onpge7u7m0rlp+5lAMJTgCDm0RvYRibT8bu3I0EUImuxgpREnAAOeqIl8Efd/xxUl1+5sooWgdDX+GAjNYbGtpwGyD+1cEQqOxj3A+I4/OpHTvMwvIzSrJ7TtOfUEDGx6dObOXsrUBwRJqD5Np/SeBAQJz/3bFzx0h+2RmrOSP3BIQCYpjNbwLQpRy+PAk8H5B9kOy6O7/stDfL41IeJ8IAqU5MDZNt3yPPUNmJk4AbILOQ/GnnnflzT7+CU3puAsIAMerNbUC0hAOXKwEvQByXO3fturVv6WlXy+U4XTdCALEsa/6Op+EPADA/3eFx9ecn4AeI0/ZPu//0hWVLFr+bk9uXgBBAqqZ1NgE8xCHLl0AQILOQPL37c8vOOfX98rlP3pEQQIyadTUg3JL8cLhiUAJhAHE0du/e84mlS06+IUhvrr8uBJCR2uRaBZWPzfXwsji+sIA4Y5uenv7wOW9Y9KksjjMuzwxIXElmRKcdQJwh7dnz9PuWnH3K5zMyvNhtMiCxRyq3YLuAOKPZu3fvdW8483VflntkYtwxIGJylVa1E0Ccwcy0WleddfqJt0s7MEHGGBBBwcoq2ykgznha9sxlZ5520l2yjk2ELwZERKoSa0YBxBkWAb3x9FNfe9BcIcGASLyYRViLCojjCQmHFy8+4V4R/mTTZEBkmxHBfuIA5GCChAERvCBlk48LkIMFEgZEthUs2E+cgBwMkDAgghekbPJxAzLXIWFAZFvBgv2IAGQuQ8KACF6QssmLAmSuQsKAyLaCBfsRCchchIQBEbwgZZMXDchcg4QBkW0FC/aTBCBzCRIGRPCClE0+KUDmCiQMiGwrWLCfJAGZC5AwIIIXpGzySQOSdUgYENlWsGA/aQCSZUgYEMELUjb5tADJKiQMiGwrWLCfNAHJIiQMiOAFKZt82oBkDRIGRLYVLNiPDIBkCRIGRPCClE1eFkCyAgkDItsKFuxHJkCyAAkDInhByiYvGyCyQ8KAyLaCBfuRERCZIWFABC9I2eRlBURWSBgQ2VawYD8yAyIjJAyI4AUpm7zsgMgGCQMi2woW7CcLgMgECQMieEHKJp8VQGSBhAGRbQUL9pMlQGSAhAERvCBlk88aIGlDwoDItoIF+8kiIGlCwoAIXpCyySMivOLoY2SzFcpPGrvKMyChpmZuNeo98kiY1z0vk4NKGhIGJJPLJJrphYcdDgte/OJoIin2ThISBiTFiU6r9PyeHjjyiJelVT6WuklBwoDEMl3ZEzn8sMPg0BcvyJ7xAxwnAQkDkuklEs380Uf1QldXVzSRlHuLhoQBSXmC0y7fe+RRMK+7O20bkeqLhIQBiTQ1c6PzwsMPhwWHZPegXeTvJAzI3FjjkUfhfIrMmzdv9vRvt/PvDH6qiPgkYUAiLy0WSDsBRcErB/vz3xDhgwERkSprJp4AAbyxoqn3xF2YAYk7UdZLJQGb7BuHSivWxl2cAYk7UdZLJQEGJJXYuWhWEmBAsjJT7DOVBBiQVGLnollJgAHJykyxz1QSYEBSiZ2LZiUBBiQrM8U+U0mAAUkldi6alQQYkKzMFPtMJQEGJJXYuWhWEmBAsjJT7DOVBBiQVGLnollJgAHJykyxz1QSYEBSiV1wUYLtgLQdQfkdIGy3ibY7FRXEXiDoJbBfDoS9gNAr2Enm5RmQTE8h/hoAJsC2N0Ku62fQ/cx2feXKWRjC/hmbN/fC3nm90Jo5HhRlFQD0A9Bfh+0/19sxIBmbYQK8XwHaBIrdKPev+K4I+9WJydPAVgo24HkIdL6IGlnRZECyMFMENUJlfQvsxgWa+tskLd9nWq/IgVJAsocBoZRkbRlqMSAyzIKXB4LNoNAterGwQQabRr2xGmy8BhBWyuAnCQ8MSBIpt1mDCLYqCt5SLubvbrNrIs2r9eabbJuuQYRliRRMsQgDkmL4zy9NRN/ZB4Z6p0S2PK1U69bl+0DBs7LgtxOPDEgnqYnoQ/QhvVT4dBzShvHAoV1ddPQz9swxuS48mohmH9yBiI+3ZuiJeUrX4zMz+ISuL90ZS71a44OA+Kk4tGTTYEBSnxHajaRcXS7l/6UTK6OjG49VenoGgehCG+gYBDwaAA4NqbWTgJ5QAB8HxHvt6emxSmXVb0L2fU6zaq15CaH9VQA8pJP+svZhQFKdGfoJKvSmdk/Xbhi3Xt+lzB4o6wSQj3MICNAEAGPGhs2rB9QftKPtnB4mG+8GwNe000/mtgxISrNDBFalpBbCljceeOBQ+4/T1yuoOGCcG7ZfxHbbbLI3K4f13KQvDf91bLRmNRBBjVhbiu4MSArTQACfr2jq+8KWHq01r1CQ1hDA68P2ibMdAvzAJlxXKYXfhnPUtP4RAd4bp480tBiQpFMnKOoldSJM2ZF6YwUSrEFALUx70W0IyCSEdUPFwmSYWkbN6geEepi2srZhQJKcGYRL9KL6r0EljQnreLBxDQBdE9Q2ndfxFlBond6v/iyovlG3LgaCjk5ABGkn8ToDkkTKszXoBl0rfCKo3LMLah0AHBnUNuXXnwSENaGANxsfBcCPp+y3o/IMSEextdsJv65r+bcG9RoxJ69TQPliUDuZXrfBfteQtuJLQZ4Ms3kHAF0Z1E621xkQ0TNCYOkhzlYZZvOjAJTJd1kAvEHX8sGfjjWrARk7u8WAiAQE8ReAdH7Qd3Wj3rwJiNaItCJcG3GdXsxf71dn9tiK8H4gepVwPzEVYEBiCtJNxjn7VNbyvmdxDLNxBwBm7quHe2z0dV0r+H6VrJrNonM2TGDssUozILHG+RcxIrq5Uir4fioYZuObAHipIAspydJdula4zK941bQ+QwDvT8lgW2UZkLbiCteYAH47D+AczefmptF641ok/Eo4xWy1IqR3VoqFf/ZyPT6+dWFL2fsAAJ4k+8gYEAEzhIhrysX8zV7SI+ON0xUFNwPA4QLKyyD5lG3TyqGBwiNeZkbNqUsR7G/KYNbPAwMS8wwh4ENlLb/E92DVtJxf0p0NEuby30ZdU/sDcrgXAP5O5hAYkLhnB3FYL+adiXf9q5rNGwnohrjLyqiHgB8va/mPeXkzatYZgPAAAPTI6N/xxIDEOzP36po67LkgxhslUHA83pKSq9k0oA8Uall9w2BAYlxfrVZryerBlQ95fu+uNR5GxNNjLCm9FBE9UikVzvAyOjb28CF2bqfzKbJYxsEwIHHNCkFNL6kD3nA0r0Ckr8dVLks6RHil36XyRs36BCB8RMYxMSCxzQpeq2v5Wzy/XpmW8y6Z1I1OsY0qJqFtuqYu9T4WmVwOqEzFVCtWGQYknjinuyF3rKYtf9JNztkmh4i+HU+pbKog4pv9tjEarVk/QoQTZRsdAxLHjCBu0Iv5C7wPRK3NBLAijlIhNJ5y7itvAUyhbX+HFNi+d5cyu19v9wK7F23oJUU5KwfQ9+z97In8FoMAk2VN9dxwbrTW+AIivivE+BJtwoDEELffu6Mx3lgNCt4XQ5kwEl+mnPK5yqq+UDuTjG6cOhZb9j8AwN+HEY/cxqYL9AH3XSJHxqy8kgMrco2YBRiQyIHiDl3LH+Z5cG42asJvmUX4Idit9+illZs6GY5R23weKLmbgeB1nfQP28e5SLGiFTz39zVMywH7FWH1kmjHgERO2ftmqLGxqRPsnP2TyCX8BBB+2IM9y/v7l/xflDoTEw++dJqmt4iGRGkprxkc7Pupm9fRWuMriHhtlHHE3ZcBiZio3QJ1aFB19pJ6wV91YmqYbPueiCU8uzvHGmVNjXV7HaNmjYvcxR0V5aJyf996t0HJ+DWLAYm4enFGOa5c7vuF6zuiaX0GBV3WLQKO/WOo1q3bieBtEaNx7U4An61o6gdc31CqU6+iLvu/RdTtVJMB6TS5Z/s9+p2p3Nq1a213QJobxTyABncD4FJd63s0on3P7tW69TARxP6rv/MAoIqWd71Qc+3atcris/paosbUiS4D0klqf+nzG11TPR9XVjWbvyeg+HcnQVirF9Ubg6wb9akyUOtvgeDU2bYI/wGY+0+92FcN6lutN64iwluD2rX7OgI+WdbyR3n1M0zLeazcse3qimrPgERL9gFdU12fkVGrbX3NDM78VzR5196PKq1dSwcHB3d7addq1stnANaD1/M7CLZ2AQyXSurv/PyJ+hTpoq7XlkrLXE9eGKa1FQA8f3UXkKevJAMSLfFv6Zp6sev3aUG/ngfdyjsxseXoabv1eJhh9Si5Y/r7lz/h1Xa01liHiO8Jo9VOG9/fjUzL2VjvLe3oiWzLgERIFwE/VdbyH3aTGKlNrlVQ8bwXotOymIPB8irV85L5qmlZYXd8DzrQr260BqgFY5169ernt+iqZvOTBPShuGt2qseAdJrc7ANplHeUi323JQmIrqnoZbkTKIMWgGE6vMX75wtIfeoqIjv2Y59ORxCUT6e6npPYqaDTr5MFEKVeUN8c5voHiss3JgYIwXa9pL7cy5dRs7Z4Hnd4dSLYqpfU5T6avwOE3qAs2nndb9GN17esalEr1Obe7dTstC0D0mlyTj+FBvR+97vlxMBM39e1wimuQI5Yhys98IdOhmNPw8KhIfUpt76G2fgeAJ7ciW4nX7GMiUYJbHnuumRAos38xbqmfiuxTxDEB/Vi3vWektHapkWIXd/vZDhEMydXSuc95gpIvbkNiHw3oWi3pt+iM0zLOUAP3AG/3ZqdtmdAOk1u30Mx31ku5l33fxLzCQI/1zX1eM+vQ6bl/KL/N20O6Ze6pnpuBWqYlvOIg1e3qenb3P8YpHktEUmzXxgDEmHmCejDFa3g+nRXIYAg7NKLqucDOo2a9TVACNxF/jlDJrhDL6mel5UYdWsnECyIENMLuvotulGz8SEE/GSc9aJoMSBR0gP8nK7lXbfQFAKI86mVU44rr3K/9qujJzr5PPGqunHqVdSK/9oo/69Yzc8CkHOPihR/DEikaaDbdK3wDjcJUVfyEsHbKyX1az5fs5z74q8OOayv6prq+RSr0Zr1NkS4PaRW6GZ+V/QaZuNWALwqtJjghgxIhIAR4J6ypr7R9SDdnHy1AkrgI8raLo94t17Mv9mvn2E2bwWggEWGt+la3hXu/dpGvfltIHpT2x4DOthgHz+krfi56xuLaf0bAVwUd81O9RiQTpNz+iFM6EW16PNu7lzrFOtvCLO1qHV+0N2Dhtm4EgDvcPdGb9W1gu8WRM/uH/xwlHg8+m7XNZ/fcupWHQh8tywV4MlTkgGJlrbvGaBR06oiwGC0Eq69N+maen6QrmluOXK61XpdrmvfLuqtGfpRTy73Q6/dVw7UC/cpFOTgha8TwFhFU8s+byqdnIlr30jIHgxIyKC8ms3YrVdfMLDS9SYfUQfqsx8iNnykMqAKOdtj1JsXApHrXX8R4/Ld6/a+8c3HdSk5169eUet22p8B6TS5Z/vZBFcMldQ73WRG680hJNoQsYRn96ALFzupO1KzTlUQhN2IRYirK8X8iJu3kZp1uYLwjU58i+rDgERMFhHuLBfVK1wnXNSB+gHFpnfBocPD6q6Iw5jtvn69taBnAeyMQ8tLw/cAvW59gwguF1m/XW0GpN3EXtje/5foutUAglg3Vni+BbLtcysDKx6MMpTR8cklqCjbomgE9kWw9KJa8GpndHYlQGDZKA0YkCjp/bmvcprX/eFGzboaEDz37I2lvCOCsLYHc7f53QDlVmv2BitqXQUEa2Pz4iVEcI1eUr/q9rJhTi0GsL8r3EObBRiQNgNza26D/a4hbcWX3F5bPzHx0h6a/xgQHRNDKX8JxMdtu3V7F3Y9OKj13e/XeMycOt9G+5zZH+US8jaNexYN9/e77t81Yk5ep4DyReEZtVmAAWkzMNfmROv1UsHzxy3DtJznFb47jlLhNWgHgvLvgLDdJprdm1dB7AWCXgL7bAB8SXitWFr+k66pnrfvGrXGPYDo+fChWBx0IMKAdBDaC7oQtQhyiyulPtdLxjfUm+fkiCIdI8RhM02NFuKS1cW868OFRmtTixBajwJiLk2Prt8OyL5xqLQi9q+fB8Udhc8JFHGdXsxf7zXBVbNpEpDnr+6yLYw4/SBgvazlNS9No968CYh8nykfp592tPgTpJ20/Nv+oYvsxaXSil+5NavWrcuJ5DrHH9/Qgw6N4Ipy0f23olpt8pUzqDi/uyxMyk87dRiQdtIKahuwoVu13ryLiC4JkplTrwccn4m82iCOHBmQOFJ8VoMAftVldy0eGFjmem+4aZov2Qvzt8Z9j3eMQ4hb6pfdAMs0Tf2tm/D4+NaFM8rMowjwyrgLx6XHgMSV5H4douv1UmGdl+xY3VpqEzi7B879v4Bnxhu1xhpAvEnmIBiQgNlxNlfza+KySdtj07vyi4eH0XMT5tGa9U5E+LLMCyOqt6AdINevp1zPgqZz7LHowFod5B3Vqm9/BiQgXr+N2nx2MXyvrqm+74yiLicXulpCiiPgQ2Ut77sTimFazhm/zz9fMmi3RxEb2fkNiwERAgjZNsL5Q8XCpJ+8YVrO7wJnh1x3mWnWDXCs13GHM4iRemOFQnA/ACoMSIzTmsYZjw4/QQARHtkzH/LDqv+Vtka9uQWIXHeIjzG6RKScRxsQ2sv0YsFzV/v1lrVg/h5oej17hD9BIkxVlgCZHWbAljr7ozBMy9lq0/WhMhHiSrQrAfwYcsqqoCfsBm1NxIBEmLbMATK7uRy9o1wsuG5wfWAURr15HxCtjhBPil1xS2vP9IWrV6/6vZ+JMA/lYUAiTGMWAQGg3a0WLFk9WPhe0NAN03Juc70wqJ1MryPgWBfsvljTtB1+vjaMNU7J5eBBADzErx0DEmF2ZQQk7HDCPo3WgQQB4n9sW1ijbbSzAf7nmV1PvmV4ePiZoG7OGb+gNvtf98uKz2L5pCgbIGEnnNvFlwADwoDEt5rmoBIDwoDMwWUd35AYEAYkvtU0B5UYEAZkDi7r+IbEgDAg8a2mOajEgDAgc3BZxzckBkQyQOKbWlbKYgJ8NW8WZ409J5YAA5JY1FwoiwkwIFmcNfacWAIMSGJRc6EsJsCAZHHW2HNiCTAgiUXNhbKYAAOSxVljz4klwIAkFjUXymICDEgWZ409J5YAA5JY1FwoiwkwIFmcNfacWAIMSGJRc6EsJsCAZHHW2HNiCTAgiUXNhbKYAAOSxVljz4klwIAkFjUXymICDEgWZ409J5YAA5JY1FwoiwkwIFmcNfacWAIMSGJRc6EsJsCAZHHW2HNiCTAgiUXNhbKYAAOSxVljz4klwIAkFjUXymICDEgWZ409J5YAA5JY1FwoiwkwIFmcNfacWAIMSGJRc6EsJsCAZHHW2HNiCTAgiUXNhbKYAAOSxVljz4klwIAkFjUXymICDEgWZ409J5YAA5JY1FwoiwkwIFmcNfacWAIMSGJRc6EsJsCAZHHW2HNiCTAgiUXNhbKYAAOSxVljz4klkClAqmbzOgL6YmLpcKGDPgEieHulpH4t7iAwbkFHz5holMDGcRHarMkJuCVg23TG0EDhkbjTEQLIaG1qEaL9/bjNsh4n4JoAwdPd+PRCTdOm405ICCDrN206rGdv11Nxm2U9TsAtASJ6sFIqnCsiHSGAOEarNevThPABEaZZkxM4MAFUlIvK/X3rRaQiDJDZYxHTcr5mLRJhnDU5gX0J4F26lr9MVBpCAdmwcdtRudYz20WZZ92DPAGE/821lGUDA30/FpWEUEAc06PmlpMQ7U1AdIyoQbDuwZcAAv4aAd8+qPXdL3L0wgH5MyTU+iAgXCxyMKx9cCSAAKM2zdxQKZ33mOgRJwLI/kGM1ae0lm0PIeJZQHQCILxI9ABZfw4kQPA0IP4Ukb5LBJt1Tf1WUqP6f3hB2W4KFhkZAAAAAElFTkSuQmCC", hy = "data:image/png;base64,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", py = "data:image/png;base64,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", vy = "data:image/png;base64,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", my = "data:image/png;base64,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", gy = "data:image/png;base64,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", yy = "data:image/png;base64,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", by = "data:image/png;base64,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", Ay = "data:image/png;base64,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", lD = "data:image/png;base64,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", uD = "data:image/jpeg;base64,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", cD = "data:image/png;base64,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", dD = "data:image/png;base64,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", fD = "data:image/png;base64,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", hD = "data:image/png;base64,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", pD = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAARKADAAQAAAABAAAARAAAAADA2cO/AAAK7klEQVR4Ae1aDYxVxRWemft2YUEKRGu1BdoCVdRISbVNjGksEduColYENgIiGlh+loUtu7iuhDyJBbru8reL/DVUSwnLFqoiLaFpYinV2FaTtqnUJiBtd01aQi0gf8vy7u33zb1z3+W9e99yccH3yM7ue+fcmTNnzvnumTMz9z4huks3At0IdCPQjUCXISDjappS9ULv/544s14IOVZIccKRsm7P+kVNcfXkq7yKa9ixk+21UsrJUoq+QHOgcpzG+2ctuyOunnyVjw2I44ghmc5ImRqaWVeo14m4hksLk8VRwsEfi8SfI2LjGnfYKyYf2xMlgAiKkkp/yFuxtbBXfpbYEcJgkDayh5eOCczVVGIDQhykwpRBMkkXN2rS14XLxQYEaMBbR+cO7TYQUkFsChcLbXlsQCTmiHSQSKWHAsnVEyAmE3R+W8fPq7/PFnYFJMdgtqQTh04nck+RTMxuXlX5j8415beElxqjjRxfuaIES+w2x7EfCpVihBAUR5wFXbJjVfWyULkCqcwZ7E8kV/brOOfsQQb9Nnangh96b6jmlVenZAIN995613dTB97e+9sC8T/LzJwRMuH7K9cjMspCeh1Gx1bU344A6a/3aAFNSDPjtjdU/jyrn1cxvnrlCJWSA6LaL2e9bTltP3uh8k9RYwTcuFBk0oI1t3aI1F+wogSj6A9FIjFta0PFASM9sWp1qSPsJmE717KOO1hs2d5rbph/OyLJy7xGWgiAvBRSz/g7XUQdl3A36tJyPudNSQ26p9/dHbuq2S/Y3/BmW5DZTj1KyWXN9ZW1/hgBJp0cA5VkUzJVg7E0GFQK5N7v1af/PUEwKLe9fl5zkSNHY2+SwvqDwaBSidseq2l8gO2ZBcbMMXKUpW5D3XHcKckR9R90+pT6sezr/t5OWfdnHW2kLo8nDfKmnX2xSM7OtMtcRwIC9aNoiDaWtMiqfCk57azpGKRbG+b/Eb5t5qAsmtr2nUEZn5fiPepNF8OTogUGG+ryuNJ1bg/DkwZ5oy9Yp2U8nRyTfyyAz49w08/Q0H3I3DVrehxtc25kdx2CSjkldu83TacwisH2o366NojRrOSwMDlLqgk4G9ZC8cB0u2uofx24tHnX0UDKYnj/Tnr1uAu63ca3BZ6UhViS9zGVqhUTGdM2vIQCcqy9H+r/p3swQjDfOwaV9GkPV+HWSmWdFI7tAaiNKwmT31pX0Yb6yJAN63Ml63ygg4NuqX78lKWsjwkGC+Zi8aGO/wwPymTzzte1bLrP+9ky+V8TCog2W8nf6SQFB92coJ6Lcmdy7YYbpVQzfQAJipJ/jZLP5/pIQABDY9BwTJsxU2qbmipXtFwwFSYn1w6VIvUask1/yhM8/B3pVZzYEexfKLybiSKsnfrsul/Zjn0fnfTXdSVbkTPfgNf/QnIaDudHQaYXYWChHCKl6uXnZzVEqM3r6tCkaiy2pDMX+4vf2I5zA9d0Fjg8UEn5uGO7GyNusAwYbLcs+eqXrGGryRdiyRkhdOjJ5ObBqVT7Xvg9tFMHpdj9mc9+8dHGijE5V6RO9XyKAp0CQtvmLH352jPnzs7DbChDhFzPiDBbbzDYIIkP8OB54eYlM3Z25suM5IZe523nKSRdvQ+xsUlgDiYNK6aNlCUoD+OPi+Kin/x40ZM8V3VJuShAzEhz1/yyx6mjrb8ABveaOqYOy1GlP1oyfbtfl4OZtnjDLjSPjRShRZyNxjLDk4YVJT4sEuKmjcmy02HNcesiV5kwRZwK0lJH9UribZ11/tAnnrAe2XU4y4zUW2quRvxQj6Hk+WcoebYZCp5LO+tINS/kF5yi4puyR7q0mliAcAhtXNBg8HEKXNkVdFA7TKf9j7d0Qy2qvHpD3bEoawpgOdizz+f+Zq4/Kc25ykQpp0P81wXUMhM8qkOgfsA9Q6Z+uP/Q63gnHDjLBATisI483ueaa3as7MIkHhsQhbdSesk1gETN7QjHkiNHnkdTc0Tzp14dGxBGB5+46yih+bEn3afuc04DLskdJjM9ZThzOJ9jJNWc1uRBY/wIkaonHhnyBOybj8Tm84XOmEyQ049kS0vxkQ/aS/HAme9l7rhgn8CeUrwtnET5umcmvZtTUQE0dgrIrGVb+ytlv27b9t05/cEDZcRJU9PTU+ZhGsVMtTk1X9HGnIBU17XccNo592uc6G7TOYOmYf+uNwikulAFeaNKrl1bM7ncbSu8b+NFqOXlP9yyDa6WBhuRUM/gPLMfoHwEcL6K9mFQInnsZ6FCRMhTjQsnb9YVGV94njK0I9XxHDrofYiB0u3t9jd1GV0v6tL0NfpCOrVKkVjcuLD0UEibiEyqlSu2fuO8LSfyNMWVRDssxSs9RMnM+oWPHDHKKhq2jxSpjpccpQaxTsspuWjDhne2lJXd2WHkDO04f2479H3NGGx0k7Kwv6kzfXJRvQ1AhPrbAD9a3RGMLqOfuvATsJtBQt8KRC4PKVtW4y7icQjODuiNDdm+66omPVpfnQaDytcsmPiGo4pHY0B95MezEs6gLx84+feH2Z5ZsKsdzDquUmalMpT1xnBSfvT4Hg3ypj3rLMR+PFp4/b2IdSOXA6CgbojLZX9HAgJ934JWtweoUtazSSlDD+mNVRMOwIBN2ggCyH4yMSJ7ODos6tx2tFJMy7qUfNBp8iyGap7yrKNsgNeV+NL6PEqeP+7xqeFlos7IZ9LQKcPnpraTuo7jURmCr73fiOt/n9k5eA3j3gRaOpm6Rtm3BNsNv2rBY8uqGluaUx3m3S538jSD1Cueo/pK4nDPNk1ZEyKvBXN8BfRZxYm2+rkTDkdJhwLSt3eJPHbqlN8HDia8M4hfl8kAEP4cAoVfzAORwSc8gyKNytR9Ja9DrU6WjT2NMP0Izy50hIBYVStb7splGKII7RoRiIFK5yp7LyPFPjrGBEWK3wAsSTrce2WXp1e3DIJcmZ6rCE89ZZT8c7Zk/teEOkiz8eauQTtIUDgHHTnqZOPObTUv7tbvX4xr1WtfGXFeqr2Q6etHlKX+eXPx4Mjfh5i++Uh5+yNLdePOHdgXjAsKIBI+xmZhH1A6gQfNn0e6+CbaLWZet+j3MmV15eM2mppCoqFJ1Tgge4r58qwcjt9TfAUgGH/7gHmAACB2jCgvdMFiuKmu/JGCBIMORE4ZNtZNH9dm9S65G06+w1XD/cB3zZPioxOvS7FX2dSr/Hsz2bdQS+AWR7uwouWtkiNH/z0Vi2kFIuOWzLd1AOZdy5EVP5jz8FvRWtyW2hd3jU45qY2IqAG6hoFHK/wp58qlvzMFjDDjU57AXVm+fPZDXfbLx4sCJG2cEDXrX9uN35Pdb6aIdkRZpctnjr2o9zI1615tRV4aYKabAde8+Eq7642qEzrnp2dqBj7sV1RkDX5++oOHg3ZeKp8zh4QphVmnCAbt0sWz01x2RvUU4wHAc5C/iqY+TVFNB3l6SgMEXot4A3GSc3Bvsnf1k5ecOQTDZhUdqMgh5izBg1mcR6pYnmegc5vWo5EgHi4oJPqg59Egzzb9oUXkNZEnpGXVdlV0UGfsCOFBCz9/gE0ulvpOqouHZOmMB/dg3E/+TobWX4YSGxBGunt3XWu44sQOs8vgSFepjA0I4eB0MXO8qwzJFz3xAWE4IKnpeW+8uIpCJDYglpAH8V7WRcX7TijroMGm0Gnse9u7yFoKPH6K3HEcK0ZbQqq5i5/4TsG/jyn0G9ltfzcC3Qh0I5CXCPwfGQ7AN1o38yQAAAAASUVORK5CYII=", vD = "data:image/png;base64,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", mD = "data:image/png;base64,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";
var Ty = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    var n = 1e3, r = 6e4, i = 36e5, a = "millisecond", o = "second", s = "minute", l = "hour", u = "day", c = "week", f = "month", d = "quarter", h = "year", p = "date", y = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, D = function(G, te, Q) {
      var Y = String(G);
      return !Y || Y.length >= te ? G : "" + Array(te + 1 - Y.length).join(Q) + G;
    }, S = { s: D, z: function(G) {
      var te = -G.utcOffset(), Q = Math.abs(te), Y = Math.floor(Q / 60), Z = Q % 60;
      return (te <= 0 ? "+" : "-") + D(Y, 2, "0") + ":" + D(Z, 2, "0");
    }, m: function G(te, Q) {
      if (te.date() < Q.date())
        return -G(Q, te);
      var Y = 12 * (Q.year() - te.year()) + (Q.month() - te.month()), Z = te.clone().add(Y, f), oe = Q - Z < 0, he = te.clone().add(Y + (oe ? -1 : 1), f);
      return +(-(Y + (Q - Z) / (oe ? Z - he : he - Z)) || 0);
    }, a: function(G) {
      return G < 0 ? Math.ceil(G) || 0 : Math.floor(G);
    }, p: function(G) {
      return { M: f, y: h, w: c, d: u, D: p, h: l, m: s, s: o, ms: a, Q: d }[G] || String(G || "").toLowerCase().replace(/s$/, "");
    }, u: function(G) {
      return G === void 0;
    } }, C = "en", v = {};
    v[C] = x;
    var H = function(G) {
      return G instanceof K;
    }, V = function G(te, Q, Y) {
      var Z;
      if (!te)
        return C;
      if (typeof te == "string") {
        var oe = te.toLowerCase();
        v[oe] && (Z = oe), Q && (v[oe] = Q, Z = oe);
        var he = te.split("-");
        if (!Z && he.length > 1)
          return G(he[0]);
      } else {
        var Ae = te.name;
        v[Ae] = te, Z = Ae;
      }
      return !Y && Z && (C = Z), Z || !Y && C;
    }, R = function(G, te) {
      if (H(G))
        return G.clone();
      var Q = typeof te == "object" ? te : {};
      return Q.date = G, Q.args = arguments, new K(Q);
    }, F = S;
    F.l = V, F.i = H, F.w = function(G, te) {
      return R(G, { locale: te.$L, utc: te.$u, x: te.$x, $offset: te.$offset });
    };
    var K = function() {
      function G(Q) {
        this.$L = V(Q.locale, null, !0), this.parse(Q);
      }
      var te = G.prototype;
      return te.parse = function(Q) {
        this.$d = function(Y) {
          var Z = Y.date, oe = Y.utc;
          if (Z === null)
            return new Date(NaN);
          if (F.u(Z))
            return new Date();
          if (Z instanceof Date)
            return new Date(Z);
          if (typeof Z == "string" && !/Z$/i.test(Z)) {
            var he = Z.match(m);
            if (he) {
              var Ae = he[2] - 1 || 0, We = (he[7] || "0").substring(0, 3);
              return oe ? new Date(Date.UTC(he[1], Ae, he[3] || 1, he[4] || 0, he[5] || 0, he[6] || 0, We)) : new Date(he[1], Ae, he[3] || 1, he[4] || 0, he[5] || 0, he[6] || 0, We);
            }
          }
          return new Date(Z);
        }(Q), this.$x = Q.x || {}, this.init();
      }, te.init = function() {
        var Q = this.$d;
        this.$y = Q.getFullYear(), this.$M = Q.getMonth(), this.$D = Q.getDate(), this.$W = Q.getDay(), this.$H = Q.getHours(), this.$m = Q.getMinutes(), this.$s = Q.getSeconds(), this.$ms = Q.getMilliseconds();
      }, te.$utils = function() {
        return F;
      }, te.isValid = function() {
        return this.$d.toString() !== y;
      }, te.isSame = function(Q, Y) {
        var Z = R(Q);
        return this.startOf(Y) <= Z && Z <= this.endOf(Y);
      }, te.isAfter = function(Q, Y) {
        return R(Q) < this.startOf(Y);
      }, te.isBefore = function(Q, Y) {
        return this.endOf(Y) < R(Q);
      }, te.$g = function(Q, Y, Z) {
        return F.u(Q) ? this[Y] : this.set(Z, Q);
      }, te.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, te.valueOf = function() {
        return this.$d.getTime();
      }, te.startOf = function(Q, Y) {
        var Z = this, oe = !!F.u(Y) || Y, he = F.p(Q), Ae = function(Ve, Te) {
          var Me = F.w(Z.$u ? Date.UTC(Z.$y, Te, Ve) : new Date(Z.$y, Te, Ve), Z);
          return oe ? Me : Me.endOf(u);
        }, We = function(Ve, Te) {
          return F.w(Z.toDate()[Ve].apply(Z.toDate("s"), (oe ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Te)), Z);
        }, ke = this.$W, Re = this.$M, ve = this.$D, Ye = "set" + (this.$u ? "UTC" : "");
        switch (he) {
          case h:
            return oe ? Ae(1, 0) : Ae(31, 11);
          case f:
            return oe ? Ae(1, Re) : Ae(0, Re + 1);
          case c:
            var Qe = this.$locale().weekStart || 0, ot = (ke < Qe ? ke + 7 : ke) - Qe;
            return Ae(oe ? ve - ot : ve + (6 - ot), Re);
          case u:
          case p:
            return We(Ye + "Hours", 0);
          case l:
            return We(Ye + "Minutes", 1);
          case s:
            return We(Ye + "Seconds", 2);
          case o:
            return We(Ye + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, te.endOf = function(Q) {
        return this.startOf(Q, !1);
      }, te.$set = function(Q, Y) {
        var Z, oe = F.p(Q), he = "set" + (this.$u ? "UTC" : ""), Ae = (Z = {}, Z[u] = he + "Date", Z[p] = he + "Date", Z[f] = he + "Month", Z[h] = he + "FullYear", Z[l] = he + "Hours", Z[s] = he + "Minutes", Z[o] = he + "Seconds", Z[a] = he + "Milliseconds", Z)[oe], We = oe === u ? this.$D + (Y - this.$W) : Y;
        if (oe === f || oe === h) {
          var ke = this.clone().set(p, 1);
          ke.$d[Ae](We), ke.init(), this.$d = ke.set(p, Math.min(this.$D, ke.daysInMonth())).$d;
        } else
          Ae && this.$d[Ae](We);
        return this.init(), this;
      }, te.set = function(Q, Y) {
        return this.clone().$set(Q, Y);
      }, te.get = function(Q) {
        return this[F.p(Q)]();
      }, te.add = function(Q, Y) {
        var Z, oe = this;
        Q = Number(Q);
        var he = F.p(Y), Ae = function(Re) {
          var ve = R(oe);
          return F.w(ve.date(ve.date() + Math.round(Re * Q)), oe);
        };
        if (he === f)
          return this.set(f, this.$M + Q);
        if (he === h)
          return this.set(h, this.$y + Q);
        if (he === u)
          return Ae(1);
        if (he === c)
          return Ae(7);
        var We = (Z = {}, Z[s] = r, Z[l] = i, Z[o] = n, Z)[he] || 1, ke = this.$d.getTime() + Q * We;
        return F.w(ke, this);
      }, te.subtract = function(Q, Y) {
        return this.add(-1 * Q, Y);
      }, te.format = function(Q) {
        var Y = this, Z = this.$locale();
        if (!this.isValid())
          return Z.invalidDate || y;
        var oe = Q || "YYYY-MM-DDTHH:mm:ssZ", he = F.z(this), Ae = this.$H, We = this.$m, ke = this.$M, Re = Z.weekdays, ve = Z.months, Ye = function(Te, Me, Je, mt) {
          return Te && (Te[Me] || Te(Y, oe)) || Je[Me].slice(0, mt);
        }, Qe = function(Te) {
          return F.s(Ae % 12 || 12, Te, "0");
        }, ot = Z.meridiem || function(Te, Me, Je) {
          var mt = Te < 12 ? "AM" : "PM";
          return Je ? mt.toLowerCase() : mt;
        }, Ve = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: ke + 1, MM: F.s(ke + 1, 2, "0"), MMM: Ye(Z.monthsShort, ke, ve, 3), MMMM: Ye(ve, ke), D: this.$D, DD: F.s(this.$D, 2, "0"), d: String(this.$W), dd: Ye(Z.weekdaysMin, this.$W, Re, 2), ddd: Ye(Z.weekdaysShort, this.$W, Re, 3), dddd: Re[this.$W], H: String(Ae), HH: F.s(Ae, 2, "0"), h: Qe(1), hh: Qe(2), a: ot(Ae, We, !0), A: ot(Ae, We, !1), m: String(We), mm: F.s(We, 2, "0"), s: String(this.$s), ss: F.s(this.$s, 2, "0"), SSS: F.s(this.$ms, 3, "0"), Z: he };
        return oe.replace(b, function(Te, Me) {
          return Me || Ve[Te] || he.replace(":", "");
        });
      }, te.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, te.diff = function(Q, Y, Z) {
        var oe, he = F.p(Y), Ae = R(Q), We = (Ae.utcOffset() - this.utcOffset()) * r, ke = this - Ae, Re = F.m(this, Ae);
        return Re = (oe = {}, oe[h] = Re / 12, oe[f] = Re, oe[d] = Re / 3, oe[c] = (ke - We) / 6048e5, oe[u] = (ke - We) / 864e5, oe[l] = ke / i, oe[s] = ke / r, oe[o] = ke / n, oe)[he] || ke, Z ? Re : F.a(Re);
      }, te.daysInMonth = function() {
        return this.endOf(f).$D;
      }, te.$locale = function() {
        return v[this.$L];
      }, te.locale = function(Q, Y) {
        if (!Q)
          return this.$L;
        var Z = this.clone(), oe = V(Q, Y, !0);
        return oe && (Z.$L = oe), Z;
      }, te.clone = function() {
        return F.w(this.$d, this);
      }, te.toDate = function() {
        return new Date(this.valueOf());
      }, te.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, te.toISOString = function() {
        return this.$d.toISOString();
      }, te.toString = function() {
        return this.$d.toUTCString();
      }, G;
    }(), q = K.prototype;
    return R.prototype = q, [["$ms", a], ["$s", o], ["$m", s], ["$H", l], ["$W", u], ["$M", f], ["$y", h], ["$D", p]].forEach(function(G) {
      q[G[1]] = function(te) {
        return this.$g(te, G[0], G[1]);
      };
    }), R.extend = function(G, te) {
      return G.$i || (G(te, K, R), G.$i = !0), R;
    }, R.locale = V, R.isDayjs = H, R.unix = function(G) {
      return R(1e3 * G);
    }, R.en = v[C], R.Ls = v, R.p = {}, R;
  });
})(Ty);
const Ut = Ty.exports, Abe = ["txt"], Tbe = ["doc", "docx", "xls", "xlsx", "pdf", "ppt", "pptx"], wy = ["mp3", "wma", "rm", "wav", "midi", "ape", "flac"], Py = ["asf", "avi", "flv", "m4v", "mov", "mp4", "rmvb", "wmv", "mkv", "mpeg", "rm", "mpg"], xy = ["gif", "jpg", "jpeg", "png", "bmp"], V1 = (e = "") => {
  const t = {};
  try {
    const n = location.search.slice(1);
    n && n.split("&").forEach((r) => {
      const [i, a] = r.split("=");
      t[i] = decodeURIComponent(a);
    });
  } catch {
  }
  return e ? t[e] : t;
};
function O0(e) {
  const t = Math.round(e), n = t % 60, r = Math.floor(t / 60) % 60, i = Math.floor(t / 60 / 60);
  return `${10 <= i ? i : `0${i}`}:${10 <= r ? r : `0${r}`}:${10 <= n ? n : `0${n}`}`;
}
const Cy = (e, t = "YYYY-MM-DD") => e ? Ut(e).format(t) : "";
function Sy(e) {
  e = e && e.toLowerCase();
  let t = "icon-other";
  return e == "doc" || e == "docx" ? t = "icon-word" : e == "xls" || e == "xlsx" ? t = "icon-excel" : e == "ppt" || e == "pptx" ? t = "icon-ppt" : e == "txt" ? t = "icon-txt" : e == "pdf" ? t = "icon-pdf" : e == "rar" || e == "zip" ? t = "icon-zip" : xy.includes(e) ? t = "icon-image" : wy.includes(e) ? t = "icon-music" : Py.includes(e) ? t = "icon-video" : e === null && (t = "icon-link"), t;
}
function gD(e) {
  if (!e || !Number(e))
    return "0B";
  const t = 1024, n = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], r = Math.floor(Math.log(e) / Math.log(t)), i = e / t ** r;
  return i > 1e3 ? (i / 1024).toPrecision(2) + n[r + 1] : i.toPrecision(3) + n[r];
}
function yD(e) {
  if (!e)
    return "";
  const t = e.replace(/(\n)/g, "").replace(/(\t)/g, "").replace(/(\r)/g, "").replace(/<\/?[^>]*>/g, "").replace(/\s*/g, "").replaceAll("&nbsp;", " "), n = document.createElement("div");
  return n.innerHTML = t, n.innerText || n.textContent;
}
function kr(e) {
  return new Promise((t, n) => {
    let r = document.querySelector(`[src='${e}']`);
    r ? r.addEventListener("load", () => {
      t(null);
    }) : (r = document.createElement("script"), r.type = "text/javascript", r.src = e, document.querySelectorAll("head")[0].append(r), r.addEventListener("load", () => {
      t(null);
    }), r.addEventListener("error", () => {
      n();
    }));
  });
}
const bD = (e) => new URL((/* @__PURE__ */ Object.assign({ "../assets/img/base/user_avatar.jpg": tD, "../assets/img/diffMark/add_icon.png": nD, "../assets/img/diffMark/attachment_icon.png": iD, "../assets/img/diffMark/bg/course_bg1.png": rD, "../assets/img/diffMark/image_text_icon.png": aD, "../assets/img/diffMark/teaching-header-bg.png": oD, "../assets/img/diffMark/tip_icon.png": sD, "../assets/img/diffMark/types_icon/icon-excel.png": cy, "../assets/img/diffMark/types_icon/icon-image.png": dy, "../assets/img/diffMark/types_icon/icon-link.png": fy, "../assets/img/diffMark/types_icon/icon-music.png": hy, "../assets/img/diffMark/types_icon/icon-other.png": py, "../assets/img/diffMark/types_icon/icon-pdf.png": vy, "../assets/img/diffMark/types_icon/icon-ppt.png": my, "../assets/img/diffMark/types_icon/icon-txt.png": gy, "../assets/img/diffMark/types_icon/icon-video.png": yy, "../assets/img/diffMark/types_icon/icon-word.png": by, "../assets/img/diffMark/types_icon/icon-zip.png": Ay, "../assets/img/diffMark/user_icon.png": lD, "../assets/img/diffMark/video_cover.jpg": uD, "../assets/img/diffMark/video_icon.png": cD, "../assets/img/diffMark/\u5B66\u671F.png": dD, "../assets/img/diffMark/\u5B66\u9662.png": fD, "../assets/img/diffMark/\u6559\u7814\u5BA4.png": hD, "../assets/img/diffMark/\u7AE0\u8282.png": pD, "../assets/img/diffMark/\u8001\u5E08.png": vD, "../assets/img/diffMark/\u8BFE\u7A0B.png": mD, "../assets/img/empty/empty_course.png": sg, "../assets/img/empty/empty_message.png": lg, "../assets/img/empty/empty_person.png": ug }))[`../assets/img/${e}`], self.location).href;
function Dl(e) {
  let t;
  if (typeof e == "object")
    if (Array.isArray(e)) {
      t = [];
      for (const n in e)
        t.push(Dl(e[n]));
    } else if (e === null)
      t = null;
    else if (e.constructor === RegExp)
      t = e;
    else {
      t = {};
      for (const n in e)
        t[n] = Dl(e[n]);
    }
  else
    t = e;
  return t;
}
const AD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getUrlParams: V1,
  dateTransfer: O0,
  formatDate: Cy,
  formatIcons: Sy,
  converByte: gD,
  getContentText: yD,
  loadJs: kr,
  getImage: bD,
  deepClone: Dl
}, Symbol.toStringTag, { value: "Module" })), wbe = /^\w+([+.-]\w+)*@\w+([.-]\w+)*\.\w+([.-]\w+)*$/, Pbe = /^1[3-9]\d{9}$/, xbe = /(http|https):\/\/([\w.]+\/?)\S*/, TD = [
  "advlist anchor autolink autosave code codesample directionality emoticons fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textpattern visualblocks visualchars wordcount contextmenu"
], wD = [
  "searchreplace bold italic underline strikethrough lineheight alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample",
  "hr bullist numlist link image charmap preview anchor pagebreak insertdatetime table emoticons forecolor backcolor fullscreen wordcount"
], PD = ["id"], zs = /* @__PURE__ */ Ee({
  props: {
    id: {
      type: String,
      default() {
        return `vue-tinymce-${Date.now()}${(Math.random() * 1e3).toFixed(0)}`;
      }
    },
    modelValue: {
      type: String,
      default: ""
    },
    toolbar: {
      type: Array,
      required: !1,
      default() {
        return [];
      }
    },
    menubar: {
      type: String,
      default: "file edit insert view format table"
    },
    height: {
      type: [Number, String],
      required: !1,
      default: 360
    },
    width: {
      type: [Number, String],
      required: !1,
      default: "auto"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = (f) => {
      window.tinymce.get(s.tinymceId).setContent(f || "");
    };
    t({
      setContent: i,
      getContent: () => window.tinymce.get(s.tinymceId).getContent()
    });
    const o = ce("$http"), s = zt({
      hasChange: !1,
      hasInit: !1,
      tinymceId: r.id,
      fullscreen: !1
    }), l = J(() => {
      const f = r.width.toString();
      return /^\d+(\.\d+)?$/.test(f) ? `${f}px` : f;
    });
    Ne(
      () => r.modelValue,
      (f) => {
        s.hasChange || bt(() => i(f));
      }
    );
    const u = () => {
      window.tinymce.init({
        language: "zh_CN",
        selector: `#${s.tinymceId}`,
        height: r.height,
        body_class: "panel-body ",
        object_resizing: !0,
        toolbar: r.toolbar.length > 0 ? r.toolbar : wD,
        menubar: !1,
        plugins: TD,
        contextmenu: "",
        contextmenu_never_use_native: !1,
        end_container_on_empty_block: !0,
        powerpaste_word_import: "clean",
        paste_data_images: !0,
        code_dialog_height: 450,
        code_dialog_width: 1e3,
        advlist_bullet_styles: "square",
        advlist_number_styles: "default",
        default_link_target: "_blank",
        link_title: !1,
        nonbreaking_force_tab: !0,
        lineheight_formats: "1 1.5",
        paste_enable_default_filters: !0,
        paste_retain_style_properties: "color font-size text-indent text-align border-collapse",
        paste_word_valid_elements: "table[width|border],tr,td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody,h1,h2,h3,h4,h5,img,p,span",
        init_instance_callback: (f) => {
          r.modelValue && f.setContent(r.modelValue), s.hasInit = !0, f.on("NodeChange Change KeyUp SetContent", () => {
            s.hasChange = !0, n("update:modelValue", f.getContent());
          });
        },
        setup(f) {
          f.on("FullscreenStateChanged", (d) => {
            s.fullscreen = d.state;
          });
        },
        images_upload_handler(f, d, h) {
          const p = f.filename();
          o.getPolicy({ fileName: p }).then((y) => {
            const m = JSON.parse(y), b = new FormData();
            b.append(
              "key",
              `${m.dir + m.fileUUID}.${p.split(".")[p.split(".").length - 1]}`
            ), b.append("policy", m.policy), b.append("OSSAccessKeyId", m.accessid), b.append("success_action_status", "200"), b.append("callback", m.callback), b.append("signature", m.signature), b.append("Content-Disposition", `attachment;filename=${p}`), b.append("file", f.blob()), uy({
              method: "POST",
              url: m.host,
              data: b,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }).then((x) => {
              console.log(d), d(x.data.data.fileUrl);
            }).catch(() => {
              h("\u4E0A\u4F20\u5931\u8D25");
            });
          });
        }
      });
    }, c = () => {
      const f = window.tinymce.get(s.tinymceId);
      s.fullscreen && f.execCommand("mceFullScreen"), f && f.destroy();
    };
    return rn(() => {
      window.tinymce ? u() : kr("/tinymce/tinymce.min.js").then(() => {
        u();
      });
    }), hc(() => {
      c();
    }), (f, d) => (P(), L("div", {
      class: "tinymce-container",
      style: Pt({ width: E(l) })
    }, [
      T("textarea", {
        id: E(s).tinymceId,
        class: "tinymce-textarea"
      }, null, 8, PD)
    ], 4));
  }
});
zs.name = "tinymce";
zs.install = (e) => {
  e.component(zs.name, zs);
};
const xD = "data:image/jpeg;base64,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", CD = ["src"], SD = {
  key: 2,
  class: "mark"
}, ED = /* @__PURE__ */ Ee({
  props: {
    src: {
      type: String,
      default: ""
    },
    isShowDefaultAvatar: {
      type: Boolean,
      default: !1
    },
    isShowMark: {
      type: Boolean,
      default: !1
    },
    style: {
      type: Object
    },
    iconSize: {
      type: [String, Number],
      default: 40
    },
    iconName: {
      type: String,
      default: "\u4E0A\u4F20\u5934\u50CF"
    },
    isHover: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = J(() => t.src ? t.src : t.isShowDefaultAvatar ? xD : "");
    return (r, i) => (P(), L("div", {
      class: se(["zhs-avatar", e.isHover && !e.src ? "hover" : ""]),
      style: Pt(e.style)
    }, [
      E(n) ? (P(), L("img", {
        key: 0,
        src: E(n)
      }, null, 8, CD)) : (P(), ue(E(qi), {
        key: 1,
        name: e.iconName,
        color: "#EEEEEE",
        size: e.iconSize
      }, null, 8, ["name", "size"])),
      e.isShowMark && e.src ? (P(), L("div", SD, [
        B(E(qi), {
          name: e.iconName,
          color: "#FFFFFF",
          size: e.iconSize
        }, null, 8, ["name", "size"])
      ])) : re("", !0)
    ], 6));
  }
});
const Tl = /* @__PURE__ */ Ht(ED, [["__scopeId", "data-v-564fe62f"]]);
Tl.name = "avatar";
Tl.install = (e) => {
  e.component(Tl.name, Tl);
};
const kD = /* @__PURE__ */ Ee({
  props: {
    height: {
      type: String,
      default: "300px"
    },
    blur: {
      type: String,
      default: "20px"
    },
    saturate: {
      type: String,
      default: "50%"
    },
    opacity: {
      type: Number,
      default: 0.3
    },
    defaultBgColor: {
      type: String
    },
    url: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (P(), L("div", {
      class: "ground-glassbg",
      style: Pt({
        height: e.height,
        backgroundColor: e.defaultBgColor,
        backgroundImage: `url(${e.url})`
      })
    }, [
      T("div", {
        class: "warp",
        style: Pt({
          backgroundColor: `rgba(0,0,0, ${e.opacity})`,
          backdropFilter: `blur(${e.blur}) saturate(${e.saturate})`
        })
      }, [
        tt(t.$slots, "default", {}, void 0, !0)
      ], 4)
    ], 4));
  }
});
const Ou = /* @__PURE__ */ Ht(kD, [["__scopeId", "data-v-4d7f29d2"]]);
Ou.name = "ground-glassbg";
Ou.install = (e) => {
  e.component(Ou.name, Ou);
};
var OD = typeof global == "object" && global && global.Object === Object && global;
const Ey = OD;
var zD = typeof self == "object" && self && self.Object === Object && self, DD = Ey || zD || Function("return this")();
const Ga = DD;
var MD = Ga.Symbol;
const ga = MD;
var ky = Object.prototype, HD = ky.hasOwnProperty, ID = ky.toString, Gc = ga ? ga.toStringTag : void 0;
function LD(e) {
  var t = HD.call(e, Gc), n = e[Gc];
  try {
    e[Gc] = void 0;
    var r = !0;
  } catch {
  }
  var i = ID.call(e);
  return r && (t ? e[Gc] = n : delete e[Gc]), i;
}
var BD = Object.prototype, ND = BD.toString;
function jD(e) {
  return ND.call(e);
}
var FD = "[object Null]", XD = "[object Undefined]", Mv = ga ? ga.toStringTag : void 0;
function pc(e) {
  return e == null ? e === void 0 ? XD : FD : Mv && Mv in Object(e) ? LD(e) : jD(e);
}
function Ds(e) {
  return e != null && typeof e == "object";
}
var RD = "[object Symbol]";
function kh(e) {
  return typeof e == "symbol" || Ds(e) && pc(e) == RD;
}
function VD(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var UD = Array.isArray;
const qo = UD;
var qD = 1 / 0, Hv = ga ? ga.prototype : void 0, Iv = Hv ? Hv.toString : void 0;
function Oy(e) {
  if (typeof e == "string")
    return e;
  if (qo(e))
    return VD(e, Oy) + "";
  if (kh(e))
    return Iv ? Iv.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -qD ? "-0" : t;
}
var _D = /\s/;
function WD(e) {
  for (var t = e.length; t-- && _D.test(e.charAt(t)); )
    ;
  return t;
}
var KD = /^\s+/;
function GD(e) {
  return e && e.slice(0, WD(e) + 1).replace(KD, "");
}
function Ms(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Lv = 0 / 0, YD = /^[-+]0x[0-9a-f]+$/i, QD = /^0b[01]+$/i, ZD = /^0o[0-7]+$/i, JD = parseInt;
function Bv(e) {
  if (typeof e == "number")
    return e;
  if (kh(e))
    return Lv;
  if (Ms(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ms(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = GD(e);
  var n = QD.test(e);
  return n || ZD.test(e) ? JD(e.slice(2), n ? 2 : 8) : YD.test(e) ? Lv : +e;
}
var $D = "[object AsyncFunction]", eM = "[object Function]", tM = "[object GeneratorFunction]", nM = "[object Proxy]";
function zy(e) {
  if (!Ms(e))
    return !1;
  var t = pc(e);
  return t == eM || t == tM || t == $D || t == nM;
}
var iM = Ga["__core-js_shared__"];
const rp = iM;
var Nv = function() {
  var e = /[^.]+$/.exec(rp && rp.keys && rp.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function rM(e) {
  return !!Nv && Nv in e;
}
var aM = Function.prototype, oM = aM.toString;
function jl(e) {
  if (e != null) {
    try {
      return oM.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var sM = /[\\^$.*+?()[\]{}|]/g, lM = /^\[object .+?Constructor\]$/, uM = Function.prototype, cM = Object.prototype, dM = uM.toString, fM = cM.hasOwnProperty, hM = RegExp(
  "^" + dM.call(fM).replace(sM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pM(e) {
  if (!Ms(e) || rM(e))
    return !1;
  var t = zy(e) ? hM : lM;
  return t.test(jl(e));
}
function vM(e, t) {
  return e == null ? void 0 : e[t];
}
function Fl(e, t) {
  var n = vM(e, t);
  return pM(n) ? n : void 0;
}
var mM = Fl(Ga, "WeakMap");
const m8 = mM;
var jv = Object.create, gM = function() {
  function e() {
  }
  return function(t) {
    if (!Ms(t))
      return {};
    if (jv)
      return jv(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
const yM = gM;
function bM(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var AM = function() {
  try {
    var e = Fl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Fv = AM;
function TM(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var wM = 9007199254740991, PM = /^(?:0|[1-9]\d*)$/;
function xM(e, t) {
  var n = typeof e;
  return t = t == null ? wM : t, !!t && (n == "number" || n != "symbol" && PM.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Dy(e, t, n) {
  t == "__proto__" && Fv ? Fv(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function t3(e, t) {
  return e === t || e !== e && t !== t;
}
var CM = Object.prototype, SM = CM.hasOwnProperty;
function My(e, t, n) {
  var r = e[t];
  (!(SM.call(e, t) && t3(r, n)) || n === void 0 && !(t in e)) && Dy(e, t, n);
}
function Oh(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var s = t[a], l = r ? r(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), i ? Dy(n, s, l) : My(n, s, l);
  }
  return n;
}
var EM = 9007199254740991;
function Hy(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= EM;
}
function Iy(e) {
  return e != null && Hy(e.length) && !zy(e);
}
var kM = Object.prototype;
function n3(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || kM;
  return e === n;
}
function OM(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var zM = "[object Arguments]";
function Xv(e) {
  return Ds(e) && pc(e) == zM;
}
var Ly = Object.prototype, DM = Ly.hasOwnProperty, MM = Ly.propertyIsEnumerable, HM = Xv(function() {
  return arguments;
}()) ? Xv : function(e) {
  return Ds(e) && DM.call(e, "callee") && !MM.call(e, "callee");
};
const By = HM;
function IM() {
  return !1;
}
var Ny = typeof exports == "object" && exports && !exports.nodeType && exports, Rv = Ny && typeof module == "object" && module && !module.nodeType && module, LM = Rv && Rv.exports === Ny, Vv = LM ? Ga.Buffer : void 0, BM = Vv ? Vv.isBuffer : void 0, NM = BM || IM;
const z0 = NM;
var jM = "[object Arguments]", FM = "[object Array]", XM = "[object Boolean]", RM = "[object Date]", VM = "[object Error]", UM = "[object Function]", qM = "[object Map]", _M = "[object Number]", WM = "[object Object]", KM = "[object RegExp]", GM = "[object Set]", YM = "[object String]", QM = "[object WeakMap]", ZM = "[object ArrayBuffer]", JM = "[object DataView]", $M = "[object Float32Array]", eH = "[object Float64Array]", tH = "[object Int8Array]", nH = "[object Int16Array]", iH = "[object Int32Array]", rH = "[object Uint8Array]", aH = "[object Uint8ClampedArray]", oH = "[object Uint16Array]", sH = "[object Uint32Array]", Jn = {};
Jn[$M] = Jn[eH] = Jn[tH] = Jn[nH] = Jn[iH] = Jn[rH] = Jn[aH] = Jn[oH] = Jn[sH] = !0;
Jn[jM] = Jn[FM] = Jn[ZM] = Jn[XM] = Jn[JM] = Jn[RM] = Jn[VM] = Jn[UM] = Jn[qM] = Jn[_M] = Jn[WM] = Jn[KM] = Jn[GM] = Jn[YM] = Jn[QM] = !1;
function lH(e) {
  return Ds(e) && Hy(e.length) && !!Jn[pc(e)];
}
function i3(e) {
  return function(t) {
    return e(t);
  };
}
var jy = typeof exports == "object" && exports && !exports.nodeType && exports, md = jy && typeof module == "object" && module && !module.nodeType && module, uH = md && md.exports === jy, ap = uH && Ey.process, cH = function() {
  try {
    var e = md && md.require && md.require("util").types;
    return e || ap && ap.binding && ap.binding("util");
  } catch {
  }
}();
const Vu = cH;
var Uv = Vu && Vu.isTypedArray, dH = Uv ? i3(Uv) : lH;
const Fy = dH;
var fH = Object.prototype, hH = fH.hasOwnProperty;
function Xy(e, t) {
  var n = qo(e), r = !n && By(e), i = !n && !r && z0(e), a = !n && !r && !i && Fy(e), o = n || r || i || a, s = o ? OM(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || hH.call(e, u)) && !(o && (u == "length" || i && (u == "offset" || u == "parent") || a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || xM(u, l))) && s.push(u);
  return s;
}
function Ry(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var pH = Ry(Object.keys, Object);
const vH = pH;
var mH = Object.prototype, gH = mH.hasOwnProperty;
function yH(e) {
  if (!n3(e))
    return vH(e);
  var t = [];
  for (var n in Object(e))
    gH.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function r3(e) {
  return Iy(e) ? Xy(e) : yH(e);
}
function bH(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var AH = Object.prototype, TH = AH.hasOwnProperty;
function wH(e) {
  if (!Ms(e))
    return bH(e);
  var t = n3(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !TH.call(e, r)) || n.push(r);
  return n;
}
function a3(e) {
  return Iy(e) ? Xy(e, !0) : wH(e);
}
var PH = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xH = /^\w*$/;
function CH(e, t) {
  if (qo(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || kh(e) ? !0 : xH.test(e) || !PH.test(e) || t != null && e in Object(t);
}
var SH = Fl(Object, "create");
const Id = SH;
function EH() {
  this.__data__ = Id ? Id(null) : {}, this.size = 0;
}
function kH(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var OH = "__lodash_hash_undefined__", zH = Object.prototype, DH = zH.hasOwnProperty;
function MH(e) {
  var t = this.__data__;
  if (Id) {
    var n = t[e];
    return n === OH ? void 0 : n;
  }
  return DH.call(t, e) ? t[e] : void 0;
}
var HH = Object.prototype, IH = HH.hasOwnProperty;
function LH(e) {
  var t = this.__data__;
  return Id ? t[e] !== void 0 : IH.call(t, e);
}
var BH = "__lodash_hash_undefined__";
function NH(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Id && t === void 0 ? BH : t, this;
}
function Ml(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ml.prototype.clear = EH;
Ml.prototype.delete = kH;
Ml.prototype.get = MH;
Ml.prototype.has = LH;
Ml.prototype.set = NH;
function jH() {
  this.__data__ = [], this.size = 0;
}
function zh(e, t) {
  for (var n = e.length; n--; )
    if (t3(e[n][0], t))
      return n;
  return -1;
}
var FH = Array.prototype, XH = FH.splice;
function RH(e) {
  var t = this.__data__, n = zh(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : XH.call(t, n, 1), --this.size, !0;
}
function VH(e) {
  var t = this.__data__, n = zh(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function UH(e) {
  return zh(this.__data__, e) > -1;
}
function qH(e, t) {
  var n = this.__data__, r = zh(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function Jo(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Jo.prototype.clear = jH;
Jo.prototype.delete = RH;
Jo.prototype.get = VH;
Jo.prototype.has = UH;
Jo.prototype.set = qH;
var _H = Fl(Ga, "Map");
const Ld = _H;
function WH() {
  this.size = 0, this.__data__ = {
    hash: new Ml(),
    map: new (Ld || Jo)(),
    string: new Ml()
  };
}
function KH(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Dh(e, t) {
  var n = e.__data__;
  return KH(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function GH(e) {
  var t = Dh(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function YH(e) {
  return Dh(this, e).get(e);
}
function QH(e) {
  return Dh(this, e).has(e);
}
function ZH(e, t) {
  var n = Dh(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function $o(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
$o.prototype.clear = WH;
$o.prototype.delete = GH;
$o.prototype.get = YH;
$o.prototype.has = QH;
$o.prototype.set = ZH;
var JH = "Expected a function";
function Mh(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(JH);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, r);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (Mh.Cache || $o)(), n;
}
Mh.Cache = $o;
var $H = 500;
function eI(e) {
  var t = Mh(e, function(r) {
    return n.size === $H && n.clear(), r;
  }), n = t.cache;
  return t;
}
var tI = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, nI = /\\(\\)?/g, iI = eI(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(tI, function(n, r, i, a) {
    t.push(i ? a.replace(nI, "$1") : r || n);
  }), t;
});
const rI = iI;
function aI(e) {
  return e == null ? "" : Oy(e);
}
function oI(e, t) {
  return qo(e) ? e : CH(e, t) ? [e] : rI(aI(e));
}
var sI = 1 / 0;
function lI(e) {
  if (typeof e == "string" || kh(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -sI ? "-0" : t;
}
function uI(e, t) {
  t = oI(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[lI(t[n++])];
  return n && n == r ? e : void 0;
}
function vi(e, t, n) {
  var r = e == null ? void 0 : uI(e, t);
  return r === void 0 ? n : r;
}
function o3(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var qv = ga ? ga.isConcatSpreadable : void 0;
function cI(e) {
  return qo(e) || By(e) || !!(qv && e && e[qv]);
}
function Vy(e, t, n, r, i) {
  var a = -1, o = e.length;
  for (n || (n = cI), i || (i = []); ++a < o; ) {
    var s = e[a];
    t > 0 && n(s) ? t > 1 ? Vy(s, t - 1, n, r, i) : o3(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var dI = Ry(Object.getPrototypeOf, Object);
const Uy = dI;
function fI() {
  this.__data__ = new Jo(), this.size = 0;
}
function hI(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function pI(e) {
  return this.__data__.get(e);
}
function vI(e) {
  return this.__data__.has(e);
}
var mI = 200;
function gI(e, t) {
  var n = this.__data__;
  if (n instanceof Jo) {
    var r = n.__data__;
    if (!Ld || r.length < mI - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new $o(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function No(e) {
  var t = this.__data__ = new Jo(e);
  this.size = t.size;
}
No.prototype.clear = fI;
No.prototype.delete = hI;
No.prototype.get = pI;
No.prototype.has = vI;
No.prototype.set = gI;
function yI(e, t) {
  return e && Oh(t, r3(t), e);
}
function bI(e, t) {
  return e && Oh(t, a3(t), e);
}
var qy = typeof exports == "object" && exports && !exports.nodeType && exports, _v = qy && typeof module == "object" && module && !module.nodeType && module, AI = _v && _v.exports === qy, Wv = AI ? Ga.Buffer : void 0, Kv = Wv ? Wv.allocUnsafe : void 0;
function TI(e, t) {
  if (t)
    return e.slice();
  var n = e.length, r = Kv ? Kv(n) : new e.constructor(n);
  return e.copy(r), r;
}
function wI(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (a[i++] = o);
  }
  return a;
}
function _y() {
  return [];
}
var PI = Object.prototype, xI = PI.propertyIsEnumerable, Gv = Object.getOwnPropertySymbols, CI = Gv ? function(e) {
  return e == null ? [] : (e = Object(e), wI(Gv(e), function(t) {
    return xI.call(e, t);
  }));
} : _y;
const s3 = CI;
function SI(e, t) {
  return Oh(e, s3(e), t);
}
var EI = Object.getOwnPropertySymbols, kI = EI ? function(e) {
  for (var t = []; e; )
    o3(t, s3(e)), e = Uy(e);
  return t;
} : _y;
const Wy = kI;
function OI(e, t) {
  return Oh(e, Wy(e), t);
}
function Ky(e, t, n) {
  var r = t(e);
  return qo(e) ? r : o3(r, n(e));
}
function g8(e) {
  return Ky(e, r3, s3);
}
function zI(e) {
  return Ky(e, a3, Wy);
}
var DI = Fl(Ga, "DataView");
const y8 = DI;
var MI = Fl(Ga, "Promise");
const b8 = MI;
var HI = Fl(Ga, "Set");
const A8 = HI;
var Yv = "[object Map]", II = "[object Object]", Qv = "[object Promise]", Zv = "[object Set]", Jv = "[object WeakMap]", $v = "[object DataView]", LI = jl(y8), BI = jl(Ld), NI = jl(b8), jI = jl(A8), FI = jl(m8), ll = pc;
(y8 && ll(new y8(new ArrayBuffer(1))) != $v || Ld && ll(new Ld()) != Yv || b8 && ll(b8.resolve()) != Qv || A8 && ll(new A8()) != Zv || m8 && ll(new m8()) != Jv) && (ll = function(e) {
  var t = pc(e), n = t == II ? e.constructor : void 0, r = n ? jl(n) : "";
  if (r)
    switch (r) {
      case LI:
        return $v;
      case BI:
        return Yv;
      case NI:
        return Qv;
      case jI:
        return Zv;
      case FI:
        return Jv;
    }
  return t;
});
const Bd = ll;
var XI = Object.prototype, RI = XI.hasOwnProperty;
function VI(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && RI.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var UI = Ga.Uint8Array;
const D0 = UI;
function l3(e) {
  var t = new e.constructor(e.byteLength);
  return new D0(t).set(new D0(e)), t;
}
function qI(e, t) {
  var n = t ? l3(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var _I = /\w*$/;
function WI(e) {
  var t = new e.constructor(e.source, _I.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var e5 = ga ? ga.prototype : void 0, t5 = e5 ? e5.valueOf : void 0;
function KI(e) {
  return t5 ? Object(t5.call(e)) : {};
}
function GI(e, t) {
  var n = t ? l3(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var YI = "[object Boolean]", QI = "[object Date]", ZI = "[object Map]", JI = "[object Number]", $I = "[object RegExp]", eL = "[object Set]", tL = "[object String]", nL = "[object Symbol]", iL = "[object ArrayBuffer]", rL = "[object DataView]", aL = "[object Float32Array]", oL = "[object Float64Array]", sL = "[object Int8Array]", lL = "[object Int16Array]", uL = "[object Int32Array]", cL = "[object Uint8Array]", dL = "[object Uint8ClampedArray]", fL = "[object Uint16Array]", hL = "[object Uint32Array]";
function pL(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case iL:
      return l3(e);
    case YI:
    case QI:
      return new r(+e);
    case rL:
      return qI(e, n);
    case aL:
    case oL:
    case sL:
    case lL:
    case uL:
    case cL:
    case dL:
    case fL:
    case hL:
      return GI(e, n);
    case ZI:
      return new r();
    case JI:
    case tL:
      return new r(e);
    case $I:
      return WI(e);
    case eL:
      return new r();
    case nL:
      return KI(e);
  }
}
function vL(e) {
  return typeof e.constructor == "function" && !n3(e) ? yM(Uy(e)) : {};
}
var mL = "[object Map]";
function gL(e) {
  return Ds(e) && Bd(e) == mL;
}
var n5 = Vu && Vu.isMap, yL = n5 ? i3(n5) : gL;
const bL = yL;
var AL = "[object Set]";
function TL(e) {
  return Ds(e) && Bd(e) == AL;
}
var i5 = Vu && Vu.isSet, wL = i5 ? i3(i5) : TL;
const PL = wL;
var xL = 1, CL = 2, SL = 4, Gy = "[object Arguments]", EL = "[object Array]", kL = "[object Boolean]", OL = "[object Date]", zL = "[object Error]", Yy = "[object Function]", DL = "[object GeneratorFunction]", ML = "[object Map]", HL = "[object Number]", Qy = "[object Object]", IL = "[object RegExp]", LL = "[object Set]", BL = "[object String]", NL = "[object Symbol]", jL = "[object WeakMap]", FL = "[object ArrayBuffer]", XL = "[object DataView]", RL = "[object Float32Array]", VL = "[object Float64Array]", UL = "[object Int8Array]", qL = "[object Int16Array]", _L = "[object Int32Array]", WL = "[object Uint8Array]", KL = "[object Uint8ClampedArray]", GL = "[object Uint16Array]", YL = "[object Uint32Array]", Gn = {};
Gn[Gy] = Gn[EL] = Gn[FL] = Gn[XL] = Gn[kL] = Gn[OL] = Gn[RL] = Gn[VL] = Gn[UL] = Gn[qL] = Gn[_L] = Gn[ML] = Gn[HL] = Gn[Qy] = Gn[IL] = Gn[LL] = Gn[BL] = Gn[NL] = Gn[WL] = Gn[KL] = Gn[GL] = Gn[YL] = !0;
Gn[zL] = Gn[Yy] = Gn[jL] = !1;
function U1(e, t, n, r, i, a) {
  var o, s = t & xL, l = t & CL, u = t & SL;
  if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0)
    return o;
  if (!Ms(e))
    return e;
  var c = qo(e);
  if (c) {
    if (o = VI(e), !s)
      return bM(e, o);
  } else {
    var f = Bd(e), d = f == Yy || f == DL;
    if (z0(e))
      return TI(e, s);
    if (f == Qy || f == Gy || d && !i) {
      if (o = l || d ? {} : vL(e), !s)
        return l ? OI(e, bI(o, e)) : SI(e, yI(o, e));
    } else {
      if (!Gn[f])
        return i ? e : {};
      o = pL(e, f, s);
    }
  }
  a || (a = new No());
  var h = a.get(e);
  if (h)
    return h;
  a.set(e, o), PL(e) ? e.forEach(function(m) {
    o.add(U1(m, t, n, m, e, a));
  }) : bL(e) && e.forEach(function(m, b) {
    o.set(b, U1(m, t, n, b, e, a));
  });
  var p = u ? l ? zI : g8 : l ? a3 : r3, y = c ? void 0 : p(e);
  return TM(y || e, function(m, b) {
    y && (b = m, m = e[b]), My(o, b, U1(m, t, n, b, e, a));
  }), o;
}
var QL = 1, ZL = 4;
function JL(e) {
  return U1(e, QL | ZL);
}
var $L = "__lodash_hash_undefined__";
function eB(e) {
  return this.__data__.set(e, $L), this;
}
function tB(e) {
  return this.__data__.has(e);
}
function M0(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new $o(); ++t < n; )
    this.add(e[t]);
}
M0.prototype.add = M0.prototype.push = eB;
M0.prototype.has = tB;
function nB(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function iB(e, t) {
  return e.has(t);
}
var rB = 1, aB = 2;
function Zy(e, t, n, r, i, a) {
  var o = n & rB, s = e.length, l = t.length;
  if (s != l && !(o && l > s))
    return !1;
  var u = a.get(e), c = a.get(t);
  if (u && c)
    return u == t && c == e;
  var f = -1, d = !0, h = n & aB ? new M0() : void 0;
  for (a.set(e, t), a.set(t, e); ++f < s; ) {
    var p = e[f], y = t[f];
    if (r)
      var m = o ? r(y, p, f, t, e, a) : r(p, y, f, e, t, a);
    if (m !== void 0) {
      if (m)
        continue;
      d = !1;
      break;
    }
    if (h) {
      if (!nB(t, function(b, x) {
        if (!iB(h, x) && (p === b || i(p, b, n, r, a)))
          return h.push(x);
      })) {
        d = !1;
        break;
      }
    } else if (!(p === y || i(p, y, n, r, a))) {
      d = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), d;
}
function oB(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function sB(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var lB = 1, uB = 2, cB = "[object Boolean]", dB = "[object Date]", fB = "[object Error]", hB = "[object Map]", pB = "[object Number]", vB = "[object RegExp]", mB = "[object Set]", gB = "[object String]", yB = "[object Symbol]", bB = "[object ArrayBuffer]", AB = "[object DataView]", r5 = ga ? ga.prototype : void 0, op = r5 ? r5.valueOf : void 0;
function TB(e, t, n, r, i, a, o) {
  switch (n) {
    case AB:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case bB:
      return !(e.byteLength != t.byteLength || !a(new D0(e), new D0(t)));
    case cB:
    case dB:
    case pB:
      return t3(+e, +t);
    case fB:
      return e.name == t.name && e.message == t.message;
    case vB:
    case gB:
      return e == t + "";
    case hB:
      var s = oB;
    case mB:
      var l = r & lB;
      if (s || (s = sB), e.size != t.size && !l)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      r |= uB, o.set(e, t);
      var c = Zy(s(e), s(t), r, i, a, o);
      return o.delete(e), c;
    case yB:
      if (op)
        return op.call(e) == op.call(t);
  }
  return !1;
}
var wB = 1, PB = Object.prototype, xB = PB.hasOwnProperty;
function CB(e, t, n, r, i, a) {
  var o = n & wB, s = g8(e), l = s.length, u = g8(t), c = u.length;
  if (l != c && !o)
    return !1;
  for (var f = l; f--; ) {
    var d = s[f];
    if (!(o ? d in t : xB.call(t, d)))
      return !1;
  }
  var h = a.get(e), p = a.get(t);
  if (h && p)
    return h == t && p == e;
  var y = !0;
  a.set(e, t), a.set(t, e);
  for (var m = o; ++f < l; ) {
    d = s[f];
    var b = e[d], x = t[d];
    if (r)
      var D = o ? r(x, b, d, t, e, a) : r(b, x, d, e, t, a);
    if (!(D === void 0 ? b === x || i(b, x, n, r, a) : D)) {
      y = !1;
      break;
    }
    m || (m = d == "constructor");
  }
  if (y && !m) {
    var S = e.constructor, C = t.constructor;
    S != C && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof C == "function" && C instanceof C) && (y = !1);
  }
  return a.delete(e), a.delete(t), y;
}
var SB = 1, a5 = "[object Arguments]", o5 = "[object Array]", c1 = "[object Object]", EB = Object.prototype, s5 = EB.hasOwnProperty;
function kB(e, t, n, r, i, a) {
  var o = qo(e), s = qo(t), l = o ? o5 : Bd(e), u = s ? o5 : Bd(t);
  l = l == a5 ? c1 : l, u = u == a5 ? c1 : u;
  var c = l == c1, f = u == c1, d = l == u;
  if (d && z0(e)) {
    if (!z0(t))
      return !1;
    o = !0, c = !1;
  }
  if (d && !c)
    return a || (a = new No()), o || Fy(e) ? Zy(e, t, n, r, i, a) : TB(e, t, l, n, r, i, a);
  if (!(n & SB)) {
    var h = c && s5.call(e, "__wrapped__"), p = f && s5.call(t, "__wrapped__");
    if (h || p) {
      var y = h ? e.value() : e, m = p ? t.value() : t;
      return a || (a = new No()), i(y, m, n, r, a);
    }
  }
  return d ? (a || (a = new No()), CB(e, t, n, r, i, a)) : !1;
}
function Jy(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !Ds(e) && !Ds(t) ? e !== e && t !== t : kB(e, t, n, r, Jy, i);
}
var OB = function() {
  return Ga.Date.now();
};
const sp = OB;
var zB = "Expected a function", DB = Math.max, MB = Math.min;
function qa(e, t, n) {
  var r, i, a, o, s, l, u = 0, c = !1, f = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(zB);
  t = Bv(t) || 0, Ms(n) && (c = !!n.leading, f = "maxWait" in n, a = f ? DB(Bv(n.maxWait) || 0, t) : a, d = "trailing" in n ? !!n.trailing : d);
  function h(v) {
    var H = r, V = i;
    return r = i = void 0, u = v, o = e.apply(V, H), o;
  }
  function p(v) {
    return u = v, s = setTimeout(b, t), c ? h(v) : o;
  }
  function y(v) {
    var H = v - l, V = v - u, R = t - H;
    return f ? MB(R, a - V) : R;
  }
  function m(v) {
    var H = v - l, V = v - u;
    return l === void 0 || H >= t || H < 0 || f && V >= a;
  }
  function b() {
    var v = sp();
    if (m(v))
      return x(v);
    s = setTimeout(b, y(v));
  }
  function x(v) {
    return s = void 0, d && r ? h(v) : (r = i = void 0, o);
  }
  function D() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = i = s = void 0;
  }
  function S() {
    return s === void 0 ? o : x(sp());
  }
  function C() {
    var v = sp(), H = m(v);
    if (r = arguments, i = this, l = v, H) {
      if (s === void 0)
        return p(l);
      if (f)
        return clearTimeout(s), s = setTimeout(b, t), h(l);
    }
    return s === void 0 && (s = setTimeout(b, t)), o;
  }
  return C.cancel = D, C.flush = S, C;
}
var HB = 1 / 0;
function IB(e) {
  var t = e == null ? 0 : e.length;
  return t ? Vy(e, HB) : [];
}
function $y(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var i = e[t];
    r[i[0]] = i[1];
  }
  return r;
}
function ja(e, t) {
  return Jy(e, t);
}
const LB = 'a[href],button:not([disabled]),button:not([hidden]),:not([tabindex="-1"]),input:not([disabled]),input:not([type="hidden"]),select:not([disabled]),textarea:not([disabled])', BB = (e) => process.env.NODE_ENV === "test" ? !0 : getComputedStyle(e).position === "fixed" ? !1 : e.offsetParent !== null, l5 = (e) => Array.from(e.querySelectorAll(LB)).filter((t) => NB(t) && BB(t)), NB = (e) => {
  if (e.tabIndex > 0 || e.tabIndex === 0 && e.getAttribute("tabIndex") !== null)
    return !0;
  if (e.disabled)
    return !1;
  switch (e.nodeName) {
    case "A":
      return !!e.href && e.rel !== "ignore";
    case "INPUT":
      return !(e.type === "hidden" || e.type === "file");
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}, q1 = function(e, t, ...n) {
  let r;
  t.includes("mouse") || t.includes("click") ? r = "MouseEvents" : t.includes("key") ? r = "KeyboardEvent" : r = "HTMLEvents";
  const i = document.createEvent(r);
  return i.initEvent(t, ...n), e.dispatchEvent(i), e;
}, eb = (e) => !e.getAttribute("aria-owns"), tb = (e, t, n) => {
  const { parentNode: r } = e;
  if (!r)
    return null;
  const i = r.querySelectorAll(n), a = Array.prototype.indexOf.call(i, e);
  return i[a + t] || null;
}, _1 = (e) => {
  !e || (e.focus(), !eb(e) && e.click());
}, _n = (e, t, n, r = !1) => {
  e && t && n && (e == null || e.addEventListener(t, n, r));
}, si = (e, t, n, r = !1) => {
  e && t && n && (e == null || e.removeEventListener(t, n, r));
}, jB = (e, t, n) => {
  const r = function(...i) {
    n && n.apply(this, i), si(e, t, r);
  };
  _n(e, t, r);
}, Si = (e, t, { checkForDefaultPrevented: n = !0 } = {}) => (i) => {
  const a = e == null ? void 0 : e(i);
  if (n === !1 || !a)
    return t == null ? void 0 : t(i);
}, u5 = (e) => (t) => t.pointerType === "mouse" ? e(t) : void 0;
function Hh(e) {
  return tg() ? (W4(e), !0) : !1;
}
const Sn = typeof window < "u", Fa = (e) => typeof e == "boolean", jn = (e) => typeof e == "number", FB = (e) => typeof e == "string", lp = () => {
};
var XB = Object.defineProperty, RB = Object.defineProperties, VB = Object.getOwnPropertyDescriptors, c5 = Object.getOwnPropertySymbols, UB = Object.prototype.hasOwnProperty, qB = Object.prototype.propertyIsEnumerable, d5 = (e, t, n) => t in e ? XB(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, _B = (e, t) => {
  for (var n in t || (t = {}))
    UB.call(t, n) && d5(e, n, t[n]);
  if (c5)
    for (var n of c5(t))
      qB.call(t, n) && d5(e, n, t[n]);
  return e;
}, WB = (e, t) => RB(e, VB(t));
function f5(e, t) {
  var n;
  const r = Uo();
  return Bo(() => {
    r.value = e();
  }, WB(_B({}, t), {
    flush: (n = t == null ? void 0 : t.flush) != null ? n : "sync"
  })), _4(r);
}
function Nd(e, t, n = {}) {
  const {
    immediate: r = !0
  } = n, i = j(!1);
  let a = null;
  function o() {
    a && (clearTimeout(a), a = null);
  }
  function s() {
    i.value = !1, o();
  }
  function l(...u) {
    o(), i.value = !0, a = setTimeout(() => {
      i.value = !1, a = null, e(...u);
    }, E(t));
  }
  return r && (i.value = !0, Sn && l()), Hh(s), {
    isPending: i,
    start: l,
    stop: s
  };
}
function gd(e) {
  var t;
  const n = E(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const lf = Sn ? window : void 0, KB = Sn ? window.document : void 0;
Sn && window.navigator;
Sn && window.location;
function co(...e) {
  let t, n, r, i;
  if (FB(e[0]) ? ([n, r, i] = e, t = lf) : [t, n, r, i] = e, !t)
    return lp;
  let a = lp;
  const o = Ne(() => E(t), (l) => {
    a(), l && (l.addEventListener(n, r, i), a = () => {
      l.removeEventListener(n, r, i), a = lp;
    });
  }, { immediate: !0, flush: "post" }), s = () => {
    o(), a();
  };
  return Hh(s), s;
}
function T8(e, t, n = {}) {
  const { window: r = lf, ignore: i } = n;
  if (!r)
    return;
  const a = j(!0), s = [
    co(r, "click", (u) => {
      const c = gd(e), f = u.composedPath();
      !c || c === u.target || f.includes(c) || !a.value || i && i.length > 0 && i.some((d) => {
        const h = gd(d);
        return h && (u.target === h || f.includes(h));
      }) || t(u);
    }, { passive: !0, capture: !0 }),
    co(r, "pointerdown", (u) => {
      const c = gd(e);
      a.value = !!c && !u.composedPath().includes(c);
    }, { passive: !0 })
  ];
  return () => s.forEach((u) => u());
}
const w8 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, P8 = "__vueuse_ssr_handlers__";
w8[P8] = w8[P8] || {};
w8[P8];
function GB(e, t, { window: n = lf } = {}) {
  const r = j(""), i = J(() => {
    var a;
    return gd(t) || ((a = n == null ? void 0 : n.document) == null ? void 0 : a.documentElement);
  });
  return Ne([i, () => E(e)], ([a, o]) => {
    a && n && (r.value = n.getComputedStyle(a).getPropertyValue(o));
  }, { immediate: !0 }), Ne(r, (a) => {
    var o;
    (o = i.value) != null && o.style && i.value.style.setProperty(E(e), a);
  }), r;
}
function YB({ document: e = KB } = {}) {
  if (!e)
    return j("visible");
  const t = j(e.visibilityState);
  return co(e, "visibilitychange", () => {
    t.value = e.visibilityState;
  }), t;
}
var h5 = Object.getOwnPropertySymbols, QB = Object.prototype.hasOwnProperty, ZB = Object.prototype.propertyIsEnumerable, JB = (e, t) => {
  var n = {};
  for (var r in e)
    QB.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && h5)
    for (var r of h5(e))
      t.indexOf(r) < 0 && ZB.call(e, r) && (n[r] = e[r]);
  return n;
};
function u3(e, t, n = {}) {
  const r = n, { window: i = lf } = r, a = JB(r, ["window"]);
  let o;
  const s = i && "ResizeObserver" in i, l = () => {
    o && (o.disconnect(), o = void 0);
  }, u = Ne(() => gd(e), (f) => {
    l(), s && i && f && (o = new i.ResizeObserver(t), o.observe(f, a));
  }, { immediate: !0, flush: "post" }), c = () => {
    l(), u();
  };
  return Hh(c), {
    isSupported: s,
    stop: c
  };
}
var p5, v5;
Sn && (window == null ? void 0 : window.navigator) && ((p5 = window == null ? void 0 : window.navigator) == null ? void 0 : p5.platform) && /iP(ad|hone|od)/.test((v5 = window == null ? void 0 : window.navigator) == null ? void 0 : v5.platform);
var $B = Object.defineProperty, m5 = Object.getOwnPropertySymbols, eN = Object.prototype.hasOwnProperty, tN = Object.prototype.propertyIsEnumerable, g5 = (e, t, n) => t in e ? $B(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, nN = (e, t) => {
  for (var n in t || (t = {}))
    eN.call(t, n) && g5(e, n, t[n]);
  if (m5)
    for (var n of m5(t))
      tN.call(t, n) && g5(e, n, t[n]);
  return e;
};
const iN = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  height: 0,
  width: 0
};
nN({
  text: ""
}, iN);
function rN({ window: e = lf } = {}) {
  if (!e)
    return j(!1);
  const t = j(e.document.hasFocus());
  return co(e, "blur", () => {
    t.value = !1;
  }), co(e, "focus", () => {
    t.value = !0;
  }), t;
}
const aN = function(e) {
  for (const t of e) {
    const n = t.target.__resizeListeners__ || [];
    n.length && n.forEach((r) => {
      r();
    });
  }
}, Xl = function(e, t) {
  !Sn || !e || (e.__resizeListeners__ || (e.__resizeListeners__ = [], e.__ro__ = new ResizeObserver(aN), e.__ro__.observe(e)), e.__resizeListeners__.push(t));
}, Rl = function(e, t) {
  var n;
  !e || !e.__resizeListeners__ || (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t), 1), e.__resizeListeners__.length || (n = e.__ro__) == null || n.disconnect());
};
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Vn = () => {
}, oN = Object.prototype.hasOwnProperty, Lr = (e, t) => oN.call(e, t), zu = Array.isArray, fa = (e) => typeof e == "function", Ai = (e) => typeof e == "string", tr = (e) => e !== null && typeof e == "object", H0 = (e) => tr(e) && fa(e.then) && fa(e.catch), sN = Object.prototype.toString, nb = (e) => sN.call(e), up = (e) => nb(e).slice(8, -1), ib = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, lN = /-(\w)/g, uN = ib((e) => e.replace(lN, (t, n) => n ? n.toUpperCase() : "")), Ho = ib((e) => e.charAt(0).toUpperCase() + e.slice(1)), jd = (e) => e === void 0, Fd = (e) => !e && e !== 0 || zu(e) && e.length === 0 || tr(e) && !Object.keys(e).length, cN = (e = "") => e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
class rb extends Error {
  constructor(t) {
    super(t), this.name = "ElementPlusError";
  }
}
function ir(e, t) {
  throw new rb(`[${e}] ${t}`);
}
function fi(e, t) {
  process.env.NODE_ENV !== "production" && console.warn(new rb(`[${e}] ${t}`));
}
const dN = "UtilV2/objects", y5 = (e) => Object.keys(e);
function W1(e, t, n) {
  let r = e, i, a;
  if (e && Lr(e, t))
    i = t, a = r == null ? void 0 : r[t];
  else {
    t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
    const o = t.split(".");
    let s = 0;
    for (s; s < o.length - 1 && !(!r && !n); s++) {
      const l = o[s];
      if (l in r)
        r = r[l];
      else {
        n && ir(dN, "Please transfer a valid prop path to form item!");
        break;
      }
    }
    i = o[s], a = r == null ? void 0 : r[o[s]];
  }
  return {
    o: r,
    k: i,
    v: a
  };
}
const ab = (e = "") => e.split(" ").filter((t) => !!t.trim()), jo = (e, t) => {
  if (!e || !t)
    return !1;
  if (t.includes(" "))
    throw new Error("className should not contain space.");
  return e.classList.contains(t);
}, Ss = (e, t) => {
  !e || !t.trim() || e.classList.add(...ab(t));
}, oo = (e, t) => {
  !e || !t.trim() || e.classList.remove(...ab(t));
}, I0 = (e, t) => {
  var n;
  if (!Sn || !e || !t)
    return "";
  uN(t);
  try {
    const r = e.style[t];
    if (r)
      return r;
    const i = (n = document.defaultView) == null ? void 0 : n.getComputedStyle(e, "");
    return i ? i[t] : "";
  } catch {
    return e.style[t];
  }
};
let d1;
const fN = () => {
  var e;
  if (!Sn)
    return 0;
  if (d1 !== void 0)
    return d1;
  const t = document.createElement("div");
  t.className = "el-scrollbar__wrap", t.style.visibility = "hidden", t.style.width = "100px", t.style.position = "absolute", t.style.top = "-9999px", document.body.appendChild(t);
  const n = t.offsetWidth;
  t.style.overflow = "scroll";
  const r = document.createElement("div");
  r.style.width = "100%", t.appendChild(r);
  const i = r.offsetWidth;
  return (e = t.parentNode) == null || e.removeChild(t), d1 = n - i, d1;
};
function ob(e, t) {
  if (!Sn)
    return;
  if (!t) {
    e.scrollTop = 0;
    return;
  }
  const n = [];
  let r = t.offsetParent;
  for (; r !== null && e !== r && e.contains(r); )
    n.push(r), r = r.offsetParent;
  const i = t.offsetTop + n.reduce((l, u) => l + u.offsetTop, 0), a = i + t.offsetHeight, o = e.scrollTop, s = o + e.clientHeight;
  i < o ? e.scrollTop = i : a > s && (e.scrollTop = a - e.clientHeight);
}
var Yn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
};
const hN = Ee({
  name: "ArrowDown"
}), pN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, vN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M831.872 340.864L512 652.672 192.128 340.864a30.592 30.592 0 00-42.752 0 29.12 29.12 0 000 41.6L489.664 714.24a32 32 0 0044.672 0l340.288-331.712a29.12 29.12 0 000-41.728 30.592 30.592 0 00-42.752 0z"
}, null, -1), mN = [
  vN
];
function gN(e, t, n, r, i, a) {
  return P(), L("svg", pN, mN);
}
var vc = /* @__PURE__ */ Yn(hN, [["render", gN]]);
const yN = Ee({
  name: "ArrowLeft"
}), bN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, AN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M609.408 149.376L277.76 489.6a32 32 0 000 44.672l331.648 340.352a29.12 29.12 0 0041.728 0 30.592 30.592 0 000-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 000-42.688 29.12 29.12 0 00-41.728 0z"
}, null, -1), TN = [
  AN
];
function wN(e, t, n, r, i, a) {
  return P(), L("svg", bN, TN);
}
var Ih = /* @__PURE__ */ Yn(yN, [["render", wN]]);
const PN = Ee({
  name: "ArrowRight"
}), xN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, CN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M340.864 149.312a30.592 30.592 0 000 42.752L652.736 512 340.864 831.872a30.592 30.592 0 000 42.752 29.12 29.12 0 0041.728 0L714.24 534.336a32 32 0 000-44.672L382.592 149.376a29.12 29.12 0 00-41.728 0z"
}, null, -1), SN = [
  CN
];
function EN(e, t, n, r, i, a) {
  return P(), L("svg", xN, SN);
}
var es = /* @__PURE__ */ Yn(PN, [["render", EN]]);
const kN = Ee({
  name: "ArrowUp"
}), ON = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, zN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M488.832 344.32l-339.84 356.672a32 32 0 000 44.16l.384.384a29.44 29.44 0 0042.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0042.688 0l.384-.384a32 32 0 000-44.16L535.168 344.32a32 32 0 00-46.336 0z"
}, null, -1), DN = [
  zN
];
function MN(e, t, n, r, i, a) {
  return P(), L("svg", ON, DN);
}
var uf = /* @__PURE__ */ Yn(kN, [["render", MN]]);
const HN = Ee({
  name: "Calendar"
}), IN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, LN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M128 384v512h768V192H768v32a32 32 0 11-64 0v-32H320v32a32 32 0 01-64 0v-32H128v128h768v64H128zm192-256h384V96a32 32 0 1164 0v32h160a32 32 0 0132 32v768a32 32 0 01-32 32H96a32 32 0 01-32-32V160a32 32 0 0132-32h160V96a32 32 0 0164 0v32zm-32 384h64a32 32 0 010 64h-64a32 32 0 010-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64zm192-192h64a32 32 0 010 64h-64a32 32 0 010-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64zm192-192h64a32 32 0 110 64h-64a32 32 0 110-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64z"
}, null, -1), BN = [
  LN
];
function NN(e, t, n, r, i, a) {
  return P(), L("svg", IN, BN);
}
var jN = /* @__PURE__ */ Yn(HN, [["render", NN]]);
const FN = Ee({
  name: "CaretRight"
}), XN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, RN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M384 192v640l384-320.064z"
}, null, -1), VN = [
  RN
];
function UN(e, t, n, r, i, a) {
  return P(), L("svg", XN, VN);
}
var qN = /* @__PURE__ */ Yn(FN, [["render", UN]]);
const _N = Ee({
  name: "Check"
}), WN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, KN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z"
}, null, -1), GN = [
  KN
];
function YN(e, t, n, r, i, a) {
  return P(), L("svg", WN, GN);
}
var Xd = /* @__PURE__ */ Yn(_N, [["render", YN]]);
const QN = Ee({
  name: "CircleCheck"
}), ZN = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, JN = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"
}, null, -1), $N = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M745.344 361.344a32 32 0 0145.312 45.312l-288 288a32 32 0 01-45.312 0l-160-160a32 32 0 1145.312-45.312L480 626.752l265.344-265.408z"
}, null, -1), ej = [
  JN,
  $N
];
function tj(e, t, n, r, i, a) {
  return P(), L("svg", ZN, ej);
}
var L0 = /* @__PURE__ */ Yn(QN, [["render", tj]]);
const nj = Ee({
  name: "CircleCloseFilled"
}), ij = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, rj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 64a448 448 0 110 896 448 448 0 010-896zm0 393.664L407.936 353.6a38.4 38.4 0 10-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1054.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1054.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 10-54.336-54.336L512 457.664z"
}, null, -1), aj = [
  rj
];
function oj(e, t, n, r, i, a) {
  return P(), L("svg", ij, aj);
}
var sb = /* @__PURE__ */ Yn(nj, [["render", oj]]);
const sj = Ee({
  name: "CircleClose"
}), lj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, uj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M466.752 512l-90.496-90.496a32 32 0 0145.248-45.248L512 466.752l90.496-90.496a32 32 0 1145.248 45.248L557.248 512l90.496 90.496a32 32 0 11-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 01-45.248-45.248L466.752 512z"
}, null, -1), cj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"
}, null, -1), dj = [
  uj,
  cj
];
function fj(e, t, n, r, i, a) {
  return P(), L("svg", lj, dj);
}
var Hs = /* @__PURE__ */ Yn(sj, [["render", fj]]);
const hj = Ee({
  name: "Clock"
}), pj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, vj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 896a384 384 0 100-768 384 384 0 000 768zm0 64a448 448 0 110-896 448 448 0 010 896z"
}, null, -1), mj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M480 256a32 32 0 0132 32v256a32 32 0 01-64 0V288a32 32 0 0132-32z"
}, null, -1), gj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M480 512h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32z"
}, null, -1), yj = [
  vj,
  mj,
  gj
];
function bj(e, t, n, r, i, a) {
  return P(), L("svg", pj, yj);
}
var Aj = /* @__PURE__ */ Yn(hj, [["render", bj]]);
const Tj = Ee({
  name: "Close"
}), wj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Pj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M764.288 214.592L512 466.88 259.712 214.592a31.936 31.936 0 00-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1045.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0045.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 10-45.12-45.184z"
}, null, -1), xj = [
  Pj
];
function Cj(e, t, n, r, i, a) {
  return P(), L("svg", wj, xj);
}
var Is = /* @__PURE__ */ Yn(Tj, [["render", Cj]]);
const Sj = Ee({
  name: "DArrowLeft"
}), Ej = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, kj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M529.408 149.376a29.12 29.12 0 0141.728 0 30.592 30.592 0 010 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 01-.512 43.264 29.12 29.12 0 01-41.216-.512L197.76 534.272a32 32 0 010-44.672l331.648-340.224zm256 0a29.12 29.12 0 0141.728 0 30.592 30.592 0 010 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 01-.512 43.264 29.12 29.12 0 01-41.216-.512L453.76 534.272a32 32 0 010-44.672l331.648-340.224z"
}, null, -1), Oj = [
  kj
];
function zj(e, t, n, r, i, a) {
  return P(), L("svg", Ej, Oj);
}
var Lh = /* @__PURE__ */ Yn(Sj, [["render", zj]]);
const Dj = Ee({
  name: "DArrowRight"
}), Mj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Hj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M452.864 149.312a29.12 29.12 0 0141.728.064L826.24 489.664a32 32 0 010 44.672L494.592 874.624a29.12 29.12 0 01-41.728 0 30.592 30.592 0 010-42.752L764.736 512 452.864 192a30.592 30.592 0 010-42.688zm-256 0a29.12 29.12 0 0141.728.064L570.24 489.664a32 32 0 010 44.672L238.592 874.624a29.12 29.12 0 01-41.728 0 30.592 30.592 0 010-42.752L508.736 512 196.864 192a30.592 30.592 0 010-42.688z"
}, null, -1), Ij = [
  Hj
];
function Lj(e, t, n, r, i, a) {
  return P(), L("svg", Mj, Ij);
}
var Bh = /* @__PURE__ */ Yn(Dj, [["render", Lj]]);
const Bj = Ee({
  name: "Delete"
}), Nj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, jj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M160 256H96a32 32 0 010-64h256V95.936a32 32 0 0132-32h256a32 32 0 0132 32V192h256a32 32 0 110 64h-64v672a32 32 0 01-32 32H192a32 32 0 01-32-32V256zm448-64v-64H416v64h192zM224 896h576V256H224v640zm192-128a32 32 0 01-32-32V416a32 32 0 0164 0v320a32 32 0 01-32 32zm192 0a32 32 0 01-32-32V416a32 32 0 0164 0v320a32 32 0 01-32 32z"
}, null, -1), Fj = [
  jj
];
function Xj(e, t, n, r, i, a) {
  return P(), L("svg", Nj, Fj);
}
var Rj = /* @__PURE__ */ Yn(Bj, [["render", Xj]]);
const Vj = Ee({
  name: "Document"
}), Uj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, qj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M832 384H576V128H192v768h640V384zm-26.496-64L640 154.496V320h165.504zM160 64h480l256 256v608a32 32 0 01-32 32H160a32 32 0 01-32-32V96a32 32 0 0132-32zm160 448h384v64H320v-64zm0-192h160v64H320v-64zm0 384h384v64H320v-64z"
}, null, -1), _j = [
  qj
];
function Wj(e, t, n, r, i, a) {
  return P(), L("svg", Uj, _j);
}
var Kj = /* @__PURE__ */ Yn(Vj, [["render", Wj]]);
const Gj = Ee({
  name: "InfoFilled"
}), Yj = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Qj = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 64a448 448 0 110 896.064A448 448 0 01512 64zm67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344zM590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 01-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 017.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
}, null, -1), Zj = [
  Qj
];
function Jj(e, t, n, r, i, a) {
  return P(), L("svg", Yj, Zj);
}
var lb = /* @__PURE__ */ Yn(Gj, [["render", Jj]]);
const $j = Ee({
  name: "Loading"
}), eF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, tF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 64a32 32 0 0132 32v192a32 32 0 01-64 0V96a32 32 0 0132-32zm0 640a32 32 0 0132 32v192a32 32 0 11-64 0V736a32 32 0 0132-32zm448-192a32 32 0 01-32 32H736a32 32 0 110-64h192a32 32 0 0132 32zm-640 0a32 32 0 01-32 32H96a32 32 0 010-64h192a32 32 0 0132 32zM195.2 195.2a32 32 0 0145.248 0L376.32 331.008a32 32 0 01-45.248 45.248L195.2 240.448a32 32 0 010-45.248zm452.544 452.544a32 32 0 0145.248 0L828.8 783.552a32 32 0 01-45.248 45.248L647.744 692.992a32 32 0 010-45.248zM828.8 195.264a32 32 0 010 45.184L692.992 376.32a32 32 0 01-45.248-45.248l135.808-135.808a32 32 0 0145.248 0zm-452.544 452.48a32 32 0 010 45.248L240.448 828.8a32 32 0 01-45.248-45.248l135.808-135.808a32 32 0 0145.248 0z"
}, null, -1), nF = [
  tF
];
function iF(e, t, n, r, i, a) {
  return P(), L("svg", eF, nF);
}
var Vl = /* @__PURE__ */ Yn($j, [["render", iF]]);
const rF = Ee({
  name: "Minus"
}), aF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, oF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M128 544h768a32 32 0 100-64H128a32 32 0 000 64z"
}, null, -1), sF = [
  oF
];
function lF(e, t, n, r, i, a) {
  return P(), L("svg", aF, sF);
}
var uF = /* @__PURE__ */ Yn(rF, [["render", lF]]);
const cF = Ee({
  name: "MoreFilled"
}), dF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, fF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M176 416a112 112 0 110 224 112 112 0 010-224zm336 0a112 112 0 110 224 112 112 0 010-224zm336 0a112 112 0 110 224 112 112 0 010-224z"
}, null, -1), hF = [
  fF
];
function pF(e, t, n, r, i, a) {
  return P(), L("svg", dF, hF);
}
var vF = /* @__PURE__ */ Yn(cF, [["render", pF]]);
const mF = Ee({
  name: "More"
}), gF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, yF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M176 416a112 112 0 100 224 112 112 0 000-224m0 64a48 48 0 110 96 48 48 0 010-96zm336-64a112 112 0 110 224 112 112 0 010-224zm0 64a48 48 0 100 96 48 48 0 000-96zm336-64a112 112 0 110 224 112 112 0 010-224zm0 64a48 48 0 100 96 48 48 0 000-96z"
}, null, -1), bF = [
  yF
];
function AF(e, t, n, r, i, a) {
  return P(), L("svg", gF, bF);
}
var TF = /* @__PURE__ */ Yn(mF, [["render", AF]]);
const wF = Ee({
  name: "Plus"
}), PF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, xF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M480 480V128a32 32 0 0164 0v352h352a32 32 0 110 64H544v352a32 32 0 11-64 0V544H128a32 32 0 010-64h352z"
}, null, -1), CF = [
  xF
];
function SF(e, t, n, r, i, a) {
  return P(), L("svg", PF, CF);
}
var ub = /* @__PURE__ */ Yn(wF, [["render", SF]]);
const EF = Ee({
  name: "SuccessFilled"
}), kF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, OF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 64a448 448 0 110 896 448 448 0 010-896zm-55.808 536.384l-99.52-99.584a38.4 38.4 0 10-54.336 54.336l126.72 126.72a38.272 38.272 0 0054.336 0l262.4-262.464a38.4 38.4 0 10-54.272-54.336L456.192 600.384z"
}, null, -1), zF = [
  OF
];
function DF(e, t, n, r, i, a) {
  return P(), L("svg", kF, zF);
}
var cb = /* @__PURE__ */ Yn(EF, [["render", DF]]);
const MF = Ee({
  name: "View"
}), HF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, IF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 110 448 224 224 0 010-448zm0 64a160.192 160.192 0 00-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z"
}, null, -1), LF = [
  IF
];
function BF(e, t, n, r, i, a) {
  return P(), L("svg", HF, LF);
}
var NF = /* @__PURE__ */ Yn(MF, [["render", BF]]);
const jF = Ee({
  name: "WarningFilled"
}), FF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, XF = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 64a448 448 0 110 896 448 448 0 010-896zm0 192a58.432 58.432 0 00-58.24 63.744l23.36 256.384a35.072 35.072 0 0069.76 0l23.296-256.384A58.432 58.432 0 00512 256zm0 512a51.2 51.2 0 100-102.4 51.2 51.2 0 000 102.4z"
}, null, -1), RF = [
  XF
];
function VF(e, t, n, r, i, a) {
  return P(), L("svg", FF, RF);
}
var B0 = /* @__PURE__ */ Yn(jF, [["render", VF]]);
const UF = Ee({
  name: "ZoomIn"
}), qF = {
  class: "icon",
  width: "200",
  height: "200",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, _F = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M795.904 750.72l124.992 124.928a32 32 0 01-45.248 45.248L750.656 795.904a416 416 0 1145.248-45.248zM480 832a352 352 0 100-704 352 352 0 000 704zm-32-384v-96a32 32 0 0164 0v96h96a32 32 0 010 64h-96v96a32 32 0 01-64 0v-96h-96a32 32 0 010-64h96z"
}, null, -1), WF = [
  _F
];
function KF(e, t, n, r, i, a) {
  return P(), L("svg", qF, WF);
}
var GF = /* @__PURE__ */ Yn(UF, [["render", KF]]);
const x8 = Symbol(), b5 = "__elPropsReservedKey";
function _a(e, t) {
  if (!tr(e) || !!e[b5])
    return e;
  const { values: n, required: r, default: i, type: a, validator: o } = e, s = n || o ? (u) => {
    let c = !1, f = [];
    if (n && (f = Array.from(n), Lr(e, "default") && f.push(i), c || (c = f.includes(u))), o && (c || (c = o(u))), !c && f.length > 0) {
      const d = [...new Set(f)].map((h) => JSON.stringify(h)).join(", ");
      WC(`Invalid prop: validation failed${t ? ` for prop "${t}"` : ""}. Expected one of [${d}], got value ${JSON.stringify(u)}.`);
    }
    return c;
  } : void 0, l = {
    type: tr(a) && Object.getOwnPropertySymbols(a).includes(x8) ? a[x8] : a,
    required: !!r,
    validator: s,
    [b5]: !0
  };
  return Lr(e, "default") && (l.default = i), l;
}
const Gt = (e) => $y(Object.entries(e).map(([t, n]) => [
  t,
  _a(n, t)
])), jt = (e) => ({ [x8]: e }), ya = jt([
  String,
  Object,
  Function
]), YF = {
  Close: Is
}, QF = {
  Close: Is,
  SuccessFilled: cb,
  InfoFilled: lb,
  WarningFilled: B0,
  CircleCloseFilled: sb
}, A5 = {
  success: cb,
  warning: B0,
  error: sb,
  info: lb
}, db = {
  validating: Vl,
  success: L0,
  error: Hs
}, Un = (e, t) => {
  if (e.install = (n) => {
    for (const r of [e, ...Object.values(t != null ? t : {})])
      n.component(r.name, r);
  }, t)
    for (const [n, r] of Object.entries(t))
      e[n] = r;
  return e;
}, ZF = (e, t) => (e.install = (n) => {
  n.config.globalProperties[t] = e;
}, e), Wi = (e) => (e.install = Vn, e), fb = (...e) => (t) => {
  e.forEach((n) => {
    n.value = t;
  });
}, JF = "utils/vue/style";
function _o(e, t = "px") {
  if (!e)
    return "";
  if (Ai(e))
    return e;
  if (jn(e))
    return `${e}${t}`;
  fi(JF, "binding value must be a string or number");
}
const yt = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  esc: "Escape",
  delete: "Delete",
  backspace: "Backspace",
  numpadEnter: "NumpadEnter",
  pageUp: "PageUp",
  pageDown: "PageDown",
  home: "Home",
  end: "End"
}, $F = [
  "year",
  "month",
  "date",
  "dates",
  "week",
  "datetime",
  "datetimerange",
  "daterange",
  "monthrange"
], vn = "update:modelValue", Tr = "change", Ls = "input", c3 = ["default", "small", "large"], fo = (e) => ["", ...c3].includes(e), hb = (e) => [...$F].includes(e);
var K1 = /* @__PURE__ */ ((e) => (e[e.TEXT = 1] = "TEXT", e[e.CLASS = 2] = "CLASS", e[e.STYLE = 4] = "STYLE", e[e.PROPS = 8] = "PROPS", e[e.FULL_PROPS = 16] = "FULL_PROPS", e[e.HYDRATE_EVENTS = 32] = "HYDRATE_EVENTS", e[e.STABLE_FRAGMENT = 64] = "STABLE_FRAGMENT", e[e.KEYED_FRAGMENT = 128] = "KEYED_FRAGMENT", e[e.UNKEYED_FRAGMENT = 256] = "UNKEYED_FRAGMENT", e[e.NEED_PATCH = 512] = "NEED_PATCH", e[e.DYNAMIC_SLOTS = 1024] = "DYNAMIC_SLOTS", e[e.HOISTED = -1] = "HOISTED", e[e.BAIL = -2] = "BAIL", e))(K1 || {});
const T5 = (e) => [...new Set(e)], wl = (e) => !e && e !== 0 ? [] : Array.isArray(e) ? e : [e], eX = () => Sn && /firefox/i.test(window.navigator.userAgent), Nh = (e) => /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi.test(e), pb = (e) => Sn ? window.requestAnimationFrame(e) : setTimeout(e, 16), vb = (e) => Sn ? window.cancelAnimationFrame(e) : clearTimeout(e), N0 = () => Math.floor(Math.random() * 1e4), da = (e) => e, tX = ["class", "style"], nX = /^on[A-Z]/, iX = (e = {}) => {
  const { excludeListeners: t = !1, excludeKeys: n = [] } = e, r = n.concat(tX), i = sn();
  return i ? J(() => {
    var a;
    return $y(Object.entries((a = i.proxy) == null ? void 0 : a.$attrs).filter(([o]) => !r.includes(o) && !(t && nX.test(o))));
  }) : (fi("use-attrs", "getCurrentInstance() returned null. useAttrs() must be called at the top of a setup function"), J(() => ({})));
}, Pa = Symbol("elForm"), ts = Symbol("elFormItem"), mb = Symbol("buttonGroupContextKey"), gb = Symbol("elPaginationKey"), yb = Symbol(), bb = Symbol("radioGroupKey"), jh = Symbol("tabsRootContextKey"), Ab = Symbol("scrollbarContextKey"), Tb = (e) => {
  const t = sn();
  return J(() => {
    var n, r;
    return (r = (n = t.proxy) == null ? void 0 : n.$props[e]) != null ? r : void 0;
  });
}, j0 = j();
function mc(e, t = void 0) {
  const n = sn() ? ce(yb, j0) : j0;
  return e ? J(() => {
    var r, i;
    return (i = (r = n.value) == null ? void 0 : r[e]) != null ? i : t;
  }) : n;
}
const rX = (e, t, n = !1) => {
  var r;
  const i = !!sn(), a = i ? mc() : void 0, o = (r = t == null ? void 0 : t.provide) != null ? r : i ? _t : void 0;
  if (!o) {
    fi("provideGlobalConfig", "provideGlobalConfig() can only be used inside setup().");
    return;
  }
  const s = J(() => {
    const l = E(e);
    return a != null && a.value ? aX(a.value, l) : l;
  });
  return o(yb, s), (n || !j0.value) && (j0.value = s.value), s;
}, aX = (e, t) => {
  var n;
  const r = [.../* @__PURE__ */ new Set([...y5(e), ...y5(t)])], i = {};
  for (const a of r)
    i[a] = (n = t[a]) != null ? n : e[a];
  return i;
}, Fh = _a({
  type: String,
  values: c3,
  required: !1
}), Bi = (e, t = {}) => {
  const n = j(void 0), r = t.prop ? n : Tb("size"), i = t.global ? n : mc("size"), a = t.form ? { size: void 0 } : ce(Pa, void 0), o = t.formItem ? { size: void 0 } : ce(ts, void 0);
  return J(() => r.value || E(e) || (o == null ? void 0 : o.size) || (a == null ? void 0 : a.size) || i.value || "default");
}, cf = (e) => {
  const t = Tb("disabled"), n = ce(Pa, void 0);
  return J(() => t.value || E(e) || (n == null ? void 0 : n.disabled) || !1);
}, oX = ({ from: e, replacement: t, scope: n, version: r, ref: i }, a) => {
  Ne(() => E(a), (o) => {
    o && fi(n, `API ${e} is about to be deprecated in version ${r}, please use ${t} instead.
For more detail, please visit: ${i}
`);
  }, {
    immediate: !0
  });
}, sX = (e, t, n) => {
  let r = {
    offsetX: 0,
    offsetY: 0
  };
  const i = (s) => {
    const l = s.clientX, u = s.clientY, { offsetX: c, offsetY: f } = r, d = e.value.getBoundingClientRect(), h = d.left, p = d.top, y = d.width, m = d.height, b = document.documentElement.clientWidth, x = document.documentElement.clientHeight, D = -h + c, S = -p + f, C = b - h - y + c, v = x - p - m + f, H = (R) => {
      const F = Math.min(Math.max(c + R.clientX - l, D), C), K = Math.min(Math.max(f + R.clientY - u, S), v);
      r = {
        offsetX: F,
        offsetY: K
      }, e.value.style.transform = `translate(${_o(F)}, ${_o(K)})`;
    }, V = () => {
      document.removeEventListener("mousemove", H), document.removeEventListener("mouseup", V);
    };
    document.addEventListener("mousemove", H), document.addEventListener("mouseup", V);
  }, a = () => {
    t.value && e.value && t.value.addEventListener("mousedown", i);
  }, o = () => {
    t.value && e.value && t.value.removeEventListener("mousedown", i);
  };
  rn(() => {
    Bo(() => {
      n.value ? a() : o();
    });
  }), Ti(() => {
    o();
  });
}, lX = (e) => ({
  focus: () => {
    var t, n;
    (n = (t = e.value) == null ? void 0 : t.focus) == null || n.call(t);
  }
}), gc = () => {
  const e = ce(Pa, void 0), t = ce(ts, void 0);
  return {
    form: e,
    formItem: t
  };
};
var uX = {
  name: "en",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear"
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }
  }
};
const cX = (e) => (t, n) => dX(t, n, E(e)), dX = (e, t, n) => vi(n, e, e).replace(/\{(\w+)\}/g, (r, i) => {
  var a;
  return `${(a = t == null ? void 0 : t[i]) != null ? a : `{${i}}`}`;
}), fX = (e) => {
  const t = J(() => E(e).name), n = Bn(e) ? e : j(e);
  return {
    lang: t,
    locale: n,
    t: cX(e)
  };
}, hi = () => {
  const e = mc("locale");
  return fX(J(() => e.value || uX));
}, hX = (e) => {
  if (Bn(e) || ir("[useLockscreen]", "You need to pass a ref param to this function"), !Sn || jo(document.body, "el-popup-parent--hidden"))
    return;
  let t = 0, n = !1, r = "0", i = 0;
  const a = () => {
    oo(document.body, "el-popup-parent--hidden"), n && (document.body.style.paddingRight = r);
  };
  Ne(e, (o) => {
    if (!o) {
      a();
      return;
    }
    n = !jo(document.body, "el-popup-parent--hidden"), n && (r = document.body.style.paddingRight, i = parseInt(I0(document.body, "paddingRight"), 10)), t = fN();
    const s = document.documentElement.clientHeight < document.body.scrollHeight, l = I0(document.body, "overflowY");
    t > 0 && (s || l === "scroll") && n && (document.body.style.paddingRight = `${i + t}px`), Ss(document.body, "el-popup-parent--hidden");
  }), W4(() => a());
}, Du = [], pX = (e) => {
  Du.length !== 0 && e.code === yt.esc && (e.stopPropagation(), Du[Du.length - 1].handleClose());
}, vX = (e, t) => {
  Ne(t, (n) => {
    n ? Du.push(e) : Du.splice(Du.findIndex((r) => r === e), 1);
  });
};
Sn && co(document, "keydown", pX);
const wb = (e) => {
  const t = {
    [e]: _a({
      type: jt(Boolean),
      default: null
    }),
    [`onUpdate:${e}`]: _a({
      type: jt(Function)
    })
  }, n = [`update:${e}`];
  return {
    useModelToggle: ({
      indicator: i,
      shouldHideWhenRouteChanges: a,
      shouldProceed: o,
      onShow: s,
      onHide: l
    }) => {
      const u = sn(), c = u.props, { emit: f } = u, d = `update:${e}`, h = J(() => fa(c[`onUpdate:${e}`])), p = J(() => c[e] === null), y = () => {
        i.value !== !0 && (i.value = !0, fa(s) && s());
      }, m = () => {
        i.value !== !1 && (i.value = !1, fa(l) && l());
      }, b = () => {
        if (c.disabled === !0 || fa(o) && !o())
          return;
        const C = h.value && Sn;
        C && f(d, !0), (p.value || !C) && y();
      }, x = () => {
        if (c.disabled === !0 || !Sn)
          return;
        const C = h.value && Sn;
        C && f(d, !1), (p.value || !C) && m();
      }, D = (C) => {
        !Fa(C) || (c.disabled && C ? h.value && f(d, !1) : i.value !== C && (C ? y() : m()));
      }, S = () => {
        i.value ? x() : b();
      };
      return Ne(() => c[e], D), a && u.appContext.config.globalProperties.$route !== void 0 && Ne(() => ({
        ...u.proxy.$route
      }), () => {
        a.value && i.value && x();
      }), rn(() => {
        D(c[e]);
      }), {
        hide: x,
        show: b,
        toggle: S
      };
    },
    useModelToggleProps: t,
    useModelToggleEmits: n
  };
};
wb("modelValue");
const mX = (e, t) => {
  let n;
  Ne(() => e.value, (r) => {
    var i, a;
    r ? (n = document.activeElement, Bn(t) && ((a = (i = t.value).focus) == null || a.call(i))) : process.env.NODE_ENV === "test" ? n.focus.call(n) : n.focus();
  });
}, Pb = (e) => {
  if (!e)
    return { onClick: Vn, onMousedown: Vn, onMouseup: Vn };
  let t = !1, n = !1;
  return { onClick: (o) => {
    t && n && e(o), t = n = !1;
  }, onMousedown: (o) => {
    t = o.target === o.currentTarget;
  }, onMouseup: (o) => {
    n = o.target === o.currentTarget;
  } };
};
function gX() {
  let e;
  const t = (r, i) => {
    n(), e = window.setTimeout(r, i);
  }, n = () => window.clearTimeout(e);
  return Hh(() => n()), {
    registerTimeout: t,
    cancelTimeout: n
  };
}
const w5 = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, yX = Symbol("elIdInjection"), xb = (e) => {
  const t = ce(yX, w5);
  return !Sn && t === w5 && fi("IdInjection", `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`), J(() => E(e) || `el-id-${t.prefix}-${t.current++}`);
}, bX = (e) => {
  const t = (n) => {
    const r = n;
    r.key === yt.esc && (e == null || e(r));
  };
  rn(() => {
    _n(document, "keydown", t);
  }), Ti(() => {
    si(document, "keydown", t);
  });
};
let P5;
const Cb = `el-popper-container-${N0()}`, AX = `#${Cb}`, TX = () => {
  Ph(() => {
    if (!!Sn && (process.env.NODE_ENV === "test" || !P5)) {
      const e = document.createElement("div");
      e.id = Cb, document.body.appendChild(e), P5 = e;
    }
  });
}, wX = Gt({
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  }
}), PX = ({
  showAfter: e,
  hideAfter: t,
  open: n,
  close: r
}) => {
  const { registerTimeout: i } = gX();
  return {
    onOpen: () => {
      i(() => {
        n();
      }, E(e));
    },
    onClose: () => {
      i(() => {
        r();
      }, E(t));
    }
  };
}, Sb = Symbol("elForwardRef"), xX = (e) => {
  _t(Sb, {
    setForwardRef: (n) => {
      e.value = n;
    }
  });
}, CX = (e) => ({
  mounted(t) {
    e(t);
  },
  updated(t) {
    e(t);
  },
  unmounted() {
    e(null);
  }
}), SX = "el", EX = "is-", nl = (e, t, n, r, i) => {
  let a = `${e}-${t}`;
  return n && (a += `-${n}`), r && (a += `__${r}`), i && (a += `--${i}`), a;
}, Ct = (e) => {
  const t = mc("namespace"), n = J(() => t.value || SX);
  return {
    namespace: n,
    b: (f = "") => nl(E(n), e, f, "", ""),
    e: (f) => f ? nl(E(n), e, "", f, "") : "",
    m: (f) => f ? nl(E(n), e, "", "", f) : "",
    be: (f, d) => f && d ? nl(E(n), e, f, d, "") : "",
    em: (f, d) => f && d ? nl(E(n), e, "", f, d) : "",
    bm: (f, d) => f && d ? nl(E(n), e, f, "", d) : "",
    bem: (f, d, h) => f && d && h ? nl(E(n), e, f, d, h) : "",
    is: (f, ...d) => {
      const h = d.length >= 1 ? d[0] : !0;
      return f && h ? `${EX}${f}` : "";
    }
  };
}, x5 = j(0), Xh = () => {
  const e = mc("zIndex", 2e3), t = J(() => e.value + x5.value);
  return {
    initialZIndex: e,
    currentZIndex: t,
    nextZIndex: () => (x5.value++, t.value)
  };
};
var vt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
};
const kX = Gt({
  size: {
    type: jt([Number, String])
  },
  color: {
    type: String
  }
}), OX = {
  name: "ElIcon",
  inheritAttrs: !1
}, zX = /* @__PURE__ */ Ee({
  ...OX,
  props: kX,
  setup(e) {
    const t = e, n = Ct("icon"), r = J(() => !t.size && !t.color ? {} : {
      fontSize: jd(t.size) ? void 0 : _o(t.size),
      "--color": t.color
    });
    return (i, a) => (P(), L("i", $r({
      class: E(n).b(),
      style: E(r)
    }, i.$attrs), [
      tt(i.$slots, "default")
    ], 16));
  }
}), qt = Un(zX), Ps = /* @__PURE__ */ new Map();
let C5;
Sn && (_n(document, "mousedown", (e) => C5 = e), _n(document, "mouseup", (e) => {
  for (const t of Ps.values())
    for (const { documentHandler: n } of t)
      n(e, C5);
}));
function S5(e, t) {
  let n = [];
  return Array.isArray(t.arg) ? n = t.arg : t.arg instanceof HTMLElement && n.push(t.arg), function(r, i) {
    const a = t.instance.popperRef, o = r.target, s = i == null ? void 0 : i.target, l = !t || !t.instance, u = !o || !s, c = e.contains(o) || e.contains(s), f = e === o, d = n.length && n.some((p) => p == null ? void 0 : p.contains(o)) || n.length && n.includes(s), h = a && (a.contains(o) || a.contains(s));
    l || u || c || f || d || h || t.value(r, i);
  };
}
const yc = {
  beforeMount(e, t) {
    Ps.has(e) || Ps.set(e, []), Ps.get(e).push({
      documentHandler: S5(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    Ps.has(e) || Ps.set(e, []);
    const n = Ps.get(e), r = n.findIndex((a) => a.bindingFn === t.oldValue), i = {
      documentHandler: S5(e, t),
      bindingFn: t.value
    };
    r >= 0 ? n.splice(r, 1, i) : n.push(i);
  },
  unmounted(e) {
    Ps.delete(e);
  }
};
var Eb = {
  beforeMount(e, t) {
    let n = null, r;
    const i = () => t.value && t.value(), a = () => {
      Date.now() - r < 100 && i(), clearInterval(n), n = null;
    };
    _n(e, "mousedown", (o) => {
      o.button === 0 && (r = Date.now(), jB(document, "mouseup", a), clearInterval(n), n = setInterval(i, 100));
    });
  }
};
const C8 = "_trap-focus-children", vl = [], E5 = (e) => {
  var t;
  if (vl.length === 0)
    return;
  const n = vl[vl.length - 1][C8];
  if (n.length > 0 && e.code === yt.tab) {
    if (n.length === 1) {
      e.preventDefault(), document.activeElement !== n[0] && n[0].focus();
      return;
    }
    const r = e.shiftKey, i = e.target === n[0], a = e.target === n[n.length - 1];
    if (i && r && (e.preventDefault(), n[n.length - 1].focus()), a && !r && (e.preventDefault(), n[0].focus()), process.env.NODE_ENV === "test") {
      const o = n.findIndex((s) => s === e.target);
      o !== -1 && ((t = n[r ? o - 1 : o + 1]) == null || t.focus());
    }
  }
}, kb = {
  beforeMount(e) {
    e[C8] = l5(e), vl.push(e), vl.length <= 1 && _n(document, "keydown", E5);
  },
  updated(e) {
    bt(() => {
      e[C8] = l5(e);
    });
  },
  unmounted() {
    vl.shift(), vl.length === 0 && si(document, "keydown", E5);
  }
};
var k5 = !1, fl, S8, E8, G1, Y1, Ob, Q1, k8, O8, z8, zb, D8, M8, Db, Mb;
function Sr() {
  if (!k5) {
    k5 = !0;
    var e = navigator.userAgent, t = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(e), n = /(Mac OS X)|(Windows)|(Linux)/.exec(e);
    if (D8 = /\b(iPhone|iP[ao]d)/.exec(e), M8 = /\b(iP[ao]d)/.exec(e), z8 = /Android/i.exec(e), Db = /FBAN\/\w+;/i.exec(e), Mb = /Mobile/i.exec(e), zb = !!/Win64/.exec(e), t) {
      fl = t[1] ? parseFloat(t[1]) : t[5] ? parseFloat(t[5]) : NaN, fl && document && document.documentMode && (fl = document.documentMode);
      var r = /(?:Trident\/(\d+.\d+))/.exec(e);
      Ob = r ? parseFloat(r[1]) + 4 : fl, S8 = t[2] ? parseFloat(t[2]) : NaN, E8 = t[3] ? parseFloat(t[3]) : NaN, G1 = t[4] ? parseFloat(t[4]) : NaN, G1 ? (t = /(?:Chrome\/(\d+\.\d+))/.exec(e), Y1 = t && t[1] ? parseFloat(t[1]) : NaN) : Y1 = NaN;
    } else
      fl = S8 = E8 = Y1 = G1 = NaN;
    if (n) {
      if (n[1]) {
        var i = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(e);
        Q1 = i ? parseFloat(i[1].replace("_", ".")) : !0;
      } else
        Q1 = !1;
      k8 = !!n[2], O8 = !!n[3];
    } else
      Q1 = k8 = O8 = !1;
  }
}
var H8 = { ie: function() {
  return Sr() || fl;
}, ieCompatibilityMode: function() {
  return Sr() || Ob > fl;
}, ie64: function() {
  return H8.ie() && zb;
}, firefox: function() {
  return Sr() || S8;
}, opera: function() {
  return Sr() || E8;
}, webkit: function() {
  return Sr() || G1;
}, safari: function() {
  return H8.webkit();
}, chrome: function() {
  return Sr() || Y1;
}, windows: function() {
  return Sr() || k8;
}, osx: function() {
  return Sr() || Q1;
}, linux: function() {
  return Sr() || O8;
}, iphone: function() {
  return Sr() || D8;
}, mobile: function() {
  return Sr() || D8 || M8 || z8 || Mb;
}, nativeApp: function() {
  return Sr() || Db;
}, android: function() {
  return Sr() || z8;
}, ipad: function() {
  return Sr() || M8;
} }, DX = H8, f1 = !!(typeof window < "u" && window.document && window.document.createElement), MX = { canUseDOM: f1, canUseWorkers: typeof Worker < "u", canUseEventListeners: f1 && !!(window.addEventListener || window.attachEvent), canUseViewport: f1 && !!window.screen, isInWorker: !f1 }, Hb = MX, Ib;
Hb.canUseDOM && (Ib = document.implementation && document.implementation.hasFeature && document.implementation.hasFeature("", "") !== !0);
function HX(e, t) {
  if (!Hb.canUseDOM || t && !("addEventListener" in document))
    return !1;
  var n = "on" + e, r = n in document;
  if (!r) {
    var i = document.createElement("div");
    i.setAttribute(n, "return;"), r = typeof i[n] == "function";
  }
  return !r && Ib && e === "wheel" && (r = document.implementation.hasFeature("Events.wheel", "3.0")), r;
}
var IX = HX, O5 = 10, z5 = 40, D5 = 800;
function Lb(e) {
  var t = 0, n = 0, r = 0, i = 0;
  return "detail" in e && (n = e.detail), "wheelDelta" in e && (n = -e.wheelDelta / 120), "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = n, n = 0), r = t * O5, i = n * O5, "deltaY" in e && (i = e.deltaY), "deltaX" in e && (r = e.deltaX), (r || i) && e.deltaMode && (e.deltaMode == 1 ? (r *= z5, i *= z5) : (r *= D5, i *= D5)), r && !t && (t = r < 1 ? -1 : 1), i && !n && (n = i < 1 ? -1 : 1), { spinX: t, spinY: n, pixelX: r, pixelY: i };
}
Lb.getEventType = function() {
  return DX.firefox() ? "DOMMouseScroll" : IX("wheel") ? "wheel" : "mousewheel";
};
var LX = Lb;
/**
* Checks if an event is supported in the current execution environment.
*
* NOTE: This will not work correctly for non-generic events such as `change`,
* `reset`, `load`, `error`, and `select`.
*
* Borrows from Modernizr.
*
* @param {string} eventNameSuffix Event name, e.g. "click".
* @param {?boolean} capture Check if the capture phase is supported.
* @return {boolean} True if the event is supported.
* @internal
* @license Modernizr 3.0.0pre (Custom Build) | MIT
*/
const BX = function(e, t) {
  if (e && e.addEventListener) {
    const n = function(r) {
      const i = LX(r);
      t && t.apply(this, [r, i]);
    };
    eX() ? e.addEventListener("DOMMouseScroll", n) : e.onmousewheel = n;
  }
}, NX = {
  beforeMount(e, t) {
    BX(e, t.value);
  }
}, jX = {
  beforeMount(e, t) {
    e._handleResize = () => {
      var n;
      e && ((n = t.value) == null || n.call(t, e));
    }, Xl(e, e._handleResize);
  },
  beforeUnmount(e) {
    Rl(e, e._handleResize);
  }
};
let Ma;
const FX = `
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
`, XX = [
  "letter-spacing",
  "line-height",
  "padding-top",
  "padding-bottom",
  "font-family",
  "font-weight",
  "font-size",
  "text-rendering",
  "text-transform",
  "width",
  "text-indent",
  "padding-left",
  "padding-right",
  "border-width",
  "box-sizing"
];
function RX(e) {
  const t = window.getComputedStyle(e), n = t.getPropertyValue("box-sizing"), r = parseFloat(t.getPropertyValue("padding-bottom")) + parseFloat(t.getPropertyValue("padding-top")), i = parseFloat(t.getPropertyValue("border-bottom-width")) + parseFloat(t.getPropertyValue("border-top-width"));
  return { contextStyle: XX.map((o) => `${o}:${t.getPropertyValue(o)}`).join(";"), paddingSize: r, borderSize: i, boxSizing: n };
}
function M5(e, t = 1, n) {
  var r;
  Ma || (Ma = document.createElement("textarea"), document.body.appendChild(Ma));
  const { paddingSize: i, borderSize: a, boxSizing: o, contextStyle: s } = RX(e);
  Ma.setAttribute("style", `${s};${FX}`), Ma.value = e.value || e.placeholder || "";
  let l = Ma.scrollHeight;
  const u = {};
  o === "border-box" ? l = l + a : o === "content-box" && (l = l - i), Ma.value = "";
  const c = Ma.scrollHeight - i;
  if (jn(t)) {
    let f = c * t;
    o === "border-box" && (f = f + i + a), l = Math.max(f, l), u.minHeight = `${f}px`;
  }
  if (jn(n)) {
    let f = c * n;
    o === "border-box" && (f = f + i + a), l = Math.min(f, l);
  }
  return u.height = `${l}px`, (r = Ma.parentNode) == null || r.removeChild(Ma), Ma = void 0, u;
}
const VX = Gt({
  size: Fh,
  disabled: Boolean,
  modelValue: {
    type: jt(void 0),
    default: ""
  },
  type: {
    type: String,
    default: "text"
  },
  resize: {
    type: String,
    values: ["none", "both", "horizontal", "vertical"]
  },
  autosize: {
    type: jt([Boolean, Object]),
    default: !1
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  placeholder: {
    type: String
  },
  form: {
    type: String,
    default: ""
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !1
  },
  showPassword: {
    type: Boolean,
    default: !1
  },
  showWordLimit: {
    type: Boolean,
    default: !1
  },
  suffixIcon: {
    type: ya,
    default: ""
  },
  prefixIcon: {
    type: ya,
    default: ""
  },
  label: {
    type: String
  },
  tabindex: {
    type: [Number, String]
  },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  inputStyle: {
    type: jt([Object, Array, String]),
    default: () => da({})
  }
}), UX = {
  [vn]: (e) => Ai(e),
  input: (e) => Ai(e),
  change: (e) => Ai(e),
  focus: (e) => e instanceof FocusEvent,
  blur: (e) => e instanceof FocusEvent,
  clear: () => !0,
  mouseleave: (e) => e instanceof MouseEvent,
  mouseenter: (e) => e instanceof MouseEvent,
  keydown: (e) => e instanceof KeyboardEvent,
  compositionstart: (e) => e instanceof CompositionEvent,
  compositionupdate: (e) => e instanceof CompositionEvent,
  compositionend: (e) => e instanceof CompositionEvent
}, qX = {
  suffix: "append",
  prefix: "prepend"
}, _X = Ee({
  name: "ElInput",
  components: { ElIcon: qt, CircleClose: Hs, IconView: NF },
  inheritAttrs: !1,
  props: VX,
  emits: UX,
  setup(e, { slots: t, emit: n, attrs: r }) {
    const i = sn(), a = iX(), { form: o, formItem: s } = gc(), l = Bi(), u = cf(), c = Ct("input"), f = Ct("textarea"), d = j(), h = j(), p = j(!1), y = j(!1), m = j(!1), b = j(!1), x = Uo(e.inputStyle), D = J(() => d.value || h.value), S = J(() => {
      var gt;
      return (gt = o == null ? void 0 : o.statusIcon) != null ? gt : !1;
    }), C = J(() => (s == null ? void 0 : s.validateState) || ""), v = J(() => db[C.value]), H = J(() => r.style), V = J(() => [
      e.inputStyle,
      x.value,
      { resize: e.resize }
    ]), R = J(() => e.modelValue === null || e.modelValue === void 0 ? "" : String(e.modelValue)), F = J(() => e.clearable && !u.value && !e.readonly && !!R.value && (p.value || y.value)), K = J(() => e.showPassword && !u.value && !e.readonly && (!!R.value || p.value)), q = J(() => e.showWordLimit && !!a.value.maxlength && (e.type === "text" || e.type === "textarea") && !u.value && !e.readonly && !e.showPassword), G = J(() => Array.from(R.value).length), te = J(() => !!q.value && G.value > Number(a.value.maxlength)), Q = () => {
      const { type: gt, autosize: Pe } = e;
      if (!(!Sn || gt !== "textarea"))
        if (Pe) {
          const $e = tr(Pe) ? Pe.minRows : void 0, Ke = tr(Pe) ? Pe.maxRows : void 0;
          x.value = {
            ...M5(h.value, $e, Ke)
          };
        } else
          x.value = {
            minHeight: M5(h.value).minHeight
          };
    }, Y = () => {
      const gt = D.value;
      !gt || gt.value === R.value || (gt.value = R.value);
    }, Z = (gt) => {
      const { el: Pe } = i.vnode;
      if (!Pe)
        return;
      const Ke = Array.from(Pe.querySelectorAll(`.${c.e(gt)}`)).find((He) => He.parentNode === Pe);
      if (!Ke)
        return;
      const lt = qX[gt];
      t[lt] ? Ke.style.transform = `translateX(${gt === "suffix" ? "-" : ""}${Pe.querySelector(`.${c.be("group", lt)}`).offsetWidth}px)` : Ke.removeAttribute("style");
    }, oe = () => {
      Z("prefix"), Z("suffix");
    }, he = (gt) => {
      const { value: Pe } = gt.target;
      m.value || Pe !== R.value && (n(vn, Pe), n("input", Pe), bt(Y));
    }, Ae = (gt) => {
      n("change", gt.target.value);
    }, We = () => {
      bt(() => {
        var gt;
        (gt = D.value) == null || gt.focus();
      });
    }, ke = () => {
      var gt;
      (gt = D.value) == null || gt.blur();
    }, Re = (gt) => {
      p.value = !0, n("focus", gt);
    }, ve = (gt) => {
      var Pe;
      p.value = !1, n("blur", gt), e.validateEvent && ((Pe = s == null ? void 0 : s.validate) == null || Pe.call(s, "blur"));
    }, Ye = () => {
      var gt;
      (gt = D.value) == null || gt.select();
    }, Qe = (gt) => {
      n("compositionstart", gt), m.value = !0;
    }, ot = (gt) => {
      var Pe;
      n("compositionupdate", gt);
      const $e = (Pe = gt.target) == null ? void 0 : Pe.value, Ke = $e[$e.length - 1] || "";
      m.value = !Nh(Ke);
    }, Ve = (gt) => {
      n("compositionend", gt), m.value && (m.value = !1, he(gt));
    }, Te = () => {
      n(vn, ""), n("change", ""), n("clear"), n("input", "");
    }, Me = () => {
      b.value = !b.value, We();
    }, Je = J(() => !!t.suffix || !!e.suffixIcon || F.value || e.showPassword || q.value || !!C.value && S.value);
    return Ne(() => e.modelValue, () => {
      var gt;
      bt(Q), e.validateEvent && ((gt = s == null ? void 0 : s.validate) == null || gt.call(s, "change"));
    }), Ne(R, () => Y()), Ne(() => e.type, () => {
      bt(() => {
        Y(), Q(), oe();
      });
    }), rn(() => {
      Y(), oe(), bt(Q);
    }), Zo(() => {
      bt(oe);
    }), {
      input: d,
      textarea: h,
      attrs: a,
      inputSize: l,
      validateState: C,
      validateIcon: v,
      containerStyle: H,
      computedTextareaStyle: V,
      inputDisabled: u,
      showClear: F,
      showPwdVisible: K,
      isWordLimitVisible: q,
      textLength: G,
      hovering: y,
      inputExceed: te,
      passwordVisible: b,
      inputOrTextarea: D,
      suffixVisible: Je,
      needStatusIcon: S,
      resizeTextarea: Q,
      handleInput: he,
      handleChange: Ae,
      handleFocus: Re,
      handleBlur: ve,
      handleCompositionStart: Qe,
      handleCompositionUpdate: ot,
      handleCompositionEnd: Ve,
      handlePasswordVisible: Me,
      clear: Te,
      select: Ye,
      focus: We,
      blur: ke,
      onMouseLeave: (gt) => {
        y.value = !1, n("mouseleave", gt);
      },
      onMouseEnter: (gt) => {
        y.value = !0, n("mouseenter", gt);
      },
      handleKeydown: (gt) => {
        n("keydown", gt);
      },
      nsInput: c,
      nsTextarea: f
    };
  }
}), WX = ["type", "disabled", "readonly", "autocomplete", "tabindex", "aria-label", "placeholder"], KX = ["tabindex", "disabled", "readonly", "autocomplete", "aria-label", "placeholder"];
function GX(e, t, n, r, i, a) {
  const o = Ie("el-icon"), s = Ie("circle-close"), l = Ie("icon-view");
  return Bt((P(), L("div", {
    class: se([
      e.type === "textarea" ? e.nsTextarea.b() : e.nsInput.b(),
      e.nsInput.m(e.inputSize),
      e.nsInput.is("disabled", e.inputDisabled),
      e.nsInput.is("exceed", e.inputExceed),
      {
        [e.nsInput.b("group")]: e.$slots.prepend || e.$slots.append,
        [e.nsInput.bm("group", "append")]: e.$slots.append,
        [e.nsInput.bm("group", "prepend")]: e.$slots.prepend,
        [e.nsInput.m("prefix")]: e.$slots.prefix || e.prefixIcon,
        [e.nsInput.m("suffix")]: e.$slots.suffix || e.suffixIcon || e.clearable || e.showPassword,
        [e.nsInput.m("suffix--password-clear")]: e.clearable && e.showPassword
      },
      e.$attrs.class
    ]),
    style: Pt(e.containerStyle),
    onMouseenter: t[17] || (t[17] = (...u) => e.onMouseEnter && e.onMouseEnter(...u)),
    onMouseleave: t[18] || (t[18] = (...u) => e.onMouseLeave && e.onMouseLeave(...u))
  }, [
    re(" input "),
    e.type !== "textarea" ? (P(), L(nt, { key: 0 }, [
      re(" prepend slot "),
      e.$slots.prepend ? (P(), L("div", {
        key: 0,
        class: se(e.nsInput.be("group", "prepend"))
      }, [
        tt(e.$slots, "prepend")
      ], 2)) : re("v-if", !0),
      T("input", $r({
        ref: "input",
        class: e.nsInput.e("inner")
      }, e.attrs, {
        type: e.showPassword ? e.passwordVisible ? "text" : "password" : e.type,
        disabled: e.inputDisabled,
        readonly: e.readonly,
        autocomplete: e.autocomplete,
        tabindex: e.tabindex,
        "aria-label": e.label,
        placeholder: e.placeholder,
        style: e.inputStyle,
        onCompositionstart: t[0] || (t[0] = (...u) => e.handleCompositionStart && e.handleCompositionStart(...u)),
        onCompositionupdate: t[1] || (t[1] = (...u) => e.handleCompositionUpdate && e.handleCompositionUpdate(...u)),
        onCompositionend: t[2] || (t[2] = (...u) => e.handleCompositionEnd && e.handleCompositionEnd(...u)),
        onInput: t[3] || (t[3] = (...u) => e.handleInput && e.handleInput(...u)),
        onFocus: t[4] || (t[4] = (...u) => e.handleFocus && e.handleFocus(...u)),
        onBlur: t[5] || (t[5] = (...u) => e.handleBlur && e.handleBlur(...u)),
        onChange: t[6] || (t[6] = (...u) => e.handleChange && e.handleChange(...u)),
        onKeydown: t[7] || (t[7] = (...u) => e.handleKeydown && e.handleKeydown(...u))
      }), null, 16, WX),
      re(" prefix slot "),
      e.$slots.prefix || e.prefixIcon ? (P(), L("span", {
        key: 1,
        class: se(e.nsInput.e("prefix"))
      }, [
        T("span", {
          class: se(e.nsInput.e("prefix-inner"))
        }, [
          tt(e.$slots, "prefix"),
          e.prefixIcon ? (P(), ue(o, {
            key: 0,
            class: se(e.nsInput.e("icon"))
          }, {
            default: N(() => [
              (P(), ue(Ln(e.prefixIcon)))
            ]),
            _: 1
          }, 8, ["class"])) : re("v-if", !0)
        ], 2)
      ], 2)) : re("v-if", !0),
      re(" suffix slot "),
      e.suffixVisible ? (P(), L("span", {
        key: 2,
        class: se(e.nsInput.e("suffix"))
      }, [
        T("span", {
          class: se(e.nsInput.e("suffix-inner"))
        }, [
          !e.showClear || !e.showPwdVisible || !e.isWordLimitVisible ? (P(), L(nt, { key: 0 }, [
            tt(e.$slots, "suffix"),
            e.suffixIcon ? (P(), ue(o, {
              key: 0,
              class: se(e.nsInput.e("icon"))
            }, {
              default: N(() => [
                (P(), ue(Ln(e.suffixIcon)))
              ]),
              _: 1
            }, 8, ["class"])) : re("v-if", !0)
          ], 64)) : re("v-if", !0),
          e.showClear ? (P(), ue(o, {
            key: 1,
            class: se([e.nsInput.e("icon"), e.nsInput.e("clear")]),
            onMousedown: t[8] || (t[8] = wt(() => {
            }, ["prevent"])),
            onClick: e.clear
          }, {
            default: N(() => [
              B(s)
            ]),
            _: 1
          }, 8, ["class", "onClick"])) : re("v-if", !0),
          e.showPwdVisible ? (P(), ue(o, {
            key: 2,
            class: se([e.nsInput.e("icon"), e.nsInput.e("clear")]),
            onClick: e.handlePasswordVisible
          }, {
            default: N(() => [
              B(l)
            ]),
            _: 1
          }, 8, ["class", "onClick"])) : re("v-if", !0),
          e.isWordLimitVisible ? (P(), L("span", {
            key: 3,
            class: se(e.nsInput.e("count"))
          }, [
            T("span", {
              class: se(e.nsInput.e("count-inner"))
            }, de(e.textLength) + " / " + de(e.attrs.maxlength), 3)
          ], 2)) : re("v-if", !0)
        ], 2),
        e.validateState && e.validateIcon && e.needStatusIcon ? (P(), ue(o, {
          key: 0,
          class: se([e.nsInput.e("icon"), e.nsInput.e("validateIcon")])
        }, {
          default: N(() => [
            (P(), ue(Ln(e.validateIcon)))
          ]),
          _: 1
        }, 8, ["class"])) : re("v-if", !0)
      ], 2)) : re("v-if", !0),
      re(" append slot "),
      e.$slots.append ? (P(), L("div", {
        key: 3,
        class: se(e.nsInput.be("group", "append"))
      }, [
        tt(e.$slots, "append")
      ], 2)) : re("v-if", !0)
    ], 64)) : (P(), L(nt, { key: 1 }, [
      re(" textarea "),
      T("textarea", $r({
        ref: "textarea",
        class: e.nsTextarea.e("inner")
      }, e.attrs, {
        tabindex: e.tabindex,
        disabled: e.inputDisabled,
        readonly: e.readonly,
        autocomplete: e.autocomplete,
        style: e.computedTextareaStyle,
        "aria-label": e.label,
        placeholder: e.placeholder,
        onCompositionstart: t[9] || (t[9] = (...u) => e.handleCompositionStart && e.handleCompositionStart(...u)),
        onCompositionupdate: t[10] || (t[10] = (...u) => e.handleCompositionUpdate && e.handleCompositionUpdate(...u)),
        onCompositionend: t[11] || (t[11] = (...u) => e.handleCompositionEnd && e.handleCompositionEnd(...u)),
        onInput: t[12] || (t[12] = (...u) => e.handleInput && e.handleInput(...u)),
        onFocus: t[13] || (t[13] = (...u) => e.handleFocus && e.handleFocus(...u)),
        onBlur: t[14] || (t[14] = (...u) => e.handleBlur && e.handleBlur(...u)),
        onChange: t[15] || (t[15] = (...u) => e.handleChange && e.handleChange(...u)),
        onKeydown: t[16] || (t[16] = (...u) => e.handleKeydown && e.handleKeydown(...u))
      }), null, 16, KX),
      e.isWordLimitVisible ? (P(), L("span", {
        key: 0,
        class: se(e.nsInput.e("count"))
      }, de(e.textLength) + " / " + de(e.attrs.maxlength), 3)) : re("v-if", !0)
    ], 64))
  ], 38)), [
    [Cn, e.type !== "hidden"]
  ]);
}
var YX = /* @__PURE__ */ vt(_X, [["render", GX]]);
const ti = Un(YX), Bb = {
  vertical: {
    offset: "offsetHeight",
    scroll: "scrollTop",
    scrollSize: "scrollHeight",
    size: "height",
    key: "vertical",
    axis: "Y",
    client: "clientY",
    direction: "top"
  },
  horizontal: {
    offset: "offsetWidth",
    scroll: "scrollLeft",
    scrollSize: "scrollWidth",
    size: "width",
    key: "horizontal",
    axis: "X",
    client: "clientX",
    direction: "left"
  }
}, QX = ({ move: e, size: t, bar: n }) => ({
  [n.size]: t,
  transform: `translate${n.axis}(${e}%)`
}), ZX = Gt({
  vertical: Boolean,
  size: String,
  move: Number,
  ratio: {
    type: Number,
    required: !0
  },
  always: Boolean
}), H5 = "Thumb", JX = Ee({
  name: H5,
  props: ZX,
  setup(e) {
    const t = ce(Ab), n = Ct("scrollbar");
    t || ir(H5, "can not inject scrollbar context");
    const r = j(), i = j(), a = j({}), o = j(!1);
    let s = !1, l = !1, u = Sn ? document.onselectstart : null;
    const c = J(() => Bb[e.vertical ? "vertical" : "horizontal"]), f = J(() => QX({
      size: e.size,
      move: e.move,
      bar: c.value
    })), d = J(() => r.value[c.value.offset] ** 2 / t.wrapElement[c.value.scrollSize] / e.ratio / i.value[c.value.offset]), h = (C) => {
      var v;
      if (C.stopPropagation(), C.ctrlKey || [1, 2].includes(C.button))
        return;
      (v = window.getSelection()) == null || v.removeAllRanges(), y(C);
      const H = C.currentTarget;
      !H || (a.value[c.value.axis] = H[c.value.offset] - (C[c.value.client] - H.getBoundingClientRect()[c.value.direction]));
    }, p = (C) => {
      if (!i.value || !r.value || !t.wrapElement)
        return;
      const v = Math.abs(C.target.getBoundingClientRect()[c.value.direction] - C[c.value.client]), H = i.value[c.value.offset] / 2, V = (v - H) * 100 * d.value / r.value[c.value.offset];
      t.wrapElement[c.value.scroll] = V * t.wrapElement[c.value.scrollSize] / 100;
    }, y = (C) => {
      C.stopImmediatePropagation(), s = !0, document.addEventListener("mousemove", m), document.addEventListener("mouseup", b), u = document.onselectstart, document.onselectstart = () => !1;
    }, m = (C) => {
      if (!r.value || !i.value || s === !1)
        return;
      const v = a.value[c.value.axis];
      if (!v)
        return;
      const H = (r.value.getBoundingClientRect()[c.value.direction] - C[c.value.client]) * -1, V = i.value[c.value.offset] - v, R = (H - V) * 100 * d.value / r.value[c.value.offset];
      t.wrapElement[c.value.scroll] = R * t.wrapElement[c.value.scrollSize] / 100;
    }, b = () => {
      s = !1, a.value[c.value.axis] = 0, document.removeEventListener("mousemove", m), document.removeEventListener("mouseup", b), S(), l && (o.value = !1);
    }, x = () => {
      l = !1, o.value = !!e.size;
    }, D = () => {
      l = !0, o.value = s;
    };
    Ti(() => {
      S(), document.removeEventListener("mouseup", b);
    });
    const S = () => {
      document.onselectstart !== u && (document.onselectstart = u);
    };
    return co(er(t, "scrollbarElement"), "mousemove", x), co(er(t, "scrollbarElement"), "mouseleave", D), {
      ns: n,
      instance: r,
      thumb: i,
      bar: c,
      thumbStyle: f,
      visible: o,
      clickTrackHandler: p,
      clickThumbHandler: h
    };
  }
});
function $X(e, t, n, r, i, a) {
  return P(), ue(wa, {
    name: e.ns.b("fade")
  }, {
    default: N(() => [
      Bt(T("div", {
        ref: "instance",
        class: se([e.ns.e("bar"), e.ns.is(e.bar.key)]),
        onMousedown: t[1] || (t[1] = (...o) => e.clickTrackHandler && e.clickTrackHandler(...o))
      }, [
        T("div", {
          ref: "thumb",
          class: se(e.ns.e("thumb")),
          style: Pt(e.thumbStyle),
          onMousedown: t[0] || (t[0] = (...o) => e.clickThumbHandler && e.clickThumbHandler(...o))
        }, null, 38)
      ], 34), [
        [Cn, e.always || e.visible]
      ])
    ]),
    _: 1
  }, 8, ["name"]);
}
var eR = /* @__PURE__ */ vt(JX, [["render", $X]]);
const tR = Gt({
  always: {
    type: Boolean,
    default: !0
  },
  width: {
    type: String,
    default: ""
  },
  height: {
    type: String,
    default: ""
  },
  ratioX: {
    type: Number,
    default: 1
  },
  ratioY: {
    type: Number,
    default: 1
  }
}), nR = Ee({
  components: {
    Thumb: eR
  },
  props: tR,
  setup(e) {
    const t = j(0), n = j(0), r = 4;
    return {
      handleScroll: (a) => {
        if (a) {
          const o = a.offsetHeight - r, s = a.offsetWidth - r;
          n.value = a.scrollTop * 100 / o * e.ratioY, t.value = a.scrollLeft * 100 / s * e.ratioX;
        }
      },
      moveX: t,
      moveY: n
    };
  }
});
function iR(e, t, n, r, i, a) {
  const o = Ie("thumb");
  return P(), L(nt, null, [
    B(o, {
      move: e.moveX,
      ratio: e.ratioX,
      size: e.width,
      always: e.always
    }, null, 8, ["move", "ratio", "size", "always"]),
    B(o, {
      move: e.moveY,
      ratio: e.ratioY,
      size: e.height,
      vertical: "",
      always: e.always
    }, null, 8, ["move", "ratio", "size", "always"])
  ], 64);
}
var rR = /* @__PURE__ */ vt(nR, [["render", iR]]);
const aR = Gt({
  height: {
    type: [String, Number],
    default: ""
  },
  maxHeight: {
    type: [String, Number],
    default: ""
  },
  native: {
    type: Boolean,
    default: !1
  },
  wrapStyle: {
    type: jt([String, Object, Array]),
    default: ""
  },
  wrapClass: {
    type: [String, Array],
    default: ""
  },
  viewClass: {
    type: [String, Array],
    default: ""
  },
  viewStyle: {
    type: [String, Array],
    default: ""
  },
  noresize: Boolean,
  tag: {
    type: String,
    default: "div"
  },
  always: {
    type: Boolean,
    default: !1
  },
  minSize: {
    type: Number,
    default: 20
  }
}), oR = {
  scroll: ({
    scrollTop: e,
    scrollLeft: t
  }) => jn(e) && jn(t)
}, sR = Ee({
  name: "ElScrollbar",
  components: {
    Bar: rR
  },
  props: aR,
  emits: oR,
  setup(e, { emit: t }) {
    const n = Ct("scrollbar");
    let r, i;
    const a = j(), o = j(), s = j(), l = j("0"), u = j("0"), c = j(), f = j(0), d = j(0), h = j(1), p = j(1), y = "ElScrollbar", m = 4, b = J(() => {
      const v = {};
      return e.height && (v.height = _o(e.height)), e.maxHeight && (v.maxHeight = _o(e.maxHeight)), [e.wrapStyle, v];
    }), x = () => {
      var v;
      o.value && ((v = c.value) == null || v.handleScroll(o.value), t("scroll", {
        scrollTop: o.value.scrollTop,
        scrollLeft: o.value.scrollLeft
      }));
    }, D = (v) => {
      if (!jn(v)) {
        fi(y, "value must be a number");
        return;
      }
      o.value.scrollTop = v;
    }, S = (v) => {
      if (!jn(v)) {
        fi(y, "value must be a number");
        return;
      }
      o.value.scrollLeft = v;
    }, C = () => {
      if (!o.value)
        return;
      const v = o.value.offsetHeight - m, H = o.value.offsetWidth - m, V = v ** 2 / o.value.scrollHeight, R = H ** 2 / o.value.scrollWidth, F = Math.max(V, e.minSize), K = Math.max(R, e.minSize);
      h.value = V / (v - V) / (F / (v - F)), p.value = R / (H - R) / (K / (H - K)), u.value = F + m < v ? `${F}px` : "", l.value = K + m < H ? `${K}px` : "";
    };
    return Ne(() => e.noresize, (v) => {
      v ? (r == null || r(), i == null || i()) : ({ stop: r } = u3(s, C), i = co("resize", C));
    }, { immediate: !0 }), Ne(() => [e.maxHeight, e.height], () => {
      e.native || bt(() => {
        var v;
        C(), o.value && ((v = c.value) == null || v.handleScroll(o.value));
      });
    }), _t(Ab, zt({
      scrollbarElement: a,
      wrapElement: o
    })), rn(() => {
      e.native || bt(() => C());
    }), {
      ns: n,
      scrollbar$: a,
      wrap$: o,
      resize$: s,
      barRef: c,
      moveX: f,
      moveY: d,
      ratioX: p,
      ratioY: h,
      sizeWidth: l,
      sizeHeight: u,
      style: b,
      update: C,
      handleScroll: x,
      setScrollTop: D,
      setScrollLeft: S
    };
  }
});
function lR(e, t, n, r, i, a) {
  const o = Ie("bar");
  return P(), L("div", {
    ref: "scrollbar$",
    class: se(e.ns.b())
  }, [
    T("div", {
      ref: "wrap$",
      class: se([
        e.wrapClass,
        e.ns.e("wrap"),
        { [e.ns.em("wrap", "hidden-default")]: !e.native }
      ]),
      style: Pt(e.style),
      onScroll: t[0] || (t[0] = (...s) => e.handleScroll && e.handleScroll(...s))
    }, [
      (P(), ue(Ln(e.tag), {
        ref: "resize$",
        class: se([e.ns.e("view"), e.viewClass]),
        style: Pt(e.viewStyle)
      }, {
        default: N(() => [
          tt(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "style"]))
    ], 38),
    e.native ? re("v-if", !0) : (P(), ue(o, {
      key: 0,
      ref: "barRef",
      height: e.sizeHeight,
      width: e.sizeWidth,
      always: e.always,
      "ratio-x": e.ratioX,
      "ratio-y": e.ratioY
    }, null, 8, ["height", "width", "always", "ratio-x", "ratio-y"]))
  ], 2);
}
var uR = /* @__PURE__ */ vt(sR, [["render", lR]]);
const ns = Un(uR), d3 = Symbol("elPopper"), Nb = Symbol("elPopperContent"), cR = Ee({
  name: "ElPopperProvider",
  inheritAttrs: !1,
  setup() {
    const e = {
      triggerRef: j(null),
      popperInstanceRef: j(null),
      contentRef: j(null)
    };
    return _t(d3, e), e;
  }
});
function dR(e, t, n, r, i, a) {
  return tt(e.$slots, "default");
}
var fR = /* @__PURE__ */ vt(cR, [["render", dR]]), Mr = "top", ba = "bottom", Aa = "right", Hr = "left", Rh = "auto", df = [Mr, ba, Aa, Hr], Uu = "start", Rd = "end", hR = "clippingParents", jb = "viewport", Yc = "popper", pR = "reference", I5 = /* @__PURE__ */ df.reduce(function(e, t) {
  return e.concat([t + "-" + Uu, t + "-" + Rd]);
}, []), f3 = /* @__PURE__ */ [].concat(df, [Rh]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Uu, t + "-" + Rd]);
}, []), vR = "beforeRead", mR = "read", gR = "afterRead", yR = "beforeMain", bR = "main", AR = "afterMain", TR = "beforeWrite", wR = "write", PR = "afterWrite", I8 = [vR, mR, gR, yR, bR, AR, TR, wR, PR];
function ho(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function xa(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Hl(e) {
  var t = xa(e).Element;
  return e instanceof t || e instanceof Element;
}
function Jr(e) {
  var t = xa(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function h3(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = xa(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function xR(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !Jr(a) || !ho(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(o) {
      var s = i[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function CR(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], a = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Jr(i) || !ho(i) || (Object.assign(i.style, s), Object.keys(a).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const SR = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: xR,
  effect: CR,
  requires: ["computeStyles"]
};
function Xa(e) {
  return e.split("-")[0];
}
var Pl = Math.max, F0 = Math.min, qu = Math.round;
function L8() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Fb() {
  return !/^((?!chrome|android).)*safari/i.test(L8());
}
function _u(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, a = 1;
  t && Jr(e) && (i = e.offsetWidth > 0 && qu(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && qu(r.height) / e.offsetHeight || 1);
  var o = Hl(e) ? xa(e) : window, s = o.visualViewport, l = !Fb() && n, u = (r.left + (l && s ? s.offsetLeft : 0)) / i, c = (r.top + (l && s ? s.offsetTop : 0)) / a, f = r.width / i, d = r.height / a;
  return {
    width: f,
    height: d,
    top: c,
    right: u + f,
    bottom: c + d,
    left: u,
    x: u,
    y: c
  };
}
function p3(e) {
  var t = _u(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Xb(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && h3(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Wa(e) {
  return xa(e).getComputedStyle(e);
}
function ER(e) {
  return ["table", "td", "th"].indexOf(ho(e)) >= 0;
}
function Rs(e) {
  return ((Hl(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Vh(e) {
  return ho(e) === "html" ? e : e.assignedSlot || e.parentNode || (h3(e) ? e.host : null) || Rs(e);
}
function L5(e) {
  return !Jr(e) || Wa(e).position === "fixed" ? null : e.offsetParent;
}
function kR(e) {
  var t = /firefox/i.test(L8()), n = /Trident/i.test(L8());
  if (n && Jr(e)) {
    var r = Wa(e);
    if (r.position === "fixed")
      return null;
  }
  var i = Vh(e);
  for (h3(i) && (i = i.host); Jr(i) && ["html", "body"].indexOf(ho(i)) < 0; ) {
    var a = Wa(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function ff(e) {
  for (var t = xa(e), n = L5(e); n && ER(n) && Wa(n).position === "static"; )
    n = L5(n);
  return n && (ho(n) === "html" || ho(n) === "body" && Wa(n).position === "static") ? t : n || kR(e) || t;
}
function v3(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function yd(e, t, n) {
  return Pl(e, F0(t, n));
}
function OR(e, t, n) {
  var r = yd(e, t, n);
  return r > n ? n : r;
}
function Rb() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Vb(e) {
  return Object.assign({}, Rb(), e);
}
function Ub(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var zR = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Vb(typeof t != "number" ? t : Ub(t, df));
};
function DR(e) {
  var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = Xa(n.placement), l = v3(s), u = [Hr, Aa].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!a || !o)) {
    var f = zR(i.padding, n), d = p3(a), h = l === "y" ? Mr : Hr, p = l === "y" ? ba : Aa, y = n.rects.reference[c] + n.rects.reference[l] - o[l] - n.rects.popper[c], m = o[l] - n.rects.reference[l], b = ff(a), x = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, D = y / 2 - m / 2, S = f[h], C = x - d[c] - f[p], v = x / 2 - d[c] / 2 + D, H = yd(S, v, C), V = l;
    n.modifiersData[r] = (t = {}, t[V] = H, t.centerOffset = H - v, t);
  }
}
function MR(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  if (i != null && !(typeof i == "string" && (i = t.elements.popper.querySelector(i), !i))) {
    if (process.env.NODE_ENV !== "production" && (Jr(i) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !Xb(t.elements.popper, i)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = i;
  }
}
const HR = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: DR,
  effect: MR,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Wu(e) {
  return e.split("-")[1];
}
var IR = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function LR(e) {
  var t = e.x, n = e.y, r = window, i = r.devicePixelRatio || 1;
  return {
    x: qu(t * i) / i || 0,
    y: qu(n * i) / i || 0
  };
}
function B5(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, f = e.isFixed, d = o.x, h = d === void 0 ? 0 : d, p = o.y, y = p === void 0 ? 0 : p, m = typeof c == "function" ? c({
    x: h,
    y
  }) : {
    x: h,
    y
  };
  h = m.x, y = m.y;
  var b = o.hasOwnProperty("x"), x = o.hasOwnProperty("y"), D = Hr, S = Mr, C = window;
  if (u) {
    var v = ff(n), H = "clientHeight", V = "clientWidth";
    if (v === xa(n) && (v = Rs(n), Wa(v).position !== "static" && s === "absolute" && (H = "scrollHeight", V = "scrollWidth")), v = v, i === Mr || (i === Hr || i === Aa) && a === Rd) {
      S = ba;
      var R = f && v === C && C.visualViewport ? C.visualViewport.height : v[H];
      y -= R - r.height, y *= l ? 1 : -1;
    }
    if (i === Hr || (i === Mr || i === ba) && a === Rd) {
      D = Aa;
      var F = f && v === C && C.visualViewport ? C.visualViewport.width : v[V];
      h -= F - r.width, h *= l ? 1 : -1;
    }
  }
  var K = Object.assign({
    position: s
  }, u && IR), q = c === !0 ? LR({
    x: h,
    y
  }) : {
    x: h,
    y
  };
  if (h = q.x, y = q.y, l) {
    var G;
    return Object.assign({}, K, (G = {}, G[S] = x ? "0" : "", G[D] = b ? "0" : "", G.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + y + "px)" : "translate3d(" + h + "px, " + y + "px, 0)", G));
  }
  return Object.assign({}, K, (t = {}, t[S] = x ? y + "px" : "", t[D] = b ? h + "px" : "", t.transform = "", t));
}
function BR(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var u = Wa(t.elements.popper).transitionProperty || "";
    o && ["transform", "top", "right", "bottom", "left"].some(function(f) {
      return u.indexOf(f) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var c = {
    placement: Xa(t.placement),
    variation: Wu(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, B5(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, B5(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const NR = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: BR,
  data: {}
};
var h1 = {
  passive: !0
};
function jR(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, o = r.resize, s = o === void 0 ? !0 : o, l = xa(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, h1);
  }), s && l.addEventListener("resize", n.update, h1), function() {
    a && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, h1);
    }), s && l.removeEventListener("resize", n.update, h1);
  };
}
const FR = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: jR,
  data: {}
};
var XR = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Z1(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return XR[t];
  });
}
var RR = {
  start: "end",
  end: "start"
};
function N5(e) {
  return e.replace(/start|end/g, function(t) {
    return RR[t];
  });
}
function m3(e) {
  var t = xa(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function g3(e) {
  return _u(Rs(e)).left + m3(e).scrollLeft;
}
function VR(e, t) {
  var n = xa(e), r = Rs(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    var u = Fb();
    (u || !u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + g3(e),
    y: l
  };
}
function UR(e) {
  var t, n = Rs(e), r = m3(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = Pl(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = Pl(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), s = -r.scrollLeft + g3(e), l = -r.scrollTop;
  return Wa(i || n).direction === "rtl" && (s += Pl(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function y3(e) {
  var t = Wa(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function qb(e) {
  return ["html", "body", "#document"].indexOf(ho(e)) >= 0 ? e.ownerDocument.body : Jr(e) && y3(e) ? e : qb(Vh(e));
}
function bd(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = qb(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = xa(r), o = i ? [a].concat(a.visualViewport || [], y3(r) ? r : []) : r, s = t.concat(o);
  return i ? s : s.concat(bd(Vh(o)));
}
function B8(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function qR(e, t) {
  var n = _u(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function j5(e, t, n) {
  return t === jb ? B8(VR(e, n)) : Hl(t) ? qR(t, n) : B8(UR(Rs(e)));
}
function _R(e) {
  var t = bd(Vh(e)), n = ["absolute", "fixed"].indexOf(Wa(e).position) >= 0, r = n && Jr(e) ? ff(e) : e;
  return Hl(r) ? t.filter(function(i) {
    return Hl(i) && Xb(i, r) && ho(i) !== "body";
  }) : [];
}
function WR(e, t, n, r) {
  var i = t === "clippingParents" ? _R(e) : [].concat(t), a = [].concat(i, [n]), o = a[0], s = a.reduce(function(l, u) {
    var c = j5(e, u, r);
    return l.top = Pl(c.top, l.top), l.right = F0(c.right, l.right), l.bottom = F0(c.bottom, l.bottom), l.left = Pl(c.left, l.left), l;
  }, j5(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function _b(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Xa(r) : null, a = r ? Wu(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (i) {
    case Mr:
      l = {
        x: o,
        y: t.y - n.height
      };
      break;
    case ba:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Aa:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Hr:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? v3(i) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (a) {
      case Uu:
        l[u] = l[u] - (t[c] / 2 - n[c] / 2);
        break;
      case Rd:
        l[u] = l[u] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function Vd(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, o = a === void 0 ? e.strategy : a, s = n.boundary, l = s === void 0 ? hR : s, u = n.rootBoundary, c = u === void 0 ? jb : u, f = n.elementContext, d = f === void 0 ? Yc : f, h = n.altBoundary, p = h === void 0 ? !1 : h, y = n.padding, m = y === void 0 ? 0 : y, b = Vb(typeof m != "number" ? m : Ub(m, df)), x = d === Yc ? pR : Yc, D = e.rects.popper, S = e.elements[p ? x : d], C = WR(Hl(S) ? S : S.contextElement || Rs(e.elements.popper), l, c, o), v = _u(e.elements.reference), H = _b({
    reference: v,
    element: D,
    strategy: "absolute",
    placement: i
  }), V = B8(Object.assign({}, D, H)), R = d === Yc ? V : v, F = {
    top: C.top - R.top + b.top,
    bottom: R.bottom - C.bottom + b.bottom,
    left: C.left - R.left + b.left,
    right: R.right - C.right + b.right
  }, K = e.modifiersData.offset;
  if (d === Yc && K) {
    var q = K[i];
    Object.keys(F).forEach(function(G) {
      var te = [Aa, ba].indexOf(G) >= 0 ? 1 : -1, Q = [Mr, ba].indexOf(G) >= 0 ? "y" : "x";
      F[G] += q[Q] * te;
    });
  }
  return F;
}
function KR(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? f3 : l, c = Wu(r), f = c ? s ? I5 : I5.filter(function(p) {
    return Wu(p) === c;
  }) : df, d = f.filter(function(p) {
    return u.indexOf(p) >= 0;
  });
  d.length === 0 && (d = f, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var h = d.reduce(function(p, y) {
    return p[y] = Vd(e, {
      placement: y,
      boundary: i,
      rootBoundary: a,
      padding: o
    })[Xa(y)], p;
  }, {});
  return Object.keys(h).sort(function(p, y) {
    return h[p] - h[y];
  });
}
function GR(e) {
  if (Xa(e) === Rh)
    return [];
  var t = Z1(e);
  return [N5(e), t, N5(t)];
}
function YR(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, u = n.padding, c = n.boundary, f = n.rootBoundary, d = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, y = n.allowedAutoPlacements, m = t.options.placement, b = Xa(m), x = b === m, D = l || (x || !p ? [Z1(m)] : GR(m)), S = [m].concat(D).reduce(function(ve, Ye) {
      return ve.concat(Xa(Ye) === Rh ? KR(t, {
        placement: Ye,
        boundary: c,
        rootBoundary: f,
        padding: u,
        flipVariations: p,
        allowedAutoPlacements: y
      }) : Ye);
    }, []), C = t.rects.reference, v = t.rects.popper, H = /* @__PURE__ */ new Map(), V = !0, R = S[0], F = 0; F < S.length; F++) {
      var K = S[F], q = Xa(K), G = Wu(K) === Uu, te = [Mr, ba].indexOf(q) >= 0, Q = te ? "width" : "height", Y = Vd(t, {
        placement: K,
        boundary: c,
        rootBoundary: f,
        altBoundary: d,
        padding: u
      }), Z = te ? G ? Aa : Hr : G ? ba : Mr;
      C[Q] > v[Q] && (Z = Z1(Z));
      var oe = Z1(Z), he = [];
      if (a && he.push(Y[q] <= 0), s && he.push(Y[Z] <= 0, Y[oe] <= 0), he.every(function(ve) {
        return ve;
      })) {
        R = K, V = !1;
        break;
      }
      H.set(K, he);
    }
    if (V)
      for (var Ae = p ? 3 : 1, We = function(Ye) {
        var Qe = S.find(function(ot) {
          var Ve = H.get(ot);
          if (Ve)
            return Ve.slice(0, Ye).every(function(Te) {
              return Te;
            });
        });
        if (Qe)
          return R = Qe, "break";
      }, ke = Ae; ke > 0; ke--) {
        var Re = We(ke);
        if (Re === "break")
          break;
      }
    t.placement !== R && (t.modifiersData[r]._skip = !0, t.placement = R, t.reset = !0);
  }
}
const QR = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: YR,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function F5(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function X5(e) {
  return [Mr, Aa, ba, Hr].some(function(t) {
    return e[t] >= 0;
  });
}
function ZR(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, o = Vd(t, {
    elementContext: "reference"
  }), s = Vd(t, {
    altBoundary: !0
  }), l = F5(o, r), u = F5(s, i, a), c = X5(l), f = X5(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": f
  });
}
const JR = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ZR
};
function $R(e, t, n) {
  var r = Xa(e), i = [Hr, Mr].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * i, [Hr, Aa].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function eV(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = f3.reduce(function(c, f) {
    return c[f] = $R(f, t.rects, a), c;
  }, {}), s = o[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = o;
}
const tV = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: eV
};
function nV(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = _b({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const iV = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: nV,
  data: {}
};
function rV(e) {
  return e === "x" ? "y" : "x";
}
function aV(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, f = n.padding, d = n.tether, h = d === void 0 ? !0 : d, p = n.tetherOffset, y = p === void 0 ? 0 : p, m = Vd(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: c
  }), b = Xa(t.placement), x = Wu(t.placement), D = !x, S = v3(b), C = rV(S), v = t.modifiersData.popperOffsets, H = t.rects.reference, V = t.rects.popper, R = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, F = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), K = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, q = {
    x: 0,
    y: 0
  };
  if (!!v) {
    if (a) {
      var G, te = S === "y" ? Mr : Hr, Q = S === "y" ? ba : Aa, Y = S === "y" ? "height" : "width", Z = v[S], oe = Z + m[te], he = Z - m[Q], Ae = h ? -V[Y] / 2 : 0, We = x === Uu ? H[Y] : V[Y], ke = x === Uu ? -V[Y] : -H[Y], Re = t.elements.arrow, ve = h && Re ? p3(Re) : {
        width: 0,
        height: 0
      }, Ye = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Rb(), Qe = Ye[te], ot = Ye[Q], Ve = yd(0, H[Y], ve[Y]), Te = D ? H[Y] / 2 - Ae - Ve - Qe - F.mainAxis : We - Ve - Qe - F.mainAxis, Me = D ? -H[Y] / 2 + Ae + Ve + ot + F.mainAxis : ke + Ve + ot + F.mainAxis, Je = t.elements.arrow && ff(t.elements.arrow), mt = Je ? S === "y" ? Je.clientTop || 0 : Je.clientLeft || 0 : 0, It = (G = K == null ? void 0 : K[S]) != null ? G : 0, ln = Z + Te - It - mt, gt = Z + Me - It, Pe = yd(h ? F0(oe, ln) : oe, Z, h ? Pl(he, gt) : he);
      v[S] = Pe, q[S] = Pe - Z;
    }
    if (s) {
      var $e, Ke = S === "x" ? Mr : Hr, lt = S === "x" ? ba : Aa, He = v[C], Le = C === "y" ? "height" : "width", ct = He + m[Ke], Qt = He - m[lt], Zt = [Mr, Hr].indexOf(b) !== -1, Pn = ($e = K == null ? void 0 : K[C]) != null ? $e : 0, Mn = Zt ? ct : He - H[Le] - V[Le] - Pn + F.altAxis, Mt = Zt ? He + H[Le] + V[Le] - Pn - F.altAxis : Qt, Nt = h && Zt ? OR(Mn, He, Mt) : yd(h ? Mn : ct, He, h ? Mt : Qt);
      v[C] = Nt, q[C] = Nt - He;
    }
    t.modifiersData[r] = q;
  }
}
const oV = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: aV,
  requiresIfExists: ["offset"]
};
function sV(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function lV(e) {
  return e === xa(e) || !Jr(e) ? m3(e) : sV(e);
}
function uV(e) {
  var t = e.getBoundingClientRect(), n = qu(t.width) / e.offsetWidth || 1, r = qu(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function cV(e, t, n) {
  n === void 0 && (n = !1);
  var r = Jr(t), i = Jr(t) && uV(t), a = Rs(t), o = _u(e, i, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ho(t) !== "body" || y3(a)) && (s = lV(t)), Jr(t) ? (l = _u(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = g3(a))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function dV(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && i(l);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function fV(e) {
  var t = dV(e);
  return I8.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function hV(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Ts(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(i, a) {
    return i.replace(/%s/, a);
  }, e);
}
var il = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', pV = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', R5 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function vV(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), R5).filter(function(n, r, i) {
      return i.indexOf(n) === r;
    }).forEach(function(n) {
      switch (n) {
        case "name":
          typeof t.name != "string" && console.error(Ts(il, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(Ts(il, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          I8.indexOf(t.phase) < 0 && console.error(Ts(il, t.name, '"phase"', "either " + I8.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(Ts(il, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(Ts(il, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(Ts(il, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(Ts(il, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + R5.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      t.requires && t.requires.forEach(function(r) {
        e.find(function(i) {
          return i.name === r;
        }) == null && console.error(Ts(pV, String(t.name), r, r));
      });
    });
  });
}
function mV(e, t) {
  var n = /* @__PURE__ */ new Set();
  return e.filter(function(r) {
    var i = t(r);
    if (!n.has(i))
      return n.add(i), !0;
  });
}
function gV(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var V5 = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", yV = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", U5 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function q5() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function bV(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? U5 : i;
  return function(s, l, u) {
    u === void 0 && (u = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, U5, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], d = !1, h = {
      state: c,
      setOptions: function(b) {
        var x = typeof b == "function" ? b(c.options) : b;
        y(), c.options = Object.assign({}, a, c.options, x), c.scrollParents = {
          reference: Hl(s) ? bd(s) : s.contextElement ? bd(s.contextElement) : [],
          popper: bd(l)
        };
        var D = fV(gV([].concat(r, c.options.modifiers)));
        if (c.orderedModifiers = D.filter(function(K) {
          return K.enabled;
        }), process.env.NODE_ENV !== "production") {
          var S = mV([].concat(D, c.options.modifiers), function(K) {
            var q = K.name;
            return q;
          });
          if (vV(S), Xa(c.options.placement) === Rh) {
            var C = c.orderedModifiers.find(function(K) {
              var q = K.name;
              return q === "flip";
            });
            C || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var v = Wa(l), H = v.marginTop, V = v.marginRight, R = v.marginBottom, F = v.marginLeft;
          [H, V, R, F].some(function(K) {
            return parseFloat(K);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return p(), h.update();
      },
      forceUpdate: function() {
        if (!d) {
          var b = c.elements, x = b.reference, D = b.popper;
          if (!q5(x, D)) {
            process.env.NODE_ENV !== "production" && console.error(V5);
            return;
          }
          c.rects = {
            reference: cV(x, ff(D), c.options.strategy === "fixed"),
            popper: p3(D)
          }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(K) {
            return c.modifiersData[K.name] = Object.assign({}, K.data);
          });
          for (var S = 0, C = 0; C < c.orderedModifiers.length; C++) {
            if (process.env.NODE_ENV !== "production" && (S += 1, S > 100)) {
              console.error(yV);
              break;
            }
            if (c.reset === !0) {
              c.reset = !1, C = -1;
              continue;
            }
            var v = c.orderedModifiers[C], H = v.fn, V = v.options, R = V === void 0 ? {} : V, F = v.name;
            typeof H == "function" && (c = H({
              state: c,
              options: R,
              name: F,
              instance: h
            }) || c);
          }
        }
      },
      update: hV(function() {
        return new Promise(function(m) {
          h.forceUpdate(), m(c);
        });
      }),
      destroy: function() {
        y(), d = !0;
      }
    };
    if (!q5(s, l))
      return process.env.NODE_ENV !== "production" && console.error(V5), h;
    h.setOptions(u).then(function(m) {
      !d && u.onFirstUpdate && u.onFirstUpdate(m);
    });
    function p() {
      c.orderedModifiers.forEach(function(m) {
        var b = m.name, x = m.options, D = x === void 0 ? {} : x, S = m.effect;
        if (typeof S == "function") {
          var C = S({
            state: c,
            name: b,
            instance: h,
            options: D
          }), v = function() {
          };
          f.push(C || v);
        }
      });
    }
    function y() {
      f.forEach(function(m) {
        return m();
      }), f = [];
    }
    return h;
  };
}
var AV = [FR, iV, NR, SR, tV, QR, oV, HR, JR], Wb = /* @__PURE__ */ bV({
  defaultModifiers: AV
});
const TV = {
  LIGHT: "light",
  DARK: "dark"
}, Kb = Gt({
  arrowOffset: {
    type: Number,
    default: 5
  }
}), wV = Gt({
  boundariesPadding: {
    type: Number,
    default: 0
  },
  fallbackPlacements: {
    type: jt(Array),
    default: () => []
  },
  gpuAcceleration: {
    type: Boolean,
    default: !0
  },
  offset: {
    type: Number,
    default: 12
  },
  placement: {
    type: String,
    values: f3,
    default: "bottom"
  },
  popperOptions: {
    type: jt(Object),
    default: () => ({})
  },
  strategy: {
    type: String,
    values: ["fixed", "absolute"],
    default: "absolute"
  }
});
Gt({
  autoClose: {
    type: Number,
    default: 0
  },
  cutoff: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  }
});
const Gb = Gt({
  ...wV,
  style: { type: jt([String, Array, Object]) },
  className: { type: jt([String, Array, Object]) },
  effect: {
    type: String,
    default: "dark"
  },
  enterable: {
    type: Boolean,
    default: !0
  },
  pure: {
    type: Boolean
  },
  popperClass: {
    type: jt([String, Array, Object])
  },
  popperStyle: {
    type: jt([String, Array, Object])
  },
  referenceEl: {
    type: jt(Object)
  },
  stopPopperMouseEvent: {
    type: Boolean,
    default: !0
  },
  zIndex: Number
}), Yb = Gt({
  virtualRef: {
    type: jt(Object)
  },
  virtualTriggering: {
    type: Boolean
  }
}), PV = Ee({
  name: "ElPopperArrow",
  props: Kb,
  setup(e) {
    const t = Ct("popper"), n = j(null), r = ce(Nb, void 0);
    return Ne(() => e.arrowOffset, (i) => {
      r.arrowOffset.value = i;
    }), rn(() => {
      r.arrowRef.value = E(n);
    }), Ti(() => {
      r.arrowRef.value = null;
    }), {
      ns: t,
      arrowRef: n
    };
  }
});
function xV(e, t, n, r, i, a) {
  return P(), L("span", {
    ref: "arrowRef",
    class: se(e.ns.e("arrow")),
    "data-popper-arrow": ""
  }, null, 2);
}
var CV = /* @__PURE__ */ vt(PV, [["render", xV]]);
const cp = "ElOnlyChild", SV = Ee({
  name: cp,
  setup(e, { slots: t, attrs: n }) {
    var r;
    const i = ce(Sb, void 0), a = CX((r = i.setForwardRef) != null ? r : Vn);
    return () => {
      var o;
      const s = (o = t.default) == null ? void 0 : o.call(t, n);
      if (!s)
        return null;
      if (s.length > 1)
        return fi(cp, "ElOnlyChild requires exact only one valid child."), null;
      const l = Qb(s);
      return l ? Bt(KC(l, n), [
        [a]
      ]) : (fi(cp, "no valid child node found"), null);
    };
  }
});
function Qb(e) {
  if (!e)
    return null;
  const t = e;
  for (let n = 0; n < t.length; n++) {
    const r = t[n];
    if (tr(r))
      switch (r.type) {
        case GC:
          continue;
        case ng:
          return _5(r);
        case nt:
          return Qb(r.children);
        default:
          return r;
      }
    return _5(r);
  }
  return null;
}
function _5(e) {
  return et("span", { class: "el-only-child__content" }, [e]);
}
const W5 = (e, t) => {
  const { placement: n, strategy: r, popperOptions: i } = e, a = {
    placement: n,
    strategy: r,
    ...i,
    modifiers: EV(e)
  };
  return kV(a, t), OV(a, i == null ? void 0 : i.modifiers), a;
}, Zb = (e) => {
  let t = null;
  return e ? ("getBoundingClientRect" in e || e instanceof HTMLElement ? t = e : t = e.$el, t) : null;
};
function EV(e) {
  const { offset: t, gpuAcceleration: n, fallbackPlacements: r } = e;
  return [
    {
      name: "offset",
      options: {
        offset: [0, t != null ? t : 12]
      }
    },
    {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    },
    {
      name: "flip",
      options: {
        padding: 5,
        fallbackPlacements: r != null ? r : []
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: n,
        adaptive: n
      }
    }
  ];
}
function kV(e, { arrowEl: t, arrowOffset: n }) {
  e.modifiers.push({
    name: "arrow",
    options: {
      element: t,
      padding: n != null ? n : 5
    }
  });
}
function OV(e, t) {
  t && (e.modifiers = [...e.modifiers, ...t != null ? t : []]);
}
const zV = Ee({
  name: "ElPopperTrigger",
  components: { ElOnlyChild: SV },
  inheritAttrs: !1,
  props: {
    ...Yb,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function,
    onKeydown: Function,
    onFocus: Function,
    onBlur: Function,
    onContextmenu: Function,
    id: String,
    open: Boolean
  },
  setup(e) {
    const { triggerRef: t } = ce(d3, void 0);
    return xX(t), Ne(() => e.virtualRef, (n) => {
      n && (t.value = Zb(n));
    }, {
      immediate: !0
    }), Ne(() => t.value, (n, r) => {
      n && n instanceof HTMLElement && [
        "onMouseenter",
        "onMouseleave",
        "onClick",
        "onKeydown",
        "onFocus",
        "onBlur",
        "onContextmenu"
      ].forEach((i) => {
        const a = e[i];
        a && (n.addEventListener(i.slice(2).toLowerCase(), a), r == null || r.removeEventListener(i.slice(2).toLowerCase(), a));
      });
    }, {
      immediate: !0
    }), {
      triggerRef: t
    };
  }
});
function DV(e, t, n, r, i, a) {
  const o = Ie("el-only-child");
  return e.virtualTriggering ? re("v-if", !0) : (P(), ue(o, $r({ key: 0 }, e.$attrs, {
    "aria-describedby": e.open ? e.id : void 0
  }), {
    default: N(() => [
      tt(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["aria-describedby"]));
}
var MV = /* @__PURE__ */ vt(zV, [["render", DV]]);
const HV = Ee({
  name: "ElPopperContent",
  props: Gb,
  emits: ["mouseenter", "mouseleave"],
  setup(e) {
    const { triggerRef: t, popperInstanceRef: n, contentRef: r } = ce(d3, void 0), { nextZIndex: i } = Xh(), a = Ct("popper"), o = j(null), s = j(null), l = j();
    _t(Nb, {
      arrowRef: s,
      arrowOffset: l
    });
    const u = j(e.zIndex || i()), c = J(() => [{ zIndex: E(u) }, e.popperStyle]), f = J(() => [
      a.b(),
      a.is("pure", e.pure),
      a.is(e.effect),
      e.popperClass
    ]), d = ({
      referenceEl: p,
      popperContentEl: y,
      arrowEl: m
    }) => {
      const b = W5(e, {
        arrowEl: m,
        arrowOffset: E(l)
      });
      return Wb(p, y, b);
    }, h = () => {
      var p;
      (p = E(n)) == null || p.update(), u.value = e.zIndex || i();
    };
    return rn(() => {
      let p;
      Ne(() => Zb(e.referenceEl) || E(t), (y) => {
        var m;
        if (p == null || p(), y) {
          (m = n.value) == null || m.destroy();
          const b = E(o);
          r.value = b;
          const x = E(s), D = d({
            referenceEl: y,
            popperContentEl: E(o),
            arrowEl: x
          });
          n.value = D, p = Ne(() => y.getBoundingClientRect(), () => {
            h();
          }, {
            immediate: !0
          });
        } else
          n.value = null;
      }, {
        immediate: !0
      }), Ne(() => W5(e, {
        arrowEl: E(s),
        arrowOffset: E(l)
      }), (y) => {
        var m;
        return (m = n.value) == null ? void 0 : m.setOptions(y);
      });
    }), {
      ns: a,
      popperContentRef: o,
      popperInstanceRef: n,
      contentStyle: c,
      contentClass: f,
      updatePopper: h
    };
  }
});
function IV(e, t, n, r, i, a) {
  return P(), L("div", {
    ref: "popperContentRef",
    style: Pt(e.contentStyle),
    class: se(e.contentClass),
    role: "tooltip",
    onMouseenter: t[0] || (t[0] = (o) => e.$emit("mouseenter", o)),
    onMouseleave: t[1] || (t[1] = (o) => e.$emit("mouseleave", o))
  }, [
    tt(e.$slots, "default")
  ], 38);
}
var LV = /* @__PURE__ */ vt(HV, [["render", IV]]);
function Uh(e, t) {
  const n = sn(), r = J(() => Fa(n.props[t]) ? n.props[t] : n.props.teleported);
  return oX({
    scope: e,
    from: t,
    replacement: "teleported",
    version: "2.1.0",
    ref: "https://element-plus.org/en-US/component/tooltip.html#attributes"
  }, J(() => Fa(n.props[t]))), {
    compatTeleported: r
  };
}
const BV = Un(fR), NV = Ee({
  name: "ElVisuallyHidden",
  props: {
    style: {
      type: [String, Object, Array]
    }
  },
  setup(e) {
    return {
      computedStyle: J(() => [
        e.style,
        {
          position: "absolute",
          border: 0,
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          wordWrap: "normal"
        }
      ])
    };
  }
});
function jV(e, t, n, r, i, a) {
  return P(), L("span", $r(e.$attrs, { style: e.computedStyle }), null, 16);
}
var FV = /* @__PURE__ */ vt(NV, [["render", jV]]);
const zr = Gt({
  ...wX,
  ...Gb,
  appendTo: {
    type: jt([String, Object]),
    default: AX
  },
  content: {
    type: String,
    default: ""
  },
  rawContent: {
    type: Boolean,
    default: !1
  },
  persistent: Boolean,
  ariaLabel: String,
  visible: {
    type: jt(Boolean),
    default: null
  },
  transition: {
    type: String,
    default: "el-fade-in-linear"
  },
  teleported: {
    type: Boolean,
    default: !0
  },
  disabled: {
    type: Boolean
  }
}), Ud = Gt({
  ...Yb,
  disabled: Boolean,
  trigger: {
    type: jt([String, Array]),
    default: "hover"
  }
}), XV = Gt({
  openDelay: {
    type: Number
  },
  visibleArrow: {
    type: Boolean,
    default: void 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  showArrow: {
    type: Boolean,
    default: !0
  }
}), qh = Symbol("elTooltip"), RV = Ee({
  name: "ElTooltipContent",
  components: {
    ElPopperContent: LV,
    ElVisuallyHidden: FV
  },
  inheritAttrs: !1,
  props: zr,
  setup(e) {
    const t = j(null), n = j(!1), r = j(!1), i = j(!1), { controlled: a, id: o, open: s, trigger: l, onClose: u, onOpen: c, onShow: f, onHide: d } = ce(qh, void 0), h = J(() => process.env.NODE_ENV === "test" ? !0 : e.persistent), p = J(() => E(h) ? !0 : E(s)), y = J(() => e.disabled ? !1 : E(s)), m = J(() => {
      var R;
      return (R = e.style) != null ? R : {};
    }), b = J(() => !E(s));
    bX(u);
    const x = () => {
      d();
    }, D = () => {
      if (E(a))
        return !0;
    }, S = Si(D, () => {
      e.enterable && E(l) === "hover" && c();
    }), C = Si(D, () => {
      E(l) === "hover" && u();
    }), v = () => {
      var R, F;
      (F = (R = t.value) == null ? void 0 : R.updatePopper) == null || F.call(R);
    }, H = () => {
      f();
    };
    let V;
    return Ne(() => E(s), (R) => {
      R ? V = T8(J(() => {
        var F;
        return (F = t.value) == null ? void 0 : F.popperContentRef;
      }), () => {
        if (E(a))
          return;
        E(l) !== "hover" && u();
      }) : V == null || V();
    }, {
      flush: "post"
    }), {
      ariaHidden: b,
      entering: r,
      leaving: i,
      id: o,
      intermediateOpen: n,
      contentStyle: m,
      contentRef: t,
      shouldRender: p,
      shouldShow: y,
      open: s,
      onAfterShow: H,
      onBeforeEnter: v,
      onContentEnter: S,
      onContentLeave: C,
      onTransitionLeave: x
    };
  }
});
function VV(e, t, n, r, i, a) {
  const o = Ie("el-visually-hidden"), s = Ie("el-popper-content");
  return P(), ue(K4, {
    disabled: !e.teleported,
    to: e.appendTo
  }, [
    B(wa, {
      name: e.transition,
      onAfterLeave: e.onTransitionLeave,
      onBeforeEnter: e.onBeforeEnter,
      onAfterEnter: e.onAfterShow
    }, {
      default: N(() => [
        e.shouldRender ? Bt((P(), ue(s, $r({
          key: 0,
          ref: "contentRef"
        }, e.$attrs, {
          "aria-hidden": e.ariaHidden,
          "boundaries-padding": e.boundariesPadding,
          "fallback-placements": e.fallbackPlacements,
          "gpu-acceleration": e.gpuAcceleration,
          offset: e.offset,
          placement: e.placement,
          "popper-options": e.popperOptions,
          strategy: e.strategy,
          effect: e.effect,
          enterable: e.enterable,
          pure: e.pure,
          "popper-class": e.popperClass,
          "popper-style": [e.popperStyle, e.contentStyle],
          "reference-el": e.referenceEl,
          "z-index": e.zIndex,
          onMouseenter: e.onContentEnter,
          onMouseleave: e.onContentLeave
        }), {
          default: N(() => [
            tt(e.$slots, "default"),
            B(o, {
              id: e.id,
              role: "tooltip"
            }, {
              default: N(() => [
                je(de(e.ariaLabel), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "z-index", "onMouseenter", "onMouseleave"])), [
          [Cn, e.shouldShow]
        ]) : re("v-if", !0)
      ]),
      _: 3
    }, 8, ["name", "onAfterLeave", "onBeforeEnter", "onAfterEnter"])
  ], 8, ["disabled", "to"]);
}
var UV = /* @__PURE__ */ vt(RV, [["render", VV]]);
const qV = (e, t) => zu(e) ? e.includes(t) : e === t, ou = (e, t, n) => (r) => {
  qV(E(e), t) && n(r);
}, _V = Ee({
  name: "ElTooltipTrigger",
  components: {
    ElPopperTrigger: MV
  },
  props: Ud,
  setup(e) {
    const t = Ct("tooltip"), { controlled: n, id: r, open: i, onOpen: a, onClose: o, onToggle: s } = ce(qh, void 0), l = j(null), u = () => {
      if (E(n) || e.disabled)
        return !0;
    }, c = er(e, "trigger"), f = Si(u, ou(c, "hover", a)), d = Si(u, ou(c, "hover", o)), h = Si(u, ou(c, "click", (x) => {
      x.button === 0 && s(x);
    })), p = Si(u, ou(c, "focus", a)), y = Si(u, ou(c, "focus", o)), m = Si(u, ou(c, "contextmenu", (x) => {
      x.preventDefault(), s(x);
    })), b = Si(u, (x) => {
      const { code: D } = x;
      (D === yt.enter || D === yt.space) && s(x);
    });
    return {
      onBlur: y,
      onContextMenu: m,
      onFocus: p,
      onMouseenter: f,
      onMouseleave: d,
      onClick: h,
      onKeydown: b,
      open: i,
      id: r,
      triggerRef: l,
      ns: t
    };
  }
});
function WV(e, t, n, r, i, a) {
  const o = Ie("el-popper-trigger");
  return P(), ue(o, {
    id: e.id,
    "virtual-ref": e.virtualRef,
    open: e.open,
    "virtual-triggering": e.virtualTriggering,
    class: se(e.ns.e("trigger")),
    onBlur: e.onBlur,
    onClick: e.onClick,
    onContextmenu: e.onContextMenu,
    onFocus: e.onFocus,
    onMouseenter: e.onMouseenter,
    onMouseleave: e.onMouseleave,
    onKeydown: e.onKeydown
  }, {
    default: N(() => [
      tt(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["id", "virtual-ref", "open", "virtual-triggering", "class", "onBlur", "onClick", "onContextmenu", "onFocus", "onMouseenter", "onMouseleave", "onKeydown"]);
}
var KV = /* @__PURE__ */ vt(_V, [["render", WV]]);
const { useModelToggleProps: GV, useModelToggle: YV, useModelToggleEmits: QV } = wb("visible"), ZV = Ee({
  name: "ElTooltip",
  components: {
    ElPopper: BV,
    ElPopperArrow: CV,
    ElTooltipContent: UV,
    ElTooltipTrigger: KV
  },
  props: {
    ...GV,
    ...zr,
    ...Ud,
    ...Kb,
    ...XV
  },
  emits: [...QV, "show", "hide"],
  setup(e, { emit: t }) {
    TX();
    const n = J(() => (jd(e.openDelay) || fi("ElTooltip", "open-delay is about to be deprecated in the next major version, please use `show-after` instead"), e.openDelay || e.showAfter)), r = J(() => (jd(e.visibleArrow) || fi("ElTooltip", "`visible-arrow` is about to be deprecated in the next major version, please use `show-arrow` instead"), Fa(e.visibleArrow) ? e.visibleArrow : e.showArrow)), i = xb(), a = j(null), o = () => {
      var h;
      const p = E(a);
      p && ((h = p.popperInstanceRef) == null || h.update());
    }, s = j(!1), { show: l, hide: u } = YV({
      indicator: s
    }), { onOpen: c, onClose: f } = PX({
      showAfter: n,
      hideAfter: er(e, "hideAfter"),
      open: l,
      close: u
    }), d = J(() => Fa(e.visible));
    return _t(qh, {
      controlled: d,
      id: i,
      open: _4(s),
      trigger: er(e, "trigger"),
      onOpen: c,
      onClose: f,
      onToggle: () => {
        E(s) ? f() : c();
      },
      onShow: () => {
        t("show");
      },
      onHide: () => {
        t("hide");
      },
      updatePopper: o
    }), {
      compatShowAfter: n,
      compatShowArrow: r,
      popperRef: a,
      open: s,
      hide: u,
      updatePopper: o,
      onOpen: c,
      onClose: f
    };
  }
}), JV = ["innerHTML"], $V = { key: 1 };
function eU(e, t, n, r, i, a) {
  const o = Ie("el-tooltip-trigger"), s = Ie("el-popper-arrow"), l = Ie("el-tooltip-content"), u = Ie("el-popper");
  return P(), ue(u, { ref: "popperRef" }, {
    default: N(() => [
      B(o, {
        disabled: e.disabled,
        trigger: e.trigger,
        "virtual-ref": e.virtualRef,
        "virtual-triggering": e.virtualTriggering
      }, {
        default: N(() => [
          e.$slots.default ? tt(e.$slots, "default", { key: 0 }) : re("v-if", !0)
        ]),
        _: 3
      }, 8, ["disabled", "trigger", "virtual-ref", "virtual-triggering"]),
      B(l, {
        "aria-label": e.ariaLabel,
        "boundaries-padding": e.boundariesPadding,
        content: e.content,
        disabled: e.disabled,
        effect: e.effect,
        enterable: e.enterable,
        "fallback-placements": e.fallbackPlacements,
        "hide-after": e.hideAfter,
        "gpu-acceleration": e.gpuAcceleration,
        offset: e.offset,
        persistent: e.persistent,
        "popper-class": e.popperClass,
        "popper-style": e.popperStyle,
        placement: e.placement,
        "popper-options": e.popperOptions,
        pure: e.pure,
        "raw-content": e.rawContent,
        "reference-el": e.referenceEl,
        "show-after": e.compatShowAfter,
        strategy: e.strategy,
        teleported: e.teleported,
        transition: e.transition,
        "z-index": e.zIndex
      }, {
        default: N(() => [
          tt(e.$slots, "content", {}, () => [
            e.rawContent ? (P(), L("span", {
              key: 0,
              innerHTML: e.content
            }, null, 8, JV)) : (P(), L("span", $V, de(e.content), 1))
          ]),
          e.compatShowArrow ? (P(), ue(s, {
            key: 0,
            "arrow-offset": e.arrowOffset
          }, null, 8, ["arrow-offset"])) : re("v-if", !0)
        ]),
        _: 3
      }, 8, ["aria-label", "boundaries-padding", "content", "disabled", "effect", "enterable", "fallback-placements", "hide-after", "gpu-acceleration", "offset", "persistent", "popper-class", "popper-style", "placement", "popper-options", "pure", "raw-content", "reference-el", "show-after", "strategy", "teleported", "transition", "z-index"])
    ]),
    _: 3
  }, 512);
}
var tU = /* @__PURE__ */ vt(ZV, [["render", eU]]);
const Ki = Un(tU), nU = Gt({
  size: {
    type: [Number, String],
    values: ["large", "default", "small"],
    default: "default",
    validator: (e) => typeof e == "number"
  },
  shape: {
    type: String,
    values: ["circle", "square"],
    default: "circle"
  },
  icon: {
    type: ya
  },
  src: {
    type: String,
    default: ""
  },
  alt: String,
  srcSet: String,
  fit: {
    type: jt(String),
    default: "cover"
  }
}), iU = {
  error: (e) => e instanceof Event
}, rU = Ee({
  name: "ElAvatar",
  components: {
    ElIcon: qt
  },
  props: nU,
  emits: iU,
  setup(e, { emit: t }) {
    const n = Ct("avatar"), r = j(!1), i = J(() => {
      const { size: l, icon: u, shape: c } = e, f = [n.b()];
      return Ai(l) && f.push(n.m(l)), u && f.push(n.m("icon")), c && f.push(n.m(c)), f;
    }), a = J(() => {
      const { size: l } = e;
      return jn(l) ? {
        "--el-avatar-size": _o(l)
      } : void 0;
    }), o = J(() => ({
      objectFit: e.fit
    }));
    Ne(() => e.src, () => r.value = !1);
    function s(l) {
      r.value = !0, t("error", l);
    }
    return {
      hasLoadError: r,
      avatarClass: i,
      sizeStyle: a,
      fitStyle: o,
      handleError: s
    };
  }
}), aU = ["src", "alt", "srcset"];
function oU(e, t, n, r, i, a) {
  const o = Ie("el-icon");
  return P(), L("span", {
    class: se(e.avatarClass),
    style: Pt(e.sizeStyle)
  }, [
    (e.src || e.srcSet) && !e.hasLoadError ? (P(), L("img", {
      key: 0,
      src: e.src,
      alt: e.alt,
      srcset: e.srcSet,
      style: Pt(e.fitStyle),
      onError: t[0] || (t[0] = (...s) => e.handleError && e.handleError(...s))
    }, null, 44, aU)) : e.icon ? (P(), ue(o, { key: 1 }, {
      default: N(() => [
        (P(), ue(Ln(e.icon)))
      ]),
      _: 1
    })) : tt(e.$slots, "default", { key: 2 })
  ], 6);
}
var sU = /* @__PURE__ */ vt(rU, [["render", oU]]);
const lU = Un(sU), uU = Gt({
  value: {
    type: [String, Number],
    default: ""
  },
  max: {
    type: Number,
    default: 99
  },
  isDot: Boolean,
  hidden: Boolean,
  type: {
    type: String,
    values: ["primary", "success", "warning", "info", "danger"],
    default: "danger"
  }
}), cU = Ee({
  name: "ElBadge",
  props: uU,
  setup(e) {
    const t = Ct("badge"), n = J(() => e.isDot ? "" : typeof e.value == "number" && typeof e.max == "number" ? e.max < e.value ? `${e.max}+` : `${e.value}` : `${e.value}`);
    return {
      ns: t,
      content: n
    };
  }
}), dU = ["textContent"];
function fU(e, t, n, r, i, a) {
  return P(), L("div", {
    class: se(e.ns.b())
  }, [
    tt(e.$slots, "default"),
    B(wa, {
      name: `${e.ns.namespace.value}-zoom-in-center`
    }, {
      default: N(() => [
        Bt(T("sup", {
          class: se([
            e.ns.e("content"),
            e.ns.em("content", e.type),
            e.ns.is("fixed", !!e.$slots.default),
            e.ns.is("dot", e.isDot)
          ]),
          textContent: de(e.content)
        }, null, 10, dU), [
          [Cn, !e.hidden && (e.content || e.content === "0" || e.isDot)]
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ], 2);
}
var hU = /* @__PURE__ */ vt(cU, [["render", fU]]);
const Jb = Un(hU);
function _i(e, t) {
  pU(e) && (e = "100%");
  var n = vU(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function p1(e) {
  return Math.min(1, Math.max(0, e));
}
function pU(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function vU(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function $b(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function v1(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function ml(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function mU(e, t, n) {
  return {
    r: _i(e, 255) * 255,
    g: _i(t, 255) * 255,
    b: _i(n, 255) * 255
  };
}
function K5(e, t, n) {
  e = _i(e, 255), t = _i(t, 255), n = _i(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), a = 0, o = 0, s = (r + i) / 2;
  if (r === i)
    o = 0, a = 0;
  else {
    var l = r - i;
    switch (o = s > 0.5 ? l / (2 - r - i) : l / (r + i), r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: o, l: s };
}
function dp(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function gU(e, t, n) {
  var r, i, a;
  if (e = _i(e, 360), t = _i(t, 100), n = _i(n, 100), t === 0)
    i = n, a = n, r = n;
  else {
    var o = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - o;
    r = dp(s, o, e + 1 / 3), i = dp(s, o, e), a = dp(s, o, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: a * 255 };
}
function G5(e, t, n) {
  e = _i(e, 255), t = _i(t, 255), n = _i(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), a = 0, o = r, s = r - i, l = r === 0 ? 0 : s / r;
  if (r === i)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / s + 2;
        break;
      case n:
        a = (e - t) / s + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: l, v: o };
}
function yU(e, t, n) {
  e = _i(e, 360) * 6, t = _i(t, 100), n = _i(n, 100);
  var r = Math.floor(e), i = e - r, a = n * (1 - t), o = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = r % 6, u = [n, o, a, a, s, n][l], c = [s, n, n, o, a, a][l], f = [a, a, s, n, n, o][l];
  return { r: u * 255, g: c * 255, b: f * 255 };
}
function Y5(e, t, n, r) {
  var i = [
    ml(Math.round(e).toString(16)),
    ml(Math.round(t).toString(16)),
    ml(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function bU(e, t, n, r, i) {
  var a = [
    ml(Math.round(e).toString(16)),
    ml(Math.round(t).toString(16)),
    ml(Math.round(n).toString(16)),
    ml(AU(r))
  ];
  return i && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function AU(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Q5(e) {
  return qr(e) / 255;
}
function qr(e) {
  return parseInt(e, 16);
}
function TU(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var N8 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function wU(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, a = null, o = !1, s = !1;
  return typeof e == "string" && (e = CU(e)), typeof e == "object" && (So(e.r) && So(e.g) && So(e.b) ? (t = mU(e.r, e.g, e.b), o = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : So(e.h) && So(e.s) && So(e.v) ? (r = v1(e.s), i = v1(e.v), t = yU(e.h, r, i), o = !0, s = "hsv") : So(e.h) && So(e.s) && So(e.l) && (r = v1(e.s), a = v1(e.l), t = gU(e.h, r, a), o = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = $b(n), {
    ok: o,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var PU = "[-\\+]?\\d+%?", xU = "[-\\+]?\\d*\\.\\d+%?", Es = "(?:".concat(xU, ")|(?:").concat(PU, ")"), fp = "[\\s|\\(]+(".concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")\\s*\\)?"), hp = "[\\s|\\(]+(".concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")\\s*\\)?"), La = {
  CSS_UNIT: new RegExp(Es),
  rgb: new RegExp("rgb" + fp),
  rgba: new RegExp("rgba" + hp),
  hsl: new RegExp("hsl" + fp),
  hsla: new RegExp("hsla" + hp),
  hsv: new RegExp("hsv" + fp),
  hsva: new RegExp("hsva" + hp),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function CU(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (N8[e])
    e = N8[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = La.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = La.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = La.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = La.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = La.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = La.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = La.hex8.exec(e), n ? {
    r: qr(n[1]),
    g: qr(n[2]),
    b: qr(n[3]),
    a: Q5(n[4]),
    format: t ? "name" : "hex8"
  } : (n = La.hex6.exec(e), n ? {
    r: qr(n[1]),
    g: qr(n[2]),
    b: qr(n[3]),
    format: t ? "name" : "hex"
  } : (n = La.hex4.exec(e), n ? {
    r: qr(n[1] + n[1]),
    g: qr(n[2] + n[2]),
    b: qr(n[3] + n[3]),
    a: Q5(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = La.hex3.exec(e), n ? {
    r: qr(n[1] + n[1]),
    g: qr(n[2] + n[2]),
    b: qr(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function So(e) {
  return Boolean(La.CSS_UNIT.exec(String(e)));
}
var eA = function() {
  function e(t, n) {
    t === void 0 && (t = ""), n === void 0 && (n = {});
    var r;
    if (t instanceof e)
      return t;
    typeof t == "number" && (t = TU(t)), this.originalInput = t;
    var i = wU(t);
    this.originalInput = t, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : i.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
  }
  return e.prototype.isDark = function() {
    return this.getBrightness() < 128;
  }, e.prototype.isLight = function() {
    return !this.isDark();
  }, e.prototype.getBrightness = function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  }, e.prototype.getLuminance = function() {
    var t = this.toRgb(), n, r, i, a = t.r / 255, o = t.g / 255, s = t.b / 255;
    return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), o <= 0.03928 ? r = o / 12.92 : r = Math.pow((o + 0.055) / 1.055, 2.4), s <= 0.03928 ? i = s / 12.92 : i = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * i;
  }, e.prototype.getAlpha = function() {
    return this.a;
  }, e.prototype.setAlpha = function(t) {
    return this.a = $b(t), this.roundA = Math.round(100 * this.a) / 100, this;
  }, e.prototype.toHsv = function() {
    var t = G5(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
  }, e.prototype.toHsvString = function() {
    var t = G5(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.v * 100);
    return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
  }, e.prototype.toHsl = function() {
    var t = K5(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
  }, e.prototype.toHslString = function() {
    var t = K5(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.l * 100);
    return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
  }, e.prototype.toHex = function(t) {
    return t === void 0 && (t = !1), Y5(this.r, this.g, this.b, t);
  }, e.prototype.toHexString = function(t) {
    return t === void 0 && (t = !1), "#" + this.toHex(t);
  }, e.prototype.toHex8 = function(t) {
    return t === void 0 && (t = !1), bU(this.r, this.g, this.b, this.a, t);
  }, e.prototype.toHex8String = function(t) {
    return t === void 0 && (t = !1), "#" + this.toHex8(t);
  }, e.prototype.toRgb = function() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }, e.prototype.toRgbString = function() {
    var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
    return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
  }, e.prototype.toPercentageRgb = function() {
    var t = function(n) {
      return "".concat(Math.round(_i(n, 255) * 100), "%");
    };
    return {
      r: t(this.r),
      g: t(this.g),
      b: t(this.b),
      a: this.a
    };
  }, e.prototype.toPercentageRgbString = function() {
    var t = function(n) {
      return Math.round(_i(n, 255) * 100);
    };
    return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
  }, e.prototype.toName = function() {
    if (this.a === 0)
      return "transparent";
    if (this.a < 1)
      return !1;
    for (var t = "#" + Y5(this.r, this.g, this.b, !1), n = 0, r = Object.entries(N8); n < r.length; n++) {
      var i = r[n], a = i[0], o = i[1];
      if (t === o)
        return a;
    }
    return !1;
  }, e.prototype.toString = function(t) {
    var n = Boolean(t);
    t = t != null ? t : this.format;
    var r = !1, i = this.a < 1 && this.a >= 0, a = !n && i && (t.startsWith("hex") || t === "name");
    return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  }, e.prototype.toNumber = function() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }, e.prototype.clone = function() {
    return new e(this.toString());
  }, e.prototype.lighten = function(t) {
    t === void 0 && (t = 10);
    var n = this.toHsl();
    return n.l += t / 100, n.l = p1(n.l), new e(n);
  }, e.prototype.brighten = function(t) {
    t === void 0 && (t = 10);
    var n = this.toRgb();
    return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
  }, e.prototype.darken = function(t) {
    t === void 0 && (t = 10);
    var n = this.toHsl();
    return n.l -= t / 100, n.l = p1(n.l), new e(n);
  }, e.prototype.tint = function(t) {
    return t === void 0 && (t = 10), this.mix("white", t);
  }, e.prototype.shade = function(t) {
    return t === void 0 && (t = 10), this.mix("black", t);
  }, e.prototype.desaturate = function(t) {
    t === void 0 && (t = 10);
    var n = this.toHsl();
    return n.s -= t / 100, n.s = p1(n.s), new e(n);
  }, e.prototype.saturate = function(t) {
    t === void 0 && (t = 10);
    var n = this.toHsl();
    return n.s += t / 100, n.s = p1(n.s), new e(n);
  }, e.prototype.greyscale = function() {
    return this.desaturate(100);
  }, e.prototype.spin = function(t) {
    var n = this.toHsl(), r = (n.h + t) % 360;
    return n.h = r < 0 ? 360 + r : r, new e(n);
  }, e.prototype.mix = function(t, n) {
    n === void 0 && (n = 50);
    var r = this.toRgb(), i = new e(t).toRgb(), a = n / 100, o = {
      r: (i.r - r.r) * a + r.r,
      g: (i.g - r.g) * a + r.g,
      b: (i.b - r.b) * a + r.b,
      a: (i.a - r.a) * a + r.a
    };
    return new e(o);
  }, e.prototype.analogous = function(t, n) {
    t === void 0 && (t = 6), n === void 0 && (n = 30);
    var r = this.toHsl(), i = 360 / n, a = [this];
    for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t; )
      r.h = (r.h + i) % 360, a.push(new e(r));
    return a;
  }, e.prototype.complement = function() {
    var t = this.toHsl();
    return t.h = (t.h + 180) % 360, new e(t);
  }, e.prototype.monochromatic = function(t) {
    t === void 0 && (t = 6);
    for (var n = this.toHsv(), r = n.h, i = n.s, a = n.v, o = [], s = 1 / t; t--; )
      o.push(new e({ h: r, s: i, v: a })), a = (a + s) % 1;
    return o;
  }, e.prototype.splitcomplement = function() {
    var t = this.toHsl(), n = t.h;
    return [
      this,
      new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
      new e({ h: (n + 216) % 360, s: t.s, l: t.l })
    ];
  }, e.prototype.onBackground = function(t) {
    var n = this.toRgb(), r = new e(t).toRgb();
    return new e({
      r: r.r + (n.r - r.r) * n.a,
      g: r.g + (n.g - r.g) * n.a,
      b: r.b + (n.b - r.b) * n.a
    });
  }, e.prototype.triad = function() {
    return this.polyad(3);
  }, e.prototype.tetrad = function() {
    return this.polyad(4);
  }, e.prototype.polyad = function(t) {
    for (var n = this.toHsl(), r = n.h, i = [this], a = 360 / t, o = 1; o < t; o++)
      i.push(new e({ h: (r + o * a) % 360, s: n.s, l: n.l }));
    return i;
  }, e.prototype.equals = function(t) {
    return this.toRgbString() === new e(t).toRgbString();
  }, e;
}();
const SU = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  "text",
  ""
], EU = ["button", "submit", "reset"], j8 = Gt({
  size: Fh,
  disabled: Boolean,
  type: {
    type: String,
    values: SU,
    default: ""
  },
  icon: {
    type: ya,
    default: ""
  },
  nativeType: {
    type: String,
    values: EU,
    default: "button"
  },
  loading: Boolean,
  loadingIcon: {
    type: ya,
    default: () => Vl
  },
  plain: Boolean,
  autofocus: Boolean,
  round: Boolean,
  circle: Boolean,
  color: String,
  autoInsertSpace: {
    type: Boolean,
    default: void 0
  }
}), kU = {
  click: (e) => e instanceof MouseEvent
}, OU = ["disabled", "autofocus", "type"], zU = {
  name: "ElButton"
}, DU = /* @__PURE__ */ Ee({
  ...zU,
  props: j8,
  emits: kU,
  setup(e, { expose: t, emit: n }) {
    const r = e, i = YC(), a = ce(mb, void 0), o = mc("button"), s = Ct("button"), { form: l } = gc(), u = Bi(J(() => a == null ? void 0 : a.size)), c = cf(), f = j(), d = J(() => r.type || (a == null ? void 0 : a.type) || ""), h = J(() => {
      var x, D, S;
      return (S = (D = r.autoInsertSpace) != null ? D : (x = o.value) == null ? void 0 : x.autoInsertSpace) != null ? S : !1;
    }), p = J(() => {
      var x;
      const D = (x = i.default) == null ? void 0 : x.call(i);
      if (h.value && (D == null ? void 0 : D.length) === 1) {
        const S = D[0];
        if ((S == null ? void 0 : S.type) === ng) {
          const C = S.children;
          return /^\p{Unified_Ideograph}{2}$/u.test(C);
        }
      }
      return !1;
    }), y = J(() => GB(`--el-color-${r.type}`).value), m = J(() => {
      let x = {};
      const D = r.color || y.value;
      if (D) {
        const S = new eA(D), C = S.shade(10).toString();
        if (r.plain)
          x = {
            "--el-button-bg-color": S.tint(90).toString(),
            "--el-button-text-color": D,
            "--el-button-hover-text-color": "var(--el-color-white)",
            "--el-button-hover-bg-color": D,
            "--el-button-hover-border-color": D,
            "--el-button-active-bg-color": C,
            "--el-button-active-text-color": "var(--el-color-white)",
            "--el-button-active-border-color": C
          };
        else {
          const v = S.tint(20).toString();
          x = {
            "--el-button-bg-color": D,
            "--el-button-border-color": D,
            "--el-button-hover-bg-color": v,
            "--el-button-hover-border-color": v,
            "--el-button-active-bg-color": C,
            "--el-button-active-border-color": C
          };
        }
        if (c.value) {
          const v = S.tint(50).toString();
          x["--el-button-disabled-bg-color"] = v, x["--el-button-disabled-border-color"] = v;
        }
      }
      return x;
    }), b = (x) => {
      r.nativeType === "reset" && (l == null || l.resetFields()), n("click", x);
    };
    return t({
      ref: f,
      size: u,
      type: d,
      disabled: c,
      shouldAddSpace: p
    }), (x, D) => (P(), L("button", {
      ref_key: "_ref",
      ref: f,
      class: se([
        E(s).b(),
        E(s).m(E(d)),
        E(s).m(E(u)),
        E(s).is("disabled", E(c)),
        E(s).is("loading", x.loading),
        E(s).is("plain", x.plain),
        E(s).is("round", x.round),
        E(s).is("circle", x.circle)
      ]),
      disabled: E(c) || x.loading,
      autofocus: x.autofocus,
      type: x.nativeType,
      style: Pt(E(m)),
      onClick: b
    }, [
      x.loading ? (P(), L(nt, { key: 0 }, [
        x.$slots.loading ? tt(x.$slots, "loading", { key: 0 }) : (P(), ue(E(qt), {
          key: 1,
          class: se(E(s).is("loading"))
        }, {
          default: N(() => [
            (P(), ue(Ln(x.loadingIcon)))
          ]),
          _: 1
        }, 8, ["class"]))
      ], 2112)) : x.icon ? (P(), ue(E(qt), { key: 1 }, {
        default: N(() => [
          (P(), ue(Ln(x.icon)))
        ]),
        _: 1
      })) : re("v-if", !0),
      x.$slots.default ? (P(), L("span", {
        key: 2,
        class: se({ [E(s).em("text", "expand")]: E(p) })
      }, [
        tt(x.$slots, "default")
      ], 2)) : re("v-if", !0)
    ], 14, OU));
  }
}), MU = {
  size: j8.size,
  type: j8.type
}, HU = Ee({
  name: "ElButtonGroup",
  props: MU,
  setup(e) {
    return _t(mb, zt({
      size: er(e, "size"),
      type: er(e, "type")
    })), {
      ns: Ct("button")
    };
  }
});
function IU(e, t, n, r, i, a) {
  return P(), L("div", {
    class: se(`${e.ns.b("group")}`)
  }, [
    tt(e.$slots, "default")
  ], 2);
}
var tA = /* @__PURE__ */ vt(HU, [["render", IU]]);
const fn = Un(DU, {
  ButtonGroup: tA
});
Wi(tA);
var nA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r, i) {
      var a = r.prototype, o = function(f) {
        return f && (f.indexOf ? f : f.s);
      }, s = function(f, d, h, p, y) {
        var m = f.name ? f : f.$locale(), b = o(m[d]), x = o(m[h]), D = b || x.map(function(C) {
          return C.slice(0, p);
        });
        if (!y)
          return D;
        var S = m.weekStart;
        return D.map(function(C, v) {
          return D[(v + (S || 0)) % 7];
        });
      }, l = function() {
        return i.Ls[i.locale()];
      }, u = function(f, d) {
        return f.formats[d] || function(h) {
          return h.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(p, y, m) {
            return y || m.slice(1);
          });
        }(f.formats[d.toUpperCase()]);
      }, c = function() {
        var f = this;
        return { months: function(d) {
          return d ? d.format("MMMM") : s(f, "months");
        }, monthsShort: function(d) {
          return d ? d.format("MMM") : s(f, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return f.$locale().weekStart || 0;
        }, weekdays: function(d) {
          return d ? d.format("dddd") : s(f, "weekdays");
        }, weekdaysMin: function(d) {
          return d ? d.format("dd") : s(f, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(d) {
          return d ? d.format("ddd") : s(f, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(d) {
          return u(f.$locale(), d);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      a.localeData = function() {
        return c.bind(this)();
      }, i.localeData = function() {
        var f = l();
        return { firstDayOfWeek: function() {
          return f.weekStart || 0;
        }, weekdays: function() {
          return i.weekdays();
        }, weekdaysShort: function() {
          return i.weekdaysShort();
        }, weekdaysMin: function() {
          return i.weekdaysMin();
        }, months: function() {
          return i.months();
        }, monthsShort: function() {
          return i.monthsShort();
        }, longDateFormat: function(d) {
          return u(f, d);
        }, meridiem: f.meridiem, ordinal: f.ordinal };
      }, i.months = function() {
        return s(l(), "months");
      }, i.monthsShort = function() {
        return s(l(), "monthsShort", "months", 3);
      }, i.weekdays = function(f) {
        return s(l(), "weekdays", null, null, f);
      }, i.weekdaysShort = function(f) {
        return s(l(), "weekdaysShort", "weekdays", 3, f);
      }, i.weekdaysMin = function(f) {
        return s(l(), "weekdaysMin", "weekdays", 2, f);
      };
    };
  });
})(nA);
const LU = nA.exports;
var iA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, a = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, l = function(y) {
      return (y = +y) + (y > 68 ? 1900 : 2e3);
    }, u = function(y) {
      return function(m) {
        this[y] = +m;
      };
    }, c = [/[+-]\d\d:?(\d\d)?|Z/, function(y) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z")
          return 0;
        var b = m.match(/([+-]|\d\d)/g), x = 60 * b[1] + (+b[2] || 0);
        return x === 0 ? 0 : b[0] === "+" ? -x : x;
      }(y);
    }], f = function(y) {
      var m = s[y];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, d = function(y, m) {
      var b, x = s.meridiem;
      if (x) {
        for (var D = 1; D <= 24; D += 1)
          if (y.indexOf(x(D, 0, m)) > -1) {
            b = D > 12;
            break;
          }
      } else
        b = y === (m ? "pm" : "PM");
      return b;
    }, h = { A: [o, function(y) {
      this.afternoon = d(y, !1);
    }], a: [o, function(y) {
      this.afternoon = d(y, !0);
    }], S: [/\d/, function(y) {
      this.milliseconds = 100 * +y;
    }], SS: [i, function(y) {
      this.milliseconds = 10 * +y;
    }], SSS: [/\d{3}/, function(y) {
      this.milliseconds = +y;
    }], s: [a, u("seconds")], ss: [a, u("seconds")], m: [a, u("minutes")], mm: [a, u("minutes")], H: [a, u("hours")], h: [a, u("hours")], HH: [a, u("hours")], hh: [a, u("hours")], D: [a, u("day")], DD: [i, u("day")], Do: [o, function(y) {
      var m = s.ordinal, b = y.match(/\d+/);
      if (this.day = b[0], m)
        for (var x = 1; x <= 31; x += 1)
          m(x).replace(/\[|\]/g, "") === y && (this.day = x);
    }], M: [a, u("month")], MM: [i, u("month")], MMM: [o, function(y) {
      var m = f("months"), b = (f("monthsShort") || m.map(function(x) {
        return x.slice(0, 3);
      })).indexOf(y) + 1;
      if (b < 1)
        throw new Error();
      this.month = b % 12 || b;
    }], MMMM: [o, function(y) {
      var m = f("months").indexOf(y) + 1;
      if (m < 1)
        throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, u("year")], YY: [i, function(y) {
      this.year = l(y);
    }], YYYY: [/\d{4}/, u("year")], Z: c, ZZ: c };
    function p(y) {
      var m, b;
      m = y, b = s && s.formats;
      for (var x = (y = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(R, F, K) {
        var q = K && K.toUpperCase();
        return F || b[K] || n[K] || b[q].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(G, te, Q) {
          return te || Q.slice(1);
        });
      })).match(r), D = x.length, S = 0; S < D; S += 1) {
        var C = x[S], v = h[C], H = v && v[0], V = v && v[1];
        x[S] = V ? { regex: H, parser: V } : C.replace(/^\[|\]$/g, "");
      }
      return function(R) {
        for (var F = {}, K = 0, q = 0; K < D; K += 1) {
          var G = x[K];
          if (typeof G == "string")
            q += G.length;
          else {
            var te = G.regex, Q = G.parser, Y = R.slice(q), Z = te.exec(Y)[0];
            Q.call(F, Z), R = R.replace(Z, "");
          }
        }
        return function(oe) {
          var he = oe.afternoon;
          if (he !== void 0) {
            var Ae = oe.hours;
            he ? Ae < 12 && (oe.hours += 12) : Ae === 12 && (oe.hours = 0), delete oe.afternoon;
          }
        }(F), F;
      };
    }
    return function(y, m, b) {
      b.p.customParseFormat = !0, y && y.parseTwoDigitYear && (l = y.parseTwoDigitYear);
      var x = m.prototype, D = x.parse;
      x.parse = function(S) {
        var C = S.date, v = S.utc, H = S.args;
        this.$u = v;
        var V = H[1];
        if (typeof V == "string") {
          var R = H[2] === !0, F = H[3] === !0, K = R || F, q = H[2];
          F && (q = H[2]), s = this.$locale(), !R && q && (s = b.Ls[q]), this.$d = function(Y, Z, oe) {
            try {
              if (["x", "X"].indexOf(Z) > -1)
                return new Date((Z === "X" ? 1e3 : 1) * Y);
              var he = p(Z)(Y), Ae = he.year, We = he.month, ke = he.day, Re = he.hours, ve = he.minutes, Ye = he.seconds, Qe = he.milliseconds, ot = he.zone, Ve = new Date(), Te = ke || (Ae || We ? 1 : Ve.getDate()), Me = Ae || Ve.getFullYear(), Je = 0;
              Ae && !We || (Je = We > 0 ? We - 1 : Ve.getMonth());
              var mt = Re || 0, It = ve || 0, ln = Ye || 0, gt = Qe || 0;
              return ot ? new Date(Date.UTC(Me, Je, Te, mt, It, ln, gt + 60 * ot.offset * 1e3)) : oe ? new Date(Date.UTC(Me, Je, Te, mt, It, ln, gt)) : new Date(Me, Je, Te, mt, It, ln, gt);
            } catch {
              return new Date("");
            }
          }(C, V, v), this.init(), q && q !== !0 && (this.$L = this.locale(q).$L), K && C != this.format(V) && (this.$d = new Date("")), s = {};
        } else if (V instanceof Array)
          for (var G = V.length, te = 1; te <= G; te += 1) {
            H[1] = V[te - 1];
            var Q = b.apply(this, H);
            if (Q.isValid()) {
              this.$d = Q.$d, this.$L = Q.$L, this.init();
              break;
            }
            te === G && (this.$d = new Date(""));
          }
        else
          D.call(this, S);
      };
    };
  });
})(iA);
const BU = iA.exports, Z5 = "HH:mm:ss", rd = "YYYY-MM-DD", NU = {
  date: rd,
  week: "gggg[w]ww",
  year: "YYYY",
  month: "YYYY-MM",
  datetime: `${rd} ${Z5}`,
  monthrange: "YYYY-MM",
  daterange: rd,
  datetimerange: `${rd} ${Z5}`
}, rA = {
  id: {
    type: [Array, String]
  },
  name: {
    type: [Array, String],
    default: ""
  },
  popperClass: {
    type: String,
    default: ""
  },
  format: {
    type: String
  },
  valueFormat: {
    type: String
  },
  type: {
    type: String,
    default: ""
  },
  clearable: {
    type: Boolean,
    default: !0
  },
  clearIcon: {
    type: [String, Object],
    default: Hs
  },
  editable: {
    type: Boolean,
    default: !0
  },
  prefixIcon: {
    type: [String, Object],
    default: ""
  },
  size: {
    type: String,
    validator: fo
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  placeholder: {
    type: String,
    default: ""
  },
  popperOptions: {
    type: Object,
    default: () => ({})
  },
  modelValue: {
    type: [Date, Array, String, Number],
    default: ""
  },
  rangeSeparator: {
    type: String,
    default: "-"
  },
  startPlaceholder: String,
  endPlaceholder: String,
  defaultValue: {
    type: [Date, Array]
  },
  defaultTime: {
    type: [Date, Array]
  },
  isRange: {
    type: Boolean,
    default: !1
  },
  disabledHours: {
    type: Function
  },
  disabledMinutes: {
    type: Function
  },
  disabledSeconds: {
    type: Function
  },
  disabledDate: {
    type: Function
  },
  cellClassName: {
    type: Function
  },
  shortcuts: {
    type: Array,
    default: () => []
  },
  arrowControl: {
    type: Boolean,
    default: !1
  },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  unlinkPanels: Boolean
}, J5 = function(e, t) {
  const n = e instanceof Date, r = t instanceof Date;
  return n && r ? e.getTime() === t.getTime() : !n && !r ? e === t : !1;
}, $5 = function(e, t) {
  const n = e instanceof Array, r = t instanceof Array;
  return n && r ? e.length !== t.length ? !1 : e.every((i, a) => J5(i, t[a])) : !n && !r ? J5(e, t) : !1;
}, e7 = function(e, t, n) {
  const r = Fd(t) || t === "x" ? Ut(e).locale(n) : Ut(e, t).locale(n);
  return r.isValid() ? r : void 0;
}, t7 = function(e, t, n) {
  return Fd(t) ? e : t === "x" ? +e : Ut(e).locale(n).format(t);
}, jU = Ee({
  name: "Picker",
  components: {
    ElInput: ti,
    ElTooltip: Ki,
    ElIcon: qt
  },
  props: rA,
  emits: [
    "update:modelValue",
    "change",
    "focus",
    "blur",
    "calendar-change",
    "panel-change",
    "visible-change"
  ],
  setup(e, t) {
    const { lang: n } = hi(), r = ce(Pa, {}), i = ce(ts, {}), a = ce("ElPopperOptions", {}), o = j(), s = j(), l = j(!1), u = j(!1), c = j(null);
    Ne(l, (He) => {
      var Le;
      He ? c.value = e.modelValue : (ve.value = null, bt(() => {
        f(e.modelValue);
      }), t.emit("blur"), Qe(), e.validateEvent && ((Le = i.validate) == null || Le.call(i, "blur")));
    });
    const f = (He, Le) => {
      var ct;
      (Le || !$5(He, c.value)) && (t.emit("change", He), e.validateEvent && ((ct = i.validate) == null || ct.call(i, "change")));
    }, d = (He) => {
      if (!$5(e.modelValue, He)) {
        let Le;
        Array.isArray(He) ? Le = He.map((ct) => t7(ct, e.valueFormat, n.value)) : He && (Le = t7(He, e.valueFormat, n.value)), t.emit("update:modelValue", He && Le, n.value);
      }
    }, h = J(() => {
      if (s.value) {
        const He = he.value ? s.value : s.value.$el;
        return Array.from(He.querySelectorAll("input"));
      }
      return [];
    }), p = J(() => h == null ? void 0 : h.value[0]), y = J(() => h == null ? void 0 : h.value[1]), m = (He, Le, ct) => {
      const Qt = h.value;
      !Qt.length || (!ct || ct === "min" ? (Qt[0].setSelectionRange(He, Le), Qt[0].focus()) : ct === "max" && (Qt[1].setSelectionRange(He, Le), Qt[1].focus()));
    }, b = (He = "", Le = !1) => {
      l.value = Le;
      let ct;
      Array.isArray(He) ? ct = He.map((Qt) => Qt.toDate()) : ct = He && He.toDate(), ve.value = null, d(ct);
    }, x = () => {
      u.value = !0, t.emit("visible-change", !0);
    }, D = () => {
      u.value = !1, t.emit("visible-change", !1);
    }, S = (He = !0) => {
      let Le = p.value;
      !He && he.value && (Le = y.value), Le && Le.focus();
    }, C = (He) => {
      e.readonly || H.value || l.value || (l.value = !0, t.emit("focus", He));
    }, v = () => {
      var He;
      (He = o.value) == null || He.onClose(), Qe();
    }, H = J(() => e.disabled || r.disabled), V = J(() => {
      let He;
      if (Y.value ? Pe.value.getDefaultValue && (He = Pe.value.getDefaultValue()) : Array.isArray(e.modelValue) ? He = e.modelValue.map((Le) => e7(Le, e.valueFormat, n.value)) : He = e7(e.modelValue, e.valueFormat, n.value), Pe.value.getRangeAvailableTime) {
        const Le = Pe.value.getRangeAvailableTime(He);
        ja(Le, He) || (He = Le, d(Array.isArray(He) ? He.map((ct) => ct.toDate()) : He.toDate()));
      }
      return Array.isArray(He) && He.some((Le) => !Le) && (He = []), He;
    }), R = J(() => {
      if (!Pe.value.panelReady)
        return;
      const He = Ve(V.value);
      if (Array.isArray(ve.value))
        return [
          ve.value[0] || He && He[0] || "",
          ve.value[1] || He && He[1] || ""
        ];
      if (ve.value !== null)
        return ve.value;
      if (!(!K.value && Y.value) && !(!l.value && Y.value))
        return He ? q.value ? He.join(", ") : He : "";
    }), F = J(() => e.type.includes("time")), K = J(() => e.type.startsWith("time")), q = J(() => e.type === "dates"), G = J(() => e.prefixIcon || (F.value ? Aj : jN)), te = j(!1), Q = (He) => {
      e.readonly || H.value || te.value && (He.stopPropagation(), d(null), f(null, !0), te.value = !1, l.value = !1, Pe.value.handleClear && Pe.value.handleClear());
    }, Y = J(() => !e.modelValue || Array.isArray(e.modelValue) && !e.modelValue.length), Z = () => {
      e.readonly || H.value || !Y.value && e.clearable && (te.value = !0);
    }, oe = () => {
      te.value = !1;
    }, he = J(() => e.type.indexOf("range") > -1), Ae = Bi(), We = J(() => {
      var He, Le;
      return (Le = (He = o.value) == null ? void 0 : He.popperRef) == null ? void 0 : Le.contentRef;
    }), ke = J(() => {
      var He, Le;
      return (Le = (He = E(o)) == null ? void 0 : He.popperRef) == null ? void 0 : Le.contentRef;
    }), Re = J(() => {
      var He;
      return E(he) ? E(s) : (He = E(s)) == null ? void 0 : He.$el;
    });
    T8(Re, (He) => {
      const Le = E(ke), ct = E(Re);
      Le && (He.target === Le || He.composedPath().includes(Le)) || He.target === ct || He.composedPath().includes(ct) || (l.value = !1);
    });
    const ve = j(null), Ye = () => {
      if (ve.value) {
        const He = ot(R.value);
        He && Te(He) && (d(Array.isArray(He) ? He.map((Le) => Le.toDate()) : He.toDate()), ve.value = null);
      }
      ve.value === "" && (d(null), f(null), ve.value = null);
    }, Qe = () => {
      h.value.forEach((He) => He.blur());
    }, ot = (He) => He ? Pe.value.parseUserInput(He) : null, Ve = (He) => He ? Pe.value.formatToString(He) : null, Te = (He) => Pe.value.isValidValue(He), Me = (He) => {
      const Le = He.code;
      if (Le === yt.esc) {
        l.value = !1, He.stopPropagation();
        return;
      }
      if (Le === yt.tab) {
        he.value ? setTimeout(() => {
          h.value.indexOf(document.activeElement) === -1 && (l.value = !1, Qe());
        }, 0) : (Ye(), l.value = !1, He.stopPropagation());
        return;
      }
      if (Le === yt.enter || Le === yt.numpadEnter) {
        (ve.value === null || ve.value === "" || Te(ot(R.value))) && (Ye(), l.value = !1), He.stopPropagation();
        return;
      }
      if (ve.value) {
        He.stopPropagation();
        return;
      }
      Pe.value.handleKeydown && Pe.value.handleKeydown(He);
    }, Je = (He) => {
      ve.value = He;
    }, mt = (He) => {
      ve.value ? ve.value = [He.target.value, ve.value[1]] : ve.value = [He.target.value, null];
    }, It = (He) => {
      ve.value ? ve.value = [ve.value[0], He.target.value] : ve.value = [null, He.target.value];
    }, ln = () => {
      const He = ot(ve.value && ve.value[0]);
      if (He && He.isValid()) {
        ve.value = [Ve(He), R.value[1]];
        const Le = [He, V.value && V.value[1]];
        Te(Le) && (d(Le), ve.value = null);
      }
    }, gt = () => {
      const He = ot(ve.value && ve.value[1]);
      if (He && He.isValid()) {
        ve.value = [R.value[0], Ve(He)];
        const Le = [V.value && V.value[0], He];
        Te(Le) && (d(Le), ve.value = null);
      }
    }, Pe = j({}), $e = (He) => {
      Pe.value[He[0]] = He[1], Pe.value.panelReady = !0;
    }, Ke = (He) => {
      t.emit("calendar-change", He);
    }, lt = (He, Le, ct) => {
      t.emit("panel-change", He, Le, ct);
    };
    return _t("EP_PICKER_BASE", {
      props: e
    }), {
      elPopperOptions: a,
      isDatesPicker: q,
      handleEndChange: gt,
      handleStartChange: ln,
      handleStartInput: mt,
      handleEndInput: It,
      onUserInput: Je,
      handleChange: Ye,
      handleKeydown: Me,
      popperPaneRef: We,
      onClickOutside: T8,
      pickerSize: Ae,
      isRangeInput: he,
      onMouseLeave: oe,
      onMouseEnter: Z,
      onClearIconClick: Q,
      showClose: te,
      triggerIcon: G,
      onPick: b,
      handleFocus: C,
      handleBlur: v,
      pickerVisible: l,
      pickerActualVisible: u,
      displayValue: R,
      parsedValue: V,
      setSelectionRange: m,
      refPopper: o,
      inputRef: s,
      pickerDisabled: H,
      onSetPickerOption: $e,
      onCalendarChange: Ke,
      onPanelChange: lt,
      focus: S,
      onShow: x,
      onHide: D
    };
  }
}), FU = ["id", "name", "placeholder", "value", "disabled", "readonly"], XU = { class: "el-range-separator" }, RU = ["id", "name", "placeholder", "value", "disabled", "readonly"];
function VU(e, t, n, r, i, a) {
  const o = Ie("el-icon"), s = Ie("el-input"), l = Ie("el-tooltip");
  return P(), ue(l, $r({
    ref: "refPopper",
    visible: e.pickerVisible,
    "onUpdate:visible": t[17] || (t[17] = (u) => e.pickerVisible = u),
    effect: "light",
    pure: "",
    trigger: "click"
  }, e.$attrs, {
    "append-to-body": "",
    transition: "el-zoom-in-top",
    "popper-class": `el-picker__popper ${e.popperClass}`,
    "popper-options": e.elPopperOptions,
    "fallback-placements": ["bottom", "top", "right", "left"],
    "gpu-acceleration": !1,
    "stop-popper-mouse-event": !1,
    "hide-after": 0,
    persistent: "",
    onShow: e.onShow,
    onHide: e.onHide
  }), {
    default: N(() => [
      e.isRangeInput ? (P(), L("div", {
        key: 1,
        ref: "inputRef",
        class: se(["el-date-editor el-range-editor el-input__inner", [
          "el-date-editor--" + e.type,
          e.pickerSize ? `el-range-editor--${e.pickerSize}` : "",
          e.pickerDisabled ? "is-disabled" : "",
          e.pickerVisible ? "is-active" : "",
          e.$attrs.class || void 0
        ]]),
        style: Pt(e.$attrs.style || void 0),
        onClick: t[7] || (t[7] = (...u) => e.handleFocus && e.handleFocus(...u)),
        onMouseenter: t[8] || (t[8] = (...u) => e.onMouseEnter && e.onMouseEnter(...u)),
        onMouseleave: t[9] || (t[9] = (...u) => e.onMouseLeave && e.onMouseLeave(...u)),
        onKeydown: t[10] || (t[10] = (...u) => e.handleKeydown && e.handleKeydown(...u))
      }, [
        e.triggerIcon ? (P(), ue(o, {
          key: 0,
          class: "el-input__icon el-range__icon",
          onClick: e.handleFocus
        }, {
          default: N(() => [
            (P(), ue(Ln(e.triggerIcon)))
          ]),
          _: 1
        }, 8, ["onClick"])) : re("v-if", !0),
        T("input", {
          id: e.id && e.id[0],
          autocomplete: "off",
          name: e.name && e.name[0],
          placeholder: e.startPlaceholder,
          value: e.displayValue && e.displayValue[0],
          disabled: e.pickerDisabled,
          readonly: !e.editable || e.readonly,
          class: "el-range-input",
          onInput: t[1] || (t[1] = (...u) => e.handleStartInput && e.handleStartInput(...u)),
          onChange: t[2] || (t[2] = (...u) => e.handleStartChange && e.handleStartChange(...u)),
          onFocus: t[3] || (t[3] = (...u) => e.handleFocus && e.handleFocus(...u))
        }, null, 40, FU),
        tt(e.$slots, "range-separator", {}, () => [
          T("span", XU, de(e.rangeSeparator), 1)
        ]),
        T("input", {
          id: e.id && e.id[1],
          autocomplete: "off",
          name: e.name && e.name[1],
          placeholder: e.endPlaceholder,
          value: e.displayValue && e.displayValue[1],
          disabled: e.pickerDisabled,
          readonly: !e.editable || e.readonly,
          class: "el-range-input",
          onFocus: t[4] || (t[4] = (...u) => e.handleFocus && e.handleFocus(...u)),
          onInput: t[5] || (t[5] = (...u) => e.handleEndInput && e.handleEndInput(...u)),
          onChange: t[6] || (t[6] = (...u) => e.handleEndChange && e.handleEndChange(...u))
        }, null, 40, RU),
        e.clearIcon ? (P(), ue(o, {
          key: 1,
          class: se(["el-input__icon el-range__close-icon", {
            "el-range__close-icon--hidden": !e.showClose
          }]),
          onClick: e.onClearIconClick
        }, {
          default: N(() => [
            (P(), ue(Ln(e.clearIcon)))
          ]),
          _: 1
        }, 8, ["class", "onClick"])) : re("v-if", !0)
      ], 38)) : (P(), ue(s, {
        key: 0,
        id: e.id,
        ref: "inputRef",
        "model-value": e.displayValue,
        name: e.name,
        size: e.pickerSize,
        disabled: e.pickerDisabled,
        placeholder: e.placeholder,
        class: se(["el-date-editor", ["el-date-editor--" + e.type, e.$attrs.class || void 0]]),
        style: Pt(e.$attrs.style || void 0),
        readonly: !e.editable || e.readonly || e.isDatesPicker || e.type === "week",
        onInput: e.onUserInput,
        onFocus: e.handleFocus,
        onKeydown: e.handleKeydown,
        onChange: e.handleChange,
        onMouseenter: e.onMouseEnter,
        onMouseleave: e.onMouseLeave,
        onClick: t[0] || (t[0] = wt(() => {
        }, ["stop"]))
      }, {
        prefix: N(() => [
          e.triggerIcon ? (P(), ue(o, {
            key: 0,
            class: "el-input__icon",
            onClick: e.handleFocus
          }, {
            default: N(() => [
              (P(), ue(Ln(e.triggerIcon)))
            ]),
            _: 1
          }, 8, ["onClick"])) : re("v-if", !0)
        ]),
        suffix: N(() => [
          e.showClose && e.clearIcon ? (P(), ue(o, {
            key: 0,
            class: "el-input__icon clear-icon",
            onClick: e.onClearIconClick
          }, {
            default: N(() => [
              (P(), ue(Ln(e.clearIcon)))
            ]),
            _: 1
          }, 8, ["onClick"])) : re("v-if", !0)
        ]),
        _: 1
      }, 8, ["id", "model-value", "name", "size", "disabled", "placeholder", "class", "style", "readonly", "onInput", "onFocus", "onKeydown", "onChange", "onMouseenter", "onMouseleave"]))
    ]),
    content: N(() => [
      tt(e.$slots, "default", {
        visible: e.pickerVisible,
        actualVisible: e.pickerActualVisible,
        parsedValue: e.parsedValue,
        format: e.format,
        unlinkPanels: e.unlinkPanels,
        type: e.type,
        defaultValue: e.defaultValue,
        onPick: t[11] || (t[11] = (...u) => e.onPick && e.onPick(...u)),
        onSelectRange: t[12] || (t[12] = (...u) => e.setSelectionRange && e.setSelectionRange(...u)),
        onSetPickerOption: t[13] || (t[13] = (...u) => e.onSetPickerOption && e.onSetPickerOption(...u)),
        onCalendarChange: t[14] || (t[14] = (...u) => e.onCalendarChange && e.onCalendarChange(...u)),
        onPanelChange: t[15] || (t[15] = (...u) => e.onPanelChange && e.onPanelChange(...u)),
        onMousedown: t[16] || (t[16] = wt(() => {
        }, ["stop"]))
      })
    ]),
    _: 3
  }, 16, ["visible", "popper-class", "popper-options", "onShow", "onHide"]);
}
var UU = /* @__PURE__ */ vt(jU, [["render", VU]]);
const pp = (e, t, n) => {
  const r = [], i = t && n();
  for (let a = 0; a < e; a++)
    r[a] = i ? i.includes(a) : !1;
  return r;
}, vp = (e) => e.map((t, n) => t || n).filter((t) => t !== !0), aA = (e, t, n) => ({
  getHoursList: (o, s) => pp(24, e, () => e(o, s)),
  getMinutesList: (o, s, l) => pp(60, t, () => t(o, s, l)),
  getSecondsList: (o, s, l, u) => pp(60, n, () => n(o, s, l, u))
}), qU = (e, t, n) => {
  const { getHoursList: r, getMinutesList: i, getSecondsList: a } = aA(e, t, n);
  return {
    getAvailableHours: (u, c) => vp(r(u, c)),
    getAvailableMinutes: (u, c, f) => vp(i(u, c, f)),
    getAvailableSeconds: (u, c, f, d) => vp(a(u, c, f, d))
  };
}, _U = (e) => {
  const t = j(e.parsedValue);
  return Ne(() => e.visible, (n) => {
    n || (t.value = e.parsedValue);
  }), t;
}, WU = Ee({
  directives: {
    repeatClick: Eb
  },
  components: {
    ElScrollbar: ns,
    ElIcon: qt,
    ArrowUp: uf,
    ArrowDown: vc
  },
  props: {
    role: {
      type: String,
      required: !0
    },
    spinnerDate: {
      type: Object,
      required: !0
    },
    showSeconds: {
      type: Boolean,
      default: !0
    },
    arrowControl: Boolean,
    amPmMode: {
      type: String,
      default: ""
    },
    disabledHours: {
      type: Function
    },
    disabledMinutes: {
      type: Function
    },
    disabledSeconds: {
      type: Function
    }
  },
  emits: ["change", "select-range", "set-option"],
  setup(e, t) {
    let n = !1;
    const r = qa((ve) => {
      n = !1, V(ve);
    }, 200), i = j(null), a = j(null), o = j(null), s = j(null), l = {
      hours: a,
      minutes: o,
      seconds: s
    }, u = J(() => {
      const ve = ["hours", "minutes", "seconds"];
      return e.showSeconds ? ve : ve.slice(0, 2);
    }), c = J(() => e.spinnerDate.hour()), f = J(() => e.spinnerDate.minute()), d = J(() => e.spinnerDate.second()), h = J(() => ({
      hours: c,
      minutes: f,
      seconds: d
    })), p = J(() => We(e.role)), y = J(() => ke(c.value, e.role)), m = J(() => Re(c.value, f.value, e.role)), b = J(() => ({
      hours: p,
      minutes: y,
      seconds: m
    })), x = J(() => {
      const ve = c.value;
      return [
        ve > 0 ? ve - 1 : void 0,
        ve,
        ve < 23 ? ve + 1 : void 0
      ];
    }), D = J(() => {
      const ve = f.value;
      return [
        ve > 0 ? ve - 1 : void 0,
        ve,
        ve < 59 ? ve + 1 : void 0
      ];
    }), S = J(() => {
      const ve = d.value;
      return [
        ve > 0 ? ve - 1 : void 0,
        ve,
        ve < 59 ? ve + 1 : void 0
      ];
    }), C = J(() => ({
      hours: x,
      minutes: D,
      seconds: S
    })), v = (ve) => {
      if (!!!e.amPmMode)
        return "";
      const Qe = e.amPmMode === "A";
      let ot = ve < 12 ? " am" : " pm";
      return Qe && (ot = ot.toUpperCase()), ot;
    }, H = (ve) => {
      ve === "hours" ? t.emit("select-range", 0, 2) : ve === "minutes" ? t.emit("select-range", 3, 5) : ve === "seconds" && t.emit("select-range", 6, 8), i.value = ve;
    }, V = (ve) => {
      F(ve, h.value[ve].value);
    }, R = () => {
      V("hours"), V("minutes"), V("seconds");
    }, F = (ve, Ye) => {
      if (e.arrowControl)
        return;
      const Qe = l[ve];
      Qe && Qe.$el && (Qe.$el.querySelector(".el-scrollbar__wrap").scrollTop = Math.max(0, Ye * K(ve)));
    }, K = (ve) => l[ve].$el.querySelector("li").offsetHeight, q = () => {
      te(1);
    }, G = () => {
      te(-1);
    }, te = (ve) => {
      i.value || H("hours");
      const Ye = i.value;
      let Qe = h.value[Ye].value;
      const ot = i.value === "hours" ? 24 : 60;
      Qe = (Qe + ve + ot) % ot, Q(Ye, Qe), F(Ye, Qe), bt(() => H(i.value));
    }, Q = (ve, Ye) => {
      if (!b.value[ve].value[Ye])
        switch (ve) {
          case "hours":
            t.emit("change", e.spinnerDate.hour(Ye).minute(f.value).second(d.value));
            break;
          case "minutes":
            t.emit("change", e.spinnerDate.hour(c.value).minute(Ye).second(d.value));
            break;
          case "seconds":
            t.emit("change", e.spinnerDate.hour(c.value).minute(f.value).second(Ye));
            break;
        }
    }, Y = (ve, { value: Ye, disabled: Qe }) => {
      Qe || (Q(ve, Ye), H(ve), F(ve, Ye));
    }, Z = (ve) => {
      n = !0, r(ve);
      const Ye = Math.min(Math.round((l[ve].$el.querySelector(".el-scrollbar__wrap").scrollTop - (oe(ve) * 0.5 - 10) / K(ve) + 3) / K(ve)), ve === "hours" ? 23 : 59);
      Q(ve, Ye);
    }, oe = (ve) => l[ve].$el.offsetHeight, he = () => {
      const ve = (Ye) => {
        l[Ye] && l[Ye].$el && (l[Ye].$el.querySelector(".el-scrollbar__wrap").onscroll = () => {
          Z(Ye);
        });
      };
      ve("hours"), ve("minutes"), ve("seconds");
    };
    rn(() => {
      bt(() => {
        !e.arrowControl && he(), R(), e.role === "start" && H("hours");
      });
    });
    const Ae = (ve, Ye) => {
      l[Ye] = ve;
    };
    t.emit("set-option", [`${e.role}_scrollDown`, te]), t.emit("set-option", [`${e.role}_emitSelectRange`, H]);
    const { getHoursList: We, getMinutesList: ke, getSecondsList: Re } = aA(e.disabledHours, e.disabledMinutes, e.disabledSeconds);
    return Ne(() => e.spinnerDate, () => {
      n || R();
    }), {
      setRef: Ae,
      spinnerItems: u,
      currentScrollbar: i,
      hours: c,
      minutes: f,
      seconds: d,
      hoursList: p,
      minutesList: y,
      arrowHourList: x,
      arrowMinuteList: D,
      arrowSecondList: S,
      getAmPmFlag: v,
      emitSelectRange: H,
      adjustCurrentSpinner: V,
      typeItemHeight: K,
      listHoursRef: a,
      listMinutesRef: o,
      listSecondsRef: s,
      onIncreaseClick: q,
      onDecreaseClick: G,
      handleClick: Y,
      secondsList: m,
      timePartsMap: h,
      arrowListMap: C,
      listMap: b
    };
  }
}), KU = ["onClick"], GU = ["onMouseenter"], YU = { class: "el-time-spinner__list" };
function QU(e, t, n, r, i, a) {
  const o = Ie("el-scrollbar"), s = Ie("arrow-up"), l = Ie("el-icon"), u = Ie("arrow-down"), c = va("repeat-click");
  return P(), L("div", {
    class: se(["el-time-spinner", { "has-seconds": e.showSeconds }])
  }, [
    e.arrowControl ? re("v-if", !0) : (P(!0), L(nt, { key: 0 }, Lt(e.spinnerItems, (f) => (P(), ue(o, {
      key: f,
      ref_for: !0,
      ref: (d) => e.setRef(d, f),
      class: "el-time-spinner__wrapper",
      "wrap-style": "max-height: inherit;",
      "view-class": "el-time-spinner__list",
      noresize: "",
      tag: "ul",
      onMouseenter: (d) => e.emitSelectRange(f),
      onMousemove: (d) => e.adjustCurrentSpinner(f)
    }, {
      default: N(() => [
        (P(!0), L(nt, null, Lt(e.listMap[f].value, (d, h) => (P(), L("li", {
          key: h,
          class: se(["el-time-spinner__item", { active: h === e.timePartsMap[f].value, disabled: d }]),
          onClick: (p) => e.handleClick(f, { value: h, disabled: d })
        }, [
          f === "hours" ? (P(), L(nt, { key: 0 }, [
            je(de(("0" + (e.amPmMode ? h % 12 || 12 : h)).slice(-2)) + de(e.getAmPmFlag(h)), 1)
          ], 2112)) : (P(), L(nt, { key: 1 }, [
            je(de(("0" + h).slice(-2)), 1)
          ], 2112))
        ], 10, KU))), 128))
      ]),
      _: 2
    }, 1032, ["onMouseenter", "onMousemove"]))), 128)),
    e.arrowControl ? (P(!0), L(nt, { key: 1 }, Lt(e.spinnerItems, (f) => (P(), L("div", {
      key: f,
      class: "el-time-spinner__wrapper is-arrow",
      onMouseenter: (d) => e.emitSelectRange(f)
    }, [
      Bt((P(), ue(l, { class: "el-time-spinner__arrow arrow-up" }, {
        default: N(() => [
          B(s)
        ]),
        _: 1
      })), [
        [c, e.onDecreaseClick]
      ]),
      Bt((P(), ue(l, { class: "el-time-spinner__arrow arrow-down" }, {
        default: N(() => [
          B(u)
        ]),
        _: 1
      })), [
        [c, e.onIncreaseClick]
      ]),
      T("ul", YU, [
        (P(!0), L(nt, null, Lt(e.arrowListMap[f].value, (d, h) => (P(), L("li", {
          key: h,
          class: se(["el-time-spinner__item", {
            active: d === e.timePartsMap[f].value,
            disabled: e.listMap[f].value[d]
          }])
        }, [
          typeof d == "number" ? (P(), L(nt, { key: 0 }, [
            f === "hours" ? (P(), L(nt, { key: 0 }, [
              je(de(("0" + (e.amPmMode ? d % 12 || 12 : d)).slice(-2)) + de(e.getAmPmFlag(d)), 1)
            ], 2112)) : (P(), L(nt, { key: 1 }, [
              je(de(("0" + d).slice(-2)), 1)
            ], 2112))
          ], 2112)) : re("v-if", !0)
        ], 2))), 128))
      ])
    ], 40, GU))), 128)) : re("v-if", !0)
  ], 2);
}
var ZU = /* @__PURE__ */ vt(WU, [["render", QU]]);
const JU = Ee({
  components: {
    TimeSpinner: ZU
  },
  props: {
    visible: Boolean,
    actualVisible: {
      type: Boolean,
      default: void 0
    },
    datetimeRole: {
      type: String
    },
    parsedValue: {
      type: [Object, String]
    },
    format: {
      type: String,
      default: ""
    }
  },
  emits: ["pick", "select-range", "set-picker-option"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = j([0, 2]), a = _U(e), o = J(() => e.actualVisible === void 0 ? "el-zoom-in-top" : ""), s = J(() => e.format.includes("ss")), l = J(() => e.format.includes("A") ? "A" : e.format.includes("a") ? "a" : ""), u = (Q) => {
      const Y = Ut(Q).locale(r.value), Z = m(Y);
      return Y.isSame(Z);
    }, c = () => {
      t.emit("pick", a.value, !1);
    }, f = (Q = !1, Y = !1) => {
      Y || t.emit("pick", e.parsedValue, Q);
    }, d = (Q) => {
      if (!e.visible)
        return;
      const Y = m(Q).millisecond(0);
      t.emit("pick", Y, !0);
    }, h = (Q, Y) => {
      t.emit("select-range", Q, Y), i.value = [Q, Y];
    }, p = (Q) => {
      const Y = [0, 3].concat(s.value ? [6] : []), Z = ["hours", "minutes"].concat(s.value ? ["seconds"] : []), he = (Y.indexOf(i.value[0]) + Q + Y.length) % Y.length;
      S.start_emitSelectRange(Z[he]);
    }, y = (Q) => {
      const Y = Q.code;
      if (Y === yt.left || Y === yt.right) {
        const Z = Y === yt.left ? -1 : 1;
        p(Z), Q.preventDefault();
        return;
      }
      if (Y === yt.up || Y === yt.down) {
        const Z = Y === yt.up ? -1 : 1;
        S.start_scrollDown(Z), Q.preventDefault();
        return;
      }
    }, m = (Q) => {
      const Y = {
        hour: q,
        minute: G,
        second: te
      };
      let Z = Q;
      return ["hour", "minute", "second"].forEach((oe) => {
        if (Y[oe]) {
          let he;
          const Ae = Y[oe];
          oe === "minute" ? he = Ae(Z.hour(), e.datetimeRole) : oe === "second" ? he = Ae(Z.hour(), Z.minute(), e.datetimeRole) : he = Ae(e.datetimeRole), he && he.length && !he.includes(Z[oe]()) && (Z = Z[oe](he[0]));
        }
      }), Z;
    }, b = (Q) => Q ? Ut(Q, e.format).locale(r.value) : null, x = (Q) => Q ? Q.format(e.format) : null, D = () => Ut(K).locale(r.value);
    t.emit("set-picker-option", ["isValidValue", u]), t.emit("set-picker-option", ["formatToString", x]), t.emit("set-picker-option", ["parseUserInput", b]), t.emit("set-picker-option", ["handleKeydown", y]), t.emit("set-picker-option", [
      "getRangeAvailableTime",
      m
    ]), t.emit("set-picker-option", ["getDefaultValue", D]);
    const S = {}, C = (Q) => {
      S[Q[0]] = Q[1];
    }, v = ce("EP_PICKER_BASE"), {
      arrowControl: H,
      disabledHours: V,
      disabledMinutes: R,
      disabledSeconds: F,
      defaultValue: K
    } = v.props, { getAvailableHours: q, getAvailableMinutes: G, getAvailableSeconds: te } = qU(V, R, F);
    return {
      transitionName: o,
      arrowControl: H,
      onSetOption: C,
      t: n,
      handleConfirm: f,
      handleChange: d,
      setSelectionRange: h,
      amPmMode: l,
      showSeconds: s,
      handleCancel: c,
      disabledHours: V,
      disabledMinutes: R,
      disabledSeconds: F
    };
  }
}), $U = {
  key: 0,
  class: "el-time-panel"
}, eq = { class: "el-time-panel__footer" };
function tq(e, t, n, r, i, a) {
  const o = Ie("time-spinner");
  return P(), ue(wa, { name: e.transitionName }, {
    default: N(() => [
      e.actualVisible || e.visible ? (P(), L("div", $U, [
        T("div", {
          class: se(["el-time-panel__content", { "has-seconds": e.showSeconds }])
        }, [
          B(o, {
            ref: "spinner",
            role: e.datetimeRole || "start",
            "arrow-control": e.arrowControl,
            "show-seconds": e.showSeconds,
            "am-pm-mode": e.amPmMode,
            "spinner-date": e.parsedValue,
            "disabled-hours": e.disabledHours,
            "disabled-minutes": e.disabledMinutes,
            "disabled-seconds": e.disabledSeconds,
            onChange: e.handleChange,
            onSetOption: e.onSetOption,
            onSelectRange: e.setSelectionRange
          }, null, 8, ["role", "arrow-control", "show-seconds", "am-pm-mode", "spinner-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "onChange", "onSetOption", "onSelectRange"])
        ], 2),
        T("div", eq, [
          T("button", {
            type: "button",
            class: "el-time-panel__btn cancel",
            onClick: t[0] || (t[0] = (...s) => e.handleCancel && e.handleCancel(...s))
          }, de(e.t("el.datepicker.cancel")), 1),
          T("button", {
            type: "button",
            class: "el-time-panel__btn confirm",
            onClick: t[1] || (t[1] = (s) => e.handleConfirm())
          }, de(e.t("el.datepicker.confirm")), 1)
        ])
      ])) : re("v-if", !0)
    ]),
    _: 1
  }, 8, ["name"]);
}
var oA = /* @__PURE__ */ vt(JU, [["render", tq]]);
const sA = (e) => Array.from(Array(e).keys()), lA = (e) => e.replace(/\W?m{1,2}|\W?ZZ/g, "").replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, "").trim(), uA = (e) => e.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?Y{2,4}/g, "").trim(), nq = {
  modelValue: {
    type: [Boolean, Number, String],
    default: () => {
    }
  },
  label: {
    type: [String, Boolean, Number, Object]
  },
  indeterminate: Boolean,
  disabled: Boolean,
  checked: Boolean,
  name: {
    type: String,
    default: void 0
  },
  trueLabel: {
    type: [String, Number],
    default: void 0
  },
  falseLabel: {
    type: [String, Number],
    default: void 0
  },
  tabindex: [String, Number],
  size: String
}, bc = () => {
  const e = ce(Pa, {}), t = ce(ts, {}), n = ce("CheckboxGroup", {}), r = J(() => n && (n == null ? void 0 : n.name) === "ElCheckboxGroup"), i = J(() => t.size);
  return {
    isGroup: r,
    checkboxGroup: n,
    elForm: e,
    elFormItemSize: i,
    elFormItem: t
  };
}, iq = (e) => {
  const t = j(!1), { emit: n } = sn(), { isGroup: r, checkboxGroup: i } = bc(), a = j(!1);
  return {
    model: J({
      get() {
        var s, l;
        return r.value ? (s = i.modelValue) == null ? void 0 : s.value : (l = e.modelValue) != null ? l : t.value;
      },
      set(s) {
        var l;
        r.value && Array.isArray(s) ? (a.value = i.max !== void 0 && s.length > i.max.value, a.value === !1 && ((l = i == null ? void 0 : i.changeEvent) == null || l.call(i, s))) : (n(vn, s), t.value = s);
      }
    }),
    isLimitExceeded: a
  };
}, rq = (e, { model: t }) => {
  const { isGroup: n, checkboxGroup: r } = bc(), i = j(!1), a = Bi(r == null ? void 0 : r.checkboxGroupSize, { prop: !0 }), o = J(() => {
    const l = t.value;
    return nb(l) === "[object Boolean]" ? l : Array.isArray(l) ? l.includes(e.label) : l != null ? l === e.trueLabel : !!l;
  }), s = Bi(J(() => {
    var l;
    return n.value ? (l = r == null ? void 0 : r.checkboxGroupSize) == null ? void 0 : l.value : void 0;
  }));
  return {
    isChecked: o,
    focus: i,
    size: a,
    checkboxSize: s
  };
}, aq = (e, {
  model: t,
  isChecked: n
}) => {
  const { elForm: r, isGroup: i, checkboxGroup: a } = bc(), o = J(() => {
    var l, u;
    const c = (l = a.max) == null ? void 0 : l.value, f = (u = a.min) == null ? void 0 : u.value;
    return !!(c || f) && t.value.length >= c && !n.value || t.value.length <= f && n.value;
  });
  return {
    isDisabled: J(() => {
      var l, u;
      const c = e.disabled || r.disabled;
      return (u = i.value ? ((l = a.disabled) == null ? void 0 : l.value) || c || o.value : e.disabled || r.disabled) != null ? u : !1;
    }),
    isLimitDisabled: o
  };
}, oq = (e, { model: t }) => {
  function n() {
    Array.isArray(t.value) && !t.value.includes(e.label) ? t.value.push(e.label) : t.value = e.trueLabel || !0;
  }
  e.checked && n();
}, sq = (e, { isLimitExceeded: t }) => {
  const { elFormItem: n } = bc(), { emit: r } = sn();
  function i(a) {
    var o, s;
    if (t.value)
      return;
    const u = a.target.checked ? (o = e.trueLabel) != null ? o : !0 : (s = e.falseLabel) != null ? s : !1;
    r("change", u, a);
  }
  return Ne(() => e.modelValue, () => {
    var a;
    (a = n.validate) == null || a.call(n, "change");
  }), {
    handleChange: i
  };
}, cA = (e) => {
  const { model: t, isLimitExceeded: n } = iq(e), { focus: r, size: i, isChecked: a, checkboxSize: o } = rq(e, {
    model: t
  }), { isDisabled: s } = aq(e, { model: t, isChecked: a }), { handleChange: l } = sq(e, { isLimitExceeded: n });
  return oq(e, { model: t }), {
    isChecked: a,
    isDisabled: s,
    checkboxSize: o,
    model: t,
    handleChange: l,
    focus: r,
    size: i
  };
}, lq = Ee({
  name: "ElCheckbox",
  props: {
    modelValue: {
      type: [Boolean, Number, String],
      default: () => {
      }
    },
    label: {
      type: [String, Boolean, Number, Object]
    },
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: {
      type: String,
      default: void 0
    },
    trueLabel: {
      type: [String, Number],
      default: void 0
    },
    falseLabel: {
      type: [String, Number],
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    },
    controls: {
      type: String,
      default: void 0
    },
    border: Boolean,
    size: {
      type: String,
      validator: fo
    },
    tabindex: [String, Number]
  },
  emits: [vn, "change"],
  setup(e) {
    return {
      ns: Ct("checkbox"),
      ...cA(e)
    };
  }
}), uq = ["id", "aria-controls"], cq = ["tabindex", "role", "aria-checked"], dq = ["aria-hidden", "name", "tabindex", "disabled", "true-value", "false-value"], fq = ["aria-hidden", "disabled", "value", "name", "tabindex"];
function hq(e, t, n, r, i, a) {
  return P(), L("label", {
    id: e.id,
    class: se([
      e.ns.b(),
      e.ns.m(e.checkboxSize),
      e.ns.is("disabled", e.isDisabled),
      e.ns.is("bordered", e.border),
      e.ns.is("checked", e.isChecked)
    ]),
    "aria-controls": e.indeterminate ? e.controls : null
  }, [
    T("span", {
      class: se([
        e.ns.e("input"),
        e.ns.is("disabled", e.isDisabled),
        e.ns.is("checked", e.isChecked),
        e.ns.is("indeterminate", e.indeterminate),
        e.ns.is("focus", e.focus)
      ]),
      tabindex: e.indeterminate ? 0 : void 0,
      role: e.indeterminate ? "checkbox" : void 0,
      "aria-checked": e.indeterminate ? "mixed" : !1
    }, [
      T("span", {
        class: se(e.ns.e("inner"))
      }, null, 2),
      e.trueLabel || e.falseLabel ? Bt((P(), L("input", {
        key: 0,
        "onUpdate:modelValue": t[0] || (t[0] = (o) => e.model = o),
        class: se(e.ns.e("original")),
        type: "checkbox",
        "aria-hidden": e.indeterminate ? "true" : "false",
        name: e.name,
        tabindex: e.tabindex,
        disabled: e.isDisabled,
        "true-value": e.trueLabel,
        "false-value": e.falseLabel,
        onChange: t[1] || (t[1] = (...o) => e.handleChange && e.handleChange(...o)),
        onFocus: t[2] || (t[2] = (o) => e.focus = !0),
        onBlur: t[3] || (t[3] = (o) => e.focus = !1)
      }, null, 42, dq)), [
        [S0, e.model]
      ]) : Bt((P(), L("input", {
        key: 1,
        "onUpdate:modelValue": t[4] || (t[4] = (o) => e.model = o),
        class: se(e.ns.e("original")),
        type: "checkbox",
        "aria-hidden": e.indeterminate ? "true" : "false",
        disabled: e.isDisabled,
        value: e.label,
        name: e.name,
        tabindex: e.tabindex,
        onChange: t[5] || (t[5] = (...o) => e.handleChange && e.handleChange(...o)),
        onFocus: t[6] || (t[6] = (o) => e.focus = !0),
        onBlur: t[7] || (t[7] = (o) => e.focus = !1)
      }, null, 42, fq)), [
        [S0, e.model]
      ])
    ], 10, cq),
    e.$slots.default || e.label ? (P(), L("span", {
      key: 0,
      class: se(e.ns.e("label"))
    }, [
      tt(e.$slots, "default"),
      e.$slots.default ? re("v-if", !0) : (P(), L(nt, { key: 0 }, [
        je(de(e.label), 1)
      ], 2112))
    ], 2)) : re("v-if", !0)
  ], 10, uq);
}
var pq = /* @__PURE__ */ vt(lq, [["render", hq]]);
const vq = Ee({
  name: "ElCheckboxButton",
  props: nq,
  emits: [vn, "change"],
  setup(e) {
    const { focus: t, isChecked: n, isDisabled: r, size: i, model: a, handleChange: o } = cA(e), { checkboxGroup: s } = bc(), l = Ct("checkbox"), u = J(() => {
      var c, f, d, h;
      const p = (f = (c = s == null ? void 0 : s.fill) == null ? void 0 : c.value) != null ? f : "";
      return {
        backgroundColor: p,
        borderColor: p,
        color: (h = (d = s == null ? void 0 : s.textColor) == null ? void 0 : d.value) != null ? h : "",
        boxShadow: p ? `-1px 0 0 0 ${p}` : null
      };
    });
    return {
      focus: t,
      isChecked: n,
      isDisabled: r,
      model: a,
      handleChange: o,
      activeStyle: u,
      size: i,
      ns: l
    };
  }
}), mq = ["aria-checked", "aria-disabled"], gq = ["name", "tabindex", "disabled", "true-value", "false-value"], yq = ["name", "tabindex", "disabled", "value"];
function bq(e, t, n, r, i, a) {
  return P(), L("label", {
    class: se([
      e.ns.b("button"),
      e.ns.bm("button", e.size),
      e.ns.is("disabled", e.isDisabled),
      e.ns.is("checked", e.isChecked),
      e.ns.is("focus", e.focus)
    ]),
    role: "checkbox",
    "aria-checked": e.isChecked,
    "aria-disabled": e.isDisabled
  }, [
    e.trueLabel || e.falseLabel ? Bt((P(), L("input", {
      key: 0,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => e.model = o),
      class: se(e.ns.be("button", "original")),
      type: "checkbox",
      name: e.name,
      tabindex: e.tabindex,
      disabled: e.isDisabled,
      "true-value": e.trueLabel,
      "false-value": e.falseLabel,
      onChange: t[1] || (t[1] = (...o) => e.handleChange && e.handleChange(...o)),
      onFocus: t[2] || (t[2] = (o) => e.focus = !0),
      onBlur: t[3] || (t[3] = (o) => e.focus = !1)
    }, null, 42, gq)), [
      [S0, e.model]
    ]) : Bt((P(), L("input", {
      key: 1,
      "onUpdate:modelValue": t[4] || (t[4] = (o) => e.model = o),
      class: se(e.ns.be("button", "original")),
      type: "checkbox",
      name: e.name,
      tabindex: e.tabindex,
      disabled: e.isDisabled,
      value: e.label,
      onChange: t[5] || (t[5] = (...o) => e.handleChange && e.handleChange(...o)),
      onFocus: t[6] || (t[6] = (o) => e.focus = !0),
      onBlur: t[7] || (t[7] = (o) => e.focus = !1)
    }, null, 42, yq)), [
      [S0, e.model]
    ]),
    e.$slots.default || e.label ? (P(), L("span", {
      key: 2,
      class: se(e.ns.be("button", "inner")),
      style: Pt(e.isChecked ? e.activeStyle : null)
    }, [
      tt(e.$slots, "default", {}, () => [
        je(de(e.label), 1)
      ])
    ], 6)) : re("v-if", !0)
  ], 10, mq);
}
var dA = /* @__PURE__ */ vt(vq, [["render", bq]]);
const fA = Ee({
  name: "ElCheckboxGroup",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    min: {
      type: Number,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      validator: fo
    },
    fill: {
      type: String,
      default: void 0
    },
    textColor: {
      type: String,
      default: void 0
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  emits: [vn, "change"],
  setup(e, { emit: t, slots: n }) {
    const { elFormItem: r } = bc(), i = Bi(), a = Ct("checkbox"), o = (l) => {
      t(vn, l), bt(() => {
        t("change", l);
      });
    }, s = J({
      get() {
        return e.modelValue;
      },
      set(l) {
        o(l);
      }
    });
    return _t("CheckboxGroup", {
      name: "ElCheckboxGroup",
      modelValue: s,
      ...ma(e),
      checkboxGroupSize: i,
      changeEvent: o
    }), Ne(() => e.modelValue, () => {
      var l;
      (l = r.validate) == null || l.call(r, "change");
    }), () => et(e.tag, {
      class: a.b("group"),
      role: "group",
      "aria-label": "checkbox-group"
    }, [tt(n, "default")]);
  }
}), Bs = Un(pq, {
  CheckboxButton: dA,
  CheckboxGroup: fA
});
Wi(dA);
Wi(fA);
const hA = Gt({
  size: Fh,
  disabled: Boolean,
  label: {
    type: [String, Number, Boolean],
    default: ""
  }
}), Aq = Gt({
  ...hA,
  modelValue: {
    type: [String, Number, Boolean],
    default: ""
  },
  name: {
    type: String,
    default: ""
  },
  border: Boolean
}), pA = {
  [vn]: (e) => Ai(e) || jn(e) || Fa(e),
  change: (e) => Ai(e) || jn(e) || Fa(e)
}, vA = (e, t) => {
  const n = j(), r = ce(bb, void 0), i = J(() => !!r), a = J({
    get() {
      return i.value ? r.modelValue : e.modelValue;
    },
    set(c) {
      i.value ? r.changeEvent(c) : t(vn, c), n.value.checked = e.modelValue === e.label;
    }
  }), o = Bi(J(() => r == null ? void 0 : r.size)), s = cf(J(() => r == null ? void 0 : r.disabled)), l = j(!1), u = J(() => s.value || i.value && a.value !== e.label ? -1 : 0);
  return {
    radioRef: n,
    isGroup: i,
    radioGroup: r,
    focus: l,
    size: o,
    disabled: s,
    tabIndex: u,
    modelValue: a
  };
}, Tq = Ee({
  name: "ElRadio",
  props: Aq,
  emits: pA,
  setup(e, { emit: t }) {
    const n = Ct("radio"), { radioRef: r, isGroup: i, focus: a, size: o, disabled: s, tabIndex: l, modelValue: u } = vA(e, t);
    function c() {
      bt(() => t("change", u.value));
    }
    return {
      ns: n,
      focus: a,
      isGroup: i,
      modelValue: u,
      tabIndex: l,
      size: o,
      disabled: s,
      radioRef: r,
      handleChange: c
    };
  }
}), wq = ["aria-checked", "aria-disabled", "tabindex"], Pq = ["value", "name", "disabled"];
function xq(e, t, n, r, i, a) {
  return P(), L("label", {
    class: se([
      e.ns.b(),
      e.ns.is("disabled", e.disabled),
      e.ns.is("focus", e.focus),
      e.ns.is("bordered", e.border),
      e.ns.is("checked", e.modelValue === e.label),
      e.ns.m(e.size)
    ]),
    role: "radio",
    "aria-checked": e.modelValue === e.label,
    "aria-disabled": e.disabled,
    tabindex: e.tabIndex,
    onKeydown: t[5] || (t[5] = nn(wt((o) => e.modelValue = e.disabled ? e.modelValue : e.label, ["stop", "prevent"]), ["space"]))
  }, [
    T("span", {
      class: se([
        e.ns.e("input"),
        e.ns.is("disabled", e.disabled),
        e.ns.is("checked", e.modelValue === e.label)
      ])
    }, [
      T("span", {
        class: se(e.ns.e("inner"))
      }, null, 2),
      Bt(T("input", {
        ref: "radioRef",
        "onUpdate:modelValue": t[0] || (t[0] = (o) => e.modelValue = o),
        class: se(e.ns.e("original")),
        value: e.label,
        type: "radio",
        "aria-hidden": "true",
        name: e.name,
        disabled: e.disabled,
        tabindex: "-1",
        onFocus: t[1] || (t[1] = (o) => e.focus = !0),
        onBlur: t[2] || (t[2] = (o) => e.focus = !1),
        onChange: t[3] || (t[3] = (...o) => e.handleChange && e.handleChange(...o))
      }, null, 42, Pq), [
        [ig, e.modelValue]
      ])
    ], 2),
    T("span", {
      class: se(e.ns.e("label")),
      onKeydown: t[4] || (t[4] = wt(() => {
      }, ["stop"]))
    }, [
      tt(e.$slots, "default", {}, () => [
        je(de(e.label), 1)
      ])
    ], 34)
  ], 42, wq);
}
var Cq = /* @__PURE__ */ vt(Tq, [["render", xq]]);
const Sq = Gt({
  ...hA,
  name: {
    type: String,
    default: ""
  }
}), Eq = Ee({
  name: "ElRadioButton",
  props: Sq,
  setup(e, { emit: t }) {
    const n = Ct("radio"), {
      radioRef: r,
      isGroup: i,
      focus: a,
      size: o,
      disabled: s,
      tabIndex: l,
      modelValue: u,
      radioGroup: c
    } = vA(e, t), f = J(() => ({
      backgroundColor: (c == null ? void 0 : c.fill) || "",
      borderColor: (c == null ? void 0 : c.fill) || "",
      boxShadow: c != null && c.fill ? `-1px 0 0 0 ${c.fill}` : "",
      color: (c == null ? void 0 : c.textColor) || ""
    }));
    return {
      ns: n,
      isGroup: i,
      size: o,
      disabled: s,
      tabIndex: l,
      modelValue: u,
      focus: a,
      activeStyle: f,
      radioRef: r
    };
  }
}), kq = ["aria-checked", "aria-disabled", "tabindex"], Oq = ["value", "name", "disabled"];
function zq(e, t, n, r, i, a) {
  return P(), L("label", {
    class: se([
      e.ns.b("button"),
      e.ns.is("active", e.modelValue === e.label),
      e.ns.is("disabled", e.disabled),
      e.ns.is("focus", e.focus),
      e.ns.bm("button", e.size)
    ]),
    role: "radio",
    "aria-checked": e.modelValue === e.label,
    "aria-disabled": e.disabled,
    tabindex: e.tabIndex,
    onKeydown: t[4] || (t[4] = nn(wt((o) => e.modelValue = e.disabled ? e.modelValue : e.label, ["stop", "prevent"]), ["space"]))
  }, [
    Bt(T("input", {
      ref: "radioRef",
      "onUpdate:modelValue": t[0] || (t[0] = (o) => e.modelValue = o),
      class: se(e.ns.be("button", "original-radio")),
      value: e.label,
      type: "radio",
      name: e.name,
      disabled: e.disabled,
      tabindex: "-1",
      onFocus: t[1] || (t[1] = (o) => e.focus = !0),
      onBlur: t[2] || (t[2] = (o) => e.focus = !1)
    }, null, 42, Oq), [
      [ig, e.modelValue]
    ]),
    T("span", {
      class: se(e.ns.be("button", "inner")),
      style: Pt(e.modelValue === e.label ? e.activeStyle : {}),
      onKeydown: t[3] || (t[3] = wt(() => {
      }, ["stop"]))
    }, [
      tt(e.$slots, "default", {}, () => [
        je(de(e.label), 1)
      ])
    ], 38)
  ], 42, kq);
}
var mA = /* @__PURE__ */ vt(Eq, [["render", zq]]);
const Dq = Gt({
  size: Fh,
  disabled: Boolean,
  modelValue: {
    type: [String, Number, Boolean],
    default: ""
  },
  fill: {
    type: String,
    default: ""
  },
  textColor: {
    type: String,
    default: ""
  }
}), Mq = pA, Hq = Ee({
  name: "ElRadioGroup",
  props: Dq,
  emits: Mq,
  setup(e, t) {
    const n = Ct("radio"), r = j(), { formItem: i } = gc(), a = (s) => {
      t.emit(vn, s), bt(() => t.emit("change", s));
    }, o = (s) => {
      if (!r.value)
        return;
      const l = s.target, u = l.nodeName === "INPUT" ? "[type=radio]" : "[role=radio]", c = r.value.querySelectorAll(u), f = c.length, d = Array.from(c).indexOf(l), h = r.value.querySelectorAll("[role=radio]");
      let p = null;
      switch (s.code) {
        case yt.left:
        case yt.up:
          s.stopPropagation(), s.preventDefault(), p = d === 0 ? f - 1 : d - 1;
          break;
        case yt.right:
        case yt.down:
          s.stopPropagation(), s.preventDefault(), p = d === f - 1 ? 0 : d + 1;
          break;
      }
      p !== null && (h[p].click(), h[p].focus());
    };
    return rn(() => {
      const s = r.value.querySelectorAll("[type=radio]"), l = s[0];
      !Array.from(s).some((u) => u.checked) && l && (l.tabIndex = 0);
    }), _t(bb, zt({
      ...ma(e),
      changeEvent: a
    })), Ne(() => e.modelValue, () => i == null ? void 0 : i.validate("change")), {
      ns: n,
      radioGroupRef: r,
      handleKeydown: o
    };
  }
});
function Iq(e, t, n, r, i, a) {
  return P(), L("div", {
    ref: "radioGroupRef",
    class: se(e.ns.b("group")),
    role: "radiogroup",
    onKeydown: t[0] || (t[0] = (...o) => e.handleKeydown && e.handleKeydown(...o))
  }, [
    tt(e.$slots, "default")
  ], 34);
}
var gA = /* @__PURE__ */ vt(Hq, [["render", Iq]]);
const b3 = Un(Cq, {
  RadioButton: mA,
  RadioGroup: gA
}), Lq = Wi(gA);
Wi(mA);
var Bq = Ee({
  name: "NodeContent",
  render() {
    const { node: e, panel: t } = this.$parent, { data: n, label: r } = e, { renderLabelFn: i } = t;
    return et("span", { class: "el-cascader-node__label" }, i ? i({ node: e, data: n }) : r);
  }
});
const A3 = Symbol(), Nq = Ee({
  name: "ElCascaderNode",
  components: {
    ElCheckbox: Bs,
    ElRadio: b3,
    NodeContent: Bq,
    ElIcon: qt,
    Check: Xd,
    Loading: Vl,
    ArrowRight: es
  },
  props: {
    node: {
      type: Object,
      required: !0
    },
    menuId: String
  },
  emits: ["expand"],
  setup(e, { emit: t }) {
    const n = ce(A3), r = J(() => n.isHoverMenu), i = J(() => n.config.multiple), a = J(() => n.config.checkStrictly), o = J(() => {
      var C;
      return (C = n.checkedNodes[0]) == null ? void 0 : C.uid;
    }), s = J(() => e.node.isDisabled), l = J(() => e.node.isLeaf), u = J(() => a.value && !l.value || !s.value), c = J(() => d(n.expandingNode)), f = J(() => a.value && n.checkedNodes.some(d)), d = (C) => {
      var v;
      const { level: H, uid: V } = e.node;
      return ((v = C == null ? void 0 : C.pathNodes[H - 1]) == null ? void 0 : v.uid) === V;
    }, h = () => {
      c.value || n.expandNode(e.node);
    }, p = (C) => {
      const { node: v } = e;
      C !== v.checked && n.handleCheckChange(v, C);
    }, y = () => {
      n.lazyLoad(e.node, () => {
        l.value || h();
      });
    }, m = (C) => {
      !r.value || (b(), !l.value && t("expand", C));
    }, b = () => {
      const { node: C } = e;
      !u.value || C.loading || (C.loaded ? h() : y());
    }, x = () => {
      r.value && !l.value || (l.value && !s.value && !a.value && !i.value ? S(!0) : b());
    }, D = (C) => {
      a.value ? (p(C), e.node.loaded && h()) : S(C);
    }, S = (C) => {
      e.node.loaded ? (p(C), !a.value && h()) : y();
    };
    return {
      panel: n,
      isHoverMenu: r,
      multiple: i,
      checkStrictly: a,
      checkedNodeId: o,
      isDisabled: s,
      isLeaf: l,
      expandable: u,
      inExpandingPath: c,
      inCheckedPath: f,
      handleHoverExpand: m,
      handleExpand: b,
      handleClick: x,
      handleCheck: S,
      handleSelectCheck: D
    };
  }
}), jq = ["id", "aria-haspopup", "aria-owns", "aria-expanded", "tabindex"], Fq = /* @__PURE__ */ T("span", null, null, -1);
function Xq(e, t, n, r, i, a) {
  const o = Ie("el-checkbox"), s = Ie("el-radio"), l = Ie("check"), u = Ie("el-icon"), c = Ie("node-content"), f = Ie("loading"), d = Ie("arrow-right");
  return P(), L("li", {
    id: `${e.menuId}-${e.node.uid}`,
    role: "menuitem",
    "aria-haspopup": !e.isLeaf,
    "aria-owns": e.isLeaf ? null : e.menuId,
    "aria-expanded": e.inExpandingPath,
    tabindex: e.expandable ? -1 : void 0,
    class: se([
      "el-cascader-node",
      e.checkStrictly && "is-selectable",
      e.inExpandingPath && "in-active-path",
      e.inCheckedPath && "in-checked-path",
      e.node.checked && "is-active",
      !e.expandable && "is-disabled"
    ]),
    onMouseenter: t[2] || (t[2] = (...h) => e.handleHoverExpand && e.handleHoverExpand(...h)),
    onFocus: t[3] || (t[3] = (...h) => e.handleHoverExpand && e.handleHoverExpand(...h)),
    onClick: t[4] || (t[4] = (...h) => e.handleClick && e.handleClick(...h))
  }, [
    re(" prefix "),
    e.multiple ? (P(), ue(o, {
      key: 0,
      "model-value": e.node.checked,
      indeterminate: e.node.indeterminate,
      disabled: e.isDisabled,
      onClick: t[0] || (t[0] = wt(() => {
      }, ["stop"])),
      "onUpdate:modelValue": e.handleSelectCheck
    }, null, 8, ["model-value", "indeterminate", "disabled", "onUpdate:modelValue"])) : e.checkStrictly ? (P(), ue(s, {
      key: 1,
      "model-value": e.checkedNodeId,
      label: e.node.uid,
      disabled: e.isDisabled,
      "onUpdate:modelValue": e.handleSelectCheck,
      onClick: t[1] || (t[1] = wt(() => {
      }, ["stop"]))
    }, {
      default: N(() => [
        re(`
        Add an empty element to avoid render label,
        do not use empty fragment here for https://github.com/vuejs/vue-next/pull/2485
      `),
        Fq
      ]),
      _: 1
    }, 8, ["model-value", "label", "disabled", "onUpdate:modelValue"])) : e.isLeaf && e.node.checked ? (P(), ue(u, {
      key: 2,
      class: "el-cascader-node__prefix"
    }, {
      default: N(() => [
        B(l)
      ]),
      _: 1
    })) : re("v-if", !0),
    re(" content "),
    B(c),
    re(" postfix "),
    e.isLeaf ? re("v-if", !0) : (P(), L(nt, { key: 3 }, [
      e.node.loading ? (P(), ue(u, {
        key: 0,
        class: "is-loading el-cascader-node__postfix"
      }, {
        default: N(() => [
          B(f)
        ]),
        _: 1
      })) : (P(), ue(u, {
        key: 1,
        class: "arrow-right el-cascader-node__postfix"
      }, {
        default: N(() => [
          B(d)
        ]),
        _: 1
      }))
    ], 2112))
  ], 42, jq);
}
var Rq = /* @__PURE__ */ vt(Nq, [["render", Xq]]);
const Vq = Ee({
  name: "ElCascaderMenu",
  components: {
    Loading: Vl,
    ElIcon: qt,
    ElScrollbar: ns,
    ElCascaderNode: Rq
  },
  props: {
    nodes: {
      type: Array,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const t = sn(), { t: n } = hi(), r = N0();
    let i = null, a = null;
    const o = ce(A3), s = j(null), l = J(() => !e.nodes.length), u = J(() => !o.initialLoaded), c = J(() => `cascader-menu-${r}-${e.index}`), f = (y) => {
      i = y.target;
    }, d = (y) => {
      if (!(!o.isHoverMenu || !i || !s.value))
        if (i.contains(y.target)) {
          h();
          const m = t.vnode.el, { left: b } = m.getBoundingClientRect(), { offsetWidth: x, offsetHeight: D } = m, S = y.clientX - b, C = i.offsetTop, v = C + i.offsetHeight;
          s.value.innerHTML = `
          <path style="pointer-events: auto;" fill="transparent" d="M${S} ${C} L${x} 0 V${C} Z" />
          <path style="pointer-events: auto;" fill="transparent" d="M${S} ${v} L${x} ${D} V${v} Z" />
        `;
        } else
          a || (a = window.setTimeout(p, o.config.hoverThreshold));
    }, h = () => {
      !a || (clearTimeout(a), a = null);
    }, p = () => {
      !s.value || (s.value.innerHTML = "", h());
    };
    return {
      panel: o,
      hoverZone: s,
      isEmpty: l,
      isLoading: u,
      menuId: c,
      t: n,
      handleExpand: f,
      handleMouseMove: d,
      clearHoverZone: p
    };
  }
}), Uq = {
  key: 0,
  class: "el-cascader-menu__empty-text"
}, qq = {
  key: 1,
  class: "el-cascader-menu__empty-text"
}, _q = {
  key: 2,
  ref: "hoverZone",
  class: "el-cascader-menu__hover-zone"
};
function Wq(e, t, n, r, i, a) {
  const o = Ie("el-cascader-node"), s = Ie("loading"), l = Ie("el-icon"), u = Ie("el-scrollbar");
  return P(), ue(u, {
    key: e.menuId,
    tag: "ul",
    role: "menu",
    class: "el-cascader-menu",
    "wrap-class": "el-cascader-menu__wrap",
    "view-class": ["el-cascader-menu__list", e.isEmpty && "is-empty"],
    onMousemove: e.handleMouseMove,
    onMouseleave: e.clearHoverZone
  }, {
    default: N(() => {
      var c;
      return [
        (P(!0), L(nt, null, Lt(e.nodes, (f) => (P(), ue(o, {
          key: f.uid,
          node: f,
          "menu-id": e.menuId,
          onExpand: e.handleExpand
        }, null, 8, ["node", "menu-id", "onExpand"]))), 128)),
        e.isLoading ? (P(), L("div", Uq, [
          B(l, {
            size: "14",
            class: "is-loading"
          }, {
            default: N(() => [
              B(s)
            ]),
            _: 1
          }),
          je(" " + de(e.t("el.cascader.loading")), 1)
        ])) : e.isEmpty ? (P(), L("div", qq, de(e.t("el.cascader.noData")), 1)) : (c = e.panel) != null && c.isHoverMenu ? (P(), L("svg", _q, null, 512)) : re("v-if", !0)
      ];
    }),
    _: 1
  }, 8, ["view-class", "onMousemove", "onMouseleave"]);
}
var Kq = /* @__PURE__ */ vt(Vq, [["render", Wq]]), T3 = /* @__PURE__ */ ((e) => (e.CLICK = "click", e.HOVER = "hover", e))(T3 || {});
let Gq = 0;
const Yq = (e) => {
  const t = [e];
  let { parent: n } = e;
  for (; n; )
    t.unshift(n), n = n.parent;
  return t;
};
class Ku {
  constructor(t, n, r, i = !1) {
    this.data = t, this.config = n, this.parent = r, this.root = i, this.uid = Gq++, this.checked = !1, this.indeterminate = !1, this.loading = !1;
    const { value: a, label: o, children: s } = n, l = t[s], u = Yq(this);
    this.level = i ? 0 : r ? r.level + 1 : 1, this.value = t[a], this.label = t[o], this.pathNodes = u, this.pathValues = u.map((c) => c.value), this.pathLabels = u.map((c) => c.label), this.childrenData = l, this.children = (l || []).map((c) => new Ku(c, n, this)), this.loaded = !n.lazy || this.isLeaf || !Fd(l);
  }
  get isDisabled() {
    const { data: t, parent: n, config: r } = this, { disabled: i, checkStrictly: a } = r;
    return (fa(i) ? i(t, this) : !!t[i]) || !a && (n == null ? void 0 : n.isDisabled);
  }
  get isLeaf() {
    const { data: t, config: n, childrenData: r, loaded: i } = this, { lazy: a, leaf: o } = n, s = fa(o) ? o(t, this) : t[o];
    return jd(s) ? a && !i ? !1 : !(Array.isArray(r) && r.length) : !!s;
  }
  get valueByOption() {
    return this.config.emitPath ? this.pathValues : this.value;
  }
  appendChild(t) {
    const { childrenData: n, children: r } = this, i = new Ku(t, this.config, this);
    return Array.isArray(n) ? n.push(t) : this.childrenData = [t], r.push(i), i;
  }
  calcText(t, n) {
    const r = t ? this.pathLabels.join(n) : this.label;
    return this.text = r, r;
  }
  broadcast(t, ...n) {
    const r = `onParent${Ho(t)}`;
    this.children.forEach((i) => {
      i && (i.broadcast(t, ...n), i[r] && i[r](...n));
    });
  }
  emit(t, ...n) {
    const { parent: r } = this, i = `onChild${Ho(t)}`;
    r && (r[i] && r[i](...n), r.emit(t, ...n));
  }
  onParentCheck(t) {
    this.isDisabled || this.setCheckState(t);
  }
  onChildCheck() {
    const { children: t } = this, n = t.filter((i) => !i.isDisabled), r = n.length ? n.every((i) => i.checked) : !1;
    this.setCheckState(r);
  }
  setCheckState(t) {
    const n = this.children.length, r = this.children.reduce((i, a) => {
      const o = a.checked ? 1 : a.indeterminate ? 0.5 : 0;
      return i + o;
    }, 0);
    this.checked = this.loaded && this.children.every((i) => i.loaded && i.checked) && t, this.indeterminate = this.loaded && r !== n && r > 0;
  }
  doCheck(t) {
    if (this.checked === t)
      return;
    const { checkStrictly: n, multiple: r } = this.config;
    n || !r ? this.checked = t : (this.broadcast("check", t), this.setCheckState(t), this.emit("check"));
  }
}
const F8 = (e, t) => e.reduce((n, r) => (r.isLeaf ? n.push(r) : (!t && n.push(r), n = n.concat(F8(r.children, t))), n), []);
class n7 {
  constructor(t, n) {
    this.config = n;
    const r = (t || []).map((i) => new Ku(i, this.config));
    this.nodes = r, this.allNodes = F8(r, !1), this.leafNodes = F8(r, !0);
  }
  getNodes() {
    return this.nodes;
  }
  getFlattedNodes(t) {
    return t ? this.leafNodes : this.allNodes;
  }
  appendNode(t, n) {
    const r = n ? n.appendChild(t) : new Ku(t, this.config);
    n || this.nodes.push(r), this.allNodes.push(r), r.isLeaf && this.leafNodes.push(r);
  }
  appendNodes(t, n) {
    t.forEach((r) => this.appendNode(r, n));
  }
  getNodeByValue(t, n = !1) {
    return !t && t !== 0 ? null : this.getFlattedNodes(n).filter((i) => ja(i.value, t) || ja(i.pathValues, t))[0] || null;
  }
  getSameNode(t) {
    return t && this.getFlattedNodes(!1).filter(({ value: r, level: i }) => ja(t.value, r) && t.level === i)[0] || null;
  }
}
const yA = {
  modelValue: [Number, String, Array],
  options: {
    type: Array,
    default: () => []
  },
  props: {
    type: Object,
    default: () => ({})
  }
}, Qq = {
  expandTrigger: T3.CLICK,
  multiple: !1,
  checkStrictly: !1,
  emitPath: !0,
  lazy: !1,
  lazyLoad: Vn,
  value: "value",
  label: "label",
  children: "children",
  leaf: "leaf",
  disabled: "disabled",
  hoverThreshold: 500
}, Zq = (e) => J(() => ({
  ...Qq,
  ...e.props
})), i7 = (e) => {
  if (!e)
    return 0;
  const t = e.id.split("-");
  return Number(t[t.length - 2]);
}, Jq = (e) => {
  if (!e)
    return;
  const t = e.querySelector("input");
  t ? t.click() : eb(e) && e.click();
}, $q = (e, t) => {
  const n = t.slice(0), r = n.map((a) => a.uid), i = e.reduce((a, o) => {
    const s = r.indexOf(o.uid);
    return s > -1 && (a.push(o), n.splice(s, 1), r.splice(s, 1)), a;
  }, []);
  return i.push(...n), i;
}, e_ = Ee({
  name: "ElCascaderPanel",
  components: {
    ElCascaderMenu: Kq
  },
  props: {
    ...yA,
    border: {
      type: Boolean,
      default: !0
    },
    renderLabel: Function
  },
  emits: [vn, Tr, "close", "expand-change"],
  setup(e, { emit: t, slots: n }) {
    let r = !1;
    const i = Zq(e);
    let a = null;
    const o = j(!0), s = j([]), l = j(null), u = j([]), c = j(null), f = j([]), d = J(() => i.value.expandTrigger === T3.HOVER), h = J(() => e.renderLabel || n.default), p = () => {
      const { options: K } = e, q = i.value;
      r = !1, a = new n7(K, q), u.value = [a.getNodes()], q.lazy && Fd(e.options) ? (o.value = !1, y(void 0, (G) => {
        G && (a = new n7(G, q), u.value = [a.getNodes()]), o.value = !0, H(!1, !0);
      })) : H(!1, !0);
    }, y = (K, q) => {
      const G = i.value;
      K = K || new Ku({}, G, void 0, !0), K.loading = !0;
      const te = (Q) => {
        const Y = K, Z = Y.root ? null : Y;
        Q && (a == null || a.appendNodes(Q, Z)), Y.loading = !1, Y.loaded = !0, Y.childrenData = Y.childrenData || [], q && q(Q);
      };
      G.lazyLoad(K, te);
    }, m = (K, q) => {
      var G;
      const { level: te } = K, Q = u.value.slice(0, te);
      let Y;
      K.isLeaf ? Y = K.pathNodes[te - 2] : (Y = K, Q.push(K.children)), ((G = c.value) == null ? void 0 : G.uid) !== (Y == null ? void 0 : Y.uid) && (c.value = K, u.value = Q, !q && t("expand-change", (K == null ? void 0 : K.pathValues) || []));
    }, b = (K, q, G = !0) => {
      const { checkStrictly: te, multiple: Q } = i.value, Y = f.value[0];
      r = !0, !Q && (Y == null || Y.doCheck(!1)), K.doCheck(q), v(), G && !Q && !te && t("close"), !G && !Q && !te && x(K);
    }, x = (K) => {
      !K || (K = K.parent, x(K), K && m(K));
    }, D = (K) => a == null ? void 0 : a.getFlattedNodes(K), S = (K) => {
      var q;
      return (q = D(K)) == null ? void 0 : q.filter((G) => G.checked !== !1);
    }, C = () => {
      f.value.forEach((K) => K.doCheck(!1)), v();
    }, v = () => {
      var K;
      const { checkStrictly: q, multiple: G } = i.value, te = f.value, Q = S(!q), Y = $q(te, Q), Z = Y.map((oe) => oe.valueByOption);
      f.value = Y, l.value = G ? Z : (K = Z[0]) != null ? K : null;
    }, H = (K = !1, q = !1) => {
      const { modelValue: G } = e, { lazy: te, multiple: Q, checkStrictly: Y } = i.value, Z = !Y;
      if (!(!o.value || r || !q && ja(G, l.value)))
        if (te && !K) {
          const he = T5(IB(wl(G))).map((Ae) => a == null ? void 0 : a.getNodeByValue(Ae)).filter((Ae) => !!Ae && !Ae.loaded && !Ae.loading);
          he.length ? he.forEach((Ae) => {
            y(Ae, () => H(!1, q));
          }) : H(!0, q);
        } else {
          const oe = Q ? wl(G) : [G], he = T5(oe.map((Ae) => a == null ? void 0 : a.getNodeByValue(Ae, Z)));
          V(he, !1), l.value = G;
        }
    }, V = (K, q = !0) => {
      const { checkStrictly: G } = i.value, te = f.value, Q = K.filter((oe) => !!oe && (G || oe.isLeaf)), Y = a == null ? void 0 : a.getSameNode(c.value), Z = q && Y || Q[0];
      Z ? Z.pathNodes.forEach((oe) => m(oe, !0)) : c.value = null, te.forEach((oe) => oe.doCheck(!1)), Q.forEach((oe) => oe.doCheck(!0)), f.value = Q, bt(R);
    }, R = () => {
      !Sn || s.value.forEach((K) => {
        const q = K == null ? void 0 : K.$el;
        if (q) {
          const G = q.querySelector(".el-scrollbar__wrap"), te = q.querySelector(".el-cascader-node.is-active") || q.querySelector(".el-cascader-node.in-active-path");
          ob(G, te);
        }
      });
    }, F = (K) => {
      const q = K.target, { code: G } = K;
      switch (G) {
        case yt.up:
        case yt.down: {
          K.preventDefault();
          const te = G === yt.up ? -1 : 1;
          _1(tb(q, te, '.el-cascader-node[tabindex="-1"]'));
          break;
        }
        case yt.left: {
          K.preventDefault();
          const te = s.value[i7(q) - 1], Q = te == null ? void 0 : te.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
          _1(Q);
          break;
        }
        case yt.right: {
          K.preventDefault();
          const te = s.value[i7(q) + 1], Q = te == null ? void 0 : te.$el.querySelector('.el-cascader-node[tabindex="-1"]');
          _1(Q);
          break;
        }
        case yt.enter:
          Jq(q);
          break;
        case yt.esc:
        case yt.tab:
          t("close");
          break;
      }
    };
    return _t(A3, zt({
      config: i,
      expandingNode: c,
      checkedNodes: f,
      isHoverMenu: d,
      initialLoaded: o,
      renderLabelFn: h,
      lazyLoad: y,
      expandNode: m,
      handleCheckChange: b
    })), Ne([i, () => e.options], p, {
      deep: !0,
      immediate: !0
    }), Ne(() => e.modelValue, () => {
      r = !1, H();
    }), Ne(l, (K) => {
      ja(K, e.modelValue) || (t(vn, K), t(Tr, K));
    }), QC(() => s.value = []), rn(() => !Fd(e.modelValue) && H()), {
      menuList: s,
      menus: u,
      checkedNodes: f,
      handleKeyDown: F,
      handleCheckChange: b,
      getFlattedNodes: D,
      getCheckedNodes: S,
      clearCheckedNodes: C,
      calculateCheckedValue: v,
      scrollToExpandingNode: R
    };
  }
});
function t_(e, t, n, r, i, a) {
  const o = Ie("el-cascader-menu");
  return P(), L("div", {
    class: se(["el-cascader-panel", e.border && "is-bordered"]),
    onKeydown: t[0] || (t[0] = (...s) => e.handleKeyDown && e.handleKeyDown(...s))
  }, [
    (P(!0), L(nt, null, Lt(e.menus, (s, l) => (P(), ue(o, {
      key: l,
      ref_for: !0,
      ref: (u) => e.menuList[l] = u,
      index: l,
      nodes: s
    }, null, 8, ["index", "nodes"]))), 128))
  ], 34);
}
var J1 = /* @__PURE__ */ vt(e_, [["render", t_]]);
J1.install = (e) => {
  e.component(J1.name, J1);
};
const n_ = J1, bA = Gt({
  closable: Boolean,
  type: {
    type: String,
    values: ["success", "info", "warning", "danger", ""],
    default: ""
  },
  hit: Boolean,
  disableTransitions: Boolean,
  color: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    values: ["large", "default", "small"]
  },
  effect: {
    type: String,
    values: ["dark", "light", "plain"],
    default: "light"
  }
}), i_ = {
  close: (e) => e instanceof MouseEvent,
  click: (e) => e instanceof MouseEvent
}, r_ = Ee({
  name: "ElTag",
  components: { ElIcon: qt, Close: Is },
  props: bA,
  emits: i_,
  setup(e, { emit: t }) {
    const n = Bi(), r = Ct("tag"), i = J(() => {
      const { type: s, hit: l, effect: u, closable: c } = e;
      return [
        r.b(),
        r.is("closable", c),
        r.m(s),
        r.m(n.value),
        r.m(u),
        r.is("hit", l)
      ];
    });
    return {
      ns: r,
      classes: i,
      handleClose: (s) => {
        s.stopPropagation(), t("close", s);
      },
      handleClick: (s) => {
        t("click", s);
      }
    };
  }
});
function a_(e, t, n, r, i, a) {
  const o = Ie("close"), s = Ie("el-icon");
  return e.disableTransitions ? (P(), ue(wa, {
    key: 1,
    name: `${e.ns.namespace.value}-zoom-in-center`
  }, {
    default: N(() => [
      T("span", {
        class: se(e.classes),
        style: Pt({ backgroundColor: e.color }),
        onClick: t[1] || (t[1] = (...l) => e.handleClick && e.handleClick(...l))
      }, [
        T("span", {
          class: se(e.ns.e("content"))
        }, [
          tt(e.$slots, "default")
        ], 2),
        e.closable ? (P(), ue(s, {
          key: 0,
          class: se(e.ns.e("close")),
          onClick: e.handleClose
        }, {
          default: N(() => [
            B(o)
          ]),
          _: 1
        }, 8, ["class", "onClick"])) : re("v-if", !0)
      ], 6)
    ]),
    _: 3
  }, 8, ["name"])) : (P(), L("span", {
    key: 0,
    class: se(e.classes),
    style: Pt({ backgroundColor: e.color }),
    onClick: t[0] || (t[0] = (...l) => e.handleClick && e.handleClick(...l))
  }, [
    T("span", {
      class: se(e.ns.e("content"))
    }, [
      tt(e.$slots, "default")
    ], 2),
    e.closable ? (P(), ue(s, {
      key: 0,
      class: se(e.ns.e("close")),
      onClick: e.handleClose
    }, {
      default: N(() => [
        B(o)
      ]),
      _: 1
    }, 8, ["class", "onClick"])) : re("v-if", !0)
  ], 6));
}
var o_ = /* @__PURE__ */ vt(r_, [["render", a_]]);
const hf = Un(o_), s_ = 40, l_ = {
  large: 36,
  default: 32,
  small: 28
}, u_ = {
  modifiers: [
    {
      name: "arrowPosition",
      enabled: !0,
      phase: "main",
      fn: ({ state: e }) => {
        const { modifiersData: t, placement: n } = e;
        ["right", "left", "bottom", "top"].includes(n) || (t.arrow.x = 35);
      },
      requires: ["arrow"]
    }
  ]
}, r7 = "ElCascader", c_ = Ee({
  name: r7,
  components: {
    ElCascaderPanel: n_,
    ElInput: ti,
    ElTooltip: Ki,
    ElScrollbar: ns,
    ElTag: hf,
    ElIcon: qt,
    CircleClose: Hs,
    Check: Xd,
    ArrowDown: vc
  },
  directives: {
    Clickoutside: yc
  },
  props: {
    ...yA,
    size: {
      type: String,
      validator: fo
    },
    placeholder: {
      type: String
    },
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    filterMethod: {
      type: Function,
      default: (e, t) => e.text.includes(t)
    },
    separator: {
      type: String,
      default: " / "
    },
    showAllLevels: {
      type: Boolean,
      default: !0
    },
    collapseTags: Boolean,
    debounce: {
      type: Number,
      default: 300
    },
    beforeFilter: {
      type: Function,
      default: () => !0
    },
    popperClass: {
      type: String,
      default: ""
    },
    popperAppendToBody: {
      type: Boolean,
      default: void 0
    },
    teleported: zr.teleported
  },
  emits: [
    vn,
    Tr,
    "focus",
    "blur",
    "visible-change",
    "expand-change",
    "remove-tag"
  ],
  setup(e, { emit: t }) {
    let n = 0, r = 0;
    const { compatTeleported: i } = Uh(r7, "popperAppendToBody"), { t: a } = hi(), o = ce(Pa, {}), s = ce(ts, {}), l = j(null), u = j(null), c = j(null), f = j(null), d = j(null), h = j(!1), p = j(!1), y = j(!1), m = j(""), b = j(""), x = j([]), D = j([]), S = j(!1), C = J(() => e.disabled || o.disabled), v = J(() => e.placeholder || a("el.cascader.placeholder")), H = Bi(), V = J(() => ["small"].includes(H.value) ? "small" : "default"), R = J(() => !!e.props.multiple), F = J(() => !e.filterable || R.value), K = J(() => R.value ? b.value : m.value), q = J(() => {
      var Pe;
      return ((Pe = f.value) == null ? void 0 : Pe.checkedNodes) || [];
    }), G = J(() => !e.clearable || C.value || y.value || !p.value ? !1 : !!q.value.length), te = J(() => {
      const { showAllLevels: Pe, separator: $e } = e, Ke = q.value;
      return Ke.length ? R.value ? " " : Ke[0].calcText(Pe, $e) : "";
    }), Q = J({
      get() {
        return e.modelValue;
      },
      set(Pe) {
        var $e;
        t(vn, Pe), t(Tr, Pe), ($e = s.validate) == null || $e.call(s, "change");
      }
    }), Y = J(() => {
      var Pe, $e;
      return ($e = (Pe = l.value) == null ? void 0 : Pe.popperRef) == null ? void 0 : $e.contentRef;
    }), Z = (Pe) => {
      var $e, Ke, lt;
      if (!C.value && (Pe = Pe != null ? Pe : !h.value, Pe !== h.value)) {
        if (h.value = Pe, (Ke = ($e = u.value) == null ? void 0 : $e.input) == null || Ke.setAttribute("aria-expanded", `${Pe}`), Pe)
          oe(), bt((lt = f.value) == null ? void 0 : lt.scrollToExpandingNode);
        else if (e.filterable) {
          const { value: He } = te;
          m.value = He, b.value = He;
        }
        t("visible-change", Pe);
      }
    }, oe = () => {
      bt(() => {
        var Pe;
        (Pe = l.value) == null || Pe.updatePopper();
      });
    }, he = () => {
      y.value = !1;
    }, Ae = (Pe) => {
      const { showAllLevels: $e, separator: Ke } = e;
      return {
        node: Pe,
        key: Pe.uid,
        text: Pe.calcText($e, Ke),
        hitState: !1,
        closable: !C.value && !Pe.isDisabled
      };
    }, We = (Pe) => {
      var $e;
      const Ke = Pe.node;
      Ke.doCheck(!1), ($e = f.value) == null || $e.calculateCheckedValue(), t("remove-tag", Ke.valueByOption);
    }, ke = () => {
      if (!R.value)
        return;
      const Pe = q.value, $e = [];
      if (Pe.length) {
        const [Ke, ...lt] = Pe, He = lt.length;
        $e.push(Ae(Ke)), He && (e.collapseTags ? $e.push({
          key: -1,
          text: `+ ${He}`,
          closable: !1
        }) : lt.forEach((Le) => $e.push(Ae(Le))));
      }
      x.value = $e;
    }, Re = () => {
      var Pe, $e;
      const { filterMethod: Ke, showAllLevels: lt, separator: He } = e, Le = ($e = (Pe = f.value) == null ? void 0 : Pe.getFlattedNodes(!e.props.checkStrictly)) == null ? void 0 : $e.filter((ct) => ct.isDisabled ? !1 : (ct.calcText(lt, He), Ke(ct, K.value)));
      R.value && x.value.forEach((ct) => {
        ct.hitState = !1;
      }), y.value = !0, D.value = Le, oe();
    }, ve = () => {
      var Pe;
      let $e;
      y.value && d.value ? $e = d.value.$el.querySelector(".el-cascader__suggestion-item") : $e = (Pe = f.value) == null ? void 0 : Pe.$el.querySelector('.el-cascader-node[tabindex="-1"]'), $e && ($e.focus(), !y.value && $e.click());
    }, Ye = () => {
      var Pe, $e;
      const Ke = (Pe = u.value) == null ? void 0 : Pe.input, lt = c.value, He = ($e = d.value) == null ? void 0 : $e.$el;
      if (!(!Sn || !Ke)) {
        if (He) {
          const Le = He.querySelector(".el-cascader__suggestion-list");
          Le.style.minWidth = `${Ke.offsetWidth}px`;
        }
        if (lt) {
          const { offsetHeight: Le } = lt, ct = x.value.length > 0 ? `${Math.max(Le + 6, n)}px` : `${n}px`;
          Ke.style.height = ct, oe();
        }
      }
    }, Qe = (Pe) => {
      var $e;
      return ($e = f.value) == null ? void 0 : $e.getCheckedNodes(Pe);
    }, ot = (Pe) => {
      oe(), t("expand-change", Pe);
    }, Ve = (Pe) => {
      var $e;
      const Ke = ($e = Pe.target) == null ? void 0 : $e.value;
      if (Pe.type === "compositionend")
        S.value = !1, bt(() => gt(Ke));
      else {
        const lt = Ke[Ke.length - 1] || "";
        S.value = !Nh(lt);
      }
    }, Te = (Pe) => {
      if (!S.value)
        switch (Pe.code) {
          case yt.enter:
            Z();
            break;
          case yt.down:
            Z(!0), bt(ve), Pe.preventDefault();
            break;
          case yt.esc:
          case yt.tab:
            Z(!1);
            break;
        }
    }, Me = () => {
      var Pe;
      (Pe = f.value) == null || Pe.clearCheckedNodes(), Z(!1);
    }, Je = (Pe) => {
      var $e, Ke;
      const { checked: lt } = Pe;
      R.value ? ($e = f.value) == null || $e.handleCheckChange(Pe, !lt, !1) : (!lt && ((Ke = f.value) == null || Ke.handleCheckChange(Pe, !0, !1)), Z(!1));
    }, mt = (Pe) => {
      const $e = Pe.target, { code: Ke } = Pe;
      switch (Ke) {
        case yt.up:
        case yt.down: {
          const lt = Ke === yt.up ? -1 : 1;
          _1(tb($e, lt, '.el-cascader__suggestion-item[tabindex="-1"]'));
          break;
        }
        case yt.enter:
          $e.click();
          break;
        case yt.esc:
        case yt.tab:
          Z(!1);
          break;
      }
    }, It = () => {
      const Pe = x.value, $e = Pe[Pe.length - 1];
      r = b.value ? 0 : r + 1, !(!$e || !r) && ($e.hitState ? We($e) : $e.hitState = !0);
    }, ln = qa(() => {
      const { value: Pe } = K;
      if (!Pe)
        return;
      const $e = e.beforeFilter(Pe);
      H0($e) ? $e.then(Re).catch(() => {
      }) : $e !== !1 ? Re() : he();
    }, e.debounce), gt = (Pe, $e) => {
      !h.value && Z(!0), !($e != null && $e.isComposing) && (Pe ? ln() : he());
    };
    return Ne(y, oe), Ne([q, C], ke), Ne(x, () => {
      bt(() => Ye());
    }), Ne(te, (Pe) => m.value = Pe, { immediate: !0 }), rn(() => {
      var Pe;
      const $e = (Pe = u.value) == null ? void 0 : Pe.$el;
      n = ($e == null ? void 0 : $e.offsetHeight) || l_[H.value] || s_, Xl($e, Ye);
    }), Ti(() => {
      var Pe;
      Rl((Pe = u.value) == null ? void 0 : Pe.$el, Ye);
    }), {
      popperOptions: u_,
      tooltipRef: l,
      popperPaneRef: Y,
      input: u,
      tagWrapper: c,
      panel: f,
      suggestionPanel: d,
      popperVisible: h,
      inputHover: p,
      inputPlaceholder: v,
      filtering: y,
      presentText: te,
      checkedValue: Q,
      inputValue: m,
      searchInputValue: b,
      presentTags: x,
      suggestions: D,
      isDisabled: C,
      isOnComposition: S,
      realSize: H,
      tagSize: V,
      multiple: R,
      readonly: F,
      clearBtnVisible: G,
      compatTeleported: i,
      t: a,
      togglePopperVisible: Z,
      hideSuggestionPanel: he,
      deleteTag: We,
      focusFirstNode: ve,
      getCheckedNodes: Qe,
      handleExpandChange: ot,
      handleKeyDown: Te,
      handleComposition: Ve,
      handleClear: Me,
      handleSuggestionClick: Je,
      handleSuggestionKeyDown: mt,
      handleDelete: It,
      handleInput: gt
    };
  }
}), d_ = {
  key: 0,
  ref: "tagWrapper",
  class: "el-cascader__tags"
}, f_ = ["placeholder"], h_ = ["onClick"], p_ = { class: "el-cascader__empty-text" };
function v_(e, t, n, r, i, a) {
  const o = Ie("circle-close"), s = Ie("el-icon"), l = Ie("arrow-down"), u = Ie("el-input"), c = Ie("el-tag"), f = Ie("el-cascader-panel"), d = Ie("check"), h = Ie("el-scrollbar"), p = Ie("el-tooltip"), y = va("clickoutside");
  return P(), ue(p, {
    ref: "tooltipRef",
    visible: e.popperVisible,
    "onUpdate:visible": t[17] || (t[17] = (m) => e.popperVisible = m),
    teleported: e.compatTeleported,
    "popper-class": `el-cascader__dropdown ${e.popperClass}`,
    "popper-options": e.popperOptions,
    "fallback-placements": [
      "bottom-start",
      "bottom",
      "top-start",
      "top",
      "right",
      "left"
    ],
    "stop-popper-mouse-event": !1,
    "gpu-acceleration": !1,
    placement: "bottom-start",
    transition: "el-zoom-in-top",
    effect: "light",
    pure: "",
    persistent: "",
    onHide: e.hideSuggestionPanel
  }, {
    default: N(() => [
      Bt((P(), L("div", {
        class: se([
          "el-cascader",
          e.realSize && `el-cascader--${e.realSize}`,
          { "is-disabled": e.isDisabled },
          e.$attrs.class
        ]),
        style: Pt(e.$attrs.style),
        onClick: t[11] || (t[11] = () => e.togglePopperVisible(e.readonly ? void 0 : !0)),
        onKeydown: t[12] || (t[12] = (...m) => e.handleKeyDown && e.handleKeyDown(...m)),
        onMouseenter: t[13] || (t[13] = (m) => e.inputHover = !0),
        onMouseleave: t[14] || (t[14] = (m) => e.inputHover = !1)
      }, [
        B(u, {
          ref: "input",
          modelValue: e.inputValue,
          "onUpdate:modelValue": t[1] || (t[1] = (m) => e.inputValue = m),
          placeholder: e.inputPlaceholder,
          readonly: e.readonly,
          disabled: e.isDisabled,
          "validate-event": !1,
          size: e.realSize,
          class: se({ "is-focus": e.popperVisible }),
          onCompositionstart: e.handleComposition,
          onCompositionupdate: e.handleComposition,
          onCompositionend: e.handleComposition,
          onFocus: t[2] || (t[2] = (m) => e.$emit("focus", m)),
          onBlur: t[3] || (t[3] = (m) => e.$emit("blur", m)),
          onInput: e.handleInput
        }, {
          suffix: N(() => [
            e.clearBtnVisible ? (P(), ue(s, {
              key: "clear",
              class: "el-input__icon icon-circle-close",
              onClick: wt(e.handleClear, ["stop"])
            }, {
              default: N(() => [
                B(o)
              ]),
              _: 1
            }, 8, ["onClick"])) : (P(), ue(s, {
              key: "arrow-down",
              class: se([
                "el-input__icon",
                "icon-arrow-down",
                e.popperVisible && "is-reverse"
              ]),
              onClick: t[0] || (t[0] = wt((m) => e.togglePopperVisible(), ["stop"]))
            }, {
              default: N(() => [
                B(l)
              ]),
              _: 1
            }, 8, ["class"]))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "readonly", "disabled", "size", "class", "onCompositionstart", "onCompositionupdate", "onCompositionend", "onInput"]),
        e.multiple ? (P(), L("div", d_, [
          (P(!0), L(nt, null, Lt(e.presentTags, (m) => (P(), ue(c, {
            key: m.key,
            type: "info",
            size: e.tagSize,
            hit: m.hitState,
            closable: m.closable,
            "disable-transitions": "",
            onClose: (b) => e.deleteTag(m)
          }, {
            default: N(() => [
              T("span", null, de(m.text), 1)
            ]),
            _: 2
          }, 1032, ["size", "hit", "closable", "onClose"]))), 128)),
          e.filterable && !e.isDisabled ? Bt((P(), L("input", {
            key: 0,
            "onUpdate:modelValue": t[4] || (t[4] = (m) => e.searchInputValue = m),
            type: "text",
            class: "el-cascader__search-input",
            placeholder: e.presentText ? "" : e.inputPlaceholder,
            onInput: t[5] || (t[5] = (m) => e.handleInput(e.searchInputValue, m)),
            onClick: t[6] || (t[6] = wt((m) => e.togglePopperVisible(!0), ["stop"])),
            onKeydown: t[7] || (t[7] = nn((...m) => e.handleDelete && e.handleDelete(...m), ["delete"])),
            onCompositionstart: t[8] || (t[8] = (...m) => e.handleComposition && e.handleComposition(...m)),
            onCompositionupdate: t[9] || (t[9] = (...m) => e.handleComposition && e.handleComposition(...m)),
            onCompositionend: t[10] || (t[10] = (...m) => e.handleComposition && e.handleComposition(...m))
          }, null, 40, f_)), [
            [G4, e.searchInputValue]
          ]) : re("v-if", !0)
        ], 512)) : re("v-if", !0)
      ], 38)), [
        [y, () => e.togglePopperVisible(!1), e.popperPaneRef]
      ])
    ]),
    content: N(() => [
      Bt(B(f, {
        ref: "panel",
        modelValue: e.checkedValue,
        "onUpdate:modelValue": t[15] || (t[15] = (m) => e.checkedValue = m),
        options: e.options,
        props: e.props,
        border: !1,
        "render-label": e.$slots.default,
        onExpandChange: e.handleExpandChange,
        onClose: t[16] || (t[16] = (m) => e.$nextTick(() => e.togglePopperVisible(!1)))
      }, null, 8, ["modelValue", "options", "props", "render-label", "onExpandChange"]), [
        [Cn, !e.filtering]
      ]),
      e.filterable ? Bt((P(), ue(h, {
        key: 0,
        ref: "suggestionPanel",
        tag: "ul",
        class: "el-cascader__suggestion-panel",
        "view-class": "el-cascader__suggestion-list",
        onKeydown: e.handleSuggestionKeyDown
      }, {
        default: N(() => [
          e.suggestions.length ? (P(!0), L(nt, { key: 0 }, Lt(e.suggestions, (m) => (P(), L("li", {
            key: m.uid,
            class: se([
              "el-cascader__suggestion-item",
              m.checked && "is-checked"
            ]),
            tabindex: -1,
            onClick: (b) => e.handleSuggestionClick(m)
          }, [
            T("span", null, de(m.text), 1),
            m.checked ? (P(), ue(s, { key: 0 }, {
              default: N(() => [
                B(d)
              ]),
              _: 1
            })) : re("v-if", !0)
          ], 10, h_))), 128)) : tt(e.$slots, "empty", { key: 1 }, () => [
            T("li", p_, de(e.t("el.cascader.noMatch")), 1)
          ])
        ]),
        _: 3
      }, 8, ["onKeydown"])), [
        [Cn, e.filtering]
      ]) : re("v-if", !0)
    ]),
    _: 3
  }, 8, ["visible", "teleported", "popper-class", "popper-options", "onHide"]);
}
var $1 = /* @__PURE__ */ vt(c_, [["render", v_]]);
$1.install = (e) => {
  e.component($1.name, $1);
};
const m_ = $1, Ac = m_, g_ = Gt({
  tag: {
    type: String,
    default: "div"
  },
  span: {
    type: Number,
    default: 24
  },
  offset: {
    type: Number,
    default: 0
  },
  pull: {
    type: Number,
    default: 0
  },
  push: {
    type: Number,
    default: 0
  },
  xs: {
    type: jt([Number, Object]),
    default: () => da({})
  },
  sm: {
    type: jt([Number, Object]),
    default: () => da({})
  },
  md: {
    type: jt([Number, Object]),
    default: () => da({})
  },
  lg: {
    type: jt([Number, Object]),
    default: () => da({})
  },
  xl: {
    type: jt([Number, Object]),
    default: () => da({})
  }
});
var y_ = Ee({
  name: "ElCol",
  props: g_,
  setup(e, { slots: t }) {
    const { gutter: n } = ce("ElRow", { gutter: { value: 0 } }), r = Ct("col"), i = J(() => n.value ? {
      paddingLeft: `${n.value / 2}px`,
      paddingRight: `${n.value / 2}px`
    } : {}), a = J(() => {
      const o = [];
      return ["span", "offset", "pull", "push"].forEach((u) => {
        const c = e[u];
        typeof c == "number" && (u === "span" ? o.push(r.b(`${e[u]}`)) : c > 0 && o.push(r.b(`${u}-${e[u]}`)));
      }), ["xs", "sm", "md", "lg", "xl"].forEach((u) => {
        if (typeof e[u] == "number")
          o.push(r.b(`${u}-${e[u]}`));
        else if (typeof e[u] == "object") {
          const c = e[u];
          Object.keys(c).forEach((f) => {
            o.push(f !== "span" ? r.b(`${u}-${f}-${c[f]}`) : r.b(`${u}-${c[f]}`));
          });
        }
      }), n.value && o.push("is-guttered"), o;
    });
    return () => et(e.tag, {
      class: [r.b(), a.value],
      style: i.value
    }, [tt(t, "default")]);
  }
});
const AA = Un(y_), b_ = Ee({
  name: "ElCollapse",
  props: {
    accordion: Boolean,
    modelValue: {
      type: [Array, String, Number],
      default: () => []
    }
  },
  emits: [vn, Tr],
  setup(e, { emit: t }) {
    const n = Ct("collapse"), r = j([].concat(e.modelValue)), i = (o) => {
      r.value = [].concat(o);
      const s = e.accordion ? r.value[0] : r.value;
      t(vn, s), t(Tr, s);
    }, a = (o) => {
      if (e.accordion)
        i((r.value[0] || r.value[0] === 0) && r.value[0] === o ? "" : o);
      else {
        const s = r.value.slice(0), l = s.indexOf(o);
        l > -1 ? s.splice(l, 1) : s.push(o), i(s);
      }
    };
    return Ne(() => e.modelValue, () => {
      r.value = [].concat(e.modelValue);
    }, {
      deep: !0
    }), _t("collapse", {
      activeNames: r,
      handleItemClick: a
    }), {
      ns: n,
      activeNames: r,
      setActiveNames: i,
      handleItemClick: a
    };
  }
});
function A_(e, t, n, r, i, a) {
  return P(), L("div", {
    class: se(e.ns.b()),
    role: "tablist",
    "aria-multiselectable": "true"
  }, [
    tt(e.$slots, "default")
  ], 2);
}
var T_ = /* @__PURE__ */ vt(b_, [["render", A_]]);
const w_ = Ee({
  name: "ElCollapseTransition",
  setup() {
    return {
      ns: Ct("collapse-transition"),
      on: {
        beforeEnter(t) {
          t.dataset || (t.dataset = {}), t.dataset.oldPaddingTop = t.style.paddingTop, t.dataset.oldPaddingBottom = t.style.paddingBottom, t.style.maxHeight = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0;
        },
        enter(t) {
          t.dataset.oldOverflow = t.style.overflow, t.scrollHeight !== 0 ? (t.style.maxHeight = `${t.scrollHeight}px`, t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom) : (t.style.maxHeight = 0, t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom), t.style.overflow = "hidden";
        },
        afterEnter(t) {
          t.style.maxHeight = "", t.style.overflow = t.dataset.oldOverflow;
        },
        beforeLeave(t) {
          t.dataset || (t.dataset = {}), t.dataset.oldPaddingTop = t.style.paddingTop, t.dataset.oldPaddingBottom = t.style.paddingBottom, t.dataset.oldOverflow = t.style.overflow, t.style.maxHeight = `${t.scrollHeight}px`, t.style.overflow = "hidden";
        },
        leave(t) {
          t.scrollHeight !== 0 && (t.style.maxHeight = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0);
        },
        afterLeave(t) {
          t.style.maxHeight = "", t.style.overflow = t.dataset.oldOverflow, t.style.paddingTop = t.dataset.oldPaddingTop, t.style.paddingBottom = t.dataset.oldPaddingBottom;
        }
      }
    };
  }
});
function P_(e, t, n, r, i, a) {
  return P(), ue(wa, $r({
    name: e.ns.b()
  }, ZC(e.on)), {
    default: N(() => [
      tt(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["name"]);
}
var e0 = /* @__PURE__ */ vt(w_, [["render", P_]]);
e0.install = (e) => {
  e.component(e0.name, e0);
};
const w3 = e0, x_ = Ee({
  name: "ElCollapseItem",
  components: { ElCollapseTransition: w3, ElIcon: qt, ArrowRight: es },
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: [String, Number],
      default: () => N0()
    },
    disabled: Boolean
  },
  setup(e) {
    const t = ce("collapse"), n = Ct("collapse"), r = j({
      height: "auto",
      display: "block"
    }), i = j(0), a = j(!1), o = j(!1), s = j(N0());
    return {
      isActive: J(() => (t == null ? void 0 : t.activeNames.value.indexOf(e.name)) > -1),
      contentWrapStyle: r,
      contentHeight: i,
      focusing: a,
      isClick: o,
      id: s,
      ns: n,
      handleFocus: () => {
        setTimeout(() => {
          o.value ? o.value = !1 : a.value = !0;
        }, 50);
      },
      handleHeaderClick: () => {
        e.disabled || (t == null || t.handleItemClick(e.name), a.value = !1, o.value = !0);
      },
      handleEnterClick: () => {
        t == null || t.handleItemClick(e.name);
      },
      collapse: t
    };
  }
}), C_ = ["aria-expanded", "aria-controls", "aria-describedby"], S_ = ["id", "tabindex"], E_ = ["id", "aria-hidden", "aria-labelledby"];
function k_(e, t, n, r, i, a) {
  const o = Ie("arrow-right"), s = Ie("el-icon"), l = Ie("el-collapse-transition");
  return P(), L("div", {
    class: se([
      e.ns.b("item"),
      e.ns.is("active", e.isActive),
      e.ns.is("disabled", e.disabled)
    ])
  }, [
    T("div", {
      role: "tab",
      "aria-expanded": e.isActive,
      "aria-controls": e.ns.b(`content-${e.id}`),
      "aria-describedby": e.ns.b(`content-${e.id}`)
    }, [
      T("div", {
        id: e.ns.b(`head-${e.id}`),
        class: se([
          e.ns.be("item", "header"),
          e.ns.is("active", e.isActive),
          { focusing: e.focusing }
        ]),
        role: "button",
        tabindex: e.disabled ? -1 : 0,
        onClick: t[0] || (t[0] = (...u) => e.handleHeaderClick && e.handleHeaderClick(...u)),
        onKeyup: t[1] || (t[1] = nn(wt((...u) => e.handleEnterClick && e.handleEnterClick(...u), ["stop"]), ["space", "enter"])),
        onFocus: t[2] || (t[2] = (...u) => e.handleFocus && e.handleFocus(...u)),
        onBlur: t[3] || (t[3] = (u) => e.focusing = !1)
      }, [
        tt(e.$slots, "title", {}, () => [
          je(de(e.title), 1)
        ]),
        B(s, {
          class: se([e.ns.be("item", "arrow"), e.ns.is("active", e.isActive)])
        }, {
          default: N(() => [
            B(o)
          ]),
          _: 1
        }, 8, ["class"])
      ], 42, S_)
    ], 8, C_),
    B(l, null, {
      default: N(() => [
        Bt(T("div", {
          id: e.ns.b(`content-${e.id}`),
          class: se(e.ns.be("item", "wrap")),
          role: "tabpanel",
          "aria-hidden": !e.isActive,
          "aria-labelledby": e.ns.b(`head-${e.id}`)
        }, [
          T("div", {
            class: se(e.ns.be("item", "content"))
          }, [
            tt(e.$slots, "default")
          ], 2)
        ], 10, E_), [
          [Cn, e.isActive]
        ])
      ]),
      _: 3
    })
  ], 2);
}
var TA = /* @__PURE__ */ vt(x_, [["render", k_]]);
const wA = Un(T_, {
  CollapseItem: TA
}), PA = Wi(TA), X8 = {}, O_ = Gt({
  locale: {
    type: jt(Object)
  },
  size: {
    type: String,
    values: ["large", "default", "small"]
  },
  button: {
    type: jt(Object)
  },
  message: {
    type: jt(Object)
  },
  zIndex: {
    type: Number
  },
  namespace: {
    type: String,
    default: "el"
  }
});
var z_ = Ee({
  name: "ElConfigProvider",
  props: O_,
  setup(e, { slots: t }) {
    Ne(() => e.message, (r) => {
      Object.assign(X8, r != null ? r : {});
    }, { immediate: !0, deep: !0 });
    const n = rX(e);
    return () => tt(t, "default", { config: n == null ? void 0 : n.value });
  }
});
const D_ = Un(z_);
var xA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r, i) {
      var a = r.prototype, o = a.format;
      i.en.ordinal = function(s) {
        var l = ["th", "st", "nd", "rd"], u = s % 100;
        return "[" + s + (l[(u - 20) % 10] || l[u] || l[0]) + "]";
      }, a.format = function(s) {
        var l = this, u = this.$locale();
        if (!this.isValid())
          return o.bind(this)(s);
        var c = this.$utils(), f = (s || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(d) {
          switch (d) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return u.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return u.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return c.s(l.week(), d === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(l.isoWeek(), d === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(l.$H === 0 ? 24 : l.$H), d === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return d;
          }
        });
        return o.bind(this)(f);
      };
    };
  });
})(xA);
const M_ = xA.exports;
var CA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    var n = "week", r = "year";
    return function(i, a, o) {
      var s = a.prototype;
      s.week = function(l) {
        if (l === void 0 && (l = null), l !== null)
          return this.add(7 * (l - this.week()), "day");
        var u = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var c = o(this).startOf(r).add(1, r).date(u), f = o(this).endOf(n);
          if (c.isBefore(f))
            return 1;
        }
        var d = o(this).startOf(r).date(u).startOf(n).subtract(1, "millisecond"), h = this.diff(d, n, !0);
        return h < 0 ? o(this).startOf("week").week() : Math.ceil(h);
      }, s.weeks = function(l) {
        return l === void 0 && (l = null), this.week(l);
      };
    };
  });
})(CA);
const H_ = CA.exports;
var SA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r) {
      r.prototype.weekYear = function() {
        var i = this.month(), a = this.week(), o = this.year();
        return a === 1 && i === 11 ? o + 1 : i === 0 && a >= 52 ? o - 1 : o;
      };
    };
  });
})(SA);
const I_ = SA.exports;
var EA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r, i) {
      r.prototype.dayOfYear = function(a) {
        var o = Math.round((i(this).startOf("day") - i(this).startOf("year")) / 864e5) + 1;
        return a == null ? o : this.add(a - o, "day");
      };
    };
  });
})(EA);
const L_ = EA.exports;
var kA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r) {
      r.prototype.isSameOrAfter = function(i, a) {
        return this.isSame(i, a) || this.isAfter(i, a);
      };
    };
  });
})(kA);
const B_ = kA.exports;
var OA = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Ir, function() {
    return function(n, r) {
      r.prototype.isSameOrBefore = function(i, a) {
        return this.isSame(i, a) || this.isBefore(i, a);
      };
    };
  });
})(OA);
const N_ = OA.exports, zA = Symbol();
var j_ = Ee({
  name: "ElDatePickerCell",
  props: Gt({
    cell: {
      type: jt(Object)
    }
  }),
  setup(e) {
    const t = ce(zA);
    return () => {
      const n = e.cell;
      if (t != null && t.ctx.slots.default) {
        const r = t.ctx.slots.default(n).filter((i) => i.patchFlag !== -2 && i.type.toString() !== "Symbol(Comment)");
        if (r.length)
          return r;
      }
      return et("div", {
        class: "el-date-table-cell"
      }, [
        et("span", {
          class: "el-date-table-cell__text"
        }, [n == null ? void 0 : n.text])
      ]);
    };
  }
});
const F_ = Ee({
  components: {
    ElDatePickerCell: j_
  },
  props: {
    date: {
      type: Object
    },
    minDate: {
      type: Object
    },
    maxDate: {
      type: Object
    },
    parsedValue: {
      type: [Object, Array]
    },
    selectionMode: {
      type: String,
      default: "day"
    },
    showWeekNumber: {
      type: Boolean,
      default: !1
    },
    disabledDate: {
      type: Function
    },
    cellClassName: {
      type: Function
    },
    rangeState: {
      type: Object,
      default: () => ({
        endDate: null,
        selecting: !1
      })
    }
  },
  emits: ["changerange", "pick", "select"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = j(null), a = j(null), o = j([[], [], [], [], [], []]), s = e.date.$locale().weekStart || 7, l = e.date.locale("en").localeData().weekdaysShort().map((S) => S.toLowerCase()), u = J(() => s > 3 ? 7 - s : -s), c = J(() => {
      const S = e.date.startOf("month");
      return S.subtract(S.day() || 7, "day");
    }), f = J(() => l.concat(l).slice(s, s + 7)), d = J(() => {
      var S;
      const C = e.date.startOf("month"), v = C.day() || 7, H = C.daysInMonth(), V = C.subtract(1, "month").daysInMonth(), R = u.value, F = o.value;
      let K = 1;
      const q = e.selectionMode === "dates" ? wl(e.parsedValue) : [], G = Ut().locale(r.value).startOf("day");
      for (let te = 0; te < 6; te++) {
        const Q = F[te];
        e.showWeekNumber && (Q[0] || (Q[0] = {
          type: "week",
          text: c.value.add(te * 7 + 1, "day").week()
        }));
        for (let Y = 0; Y < 7; Y++) {
          let Z = Q[e.showWeekNumber ? Y + 1 : Y];
          Z || (Z = {
            row: te,
            column: Y,
            type: "normal",
            inRange: !1,
            start: !1,
            end: !1
          });
          const oe = te * 7 + Y, he = c.value.add(oe - R, "day");
          Z.dayjs = he, Z.date = he.toDate(), Z.timestamp = he.valueOf(), Z.type = "normal";
          const Ae = e.rangeState.endDate || e.maxDate || e.rangeState.selecting && e.minDate;
          if (Z.inRange = e.minDate && he.isSameOrAfter(e.minDate, "day") && Ae && he.isSameOrBefore(Ae, "day") || e.minDate && he.isSameOrBefore(e.minDate, "day") && Ae && he.isSameOrAfter(Ae, "day"), (S = e.minDate) != null && S.isSameOrAfter(Ae) ? (Z.start = Ae && he.isSame(Ae, "day"), Z.end = e.minDate && he.isSame(e.minDate, "day")) : (Z.start = e.minDate && he.isSame(e.minDate, "day"), Z.end = Ae && he.isSame(Ae, "day")), he.isSame(G, "day") && (Z.type = "today"), te >= 0 && te <= 1) {
            const Re = v + R < 0 ? 7 + v + R : v + R;
            Y + te * 7 >= Re ? Z.text = K++ : (Z.text = V - (Re - Y % 7) + 1 + te * 7, Z.type = "prev-month");
          } else
            K <= H ? Z.text = K++ : (Z.text = K++ - H, Z.type = "next-month");
          const ke = he.toDate();
          Z.selected = q.find((Re) => Re.valueOf() === he.valueOf()), Z.isSelected = !!Z.selected, Z.isCurrent = h(Z), Z.disabled = e.disabledDate && e.disabledDate(ke), Z.customClass = e.cellClassName && e.cellClassName(ke), Q[e.showWeekNumber ? Y + 1 : Y] = Z;
        }
        if (e.selectionMode === "week") {
          const Y = e.showWeekNumber ? 1 : 0, Z = e.showWeekNumber ? 7 : 6, oe = D(Q[Y + 1]);
          Q[Y].inRange = oe, Q[Y].start = oe, Q[Z].inRange = oe, Q[Z].end = oe;
        }
      }
      return F;
    }), h = (S) => e.selectionMode === "day" && (S.type === "normal" || S.type === "today") && p(S, e.parsedValue), p = (S, C) => C ? Ut(C).locale(r.value).isSame(e.date.date(Number(S.text)), "day") : !1, y = (S) => {
      const C = [];
      return (S.type === "normal" || S.type === "today") && !S.disabled ? (C.push("available"), S.type === "today" && C.push("today")) : C.push(S.type), h(S) && C.push("current"), S.inRange && (S.type === "normal" || S.type === "today" || e.selectionMode === "week") && (C.push("in-range"), S.start && C.push("start-date"), S.end && C.push("end-date")), S.disabled && C.push("disabled"), S.selected && C.push("selected"), S.customClass && C.push(S.customClass), C.join(" ");
    }, m = (S, C) => {
      const v = S * 7 + (C - (e.showWeekNumber ? 1 : 0)) - u.value;
      return c.value.add(v, "day");
    }, b = (S) => {
      if (!e.rangeState.selecting)
        return;
      let C = S.target;
      if (C.tagName === "SPAN" && (C = C.parentNode.parentNode), C.tagName === "DIV" && (C = C.parentNode), C.tagName !== "TD")
        return;
      const v = C.parentNode.rowIndex - 1, H = C.cellIndex;
      d.value[v][H].disabled || (v !== i.value || H !== a.value) && (i.value = v, a.value = H, t.emit("changerange", {
        selecting: !0,
        endDate: m(v, H)
      }));
    }, x = (S) => {
      let C = S.target;
      for (; C && C.tagName !== "TD"; )
        C = C.parentNode;
      if (!C || C.tagName !== "TD")
        return;
      const v = C.parentNode.rowIndex - 1, H = C.cellIndex, V = d.value[v][H];
      if (V.disabled || V.type === "week")
        return;
      const R = m(v, H);
      if (e.selectionMode === "range")
        e.rangeState.selecting ? (R >= e.minDate ? t.emit("pick", { minDate: e.minDate, maxDate: R }) : t.emit("pick", { minDate: R, maxDate: e.minDate }), t.emit("select", !1)) : (t.emit("pick", { minDate: R, maxDate: null }), t.emit("select", !0));
      else if (e.selectionMode === "day")
        t.emit("pick", R);
      else if (e.selectionMode === "week") {
        const F = R.week(), K = `${R.year()}w${F}`;
        t.emit("pick", {
          year: R.year(),
          week: F,
          value: K,
          date: R.startOf("week")
        });
      } else if (e.selectionMode === "dates") {
        const F = V.selected ? wl(e.parsedValue).filter((K) => K.valueOf() !== R.valueOf()) : wl(e.parsedValue).concat([R]);
        t.emit("pick", F);
      }
    }, D = (S) => {
      if (e.selectionMode !== "week")
        return !1;
      let C = e.date.startOf("day");
      if (S.type === "prev-month" && (C = C.subtract(1, "month")), S.type === "next-month" && (C = C.add(1, "month")), C = C.date(parseInt(S.text, 10)), e.parsedValue && !Array.isArray(e.parsedValue)) {
        const v = (e.parsedValue.day() - s + 7) % 7 - 1;
        return e.parsedValue.subtract(v, "day").isSame(C, "day");
      }
      return !1;
    };
    return {
      handleMouseMove: b,
      t: n,
      rows: d,
      isWeekActive: D,
      getCellClasses: y,
      WEEKS: f,
      handleClick: x
    };
  }
}), X_ = { key: 0 };
function R_(e, t, n, r, i, a) {
  const o = Ie("el-date-picker-cell");
  return P(), L("table", {
    cellspacing: "0",
    cellpadding: "0",
    class: se(["el-date-table", { "is-week-mode": e.selectionMode === "week" }]),
    onClick: t[0] || (t[0] = (...s) => e.handleClick && e.handleClick(...s)),
    onMousemove: t[1] || (t[1] = (...s) => e.handleMouseMove && e.handleMouseMove(...s))
  }, [
    T("tbody", null, [
      T("tr", null, [
        e.showWeekNumber ? (P(), L("th", X_, de(e.t("el.datepicker.week")), 1)) : re("v-if", !0),
        (P(!0), L(nt, null, Lt(e.WEEKS, (s, l) => (P(), L("th", { key: l }, de(e.t("el.datepicker.weeks." + s)), 1))), 128))
      ]),
      (P(!0), L(nt, null, Lt(e.rows, (s, l) => (P(), L("tr", {
        key: l,
        class: se(["el-date-table__row", { current: e.isWeekActive(s[1]) }])
      }, [
        (P(!0), L(nt, null, Lt(s, (u, c) => (P(), L("td", {
          key: c,
          class: se(e.getCellClasses(u))
        }, [
          B(o, { cell: u }, null, 8, ["cell"])
        ], 2))), 128))
      ], 2))), 128))
    ])
  ], 34);
}
var DA = /* @__PURE__ */ vt(F_, [["render", R_]]);
const V_ = (e, t, n) => {
  const r = Ut().locale(n).startOf("month").month(t).year(e), i = r.daysInMonth();
  return sA(i).map((a) => r.add(a, "day").toDate());
}, U_ = Ee({
  props: {
    disabledDate: {
      type: Function
    },
    selectionMode: {
      type: String,
      default: "month"
    },
    minDate: {
      type: Object
    },
    maxDate: {
      type: Object
    },
    date: {
      type: Object
    },
    parsedValue: {
      type: Object
    },
    rangeState: {
      type: Object,
      default: () => ({
        endDate: null,
        selecting: !1
      })
    }
  },
  emits: ["changerange", "pick", "select"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = j(e.date.locale("en").localeData().monthsShort().map((d) => d.toLowerCase())), a = j([[], [], []]), o = j(null), s = j(null), l = J(() => {
      var d;
      const h = a.value, p = Ut().locale(r.value).startOf("month");
      for (let y = 0; y < 3; y++) {
        const m = h[y];
        for (let b = 0; b < 4; b++) {
          let x = m[b];
          x || (x = {
            row: y,
            column: b,
            type: "normal",
            inRange: !1,
            start: !1,
            end: !1
          }), x.type = "normal";
          const D = y * 4 + b, S = e.date.startOf("year").month(D), C = e.rangeState.endDate || e.maxDate || e.rangeState.selecting && e.minDate;
          x.inRange = e.minDate && S.isSameOrAfter(e.minDate, "month") && C && S.isSameOrBefore(C, "month") || e.minDate && S.isSameOrBefore(e.minDate, "month") && C && S.isSameOrAfter(C, "month"), (d = e.minDate) != null && d.isSameOrAfter(C) ? (x.start = C && S.isSame(C, "month"), x.end = e.minDate && S.isSame(e.minDate, "month")) : (x.start = e.minDate && S.isSame(e.minDate, "month"), x.end = C && S.isSame(C, "month")), p.isSame(S) && (x.type = "today"), x.text = D;
          const H = S.toDate();
          x.disabled = e.disabledDate && e.disabledDate(H), m[b] = x;
        }
      }
      return h;
    });
    return {
      handleMouseMove: (d) => {
        if (!e.rangeState.selecting)
          return;
        let h = d.target;
        if (h.tagName === "A" && (h = h.parentNode.parentNode), h.tagName === "DIV" && (h = h.parentNode), h.tagName !== "TD")
          return;
        const p = h.parentNode.rowIndex, y = h.cellIndex;
        l.value[p][y].disabled || (p !== o.value || y !== s.value) && (o.value = p, s.value = y, t.emit("changerange", {
          selecting: !0,
          endDate: e.date.startOf("year").month(p * 4 + y)
        }));
      },
      handleMonthTableClick: (d) => {
        let h = d.target;
        if (h.tagName === "A" && (h = h.parentNode.parentNode), h.tagName === "DIV" && (h = h.parentNode), h.tagName !== "TD" || jo(h, "disabled"))
          return;
        const p = h.cellIndex, m = h.parentNode.rowIndex * 4 + p, b = e.date.startOf("year").month(m);
        e.selectionMode === "range" ? e.rangeState.selecting ? (b >= e.minDate ? t.emit("pick", { minDate: e.minDate, maxDate: b }) : t.emit("pick", { minDate: b, maxDate: e.minDate }), t.emit("select", !1)) : (t.emit("pick", { minDate: b, maxDate: null }), t.emit("select", !0)) : t.emit("pick", m);
      },
      rows: l,
      getCellStyle: (d) => {
        const h = {}, p = e.date.year(), y = new Date(), m = d.text;
        return h.disabled = e.disabledDate ? V_(p, m, r.value).every(e.disabledDate) : !1, h.current = wl(e.parsedValue).findIndex((b) => b.year() === p && b.month() === m) >= 0, h.today = y.getFullYear() === p && y.getMonth() === m, d.inRange && (h["in-range"] = !0, d.start && (h["start-date"] = !0), d.end && (h["end-date"] = !0)), h;
      },
      t: n,
      months: i
    };
  }
}), q_ = { class: "cell" };
function __(e, t, n, r, i, a) {
  return P(), L("table", {
    class: "el-month-table",
    onClick: t[0] || (t[0] = (...o) => e.handleMonthTableClick && e.handleMonthTableClick(...o)),
    onMousemove: t[1] || (t[1] = (...o) => e.handleMouseMove && e.handleMouseMove(...o))
  }, [
    T("tbody", null, [
      (P(!0), L(nt, null, Lt(e.rows, (o, s) => (P(), L("tr", { key: s }, [
        (P(!0), L(nt, null, Lt(o, (l, u) => (P(), L("td", {
          key: u,
          class: se(e.getCellStyle(l))
        }, [
          T("div", null, [
            T("a", q_, de(e.t("el.datepicker.months." + e.months[l.text])), 1)
          ])
        ], 2))), 128))
      ]))), 128))
    ])
  ], 32);
}
var MA = /* @__PURE__ */ vt(U_, [["render", __]]);
const W_ = (e, t) => {
  const n = Ut(String(e)).locale(t).startOf("year"), i = n.endOf("year").dayOfYear();
  return sA(i).map((a) => n.add(a, "day").toDate());
}, K_ = Ee({
  props: {
    disabledDate: {
      type: Function
    },
    parsedValue: {
      type: Object
    },
    date: {
      type: Object
    }
  },
  emits: ["pick"],
  setup(e, t) {
    const { lang: n } = hi();
    return {
      startYear: J(() => Math.floor(e.date.year() / 10) * 10),
      getCellStyle: (o) => {
        const s = {}, l = Ut().locale(n.value);
        return s.disabled = e.disabledDate ? W_(o, n.value).every(e.disabledDate) : !1, s.current = wl(e.parsedValue).findIndex((u) => u.year() === o) >= 0, s.today = l.year() === o, s;
      },
      handleYearTableClick: (o) => {
        const s = o.target;
        if (s.tagName === "A") {
          if (jo(s.parentNode, "disabled"))
            return;
          const l = s.textContent || s.innerText;
          t.emit("pick", Number(l));
        }
      }
    };
  }
}), G_ = { class: "cell" }, Y_ = { class: "cell" }, Q_ = { class: "cell" }, Z_ = { class: "cell" }, J_ = { class: "cell" }, $_ = { class: "cell" }, eW = { class: "cell" }, tW = { class: "cell" }, nW = { class: "cell" }, iW = { class: "cell" }, rW = /* @__PURE__ */ T("td", null, null, -1), aW = /* @__PURE__ */ T("td", null, null, -1);
function oW(e, t, n, r, i, a) {
  return P(), L("table", {
    class: "el-year-table",
    onClick: t[0] || (t[0] = (...o) => e.handleYearTableClick && e.handleYearTableClick(...o))
  }, [
    T("tbody", null, [
      T("tr", null, [
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 0)])
        }, [
          T("a", G_, de(e.startYear), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 1)])
        }, [
          T("a", Y_, de(e.startYear + 1), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 2)])
        }, [
          T("a", Q_, de(e.startYear + 2), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 3)])
        }, [
          T("a", Z_, de(e.startYear + 3), 1)
        ], 2)
      ]),
      T("tr", null, [
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 4)])
        }, [
          T("a", J_, de(e.startYear + 4), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 5)])
        }, [
          T("a", $_, de(e.startYear + 5), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 6)])
        }, [
          T("a", eW, de(e.startYear + 6), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 7)])
        }, [
          T("a", tW, de(e.startYear + 7), 1)
        ], 2)
      ]),
      T("tr", null, [
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 8)])
        }, [
          T("a", nW, de(e.startYear + 8), 1)
        ], 2),
        T("td", {
          class: se(["available", e.getCellStyle(e.startYear + 9)])
        }, [
          T("a", iW, de(e.startYear + 9), 1)
        ], 2),
        rW,
        aW
      ])
    ])
  ]);
}
var sW = /* @__PURE__ */ vt(K_, [["render", oW]]);
const lW = (e, t, n) => !0, uW = Ee({
  components: {
    DateTable: DA,
    ElInput: ti,
    ElButton: fn,
    ElIcon: qt,
    TimePickPanel: oA,
    MonthTable: MA,
    YearTable: sW,
    DArrowLeft: Lh,
    ArrowLeft: Ih,
    DArrowRight: Bh,
    ArrowRight: es
  },
  directives: { clickoutside: yc },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    parsedValue: {
      type: [Object, Array]
    },
    format: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: !0,
      validator: hb
    }
  },
  emits: ["pick", "set-picker-option", "panel-change"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = ce("EP_PICKER_BASE"), a = ce(qh), {
      shortcuts: o,
      disabledDate: s,
      cellClassName: l,
      defaultTime: u,
      arrowControl: c
    } = i.props, f = er(i.props, "defaultValue"), d = j(Ut().locale(r.value)), h = J(() => Ut(u).locale(r.value)), p = J(() => d.value.month()), y = J(() => d.value.year()), m = j([]), b = j(null), x = j(null), D = (Le) => m.value.length > 0 ? lW(Le, m.value, e.format || "HH:mm:ss") : !0, S = (Le) => u && !Qe.value ? h.value.year(Le.year()).month(Le.month()).date(Le.date()) : Ae.value ? Le.millisecond(0) : Le.startOf("day"), C = (Le, ...ct) => {
      if (!Le)
        t.emit("pick", Le, ...ct);
      else if (Array.isArray(Le)) {
        const Qt = Le.map(S);
        t.emit("pick", Qt, ...ct);
      } else
        t.emit("pick", S(Le), ...ct);
      b.value = null, x.value = null;
    }, v = (Le) => {
      if (te.value === "day") {
        let ct = e.parsedValue ? e.parsedValue.year(Le.year()).month(Le.month()).date(Le.date()) : Le;
        D(ct) || (ct = m.value[0][0].year(Le.year()).month(Le.month()).date(Le.date())), d.value = ct, C(ct, Ae.value);
      } else
        te.value === "week" ? C(Le.date) : te.value === "dates" && C(Le, !0);
    }, H = () => {
      d.value = d.value.subtract(1, "month"), He("month");
    }, V = () => {
      d.value = d.value.add(1, "month"), He("month");
    }, R = () => {
      K.value === "year" ? d.value = d.value.subtract(10, "year") : d.value = d.value.subtract(1, "year"), He("year");
    }, F = () => {
      K.value === "year" ? d.value = d.value.add(10, "year") : d.value = d.value.add(1, "year"), He("year");
    }, K = j("date"), q = J(() => {
      const Le = n("el.datepicker.year");
      if (K.value === "year") {
        const ct = Math.floor(y.value / 10) * 10;
        return Le ? `${ct} ${Le} - ${ct + 9} ${Le}` : `${ct} - ${ct + 9}`;
      }
      return `${y.value} ${Le}`;
    }), G = (Le) => {
      const ct = typeof Le.value == "function" ? Le.value() : Le.value;
      if (ct) {
        C(Ut(ct).locale(r.value));
        return;
      }
      Le.onClick && Le.onClick(t);
    }, te = J(() => ["week", "month", "year", "dates"].includes(e.type) ? e.type : "day");
    Ne(() => te.value, (Le) => {
      if (["month", "year"].includes(Le)) {
        K.value = Le;
        return;
      }
      K.value = "date";
    }, { immediate: !0 }), Ne(() => K.value, () => {
      a == null || a.updatePopper();
    });
    const Q = J(() => !!o.length), Y = (Le) => {
      d.value = d.value.startOf("month").month(Le), te.value === "month" ? C(d.value) : K.value = "date", He("month");
    }, Z = (Le) => {
      te.value === "year" ? (d.value = d.value.startOf("year").year(Le), C(d.value)) : (d.value = d.value.year(Le), K.value = "month"), He("year");
    }, oe = () => {
      K.value = "month";
    }, he = () => {
      K.value = "year";
    }, Ae = J(() => e.type === "datetime" || e.type === "datetimerange"), We = J(() => Ae.value || te.value === "dates"), ke = () => {
      if (te.value === "dates")
        C(e.parsedValue);
      else {
        let Le = e.parsedValue;
        if (!Le) {
          const ct = Ut(u).locale(r.value), Qt = $e();
          Le = ct.year(Qt.year()).month(Qt.month()).date(Qt.date());
        }
        d.value = Le, C(Le);
      }
    }, Re = () => {
      const ct = Ut().locale(r.value).toDate();
      (!s || !s(ct)) && D(ct) && (d.value = Ut().locale(r.value), C(d.value));
    }, ve = J(() => uA(e.format)), Ye = J(() => lA(e.format)), Qe = J(() => {
      if (x.value)
        return x.value;
      if (!(!e.parsedValue && !f.value))
        return (e.parsedValue || d.value).format(ve.value);
    }), ot = J(() => {
      if (b.value)
        return b.value;
      if (!(!e.parsedValue && !f.value))
        return (e.parsedValue || d.value).format(Ye.value);
    }), Ve = j(!1), Te = () => {
      Ve.value = !0;
    }, Me = () => {
      Ve.value = !1;
    }, Je = (Le, ct, Qt) => {
      const Zt = e.parsedValue ? e.parsedValue.hour(Le.hour()).minute(Le.minute()).second(Le.second()) : Le;
      d.value = Zt, C(d.value, !0), Qt || (Ve.value = ct);
    }, mt = (Le) => {
      const ct = Ut(Le, ve.value).locale(r.value);
      ct.isValid() && D(ct) && (d.value = ct.year(d.value.year()).month(d.value.month()).date(d.value.date()), x.value = null, Ve.value = !1, C(d.value, !0));
    }, It = (Le) => {
      const ct = Ut(Le, Ye.value).locale(r.value);
      if (ct.isValid()) {
        if (s && s(ct.toDate()))
          return;
        d.value = ct.hour(d.value.hour()).minute(d.value.minute()).second(d.value.second()), b.value = null, C(d.value, !0);
      }
    }, ln = (Le) => Ut.isDayjs(Le) && Le.isValid() && (s ? !s(Le.toDate()) : !0), gt = (Le) => te.value === "dates" ? Le.map((ct) => ct.format(e.format)) : Le.format(e.format), Pe = (Le) => Ut(Le, e.format).locale(r.value), $e = () => {
      const Le = Ut(f.value).locale(r.value);
      if (!f.value) {
        const ct = h.value;
        return Ut().hour(ct.hour()).minute(ct.minute()).second(ct.second()).locale(r.value);
      }
      return Le;
    }, Ke = (Le) => {
      const { code: ct, keyCode: Qt } = Le, Zt = [
        yt.up,
        yt.down,
        yt.left,
        yt.right
      ];
      e.visible && !Ve.value && (Zt.includes(ct) && (lt(Qt), Le.stopPropagation(), Le.preventDefault()), ct === yt.enter && b.value === null && x.value === null && C(d, !1));
    }, lt = (Le) => {
      const ct = {
        year: {
          38: -4,
          40: 4,
          37: -1,
          39: 1,
          offset: (Zt, Pn) => Zt.setFullYear(Zt.getFullYear() + Pn)
        },
        month: {
          38: -4,
          40: 4,
          37: -1,
          39: 1,
          offset: (Zt, Pn) => Zt.setMonth(Zt.getMonth() + Pn)
        },
        week: {
          38: -1,
          40: 1,
          37: -1,
          39: 1,
          offset: (Zt, Pn) => Zt.setDate(Zt.getDate() + Pn * 7)
        },
        day: {
          38: -7,
          40: 7,
          37: -1,
          39: 1,
          offset: (Zt, Pn) => Zt.setDate(Zt.getDate() + Pn)
        }
      }, Qt = d.value.toDate();
      for (; Math.abs(d.value.diff(Qt, "year", !0)) < 1; ) {
        const Zt = ct[te.value];
        if (Zt.offset(Qt, Zt[Le]), s && s(Qt))
          continue;
        const Pn = Ut(Qt).locale(r.value);
        d.value = Pn, t.emit("pick", Pn, !0);
        break;
      }
    }, He = (Le) => {
      t.emit("panel-change", d.value.toDate(), Le, K.value);
    };
    return t.emit("set-picker-option", ["isValidValue", ln]), t.emit("set-picker-option", ["formatToString", gt]), t.emit("set-picker-option", ["parseUserInput", Pe]), t.emit("set-picker-option", ["handleKeydown", Ke]), Ne(() => f.value, (Le) => {
      Le && (d.value = $e());
    }, { immediate: !0 }), Ne(() => e.parsedValue, (Le) => {
      if (Le) {
        if (te.value === "dates" || Array.isArray(Le))
          return;
        d.value = Le;
      } else
        d.value = $e();
    }, { immediate: !0 }), {
      handleTimePick: Je,
      handleTimePickClose: Me,
      onTimePickerInputFocus: Te,
      timePickerVisible: Ve,
      visibleTime: Qe,
      visibleDate: ot,
      showTime: Ae,
      changeToNow: Re,
      onConfirm: ke,
      footerVisible: We,
      handleYearPick: Z,
      showMonthPicker: oe,
      showYearPicker: he,
      handleMonthPick: Y,
      hasShortcuts: Q,
      shortcuts: o,
      arrowControl: c,
      disabledDate: s,
      cellClassName: l,
      selectionMode: te,
      handleShortcutClick: G,
      prevYear_: R,
      nextYear_: F,
      prevMonth_: H,
      nextMonth_: V,
      innerDate: d,
      t: n,
      yearLabel: q,
      currentView: K,
      month: p,
      handleDatePick: v,
      handleVisibleTimeChange: mt,
      handleVisibleDateChange: It,
      timeFormat: ve,
      userInputTime: x,
      userInputDate: b
    };
  }
}), cW = { class: "el-picker-panel__body-wrapper" }, dW = {
  key: 0,
  class: "el-picker-panel__sidebar"
}, fW = ["onClick"], hW = { class: "el-picker-panel__body" }, pW = {
  key: 0,
  class: "el-date-picker__time-header"
}, vW = { class: "el-date-picker__editor-wrap" }, mW = { class: "el-date-picker__editor-wrap" }, gW = ["aria-label"], yW = ["aria-label"], bW = ["aria-label"], AW = ["aria-label"], TW = { class: "el-picker-panel__content" }, wW = { class: "el-picker-panel__footer" };
function PW(e, t, n, r, i, a) {
  const o = Ie("el-input"), s = Ie("time-pick-panel"), l = Ie("d-arrow-left"), u = Ie("el-icon"), c = Ie("arrow-left"), f = Ie("d-arrow-right"), d = Ie("arrow-right"), h = Ie("date-table"), p = Ie("year-table"), y = Ie("month-table"), m = Ie("el-button"), b = va("clickoutside");
  return P(), L("div", {
    class: se(["el-picker-panel el-date-picker", [
      {
        "has-sidebar": e.$slots.sidebar || e.hasShortcuts,
        "has-time": e.showTime
      }
    ]])
  }, [
    T("div", cW, [
      tt(e.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      e.hasShortcuts ? (P(), L("div", dW, [
        (P(!0), L(nt, null, Lt(e.shortcuts, (x, D) => (P(), L("button", {
          key: D,
          type: "button",
          class: "el-picker-panel__shortcut",
          onClick: (S) => e.handleShortcutClick(x)
        }, de(x.text), 9, fW))), 128))
      ])) : re("v-if", !0),
      T("div", hW, [
        e.showTime ? (P(), L("div", pW, [
          T("span", vW, [
            B(o, {
              placeholder: e.t("el.datepicker.selectDate"),
              "model-value": e.visibleDate,
              size: "small",
              onInput: t[0] || (t[0] = (x) => e.userInputDate = x),
              onChange: e.handleVisibleDateChange
            }, null, 8, ["placeholder", "model-value", "onChange"])
          ]),
          Bt((P(), L("span", mW, [
            B(o, {
              placeholder: e.t("el.datepicker.selectTime"),
              "model-value": e.visibleTime,
              size: "small",
              onFocus: e.onTimePickerInputFocus,
              onInput: t[1] || (t[1] = (x) => e.userInputTime = x),
              onChange: e.handleVisibleTimeChange
            }, null, 8, ["placeholder", "model-value", "onFocus", "onChange"]),
            B(s, {
              visible: e.timePickerVisible,
              format: e.timeFormat,
              "time-arrow-control": e.arrowControl,
              "parsed-value": e.innerDate,
              onPick: e.handleTimePick
            }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick"])
          ])), [
            [b, e.handleTimePickClose]
          ])
        ])) : re("v-if", !0),
        Bt(T("div", {
          class: se(["el-date-picker__header", {
            "el-date-picker__header--bordered": e.currentView === "year" || e.currentView === "month"
          }])
        }, [
          T("button", {
            type: "button",
            "aria-label": e.t("el.datepicker.prevYear"),
            class: "el-picker-panel__icon-btn el-date-picker__prev-btn d-arrow-left",
            onClick: t[2] || (t[2] = (...x) => e.prevYear_ && e.prevYear_(...x))
          }, [
            B(u, null, {
              default: N(() => [
                B(l)
              ]),
              _: 1
            })
          ], 8, gW),
          Bt(T("button", {
            type: "button",
            "aria-label": e.t("el.datepicker.prevMonth"),
            class: "el-picker-panel__icon-btn el-date-picker__prev-btn arrow-left",
            onClick: t[3] || (t[3] = (...x) => e.prevMonth_ && e.prevMonth_(...x))
          }, [
            B(u, null, {
              default: N(() => [
                B(c)
              ]),
              _: 1
            })
          ], 8, yW), [
            [Cn, e.currentView === "date"]
          ]),
          T("span", {
            role: "button",
            class: "el-date-picker__header-label",
            onClick: t[4] || (t[4] = (...x) => e.showYearPicker && e.showYearPicker(...x))
          }, de(e.yearLabel), 1),
          Bt(T("span", {
            role: "button",
            class: se(["el-date-picker__header-label", { active: e.currentView === "month" }]),
            onClick: t[5] || (t[5] = (...x) => e.showMonthPicker && e.showMonthPicker(...x))
          }, de(e.t(`el.datepicker.month${e.month + 1}`)), 3), [
            [Cn, e.currentView === "date"]
          ]),
          T("button", {
            type: "button",
            "aria-label": e.t("el.datepicker.nextYear"),
            class: "el-picker-panel__icon-btn el-date-picker__next-btn d-arrow-right",
            onClick: t[6] || (t[6] = (...x) => e.nextYear_ && e.nextYear_(...x))
          }, [
            B(u, null, {
              default: N(() => [
                B(f)
              ]),
              _: 1
            })
          ], 8, bW),
          Bt(T("button", {
            type: "button",
            "aria-label": e.t("el.datepicker.nextMonth"),
            class: "el-picker-panel__icon-btn el-date-picker__next-btn arrow-right",
            onClick: t[7] || (t[7] = (...x) => e.nextMonth_ && e.nextMonth_(...x))
          }, [
            B(u, null, {
              default: N(() => [
                B(d)
              ]),
              _: 1
            })
          ], 8, AW), [
            [Cn, e.currentView === "date"]
          ])
        ], 2), [
          [Cn, e.currentView !== "time"]
        ]),
        T("div", TW, [
          e.currentView === "date" ? (P(), ue(h, {
            key: 0,
            "selection-mode": e.selectionMode,
            date: e.innerDate,
            "parsed-value": e.parsedValue,
            "disabled-date": e.disabledDate,
            onPick: e.handleDatePick
          }, null, 8, ["selection-mode", "date", "parsed-value", "disabled-date", "onPick"])) : re("v-if", !0),
          e.currentView === "year" ? (P(), ue(p, {
            key: 1,
            date: e.innerDate,
            "disabled-date": e.disabledDate,
            "parsed-value": e.parsedValue,
            onPick: e.handleYearPick
          }, null, 8, ["date", "disabled-date", "parsed-value", "onPick"])) : re("v-if", !0),
          e.currentView === "month" ? (P(), ue(y, {
            key: 2,
            date: e.innerDate,
            "parsed-value": e.parsedValue,
            "disabled-date": e.disabledDate,
            onPick: e.handleMonthPick
          }, null, 8, ["date", "parsed-value", "disabled-date", "onPick"])) : re("v-if", !0)
        ])
      ])
    ]),
    Bt(T("div", wW, [
      Bt(B(m, {
        size: "small",
        type: "text",
        class: "el-picker-panel__link-btn",
        onClick: e.changeToNow
      }, {
        default: N(() => [
          je(de(e.t("el.datepicker.now")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [Cn, e.selectionMode !== "dates"]
      ]),
      B(m, {
        plain: "",
        size: "small",
        class: "el-picker-panel__link-btn",
        onClick: e.onConfirm
      }, {
        default: N(() => [
          je(de(e.t("el.datepicker.confirm")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 512), [
      [Cn, e.footerVisible && e.currentView === "date"]
    ])
  ], 2);
}
var xW = /* @__PURE__ */ vt(uW, [["render", PW]]);
const CW = Ee({
  directives: { clickoutside: yc },
  components: {
    TimePickPanel: oA,
    DateTable: DA,
    ElInput: ti,
    ElButton: fn,
    ElIcon: qt,
    DArrowLeft: Lh,
    ArrowLeft: Ih,
    DArrowRight: Bh,
    ArrowRight: es
  },
  props: {
    unlinkPanels: Boolean,
    parsedValue: {
      type: Array
    },
    type: {
      type: String,
      required: !0,
      validator: hb
    }
  },
  emits: ["pick", "set-picker-option", "calendar-change", "panel-change"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = j(Ut().locale(r.value)), a = j(Ut().locale(r.value).add(1, "month")), o = j(null), s = j(null), l = j({
      min: null,
      max: null
    }), u = j({
      min: null,
      max: null
    }), c = J(() => `${i.value.year()} ${n("el.datepicker.year")} ${n(`el.datepicker.month${i.value.month() + 1}`)}`), f = J(() => `${a.value.year()} ${n("el.datepicker.year")} ${n(`el.datepicker.month${a.value.month() + 1}`)}`), d = J(() => i.value.year()), h = J(() => i.value.month()), p = J(() => a.value.year()), y = J(() => a.value.month()), m = J(() => !!Qt.length), b = J(() => l.value.min !== null ? l.value.min : o.value ? o.value.format(v.value) : ""), x = J(() => l.value.max !== null ? l.value.max : s.value || o.value ? (s.value || o.value).format(v.value) : ""), D = J(() => u.value.min !== null ? u.value.min : o.value ? o.value.format(C.value) : ""), S = J(() => u.value.max !== null ? u.value.max : s.value || o.value ? (s.value || o.value).format(C.value) : ""), C = J(() => uA(Mn)), v = J(() => lA(Mn)), H = () => {
      i.value = i.value.subtract(1, "year"), e.unlinkPanels || (a.value = i.value.add(1, "month")), Q("year");
    }, V = () => {
      i.value = i.value.subtract(1, "month"), e.unlinkPanels || (a.value = i.value.add(1, "month")), Q("month");
    }, R = () => {
      e.unlinkPanels ? a.value = a.value.add(1, "year") : (i.value = i.value.add(1, "year"), a.value = i.value.add(1, "month")), Q("year");
    }, F = () => {
      e.unlinkPanels ? a.value = a.value.add(1, "month") : (i.value = i.value.add(1, "month"), a.value = i.value.add(1, "month")), Q("month");
    }, K = () => {
      i.value = i.value.add(1, "year"), Q("year");
    }, q = () => {
      i.value = i.value.add(1, "month"), Q("month");
    }, G = () => {
      a.value = a.value.subtract(1, "year"), Q("year");
    }, te = () => {
      a.value = a.value.subtract(1, "month"), Q("month");
    }, Q = (Se) => {
      t.emit("panel-change", [i.value.toDate(), a.value.toDate()], Se);
    }, Y = J(() => {
      const Se = (h.value + 1) % 12, st = h.value + 1 >= 12 ? 1 : 0;
      return e.unlinkPanels && new Date(d.value + st, Se) < new Date(p.value, y.value);
    }), Z = J(() => e.unlinkPanels && p.value * 12 + y.value - (d.value * 12 + h.value + 1) >= 12), oe = (Se) => Array.isArray(Se) && Se[0] && Se[1] && Se[0].valueOf() <= Se[1].valueOf(), he = j({
      endDate: null,
      selecting: !1
    }), Ae = J(() => !(o.value && s.value && !he.value.selecting && oe([o.value, s.value]))), We = (Se) => {
      he.value = Se;
    }, ke = (Se) => {
      he.value.selecting = Se, Se || (he.value.endDate = null);
    }, Re = J(() => e.type === "datetime" || e.type === "datetimerange"), ve = (Se = !1) => {
      oe([o.value, s.value]) && t.emit("pick", [o.value, s.value], Se);
    }, Ye = (Se, st) => {
      if (!!Se)
        return Mt ? Ut(Mt[st] || Mt).locale(r.value).year(Se.year()).month(Se.month()).date(Se.date()) : Se;
    }, Qe = (Se, st = !0) => {
      const kt = Se.minDate, mn = Se.maxDate, cn = Ye(kt, 0), kn = Ye(mn, 1);
      s.value === kn && o.value === cn || (t.emit("calendar-change", [kt.toDate(), mn && mn.toDate()]), s.value = kn, o.value = cn, !(!st || Re.value) && ve());
    }, ot = (Se) => {
      const st = typeof Se.value == "function" ? Se.value() : Se.value;
      if (st) {
        t.emit("pick", [
          Ut(st[0]).locale(r.value),
          Ut(st[1]).locale(r.value)
        ]);
        return;
      }
      Se.onClick && Se.onClick(t);
    }, Ve = j(!1), Te = j(!1), Me = () => {
      Ve.value = !1;
    }, Je = () => {
      Te.value = !1;
    }, mt = (Se, st) => {
      l.value[st] = Se;
      const kt = Ut(Se, v.value).locale(r.value);
      if (kt.isValid()) {
        if (Zt && Zt(kt.toDate()))
          return;
        st === "min" ? (i.value = kt, o.value = (o.value || i.value).year(kt.year()).month(kt.month()).date(kt.date()), e.unlinkPanels || (a.value = kt.add(1, "month"), s.value = o.value.add(1, "month"))) : (a.value = kt, s.value = (s.value || a.value).year(kt.year()).month(kt.month()).date(kt.date()), e.unlinkPanels || (i.value = kt.subtract(1, "month"), o.value = s.value.subtract(1, "month")));
      }
    }, It = (Se, st) => {
      l.value[st] = null;
    }, ln = (Se, st) => {
      u.value[st] = Se;
      const kt = Ut(Se, C.value).locale(r.value);
      kt.isValid() && (st === "min" ? (Ve.value = !0, o.value = (o.value || i.value).hour(kt.hour()).minute(kt.minute()).second(kt.second()), (!s.value || s.value.isBefore(o.value)) && (s.value = o.value)) : (Te.value = !0, s.value = (s.value || a.value).hour(kt.hour()).minute(kt.minute()).second(kt.second()), a.value = s.value, s.value && s.value.isBefore(o.value) && (o.value = s.value)));
    }, gt = (Se, st) => {
      u.value[st] = null, st === "min" ? (i.value = o.value, Ve.value = !1) : (a.value = s.value, Te.value = !1);
    }, Pe = (Se, st, kt) => {
      u.value.min || (Se && (i.value = Se, o.value = (o.value || i.value).hour(Se.hour()).minute(Se.minute()).second(Se.second())), kt || (Ve.value = st), (!s.value || s.value.isBefore(o.value)) && (s.value = o.value, a.value = Se));
    }, $e = (Se, st, kt) => {
      u.value.max || (Se && (a.value = Se, s.value = (s.value || a.value).hour(Se.hour()).minute(Se.minute()).second(Se.second())), kt || (Te.value = st), s.value && s.value.isBefore(o.value) && (o.value = s.value));
    }, Ke = () => {
      i.value = Le()[0], a.value = i.value.add(1, "month"), t.emit("pick", null);
    }, lt = (Se) => Array.isArray(Se) ? Se.map((st) => st.format(Mn)) : Se.format(Mn), He = (Se) => Array.isArray(Se) ? Se.map((st) => Ut(st, Mn).locale(r.value)) : Ut(Se, Mn).locale(r.value), Le = () => {
      let Se;
      if (Array.isArray(Ue.value)) {
        const st = Ut(Ue.value[0]);
        let kt = Ut(Ue.value[1]);
        return e.unlinkPanels || (kt = st.add(1, "month")), [st, kt];
      } else
        Ue.value ? Se = Ut(Ue.value) : Se = Ut();
      return Se = Se.locale(r.value), [Se, Se.add(1, "month")];
    };
    t.emit("set-picker-option", ["isValidValue", oe]), t.emit("set-picker-option", ["parseUserInput", He]), t.emit("set-picker-option", ["formatToString", lt]), t.emit("set-picker-option", ["handleClear", Ke]);
    const ct = ce("EP_PICKER_BASE"), {
      shortcuts: Qt,
      disabledDate: Zt,
      cellClassName: Pn,
      format: Mn,
      defaultTime: Mt,
      arrowControl: Nt,
      clearable: De
    } = ct.props, Ue = er(ct.props, "defaultValue");
    return Ne(() => Ue.value, (Se) => {
      if (Se) {
        const st = Le();
        o.value = null, s.value = null, i.value = st[0], a.value = st[1];
      }
    }, { immediate: !0 }), Ne(() => e.parsedValue, (Se) => {
      if (Se && Se.length === 2)
        if (o.value = Se[0], s.value = Se[1], i.value = o.value, e.unlinkPanels && s.value) {
          const st = o.value.year(), kt = o.value.month(), mn = s.value.year(), cn = s.value.month();
          a.value = st === mn && kt === cn ? s.value.add(1, "month") : s.value;
        } else
          a.value = i.value.add(1, "month"), s.value && (a.value = a.value.hour(s.value.hour()).minute(s.value.minute()).second(s.value.second()));
      else {
        const st = Le();
        o.value = null, s.value = null, i.value = st[0], a.value = st[1];
      }
    }, { immediate: !0 }), {
      shortcuts: Qt,
      disabledDate: Zt,
      cellClassName: Pn,
      minTimePickerVisible: Ve,
      maxTimePickerVisible: Te,
      handleMinTimeClose: Me,
      handleMaxTimeClose: Je,
      handleShortcutClick: ot,
      rangeState: he,
      minDate: o,
      maxDate: s,
      handleRangePick: Qe,
      onSelect: ke,
      handleChangeRange: We,
      btnDisabled: Ae,
      enableYearArrow: Z,
      enableMonthArrow: Y,
      rightPrevMonth: te,
      rightPrevYear: G,
      rightNextMonth: F,
      rightNextYear: R,
      leftPrevMonth: V,
      leftPrevYear: H,
      leftNextMonth: q,
      leftNextYear: K,
      hasShortcuts: m,
      leftLabel: c,
      rightLabel: f,
      leftDate: i,
      rightDate: a,
      showTime: Re,
      t: n,
      minVisibleDate: b,
      maxVisibleDate: x,
      minVisibleTime: D,
      maxVisibleTime: S,
      arrowControl: Nt,
      handleDateInput: mt,
      handleDateChange: It,
      handleTimeInput: ln,
      handleTimeChange: gt,
      handleMinTimePick: Pe,
      handleMaxTimePick: $e,
      handleClear: Ke,
      handleConfirm: ve,
      timeFormat: C,
      clearable: De
    };
  }
}), SW = { class: "el-picker-panel__body-wrapper" }, EW = {
  key: 0,
  class: "el-picker-panel__sidebar"
}, kW = ["onClick"], OW = { class: "el-picker-panel__body" }, zW = {
  key: 0,
  class: "el-date-range-picker__time-header"
}, DW = { class: "el-date-range-picker__editors-wrap" }, MW = { class: "el-date-range-picker__time-picker-wrap" }, HW = { class: "el-date-range-picker__time-picker-wrap" }, IW = { class: "el-date-range-picker__editors-wrap is-right" }, LW = { class: "el-date-range-picker__time-picker-wrap" }, BW = { class: "el-date-range-picker__time-picker-wrap" }, NW = { class: "el-picker-panel__content el-date-range-picker__content is-left" }, jW = { class: "el-date-range-picker__header" }, FW = ["disabled"], XW = ["disabled"], RW = { class: "el-picker-panel__content el-date-range-picker__content is-right" }, VW = { class: "el-date-range-picker__header" }, UW = ["disabled"], qW = ["disabled"], _W = {
  key: 0,
  class: "el-picker-panel__footer"
};
function WW(e, t, n, r, i, a) {
  const o = Ie("el-input"), s = Ie("time-pick-panel"), l = Ie("arrow-right"), u = Ie("el-icon"), c = Ie("d-arrow-left"), f = Ie("arrow-left"), d = Ie("d-arrow-right"), h = Ie("date-table"), p = Ie("el-button"), y = va("clickoutside");
  return P(), L("div", {
    class: se(["el-picker-panel el-date-range-picker", [
      {
        "has-sidebar": e.$slots.sidebar || e.hasShortcuts,
        "has-time": e.showTime
      }
    ]])
  }, [
    T("div", SW, [
      tt(e.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      e.hasShortcuts ? (P(), L("div", EW, [
        (P(!0), L(nt, null, Lt(e.shortcuts, (m, b) => (P(), L("button", {
          key: b,
          type: "button",
          class: "el-picker-panel__shortcut",
          onClick: (x) => e.handleShortcutClick(m)
        }, de(m.text), 9, kW))), 128))
      ])) : re("v-if", !0),
      T("div", OW, [
        e.showTime ? (P(), L("div", zW, [
          T("span", DW, [
            T("span", MW, [
              B(o, {
                size: "small",
                disabled: e.rangeState.selecting,
                placeholder: e.t("el.datepicker.startDate"),
                class: "el-date-range-picker__editor",
                "model-value": e.minVisibleDate,
                onInput: t[0] || (t[0] = (m) => e.handleDateInput(m, "min")),
                onChange: t[1] || (t[1] = (m) => e.handleDateChange(m, "min"))
              }, null, 8, ["disabled", "placeholder", "model-value"])
            ]),
            Bt((P(), L("span", HW, [
              B(o, {
                size: "small",
                class: "el-date-range-picker__editor",
                disabled: e.rangeState.selecting,
                placeholder: e.t("el.datepicker.startTime"),
                "model-value": e.minVisibleTime,
                onFocus: t[2] || (t[2] = (m) => e.minTimePickerVisible = !0),
                onInput: t[3] || (t[3] = (m) => e.handleTimeInput(m, "min")),
                onChange: t[4] || (t[4] = (m) => e.handleTimeChange(m, "min"))
              }, null, 8, ["disabled", "placeholder", "model-value"]),
              B(s, {
                visible: e.minTimePickerVisible,
                format: e.timeFormat,
                "datetime-role": "start",
                "time-arrow-control": e.arrowControl,
                "parsed-value": e.leftDate,
                onPick: e.handleMinTimePick
              }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick"])
            ])), [
              [y, e.handleMinTimeClose]
            ])
          ]),
          T("span", null, [
            B(u, null, {
              default: N(() => [
                B(l)
              ]),
              _: 1
            })
          ]),
          T("span", IW, [
            T("span", LW, [
              B(o, {
                size: "small",
                class: "el-date-range-picker__editor",
                disabled: e.rangeState.selecting,
                placeholder: e.t("el.datepicker.endDate"),
                "model-value": e.maxVisibleDate,
                readonly: !e.minDate,
                onInput: t[5] || (t[5] = (m) => e.handleDateInput(m, "max")),
                onChange: t[6] || (t[6] = (m) => e.handleDateChange(m, "max"))
              }, null, 8, ["disabled", "placeholder", "model-value", "readonly"])
            ]),
            Bt((P(), L("span", BW, [
              B(o, {
                size: "small",
                class: "el-date-range-picker__editor",
                disabled: e.rangeState.selecting,
                placeholder: e.t("el.datepicker.endTime"),
                "model-value": e.maxVisibleTime,
                readonly: !e.minDate,
                onFocus: t[7] || (t[7] = (m) => e.minDate && (e.maxTimePickerVisible = !0)),
                onInput: t[8] || (t[8] = (m) => e.handleTimeInput(m, "max")),
                onChange: t[9] || (t[9] = (m) => e.handleTimeChange(m, "max"))
              }, null, 8, ["disabled", "placeholder", "model-value", "readonly"]),
              B(s, {
                "datetime-role": "end",
                visible: e.maxTimePickerVisible,
                format: e.timeFormat,
                "time-arrow-control": e.arrowControl,
                "parsed-value": e.rightDate,
                onPick: e.handleMaxTimePick
              }, null, 8, ["visible", "format", "time-arrow-control", "parsed-value", "onPick"])
            ])), [
              [y, e.handleMaxTimeClose]
            ])
          ])
        ])) : re("v-if", !0),
        T("div", NW, [
          T("div", jW, [
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn d-arrow-left",
              onClick: t[10] || (t[10] = (...m) => e.leftPrevYear && e.leftPrevYear(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(c)
                ]),
                _: 1
              })
            ]),
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn arrow-left",
              onClick: t[11] || (t[11] = (...m) => e.leftPrevMonth && e.leftPrevMonth(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(f)
                ]),
                _: 1
              })
            ]),
            e.unlinkPanels ? (P(), L("button", {
              key: 0,
              type: "button",
              disabled: !e.enableYearArrow,
              class: se([{ "is-disabled": !e.enableYearArrow }, "el-picker-panel__icon-btn d-arrow-right"]),
              onClick: t[12] || (t[12] = (...m) => e.leftNextYear && e.leftNextYear(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(d)
                ]),
                _: 1
              })
            ], 10, FW)) : re("v-if", !0),
            e.unlinkPanels ? (P(), L("button", {
              key: 1,
              type: "button",
              disabled: !e.enableMonthArrow,
              class: se([{ "is-disabled": !e.enableMonthArrow }, "el-picker-panel__icon-btn arrow-right"]),
              onClick: t[13] || (t[13] = (...m) => e.leftNextMonth && e.leftNextMonth(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(l)
                ]),
                _: 1
              })
            ], 10, XW)) : re("v-if", !0),
            T("div", null, de(e.leftLabel), 1)
          ]),
          B(h, {
            "selection-mode": "range",
            date: e.leftDate,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "range-state": e.rangeState,
            "disabled-date": e.disabledDate,
            "cell-class-name": e.cellClassName,
            onChangerange: e.handleChangeRange,
            onPick: e.handleRangePick,
            onSelect: e.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "onChangerange", "onPick", "onSelect"])
        ]),
        T("div", RW, [
          T("div", VW, [
            e.unlinkPanels ? (P(), L("button", {
              key: 0,
              type: "button",
              disabled: !e.enableYearArrow,
              class: se([{ "is-disabled": !e.enableYearArrow }, "el-picker-panel__icon-btn d-arrow-left"]),
              onClick: t[14] || (t[14] = (...m) => e.rightPrevYear && e.rightPrevYear(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(c)
                ]),
                _: 1
              })
            ], 10, UW)) : re("v-if", !0),
            e.unlinkPanels ? (P(), L("button", {
              key: 1,
              type: "button",
              disabled: !e.enableMonthArrow,
              class: se([{ "is-disabled": !e.enableMonthArrow }, "el-picker-panel__icon-btn arrow-left"]),
              onClick: t[15] || (t[15] = (...m) => e.rightPrevMonth && e.rightPrevMonth(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(f)
                ]),
                _: 1
              })
            ], 10, qW)) : re("v-if", !0),
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn d-arrow-right",
              onClick: t[16] || (t[16] = (...m) => e.rightNextYear && e.rightNextYear(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(d)
                ]),
                _: 1
              })
            ]),
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn arrow-right",
              onClick: t[17] || (t[17] = (...m) => e.rightNextMonth && e.rightNextMonth(...m))
            }, [
              B(u, null, {
                default: N(() => [
                  B(l)
                ]),
                _: 1
              })
            ]),
            T("div", null, de(e.rightLabel), 1)
          ]),
          B(h, {
            "selection-mode": "range",
            date: e.rightDate,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "range-state": e.rangeState,
            "disabled-date": e.disabledDate,
            "cell-class-name": e.cellClassName,
            onChangerange: e.handleChangeRange,
            onPick: e.handleRangePick,
            onSelect: e.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "cell-class-name", "onChangerange", "onPick", "onSelect"])
        ])
      ])
    ]),
    e.showTime ? (P(), L("div", _W, [
      e.clearable ? (P(), ue(p, {
        key: 0,
        size: "small",
        type: "text",
        class: "el-picker-panel__link-btn",
        onClick: e.handleClear
      }, {
        default: N(() => [
          je(de(e.t("el.datepicker.clear")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : re("v-if", !0),
      B(p, {
        plain: "",
        size: "small",
        class: "el-picker-panel__link-btn",
        disabled: e.btnDisabled,
        onClick: t[18] || (t[18] = (m) => e.handleConfirm(!1))
      }, {
        default: N(() => [
          je(de(e.t("el.datepicker.confirm")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])) : re("v-if", !0)
  ], 2);
}
var KW = /* @__PURE__ */ vt(CW, [["render", WW]]);
const GW = Ee({
  components: { MonthTable: MA, ElIcon: qt, DArrowLeft: Lh, DArrowRight: Bh },
  props: {
    unlinkPanels: Boolean,
    parsedValue: {
      type: Array
    }
  },
  emits: ["pick", "set-picker-option"],
  setup(e, t) {
    const { t: n, lang: r } = hi(), i = j(Ut().locale(r.value)), a = j(Ut().locale(r.value).add(1, "year")), o = J(() => !!q.length), s = (Y) => {
      const Z = typeof Y.value == "function" ? Y.value() : Y.value;
      if (Z) {
        t.emit("pick", [
          Ut(Z[0]).locale(r.value),
          Ut(Z[1]).locale(r.value)
        ]);
        return;
      }
      Y.onClick && Y.onClick(t);
    }, l = () => {
      i.value = i.value.subtract(1, "year"), e.unlinkPanels || (a.value = a.value.subtract(1, "year"));
    }, u = () => {
      e.unlinkPanels || (i.value = i.value.add(1, "year")), a.value = a.value.add(1, "year");
    }, c = () => {
      i.value = i.value.add(1, "year");
    }, f = () => {
      a.value = a.value.subtract(1, "year");
    }, d = J(() => `${i.value.year()} ${n("el.datepicker.year")}`), h = J(() => `${a.value.year()} ${n("el.datepicker.year")}`), p = J(() => i.value.year()), y = J(() => a.value.year() === i.value.year() ? i.value.year() + 1 : a.value.year()), m = J(() => e.unlinkPanels && y.value > p.value + 1), b = j(null), x = j(null), D = j({
      endDate: null,
      selecting: !1
    }), S = (Y) => {
      D.value = Y;
    }, C = (Y, Z = !0) => {
      const oe = Y.minDate, he = Y.maxDate;
      x.value === he && b.value === oe || (x.value = he, b.value = oe, Z && H());
    }, v = (Y) => Array.isArray(Y) && Y && Y[0] && Y[1] && Y[0].valueOf() <= Y[1].valueOf(), H = (Y = !1) => {
      v([b.value, x.value]) && t.emit("pick", [b.value, x.value], Y);
    }, V = (Y) => {
      D.value.selecting = Y, Y || (D.value.endDate = null);
    }, R = (Y) => Y.map((Z) => Z.format(te)), F = () => {
      let Y;
      if (Array.isArray(Q.value)) {
        const Z = Ut(Q.value[0]);
        let oe = Ut(Q.value[1]);
        return e.unlinkPanels || (oe = Z.add(1, "year")), [Z, oe];
      } else
        Q.value ? Y = Ut(Q.value) : Y = Ut();
      return Y = Y.locale(r.value), [Y, Y.add(1, "year")];
    };
    t.emit("set-picker-option", ["formatToString", R]);
    const K = ce("EP_PICKER_BASE"), { shortcuts: q, disabledDate: G, format: te } = K.props, Q = er(K.props, "defaultValue");
    return Ne(() => Q.value, (Y) => {
      if (Y) {
        const Z = F();
        i.value = Z[0], a.value = Z[1];
      }
    }, { immediate: !0 }), Ne(() => e.parsedValue, (Y) => {
      if (Y && Y.length === 2)
        if (b.value = Y[0], x.value = Y[1], i.value = b.value, e.unlinkPanels && x.value) {
          const Z = b.value.year(), oe = x.value.year();
          a.value = Z === oe ? x.value.add(1, "year") : x.value;
        } else
          a.value = i.value.add(1, "year");
      else {
        const Z = F();
        b.value = null, x.value = null, i.value = Z[0], a.value = Z[1];
      }
    }, { immediate: !0 }), {
      shortcuts: q,
      disabledDate: G,
      onSelect: V,
      handleRangePick: C,
      rangeState: D,
      handleChangeRange: S,
      minDate: b,
      maxDate: x,
      enableYearArrow: m,
      leftLabel: d,
      rightLabel: h,
      leftNextYear: c,
      leftPrevYear: l,
      rightNextYear: u,
      rightPrevYear: f,
      t: n,
      leftDate: i,
      rightDate: a,
      hasShortcuts: o,
      handleShortcutClick: s
    };
  }
}), YW = { class: "el-picker-panel__body-wrapper" }, QW = {
  key: 0,
  class: "el-picker-panel__sidebar"
}, ZW = ["onClick"], JW = { class: "el-picker-panel__body" }, $W = { class: "el-picker-panel__content el-date-range-picker__content is-left" }, eK = { class: "el-date-range-picker__header" }, tK = ["disabled"], nK = { class: "el-picker-panel__content el-date-range-picker__content is-right" }, iK = { class: "el-date-range-picker__header" }, rK = ["disabled"];
function aK(e, t, n, r, i, a) {
  const o = Ie("d-arrow-left"), s = Ie("el-icon"), l = Ie("d-arrow-right"), u = Ie("month-table");
  return P(), L("div", {
    class: se(["el-picker-panel el-date-range-picker", [
      {
        "has-sidebar": e.$slots.sidebar || e.hasShortcuts
      }
    ]])
  }, [
    T("div", YW, [
      tt(e.$slots, "sidebar", { class: "el-picker-panel__sidebar" }),
      e.hasShortcuts ? (P(), L("div", QW, [
        (P(!0), L(nt, null, Lt(e.shortcuts, (c, f) => (P(), L("button", {
          key: f,
          type: "button",
          class: "el-picker-panel__shortcut",
          onClick: (d) => e.handleShortcutClick(c)
        }, de(c.text), 9, ZW))), 128))
      ])) : re("v-if", !0),
      T("div", JW, [
        T("div", $W, [
          T("div", eK, [
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn d-arrow-left",
              onClick: t[0] || (t[0] = (...c) => e.leftPrevYear && e.leftPrevYear(...c))
            }, [
              B(s, null, {
                default: N(() => [
                  B(o)
                ]),
                _: 1
              })
            ]),
            e.unlinkPanels ? (P(), L("button", {
              key: 0,
              type: "button",
              disabled: !e.enableYearArrow,
              class: se([{ "is-disabled": !e.enableYearArrow }, "el-picker-panel__icon-btn d-arrow-right"]),
              onClick: t[1] || (t[1] = (...c) => e.leftNextYear && e.leftNextYear(...c))
            }, [
              B(s, null, {
                default: N(() => [
                  B(l)
                ]),
                _: 1
              })
            ], 10, tK)) : re("v-if", !0),
            T("div", null, de(e.leftLabel), 1)
          ]),
          B(u, {
            "selection-mode": "range",
            date: e.leftDate,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "range-state": e.rangeState,
            "disabled-date": e.disabledDate,
            onChangerange: e.handleChangeRange,
            onPick: e.handleRangePick,
            onSelect: e.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onPick", "onSelect"])
        ]),
        T("div", nK, [
          T("div", iK, [
            e.unlinkPanels ? (P(), L("button", {
              key: 0,
              type: "button",
              disabled: !e.enableYearArrow,
              class: se([{ "is-disabled": !e.enableYearArrow }, "el-picker-panel__icon-btn d-arrow-left"]),
              onClick: t[2] || (t[2] = (...c) => e.rightPrevYear && e.rightPrevYear(...c))
            }, [
              B(s, null, {
                default: N(() => [
                  B(o)
                ]),
                _: 1
              })
            ], 10, rK)) : re("v-if", !0),
            T("button", {
              type: "button",
              class: "el-picker-panel__icon-btn d-arrow-right",
              onClick: t[3] || (t[3] = (...c) => e.rightNextYear && e.rightNextYear(...c))
            }, [
              B(s, null, {
                default: N(() => [
                  B(l)
                ]),
                _: 1
              })
            ]),
            T("div", null, de(e.rightLabel), 1)
          ]),
          B(u, {
            "selection-mode": "range",
            date: e.rightDate,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "range-state": e.rangeState,
            "disabled-date": e.disabledDate,
            onChangerange: e.handleChangeRange,
            onPick: e.handleRangePick,
            onSelect: e.onSelect
          }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onPick", "onSelect"])
        ])
      ])
    ])
  ], 2);
}
var oK = /* @__PURE__ */ vt(GW, [["render", aK]]);
Ut.extend(LU);
Ut.extend(M_);
Ut.extend(BU);
Ut.extend(H_);
Ut.extend(I_);
Ut.extend(L_);
Ut.extend(B_);
Ut.extend(N_);
const sK = function(e) {
  return e === "daterange" || e === "datetimerange" ? KW : e === "monthrange" ? oK : xW;
};
var lK = Ee({
  name: "ElDatePicker",
  install: null,
  props: {
    ...rA,
    type: {
      type: String,
      default: "date"
    }
  },
  emits: ["update:modelValue"],
  setup(e, t) {
    _t("ElPopperOptions", e.popperOptions), _t(zA, {
      ctx: t
    });
    const n = j(null), r = {
      ...e,
      focus: (i = !0) => {
        var a;
        (a = n.value) == null || a.focus(i);
      }
    };
    return t.expose(r), () => {
      var i;
      const a = (i = e.format) != null ? i : NU[e.type] || rd;
      return et(UU, {
        ...e,
        format: a,
        type: e.type,
        ref: n,
        "onUpdate:modelValue": (o) => t.emit("update:modelValue", o)
      }, {
        default: (o) => et(sK(e.type), o),
        "range-separator": () => tt(t.slots, "range-separator")
      });
    };
  }
});
const t0 = lK;
t0.install = (e) => {
  e.component(t0.name, t0);
};
const uK = t0, cK = Gt({
  mask: {
    type: Boolean,
    default: !0
  },
  customMaskEvent: {
    type: Boolean,
    default: !1
  },
  overlayClass: {
    type: jt([
      String,
      Array,
      Object
    ])
  },
  zIndex: {
    type: jt([String, Number])
  }
}), dK = {
  click: (e) => e instanceof MouseEvent
};
var fK = Ee({
  name: "ElOverlay",
  props: cK,
  emits: dK,
  setup(e, { slots: t, emit: n }) {
    const r = Ct("overlay"), i = (l) => {
      n("click", l);
    }, { onClick: a, onMousedown: o, onMouseup: s } = Pb(e.customMaskEvent ? void 0 : i);
    return () => e.mask ? B("div", {
      class: [r.b(), e.overlayClass],
      style: {
        zIndex: e.zIndex
      },
      onClick: a,
      onMousedown: o,
      onMouseup: s
    }, [tt(t, "default")], K1.STYLE | K1.CLASS | K1.PROPS, ["onClick", "onMouseup", "onMousedown"]) : et("div", {
      class: e.overlayClass,
      style: {
        zIndex: e.zIndex,
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px"
      }
    }, [tt(t, "default")]);
  }
});
const HA = fK, IA = Gt({
  appendToBody: {
    type: Boolean,
    default: !1
  },
  beforeClose: {
    type: jt(Function)
  },
  destroyOnClose: {
    type: Boolean,
    default: !1
  },
  center: {
    type: Boolean,
    default: !1
  },
  customClass: {
    type: String,
    default: ""
  },
  closeIcon: {
    type: ya,
    default: ""
  },
  closeOnClickModal: {
    type: Boolean,
    default: !0
  },
  closeOnPressEscape: {
    type: Boolean,
    default: !0
  },
  fullscreen: {
    type: Boolean,
    default: !1
  },
  draggable: {
    type: Boolean,
    default: !1
  },
  lockScroll: {
    type: Boolean,
    default: !0
  },
  modal: {
    type: Boolean,
    default: !0
  },
  showClose: {
    type: Boolean,
    default: !0
  },
  title: {
    type: String,
    default: ""
  },
  openDelay: {
    type: Number,
    default: 0
  },
  closeDelay: {
    type: Number,
    default: 0
  },
  top: {
    type: String
  },
  modelValue: {
    type: Boolean,
    required: !0
  },
  modalClass: String,
  width: {
    type: [String, Number]
  },
  zIndex: {
    type: Number
  }
}), LA = {
  open: () => !0,
  opened: () => !0,
  close: () => !0,
  closed: () => !0,
  [vn]: (e) => typeof e == "boolean"
}, BA = (e, { emit: t }, n) => {
  let r = "";
  const i = j(!1), a = j(!1), o = j(!1), { nextZIndex: s } = Xh(), l = j(e.zIndex || s());
  let u, c;
  const f = J(() => jn(e.width) ? `${e.width}px` : e.width), d = J(() => {
    const H = {}, V = "--el-dialog";
    return e.fullscreen || (e.top && (H[`${V}-margin-top`] = e.top), e.width && (H[`${V}-width`] = f.value)), H;
  });
  function h() {
    t("opened");
  }
  function p() {
    t("closed"), t(vn, !1), e.destroyOnClose && (o.value = !1);
  }
  function y() {
    t("close");
  }
  function m() {
    c == null || c(), u == null || u(), e.openDelay && e.openDelay > 0 ? { stop: u } = Nd(() => C(), e.openDelay) : C();
  }
  function b() {
    u == null || u(), c == null || c(), e.closeDelay && e.closeDelay > 0 ? { stop: c } = Nd(() => v(), e.closeDelay) : v();
  }
  function x(H) {
    H || (a.value = !0, i.value = !1);
  }
  function D() {
    e.beforeClose ? e.beforeClose(x) : b();
  }
  function S() {
    e.closeOnClickModal && D();
  }
  function C() {
    !Sn || (i.value = !0);
  }
  function v() {
    i.value = !1;
  }
  return e.lockScroll && hX(i), e.closeOnPressEscape && vX({
    handleClose: D
  }, i), mX(i), Ne(() => e.modelValue, (H) => {
    H ? (a.value = !1, m(), o.value = !0, t("open"), l.value = e.zIndex ? l.value++ : s(), bt(() => {
      n.value && (n.value.scrollTop = 0);
    })) : i.value && b();
  }), Ne(() => e.fullscreen, (H) => {
    !n.value || (H ? (r = n.value.style.transform, n.value.style.transform = "") : n.value.style.transform = r);
  }), rn(() => {
    e.modelValue && (i.value = !0, o.value = !0, m());
  }), {
    afterEnter: h,
    afterLeave: p,
    beforeLeave: y,
    handleClose: D,
    onModalClick: S,
    close: b,
    doClose: v,
    closed: a,
    style: d,
    rendered: o,
    visible: i,
    zIndex: l
  };
}, hK = Ee({
  name: "ElDialog",
  components: {
    ElOverlay: HA,
    ElIcon: qt,
    ...YF
  },
  directives: {
    TrapFocus: kb
  },
  props: IA,
  emits: LA,
  setup(e, t) {
    const n = Ct("dialog"), r = j(), i = j(), a = BA(e, t, r), o = Pb(a.onModalClick), s = J(() => e.draggable && !e.fullscreen);
    return sX(r, i, s), {
      ns: n,
      dialogRef: r,
      headerRef: i,
      overlayEvent: o,
      ...a
    };
  }
}), pK = ["aria-label"];
function vK(e, t, n, r, i, a) {
  const o = Ie("el-icon"), s = Ie("el-overlay"), l = va("trap-focus");
  return P(), ue(K4, {
    to: "body",
    disabled: !e.appendToBody
  }, [
    B(wa, {
      name: "dialog-fade",
      onAfterEnter: e.afterEnter,
      onAfterLeave: e.afterLeave,
      onBeforeLeave: e.beforeLeave
    }, {
      default: N(() => [
        Bt(B(s, {
          "custom-mask-event": "",
          mask: e.modal,
          "overlay-class": e.modalClass,
          "z-index": e.zIndex
        }, {
          default: N(() => [
            T("div", {
              class: se(`${e.ns.namespace.value}-overlay-dialog`),
              onClick: t[2] || (t[2] = (...u) => e.overlayEvent.onClick && e.overlayEvent.onClick(...u)),
              onMousedown: t[3] || (t[3] = (...u) => e.overlayEvent.onMousedown && e.overlayEvent.onMousedown(...u)),
              onMouseup: t[4] || (t[4] = (...u) => e.overlayEvent.onMouseup && e.overlayEvent.onMouseup(...u))
            }, [
              Bt((P(), L("div", {
                ref: "dialogRef",
                class: se([
                  e.ns.b(),
                  e.ns.is("fullscreen", e.fullscreen),
                  e.ns.is("draggable", e.draggable),
                  { [e.ns.m("center")]: e.center },
                  e.customClass
                ]),
                "aria-modal": "true",
                role: "dialog",
                "aria-label": e.title || "dialog",
                style: Pt(e.style),
                onClick: t[1] || (t[1] = wt(() => {
                }, ["stop"]))
              }, [
                T("div", {
                  ref: "headerRef",
                  class: se(e.ns.e("header"))
                }, [
                  tt(e.$slots, "title", {}, () => [
                    T("span", {
                      class: se(e.ns.e("title"))
                    }, de(e.title), 3)
                  ]),
                  e.showClose ? (P(), L("button", {
                    key: 0,
                    "aria-label": "close",
                    class: se(e.ns.e("headerbtn")),
                    type: "button",
                    onClick: t[0] || (t[0] = (...u) => e.handleClose && e.handleClose(...u))
                  }, [
                    B(o, {
                      class: se(e.ns.e("close"))
                    }, {
                      default: N(() => [
                        (P(), ue(Ln(e.closeIcon || "close")))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ], 2)) : re("v-if", !0)
                ], 2),
                e.rendered ? (P(), L("div", {
                  key: 0,
                  class: se(e.ns.e("body"))
                }, [
                  tt(e.$slots, "default")
                ], 2)) : re("v-if", !0),
                e.$slots.footer ? (P(), L("div", {
                  key: 1,
                  class: se(e.ns.e("footer"))
                }, [
                  tt(e.$slots, "footer")
                ], 2)) : re("v-if", !0)
              ], 14, pK)), [
                [l]
              ])
            ], 34)
          ]),
          _: 3
        }, 8, ["mask", "overlay-class", "z-index"]), [
          [Cn, e.visible]
        ])
      ]),
      _: 3
    }, 8, ["onAfterEnter", "onAfterLeave", "onBeforeLeave"])
  ], 8, ["disabled"]);
}
var mK = /* @__PURE__ */ vt(hK, [["render", vK]]);
const ni = Un(mK), gK = Gt({
  ...IA,
  direction: {
    type: String,
    default: "rtl",
    values: ["ltr", "rtl", "ttb", "btt"]
  },
  size: {
    type: [String, Number],
    default: "30%"
  },
  withHeader: {
    type: Boolean,
    default: !0
  },
  modalFade: {
    type: Boolean,
    default: !0
  }
}), yK = LA, bK = Ee({
  name: "ElDrawer",
  components: {
    ElOverlay: HA,
    ElIcon: qt,
    Close: Is
  },
  directives: {
    TrapFocus: kb
  },
  props: gK,
  emits: yK,
  setup(e, t) {
    const n = j(), r = Ct("drawer"), i = J(() => e.direction === "rtl" || e.direction === "ltr"), a = J(() => typeof e.size == "number" ? `${e.size}px` : e.size);
    return {
      ...BA(e, t, n),
      drawerRef: n,
      isHorizontal: i,
      drawerSize: a,
      ns: r
    };
  }
}), AK = ["aria-labelledby", "aria-label"], TK = ["id"], wK = ["title"], PK = ["aria-label"];
function xK(e, t, n, r, i, a) {
  const o = Ie("close"), s = Ie("el-icon"), l = Ie("el-overlay"), u = va("trap-focus");
  return P(), ue(K4, {
    to: "body",
    disabled: !e.appendToBody
  }, [
    B(wa, {
      name: e.ns.b("fade"),
      onAfterEnter: e.afterEnter,
      onAfterLeave: e.afterLeave,
      onBeforeLeave: e.beforeLeave
    }, {
      default: N(() => [
        Bt(B(l, {
          mask: e.modal,
          "overlay-class": e.modalClass,
          "z-index": e.zIndex,
          onClick: e.onModalClick
        }, {
          default: N(() => [
            Bt((P(), L("div", {
              ref: "drawerRef",
              "aria-modal": "true",
              "aria-labelledby": e.ns.e("title"),
              "aria-label": e.title,
              class: se([e.ns.b(), e.direction, e.visible && "open", e.customClass]),
              style: Pt(e.isHorizontal ? "width: " + e.drawerSize : "height: " + e.drawerSize),
              role: "dialog",
              onClick: t[1] || (t[1] = wt(() => {
              }, ["stop"]))
            }, [
              e.withHeader ? (P(), L("header", {
                key: 0,
                id: e.ns.e("title"),
                class: se(e.ns.e("header"))
              }, [
                tt(e.$slots, "title", {}, () => [
                  T("span", {
                    role: "heading",
                    title: e.title
                  }, de(e.title), 9, wK)
                ]),
                e.showClose ? (P(), L("button", {
                  key: 0,
                  "aria-label": "close " + (e.title || "drawer"),
                  class: se(e.ns.e("close-btn")),
                  type: "button",
                  onClick: t[0] || (t[0] = (...c) => e.handleClose && e.handleClose(...c))
                }, [
                  B(s, {
                    class: se(e.ns.e("close"))
                  }, {
                    default: N(() => [
                      B(o)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 10, PK)) : re("v-if", !0)
              ], 10, TK)) : re("v-if", !0),
              e.rendered ? (P(), L("section", {
                key: 1,
                class: se(e.ns.e("body"))
              }, [
                tt(e.$slots, "default")
              ], 2)) : re("v-if", !0),
              e.$slots.footer ? (P(), L("div", {
                key: 2,
                class: se(e.ns.e("footer"))
              }, [
                tt(e.$slots, "footer")
              ], 2)) : re("v-if", !0)
            ], 14, AK)), [
              [u]
            ])
          ]),
          _: 3
        }, 8, ["mask", "overlay-class", "z-index", "onClick"]), [
          [Cn, e.visible]
        ])
      ]),
      _: 3
    }, 8, ["name", "onAfterEnter", "onAfterLeave", "onBeforeLeave"])
  ], 8, ["disabled"]);
}
var CK = /* @__PURE__ */ vt(bK, [["render", xK]]);
const SK = Un(CK), NA = (e) => {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}, a7 = (e, t) => {
  for (const n of e)
    if (!EK(n, t))
      return n;
}, EK = (e, t) => {
  if (process.env.NODE_ENV === "test")
    return !1;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, kK = (e) => {
  const t = NA(e), n = a7(t, e), r = a7(t.reverse(), e);
  return [n, r];
}, OK = (e) => e instanceof HTMLInputElement && "select" in e, ul = (e, t) => {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && OK(e) && t && e.select();
  }
};
function o7(e, t) {
  const n = [...e], r = e.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
const zK = () => {
  let e = [];
  return {
    push: (r) => {
      const i = e[0];
      i && r !== i && i.pause(), e = o7(e, r), e.unshift(r);
    },
    remove: (r) => {
      var i, a;
      e = o7(e, r), (a = (i = e[0]) == null ? void 0 : i.resume) == null || a.call(i);
    }
  };
}, DK = (e, t = !1) => {
  const n = document.activeElement;
  for (const r of e)
    if (ul(r, t), document.activeElement !== n)
      return;
}, s7 = zK(), mp = "focus-trap.focus-on-mount", gp = "focus-trap.focus-on-unmount", l7 = {
  cancelable: !0,
  bubbles: !1
}, u7 = "mountOnFocus", c7 = "unmountOnFocus", jA = Symbol("elFocusTrap"), MK = Ee({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean
  },
  emits: [u7, c7],
  setup(e, { emit: t }) {
    const n = j(), r = j(null);
    let i, a;
    const o = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, s = (d) => {
      if (!e.loop && !e.trapped || o.paused)
        return;
      const { key: h, altKey: p, ctrlKey: y, metaKey: m, currentTarget: b, shiftKey: x } = d, { loop: D } = e, S = h === yt.tab && !p && !y && !m, C = document.activeElement;
      if (S && C) {
        const v = b, [H, V] = kK(v);
        H && V ? !x && C === V ? (d.preventDefault(), D && ul(H, !0)) : x && C === H && (d.preventDefault(), D && ul(V, !0)) : C === v && d.preventDefault();
      }
    };
    _t(jA, {
      focusTrapRef: r,
      onKeydown: s
    });
    const l = (d) => {
      t(u7, d);
    }, u = (d) => t(c7, d), c = (d) => {
      const h = E(r);
      if (o.paused || !h)
        return;
      const p = d.target;
      p && h.contains(p) ? a = p : ul(a, !0);
    }, f = (d) => {
      const h = E(r);
      o.paused || !h || h.contains(d.relatedTarget) || ul(a, !0);
    };
    return rn(() => {
      const d = E(r);
      if (d) {
        s7.push(o);
        const h = document.activeElement;
        if (i = h, !d.contains(h)) {
          const y = new Event(mp, l7);
          _n(d, mp, l), d.dispatchEvent(y), y.defaultPrevented || (DK(NA(d), !0), document.activeElement === h && ul(d));
        }
      }
      Ne(() => e.trapped, (h) => {
        h ? (_n(document, "focusin", c), _n(document, "focusout", f)) : (si(document, "focusin", c), si(document, "focusout", f));
      }, { immediate: !0 });
    }), Ti(() => {
      const d = E(r);
      if (d) {
        si(d, mp, l);
        const h = new Event(gp, l7);
        _n(d, gp, u), d.dispatchEvent(h), h.defaultPrevented || ul(i != null ? i : document.body, !0), si(d, gp, u), s7.remove(o);
      }
    }), {
      focusTrapRef: n,
      forwardRef: r,
      onKeydown: s
    };
  }
});
function HK(e, t, n, r, i, a) {
  return tt(e.$slots, "default");
}
var IK = /* @__PURE__ */ vt(MK, [["render", HK]]);
const LK = Ee({
  inheritAttrs: !1
});
function BK(e, t, n, r, i, a) {
  return tt(e.$slots, "default");
}
var NK = /* @__PURE__ */ vt(LK, [["render", BK]]);
const jK = Ee({
  name: "ElCollectionItem",
  inheritAttrs: !1
});
function FK(e, t, n, r, i, a) {
  return tt(e.$slots, "default");
}
var XK = /* @__PURE__ */ vt(jK, [["render", FK]]);
const FA = "data-el-collection-item", XA = (e) => {
  const t = `El${e}Collection`, n = `${t}Item`, r = Symbol(t), i = Symbol(n), a = {
    ...NK,
    name: t,
    setup() {
      const s = j(null), l = /* @__PURE__ */ new Map();
      _t(r, {
        itemMap: l,
        getItems: () => {
          const c = E(s);
          if (!c)
            return [];
          const f = Array.from(c.querySelectorAll(`[${FA}]`));
          return [...l.values()].sort((p, y) => f.indexOf(p.ref) - f.indexOf(y.ref));
        },
        collectionRef: s
      });
    }
  }, o = {
    ...XK,
    name: n,
    setup(s, { attrs: l }) {
      const u = j(null), c = ce(r, void 0);
      _t(i, {
        collectionItemRef: u
      }), rn(() => {
        const f = E(u);
        f && c.itemMap.set(f, {
          ref: f,
          ...l
        });
      }), Ti(() => {
        const f = E(u);
        c.itemMap.delete(f);
      });
    }
  };
  return {
    COLLECTION_INJECTION_KEY: r,
    COLLECTION_ITEM_INJECTION_KEY: i,
    ElCollection: a,
    ElCollectionItem: o
  };
}, RK = Gt({
  style: { type: jt([String, Array, Object]) },
  currentTabId: {
    type: jt(String)
  },
  defaultCurrentTabId: String,
  loop: Boolean,
  dir: {
    type: String,
    values: ["ltr", "rtl"],
    default: "ltr"
  },
  orientation: {
    type: jt(String)
  },
  onBlur: Function,
  onFocus: Function,
  onMousedown: Function
}), {
  ElCollection: VK,
  ElCollectionItem: UK,
  COLLECTION_INJECTION_KEY: P3,
  COLLECTION_ITEM_INJECTION_KEY: qK
} = XA("RovingFocusGroup"), x3 = Symbol("elRovingFocusGroup"), RA = Symbol("elRovingFocusGroupItem"), _K = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
}, WK = (e, t) => {
  if (t !== "rtl")
    return e;
  switch (e) {
    case yt.right:
      return yt.left;
    case yt.left:
      return yt.right;
    default:
      return e;
  }
}, KK = (e, t, n) => {
  const r = WK(e.key, n);
  if (!(t === "vertical" && [yt.left, yt.right].includes(r)) && !(t === "horizontal" && [yt.up, yt.down].includes(r)))
    return _K[r];
}, GK = (e, t) => e.map((n, r) => e[(r + t) % e.length]), C3 = (e) => {
  const { activeElement: t } = document;
  for (const n of e)
    if (n === t || (n.focus(), t !== document.activeElement))
      return;
}, d7 = "currentTabIdChange", yp = "rovingFocusGroup.entryFocus", YK = { bubbles: !1, cancelable: !0 }, QK = Ee({
  name: "ElRovingFocusGroupImpl",
  inheritAttrs: !1,
  props: RK,
  emits: [d7, "entryFocus"],
  setup(e, { emit: t }) {
    var n;
    const r = j((n = e.currentTabId || e.defaultCurrentTabId) != null ? n : null), i = j(!1), a = j(!1), o = j(null), { getItems: s } = ce(P3, void 0), l = J(() => [
      {
        outline: "none"
      },
      e.style
    ]), u = (y) => {
      t(d7, y);
    }, c = () => {
      i.value = !0;
    }, f = Si((y) => {
      var m;
      (m = e.onMousedown) == null || m.call(e, y);
    }, () => {
      a.value = !0;
    }), d = Si((y) => {
      var m;
      (m = e.onFocus) == null || m.call(e, y);
    }, (y) => {
      const m = !E(a), { target: b, currentTarget: x } = y;
      if (b === x && m && !E(i)) {
        const D = new Event(yp, YK);
        if (x == null || x.dispatchEvent(D), !D.defaultPrevented) {
          const S = s().filter((R) => R.focusable), C = S.find((R) => R.active), v = S.find((R) => R.id === E(r)), V = [C, v, ...S].filter(Boolean).map((R) => R.ref);
          C3(V);
        }
      }
      a.value = !1;
    }), h = Si((y) => {
      var m;
      (m = e.onBlur) == null || m.call(e, y);
    }, () => {
      i.value = !1;
    }), p = (...y) => {
      t("entryFocus", ...y);
    };
    _t(x3, {
      currentTabbedId: _4(r),
      loop: er(e, "loop"),
      tabIndex: J(() => E(i) ? -1 : 0),
      rovingFocusGroupRef: o,
      rovingFocusGroupRootStyle: l,
      orientation: er(e, "orientation"),
      dir: er(e, "dir"),
      onItemFocus: u,
      onItemShiftTab: c,
      onBlur: h,
      onFocus: d,
      onMousedown: f
    }), Ne(() => e.currentTabId, (y) => {
      r.value = y != null ? y : null;
    }), rn(() => {
      const y = E(o);
      _n(y, yp, p);
    }), Ti(() => {
      const y = E(o);
      si(y, yp, p);
    });
  }
});
function ZK(e, t, n, r, i, a) {
  return tt(e.$slots, "default");
}
var JK = /* @__PURE__ */ vt(QK, [["render", ZK]]);
const $K = Ee({
  name: "ElRovingFocusGroup",
  components: {
    ElFocusGroupCollection: VK,
    ElRovingFocusGroupImpl: JK
  }
});
function eG(e, t, n, r, i, a) {
  const o = Ie("el-roving-focus-group-impl"), s = Ie("el-focus-group-collection");
  return P(), ue(s, null, {
    default: N(() => [
      B(o, E0(k0(e.$attrs)), {
        default: N(() => [
          tt(e.$slots, "default")
        ]),
        _: 3
      }, 16)
    ]),
    _: 3
  });
}
var tG = /* @__PURE__ */ vt($K, [["render", eG]]);
const nG = Ee({
  components: {
    ElRovingFocusCollectionItem: UK
  },
  props: {
    focusable: {
      type: Boolean,
      default: !0
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["mousedown", "focus", "keydown"],
  setup(e, { emit: t }) {
    const { currentTabbedId: n, loop: r, onItemFocus: i, onItemShiftTab: a } = ce(x3, void 0), { getItems: o } = ce(P3, void 0), s = xb(), l = j(null), u = Si((h) => {
      t("mousedown", h);
    }, (h) => {
      e.focusable ? i(E(s)) : h.preventDefault();
    }), c = Si((h) => {
      t("focus", h);
    }, () => {
      i(E(s));
    }), f = Si((h) => {
      t("keydown", h);
    }, (h) => {
      const { key: p, shiftKey: y, target: m, currentTarget: b } = h;
      if (p === yt.tab && y) {
        a();
        return;
      }
      if (m !== b)
        return;
      const x = KK(h);
      if (x) {
        h.preventDefault();
        let S = o().filter((C) => C.focusable).map((C) => C.ref);
        switch (x) {
          case "last": {
            S.reverse();
            break;
          }
          case "prev":
          case "next": {
            x === "prev" && S.reverse();
            const C = S.indexOf(b);
            S = r.value ? GK(S, C + 1) : S.slice(C + 1);
            break;
          }
        }
        bt(() => {
          C3(S);
        });
      }
    }), d = J(() => n.value === E(s));
    return _t(RA, {
      rovingFocusGroupItemRef: l,
      tabIndex: J(() => E(d) ? 0 : -1),
      handleMousedown: u,
      handleFocus: c,
      handleKeydown: f
    }), {
      id: s,
      handleKeydown: f,
      handleFocus: c,
      handleMousedown: u
    };
  }
});
function iG(e, t, n, r, i, a) {
  const o = Ie("el-roving-focus-collection-item");
  return P(), ue(o, {
    id: e.id,
    focusable: e.focusable,
    active: e.active
  }, {
    default: N(() => [
      tt(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["id", "focusable", "active"]);
}
var rG = /* @__PURE__ */ vt(nG, [["render", iG]]);
const n0 = Gt({
  trigger: Ud.trigger,
  effect: {
    ...zr.effect,
    default: "light"
  },
  type: {
    type: jt(String)
  },
  placement: {
    type: jt(String),
    default: "bottom"
  },
  popperOptions: {
    type: jt(Object),
    default: () => ({})
  },
  size: {
    type: String,
    default: ""
  },
  splitButton: Boolean,
  hideOnClick: {
    type: Boolean,
    default: !0
  },
  loop: {
    type: Boolean
  },
  showTimeout: {
    type: Number,
    default: 150
  },
  hideTimeout: {
    type: Number,
    default: 150
  },
  tabindex: {
    type: jt([Number, String]),
    default: 0
  },
  maxHeight: {
    type: jt([Number, String]),
    default: ""
  },
  popperClass: {
    type: String,
    default: ""
  }
}), VA = Gt({
  command: {
    type: [Object, String, Number],
    default: () => ({})
  },
  disabled: Boolean,
  divided: Boolean,
  textValue: String,
  icon: {
    type: ya
  }
}), aG = Gt({
  onKeydown: { type: jt(Function) }
}), oG = [
  yt.down,
  yt.pageDown,
  yt.home
], UA = [yt.up, yt.pageUp, yt.end], sG = [...oG, ...UA], {
  ElCollection: lG,
  ElCollectionItem: uG,
  COLLECTION_INJECTION_KEY: cG,
  COLLECTION_ITEM_INJECTION_KEY: dG
} = XA("Dropdown"), S3 = Symbol("elDropdown"), { ButtonGroup: fG } = fn, hG = Ee({
  name: "ElDropdown",
  components: {
    ElButton: fn,
    ElFocusTrap: IK,
    ElButtonGroup: fG,
    ElScrollbar: ns,
    ElDropdownCollection: lG,
    ElTooltip: Ki,
    ElRovingFocusGroup: tG,
    ElIcon: qt,
    ArrowDown: vc
  },
  props: n0,
  emits: ["visible-change", "click", "command"],
  setup(e, { emit: t }) {
    const n = sn(), r = Ct("dropdown"), i = j(), a = j(), o = j(null), s = j(null), l = j(null), u = j(null), c = j(!1), f = J(() => ({
      maxHeight: _o(e.maxHeight)
    })), d = J(() => [r.m(m.value)]);
    function h() {
      p();
    }
    function p() {
      var V;
      (V = o.value) == null || V.onClose();
    }
    function y() {
      var V;
      (V = o.value) == null || V.onOpen();
    }
    const m = Bi();
    function b(...V) {
      t("command", ...V);
    }
    function x() {
    }
    function D() {
      const V = E(s);
      V == null || V.focus(), u.value = null;
    }
    function S(V) {
      u.value = V;
    }
    function C(V) {
      c.value || (V.preventDefault(), V.stopImmediatePropagation());
    }
    return _t(S3, {
      contentRef: s,
      isUsingKeyboard: c,
      onItemEnter: x,
      onItemLeave: D
    }), _t("elDropdown", {
      instance: n,
      dropdownSize: m,
      handleClick: h,
      commandHandler: b,
      trigger: er(e, "trigger"),
      hideOnClick: er(e, "hideOnClick")
    }), {
      ns: r,
      scrollbar: l,
      wrapStyle: f,
      dropdownTriggerKls: d,
      dropdownSize: m,
      currentTabId: u,
      handleCurrentTabIdChange: S,
      handlerMainButtonClick: (V) => {
        t("click", V);
      },
      handleEntryFocus: C,
      handleClose: p,
      handleOpen: y,
      onMountOnFocus: (V) => {
        var R, F;
        V.preventDefault(), (F = (R = s.value) == null ? void 0 : R.focus) == null || F.call(R, {
          preventScroll: !0
        });
      },
      popperRef: o,
      triggeringElementRef: i,
      referenceElementRef: a
    };
  }
});
function pG(e, t, n, r, i, a) {
  var o;
  const s = Ie("el-dropdown-collection"), l = Ie("el-roving-focus-group"), u = Ie("el-focus-trap"), c = Ie("el-scrollbar"), f = Ie("el-tooltip"), d = Ie("el-button"), h = Ie("arrow-down"), p = Ie("el-icon"), y = Ie("el-button-group");
  return P(), L("div", {
    class: se(e.ns.b())
  }, [
    B(f, {
      ref: "popperRef",
      effect: e.effect,
      "fallback-placements": ["bottom", "top"],
      "popper-options": e.popperOptions,
      "gpu-acceleration": !1,
      "hide-after": e.hideTimeout,
      "manual-mode": !0,
      placement: e.placement,
      "popper-class": [e.ns.e("popper"), e.popperClass],
      "reference-element": (o = e.referenceElementRef) == null ? void 0 : o.$el,
      trigger: e.trigger,
      "show-after": e.showTimeout,
      "stop-popper-mouse-event": !1,
      "virtual-ref": e.triggeringElementRef,
      "virtual-triggering": e.splitButton,
      "append-to-body": "",
      pure: "",
      transition: `${e.ns.namespace.value}-zoom-in-top`,
      persistent: "",
      onShow: t[0] || (t[0] = (m) => e.$emit("visible-change", !0)),
      onHide: t[1] || (t[1] = (m) => e.$emit("visible-change", !1))
    }, rg({
      content: N(() => [
        B(c, {
          ref: "scrollbar",
          "wrap-style": e.wrapStyle,
          tag: "ul",
          "view-class": e.ns.e("list")
        }, {
          default: N(() => [
            B(u, {
              trapped: "",
              onMountOnFocus: e.onMountOnFocus
            }, {
              default: N(() => [
                B(l, {
                  loop: e.loop,
                  "current-tab-id": e.currentTabId,
                  orientation: "horizontal",
                  onCurrentTabIdChange: e.handleCurrentTabIdChange,
                  onEntryFocus: e.handleEntryFocus
                }, {
                  default: N(() => [
                    B(s, null, {
                      default: N(() => [
                        tt(e.$slots, "dropdown")
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["loop", "current-tab-id", "onCurrentTabIdChange", "onEntryFocus"])
              ]),
              _: 3
            }, 8, ["onMountOnFocus"])
          ]),
          _: 3
        }, 8, ["wrap-style", "view-class"])
      ]),
      _: 2
    }, [
      e.splitButton ? void 0 : {
        name: "default",
        fn: N(() => [
          T("div", {
            class: se(e.dropdownTriggerKls)
          }, [
            tt(e.$slots, "default")
          ], 2)
        ])
      }
    ]), 1032, ["effect", "popper-options", "hide-after", "placement", "popper-class", "reference-element", "trigger", "show-after", "virtual-ref", "virtual-triggering", "transition"]),
    e.splitButton ? (P(), ue(y, { key: 0 }, {
      default: N(() => [
        B(d, {
          ref: "referenceElementRef",
          size: e.dropdownSize,
          type: e.type,
          onClick: e.handlerMainButtonClick
        }, {
          default: N(() => [
            tt(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "type", "onClick"]),
        B(d, {
          ref: "triggeringElementRef",
          size: e.dropdownSize,
          type: e.type,
          class: se(e.ns.e("caret-button"))
        }, {
          default: N(() => [
            B(p, {
              class: se(e.ns.e("icon"))
            }, {
              default: N(() => [
                B(h)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["size", "type", "class"])
      ]),
      _: 3
    })) : re("v-if", !0)
  ], 2);
}
var vG = /* @__PURE__ */ vt(hG, [["render", pG]]);
const mG = Ee({
  name: "DropdownItemImpl",
  components: {
    ElIcon: qt
  },
  props: VA,
  emits: ["pointermove", "pointerleave", "click"],
  setup(e, { emit: t }) {
    const n = Ct("dropdown"), { collectionItemRef: r } = ce(dG, void 0), { collectionItemRef: i } = ce(qK, void 0), {
      rovingFocusGroupItemRef: a,
      tabIndex: o,
      handleFocus: s,
      handleKeydown: l,
      handleMousedown: u
    } = ce(RA, void 0), c = fb(r, i, a), f = Si((d) => {
      const { code: h } = d;
      if (h === yt.enter || h === yt.space)
        return d.preventDefault(), d.stopImmediatePropagation(), t("click", d), !0;
    }, l);
    return {
      ns: n,
      itemRef: c,
      dataset: {
        [FA]: ""
      },
      tabIndex: o,
      handleFocus: s,
      handleKeydown: f,
      handleMousedown: u
    };
  }
}), gG = ["aria-disabled", "tabindex"];
function yG(e, t, n, r, i, a) {
  const o = Ie("el-icon");
  return P(), L(nt, null, [
    e.divided ? (P(), L("div", $r({
      key: 0,
      class: e.ns.bem("menu", "item", "divided")
    }, e.$attrs), null, 16)) : re("v-if", !0),
    T("div", $r({ ref: e.itemRef }, { ...e.dataset, ...e.$attrs }, {
      "aria-disabled": e.disabled,
      class: [e.ns.be("menu", "item"), e.ns.is("disabled", e.disabled)],
      tabindex: e.tabIndex,
      role: "menuitem",
      onClick: t[0] || (t[0] = (s) => e.$emit("click", s)),
      onFocus: t[1] || (t[1] = (...s) => e.handleFocus && e.handleFocus(...s)),
      onKeydown: t[2] || (t[2] = (...s) => e.handleKeydown && e.handleKeydown(...s)),
      onMousedown: t[3] || (t[3] = (...s) => e.handleMousedown && e.handleMousedown(...s)),
      onPointermove: t[4] || (t[4] = (s) => e.$emit("pointermove", s)),
      onPointerleave: t[5] || (t[5] = (s) => e.$emit("pointerleave", s))
    }), [
      e.icon ? (P(), ue(o, { key: 0 }, {
        default: N(() => [
          (P(), ue(Ln(e.icon)))
        ]),
        _: 1
      })) : re("v-if", !0),
      tt(e.$slots, "default")
    ], 16, gG)
  ], 64);
}
var bG = /* @__PURE__ */ vt(mG, [["render", yG]]);
const qA = () => {
  const e = ce("elDropdown", {}), t = J(() => e == null ? void 0 : e.dropdownSize);
  return {
    elDropdown: e,
    _elDropdownSize: t
  };
}, AG = Ee({
  name: "ElDropdownItem",
  components: {
    ElDropdownCollectionItem: uG,
    ElRovingFocusItem: rG,
    ElDropdownItemImpl: bG
  },
  inheritAttrs: !1,
  props: VA,
  emits: ["pointermove", "pointerleave", "click"],
  setup(e, { emit: t, attrs: n }) {
    const { elDropdown: r } = qA(), i = sn(), a = j(null), o = J(() => {
      var h, p;
      return (p = (h = E(a)) == null ? void 0 : h.textContent) != null ? p : "";
    }), { onItemEnter: s, onItemLeave: l } = ce(S3, void 0), u = Si((h) => (t("pointermove", h), h.defaultPrevented), u5((h) => {
      var p;
      e.disabled ? l(h) : (s(h), h.defaultPrevented || (p = h.currentTarget) == null || p.focus());
    })), c = Si((h) => (t("pointerleave", h), h.defaultPrevented), u5((h) => {
      l(h);
    })), f = Si((h) => (t("click", h), h.defaultPrevented), (h) => {
      var p, y, m;
      if (e.disabled) {
        h.stopImmediatePropagation();
        return;
      }
      (p = r == null ? void 0 : r.hideOnClick) != null && p.value && ((y = r.handleClick) == null || y.call(r)), (m = r.commandHandler) == null || m.call(r, e.command, i, h);
    }), d = J(() => ({ ...e, ...n }));
    return {
      handleClick: f,
      handlePointerMove: u,
      handlePointerLeave: c,
      textContent: o,
      propsAndAttrs: d
    };
  }
});
function TG(e, t, n, r, i, a) {
  var o;
  const s = Ie("el-dropdown-item-impl"), l = Ie("el-roving-focus-item"), u = Ie("el-dropdown-collection-item");
  return P(), ue(u, {
    disabled: e.disabled,
    "text-value": (o = e.textValue) != null ? o : e.textContent
  }, {
    default: N(() => [
      B(l, {
        focusable: !e.disabled
      }, {
        default: N(() => [
          B(s, $r(e.propsAndAttrs, {
            onPointerleave: e.handlePointerLeave,
            onPointermove: e.handlePointerMove,
            onClick: e.handleClick
          }), {
            default: N(() => [
              tt(e.$slots, "default")
            ]),
            _: 3
          }, 16, ["onPointerleave", "onPointermove", "onClick"])
        ]),
        _: 3
      }, 8, ["focusable"])
    ]),
    _: 3
  }, 8, ["disabled", "text-value"]);
}
var _A = /* @__PURE__ */ vt(AG, [["render", TG]]);
const wG = Ee({
  name: "ElDropdownMenu",
  props: aG,
  setup(e) {
    const t = Ct("dropdown"), { _elDropdownSize: n } = qA(), r = n.value, { focusTrapRef: i, onKeydown: a } = ce(jA, void 0), { contentRef: o } = ce(S3, void 0), { collectionRef: s, getItems: l } = ce(cG, void 0), {
      rovingFocusGroupRef: u,
      rovingFocusGroupRootStyle: c,
      tabIndex: f,
      onBlur: d,
      onFocus: h,
      onMousedown: p
    } = ce(x3, void 0), { collectionRef: y } = ce(P3, void 0), m = J(() => [t.b("menu"), t.bm("menu", r == null ? void 0 : r.value)]), b = fb(o, s, i, u, y), x = Si((S) => {
      var C;
      (C = e.onKeydown) == null || C.call(e, S);
    }, (S) => {
      const { currentTarget: C, code: v, target: H } = S;
      if (C.contains(H), yt.tab === v && S.stopImmediatePropagation(), S.preventDefault(), H !== E(o) || !sG.includes(v))
        return;
      const R = l().filter((F) => !F.disabled).map((F) => F.ref);
      UA.includes(v) && R.reverse(), C3(R);
    });
    return {
      size: r,
      rovingFocusGroupRootStyle: c,
      tabIndex: f,
      dropdownKls: m,
      dropdownListWrapperRef: b,
      handleKeydown: (S) => {
        x(S), a(S);
      },
      onBlur: d,
      onFocus: h,
      onMousedown: p
    };
  }
});
function PG(e, t, n, r, i, a) {
  return P(), L("ul", {
    ref: e.dropdownListWrapperRef,
    class: se(e.dropdownKls),
    style: Pt(e.rovingFocusGroupRootStyle),
    tabindex: -1,
    role: "menu",
    onBlur: t[0] || (t[0] = (...o) => e.onBlur && e.onBlur(...o)),
    onFocus: t[1] || (t[1] = (...o) => e.onFocus && e.onFocus(...o)),
    onKeydown: t[2] || (t[2] = (...o) => e.handleKeydown && e.handleKeydown(...o)),
    onMousedown: t[3] || (t[3] = (...o) => e.onMousedown && e.onMousedown(...o))
  }, [
    tt(e.$slots, "default")
  ], 38);
}
var WA = /* @__PURE__ */ vt(wG, [["render", PG]]);
const pf = Un(vG, {
  DropdownItem: _A,
  DropdownMenu: WA
}), xG = Wi(_A), vf = Wi(WA);
function CG() {
  const e = j([]), t = J(() => {
    if (!e.value.length)
      return "0";
    const a = Math.max(...e.value);
    return a ? `${a}px` : "";
  });
  function n(a) {
    const o = e.value.indexOf(a);
    return o === -1 && fi("Form", `unexpected width ${a}`), o;
  }
  function r(a, o) {
    if (a && o) {
      const s = n(o);
      e.value.splice(s, 1, a);
    } else
      a && e.value.push(a);
  }
  function i(a) {
    const o = n(a);
    o > -1 && e.value.splice(o, 1);
  }
  return {
    autoLabelWidth: t,
    registerLabelWidth: r,
    deregisterLabelWidth: i
  };
}
const SG = Ee({
  name: "ElForm",
  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: {
      type: [String, Number],
      default: ""
    },
    labelSuffix: {
      type: String,
      default: ""
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: !0
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: !0
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: !1
    },
    scrollToError: Boolean
  },
  emits: ["validate"],
  setup(e, { emit: t }) {
    const n = [];
    Ne(() => e.rules, () => {
      n.forEach((p) => {
        p.evaluateValidationEnabled();
      }), e.validateOnRuleChange && c(() => ({}));
    });
    const r = Bi(), i = "el-form", a = J(() => {
      const { labelPosition: p, inline: y } = e;
      return [
        i,
        `${i}--${r.value}`,
        p ? `${i}--label-${p}` : "",
        y ? `${i}--inline` : ""
      ];
    }), o = (p) => {
      p && n.push(p);
    }, s = (p) => {
      p.prop && n.splice(n.indexOf(p), 1);
    }, l = () => {
      if (!e.model) {
        fi("Form", "model is required for resetFields to work.");
        return;
      }
      n.forEach((p) => {
        p.resetField();
      });
    }, u = (p = []) => {
      (p.length ? typeof p == "string" ? n.filter((m) => p === m.prop) : n.filter((m) => p.indexOf(m.prop) > -1) : n).forEach((m) => {
        m.clearValidate();
      });
    }, c = (p) => {
      if (!e.model) {
        fi("Form", "model is required for validate to work!");
        return;
      }
      let y;
      typeof p != "function" && (y = new Promise((S, C) => {
        p = function(v, H) {
          v ? S(!0) : C(H);
        };
      })), n.length === 0 && p(!0);
      let m = !0, b = 0, x = {}, D;
      for (const S of n)
        S.validate("", (C, v) => {
          C && (m = !1, D || (D = v)), x = { ...x, ...v }, ++b === n.length && p(m, x);
        });
      return !m && e.scrollToError && d(Object.keys(D)[0]), y;
    }, f = (p, y) => {
      p = [].concat(p);
      const m = n.filter((b) => p.indexOf(b.prop) !== -1);
      if (!n.length) {
        fi("Form", "please pass correct props!");
        return;
      }
      m.forEach((b) => {
        b.validate("", y);
      });
    }, d = (p) => {
      n.forEach((y) => {
        var m, b;
        y.prop === p && ((b = (m = y.$el).scrollIntoView) == null || b.call(m));
      });
    }, h = zt({
      ...ma(e),
      resetFields: l,
      clearValidate: u,
      validateField: f,
      emit: t,
      addField: o,
      removeField: s,
      ...CG()
    });
    return _t(Pa, h), {
      formKls: a,
      validate: c,
      resetFields: l,
      clearValidate: u,
      validateField: f,
      scrollToField: d
    };
  }
});
function EG(e, t, n, r, i, a) {
  return P(), L("form", {
    class: se(e.formKls)
  }, [
    tt(e.$slots, "default")
  ], 2);
}
var kG = /* @__PURE__ */ vt(SG, [["render", EG]]);
function gl() {
  return gl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gl.apply(this, arguments);
}
function OG(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, qd(e, t);
}
function R8(e) {
  return R8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, R8(e);
}
function qd(e, t) {
  return qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, qd(e, t);
}
function zG() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function i0(e, t, n) {
  return zG() ? i0 = Reflect.construct.bind() : i0 = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(i, s), u = new l();
    return o && qd(u, o.prototype), u;
  }, i0.apply(null, arguments);
}
function DG(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function V8(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return V8 = function(r) {
    if (r === null || !DG(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return i0(r, arguments, R8(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), qd(i, r);
  }, V8(e);
}
var MG = /%[sdj%]/g, KA = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (KA = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function U8(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function Zr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = 0, a = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var o = e.replace(MG, function(s) {
      if (s === "%%")
        return "%";
      if (i >= a)
        return s;
      switch (s) {
        case "%s":
          return String(n[i++]);
        case "%d":
          return Number(n[i++]);
        case "%j":
          try {
            return JSON.stringify(n[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return o;
  }
  return e;
}
function HG(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function Mi(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || HG(t) && typeof e == "string" && !e);
}
function IG(e, t, n) {
  var r = [], i = 0, a = e.length;
  function o(s) {
    r.push.apply(r, s || []), i++, i === a && n(r);
  }
  e.forEach(function(s) {
    t(s, o);
  });
}
function f7(e, t, n) {
  var r = 0, i = e.length;
  function a(o) {
    if (o && o.length) {
      n(o);
      return;
    }
    var s = r;
    r = r + 1, s < i ? t(e[s], a) : n([]);
  }
  a([]);
}
function LG(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, e[n] || []);
  }), t;
}
var h7 = /* @__PURE__ */ function(e) {
  OG(t, e);
  function t(n, r) {
    var i;
    return i = e.call(this, "Async Validation Error") || this, i.errors = n, i.fields = r, i;
  }
  return t;
}(/* @__PURE__ */ V8(Error));
function BG(e, t, n, r, i) {
  if (t.first) {
    var a = new Promise(function(d, h) {
      var p = function(b) {
        return r(b), b.length ? h(new h7(b, U8(b))) : d(i);
      }, y = LG(e);
      f7(y, n, p);
    });
    return a.catch(function(d) {
      return d;
    }), a;
  }
  var o = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), l = s.length, u = 0, c = [], f = new Promise(function(d, h) {
    var p = function(m) {
      if (c.push.apply(c, m), u++, u === l)
        return r(c), c.length ? h(new h7(c, U8(c))) : d(i);
    };
    s.length || (r(c), d(i)), s.forEach(function(y) {
      var m = e[y];
      o.indexOf(y) !== -1 ? f7(m, n, p) : IG(m, n, p);
    });
  });
  return f.catch(function(d) {
    return d;
  }), f;
}
function NG(e) {
  return !!(e && e.message !== void 0);
}
function jG(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function p7(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = jG(t, e.fullFields) : r = t[n.field || e.fullField], NG(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function v7(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        typeof r == "object" && typeof e[n] == "object" ? e[n] = gl({}, e[n], r) : e[n] = r;
      }
  }
  return e;
}
var GA = function(t, n, r, i, a, o) {
  t.required && (!r.hasOwnProperty(t.field) || Mi(n, o || t.type)) && i.push(Zr(a.messages.required, t.fullField));
}, FG = function(t, n, r, i, a) {
  (/^\s+$/.test(n) || n === "") && i.push(Zr(a.messages.whitespace, t.fullField));
}, m1, XG = function() {
  if (m1)
    return m1;
  var e = "[a-fA-F\\d:]", t = function(S) {
    return S && S.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", i = (`
(?:
(?:` + r + ":){7}(?:" + r + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + r + ":){6}(?:" + n + "|:" + r + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + r + ":){5}(?::" + n + "|(?::" + r + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + r + ":){4}(?:(?::" + r + "){0,1}:" + n + "|(?::" + r + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + r + ":){3}(?:(?::" + r + "){0,2}:" + n + "|(?::" + r + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + r + ":){2}(?:(?::" + r + "){0,3}:" + n + "|(?::" + r + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + r + ":){1}(?:(?::" + r + "){0,4}:" + n + "|(?::" + r + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + r + "){0,5}:" + n + "|(?::" + r + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), a = new RegExp("(?:^" + n + "$)|(?:^" + i + "$)"), o = new RegExp("^" + n + "$"), s = new RegExp("^" + i + "$"), l = function(S) {
    return S && S.exact ? a : new RegExp("(?:" + t(S) + n + t(S) + ")|(?:" + t(S) + i + t(S) + ")", "g");
  };
  l.v4 = function(D) {
    return D && D.exact ? o : new RegExp("" + t(D) + n + t(D), "g");
  }, l.v6 = function(D) {
    return D && D.exact ? s : new RegExp("" + t(D) + i + t(D), "g");
  };
  var u = "(?:(?:[a-z]+:)?//)", c = "(?:\\S+(?::\\S*)?@)?", f = l.v4().source, d = l.v6().source, h = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", p = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", y = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", m = "(?::\\d{2,5})?", b = '(?:[/?#][^\\s"]*)?', x = "(?:" + u + "|www\\.)" + c + "(?:localhost|" + f + "|" + d + "|" + h + p + y + ")" + m + b;
  return m1 = new RegExp("(?:^" + x + "$)", "i"), m1;
}, m7 = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, ad = {
  integer: function(t) {
    return ad.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return ad.number(t) && !ad.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !ad.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(m7.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(XG());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(m7.hex);
  }
}, RG = function(t, n, r, i, a) {
  if (t.required && n === void 0) {
    GA(t, n, r, i, a);
    return;
  }
  var o = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  o.indexOf(s) > -1 ? ad[s](n) || i.push(Zr(a.messages.types[s], t.fullField, t.type)) : s && typeof n !== t.type && i.push(Zr(a.messages.types[s], t.fullField, t.type));
}, VG = function(t, n, r, i, a) {
  var o = typeof t.len == "number", s = typeof t.min == "number", l = typeof t.max == "number", u = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, c = n, f = null, d = typeof n == "number", h = typeof n == "string", p = Array.isArray(n);
  if (d ? f = "number" : h ? f = "string" : p && (f = "array"), !f)
    return !1;
  p && (c = n.length), h && (c = n.replace(u, "_").length), o ? c !== t.len && i.push(Zr(a.messages[f].len, t.fullField, t.len)) : s && !l && c < t.min ? i.push(Zr(a.messages[f].min, t.fullField, t.min)) : l && !s && c > t.max ? i.push(Zr(a.messages[f].max, t.fullField, t.max)) : s && l && (c < t.min || c > t.max) && i.push(Zr(a.messages[f].range, t.fullField, t.min, t.max));
}, su = "enum", UG = function(t, n, r, i, a) {
  t[su] = Array.isArray(t[su]) ? t[su] : [], t[su].indexOf(n) === -1 && i.push(Zr(a.messages[su], t.fullField, t[su].join(", ")));
}, qG = function(t, n, r, i, a) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || i.push(Zr(a.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var o = new RegExp(t.pattern);
      o.test(n) || i.push(Zr(a.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, wn = {
  required: GA,
  whitespace: FG,
  type: RG,
  range: VG,
  enum: UG,
  pattern: qG
}, _G = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n, "string") && !t.required)
      return r();
    wn.required(t, n, i, o, a, "string"), Mi(n, "string") || (wn.type(t, n, i, o, a), wn.range(t, n, i, o, a), wn.pattern(t, n, i, o, a), t.whitespace === !0 && wn.whitespace(t, n, i, o, a));
  }
  r(o);
}, WG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && wn.type(t, n, i, o, a);
  }
  r(o);
}, KG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && (wn.type(t, n, i, o, a), wn.range(t, n, i, o, a));
  }
  r(o);
}, GG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && wn.type(t, n, i, o, a);
  }
  r(o);
}, YG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), Mi(n) || wn.type(t, n, i, o, a);
  }
  r(o);
}, QG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && (wn.type(t, n, i, o, a), wn.range(t, n, i, o, a));
  }
  r(o);
}, ZG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && (wn.type(t, n, i, o, a), wn.range(t, n, i, o, a));
  }
  r(o);
}, JG = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    wn.required(t, n, i, o, a, "array"), n != null && (wn.type(t, n, i, o, a), wn.range(t, n, i, o, a));
  }
  r(o);
}, $G = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && wn.type(t, n, i, o, a);
  }
  r(o);
}, eY = "enum", tY = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a), n !== void 0 && wn[eY](t, n, i, o, a);
  }
  r(o);
}, nY = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n, "string") && !t.required)
      return r();
    wn.required(t, n, i, o, a), Mi(n, "string") || wn.pattern(t, n, i, o, a);
  }
  r(o);
}, iY = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n, "date") && !t.required)
      return r();
    if (wn.required(t, n, i, o, a), !Mi(n, "date")) {
      var l;
      n instanceof Date ? l = n : l = new Date(n), wn.type(t, l, i, o, a), l && wn.range(t, l.getTime(), i, o, a);
    }
  }
  r(o);
}, rY = function(t, n, r, i, a) {
  var o = [], s = Array.isArray(n) ? "array" : typeof n;
  wn.required(t, n, i, o, a, s), r(o);
}, bp = function(t, n, r, i, a) {
  var o = t.type, s = [], l = t.required || !t.required && i.hasOwnProperty(t.field);
  if (l) {
    if (Mi(n, o) && !t.required)
      return r();
    wn.required(t, n, i, s, a, o), Mi(n, o) || wn.type(t, n, i, s, a);
  }
  r(s);
}, aY = function(t, n, r, i, a) {
  var o = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (Mi(n) && !t.required)
      return r();
    wn.required(t, n, i, o, a);
  }
  r(o);
}, Ad = {
  string: _G,
  method: WG,
  number: KG,
  boolean: GG,
  regexp: YG,
  integer: QG,
  float: ZG,
  array: JG,
  object: $G,
  enum: tY,
  pattern: nY,
  date: iY,
  url: bp,
  hex: bp,
  email: bp,
  required: rY,
  any: aY
};
function q8() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var _8 = q8(), mf = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = null, this._messages = _8, this.define(n);
  }
  var t = e.prototype;
  return t.define = function(r) {
    var i = this;
    if (!r)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof r != "object" || Array.isArray(r))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(r).forEach(function(a) {
      var o = r[a];
      i.rules[a] = Array.isArray(o) ? o : [o];
    });
  }, t.messages = function(r) {
    return r && (this._messages = v7(q8(), r)), this._messages;
  }, t.validate = function(r, i, a) {
    var o = this;
    i === void 0 && (i = {}), a === void 0 && (a = function() {
    });
    var s = r, l = i, u = a;
    if (typeof l == "function" && (u = l, l = {}), !this.rules || Object.keys(this.rules).length === 0)
      return u && u(null, s), Promise.resolve(s);
    function c(y) {
      var m = [], b = {};
      function x(S) {
        if (Array.isArray(S)) {
          var C;
          m = (C = m).concat.apply(C, S);
        } else
          m.push(S);
      }
      for (var D = 0; D < y.length; D++)
        x(y[D]);
      m.length ? (b = U8(m), u(m, b)) : u(null, s);
    }
    if (l.messages) {
      var f = this.messages();
      f === _8 && (f = q8()), v7(f, l.messages), l.messages = f;
    } else
      l.messages = this.messages();
    var d = {}, h = l.keys || Object.keys(this.rules);
    h.forEach(function(y) {
      var m = o.rules[y], b = s[y];
      m.forEach(function(x) {
        var D = x;
        typeof D.transform == "function" && (s === r && (s = gl({}, s)), b = s[y] = D.transform(b)), typeof D == "function" ? D = {
          validator: D
        } : D = gl({}, D), D.validator = o.getValidationMethod(D), D.validator && (D.field = y, D.fullField = D.fullField || y, D.type = o.getType(D), d[y] = d[y] || [], d[y].push({
          rule: D,
          value: b,
          source: s,
          field: y
        }));
      });
    });
    var p = {};
    return BG(d, l, function(y, m) {
      var b = y.rule, x = (b.type === "object" || b.type === "array") && (typeof b.fields == "object" || typeof b.defaultField == "object");
      x = x && (b.required || !b.required && y.value), b.field = y.field;
      function D(v, H) {
        return gl({}, H, {
          fullField: b.fullField + "." + v,
          fullFields: b.fullFields ? [].concat(b.fullFields, [v]) : [v]
        });
      }
      function S(v) {
        v === void 0 && (v = []);
        var H = Array.isArray(v) ? v : [v];
        !l.suppressWarning && H.length && e.warning("async-validator:", H), H.length && b.message !== void 0 && (H = [].concat(b.message));
        var V = H.map(p7(b, s));
        if (l.first && V.length)
          return p[b.field] = 1, m(V);
        if (!x)
          m(V);
        else {
          if (b.required && !y.value)
            return b.message !== void 0 ? V = [].concat(b.message).map(p7(b, s)) : l.error && (V = [l.error(b, Zr(l.messages.required, b.field))]), m(V);
          var R = {};
          b.defaultField && Object.keys(y.value).map(function(q) {
            R[q] = b.defaultField;
          }), R = gl({}, R, y.rule.fields);
          var F = {};
          Object.keys(R).forEach(function(q) {
            var G = R[q], te = Array.isArray(G) ? G : [G];
            F[q] = te.map(D.bind(null, q));
          });
          var K = new e(F);
          K.messages(l.messages), y.rule.options && (y.rule.options.messages = l.messages, y.rule.options.error = l.error), K.validate(y.value, y.rule.options || l, function(q) {
            var G = [];
            V && V.length && G.push.apply(G, V), q && q.length && G.push.apply(G, q), m(G.length ? G : null);
          });
        }
      }
      var C;
      if (b.asyncValidator)
        C = b.asyncValidator(b, y.value, S, y.source, l);
      else if (b.validator) {
        try {
          C = b.validator(b, y.value, S, y.source, l);
        } catch (v) {
          console.error == null || console.error(v), l.suppressValidatorError || setTimeout(function() {
            throw v;
          }, 0), S(v.message);
        }
        C === !0 ? S() : C === !1 ? S(typeof b.message == "function" ? b.message(b.fullField || b.field) : b.message || (b.fullField || b.field) + " fails") : C instanceof Array ? S(C) : C instanceof Error && S(C.message);
      }
      C && C.then && C.then(function() {
        return S();
      }, function(v) {
        return S(v);
      });
    }, function(y) {
      c(y);
    }, s);
  }, t.getType = function(r) {
    if (r.type === void 0 && r.pattern instanceof RegExp && (r.type = "pattern"), typeof r.validator != "function" && r.type && !Ad.hasOwnProperty(r.type))
      throw new Error(Zr("Unknown rule type %s", r.type));
    return r.type || "string";
  }, t.getValidationMethod = function(r) {
    if (typeof r.validator == "function")
      return r.validator;
    var i = Object.keys(r), a = i.indexOf("message");
    return a !== -1 && i.splice(a, 1), i.length === 1 && i[0] === "required" ? Ad.required : Ad[this.getType(r)] || void 0;
  }, e;
}();
mf.register = function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  Ad[t] = n;
};
mf.warning = KA;
mf.messages = _8;
mf.validators = Ad;
var oY = Ee({
  name: "ElLabelWrap",
  props: {
    isAutoWidth: Boolean,
    updateAll: Boolean
  },
  setup(e, { slots: t }) {
    const n = j(null), r = ce(Pa), i = ce(ts), a = j(0);
    Ne(a, (c, f) => {
      e.updateAll && (r.registerLabelWidth(c, f), i.updateComputedLabelWidth(c));
    });
    const o = () => {
      var c;
      if ((c = n.value) != null && c.firstElementChild) {
        const f = window.getComputedStyle(n.value.firstElementChild).width;
        return Math.ceil(parseFloat(f));
      } else
        return 0;
    }, s = (c = "update") => {
      bt(() => {
        t.default && e.isAutoWidth && (c === "update" ? a.value = o() : c === "remove" && r.deregisterLabelWidth(a.value));
      });
    }, l = () => s("update");
    rn(() => {
      Xl(n.value.firstElementChild, l), l();
    }), Zo(l), Ti(() => {
      var c;
      s("remove"), Rl((c = n.value) == null ? void 0 : c.firstElementChild, l);
    });
    function u() {
      var c, f;
      if (!t)
        return null;
      if (e.isAutoWidth) {
        const d = r.autoLabelWidth, h = {};
        if (d && d !== "auto") {
          const p = Math.max(0, parseInt(d, 10) - a.value), y = r.labelPosition === "left" ? "marginRight" : "marginLeft";
          p && (h[y] = `${p}px`);
        }
        return et("div", {
          ref: n,
          class: ["el-form-item__label-wrap"],
          style: h
        }, (c = t.default) == null ? void 0 : c.call(t));
      } else
        return et(nt, { ref: n }, (f = t.default) == null ? void 0 : f.call(t));
    }
    return u;
  }
});
const sY = Ee({
  name: "ElFormItem",
  componentName: "ElFormItem",
  components: {
    LabelWrap: oY
  },
  props: {
    label: String,
    labelWidth: {
      type: [String, Number],
      default: ""
    },
    prop: String,
    required: {
      type: Boolean,
      default: void 0
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    for: String,
    inlineMessage: {
      type: [String, Boolean],
      default: ""
    },
    showMessage: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      validator: fo
    }
  },
  setup(e, { slots: t }) {
    const n = ce(Pa, {}), r = j(""), i = j(""), a = j(!1), o = j(""), s = j(), l = sn(), u = J(() => {
      let q = l.parent;
      for (; q && q.type.name !== "ElForm"; ) {
        if (q.type.name === "ElFormItem")
          return !0;
        q = q.parent;
      }
      return !1;
    });
    let c;
    Ne(() => e.error, (q) => {
      i.value = q, r.value = q ? "error" : "";
    }, {
      immediate: !0
    }), Ne(() => e.validateStatus, (q) => {
      r.value = q;
    });
    const f = J(() => e.for || e.prop), d = J(() => {
      const q = {};
      if (n.labelPosition === "top")
        return q;
      const G = _o(e.labelWidth || n.labelWidth);
      return G && (q.width = G), q;
    }), h = J(() => {
      const q = {};
      if (n.labelPosition === "top" || n.inline || !e.label && !e.labelWidth && u.value)
        return q;
      const G = _o(e.labelWidth || n.labelWidth);
      return !e.label && !t.label && (q.marginLeft = G), q;
    }), p = J(() => {
      const q = n.model;
      if (!q || !e.prop)
        return;
      let G = e.prop;
      return G.indexOf(":") !== -1 && (G = G.replace(/:/, ".")), W1(q, G, !0).v;
    }), y = J(() => {
      const q = S();
      let G = !1;
      return q && q.length && q.every((te) => te.required ? (G = !0, !1) : !0), G;
    }), m = Bi(void 0, { formItem: !1 }), b = (q, G = Vn) => {
      if (!a.value) {
        G();
        return;
      }
      const te = C(q);
      if ((!te || te.length === 0) && e.required === void 0) {
        G();
        return;
      }
      r.value = "validating";
      const Q = {};
      te && te.length > 0 && te.forEach((oe) => {
        delete oe.trigger;
      }), Q[e.prop] = te;
      const Y = new mf(Q), Z = {};
      Z[e.prop] = p.value, Y.validate(Z, { firstFields: !0 }, (oe, he) => {
        var Ae;
        r.value = oe ? "error" : "success", i.value = oe ? oe[0].message || `${e.prop} is required` : "", G(i.value, oe ? he : {}), (Ae = n.emit) == null || Ae.call(n, "validate", e.prop, !oe, i.value || null);
      });
    }, x = () => {
      r.value = "", i.value = "";
    }, D = () => {
      const q = n.model, G = p.value;
      let te = e.prop;
      te.indexOf(":") !== -1 && (te = te.replace(/:/, "."));
      const Q = W1(q, te, !0);
      Array.isArray(G) ? Q.o[Q.k] = [].concat(c) : Q.o[Q.k] = c, bt(() => {
        x();
      });
    }, S = () => {
      const q = n.rules, G = e.rules, te = e.required !== void 0 ? { required: !!e.required } : [], Q = W1(q, e.prop || "", !1), Y = q ? Q.o[e.prop || ""] || Q.v : [];
      return [].concat(G || Y || []).concat(te);
    }, C = (q) => S().filter((te) => !te.trigger || q === "" ? !0 : Array.isArray(te.trigger) ? te.trigger.indexOf(q) > -1 : te.trigger === q).map((te) => ({ ...te })), v = () => {
      var q;
      a.value = !!((q = S()) != null && q.length);
    }, H = (q) => {
      o.value = q ? `${q}px` : "";
    }, V = zt({
      ...ma(e),
      size: m,
      validateState: r,
      $el: s,
      evaluateValidationEnabled: v,
      resetField: D,
      clearValidate: x,
      validate: b,
      updateComputedLabelWidth: H
    });
    rn(() => {
      if (e.prop) {
        n == null || n.addField(V);
        const q = p.value;
        c = Array.isArray(q) ? [...q] : q, v();
      }
    }), Ti(() => {
      n == null || n.removeField(V);
    }), _t(ts, V);
    const R = J(() => [
      {
        "el-form-item--feedback": n.statusIcon,
        "is-error": r.value === "error",
        "is-validating": r.value === "validating",
        "is-success": r.value === "success",
        "is-required": y.value || e.required,
        "is-no-asterisk": n.hideRequiredAsterisk
      },
      m.value ? `el-form-item--${m.value}` : ""
    ]), F = J(() => r.value === "error" && e.showMessage && n.showMessage), K = J(() => (e.label || "") + (n.labelSuffix || ""));
    return {
      formItemRef: s,
      formItemClass: R,
      shouldShowError: F,
      elForm: n,
      labelStyle: d,
      contentStyle: h,
      validateMessage: i,
      labelFor: f,
      resetField: D,
      clearValidate: x,
      currentLabel: K
    };
  }
}), lY = ["for"];
function uY(e, t, n, r, i, a) {
  const o = Ie("LabelWrap");
  return P(), L("div", {
    ref: "formItemRef",
    class: se(["el-form-item", e.formItemClass])
  }, [
    B(o, {
      "is-auto-width": e.labelStyle.width === "auto",
      "update-all": e.elForm.labelWidth === "auto"
    }, {
      default: N(() => [
        e.label || e.$slots.label ? (P(), L("label", {
          key: 0,
          for: e.labelFor,
          class: "el-form-item__label",
          style: Pt(e.labelStyle)
        }, [
          tt(e.$slots, "label", { label: e.currentLabel }, () => [
            je(de(e.currentLabel), 1)
          ])
        ], 12, lY)) : re("v-if", !0)
      ]),
      _: 3
    }, 8, ["is-auto-width", "update-all"]),
    T("div", {
      class: "el-form-item__content",
      style: Pt(e.contentStyle)
    }, [
      tt(e.$slots, "default"),
      B(wa, { name: "el-zoom-in-top" }, {
        default: N(() => [
          e.shouldShowError ? tt(e.$slots, "error", {
            key: 0,
            error: e.validateMessage
          }, () => [
            T("div", {
              class: se(["el-form-item__error", {
                "el-form-item__error--inline": typeof e.inlineMessage == "boolean" ? e.inlineMessage : e.elForm.inlineMessage || !1
              }])
            }, de(e.validateMessage), 3)
          ]) : re("v-if", !0)
        ]),
        _: 3
      })
    ], 4)
  ], 2);
}
var YA = /* @__PURE__ */ vt(sY, [["render", uY]]);
const Ca = Un(kG, {
  FormItem: YA
}), Sa = Wi(YA), cY = Gt({
  step: {
    type: Number,
    default: 1
  },
  stepStrictly: {
    type: Boolean,
    default: !1
  },
  max: {
    type: Number,
    default: 1 / 0
  },
  min: {
    type: Number,
    default: -1 / 0
  },
  modelValue: {
    type: Number
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  size: {
    type: String,
    values: c3
  },
  controls: {
    type: Boolean,
    default: !0
  },
  controlsPosition: {
    type: String,
    default: "",
    values: ["", "right"]
  },
  name: String,
  label: String,
  placeholder: String,
  precision: {
    type: Number,
    validator: (e) => e >= 0 && e === parseInt(`${e}`, 10)
  }
}), dY = {
  change: (e, t) => e !== t,
  blur: (e) => e instanceof FocusEvent,
  focus: (e) => e instanceof FocusEvent,
  input: (e) => jn(e),
  "update:modelValue": (e) => jn(e) || e === void 0
}, fY = Ee({
  name: "ElInputNumber",
  components: {
    ElInput: ti,
    ElIcon: qt,
    ArrowUp: uf,
    ArrowDown: vc,
    Plus: ub,
    Minus: uF
  },
  directives: {
    RepeatClick: Eb
  },
  props: cY,
  emits: dY,
  setup(e, { emit: t }) {
    const n = j(), r = zt({
      currentValue: e.modelValue,
      userInput: null
    }), { formItem: i } = gc(), a = Ct("input-number"), o = J(() => m(e.modelValue) < e.min), s = J(() => y(e.modelValue) > e.max), l = J(() => {
      const F = p(e.step);
      return e.precision !== void 0 ? (F > e.precision && fi("InputNumber", "precision should not be less than the decimal places of step"), e.precision) : Math.max(p(e.modelValue), F);
    }), u = J(() => e.controls && e.controlsPosition === "right"), c = Bi(), f = cf(), d = J(() => {
      if (r.userInput !== null)
        return r.userInput;
      let F = r.currentValue;
      if (jn(F)) {
        if (Number.isNaN(F))
          return "";
        e.precision !== void 0 && (F = F.toFixed(e.precision));
      }
      return F;
    }), h = (F, K) => (K === void 0 && (K = l.value), parseFloat(`${Math.round(F * Math.pow(10, K)) / Math.pow(10, K)}`)), p = (F) => {
      if (F === void 0)
        return 0;
      const K = F.toString(), q = K.indexOf(".");
      let G = 0;
      return q !== -1 && (G = K.length - q - 1), G;
    }, y = (F) => {
      if (!jn(F))
        return r.currentValue;
      const K = Math.pow(10, l.value);
      return F = jn(F) ? F : NaN, h((K * F + K * e.step) / K);
    }, m = (F) => {
      if (!jn(F))
        return r.currentValue;
      const K = Math.pow(10, l.value);
      return F = jn(F) ? F : NaN, h((K * F - K * e.step) / K);
    }, b = () => {
      if (f.value || s.value)
        return;
      const F = e.modelValue || 0, K = y(F);
      D(K);
    }, x = () => {
      if (f.value || o.value)
        return;
      const F = e.modelValue || 0, K = m(F);
      D(K);
    }, D = (F) => {
      var K;
      const q = r.currentValue;
      typeof F == "number" && e.precision !== void 0 && (F = h(F, e.precision)), F !== void 0 && F >= e.max && (F = e.max), F !== void 0 && F <= e.min && (F = e.min), q !== F && (jn(F) || (F = void 0), r.userInput = null, t("update:modelValue", F), t("input", F), t("change", F, q), (K = i == null ? void 0 : i.validate) == null || K.call(i, "change"), r.currentValue = F);
    }, S = (F) => r.userInput = F, C = (F) => {
      const K = F !== "" ? Number(F) : "";
      (jn(K) && !Number.isNaN(K) || F === "") && D(K), r.userInput = null;
    }, v = () => {
      var F, K;
      (K = (F = n.value) == null ? void 0 : F.focus) == null || K.call(F);
    }, H = () => {
      var F, K;
      (K = (F = n.value) == null ? void 0 : F.blur) == null || K.call(F);
    }, V = (F) => {
      t("focus", F);
    }, R = (F) => {
      var K;
      t("blur", F), (K = i == null ? void 0 : i.validate) == null || K.call(i, "blur");
    };
    return Ne(() => e.modelValue, (F) => {
      let K = Number(F);
      if (F === null && (K = Number.NaN), !isNaN(K)) {
        if (e.stepStrictly) {
          const q = p(e.step), G = Math.pow(10, q);
          K = Math.round(K / e.step) * G * e.step / G;
        }
        e.precision !== void 0 && (K = h(K, e.precision)), K > e.max && (K = e.max, t("update:modelValue", K)), K < e.min && (K = e.min, t("update:modelValue", K));
      }
      r.currentValue = K, r.userInput = null;
    }, { immediate: !0 }), rn(() => {
      var F;
      const K = (F = n.value) == null ? void 0 : F.input;
      if (K.setAttribute("role", "spinbutton"), K.setAttribute("aria-valuemax", String(e.max)), K.setAttribute("aria-valuemin", String(e.min)), K.setAttribute("aria-valuenow", String(r.currentValue)), K.setAttribute("aria-disabled", String(f.value)), !jn(e.modelValue)) {
        let q = Number(e.modelValue);
        isNaN(q) && (q = void 0), t("update:modelValue", q);
      }
    }), Zo(() => {
      var F;
      const K = (F = n.value) == null ? void 0 : F.input;
      K == null || K.setAttribute("aria-valuenow", r.currentValue);
    }), {
      input: n,
      displayValue: d,
      handleInput: S,
      handleInputChange: C,
      controlsAtRight: u,
      decrease: x,
      increase: b,
      inputNumberSize: c,
      inputNumberDisabled: f,
      maxDisabled: s,
      minDisabled: o,
      focus: v,
      blur: H,
      handleFocus: V,
      handleBlur: R,
      ns: a
    };
  }
});
function hY(e, t, n, r, i, a) {
  const o = Ie("arrow-down"), s = Ie("minus"), l = Ie("el-icon"), u = Ie("arrow-up"), c = Ie("plus"), f = Ie("el-input"), d = va("repeat-click");
  return P(), L("div", {
    class: se([
      e.ns.b(),
      e.ns.m(e.inputNumberSize),
      e.ns.is("disabled", e.inputNumberDisabled),
      e.ns.is("without-controls", !e.controls),
      e.ns.is("controls-right", e.controlsAtRight)
    ]),
    onDragstart: t[2] || (t[2] = wt(() => {
    }, ["prevent"]))
  }, [
    e.controls ? Bt((P(), L("span", {
      key: 0,
      role: "button",
      class: se([e.ns.e("decrease"), e.ns.is("disabled", e.minDisabled)]),
      onKeydown: t[0] || (t[0] = nn((...h) => e.decrease && e.decrease(...h), ["enter"]))
    }, [
      B(l, null, {
        default: N(() => [
          e.controlsAtRight ? (P(), ue(o, { key: 0 })) : (P(), ue(s, { key: 1 }))
        ]),
        _: 1
      })
    ], 34)), [
      [d, e.decrease]
    ]) : re("v-if", !0),
    e.controls ? Bt((P(), L("span", {
      key: 1,
      role: "button",
      class: se([e.ns.e("increase"), e.ns.is("disabled", e.maxDisabled)]),
      onKeydown: t[1] || (t[1] = nn((...h) => e.increase && e.increase(...h), ["enter"]))
    }, [
      B(l, null, {
        default: N(() => [
          e.controlsAtRight ? (P(), ue(u, { key: 0 })) : (P(), ue(c, { key: 1 }))
        ]),
        _: 1
      })
    ], 34)), [
      [d, e.increase]
    ]) : re("v-if", !0),
    B(f, {
      ref: "input",
      type: "number",
      step: e.step,
      "model-value": e.displayValue,
      placeholder: e.placeholder,
      disabled: e.inputNumberDisabled,
      size: e.inputNumberSize,
      max: e.max,
      min: e.min,
      name: e.name,
      label: e.label,
      "validate-event": !1,
      onKeydown: [
        nn(wt(e.increase, ["prevent"]), ["up"]),
        nn(wt(e.decrease, ["prevent"]), ["down"])
      ],
      onBlur: e.handleBlur,
      onFocus: e.handleFocus,
      onInput: e.handleInput,
      onChange: e.handleInputChange
    }, null, 8, ["step", "model-value", "placeholder", "disabled", "size", "max", "min", "name", "label", "onKeydown", "onBlur", "onFocus", "onInput", "onChange"])
  ], 34);
}
var pY = /* @__PURE__ */ vt(fY, [["render", hY]]);
const QA = Un(pY), vY = Gt({
  type: {
    type: String,
    values: ["primary", "success", "warning", "info", "danger", "default"],
    default: "default"
  },
  underline: {
    type: Boolean,
    default: !0
  },
  disabled: { type: Boolean, default: !1 },
  href: { type: String, default: "" },
  icon: {
    type: ya,
    default: ""
  }
}), mY = {
  click: (e) => e instanceof MouseEvent
}, gY = Ee({
  name: "ElLink",
  components: { ElIcon: qt },
  props: vY,
  emits: mY,
  setup(e, { emit: t }) {
    const n = Ct("link");
    function r(i) {
      e.disabled || t("click", i);
    }
    return {
      ns: n,
      handleClick: r
    };
  }
}), yY = ["href"];
function bY(e, t, n, r, i, a) {
  const o = Ie("el-icon");
  return P(), L("a", {
    class: se([
      e.ns.b(),
      e.type ? e.ns.m(e.type) : "",
      e.ns.is("disabled", e.disabled),
      e.ns.is("underline", e.underline && !e.disabled)
    ]),
    href: e.disabled || !e.href ? void 0 : e.href,
    onClick: t[0] || (t[0] = (...s) => e.handleClick && e.handleClick(...s))
  }, [
    e.icon ? (P(), ue(o, { key: 0 }, {
      default: N(() => [
        (P(), ue(Ln(e.icon)))
      ]),
      _: 1
    })) : re("v-if", !0),
    e.$slots.default ? (P(), L("span", {
      key: 1,
      class: se(e.ns.m("inner"))
    }, [
      tt(e.$slots, "default")
    ], 2)) : re("v-if", !0),
    e.$slots.icon ? tt(e.$slots, "icon", { key: 2 }) : re("v-if", !0)
  ], 10, yY);
}
var AY = /* @__PURE__ */ vt(gY, [["render", bY]]);
const E3 = Un(AY);
class TY {
  constructor(t, n) {
    this.parent = t, this.domNode = n, this.subIndex = 0, this.subIndex = 0, this.init();
  }
  init() {
    this.subMenuItems = this.domNode.querySelectorAll("li"), this.addListeners();
  }
  gotoSubIndex(t) {
    t === this.subMenuItems.length ? t = 0 : t < 0 && (t = this.subMenuItems.length - 1), this.subMenuItems[t].focus(), this.subIndex = t;
  }
  addListeners() {
    const t = this.parent.domNode;
    Array.prototype.forEach.call(this.subMenuItems, (n) => {
      n.addEventListener("keydown", (r) => {
        let i = !1;
        switch (r.code) {
          case yt.down: {
            this.gotoSubIndex(this.subIndex + 1), i = !0;
            break;
          }
          case yt.up: {
            this.gotoSubIndex(this.subIndex - 1), i = !0;
            break;
          }
          case yt.tab: {
            q1(t, "mouseleave");
            break;
          }
          case yt.enter:
          case yt.space: {
            i = !0, r.currentTarget.click();
            break;
          }
        }
        return i && (r.preventDefault(), r.stopPropagation()), !1;
      });
    });
  }
}
class wY {
  constructor(t) {
    this.domNode = t, this.submenu = null, this.submenu = null, this.init();
  }
  init() {
    this.domNode.setAttribute("tabindex", "0");
    const t = this.domNode.querySelector(".el-menu");
    t && (this.submenu = new TY(this, t)), this.addListeners();
  }
  addListeners() {
    this.domNode.addEventListener("keydown", (t) => {
      let n = !1;
      switch (t.code) {
        case yt.down: {
          q1(t.currentTarget, "mouseenter"), this.submenu && this.submenu.gotoSubIndex(0), n = !0;
          break;
        }
        case yt.up: {
          q1(t.currentTarget, "mouseenter"), this.submenu && this.submenu.gotoSubIndex(this.submenu.subMenuItems.length - 1), n = !0;
          break;
        }
        case yt.tab: {
          q1(t.currentTarget, "mouseleave");
          break;
        }
        case yt.enter:
        case yt.space: {
          n = !0, t.currentTarget.click();
          break;
        }
      }
      n && t.preventDefault();
    });
  }
}
class PY {
  constructor(t) {
    this.domNode = t, this.init();
  }
  init() {
    const t = this.domNode.childNodes;
    Array.from(t, (n) => {
      n.nodeType === 1 && new wY(n);
    });
  }
}
const xY = Ee({
  name: "ElMenuCollapseTransition",
  setup() {
    return {
      listeners: {
        onBeforeEnter: (t) => t.style.opacity = "0.2",
        onEnter(t, n) {
          Ss(t, "el-opacity-transition"), t.style.opacity = "1", n();
        },
        onAfterEnter(t) {
          oo(t, "el-opacity-transition"), t.style.opacity = "";
        },
        onBeforeLeave(t) {
          t.dataset || (t.dataset = {}), jo(t, "el-menu--collapse") ? (oo(t, "el-menu--collapse"), t.dataset.oldOverflow = t.style.overflow, t.dataset.scrollWidth = t.clientWidth.toString(), Ss(t, "el-menu--collapse")) : (Ss(t, "el-menu--collapse"), t.dataset.oldOverflow = t.style.overflow, t.dataset.scrollWidth = t.clientWidth.toString(), oo(t, "el-menu--collapse")), t.style.width = `${t.scrollWidth}px`, t.style.overflow = "hidden";
        },
        onLeave(t) {
          Ss(t, "horizontal-collapse-transition"), t.style.width = `${t.dataset.scrollWidth}px`;
        }
      }
    };
  }
});
function CY(e, t, n, r, i, a) {
  return P(), ue(wa, $r({ mode: "out-in" }, e.listeners), {
    default: N(() => [
      tt(e.$slots, "default")
    ]),
    _: 3
  }, 16);
}
var SY = /* @__PURE__ */ vt(xY, [["render", CY]]);
function ZA(e, t) {
  const n = ce("rootMenu");
  n || ir("useMenu", "can not inject root menu");
  const r = J(() => {
    let o = e.parent;
    const s = [t.value];
    for (; o.type.name !== "ElMenu"; )
      o.props.index && s.unshift(o.props.index), o = o.parent;
    return s;
  }), i = J(() => {
    let o = e.parent;
    for (; o && !["ElMenu", "ElSubMenu"].includes(o.type.name); )
      o = o.parent;
    return o;
  }), a = J(() => {
    let o = e.parent;
    if (n.props.mode !== "vertical")
      return {};
    let s = 20;
    if (n.props.collapse)
      s = 20;
    else
      for (; o && o.type.name !== "ElMenu"; )
        o.type.name === "ElSubMenu" && (s += 20), o = o.parent;
    return { paddingLeft: `${s}px` };
  });
  return {
    parentMenu: i,
    paddingStyle: a,
    indexPath: r
  };
}
function EY(e) {
  return J(() => {
    const n = e.backgroundColor;
    return n ? new eA(n).shade(20).toString() : "";
  });
}
const JA = (e) => J(() => ({
  "--el-menu-text-color": e.textColor || "",
  "--el-menu-hover-text-color": e.textColor || "",
  "--el-menu-bg-color": e.backgroundColor || "",
  "--el-menu-hover-bg-color": EY(e).value || "",
  "--el-menu-active-color": e.activeTextColor || ""
})), kY = Gt({
  index: {
    type: String,
    required: !0
  },
  showTimeout: {
    type: Number,
    default: 300
  },
  hideTimeout: {
    type: Number,
    default: 300
  },
  popperClass: String,
  disabled: Boolean,
  popperAppendToBody: {
    type: Boolean,
    default: void 0
  }
}), Ap = "ElSubMenu";
var k3 = Ee({
  name: Ap,
  props: kY,
  setup(e, { slots: t, expose: n }) {
    const r = sn(), { paddingStyle: i, indexPath: a, parentMenu: o } = ZA(r, J(() => e.index)), s = ce("rootMenu");
    s || ir(Ap, "can not inject root menu");
    const l = ce(`subMenu:${o.value.uid}`);
    l || ir(Ap, "can not inject sub menu");
    const u = j({}), c = j({});
    let f;
    const d = j(!1), h = j(), p = j(null), y = J(() => F.value === "horizontal" && b.value ? "bottom-start" : "right-start"), m = J(() => F.value === "horizontal" && b.value || F.value === "vertical" && !s.props.collapse ? vc : es), b = J(() => {
      let oe = !0, he = r.parent;
      for (; he && he.type.name !== "ElMenu"; )
        if (["ElSubMenu", "ElMenuItemGroup"].includes(he.type.name)) {
          oe = !1;
          break;
        } else
          he = he.parent;
      return oe;
    }), x = J(() => e.popperAppendToBody === void 0 ? b.value : Boolean(e.popperAppendToBody)), D = J(() => s.props.collapse ? "el-zoom-in-left" : "el-zoom-in-top"), S = J(() => F.value === "horizontal" && b.value ? [
      "bottom-start",
      "bottom-end",
      "top-start",
      "top-end",
      "right-start",
      "left-start"
    ] : [
      "right-start",
      "left-start",
      "bottom-start",
      "bottom-end",
      "top-start",
      "top-end"
    ]), C = J(() => s.openedMenus.includes(e.index)), v = J(() => {
      let oe = !1;
      return Object.values(u.value).forEach((he) => {
        he.active && (oe = !0);
      }), Object.values(c.value).forEach((he) => {
        he.active && (oe = !0);
      }), oe;
    }), H = J(() => s.props.backgroundColor || ""), V = J(() => s.props.activeTextColor || ""), R = J(() => s.props.textColor || ""), F = J(() => s.props.mode), K = zt({
      index: e.index,
      indexPath: a,
      active: v
    }), q = J(() => F.value !== "horizontal" ? {
      color: R.value
    } : {
      borderBottomColor: v.value ? s.props.activeTextColor ? V.value : "" : "transparent",
      color: v.value ? V.value : R.value
    }), G = () => {
      var oe, he, Ae;
      return (Ae = (he = (oe = p.value) == null ? void 0 : oe.popperRef) == null ? void 0 : he.popperInstanceRef) == null ? void 0 : Ae.destroy();
    }, te = (oe) => {
      oe || G();
    }, Q = () => {
      s.props.menuTrigger === "hover" && s.props.mode === "horizontal" || s.props.collapse && s.props.mode === "vertical" || e.disabled || s.handleSubMenuClick({
        index: e.index,
        indexPath: a.value,
        active: v.value
      });
    }, Y = (oe, he = e.showTimeout) => {
      var Ae;
      oe.type === "focus" && !oe.relatedTarget || s.props.menuTrigger === "click" && s.props.mode === "horizontal" || !s.props.collapse && s.props.mode === "vertical" || e.disabled || (l.mouseInChild.value = !0, f == null || f(), { stop: f } = Nd(() => {
        s.openMenu(e.index, a.value);
      }, he), x.value && ((Ae = o.value.vnode.el) == null || Ae.dispatchEvent(new MouseEvent("mouseenter"))));
    }, Z = (oe = !1) => {
      var he, Ae;
      s.props.menuTrigger === "click" && s.props.mode === "horizontal" || !s.props.collapse && s.props.mode === "vertical" || (f == null || f(), l.mouseInChild.value = !1, { stop: f } = Nd(() => !d.value && s.closeMenu(e.index, a.value), e.hideTimeout), x.value && oe && ((he = r.parent) == null ? void 0 : he.type.name) === "ElSubMenu" && ((Ae = l.handleMouseleave) == null || Ae.call(l, !0)));
    };
    Ne(() => s.props.collapse, (oe) => te(Boolean(oe)));
    {
      const oe = (Ae) => {
        c.value[Ae.index] = Ae;
      }, he = (Ae) => {
        delete c.value[Ae.index];
      };
      _t(`subMenu:${r.uid}`, {
        addSubMenu: oe,
        removeSubMenu: he,
        handleMouseleave: Z,
        mouseInChild: d
      });
    }
    return n({
      opened: C
    }), rn(() => {
      s.addSubMenu(K), l.addSubMenu(K);
    }), Ti(() => {
      l.removeSubMenu(K), s.removeSubMenu(K);
    }), () => {
      var oe;
      const he = [
        (oe = t.title) == null ? void 0 : oe.call(t),
        et(qt, {
          class: ["el-sub-menu__icon-arrow"]
        }, { default: () => et(m.value) })
      ], Ae = JA(s.props), We = s.isMenuPopup ? et(Ki, {
        ref: p,
        visible: C.value,
        effect: "light",
        pure: !0,
        offset: 6,
        showArrow: !1,
        persistent: !0,
        popperClass: e.popperClass,
        placement: y.value,
        teleported: x.value,
        fallbackPlacements: S.value,
        transition: D.value,
        gpuAcceleration: !1
      }, {
        content: () => {
          var ke;
          return et("div", {
            class: [`el-menu--${F.value}`, e.popperClass],
            onMouseenter: (Re) => Y(Re, 100),
            onMouseleave: () => Z(!0),
            onFocus: (Re) => Y(Re, 100)
          }, [
            et("ul", {
              class: [
                "el-menu el-menu--popup",
                `el-menu--popup-${y.value}`
              ],
              style: Ae.value
            }, [(ke = t.default) == null ? void 0 : ke.call(t)])
          ]);
        },
        default: () => et("div", {
          class: "el-sub-menu__title",
          style: [
            i.value,
            q.value,
            { backgroundColor: H.value }
          ],
          onClick: Q
        }, he)
      }) : et(nt, {}, [
        et("div", {
          class: "el-sub-menu__title",
          style: [
            i.value,
            q.value,
            { backgroundColor: H.value }
          ],
          ref: h,
          onClick: Q
        }, he),
        et(w3, {}, {
          default: () => {
            var ke;
            return Bt(et("ul", {
              role: "menu",
              class: "el-menu el-menu--inline",
              style: Ae.value
            }, [(ke = t.default) == null ? void 0 : ke.call(t)]), [[Cn, C.value]]);
          }
        })
      ]);
      return et("li", {
        class: [
          "el-sub-menu",
          {
            "is-active": v.value,
            "is-opened": C.value,
            "is-disabled": e.disabled
          }
        ],
        role: "menuitem",
        ariaHaspopup: !0,
        ariaExpanded: C.value,
        onMouseenter: Y,
        onMouseleave: () => Z(!0),
        onFocus: Y
      }, [We]);
    };
  }
});
const OY = Gt({
  mode: {
    type: String,
    values: ["horizontal", "vertical"],
    default: "vertical"
  },
  defaultActive: {
    type: String,
    default: ""
  },
  defaultOpeneds: {
    type: jt(Array),
    default: () => da([])
  },
  uniqueOpened: Boolean,
  router: Boolean,
  menuTrigger: {
    type: String,
    values: ["hover", "click"],
    default: "hover"
  },
  collapse: Boolean,
  backgroundColor: String,
  textColor: String,
  activeTextColor: String,
  collapseTransition: {
    type: Boolean,
    default: !0
  },
  ellipsis: {
    type: Boolean,
    default: !0
  }
}), Tp = (e) => Array.isArray(e) && e.every((t) => Ai(t)), zY = {
  close: (e, t) => Ai(e) && Tp(t),
  open: (e, t) => Ai(e) && Tp(t),
  select: (e, t, n, r) => Ai(e) && Tp(t) && tr(n) && (r === void 0 || r instanceof Promise)
};
var DY = Ee({
  name: "ElMenu",
  props: OY,
  emits: zY,
  setup(e, { emit: t, slots: n, expose: r }) {
    const i = sn(), a = i.appContext.config.globalProperties.$router, o = j(), s = j(e.defaultOpeneds && !e.collapse ? e.defaultOpeneds.slice(0) : []), l = j(e.defaultActive), u = j({}), c = j({}), f = J(() => e.mode === "horizontal" || e.mode === "vertical" && e.collapse), d = () => {
      const C = l.value && u.value[l.value];
      if (!C || e.mode === "horizontal" || e.collapse)
        return;
      C.indexPath.forEach((H) => {
        const V = c.value[H];
        V && h(H, V.indexPath);
      });
    }, h = (C, v) => {
      s.value.includes(C) || (e.uniqueOpened && (s.value = s.value.filter((H) => v.includes(H))), s.value.push(C), t("open", C, v));
    }, p = (C, v) => {
      const H = s.value.indexOf(C);
      H !== -1 && s.value.splice(H, 1), t("close", C, v);
    }, y = ({
      index: C,
      indexPath: v
    }) => {
      s.value.includes(C) ? p(C, v) : h(C, v);
    }, m = (C) => {
      (e.mode === "horizontal" || e.collapse) && (s.value = []);
      const { index: v, indexPath: H } = C;
      if (!(v === void 0 || H === void 0))
        if (e.router && a) {
          const V = C.route || v, R = a.push(V).then((F) => (F || (l.value = v), F));
          t("select", v, H, { index: v, indexPath: H, route: V }, R);
        } else
          l.value = v, t("select", v, H, { index: v, indexPath: H });
    }, b = (C) => {
      const v = u.value, H = v[C] || l.value && v[l.value] || v[e.defaultActive];
      H ? (l.value = H.index, d()) : l.value = C;
    }, x = () => {
      bt(() => i.proxy.$forceUpdate());
    };
    Ne(() => e.defaultActive, (C) => {
      u.value[C] || (l.value = ""), b(C);
    }), Ne(u.value, () => d()), Ne(() => e.collapse, (C) => {
      C && (s.value = []);
    });
    {
      const C = (R) => {
        c.value[R.index] = R;
      }, v = (R) => {
        delete c.value[R.index];
      };
      _t("rootMenu", zt({
        props: e,
        openedMenus: s,
        items: u,
        subMenus: c,
        activeIndex: l,
        isMenuPopup: f,
        addMenuItem: (R) => {
          u.value[R.index] = R;
        },
        removeMenuItem: (R) => {
          delete u.value[R.index];
        },
        addSubMenu: C,
        removeSubMenu: v,
        openMenu: h,
        closeMenu: p,
        handleMenuItemClick: m,
        handleSubMenuClick: y
      })), _t(`subMenu:${i.uid}`, {
        addSubMenu: C,
        removeSubMenu: v,
        mouseInChild: j(!1)
      });
    }
    rn(() => {
      d(), e.mode === "horizontal" && new PY(i.vnode.el);
    }), r({
      open: (v) => {
        const { indexPath: H } = c.value[v];
        H.forEach((V) => h(V, H));
      },
      close: p,
      handleResize: x
    });
    const D = (C) => {
      const v = Array.isArray(C) ? C : [C], H = [];
      return v.forEach((V) => {
        Array.isArray(V.children) ? H.push(...D(V.children)) : H.push(V);
      }), H;
    }, S = (C) => e.mode === "horizontal" ? Bt(C, [[jX, x]]) : C;
    return () => {
      var C, v, H, V;
      let R = (v = (C = n.default) == null ? void 0 : C.call(n)) != null ? v : [];
      const F = [];
      if (e.mode === "horizontal" && o.value) {
        const te = Array.from((V = (H = o.value) == null ? void 0 : H.childNodes) != null ? V : []).filter((ve) => ve.nodeName !== "#text" || ve.nodeValue), Q = D(R), Y = 64, Z = parseInt(getComputedStyle(o.value).paddingLeft, 10), oe = parseInt(getComputedStyle(o.value).paddingRight, 10), he = o.value.clientWidth - Z - oe;
        let Ae = 0, We = 0;
        te.forEach((ve, Ye) => {
          Ae += ve.offsetWidth || 0, Ae <= he - Y && (We = Ye + 1);
        });
        const ke = Q.slice(0, We), Re = Q.slice(We);
        (Re == null ? void 0 : Re.length) && e.ellipsis && (R = ke, F.push(et(k3, {
          index: "sub-menu-more",
          class: "el-sub-menu__hide-arrow"
        }, {
          title: () => et(qt, {
            class: ["el-sub-menu__icon-more"]
          }, { default: () => et(TF) }),
          default: () => Re
        })));
      }
      const K = JA(e), q = (te) => e.ellipsis ? S(te) : te, G = q(et("ul", {
        key: String(e.collapse),
        role: "menubar",
        ref: o,
        style: K.value,
        class: {
          "el-menu": !0,
          "el-menu--horizontal": e.mode === "horizontal",
          "el-menu--collapse": e.collapse
        }
      }, [...R.map((te) => q(te)), ...F]));
      return e.collapseTransition && e.mode === "vertical" ? et(SY, () => G) : G;
    };
  }
});
const MY = Gt({
  index: {
    type: jt([String, null]),
    default: null
  },
  route: {
    type: jt([String, Object])
  },
  disabled: Boolean
}), HY = {
  click: (e) => Ai(e.index) && Array.isArray(e.indexPath)
}, wp = "ElMenuItem", IY = Ee({
  name: wp,
  components: {
    ElTooltip: Ki
  },
  props: MY,
  emits: HY,
  setup(e, { emit: t }) {
    const n = sn(), r = ce("rootMenu");
    r || ir(wp, "can not inject root menu");
    const { parentMenu: i, paddingStyle: a, indexPath: o } = ZA(n, er(e, "index")), s = ce(`subMenu:${i.value.uid}`);
    s || ir(wp, "can not inject sub menu");
    const l = J(() => e.index === r.activeIndex), u = zt({
      index: e.index,
      indexPath: o,
      active: l
    }), c = () => {
      e.disabled || (r.handleMenuItemClick({
        index: e.index,
        indexPath: o.value,
        route: e.route
      }), t("click", u));
    };
    return rn(() => {
      s.addSubMenu(u), r.addMenuItem(u);
    }), Ti(() => {
      s.removeSubMenu(u), r.removeMenuItem(u);
    }), {
      Effect: TV,
      parentMenu: i,
      rootMenu: r,
      paddingStyle: a,
      active: l,
      handleClick: c
    };
  }
}), LY = { style: {
  position: "absolute",
  left: 0,
  top: 0,
  height: "100%",
  width: "100%",
  display: "inline-block",
  boxSizing: "border-box",
  padding: "0 20px"
} };
function BY(e, t, n, r, i, a) {
  const o = Ie("el-tooltip");
  return P(), L("li", {
    class: se(["el-menu-item", {
      "is-active": e.active,
      "is-disabled": e.disabled
    }]),
    role: "menuitem",
    tabindex: "-1",
    style: Pt(e.paddingStyle),
    onClick: t[0] || (t[0] = (...s) => e.handleClick && e.handleClick(...s))
  }, [
    e.parentMenu.type.name === "ElMenu" && e.rootMenu.props.collapse && e.$slots.title ? (P(), ue(o, {
      key: 0,
      effect: e.Effect.DARK,
      placement: "right",
      persistent: ""
    }, {
      content: N(() => [
        tt(e.$slots, "title")
      ]),
      default: N(() => [
        T("div", LY, [
          tt(e.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["effect"])) : (P(), L(nt, { key: 1 }, [
      tt(e.$slots, "default"),
      tt(e.$slots, "title")
    ], 64))
  ], 6);
}
var $A = /* @__PURE__ */ vt(IY, [["render", BY]]);
const NY = {
  title: String
}, g7 = "ElMenuItemGroup", jY = Ee({
  name: g7,
  props: NY,
  setup() {
    const e = sn(), t = ce("rootMenu");
    return t || ir(g7, "can not inject root menu"), {
      levelPadding: J(() => {
        if (t.props.collapse)
          return 20;
        let r = 20, i = e.parent;
        for (; i && i.type.name !== "ElMenu"; )
          i.type.name === "ElSubMenu" && (r += 20), i = i.parent;
        return r;
      })
    };
  }
}), FY = { class: "el-menu-item-group" };
function XY(e, t, n, r, i, a) {
  return P(), L("li", FY, [
    T("div", {
      class: "el-menu-item-group__title",
      style: Pt({ paddingLeft: `${e.levelPadding}px` })
    }, [
      e.$slots.title ? tt(e.$slots, "title", { key: 1 }) : (P(), L(nt, { key: 0 }, [
        je(de(e.title), 1)
      ], 2112))
    ], 4),
    T("ul", null, [
      tt(e.$slots, "default")
    ])
  ]);
}
var eT = /* @__PURE__ */ vt(jY, [["render", XY]]);
const tT = Un(DY, {
  MenuItem: $A,
  MenuItemGroup: eT,
  SubMenu: k3
}), nT = Wi($A);
Wi(eT);
Wi(k3);
const RY = {
  disabled: Boolean,
  currentPage: {
    type: Number,
    default: 1
  },
  prevText: {
    type: String,
    default: ""
  }
}, VY = Ee({
  name: "ElPaginationPrev",
  components: {
    ElIcon: qt,
    ArrowLeft: Ih
  },
  props: RY,
  emits: ["click"],
  setup(e) {
    return {
      internalDisabled: J(() => e.disabled || e.currentPage <= 1)
    };
  }
}), UY = ["disabled", "aria-disabled"], qY = { key: 0 };
function _Y(e, t, n, r, i, a) {
  const o = Ie("arrow-left"), s = Ie("el-icon");
  return P(), L("button", {
    type: "button",
    class: "btn-prev",
    disabled: e.internalDisabled,
    "aria-disabled": e.internalDisabled,
    onClick: t[0] || (t[0] = (l) => e.$emit("click", l))
  }, [
    e.prevText ? (P(), L("span", qY, de(e.prevText), 1)) : (P(), ue(s, { key: 1 }, {
      default: N(() => [
        B(o)
      ]),
      _: 1
    }))
  ], 8, UY);
}
var WY = /* @__PURE__ */ vt(VY, [["render", _Y]]);
const KY = {
  disabled: Boolean,
  currentPage: {
    type: Number,
    default: 1
  },
  pageCount: {
    type: Number,
    default: 50
  },
  nextText: {
    type: String,
    default: ""
  }
}, GY = Ee({
  name: "ElPaginationNext",
  components: {
    ElIcon: qt,
    ArrowRight: es
  },
  props: KY,
  emits: ["click"],
  setup(e) {
    return {
      internalDisabled: J(() => e.disabled || e.currentPage === e.pageCount || e.pageCount === 0)
    };
  }
}), YY = ["disabled", "aria-disabled"], QY = { key: 0 };
function ZY(e, t, n, r, i, a) {
  const o = Ie("arrow-right"), s = Ie("el-icon");
  return P(), L("button", {
    type: "button",
    class: "btn-next",
    disabled: e.internalDisabled,
    "aria-disabled": e.internalDisabled,
    onClick: t[0] || (t[0] = (l) => e.$emit("click", l))
  }, [
    e.nextText ? (P(), L("span", QY, de(e.nextText), 1)) : (P(), ue(s, { key: 1 }, {
      default: N(() => [
        B(o)
      ]),
      _: 1
    }))
  ], 8, YY);
}
var JY = /* @__PURE__ */ vt(GY, [["render", ZY]]);
const iT = "ElSelectGroup", _h = "ElSelect";
function $Y(e, t) {
  const n = ce(_h), r = ce(iT, { disabled: !1 }), i = J(() => Object.prototype.toString.call(e.value).toLowerCase() === "[object object]"), a = J(() => n.props.multiple ? f(n.props.modelValue, e.value) : d(e.value, n.props.modelValue)), o = J(() => {
    if (n.props.multiple) {
      const y = n.props.modelValue || [];
      return !a.value && y.length >= n.props.multipleLimit && n.props.multipleLimit > 0;
    } else
      return !1;
  }), s = J(() => e.label || (i.value ? "" : e.value)), l = J(() => e.value || e.label || ""), u = J(() => e.disabled || t.groupDisabled || o.value), c = sn(), f = (y = [], m) => {
    if (i.value) {
      const b = n.props.valueKey;
      return y && y.some((x) => vi(x, b) === vi(m, b));
    } else
      return y && y.indexOf(m) > -1;
  }, d = (y, m) => {
    if (i.value) {
      const { valueKey: b } = n.props;
      return vi(y, b) === vi(m, b);
    } else
      return y === m;
  }, h = () => {
    !e.disabled && !r.disabled && (n.hoverIndex = n.optionsArray.indexOf(c.proxy));
  };
  Ne(() => s.value, () => {
    !e.created && !n.props.remote && n.setSelected();
  }), Ne(() => e.value, (y, m) => {
    const { remote: b, valueKey: x } = n.props;
    if (!e.created && !b) {
      if (x && typeof y == "object" && typeof m == "object" && y[x] === m[x])
        return;
      n.setSelected();
    }
  }), Ne(() => r.disabled, () => {
    t.groupDisabled = r.disabled;
  }, { immediate: !0 });
  const { queryChange: p } = ag(n);
  return Ne(p, (y) => {
    const { query: m } = E(y), b = new RegExp(cN(m), "i");
    t.visible = b.test(s.value) || e.created, t.visible || n.filteredOptionsCount--;
  }), {
    select: n,
    currentLabel: s,
    currentValue: l,
    itemSelected: a,
    isDisabled: u,
    hoverItem: h
  };
}
const eQ = Ee({
  name: "ElOption",
  componentName: "ElOption",
  props: {
    value: {
      required: !0,
      type: [String, Number, Boolean, Object]
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = Ct("select"), n = zt({
      index: -1,
      groupDisabled: !1,
      visible: !0,
      hitState: !1,
      hover: !1
    }), { currentLabel: r, itemSelected: i, isDisabled: a, select: o, hoverItem: s } = $Y(e, n), { visible: l, hover: u } = ma(n), c = sn().proxy, f = c.value;
    o.onOptionCreate(c), Ti(() => {
      const { selected: h } = o, p = o.props.multiple ? h : [h], y = o.cachedOptions.has(f), m = p.some((b) => b.value === c.value);
      y && !m && o.cachedOptions.delete(f), o.onOptionDestroy(f);
    });
    function d() {
      e.disabled !== !0 && n.groupDisabled !== !0 && o.handleOptionSelect(c, !0);
    }
    return {
      ns: t,
      currentLabel: r,
      itemSelected: i,
      isDisabled: a,
      select: o,
      hoverItem: s,
      visible: l,
      hover: u,
      selectOptionClick: d,
      states: n
    };
  }
});
function tQ(e, t, n, r, i, a) {
  return Bt((P(), L("li", {
    class: se([
      e.ns.be("dropdown", "item"),
      e.ns.is("disabled", e.isDisabled),
      {
        selected: e.itemSelected,
        hover: e.hover
      }
    ]),
    onMouseenter: t[0] || (t[0] = (...o) => e.hoverItem && e.hoverItem(...o)),
    onClick: t[1] || (t[1] = wt((...o) => e.selectOptionClick && e.selectOptionClick(...o), ["stop"]))
  }, [
    tt(e.$slots, "default", {}, () => [
      T("span", null, de(e.currentLabel), 1)
    ])
  ], 34)), [
    [Cn, e.visible]
  ]);
}
var O3 = /* @__PURE__ */ vt(eQ, [["render", tQ]]);
const nQ = Ee({
  name: "ElSelectDropdown",
  componentName: "ElSelectDropdown",
  setup() {
    const e = ce(_h), t = Ct("select"), n = J(() => e.props.popperClass), r = J(() => e.props.multiple), i = J(() => e.props.fitInputWidth), a = j("");
    function o() {
      var s;
      a.value = `${(s = e.selectWrapper) == null ? void 0 : s.getBoundingClientRect().width}px`;
    }
    return rn(() => {
      o(), Xl(e.selectWrapper, o);
    }), Ti(() => {
      Rl(e.selectWrapper, o);
    }), {
      ns: t,
      minWidth: a,
      popperClass: n,
      isMultiple: r,
      isFitInputWidth: i
    };
  }
});
function iQ(e, t, n, r, i, a) {
  return P(), L("div", {
    class: se([e.ns.b("dropdown"), e.ns.is("multiple", e.isMultiple), e.popperClass]),
    style: Pt({ [e.isFitInputWidth ? "width" : "minWidth"]: e.minWidth })
  }, [
    tt(e.$slots, "default")
  ], 6);
}
var rQ = /* @__PURE__ */ vt(nQ, [["render", iQ]]);
function aQ(e) {
  const { t } = hi();
  return zt({
    options: /* @__PURE__ */ new Map(),
    cachedOptions: /* @__PURE__ */ new Map(),
    createdLabel: null,
    createdSelected: !1,
    selected: e.multiple ? [] : {},
    inputLength: 20,
    inputWidth: 0,
    initialInputHeight: 0,
    optionsCount: 0,
    filteredOptionsCount: 0,
    visible: !1,
    softFocus: !1,
    selectedLabel: "",
    hoverIndex: -1,
    query: "",
    previousQuery: null,
    inputHovering: !1,
    cachedPlaceHolder: "",
    currentPlaceholder: t("el.select.placeholder"),
    menuVisibleOnFocus: !1,
    isOnComposition: !1,
    isSilentBlur: !1,
    prefixWidth: 11,
    tagInMultiLine: !1
  });
}
const oQ = (e, t, n) => {
  const { t: r } = hi(), i = Ct("select"), a = j(null), o = j(null), s = j(null), l = j(null), u = j(null), c = j(null), f = j(-1), d = Uo({ query: "" }), h = Uo(""), p = ce(Pa, {}), y = ce(ts, {}), m = J(() => !e.filterable || e.multiple || !t.visible), b = J(() => e.disabled || p.disabled), x = J(() => {
    const De = e.multiple ? Array.isArray(e.modelValue) && e.modelValue.length > 0 : e.modelValue !== void 0 && e.modelValue !== null && e.modelValue !== "";
    return e.clearable && !b.value && t.inputHovering && De;
  }), D = J(() => e.remote && e.filterable ? "" : e.suffixIcon), S = J(() => i.is("reverse", D.value && t.visible)), C = J(() => e.remote ? 300 : 0), v = J(() => e.loading ? e.loadingText || r("el.select.loading") : e.remote && t.query === "" && t.options.size === 0 ? !1 : e.filterable && t.query && t.options.size > 0 && t.filteredOptionsCount === 0 ? e.noMatchText || r("el.select.noMatch") : t.options.size === 0 ? e.noDataText || r("el.select.noData") : null), H = J(() => Array.from(t.options.values())), V = J(() => Array.from(t.cachedOptions.values())), R = J(() => {
    const De = H.value.filter((Ue) => !Ue.created).some((Ue) => Ue.currentLabel === t.query);
    return e.filterable && e.allowCreate && t.query !== "" && !De;
  }), F = Bi(), K = J(() => ["small"].indexOf(F.value) > -1 ? "small" : "default"), q = J({
    get() {
      return t.visible && v.value !== !1;
    },
    set(De) {
      t.visible = De;
    }
  });
  Ne(() => b.value, () => {
    bt(() => {
      G();
    });
  }), Ne(() => e.placeholder, (De) => {
    t.cachedPlaceHolder = t.currentPlaceholder = De;
  }), Ne(() => e.modelValue, (De, Ue) => {
    var Se;
    e.multiple && (G(), De && De.length > 0 || o.value && t.query !== "" ? t.currentPlaceholder = "" : t.currentPlaceholder = t.cachedPlaceHolder, e.filterable && !e.reserveKeyword && (t.query = "", te(t.query))), Z(), e.filterable && !e.multiple && (t.inputLength = 20), ja(De, Ue) || (Se = y.validate) == null || Se.call(y, "change");
  }, {
    flush: "post",
    deep: !0
  }), Ne(() => t.visible, (De) => {
    var Ue, Se, st;
    De ? ((Se = (Ue = s.value) == null ? void 0 : Ue.updatePopper) == null || Se.call(Ue), e.filterable && (t.filteredOptionsCount = t.optionsCount, t.query = e.remote ? "" : t.selectedLabel, e.multiple ? (st = o.value) == null || st.focus() : t.selectedLabel && (t.currentPlaceholder = t.selectedLabel, t.selectedLabel = ""), te(t.query), !e.multiple && !e.remote && (d.value.query = "", Kc(d), Kc(h)))) : (o.value && o.value.blur(), t.query = "", t.previousQuery = null, t.selectedLabel = "", t.inputLength = 20, t.menuVisibleOnFocus = !1, he(), bt(() => {
      o.value && o.value.value === "" && t.selected.length === 0 && (t.currentPlaceholder = t.cachedPlaceHolder);
    }), e.multiple || (t.selected && (e.filterable && e.allowCreate && t.createdSelected && t.createdLabel ? t.selectedLabel = t.createdLabel : t.selectedLabel = t.selected.currentLabel, e.filterable && (t.query = t.selectedLabel)), e.filterable && (t.currentPlaceholder = t.cachedPlaceHolder))), n.emit("visible-change", De);
  }), Ne(() => t.options.entries(), () => {
    var De, Ue, Se;
    if (!Sn)
      return;
    (Ue = (De = s.value) == null ? void 0 : De.updatePopper) == null || Ue.call(De), e.multiple && G();
    const st = ((Se = u.value) == null ? void 0 : Se.querySelectorAll("input")) || [];
    Array.from(st).indexOf(document.activeElement) === -1 && Z(), e.defaultFirstOption && (e.filterable || e.remote) && t.filteredOptionsCount && Y();
  }, {
    flush: "post"
  }), Ne(() => t.hoverIndex, (De) => {
    typeof De == "number" && De > -1 && (f.value = H.value[De] || {}), H.value.forEach((Ue) => {
      Ue.hover = f.value === Ue;
    });
  });
  const G = () => {
    e.collapseTags && !e.filterable || bt(() => {
      var De, Ue;
      if (!a.value)
        return;
      const Se = a.value.$el.childNodes, st = Array.from(Se).filter((cn) => cn.tagName === "INPUT")[0], kt = l.value, mn = t.initialInputHeight || 40;
      st.style.height = t.selected.length === 0 ? `${mn}px` : `${Math.max(kt ? kt.clientHeight + (kt.clientHeight > mn ? 6 : 0) : 0, mn)}px`, t.tagInMultiLine = parseFloat(st.style.height) >= mn, t.visible && v.value !== !1 && ((Ue = (De = s.value) == null ? void 0 : De.updatePopper) == null || Ue.call(De));
    });
  }, te = (De) => {
    if (!(t.previousQuery === De || t.isOnComposition)) {
      if (t.previousQuery === null && (typeof e.filterMethod == "function" || typeof e.remoteMethod == "function")) {
        t.previousQuery = De;
        return;
      }
      t.previousQuery = De, bt(() => {
        var Ue, Se;
        t.visible && ((Se = (Ue = s.value) == null ? void 0 : Ue.updatePopper) == null || Se.call(Ue));
      }), t.hoverIndex = -1, e.multiple && e.filterable && bt(() => {
        const Ue = o.value.value.length * 15 + 20;
        t.inputLength = e.collapseTags ? Math.min(50, Ue) : Ue, Q(), G();
      }), e.remote && typeof e.remoteMethod == "function" ? (t.hoverIndex = -1, e.remoteMethod(De)) : typeof e.filterMethod == "function" ? (e.filterMethod(De), Kc(h)) : (t.filteredOptionsCount = t.optionsCount, d.value.query = De, Kc(d), Kc(h)), e.defaultFirstOption && (e.filterable || e.remote) && t.filteredOptionsCount && Y();
    }
  }, Q = () => {
    t.currentPlaceholder !== "" && (t.currentPlaceholder = o.value.value ? "" : t.cachedPlaceHolder);
  }, Y = () => {
    const De = H.value.filter((st) => st.visible && !st.disabled && !st.states.groupDisabled), Ue = De.filter((st) => st.created)[0], Se = De[0];
    t.hoverIndex = Me(H.value, Ue || Se);
  }, Z = () => {
    var De;
    if (!e.multiple) {
      const Se = oe(e.modelValue);
      (De = Se.props) != null && De.created ? (t.createdLabel = Se.props.value, t.createdSelected = !0) : t.createdSelected = !1, t.selectedLabel = Se.currentLabel, t.selected = Se, e.filterable && (t.query = t.selectedLabel);
      return;
    }
    const Ue = [];
    Array.isArray(e.modelValue) && e.modelValue.forEach((Se) => {
      Ue.push(oe(Se));
    }), t.selected = Ue, bt(() => {
      G();
    });
  }, oe = (De) => {
    let Ue;
    const Se = up(De).toLowerCase() === "object", st = up(De).toLowerCase() === "null", kt = up(De).toLowerCase() === "undefined";
    for (let kn = t.cachedOptions.size - 1; kn >= 0; kn--) {
      const Tn = V.value[kn];
      if (Se ? vi(Tn.value, e.valueKey) === vi(De, e.valueKey) : Tn.value === De) {
        Ue = {
          value: De,
          currentLabel: Tn.currentLabel,
          isDisabled: Tn.isDisabled
        };
        break;
      }
    }
    if (Ue)
      return Ue;
    const mn = Se ? De.label : !st && !kt ? De : "", cn = {
      value: De,
      currentLabel: mn
    };
    return e.multiple && (cn.hitState = !1), cn;
  }, he = () => {
    setTimeout(() => {
      const De = e.valueKey;
      e.multiple ? t.selected.length > 0 ? t.hoverIndex = Math.min.apply(null, t.selected.map((Ue) => H.value.findIndex((Se) => vi(Se, De) === vi(Ue, De)))) : t.hoverIndex = -1 : t.hoverIndex = H.value.findIndex((Ue) => Mn(Ue) === Mn(t.selected));
    }, 300);
  }, Ae = () => {
    var De, Ue;
    We(), (Ue = (De = s.value) == null ? void 0 : De.updatePopper) == null || Ue.call(De), e.multiple && !e.filterable && G();
  }, We = () => {
    var De;
    t.inputWidth = (De = a.value) == null ? void 0 : De.$el.getBoundingClientRect().width;
  }, ke = () => {
    e.filterable && t.query !== t.selectedLabel && (t.query = t.selectedLabel, te(t.query));
  }, Re = qa(() => {
    ke();
  }, C.value), ve = qa((De) => {
    te(De.target.value);
  }, C.value), Ye = (De) => {
    ja(e.modelValue, De) || n.emit(Tr, De);
  }, Qe = (De) => {
    if (De.target.value.length <= 0 && !Pe()) {
      const Ue = e.modelValue.slice();
      Ue.pop(), n.emit(vn, Ue), Ye(Ue);
    }
    De.target.value.length === 1 && e.modelValue.length === 0 && (t.currentPlaceholder = t.cachedPlaceHolder);
  }, ot = (De, Ue) => {
    const Se = t.selected.indexOf(Ue);
    if (Se > -1 && !b.value) {
      const st = e.modelValue.slice();
      st.splice(Se, 1), n.emit(vn, st), Ye(st), n.emit("remove-tag", Ue.value);
    }
    De.stopPropagation();
  }, Ve = (De) => {
    De.stopPropagation();
    const Ue = e.multiple ? [] : "";
    if (typeof Ue != "string")
      for (const Se of t.selected)
        Se.isDisabled && Ue.push(Se.value);
    n.emit(vn, Ue), Ye(Ue), t.visible = !1, n.emit("clear");
  }, Te = (De, Ue) => {
    var Se;
    if (e.multiple) {
      const st = (e.modelValue || []).slice(), kt = Me(st, De.value);
      kt > -1 ? st.splice(kt, 1) : (e.multipleLimit <= 0 || st.length < e.multipleLimit) && st.push(De.value), n.emit(vn, st), Ye(st), De.created && (t.query = "", te(""), t.inputLength = 20), e.filterable && ((Se = o.value) == null || Se.focus());
    } else
      n.emit(vn, De.value), Ye(De.value), t.visible = !1;
    t.isSilentBlur = Ue, Je(), !t.visible && bt(() => {
      mt(De);
    });
  }, Me = (De = [], Ue) => {
    if (!tr(Ue))
      return De.indexOf(Ue);
    const Se = e.valueKey;
    let st = -1;
    return De.some((kt, mn) => vi(kt, Se) === vi(Ue, Se) ? (st = mn, !0) : !1), st;
  }, Je = () => {
    t.softFocus = !0;
    const De = o.value || a.value;
    De && (De == null || De.focus());
  }, mt = (De) => {
    var Ue, Se, st, kt, mn;
    const cn = Array.isArray(De) ? De[0] : De;
    let kn = null;
    if (cn != null && cn.value) {
      const Tn = H.value.filter((sr) => sr.value === cn.value);
      Tn.length > 0 && (kn = Tn[0].$el);
    }
    if (s.value && kn) {
      const Tn = (kt = (st = (Se = (Ue = s.value) == null ? void 0 : Ue.popperRef) == null ? void 0 : Se.contentRef) == null ? void 0 : st.querySelector) == null ? void 0 : kt.call(st, ".el-select-dropdown__wrap");
      Tn && ob(Tn, kn);
    }
    (mn = c.value) == null || mn.handleScroll();
  }, It = (De) => {
    t.optionsCount++, t.filteredOptionsCount++, t.options.set(De.value, De), t.cachedOptions.set(De.value, De);
  }, ln = (De) => {
    t.optionsCount--, t.filteredOptionsCount--, t.options.delete(De);
  }, gt = (De) => {
    De.code !== yt.backspace && Pe(!1), t.inputLength = o.value.value.length * 15 + 20, G();
  }, Pe = (De) => {
    if (!Array.isArray(t.selected))
      return;
    const Ue = t.selected[t.selected.length - 1];
    if (!!Ue)
      return De === !0 || De === !1 ? (Ue.hitState = De, De) : (Ue.hitState = !Ue.hitState, Ue.hitState);
  }, $e = (De) => {
    const Ue = De.target.value;
    if (De.type === "compositionend")
      t.isOnComposition = !1, bt(() => te(Ue));
    else {
      const Se = Ue[Ue.length - 1] || "";
      t.isOnComposition = !Nh(Se);
    }
  }, Ke = () => {
    bt(() => mt(t.selected));
  }, lt = (De) => {
    t.softFocus ? t.softFocus = !1 : ((e.automaticDropdown || e.filterable) && (t.visible = !0, e.filterable && (t.menuVisibleOnFocus = !0)), n.emit("focus", De));
  }, He = () => {
    var De;
    t.visible = !1, (De = a.value) == null || De.blur();
  }, Le = (De) => {
    bt(() => {
      t.isSilentBlur ? t.isSilentBlur = !1 : n.emit("blur", De);
    }), t.softFocus = !1;
  }, ct = (De) => {
    Ve(De);
  }, Qt = () => {
    t.visible = !1;
  }, Zt = () => {
    var De;
    e.automaticDropdown || b.value || (t.menuVisibleOnFocus ? t.menuVisibleOnFocus = !1 : t.visible = !t.visible, t.visible && ((De = o.value || a.value) == null || De.focus()));
  }, Pn = () => {
    t.visible ? H.value[t.hoverIndex] && Te(H.value[t.hoverIndex], void 0) : Zt();
  }, Mn = (De) => tr(De.value) ? vi(De.value, e.valueKey) : De.value, Mt = J(() => H.value.filter((De) => De.visible).every((De) => De.disabled)), Nt = (De) => {
    if (!t.visible) {
      t.visible = !0;
      return;
    }
    if (!(t.options.size === 0 || t.filteredOptionsCount === 0) && !t.isOnComposition && !Mt.value) {
      De === "next" ? (t.hoverIndex++, t.hoverIndex === t.options.size && (t.hoverIndex = 0)) : De === "prev" && (t.hoverIndex--, t.hoverIndex < 0 && (t.hoverIndex = t.options.size - 1));
      const Ue = H.value[t.hoverIndex];
      (Ue.disabled === !0 || Ue.states.groupDisabled === !0 || !Ue.visible) && Nt(De), bt(() => mt(f.value));
    }
  };
  return {
    optionsArray: H,
    selectSize: F,
    handleResize: Ae,
    debouncedOnInputChange: Re,
    debouncedQueryChange: ve,
    deletePrevTag: Qe,
    deleteTag: ot,
    deleteSelected: Ve,
    handleOptionSelect: Te,
    scrollToOption: mt,
    readonly: m,
    resetInputHeight: G,
    showClose: x,
    iconComponent: D,
    iconReverse: S,
    showNewOption: R,
    collapseTagSize: K,
    setSelected: Z,
    managePlaceholder: Q,
    selectDisabled: b,
    emptyText: v,
    toggleLastOptionHitState: Pe,
    resetInputState: gt,
    handleComposition: $e,
    onOptionCreate: It,
    onOptionDestroy: ln,
    handleMenuEnter: Ke,
    handleFocus: lt,
    blur: He,
    handleBlur: Le,
    handleClearClick: ct,
    handleClose: Qt,
    toggleMenu: Zt,
    selectOption: Pn,
    getValueKey: Mn,
    navigateOptions: Nt,
    dropMenuVisible: q,
    queryChange: d,
    groupQueryChange: h,
    reference: a,
    input: o,
    tooltipRef: s,
    tags: l,
    selectWrapper: u,
    scrollbar: c
  };
}, Pp = "ElSelect", sQ = Ee({
  name: Pp,
  componentName: Pp,
  components: {
    ElInput: ti,
    ElSelectMenu: rQ,
    ElOption: O3,
    ElTag: hf,
    ElScrollbar: ns,
    ElTooltip: Ki,
    ElIcon: qt
  },
  directives: { ClickOutside: yc },
  props: {
    name: String,
    id: String,
    modelValue: {
      type: [Array, String, Number, Boolean, Object],
      default: void 0
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    automaticDropdown: Boolean,
    size: {
      type: String,
      validator: fo
    },
    effect: {
      type: String,
      default: "light"
    },
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: {
      type: String,
      default: ""
    },
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String
    },
    defaultFirstOption: Boolean,
    reserveKeyword: {
      type: Boolean,
      default: !0
    },
    valueKey: {
      type: String,
      default: "value"
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: void 0
    },
    teleported: zr.teleported,
    clearIcon: {
      type: [String, Object],
      default: Hs
    },
    fitInputWidth: {
      type: Boolean,
      default: !1
    },
    suffixIcon: {
      type: [String, Object],
      default: uf
    },
    tagType: { ...bA.type, default: "info" }
  },
  emits: [
    vn,
    Tr,
    "remove-tag",
    "clear",
    "visible-change",
    "focus",
    "blur"
  ],
  setup(e, t) {
    const n = Ct("select"), r = Ct("input"), { t: i } = hi(), a = aQ(e), {
      optionsArray: o,
      selectSize: s,
      readonly: l,
      handleResize: u,
      collapseTagSize: c,
      debouncedOnInputChange: f,
      debouncedQueryChange: d,
      deletePrevTag: h,
      deleteTag: p,
      deleteSelected: y,
      handleOptionSelect: m,
      scrollToOption: b,
      setSelected: x,
      resetInputHeight: D,
      managePlaceholder: S,
      showClose: C,
      selectDisabled: v,
      iconComponent: H,
      iconReverse: V,
      showNewOption: R,
      emptyText: F,
      toggleLastOptionHitState: K,
      resetInputState: q,
      handleComposition: G,
      onOptionCreate: te,
      onOptionDestroy: Q,
      handleMenuEnter: Y,
      handleFocus: Z,
      blur: oe,
      handleBlur: he,
      handleClearClick: Ae,
      handleClose: We,
      toggleMenu: ke,
      selectOption: Re,
      getValueKey: ve,
      navigateOptions: Ye,
      dropMenuVisible: Qe,
      reference: ot,
      input: Ve,
      tooltipRef: Te,
      tags: Me,
      selectWrapper: Je,
      scrollbar: mt,
      queryChange: It,
      groupQueryChange: ln
    } = oQ(e, a, t), { focus: gt } = lX(ot), {
      inputWidth: Pe,
      selected: $e,
      inputLength: Ke,
      filteredOptionsCount: lt,
      visible: He,
      softFocus: Le,
      selectedLabel: ct,
      hoverIndex: Qt,
      query: Zt,
      inputHovering: Pn,
      currentPlaceholder: Mn,
      menuVisibleOnFocus: Mt,
      isOnComposition: Nt,
      isSilentBlur: De,
      options: Ue,
      cachedOptions: Se,
      optionsCount: st,
      prefixWidth: kt,
      tagInMultiLine: mn
    } = ma(a), cn = J(() => {
      const wi = [n.b()], Hi = E(s);
      return Hi && wi.push(n.m(Hi)), e.disabled && wi.push(n.m("disabled")), wi;
    }), kn = J(() => ({
      maxWidth: `${E(Pe) - 32}px`,
      width: "100%"
    }));
    _t(_h, zt({
      props: e,
      options: Ue,
      optionsArray: o,
      cachedOptions: Se,
      optionsCount: st,
      filteredOptionsCount: lt,
      hoverIndex: Qt,
      handleOptionSelect: m,
      onOptionCreate: te,
      onOptionDestroy: Q,
      selectWrapper: Je,
      selected: $e,
      setSelected: x,
      queryChange: It,
      groupQueryChange: ln
    })), rn(() => {
      if (a.cachedPlaceHolder = Mn.value = e.placeholder || i("el.select.placeholder"), e.multiple && Array.isArray(e.modelValue) && e.modelValue.length > 0 && (Mn.value = ""), Xl(Je.value, u), ot.value && ot.value.$el) {
        const wi = {
          large: 36,
          default: 32,
          small: 28
        }, Hi = ot.value.input;
        a.initialInputHeight = Hi.getBoundingClientRect().height || wi[s.value];
      }
      e.remote && e.multiple && D(), bt(() => {
        if (!!ot.value && (ot.value.$el && (Pe.value = ot.value.$el.getBoundingClientRect().width), t.slots.prefix)) {
          const wi = ot.value.$el.childNodes, Hi = Array.from(wi).filter((ii) => ii.tagName === "INPUT")[0], Qa = ot.value.$el.querySelector(`.${r.e("prefix")}`);
          kt.value = Math.max(Qa.getBoundingClientRect().width + 5, 30), a.prefixWidth && (Hi.style.paddingLeft = `${Math.max(a.prefixWidth, 30)}px`);
        }
      }), x();
    }), Ti(() => {
      Rl(Je.value, u);
    }), e.multiple && !Array.isArray(e.modelValue) && t.emit(vn, []), !e.multiple && Array.isArray(e.modelValue) && t.emit(vn, "");
    const Tn = J(() => {
      var wi, Hi;
      return (Hi = (wi = Te.value) == null ? void 0 : wi.popperRef) == null ? void 0 : Hi.contentRef;
    }), { compatTeleported: sr } = Uh(Pp, "popperAppendToBody");
    return {
      tagInMultiLine: mn,
      prefixWidth: kt,
      selectSize: s,
      readonly: l,
      handleResize: u,
      collapseTagSize: c,
      debouncedOnInputChange: f,
      debouncedQueryChange: d,
      deletePrevTag: h,
      deleteTag: p,
      deleteSelected: y,
      handleOptionSelect: m,
      scrollToOption: b,
      inputWidth: Pe,
      selected: $e,
      inputLength: Ke,
      filteredOptionsCount: lt,
      visible: He,
      softFocus: Le,
      selectedLabel: ct,
      hoverIndex: Qt,
      query: Zt,
      inputHovering: Pn,
      currentPlaceholder: Mn,
      menuVisibleOnFocus: Mt,
      isOnComposition: Nt,
      isSilentBlur: De,
      options: Ue,
      resetInputHeight: D,
      managePlaceholder: S,
      showClose: C,
      selectDisabled: v,
      iconComponent: H,
      iconReverse: V,
      showNewOption: R,
      emptyText: F,
      toggleLastOptionHitState: K,
      resetInputState: q,
      handleComposition: G,
      handleMenuEnter: Y,
      handleFocus: Z,
      blur: oe,
      handleBlur: he,
      handleClearClick: Ae,
      handleClose: We,
      toggleMenu: ke,
      selectOption: Re,
      getValueKey: ve,
      navigateOptions: Ye,
      dropMenuVisible: Qe,
      focus: gt,
      reference: ot,
      input: Ve,
      tooltipRef: Te,
      popperPaneRef: Tn,
      tags: Me,
      selectWrapper: Je,
      scrollbar: mt,
      wrapperKls: cn,
      selectTagsStyle: kn,
      compatTeleported: sr,
      nsSelect: n
    };
  }
}), lQ = { class: "select-trigger" }, uQ = { key: 0 }, cQ = ["disabled", "autocomplete"], dQ = { style: { height: "100%", display: "flex", "justify-content": "center", "align-items": "center" } };
function fQ(e, t, n, r, i, a) {
  const o = Ie("el-tag"), s = Ie("el-icon"), l = Ie("el-input"), u = Ie("el-option"), c = Ie("el-scrollbar"), f = Ie("el-select-menu"), d = Ie("el-tooltip"), h = va("click-outside");
  return Bt((P(), L("div", {
    ref: "selectWrapper",
    class: se(e.wrapperKls),
    onClick: t[24] || (t[24] = wt((...p) => e.toggleMenu && e.toggleMenu(...p), ["stop"]))
  }, [
    B(d, {
      ref: "tooltipRef",
      visible: e.dropMenuVisible,
      "onUpdate:visible": t[23] || (t[23] = (p) => e.dropMenuVisible = p),
      placement: "bottom-start",
      teleported: e.compatTeleported,
      "popper-class": [e.nsSelect.e("popper"), e.popperClass],
      "fallback-placements": ["bottom-start", "top-start", "right", "left"],
      effect: e.effect,
      pure: "",
      trigger: "click",
      transition: `${e.nsSelect.namespace.value}-zoom-in-top`,
      "stop-popper-mouse-event": !1,
      "gpu-acceleration": !1,
      persistent: "",
      onShow: e.handleMenuEnter
    }, {
      default: N(() => [
        T("div", lQ, [
          e.multiple ? (P(), L("div", {
            key: 0,
            ref: "tags",
            class: se(e.nsSelect.e("tags")),
            style: Pt(e.selectTagsStyle)
          }, [
            e.collapseTags && e.selected.length ? (P(), L("span", uQ, [
              B(o, {
                closable: !e.selectDisabled && !e.selected[0].isDisabled,
                size: e.collapseTagSize,
                hit: e.selected[0].hitState,
                type: e.tagType,
                "disable-transitions": "",
                onClose: t[0] || (t[0] = (p) => e.deleteTag(p, e.selected[0]))
              }, {
                default: N(() => [
                  T("span", {
                    class: se(e.nsSelect.e("tags-text")),
                    style: Pt({ maxWidth: e.inputWidth - 123 + "px" })
                  }, de(e.selected[0].currentLabel), 7)
                ]),
                _: 1
              }, 8, ["closable", "size", "hit", "type"]),
              e.selected.length > 1 ? (P(), ue(o, {
                key: 0,
                closable: !1,
                size: e.collapseTagSize,
                type: e.tagType,
                "disable-transitions": ""
              }, {
                default: N(() => [
                  T("span", {
                    class: se(e.nsSelect.e("tags-text"))
                  }, "+ " + de(e.selected.length - 1), 3)
                ]),
                _: 1
              }, 8, ["size", "type"])) : re("v-if", !0)
            ])) : re("v-if", !0),
            re(" <div> "),
            e.collapseTags ? re("v-if", !0) : (P(), ue(wa, {
              key: 1,
              onAfterLeave: e.resetInputHeight
            }, {
              default: N(() => [
                T("span", {
                  style: Pt({
                    marginLeft: e.prefixWidth && e.selected.length ? `${e.prefixWidth}px` : ""
                  })
                }, [
                  (P(!0), L(nt, null, Lt(e.selected, (p) => (P(), ue(o, {
                    key: e.getValueKey(p),
                    closable: !e.selectDisabled && !p.isDisabled,
                    size: e.collapseTagSize,
                    hit: p.hitState,
                    type: e.tagType,
                    "disable-transitions": "",
                    onClose: (y) => e.deleteTag(y, p)
                  }, {
                    default: N(() => [
                      T("span", {
                        class: se(e.nsSelect.e("tags-text")),
                        style: Pt({ maxWidth: e.inputWidth - 75 + "px" })
                      }, de(p.currentLabel), 7)
                    ]),
                    _: 2
                  }, 1032, ["closable", "size", "hit", "type", "onClose"]))), 128))
                ], 4)
              ]),
              _: 1
            }, 8, ["onAfterLeave"])),
            re(" </div> "),
            e.filterable ? Bt((P(), L("input", {
              key: 2,
              ref: "input",
              "onUpdate:modelValue": t[1] || (t[1] = (p) => e.query = p),
              type: "text",
              class: se([e.nsSelect.e("input"), e.nsSelect.is(e.selectSize)]),
              disabled: e.selectDisabled,
              autocomplete: e.autocomplete,
              style: Pt({
                marginLeft: e.prefixWidth && !e.selected.length || e.tagInMultiLine ? `${e.prefixWidth}px` : "",
                flexGrow: 1,
                width: `${e.inputLength / (e.inputWidth - 32)}%`,
                maxWidth: `${e.inputWidth - 42}px`
              }),
              onFocus: t[2] || (t[2] = (...p) => e.handleFocus && e.handleFocus(...p)),
              onBlur: t[3] || (t[3] = (...p) => e.handleBlur && e.handleBlur(...p)),
              onKeyup: t[4] || (t[4] = (...p) => e.managePlaceholder && e.managePlaceholder(...p)),
              onKeydown: [
                t[5] || (t[5] = (...p) => e.resetInputState && e.resetInputState(...p)),
                t[6] || (t[6] = nn(wt((p) => e.navigateOptions("next"), ["prevent"]), ["down"])),
                t[7] || (t[7] = nn(wt((p) => e.navigateOptions("prev"), ["prevent"]), ["up"])),
                t[8] || (t[8] = nn(wt((p) => e.visible = !1, ["stop", "prevent"]), ["esc"])),
                t[9] || (t[9] = nn(wt((...p) => e.selectOption && e.selectOption(...p), ["stop", "prevent"]), ["enter"])),
                t[10] || (t[10] = nn((...p) => e.deletePrevTag && e.deletePrevTag(...p), ["delete"])),
                t[11] || (t[11] = nn((p) => e.visible = !1, ["tab"]))
              ],
              onCompositionstart: t[12] || (t[12] = (...p) => e.handleComposition && e.handleComposition(...p)),
              onCompositionupdate: t[13] || (t[13] = (...p) => e.handleComposition && e.handleComposition(...p)),
              onCompositionend: t[14] || (t[14] = (...p) => e.handleComposition && e.handleComposition(...p)),
              onInput: t[15] || (t[15] = (...p) => e.debouncedQueryChange && e.debouncedQueryChange(...p))
            }, null, 46, cQ)), [
              [G4, e.query]
            ]) : re("v-if", !0)
          ], 6)) : re("v-if", !0),
          B(l, {
            id: e.id,
            ref: "reference",
            modelValue: e.selectedLabel,
            "onUpdate:modelValue": t[16] || (t[16] = (p) => e.selectedLabel = p),
            type: "text",
            placeholder: e.currentPlaceholder,
            name: e.name,
            autocomplete: e.autocomplete,
            size: e.selectSize,
            disabled: e.selectDisabled,
            readonly: e.readonly,
            "validate-event": !1,
            class: se([e.nsSelect.is("focus", e.visible)]),
            tabindex: e.multiple && e.filterable ? -1 : void 0,
            onFocus: e.handleFocus,
            onBlur: e.handleBlur,
            onInput: e.debouncedOnInputChange,
            onPaste: e.debouncedOnInputChange,
            onCompositionstart: e.handleComposition,
            onCompositionupdate: e.handleComposition,
            onCompositionend: e.handleComposition,
            onKeydown: [
              t[17] || (t[17] = nn(wt((p) => e.navigateOptions("next"), ["stop", "prevent"]), ["down"])),
              t[18] || (t[18] = nn(wt((p) => e.navigateOptions("prev"), ["stop", "prevent"]), ["up"])),
              nn(wt(e.selectOption, ["stop", "prevent"]), ["enter"]),
              t[19] || (t[19] = nn(wt((p) => e.visible = !1, ["stop", "prevent"]), ["esc"])),
              t[20] || (t[20] = nn((p) => e.visible = !1, ["tab"]))
            ],
            onMouseenter: t[21] || (t[21] = (p) => e.inputHovering = !0),
            onMouseleave: t[22] || (t[22] = (p) => e.inputHovering = !1)
          }, rg({
            suffix: N(() => [
              e.iconComponent ? Bt((P(), ue(s, {
                key: 0,
                class: se([e.nsSelect.e("caret"), e.nsSelect.e("icon"), e.iconReverse])
              }, {
                default: N(() => [
                  (P(), ue(Ln(e.iconComponent)))
                ]),
                _: 1
              }, 8, ["class"])), [
                [Cn, !e.showClose]
              ]) : re("v-if", !0),
              e.showClose && e.clearIcon ? (P(), ue(s, {
                key: 1,
                class: se([e.nsSelect.e("caret"), e.nsSelect.e("icon")]),
                onClick: e.handleClearClick
              }, {
                default: N(() => [
                  (P(), ue(Ln(e.clearIcon)))
                ]),
                _: 1
              }, 8, ["class", "onClick"])) : re("v-if", !0)
            ]),
            _: 2
          }, [
            e.$slots.prefix ? {
              name: "prefix",
              fn: N(() => [
                T("div", dQ, [
                  tt(e.$slots, "prefix")
                ])
              ])
            } : void 0
          ]), 1032, ["id", "modelValue", "placeholder", "name", "autocomplete", "size", "disabled", "readonly", "class", "tabindex", "onFocus", "onBlur", "onInput", "onPaste", "onCompositionstart", "onCompositionupdate", "onCompositionend", "onKeydown"])
        ])
      ]),
      content: N(() => [
        B(f, null, {
          default: N(() => [
            Bt(B(c, {
              ref: "scrollbar",
              tag: "ul",
              "wrap-class": e.nsSelect.be("dropdown", "wrap"),
              "view-class": e.nsSelect.be("dropdown", "list"),
              class: se([
                e.nsSelect.is("empty", !e.allowCreate && e.query && e.filteredOptionsCount === 0)
              ])
            }, {
              default: N(() => [
                e.showNewOption ? (P(), ue(u, {
                  key: 0,
                  value: e.query,
                  created: !0
                }, null, 8, ["value"])) : re("v-if", !0),
                tt(e.$slots, "default")
              ]),
              _: 3
            }, 8, ["wrap-class", "view-class", "class"]), [
              [Cn, e.options.size > 0 && !e.loading]
            ]),
            e.emptyText && (!e.allowCreate || e.loading || e.allowCreate && e.options.size === 0) ? (P(), L(nt, { key: 0 }, [
              e.$slots.empty ? tt(e.$slots, "empty", { key: 0 }) : (P(), L("p", {
                key: 1,
                class: se(e.nsSelect.be("dropdown", "empty"))
              }, de(e.emptyText), 3))
            ], 2112)) : re("v-if", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["visible", "teleported", "popper-class", "effect", "transition", "onShow"])
  ], 2)), [
    [h, e.handleClose, e.popperPaneRef]
  ]);
}
var hQ = /* @__PURE__ */ vt(sQ, [["render", fQ]]);
const pQ = Ee({
  name: "ElOptionGroup",
  componentName: "ElOptionGroup",
  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = Ct("select"), n = j(!0), r = sn(), i = j([]);
    _t(iT, zt({
      ...ma(e)
    }));
    const a = ce(_h);
    rn(() => {
      i.value = o(r.subTree);
    });
    const o = (l) => {
      const u = [];
      return Array.isArray(l.children) && l.children.forEach((c) => {
        var f;
        c.type && c.type.name === "ElOption" && c.component && c.component.proxy ? u.push(c.component.proxy) : (f = c.children) != null && f.length && u.push(...o(c));
      }), u;
    }, { groupQueryChange: s } = ag(a);
    return Ne(s, () => {
      n.value = i.value.some((l) => l.visible === !0);
    }), {
      visible: n,
      ns: t
    };
  }
});
function vQ(e, t, n, r, i, a) {
  return Bt((P(), L("ul", {
    class: se(e.ns.be("group", "wrap"))
  }, [
    T("li", {
      class: se(e.ns.be("group", "title"))
    }, de(e.label), 3),
    T("li", null, [
      T("ul", {
        class: se(e.ns.b("group"))
      }, [
        tt(e.$slots, "default")
      ], 2)
    ])
  ], 2)), [
    [Cn, e.visible]
  ]);
}
var rT = /* @__PURE__ */ vt(pQ, [["render", vQ]]);
const Tc = Un(hQ, {
  Option: O3,
  OptionGroup: rT
}), wc = Wi(O3);
Wi(rT);
const z3 = () => ce(gb, {}), mQ = Gt({
  pageSize: {
    type: Number,
    required: !0
  },
  pageSizes: {
    type: jt(Array),
    default: () => da([10, 20, 30, 40, 50, 100])
  },
  popperClass: {
    type: String,
    default: ""
  },
  disabled: Boolean,
  size: {
    type: String,
    default: "default"
  }
}), gQ = Ee({
  name: "ElPaginationSizes",
  components: {
    ElSelect: Tc,
    ElOption: wc
  },
  props: mQ,
  emits: ["page-size-change"],
  setup(e, { emit: t }) {
    const { t: n } = hi(), r = Ct("pagination"), i = z3(), a = j(e.pageSize);
    Ne(() => e.pageSizes, (l, u) => {
      if (!ja(l, u) && Array.isArray(l)) {
        const c = l.indexOf(e.pageSize) > -1 ? e.pageSize : e.pageSizes[0];
        t("page-size-change", c);
      }
    }), Ne(() => e.pageSize, (l) => {
      a.value = l;
    });
    const o = J(() => e.pageSizes);
    function s(l) {
      var u;
      l !== a.value && (a.value = l, (u = i.handleSizeChange) == null || u.call(i, Number(l)));
    }
    return {
      ns: r,
      innerPagesizes: o,
      innerPageSize: a,
      t: n,
      handleChange: s
    };
  }
});
function yQ(e, t, n, r, i, a) {
  const o = Ie("el-option"), s = Ie("el-select");
  return P(), L("span", {
    class: se(e.ns.e("sizes"))
  }, [
    B(s, {
      "model-value": e.innerPageSize,
      disabled: e.disabled,
      "popper-class": e.popperClass,
      size: e.size,
      onChange: e.handleChange
    }, {
      default: N(() => [
        (P(!0), L(nt, null, Lt(e.innerPagesizes, (l) => (P(), ue(o, {
          key: l,
          value: l,
          label: l + e.t("el.pagination.pagesize")
        }, null, 8, ["value", "label"]))), 128))
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "popper-class", "size", "onChange"])
  ], 2);
}
var bQ = /* @__PURE__ */ vt(gQ, [["render", yQ]]);
const AQ = Ee({
  name: "ElPaginationJumper",
  components: {
    ElInput: ti
  },
  setup() {
    const { t: e } = hi(), t = Ct("pagination"), { pageCount: n, disabled: r, currentPage: i, changeEvent: a } = z3(), o = j(), s = J(() => {
      var c;
      return (c = o.value) != null ? c : i == null ? void 0 : i.value;
    });
    function l(c) {
      o.value = +c;
    }
    function u(c) {
      c = Math.trunc(+c), a == null || a(+c), o.value = void 0;
    }
    return {
      ns: t,
      pageCount: n,
      disabled: r,
      innerValue: s,
      t: e,
      handleInput: l,
      handleChange: u
    };
  }
}), TQ = ["disabled"];
function wQ(e, t, n, r, i, a) {
  const o = Ie("el-input");
  return P(), L("span", {
    class: se(e.ns.e("jump")),
    disabled: e.disabled
  }, [
    je(de(e.t("el.pagination.goto")) + " ", 1),
    B(o, {
      size: "small",
      class: se([e.ns.e("editor"), e.ns.is("in-pagination")]),
      min: 1,
      max: e.pageCount,
      disabled: e.disabled,
      "model-value": e.innerValue,
      type: "number",
      "onUpdate:modelValue": e.handleInput,
      onChange: e.handleChange
    }, null, 8, ["class", "max", "disabled", "model-value", "onUpdate:modelValue", "onChange"]),
    je(" " + de(e.t("el.pagination.pageClassifier")), 1)
  ], 10, TQ);
}
var PQ = /* @__PURE__ */ vt(AQ, [["render", wQ]]);
const xQ = {
  total: {
    type: Number,
    default: 1e3
  }
}, CQ = Ee({
  name: "ElPaginationTotal",
  props: xQ,
  setup() {
    const { t: e } = hi(), t = Ct("pagination"), { disabled: n } = z3();
    return {
      t: e,
      ns: t,
      disabled: n
    };
  }
}), SQ = ["disabled"];
function EQ(e, t, n, r, i, a) {
  return P(), L("span", {
    class: se(e.ns.e("total")),
    disabled: e.disabled
  }, de(e.t("el.pagination.total", {
    total: e.total
  })), 11, SQ);
}
var kQ = /* @__PURE__ */ vt(CQ, [["render", EQ]]);
const OQ = {
  currentPage: {
    type: Number,
    default: 1
  },
  pageCount: {
    type: Number,
    required: !0
  },
  pagerCount: {
    type: Number,
    default: 7
  },
  disabled: Boolean
}, zQ = Ee({
  name: "ElPaginationPager",
  components: {
    DArrowLeft: Lh,
    DArrowRight: Bh,
    MoreFilled: vF
  },
  props: OQ,
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = Ct("pager"), r = Ct("icon"), i = j(!1), a = j(!1), o = j(!1), s = j(!1), l = J(() => {
      const d = e.pagerCount, h = (d - 1) / 2, p = Number(e.currentPage), y = Number(e.pageCount);
      let m = !1, b = !1;
      y > d && (p > d - h && (m = !0), p < y - h && (b = !0));
      const x = [];
      if (m && !b) {
        const D = y - (d - 2);
        for (let S = D; S < y; S++)
          x.push(S);
      } else if (!m && b)
        for (let D = 2; D < d; D++)
          x.push(D);
      else if (m && b) {
        const D = Math.floor(d / 2) - 1;
        for (let S = p - D; S <= p + D; S++)
          x.push(S);
      } else
        for (let D = 2; D < y; D++)
          x.push(D);
      return x;
    });
    Bo(() => {
      const d = (e.pagerCount - 1) / 2;
      i.value = !1, a.value = !1, e.pageCount > e.pagerCount && (e.currentPage > e.pagerCount - d && (i.value = !0), e.currentPage < e.pageCount - d && (a.value = !0));
    });
    function u(d) {
      e.disabled || (d === "left" ? o.value = !0 : s.value = !0);
    }
    function c(d) {
      const h = d.target;
      if (h.tagName.toLowerCase() === "li" && Array.from(h.classList).includes("number")) {
        const p = Number(h.textContent);
        p !== e.currentPage && t("change", p);
      }
    }
    function f(d) {
      const h = d.target;
      if (h.tagName.toLowerCase() === "ul" || e.disabled)
        return;
      let p = Number(h.textContent);
      const y = e.pageCount, m = e.currentPage, b = e.pagerCount - 2;
      h.className.includes("more") && (h.className.includes("quickprev") ? p = m - b : h.className.includes("quicknext") && (p = m + b)), isNaN(p) || (p < 1 && (p = 1), p > y && (p = y)), p !== m && t("change", p);
    }
    return {
      showPrevMore: i,
      showNextMore: a,
      quickPrevHover: o,
      quickNextHover: s,
      pagers: l,
      nsPager: n,
      nsIcon: r,
      onMouseenter: u,
      onPagerClick: f,
      onEnter: c
    };
  }
}), DQ = ["aria-current"], MQ = ["aria-current"], HQ = ["aria-current"];
function IQ(e, t, n, r, i, a) {
  const o = Ie("d-arrow-left"), s = Ie("more-filled"), l = Ie("d-arrow-right");
  return P(), L("ul", {
    class: se(e.nsPager.b()),
    onClick: t[4] || (t[4] = (...u) => e.onPagerClick && e.onPagerClick(...u)),
    onKeyup: t[5] || (t[5] = nn((...u) => e.onEnter && e.onEnter(...u), ["enter"]))
  }, [
    e.pageCount > 0 ? (P(), L("li", {
      key: 0,
      class: se([{ active: e.currentPage === 1, disabled: e.disabled }, "number"]),
      "aria-current": e.currentPage === 1,
      tabindex: "0"
    }, " 1 ", 10, DQ)) : re("v-if", !0),
    e.showPrevMore ? (P(), L("li", {
      key: 1,
      class: se(["more", "btn-quickprev", e.nsIcon.b(), { disabled: e.disabled }]),
      onMouseenter: t[0] || (t[0] = (u) => e.onMouseenter("left")),
      onMouseleave: t[1] || (t[1] = (u) => e.quickPrevHover = !1)
    }, [
      e.quickPrevHover ? (P(), ue(o, { key: 0 })) : (P(), ue(s, { key: 1 }))
    ], 34)) : re("v-if", !0),
    (P(!0), L(nt, null, Lt(e.pagers, (u) => (P(), L("li", {
      key: u,
      class: se([{ active: e.currentPage === u, disabled: e.disabled }, "number"]),
      "aria-current": e.currentPage === u,
      tabindex: "0"
    }, de(u), 11, MQ))), 128)),
    e.showNextMore ? (P(), L("li", {
      key: 2,
      class: se(["more", "btn-quicknext", e.nsIcon.b(), { disabled: e.disabled }]),
      onMouseenter: t[2] || (t[2] = (u) => e.onMouseenter("right")),
      onMouseleave: t[3] || (t[3] = (u) => e.quickNextHover = !1)
    }, [
      e.quickNextHover ? (P(), ue(l, { key: 0 })) : (P(), ue(s, { key: 1 }))
    ], 34)) : re("v-if", !0),
    e.pageCount > 1 ? (P(), L("li", {
      key: 3,
      class: se([{ active: e.currentPage === e.pageCount, disabled: e.disabled }, "number"]),
      "aria-current": e.currentPage === e.pageCount,
      tabindex: "0"
    }, de(e.pageCount), 11, HQ)) : re("v-if", !0)
  ], 34);
}
var LQ = /* @__PURE__ */ vt(zQ, [["render", IQ]]);
const fr = (e) => typeof e != "number", BQ = Gt({
  total: Number,
  pageSize: Number,
  defaultPageSize: Number,
  currentPage: Number,
  defaultCurrentPage: Number,
  pageCount: Number,
  pagerCount: {
    type: Number,
    validator: (e) => typeof e == "number" && (e | 0) === e && e > 4 && e < 22 && e % 2 === 1,
    default: 7
  },
  layout: {
    type: String,
    default: ["prev", "pager", "next", "jumper", "->", "total"].join(", ")
  },
  pageSizes: {
    type: jt(Array),
    default: () => da([10, 20, 30, 40, 50, 100])
  },
  popperClass: {
    type: String,
    default: ""
  },
  prevText: {
    type: String,
    default: ""
  },
  nextText: {
    type: String,
    default: ""
  },
  small: Boolean,
  background: Boolean,
  disabled: Boolean,
  hideOnSinglePage: Boolean
}), NQ = {
  "update:current-page": (e) => typeof e == "number",
  "update:page-size": (e) => typeof e == "number",
  "size-change": (e) => typeof e == "number",
  "current-change": (e) => typeof e == "number",
  "prev-click": (e) => typeof e == "number",
  "next-click": (e) => typeof e == "number"
}, y7 = "ElPagination";
var jQ = Ee({
  name: y7,
  props: BQ,
  emits: NQ,
  setup(e, { emit: t, slots: n }) {
    const { t: r } = hi(), i = Ct("pagination"), a = sn().vnode.props || {}, o = "onUpdate:currentPage" in a || "onUpdate:current-page" in a || "onCurrentChange" in a, s = "onUpdate:pageSize" in a || "onUpdate:page-size" in a || "onSizeChange" in a, l = J(() => {
      if (fr(e.total) && fr(e.pageCount) || !fr(e.currentPage) && !o)
        return !1;
      if (e.layout.includes("sizes")) {
        if (fr(e.pageCount)) {
          if (!fr(e.total) && !fr(e.pageSize) && !s)
            return !1;
        } else if (!s)
          return !1;
      }
      return !0;
    }), u = j(fr(e.defaultPageSize) ? 10 : e.defaultPageSize), c = j(fr(e.defaultCurrentPage) ? 1 : e.defaultCurrentPage), f = J({
      get() {
        return fr(e.pageSize) ? u.value : e.pageSize;
      },
      set(D) {
        fr(e.pageSize) && (u.value = D), s && (t("update:page-size", D), t("size-change", D));
      }
    }), d = J(() => {
      let D = 0;
      return fr(e.pageCount) ? fr(e.total) || (D = Math.max(1, Math.ceil(e.total / f.value))) : D = e.pageCount, D;
    }), h = J({
      get() {
        return fr(e.currentPage) ? c.value : e.currentPage;
      },
      set(D) {
        let S = D;
        D < 1 ? S = 1 : D > d.value && (S = d.value), fr(e.currentPage) && (c.value = S), o && (t("update:current-page", S), t("current-change", S));
      }
    });
    Ne(d, (D) => {
      h.value > D && (h.value = D);
    });
    function p(D) {
      h.value = D;
    }
    function y(D) {
      f.value = D;
      const S = d.value;
      h.value > S && (h.value = S);
    }
    function m() {
      e.disabled || (h.value -= 1, t("prev-click", h.value));
    }
    function b() {
      e.disabled || (h.value += 1, t("next-click", h.value));
    }
    function x(D, S) {
      D && (D.props || (D.props = {}), D.props.class = [D.props.class, S].join(" "));
    }
    return _t(gb, {
      pageCount: d,
      disabled: J(() => e.disabled),
      currentPage: h,
      changeEvent: p,
      handleSizeChange: y
    }), () => {
      var D, S;
      if (!l.value)
        return fi(y7, r("el.pagination.deprecationWarning")), null;
      if (!e.layout || e.hideOnSinglePage && d.value <= 1)
        return null;
      const C = [], v = [], H = et("div", { class: i.e("rightwrapper") }, v), V = {
        prev: et(WY, {
          disabled: e.disabled,
          currentPage: h.value,
          prevText: e.prevText,
          onClick: m
        }),
        jumper: et(PQ),
        pager: et(LQ, {
          currentPage: h.value,
          pageCount: d.value,
          pagerCount: e.pagerCount,
          onChange: p,
          disabled: e.disabled
        }),
        next: et(JY, {
          disabled: e.disabled,
          currentPage: h.value,
          pageCount: d.value,
          nextText: e.nextText,
          onClick: b
        }),
        sizes: et(bQ, {
          pageSize: f.value,
          pageSizes: e.pageSizes,
          popperClass: e.popperClass,
          disabled: e.disabled,
          size: e.small ? "small" : "default"
        }),
        slot: (S = (D = n == null ? void 0 : n.default) == null ? void 0 : D.call(n)) != null ? S : null,
        total: et(kQ, { total: fr(e.total) ? 0 : e.total })
      }, R = e.layout.split(",").map((K) => K.trim());
      let F = !1;
      return R.forEach((K) => {
        if (K === "->") {
          F = !0;
          return;
        }
        F ? v.push(V[K]) : C.push(V[K]);
      }), x(C[0], i.is("first")), x(C[C.length - 1], i.is("last")), F && v.length > 0 && (x(v[0], i.is("first")), x(v[v.length - 1], i.is("last")), C.push(H)), et("div", {
        role: "pagination",
        "aria-label": "pagination",
        class: [
          i.b(),
          i.is("background", e.background),
          {
            [i.m("small")]: e.small
          }
        ]
      }, C);
    };
  }
});
const D3 = Un(jQ), FQ = Gt({
  trigger: Ud.trigger,
  placement: n0.placement,
  disabled: Ud.disabled,
  visible: zr.visible,
  transition: zr.transition,
  popperOptions: n0.popperOptions,
  tabindex: n0.tabindex,
  appendToBody: { type: Boolean, default: void 0 },
  content: zr.content,
  popperStyle: zr.popperStyle,
  popperClass: zr.popperClass,
  enterable: {
    ...zr.enterable,
    default: !0
  },
  effect: {
    ...zr.effect,
    default: "light"
  },
  teleported: zr.teleported,
  title: String,
  width: {
    type: [String, Number],
    default: 150
  },
  offset: {
    type: Number,
    default: void 0
  },
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  },
  showArrow: {
    type: Boolean,
    default: !0
  }
}), XQ = ["update:visible", "after-enter", "after-leave"], b7 = "ElPopover", RQ = Ee({
  name: b7,
  components: {
    ElTooltip: Ki
  },
  props: FQ,
  emits: XQ,
  setup(e, { emit: t }) {
    const n = Ct("popover"), r = j(null), i = J(() => {
      var d;
      return (d = E(r)) == null ? void 0 : d.popperRef;
    }), a = J(() => Ai(e.width) ? e.width : `${e.width}px`), o = J(() => [
      {
        width: a.value
      },
      e.popperStyle
    ]), s = J(() => [n.b(), e.popperClass, { [n.m("plain")]: !!e.content }]), { compatTeleported: l } = Uh(b7, "appendToBody");
    return {
      compatTeleported: l,
      ns: n,
      kls: s,
      style: o,
      tooltipRef: r,
      popperRef: i,
      hide: () => {
        var d;
        (d = r.value) == null || d.hide();
      },
      afterEnter: () => {
        t("after-enter");
      },
      afterLeave: () => {
        t("after-leave");
      }
    };
  }
});
function VQ(e, t, n, r, i, a) {
  const o = Ie("el-tooltip");
  return P(), ue(o, $r({ ref: "tooltipRef" }, e.$attrs, {
    trigger: e.trigger,
    placement: e.placement,
    disabled: e.disabled,
    visible: e.visible,
    transition: e.transition,
    "popper-options": e.popperOptions,
    tabindex: e.tabindex,
    "append-to-body": e.appendToBody,
    content: e.content,
    offset: e.offset,
    "show-after": e.showAfter,
    "hide-after": e.hideAfter,
    "auto-close": e.autoClose,
    "show-arrow": e.showArrow,
    "aria-label": e.title,
    effect: e.effect,
    enterable: e.enterable,
    "popper-class": e.kls,
    "popper-style": e.style,
    teleported: e.compatTeleported,
    persistent: "",
    onShow: e.afterEnter,
    onHide: e.afterLeave
  }), {
    content: N(() => [
      e.title ? (P(), L("div", {
        key: 0,
        class: se(e.ns.e("title")),
        role: "title"
      }, de(e.title), 3)) : re("v-if", !0),
      tt(e.$slots, "default", {}, () => [
        je(de(e.content), 1)
      ])
    ]),
    default: N(() => [
      e.$slots.reference ? tt(e.$slots, "reference", { key: 0 }) : re("v-if", !0)
    ]),
    _: 3
  }, 16, ["trigger", "placement", "disabled", "visible", "transition", "popper-options", "tabindex", "append-to-body", "content", "offset", "show-after", "hide-after", "auto-close", "show-arrow", "aria-label", "effect", "enterable", "popper-class", "popper-style", "teleported", "onShow", "onHide"]);
}
var Td = /* @__PURE__ */ vt(RQ, [["render", VQ]]);
const A7 = (e, t) => {
  const n = t.arg || t.value, r = n == null ? void 0 : n.popperRef;
  r && (r.triggerRef = e);
};
var W8 = {
  mounted(e, t) {
    A7(e, t);
  },
  updated(e, t) {
    A7(e, t);
  }
};
const UQ = "popover";
Td.install = (e) => {
  e.component(Td.name, Td);
};
W8.install = (e) => {
  e.directive(UQ, W8);
};
const qQ = W8;
Td.directive = qQ;
const _Q = Td, gf = _Q, WQ = Gt({
  type: {
    type: String,
    default: "line",
    values: ["line", "circle", "dashboard"]
  },
  percentage: {
    type: Number,
    default: 0,
    validator: (e) => e >= 0 && e <= 100
  },
  status: {
    type: String,
    default: "",
    values: ["", "success", "exception", "warning"]
  },
  indeterminate: {
    type: Boolean,
    default: !1
  },
  duration: {
    type: Number,
    default: 3
  },
  strokeWidth: {
    type: Number,
    default: 6
  },
  strokeLinecap: {
    type: jt(String),
    default: "round"
  },
  textInside: {
    type: Boolean,
    default: !1
  },
  width: {
    type: Number,
    default: 126
  },
  showText: {
    type: Boolean,
    default: !0
  },
  color: {
    type: jt([
      String,
      Array,
      Function
    ]),
    default: ""
  },
  format: {
    type: jt(Function),
    default: (e) => `${e}%`
  }
}), KQ = Ee({
  name: "ElProgress",
  components: {
    ElIcon: qt,
    CircleCheck: L0,
    CircleClose: Hs,
    Check: Xd,
    Close: Is,
    WarningFilled: B0
  },
  props: WQ,
  setup(e) {
    const t = Ct("progress"), n = J(() => ({
      width: `${e.percentage}%`,
      animationDuration: `${e.duration}s`,
      backgroundColor: y(e.percentage)
    })), r = J(() => (e.strokeWidth / e.width * 100).toFixed(1)), i = J(() => e.type === "circle" || e.type === "dashboard" ? parseInt(`${50 - parseFloat(r.value) / 2}`, 10) : 0), a = J(() => {
      const b = i.value, x = e.type === "dashboard";
      return `
          M 50 50
          m 0 ${x ? "" : "-"}${b}
          a ${b} ${b} 0 1 1 0 ${x ? "-" : ""}${b * 2}
          a ${b} ${b} 0 1 1 0 ${x ? "" : "-"}${b * 2}
          `;
    }), o = J(() => 2 * Math.PI * i.value), s = J(() => e.type === "dashboard" ? 0.75 : 1), l = J(() => `${-1 * o.value * (1 - s.value) / 2}px`), u = J(() => ({
      strokeDasharray: `${o.value * s.value}px, ${o.value}px`,
      strokeDashoffset: l.value
    })), c = J(() => ({
      strokeDasharray: `${o.value * s.value * (e.percentage / 100)}px, ${o.value}px`,
      strokeDashoffset: l.value,
      transition: "stroke-dasharray 0.6s ease 0s, stroke 0.6s ease"
    })), f = J(() => {
      let b;
      if (e.color)
        b = y(e.percentage);
      else
        switch (e.status) {
          case "success":
            b = "#13ce66";
            break;
          case "exception":
            b = "#ff4949";
            break;
          case "warning":
            b = "#e6a23c";
            break;
          default:
            b = "#20a0ff";
        }
      return b;
    }), d = J(() => e.status === "warning" ? B0 : e.type === "line" ? e.status === "success" ? L0 : Hs : e.status === "success" ? Xd : Is), h = J(() => e.type === "line" ? 12 + e.strokeWidth * 0.4 : e.width * 0.111111 + 2), p = J(() => e.format(e.percentage)), y = (b) => {
      var x;
      const { color: D } = e;
      if (typeof D == "function")
        return D(b);
      if (typeof D == "string")
        return D;
      {
        const S = 100 / D.length, v = D.map((H, V) => typeof H == "string" ? {
          color: H,
          percentage: (V + 1) * S
        } : H).sort((H, V) => H.percentage - V.percentage);
        for (const H of v)
          if (H.percentage > b)
            return H.color;
        return (x = v[v.length - 1]) == null ? void 0 : x.color;
      }
    }, m = J(() => ({
      percentage: e.percentage
    }));
    return {
      ns: t,
      barStyle: n,
      relativeStrokeWidth: r,
      radius: i,
      trackPath: a,
      perimeter: o,
      rate: s,
      strokeDashoffset: l,
      trailPathStyle: u,
      circlePathStyle: c,
      stroke: f,
      statusIcon: d,
      progressTextSize: h,
      content: p,
      slotData: m
    };
  }
}), GQ = ["aria-valuenow"], YQ = { viewBox: "0 0 100 100" }, QQ = ["d", "stroke-width"], ZQ = ["d", "stroke", "stroke-linecap", "stroke-width"], JQ = { key: 0 };
function $Q(e, t, n, r, i, a) {
  const o = Ie("el-icon");
  return P(), L("div", {
    class: se([
      e.ns.b(),
      e.ns.m(e.type),
      e.ns.is(e.status),
      {
        [e.ns.m("without-text")]: !e.showText,
        [e.ns.m("text-inside")]: e.textInside
      }
    ]),
    role: "progressbar",
    "aria-valuenow": e.percentage,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, [
    e.type === "line" ? (P(), L("div", {
      key: 0,
      class: se(e.ns.b("bar"))
    }, [
      T("div", {
        class: se(e.ns.be("bar", "outer")),
        style: Pt({ height: `${e.strokeWidth}px` })
      }, [
        T("div", {
          class: se([
            e.ns.be("bar", "inner"),
            { [e.ns.bem("bar", "inner", "indeterminate")]: e.indeterminate }
          ]),
          style: Pt(e.barStyle)
        }, [
          (e.showText || e.$slots.default) && e.textInside ? (P(), L("div", {
            key: 0,
            class: se(e.ns.be("bar", "innerText"))
          }, [
            tt(e.$slots, "default", E0(k0(e.slotData)), () => [
              T("span", null, de(e.content), 1)
            ])
          ], 2)) : re("v-if", !0)
        ], 6)
      ], 6)
    ], 2)) : (P(), L("div", {
      key: 1,
      class: se(e.ns.b("circle")),
      style: Pt({ height: `${e.width}px`, width: `${e.width}px` })
    }, [
      (P(), L("svg", YQ, [
        T("path", {
          class: se(e.ns.be("circle", "track")),
          d: e.trackPath,
          stroke: "#e5e9f2",
          "stroke-width": e.relativeStrokeWidth,
          fill: "none",
          style: Pt(e.trailPathStyle)
        }, null, 14, QQ),
        T("path", {
          class: se(e.ns.be("circle", "path")),
          d: e.trackPath,
          stroke: e.stroke,
          fill: "none",
          "stroke-linecap": e.strokeLinecap,
          "stroke-width": e.percentage ? e.relativeStrokeWidth : 0,
          style: Pt(e.circlePathStyle)
        }, null, 14, ZQ)
      ]))
    ], 6)),
    (e.showText || e.$slots.default) && !e.textInside ? (P(), L("div", {
      key: 2,
      class: se(e.ns.e("text")),
      style: Pt({ fontSize: `${e.progressTextSize}px` })
    }, [
      tt(e.$slots, "default", E0(k0(e.slotData)), () => [
        e.status ? (P(), ue(o, { key: 1 }, {
          default: N(() => [
            (P(), ue(Ln(e.statusIcon)))
          ]),
          _: 1
        })) : (P(), L("span", JQ, de(e.content), 1))
      ])
    ], 6)) : re("v-if", !0)
  ], 10, GQ);
}
var eZ = /* @__PURE__ */ vt(KQ, [["render", $Q]]);
const M3 = Un(eZ), tZ = Gt({
  tag: {
    type: String,
    default: "div"
  },
  gutter: {
    type: Number,
    default: 0
  },
  justify: {
    type: String,
    values: ["start", "center", "end", "space-around", "space-between"],
    default: "start"
  },
  align: {
    type: String,
    values: ["top", "middle", "bottom"],
    default: "top"
  }
}), nZ = Ee({
  name: "ElRow",
  props: tZ,
  setup(e, { slots: t }) {
    const n = Ct("row"), r = J(() => e.gutter);
    _t("ElRow", {
      gutter: r
    });
    const i = J(() => {
      const a = {
        marginLeft: "",
        marginRight: ""
      };
      return e.gutter && (a.marginLeft = `-${e.gutter / 2}px`, a.marginRight = a.marginLeft), a;
    });
    return () => {
      var a;
      return et(e.tag, {
        class: [
          n.b(),
          n.is(`justify-${e.justify}`, e.justify !== "start"),
          n.is(`align-${e.align}`, e.align !== "top")
        ],
        style: i.value
      }, (a = t.default) == null ? void 0 : a.call(t));
    };
  }
}), aT = Un(nZ);
var T7 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function iZ(e, t) {
  return !!(e === t || T7(e) && T7(t));
}
function rZ(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!iZ(e[n], t[n]))
      return !1;
  return !0;
}
function aZ(e, t) {
  t === void 0 && (t = rZ);
  var n = null;
  function r() {
    for (var i = [], a = 0; a < arguments.length; a++)
      i[a] = arguments[a];
    if (n && n.lastThis === this && t(i, n.lastArgs))
      return n.lastResult;
    var o = e.apply(this, i);
    return n = {
      lastResult: o,
      lastArgs: i,
      lastThis: this
    }, o;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
const oZ = () => {
  const t = sn().proxy.$props;
  return J(() => {
    const n = (r, i, a) => ({});
    return t.perfMode ? Mh(n) : aZ(n);
  });
}, sZ = 50, w7 = "item-rendered", P7 = "scroll", oT = "forward", sT = "backward", _d = "auto", lT = "smart", uT = "start", X0 = "center", cT = "end", Gu = "horizontal", H3 = "vertical", lZ = "ltr", r0 = "rtl", dT = "negative", uZ = "positive-ascending", fT = "positive-descending", cZ = {
  [Gu]: "left",
  [H3]: "top"
}, dZ = 20, xp = (e, t) => e < t ? oT : sT, Wd = (e) => e === lZ || e === r0 || e === Gu;
let lu = null;
function x7(e = !1) {
  if (lu === null || e) {
    const t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    const r = document.createElement("div"), i = r.style;
    return i.width = "100px", i.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? lu = fT : (t.scrollLeft = 1, t.scrollLeft === 0 ? lu = dT : lu = uZ), document.body.removeChild(t), lu;
  }
  return lu;
}
function fZ({ move: e, size: t, bar: n }, r) {
  const i = {}, a = `translate${n.axis}(${e}px)`;
  return i[n.size] = t, i.transform = a, i.msTransform = a, i.webkitTransform = a, r === "horizontal" ? i.height = "100%" : i.width = "100%", i;
}
const hZ = typeof navigator < "u" && tr(navigator) && /Firefox/i.test(navigator.userAgent), pZ = {
  [Gu]: "deltaX",
  [H3]: "deltaY"
}, vZ = ({ atEndEdge: e, atStartEdge: t, layout: n }, r) => {
  let i, a = 0;
  const o = (l) => l < 0 && t.value || l > 0 && e.value;
  return {
    hasReachedEdge: o,
    onWheel: (l) => {
      vb(i);
      const u = l[pZ[n.value]];
      o(a) && o(a + u) || (a += u, hZ || l.preventDefault(), i = pb(() => {
        r(a), a = 0;
      }));
    }
  };
}, K8 = _a({
  type: jt([Number, Function]),
  required: !0
}), G8 = _a({
  type: Number
}), Y8 = _a({
  type: Number,
  default: 2
}), mZ = _a({
  type: String,
  values: ["ltr", "rtl"],
  default: "ltr"
}), Q8 = _a({
  type: Number,
  default: 0
}), R0 = _a({
  type: Number,
  required: !0
}), hT = _a({
  type: String,
  values: ["horizontal", "vertical"],
  default: H3
}), pT = Gt({
  className: {
    type: String,
    default: ""
  },
  containerElement: {
    type: jt([String, Object]),
    default: "div"
  },
  data: {
    type: jt(Array),
    default: () => da([])
  },
  direction: mZ,
  height: {
    type: [String, Number],
    required: !0
  },
  innerElement: {
    type: [String, Object],
    default: "div"
  },
  style: {
    type: jt([Object, String, Array])
  },
  useIsScrolling: {
    type: Boolean,
    default: !1
  },
  width: {
    type: [Number, String],
    required: !1
  },
  perfMode: {
    type: Boolean,
    default: !0
  },
  scrollbarAlwaysOn: {
    type: Boolean,
    default: !1
  }
}), gZ = Gt({
  cache: Y8,
  estimatedItemSize: G8,
  layout: hT,
  initScrollOffset: Q8,
  total: R0,
  itemSize: K8,
  ...pT
});
Gt({
  columnCache: Y8,
  columnWidth: K8,
  estimatedColumnWidth: G8,
  estimatedRowHeight: G8,
  initScrollLeft: Q8,
  initScrollTop: Q8,
  rowCache: Y8,
  rowHeight: K8,
  totalColumn: R0,
  totalRow: R0,
  ...pT
});
const yZ = Gt({
  layout: hT,
  total: R0,
  ratio: {
    type: Number,
    required: !0
  },
  clientSize: {
    type: Number,
    required: !0
  },
  scrollFrom: {
    type: Number,
    required: !0
  },
  visible: Boolean
}), bZ = Ee({
  name: "ElVirtualScrollBar",
  props: yZ,
  emits: ["scroll", "start-move", "stop-move"],
  setup(e, { emit: t }) {
    const r = j(), i = j();
    let a = null, o = null;
    const s = zt({
      isDragging: !1,
      traveled: 0
    }), l = J(() => Bb[e.layout]), u = J(() => e.clientSize - 4), c = J(() => ({
      position: "absolute",
      width: Gu === e.layout ? `${u.value}px` : "6px",
      height: Gu === e.layout ? "6px" : `${u.value}px`,
      [cZ[e.layout]]: "2px",
      right: "2px",
      bottom: "2px",
      borderRadius: "4px"
    })), f = J(() => {
      const C = e.ratio, v = e.clientSize;
      if (C >= 100)
        return Number.POSITIVE_INFINITY;
      if (C >= 50)
        return C * v / 100;
      const H = v / 3;
      return Math.floor(Math.min(Math.max(C * v, dZ), H));
    }), d = J(() => {
      if (!Number.isFinite(f.value))
        return {
          display: "none"
        };
      const C = `${f.value}px`;
      return fZ({
        bar: l.value,
        size: C,
        move: s.traveled
      }, e.layout);
    }), h = J(() => Math.floor(e.clientSize - f.value - 4)), p = () => {
      _n(window, "mousemove", x), _n(window, "mouseup", b);
      const C = E(i);
      !C || (o = document.onselectstart, document.onselectstart = () => !1, _n(C, "touchmove", x), _n(C, "touchend", b));
    }, y = () => {
      si(window, "mousemove", x), si(window, "mouseup", b), document.onselectstart = o, o = null;
      const C = E(i);
      !C || (si(C, "touchmove", x), si(C, "touchend", b));
    }, m = (C) => {
      C.stopImmediatePropagation(), !(C.ctrlKey || [1, 2].includes(C.button)) && (s.isDragging = !0, s[l.value.axis] = C.currentTarget[l.value.offset] - (C[l.value.client] - C.currentTarget.getBoundingClientRect()[l.value.direction]), t("start-move"), p());
    }, b = () => {
      s.isDragging = !1, s[l.value.axis] = 0, t("stop-move"), y();
    }, x = (C) => {
      const { isDragging: v } = s;
      if (!v || !i.value || !r.value)
        return;
      const H = s[l.value.axis];
      if (!H)
        return;
      vb(a);
      const V = (r.value.getBoundingClientRect()[l.value.direction] - C[l.value.client]) * -1, R = i.value[l.value.offset] - H, F = V - R;
      a = pb(() => {
        s.traveled = Math.max(0, Math.min(F, h.value)), t("scroll", F, h.value);
      });
    }, D = (C) => {
      const v = Math.abs(C.target.getBoundingClientRect()[l.value.direction] - C[l.value.client]), H = i.value[l.value.offset] / 2, V = v - H;
      s.traveled = Math.max(0, Math.min(V, h.value)), t("scroll", V, h.value);
    }, S = (C) => C.preventDefault();
    return Ne(() => e.scrollFrom, (C) => {
      s.isDragging || (s.traveled = Math.ceil(C * h.value));
    }), rn(() => {
      !Sn || (_n(r.value, "touchstart", S), _n(i.value, "touchstart", m));
    }), Ti(() => {
      si(r.value, "touchstart", S), y();
    }), () => et("div", {
      role: "presentation",
      ref: r,
      class: "el-virtual-scrollbar",
      style: c.value,
      onMousedown: wt(D, ["stop", "prevent"])
    }, et("div", {
      ref: i,
      class: "el-scrollbar__thumb",
      style: d.value,
      onMousedown: m
    }, []));
  }
}), vT = ({
  name: e,
  getOffset: t,
  getItemSize: n,
  getItemOffset: r,
  getEstimatedTotalSize: i,
  getStartIndexForOffset: a,
  getStopIndexForStartIndex: o,
  initCache: s,
  clearCache: l,
  validateProps: u
}) => Ee({
  name: e != null ? e : "ElVirtualList",
  props: gZ,
  emits: [w7, P7],
  setup(c, { emit: f, expose: d }) {
    u(c);
    const h = sn(), p = j(s(c, h)), y = oZ(), m = j(), b = j(), x = j(), D = j({
      isScrolling: !1,
      scrollDir: "forward",
      scrollOffset: jn(c.initScrollOffset) ? c.initScrollOffset : 0,
      updateRequested: !1,
      isScrollbarDragging: !1,
      scrollbarAlwaysOn: c.scrollbarAlwaysOn
    }), S = J(() => {
      const { total: ke, cache: Re } = c, { isScrolling: ve, scrollDir: Ye, scrollOffset: Qe } = E(D);
      if (ke === 0)
        return [0, 0, 0, 0];
      const ot = a(c, Qe, E(p)), Ve = o(c, ot, Qe, E(p)), Te = !ve || Ye === sT ? Math.max(1, Re) : 1, Me = !ve || Ye === oT ? Math.max(1, Re) : 1;
      return [
        Math.max(0, ot - Te),
        Math.max(0, Math.min(ke - 1, Ve + Me)),
        ot,
        Ve
      ];
    }), C = J(() => i(c, E(p))), v = J(() => Wd(c.layout)), H = J(() => [
      {
        position: "relative",
        overflow: "hidden",
        WebkitOverflowScrolling: "touch",
        willChange: "transform"
      },
      {
        direction: c.direction,
        height: jn(c.height) ? `${c.height}px` : c.height,
        width: jn(c.width) ? `${c.width}px` : c.width
      },
      c.style
    ]), V = J(() => {
      const ke = E(C), Re = E(v);
      return {
        height: Re ? "100%" : `${ke}px`,
        pointerEvents: E(D).isScrolling ? "none" : void 0,
        width: Re ? `${ke}px` : "100%"
      };
    }), R = J(() => v.value ? c.width : c.height), { onWheel: F } = vZ({
      atStartEdge: J(() => D.value.scrollOffset <= 0),
      atEndEdge: J(() => D.value.scrollOffset >= C.value),
      layout: J(() => c.layout)
    }, (ke) => {
      var Re, ve;
      (ve = (Re = x.value).onMouseUp) == null || ve.call(Re), Y(Math.min(D.value.scrollOffset + ke, C.value - R.value));
    }), K = () => {
      const { total: ke } = c;
      if (ke > 0) {
        const [Qe, ot, Ve, Te] = E(S);
        f(w7, Qe, ot, Ve, Te);
      }
      const { scrollDir: Re, scrollOffset: ve, updateRequested: Ye } = E(D);
      f(P7, Re, ve, Ye);
    }, q = (ke) => {
      const { clientHeight: Re, scrollHeight: ve, scrollTop: Ye } = ke.currentTarget, Qe = E(D);
      if (Qe.scrollOffset === Ye)
        return;
      const ot = Math.max(0, Math.min(Ye, ve - Re));
      D.value = {
        ...Qe,
        isScrolling: !0,
        scrollDir: xp(Qe.scrollOffset, ot),
        scrollOffset: ot,
        updateRequested: !1
      }, bt(he);
    }, G = (ke) => {
      const { clientWidth: Re, scrollLeft: ve, scrollWidth: Ye } = ke.currentTarget, Qe = E(D);
      if (Qe.scrollOffset === ve)
        return;
      const { direction: ot } = c;
      let Ve = ve;
      if (ot === r0)
        switch (x7()) {
          case dT: {
            Ve = -ve;
            break;
          }
          case fT: {
            Ve = Ye - Re - ve;
            break;
          }
        }
      Ve = Math.max(0, Math.min(Ve, Ye - Re)), D.value = {
        ...Qe,
        isScrolling: !0,
        scrollDir: xp(Qe.scrollOffset, Ve),
        scrollOffset: Ve,
        updateRequested: !1
      }, bt(he);
    }, te = (ke) => {
      E(v) ? G(ke) : q(ke), K();
    }, Q = (ke, Re) => {
      const ve = (C.value - R.value) / Re * ke;
      Y(Math.min(C.value - R.value, ve));
    }, Y = (ke) => {
      ke = Math.max(ke, 0), ke !== E(D).scrollOffset && (D.value = {
        ...E(D),
        scrollOffset: ke,
        scrollDir: xp(E(D).scrollOffset, ke),
        updateRequested: !0
      }, bt(he));
    }, Z = (ke, Re = _d) => {
      const { scrollOffset: ve } = E(D);
      ke = Math.max(0, Math.min(ke, c.total - 1)), Y(t(c, ke, Re, ve, E(p)));
    }, oe = (ke) => {
      const { direction: Re, itemSize: ve, layout: Ye } = c, Qe = y.value(l && ve, l && Ye, l && Re);
      let ot;
      if (Lr(Qe, String(ke)))
        ot = Qe[ke];
      else {
        const Ve = r(c, ke, E(p)), Te = n(c, ke, E(p)), Me = E(v), Je = Re === r0, mt = Me ? Ve : 0;
        Qe[ke] = ot = {
          position: "absolute",
          left: Je ? void 0 : `${mt}px`,
          right: Je ? `${mt}px` : void 0,
          top: Me ? 0 : `${Ve}px`,
          height: Me ? "100%" : `${Te}px`,
          width: Me ? `${Te}px` : "100%"
        };
      }
      return ot;
    }, he = () => {
      D.value.isScrolling = !1, bt(() => {
        y.value(-1, null, null);
      });
    }, Ae = () => {
      const ke = m.value;
      ke && (ke.scrollTop = 0);
    };
    rn(() => {
      if (!Sn)
        return;
      const { initScrollOffset: ke } = c, Re = E(m);
      jn(ke) && Re && (E(v) ? Re.scrollLeft = ke : Re.scrollTop = ke), K();
    }), Zo(() => {
      const { direction: ke, layout: Re } = c, { scrollOffset: ve, updateRequested: Ye } = E(D), Qe = E(m);
      if (Ye && Qe)
        if (Re === Gu)
          if (ke === r0)
            switch (x7()) {
              case "negative": {
                Qe.scrollLeft = -ve;
                break;
              }
              case "positive-ascending": {
                Qe.scrollLeft = ve;
                break;
              }
              default: {
                const { clientWidth: ot, scrollWidth: Ve } = Qe;
                Qe.scrollLeft = Ve - ot - ve;
                break;
              }
            }
          else
            Qe.scrollLeft = ve;
        else
          Qe.scrollTop = ve;
    });
    const We = {
      clientSize: R,
      estimatedTotalSize: C,
      windowStyle: H,
      windowRef: m,
      innerRef: b,
      innerStyle: V,
      itemsToRender: S,
      scrollbarRef: x,
      states: D,
      getItemStyle: oe,
      onScroll: te,
      onScrollbarScroll: Q,
      onWheel: F,
      scrollTo: Y,
      scrollToItem: Z,
      resetScrollTop: Ae
    };
    return d({
      windowRef: m,
      innerRef: b,
      getItemStyleCache: y,
      scrollTo: Y,
      scrollToItem: Z,
      resetScrollTop: Ae,
      states: D
    }), We;
  },
  render(c) {
    var f;
    const {
      $slots: d,
      className: h,
      clientSize: p,
      containerElement: y,
      data: m,
      getItemStyle: b,
      innerElement: x,
      itemsToRender: D,
      innerStyle: S,
      layout: C,
      total: v,
      onScroll: H,
      onScrollbarScroll: V,
      onWheel: R,
      states: F,
      useIsScrolling: K,
      windowStyle: q
    } = c, [G, te] = D, Q = Ln(y), Y = Ln(x), Z = [];
    if (v > 0)
      for (let We = G; We <= te; We++)
        Z.push((f = d.default) == null ? void 0 : f.call(d, {
          data: m,
          key: We,
          index: We,
          isScrolling: K ? F.isScrolling : void 0,
          style: b(We)
        }));
    const oe = [
      et(Y, {
        style: S,
        ref: "innerRef"
      }, Ai(Y) ? Z : {
        default: () => Z
      })
    ], he = et(bZ, {
      ref: "scrollbarRef",
      clientSize: p,
      layout: C,
      onScroll: V,
      ratio: p * 100 / this.estimatedTotalSize,
      scrollFrom: F.scrollOffset / (this.estimatedTotalSize - p),
      total: v
    }), Ae = et(Q, {
      class: h,
      style: q,
      onScroll: H,
      onWheel: R,
      ref: "windowRef",
      key: 0
    }, Ai(Q) ? [oe] : { default: () => [oe] });
    return et("div", {
      key: 0,
      class: [
        "el-vl__wrapper",
        F.scrollbarAlwaysOn ? "always-on" : ""
      ]
    }, [Ae, he]);
  }
}), AZ = vT({
  name: "ElFixedSizeList",
  getItemOffset: ({ itemSize: e }, t) => t * e,
  getItemSize: ({ itemSize: e }) => e,
  getEstimatedTotalSize: ({ total: e, itemSize: t }) => t * e,
  getOffset: ({ height: e, total: t, itemSize: n, layout: r, width: i }, a, o, s) => {
    const l = Wd(r) ? i : e;
    process.env.NODE_ENV !== "production" && Ai(l) && ir("[ElVirtualList]", `
        You should set
          width/height
        to number when your layout is
          horizontal/vertical
      `);
    const u = Math.max(0, t * n - l), c = Math.min(u, a * n), f = Math.max(0, (a + 1) * n - l);
    switch (o === lT && (s >= f - l && s <= c + l ? o = _d : o = X0), o) {
      case uT:
        return c;
      case cT:
        return f;
      case X0: {
        const d = Math.round(f + (c - f) / 2);
        return d < Math.ceil(l / 2) ? 0 : d > u + Math.floor(l / 2) ? u : d;
      }
      case _d:
      default:
        return s >= f && s <= c ? s : s < f ? f : c;
    }
  },
  getStartIndexForOffset: ({ total: e, itemSize: t }, n) => Math.max(0, Math.min(e - 1, Math.floor(n / t))),
  getStopIndexForStartIndex: ({ height: e, total: t, itemSize: n, layout: r, width: i }, a, o) => {
    const s = a * n, l = Wd(r) ? i : e, u = Math.ceil((l + o - s) / n);
    return Math.max(0, Math.min(t - 1, a + u - 1));
  },
  initCache() {
  },
  clearCache: !0,
  validateProps() {
  }
}), TZ = "ElDynamicSizeList", Pu = (e, t, n) => {
  const { itemSize: r } = e, { items: i, lastVisitedIndex: a } = n;
  if (t > a) {
    let o = 0;
    if (a >= 0) {
      const s = i[a];
      o = s.offset + s.size;
    }
    for (let s = a + 1; s <= t; s++) {
      const l = r(s);
      i[s] = {
        offset: o,
        size: l
      }, o += l;
    }
    n.lastVisitedIndex = t;
  }
  return i[t];
}, wZ = (e, t, n) => {
  const { items: r, lastVisitedIndex: i } = t;
  return (i > 0 ? r[i].offset : 0) >= n ? mT(e, t, 0, i, n) : PZ(e, t, Math.max(0, i), n);
}, mT = (e, t, n, r, i) => {
  for (; n <= r; ) {
    const a = n + Math.floor((r - n) / 2), o = Pu(e, a, t).offset;
    if (o === i)
      return a;
    o < i ? n = a + 1 : o > i && (r = a - 1);
  }
  return Math.max(0, n - 1);
}, PZ = (e, t, n, r) => {
  const { total: i } = e;
  let a = 1;
  for (; n < i && Pu(e, n, t).offset < r; )
    n += a, a *= 2;
  return mT(e, t, Math.floor(n / 2), Math.min(n, i - 1), r);
}, C7 = ({ total: e }, { items: t, estimatedItemSize: n, lastVisitedIndex: r }) => {
  let i = 0;
  if (r >= e && (r = e - 1), r >= 0) {
    const s = t[r];
    i = s.offset + s.size;
  }
  const o = (e - r - 1) * n;
  return i + o;
}, xZ = vT({
  name: "ElDynamicSizeList",
  getItemOffset: (e, t, n) => Pu(e, t, n).offset,
  getItemSize: (e, t, { items: n }) => n[t].size,
  getEstimatedTotalSize: C7,
  getOffset: (e, t, n, r, i) => {
    const { height: a, layout: o, width: s } = e, l = Wd(o) ? s : a, u = Pu(e, t, i), c = C7(e, i), f = Math.max(0, Math.min(c - l, u.offset)), d = Math.max(0, u.offset - l + u.size);
    switch (n === lT && (r >= d - l && r <= f + l ? n = _d : n = X0), n) {
      case uT:
        return f;
      case cT:
        return d;
      case X0:
        return Math.round(d + (f - d) / 2);
      case _d:
      default:
        return r >= d && r <= f ? r : r < d ? d : f;
    }
  },
  getStartIndexForOffset: (e, t, n) => wZ(e, n, t),
  getStopIndexForStartIndex: (e, t, n, r) => {
    const { height: i, total: a, layout: o, width: s } = e, l = Wd(o) ? s : i, u = Pu(e, t, r), c = n + l;
    let f = u.offset + u.size, d = t;
    for (; d < a - 1 && f < c; )
      d++, f += Pu(e, d, r).size;
    return d;
  },
  initCache({ estimatedItemSize: e = sZ }, t) {
    const n = {
      items: {},
      estimatedItemSize: e,
      lastVisitedIndex: -1
    };
    return n.clearCacheAfterIndex = (r, i = !0) => {
      var a, o;
      n.lastVisitedIndex = Math.min(n.lastVisitedIndex, r - 1), (a = t.exposed) == null || a.getItemStyleCache(-1), i && ((o = t.proxy) == null || o.$forceUpdate());
    }, n;
  },
  clearCache: !1,
  validateProps: ({ itemSize: e }) => {
    process.env.NODE_ENV !== "production" && typeof e != "function" && ir(TZ, `
          itemSize is required as function, but the given value was ${typeof e}
        `);
  }
}), CZ = Ee({
  props: {
    item: {
      type: Object,
      required: !0
    },
    style: Object,
    height: Number
  },
  setup() {
    return {
      ns: Ct("select")
    };
  }
});
function SZ(e, t, n, r, i, a) {
  return e.item.isTitle ? (P(), L("div", {
    key: 0,
    class: se(e.ns.be("group", "title")),
    style: Pt([e.style, { lineHeight: `${e.height}px` }])
  }, de(e.item.label), 7)) : (P(), L("div", {
    key: 1,
    class: se(e.ns.be("group", "split")),
    style: Pt(e.style)
  }, [
    T("span", {
      class: se(e.ns.be("group", "split-dash")),
      style: Pt({ top: `${e.height / 2}px` })
    }, null, 6)
  ], 6));
}
var EZ = /* @__PURE__ */ vt(CZ, [["render", SZ]]);
function kZ(e, { emit: t }) {
  return {
    hoverItem: () => {
      e.disabled || t("hover", e.index);
    },
    selectOptionClick: () => {
      e.disabled || t("select", e.item, e.index);
    }
  };
}
const OZ = {
  allowCreate: Boolean,
  autocomplete: {
    type: String,
    default: "none"
  },
  automaticDropdown: Boolean,
  clearable: Boolean,
  clearIcon: {
    type: [String, Object],
    default: Hs
  },
  effect: {
    type: String,
    default: "light"
  },
  collapseTags: Boolean,
  defaultFirstOption: Boolean,
  disabled: Boolean,
  estimatedOptionHeight: {
    type: Number,
    default: void 0
  },
  filterable: Boolean,
  filterMethod: Function,
  height: {
    type: Number,
    default: 170
  },
  itemHeight: {
    type: Number,
    default: 34
  },
  id: String,
  loading: Boolean,
  loadingText: String,
  label: String,
  modelValue: [Array, String, Number, Boolean, Object],
  multiple: Boolean,
  multipleLimit: {
    type: Number,
    default: 0
  },
  name: String,
  noDataText: String,
  noMatchText: String,
  remoteMethod: Function,
  reserveKeyword: {
    type: Boolean,
    default: !0
  },
  options: {
    type: Array,
    required: !0
  },
  placeholder: {
    type: String
  },
  popperAppendToBody: {
    type: Boolean,
    default: void 0
  },
  teleported: zr.teleported,
  popperClass: {
    type: String,
    default: ""
  },
  popperOptions: {
    type: Object,
    default: () => ({})
  },
  remote: Boolean,
  size: {
    type: String,
    validator: fo
  },
  valueKey: {
    type: String,
    default: "value"
  },
  scrollbarAlwaysOn: {
    type: Boolean,
    default: !1
  }
}, zZ = {
  data: Array,
  disabled: Boolean,
  hovering: Boolean,
  item: Object,
  index: Number,
  style: Object,
  selected: Boolean,
  created: Boolean
}, DZ = Ee({
  props: zZ,
  emits: ["select", "hover"],
  setup(e, { emit: t }) {
    const n = Ct("select"), { hoverItem: r, selectOptionClick: i } = kZ(e, { emit: t });
    return {
      ns: n,
      hoverItem: r,
      selectOptionClick: i
    };
  }
}), MZ = ["aria-selected"];
function HZ(e, t, n, r, i, a) {
  return P(), L("li", {
    "aria-selected": e.selected,
    style: Pt(e.style),
    class: se([
      e.ns.be("dropdown", "option-item"),
      e.ns.is("selected", e.selected),
      e.ns.is("disabled", e.disabled),
      e.ns.is("created", e.created),
      { hover: e.hovering }
    ]),
    onMouseenter: t[0] || (t[0] = (...o) => e.hoverItem && e.hoverItem(...o)),
    onClick: t[1] || (t[1] = wt((...o) => e.selectOptionClick && e.selectOptionClick(...o), ["stop"]))
  }, [
    tt(e.$slots, "default", {
      item: e.item,
      index: e.index,
      disabled: e.disabled
    }, () => [
      T("span", null, de(e.item.label), 1)
    ])
  ], 46, MZ);
}
var IZ = /* @__PURE__ */ vt(DZ, [["render", HZ]]);
const gT = "ElSelectV2Injection", LZ = Ee({
  name: "ElSelectDropdown",
  props: {
    data: Array,
    hoveringIndex: Number,
    width: Number
  },
  setup(e) {
    const t = ce(gT), n = Ct("select"), r = j([]), i = j(null), a = J(() => jd(t.props.estimatedOptionHeight)), o = J(() => a.value ? {
      itemSize: t.props.itemHeight
    } : {
      estimatedSize: t.props.estimatedOptionHeight,
      itemSize: (p) => r.value[p]
    }), s = (p = [], y) => {
      const {
        props: { valueKey: m }
      } = t;
      return tr(y) ? p && p.some((b) => vi(b, m) === vi(y, m)) : p.includes(y);
    }, l = (p, y) => {
      if (tr(y)) {
        const { valueKey: m } = t.props;
        return vi(p, m) === vi(y, m);
      } else
        return p === y;
    };
    return {
      ns: n,
      select: t,
      listProps: o,
      listRef: i,
      isSized: a,
      isItemDisabled: (p, y) => {
        const { disabled: m, multiple: b, multipleLimit: x } = t.props;
        return m || !y && (b ? x > 0 && p.length >= x : !1);
      },
      isItemHovering: (p) => e.hoveringIndex === p,
      isItemSelected: (p, y) => t.props.multiple ? s(p, y.value) : l(p, y.value),
      scrollToItem: (p) => {
        const y = i.value;
        y && y.scrollToItem(p);
      },
      resetScrollTop: () => {
        const p = i.value;
        p && p.resetScrollTop();
      }
    };
  },
  render(e, t) {
    var n;
    const {
      $slots: r,
      data: i,
      listProps: a,
      select: o,
      isSized: s,
      width: l,
      ns: u,
      isItemDisabled: c,
      isItemHovering: f,
      isItemSelected: d
    } = e, h = s ? AZ : xZ, {
      props: p,
      onSelect: y,
      onHover: m,
      onKeyboardNavigate: b,
      onKeyboardSelect: x
    } = o, { height: D, modelValue: S, multiple: C } = p;
    if (i.length === 0)
      return et("div", {
        class: u.b("dropdown"),
        style: {
          width: `${l}px`
        }
      }, (n = r.empty) == null ? void 0 : n.call(r));
    const v = N((V) => {
      const { index: R, data: F } = V, K = F[R];
      if (F[R].type === "Group")
        return et(EZ, {
          item: K,
          style: V.style,
          height: s ? a.itemSize : a.estimatedSize
        });
      const q = d(S, K), G = c(S, q);
      return et(IZ, {
        ...V,
        selected: q,
        disabled: K.disabled || G,
        created: !!K.created,
        hovering: f(R),
        item: K,
        onSelect: y,
        onHover: m
      }, {
        default: N((te) => tt(r, "default", te, () => [
          et("span", K.label)
        ]))
      });
    }), H = et(h, {
      ref: "listRef",
      className: u.be("dropdown", "list"),
      data: i,
      height: D,
      width: l,
      total: i.length,
      scrollbarAlwaysOn: p.scrollbarAlwaysOn,
      onKeydown: [
        t[1] || (t[1] = nn(wt(() => b("forward"), ["stop", "prevent"]), ["down"])),
        t[2] || (t[2] = nn(wt(() => b("backward"), ["stop", "prevent"]), ["up"])),
        t[3] || (t[3] = nn(wt(x, ["stop", "prevent"]), ["enter"])),
        t[4] || (t[4] = nn(wt(() => o.expanded = !1, ["stop", "prevent"]), ["esc"])),
        t[5] || (t[5] = nn(() => o.expanded = !1, ["tab"]))
      ],
      ...a
    }, {
      default: v
    });
    return et("div", {
      class: [u.b("dropdown"), u.is("multiple", C)]
    }, [H]);
  }
});
function BZ(e, t) {
  const n = j(0), r = j(null), i = J(() => e.allowCreate && e.filterable);
  function a(c) {
    const f = (d) => d.value === c;
    return e.options && e.options.some(f) || t.createdOptions.some(f);
  }
  function o(c) {
    !i.value || (e.multiple && c.created ? n.value++ : r.value = c);
  }
  function s(c) {
    if (i.value)
      if (c && c.length > 0 && !a(c)) {
        const f = {
          value: c,
          label: c,
          created: !0,
          disabled: !1
        };
        t.createdOptions.length >= n.value ? t.createdOptions[n.value] = f : t.createdOptions.push(f);
      } else if (e.multiple)
        t.createdOptions.length = n.value;
      else {
        const f = r.value;
        t.createdOptions.length = 0, f && f.created && t.createdOptions.push(f);
      }
  }
  function l(c) {
    if (!i.value || !c || !c.created || c.created && e.reserveKeyword && t.inputValue === c.label)
      return;
    const f = t.createdOptions.findIndex((d) => d.value === c.value);
    ~f && (t.createdOptions.splice(f, 1), n.value--);
  }
  function u() {
    i.value && (t.createdOptions.length = 0, n.value = 0);
  }
  return {
    createNewOption: s,
    removeNewOption: l,
    selectNewOption: o,
    clearAllNewOption: u
  };
}
const NZ = (e) => {
  const t = [];
  return e.map((n) => {
    zu(n.options) ? (t.push({
      label: n.label,
      isTitle: !0,
      type: "Group"
    }), n.options.forEach((r) => {
      t.push(r);
    }), t.push({
      type: "Group"
    })) : t.push(n);
  }), t;
};
function jZ(e) {
  const t = j(!1);
  return {
    handleCompositionStart: () => {
      t.value = !0;
    },
    handleCompositionUpdate: (a) => {
      const o = a.target.value, s = o[o.length - 1] || "";
      t.value = !Nh(s);
    },
    handleCompositionEnd: (a) => {
      t.value && (t.value = !1, fa(e) && e(a));
    }
  };
}
const S7 = "", E7 = 11, FZ = {
  larget: 51,
  default: 42,
  small: 33
}, XZ = "ElSelectV2", RZ = (e, t) => {
  const { t: n } = hi(), r = Ct("select-v2"), i = Ct("input"), { form: a, formItem: o } = gc(), { compatTeleported: s } = Uh(XZ, "popperAppendToBody"), l = zt({
    inputValue: S7,
    displayInputValue: S7,
    calculatedWidth: 0,
    cachedPlaceholder: "",
    cachedOptions: [],
    createdOptions: [],
    createdLabel: "",
    createdSelected: !1,
    currentPlaceholder: "",
    hoveringIndex: -1,
    comboBoxHovering: !1,
    isOnComposition: !1,
    isSilentBlur: !1,
    isComposing: !1,
    inputLength: 20,
    selectWidth: 200,
    initialInputHeight: 0,
    previousQuery: null,
    previousValue: "",
    query: "",
    selectedLabel: "",
    softFocus: !1,
    tagInMultiLine: !1
  }), u = j(-1), c = j(-1), f = j(null), d = j(null), h = j(null), p = j(null), y = j(null), m = j(null), b = j(null), x = j(!1), D = J(() => e.disabled || (a == null ? void 0 : a.disabled)), S = J(() => {
    const Fe = G.value.length * 34;
    return Fe > e.height ? e.height : Fe;
  }), C = J(() => e.modelValue !== void 0 && e.modelValue !== null && e.modelValue !== ""), v = J(() => {
    const Fe = e.multiple ? Array.isArray(e.modelValue) && e.modelValue.length > 0 : C.value;
    return e.clearable && !D.value && l.comboBoxHovering && Fe;
  }), H = J(() => e.remote && e.filterable ? "" : uf), V = J(() => H.value && r.is("reverse", x.value)), R = J(() => (o == null ? void 0 : o.validateState) || ""), F = J(() => db[R.value]), K = J(() => e.remote ? 300 : 0), q = J(() => {
    const Fe = G.value;
    return e.loading ? e.loadingText || n("el.select.loading") : e.remote && l.inputValue === "" && Fe.length === 0 ? !1 : e.filterable && l.inputValue && Fe.length > 0 ? e.noMatchText || n("el.select.noMatch") : Fe.length === 0 ? e.noDataText || n("el.select.noData") : null;
  }), G = J(() => {
    const Fe = (xt) => {
      const an = l.inputValue;
      return an ? xt.label.includes(an) : !0;
    };
    return e.loading ? [] : NZ(e.options.concat(l.createdOptions).map((xt) => {
      if (zu(xt.options)) {
        const an = xt.options.filter(Fe);
        if (an.length > 0)
          return {
            ...xt,
            options: an
          };
      } else if (e.remote || Fe(xt))
        return xt;
      return null;
    }).filter((xt) => xt !== null));
  }), te = J(() => G.value.every((Fe) => Fe.disabled)), Q = Bi(), Y = J(() => Q.value === "small" ? "small" : "default"), Z = J(() => {
    const Fe = m.value, xt = Y.value || "default", an = Fe ? parseInt(getComputedStyle(Fe).paddingLeft) : 0, Fn = Fe ? parseInt(getComputedStyle(Fe).paddingRight) : 0;
    return l.selectWidth - Fn - an - FZ[xt];
  }), oe = () => {
    var Fe, xt, an;
    c.value = ((an = (xt = (Fe = y.value) == null ? void 0 : Fe.getBoundingClientRect) == null ? void 0 : xt.call(Fe)) == null ? void 0 : an.width) || 200;
  }, he = J(() => ({
    width: `${l.calculatedWidth === 0 ? E7 : Math.ceil(l.calculatedWidth) + E7}px`
  })), Ae = J(() => zu(e.modelValue) ? e.modelValue.length === 0 && !l.displayInputValue : e.filterable ? l.displayInputValue.length === 0 : !0), We = J(() => {
    const Fe = e.placeholder || n("el.select.placeholder");
    return e.multiple ? Fe : l.selectedLabel || Fe;
  }), ke = J(() => {
    var Fe, xt;
    return (xt = (Fe = p.value) == null ? void 0 : Fe.popperRef) == null ? void 0 : xt.contentRef;
  }), Re = J(() => {
    if (e.multiple) {
      const Fe = e.modelValue.length;
      if (e.modelValue.length > 0)
        return G.value.findIndex((xt) => xt.value === e.modelValue[Fe - 1]);
    } else if (e.modelValue)
      return G.value.findIndex((Fe) => Fe.value === e.modelValue);
    return -1;
  }), ve = J(() => x.value && q.value !== !1), {
    createNewOption: Ye,
    removeNewOption: Qe,
    selectNewOption: ot,
    clearAllNewOption: Ve
  } = BZ(e, l), {
    handleCompositionStart: Te,
    handleCompositionUpdate: Me,
    handleCompositionEnd: Je
  } = jZ((Fe) => sr(Fe)), mt = () => {
    var Fe, xt, an;
    (xt = (Fe = d.value).focus) == null || xt.call(Fe), (an = p.value) == null || an.updatePopper();
  }, It = () => {
    if (!e.automaticDropdown && !D.value)
      return l.isComposing && (l.softFocus = !0), bt(() => {
        var Fe, xt;
        x.value = !x.value, (xt = (Fe = d.value) == null ? void 0 : Fe.focus) == null || xt.call(Fe);
      });
  }, ln = () => (e.filterable && l.inputValue !== l.selectedLabel && (l.query = l.selectedLabel), Pe(l.inputValue), bt(() => {
    Ye(l.inputValue);
  })), gt = qa(ln, K.value), Pe = (Fe) => {
    l.previousQuery !== Fe && (l.previousQuery = Fe, e.filterable && fa(e.filterMethod) ? e.filterMethod(Fe) : e.filterable && e.remote && fa(e.remoteMethod) && e.remoteMethod(Fe));
  }, $e = (Fe) => {
    ja(e.modelValue, Fe) || t(Tr, Fe);
  }, Ke = (Fe) => {
    t(vn, Fe), $e(Fe), l.previousValue = Fe.toString();
  }, lt = (Fe = [], xt) => {
    if (!tr(xt))
      return Fe.indexOf(xt);
    const an = e.valueKey;
    let Fn = -1;
    return Fe.some((Pr, xr) => vi(Pr, an) === vi(xt, an) ? (Fn = xr, !0) : !1), Fn;
  }, He = (Fe) => tr(Fe) ? vi(Fe, e.valueKey) : Fe, Le = (Fe) => tr(Fe) ? Fe.label : Fe, ct = () => {
    if (!(e.collapseTags && !e.filterable))
      return bt(() => {
        var Fe, xt;
        if (!d.value)
          return;
        const an = m.value;
        y.value.height = an.offsetHeight, x.value && q.value !== !1 && ((xt = (Fe = p.value) == null ? void 0 : Fe.updatePopper) == null || xt.call(Fe));
      });
  }, Qt = () => {
    var Fe, xt;
    if (Zt(), oe(), (xt = (Fe = p.value) == null ? void 0 : Fe.updatePopper) == null || xt.call(Fe), e.multiple)
      return ct();
  }, Zt = () => {
    const Fe = m.value;
    Fe && (l.selectWidth = Fe.getBoundingClientRect().width);
  }, Pn = (Fe, xt, an = !0) => {
    var Fn, Pr;
    if (e.multiple) {
      let xr = e.modelValue.slice();
      const na = lt(xr, He(Fe));
      na > -1 ? (xr = [
        ...xr.slice(0, na),
        ...xr.slice(na + 1)
      ], l.cachedOptions.splice(na, 1), Qe(Fe)) : (e.multipleLimit <= 0 || xr.length < e.multipleLimit) && (xr = [...xr, He(Fe)], l.cachedOptions.push(Fe), ot(Fe), cn(xt)), Ke(xr), Fe.created && (l.query = "", Pe(""), l.inputLength = 20), e.filterable && !e.reserveKeyword && ((Pr = (Fn = d.value).focus) == null || Pr.call(Fn), st("")), e.filterable && (l.calculatedWidth = b.value.getBoundingClientRect().width), ct(), Tn();
    } else
      u.value = xt, l.selectedLabel = Fe.label, Ke(He(Fe)), x.value = !1, l.isComposing = !1, l.isSilentBlur = an, ot(Fe), Fe.created || Ve(), cn(xt);
  }, Mn = (Fe, xt) => {
    const an = e.modelValue.indexOf(xt.value);
    if (an > -1 && !D.value) {
      const Fn = [
        ...e.modelValue.slice(0, an),
        ...e.modelValue.slice(an + 1)
      ];
      return l.cachedOptions.splice(an, 1), Ke(Fn), t("remove-tag", xt.value), l.softFocus = !0, Qe(xt), bt(mt);
    }
    Fe.stopPropagation();
  }, Mt = (Fe) => {
    const xt = l.isComposing;
    l.isComposing = !0, l.softFocus ? l.softFocus = !1 : xt || t("focus", Fe);
  }, Nt = () => (l.softFocus = !1, bt(() => {
    var Fe, xt;
    (xt = (Fe = d.value) == null ? void 0 : Fe.blur) == null || xt.call(Fe), b.value && (l.calculatedWidth = b.value.getBoundingClientRect().width), l.isSilentBlur ? l.isSilentBlur = !1 : l.isComposing && t("blur"), l.isComposing = !1;
  })), De = () => {
    l.displayInputValue.length > 0 ? st("") : x.value = !1;
  }, Ue = (Fe) => {
    if (l.displayInputValue.length === 0) {
      Fe.preventDefault();
      const xt = e.modelValue.slice();
      xt.pop(), Qe(l.cachedOptions.pop()), Ke(xt);
    }
  }, Se = () => {
    let Fe;
    return zu(e.modelValue) ? Fe = [] : Fe = "", l.softFocus = !0, e.multiple ? l.cachedOptions = [] : l.selectedLabel = "", x.value = !1, Ke(Fe), t("clear"), Ve(), bt(mt);
  }, st = (Fe) => {
    l.displayInputValue = Fe, l.inputValue = Fe;
  }, kt = (Fe, xt = void 0) => {
    const an = G.value;
    if (!["forward", "backward"].includes(Fe) || D.value || an.length <= 0 || te.value)
      return;
    if (!x.value)
      return It();
    xt === void 0 && (xt = l.hoveringIndex);
    let Fn = -1;
    Fe === "forward" ? (Fn = xt + 1, Fn >= an.length && (Fn = 0)) : Fe === "backward" && (Fn = xt - 1, Fn < 0 && (Fn = an.length - 1));
    const Pr = an[Fn];
    if (Pr.disabled || Pr.type === "Group")
      return kt(Fe, Fn);
    cn(Fn), Qa(Fn);
  }, mn = () => {
    if (x.value)
      ~l.hoveringIndex && G.value[l.hoveringIndex] && Pn(G.value[l.hoveringIndex], l.hoveringIndex, !1);
    else
      return It();
  }, cn = (Fe) => {
    l.hoveringIndex = Fe;
  }, kn = () => {
    l.hoveringIndex = -1;
  }, Tn = () => {
    var Fe;
    const xt = d.value;
    xt && ((Fe = xt.focus) == null || Fe.call(xt));
  }, sr = (Fe) => {
    const xt = Fe.target.value;
    if (st(xt), l.displayInputValue.length > 0 && !x.value && (x.value = !0), l.calculatedWidth = b.value.getBoundingClientRect().width, e.multiple && ct(), e.remote)
      gt();
    else
      return ln();
  }, wi = () => (x.value = !1, Nt()), Hi = () => (l.inputValue = l.displayInputValue, bt(() => {
    ~Re.value && (cn(Re.value), Qa(l.hoveringIndex));
  })), Qa = (Fe) => {
    h.value.scrollToItem(Fe);
  }, ii = () => {
    if (kn(), e.multiple)
      if (e.modelValue.length > 0) {
        let Fe = !1;
        l.cachedOptions.length = 0, l.previousValue = e.modelValue.toString(), e.modelValue.map((xt) => {
          const an = G.value.findIndex((Fn) => He(Fn) === xt);
          ~an && (l.cachedOptions.push(G.value[an]), Fe || cn(an), Fe = !0);
        });
      } else
        l.cachedOptions = [], l.previousValue = "";
    else if (C.value) {
      l.previousValue = e.modelValue;
      const Fe = G.value, xt = Fe.findIndex((an) => He(an) === e.modelValue);
      ~xt ? (l.selectedLabel = Fe[xt].label, cn(xt)) : l.selectedLabel = `${e.modelValue}`;
    } else
      l.selectedLabel = "", l.previousValue = "";
    oe();
  };
  return Ne(x, (Fe) => {
    var xt, an;
    t("visible-change", Fe), Fe ? (an = (xt = p.value).update) == null || an.call(xt) : (l.displayInputValue = "", Ye(""));
  }), Ne(() => e.modelValue, (Fe, xt) => {
    var an;
    (!Fe || Fe.toString() !== l.previousValue) && ii(), ja(Fe, xt) || (an = o == null ? void 0 : o.validate) == null || an.call(o, "change");
  }, {
    deep: !0
  }), Ne(() => e.options, () => {
    const Fe = d.value;
    (!Fe || Fe && document.activeElement !== Fe) && ii();
  }, {
    deep: !0
  }), Ne(G, () => bt(h.value.resetScrollTop)), rn(() => {
    ii(), Xl(y.value, Qt);
  }), Ph(() => {
    Rl(y.value, Qt);
  }), {
    collapseTagSize: Y,
    currentPlaceholder: We,
    expanded: x,
    emptyText: q,
    popupHeight: S,
    debounce: K,
    filteredOptions: G,
    iconComponent: H,
    iconReverse: V,
    inputWrapperStyle: he,
    popperSize: c,
    dropdownMenuVisible: ve,
    hasModelValue: C,
    shouldShowPlaceholder: Ae,
    selectDisabled: D,
    selectSize: Q,
    showClearBtn: v,
    states: l,
    tagMaxWidth: Z,
    nsSelectV2: r,
    nsInput: i,
    calculatorRef: b,
    controlRef: f,
    inputRef: d,
    menuRef: h,
    popper: p,
    selectRef: y,
    selectionRef: m,
    popperRef: ke,
    validateState: R,
    validateIcon: F,
    compatTeleported: s,
    debouncedOnInputChange: gt,
    deleteTag: Mn,
    getLabel: Le,
    getValueKey: He,
    handleBlur: Nt,
    handleClear: Se,
    handleClickOutside: wi,
    handleDel: Ue,
    handleEsc: De,
    handleFocus: Mt,
    handleMenuEnter: Hi,
    handleResize: Qt,
    toggleMenu: It,
    scrollTo: Qa,
    onInput: sr,
    onKeyboardNavigate: kt,
    onKeyboardSelect: mn,
    onSelect: Pn,
    onHover: cn,
    onUpdateInputValue: st,
    handleCompositionStart: Te,
    handleCompositionEnd: Je,
    handleCompositionUpdate: Me
  };
}, VZ = Ee({
  name: "ElSelectV2",
  components: {
    ElSelectMenu: LZ,
    ElTag: hf,
    ElTooltip: Ki,
    ElIcon: qt
  },
  directives: { ClickOutside: yc, ModelText: G4 },
  props: OZ,
  emits: [
    vn,
    Tr,
    "remove-tag",
    "clear",
    "visible-change",
    "focus",
    "blur"
  ],
  setup(e, { emit: t }) {
    const n = RZ(e, t);
    return _t(gT, {
      props: zt({
        ...ma(e),
        height: n.popupHeight
      }),
      onSelect: n.onSelect,
      onHover: n.onHover,
      onKeyboardNavigate: n.onKeyboardNavigate,
      onKeyboardSelect: n.onKeyboardSelect
    }), n;
  }
}), UZ = { key: 0 }, qZ = ["id", "autocomplete", "aria-expanded", "aria-labelledby", "disabled", "readonly", "name", "unselectable"], _Z = ["textContent"], WZ = ["id", "aria-labelledby", "aria-expanded", "autocomplete", "disabled", "name", "readonly", "unselectable"], KZ = ["textContent"];
function GZ(e, t, n, r, i, a) {
  const o = Ie("el-tag"), s = Ie("el-icon"), l = Ie("el-select-menu"), u = Ie("el-tooltip"), c = va("model-text"), f = va("click-outside");
  return Bt((P(), L("div", {
    ref: "selectRef",
    class: se([e.nsSelectV2.b(), e.nsSelectV2.m(e.selectSize)]),
    onClick: t[24] || (t[24] = wt((...d) => e.toggleMenu && e.toggleMenu(...d), ["stop"])),
    onMouseenter: t[25] || (t[25] = (d) => e.states.comboBoxHovering = !0),
    onMouseleave: t[26] || (t[26] = (d) => e.states.comboBoxHovering = !1)
  }, [
    B(u, {
      ref: "popper",
      visible: e.dropdownMenuVisible,
      "onUpdate:visible": t[22] || (t[22] = (d) => e.dropdownMenuVisible = d),
      teleported: e.compatTeleported,
      "popper-class": [e.nsSelectV2.e("popper"), e.popperClass],
      "gpu-acceleration": !1,
      "stop-popper-mouse-event": !1,
      "popper-options": e.popperOptions,
      "fallback-placements": ["bottom-start", "top-start", "right", "left"],
      effect: e.effect,
      placement: "bottom-start",
      pure: "",
      transition: `${e.nsSelectV2.namespace.value}-zoom-in-top`,
      trigger: "click",
      persistent: "",
      onShow: e.handleMenuEnter,
      onHide: t[23] || (t[23] = (d) => e.states.inputValue = e.states.displayInputValue)
    }, {
      default: N(() => {
        var d;
        return [
          T("div", {
            ref: "selectionRef",
            class: se([
              e.nsSelectV2.e("wrapper"),
              e.nsSelectV2.is("focused", e.states.isComposing),
              e.nsSelectV2.is("hovering", e.states.comboBoxHovering),
              e.nsSelectV2.is("filterable", e.filterable),
              e.nsSelectV2.is("disabled", e.disabled)
            ])
          }, [
            e.$slots.prefix ? (P(), L("div", UZ, [
              tt(e.$slots, "prefix")
            ])) : re("v-if", !0),
            e.multiple ? (P(), L("div", {
              key: 1,
              class: se(e.nsSelectV2.e("selection"))
            }, [
              e.collapseTags && e.modelValue.length > 0 ? (P(), L("div", {
                key: 0,
                class: se(e.nsSelectV2.e("selected-item"))
              }, [
                B(o, {
                  closable: !e.selectDisabled && !((d = e.states.cachedOptions[0]) != null && d.disable),
                  size: e.collapseTagSize,
                  type: "info",
                  "disable-transitions": "",
                  onClose: t[0] || (t[0] = (h) => e.deleteTag(h, e.states.cachedOptions[0]))
                }, {
                  default: N(() => {
                    var h;
                    return [
                      T("span", {
                        class: se(e.nsSelectV2.e("tags-text")),
                        style: Pt({
                          maxWidth: `${e.tagMaxWidth}px`
                        })
                      }, de((h = e.states.cachedOptions[0]) == null ? void 0 : h.label), 7)
                    ];
                  }),
                  _: 1
                }, 8, ["closable", "size"]),
                e.modelValue.length > 1 ? (P(), ue(o, {
                  key: 0,
                  closable: !1,
                  size: e.collapseTagSize,
                  type: "info",
                  "disable-transitions": ""
                }, {
                  default: N(() => [
                    T("span", {
                      class: se(e.nsSelectV2.e("tags-text")),
                      style: Pt({
                        maxWidth: `${e.tagMaxWidth}px`
                      })
                    }, "+ " + de(e.modelValue.length - 1), 7)
                  ]),
                  _: 1
                }, 8, ["size"])) : re("v-if", !0)
              ], 2)) : (P(!0), L(nt, { key: 1 }, Lt(e.states.cachedOptions, (h, p) => (P(), L("div", {
                key: p,
                class: se(e.nsSelectV2.e("selected-item"))
              }, [
                (P(), ue(o, {
                  key: e.getValueKey(h),
                  closable: !e.selectDisabled && !h.disabled,
                  size: e.collapseTagSize,
                  type: "info",
                  "disable-transitions": "",
                  onClose: (y) => e.deleteTag(y, h)
                }, {
                  default: N(() => [
                    T("span", {
                      class: se(e.nsSelectV2.e("tags-text")),
                      style: Pt({
                        maxWidth: `${e.tagMaxWidth}px`
                      })
                    }, de(e.getLabel(h)), 7)
                  ]),
                  _: 2
                }, 1032, ["closable", "size", "onClose"]))
              ], 2))), 128)),
              T("div", {
                class: se([
                  e.nsSelectV2.e("selected-item"),
                  e.nsSelectV2.e("input-wrapper")
                ]),
                style: Pt(e.inputWrapperStyle)
              }, [
                Bt(T("input", {
                  id: e.id,
                  ref: "inputRef",
                  autocomplete: e.autocomplete,
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  autocapitalize: "off",
                  "aria-expanded": e.expanded,
                  "aria-labelledby": e.label,
                  class: se([
                    e.nsSelectV2.is(e.selectSize),
                    e.nsSelectV2.e("combobox-input")
                  ]),
                  disabled: e.disabled,
                  role: "combobox",
                  readonly: !e.filterable,
                  spellcheck: "false",
                  type: "text",
                  name: e.name,
                  unselectable: e.expanded ? "on" : void 0,
                  "onUpdate:modelValue": t[1] || (t[1] = (...h) => e.onUpdateInputValue && e.onUpdateInputValue(...h)),
                  onFocus: t[2] || (t[2] = (...h) => e.handleFocus && e.handleFocus(...h)),
                  onInput: t[3] || (t[3] = (...h) => e.onInput && e.onInput(...h)),
                  onCompositionstart: t[4] || (t[4] = (...h) => e.handleCompositionStart && e.handleCompositionStart(...h)),
                  onCompositionupdate: t[5] || (t[5] = (...h) => e.handleCompositionUpdate && e.handleCompositionUpdate(...h)),
                  onCompositionend: t[6] || (t[6] = (...h) => e.handleCompositionEnd && e.handleCompositionEnd(...h)),
                  onKeydown: [
                    t[7] || (t[7] = nn(wt((h) => e.onKeyboardNavigate("backward"), ["stop", "prevent"]), ["up"])),
                    t[8] || (t[8] = nn(wt((h) => e.onKeyboardNavigate("forward"), ["stop", "prevent"]), ["down"])),
                    t[9] || (t[9] = nn(wt((...h) => e.onKeyboardSelect && e.onKeyboardSelect(...h), ["stop", "prevent"]), ["enter"])),
                    t[10] || (t[10] = nn(wt((...h) => e.handleEsc && e.handleEsc(...h), ["stop", "prevent"]), ["esc"])),
                    t[11] || (t[11] = nn(wt((...h) => e.handleDel && e.handleDel(...h), ["stop"]), ["delete"]))
                  ]
                }, null, 42, qZ), [
                  [c, e.states.displayInputValue]
                ]),
                e.filterable ? (P(), L("span", {
                  key: 0,
                  ref: "calculatorRef",
                  "aria-hidden": "true",
                  class: se(e.nsSelectV2.e("input-calculator")),
                  textContent: de(e.states.displayInputValue)
                }, null, 10, _Z)) : re("v-if", !0)
              ], 6)
            ], 2)) : (P(), L(nt, { key: 2 }, [
              T("div", {
                class: se([
                  e.nsSelectV2.e("selected-item"),
                  e.nsSelectV2.e("input-wrapper")
                ])
              }, [
                Bt(T("input", {
                  id: e.id,
                  ref: "inputRef",
                  "aria-autocomplete": "list",
                  "aria-haspopup": "listbox",
                  "aria-labelledby": e.label,
                  "aria-expanded": e.expanded,
                  autocapitalize: "off",
                  autocomplete: e.autocomplete,
                  class: se(e.nsSelectV2.e("combobox-input")),
                  disabled: e.disabled,
                  name: e.name,
                  role: "combobox",
                  readonly: !e.filterable,
                  spellcheck: "false",
                  type: "text",
                  unselectable: e.expanded ? "on" : void 0,
                  onCompositionstart: t[12] || (t[12] = (...h) => e.handleCompositionStart && e.handleCompositionStart(...h)),
                  onCompositionupdate: t[13] || (t[13] = (...h) => e.handleCompositionUpdate && e.handleCompositionUpdate(...h)),
                  onCompositionend: t[14] || (t[14] = (...h) => e.handleCompositionEnd && e.handleCompositionEnd(...h)),
                  onFocus: t[15] || (t[15] = (...h) => e.handleFocus && e.handleFocus(...h)),
                  onInput: t[16] || (t[16] = (...h) => e.onInput && e.onInput(...h)),
                  onKeydown: [
                    t[17] || (t[17] = nn(wt((h) => e.onKeyboardNavigate("backward"), ["stop", "prevent"]), ["up"])),
                    t[18] || (t[18] = nn(wt((h) => e.onKeyboardNavigate("forward"), ["stop", "prevent"]), ["down"])),
                    t[19] || (t[19] = nn(wt((...h) => e.onKeyboardSelect && e.onKeyboardSelect(...h), ["stop", "prevent"]), ["enter"])),
                    t[20] || (t[20] = nn(wt((...h) => e.handleEsc && e.handleEsc(...h), ["stop", "prevent"]), ["esc"]))
                  ],
                  "onUpdate:modelValue": t[21] || (t[21] = (...h) => e.onUpdateInputValue && e.onUpdateInputValue(...h))
                }, null, 42, WZ), [
                  [c, e.states.displayInputValue]
                ])
              ], 2),
              e.filterable ? (P(), L("span", {
                key: 0,
                ref: "calculatorRef",
                "aria-hidden": "true",
                class: se([
                  e.nsSelectV2.e("selected-item"),
                  e.nsSelectV2.e("input-calculator")
                ]),
                textContent: de(e.states.displayInputValue)
              }, null, 10, KZ)) : re("v-if", !0)
            ], 64)),
            e.shouldShowPlaceholder ? (P(), L("span", {
              key: 3,
              class: se([
                e.nsSelectV2.e("placeholder"),
                e.nsSelectV2.is("transparent", e.states.isComposing || (e.placeholder && e.multiple ? e.modelValue.length === 0 : !e.hasModelValue))
              ])
            }, de(e.currentPlaceholder), 3)) : re("v-if", !0),
            T("span", {
              class: se(e.nsSelectV2.e("suffix"))
            }, [
              e.iconComponent ? Bt((P(), ue(s, {
                key: 0,
                class: se([e.nsSelectV2.e("caret"), e.nsInput.e("icon"), e.iconReverse])
              }, {
                default: N(() => [
                  (P(), ue(Ln(e.iconComponent)))
                ]),
                _: 1
              }, 8, ["class"])), [
                [Cn, !e.showClearBtn]
              ]) : re("v-if", !0),
              e.showClearBtn && e.clearIcon ? (P(), ue(s, {
                key: 1,
                class: se([e.nsSelectV2.e("caret"), e.nsInput.e("icon")]),
                onClick: wt(e.handleClear, ["prevent", "stop"])
              }, {
                default: N(() => [
                  (P(), ue(Ln(e.clearIcon)))
                ]),
                _: 1
              }, 8, ["class", "onClick"])) : re("v-if", !0),
              e.validateState && e.validateIcon ? (P(), ue(s, {
                key: 2,
                class: se([e.nsInput.e("icon"), e.nsInput.e("validateIcon")])
              }, {
                default: N(() => [
                  (P(), ue(Ln(e.validateIcon)))
                ]),
                _: 1
              }, 8, ["class"])) : re("v-if", !0)
            ], 2)
          ], 2)
        ];
      }),
      content: N(() => [
        B(l, {
          ref: "menuRef",
          data: e.filteredOptions,
          width: e.popperSize,
          "hovering-index": e.states.hoveringIndex,
          "scrollbar-always-on": e.scrollbarAlwaysOn
        }, {
          default: N((d) => [
            tt(e.$slots, "default", E0(k0(d)))
          ]),
          empty: N(() => [
            tt(e.$slots, "empty", {}, () => [
              T("p", {
                class: se(e.nsSelectV2.e("empty"))
              }, de(e.emptyText ? e.emptyText : ""), 3)
            ])
          ]),
          _: 3
        }, 8, ["data", "width", "hovering-index", "scrollbar-always-on"])
      ]),
      _: 3
    }, 8, ["visible", "teleported", "popper-class", "popper-options", "effect", "transition", "onShow"])
  ], 34)), [
    [f, e.handleClickOutside, e.popperRef]
  ]);
}
var a0 = /* @__PURE__ */ vt(VZ, [["render", GZ]]);
a0.install = (e) => {
  e.component(a0.name, a0);
};
const YZ = a0, QZ = YZ, ZZ = (e, t, n) => {
  const r = j(null), i = j(!1), a = J(() => t.value instanceof Function), o = J(() => a.value && t.value(e.modelValue) || e.modelValue), s = qa(() => {
    n.value && (i.value = !0);
  }, 50), l = qa(() => {
    n.value && (i.value = !1);
  }, 50);
  return {
    tooltip: r,
    tooltipVisible: i,
    formatValue: o,
    displayTooltip: s,
    hideTooltip: l
  };
}, JZ = (e, t, n) => {
  const {
    disabled: r,
    min: i,
    max: a,
    step: o,
    showTooltip: s,
    precision: l,
    sliderSize: u,
    formatTooltip: c,
    emitChange: f,
    resetSize: d,
    updateDragging: h
  } = ce("SliderProvider"), { tooltip: p, tooltipVisible: y, formatValue: m, displayTooltip: b, hideTooltip: x } = ZZ(e, c, s), D = J(() => `${(e.modelValue - i.value) / (a.value - i.value) * 100}%`), S = J(() => e.vertical ? { bottom: D.value } : { left: D.value }), C = () => {
    t.hovering = !0, b();
  }, v = () => {
    t.hovering = !1, t.dragging || x();
  }, H = (Q) => {
    r.value || (Q.preventDefault(), K(Q), _n(window, "mousemove", q), _n(window, "touchmove", q), _n(window, "mouseup", G), _n(window, "touchend", G), _n(window, "contextmenu", G));
  }, V = () => {
    r.value || (t.newPosition = parseFloat(D.value) - o.value / (a.value - i.value) * 100, te(t.newPosition), f());
  }, R = () => {
    r.value || (t.newPosition = parseFloat(D.value) + o.value / (a.value - i.value) * 100, te(t.newPosition), f());
  }, F = (Q) => {
    let Y, Z;
    return Q.type.startsWith("touch") ? (Z = Q.touches[0].clientY, Y = Q.touches[0].clientX) : (Z = Q.clientY, Y = Q.clientX), {
      clientX: Y,
      clientY: Z
    };
  }, K = (Q) => {
    t.dragging = !0, t.isClick = !0;
    const { clientX: Y, clientY: Z } = F(Q);
    e.vertical ? t.startY = Z : t.startX = Y, t.startPosition = parseFloat(D.value), t.newPosition = t.startPosition;
  }, q = (Q) => {
    if (t.dragging) {
      t.isClick = !1, b(), d();
      let Y;
      const { clientX: Z, clientY: oe } = F(Q);
      e.vertical ? (t.currentY = oe, Y = (t.startY - t.currentY) / u.value * 100) : (t.currentX = Z, Y = (t.currentX - t.startX) / u.value * 100), t.newPosition = t.startPosition + Y, te(t.newPosition);
    }
  }, G = () => {
    t.dragging && (setTimeout(() => {
      t.dragging = !1, t.hovering || x(), t.isClick || (te(t.newPosition), f());
    }, 0), si(window, "mousemove", q), si(window, "touchmove", q), si(window, "mouseup", G), si(window, "touchend", G), si(window, "contextmenu", G));
  }, te = async (Q) => {
    if (Q === null || isNaN(Q))
      return;
    Q < 0 ? Q = 0 : Q > 100 && (Q = 100);
    const Y = 100 / ((a.value - i.value) / o.value);
    let oe = Math.round(Q / Y) * Y * (a.value - i.value) * 0.01 + i.value;
    oe = parseFloat(oe.toFixed(l.value)), n(vn, oe), !t.dragging && e.modelValue !== t.oldValue && (t.oldValue = e.modelValue), await bt(), t.dragging && b(), p.value.updatePopper();
  };
  return Ne(() => t.dragging, (Q) => {
    h(Q);
  }), {
    tooltip: p,
    tooltipVisible: y,
    showTooltip: s,
    wrapperStyle: S,
    formatValue: m,
    handleMouseEnter: C,
    handleMouseLeave: v,
    onButtonDown: H,
    onLeftKeyDown: V,
    onRightKeyDown: R,
    setPosition: te
  };
}, $Z = Ee({
  name: "ElSliderButton",
  components: {
    ElTooltip: Ki
  },
  props: {
    modelValue: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    tooltipClass: {
      type: String,
      default: ""
    }
  },
  emits: [vn],
  setup(e, { emit: t }) {
    const n = Ct("slider"), r = zt({
      hovering: !1,
      dragging: !1,
      isClick: !1,
      startX: 0,
      currentX: 0,
      startY: 0,
      currentY: 0,
      startPosition: 0,
      newPosition: 0,
      oldValue: e.modelValue
    }), {
      tooltip: i,
      showTooltip: a,
      tooltipVisible: o,
      wrapperStyle: s,
      formatValue: l,
      handleMouseEnter: u,
      handleMouseLeave: c,
      onButtonDown: f,
      onLeftKeyDown: d,
      onRightKeyDown: h,
      setPosition: p
    } = JZ(e, r, t), { hovering: y, dragging: m } = ma(r);
    return {
      ns: n,
      tooltip: i,
      tooltipVisible: o,
      showTooltip: a,
      wrapperStyle: s,
      formatValue: l,
      handleMouseEnter: u,
      handleMouseLeave: c,
      onButtonDown: f,
      onLeftKeyDown: d,
      onRightKeyDown: h,
      setPosition: p,
      hovering: y,
      dragging: m
    };
  }
});
function eJ(e, t, n, r, i, a) {
  const o = Ie("el-tooltip");
  return P(), L("div", {
    ref: "button",
    class: se([e.ns.e("button-wrapper"), { hover: e.hovering, dragging: e.dragging }]),
    style: Pt(e.wrapperStyle),
    tabindex: "0",
    onMouseenter: t[1] || (t[1] = (...s) => e.handleMouseEnter && e.handleMouseEnter(...s)),
    onMouseleave: t[2] || (t[2] = (...s) => e.handleMouseLeave && e.handleMouseLeave(...s)),
    onMousedown: t[3] || (t[3] = (...s) => e.onButtonDown && e.onButtonDown(...s)),
    onTouchstart: t[4] || (t[4] = (...s) => e.onButtonDown && e.onButtonDown(...s)),
    onFocus: t[5] || (t[5] = (...s) => e.handleMouseEnter && e.handleMouseEnter(...s)),
    onBlur: t[6] || (t[6] = (...s) => e.handleMouseLeave && e.handleMouseLeave(...s)),
    onKeydown: [
      t[7] || (t[7] = nn((...s) => e.onLeftKeyDown && e.onLeftKeyDown(...s), ["left"])),
      t[8] || (t[8] = nn((...s) => e.onRightKeyDown && e.onRightKeyDown(...s), ["right"])),
      t[9] || (t[9] = nn(wt((...s) => e.onLeftKeyDown && e.onLeftKeyDown(...s), ["prevent"]), ["down"])),
      t[10] || (t[10] = nn(wt((...s) => e.onRightKeyDown && e.onRightKeyDown(...s), ["prevent"]), ["up"]))
    ]
  }, [
    B(o, {
      ref: "tooltip",
      visible: e.tooltipVisible,
      "onUpdate:visible": t[0] || (t[0] = (s) => e.tooltipVisible = s),
      placement: "top",
      "stop-popper-mouse-event": !1,
      "popper-class": e.tooltipClass,
      disabled: !e.showTooltip,
      persistent: ""
    }, {
      content: N(() => [
        T("span", null, de(e.formatValue), 1)
      ]),
      default: N(() => [
        T("div", {
          class: se([e.ns.e("button"), { hover: e.hovering, dragging: e.dragging }])
        }, null, 2)
      ]),
      _: 1
    }, 8, ["visible", "popper-class", "disabled"])
  ], 38);
}
var tJ = /* @__PURE__ */ vt($Z, [["render", eJ]]);
const nJ = Ee({
  name: "ElMarker",
  props: {
    mark: {
      type: [String, Object],
      default: () => {
      }
    }
  },
  setup(e) {
    const t = Ct("slider"), n = J(() => typeof e.mark == "string" ? e.mark : e.mark.label);
    return {
      ns: t,
      label: n
    };
  },
  render() {
    var e;
    return et("div", {
      class: this.ns.e("marks-text"),
      style: (e = this.mark) == null ? void 0 : e.style
    }, this.label);
  }
}), iJ = (e) => J(() => e.marks ? Object.keys(e.marks).map(parseFloat).sort((n, r) => n - r).filter((n) => n <= e.max && n >= e.min).map((n) => ({
  point: n,
  position: (n - e.min) * 100 / (e.max - e.min),
  mark: e.marks[n]
})) : []), rJ = (e, t, n) => {
  const r = ce(Pa, {}), i = ce(ts, {}), a = Uo(null), o = j(null), s = j(null), l = {
    firstButton: o,
    secondButton: s
  }, u = J(() => e.disabled || r.disabled || !1), c = J(() => Math.min(t.firstValue, t.secondValue)), f = J(() => Math.max(t.firstValue, t.secondValue)), d = J(() => e.range ? `${100 * (f.value - c.value) / (e.max - e.min)}%` : `${100 * (t.firstValue - e.min) / (e.max - e.min)}%`), h = J(() => e.range ? `${100 * (c.value - e.min) / (e.max - e.min)}%` : "0%"), p = J(() => e.vertical ? { height: e.height } : {}), y = J(() => e.vertical ? {
    height: d.value,
    bottom: h.value
  } : {
    width: d.value,
    left: h.value
  }), m = () => {
    a.value && (t.sliderSize = a.value[`client${e.vertical ? "Height" : "Width"}`]);
  }, b = (H) => {
    const V = e.min + H * (e.max - e.min) / 100;
    if (!e.range) {
      o.value.setPosition(H);
      return;
    }
    let R;
    Math.abs(c.value - V) < Math.abs(f.value - V) ? R = t.firstValue < t.secondValue ? "firstButton" : "secondButton" : R = t.firstValue > t.secondValue ? "firstButton" : "secondButton", l[R].value.setPosition(H);
  }, x = (H) => {
    t.firstValue = H, S(e.range ? [c.value, f.value] : H);
  }, D = (H) => {
    t.secondValue = H, e.range && S([c.value, f.value]);
  }, S = (H) => {
    n(vn, H), n(Ls, H);
  }, C = async () => {
    await bt(), n(Tr, e.range ? [c.value, f.value] : e.modelValue);
  };
  return {
    elFormItem: i,
    slider: a,
    firstButton: o,
    secondButton: s,
    sliderDisabled: u,
    minValue: c,
    maxValue: f,
    runwayStyle: p,
    barStyle: y,
    resetSize: m,
    setPosition: b,
    emitChange: C,
    onSliderClick: (H) => {
      if (!(u.value || t.dragging)) {
        if (m(), e.vertical) {
          const V = a.value.getBoundingClientRect().bottom;
          b((V - H.clientY) / t.sliderSize * 100);
        } else {
          const V = a.value.getBoundingClientRect().left;
          b((H.clientX - V) / t.sliderSize * 100);
        }
        C();
      }
    },
    setFirstValue: x,
    setSecondValue: D
  };
}, aJ = (e, t, n, r) => ({
  stops: J(() => {
    if (!e.showStops || e.min > e.max)
      return [];
    if (e.step === 0)
      return fi("Slider", "step should not be 0."), [];
    const o = (e.max - e.min) / e.step, s = 100 * e.step / (e.max - e.min), l = Array.from({ length: o - 1 }).map((u, c) => (c + 1) * s);
    return e.range ? l.filter((u) => u < 100 * (n.value - e.min) / (e.max - e.min) || u > 100 * (r.value - e.min) / (e.max - e.min)) : l.filter((u) => u > 100 * (t.firstValue - e.min) / (e.max - e.min));
  }),
  getStopStyle: (o) => e.vertical ? { bottom: `${o}%` } : { left: `${o}%` }
}), oJ = Ee({
  name: "ElSlider",
  components: {
    ElInputNumber: QA,
    SliderButton: tJ,
    SliderMarker: nJ
  },
  props: {
    modelValue: {
      type: [Number, Array],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    showInput: {
      type: Boolean,
      default: !1
    },
    showInputControls: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      validator: fo
    },
    inputSize: {
      type: String,
      validator: fo
    },
    showStops: {
      type: Boolean,
      default: !1
    },
    showTooltip: {
      type: Boolean,
      default: !0
    },
    formatTooltip: {
      type: Function,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    height: {
      type: String,
      default: ""
    },
    debounce: {
      type: Number,
      default: 300
    },
    label: {
      type: String,
      default: void 0
    },
    tooltipClass: {
      type: String,
      default: void 0
    },
    marks: Object
  },
  emits: [vn, Tr, Ls],
  setup(e, { emit: t }) {
    const n = Ct("slider"), r = zt({
      firstValue: 0,
      secondValue: 0,
      oldValue: 0,
      dragging: !1,
      sliderSize: 1
    }), {
      elFormItem: i,
      slider: a,
      firstButton: o,
      secondButton: s,
      sliderDisabled: l,
      minValue: u,
      maxValue: c,
      runwayStyle: f,
      barStyle: d,
      resetSize: h,
      emitChange: p,
      onSliderClick: y,
      setFirstValue: m,
      setSecondValue: b
    } = rJ(e, r, t), { stops: x, getStopStyle: D } = aJ(e, r, u, c), S = Bi(), C = J(() => e.inputSize || S.value), v = J(() => [
      n.b(),
      n.m(S.value),
      n.is("vertical", e.vertical),
      { [n.m("with-input")]: e.showInput }
    ]), H = iJ(e);
    sJ(e, r, u, c, t, i);
    const V = J(() => {
      const Y = [e.min, e.max, e.step].map((Z) => {
        const oe = `${Z}`.split(".")[1];
        return oe ? oe.length : 0;
      });
      return Math.max.apply(null, Y);
    }), { sliderWrapper: R } = lJ(e, r, h), { firstValue: F, secondValue: K, oldValue: q, dragging: G, sliderSize: te } = ma(r), Q = (Y) => {
      r.dragging = Y;
    };
    return _t("SliderProvider", {
      ...ma(e),
      sliderSize: te,
      disabled: l,
      precision: V,
      emitChange: p,
      resetSize: h,
      updateDragging: Q
    }), {
      ns: n,
      firstValue: F,
      secondValue: K,
      oldValue: q,
      dragging: G,
      sliderSize: te,
      slider: a,
      firstButton: o,
      secondButton: s,
      sliderDisabled: l,
      runwayStyle: f,
      barStyle: d,
      emitChange: p,
      onSliderClick: y,
      getStopStyle: D,
      setFirstValue: m,
      setSecondValue: b,
      stops: x,
      markList: H,
      sliderWrapper: R,
      sliderWrapperSize: S,
      sliderInputSize: C,
      sliderKls: v
    };
  }
}), sJ = (e, t, n, r, i, a) => {
  const o = (u) => {
    i(vn, u), i(Ls, u);
  }, s = () => e.range ? ![n.value, r.value].every((u, c) => u === t.oldValue[c]) : e.modelValue !== t.oldValue, l = () => {
    var u, c;
    if (e.min > e.max) {
      ir("Slider", "min should not be greater than max.");
      return;
    }
    const f = e.modelValue;
    e.range && Array.isArray(f) ? f[1] < e.min ? o([e.min, e.min]) : f[0] > e.max ? o([e.max, e.max]) : f[0] < e.min ? o([e.min, f[1]]) : f[1] > e.max ? o([f[0], e.max]) : (t.firstValue = f[0], t.secondValue = f[1], s() && ((u = a.validate) == null || u.call(a, "change"), t.oldValue = f.slice())) : !e.range && typeof f == "number" && !isNaN(f) && (f < e.min ? o(e.min) : f > e.max ? o(e.max) : (t.firstValue = f, s() && ((c = a.validate) == null || c.call(a, "change"), t.oldValue = f)));
  };
  l(), Ne(() => t.dragging, (u) => {
    u || l();
  }), Ne(() => e.modelValue, (u, c) => {
    t.dragging || Array.isArray(u) && Array.isArray(c) && u.every((f, d) => f === c[d]) && t.firstValue === u[0] && t.secondValue === u[1] || l();
  }, {
    deep: !0
  }), Ne(() => [e.min, e.max], () => {
    l();
  });
}, lJ = (e, t, n) => {
  const r = j(null);
  return rn(async () => {
    let i;
    e.range ? (Array.isArray(e.modelValue) ? (t.firstValue = Math.max(e.min, e.modelValue[0]), t.secondValue = Math.min(e.max, e.modelValue[1])) : (t.firstValue = e.min, t.secondValue = e.max), t.oldValue = [t.firstValue, t.secondValue], i = `${t.firstValue}-${t.secondValue}`) : (typeof e.modelValue != "number" || isNaN(e.modelValue) ? t.firstValue = e.min : t.firstValue = Math.min(e.max, Math.max(e.min, e.modelValue)), t.oldValue = t.firstValue, i = t.firstValue), r.value.setAttribute("aria-valuetext", i), r.value.setAttribute("aria-label", e.label ? e.label : `slider between ${e.min} and ${e.max}`), _n(window, "resize", n), await bt(), n();
  }), Ti(() => {
    si(window, "resize", n);
  }), {
    sliderWrapper: r
  };
}, uJ = ["aria-valuemin", "aria-valuemax", "aria-orientation", "aria-disabled"], cJ = { key: 1 };
function dJ(e, t, n, r, i, a) {
  const o = Ie("slider-button"), s = Ie("slider-marker"), l = Ie("el-input-number");
  return P(), L("div", {
    ref: "sliderWrapper",
    class: se(e.sliderKls),
    role: "slider",
    "aria-valuemin": e.min,
    "aria-valuemax": e.max,
    "aria-orientation": e.vertical ? "vertical" : "horizontal",
    "aria-disabled": e.sliderDisabled
  }, [
    T("div", {
      ref: "slider",
      class: se([
        e.ns.e("runway"),
        { "show-input": e.showInput && !e.range, disabled: e.sliderDisabled }
      ]),
      style: Pt(e.runwayStyle),
      onClick: t[0] || (t[0] = (...u) => e.onSliderClick && e.onSliderClick(...u))
    }, [
      T("div", {
        class: se(e.ns.e("bar")),
        style: Pt(e.barStyle)
      }, null, 6),
      B(o, {
        ref: "firstButton",
        "model-value": e.firstValue,
        vertical: e.vertical,
        "tooltip-class": e.tooltipClass,
        "onUpdate:modelValue": e.setFirstValue
      }, null, 8, ["model-value", "vertical", "tooltip-class", "onUpdate:modelValue"]),
      e.range ? (P(), ue(o, {
        key: 0,
        ref: "secondButton",
        "model-value": e.secondValue,
        vertical: e.vertical,
        "tooltip-class": e.tooltipClass,
        "onUpdate:modelValue": e.setSecondValue
      }, null, 8, ["model-value", "vertical", "tooltip-class", "onUpdate:modelValue"])) : re("v-if", !0),
      e.showStops ? (P(), L("div", cJ, [
        (P(!0), L(nt, null, Lt(e.stops, (u, c) => (P(), L("div", {
          key: c,
          class: se(e.ns.e("stop")),
          style: Pt(e.getStopStyle(u))
        }, null, 6))), 128))
      ])) : re("v-if", !0),
      e.markList.length > 0 ? (P(), L(nt, { key: 2 }, [
        T("div", null, [
          (P(!0), L(nt, null, Lt(e.markList, (u, c) => (P(), L("div", {
            key: c,
            style: Pt(e.getStopStyle(u.position)),
            class: se([e.ns.e("stop"), e.ns.e("marks-stop")])
          }, null, 6))), 128))
        ]),
        T("div", {
          class: se(e.ns.e("marks"))
        }, [
          (P(!0), L(nt, null, Lt(e.markList, (u, c) => (P(), ue(s, {
            key: c,
            mark: u.mark,
            style: Pt(e.getStopStyle(u.position))
          }, null, 8, ["mark", "style"]))), 128))
        ], 2)
      ], 64)) : re("v-if", !0)
    ], 6),
    e.showInput && !e.range ? (P(), ue(l, {
      key: 0,
      ref: "input",
      "model-value": e.firstValue,
      class: se(e.ns.e("input")),
      step: e.step,
      disabled: e.sliderDisabled,
      controls: e.showInputControls,
      min: e.min,
      max: e.max,
      debounce: e.debounce,
      size: e.sliderInputSize,
      "onUpdate:modelValue": e.setFirstValue,
      onChange: e.emitChange
    }, null, 8, ["model-value", "class", "step", "disabled", "controls", "min", "max", "debounce", "size", "onUpdate:modelValue", "onChange"])) : re("v-if", !0)
  ], 10, uJ);
}
var o0 = /* @__PURE__ */ vt(oJ, [["render", dJ]]);
o0.install = (e) => {
  e.component(o0.name, o0);
};
const fJ = o0, hJ = fJ, pJ = Gt({
  modelValue: {
    type: [Boolean, String, Number],
    default: !1
  },
  value: {
    type: [Boolean, String, Number],
    default: !1
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  width: {
    type: Number,
    default: 40
  },
  inlinePrompt: {
    type: Boolean,
    default: !1
  },
  activeIcon: {
    type: ya,
    default: ""
  },
  inactiveIcon: {
    type: ya,
    default: ""
  },
  activeText: {
    type: String,
    default: ""
  },
  inactiveText: {
    type: String,
    default: ""
  },
  activeColor: {
    type: String,
    default: ""
  },
  inactiveColor: {
    type: String,
    default: ""
  },
  borderColor: {
    type: String,
    default: ""
  },
  activeValue: {
    type: [Boolean, String, Number],
    default: !0
  },
  inactiveValue: {
    type: [Boolean, String, Number],
    default: !1
  },
  name: {
    type: String,
    default: ""
  },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  id: String,
  loading: {
    type: Boolean,
    default: !1
  },
  beforeChange: {
    type: jt(Function)
  },
  size: {
    type: String,
    validator: fo
  }
}), vJ = {
  [vn]: (e) => Fa(e) || Ai(e) || jn(e),
  [Tr]: (e) => Fa(e) || Ai(e) || jn(e),
  [Ls]: (e) => Fa(e) || Ai(e) || jn(e)
}, Cp = "ElSwitch", mJ = Ee({
  name: Cp,
  components: { ElIcon: qt, Loading: Vl },
  props: pJ,
  emits: vJ,
  setup(e, { emit: t }) {
    const { formItem: n } = gc(), r = cf(J(() => e.loading)), i = Ct("switch"), a = Bi(), o = j(e.modelValue !== !1), s = j(), l = j(), u = J(() => [
      i.b(),
      i.m(a.value),
      i.is("disabled", r.value),
      i.is("checked", f.value)
    ]);
    Ne(() => e.modelValue, () => {
      o.value = !0;
    }), Ne(() => e.value, () => {
      o.value = !1;
    });
    const c = J(() => o.value ? e.modelValue : e.value), f = J(() => c.value === e.activeValue);
    [e.activeValue, e.inactiveValue].includes(c.value) || (t(vn, e.inactiveValue), t(Tr, e.inactiveValue), t(Ls, e.inactiveValue)), Ne(f, () => {
      var m;
      s.value.checked = f.value, (e.activeColor || e.inactiveColor) && p(), e.validateEvent && ((m = n == null ? void 0 : n.validate) == null || m.call(n, "change"));
    });
    const d = () => {
      const m = f.value ? e.inactiveValue : e.activeValue;
      t(vn, m), t(Tr, m), t(Ls, m), bt(() => {
        s.value.checked = f.value;
      });
    }, h = () => {
      if (r.value)
        return;
      const { beforeChange: m } = e;
      if (!m) {
        d();
        return;
      }
      const b = m();
      [
        H0(b),
        Fa(b)
      ].some((D) => D) || ir(Cp, "beforeChange must return type `Promise<boolean>` or `boolean`"), H0(b) ? b.then((D) => {
        D && d();
      }).catch((D) => {
        fi(Cp, `some error occurred: ${D}`);
      }) : b && d();
    }, p = () => {
      const m = f.value ? e.activeColor : e.inactiveColor, b = l.value;
      e.borderColor ? b.style.borderColor = e.borderColor : e.borderColor || (b.style.borderColor = m), b.style.backgroundColor = m, b.children[0].style.color = m;
    }, y = () => {
      var m, b;
      (b = (m = s.value) == null ? void 0 : m.focus) == null || b.call(m);
    };
    return rn(() => {
      (e.activeColor || e.inactiveColor || e.borderColor) && p(), s.value.checked = f.value;
    }), {
      ns: i,
      input: s,
      core: l,
      switchDisabled: r,
      checked: f,
      switchKls: u,
      handleChange: d,
      switchValue: h,
      focus: y
    };
  }
}), gJ = ["aria-checked", "aria-disabled"], yJ = ["id", "name", "true-value", "false-value", "disabled"], bJ = ["aria-hidden"], AJ = ["aria-hidden"], TJ = ["aria-hidden"], wJ = ["aria-hidden"];
function PJ(e, t, n, r, i, a) {
  const o = Ie("el-icon"), s = Ie("loading");
  return P(), L("div", {
    class: se(e.switchKls),
    role: "switch",
    "aria-checked": e.checked,
    "aria-disabled": e.switchDisabled,
    onClick: t[2] || (t[2] = wt((...l) => e.switchValue && e.switchValue(...l), ["prevent"]))
  }, [
    T("input", {
      id: e.id,
      ref: "input",
      class: se(e.ns.e("input")),
      type: "checkbox",
      name: e.name,
      "true-value": e.activeValue,
      "false-value": e.inactiveValue,
      disabled: e.switchDisabled,
      onChange: t[0] || (t[0] = (...l) => e.handleChange && e.handleChange(...l)),
      onKeydown: t[1] || (t[1] = nn((...l) => e.switchValue && e.switchValue(...l), ["enter"]))
    }, null, 42, yJ),
    !e.inlinePrompt && (e.inactiveIcon || e.inactiveText) ? (P(), L("span", {
      key: 0,
      class: se([
        e.ns.e("label"),
        e.ns.em("label", "left"),
        e.ns.is("active", !e.checked)
      ])
    }, [
      e.inactiveIcon ? (P(), ue(o, { key: 0 }, {
        default: N(() => [
          (P(), ue(Ln(e.inactiveIcon)))
        ]),
        _: 1
      })) : re("v-if", !0),
      !e.inactiveIcon && e.inactiveText ? (P(), L("span", {
        key: 1,
        "aria-hidden": e.checked
      }, de(e.inactiveText), 9, bJ)) : re("v-if", !0)
    ], 2)) : re("v-if", !0),
    T("span", {
      ref: "core",
      class: se(e.ns.e("core")),
      style: Pt({ width: (e.width || 40) + "px" })
    }, [
      e.inlinePrompt ? (P(), L("div", {
        key: 0,
        class: se(e.ns.e("inner"))
      }, [
        e.activeIcon || e.inactiveIcon ? (P(), L(nt, { key: 0 }, [
          e.activeIcon ? (P(), ue(o, {
            key: 0,
            class: se([e.ns.is("icon"), e.checked ? e.ns.is("show") : e.ns.is("hide")])
          }, {
            default: N(() => [
              (P(), ue(Ln(e.activeIcon)))
            ]),
            _: 1
          }, 8, ["class"])) : re("v-if", !0),
          e.inactiveIcon ? (P(), ue(o, {
            key: 1,
            class: se([e.ns.is("icon"), e.checked ? e.ns.is("hide") : e.ns.is("show")])
          }, {
            default: N(() => [
              (P(), ue(Ln(e.inactiveIcon)))
            ]),
            _: 1
          }, 8, ["class"])) : re("v-if", !0)
        ], 64)) : e.activeText || e.inactiveIcon ? (P(), L(nt, { key: 1 }, [
          e.activeText ? (P(), L("span", {
            key: 0,
            class: se([e.ns.is("text"), e.checked ? e.ns.is("show") : e.ns.is("hide")]),
            "aria-hidden": !e.checked
          }, de(e.activeText.substr(0, 1)), 11, AJ)) : re("v-if", !0),
          e.inactiveText ? (P(), L("span", {
            key: 1,
            class: se([e.ns.is("text"), e.checked ? e.ns.is("hide") : e.ns.is("show")]),
            "aria-hidden": e.checked
          }, de(e.inactiveText.substr(0, 1)), 11, TJ)) : re("v-if", !0)
        ], 64)) : re("v-if", !0)
      ], 2)) : re("v-if", !0),
      T("div", {
        class: se(e.ns.e("action"))
      }, [
        e.loading ? (P(), ue(o, {
          key: 0,
          class: se(e.ns.is("loading"))
        }, {
          default: N(() => [
            B(s)
          ]),
          _: 1
        }, 8, ["class"])) : re("v-if", !0)
      ], 2)
    ], 6),
    !e.inlinePrompt && (e.activeIcon || e.activeText) ? (P(), L("span", {
      key: 1,
      class: se([
        e.ns.e("label"),
        e.ns.em("label", "right"),
        e.ns.is("active", e.checked)
      ])
    }, [
      e.activeIcon ? (P(), ue(o, { key: 0 }, {
        default: N(() => [
          (P(), ue(Ln(e.activeIcon)))
        ]),
        _: 1
      })) : re("v-if", !0),
      !e.activeIcon && e.activeText ? (P(), L("span", {
        key: 1,
        "aria-hidden": !e.checked
      }, de(e.activeText), 9, wJ)) : re("v-if", !0)
    ], 2)) : re("v-if", !0)
  ], 10, gJ);
}
var xJ = /* @__PURE__ */ vt(mJ, [["render", PJ]]);
const yT = Un(xJ), Sp = function(e) {
  let t = e.target;
  for (; t && t.tagName.toUpperCase() !== "HTML"; ) {
    if (t.tagName.toUpperCase() === "TD")
      return t;
    t = t.parentNode;
  }
  return null;
}, k7 = function(e) {
  return e !== null && typeof e == "object";
}, CJ = function(e, t, n, r, i) {
  if (!t && !r && (!i || Array.isArray(i) && !i.length))
    return e;
  typeof n == "string" ? n = n === "descending" ? -1 : 1 : n = n && n < 0 ? -1 : 1;
  const a = r ? null : function(s, l) {
    return i ? (Array.isArray(i) || (i = [i]), i.map(function(u) {
      return typeof u == "string" ? vi(s, u) : u(s, l, e);
    })) : (t !== "$key" && k7(s) && "$value" in s && (s = s.$value), [k7(s) ? vi(s, t) : s]);
  }, o = function(s, l) {
    if (r)
      return r(s.value, l.value);
    for (let u = 0, c = s.key.length; u < c; u++) {
      if (s.key[u] < l.key[u])
        return -1;
      if (s.key[u] > l.key[u])
        return 1;
    }
    return 0;
  };
  return e.map(function(s, l) {
    return {
      value: s,
      index: l,
      key: a ? a(s, l) : null
    };
  }).sort(function(s, l) {
    let u = o(s, l);
    return u || (u = s.index - l.index), u * +n;
  }).map((s) => s.value);
}, bT = function(e, t) {
  let n = null;
  return e.columns.forEach(function(r) {
    r.id === t && (n = r);
  }), n;
}, SJ = function(e, t) {
  let n = null;
  for (let r = 0; r < e.columns.length; r++) {
    const i = e.columns[r];
    if (i.columnKey === t) {
      n = i;
      break;
    }
  }
  return n;
}, O7 = function(e, t, n) {
  const r = (t.className || "").match(new RegExp(`${n}-table_[^\\s]+`, "gm"));
  return r ? bT(e, r[0]) : null;
}, Vi = (e, t) => {
  if (!e)
    throw new Error("Row is required when get row identity");
  if (typeof t == "string") {
    if (t.indexOf(".") < 0)
      return `${e[t]}`;
    const n = t.split(".");
    let r = e;
    for (let i = 0; i < n.length; i++)
      r = r[n[i]];
    return `${r}`;
  } else if (typeof t == "function")
    return t.call(null, e);
}, yl = function(e, t) {
  const n = {};
  return (e || []).forEach((r, i) => {
    n[Vi(r, t)] = { row: r, index: i };
  }), n;
};
function EJ(e, t) {
  const n = {};
  let r;
  for (r in e)
    n[r] = e[r];
  for (r in t)
    if (Lr(t, r)) {
      const i = t[r];
      typeof i < "u" && (n[r] = i);
    }
  return n;
}
function I3(e) {
  return e === "" || e !== void 0 && (e = parseInt(e, 10), Number.isNaN(e) && (e = "")), e;
}
function AT(e) {
  return e === "" || e !== void 0 && (e = I3(e), Number.isNaN(e) && (e = 80)), e;
}
function Z8(e) {
  return typeof e == "number" ? e : typeof e == "string" ? /^\d+(?:px)?$/.test(e) ? parseInt(e, 10) : e : null;
}
function kJ(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, n) => (...r) => t(n(...r)));
}
function s0(e, t, n) {
  let r = !1;
  const i = e.indexOf(t), a = i !== -1, o = () => {
    e.push(t), r = !0;
  }, s = () => {
    e.splice(i, 1), r = !0;
  };
  return typeof n == "boolean" ? n && !a ? o() : !n && a && s() : a ? s() : o(), r;
}
function OJ(e, t, n = "children", r = "hasChildren") {
  const i = (o) => !(Array.isArray(o) && o.length);
  function a(o, s, l) {
    t(o, s, l), s.forEach((u) => {
      if (u[r]) {
        t(u, null, l + 1);
        return;
      }
      const c = u[n];
      i(c) || a(u, c, l + 1);
    });
  }
  e.forEach((o) => {
    if (o[r]) {
      t(o, null, 0);
      return;
    }
    const s = o[n];
    i(s) || a(o, s, 0);
  });
}
let V0;
function zJ(e, t, n, r) {
  const { nextZIndex: i } = Xh();
  function a() {
    const f = r === "light", d = document.createElement("div");
    return d.className = `el-popper ${f ? "is-light" : "is-dark"}`, d.innerHTML = t, d.style.zIndex = String(i()), document.body.appendChild(d), d;
  }
  function o() {
    const f = document.createElement("div");
    return f.className = "el-popper__arrow", f;
  }
  function s() {
    l && l.update();
  }
  V0 = function f() {
    try {
      l && l.destroy(), u && document.body.removeChild(u), si(e, "mouseenter", s), si(e, "mouseleave", f);
    } catch {
    }
  };
  let l = null;
  const u = a(), c = o();
  return u.appendChild(c), l = Wb(e, u, {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      },
      {
        name: "arrow",
        options: {
          element: c,
          padding: 10
        }
      }
    ],
    ...n
  }), _n(e, "mouseenter", s), _n(e, "mouseleave", V0), l;
}
const TT = (e, t, n, r) => {
  let i = 0, a = e;
  if (r) {
    if (r[e].colSpan > 1)
      return {};
    for (let l = 0; l < e; l++)
      i += r[l].colSpan;
    a = i + r[e].colSpan - 1;
  } else
    i = e;
  let o;
  const s = n.states.columns;
  switch (t) {
    case "left":
      a < n.states.fixedLeafColumnsLength.value && (o = "left");
      break;
    case "right":
      i >= s.value.length - n.states.rightFixedLeafColumnsLength.value && (o = "right");
      break;
    default:
      a < n.states.fixedLeafColumnsLength.value ? o = "left" : i >= s.value.length - n.states.rightFixedLeafColumnsLength.value && (o = "right");
  }
  return o ? {
    direction: o,
    start: i,
    after: a
  } : {};
}, L3 = (e, t, n, r, i) => {
  const a = [], { direction: o, start: s } = TT(t, n, r, i);
  if (o) {
    const l = o === "left";
    a.push(`${e}-fixed-column--${o}`), l && s === r.states.fixedLeafColumnsLength.value - 1 ? a.push("is-last-column") : !l && s === r.states.columns.value.length - r.states.rightFixedLeafColumnsLength.value && a.push("is-first-column");
  }
  return a;
};
function z7(e, t) {
  return e + (t.realWidth === null || Number.isNaN(t.realWidth) ? Number(t.width) : t.realWidth);
}
const B3 = (e, t, n, r) => {
  const { direction: i, start: a = 0 } = TT(e, t, n, r);
  if (!i)
    return;
  const o = {}, s = i === "left", l = n.states.columns.value;
  return s ? o.left = l.slice(0, e).reduce(z7, 0) : o.right = l.slice(a + 1).reverse().reduce(z7, 0), o;
}, Yu = (e, t) => {
  !e || Number.isNaN(e[t]) || (e[t] = `${e[t]}px`);
};
function DJ(e) {
  const t = sn(), n = j(!1), r = j([]);
  return {
    updateExpandRows: () => {
      const l = e.data.value || [], u = e.rowKey.value;
      if (n.value)
        r.value = l.slice();
      else if (u) {
        const c = yl(r.value, u);
        r.value = l.reduce((f, d) => {
          const h = Vi(d, u);
          return c[h] && f.push(d), f;
        }, []);
      } else
        r.value = [];
    },
    toggleRowExpansion: (l, u) => {
      s0(r.value, l, u) && (t.emit("expand-change", l, r.value.slice()), t.store.scheduleLayout());
    },
    setExpandRowKeys: (l) => {
      t.store.assertRowKey();
      const u = e.data.value || [], c = e.rowKey.value, f = yl(u, c);
      r.value = l.reduce((d, h) => {
        const p = f[h];
        return p && d.push(p.row), d;
      }, []);
    },
    isRowExpanded: (l) => {
      const u = e.rowKey.value;
      return u ? !!yl(r.value, u)[Vi(l, u)] : r.value.indexOf(l) !== -1;
    },
    states: {
      expandRows: r,
      defaultExpandAll: n
    }
  };
}
function MJ(e) {
  const t = sn(), n = j(null), r = j(null), i = (u) => {
    t.store.assertRowKey(), n.value = u, o(u);
  }, a = () => {
    n.value = null;
  }, o = (u) => {
    const { data: c, rowKey: f } = e;
    let d = null;
    f.value && (d = (E(c) || []).find((h) => Vi(h, f.value) === u)), r.value = d;
  };
  return {
    setCurrentRowKey: i,
    restoreCurrentRowKey: a,
    setCurrentRowByKey: o,
    updateCurrentRow: (u) => {
      const c = r.value;
      if (u && u !== c) {
        r.value = u, t.emit("current-change", r.value, c);
        return;
      }
      !u && c && (r.value = null, t.emit("current-change", null, c));
    },
    updateCurrentRowData: () => {
      const u = e.rowKey.value, c = e.data.value || [], f = r.value;
      if (c.indexOf(f) === -1 && f) {
        if (u) {
          const d = Vi(f, u);
          o(d);
        } else
          r.value = null;
        r.value === null && t.emit("current-change", null, f);
      } else
        n.value && (o(n.value), a());
    },
    states: {
      _currentRowKey: n,
      currentRow: r
    }
  };
}
function HJ(e) {
  const t = j([]), n = j({}), r = j(16), i = j(!1), a = j({}), o = j("hasChildren"), s = j("children"), l = sn(), u = J(() => {
    if (!e.rowKey.value)
      return {};
    const b = e.data.value || [];
    return f(b);
  }), c = J(() => {
    const b = e.rowKey.value, x = Object.keys(a.value), D = {};
    return x.length && x.forEach((S) => {
      if (a.value[S].length) {
        const C = { children: [] };
        a.value[S].forEach((v) => {
          const H = Vi(v, b);
          C.children.push(H), v[o.value] && !D[H] && (D[H] = { children: [] });
        }), D[S] = C;
      }
    }), D;
  }), f = (b) => {
    const x = e.rowKey.value, D = {};
    return OJ(b, (S, C, v) => {
      const H = Vi(S, x);
      Array.isArray(C) ? D[H] = {
        children: C.map((V) => Vi(V, x)),
        level: v
      } : i.value && (D[H] = {
        children: [],
        lazy: !0,
        level: v
      });
    }, s.value, o.value), D;
  }, d = (b = !1, x = ((D) => (D = l.store) == null ? void 0 : D.states.defaultExpandAll.value)()) => {
    var D;
    const S = u.value, C = c.value, v = Object.keys(S), H = {};
    if (v.length) {
      const V = E(n), R = [], F = (q, G) => {
        if (b)
          return t.value ? x || t.value.includes(G) : !!(x || (q == null ? void 0 : q.expanded));
        {
          const te = x || t.value && t.value.includes(G);
          return !!((q == null ? void 0 : q.expanded) || te);
        }
      };
      v.forEach((q) => {
        const G = V[q], te = { ...S[q] };
        if (te.expanded = F(G, q), te.lazy) {
          const { loaded: Q = !1, loading: Y = !1 } = G || {};
          te.loaded = !!Q, te.loading = !!Y, R.push(q);
        }
        H[q] = te;
      });
      const K = Object.keys(C);
      i.value && K.length && R.length && K.forEach((q) => {
        const G = V[q], te = C[q].children;
        if (R.indexOf(q) !== -1) {
          if (H[q].children.length !== 0)
            throw new Error("[ElTable]children must be an empty array.");
          H[q].children = te;
        } else {
          const { loaded: Q = !1, loading: Y = !1 } = G || {};
          H[q] = {
            lazy: !0,
            loaded: !!Q,
            loading: !!Y,
            expanded: F(G, q),
            children: te,
            level: ""
          };
        }
      });
    }
    n.value = H, (D = l.store) == null || D.updateTableScrollY();
  };
  Ne(() => t.value, () => {
    d(!0);
  }), Ne(() => u.value, () => {
    d();
  }), Ne(() => c.value, () => {
    d();
  });
  const h = (b) => {
    t.value = b, d();
  }, p = (b, x) => {
    l.store.assertRowKey();
    const D = e.rowKey.value, S = Vi(b, D), C = S && n.value[S];
    if (S && C && "expanded" in C) {
      const v = C.expanded;
      x = typeof x > "u" ? !C.expanded : x, n.value[S].expanded = x, v !== x && l.emit("expand-change", b, x), l.store.updateTableScrollY();
    }
  }, y = (b) => {
    l.store.assertRowKey();
    const x = e.rowKey.value, D = Vi(b, x), S = n.value[D];
    i.value && S && "loaded" in S && !S.loaded ? m(b, D, S) : p(b, void 0);
  }, m = (b, x, D) => {
    const { load: S } = l.props;
    S && !n.value[x].loaded && (n.value[x].loading = !0, S(b, D, (C) => {
      if (!Array.isArray(C))
        throw new Error("[ElTable] data must be an array");
      n.value[x].loading = !1, n.value[x].loaded = !0, n.value[x].expanded = !0, C.length && (a.value[x] = C), l.emit("expand-change", b, !0);
    }));
  };
  return {
    loadData: m,
    loadOrToggle: y,
    toggleTreeExpansion: p,
    updateTreeExpandKeys: h,
    updateTreeData: d,
    normalize: f,
    states: {
      expandRowKeys: t,
      treeData: n,
      indent: r,
      lazy: i,
      lazyTreeNodeMap: a,
      lazyColumnIdentifier: o,
      childrenColumnName: s
    }
  };
}
const IJ = (e, t) => {
  const n = t.sortingColumn;
  return !n || typeof n.sortable == "string" ? e : CJ(e, t.sortProp, t.sortOrder, n.sortMethod, n.sortBy);
}, l0 = (e) => {
  const t = [];
  return e.forEach((n) => {
    n.children ? t.push.apply(t, l0(n.children)) : t.push(n);
  }), t;
};
function LJ() {
  var e;
  const t = sn(), { size: n } = ma((e = t.proxy) == null ? void 0 : e.$props), r = j(null), i = j([]), a = j([]), o = j(!1), s = j([]), l = j([]), u = j([]), c = j([]), f = j([]), d = j([]), h = j([]), p = j([]), y = j(0), m = j(0), b = j(0), x = j(!1), D = j([]), S = j(!1), C = j(!1), v = j(null), H = j({}), V = j(null), R = j(null), F = j(null), K = j(null), q = j(null);
  Ne(i, () => t.state && Q(!1), {
    deep: !0
  });
  const G = () => {
    if (!r.value)
      throw new Error("[ElTable] prop row-key is required");
  }, te = () => {
    c.value = s.value.filter((Se) => Se.fixed === !0 || Se.fixed === "left"), f.value = s.value.filter((Se) => Se.fixed === "right"), c.value.length > 0 && s.value[0] && s.value[0].type === "selection" && !s.value[0].fixed && (s.value[0].fixed = !0, c.value.unshift(s.value[0]));
    const Mt = s.value.filter((Se) => !Se.fixed);
    l.value = [].concat(c.value).concat(Mt).concat(f.value);
    const Nt = l0(Mt), De = l0(c.value), Ue = l0(f.value);
    y.value = Nt.length, m.value = De.length, b.value = Ue.length, u.value = [].concat(De).concat(Nt).concat(Ue), o.value = c.value.length > 0 || f.value.length > 0;
  }, Q = (Mt, Nt = !1) => {
    Mt && te(), Nt ? t.state.doLayout() : t.state.debouncedUpdateLayout();
  }, Y = (Mt) => D.value.indexOf(Mt) > -1, Z = () => {
    x.value = !1, D.value.length && (D.value = [], t.emit("selection-change", []));
  }, oe = () => {
    let Mt;
    if (r.value) {
      Mt = [];
      const Nt = yl(D.value, r.value), De = yl(i.value, r.value);
      for (const Ue in Nt)
        Lr(Nt, Ue) && !De[Ue] && Mt.push(Nt[Ue].row);
    } else
      Mt = D.value.filter((Nt) => i.value.indexOf(Nt) === -1);
    if (Mt.length) {
      const Nt = D.value.filter((De) => Mt.indexOf(De) === -1);
      D.value = Nt, t.emit("selection-change", Nt.slice());
    }
  }, he = (Mt, Nt = void 0, De = !0) => {
    if (s0(D.value, Mt, Nt)) {
      const Se = (D.value || []).slice();
      De && t.emit("select", Se, Mt), t.emit("selection-change", Se);
    }
  }, Ae = () => {
    var Mt, Nt;
    const De = C.value ? !x.value : !(x.value || D.value.length);
    x.value = De;
    let Ue = !1, Se = 0;
    const st = (Nt = (Mt = t == null ? void 0 : t.store) == null ? void 0 : Mt.states) == null ? void 0 : Nt.rowKey.value;
    i.value.forEach((kt, mn) => {
      const cn = mn + Se;
      v.value ? v.value.call(null, kt, cn) && s0(D.value, kt, De) && (Ue = !0) : s0(D.value, kt, De) && (Ue = !0), Se += Re(Vi(kt, st));
    }), Ue && t.emit("selection-change", D.value ? D.value.slice() : []), t.emit("select-all", D.value);
  }, We = () => {
    const Mt = yl(D.value, r.value);
    i.value.forEach((Nt) => {
      const De = Vi(Nt, r.value), Ue = Mt[De];
      Ue && (D.value[Ue.index] = Nt);
    });
  }, ke = () => {
    var Mt, Nt, De;
    if (((Mt = i.value) == null ? void 0 : Mt.length) === 0) {
      x.value = !1;
      return;
    }
    let Ue;
    r.value && (Ue = yl(D.value, r.value));
    const Se = function(cn) {
      return Ue ? !!Ue[Vi(cn, r.value)] : D.value.indexOf(cn) !== -1;
    };
    let st = !0, kt = 0, mn = 0;
    for (let cn = 0, kn = (i.value || []).length; cn < kn; cn++) {
      const Tn = (De = (Nt = t == null ? void 0 : t.store) == null ? void 0 : Nt.states) == null ? void 0 : De.rowKey.value, sr = cn + mn, wi = i.value[cn], Hi = v.value && v.value.call(null, wi, sr);
      if (Se(wi))
        kt++;
      else if (!v.value || Hi) {
        st = !1;
        break;
      }
      mn += Re(Vi(wi, Tn));
    }
    kt === 0 && (st = !1), x.value = st;
  }, Re = (Mt) => {
    var Nt;
    if (!t || !t.store)
      return 0;
    const { treeData: De } = t.store.states;
    let Ue = 0;
    const Se = (Nt = De.value[Mt]) == null ? void 0 : Nt.children;
    return Se && (Ue += Se.length, Se.forEach((st) => {
      Ue += Re(st);
    })), Ue;
  }, ve = (Mt, Nt) => {
    Array.isArray(Mt) || (Mt = [Mt]);
    const De = {};
    return Mt.forEach((Ue) => {
      H.value[Ue.id] = Nt, De[Ue.columnKey || Ue.id] = Nt;
    }), De;
  }, Ye = (Mt, Nt, De) => {
    R.value && R.value !== Mt && (R.value.order = null), R.value = Mt, F.value = Nt, K.value = De;
  }, Qe = () => {
    let Mt = E(a);
    Object.keys(H.value).forEach((Nt) => {
      const De = H.value[Nt];
      if (!De || De.length === 0)
        return;
      const Ue = bT({
        columns: u.value
      }, Nt);
      Ue && Ue.filterMethod && (Mt = Mt.filter((Se) => De.some((st) => Ue.filterMethod.call(null, st, Se, Ue))));
    }), V.value = Mt;
  }, ot = () => {
    i.value = IJ(V.value, {
      sortingColumn: R.value,
      sortProp: F.value,
      sortOrder: K.value
    });
  }, Ve = (Mt = void 0) => {
    Mt && Mt.filter || Qe(), ot();
  }, Te = (Mt) => {
    const { tableHeader: Nt, fixedTableHeader: De, rightFixedTableHeader: Ue } = t.refs;
    let Se = {};
    Nt && (Se = Object.assign(Se, Nt.filterPanels)), De && (Se = Object.assign(Se, De.filterPanels)), Ue && (Se = Object.assign(Se, Ue.filterPanels));
    const st = Object.keys(Se);
    if (!!st.length)
      if (typeof Mt == "string" && (Mt = [Mt]), Array.isArray(Mt)) {
        const kt = Mt.map((mn) => SJ({
          columns: u.value
        }, mn));
        st.forEach((mn) => {
          const cn = kt.find((kn) => kn.id === mn);
          cn && (cn.filteredValue = []);
        }), t.store.commit("filterChange", {
          column: kt,
          values: [],
          silent: !0,
          multi: !0
        });
      } else
        st.forEach((kt) => {
          const mn = u.value.find((cn) => cn.id === kt);
          mn && (mn.filteredValue = []);
        }), H.value = {}, t.store.commit("filterChange", {
          column: {},
          values: [],
          silent: !0
        });
  }, Me = () => {
    !R.value || (Ye(null, null, null), t.store.commit("changeSortCondition", {
      silent: !0
    }));
  }, {
    setExpandRowKeys: Je,
    toggleRowExpansion: mt,
    updateExpandRows: It,
    states: ln,
    isRowExpanded: gt
  } = DJ({
    data: i,
    rowKey: r
  }), {
    updateTreeExpandKeys: Pe,
    toggleTreeExpansion: $e,
    updateTreeData: Ke,
    loadOrToggle: lt,
    states: He
  } = HJ({
    data: i,
    rowKey: r
  }), {
    updateCurrentRowData: Le,
    updateCurrentRow: ct,
    setCurrentRowKey: Qt,
    states: Zt
  } = MJ({
    data: i,
    rowKey: r
  });
  return {
    assertRowKey: G,
    updateColumns: te,
    scheduleLayout: Q,
    isSelected: Y,
    clearSelection: Z,
    cleanSelection: oe,
    toggleRowSelection: he,
    _toggleAllSelection: Ae,
    toggleAllSelection: null,
    updateSelectionByRowKey: We,
    updateAllSelected: ke,
    updateFilters: ve,
    updateCurrentRow: ct,
    updateSort: Ye,
    execFilter: Qe,
    execSort: ot,
    execQuery: Ve,
    clearFilter: Te,
    clearSort: Me,
    toggleRowExpansion: mt,
    setExpandRowKeysAdapter: (Mt) => {
      Je(Mt), Pe(Mt);
    },
    setCurrentRowKey: Qt,
    toggleRowExpansionAdapter: (Mt, Nt) => {
      u.value.some(({ type: Ue }) => Ue === "expand") ? mt(Mt, Nt) : $e(Mt, Nt);
    },
    isRowExpanded: gt,
    updateExpandRows: It,
    updateCurrentRowData: Le,
    loadOrToggle: lt,
    updateTreeData: Ke,
    states: {
      tableSize: n,
      rowKey: r,
      data: i,
      _data: a,
      isComplex: o,
      _columns: s,
      originColumns: l,
      columns: u,
      fixedColumns: c,
      rightFixedColumns: f,
      leafColumns: d,
      fixedLeafColumns: h,
      rightFixedLeafColumns: p,
      leafColumnsLength: y,
      fixedLeafColumnsLength: m,
      rightFixedLeafColumnsLength: b,
      isAllSelected: x,
      selection: D,
      reserveSelection: S,
      selectOnIndeterminate: C,
      selectable: v,
      filters: H,
      filteredData: V,
      sortingColumn: R,
      sortProp: F,
      sortOrder: K,
      hoverRow: q,
      ...ln,
      ...He,
      ...Zt
    }
  };
}
function J8(e, t) {
  return e.map((n) => {
    var r;
    return n.id === t.id ? t : ((r = n.children) != null && r.length && (n.children = J8(n.children, t)), n);
  });
}
function wT(e) {
  e.forEach((t) => {
    var n, r;
    t.no = (n = t.getColumnIndex) == null ? void 0 : n.call(t), (r = t.children) != null && r.length && wT(t.children);
  }), e.sort((t, n) => t.no - n.no);
}
function BJ() {
  const e = sn(), t = LJ();
  return {
    ns: Ct("table"),
    ...t,
    mutations: {
      setData(o, s) {
        const l = E(o._data) !== s;
        o.data.value = s, o._data.value = s, e.store.execQuery(), e.store.updateCurrentRowData(), e.store.updateExpandRows(), e.store.updateTreeData(e.store.states.defaultExpandAll.value), E(o.reserveSelection) ? (e.store.assertRowKey(), e.store.updateSelectionByRowKey()) : l ? e.store.clearSelection() : e.store.cleanSelection(), e.store.updateAllSelected(), e.$ready && e.store.scheduleLayout();
      },
      insertColumn(o, s, l) {
        const u = E(o._columns);
        let c = [];
        l ? (l && !l.children && (l.children = []), l.children.push(s), c = J8(u, l)) : (u.push(s), c = u), wT(c), o._columns.value = c, s.type === "selection" && (o.selectable.value = s.selectable, o.reserveSelection.value = s.reserveSelection), e.$ready && (e.store.updateColumns(), e.store.scheduleLayout());
      },
      removeColumn(o, s, l) {
        const u = E(o._columns) || [];
        if (l)
          l.children.splice(l.children.findIndex((c) => c.id === s.id), 1), l.children.length === 0 && delete l.children, o._columns.value = J8(u, l);
        else {
          const c = u.indexOf(s);
          c > -1 && (u.splice(c, 1), o._columns.value = u);
        }
        e.$ready && (e.store.updateColumns(), e.store.scheduleLayout());
      },
      sort(o, s) {
        const { prop: l, order: u, init: c } = s;
        if (l) {
          const f = E(o.columns).find((d) => d.property === l);
          f && (f.order = u, e.store.updateSort(f, l, u), e.store.commit("changeSortCondition", { init: c }));
        }
      },
      changeSortCondition(o, s) {
        const { sortingColumn: l, sortProp: u, sortOrder: c } = o;
        E(c) === null && (o.sortingColumn.value = null, o.sortProp.value = null);
        const f = { filter: !0 };
        e.store.execQuery(f), (!s || !(s.silent || s.init)) && e.emit("sort-change", {
          column: E(l),
          prop: E(u),
          order: E(c)
        }), e.store.updateTableScrollY();
      },
      filterChange(o, s) {
        const { column: l, values: u, silent: c } = s, f = e.store.updateFilters(l, u);
        e.store.execQuery(), c || e.emit("filter-change", f), e.store.updateTableScrollY();
      },
      toggleAllSelection() {
        e.store.toggleAllSelection();
      },
      rowSelectedChanged(o, s) {
        e.store.toggleRowSelection(s), e.store.updateAllSelected();
      },
      setHoverRow(o, s) {
        o.hoverRow.value = s;
      },
      setCurrentRow(o, s) {
        e.store.updateCurrentRow(s);
      }
    },
    commit: function(o, ...s) {
      const l = e.store.mutations;
      if (l[o])
        l[o].apply(e, [e.store.states].concat(s));
      else
        throw new Error(`Action not found: ${o}`);
    },
    updateTableScrollY: function() {
      bt(() => e.layout.updateScrollY.apply(e.layout));
    }
  };
}
const wd = {
  rowKey: "rowKey",
  defaultExpandAll: "defaultExpandAll",
  selectOnIndeterminate: "selectOnIndeterminate",
  indent: "indent",
  lazy: "lazy",
  data: "data",
  ["treeProps.hasChildren"]: {
    key: "lazyColumnIdentifier",
    default: "hasChildren"
  },
  ["treeProps.children"]: {
    key: "childrenColumnName",
    default: "children"
  }
};
function NJ(e, t) {
  if (!e)
    throw new Error("Table is required.");
  const n = BJ();
  return n.toggleAllSelection = qa(n._toggleAllSelection, 10), Object.keys(wd).forEach((r) => {
    PT(xT(t, r), r, n);
  }), jJ(n, t), n;
}
function jJ(e, t) {
  Object.keys(wd).forEach((n) => {
    Ne(() => xT(t, n), (r) => {
      PT(r, n, e);
    });
  });
}
function PT(e, t, n) {
  let r = e, i = wd[t];
  typeof wd[t] == "object" && (i = i.key, r = r || wd[t].default), n.states[i].value = r;
}
function xT(e, t) {
  if (t.includes(".")) {
    const n = t.split(".");
    let r = e;
    return n.forEach((i) => {
      r = r[i];
    }), r;
  } else
    return e[t];
}
class FJ {
  constructor(t) {
    this.observers = [], this.table = null, this.store = null, this.columns = [], this.fit = !0, this.showHeader = !0, this.height = j(null), this.scrollX = j(!1), this.scrollY = j(!1), this.bodyWidth = j(null), this.fixedWidth = j(null), this.rightFixedWidth = j(null), this.tableHeight = j(null), this.headerHeight = j(44), this.appendHeight = j(0), this.footerHeight = j(44), this.viewportHeight = j(null), this.bodyHeight = j(null), this.bodyScrollHeight = j(0), this.fixedBodyHeight = j(null), this.gutterWidth = 0;
    for (const n in t)
      Lr(t, n) && (Bn(this[n]) ? this[n].value = t[n] : this[n] = t[n]);
    if (!this.table)
      throw new Error("Table is required for Table Layout");
    if (!this.store)
      throw new Error("Store is required for Table Layout");
  }
  updateScrollY() {
    if (this.height.value === null)
      return !1;
    const n = this.table.refs.bodyWrapper;
    if (this.table.vnode.el && n) {
      let r = !0;
      const i = this.scrollY.value;
      return this.bodyHeight.value === null ? r = !1 : r = n.scrollHeight > this.bodyHeight.value, this.scrollY.value = r, i !== r;
    }
    return !1;
  }
  setHeight(t, n = "height") {
    if (!Sn)
      return;
    const r = this.table.vnode.el;
    if (t = Z8(t), this.height.value = Number(t), !r && (t || t === 0))
      return bt(() => this.setHeight(t, n));
    typeof t == "number" ? (r.style[n] = `${t}px`, this.updateElsHeight()) : typeof t == "string" && (r.style[n] = t, this.updateElsHeight());
  }
  setMaxHeight(t) {
    this.setHeight(t, "max-height");
  }
  getFlattenColumns() {
    const t = [];
    return this.table.store.states.columns.value.forEach((r) => {
      r.isColumnGroup ? t.push.apply(t, r.columns) : t.push(r);
    }), t;
  }
  updateElsHeight() {
    var t, n;
    if (!this.table.$ready)
      return bt(() => this.updateElsHeight());
    const {
      tableWrapper: r,
      headerWrapper: i,
      appendWrapper: a,
      footerWrapper: o,
      tableHeader: s,
      tableBody: l
    } = this.table.refs;
    if (r && r.style.display === "none" || (this.appendHeight.value = a ? a.offsetHeight : 0, this.showHeader && !i))
      return;
    const u = s || null, c = this.headerDisplayNone(u), f = this.headerHeight.value = this.showHeader ? i.offsetHeight : 0;
    if (this.showHeader && !c && i.offsetWidth > 0 && (this.table.store.states.columns.value || []).length > 0 && f < 2)
      return bt(() => this.updateElsHeight());
    const d = this.tableHeight.value = (n = (t = this.table) == null ? void 0 : t.vnode.el) == null ? void 0 : n.clientHeight, h = this.footerHeight.value = o ? o.offsetHeight : 0;
    this.height.value !== null && (this.bodyHeight.value === null && requestAnimationFrame(() => this.updateElsHeight()), this.bodyHeight.value = d - f - h + (o ? 1 : 0), this.bodyScrollHeight.value = l == null ? void 0 : l.scrollHeight), this.fixedBodyHeight.value = this.scrollX.value ? this.bodyHeight.value - this.gutterWidth : this.bodyHeight.value, this.viewportHeight.value = this.scrollX.value ? d - this.gutterWidth : d, this.updateScrollY(), this.notifyObservers("scrollable");
  }
  headerDisplayNone(t) {
    if (!t)
      return !0;
    let n = t;
    for (; n.tagName !== "DIV"; ) {
      if (getComputedStyle(n).display === "none")
        return !0;
      n = n.parentElement;
    }
    return !1;
  }
  updateColumnsWidth() {
    if (!Sn)
      return;
    const t = this.fit, n = this.table.vnode.el.clientWidth, { tableBody: r } = this.table.refs, i = (r == null ? void 0 : r.scrollWidth) || 0;
    let a = 0;
    const o = this.getFlattenColumns(), s = o.filter((c) => typeof c.width != "number");
    if (o.forEach((c) => {
      typeof c.width == "number" && c.realWidth && (c.realWidth = null);
    }), s.length > 0 && t) {
      o.forEach((f) => {
        a += Number(f.width || f.minWidth || 80);
      });
      const c = 0;
      if (a <= n - c && i <= n) {
        this.scrollX.value = !1;
        const f = n - c - a;
        if (s.length === 1)
          s[0].realWidth = Number(s[0].minWidth || 80) + f;
        else {
          const d = s.reduce((y, m) => y + Number(m.minWidth || 80), 0), h = f / d;
          let p = 0;
          s.forEach((y, m) => {
            if (m === 0)
              return;
            const b = Math.floor(Number(y.minWidth || 80) * h);
            p += b, y.realWidth = Number(y.minWidth || 80) + b;
          }), s[0].realWidth = Number(s[0].minWidth || 80) + f - p;
        }
      } else
        this.scrollX.value = !0, s.forEach(function(f) {
          f.realWidth = Number(f.minWidth);
        });
      this.bodyWidth.value = Math.max(a, n), this.table.state.resizeState.value.width = this.bodyWidth.value;
    } else
      o.forEach((c) => {
        !c.width && !c.minWidth ? c.realWidth = 80 : c.realWidth = Number(c.width || c.minWidth), a += c.realWidth;
      }), this.scrollX.value = a > n, this.bodyWidth.value = a;
    const l = this.store.states.fixedColumns.value;
    if (l.length > 0) {
      let c = 0;
      l.forEach(function(f) {
        c += Number(f.realWidth || f.width);
      }), this.fixedWidth.value = c;
    }
    const u = this.store.states.rightFixedColumns.value;
    if (u.length > 0) {
      let c = 0;
      u.forEach(function(f) {
        c += Number(f.realWidth || f.width);
      }), this.rightFixedWidth.value = c;
    }
    this.notifyObservers("columns");
  }
  addObserver(t) {
    this.observers.push(t);
  }
  removeObserver(t) {
    const n = this.observers.indexOf(t);
    n !== -1 && this.observers.splice(n, 1);
  }
  notifyObservers(t) {
    this.observers.forEach((r) => {
      var i, a;
      switch (t) {
        case "columns":
          (i = r.state) == null || i.onColumnsChange(this);
          break;
        case "scrollable":
          (a = r.state) == null || a.onScrollableChange(this);
          break;
        default:
          throw new Error(`Table Layout don't have event ${t}.`);
      }
    });
  }
}
const { CheckboxGroup: XJ } = Bs, RJ = Ee({
  name: "ElTableFilterPanel",
  components: {
    ElCheckbox: Bs,
    ElCheckboxGroup: XJ,
    ElScrollbar: ns,
    ElTooltip: Ki,
    ElIcon: qt,
    ArrowDown: vc,
    ArrowUp: uf
  },
  directives: { ClickOutside: yc },
  props: {
    placement: {
      type: String,
      default: "bottom-start"
    },
    store: {
      type: Object
    },
    column: {
      type: Object
    },
    upDataColumn: {
      type: Function
    }
  },
  setup(e) {
    const t = sn(), { t: n } = hi(), r = Ct("table-filter"), i = t == null ? void 0 : t.parent;
    i.filterPanels.value[e.column.id] || (i.filterPanels.value[e.column.id] = t);
    const a = j(!1), o = j(null), s = J(() => e.column && e.column.filters), l = J({
      get: () => {
        var S;
        return (((S = e.column) == null ? void 0 : S.filteredValue) || [])[0];
      },
      set: (S) => {
        u.value && (typeof S < "u" && S !== null ? u.value.splice(0, 1, S) : u.value.splice(0, 1));
      }
    }), u = J({
      get() {
        return e.column ? e.column.filteredValue || [] : [];
      },
      set(S) {
        e.column && e.upDataColumn("filteredValue", S);
      }
    }), c = J(() => e.column ? e.column.filterMultiple : !0), f = (S) => S.value === l.value, d = () => {
      a.value = !1;
    }, h = (S) => {
      S.stopPropagation(), a.value = !a.value;
    }, p = () => {
      a.value = !1;
    }, y = () => {
      x(u.value), d();
    }, m = () => {
      u.value = [], x(u.value), d();
    }, b = (S) => {
      l.value = S, x(typeof S < "u" && S !== null ? u.value : []), d();
    }, x = (S) => {
      e.store.commit("filterChange", {
        column: e.column,
        values: S
      }), e.store.updateAllSelected();
    };
    Ne(a, (S) => {
      e.column && e.upDataColumn("filterOpened", S);
    }, {
      immediate: !0
    });
    const D = J(() => {
      var S, C;
      return (C = (S = o.value) == null ? void 0 : S.popperRef) == null ? void 0 : C.contentRef;
    });
    return {
      tooltipVisible: a,
      multiple: c,
      filteredValue: u,
      filterValue: l,
      filters: s,
      handleConfirm: y,
      handleReset: m,
      handleSelect: b,
      isActive: f,
      t: n,
      ns: r,
      showFilterPanel: h,
      hideFilterPanel: p,
      popperPaneRef: D,
      tooltip: o
    };
  }
}), VJ = { key: 0 }, UJ = ["disabled"], qJ = ["label", "onClick"];
function _J(e, t, n, r, i, a) {
  const o = Ie("el-checkbox"), s = Ie("el-checkbox-group"), l = Ie("el-scrollbar"), u = Ie("arrow-up"), c = Ie("arrow-down"), f = Ie("el-icon"), d = Ie("el-tooltip"), h = va("click-outside");
  return P(), ue(d, {
    ref: "tooltip",
    visible: e.tooltipVisible,
    "onUpdate:visible": t[5] || (t[5] = (p) => e.tooltipVisible = p),
    offset: 0,
    placement: e.placement,
    "show-arrow": !1,
    "stop-popper-mouse-event": !1,
    "append-to-body": "",
    effect: "light",
    pure: "",
    "popper-class": e.ns.b(),
    persistent: ""
  }, {
    content: N(() => [
      e.multiple ? (P(), L("div", VJ, [
        T("div", {
          class: se(e.ns.e("content"))
        }, [
          B(l, {
            "wrap-class": e.ns.e("wrap")
          }, {
            default: N(() => [
              B(s, {
                modelValue: e.filteredValue,
                "onUpdate:modelValue": t[0] || (t[0] = (p) => e.filteredValue = p),
                class: se(e.ns.e("checkbox-group"))
              }, {
                default: N(() => [
                  (P(!0), L(nt, null, Lt(e.filters, (p) => (P(), ue(o, {
                    key: p.value,
                    label: p.value
                  }, {
                    default: N(() => [
                      je(de(p.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "class"])
            ]),
            _: 1
          }, 8, ["wrap-class"])
        ], 2),
        T("div", {
          class: se(e.ns.e("bottom"))
        }, [
          T("button", {
            class: se({ [e.ns.is("disabled")]: e.filteredValue.length === 0 }),
            disabled: e.filteredValue.length === 0,
            type: "button",
            onClick: t[1] || (t[1] = (...p) => e.handleConfirm && e.handleConfirm(...p))
          }, de(e.t("el.table.confirmFilter")), 11, UJ),
          T("button", {
            type: "button",
            onClick: t[2] || (t[2] = (...p) => e.handleReset && e.handleReset(...p))
          }, de(e.t("el.table.resetFilter")), 1)
        ], 2)
      ])) : (P(), L("ul", {
        key: 1,
        class: se(e.ns.e("list"))
      }, [
        T("li", {
          class: se([
            e.ns.e("list-item"),
            {
              [e.ns.is("active")]: e.filterValue === void 0 || e.filterValue === null
            }
          ]),
          onClick: t[3] || (t[3] = (p) => e.handleSelect(null))
        }, de(e.t("el.table.clearFilter")), 3),
        (P(!0), L(nt, null, Lt(e.filters, (p) => (P(), L("li", {
          key: p.value,
          class: se([e.ns.e("list-item"), e.ns.is("active", e.isActive(p))]),
          label: p.value,
          onClick: (y) => e.handleSelect(p.value)
        }, de(p.text), 11, qJ))), 128))
      ], 2))
    ]),
    default: N(() => [
      Bt((P(), L("span", {
        class: se([
          `${e.ns.namespace.value}-table__column-filter-trigger`,
          `${e.ns.namespace.value}-none-outline`
        ]),
        onClick: t[4] || (t[4] = (...p) => e.showFilterPanel && e.showFilterPanel(...p))
      }, [
        B(f, null, {
          default: N(() => [
            e.column.filterOpened ? (P(), ue(u, { key: 0 })) : (P(), ue(c, { key: 1 }))
          ]),
          _: 1
        })
      ], 2)), [
        [h, e.hideFilterPanel, e.popperPaneRef]
      ])
    ]),
    _: 1
  }, 8, ["visible", "placement", "popper-class"]);
}
var WJ = /* @__PURE__ */ vt(RJ, [["render", _J]]);
function CT(e) {
  const t = sn();
  Ph(() => {
    n.value.addObserver(t);
  }), rn(() => {
    r(n.value), i(n.value);
  }), Zo(() => {
    r(n.value), i(n.value);
  }), hc(() => {
    n.value.removeObserver(t);
  });
  const n = J(() => {
    const a = e.layout;
    if (!a)
      throw new Error("Can not find table layout.");
    return a;
  }), r = (a) => {
    var o;
    const s = ((o = e.vnode.el) == null ? void 0 : o.querySelectorAll("colgroup > col")) || [];
    if (!s.length)
      return;
    const l = a.getFlattenColumns(), u = {};
    l.forEach((c) => {
      u[c.id] = c;
    });
    for (let c = 0, f = s.length; c < f; c++) {
      const d = s[c], h = d.getAttribute("name"), p = u[h];
      p && d.setAttribute("width", p.realWidth || p.width);
    }
  }, i = (a) => {
    var o, s;
    const l = ((o = e.vnode.el) == null ? void 0 : o.querySelectorAll("colgroup > col[name=gutter]")) || [];
    for (let c = 0, f = l.length; c < f; c++)
      l[c].setAttribute("width", a.scrollY.value ? a.gutterWidth : "0");
    const u = ((s = e.vnode.el) == null ? void 0 : s.querySelectorAll("th.gutter")) || [];
    for (let c = 0, f = u.length; c < f; c++) {
      const d = u[c];
      d.style.width = a.scrollY.value ? `${a.gutterWidth}px` : "0", d.style.display = a.scrollY.value ? "" : "none";
    }
  };
  return {
    tableLayout: n.value,
    onColumnsChange: r,
    onScrollableChange: i
  };
}
const mo = Symbol("ElTable");
function KJ(e, t) {
  const n = sn(), r = ce(mo), i = (y) => {
    y.stopPropagation();
  }, a = (y, m) => {
    !m.filters && m.sortable ? p(y, m, !1) : m.filterable && !m.sortable && i(y), r == null || r.emit("header-click", m, y);
  }, o = (y, m) => {
    r == null || r.emit("header-contextmenu", m, y);
  }, s = j(null), l = j(!1), u = j({}), c = (y, m) => {
    if (!!Sn && !(m.children && m.children.length > 0) && s.value && e.border) {
      l.value = !0;
      const b = r;
      t("set-drag-visible", !0);
      const D = (b == null ? void 0 : b.vnode.el).getBoundingClientRect().left, S = n.vnode.el.querySelector(`th.${m.id}`), C = S.getBoundingClientRect(), v = C.left - D + 30;
      Ss(S, "noclick"), u.value = {
        startMouseLeft: y.clientX,
        startLeft: C.right - D,
        startColumnLeft: C.left - D,
        tableLeft: D
      };
      const H = b == null ? void 0 : b.refs.resizeProxy;
      H.style.left = `${u.value.startLeft}px`, document.onselectstart = function() {
        return !1;
      }, document.ondragstart = function() {
        return !1;
      };
      const V = (F) => {
        const K = F.clientX - u.value.startMouseLeft, q = u.value.startLeft + K;
        H.style.left = `${Math.max(v, q)}px`;
      }, R = () => {
        if (l.value) {
          const { startColumnLeft: F, startLeft: K } = u.value, G = parseInt(H.style.left, 10) - F;
          m.width = m.realWidth = G, b == null || b.emit("header-dragend", m.width, K - F, m, y), requestAnimationFrame(() => {
            e.store.scheduleLayout(!1, !0);
          }), document.body.style.cursor = "", l.value = !1, s.value = null, u.value = {}, t("set-drag-visible", !1);
        }
        document.removeEventListener("mousemove", V), document.removeEventListener("mouseup", R), document.onselectstart = null, document.ondragstart = null, setTimeout(function() {
          oo(S, "noclick");
        }, 0);
      };
      document.addEventListener("mousemove", V), document.addEventListener("mouseup", R);
    }
  }, f = (y, m) => {
    if (m.children && m.children.length > 0)
      return;
    let b = y.target;
    for (; b && b.tagName !== "TH"; )
      b = b.parentNode;
    if (!(!m || !m.resizable) && !l.value && e.border) {
      const x = b.getBoundingClientRect(), D = document.body.style;
      x.width > 12 && x.right - y.pageX < 8 ? (D.cursor = "col-resize", jo(b, "is-sortable") && (b.style.cursor = "col-resize"), s.value = m) : l.value || (D.cursor = "", jo(b, "is-sortable") && (b.style.cursor = "pointer"), s.value = null);
    }
  }, d = () => {
    !Sn || (document.body.style.cursor = "");
  }, h = ({ order: y, sortOrders: m }) => {
    if (y === "")
      return m[0];
    const b = m.indexOf(y || null);
    return m[b > m.length - 2 ? 0 : b + 1];
  }, p = (y, m, b) => {
    y.stopPropagation();
    const x = m.order === b ? null : b || h(m);
    let D = y.target;
    for (; D && D.tagName !== "TH"; )
      D = D.parentNode;
    if (D && D.tagName === "TH" && jo(D, "noclick")) {
      oo(D, "noclick");
      return;
    }
    if (!m.sortable)
      return;
    const S = e.store.states;
    let C = S.sortProp.value, v;
    const H = S.sortingColumn.value;
    (H !== m || H === m && H.order === null) && (H && (H.order = null), S.sortingColumn.value = m, C = m.property), x ? v = m.order = x : v = m.order = null, S.sortProp.value = C, S.sortOrder.value = v, r == null || r.store.commit("changeSortCondition");
  };
  return {
    handleHeaderClick: a,
    handleHeaderContextMenu: o,
    handleMouseDown: c,
    handleMouseMove: f,
    handleMouseOut: d,
    handleSortClick: p,
    handleFilterClick: i
  };
}
function GJ(e) {
  const t = ce(mo), n = Ct("table");
  return {
    getHeaderRowStyle: (s) => {
      const l = t == null ? void 0 : t.props.headerRowStyle;
      return typeof l == "function" ? l.call(null, { rowIndex: s }) : l;
    },
    getHeaderRowClass: (s) => {
      const l = [], u = t == null ? void 0 : t.props.headerRowClassName;
      return typeof u == "string" ? l.push(u) : typeof u == "function" && l.push(u.call(null, { rowIndex: s })), l.join(" ");
    },
    getHeaderCellStyle: (s, l, u, c) => {
      var f;
      let d = (f = t == null ? void 0 : t.props.headerCellStyle) != null ? f : {};
      typeof d == "function" && (d = d.call(null, {
        rowIndex: s,
        columnIndex: l,
        row: u,
        column: c
      }));
      const h = c.isSubColumn ? null : B3(l, c.fixed, e.store, u);
      return Yu(h, "left"), Yu(h, "right"), Object.assign({}, d, h);
    },
    getHeaderCellClass: (s, l, u, c) => {
      const f = c.isSubColumn ? [] : L3(n.b(), l, c.fixed, e.store, u), d = [
        c.id,
        c.order,
        c.headerAlign,
        c.className,
        c.labelClassName,
        ...f
      ];
      c.children || d.push("is-leaf"), c.sortable && d.push("is-sortable");
      const h = t == null ? void 0 : t.props.headerCellClassName;
      return typeof h == "string" ? d.push(h) : typeof h == "function" && d.push(h.call(null, {
        rowIndex: s,
        columnIndex: l,
        row: u,
        column: c
      })), d.push(n.e("cell")), d.join(" ");
    }
  };
}
const ST = (e) => {
  const t = [];
  return e.forEach((n) => {
    n.children ? (t.push(n), t.push.apply(t, ST(n.children))) : t.push(n);
  }), t;
}, YJ = (e) => {
  let t = 1;
  const n = (a, o) => {
    if (o && (a.level = o.level + 1, t < a.level && (t = a.level)), a.children) {
      let s = 0;
      a.children.forEach((l) => {
        n(l, a), s += l.colSpan;
      }), a.colSpan = s;
    } else
      a.colSpan = 1;
  };
  e.forEach((a) => {
    a.level = 1, n(a, void 0);
  });
  const r = [];
  for (let a = 0; a < t; a++)
    r.push([]);
  return ST(e).forEach((a) => {
    a.children ? (a.rowSpan = 1, a.children.forEach((o) => o.isSubColumn = !0)) : a.rowSpan = t - a.level + 1, r[a.level - 1].push(a);
  }), r;
};
function QJ(e) {
  const t = ce(mo), n = J(() => YJ(e.store.states.originColumns.value));
  return {
    isGroup: J(() => {
      const a = n.value.length > 1;
      return a && t && (t.state.isGroup.value = !0), a;
    }),
    toggleAllSelection: (a) => {
      a.stopPropagation(), t == null || t.store.commit("toggleAllSelection");
    },
    columnRows: n
  };
}
var ZJ = Ee({
  name: "ElTableHeader",
  components: {
    ElCheckbox: Bs
  },
  props: {
    fixed: {
      type: String,
      default: ""
    },
    store: {
      required: !0,
      type: Object
    },
    border: Boolean,
    defaultSort: {
      type: Object,
      default: () => ({
        prop: "",
        order: ""
      })
    }
  },
  setup(e, { emit: t }) {
    const n = sn(), r = ce(mo), i = Ct("table"), a = j({}), { onColumnsChange: o, onScrollableChange: s } = CT(r);
    rn(() => {
      bt(() => {
        const { prop: v, order: H } = e.defaultSort, V = !0;
        r == null || r.store.commit("sort", { prop: v, order: H, init: V });
      });
    });
    const {
      handleHeaderClick: l,
      handleHeaderContextMenu: u,
      handleMouseDown: c,
      handleMouseMove: f,
      handleMouseOut: d,
      handleSortClick: h,
      handleFilterClick: p
    } = KJ(e, t), {
      getHeaderRowStyle: y,
      getHeaderRowClass: m,
      getHeaderCellStyle: b,
      getHeaderCellClass: x
    } = GJ(e), { isGroup: D, toggleAllSelection: S, columnRows: C } = QJ(e);
    return n.state = {
      onColumnsChange: o,
      onScrollableChange: s
    }, n.filterPanels = a, {
      ns: i,
      filterPanels: a,
      onColumnsChange: o,
      onScrollableChange: s,
      columnRows: C,
      getHeaderRowClass: m,
      getHeaderRowStyle: y,
      getHeaderCellClass: x,
      getHeaderCellStyle: b,
      handleHeaderClick: l,
      handleHeaderContextMenu: u,
      handleMouseDown: c,
      handleMouseMove: f,
      handleMouseOut: d,
      handleSortClick: h,
      handleFilterClick: p,
      isGroup: D,
      toggleAllSelection: S
    };
  },
  render() {
    const {
      ns: e,
      isGroup: t,
      columnRows: n,
      getHeaderCellStyle: r,
      getHeaderCellClass: i,
      getHeaderRowClass: a,
      getHeaderRowStyle: o,
      handleHeaderClick: s,
      handleHeaderContextMenu: l,
      handleMouseDown: u,
      handleMouseMove: c,
      handleSortClick: f,
      handleMouseOut: d,
      store: h,
      $parent: p
    } = this;
    let y = 1;
    return et("thead", {
      class: { [e.is("group")]: t }
    }, n.map((m, b) => et("tr", {
      class: a(b),
      key: b,
      style: o(b)
    }, m.map((x, D) => (x.rowSpan > y && (y = x.rowSpan), et("th", {
      class: i(b, D, m, x),
      colspan: x.colSpan,
      key: `${x.id}-thead`,
      rowspan: x.rowSpan,
      style: r(b, D, m, x),
      onClick: (S) => s(S, x),
      onContextmenu: (S) => l(S, x),
      onMousedown: (S) => u(S, x),
      onMousemove: (S) => c(S, x),
      onMouseout: d
    }, [
      et("div", {
        class: [
          "cell",
          x.filteredValue && x.filteredValue.length > 0 ? "highlight" : "",
          x.labelClassName
        ]
      }, [
        x.renderHeader ? x.renderHeader({
          column: x,
          $index: D,
          store: h,
          _self: p
        }) : x.label,
        x.sortable && et("span", {
          onClick: (S) => f(S, x),
          class: "caret-wrapper"
        }, [
          et("i", {
            onClick: (S) => f(S, x, "ascending"),
            class: "sort-caret ascending"
          }),
          et("i", {
            onClick: (S) => f(S, x, "descending"),
            class: "sort-caret descending"
          })
        ]),
        x.filterable && et(WJ, {
          store: p.store,
          placement: x.filterPlacement || "bottom-start",
          column: x,
          upDataColumn: (S, C) => {
            x[S] = C;
          }
        })
      ])
    ]))))));
  }
});
function JJ(e) {
  const t = ce(mo), n = j(""), r = j(et("div")), i = (d, h, p) => {
    var y;
    const m = t, b = Sp(d);
    let x;
    const D = (y = m == null ? void 0 : m.vnode.el) == null ? void 0 : y.dataset.prefix;
    b && (x = O7({
      columns: e.store.states.columns.value
    }, b, D), x && (m == null || m.emit(`cell-${p}`, h, x, b, d))), m == null || m.emit(`row-${p}`, h, x, d);
  }, a = (d, h) => {
    i(d, h, "dblclick");
  }, o = (d, h) => {
    e.store.commit("setCurrentRow", h), i(d, h, "click");
  }, s = (d, h) => {
    i(d, h, "contextmenu");
  }, l = qa(function(d) {
    e.store.commit("setHoverRow", d);
  }, 30), u = qa(function() {
    e.store.commit("setHoverRow", null);
  }, 30);
  return {
    handleDoubleClick: a,
    handleClick: o,
    handleContextMenu: s,
    handleMouseEnter: l,
    handleMouseLeave: u,
    handleCellMouseEnter: (d, h) => {
      var p;
      const y = t, m = Sp(d), b = (p = y == null ? void 0 : y.vnode.el) == null ? void 0 : p.dataset.prefix;
      if (m) {
        const v = O7({
          columns: e.store.states.columns.value
        }, m, b), H = y.hoverState = { cell: m, column: v, row: h };
        y == null || y.emit("cell-mouse-enter", H.row, H.column, H.cell, d);
      }
      const x = d.target.querySelector(".cell");
      if (!(jo(x, `${b}-tooltip`) && x.childNodes.length))
        return;
      const D = document.createRange();
      D.setStart(x, 0), D.setEnd(x, x.childNodes.length);
      const S = D.getBoundingClientRect().width, C = (parseInt(I0(x, "paddingLeft"), 10) || 0) + (parseInt(I0(x, "paddingRight"), 10) || 0);
      (S + C > x.offsetWidth || x.scrollWidth > x.offsetWidth) && zJ(m, m.innerText || m.textContent, {
        placement: "top",
        strategy: "fixed"
      }, h.tooltipEffect);
    },
    handleCellMouseLeave: (d) => {
      if (!Sp(d))
        return;
      const p = t == null ? void 0 : t.hoverState;
      t == null || t.emit("cell-mouse-leave", p == null ? void 0 : p.row, p == null ? void 0 : p.column, p == null ? void 0 : p.cell, d);
    },
    tooltipContent: n,
    tooltipTrigger: r
  };
}
function $J(e) {
  const t = ce(mo), n = Ct("table");
  return {
    getRowStyle: (u, c) => {
      const f = t == null ? void 0 : t.props.rowStyle;
      return typeof f == "function" ? f.call(null, {
        row: u,
        rowIndex: c
      }) : f || null;
    },
    getRowClass: (u, c) => {
      const f = [n.e("row")];
      (t == null ? void 0 : t.props.highlightCurrentRow) && u === e.store.states.currentRow.value && f.push("current-row"), e.stripe && c % 2 === 1 && f.push(n.em("row", "striped"));
      const d = t == null ? void 0 : t.props.rowClassName;
      return typeof d == "string" ? f.push(d) : typeof d == "function" && f.push(d.call(null, {
        row: u,
        rowIndex: c
      })), e.store.states.expandRows.value.indexOf(u) > -1 && f.push("expanded"), f;
    },
    getCellStyle: (u, c, f, d) => {
      const h = t == null ? void 0 : t.props.cellStyle;
      let p = h != null ? h : {};
      typeof h == "function" && (p = h.call(null, {
        rowIndex: u,
        columnIndex: c,
        row: f,
        column: d
      }));
      const y = d.isSubColumn ? null : B3(c, e == null ? void 0 : e.fixed, e.store);
      return Yu(y, "left"), Yu(y, "right"), Object.assign({}, p, y);
    },
    getCellClass: (u, c, f, d) => {
      const h = d.isSubColumn ? [] : L3(n.b(), c, e == null ? void 0 : e.fixed, e.store), p = [d.id, d.align, d.className, ...h], y = t == null ? void 0 : t.props.cellClassName;
      return typeof y == "string" ? p.push(y) : typeof y == "function" && p.push(y.call(null, {
        rowIndex: u,
        columnIndex: c,
        row: f,
        column: d
      })), p.push(n.e("cell")), p.join(" ");
    },
    getSpan: (u, c, f, d) => {
      let h = 1, p = 1;
      const y = t == null ? void 0 : t.props.spanMethod;
      if (typeof y == "function") {
        const m = y({
          row: u,
          column: c,
          rowIndex: f,
          columnIndex: d
        });
        Array.isArray(m) ? (h = m[0], p = m[1]) : typeof m == "object" && (h = m.rowspan, p = m.colspan);
      }
      return { rowspan: h, colspan: p };
    },
    getColspanRealWidth: (u, c, f) => {
      if (c < 1)
        return u[f].realWidth;
      const d = u.map(({ realWidth: h, width: p }) => h || p).slice(f, f + c);
      return Number(d.reduce((h, p) => Number(h) + Number(p), -1));
    }
  };
}
function e$(e) {
  const t = ce(mo), {
    handleDoubleClick: n,
    handleClick: r,
    handleContextMenu: i,
    handleMouseEnter: a,
    handleMouseLeave: o,
    handleCellMouseEnter: s,
    handleCellMouseLeave: l,
    tooltipContent: u,
    tooltipTrigger: c
  } = JJ(e), {
    getRowStyle: f,
    getRowClass: d,
    getCellStyle: h,
    getCellClass: p,
    getSpan: y,
    getColspanRealWidth: m
  } = $J(e), b = J(() => e.store.states.columns.value.findIndex(({ type: v }) => v === "default")), x = (v, H) => {
    const V = t.props.rowKey;
    return V ? Vi(v, V) : H;
  }, D = (v, H, V) => {
    const { tooltipEffect: R, store: F } = e, { indent: K, columns: q } = F.states, G = d(v, H);
    let te = !0;
    return V && (G.push(`el-table__row--level-${V.level}`), te = V.display), et("tr", {
      style: [te ? null : {
        display: "none"
      }, f(v, H)],
      class: G,
      key: x(v, H),
      onDblclick: (Y) => n(Y, v),
      onClick: (Y) => r(Y, v),
      onContextmenu: (Y) => i(Y, v),
      onMouseenter: () => a(H),
      onMouseleave: o
    }, q.value.map((Y, Z) => {
      const { rowspan: oe, colspan: he } = y(v, Y, H, Z);
      if (!oe || !he)
        return null;
      const Ae = { ...Y };
      Ae.realWidth = m(q.value, he, Z);
      const We = {
        store: e.store,
        _self: e.context || t,
        column: Ae,
        row: v,
        $index: H
      };
      Z === b.value && V && (We.treeNode = {
        indent: V.level * K.value,
        level: V.level
      }, typeof V.expanded == "boolean" && (We.treeNode.expanded = V.expanded, "loading" in V && (We.treeNode.loading = V.loading), "noLazyChildren" in V && (We.treeNode.noLazyChildren = V.noLazyChildren)));
      const ke = `${H},${Z}`, Re = Ae.columnKey || Ae.rawColumnKey || "", ve = S(Z, Y, We);
      return et("td", {
        style: h(H, Z, v, Y),
        class: p(H, Z, v, Y),
        key: `${Re}${ke}`,
        rowspan: oe,
        colspan: he,
        onMouseenter: (Ye) => s(Ye, { ...v, tooltipEffect: R }),
        onMouseleave: l
      }, [ve]);
    }));
  }, S = (v, H, V) => H.renderCell(V);
  return {
    wrappedRowRender: (v, H) => {
      const V = e.store, { isRowExpanded: R, assertRowKey: F } = V, { treeData: K, lazyTreeNodeMap: q, childrenColumnName: G, rowKey: te } = V.states;
      if (V.states.columns.value.some(({ type: Y }) => Y === "expand") && R(v)) {
        const Y = t.renderExpanded, Z = D(v, H, void 0);
        return Y ? [
          [
            Z,
            et("tr", {
              key: `expanded-row__${Z.key}`
            }, [
              et("td", {
                colspan: V.states.columns.value.length,
                class: "el-table__cell el-table__expanded-cell"
              }, [Y({ row: v, $index: H, store: V })])
            ])
          ]
        ] : (console.error("[Element Error]renderExpanded is required."), Z);
      } else if (Object.keys(K.value).length) {
        F();
        const Y = Vi(v, te.value);
        let Z = K.value[Y], oe = null;
        Z && (oe = {
          expanded: Z.expanded,
          level: Z.level,
          display: !0
        }, typeof Z.lazy == "boolean" && (typeof Z.loaded == "boolean" && Z.loaded && (oe.noLazyChildren = !(Z.children && Z.children.length)), oe.loading = Z.loading));
        const he = [D(v, H, oe)];
        if (Z) {
          let Ae = 0;
          const We = (Re, ve) => {
            !(Re && Re.length && ve) || Re.forEach((Ye) => {
              const Qe = {
                display: ve.display && ve.expanded,
                level: ve.level + 1,
                expanded: !1,
                noLazyChildren: !1,
                loading: !1
              }, ot = Vi(Ye, te.value);
              if (ot == null)
                throw new Error("For nested data item, row-key is required.");
              if (Z = { ...K.value[ot] }, Z && (Qe.expanded = Z.expanded, Z.level = Z.level || Qe.level, Z.display = !!(Z.expanded && Qe.display), typeof Z.lazy == "boolean" && (typeof Z.loaded == "boolean" && Z.loaded && (Qe.noLazyChildren = !(Z.children && Z.children.length)), Qe.loading = Z.loading)), Ae++, he.push(D(Ye, H + Ae, Qe)), Z) {
                const Ve = q.value[ot] || Ye[G.value];
                We(Ve, Z);
              }
            });
          };
          Z.display = !0;
          const ke = q.value[Y] || v[G.value];
          We(ke, Z);
        }
        return he;
      } else
        return D(v, H, void 0);
    },
    tooltipContent: u,
    tooltipTrigger: c
  };
}
const t$ = {
  store: {
    required: !0,
    type: Object
  },
  stripe: Boolean,
  tooltipEffect: String,
  context: {
    default: () => ({}),
    type: Object
  },
  rowClassName: [String, Function],
  rowStyle: [Object, Function],
  fixed: {
    type: String,
    default: ""
  },
  highlight: Boolean
};
var n$ = Ee({
  name: "ElTableBody",
  props: t$,
  setup(e) {
    const t = sn(), n = ce(mo), r = Ct("table"), { wrappedRowRender: i, tooltipContent: a, tooltipTrigger: o } = e$(e), { onColumnsChange: s, onScrollableChange: l } = CT(n);
    return Ne(e.store.states.hoverRow, (u, c) => {
      if (!e.store.states.isComplex.value || !Sn)
        return;
      let f = window.requestAnimationFrame;
      f || (f = (d) => window.setTimeout(d, 16)), f(() => {
        var d;
        const h = (d = t == null ? void 0 : t.vnode.el) == null ? void 0 : d.querySelectorAll(`.${r.e("row")}`), p = h[c], y = h[u];
        p && oo(p, "hover-row"), y && Ss(y, "hover-row");
      });
    }), hc(() => {
      var u;
      (u = V0) == null || u();
    }), Zo(() => {
      var u;
      (u = V0) == null || u();
    }), {
      ns: r,
      onColumnsChange: s,
      onScrollableChange: l,
      wrappedRowRender: i,
      tooltipContent: a,
      tooltipTrigger: o
    };
  },
  render() {
    const { wrappedRowRender: e, store: t } = this, n = t.states.data.value || [];
    return et("tbody", {}, [
      n.reduce((r, i) => r.concat(e(i, r.length)), [])
    ]);
  }
});
function N3(e) {
  const t = e.tableLayout === "auto";
  let n = e.columns || [];
  t && n.every((i) => i.width === void 0) && (n = []);
  const r = (i) => {
    const a = {
      key: `${e.tableLayout}_${i.id}`,
      style: {},
      name: void 0
    };
    return t ? a.style = {
      width: `${i.width}px`
    } : a.name = i.id, a;
  };
  return et("colgroup", {}, n.map((i) => et("col", r(i))));
}
N3.props = ["columns", "tableLayout"];
function i$() {
  const e = ce(mo), t = e == null ? void 0 : e.store, n = J(() => t.states.fixedLeafColumnsLength.value), r = J(() => t.states.rightFixedColumns.value.length), i = J(() => t.states.columns.value.length), a = J(() => t.states.fixedColumns.value.length), o = J(() => t.states.rightFixedColumns.value.length);
  return {
    leftFixedLeafCount: n,
    rightFixedLeafCount: r,
    columnsCount: i,
    leftFixedCount: a,
    rightFixedCount: o,
    columns: t.states.columns
  };
}
function r$(e) {
  const { columns: t } = i$(), n = Ct("table");
  return {
    getCellClasses: (a, o) => {
      const s = a[o], l = [
        n.e("cell"),
        s.id,
        s.align,
        s.labelClassName,
        ...L3(n.b(), o, s.fixed, e.store)
      ];
      return s.className && l.push(s.className), s.children || l.push(n.is("leaf")), l;
    },
    getCellStyles: (a, o) => {
      const s = B3(o, a.fixed, e.store);
      return Yu(s, "left"), Yu(s, "right"), s;
    },
    columns: t
  };
}
var a$ = Ee({
  name: "ElTableFooter",
  props: {
    fixed: {
      type: String,
      default: ""
    },
    store: {
      required: !0,
      type: Object
    },
    summaryMethod: Function,
    sumText: String,
    border: Boolean,
    defaultSort: {
      type: Object,
      default: () => ({
        prop: "",
        order: ""
      })
    }
  },
  setup(e) {
    const { getCellClasses: t, getCellStyles: n, columns: r } = r$(e);
    return {
      ns: Ct("table"),
      getCellClasses: t,
      getCellStyles: n,
      columns: r
    };
  },
  render() {
    const {
      columns: e,
      getCellStyles: t,
      getCellClasses: n,
      summaryMethod: r,
      sumText: i,
      ns: a
    } = this, o = this.store.states.data.value;
    let s = [];
    return r ? s = r({
      columns: e,
      data: o
    }) : e.forEach((l, u) => {
      if (u === 0) {
        s[u] = i;
        return;
      }
      const c = o.map((p) => Number(p[l.property])), f = [];
      let d = !0;
      c.forEach((p) => {
        if (!isNaN(p)) {
          d = !1;
          const y = `${p}`.split(".")[1];
          f.push(y ? y.length : 0);
        }
      });
      const h = Math.max.apply(null, f);
      d ? s[u] = "" : s[u] = c.reduce((p, y) => {
        const m = Number(y);
        return isNaN(m) ? p : parseFloat((p + y).toFixed(Math.min(h, 20)));
      }, 0);
    }), et("table", {
      class: a.e("footer"),
      cellspacing: "0",
      cellpadding: "0",
      border: "0"
    }, [
      N3(e),
      et("tbody", [
        et("tr", {}, [
          ...e.map((l, u) => et("td", {
            key: u,
            colspan: l.colSpan,
            rowspan: l.rowSpan,
            class: n(e, u),
            style: t(l, u)
          }, [
            et("div", {
              class: ["cell", l.labelClassName]
            }, [s[u]])
          ]))
        ])
      ])
    ]);
  }
});
function o$(e) {
  return {
    setCurrentRow: (u) => {
      e.commit("setCurrentRow", u);
    },
    toggleRowSelection: (u, c) => {
      e.toggleRowSelection(u, c, !1), e.updateAllSelected();
    },
    clearSelection: () => {
      e.clearSelection();
    },
    clearFilter: (u) => {
      e.clearFilter(u);
    },
    toggleAllSelection: () => {
      e.commit("toggleAllSelection");
    },
    toggleRowExpansion: (u, c) => {
      e.toggleRowExpansionAdapter(u, c);
    },
    clearSort: () => {
      e.clearSort();
    },
    sort: (u, c) => {
      e.commit("sort", { prop: u, order: c });
    }
  };
}
function s$(e, t, n, r) {
  const i = j(!1), a = j(null), o = j(!1), s = (Q) => {
    o.value = Q;
  }, l = j({
    width: null,
    height: null
  }), u = j(!1);
  Bo(() => {
    t.setHeight(e.height);
  }), Bo(() => {
    t.setMaxHeight(e.maxHeight);
  }), Ne(() => [e.currentRowKey, n.states.rowKey], ([Q, Y]) => {
    !E(Y) || n.setCurrentRowKey(`${Q}`);
  }, {
    immediate: !0
  }), Ne(() => e.data, (Q) => {
    r.store.commit("setData", Q);
  }, {
    immediate: !0,
    deep: !0
  }), Bo(() => {
    e.expandRowKeys && n.setExpandRowKeysAdapter(e.expandRowKeys);
  });
  const c = () => {
    r.store.commit("setHoverRow", null), r.hoverState && (r.hoverState = null);
  }, f = (Q, Y) => {
    const { pixelX: Z, pixelY: oe } = Y;
    Math.abs(Z) >= Math.abs(oe) && (r.refs.bodyWrapper.scrollLeft += Y.pixelX / 5);
  }, d = J(() => e.height || e.maxHeight || n.states.fixedColumns.value.length > 0 || n.states.rightFixedColumns.value.length > 0), h = J(() => ({
    width: t.bodyWidth.value ? `${t.bodyWidth.value}px` : ""
  })), p = () => {
    d.value && t.updateElsHeight(), t.updateColumnsWidth(), requestAnimationFrame(b);
  };
  rn(async () => {
    m("is-scrolling-left"), n.updateColumns(), await bt(), x(), requestAnimationFrame(p), l.value = {
      width: r.vnode.el.offsetWidth,
      height: r.vnode.el.offsetHeight
    }, n.states.columns.value.forEach((Q) => {
      Q.filteredValue && Q.filteredValue.length && r.store.commit("filterChange", {
        column: Q,
        values: Q.filteredValue,
        silent: !0
      });
    }), r.$ready = !0;
  });
  const y = (Q, Y) => {
    if (!Q)
      return;
    const Z = Array.from(Q.classList).filter((oe) => !oe.startsWith("is-scrolling-"));
    Z.push(t.scrollX.value ? Y : "is-scrolling-none"), Q.className = Z.join(" ");
  }, m = (Q) => {
    const { tableWrapper: Y } = r.refs;
    y(Y, Q);
  }, b = function() {
    if (!r.refs.scrollWrapper)
      return;
    const Q = r.refs.scrollWrapper.wrap$;
    if (!Q)
      return;
    const { scrollLeft: Y, offsetWidth: Z, scrollWidth: oe } = Q, { headerWrapper: he, footerWrapper: Ae } = r.refs;
    he && (he.scrollLeft = Y), Ae && (Ae.scrollLeft = Y);
    const We = oe - Z - 1;
    Y >= We ? m("is-scrolling-right") : m(Y === 0 ? "is-scrolling-left" : "is-scrolling-middle");
  }, x = () => {
    var Q;
    !r.refs.scrollWrapper || ((Q = r.refs.scrollWrapper.wrap$) == null || Q.addEventListener("scroll", b, {
      passive: !0
    }), e.fit ? Xl(r.vnode.el, S) : _n(window, "resize", p));
  };
  Ti(() => {
    D();
  });
  const D = () => {
    var Q;
    (Q = r.refs.scrollWrapper.wrap$) == null || Q.removeEventListener("scroll", b, !0), e.fit ? Rl(r.vnode.el, S) : si(window, "resize", p);
  }, S = () => {
    if (!r.$ready)
      return;
    let Q = !1;
    const Y = r.vnode.el, { width: Z, height: oe } = l.value, he = Y.offsetWidth;
    Z !== he && (Q = !0);
    const Ae = Y.offsetHeight;
    (e.height || d.value) && oe !== Ae && (Q = !0), Q && (l.value = {
      width: he,
      height: Ae
    }, p());
  }, C = Bi(), v = J(() => {
    const { bodyWidth: Q, scrollY: Y, gutterWidth: Z } = t;
    return Q.value ? `${Q.value - (Y.value ? Z : 0)}px` : "";
  }), H = J(() => e.maxHeight ? "fixed" : e.tableLayout);
  function V(Q, Y, Z) {
    const oe = Z8(Q), he = e.showHeader ? Z : 0;
    if (oe !== null)
      return Ai(oe) ? `calc(${oe} - ${Y}px - ${he}px)` : oe - Y - he;
  }
  const R = J(() => {
    const Q = t.headerHeight.value || 0, Y = t.bodyHeight.value, Z = t.footerHeight.value || 0;
    if (e.height)
      return Y || void 0;
    if (e.maxHeight)
      return V(e.maxHeight, Z, Q);
  }), F = J(() => {
    const Q = t.headerHeight.value || 0, Y = t.bodyHeight.value, Z = t.footerHeight.value || 0;
    if (e.height)
      return {
        height: Y ? `${Y}px` : ""
      };
    if (e.maxHeight) {
      const oe = V(e.maxHeight, Z, Q);
      if (oe !== null)
        return {
          "max-height": `${oe}${jn(oe) ? "px" : ""}`
        };
    }
    return {};
  }), K = J(() => {
    if (e.data && e.data.length)
      return null;
    let Q = "100%";
    return t.appendHeight.value && (Q = `calc(100% - ${t.appendHeight.value}px)`), {
      width: v.value,
      height: Q
    };
  }), q = (Q, Y) => {
    const Z = r.refs.bodyWrapper;
    if (Math.abs(Y.spinY) > 0) {
      const oe = Z.scrollTop;
      Y.pixelY < 0 && oe !== 0 && Q.preventDefault(), Y.pixelY > 0 && Z.scrollHeight - Z.clientHeight > oe && Q.preventDefault(), Z.scrollTop += Math.ceil(Y.pixelY / 5);
    } else
      Z.scrollLeft += Math.ceil(Y.pixelX / 5);
  }, G = J(() => e.maxHeight ? e.showSummary ? {
    bottom: 0
  } : {
    bottom: t.scrollX.value && e.data.length ? `${t.gutterWidth}px` : ""
  } : e.showSummary ? {
    height: t.tableHeight.value ? `${t.tableHeight.value}px` : ""
  } : {
    height: t.viewportHeight.value ? `${t.viewportHeight.value}px` : ""
  }), te = J(() => {
    if (e.height)
      return {
        height: t.fixedBodyHeight.value ? `${t.fixedBodyHeight.value}px` : ""
      };
    if (e.maxHeight) {
      let Q = Z8(e.maxHeight);
      if (typeof Q == "number")
        return Q = t.scrollX.value ? Q - t.gutterWidth : Q, e.showHeader && (Q -= t.headerHeight.value), Q -= t.footerHeight.value, {
          "max-height": `${Q}px`
        };
    }
    return {};
  });
  return {
    isHidden: i,
    renderExpanded: a,
    setDragVisible: s,
    isGroup: u,
    handleMouseLeave: c,
    handleHeaderFooterMousewheel: f,
    tableSize: C,
    bodyHeight: F,
    height: R,
    emptyBlockStyle: K,
    handleFixedMousewheel: q,
    fixedHeight: G,
    fixedBodyHeight: te,
    resizeProxyVisible: o,
    bodyWidth: v,
    resizeState: l,
    doLayout: p,
    tableBodyStyles: h,
    tableLayout: H
  };
}
var l$ = {
  data: {
    type: Array,
    default: () => []
  },
  size: String,
  width: [String, Number],
  height: [String, Number],
  maxHeight: [String, Number],
  fit: {
    type: Boolean,
    default: !0
  },
  stripe: Boolean,
  border: Boolean,
  rowKey: [String, Function],
  showHeader: {
    type: Boolean,
    default: !0
  },
  showSummary: Boolean,
  sumText: String,
  summaryMethod: Function,
  rowClassName: [String, Function],
  rowStyle: [Object, Function],
  cellClassName: [String, Function],
  cellStyle: [Object, Function],
  headerRowClassName: [String, Function],
  headerRowStyle: [Object, Function],
  headerCellClassName: [String, Function],
  headerCellStyle: [Object, Function],
  highlightCurrentRow: Boolean,
  currentRowKey: [String, Number],
  emptyText: String,
  expandRowKeys: Array,
  defaultExpandAll: Boolean,
  defaultSort: Object,
  tooltipEffect: String,
  spanMethod: Function,
  selectOnIndeterminate: {
    type: Boolean,
    default: !0
  },
  indent: {
    type: Number,
    default: 16
  },
  treeProps: {
    type: Object,
    default: () => ({
      hasChildren: "hasChildren",
      children: "children"
    })
  },
  lazy: Boolean,
  load: Function,
  style: {
    type: Object,
    default: () => ({})
  },
  className: {
    type: String,
    default: ""
  },
  tableLayout: {
    type: String,
    default: "fixed"
  }
};
let u$ = 1;
const c$ = Ee({
  name: "ElTable",
  directives: {
    Mousewheel: NX
  },
  components: {
    TableHeader: ZJ,
    TableBody: n$,
    TableFooter: a$,
    ElScrollbar: ns,
    hColgroup: N3
  },
  props: l$,
  emits: [
    "select",
    "select-all",
    "selection-change",
    "cell-mouse-enter",
    "cell-mouse-leave",
    "cell-contextmenu",
    "cell-click",
    "cell-dblclick",
    "row-click",
    "row-contextmenu",
    "row-dblclick",
    "header-click",
    "header-contextmenu",
    "sort-change",
    "filter-change",
    "current-change",
    "header-dragend",
    "expand-change"
  ],
  setup(e) {
    const { t } = hi(), n = Ct("table"), r = sn();
    _t(mo, r);
    const i = NJ(r, e);
    r.store = i;
    const a = new FJ({
      store: r.store,
      table: r,
      fit: e.fit,
      showHeader: e.showHeader
    });
    r.layout = a;
    const o = J(() => (i.states.data.value || []).length === 0), {
      setCurrentRow: s,
      toggleRowSelection: l,
      clearSelection: u,
      clearFilter: c,
      toggleAllSelection: f,
      toggleRowExpansion: d,
      clearSort: h,
      sort: p
    } = o$(i), {
      isHidden: y,
      renderExpanded: m,
      setDragVisible: b,
      isGroup: x,
      handleMouseLeave: D,
      handleHeaderFooterMousewheel: S,
      tableSize: C,
      bodyHeight: v,
      height: H,
      emptyBlockStyle: V,
      handleFixedMousewheel: R,
      fixedHeight: F,
      fixedBodyHeight: K,
      resizeProxyVisible: q,
      bodyWidth: G,
      resizeState: te,
      doLayout: Q,
      tableBodyStyles: Y,
      tableLayout: Z
    } = s$(e, a, i, r), oe = qa(Q, 50), he = `el-table_${u$++}`;
    r.tableId = he, r.state = {
      isGroup: x,
      resizeState: te,
      doLayout: Q,
      debouncedUpdateLayout: oe
    };
    const Ae = J(() => e.sumText || t("el.table.sumText")), We = J(() => e.emptyText || t("el.table.emptyText"));
    return {
      ns: n,
      layout: a,
      store: i,
      handleHeaderFooterMousewheel: S,
      handleMouseLeave: D,
      tableId: he,
      tableSize: C,
      isHidden: y,
      isEmpty: o,
      renderExpanded: m,
      resizeProxyVisible: q,
      resizeState: te,
      isGroup: x,
      bodyWidth: G,
      bodyHeight: v,
      height: H,
      tableBodyStyles: Y,
      emptyBlockStyle: V,
      debouncedUpdateLayout: oe,
      handleFixedMousewheel: R,
      fixedHeight: F,
      fixedBodyHeight: K,
      setCurrentRow: s,
      toggleRowSelection: l,
      clearSelection: u,
      clearFilter: c,
      toggleAllSelection: f,
      toggleRowExpansion: d,
      clearSort: h,
      doLayout: Q,
      sort: p,
      t,
      setDragVisible: b,
      context: r,
      computedSumText: Ae,
      computedEmptyText: We,
      tableLayout: Z
    };
  }
}), d$ = ["data-prefix"], f$ = {
  ref: "hiddenColumns",
  class: "hidden-columns"
};
function h$(e, t, n, r, i, a) {
  const o = Ie("hColgroup"), s = Ie("table-header"), l = Ie("table-body"), u = Ie("el-scrollbar"), c = Ie("table-footer"), f = va("mousewheel");
  return P(), L("div", {
    ref: "tableWrapper",
    class: se([
      {
        [e.ns.m("fit")]: e.fit,
        [e.ns.m("striped")]: e.stripe,
        [e.ns.m("border")]: e.border || e.isGroup,
        [e.ns.m("hidden")]: e.isHidden,
        [e.ns.m("group")]: e.isGroup,
        [e.ns.m("fluid-height")]: e.maxHeight,
        [e.ns.m("scrollable-x")]: e.layout.scrollX.value,
        [e.ns.m("scrollable-y")]: e.layout.scrollY.value,
        [e.ns.m("enable-row-hover")]: !e.store.states.isComplex.value,
        [e.ns.m("enable-row-transition")]: (e.store.states.data.value || []).length !== 0 && (e.store.states.data.value || []).length < 100,
        "has-footer": e.showSummary
      },
      e.ns.m(e.tableSize),
      e.className,
      e.ns.b(),
      e.ns.m(`layout-${e.tableLayout}`)
    ]),
    style: Pt(e.style),
    "data-prefix": e.ns.namespace.value,
    onMouseleave: t[0] || (t[0] = (d) => e.handleMouseLeave())
  }, [
    T("div", {
      class: se(e.ns.e("inner-wrapper"))
    }, [
      T("div", f$, [
        tt(e.$slots, "default")
      ], 512),
      e.showHeader && e.tableLayout === "fixed" ? Bt((P(), L("div", {
        key: 0,
        ref: "headerWrapper",
        class: se(e.ns.e("header-wrapper"))
      }, [
        T("table", {
          ref: "tableHeader",
          class: se(e.ns.e("header")),
          style: Pt(e.tableBodyStyles),
          border: "0",
          cellpadding: "0",
          cellspacing: "0"
        }, [
          B(o, {
            columns: e.store.states.columns.value,
            "table-layout": e.tableLayout
          }, null, 8, ["columns", "table-layout"]),
          B(s, {
            border: e.border,
            "default-sort": e.defaultSort,
            store: e.store,
            onSetDragVisible: e.setDragVisible
          }, null, 8, ["border", "default-sort", "store", "onSetDragVisible"])
        ], 6)
      ], 2)), [
        [f, e.handleHeaderFooterMousewheel]
      ]) : re("v-if", !0),
      T("div", {
        ref: "bodyWrapper",
        style: Pt(e.bodyHeight),
        class: se(e.ns.e("body-wrapper"))
      }, [
        B(u, {
          ref: "scrollWrapper",
          height: e.maxHeight ? void 0 : e.height,
          "max-height": e.maxHeight ? e.height : void 0
        }, {
          default: N(() => [
            T("table", {
              ref: "tableBody",
              class: se(e.ns.e("body")),
              cellspacing: "0",
              cellpadding: "0",
              border: "0",
              style: Pt({
                width: e.bodyWidth,
                tableLayout: e.tableLayout
              })
            }, [
              B(o, {
                columns: e.store.states.columns.value,
                "table-layout": e.tableLayout
              }, null, 8, ["columns", "table-layout"]),
              e.showHeader && e.tableLayout === "auto" ? (P(), ue(s, {
                key: 0,
                border: e.border,
                "default-sort": e.defaultSort,
                store: e.store,
                onSetDragVisible: e.setDragVisible
              }, null, 8, ["border", "default-sort", "store", "onSetDragVisible"])) : re("v-if", !0),
              B(l, {
                context: e.context,
                highlight: e.highlightCurrentRow,
                "row-class-name": e.rowClassName,
                "tooltip-effect": e.tooltipEffect,
                "row-style": e.rowStyle,
                store: e.store,
                stripe: e.stripe
              }, null, 8, ["context", "highlight", "row-class-name", "tooltip-effect", "row-style", "store", "stripe"])
            ], 6),
            e.isEmpty ? (P(), L("div", {
              key: 0,
              ref: "emptyBlock",
              style: Pt(e.emptyBlockStyle),
              class: se(e.ns.e("empty-block"))
            }, [
              T("span", {
                class: se(e.ns.e("empty-text"))
              }, [
                tt(e.$slots, "empty", {}, () => [
                  je(de(e.computedEmptyText), 1)
                ])
              ], 2)
            ], 6)) : re("v-if", !0),
            e.$slots.append ? (P(), L("div", {
              key: 1,
              ref: "appendWrapper",
              class: se(e.ns.e("append-wrapper"))
            }, [
              tt(e.$slots, "append")
            ], 2)) : re("v-if", !0)
          ]),
          _: 3
        }, 8, ["height", "max-height"])
      ], 6),
      e.border || e.isGroup ? (P(), L("div", {
        key: 1,
        class: se(e.ns.e("border-left-patch"))
      }, null, 2)) : re("v-if", !0)
    ], 2),
    e.showSummary ? Bt((P(), L("div", {
      key: 0,
      ref: "footerWrapper",
      class: se(e.ns.e("footer-wrapper"))
    }, [
      B(c, {
        border: e.border,
        "default-sort": e.defaultSort,
        store: e.store,
        style: Pt(e.tableBodyStyles),
        "sum-text": e.computedSumText,
        "summary-method": e.summaryMethod
      }, null, 8, ["border", "default-sort", "store", "style", "sum-text", "summary-method"])
    ], 2)), [
      [Cn, !e.isEmpty],
      [f, e.handleHeaderFooterMousewheel]
    ]) : re("v-if", !0),
    Bt(T("div", {
      ref: "resizeProxy",
      class: se(e.ns.e("column-resize-proxy"))
    }, null, 2), [
      [Cn, e.resizeProxyVisible]
    ])
  ], 46, d$);
}
var p$ = /* @__PURE__ */ vt(c$, [["render", h$]]);
const v$ = {
  selection: "table-column--selection",
  expand: "table__expand-column"
}, m$ = {
  default: {
    order: ""
  },
  selection: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ""
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ""
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ""
  }
}, g$ = (e) => v$[e] || "", y$ = {
  selection: {
    renderHeader({ store: e }) {
      function t() {
        return e.states.data.value && e.states.data.value.length === 0;
      }
      return et(Bs, {
        disabled: t(),
        size: e.states.tableSize.value,
        indeterminate: e.states.selection.value.length > 0 && !e.states.isAllSelected.value,
        "onUpdate:modelValue": e.toggleAllSelection,
        modelValue: e.states.isAllSelected.value
      });
    },
    renderCell({
      row: e,
      column: t,
      store: n,
      $index: r
    }) {
      return et(Bs, {
        disabled: t.selectable ? !t.selectable.call(null, e, r) : !1,
        size: n.states.tableSize.value,
        onChange: () => {
          n.commit("rowSelectedChanged", e);
        },
        onClick: (i) => i.stopPropagation(),
        modelValue: n.isSelected(e)
      });
    },
    sortable: !1,
    resizable: !1
  },
  index: {
    renderHeader({ column: e }) {
      return e.label || "#";
    },
    renderCell({
      column: e,
      $index: t
    }) {
      let n = t + 1;
      const r = e.index;
      return typeof r == "number" ? n = t + r : typeof r == "function" && (n = r(t)), et("div", {}, [n]);
    },
    sortable: !1
  },
  expand: {
    renderHeader({ column: e }) {
      return e.label || "";
    },
    renderCell({ row: e, store: t }) {
      const { ns: n } = t, r = [n.e("expand-icon")];
      return t.states.expandRows.value.indexOf(e) > -1 && r.push(n.em("expand-icon", "expanded")), et("div", {
        class: r,
        onClick: function(a) {
          a.stopPropagation(), t.toggleRowExpansion(e);
        }
      }, {
        default: () => [
          et(qt, null, {
            default: () => [et(es)]
          })
        ]
      });
    },
    sortable: !1,
    resizable: !1
  }
};
function b$({
  row: e,
  column: t,
  $index: n
}) {
  var r;
  const i = t.property, a = i && W1(e, i, !1).v;
  return t && t.formatter ? t.formatter(e, t, a, n) : ((r = a == null ? void 0 : a.toString) == null ? void 0 : r.call(a)) || "";
}
function A$({
  row: e,
  treeNode: t,
  store: n
}) {
  if (!t)
    return null;
  const r = [], i = function(o) {
    o.stopPropagation(), n.loadOrToggle(e);
  }, { ns: a } = n;
  if (t.indent && r.push(et("span", {
    class: a.e("indent"),
    style: { "padding-left": `${t.indent}px` }
  })), typeof t.expanded == "boolean" && !t.noLazyChildren) {
    const o = [
      a.e("expand-icon"),
      t.expanded ? a.em("expand-icon", "expanded") : ""
    ];
    let s = es;
    t.loading && (s = Vl), r.push(et("div", {
      class: o,
      onClick: i
    }, {
      default: () => [
        et(qt, { class: { [a.is("loading")]: t.loading } }, {
          default: () => [et(s)]
        })
      ]
    }));
  } else
    r.push(et("span", {
      class: a.e("placeholder")
    }));
  return r;
}
function T$(e, t) {
  const n = sn();
  return {
    registerComplexWatchers: () => {
      const a = ["fixed"], o = {
        realWidth: "width",
        realMinWidth: "minWidth"
      }, s = a.reduce((l, u) => (l[u] = u, l), o);
      Object.keys(s).forEach((l) => {
        const u = o[l];
        Lr(t, u) && Ne(() => t[u], (c) => {
          let f = c;
          u === "width" && l === "realWidth" && (f = I3(c)), u === "minWidth" && l === "realMinWidth" && (f = AT(c)), n.columnConfig.value[u] = f, n.columnConfig.value[l] = f;
          const d = u === "fixed";
          e.value.store.scheduleLayout(d);
        });
      });
    },
    registerNormalWatchers: () => {
      const a = [
        "label",
        "filters",
        "filterMultiple",
        "sortable",
        "index",
        "formatter",
        "className",
        "labelClassName",
        "showOverflowTooltip"
      ], o = {
        property: "prop",
        align: "realAlign",
        headerAlign: "realHeaderAlign"
      }, s = a.reduce((l, u) => (l[u] = u, l), o);
      Object.keys(s).forEach((l) => {
        const u = o[l];
        Lr(t, u) && Ne(() => t[u], (c) => {
          n.columnConfig.value[l] = c;
        });
      });
    }
  };
}
function w$(e, t, n) {
  const r = sn(), i = j(""), a = j(!1), o = j(), s = j(), l = Ct("table");
  Bo(() => {
    o.value = e.align ? `is-${e.align}` : null, o.value;
  }), Bo(() => {
    s.value = e.headerAlign ? `is-${e.headerAlign}` : o.value, s.value;
  });
  const u = J(() => {
    let x = r.vnode.vParent || r.parent;
    for (; x && !x.tableId && !x.columnId; )
      x = x.vnode.vParent || x.parent;
    return x;
  }), c = j(I3(e.width)), f = j(AT(e.minWidth)), d = (x) => (c.value && (x.width = c.value), f.value && (x.minWidth = f.value), x.minWidth || (x.minWidth = 80), x.realWidth = Number(x.width === void 0 ? x.minWidth : x.width), x), h = (x) => {
    const D = x.type, S = y$[D] || {};
    Object.keys(S).forEach((v) => {
      const H = S[v];
      v !== "className" && H !== void 0 && (x[v] = H);
    });
    const C = g$(D);
    if (C) {
      const v = `${E(l.namespace)}-${C}`;
      x.className = x.className ? `${x.className} ${v}` : v;
    }
    return x;
  }, p = (x) => {
    x instanceof Array ? x.forEach((S) => D(S)) : D(x);
    function D(S) {
      var C;
      ((C = S == null ? void 0 : S.type) == null ? void 0 : C.name) === "ElTableColumn" && (S.vParent = r);
    }
  };
  return {
    columnId: i,
    realAlign: o,
    isSubColumn: a,
    realHeaderAlign: s,
    columnOrTableParent: u,
    setColumnWidth: d,
    setColumnForcedProps: h,
    setColumnRenders: (x) => {
      e.renderHeader ? fi("TableColumn", "Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.") : x.type !== "selection" && (x.renderHeader = (S) => {
        r.columnConfig.value.label;
        const C = t.header;
        return C ? C(S) : x.label;
      });
      let D = x.renderCell;
      return x.type === "expand" ? (x.renderCell = (S) => et("div", {
        class: "cell"
      }, [D(S)]), n.value.renderExpanded = (S) => t.default ? t.default(S) : t.default) : (D = D || b$, x.renderCell = (S) => {
        let C = null;
        t.default ? C = t.default(S) : C = D(S);
        const v = A$(S), H = {
          class: "cell",
          style: {}
        };
        return x.showOverflowTooltip && (H.class = `${H.class} ${E(l.namespace)}-tooltip`, H.style = {
          width: `${(S.column.realWidth || Number(S.column.width)) - 1}px`
        }), p(C), et("div", H, [v, C]);
      }), x;
    },
    getPropsData: (...x) => x.reduce((D, S) => (Array.isArray(S) && S.forEach((C) => {
      D[C] = e[C];
    }), D), {}),
    getColumnElIndex: (x, D) => [].indexOf.call(x, D)
  };
}
var P$ = {
  type: {
    type: String,
    default: "default"
  },
  label: String,
  className: String,
  labelClassName: String,
  property: String,
  prop: String,
  width: {
    type: [String, Number],
    default: ""
  },
  minWidth: {
    type: [String, Number],
    default: ""
  },
  renderHeader: Function,
  sortable: {
    type: [Boolean, String],
    default: !1
  },
  sortMethod: Function,
  sortBy: [String, Function, Array],
  resizable: {
    type: Boolean,
    default: !0
  },
  columnKey: String,
  align: String,
  headerAlign: String,
  showTooltipWhenOverflow: Boolean,
  showOverflowTooltip: Boolean,
  fixed: [Boolean, String],
  formatter: Function,
  selectable: Function,
  reserveSelection: Boolean,
  filterMethod: Function,
  filteredValue: Array,
  filters: Array,
  filterPlacement: String,
  filterMultiple: {
    type: Boolean,
    default: !0
  },
  index: [Number, Function],
  sortOrders: {
    type: Array,
    default: () => ["ascending", "descending", null],
    validator: (e) => e.every((t) => ["ascending", "descending", null].indexOf(t) > -1)
  }
};
let x$ = 1;
var ET = Ee({
  name: "ElTableColumn",
  components: {
    ElCheckbox: Bs
  },
  props: P$,
  setup(e, { slots: t }) {
    const n = sn(), r = j({}), i = J(() => {
      let x = n.parent;
      for (; x && !x.tableId; )
        x = x.parent;
      return x;
    }), { registerNormalWatchers: a, registerComplexWatchers: o } = T$(i, e), {
      columnId: s,
      isSubColumn: l,
      realHeaderAlign: u,
      columnOrTableParent: c,
      setColumnWidth: f,
      setColumnForcedProps: d,
      setColumnRenders: h,
      getPropsData: p,
      getColumnElIndex: y,
      realAlign: m
    } = w$(e, t, i), b = c.value;
    s.value = `${b.tableId || b.columnId}_column_${x$++}`, Ph(() => {
      l.value = i.value !== b;
      const x = e.type || "default", D = e.sortable === "" ? !0 : e.sortable, S = {
        ...m$[x],
        id: s.value,
        type: x,
        property: e.prop || e.property,
        align: m,
        headerAlign: u,
        showOverflowTooltip: e.showOverflowTooltip || e.showTooltipWhenOverflow,
        filterable: e.filters || e.filterMethod,
        filteredValue: [],
        filterPlacement: "",
        isColumnGroup: !1,
        isSubColumn: !1,
        filterOpened: !1,
        sortable: D,
        index: e.index,
        rawColumnKey: n.vnode.key
      };
      let R = p([
        "columnKey",
        "label",
        "className",
        "labelClassName",
        "type",
        "renderHeader",
        "formatter",
        "fixed",
        "resizable"
      ], ["sortMethod", "sortBy", "sortOrders"], ["selectable", "reserveSelection"], [
        "filterMethod",
        "filters",
        "filterMultiple",
        "filterOpened",
        "filteredValue",
        "filterPlacement"
      ]);
      R = EJ(S, R), R = kJ(h, f, d)(R), r.value = R, a(), o();
    }), rn(() => {
      var x;
      const D = c.value, S = l.value ? D.vnode.el.children : (x = D.refs.hiddenColumns) == null ? void 0 : x.children, C = () => y(S || [], n.vnode.el);
      r.value.getColumnIndex = C, C() > -1 && i.value.store.commit("insertColumn", r.value, l.value ? D.columnConfig.value : null);
    }), Ti(() => {
      i.value.store.commit("removeColumn", r.value, l.value ? b.columnConfig.value : null);
    }), n.columnId = s.value, n.columnConfig = r;
  },
  render() {
    var e, t, n;
    let r = [];
    try {
      const i = (t = (e = this.$slots).default) == null ? void 0 : t.call(e, {
        row: {},
        column: {},
        $index: -1
      });
      if (i instanceof Array)
        for (const a of i)
          ((n = a.type) == null ? void 0 : n.name) === "ElTableColumn" || a.shapeFlag & 2 ? r.push(a) : a.type === nt && a.children instanceof Array && r.push(...a.children);
    } catch {
      r = [];
    }
    return et("div", r);
  }
});
const Wh = Un(p$, {
  TableColumn: ET
}), Kh = Wi(ET), C$ = Gt({
  tabs: {
    type: jt(Array),
    default: () => da([])
  }
}), D7 = "ElTabBar", S$ = Ee({
  name: D7,
  props: C$,
  setup(e) {
    const t = sn(), n = ce(jh);
    n || ir(D7, "must use with ElTabs");
    const r = j(), i = j(), a = () => {
      let s = 0, l = 0;
      const u = ["top", "bottom"].includes(n.props.tabPosition) ? "width" : "height", c = u === "width" ? "x" : "y";
      return e.tabs.every((f) => {
        var d, h, p, y;
        const m = (h = (d = t.parent) == null ? void 0 : d.refs) == null ? void 0 : h[`tab-${f.paneName}`];
        if (!m)
          return !1;
        if (!f.active)
          return !0;
        l = m[`client${Ho(u)}`];
        const b = c === "x" ? "left" : "top";
        s = m.getBoundingClientRect()[b] - ((y = (p = m.parentElement) == null ? void 0 : p.getBoundingClientRect()[b]) != null ? y : 0);
        const x = window.getComputedStyle(m);
        return u === "width" && (e.tabs.length > 1 && (l -= parseFloat(x.paddingLeft) + parseFloat(x.paddingRight)), s += parseFloat(x.paddingLeft)), !1;
      }), {
        [u]: `${l}px`,
        transform: `translate${Ho(c)}(${s}px)`
      };
    }, o = () => i.value = a();
    return Ne(() => e.tabs, async () => {
      await bt(), o();
    }, { immediate: !0 }), u3(r, () => o()), {
      bar$: r,
      rootTabs: n,
      barStyle: i,
      update: o
    };
  }
});
function E$(e, t, n, r, i, a) {
  return P(), L("div", {
    ref: "bar$",
    class: se(["el-tabs__active-bar", `is-${e.rootTabs.props.tabPosition}`]),
    style: Pt(e.barStyle)
  }, null, 6);
}
var k$ = /* @__PURE__ */ vt(S$, [["render", E$]]);
const O$ = Gt({
  panes: {
    type: jt(Array),
    default: () => da([])
  },
  currentName: {
    type: [String, Number],
    default: ""
  },
  editable: Boolean,
  onTabClick: {
    type: jt(Function),
    default: Vn
  },
  onTabRemove: {
    type: jt(Function),
    default: Vn
  },
  type: {
    type: String,
    values: ["card", "border-card", ""],
    default: ""
  },
  stretch: Boolean
}), M7 = "ElTabNav";
var z$ = Ee({
  name: M7,
  props: O$,
  setup(e, { expose: t }) {
    const n = YB(), r = rN(), i = ce(jh);
    i || ir(M7, "ElTabNav must be nested inside ElTabs");
    const a = j(!1), o = j(0), s = j(!1), l = j(!0), u = j(), c = j(), f = j(), d = J(() => ["top", "bottom"].includes(i.props.tabPosition) ? "width" : "height"), h = J(() => ({
      transform: `translate${d.value === "width" ? "X" : "Y"}(-${o.value}px)`
    })), p = () => {
      if (!u.value)
        return;
      const C = u.value[`offset${Ho(d.value)}`], v = o.value;
      if (!v)
        return;
      const H = v > C ? v - C : 0;
      o.value = H;
    }, y = () => {
      if (!u.value || !c.value)
        return;
      const C = c.value[`offset${Ho(d.value)}`], v = u.value[`offset${Ho(d.value)}`], H = o.value;
      if (C - H <= v)
        return;
      const V = C - H > v * 2 ? H + v : C - v;
      o.value = V;
    }, m = () => {
      const C = c.value;
      if (!a.value || !f.value || !u.value || !C)
        return;
      const v = f.value.querySelector(".is-active");
      if (!v)
        return;
      const H = u.value, V = ["top", "bottom"].includes(i.props.tabPosition), R = v.getBoundingClientRect(), F = H.getBoundingClientRect(), K = V ? C.offsetWidth - F.width : C.offsetHeight - F.height, q = o.value;
      let G = q;
      V ? (R.left < F.left && (G = q - (F.left - R.left)), R.right > F.right && (G = q + R.right - F.right)) : (R.top < F.top && (G = q - (F.top - R.top)), R.bottom > F.bottom && (G = q + (R.bottom - F.bottom))), G = Math.max(G, 0), o.value = Math.min(G, K);
    }, b = () => {
      if (!c.value || !u.value)
        return;
      const C = c.value[`offset${Ho(d.value)}`], v = u.value[`offset${Ho(d.value)}`], H = o.value;
      if (v < C) {
        const V = o.value;
        a.value = a.value || {}, a.value.prev = V, a.value.next = V + v < C, C - V < v && (o.value = C - v);
      } else
        a.value = !1, H > 0 && (o.value = 0);
    }, x = (C) => {
      const v = C.code, { up: H, down: V, left: R, right: F } = yt;
      if (![H, V, R, F].includes(v))
        return;
      const K = Array.from(C.currentTarget.querySelectorAll("[role=tab]")), q = K.indexOf(C.target);
      let G;
      v === R || v === H ? q === 0 ? G = K.length - 1 : G = q - 1 : q < K.length - 1 ? G = q + 1 : G = 0, K[G].focus(), K[G].click(), D();
    }, D = () => {
      l.value && (s.value = !0);
    }, S = () => s.value = !1;
    return Ne(n, (C) => {
      C === "hidden" ? l.value = !1 : C === "visible" && setTimeout(() => l.value = !0, 50);
    }), Ne(r, (C) => {
      C ? setTimeout(() => l.value = !0, 50) : l.value = !1;
    }), u3(f, b), rn(() => setTimeout(() => m(), 0)), Zo(() => b()), t({
      scrollToActiveTab: m,
      removeFocus: S
    }), () => {
      const C = a.value ? [
        et("span", {
          class: [
            "el-tabs__nav-prev",
            a.value.prev ? "" : "is-disabled"
          ],
          onClick: p
        }, [et(qt, {}, { default: () => et(Ih) })]),
        et("span", {
          class: [
            "el-tabs__nav-next",
            a.value.next ? "" : "is-disabled"
          ],
          onClick: y
        }, [et(qt, {}, { default: () => et(es) })])
      ] : null, v = e.panes.map((H, V) => {
        var R, F;
        const K = H.props.name || H.index || `${V}`, q = H.isClosable || e.editable;
        H.index = `${V}`;
        const G = q ? et(qt, {
          class: "is-icon-close",
          onClick: (Y) => e.onTabRemove(H, Y)
        }, { default: () => et(Is) }) : null, te = ((F = (R = H.instance.slots).label) == null ? void 0 : F.call(R)) || H.props.label, Q = H.active ? 0 : -1;
        return et("div", {
          class: {
            "el-tabs__item": !0,
            [`is-${i.props.tabPosition}`]: !0,
            "is-active": H.active,
            "is-disabled": H.props.disabled,
            "is-closable": q,
            "is-focus": s
          },
          id: `tab-${K}`,
          key: `tab-${K}`,
          "aria-controls": `pane-${K}`,
          role: "tab",
          "aria-selected": H.active,
          ref: `tab-${K}`,
          tabindex: Q,
          onFocus: () => D(),
          onBlur: () => S(),
          onClick: (Y) => {
            S(), e.onTabClick(H, K, Y);
          },
          onKeydown: (Y) => {
            q && (Y.code === yt.delete || Y.code === yt.backspace) && e.onTabRemove(H, Y);
          }
        }, [te, G]);
      });
      return et("div", {
        ref: f,
        class: [
          "el-tabs__nav-wrap",
          a.value ? "is-scrollable" : "",
          `is-${i.props.tabPosition}`
        ]
      }, [
        C,
        et("div", {
          class: "el-tabs__nav-scroll",
          ref: u
        }, [
          et("div", {
            class: [
              "el-tabs__nav",
              `is-${i.props.tabPosition}`,
              e.stretch && ["top", "bottom"].includes(i.props.tabPosition) ? "is-stretch" : ""
            ],
            ref: c,
            style: h.value,
            role: "tablist",
            onKeydown: x
          }, [
            e.type ? null : et(k$, {
              tabs: [...e.panes]
            }),
            v
          ])
        ])
      ]);
    };
  }
});
const D$ = Gt({
  type: {
    type: String,
    values: ["card", "border-card", ""],
    default: ""
  },
  activeName: {
    type: String,
    default: ""
  },
  closable: Boolean,
  addable: Boolean,
  modelValue: {
    type: [String, Number],
    default: ""
  },
  editable: Boolean,
  tabPosition: {
    type: String,
    values: ["top", "right", "bottom", "left"],
    default: "top"
  },
  beforeLeave: {
    type: jt(Function),
    default: () => !0
  },
  stretch: Boolean
}), M$ = {
  [vn]: (e) => typeof e == "string" || typeof e == "number",
  [Ls]: (e) => typeof e == "string" || typeof e == "number",
  "tab-click": (e, t) => t instanceof Event,
  edit: (e, t) => t === "remove" || t === "add",
  "tab-remove": (e) => typeof e == "string" || typeof e == "number",
  "tab-add": () => !0
}, kT = (e, t = []) => {
  const n = e.children || [];
  return Array.from(n).forEach((r) => {
    let i = r.type;
    i = i.name || i, i === "ElTabPane" && r.component ? t.push(r.component) : (i === nt || i === "template") && kT(r, t);
  }), t;
};
var H$ = Ee({
  name: "ElTabs",
  props: D$,
  emits: M$,
  setup(e, { emit: t, slots: n, expose: r }) {
    const i = sn(), a = j(), o = j([]), s = j(e.modelValue || e.activeName || "0"), l = {}, u = (y = !1) => {
      if (n.default) {
        const m = i.subTree.children, b = Array.from(m).find(({ props: S }) => (S == null ? void 0 : S.class) === "el-tabs__content");
        if (!b)
          return;
        const x = kT(b).map((S) => l[S.uid]), D = !(x.length === o.value.length && x.every((S, C) => S.uid === o.value[C].uid));
        (y || D) && (o.value = x);
      } else
        o.value.length !== 0 && (o.value = []);
    }, c = (y) => {
      s.value = y, t(Ls, y), t(vn, y);
    }, f = (y) => {
      var m;
      if (s.value === y)
        return;
      const b = (m = e.beforeLeave) == null ? void 0 : m.call(e, y, s.value);
      H0(b) ? b.then(() => {
        var x, D;
        c(y), (D = (x = a.value) == null ? void 0 : x.removeFocus) == null || D.call(x);
      }, Vn) : b !== !1 && c(y);
    }, d = (y, m, b) => {
      y.props.disabled || (f(m), t("tab-click", y, b));
    }, h = (y, m) => {
      y.props.disabled || (m.stopPropagation(), t("edit", y.props.name, "remove"), t("tab-remove", y.props.name));
    }, p = () => {
      t("edit", null, "add"), t("tab-add");
    };
    return Zo(() => u()), rn(() => u()), Ne(() => e.activeName, (y) => f(y)), Ne(() => e.modelValue, (y) => f(y)), Ne(s, async () => {
      var y, m;
      u(!0), await bt(), await ((y = a.value) == null ? void 0 : y.$nextTick()), (m = a.value) == null || m.scrollToActiveTab();
    }), _t(jh, {
      props: e,
      currentName: s,
      updatePaneState: (y) => l[y.uid] = y
    }), r({
      currentName: s
    }), () => {
      const y = e.editable || e.addable ? et("span", {
        class: "el-tabs__new-tab",
        tabindex: "0",
        onClick: p,
        onKeydown: (x) => {
          x.code === yt.enter && p();
        }
      }, [et(qt, { class: "is-icon-plus" }, { default: () => et(ub) })]) : null, m = et("div", { class: ["el-tabs__header", `is-${e.tabPosition}`] }, [
        y,
        et(z$, {
          currentName: s.value,
          editable: e.editable,
          type: e.type,
          panes: o.value,
          stretch: e.stretch,
          ref: a,
          onTabClick: d,
          onTabRemove: h
        })
      ]), b = et("div", { class: "el-tabs__content" }, [
        tt(n, "default")
      ]);
      return et("div", {
        class: {
          "el-tabs": !0,
          "el-tabs--card": e.type === "card",
          [`el-tabs--${e.tabPosition}`]: !0,
          "el-tabs--border-card": e.type === "border-card"
        }
      }, e.tabPosition !== "bottom" ? [m, b] : [b, m]);
    };
  }
});
const I$ = Gt({
  label: {
    type: String,
    default: ""
  },
  name: {
    type: [String, Number],
    default: ""
  },
  closable: Boolean,
  disabled: Boolean,
  lazy: Boolean
}), H7 = "ElTabPane", L$ = Ee({
  name: H7,
  props: I$,
  setup(e) {
    const t = sn(), n = ce(jh);
    n || ir(H7, "must use with ElTabs");
    const r = j(), i = j(!1), a = J(() => e.closable || n.props.closable), o = f5(() => n.currentName.value === (e.name || r.value)), s = J(() => e.name || r.value), l = f5(() => !e.lazy || i.value || o.value);
    return Ne(o, (u) => {
      u && (i.value = !0);
    }), n.updatePaneState(zt({
      uid: t.uid,
      instance: og(t),
      props: e,
      paneName: s,
      active: o,
      index: r,
      isClosable: a
    })), {
      active: o,
      paneName: s,
      shouldBeRender: l
    };
  }
}), B$ = ["id", "aria-hidden", "aria-labelledby"];
function N$(e, t, n, r, i, a) {
  return e.shouldBeRender ? Bt((P(), L("div", {
    key: 0,
    id: `pane-${e.paneName}`,
    class: "el-tab-pane",
    role: "tabpanel",
    "aria-hidden": !e.active,
    "aria-labelledby": `tab-${e.paneName}`
  }, [
    tt(e.$slots, "default")
  ], 8, B$)), [
    [Cn, e.active]
  ]) : re("v-if", !0);
}
var OT = /* @__PURE__ */ vt(L$, [["render", N$]]);
const j$ = Un(H$, {
  TabPane: OT
}), F$ = Wi(OT), X$ = Ee({
  name: "ElTimeline",
  setup(e, { slots: t }) {
    const n = Ct("timeline");
    return _t("timeline", t), () => et("ul", { class: [n.b()] }, [tt(t, "default")]);
  }
}), R$ = Gt({
  timestamp: {
    type: String,
    default: ""
  },
  hideTimestamp: {
    type: Boolean,
    default: !1
  },
  center: {
    type: Boolean,
    default: !1
  },
  placement: {
    type: String,
    default: "bottom"
  },
  type: {
    type: String,
    default: ""
  },
  color: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    default: "normal"
  },
  icon: {
    type: ya,
    default: ""
  },
  hollow: {
    type: Boolean,
    default: !1
  }
}), V$ = Ee({
  name: "ElTimelineItem",
  components: {
    ElIcon: qt
  },
  props: R$,
  setup() {
    return {
      ns: Ct("timeline-item")
    };
  }
});
function U$(e, t, n, r, i, a) {
  const o = Ie("el-icon");
  return P(), L("li", {
    class: se([e.ns.b(), { [e.ns.e("center")]: e.center }])
  }, [
    T("div", {
      class: se(e.ns.e("tail"))
    }, null, 2),
    e.$slots.dot ? re("v-if", !0) : (P(), L("div", {
      key: 0,
      class: se([
        e.ns.e("node"),
        e.ns.em("node", e.size || ""),
        e.ns.em("node", e.type || ""),
        e.ns.is("hollow", e.hollow)
      ]),
      style: Pt({
        backgroundColor: e.color
      })
    }, [
      e.icon ? (P(), ue(o, {
        key: 0,
        class: se(e.ns.e("icon"))
      }, {
        default: N(() => [
          (P(), ue(Ln(e.icon)))
        ]),
        _: 1
      }, 8, ["class"])) : re("v-if", !0)
    ], 6)),
    e.$slots.dot ? (P(), L("div", {
      key: 1,
      class: se(e.ns.e("dot"))
    }, [
      tt(e.$slots, "dot")
    ], 2)) : re("v-if", !0),
    T("div", {
      class: se(e.ns.e("wrapper"))
    }, [
      !e.hideTimestamp && e.placement === "top" ? (P(), L("div", {
        key: 0,
        class: se([e.ns.e("timestamp"), e.ns.is("top")])
      }, de(e.timestamp), 3)) : re("v-if", !0),
      T("div", {
        class: se(e.ns.e("content"))
      }, [
        tt(e.$slots, "default")
      ], 2),
      !e.hideTimestamp && e.placement === "bottom" ? (P(), L("div", {
        key: 1,
        class: se([e.ns.e("timestamp"), e.ns.is("bottom")])
      }, de(e.timestamp), 3)) : re("v-if", !0)
    ], 2)
  ], 2);
}
var zT = /* @__PURE__ */ vt(V$, [["render", U$]]);
const q$ = Un(X$, {
  TimelineItem: zT
}), _$ = Wi(zT), Mu = "$treeNodeId", I7 = function(e, t) {
  !t || t[Mu] || Object.defineProperty(t, Mu, {
    value: e.id,
    enumerable: !1,
    configurable: !1,
    writable: !1
  });
}, j3 = function(e, t) {
  return e ? t[e] : t[Mu];
}, $8 = (e) => {
  let t = !0, n = !0, r = !0;
  for (let i = 0, a = e.length; i < a; i++) {
    const o = e[i];
    (o.checked !== !0 || o.indeterminate) && (t = !1, o.disabled || (r = !1)), (o.checked !== !1 || o.indeterminate) && (n = !1);
  }
  return { all: t, none: n, allWithoutDisable: r, half: !t && !n };
}, u0 = function(e) {
  if (e.childNodes.length === 0)
    return;
  const { all: t, none: n, half: r } = $8(e.childNodes);
  t ? (e.checked = !0, e.indeterminate = !1) : r ? (e.checked = !1, e.indeterminate = !0) : n && (e.checked = !1, e.indeterminate = !1);
  const i = e.parent;
  !i || i.level === 0 || e.store.checkStrictly || u0(i);
}, g1 = function(e, t) {
  const n = e.store.props, r = e.data || {}, i = n[t];
  if (typeof i == "function")
    return i(r, e);
  if (typeof i == "string")
    return r[i];
  if (typeof i > "u") {
    const a = r[t];
    return a === void 0 ? "" : a;
  }
};
let W$ = 0;
class xl {
  constructor(t) {
    this.id = W$++, this.text = null, this.checked = !1, this.indeterminate = !1, this.data = null, this.expanded = !1, this.parent = null, this.visible = !0, this.isCurrent = !1, this.canFocus = !1;
    for (const n in t)
      Lr(t, n) && (this[n] = t[n]);
    this.level = 0, this.loaded = !1, this.childNodes = [], this.loading = !1, this.parent && (this.level = this.parent.level + 1);
  }
  initialize() {
    const t = this.store;
    if (!t)
      throw new Error("[Node]store is required!");
    t.registerNode(this);
    const n = t.props;
    if (n && typeof n.isLeaf < "u") {
      const a = g1(this, "isLeaf");
      typeof a == "boolean" && (this.isLeafByUser = a);
    }
    if (t.lazy !== !0 && this.data ? (this.setData(this.data), t.defaultExpandAll && (this.expanded = !0, this.canFocus = !0)) : this.level > 0 && t.lazy && t.defaultExpandAll && this.expand(), Array.isArray(this.data) || I7(this, this.data), !this.data)
      return;
    const r = t.defaultExpandedKeys, i = t.key;
    i && r && r.indexOf(this.key) !== -1 && this.expand(null, t.autoExpandParent), i && t.currentNodeKey !== void 0 && this.key === t.currentNodeKey && (t.currentNode = this, t.currentNode.isCurrent = !0), t.lazy && t._initDefaultCheckedNode(this), this.updateLeafState(), this.parent && (this.level === 1 || this.parent.expanded === !0) && (this.canFocus = !0);
  }
  setData(t) {
    Array.isArray(t) || I7(this, t), this.data = t, this.childNodes = [];
    let n;
    this.level === 0 && this.data instanceof Array ? n = this.data : n = g1(this, "children") || [];
    for (let r = 0, i = n.length; r < i; r++)
      this.insertChild({ data: n[r] });
  }
  get label() {
    return g1(this, "label");
  }
  get key() {
    const t = this.store.key;
    return this.data ? this.data[t] : null;
  }
  get disabled() {
    return g1(this, "disabled");
  }
  get nextSibling() {
    const t = this.parent;
    if (t) {
      const n = t.childNodes.indexOf(this);
      if (n > -1)
        return t.childNodes[n + 1];
    }
    return null;
  }
  get previousSibling() {
    const t = this.parent;
    if (t) {
      const n = t.childNodes.indexOf(this);
      if (n > -1)
        return n > 0 ? t.childNodes[n - 1] : null;
    }
    return null;
  }
  contains(t, n = !0) {
    return (this.childNodes || []).some((r) => r === t || n && r.contains(t));
  }
  remove() {
    const t = this.parent;
    t && t.removeChild(this);
  }
  insertChild(t, n, r) {
    if (!t)
      throw new Error("InsertChild error: child is required.");
    if (!(t instanceof xl)) {
      if (!r) {
        const i = this.getChildren(!0);
        i.indexOf(t.data) === -1 && (typeof n > "u" || n < 0 ? i.push(t.data) : i.splice(n, 0, t.data));
      }
      Object.assign(t, {
        parent: this,
        store: this.store
      }), t = zt(new xl(t)), t instanceof xl && t.initialize();
    }
    t.level = this.level + 1, typeof n > "u" || n < 0 ? this.childNodes.push(t) : this.childNodes.splice(n, 0, t), this.updateLeafState();
  }
  insertBefore(t, n) {
    let r;
    n && (r = this.childNodes.indexOf(n)), this.insertChild(t, r);
  }
  insertAfter(t, n) {
    let r;
    n && (r = this.childNodes.indexOf(n), r !== -1 && (r += 1)), this.insertChild(t, r);
  }
  removeChild(t) {
    const n = this.getChildren() || [], r = n.indexOf(t.data);
    r > -1 && n.splice(r, 1);
    const i = this.childNodes.indexOf(t);
    i > -1 && (this.store && this.store.deregisterNode(t), t.parent = null, this.childNodes.splice(i, 1)), this.updateLeafState();
  }
  removeChildByData(t) {
    let n = null;
    for (let r = 0; r < this.childNodes.length; r++)
      if (this.childNodes[r].data === t) {
        n = this.childNodes[r];
        break;
      }
    n && this.removeChild(n);
  }
  expand(t, n) {
    const r = () => {
      if (n) {
        let i = this.parent;
        for (; i.level > 0; )
          i.expanded = !0, i = i.parent;
      }
      this.expanded = !0, t && t(), this.childNodes.forEach((i) => {
        i.canFocus = !0;
      });
    };
    this.shouldLoadData() ? this.loadData((i) => {
      Array.isArray(i) && (this.checked ? this.setChecked(!0, !0) : this.store.checkStrictly || u0(this), r());
    }) : r();
  }
  doCreateChildren(t, n = {}) {
    t.forEach((r) => {
      this.insertChild(Object.assign({ data: r }, n), void 0, !0);
    });
  }
  collapse() {
    this.expanded = !1, this.childNodes.forEach((t) => {
      t.canFocus = !1;
    });
  }
  shouldLoadData() {
    return this.store.lazy === !0 && this.store.load && !this.loaded;
  }
  updateLeafState() {
    if (this.store.lazy === !0 && this.loaded !== !0 && typeof this.isLeafByUser < "u") {
      this.isLeaf = this.isLeafByUser;
      return;
    }
    const t = this.childNodes;
    if (!this.store.lazy || this.store.lazy === !0 && this.loaded === !0) {
      this.isLeaf = !t || t.length === 0;
      return;
    }
    this.isLeaf = !1;
  }
  setChecked(t, n, r, i) {
    if (this.indeterminate = t === "half", this.checked = t === !0, this.store.checkStrictly)
      return;
    if (!(this.shouldLoadData() && !this.store.checkDescendants)) {
      const { all: o, allWithoutDisable: s } = $8(this.childNodes);
      !this.isLeaf && !o && s && (this.checked = !1, t = !1);
      const l = () => {
        if (n) {
          const u = this.childNodes;
          for (let d = 0, h = u.length; d < h; d++) {
            const p = u[d];
            i = i || t !== !1;
            const y = p.disabled ? p.checked : i;
            p.setChecked(y, n, !0, i);
          }
          const { half: c, all: f } = $8(u);
          f || (this.checked = f, this.indeterminate = c);
        }
      };
      if (this.shouldLoadData()) {
        this.loadData(() => {
          l(), u0(this);
        }, {
          checked: t !== !1
        });
        return;
      } else
        l();
    }
    const a = this.parent;
    !a || a.level === 0 || r || u0(a);
  }
  getChildren(t = !1) {
    if (this.level === 0)
      return this.data;
    const n = this.data;
    if (!n)
      return null;
    const r = this.store.props;
    let i = "children";
    return r && (i = r.children || "children"), n[i] === void 0 && (n[i] = null), t && !n[i] && (n[i] = []), n[i];
  }
  updateChildren() {
    const t = this.getChildren() || [], n = this.childNodes.map((a) => a.data), r = {}, i = [];
    t.forEach((a, o) => {
      const s = a[Mu];
      !!s && n.findIndex((u) => u[Mu] === s) >= 0 ? r[s] = { index: o, data: a } : i.push({ index: o, data: a });
    }), this.store.lazy || n.forEach((a) => {
      r[a[Mu]] || this.removeChildByData(a);
    }), i.forEach(({ index: a, data: o }) => {
      this.insertChild({ data: o }, a);
    }), this.updateLeafState();
  }
  loadData(t, n = {}) {
    if (this.store.lazy === !0 && this.store.load && !this.loaded && (!this.loading || Object.keys(n).length)) {
      this.loading = !0;
      const r = (i) => {
        this.loaded = !0, this.loading = !1, this.childNodes = [], this.doCreateChildren(i, n), this.updateLeafState(), t && t.call(this, i);
      };
      this.store.load(this, r);
    } else
      t && t.call(this);
  }
}
class K$ {
  constructor(t) {
    this.currentNode = null, this.currentNodeKey = null;
    for (const n in t)
      Lr(t, n) && (this[n] = t[n]);
    this.nodesMap = {};
  }
  initialize() {
    if (this.root = new xl({
      data: this.data,
      store: this
    }), this.root.initialize(), this.lazy && this.load) {
      const t = this.load;
      t(this.root, (n) => {
        this.root.doCreateChildren(n), this._initDefaultCheckedNodes();
      });
    } else
      this._initDefaultCheckedNodes();
  }
  filter(t) {
    const n = this.filterNodeMethod, r = this.lazy, i = function(a) {
      const o = a.root ? a.root.childNodes : a.childNodes;
      if (o.forEach((s) => {
        s.visible = n.call(s, t, s.data, s), i(s);
      }), !a.visible && o.length) {
        let s = !0;
        s = !o.some((l) => l.visible), a.root ? a.root.visible = s === !1 : a.visible = s === !1;
      }
      !t || a.visible && !a.isLeaf && !r && a.expand();
    };
    i(this);
  }
  setData(t) {
    t !== this.root.data ? (this.root.setData(t), this._initDefaultCheckedNodes()) : this.root.updateChildren();
  }
  getNode(t) {
    if (t instanceof xl)
      return t;
    const n = typeof t != "object" ? t : j3(this.key, t);
    return this.nodesMap[n] || null;
  }
  insertBefore(t, n) {
    const r = this.getNode(n);
    r.parent.insertBefore({ data: t }, r);
  }
  insertAfter(t, n) {
    const r = this.getNode(n);
    r.parent.insertAfter({ data: t }, r);
  }
  remove(t) {
    const n = this.getNode(t);
    n && n.parent && (n === this.currentNode && (this.currentNode = null), n.parent.removeChild(n));
  }
  append(t, n) {
    const r = n ? this.getNode(n) : this.root;
    r && r.insertChild({ data: t });
  }
  _initDefaultCheckedNodes() {
    const t = this.defaultCheckedKeys || [], n = this.nodesMap;
    t.forEach((r) => {
      const i = n[r];
      i && i.setChecked(!0, !this.checkStrictly);
    });
  }
  _initDefaultCheckedNode(t) {
    (this.defaultCheckedKeys || []).indexOf(t.key) !== -1 && t.setChecked(!0, !this.checkStrictly);
  }
  setDefaultCheckedKey(t) {
    t !== this.defaultCheckedKeys && (this.defaultCheckedKeys = t, this._initDefaultCheckedNodes());
  }
  registerNode(t) {
    const n = this.key;
    !t || !t.data || (n ? t.key !== void 0 && (this.nodesMap[t.key] = t) : this.nodesMap[t.id] = t);
  }
  deregisterNode(t) {
    !this.key || !t || !t.data || (t.childNodes.forEach((r) => {
      this.deregisterNode(r);
    }), delete this.nodesMap[t.key]);
  }
  getCheckedNodes(t = !1, n = !1) {
    const r = [], i = function(a) {
      (a.root ? a.root.childNodes : a.childNodes).forEach((s) => {
        (s.checked || n && s.indeterminate) && (!t || t && s.isLeaf) && r.push(s.data), i(s);
      });
    };
    return i(this), r;
  }
  getCheckedKeys(t = !1) {
    return this.getCheckedNodes(t).map((n) => (n || {})[this.key]);
  }
  getHalfCheckedNodes() {
    const t = [], n = function(r) {
      (r.root ? r.root.childNodes : r.childNodes).forEach((a) => {
        a.indeterminate && t.push(a.data), n(a);
      });
    };
    return n(this), t;
  }
  getHalfCheckedKeys() {
    return this.getHalfCheckedNodes().map((t) => (t || {})[this.key]);
  }
  _getAllNodes() {
    const t = [], n = this.nodesMap;
    for (const r in n)
      Lr(n, r) && t.push(n[r]);
    return t;
  }
  updateChildren(t, n) {
    const r = this.nodesMap[t];
    if (!r)
      return;
    const i = r.childNodes;
    for (let a = i.length - 1; a >= 0; a--) {
      const o = i[a];
      this.remove(o.data);
    }
    for (let a = 0, o = n.length; a < o; a++) {
      const s = n[a];
      this.append(s, r.data);
    }
  }
  _setCheckedKeys(t, n = !1, r) {
    const i = this._getAllNodes().sort((s, l) => l.level - s.level), a = /* @__PURE__ */ Object.create(null), o = Object.keys(r);
    i.forEach((s) => s.setChecked(!1, !1));
    for (let s = 0, l = i.length; s < l; s++) {
      const u = i[s], c = u.data[t].toString();
      if (!(o.indexOf(c) > -1)) {
        u.checked && !a[c] && u.setChecked(!1, !1);
        continue;
      }
      let d = u.parent;
      for (; d && d.level > 0; )
        a[d.data[t]] = !0, d = d.parent;
      if (u.isLeaf || this.checkStrictly) {
        u.setChecked(!0, !1);
        continue;
      }
      if (u.setChecked(!0, !0), n) {
        u.setChecked(!1, !1);
        const h = function(p) {
          p.childNodes.forEach((m) => {
            m.isLeaf || m.setChecked(!1, !1), h(m);
          });
        };
        h(u);
      }
    }
  }
  setCheckedNodes(t, n = !1) {
    const r = this.key, i = {};
    t.forEach((a) => {
      i[(a || {})[r]] = !0;
    }), this._setCheckedKeys(r, n, i);
  }
  setCheckedKeys(t, n = !1) {
    this.defaultCheckedKeys = t;
    const r = this.key, i = {};
    t.forEach((a) => {
      i[a] = !0;
    }), this._setCheckedKeys(r, n, i);
  }
  setDefaultExpandedKeys(t) {
    t = t || [], this.defaultExpandedKeys = t, t.forEach((n) => {
      const r = this.getNode(n);
      r && r.expand(null, this.autoExpandParent);
    });
  }
  setChecked(t, n, r) {
    const i = this.getNode(t);
    i && i.setChecked(!!n, r);
  }
  getCurrentNode() {
    return this.currentNode;
  }
  setCurrentNode(t) {
    const n = this.currentNode;
    n && (n.isCurrent = !1), this.currentNode = t, this.currentNode.isCurrent = !0;
  }
  setUserCurrentNode(t, n = !0) {
    const r = t[this.key], i = this.nodesMap[r];
    this.setCurrentNode(i), n && this.currentNode.level > 1 && this.currentNode.parent.expand(null, !0);
  }
  setCurrentNodeKey(t, n = !0) {
    if (t == null) {
      this.currentNode && (this.currentNode.isCurrent = !1), this.currentNode = null;
      return;
    }
    const r = this.getNode(t);
    r && (this.setCurrentNode(r), n && this.currentNode.level > 1 && this.currentNode.parent.expand(null, !0));
  }
}
const G$ = Ee({
  name: "ElTreeNodeContent",
  props: {
    node: {
      type: Object,
      required: !0
    },
    renderContent: Function
  },
  setup(e) {
    const t = Ct("tree"), n = ce("NodeInstance"), r = ce("RootTree");
    return () => {
      const i = e.node, { data: a, store: o } = i;
      return e.renderContent ? e.renderContent(et, { _self: n, node: i, data: a, store: o }) : r.ctx.slots.default ? r.ctx.slots.default({ node: i, data: a }) : et("span", { class: t.be("node", "label") }, [i.label]);
    };
  }
});
function DT(e) {
  const t = ce("TreeNodeMap", null), n = {
    treeNodeExpand: (r) => {
      e.node !== r && e.node.collapse();
    },
    children: []
  };
  return t && t.children.push(n), _t("TreeNodeMap", n), {
    broadcastExpanded: (r) => {
      if (!!e.accordion)
        for (const i of n.children)
          i.treeNodeExpand(r);
    }
  };
}
const MT = Symbol("dragEvents");
function Y$({ props: e, ctx: t, el$: n, dropIndicator$: r, store: i }) {
  const a = Ct("tree"), o = j({
    showDropIndicator: !1,
    draggingNode: null,
    dropNode: null,
    allowDrop: !0,
    dropType: null
  });
  return _t(MT, {
    treeNodeDragStart: ({ event: c, treeNode: f }) => {
      if (typeof e.allowDrag == "function" && !e.allowDrag(f.node))
        return c.preventDefault(), !1;
      c.dataTransfer.effectAllowed = "move";
      try {
        c.dataTransfer.setData("text/plain", "");
      } catch {
      }
      o.value.draggingNode = f, t.emit("node-drag-start", f.node, c);
    },
    treeNodeDragOver: ({ event: c, treeNode: f }) => {
      const d = f, h = o.value.dropNode;
      h && h !== d && oo(h.$el, a.is("drop-inner"));
      const p = o.value.draggingNode;
      if (!p || !d)
        return;
      let y = !0, m = !0, b = !0, x = !0;
      typeof e.allowDrop == "function" && (y = e.allowDrop(p.node, d.node, "prev"), x = m = e.allowDrop(p.node, d.node, "inner"), b = e.allowDrop(p.node, d.node, "next")), c.dataTransfer.dropEffect = m || y || b ? "move" : "none", (y || m || b) && h !== d && (h && t.emit("node-drag-leave", p.node, h.node, c), t.emit("node-drag-enter", p.node, d.node, c)), (y || m || b) && (o.value.dropNode = d), d.node.nextSibling === p.node && (b = !1), d.node.previousSibling === p.node && (y = !1), d.node.contains(p.node, !1) && (m = !1), (p.node === d.node || p.node.contains(d.node)) && (y = !1, m = !1, b = !1);
      const D = d.$el.getBoundingClientRect(), S = n.value.getBoundingClientRect();
      let C;
      const v = y ? m ? 0.25 : b ? 0.45 : 1 : -1, H = b ? m ? 0.75 : y ? 0.55 : 0 : 1;
      let V = -9999;
      const R = c.clientY - D.top;
      R < D.height * v ? C = "before" : R > D.height * H ? C = "after" : m ? C = "inner" : C = "none";
      const F = d.$el.querySelector(`.${a.be("node", "expand-icon")}`).getBoundingClientRect(), K = r.value;
      C === "before" ? V = F.top - S.top : C === "after" && (V = F.bottom - S.top), K.style.top = `${V}px`, K.style.left = `${F.right - S.left}px`, C === "inner" ? Ss(d.$el, a.is("drop-inner")) : oo(d.$el, a.is("drop-inner")), o.value.showDropIndicator = C === "before" || C === "after", o.value.allowDrop = o.value.showDropIndicator || x, o.value.dropType = C, t.emit("node-drag-over", p.node, d.node, c);
    },
    treeNodeDragEnd: (c) => {
      const { draggingNode: f, dropType: d, dropNode: h } = o.value;
      if (c.preventDefault(), c.dataTransfer.dropEffect = "move", f && h) {
        const p = { data: f.node.data };
        d !== "none" && f.node.remove(), d === "before" ? h.node.parent.insertBefore(p, h.node) : d === "after" ? h.node.parent.insertAfter(p, h.node) : d === "inner" && h.node.insertChild(p), d !== "none" && i.value.registerNode(p), oo(h.$el, a.is("drop-inner")), t.emit("node-drag-end", f.node, h.node, d, c), d !== "none" && t.emit("node-drop", f.node, h.node, d, c);
      }
      f && !h && t.emit("node-drag-end", f.node, null, d, c), o.value.showDropIndicator = !1, o.value.draggingNode = null, o.value.dropNode = null, o.value.allowDrop = !0;
    }
  }), {
    dragState: o
  };
}
const Q$ = Ee({
  name: "ElTreeNode",
  components: {
    ElCollapseTransition: w3,
    ElCheckbox: Bs,
    NodeContent: G$,
    ElIcon: qt,
    Loading: Vl
  },
  props: {
    node: {
      type: xl,
      default: () => ({})
    },
    props: {
      type: Object,
      default: () => ({})
    },
    accordion: Boolean,
    renderContent: Function,
    renderAfterExpand: Boolean,
    showCheckbox: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["node-expand"],
  setup(e, t) {
    const n = Ct("tree"), { broadcastExpanded: r } = DT(e), i = ce("RootTree"), a = j(!1), o = j(!1), s = j(null), l = j(null), u = j(null), c = ce(MT), f = sn();
    _t("NodeInstance", f), i || fi("Tree", "Can not find node's tree."), e.node.expanded && (a.value = !0, o.value = !0);
    const d = i.props.children || "children";
    Ne(() => {
      const R = e.node.data[d];
      return R && [...R];
    }, () => {
      e.node.updateChildren();
    }), Ne(() => e.node.indeterminate, (R) => {
      y(e.node.checked, R);
    }), Ne(() => e.node.checked, (R) => {
      y(R, e.node.indeterminate);
    }), Ne(() => e.node.expanded, (R) => {
      bt(() => a.value = R), R && (o.value = !0);
    });
    const h = (R) => j3(i.props.nodeKey, R.data), p = (R) => {
      const F = e.props.class;
      if (!F)
        return {};
      let K;
      if (fa(F)) {
        const { data: q } = R;
        K = F(q, R);
      } else
        K = F;
      return Ai(K) ? { [K]: !0 } : K;
    }, y = (R, F) => {
      (s.value !== R || l.value !== F) && i.ctx.emit("check-change", e.node.data, R, F), s.value = R, l.value = F;
    }, m = (R) => {
      const F = i.store.value;
      F.setCurrentNode(e.node), i.ctx.emit("current-change", F.currentNode ? F.currentNode.data : null, F.currentNode), i.currentNode.value = e.node, i.props.expandOnClickNode && x(), i.props.checkOnClickNode && !e.node.disabled && D(null, {
        target: { checked: !e.node.checked }
      }), i.ctx.emit("node-click", e.node.data, e.node, f, R);
    }, b = (R) => {
      i.instance.vnode.props.onNodeContextmenu && (R.stopPropagation(), R.preventDefault()), i.ctx.emit("node-contextmenu", R, e.node.data, e.node, f);
    }, x = () => {
      e.node.isLeaf || (a.value ? (i.ctx.emit("node-collapse", e.node.data, e.node, f), e.node.collapse()) : (e.node.expand(), t.emit("node-expand", e.node.data, e.node, f)));
    }, D = (R, F) => {
      e.node.setChecked(F.target.checked, !i.props.checkStrictly), bt(() => {
        const K = i.store.value;
        i.ctx.emit("check", e.node.data, {
          checkedNodes: K.getCheckedNodes(),
          checkedKeys: K.getCheckedKeys(),
          halfCheckedNodes: K.getHalfCheckedNodes(),
          halfCheckedKeys: K.getHalfCheckedKeys()
        });
      });
    };
    return {
      ns: n,
      node$: u,
      tree: i,
      expanded: a,
      childNodeRendered: o,
      oldChecked: s,
      oldIndeterminate: l,
      getNodeKey: h,
      getNodeClass: p,
      handleSelectChange: y,
      handleClick: m,
      handleContextMenu: b,
      handleExpandIconClick: x,
      handleCheckChange: D,
      handleChildNodeExpand: (R, F, K) => {
        r(F), i.ctx.emit("node-expand", R, F, K);
      },
      handleDragStart: (R) => {
        !i.props.draggable || c.treeNodeDragStart({ event: R, treeNode: e });
      },
      handleDragOver: (R) => {
        R.preventDefault(), i.props.draggable && c.treeNodeDragOver({
          event: R,
          treeNode: { $el: u.value, node: e.node }
        });
      },
      handleDrop: (R) => {
        R.preventDefault();
      },
      handleDragEnd: (R) => {
        !i.props.draggable || c.treeNodeDragEnd(R);
      },
      CaretRight: qN
    };
  }
}), Z$ = ["aria-expanded", "aria-disabled", "aria-checked", "draggable", "data-key"], J$ = ["aria-expanded"];
function $$(e, t, n, r, i, a) {
  const o = Ie("el-icon"), s = Ie("el-checkbox"), l = Ie("loading"), u = Ie("node-content"), c = Ie("el-tree-node"), f = Ie("el-collapse-transition");
  return Bt((P(), L("div", {
    ref: "node$",
    class: se([
      e.ns.b("node"),
      e.ns.is("expanded", e.expanded),
      e.ns.is("current", e.node.isCurrent),
      e.ns.is("hidden", !e.node.visible),
      e.ns.is("focusable", !e.node.disabled),
      e.ns.is("checked", !e.node.disabled && e.node.checked),
      e.getNodeClass(e.node)
    ]),
    role: "treeitem",
    tabindex: "-1",
    "aria-expanded": e.expanded,
    "aria-disabled": e.node.disabled,
    "aria-checked": e.node.checked,
    draggable: e.tree.props.draggable,
    "data-key": e.getNodeKey(e.node),
    onClick: t[1] || (t[1] = wt((...d) => e.handleClick && e.handleClick(...d), ["stop"])),
    onContextmenu: t[2] || (t[2] = (...d) => e.handleContextMenu && e.handleContextMenu(...d)),
    onDragstart: t[3] || (t[3] = wt((...d) => e.handleDragStart && e.handleDragStart(...d), ["stop"])),
    onDragover: t[4] || (t[4] = wt((...d) => e.handleDragOver && e.handleDragOver(...d), ["stop"])),
    onDragend: t[5] || (t[5] = wt((...d) => e.handleDragEnd && e.handleDragEnd(...d), ["stop"])),
    onDrop: t[6] || (t[6] = wt((...d) => e.handleDrop && e.handleDrop(...d), ["stop"]))
  }, [
    T("div", {
      class: se(e.ns.be("node", "content")),
      style: Pt({ paddingLeft: (e.node.level - 1) * e.tree.props.indent + "px" })
    }, [
      e.tree.props.icon || e.CaretRight ? (P(), ue(o, {
        key: 0,
        class: se([
          e.ns.be("node", "expand-icon"),
          e.ns.is("leaf", e.node.isLeaf),
          {
            expanded: !e.node.isLeaf && e.expanded
          }
        ]),
        onClick: wt(e.handleExpandIconClick, ["stop"])
      }, {
        default: N(() => [
          (P(), ue(Ln(e.tree.props.icon || e.CaretRight)))
        ]),
        _: 1
      }, 8, ["class", "onClick"])) : re("v-if", !0),
      e.showCheckbox ? (P(), ue(s, {
        key: 1,
        "model-value": e.node.checked,
        indeterminate: e.node.indeterminate,
        disabled: !!e.node.disabled,
        onClick: t[0] || (t[0] = wt(() => {
        }, ["stop"])),
        onChange: e.handleCheckChange
      }, null, 8, ["model-value", "indeterminate", "disabled", "onChange"])) : re("v-if", !0),
      e.node.loading ? (P(), ue(o, {
        key: 2,
        class: se([e.ns.be("node", "loading-icon"), e.ns.is("loading")])
      }, {
        default: N(() => [
          B(l)
        ]),
        _: 1
      }, 8, ["class"])) : re("v-if", !0),
      B(u, {
        node: e.node,
        "render-content": e.renderContent
      }, null, 8, ["node", "render-content"])
    ], 6),
    B(f, null, {
      default: N(() => [
        !e.renderAfterExpand || e.childNodeRendered ? Bt((P(), L("div", {
          key: 0,
          class: se(e.ns.be("node", "children")),
          role: "group",
          "aria-expanded": e.expanded
        }, [
          (P(!0), L(nt, null, Lt(e.node.childNodes, (d) => (P(), ue(c, {
            key: e.getNodeKey(d),
            "render-content": e.renderContent,
            "render-after-expand": e.renderAfterExpand,
            "show-checkbox": e.showCheckbox,
            node: d,
            accordion: e.accordion,
            props: e.props,
            onNodeExpand: e.handleChildNodeExpand
          }, null, 8, ["render-content", "render-after-expand", "show-checkbox", "node", "accordion", "props", "onNodeExpand"]))), 128))
        ], 10, J$)), [
          [Cn, e.expanded]
        ]) : re("v-if", !0)
      ]),
      _: 1
    })
  ], 42, Z$)), [
    [Cn, e.node.visible]
  ]);
}
var eee = /* @__PURE__ */ vt(Q$, [["render", $$]]);
function tee({ el$: e }, t) {
  const n = Ct("tree"), r = Uo([]), i = Uo([]);
  rn(() => {
    o(), _n(e.value, "keydown", a);
  }), Ti(() => {
    si(e.value, "keydown", a);
  }), Zo(() => {
    r.value = Array.from(e.value.querySelectorAll("[role=treeitem]")), i.value = Array.from(e.value.querySelectorAll("input[type=checkbox]"));
  }), Ne(i, (s) => {
    s.forEach((l) => {
      l.setAttribute("tabindex", "-1");
    });
  });
  const a = (s) => {
    const l = s.target;
    if (l.className.indexOf(n.b("node")) === -1)
      return;
    const u = s.code;
    r.value = Array.from(e.value.querySelectorAll(`.${n.is("focusable")}[role=treeitem]`));
    const c = r.value.indexOf(l);
    let f;
    if ([yt.up, yt.down].indexOf(u) > -1) {
      if (s.preventDefault(), u === yt.up) {
        f = c === -1 ? 0 : c !== 0 ? c - 1 : r.value.length - 1;
        const h = f;
        for (; !t.value.getNode(r.value[f].dataset.key).canFocus; ) {
          if (f--, f === h) {
            f = -1;
            break;
          }
          f < 0 && (f = r.value.length - 1);
        }
      } else {
        f = c === -1 ? 0 : c < r.value.length - 1 ? c + 1 : 0;
        const h = f;
        for (; !t.value.getNode(r.value[f].dataset.key).canFocus; ) {
          if (f++, f === h) {
            f = -1;
            break;
          }
          f >= r.value.length && (f = 0);
        }
      }
      f !== -1 && r.value[f].focus();
    }
    [yt.left, yt.right].indexOf(u) > -1 && (s.preventDefault(), l.click());
    const d = l.querySelector('[type="checkbox"]');
    [yt.enter, yt.space].indexOf(u) > -1 && d && (s.preventDefault(), d.click());
  }, o = () => {
    var s;
    r.value = Array.from(e.value.querySelectorAll(`.${n.is("focusable")}[role=treeitem]`)), i.value = Array.from(e.value.querySelectorAll("input[type=checkbox]"));
    const l = e.value.querySelectorAll(`.${n.is("checked")}[role=treeitem]`);
    if (l.length) {
      l[0].setAttribute("tabindex", "0");
      return;
    }
    (s = r.value[0]) == null || s.setAttribute("tabindex", "0");
  };
}
const nee = Ee({
  name: "ElTree",
  components: { ElTreeNode: eee },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String
    },
    renderAfterExpand: {
      type: Boolean,
      default: !0
    },
    nodeKey: String,
    checkStrictly: Boolean,
    defaultExpandAll: Boolean,
    expandOnClickNode: {
      type: Boolean,
      default: !0
    },
    checkOnClickNode: Boolean,
    checkDescendants: {
      type: Boolean,
      default: !1
    },
    autoExpandParent: {
      type: Boolean,
      default: !0
    },
    defaultCheckedKeys: Array,
    defaultExpandedKeys: Array,
    currentNodeKey: [String, Number],
    renderContent: Function,
    showCheckbox: {
      type: Boolean,
      default: !1
    },
    draggable: {
      type: Boolean,
      default: !1
    },
    allowDrag: Function,
    allowDrop: Function,
    props: {
      type: Object,
      default: () => ({
        children: "children",
        label: "label",
        disabled: "disabled"
      })
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    highlightCurrent: Boolean,
    load: Function,
    filterNodeMethod: Function,
    accordion: Boolean,
    indent: {
      type: Number,
      default: 18
    },
    icon: [String, Object]
  },
  emits: [
    "check-change",
    "current-change",
    "node-click",
    "node-contextmenu",
    "node-collapse",
    "node-expand",
    "check",
    "node-drag-start",
    "node-drag-end",
    "node-drop",
    "node-drag-leave",
    "node-drag-enter",
    "node-drag-over"
  ],
  setup(e, t) {
    const { t: n } = hi(), r = Ct("tree"), i = j(new K$({
      key: e.nodeKey,
      data: e.data,
      lazy: e.lazy,
      props: e.props,
      load: e.load,
      currentNodeKey: e.currentNodeKey,
      checkStrictly: e.checkStrictly,
      checkDescendants: e.checkDescendants,
      defaultCheckedKeys: e.defaultCheckedKeys,
      defaultExpandedKeys: e.defaultExpandedKeys,
      autoExpandParent: e.autoExpandParent,
      defaultExpandAll: e.defaultExpandAll,
      filterNodeMethod: e.filterNodeMethod
    }));
    i.value.initialize();
    const a = j(i.value.root), o = j(null), s = j(null), l = j(null), { broadcastExpanded: u } = DT(e), { dragState: c } = Y$({
      props: e,
      ctx: t,
      el$: s,
      dropIndicator$: l,
      store: i
    });
    tee({ el$: s }, i);
    const f = J(() => {
      const { childNodes: Z } = a.value;
      return !Z || Z.length === 0 || Z.every(({ visible: oe }) => !oe);
    });
    Ne(() => e.defaultCheckedKeys, (Z) => {
      i.value.setDefaultCheckedKey(Z);
    }), Ne(() => e.defaultExpandedKeys, (Z) => {
      i.value.setDefaultExpandedKeys(Z);
    }), Ne(() => e.data, (Z) => {
      i.value.setData(Z);
    }, { deep: !0 }), Ne(() => e.checkStrictly, (Z) => {
      i.value.checkStrictly = Z;
    });
    const d = (Z) => {
      if (!e.filterNodeMethod)
        throw new Error("[Tree] filterNodeMethod is required when filter");
      i.value.filter(Z);
    }, h = (Z) => j3(e.nodeKey, Z.data), p = (Z) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in getNodePath");
      const oe = i.value.getNode(Z);
      if (!oe)
        return [];
      const he = [oe.data];
      let Ae = oe.parent;
      for (; Ae && Ae !== a.value; )
        he.push(Ae.data), Ae = Ae.parent;
      return he.reverse();
    }, y = (Z, oe) => i.value.getCheckedNodes(Z, oe), m = (Z) => i.value.getCheckedKeys(Z), b = () => {
      const Z = i.value.getCurrentNode();
      return Z ? Z.data : null;
    }, x = () => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in getCurrentKey");
      const Z = b();
      return Z ? Z[e.nodeKey] : null;
    }, D = (Z, oe) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in setCheckedNodes");
      i.value.setCheckedNodes(Z, oe);
    }, S = (Z, oe) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in setCheckedKeys");
      i.value.setCheckedKeys(Z, oe);
    }, C = (Z, oe, he) => {
      i.value.setChecked(Z, oe, he);
    }, v = () => i.value.getHalfCheckedNodes(), H = () => i.value.getHalfCheckedKeys(), V = (Z, oe = !0) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in setCurrentNode");
      i.value.setUserCurrentNode(Z, oe);
    }, R = (Z, oe = !0) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in setCurrentKey");
      i.value.setCurrentNodeKey(Z, oe);
    }, F = (Z) => i.value.getNode(Z), K = (Z) => {
      i.value.remove(Z);
    }, q = (Z, oe) => {
      i.value.append(Z, oe);
    }, G = (Z, oe) => {
      i.value.insertBefore(Z, oe);
    }, te = (Z, oe) => {
      i.value.insertAfter(Z, oe);
    }, Q = (Z, oe, he) => {
      u(oe), t.emit("node-expand", Z, oe, he);
    }, Y = (Z, oe) => {
      if (!e.nodeKey)
        throw new Error("[Tree] nodeKey is required in updateKeyChild");
      i.value.updateChildren(Z, oe);
    };
    return _t("RootTree", {
      ctx: t,
      props: e,
      store: i,
      root: a,
      currentNode: o,
      instance: sn()
    }), {
      ns: r,
      store: i,
      root: a,
      currentNode: o,
      dragState: c,
      el$: s,
      dropIndicator$: l,
      isEmpty: f,
      filter: d,
      getNodeKey: h,
      getNodePath: p,
      getCheckedNodes: y,
      getCheckedKeys: m,
      getCurrentNode: b,
      getCurrentKey: x,
      setCheckedNodes: D,
      setCheckedKeys: S,
      setChecked: C,
      getHalfCheckedNodes: v,
      getHalfCheckedKeys: H,
      setCurrentNode: V,
      setCurrentKey: R,
      t: n,
      getNode: F,
      remove: K,
      append: q,
      insertBefore: G,
      insertAfter: te,
      handleNodeExpand: Q,
      updateKeyChildren: Y
    };
  }
});
function iee(e, t, n, r, i, a) {
  var o;
  const s = Ie("el-tree-node");
  return P(), L("div", {
    ref: "el$",
    class: se([
      e.ns.b(),
      e.ns.is("dragging", !!e.dragState.draggingNode),
      e.ns.is("drop-not-allow", !e.dragState.allowDrop),
      e.ns.is("drop-inner", e.dragState.dropType === "inner"),
      { [e.ns.m("highlight-current")]: e.highlightCurrent }
    ]),
    role: "tree"
  }, [
    (P(!0), L(nt, null, Lt(e.root.childNodes, (l) => (P(), ue(s, {
      key: e.getNodeKey(l),
      node: l,
      props: e.props,
      accordion: e.accordion,
      "render-after-expand": e.renderAfterExpand,
      "show-checkbox": e.showCheckbox,
      "render-content": e.renderContent,
      onNodeExpand: e.handleNodeExpand
    }, null, 8, ["node", "props", "accordion", "render-after-expand", "show-checkbox", "render-content", "onNodeExpand"]))), 128)),
    e.isEmpty ? (P(), L("div", {
      key: 0,
      class: se(e.ns.e("empty-block"))
    }, [
      T("span", {
        class: se(e.ns.e("empty-text"))
      }, de((o = e.emptyText) != null ? o : e.t("el.tree.emptyText")), 3)
    ], 2)) : re("v-if", !0),
    Bt(T("div", {
      ref: "dropIndicator$",
      class: se(e.ns.e("drop-indicator"))
    }, null, 2), [
      [Cn, e.dragState.showDropIndicator]
    ])
  ], 2);
}
var c0 = /* @__PURE__ */ vt(nee, [["render", iee]]);
c0.install = (e) => {
  e.component(c0.name, c0);
};
const ree = c0, aee = ree;
function L7(e, t, n) {
  let r;
  n.response ? r = `${n.response.error || n.response}` : n.responseText ? r = `${n.responseText}` : r = `fail to ${t.method} ${e} ${n.status}`;
  const i = new Error(r);
  return i.status = n.status, i.method = t.method, i.url = e, i;
}
function oee(e) {
  const t = e.responseText || e.response;
  if (!t)
    return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}
function HT(e) {
  if (typeof XMLHttpRequest > "u")
    return;
  const t = new XMLHttpRequest(), n = e.action;
  t.upload && (t.upload.onprogress = function(o) {
    o.total > 0 && (o.percent = o.loaded / o.total * 100), e.onProgress(o);
  });
  const r = new FormData();
  e.data && Object.keys(e.data).forEach((a) => {
    r.append(a, e.data[a]);
  }), r.append(e.filename, e.file, e.file.name), t.onerror = function() {
    e.onError(L7(n, e, t));
  }, t.onload = function() {
    if (t.status < 200 || t.status >= 300)
      return e.onError(L7(n, e, t));
    e.onSuccess(oee(t));
  }, t.open(e.method, n, !0), e.withCredentials && "withCredentials" in t && (t.withCredentials = !0);
  const i = e.headers || {};
  for (const a in i)
    Lr(i, a) && i[a] !== null && t.setRequestHeader(a, i[a]);
  return i instanceof Headers && i.forEach((a, o) => {
    t.setRequestHeader(o, a);
  }), t.send(r), t;
}
const see = Ee({
  name: "ElUploadList",
  components: {
    ElProgress: M3,
    ElIcon: qt,
    Document: Kj,
    Delete: Rj,
    Close: Is,
    ZoomIn: GF,
    Check: Xd,
    CircleCheck: L0
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    handlePreview: {
      type: Function,
      default: () => Vn
    },
    listType: {
      type: String,
      default: "text"
    }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const { t: n } = hi(), r = Ct("upload"), i = Ct("icon"), a = Ct("list"), o = (u) => {
      e.handlePreview(u);
    }, s = (u) => {
      u.target.focus();
    }, l = (u) => {
      t("remove", u);
    };
    return {
      focusing: j(!1),
      handleClick: o,
      handleRemove: l,
      onFileClicked: s,
      t: n,
      nsUpload: r,
      nsIcon: i,
      nsList: a
    };
  }
}), lee = ["onKeydown"], uee = ["src"], cee = ["onClick"], dee = ["onClick"], fee = ["onClick"];
function hee(e, t, n, r, i, a) {
  const o = Ie("document"), s = Ie("el-icon"), l = Ie("circle-check"), u = Ie("check"), c = Ie("close"), f = Ie("el-progress"), d = Ie("zoom-in"), h = Ie("delete");
  return P(), ue(Y4, {
    tag: "ul",
    class: se([
      e.nsUpload.b("list"),
      e.nsUpload.bm("list", e.listType),
      e.nsUpload.is("disabled", e.disabled)
    ]),
    name: e.nsList.b()
  }, {
    default: N(() => [
      (P(!0), L(nt, null, Lt(e.files, (p) => (P(), L("li", {
        key: p.uid || p,
        class: se([
          e.nsUpload.be("list", "item"),
          e.nsUpload.is(p.status),
          { focusing: e.focusing }
        ]),
        tabindex: "0",
        onKeydown: nn((y) => !e.disabled && e.handleRemove(p), ["delete"]),
        onFocus: t[0] || (t[0] = (y) => e.focusing = !0),
        onBlur: t[1] || (t[1] = (y) => e.focusing = !1),
        onClick: t[2] || (t[2] = (...y) => e.onFileClicked && e.onFileClicked(...y))
      }, [
        tt(e.$slots, "default", { file: p }, () => [
          p.status !== "uploading" && ["picture-card", "picture"].includes(e.listType) ? (P(), L("img", {
            key: 0,
            class: se(e.nsUpload.be("list", "item-thumbnail")),
            src: p.url,
            alt: ""
          }, null, 10, uee)) : re("v-if", !0),
          T("a", {
            class: se(e.nsUpload.be("list", "item-name")),
            onClick: (y) => e.handleClick(p)
          }, [
            B(s, {
              class: se(e.nsIcon.m("document"))
            }, {
              default: N(() => [
                B(o)
              ]),
              _: 1
            }, 8, ["class"]),
            je(" " + de(p.name), 1)
          ], 10, cee),
          T("label", {
            class: se(e.nsUpload.be("list", "item-status-label"))
          }, [
            e.listType === "text" ? (P(), ue(s, {
              key: 0,
              class: se([e.nsIcon.m("upload-success"), e.nsIcon.m("circle-check")])
            }, {
              default: N(() => [
                B(l)
              ]),
              _: 1
            }, 8, ["class"])) : ["picture-card", "picture"].includes(e.listType) ? (P(), ue(s, {
              key: 1,
              class: se([e.nsIcon.m("upload-success"), e.nsIcon.m("check")])
            }, {
              default: N(() => [
                B(u)
              ]),
              _: 1
            }, 8, ["class"])) : re("v-if", !0)
          ], 2),
          e.disabled ? re("v-if", !0) : (P(), ue(s, {
            key: 1,
            class: se(e.nsIcon.m("close")),
            onClick: (y) => e.handleRemove(p)
          }, {
            default: N(() => [
              B(c)
            ]),
            _: 2
          }, 1032, ["class", "onClick"])),
          re(" Due to close btn only appears when li gets focused disappears after li gets blurred, thus keyboard navigation can never reach close btn"),
          re(" This is a bug which needs to be fixed "),
          re(" TODO: Fix the incorrect navigation interaction "),
          e.disabled ? re("v-if", !0) : (P(), L("i", {
            key: 2,
            class: se(e.nsIcon.m("close-tip"))
          }, de(e.t("el.upload.deleteTip")), 3)),
          p.status === "uploading" ? (P(), ue(f, {
            key: 3,
            type: e.listType === "picture-card" ? "circle" : "line",
            "stroke-width": e.listType === "picture-card" ? 6 : 2,
            percentage: +p.percentage,
            style: { "margin-top": "0.5rem" }
          }, null, 8, ["type", "stroke-width", "percentage"])) : re("v-if", !0),
          e.listType === "picture-card" ? (P(), L("span", {
            key: 4,
            class: se(e.nsUpload.be("list", "item-actions"))
          }, [
            T("span", {
              class: se(e.nsUpload.be("list", "item-preview")),
              onClick: (y) => e.handlePreview(p)
            }, [
              B(s, {
                class: se(e.nsIcon.m("zoom-in"))
              }, {
                default: N(() => [
                  B(d)
                ]),
                _: 1
              }, 8, ["class"])
            ], 10, dee),
            e.disabled ? re("v-if", !0) : (P(), L("span", {
              key: 0,
              class: se(e.nsUpload.be("list", "item-delete")),
              onClick: (y) => e.handleRemove(p)
            }, [
              B(s, {
                class: se(e.nsIcon.m("delete"))
              }, {
                default: N(() => [
                  B(h)
                ]),
                _: 1
              }, 8, ["class"])
            ], 10, fee))
          ], 2)) : re("v-if", !0)
        ])
      ], 42, lee))), 128))
    ]),
    _: 3
  }, 8, ["class", "name"]);
}
var B7 = /* @__PURE__ */ vt(see, [["render", hee]]);
const pee = Ee({
  name: "ElUploadDrag",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["file"],
  setup(e, { emit: t }) {
    const n = ce("uploader", {}), r = Ct("upload"), i = j(!1);
    function a(s) {
      var l;
      if (e.disabled || !n)
        return;
      const u = ((l = n.props) == null ? void 0 : l.accept) || n.accept;
      if (i.value = !1, !u) {
        t("file", s.dataTransfer.files);
        return;
      }
      t("file", Array.from(s.dataTransfer.files).filter((c) => {
        const { type: f, name: d } = c, h = d.indexOf(".") > -1 ? `.${d.split(".").pop()}` : "", p = f.replace(/\/.*$/, "");
        return u.split(",").map((y) => y.trim()).filter((y) => y).some((y) => y.startsWith(".") ? h === y : /\/\*$/.test(y) ? p === y.replace(/\/\*$/, "") : /^[^/]+\/[^/]+$/.test(y) ? f === y : !1);
      }));
    }
    function o() {
      e.disabled || (i.value = !0);
    }
    return {
      ns: r,
      dragover: i,
      onDrop: a,
      onDragover: o
    };
  }
});
function vee(e, t, n, r, i, a) {
  return P(), L("div", {
    class: se([e.ns.b("dragger"), e.ns.is("dragover", e.dragover)]),
    onDrop: t[0] || (t[0] = wt((...o) => e.onDrop && e.onDrop(...o), ["prevent"])),
    onDragover: t[1] || (t[1] = wt((...o) => e.onDragover && e.onDragover(...o), ["prevent"])),
    onDragleave: t[2] || (t[2] = wt((o) => e.dragover = !1, ["prevent"]))
  }, [
    tt(e.$slots, "default")
  ], 34);
}
var mee = /* @__PURE__ */ vt(pee, [["render", vee]]);
const gee = Ee({
  components: {
    UploadDragger: mee
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      default: "file"
    },
    data: {
      type: Object,
      default: () => null
    },
    headers: {
      type: Object,
      default: () => null
    },
    method: {
      type: String,
      default: "post"
    },
    withCredentials: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: null
    },
    accept: {
      type: String,
      default: ""
    },
    onStart: {
      type: Function,
      default: Vn
    },
    onProgress: {
      type: Function,
      default: Vn
    },
    onSuccess: {
      type: Function,
      default: Vn
    },
    onError: {
      type: Function,
      default: Vn
    },
    beforeUpload: {
      type: Function,
      default: Vn
    },
    drag: {
      type: Boolean,
      default: !1
    },
    onPreview: {
      type: Function,
      default: Vn
    },
    onRemove: {
      type: Function,
      default: Vn
    },
    fileList: {
      type: Array,
      default: () => []
    },
    autoUpload: {
      type: Boolean,
      default: !0
    },
    listType: {
      type: String,
      default: "text"
    },
    httpRequest: {
      type: Function,
      default: () => HT
    },
    disabled: Boolean,
    limit: {
      type: Number,
      default: null
    },
    onExceed: {
      type: Function,
      default: Vn
    }
  },
  setup(e) {
    const t = j({}), n = Ct("upload"), r = j(!1), i = j(null);
    function a(d) {
      if (e.limit && e.fileList.length + d.length > e.limit) {
        e.onExceed(d, e.fileList);
        return;
      }
      let h = Array.from(d);
      e.multiple || (h = h.slice(0, 1)), h.length !== 0 && h.forEach((p) => {
        e.onStart(p), e.autoUpload && o(p);
      });
    }
    function o(d) {
      if (i.value.value = null, !e.beforeUpload)
        return l(d);
      const h = e.beforeUpload(d);
      h instanceof Promise ? h.then((p) => {
        const y = Object.prototype.toString.call(p);
        if (y === "[object File]" || y === "[object Blob]") {
          y === "[object Blob]" && (p = new File([p], d.name, {
            type: d.type
          }));
          for (const m in d)
            Lr(d, m) && (p[m] = d[m]);
          l(p);
        } else
          l(d);
      }).catch(() => {
        e.onRemove(null, d);
      }) : h !== !1 ? l(d) : e.onRemove(null, d);
    }
    function s(d) {
      const h = t.value;
      if (d) {
        let p = d;
        d.uid && (p = d.uid), h[p] && h[p].abort();
      } else
        Object.keys(h).forEach((p) => {
          h[p] && h[p].abort(), delete h[p];
        });
    }
    function l(d) {
      const { uid: h } = d, p = {
        headers: e.headers,
        withCredentials: e.withCredentials,
        file: d,
        data: e.data,
        method: e.method,
        filename: e.name,
        action: e.action,
        onProgress: (m) => {
          e.onProgress(m, d);
        },
        onSuccess: (m) => {
          e.onSuccess(m, d), delete t.value[h];
        },
        onError: (m) => {
          e.onError(m, d), delete t.value[h];
        }
      }, y = e.httpRequest(p);
      t.value[h] = y, y instanceof Promise && y.then(p.onSuccess, p.onError);
    }
    function u(d) {
      const h = d.target.files;
      !h || a(h);
    }
    function c() {
      e.disabled || (i.value.value = null, i.value.click());
    }
    function f() {
      c();
    }
    return {
      ns: n,
      reqs: t,
      mouseover: r,
      inputRef: i,
      abort: s,
      post: l,
      handleChange: u,
      handleClick: c,
      handleKeydown: f,
      upload: o,
      uploadFiles: a
    };
  }
}), yee = ["name", "multiple", "accept"];
function bee(e, t, n, r, i, a) {
  const o = Ie("upload-dragger");
  return P(), L("div", {
    class: se([e.ns.b(), e.ns.m(e.listType)]),
    tabindex: "0",
    onClick: t[1] || (t[1] = (...s) => e.handleClick && e.handleClick(...s)),
    onKeydown: t[2] || (t[2] = nn(wt((...s) => e.handleKeydown && e.handleKeydown(...s), ["self"]), ["enter", "space"]))
  }, [
    e.drag ? (P(), ue(o, {
      key: 0,
      disabled: e.disabled,
      onFile: e.uploadFiles
    }, {
      default: N(() => [
        tt(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled", "onFile"])) : tt(e.$slots, "default", { key: 1 }),
    T("input", {
      ref: "inputRef",
      class: se(e.ns.e("input")),
      type: "file",
      name: e.name,
      multiple: e.multiple,
      accept: e.accept,
      onChange: t[0] || (t[0] = (...s) => e.handleChange && e.handleChange(...s))
    }, null, 42, yee)
  ], 34);
}
var N7 = /* @__PURE__ */ vt(gee, [["render", bee]]);
function y1(e, t) {
  return t.find((n) => n.uid === e.uid);
}
function j7(e) {
  return Date.now() + e;
}
var Aee = (e) => {
  const t = j([]), n = j(null);
  let r = 1;
  function i(d) {
    n.value.abort(d);
  }
  function a(d = ["ready", "uploading", "success", "fail"]) {
    t.value = t.value.filter((h) => !d.includes(h.status));
  }
  function o(d, h) {
    const p = y1(h, t.value);
    p.status = "fail", t.value.splice(t.value.indexOf(p), 1), e.onError(d, p, t.value), e.onChange(p, t.value);
  }
  function s(d, h) {
    const p = y1(h, t.value);
    e.onProgress(d, p, t.value), p.status = "uploading", p.percentage = d.percent || 0;
  }
  function l(d, h) {
    const p = y1(h, t.value);
    p && (p.status = "success", p.response = d, e.onSuccess(d, p, t.value), e.onChange(p, t.value));
  }
  function u(d) {
    const h = j7(r++);
    d.uid = h;
    const p = {
      name: d.name,
      percentage: 0,
      status: "ready",
      size: d.size,
      raw: d,
      uid: h
    };
    if (e.listType === "picture-card" || e.listType === "picture")
      try {
        p.url = URL.createObjectURL(d);
      } catch (y) {
        console.error("[Element Error][Upload]", y), e.onError(y, p, t.value);
      }
    t.value.push(p), e.onChange(p, t.value);
  }
  function c(d, h) {
    h && (d = y1(h, t.value));
    const p = () => {
      d.url && d.url.indexOf("blob:") === 0 && URL.revokeObjectURL(d.url);
    }, y = () => {
      i(d);
      const m = t.value;
      m.splice(m.indexOf(d), 1), e.onRemove(d, m), p();
    };
    if (!e.beforeRemove)
      y();
    else if (typeof e.beforeRemove == "function") {
      const m = e.beforeRemove(d, t.value);
      m instanceof Promise ? m.then(() => {
        y();
      }).catch(Vn) : m !== !1 && y();
    }
  }
  function f() {
    t.value.filter((d) => d.status === "ready").forEach((d) => {
      n.value.upload(d.raw);
    });
  }
  return Ne(() => e.listType, (d) => {
    (d === "picture-card" || d === "picture") && (t.value = t.value.map((h) => {
      if (!h.url && h.raw)
        try {
          h.url = URL.createObjectURL(h.raw);
        } catch (p) {
          e.onError(p, h, t.value);
        }
      return h;
    }));
  }), Ne(() => e.fileList, (d) => {
    t.value = d.map((h) => ({
      ...JL(h),
      uid: h.uid || j7(r++),
      status: h.status || "success"
    }));
  }, {
    immediate: !0,
    deep: !0
  }), {
    abort: i,
    clearFiles: a,
    handleError: o,
    handleProgress: s,
    handleStart: u,
    handleSuccess: l,
    handleRemove: c,
    submit: f,
    uploadFiles: t,
    uploadRef: n
  };
};
const d0 = Ee({
  name: "ElUpload",
  components: {
    Upload: N7,
    UploadList: B7
  },
  props: {
    action: {
      type: String,
      required: !0
    },
    headers: {
      type: Object,
      default: () => ({})
    },
    method: {
      type: String,
      default: "post"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "file"
    },
    drag: {
      type: Boolean,
      default: !1
    },
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: !0
    },
    accept: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "select"
    },
    beforeUpload: {
      type: Function,
      default: Vn
    },
    beforeRemove: {
      type: Function,
      default: Vn
    },
    onRemove: {
      type: Function,
      default: Vn
    },
    onChange: {
      type: Function,
      default: Vn
    },
    onPreview: {
      type: Function,
      default: Vn
    },
    onSuccess: {
      type: Function,
      default: Vn
    },
    onProgress: {
      type: Function,
      default: Vn
    },
    onError: {
      type: Function,
      default: Vn
    },
    fileList: {
      type: Array,
      default: () => []
    },
    autoUpload: {
      type: Boolean,
      default: !0
    },
    listType: {
      type: String,
      default: "text"
    },
    httpRequest: {
      type: Function,
      default: HT
    },
    disabled: Boolean,
    limit: {
      type: Number,
      default: null
    },
    onExceed: {
      type: Function,
      default: () => Vn
    }
  },
  setup(e) {
    const t = ce(Pa, {}), n = J(() => e.disabled || t.disabled), {
      abort: r,
      clearFiles: i,
      handleError: a,
      handleProgress: o,
      handleStart: s,
      handleSuccess: l,
      handleRemove: u,
      submit: c,
      uploadRef: f,
      uploadFiles: d
    } = Aee(e);
    return _t("uploader", sn()), Ti(() => {
      d.value.forEach((h) => {
        h.url && h.url.indexOf("blob:") === 0 && URL.revokeObjectURL(h.url);
      });
    }), {
      abort: r,
      dragOver: j(!1),
      draging: j(!1),
      handleError: a,
      handleProgress: o,
      handleRemove: u,
      handleStart: s,
      handleSuccess: l,
      uploadDisabled: n,
      uploadFiles: d,
      uploadRef: f,
      submit: c,
      clearFiles: i
    };
  },
  render() {
    var e, t;
    let n;
    this.showFileList ? n = et(B7, {
      disabled: this.uploadDisabled,
      listType: this.listType,
      files: this.uploadFiles,
      onRemove: this.handleRemove,
      handlePreview: this.onPreview
    }, this.$slots.file ? {
      default: (o) => this.$slots.file({
        file: o.file
      })
    } : null) : n = null;
    const r = {
      type: this.type,
      drag: this.drag,
      action: this.action,
      multiple: this.multiple,
      "before-upload": this.beforeUpload,
      "with-credentials": this.withCredentials,
      headers: this.headers,
      method: this.method,
      name: this.name,
      data: this.data,
      accept: this.accept,
      fileList: this.uploadFiles,
      autoUpload: this.autoUpload,
      listType: this.listType,
      disabled: this.uploadDisabled,
      limit: this.limit,
      "on-exceed": this.onExceed,
      "on-start": this.handleStart,
      "on-progress": this.handleProgress,
      "on-success": this.handleSuccess,
      "on-error": this.handleError,
      "on-preview": this.onPreview,
      "on-remove": this.handleRemove,
      "http-request": this.httpRequest,
      ref: "uploadRef"
    }, i = this.$slots.trigger || this.$slots.default, a = et(N7, r, {
      default: () => i == null ? void 0 : i()
    });
    return et("div", [
      this.listType === "picture-card" ? n : null,
      this.$slots.trigger ? [a, this.$slots.default()] : a,
      (t = (e = this.$slots).tip) == null ? void 0 : t.call(e),
      this.listType !== "picture-card" ? n : null
    ]);
  }
});
d0.install = (e) => {
  e.component(d0.name, d0);
};
const Tee = d0, yf = Tee, IT = ["success", "info", "warning", "error"], wee = Gt({
  customClass: {
    type: String,
    default: ""
  },
  center: {
    type: Boolean,
    default: !1
  },
  dangerouslyUseHTMLString: {
    type: Boolean,
    default: !1
  },
  duration: {
    type: Number,
    default: 3e3
  },
  icon: {
    type: ya,
    default: ""
  },
  id: {
    type: String,
    default: ""
  },
  message: {
    type: jt([String, Object]),
    default: ""
  },
  onClose: {
    type: jt(Function),
    required: !1
  },
  showClose: {
    type: Boolean,
    default: !1
  },
  type: {
    type: String,
    values: IT,
    default: "info"
  },
  offset: {
    type: Number,
    default: 20
  },
  zIndex: {
    type: Number,
    default: 0
  },
  grouping: {
    type: Boolean,
    default: !1
  },
  repeatNum: {
    type: Number,
    default: 1
  }
}), Pee = {
  destroy: () => !0
}, xee = Ee({
  name: "ElMessage",
  components: {
    ElBadge: Jb,
    ElIcon: qt,
    ...QF
  },
  props: wee,
  emits: Pee,
  setup(e) {
    const t = Ct("message"), n = j(!1), r = j(e.type ? e.type === "error" ? "danger" : e.type : "info");
    let i;
    const a = J(() => {
      const d = e.type;
      return { [t.bm("icon", d)]: d && A5[d] };
    }), o = J(() => e.icon || A5[e.type] || ""), s = J(() => ({
      top: `${e.offset}px`,
      zIndex: e.zIndex
    }));
    function l() {
      e.duration > 0 && ({ stop: i } = Nd(() => {
        n.value && c();
      }, e.duration));
    }
    function u() {
      i == null || i();
    }
    function c() {
      n.value = !1;
    }
    function f({ code: d }) {
      d === yt.esc ? n.value && c() : l();
    }
    return rn(() => {
      l(), n.value = !0;
    }), Ne(() => e.repeatNum, () => {
      u(), l();
    }), co(document, "keydown", f), {
      ns: t,
      typeClass: a,
      iconComponent: o,
      customStyle: s,
      visible: n,
      badgeType: r,
      close: c,
      clearTimer: u,
      startTimer: l
    };
  }
}), Cee = ["id"], See = ["innerHTML"];
function Eee(e, t, n, r, i, a) {
  const o = Ie("el-badge"), s = Ie("el-icon"), l = Ie("close");
  return P(), ue(wa, {
    name: e.ns.b("fade"),
    onBeforeLeave: e.onClose,
    onAfterLeave: t[2] || (t[2] = (u) => e.$emit("destroy"))
  }, {
    default: N(() => [
      Bt(T("div", {
        id: e.id,
        class: se([
          e.ns.b(),
          { [e.ns.m(e.type)]: e.type && !e.icon },
          e.ns.is("center", e.center),
          e.ns.is("closable", e.showClose),
          e.customClass
        ]),
        style: Pt(e.customStyle),
        role: "alert",
        onMouseenter: t[0] || (t[0] = (...u) => e.clearTimer && e.clearTimer(...u)),
        onMouseleave: t[1] || (t[1] = (...u) => e.startTimer && e.startTimer(...u))
      }, [
        e.repeatNum > 1 ? (P(), ue(o, {
          key: 0,
          value: e.repeatNum,
          type: e.badgeType,
          class: se(e.ns.e("badge"))
        }, null, 8, ["value", "type", "class"])) : re("v-if", !0),
        e.iconComponent ? (P(), ue(s, {
          key: 1,
          class: se([e.ns.e("icon"), e.typeClass])
        }, {
          default: N(() => [
            (P(), ue(Ln(e.iconComponent)))
          ]),
          _: 1
        }, 8, ["class"])) : re("v-if", !0),
        tt(e.$slots, "default", {}, () => [
          e.dangerouslyUseHTMLString ? (P(), L(nt, { key: 1 }, [
            re(" Caution here, message could've been compromised, never use user's input as message "),
            T("p", {
              class: se(e.ns.e("content")),
              innerHTML: e.message
            }, null, 10, See)
          ], 2112)) : (P(), L("p", {
            key: 0,
            class: se(e.ns.e("content"))
          }, de(e.message), 3))
        ]),
        e.showClose ? (P(), ue(s, {
          key: 2,
          class: se(e.ns.e("closeBtn")),
          onClick: wt(e.close, ["stop"])
        }, {
          default: N(() => [
            B(l)
          ]),
          _: 1
        }, 8, ["class", "onClick"])) : re("v-if", !0)
      ], 46, Cee), [
        [Cn, e.visible]
      ])
    ]),
    _: 3
  }, 8, ["name", "onBeforeLeave"]);
}
var kee = /* @__PURE__ */ vt(xee, [["render", Eee]]);
const Gr = [];
let Oee = 1;
const U0 = function(e = {}) {
  if (!Sn)
    return { close: () => {
    } };
  if (jn(X8.max) && Gr.length >= X8.max)
    return { close: () => {
    } };
  if (!id(e) && typeof e == "object" && e.grouping && !id(e.message) && Gr.length) {
    const c = Gr.find((f) => {
      var d, h, p;
      return `${(h = (d = f.vm.props) == null ? void 0 : d.message) != null ? h : ""}` == `${(p = e.message) != null ? p : ""}`;
    });
    if (c)
      return c.vm.component.props.repeatNum += 1, c.vm.component.props.type = e == null ? void 0 : e.type, {
        close: () => u.component.proxy.visible = !1
      };
  }
  (typeof e == "string" || id(e)) && (e = { message: e });
  let t = e.offset || 20;
  Gr.forEach(({ vm: c }) => {
    var f;
    t += (((f = c.el) == null ? void 0 : f.offsetHeight) || 0) + 16;
  }), t += 16;
  const { nextZIndex: n } = Xh(), r = `message_${Oee++}`, i = e.onClose, a = {
    zIndex: n(),
    offset: t,
    ...e,
    id: r,
    onClose: () => {
      zee(r, i);
    }
  };
  let o = document.body;
  e.appendTo instanceof HTMLElement ? o = e.appendTo : typeof e.appendTo == "string" && (o = document.querySelector(e.appendTo)), o instanceof HTMLElement || (fi("ElMessage", "the appendTo option is not an HTMLElement. Falling back to document.body."), o = document.body);
  const s = document.createElement("div");
  s.className = `container_${r}`;
  const l = a.message, u = B(kee, a, id(a.message) ? { default: () => l } : null);
  return u.props.onDestroy = () => {
    lv(null, s);
  }, lv(u, s), Gr.push({ vm: u }), o.appendChild(s.firstElementChild), {
    close: () => u.component.proxy.visible = !1
  };
};
IT.forEach((e) => {
  U0[e] = (t = {}) => ((typeof t == "string" || id(t)) && (t = {
    message: t
  }), U0({
    ...t,
    type: e
  }));
});
function zee(e, t) {
  const n = Gr.findIndex(({ vm: o }) => e === o.component.props.id);
  if (n === -1)
    return;
  const { vm: r } = Gr[n];
  if (!r)
    return;
  t == null || t(r);
  const i = r.el.offsetHeight;
  Gr.splice(n, 1);
  const a = Gr.length;
  if (!(a < 1))
    for (let o = n; o < a; o++) {
      const s = parseInt(Gr[o].vm.el.style.top, 10) - i - 16;
      Gr[o].vm.component.props.offset = s;
    }
}
function Dee() {
  var e;
  for (let t = Gr.length - 1; t >= 0; t--) {
    const n = Gr[t].vm.component;
    (e = n == null ? void 0 : n.proxy) == null || e.close();
  }
}
U0.closeAll = Dee;
const An = ZF(U0, "$message");
const LT = {};
LT.getData = (e) => new Promise((t, n) => {
  let r = {};
  Mee(e).then((i) => {
    r.arrayBuffer = i, r.orientation = Bee(i), t(r);
  }).catch((i) => {
    n(i);
  });
});
function Mee(e) {
  let t = null;
  return new Promise((n, r) => {
    if (e.src)
      if (/^data\:/i.test(e.src))
        t = Iee(e.src), n(t);
      else if (/^blob\:/i.test(e.src)) {
        var i = new FileReader();
        i.onload = function(o) {
          t = o.target.result, n(t);
        }, Hee(e.src, function(o) {
          i.readAsArrayBuffer(o);
        });
      } else {
        var a = new XMLHttpRequest();
        a.onload = function() {
          if (this.status == 200 || this.status === 0)
            t = a.response, n(t);
          else
            throw "Could not load image";
          a = null;
        }, a.open("GET", e.src, !0), a.responseType = "arraybuffer", a.send(null);
      }
    else
      r("img error");
  });
}
function Hee(e, t) {
  var n = new XMLHttpRequest();
  n.open("GET", e, !0), n.responseType = "blob", n.onload = function(r) {
    (this.status == 200 || this.status === 0) && t(this.response);
  }, n.send();
}
function Iee(e) {
  e = e.replace(/^data\:([^\;]+)\;base64,/gmi, "");
  for (var t = atob(e), n = t.length, r = new ArrayBuffer(n), i = new Uint8Array(r), a = 0; a < n; a++)
    i[a] = t.charCodeAt(a);
  return r;
}
function Lee(e, t, n) {
  var r = "", i;
  for (i = t, n += t; i < n; i++)
    r += String.fromCharCode(e.getUint8(i));
  return r;
}
function Bee(e) {
  var t = new DataView(e), n = t.byteLength, r, i, a, o, s, l, u, c, f, d;
  if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
    for (f = 2; f < n; ) {
      if (t.getUint8(f) === 255 && t.getUint8(f + 1) === 225) {
        u = f;
        break;
      }
      f++;
    }
  if (u && (i = u + 4, a = u + 10, Lee(t, i, 4) === "Exif" && (l = t.getUint16(a), s = l === 18761, (s || l === 19789) && t.getUint16(a + 2, s) === 42 && (o = t.getUint32(a + 4, s), o >= 8 && (c = a + o)))), c) {
    for (n = t.getUint16(c, s), d = 0; d < n; d++)
      if (f = c + d * 12 + 2, t.getUint16(f, s) === 274) {
        f += 8, r = t.getUint16(f, s);
        break;
      }
  }
  return r;
}
var Nee = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
};
const jee = Ee({
  data: function() {
    return {
      w: 0,
      h: 0,
      scale: 1,
      x: 0,
      y: 0,
      loading: !0,
      trueWidth: 0,
      trueHeight: 0,
      move: !0,
      moveX: 0,
      moveY: 0,
      crop: !1,
      cropping: !1,
      cropW: 0,
      cropH: 0,
      cropOldW: 0,
      cropOldH: 0,
      canChangeX: !1,
      canChangeY: !1,
      changeCropTypeX: 1,
      changeCropTypeY: 1,
      cropX: 0,
      cropY: 0,
      cropChangeX: 0,
      cropChangeY: 0,
      cropOffsertX: 0,
      cropOffsertY: 0,
      support: "",
      touches: [],
      touchNow: !1,
      rotate: 0,
      isIos: !1,
      orientation: 0,
      imgs: "",
      coe: 0.2,
      scaling: !1,
      scalingSet: "",
      coeStatus: "",
      isCanShow: !0
    };
  },
  props: {
    img: {
      type: [String, Blob, null, File],
      default: ""
    },
    outputSize: {
      type: Number,
      default: 1
    },
    outputType: {
      type: String,
      default: "jpeg"
    },
    info: {
      type: Boolean,
      default: !0
    },
    canScale: {
      type: Boolean,
      default: !0
    },
    autoCrop: {
      type: Boolean,
      default: !1
    },
    autoCropWidth: {
      type: [Number, String],
      default: 0
    },
    autoCropHeight: {
      type: [Number, String],
      default: 0
    },
    fixed: {
      type: Boolean,
      default: !1
    },
    fixedNumber: {
      type: Array,
      default: () => [1, 1]
    },
    fixedBox: {
      type: Boolean,
      default: !1
    },
    full: {
      type: Boolean,
      default: !1
    },
    canMove: {
      type: Boolean,
      default: !0
    },
    canMoveBox: {
      type: Boolean,
      default: !0
    },
    original: {
      type: Boolean,
      default: !1
    },
    centerBox: {
      type: Boolean,
      default: !1
    },
    high: {
      type: Boolean,
      default: !0
    },
    infoTrue: {
      type: Boolean,
      default: !1
    },
    maxImgSize: {
      type: [Number, String],
      default: 2e3
    },
    enlarge: {
      type: [Number, String],
      default: 1
    },
    preW: {
      type: [Number, String],
      default: 0
    },
    mode: {
      type: String,
      default: "contain"
    },
    limitMinSize: {
      type: [Number, Array, String],
      default: () => 10
    }
  },
  computed: {
    cropInfo() {
      let e = {};
      if (e.top = this.cropOffsertY > 21 ? "-21px" : "0px", e.width = this.cropW > 0 ? this.cropW : 0, e.height = this.cropH > 0 ? this.cropH : 0, this.infoTrue) {
        let t = 1;
        this.high && !this.full && (t = window.devicePixelRatio), this.enlarge !== 1 & !this.full && (t = Math.abs(Number(this.enlarge))), e.width = e.width * t, e.height = e.height * t, this.full && (e.width = e.width / this.scale, e.height = e.height / this.scale);
      }
      return e.width = e.width.toFixed(0), e.height = e.height.toFixed(0), e;
    },
    isIE() {
      return !!window.ActiveXObject || "ActiveXObject" in window;
    },
    passive() {
      return this.isIE ? null : {
        passive: !1
      };
    }
  },
  watch: {
    img() {
      this.checkedImg();
    },
    imgs(e) {
      e !== "" && this.reload();
    },
    cropW() {
      this.showPreview();
    },
    cropH() {
      this.showPreview();
    },
    cropOffsertX() {
      this.showPreview();
    },
    cropOffsertY() {
      this.showPreview();
    },
    scale(e, t) {
      this.showPreview();
    },
    x() {
      this.showPreview();
    },
    y() {
      this.showPreview();
    },
    autoCrop(e) {
      e && this.goAutoCrop();
    },
    autoCropWidth() {
      this.autoCrop && this.goAutoCrop();
    },
    autoCropHeight() {
      this.autoCrop && this.goAutoCrop();
    },
    mode() {
      this.checkedImg();
    },
    rotate() {
      this.showPreview(), this.autoCrop ? this.goAutoCrop(this.cropW, this.cropH) : (this.cropW > 0 || this.cropH > 0) && this.goAutoCrop(this.cropW, this.cropH);
    }
  },
  methods: {
    getVersion(e) {
      var t = navigator.userAgent.split(" "), n = "";
      let r = 0;
      const i = new RegExp(e, "i");
      for (var a = 0; a < t.length; a++)
        i.test(t[a]) && (n = t[a]);
      return n ? r = n.split("/")[1].split(".") : r = ["0", "0", "0"], r;
    },
    checkOrientationImage(e, t, n, r) {
      if (this.getVersion("chrome")[0] >= 81)
        t = -1;
      else if (this.getVersion("safari")[0] >= 605) {
        const o = this.getVersion("version");
        o[0] > 13 && o[1] > 1 && (t = -1);
      } else {
        const o = navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/);
        if (o) {
          let s = o[1];
          s = s.split("_"), (s[0] > 13 || s[0] >= 13 && s[1] >= 4) && (t = -1);
        }
      }
      let i = document.createElement("canvas"), a = i.getContext("2d");
      switch (a.save(), t) {
        case 2:
          i.width = n, i.height = r, a.translate(n, 0), a.scale(-1, 1);
          break;
        case 3:
          i.width = n, i.height = r, a.translate(n / 2, r / 2), a.rotate(180 * Math.PI / 180), a.translate(-n / 2, -r / 2);
          break;
        case 4:
          i.width = n, i.height = r, a.translate(0, r), a.scale(1, -1);
          break;
        case 5:
          i.height = n, i.width = r, a.rotate(0.5 * Math.PI), a.scale(1, -1);
          break;
        case 6:
          i.width = r, i.height = n, a.translate(r / 2, n / 2), a.rotate(90 * Math.PI / 180), a.translate(-n / 2, -r / 2);
          break;
        case 7:
          i.height = n, i.width = r, a.rotate(0.5 * Math.PI), a.translate(n, -r), a.scale(-1, 1);
          break;
        case 8:
          i.height = n, i.width = r, a.translate(r / 2, n / 2), a.rotate(-90 * Math.PI / 180), a.translate(-n / 2, -r / 2);
          break;
        default:
          i.width = n, i.height = r;
      }
      a.drawImage(e, 0, 0, n, r), a.restore(), i.toBlob((o) => {
        let s = URL.createObjectURL(o);
        URL.revokeObjectURL(this.imgs), this.imgs = s;
      }, "image/" + this.outputType, 1);
    },
    checkedImg() {
      if (this.img === null || this.img === "") {
        this.imgs = "", this.clearCrop();
        return;
      }
      this.loading = !0, this.scale = 1, this.rotate = 0, this.clearCrop();
      let e = new Image();
      if (e.onload = () => {
        if (this.img === "")
          return this.$emit("img-load", "error"), !1;
        let n = e.width, r = e.height;
        LT.getData(e).then((i) => {
          this.orientation = i.orientation || 1;
          let a = Number(this.maxImgSize);
          if (!this.orientation && n < a & r < a) {
            this.imgs = this.img;
            return;
          }
          n > a && (r = r / n * a, n = a), r > a && (n = n / r * a, r = a), this.checkOrientationImage(e, this.orientation, n, r);
        });
      }, e.onerror = () => {
        this.$emit("img-load", "error");
      }, this.img.substr(0, 4) !== "data" && (e.crossOrigin = ""), this.isIE) {
        var t = new XMLHttpRequest();
        t.onload = function() {
          var n = URL.createObjectURL(this.response);
          e.src = n;
        }, t.open("GET", this.img, !0), t.responseType = "blob", t.send();
      } else
        e.src = this.img;
    },
    startMove(e) {
      if (e.preventDefault(), this.move && !this.crop) {
        if (!this.canMove)
          return !1;
        this.moveX = ("clientX" in e ? e.clientX : e.touches[0].clientX) - this.x, this.moveY = ("clientY" in e ? e.clientY : e.touches[0].clientY) - this.y, e.touches ? (window.addEventListener("touchmove", this.moveImg), window.addEventListener("touchend", this.leaveImg), e.touches.length == 2 && (this.touches = e.touches, window.addEventListener("touchmove", this.touchScale), window.addEventListener("touchend", this.cancelTouchScale))) : (window.addEventListener("mousemove", this.moveImg), window.addEventListener("mouseup", this.leaveImg)), this.$emit("imgMoving", {
          moving: !0,
          axis: this.getImgAxis()
        }), this.$emit("img-moving", {
          moving: !0,
          axis: this.getImgAxis()
        });
      } else
        this.cropping = !0, window.addEventListener("mousemove", this.createCrop), window.addEventListener("mouseup", this.endCrop), window.addEventListener("touchmove", this.createCrop), window.addEventListener("touchend", this.endCrop), this.cropOffsertX = e.offsetX ? e.offsetX : e.touches[0].pageX - this.$refs.cropper.offsetLeft, this.cropOffsertY = e.offsetY ? e.offsetY : e.touches[0].pageY - this.$refs.cropper.offsetTop, this.cropX = "clientX" in e ? e.clientX : e.touches[0].clientX, this.cropY = "clientY" in e ? e.clientY : e.touches[0].clientY, this.cropChangeX = this.cropOffsertX, this.cropChangeY = this.cropOffsertY, this.cropW = 0, this.cropH = 0;
    },
    touchScale(e) {
      e.preventDefault();
      let t = this.scale;
      var n = {
        x: this.touches[0].clientX,
        y: this.touches[0].clientY
      }, r = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      }, i = {
        x: this.touches[1].clientX,
        y: this.touches[1].clientY
      }, a = {
        x: e.touches[1].clientX,
        y: e.touches[1].clientY
      }, o = Math.sqrt(Math.pow(n.x - i.x, 2) + Math.pow(n.y - i.y, 2)), s = Math.sqrt(Math.pow(r.x - a.x, 2) + Math.pow(r.y - a.y, 2)), l = s - o, u = 1;
      u = u / this.trueWidth > u / this.trueHeight ? u / this.trueHeight : u / this.trueWidth, u = u > 0.1 ? 0.1 : u;
      var c = u * l;
      if (!this.touchNow) {
        if (this.touchNow = !0, l > 0 ? t += Math.abs(c) : l < 0 && t > Math.abs(c) && (t -= Math.abs(c)), this.touches = e.touches, setTimeout(() => {
          this.touchNow = !1;
        }, 8), !this.checkoutImgAxis(this.x, this.y, t))
          return !1;
        this.scale = t;
      }
    },
    cancelTouchScale(e) {
      window.removeEventListener("touchmove", this.touchScale);
    },
    moveImg(e) {
      if (e.preventDefault(), e.touches && e.touches.length === 2)
        return this.touches = e.touches, window.addEventListener("touchmove", this.touchScale), window.addEventListener("touchend", this.cancelTouchScale), window.removeEventListener("touchmove", this.moveImg), !1;
      let t = "clientX" in e ? e.clientX : e.touches[0].clientX, n = "clientY" in e ? e.clientY : e.touches[0].clientY, r, i;
      r = t - this.moveX, i = n - this.moveY, this.$nextTick(() => {
        if (this.centerBox) {
          let a = this.getImgAxis(r, i, this.scale), o = this.getCropAxis(), s = this.trueHeight * this.scale, l = this.trueWidth * this.scale, u, c, f, d;
          switch (this.rotate) {
            case 1:
            case -1:
            case 3:
            case -3:
              u = this.cropOffsertX - this.trueWidth * (1 - this.scale) / 2 + (s - l) / 2, c = this.cropOffsertY - this.trueHeight * (1 - this.scale) / 2 + (l - s) / 2, f = u - s + this.cropW, d = c - l + this.cropH;
              break;
            default:
              u = this.cropOffsertX - this.trueWidth * (1 - this.scale) / 2, c = this.cropOffsertY - this.trueHeight * (1 - this.scale) / 2, f = u - l + this.cropW, d = c - s + this.cropH;
              break;
          }
          a.x1 >= o.x1 && (r = u), a.y1 >= o.y1 && (i = c), a.x2 <= o.x2 && (r = f), a.y2 <= o.y2 && (i = d);
        }
        this.x = r, this.y = i, this.$emit("imgMoving", {
          moving: !0,
          axis: this.getImgAxis()
        }), this.$emit("img-moving", {
          moving: !0,
          axis: this.getImgAxis()
        });
      });
    },
    leaveImg(e) {
      window.removeEventListener("mousemove", this.moveImg), window.removeEventListener("touchmove", this.moveImg), window.removeEventListener("mouseup", this.leaveImg), window.removeEventListener("touchend", this.leaveImg), this.$emit("imgMoving", {
        moving: !1,
        axis: this.getImgAxis()
      }), this.$emit("img-moving", {
        moving: !1,
        axis: this.getImgAxis()
      });
    },
    scaleImg() {
      this.canScale && window.addEventListener(this.support, this.changeSize, this.passive);
    },
    cancelScale() {
      this.canScale && window.removeEventListener(this.support, this.changeSize);
    },
    changeSize(e) {
      e.preventDefault();
      let t = this.scale;
      var n = e.deltaY || e.wheelDelta, r = navigator.userAgent.indexOf("Firefox");
      n = r > 0 ? n * 30 : n, this.isIE && (n = -n);
      var i = this.coe;
      i = i / this.trueWidth > i / this.trueHeight ? i / this.trueHeight : i / this.trueWidth;
      var a = i * n;
      a < 0 ? t += Math.abs(a) : t > Math.abs(a) && (t -= Math.abs(a));
      let o = a < 0 ? "add" : "reduce";
      if (o !== this.coeStatus && (this.coeStatus = o, this.coe = 0.2), this.scaling || (this.scalingSet = setTimeout(() => {
        this.scaling = !1, this.coe = this.coe += 0.01;
      }, 50)), this.scaling = !0, !this.checkoutImgAxis(this.x, this.y, t))
        return !1;
      this.scale = t;
    },
    changeScale(e) {
      let t = this.scale;
      e = e || 1;
      var n = 20;
      if (n = n / this.trueWidth > n / this.trueHeight ? n / this.trueHeight : n / this.trueWidth, e = e * n, e > 0 ? t += Math.abs(e) : t > Math.abs(e) && (t -= Math.abs(e)), !this.checkoutImgAxis(this.x, this.y, t))
        return !1;
      this.scale = t;
    },
    createCrop(e) {
      e.preventDefault();
      var t = "clientX" in e ? e.clientX : e.touches ? e.touches[0].clientX : 0, n = "clientY" in e ? e.clientY : e.touches ? e.touches[0].clientY : 0;
      this.$nextTick(() => {
        var r = t - this.cropX, i = n - this.cropY;
        if (r > 0 ? (this.cropW = r + this.cropChangeX > this.w ? this.w - this.cropChangeX : r, this.cropOffsertX = this.cropChangeX) : (this.cropW = this.w - this.cropChangeX + Math.abs(r) > this.w ? this.cropChangeX : Math.abs(r), this.cropOffsertX = this.cropChangeX + r > 0 ? this.cropChangeX + r : 0), !this.fixed)
          i > 0 ? (this.cropH = i + this.cropChangeY > this.h ? this.h - this.cropChangeY : i, this.cropOffsertY = this.cropChangeY) : (this.cropH = this.h - this.cropChangeY + Math.abs(i) > this.h ? this.cropChangeY : Math.abs(i), this.cropOffsertY = this.cropChangeY + i > 0 ? this.cropChangeY + i : 0);
        else {
          var a = this.cropW / this.fixedNumber[0] * this.fixedNumber[1];
          a + this.cropOffsertY > this.h ? (this.cropH = this.h - this.cropOffsertY, this.cropW = this.cropH / this.fixedNumber[1] * this.fixedNumber[0], r > 0 ? this.cropOffsertX = this.cropChangeX : this.cropOffsertX = this.cropChangeX - this.cropW) : this.cropH = a, this.cropOffsertY = this.cropOffsertY;
        }
      });
    },
    changeCropSize(e, t, n, r, i) {
      e.preventDefault(), window.addEventListener("mousemove", this.changeCropNow), window.addEventListener("mouseup", this.changeCropEnd), window.addEventListener("touchmove", this.changeCropNow), window.addEventListener("touchend", this.changeCropEnd), this.canChangeX = t, this.canChangeY = n, this.changeCropTypeX = r, this.changeCropTypeY = i, this.cropX = "clientX" in e ? e.clientX : e.touches[0].clientX, this.cropY = "clientY" in e ? e.clientY : e.touches[0].clientY, this.cropOldW = this.cropW, this.cropOldH = this.cropH, this.cropChangeX = this.cropOffsertX, this.cropChangeY = this.cropOffsertY, this.fixed && this.canChangeX && this.canChangeY && (this.canChangeY = 0), this.$emit("change-crop-size", {
        width: this.cropW,
        height: this.cropH
      });
    },
    changeCropNow(e) {
      e.preventDefault();
      var t = "clientX" in e ? e.clientX : e.touches ? e.touches[0].clientX : 0, n = "clientY" in e ? e.clientY : e.touches ? e.touches[0].clientY : 0;
      let r = this.w, i = this.h, a = 0, o = 0;
      if (this.centerBox) {
        let s = this.getImgAxis(), l = s.x2, u = s.y2;
        a = s.x1 > 0 ? s.x1 : 0, o = s.y1 > 0 ? s.y1 : 0, r > l && (r = l), i > u && (i = u);
      }
      this.$nextTick(() => {
        var s = t - this.cropX, l = n - this.cropY;
        if (this.canChangeX && (this.changeCropTypeX === 1 ? this.cropOldW - s > 0 ? (this.cropW = r - this.cropChangeX - s <= r - a ? this.cropOldW - s : this.cropOldW + this.cropChangeX - a, this.cropOffsertX = r - this.cropChangeX - s <= r - a ? this.cropChangeX + s : a) : (this.cropW = Math.abs(s) + this.cropChangeX <= r ? Math.abs(s) - this.cropOldW : r - this.cropOldW - this.cropChangeX, this.cropOffsertX = this.cropChangeX + this.cropOldW) : this.changeCropTypeX === 2 && (this.cropOldW + s > 0 ? (this.cropW = this.cropOldW + s + this.cropOffsertX <= r ? this.cropOldW + s : r - this.cropOffsertX, this.cropOffsertX = this.cropChangeX) : (this.cropW = r - this.cropChangeX + Math.abs(s + this.cropOldW) <= r - a ? Math.abs(s + this.cropOldW) : this.cropChangeX - a, this.cropOffsertX = r - this.cropChangeX + Math.abs(s + this.cropOldW) <= r - a ? this.cropChangeX - Math.abs(s + this.cropOldW) : a))), this.canChangeY && (this.changeCropTypeY === 1 ? this.cropOldH - l > 0 ? (this.cropH = i - this.cropChangeY - l <= i - o ? this.cropOldH - l : this.cropOldH + this.cropChangeY - o, this.cropOffsertY = i - this.cropChangeY - l <= i - o ? this.cropChangeY + l : o) : (this.cropH = Math.abs(l) + this.cropChangeY <= i ? Math.abs(l) - this.cropOldH : i - this.cropOldH - this.cropChangeY, this.cropOffsertY = this.cropChangeY + this.cropOldH) : this.changeCropTypeY === 2 && (this.cropOldH + l > 0 ? (this.cropH = this.cropOldH + l + this.cropOffsertY <= i ? this.cropOldH + l : i - this.cropOffsertY, this.cropOffsertY = this.cropChangeY) : (this.cropH = i - this.cropChangeY + Math.abs(l + this.cropOldH) <= i - o ? Math.abs(l + this.cropOldH) : this.cropChangeY - o, this.cropOffsertY = i - this.cropChangeY + Math.abs(l + this.cropOldH) <= i - o ? this.cropChangeY - Math.abs(l + this.cropOldH) : o))), this.canChangeX && this.fixed) {
          var u = this.cropW / this.fixedNumber[0] * this.fixedNumber[1];
          u + this.cropOffsertY > i ? (this.cropH = i - this.cropOffsertY, this.cropW = this.cropH / this.fixedNumber[1] * this.fixedNumber[0]) : this.cropH = u;
        }
        if (this.canChangeY && this.fixed) {
          var c = this.cropH / this.fixedNumber[1] * this.fixedNumber[0];
          c + this.cropOffsertX > r ? (this.cropW = r - this.cropOffsertX, this.cropH = this.cropW / this.fixedNumber[0] * this.fixedNumber[1]) : this.cropW = c;
        }
      });
    },
    checkCropLimitSize() {
      let { cropW: e, cropH: t, limitMinSize: n } = this, r = new Array();
      return Array.isArray[n] ? r = n : r = [n, n], e = parseFloat(r[0]), t = parseFloat(r[1]), [e, t];
    },
    changeCropEnd(e) {
      window.removeEventListener("mousemove", this.changeCropNow), window.removeEventListener("mouseup", this.changeCropEnd), window.removeEventListener("touchmove", this.changeCropNow), window.removeEventListener("touchend", this.changeCropEnd);
    },
    endCrop() {
      this.cropW === 0 && this.cropH === 0 && (this.cropping = !1), window.removeEventListener("mousemove", this.createCrop), window.removeEventListener("mouseup", this.endCrop), window.removeEventListener("touchmove", this.createCrop), window.removeEventListener("touchend", this.endCrop);
    },
    startCrop() {
      this.crop = !0;
    },
    stopCrop() {
      this.crop = !1;
    },
    clearCrop() {
      this.cropping = !1, this.cropW = 0, this.cropH = 0;
    },
    cropMove(e) {
      if (e.preventDefault(), !this.canMoveBox)
        return this.crop = !1, this.startMove(e), !1;
      if (e.touches && e.touches.length === 2)
        return this.crop = !1, this.startMove(e), this.leaveCrop(), !1;
      window.addEventListener("mousemove", this.moveCrop), window.addEventListener("mouseup", this.leaveCrop), window.addEventListener("touchmove", this.moveCrop), window.addEventListener("touchend", this.leaveCrop);
      let t = "clientX" in e ? e.clientX : e.touches[0].clientX, n = "clientY" in e ? e.clientY : e.touches[0].clientY, r, i;
      r = t - this.cropOffsertX, i = n - this.cropOffsertY, this.cropX = r, this.cropY = i, this.$emit("cropMoving", {
        moving: !0,
        axis: this.getCropAxis()
      }), this.$emit("crop-moving", {
        moving: !0,
        axis: this.getCropAxis()
      });
    },
    moveCrop(e, t) {
      let n = 0, r = 0;
      e && (e.preventDefault(), n = "clientX" in e ? e.clientX : e.touches[0].clientX, r = "clientY" in e ? e.clientY : e.touches[0].clientY), this.$nextTick(() => {
        let i, a, o = n - this.cropX, s = r - this.cropY;
        if (t && (o = this.cropOffsertX, s = this.cropOffsertY), o <= 0 ? i = 0 : o + this.cropW > this.w ? i = this.w - this.cropW : i = o, s <= 0 ? a = 0 : s + this.cropH > this.h ? a = this.h - this.cropH : a = s, this.centerBox) {
          let l = this.getImgAxis();
          i <= l.x1 && (i = l.x1), i + this.cropW > l.x2 && (i = l.x2 - this.cropW), a <= l.y1 && (a = l.y1), a + this.cropH > l.y2 && (a = l.y2 - this.cropH);
        }
        this.cropOffsertX = i, this.cropOffsertY = a, this.$emit("cropMoving", {
          moving: !0,
          axis: this.getCropAxis()
        }), this.$emit("crop-moving", {
          moving: !0,
          axis: this.getCropAxis()
        });
      });
    },
    getImgAxis(e, t, n) {
      e = e || this.x, t = t || this.y, n = n || this.scale;
      let r = {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0
      }, i = this.trueWidth * n, a = this.trueHeight * n;
      switch (this.rotate) {
        case 0:
          r.x1 = e + this.trueWidth * (1 - n) / 2, r.x2 = r.x1 + this.trueWidth * n, r.y1 = t + this.trueHeight * (1 - n) / 2, r.y2 = r.y1 + this.trueHeight * n;
          break;
        case 1:
        case -1:
        case 3:
        case -3:
          r.x1 = e + this.trueWidth * (1 - n) / 2 + (i - a) / 2, r.x2 = r.x1 + this.trueHeight * n, r.y1 = t + this.trueHeight * (1 - n) / 2 + (a - i) / 2, r.y2 = r.y1 + this.trueWidth * n;
          break;
        default:
          r.x1 = e + this.trueWidth * (1 - n) / 2, r.x2 = r.x1 + this.trueWidth * n, r.y1 = t + this.trueHeight * (1 - n) / 2, r.y2 = r.y1 + this.trueHeight * n;
          break;
      }
      return r;
    },
    getCropAxis() {
      let e = {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0
      };
      return e.x1 = this.cropOffsertX, e.x2 = e.x1 + this.cropW, e.y1 = this.cropOffsertY, e.y2 = e.y1 + this.cropH, e;
    },
    leaveCrop(e) {
      window.removeEventListener("mousemove", this.moveCrop), window.removeEventListener("mouseup", this.leaveCrop), window.removeEventListener("touchmove", this.moveCrop), window.removeEventListener("touchend", this.leaveCrop), this.$emit("cropMoving", {
        moving: !1,
        axis: this.getCropAxis()
      }), this.$emit("crop-moving", {
        moving: !1,
        axis: this.getCropAxis()
      });
    },
    getCropChecked(e) {
      let t = document.createElement("canvas"), n = new Image(), r = this.rotate, i = this.trueWidth, a = this.trueHeight, o = this.cropOffsertX, s = this.cropOffsertY;
      n.onload = () => {
        if (this.cropW !== 0) {
          let c = t.getContext("2d"), f = 1;
          this.high & !this.full && (f = window.devicePixelRatio), this.enlarge !== 1 & !this.full && (f = Math.abs(Number(this.enlarge)));
          let d = this.cropW * f, h = this.cropH * f, p = i * this.scale * f, y = a * this.scale * f, m = (this.x - o + this.trueWidth * (1 - this.scale) / 2) * f, b = (this.y - s + this.trueHeight * (1 - this.scale) / 2) * f;
          switch (u(d, h), c.save(), r) {
            case 0:
              this.full ? (u(d / this.scale, h / this.scale), c.drawImage(n, m / this.scale, b / this.scale, p / this.scale, y / this.scale)) : c.drawImage(n, m, b, p, y);
              break;
            case 1:
            case -3:
              this.full ? (u(d / this.scale, h / this.scale), m = m / this.scale + (p / this.scale - y / this.scale) / 2, b = b / this.scale + (y / this.scale - p / this.scale) / 2, c.rotate(r * 90 * Math.PI / 180), c.drawImage(n, b, -m - y / this.scale, p / this.scale, y / this.scale)) : (m = m + (p - y) / 2, b = b + (y - p) / 2, c.rotate(r * 90 * Math.PI / 180), c.drawImage(n, b, -m - y, p, y));
              break;
            case 2:
            case -2:
              this.full ? (u(d / this.scale, h / this.scale), c.rotate(r * 90 * Math.PI / 180), m = m / this.scale, b = b / this.scale, c.drawImage(n, -m - p / this.scale, -b - y / this.scale, p / this.scale, y / this.scale)) : (c.rotate(r * 90 * Math.PI / 180), c.drawImage(n, -m - p, -b - y, p, y));
              break;
            case 3:
            case -1:
              this.full ? (u(d / this.scale, h / this.scale), m = m / this.scale + (p / this.scale - y / this.scale) / 2, b = b / this.scale + (y / this.scale - p / this.scale) / 2, c.rotate(r * 90 * Math.PI / 180), c.drawImage(n, -b - p / this.scale, m, p / this.scale, y / this.scale)) : (m = m + (p - y) / 2, b = b + (y - p) / 2, c.rotate(r * 90 * Math.PI / 180), c.drawImage(n, -b - p, m, p, y));
              break;
            default:
              this.full ? (u(d / this.scale, h / this.scale), c.drawImage(n, m / this.scale, b / this.scale, p / this.scale, y / this.scale)) : c.drawImage(n, m, b, p, y);
          }
          c.restore();
        } else {
          let c = i * this.scale, f = a * this.scale, d = t.getContext("2d");
          switch (d.save(), r) {
            case 0:
              u(c, f), d.drawImage(n, 0, 0, c, f);
              break;
            case 1:
            case -3:
              u(f, c), d.rotate(r * 90 * Math.PI / 180), d.drawImage(n, 0, -f, c, f);
              break;
            case 2:
            case -2:
              u(c, f), d.rotate(r * 90 * Math.PI / 180), d.drawImage(n, -c, -f, c, f);
              break;
            case 3:
            case -1:
              u(f, c), d.rotate(r * 90 * Math.PI / 180), d.drawImage(n, -c, 0, c, f);
              break;
            default:
              u(c, f), d.drawImage(n, 0, 0, c, f);
          }
          d.restore();
        }
        e(t);
      };
      var l = this.img.substr(0, 4);
      l !== "data" && (n.crossOrigin = "Anonymous"), n.src = this.imgs;
      function u(c, f) {
        t.width = Math.round(c), t.height = Math.round(f);
      }
    },
    getCropData(e) {
      this.getCropChecked((t) => {
        e(t.toDataURL("image/" + this.outputType, this.outputSize));
      });
    },
    getCropBlob(e) {
      this.getCropChecked((t) => {
        t.toBlob((n) => e(n), "image/" + this.outputType, this.outputSize);
      });
    },
    showPreview() {
      if (this.isCanShow)
        this.isCanShow = !1, setTimeout(() => {
          this.isCanShow = !0;
        }, 16);
      else
        return !1;
      let e = this.cropW, t = this.cropH, n = this.scale;
      var r = {};
      r.div = {
        width: `${e}px`,
        height: `${t}px`
      };
      let i = (this.x - this.cropOffsertX) / n, a = (this.y - this.cropOffsertY) / n, o = 0;
      r.w = e, r.h = t, r.url = this.imgs, r.img = {
        width: `${this.trueWidth}px`,
        height: `${this.trueHeight}px`,
        transform: `scale(${n})translate3d(${i}px, ${a}px, ${o}px)rotateZ(${this.rotate * 90}deg)`
      }, r.html = `
      <div class="show-preview" style="width: ${r.w}px; height: ${r.h}px,; overflow: hidden">
        <div style="width: ${e}px; height: ${t}px">
          <img src=${r.url} style="width: ${this.trueWidth}px; height: ${this.trueHeight}px; transform:
          scale(${n})translate3d(${i}px, ${a}px, ${o}px)rotateZ(${this.rotate * 90}deg)">
        </div>
      </div>`, this.$emit("realTime", r), this.$emit("real-time", r);
    },
    reload() {
      let e = new Image();
      e.onload = () => {
        this.w = parseFloat(window.getComputedStyle(this.$refs.cropper).width), this.h = parseFloat(window.getComputedStyle(this.$refs.cropper).height), this.trueWidth = e.width, this.trueHeight = e.height, this.original ? this.scale = 1 : this.scale = this.checkedMode(), this.$nextTick(() => {
          this.x = -(this.trueWidth - this.trueWidth * this.scale) / 2 + (this.w - this.trueWidth * this.scale) / 2, this.y = -(this.trueHeight - this.trueHeight * this.scale) / 2 + (this.h - this.trueHeight * this.scale) / 2, this.loading = !1, this.autoCrop && this.goAutoCrop(), this.$emit("img-load", "success"), this.$emit("imgLoad", "success"), setTimeout(() => {
            this.showPreview();
          }, 20);
        });
      }, e.onerror = () => {
        this.$emit("imgLoad", "error"), this.$emit("img-load", "error");
      }, e.src = this.imgs;
    },
    checkedMode() {
      let e = 1, t = this.trueWidth, n = this.trueHeight;
      const r = this.mode.split(" ");
      switch (r[0]) {
        case "contain":
          this.trueWidth > this.w && (e = this.w / this.trueWidth), this.trueHeight * e > this.h && (e = this.h / this.trueHeight);
          break;
        case "cover":
          t = this.w, e = t / this.trueWidth, n = n * e, n < this.h && (n = this.h, e = n / this.trueHeight);
          break;
        default:
          try {
            let i = r[0];
            if (i.search("px") !== -1) {
              i = i.replace("px", ""), t = parseFloat(i);
              const a = t / this.trueWidth;
              let o = 1, s = r[1];
              s.search("px") !== -1 && (s = s.replace("px", ""), n = parseFloat(s), o = n / this.trueHeight), e = Math.min(a, o);
            }
            if (i.search("%") !== -1 && (i = i.replace("%", ""), t = parseFloat(i) / 100 * this.w, e = t / this.trueWidth), r.length === 2 && i === "auto") {
              let a = r[1];
              a.search("px") !== -1 && (a = a.replace("px", ""), n = parseFloat(a), e = n / this.trueHeight), a.search("%") !== -1 && (a = a.replace("%", ""), n = parseFloat(a) / 100 * this.h, e = n / this.trueHeight);
            }
          } catch {
            e = 1;
          }
      }
      return e;
    },
    goAutoCrop(e, t) {
      if (this.imgs === "" || this.imgs === null)
        return;
      this.clearCrop(), this.cropping = !0;
      let n = this.w, r = this.h;
      if (this.centerBox) {
        const o = Math.abs(this.rotate) % 2 > 0;
        let s = (o ? this.trueHeight : this.trueWidth) * this.scale, l = (o ? this.trueWidth : this.trueHeight) * this.scale;
        n = s < n ? s : n, r = l < r ? l : r;
      }
      var i = e || parseFloat(this.autoCropWidth), a = t || parseFloat(this.autoCropHeight);
      (i === 0 || a === 0) && (i = n * 0.8, a = r * 0.8), i = i > n ? n : i, a = a > r ? r : a, this.fixed && (a = i / this.fixedNumber[0] * this.fixedNumber[1]), a > this.h && (a = this.h, i = a / this.fixedNumber[1] * this.fixedNumber[0]), this.changeCrop(i, a);
    },
    changeCrop(e, t) {
      if (this.centerBox) {
        let n = this.getImgAxis();
        e > n.x2 - n.x1 && (e = n.x2 - n.x1, t = e / this.fixedNumber[0] * this.fixedNumber[1]), t > n.y2 - n.y1 && (t = n.y2 - n.y1, e = t / this.fixedNumber[1] * this.fixedNumber[0]);
      }
      this.cropW = e, this.cropH = t, this.checkCropLimitSize(), this.$nextTick(() => {
        this.cropOffsertX = (this.w - this.cropW) / 2, this.cropOffsertY = (this.h - this.cropH) / 2, this.centerBox && this.moveCrop(null, !0);
      });
    },
    refresh() {
      this.img, this.imgs = "", this.scale = 1, this.crop = !1, this.rotate = 0, this.w = 0, this.h = 0, this.trueWidth = 0, this.trueHeight = 0, this.clearCrop(), this.$nextTick(() => {
        this.checkedImg();
      });
    },
    rotateLeft() {
      this.rotate = this.rotate <= -3 ? 0 : this.rotate - 1;
    },
    rotateRight() {
      this.rotate = this.rotate >= 3 ? 0 : this.rotate + 1;
    },
    rotateClear() {
      this.rotate = 0;
    },
    checkoutImgAxis(e, t, n) {
      e = e || this.x, t = t || this.y, n = n || this.scale;
      let r = !0;
      if (this.centerBox) {
        let i = this.getImgAxis(e, t, n), a = this.getCropAxis();
        i.x1 >= a.x1 && (r = !1), i.x2 <= a.x2 && (r = !1), i.y1 >= a.y1 && (r = !1), i.y2 <= a.y2 && (r = !1);
      }
      return r;
    }
  },
  mounted() {
    this.support = "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll";
    let e = this;
    var t = navigator.userAgent;
    this.isIOS = !!t.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), HTMLCanvasElement.prototype.toBlob || Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
      value: function(n, r, i) {
        for (var a = atob(this.toDataURL(r, i).split(",")[1]), o = a.length, s = new Uint8Array(o), l = 0; l < o; l++)
          s[l] = a.charCodeAt(l);
        n(new Blob([s], { type: e.type || "image/png" }));
      }
    }), this.showPreview(), this.checkedImg();
  },
  unmounted() {
    window.removeEventListener("mousemove", this.moveCrop), window.removeEventListener("mouseup", this.leaveCrop), window.removeEventListener("touchmove", this.moveCrop), window.removeEventListener("touchend", this.leaveCrop), this.cancelScale();
  }
}), Fee = {
  key: 0,
  class: "cropper-box"
}, Xee = ["src"], Ree = { class: "cropper-view-box" }, Vee = ["src"], Uee = { key: 1 };
function qee(e, t, n, r, i, a) {
  return P(), L("div", {
    class: "vue-cropper",
    ref: "cropper",
    onMouseover: t[28] || (t[28] = (...o) => e.scaleImg && e.scaleImg(...o)),
    onMouseout: t[29] || (t[29] = (...o) => e.cancelScale && e.cancelScale(...o))
  }, [
    e.imgs ? (P(), L("div", Fee, [
      Bt(T("div", {
        class: "cropper-box-canvas",
        style: Pt({
          width: e.trueWidth + "px",
          height: e.trueHeight + "px",
          transform: "scale(" + e.scale + "," + e.scale + ") translate3d(" + e.x / e.scale + "px," + e.y / e.scale + "px,0)rotateZ(" + e.rotate * 90 + "deg)"
        })
      }, [
        T("img", {
          src: e.imgs,
          alt: "cropper-img",
          ref: "cropperImg"
        }, null, 8, Xee)
      ], 4), [
        [Cn, !e.loading]
      ])
    ])) : re("", !0),
    T("div", {
      class: se(["cropper-drag-box", { "cropper-move": e.move && !e.crop, "cropper-crop": e.crop, "cropper-modal": e.cropping }]),
      onMousedown: t[0] || (t[0] = (...o) => e.startMove && e.startMove(...o)),
      onTouchstart: t[1] || (t[1] = (...o) => e.startMove && e.startMove(...o))
    }, null, 34),
    Bt(T("div", {
      class: "cropper-crop-box",
      style: Pt({
        width: e.cropW + "px",
        height: e.cropH + "px",
        transform: "translate3d(" + e.cropOffsertX + "px," + e.cropOffsertY + "px,0)"
      })
    }, [
      T("span", Ree, [
        T("img", {
          style: Pt({
            width: e.trueWidth + "px",
            height: e.trueHeight + "px",
            transform: "scale(" + e.scale + "," + e.scale + ") translate3d(" + (e.x - e.cropOffsertX) / e.scale + "px," + (e.y - e.cropOffsertY) / e.scale + "px,0)rotateZ(" + e.rotate * 90 + "deg)"
          }),
          src: e.imgs,
          alt: "cropper-img"
        }, null, 12, Vee)
      ]),
      T("span", {
        class: "cropper-face cropper-move",
        onMousedown: t[2] || (t[2] = (...o) => e.cropMove && e.cropMove(...o)),
        onTouchstart: t[3] || (t[3] = (...o) => e.cropMove && e.cropMove(...o))
      }, null, 32),
      e.info ? (P(), L("span", {
        key: 0,
        class: "crop-info",
        style: Pt({ top: e.cropInfo.top })
      }, de(e.cropInfo.width) + " \xD7 " + de(e.cropInfo.height), 5)) : re("", !0),
      e.fixedBox ? re("", !0) : (P(), L("span", Uee, [
        T("span", {
          class: "crop-line line-w",
          onMousedown: t[4] || (t[4] = (o) => e.changeCropSize(o, !1, !0, 0, 1)),
          onTouchstart: t[5] || (t[5] = (o) => e.changeCropSize(o, !1, !0, 0, 1))
        }, null, 32),
        T("span", {
          class: "crop-line line-a",
          onMousedown: t[6] || (t[6] = (o) => e.changeCropSize(o, !0, !1, 1, 0)),
          onTouchstart: t[7] || (t[7] = (o) => e.changeCropSize(o, !0, !1, 1, 0))
        }, null, 32),
        T("span", {
          class: "crop-line line-s",
          onMousedown: t[8] || (t[8] = (o) => e.changeCropSize(o, !1, !0, 0, 2)),
          onTouchstart: t[9] || (t[9] = (o) => e.changeCropSize(o, !1, !0, 0, 2))
        }, null, 32),
        T("span", {
          class: "crop-line line-d",
          onMousedown: t[10] || (t[10] = (o) => e.changeCropSize(o, !0, !1, 2, 0)),
          onTouchstart: t[11] || (t[11] = (o) => e.changeCropSize(o, !0, !1, 2, 0))
        }, null, 32),
        T("span", {
          class: "crop-point point1",
          onMousedown: t[12] || (t[12] = (o) => e.changeCropSize(o, !0, !0, 1, 1)),
          onTouchstart: t[13] || (t[13] = (o) => e.changeCropSize(o, !0, !0, 1, 1))
        }, null, 32),
        T("span", {
          class: "crop-point point2",
          onMousedown: t[14] || (t[14] = (o) => e.changeCropSize(o, !1, !0, 0, 1)),
          onTouchstart: t[15] || (t[15] = (o) => e.changeCropSize(o, !1, !0, 0, 1))
        }, null, 32),
        T("span", {
          class: "crop-point point3",
          onMousedown: t[16] || (t[16] = (o) => e.changeCropSize(o, !0, !0, 2, 1)),
          onTouchstart: t[17] || (t[17] = (o) => e.changeCropSize(o, !0, !0, 2, 1))
        }, null, 32),
        T("span", {
          class: "crop-point point4",
          onMousedown: t[18] || (t[18] = (o) => e.changeCropSize(o, !0, !1, 1, 0)),
          onTouchstart: t[19] || (t[19] = (o) => e.changeCropSize(o, !0, !1, 1, 0))
        }, null, 32),
        T("span", {
          class: "crop-point point5",
          onMousedown: t[20] || (t[20] = (o) => e.changeCropSize(o, !0, !1, 2, 0)),
          onTouchstart: t[21] || (t[21] = (o) => e.changeCropSize(o, !0, !1, 2, 0))
        }, null, 32),
        T("span", {
          class: "crop-point point6",
          onMousedown: t[22] || (t[22] = (o) => e.changeCropSize(o, !0, !0, 1, 2)),
          onTouchstart: t[23] || (t[23] = (o) => e.changeCropSize(o, !0, !0, 1, 2))
        }, null, 32),
        T("span", {
          class: "crop-point point7",
          onMousedown: t[24] || (t[24] = (o) => e.changeCropSize(o, !1, !0, 0, 2)),
          onTouchstart: t[25] || (t[25] = (o) => e.changeCropSize(o, !1, !0, 0, 2))
        }, null, 32),
        T("span", {
          class: "crop-point point8",
          onMousedown: t[26] || (t[26] = (o) => e.changeCropSize(o, !0, !0, 2, 2)),
          onTouchstart: t[27] || (t[27] = (o) => e.changeCropSize(o, !0, !0, 2, 2))
        }, null, 32)
      ]))
    ], 4), [
      [Cn, e.cropping]
    ])
  ], 544);
}
var BT = /* @__PURE__ */ Nee(jee, [["render", qee], ["__scopeId", "data-v-26736c2c"]]);
typeof window < "u" && window.Vue && window.Vue.createApp({}).component("VueCropper", BT);
var F7;
const bf = typeof window < "u", _ee = (e) => typeof e < "u", Wee = (e) => typeof e == "string", Ep = () => {
};
bf && ((F7 = window == null ? void 0 : window.navigator) == null ? void 0 : F7.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function NT(e) {
  return tg() ? (W4(e), !0) : !1;
}
function jT(e, t = !0) {
  sn() ? rn(e) : t ? e() : bt(e);
}
function q0(e) {
  var t;
  const n = E(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const F3 = bf ? window : void 0;
bf && window.document;
bf && window.navigator;
bf && window.location;
function _0(...e) {
  let t, n, r, i;
  if (Wee(e[0]) ? ([n, r, i] = e, t = F3) : [t, n, r, i] = e, !t)
    return Ep;
  let a = Ep;
  const o = Ne(() => q0(t), (l) => {
    a(), l && (l.addEventListener(n, r, i), a = () => {
      l.removeEventListener(n, r, i), a = Ep;
    });
  }, { immediate: !0, flush: "post" }), s = () => {
    o(), a();
  };
  return NT(s), s;
}
const e4 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, t4 = "__vueuse_ssr_handlers__";
e4[t4] = e4[t4] || {};
e4[t4];
var X7 = Object.getOwnPropertySymbols, Kee = Object.prototype.hasOwnProperty, Gee = Object.prototype.propertyIsEnumerable, Yee = (e, t) => {
  var n = {};
  for (var r in e)
    Kee.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && X7)
    for (var r of X7(e))
      t.indexOf(r) < 0 && Gee.call(e, r) && (n[r] = e[r]);
  return n;
};
function Qee(e, t, n = {}) {
  const r = n, { window: i = F3 } = r, a = Yee(r, ["window"]);
  let o;
  const s = i && "ResizeObserver" in i, l = () => {
    o && (o.disconnect(), o = void 0);
  }, u = Ne(() => q0(e), (f) => {
    l(), s && i && f && (o = new ResizeObserver(t), o.observe(f, a));
  }, { immediate: !0, flush: "post" }), c = () => {
    l(), u();
  };
  return NT(c), {
    isSupported: s,
    stop: c
  };
}
function Zee(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: r = !0,
    windowScroll: i = !0,
    immediate: a = !0
  } = t, o = j(0), s = j(0), l = j(0), u = j(0), c = j(0), f = j(0), d = j(0), h = j(0);
  function p() {
    const y = q0(e);
    if (!y) {
      n && (o.value = 0, s.value = 0, l.value = 0, u.value = 0, c.value = 0, f.value = 0, d.value = 0, h.value = 0);
      return;
    }
    const m = y.getBoundingClientRect();
    o.value = m.height, s.value = m.bottom, l.value = m.left, u.value = m.right, c.value = m.top, f.value = m.width, d.value = m.x, h.value = m.y;
  }
  return Qee(e, p), Ne(() => q0(e), (y) => !y && p()), i && _0("scroll", p, { passive: !0 }), r && _0("resize", p, { passive: !0 }), jT(() => {
    a && p();
  }), {
    height: o,
    bottom: s,
    left: l,
    right: u,
    top: c,
    width: f,
    x: d,
    y: h,
    update: p
  };
}
var R7;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(R7 || (R7 = {}));
function Vs(e, t, n, r = {}) {
  var i, a, o;
  const {
    passive: s = !1,
    eventName: l,
    deep: u = !1,
    defaultValue: c
  } = r, f = sn(), d = n || (f == null ? void 0 : f.emit) || ((i = f == null ? void 0 : f.$emit) == null ? void 0 : i.bind(f)) || ((o = (a = f == null ? void 0 : f.proxy) == null ? void 0 : a.$emit) == null ? void 0 : o.bind(f == null ? void 0 : f.proxy));
  let h = l;
  t || (t = "modelValue"), h = l || h || `update:${t.toString()}`;
  const p = () => _ee(e[t]) ? e[t] : c;
  if (s) {
    const y = j(p());
    return Ne(() => e[t], (m) => y.value = m), Ne(y, (m) => {
      (m !== e[t] || u) && d(h, m);
    }, {
      deep: u
    }), y;
  } else
    return J({
      get() {
        return p();
      },
      set(y) {
        d(h, y);
      }
    });
}
function Jee(e = {}) {
  const {
    window: t = F3,
    initialWidth: n = 1 / 0,
    initialHeight: r = 1 / 0,
    listenOrientation: i = !0
  } = e, a = j(n), o = j(r), s = () => {
    t && (a.value = t.innerWidth, o.value = t.innerHeight);
  };
  return s(), jT(s), _0("resize", s, { passive: !0 }), i && _0("orientationchange", s, { passive: !0 }), { width: a, height: o };
}
/*! Element Plus Icons Vue v2.0.9 */
var rr = (e, t) => {
  let n = e.__vccOpts || e;
  for (let [r, i] of t)
    n[r] = i;
  return n;
}, $ee = {
  name: "ArrowDown"
}, ete = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, tte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
}, null, -1), nte = [
  tte
];
function ite(e, t, n, r, i, a) {
  return P(), L("svg", ete, nte);
}
var W0 = /* @__PURE__ */ rr($ee, [["render", ite], ["__file", "arrow-down.vue"]]), rte = {
  name: "ArrowLeft"
}, ate = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, ote = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
}, null, -1), ste = [
  ote
];
function lte(e, t, n, r, i, a) {
  return P(), L("svg", ate, ste);
}
var ute = /* @__PURE__ */ rr(rte, [["render", lte], ["__file", "arrow-left.vue"]]), cte = {
  name: "ArrowRight"
}, dte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, fte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
}, null, -1), hte = [
  fte
];
function pte(e, t, n, r, i, a) {
  return P(), L("svg", dte, hte);
}
var FT = /* @__PURE__ */ rr(cte, [["render", pte], ["__file", "arrow-right.vue"]]), vte = {
  name: "CircleClose"
}, mte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, gte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248L466.752 512z"
}, null, -1), yte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768zm0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896z"
}, null, -1), bte = [
  gte,
  yte
];
function Ate(e, t, n, r, i, a) {
  return P(), L("svg", mte, bte);
}
var Tte = /* @__PURE__ */ rr(vte, [["render", Ate], ["__file", "circle-close.vue"]]), wte = {
  name: "Close"
}, Pte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, xte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
}, null, -1), Cte = [
  xte
];
function Ste(e, t, n, r, i, a) {
  return P(), L("svg", Pte, Cte);
}
var Ete = /* @__PURE__ */ rr(wte, [["render", Ste], ["__file", "close.vue"]]), kte = {
  name: "CopyDocument"
}, Ote = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, zte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64h64z"
}, null, -1), Dte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H384zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64z"
}, null, -1), Mte = [
  zte,
  Dte
];
function Hte(e, t, n, r, i, a) {
  return P(), L("svg", Ote, Mte);
}
var Ite = /* @__PURE__ */ rr(kte, [["render", Hte], ["__file", "copy-document.vue"]]), Lte = {
  name: "DArrowRight"
}, Bte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Nte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688zm-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
}, null, -1), jte = [
  Nte
];
function Fte(e, t, n, r, i, a) {
  return P(), L("svg", Bte, jte);
}
var XT = /* @__PURE__ */ rr(Lte, [["render", Fte], ["__file", "d-arrow-right.vue"]]), Xte = {
  name: "Document"
}, Rte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Vte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M832 384H576V128H192v768h640V384zm-26.496-64L640 154.496V320h165.504zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h160v64H320v-64zm0 384h384v64H320v-64z"
}, null, -1), Ute = [
  Vte
];
function qte(e, t, n, r, i, a) {
  return P(), L("svg", Rte, Ute);
}
var _te = /* @__PURE__ */ rr(Xte, [["render", qte], ["__file", "document.vue"]]), Wte = {
  name: "Link"
}, Kte = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Gte = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
}, null, -1), Yte = [
  Gte
];
function Qte(e, t, n, r, i, a) {
  return P(), L("svg", Kte, Yte);
}
var Zte = /* @__PURE__ */ rr(Wte, [["render", Qte], ["__file", "link.vue"]]), Jte = {
  name: "Minus"
}, $te = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, ene = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64z"
}, null, -1), tne = [
  ene
];
function nne(e, t, n, r, i, a) {
  return P(), L("svg", $te, tne);
}
var ine = /* @__PURE__ */ rr(Jte, [["render", nne], ["__file", "minus.vue"]]), rne = {
  name: "MoreFilled"
}, ane = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, one = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224zm336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224zm336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224z"
}, null, -1), sne = [
  one
];
function lne(e, t, n, r, i, a) {
  return P(), L("svg", ane, sne);
}
var une = /* @__PURE__ */ rr(rne, [["render", lne], ["__file", "more-filled.vue"]]), cne = {
  name: "Plus"
}, dne = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, fne = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64h352z"
}, null, -1), hne = [
  fne
];
function pne(e, t, n, r, i, a) {
  return P(), L("svg", dne, hne);
}
var vne = /* @__PURE__ */ rr(cne, [["render", pne], ["__file", "plus.vue"]]), mne = {
  name: "RefreshLeft"
}, gne = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, yne = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z"
}, null, -1), bne = [
  yne
];
function Ane(e, t, n, r, i, a) {
  return P(), L("svg", gne, bne);
}
var Tne = /* @__PURE__ */ rr(mne, [["render", Ane], ["__file", "refresh-left.vue"]]), wne = {
  name: "RefreshRight"
}, Pne = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, xne = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88z"
}, null, -1), Cne = [
  xne
];
function Sne(e, t, n, r, i, a) {
  return P(), L("svg", Pne, Cne);
}
var Ene = /* @__PURE__ */ rr(wne, [["render", Sne], ["__file", "refresh-right.vue"]]), kne = {
  name: "Search"
}, One = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, zne = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704z"
}, null, -1), Dne = [
  zne
];
function Mne(e, t, n, r, i, a) {
  return P(), L("svg", One, Dne);
}
var Gh = /* @__PURE__ */ rr(kne, [["render", Mne], ["__file", "search.vue"]]), Hne = {
  name: "UploadFilled"
}, Ine = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, Lne = /* @__PURE__ */ T("path", {
  fill: "currentColor",
  d: "M544 864V672h128L512 480 352 672h128v192H320v-1.6c-5.376.32-10.496 1.6-16 1.6A240 240 0 0 1 64 624c0-123.136 93.12-223.488 212.608-237.248A239.808 239.808 0 0 1 512 192a239.872 239.872 0 0 1 235.456 194.752c119.488 13.76 212.48 114.112 212.48 237.248a240 240 0 0 1-240 240c-5.376 0-10.56-1.28-16-1.6v1.6H544z"
}, null, -1), Bne = [
  Lne
];
function Nne(e, t, n, r, i, a) {
  return P(), L("svg", Ine, Bne);
}
var RT = /* @__PURE__ */ rr(Hne, [["render", Nne], ["__file", "upload-filled.vue"]]);
const jne = () => {
  const e = j({
    img: "",
    url: ""
  }), t = zt({
    outputType: "png",
    autoCrop: !0,
    autoCropWidth: 200,
    autoCropHeight: 200,
    fixedBox: !0
  }), n = j();
  return {
    previews: e,
    cropperRef: n,
    vcOption: t,
    rotateLeft: () => {
      n.value.rotateLeft();
    },
    rotateRight: () => {
      n.value.rotateRight();
    },
    changeScale: (s = 1) => {
      n.value.changeScale(s);
    },
    realTime: (s) => {
      e.value = s;
    }
  };
}, Af = (e) => (yn("data-v-98011075"), e = e(), bn(), e), Fne = /* @__PURE__ */ Af(() => /* @__PURE__ */ T("span", { class: "title" }, "\u66F4\u6362\u5934\u50CF", -1)), Xne = { class: "avatar-upload-preview" }, Rne = ["src"], Vne = {
  key: 1,
  class: "img-empty"
}, Une = /* @__PURE__ */ Af(() => /* @__PURE__ */ T("div", { class: "tip" }, [
  /* @__PURE__ */ T("div", { class: "tip1" }, "\u5934\u50CF\u9884\u89C8"),
  /* @__PURE__ */ T("div", { class: "tip2" }, "\u4EC5\u652F\u6301jpg\u3001gif\u3001png\u56FE\u7247\u6587\u4EF6\uFF0C\u4E14\u6587\u4EF6\u5C0F\u4E8E5M\uFF0C\u5EFA\u8BAE\u5C3A\u5BF8160*160\u50CF\u7D20")
], -1)), qne = /* @__PURE__ */ Af(() => /* @__PURE__ */ T("br", null, null, -1)), _ne = /* @__PURE__ */ je(" \u4E0A\u4F20\u56FE\u7247 "), Wne = { class: "dialog-footer" }, Kne = /* @__PURE__ */ Af(() => /* @__PURE__ */ T("span", null, "\u53D6 \u6D88", -1)), Gne = /* @__PURE__ */ Af(() => /* @__PURE__ */ T("span", null, "\u4FDD \u5B58", -1)), Yne = /* @__PURE__ */ Ee({
  props: {
    isShow: {
      type: Boolean,
      default: !1
    },
    defaultImg: {
      type: String,
      default: ""
    },
    defaultTip: {
      type: String,
      default: "\u6682\u672A\u4E0A\u4F20\u56FE\u7247"
    }
  },
  emits: ["update:isShow", "changeAvatar"],
  setup(e, { emit: t }) {
    const n = e, { getPolicy: r } = ce("$http"), i = j(""), a = zt({}), o = Vs(n, "isShow", t), s = zt({
      id: "",
      url: ""
    });
    Ne(
      () => n.defaultImg,
      (S) => {
        s.url = S;
      },
      {
        immediate: !0
      }
    );
    const { cropperRef: l, previews: u, realTime: c, vcOption: f, rotateLeft: d, rotateRight: h, changeScale: p } = jne(), y = async () => {
      o.value = !1;
    }, m = () => {
      if (!s.url) {
        An.error("\u6682\u672A\u4E0A\u4F20\u56FE\u7247");
        return;
      }
      const S = s.url.split("/")[s.url.split("/").length - 1];
      D(S);
    }, b = ({
      data: S
    }) => {
      s.id = S.id, s.url = S.fileUrl;
    }, x = (S) => {
      const C = S.type === "image/jpeg", v = S.type === "image/png";
      if (!C && !v) {
        An.error("\u4E0A\u4F20\u56FE\u7247\u53EA\u80FD\u662F JPG/PNG \u683C\u5F0F!");
        return;
      }
      return new Promise(async (H, V) => {
        try {
          const R = await r({ fileName: S.name }), F = JSON.parse(R);
          i.value = F.host, a.key = `${F.dir + F.fileUUID}.${S.name.substring(
            S.name.lastIndexOf(".") + 1,
            S.name.length
          )}`, a.policy = F.policy, a.OSSAccessKeyId = F.accessid, a.success_action_status = 200, a.callback = F.callback, a.signature = F.signature, H(!0);
        } catch (R) {
          V(R);
        }
      });
    }, D = async (S) => {
      try {
        const C = await r({ fileName: S }), v = JSON.parse(C);
        l.value.getCropBlob(async (H) => {
          const V = new FormData();
          V.append(
            "key",
            `${v.dir + v.fileUUID}.${S.split(".")[S.split(".").length - 1]}`
          ), V.append("policy", v.policy), V.append("OSSAccessKeyId", v.accessid), V.append("success_action_status", "200"), V.append("callback", v.callback), V.append("signature", v.signature), V.append("Content-Disposition", `attachment;filename=${S}`), V.append("file", H);
          const R = await uy.post(v.host, V, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }), { id: F, fileUrl: K } = R.data.data;
          s.url = K, t("changeAvatar", { url: K, id: F });
        });
      } catch (C) {
        console.log(C);
      }
    };
    return (S, C) => {
      const v = AA, H = aT, V = qt, R = fn, F = yf, K = ni;
      return E(o) ? (P(), ue(K, {
        key: 0,
        modelValue: E(o),
        "onUpdate:modelValue": C[4] || (C[4] = (q) => Bn(o) ? o.value = q : null),
        width: "630px",
        "append-to-body": "",
        "before-close": y
      }, {
        title: N(() => [
          Fne
        ]),
        footer: N(() => [
          T("div", Wne, [
            B(R, {
              style: { width: "96px" },
              onClick: y
            }, {
              default: N(() => [
                Kne
              ]),
              _: 1
            }),
            B(R, {
              type: "primary",
              style: { width: "96px" },
              onClick: m
            }, {
              default: N(() => [
                Gne
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(H, null, {
            default: N(() => [
              B(v, {
                xs: 24,
                md: 15,
                class: "cropper_col"
              }, {
                default: N(() => [
                  E(o) ? (P(), ue(E(BT), {
                    key: 0,
                    ref_key: "cropperRef",
                    ref: l,
                    img: E(s).url,
                    info: !0,
                    "auto-crop": E(f).autoCrop,
                    "auto-crop-width": E(f).autoCropWidth,
                    "auto-crop-height": E(f).autoCropHeight,
                    "fixed-box": E(f).fixedBox,
                    onRealTime: E(c)
                  }, null, 8, ["img", "auto-crop", "auto-crop-width", "auto-crop-height", "fixed-box", "onRealTime"])) : re("", !0)
                ]),
                _: 1
              }),
              B(v, {
                xs: 24,
                md: 9,
                class: "img_view"
              }, {
                default: N(() => [
                  T("div", Xne, [
                    E(s).url ? (P(), L("img", {
                      key: 0,
                      src: E(u).url,
                      style: Pt(E(u).img)
                    }, null, 12, Rne)) : (P(), L("div", Vne, de(e.defaultTip), 1))
                  ]),
                  Une
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          qne,
          B(H, null, {
            default: N(() => [
              B(v, {
                md: 15,
                class: "btn"
              }, {
                default: N(() => [
                  B(H, null, {
                    default: N(() => [
                      B(v, {
                        lg: 5,
                        md: 5
                      }, {
                        default: N(() => [
                          B(F, {
                            action: i.value,
                            data: E(a),
                            "show-file-list": !1,
                            "before-upload": x,
                            "on-success": b,
                            accept: "image/*"
                          }, {
                            default: N(() => [
                              B(R, { size: "small" }, {
                                default: N(() => [
                                  B(V, { style: { "margin-right": "7px" } }, {
                                    default: N(() => [
                                      B(E(RT))
                                    ]),
                                    _: 1
                                  }),
                                  _ne
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["action", "data"])
                        ]),
                        _: 1
                      }),
                      B(v, {
                        lg: 17,
                        md: 17,
                        offset: 2
                      }, {
                        default: N(() => [
                          B(H, { justify: "end" }, {
                            default: N(() => [
                              B(v, {
                                lg: { span: 4, offset: 5 },
                                md: 4
                              }, {
                                default: N(() => [
                                  B(R, {
                                    size: "small",
                                    onClick: C[0] || (C[0] = (q) => E(p)(1))
                                  }, {
                                    default: N(() => [
                                      B(V, null, {
                                        default: N(() => [
                                          B(E(vne))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              B(v, {
                                lg: { span: 4, offset: 1 },
                                md: 4
                              }, {
                                default: N(() => [
                                  B(R, {
                                    size: "small",
                                    onClick: C[1] || (C[1] = (q) => E(p)(-1))
                                  }, {
                                    default: N(() => [
                                      B(V, null, {
                                        default: N(() => [
                                          B(E(ine))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              B(v, {
                                lg: { span: 4, offset: 1 },
                                md: 4
                              }, {
                                default: N(() => [
                                  B(R, {
                                    size: "small",
                                    onClick: C[2] || (C[2] = (q) => E(d)())
                                  }, {
                                    default: N(() => [
                                      B(V, null, {
                                        default: N(() => [
                                          B(E(Tne))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              B(v, {
                                lg: { span: 4, offset: 1 },
                                md: 4
                              }, {
                                default: N(() => [
                                  B(R, {
                                    size: "small",
                                    onClick: C[3] || (C[3] = (q) => E(h)())
                                  }, {
                                    default: N(() => [
                                      B(V, null, {
                                        default: N(() => [
                                          B(E(Ene))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])) : re("", !0);
    };
  }
});
const Hu = /* @__PURE__ */ Ht(Yne, [["__scopeId", "data-v-98011075"]]);
Hu.name = "cover-upload";
Hu.install = (e) => {
  e.component(Hu.name, Hu);
};
var VT = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = {
    name: "zh-cn",
    el: {
      colorpicker: {
        confirm: "\u786E\u5B9A",
        clear: "\u6E05\u7A7A"
      },
      datepicker: {
        now: "\u6B64\u523B",
        today: "\u4ECA\u5929",
        cancel: "\u53D6\u6D88",
        clear: "\u6E05\u7A7A",
        confirm: "\u786E\u5B9A",
        selectDate: "\u9009\u62E9\u65E5\u671F",
        selectTime: "\u9009\u62E9\u65F6\u95F4",
        startDate: "\u5F00\u59CB\u65E5\u671F",
        startTime: "\u5F00\u59CB\u65F6\u95F4",
        endDate: "\u7ED3\u675F\u65E5\u671F",
        endTime: "\u7ED3\u675F\u65F6\u95F4",
        prevYear: "\u524D\u4E00\u5E74",
        nextYear: "\u540E\u4E00\u5E74",
        prevMonth: "\u4E0A\u4E2A\u6708",
        nextMonth: "\u4E0B\u4E2A\u6708",
        year: "\u5E74",
        month1: "1 \u6708",
        month2: "2 \u6708",
        month3: "3 \u6708",
        month4: "4 \u6708",
        month5: "5 \u6708",
        month6: "6 \u6708",
        month7: "7 \u6708",
        month8: "8 \u6708",
        month9: "9 \u6708",
        month10: "10 \u6708",
        month11: "11 \u6708",
        month12: "12 \u6708",
        weeks: {
          sun: "\u65E5",
          mon: "\u4E00",
          tue: "\u4E8C",
          wed: "\u4E09",
          thu: "\u56DB",
          fri: "\u4E94",
          sat: "\u516D"
        },
        months: {
          jan: "\u4E00\u6708",
          feb: "\u4E8C\u6708",
          mar: "\u4E09\u6708",
          apr: "\u56DB\u6708",
          may: "\u4E94\u6708",
          jun: "\u516D\u6708",
          jul: "\u4E03\u6708",
          aug: "\u516B\u6708",
          sep: "\u4E5D\u6708",
          oct: "\u5341\u6708",
          nov: "\u5341\u4E00\u6708",
          dec: "\u5341\u4E8C\u6708"
        }
      },
      select: {
        loading: "\u52A0\u8F7D\u4E2D",
        noMatch: "\u65E0\u5339\u914D\u6570\u636E",
        noData: "\u65E0\u6570\u636E",
        placeholder: "\u8BF7\u9009\u62E9"
      },
      cascader: {
        noMatch: "\u65E0\u5339\u914D\u6570\u636E",
        loading: "\u52A0\u8F7D\u4E2D",
        placeholder: "\u8BF7\u9009\u62E9",
        noData: "\u6682\u65E0\u6570\u636E"
      },
      pagination: {
        goto: "\u524D\u5F80",
        pagesize: "\u6761/\u9875",
        total: "\u5171 {total} \u6761",
        pageClassifier: "\u9875",
        deprecationWarning: "\u4F60\u4F7F\u7528\u4E86\u4E00\u4E9B\u5DF2\u88AB\u5E9F\u5F03\u7684\u7528\u6CD5\uFF0C\u8BF7\u53C2\u8003 el-pagination \u7684\u5B98\u65B9\u6587\u6863"
      },
      messagebox: {
        title: "\u63D0\u793A",
        confirm: "\u786E\u5B9A",
        cancel: "\u53D6\u6D88",
        error: "\u8F93\u5165\u7684\u6570\u636E\u4E0D\u5408\u6CD5!"
      },
      upload: {
        deleteTip: "\u6309 delete \u952E\u53EF\u5220\u9664",
        delete: "\u5220\u9664",
        preview: "\u67E5\u770B\u56FE\u7247",
        continue: "\u7EE7\u7EED\u4E0A\u4F20"
      },
      table: {
        emptyText: "\u6682\u65E0\u6570\u636E",
        confirmFilter: "\u7B5B\u9009",
        resetFilter: "\u91CD\u7F6E",
        clearFilter: "\u5168\u90E8",
        sumText: "\u5408\u8BA1"
      },
      tree: {
        emptyText: "\u6682\u65E0\u6570\u636E"
      },
      transfer: {
        noMatch: "\u65E0\u5339\u914D\u6570\u636E",
        noData: "\u65E0\u6570\u636E",
        titles: ["\u5217\u8868 1", "\u5217\u8868 2"],
        filterPlaceholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9",
        noCheckedFormat: "\u5171 {total} \u9879",
        hasCheckedFormat: "\u5DF2\u9009 {checked}/{total} \u9879"
      },
      image: {
        error: "\u52A0\u8F7D\u5931\u8D25"
      },
      pageHeader: {
        title: "\u8FD4\u56DE"
      },
      popconfirm: {
        confirmButtonText: "\u786E\u5B9A",
        cancelButtonText: "\u53D6\u6D88"
      }
    }
  };
  e.default = t;
})(VT);
const Qne = /* @__PURE__ */ Wg(VT);
class X3 {
  constructor() {
    this.events = {};
  }
  static creatBus() {
    return new X3();
  }
  emit(t, n) {
    this.events[t] && this.events[t].forEach((r) => {
      r(n);
    });
  }
  on(t, n) {
    this.events[t] = this.events[t] || [], this.events[t].push(n);
  }
  off(t, n) {
    if (this.events[t]) {
      for (let r = 0; r < this.events[t].length; r++)
        if (this.events[t][r] === n) {
          this.events[t].splice(r, 1);
          break;
        }
    }
  }
}
var UT = { exports: {} };
/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
(function(e) {
  (function(t, n) {
    e.exports = t.document ? n(t, !0) : function(r) {
      if (!r.document)
        throw new Error("jQuery requires a window with a document");
      return n(r);
    };
  })(typeof window < "u" ? window : Ir, function(t, n) {
    var r = [], i = Object.getPrototypeOf, a = r.slice, o = r.flat ? function(g) {
      return r.flat.call(g);
    } : function(g) {
      return r.concat.apply([], g);
    }, s = r.push, l = r.indexOf, u = {}, c = u.toString, f = u.hasOwnProperty, d = f.toString, h = d.call(Object), p = {}, y = function(w) {
      return typeof w == "function" && typeof w.nodeType != "number" && typeof w.item != "function";
    }, m = function(w) {
      return w != null && w === w.window;
    }, b = t.document, x = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function D(g, w, z) {
      z = z || b;
      var I, _, W = z.createElement("script");
      if (W.text = g, w)
        for (I in x)
          _ = w[I] || w.getAttribute && w.getAttribute(I), _ && W.setAttribute(I, _);
      z.head.appendChild(W).parentNode.removeChild(W);
    }
    function S(g) {
      return g == null ? g + "" : typeof g == "object" || typeof g == "function" ? u[c.call(g)] || "object" : typeof g;
    }
    var C = "3.6.0", v = function(g, w) {
      return new v.fn.init(g, w);
    };
    v.fn = v.prototype = {
      jquery: C,
      constructor: v,
      length: 0,
      toArray: function() {
        return a.call(this);
      },
      get: function(g) {
        return g == null ? a.call(this) : g < 0 ? this[g + this.length] : this[g];
      },
      pushStack: function(g) {
        var w = v.merge(this.constructor(), g);
        return w.prevObject = this, w;
      },
      each: function(g) {
        return v.each(this, g);
      },
      map: function(g) {
        return this.pushStack(v.map(this, function(w, z) {
          return g.call(w, z, w);
        }));
      },
      slice: function() {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(v.grep(this, function(g, w) {
          return (w + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(v.grep(this, function(g, w) {
          return w % 2;
        }));
      },
      eq: function(g) {
        var w = this.length, z = +g + (g < 0 ? w : 0);
        return this.pushStack(z >= 0 && z < w ? [this[z]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      push: s,
      sort: r.sort,
      splice: r.splice
    }, v.extend = v.fn.extend = function() {
      var g, w, z, I, _, W, ne = arguments[0] || {}, me = 1, ye = arguments.length, Oe = !1;
      for (typeof ne == "boolean" && (Oe = ne, ne = arguments[me] || {}, me++), typeof ne != "object" && !y(ne) && (ne = {}), me === ye && (ne = this, me--); me < ye; me++)
        if ((g = arguments[me]) != null)
          for (w in g)
            I = g[w], !(w === "__proto__" || ne === I) && (Oe && I && (v.isPlainObject(I) || (_ = Array.isArray(I))) ? (z = ne[w], _ && !Array.isArray(z) ? W = [] : !_ && !v.isPlainObject(z) ? W = {} : W = z, _ = !1, ne[w] = v.extend(Oe, W, I)) : I !== void 0 && (ne[w] = I));
      return ne;
    }, v.extend({
      expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function(g) {
        throw new Error(g);
      },
      noop: function() {
      },
      isPlainObject: function(g) {
        var w, z;
        return !g || c.call(g) !== "[object Object]" ? !1 : (w = i(g), w ? (z = f.call(w, "constructor") && w.constructor, typeof z == "function" && d.call(z) === h) : !0);
      },
      isEmptyObject: function(g) {
        var w;
        for (w in g)
          return !1;
        return !0;
      },
      globalEval: function(g, w, z) {
        D(g, { nonce: w && w.nonce }, z);
      },
      each: function(g, w) {
        var z, I = 0;
        if (H(g))
          for (z = g.length; I < z && w.call(g[I], I, g[I]) !== !1; I++)
            ;
        else
          for (I in g)
            if (w.call(g[I], I, g[I]) === !1)
              break;
        return g;
      },
      makeArray: function(g, w) {
        var z = w || [];
        return g != null && (H(Object(g)) ? v.merge(
          z,
          typeof g == "string" ? [g] : g
        ) : s.call(z, g)), z;
      },
      inArray: function(g, w, z) {
        return w == null ? -1 : l.call(w, g, z);
      },
      merge: function(g, w) {
        for (var z = +w.length, I = 0, _ = g.length; I < z; I++)
          g[_++] = w[I];
        return g.length = _, g;
      },
      grep: function(g, w, z) {
        for (var I, _ = [], W = 0, ne = g.length, me = !z; W < ne; W++)
          I = !w(g[W], W), I !== me && _.push(g[W]);
        return _;
      },
      map: function(g, w, z) {
        var I, _, W = 0, ne = [];
        if (H(g))
          for (I = g.length; W < I; W++)
            _ = w(g[W], W, z), _ != null && ne.push(_);
        else
          for (W in g)
            _ = w(g[W], W, z), _ != null && ne.push(_);
        return o(ne);
      },
      guid: 1,
      support: p
    }), typeof Symbol == "function" && (v.fn[Symbol.iterator] = r[Symbol.iterator]), v.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(g, w) {
        u["[object " + w + "]"] = w.toLowerCase();
      }
    );
    function H(g) {
      var w = !!g && "length" in g && g.length, z = S(g);
      return y(g) || m(g) ? !1 : z === "array" || w === 0 || typeof w == "number" && w > 0 && w - 1 in g;
    }
    var V = function(g) {
      var w, z, I, _, W, ne, me, ye, Oe, Xe, it, Be, _e, Xt, en, Ft, Qn, Kn, ur, Nn = "sizzle" + 1 * new Date(), tn = g.document, Gi = 0, xn = 0, Zn = iu(), $s = iu(), eu = iu(), cr = iu(), aa = function(ie, fe) {
        return ie === fe && (it = !0), 0;
      }, Fr = {}.hasOwnProperty, Yi = [], Oa = Yi.pop, dr = Yi.push, za = Yi.push, Vc = Yi.slice, Ja = function(ie, fe) {
        for (var we = 0, Ge = ie.length; we < Ge; we++)
          if (ie[we] === fe)
            return we;
        return -1;
      }, el = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", zn = "[\\x20\\t\\r\\n\\f]", $a = "(?:\\\\[\\da-fA-F]{1,6}" + zn + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", tl = "\\[" + zn + "*(" + $a + ")(?:" + zn + "*([*^$|!~]?=)" + zn + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + $a + "))|)" + zn + "*\\]", bs = ":(" + $a + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + tl + ")*)|.*)\\)|)", N2 = new RegExp(zn + "+", "g"), tu = new RegExp("^" + zn + "+|((?:^|[^\\\\])(?:\\\\.)*)" + zn + "+$", "g"), j2 = new RegExp("^" + zn + "*," + zn + "*"), o1 = new RegExp("^" + zn + "*([>+~]|" + zn + ")" + zn + "*"), F2 = new RegExp(zn + "|>"), Uc = new RegExp(bs), X2 = new RegExp("^" + $a + "$"), nu = {
        ID: new RegExp("^#(" + $a + ")"),
        CLASS: new RegExp("^\\.(" + $a + ")"),
        TAG: new RegExp("^(" + $a + "|[*])"),
        ATTR: new RegExp("^" + tl),
        PSEUDO: new RegExp("^" + bs),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + zn + "*(even|odd|(([+-]|)(\\d*)n|)" + zn + "*(?:([+-]|)" + zn + "*(\\d+)|))" + zn + "*\\)|)", "i"),
        bool: new RegExp("^(?:" + el + ")$", "i"),
        needsContext: new RegExp("^" + zn + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + zn + "*((?:-\\d)?\\d*)" + zn + "*\\)|)(?=[^-]|$)", "i")
      }, As = /HTML$/i, Hn = /^(?:input|select|textarea|button)$/i, Co = /^h\d$/i, pi = /^[^{]+\{\s*\[native \w/, oa = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, qc = /[+~]/, sa = new RegExp("\\\\[\\da-fA-F]{1,6}" + zn + "?|\\\\([^\\r\\n\\f])", "g"), Da = function(ie, fe) {
        var we = "0x" + ie.slice(1) - 65536;
        return fe || (we < 0 ? String.fromCharCode(we + 65536) : String.fromCharCode(we >> 10 | 55296, we & 1023 | 56320));
      }, s1 = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, l1 = function(ie, fe) {
        return fe ? ie === "\0" ? "\uFFFD" : ie.slice(0, -1) + "\\" + ie.charCodeAt(ie.length - 1).toString(16) + " " : "\\" + ie;
      }, u1 = function() {
        Be();
      }, R2 = ge(
        function(ie) {
          return ie.disabled === !0 && ie.nodeName.toLowerCase() === "fieldset";
        },
        { dir: "parentNode", next: "legend" }
      );
      try {
        za.apply(
          Yi = Vc.call(tn.childNodes),
          tn.childNodes
        ), Yi[tn.childNodes.length].nodeType;
      } catch {
        za = {
          apply: Yi.length ? function(fe, we) {
            dr.apply(fe, Vc.call(we));
          } : function(fe, we) {
            for (var Ge = fe.length, ze = 0; fe[Ge++] = we[ze++]; )
              ;
            fe.length = Ge - 1;
          }
        };
      }
      function Rn(ie, fe, we, Ge) {
        var ze, Ze, rt, pt, St, Dt, Vt, Rt = fe && fe.ownerDocument, gn = fe ? fe.nodeType : 9;
        if (we = we || [], typeof ie != "string" || !ie || gn !== 1 && gn !== 9 && gn !== 11)
          return we;
        if (!Ge && (Be(fe), fe = fe || _e, en)) {
          if (gn !== 11 && (St = oa.exec(ie)))
            if (ze = St[1]) {
              if (gn === 9)
                if (rt = fe.getElementById(ze)) {
                  if (rt.id === ze)
                    return we.push(rt), we;
                } else
                  return we;
              else if (Rt && (rt = Rt.getElementById(ze)) && ur(fe, rt) && rt.id === ze)
                return we.push(rt), we;
            } else {
              if (St[2])
                return za.apply(we, fe.getElementsByTagName(ie)), we;
              if ((ze = St[3]) && z.getElementsByClassName && fe.getElementsByClassName)
                return za.apply(we, fe.getElementsByClassName(ze)), we;
            }
          if (z.qsa && !cr[ie + " "] && (!Ft || !Ft.test(ie)) && (gn !== 1 || fe.nodeName.toLowerCase() !== "object")) {
            if (Vt = ie, Rt = fe, gn === 1 && (F2.test(ie) || o1.test(ie))) {
              for (Rt = qc.test(ie) && ae(fe.parentNode) || fe, (Rt !== fe || !z.scope) && ((pt = fe.getAttribute("id")) ? pt = pt.replace(s1, l1) : fe.setAttribute("id", pt = Nn)), Dt = ne(ie), Ze = Dt.length; Ze--; )
                Dt[Ze] = (pt ? "#" + pt : ":scope") + " " + be(Dt[Ze]);
              Vt = Dt.join(",");
            }
            try {
              return za.apply(
                we,
                Rt.querySelectorAll(Vt)
              ), we;
            } catch {
              cr(ie, !0);
            } finally {
              pt === Nn && fe.removeAttribute("id");
            }
          }
        }
        return ye(ie.replace(tu, "$1"), fe, we, Ge);
      }
      function iu() {
        var ie = [];
        function fe(we, Ge) {
          return ie.push(we + " ") > I.cacheLength && delete fe[ie.shift()], fe[we + " "] = Ge;
        }
        return fe;
      }
      function Cr(ie) {
        return ie[Nn] = !0, ie;
      }
      function ee(ie) {
        var fe = _e.createElement("fieldset");
        try {
          return !!ie(fe);
        } catch {
          return !1;
        } finally {
          fe.parentNode && fe.parentNode.removeChild(fe), fe = null;
        }
      }
      function A(ie, fe) {
        for (var we = ie.split("|"), Ge = we.length; Ge--; )
          I.attrHandle[we[Ge]] = fe;
      }
      function O(ie, fe) {
        var we = fe && ie, Ge = we && ie.nodeType === 1 && fe.nodeType === 1 && ie.sourceIndex - fe.sourceIndex;
        if (Ge)
          return Ge;
        if (we) {
          for (; we = we.nextSibling; )
            if (we === fe)
              return -1;
        }
        return ie ? 1 : -1;
      }
      function k(ie) {
        return function(fe) {
          var we = fe.nodeName.toLowerCase();
          return we === "input" && fe.type === ie;
        };
      }
      function M(ie) {
        return function(fe) {
          var we = fe.nodeName.toLowerCase();
          return (we === "input" || we === "button") && fe.type === ie;
        };
      }
      function X(ie) {
        return function(fe) {
          return "form" in fe ? fe.parentNode && fe.disabled === !1 ? "label" in fe ? "label" in fe.parentNode ? fe.parentNode.disabled === ie : fe.disabled === ie : fe.isDisabled === ie || fe.isDisabled !== !ie && R2(fe) === ie : fe.disabled === ie : "label" in fe ? fe.disabled === ie : !1;
        };
      }
      function U(ie) {
        return Cr(function(fe) {
          return fe = +fe, Cr(function(we, Ge) {
            for (var ze, Ze = ie([], we.length, fe), rt = Ze.length; rt--; )
              we[ze = Ze[rt]] && (we[ze] = !(Ge[ze] = we[ze]));
          });
        });
      }
      function ae(ie) {
        return ie && typeof ie.getElementsByTagName < "u" && ie;
      }
      z = Rn.support = {}, W = Rn.isXML = function(ie) {
        var fe = ie && ie.namespaceURI, we = ie && (ie.ownerDocument || ie).documentElement;
        return !As.test(fe || we && we.nodeName || "HTML");
      }, Be = Rn.setDocument = function(ie) {
        var fe, we, Ge = ie ? ie.ownerDocument || ie : tn;
        return Ge == _e || Ge.nodeType !== 9 || !Ge.documentElement || (_e = Ge, Xt = _e.documentElement, en = !W(_e), tn != _e && (we = _e.defaultView) && we.top !== we && (we.addEventListener ? we.addEventListener("unload", u1, !1) : we.attachEvent && we.attachEvent("onunload", u1)), z.scope = ee(function(ze) {
          return Xt.appendChild(ze).appendChild(_e.createElement("div")), typeof ze.querySelectorAll < "u" && !ze.querySelectorAll(":scope fieldset div").length;
        }), z.attributes = ee(function(ze) {
          return ze.className = "i", !ze.getAttribute("className");
        }), z.getElementsByTagName = ee(function(ze) {
          return ze.appendChild(_e.createComment("")), !ze.getElementsByTagName("*").length;
        }), z.getElementsByClassName = pi.test(_e.getElementsByClassName), z.getById = ee(function(ze) {
          return Xt.appendChild(ze).id = Nn, !_e.getElementsByName || !_e.getElementsByName(Nn).length;
        }), z.getById ? (I.filter.ID = function(ze) {
          var Ze = ze.replace(sa, Da);
          return function(rt) {
            return rt.getAttribute("id") === Ze;
          };
        }, I.find.ID = function(ze, Ze) {
          if (typeof Ze.getElementById < "u" && en) {
            var rt = Ze.getElementById(ze);
            return rt ? [rt] : [];
          }
        }) : (I.filter.ID = function(ze) {
          var Ze = ze.replace(sa, Da);
          return function(rt) {
            var pt = typeof rt.getAttributeNode < "u" && rt.getAttributeNode("id");
            return pt && pt.value === Ze;
          };
        }, I.find.ID = function(ze, Ze) {
          if (typeof Ze.getElementById < "u" && en) {
            var rt, pt, St, Dt = Ze.getElementById(ze);
            if (Dt) {
              if (rt = Dt.getAttributeNode("id"), rt && rt.value === ze)
                return [Dt];
              for (St = Ze.getElementsByName(ze), pt = 0; Dt = St[pt++]; )
                if (rt = Dt.getAttributeNode("id"), rt && rt.value === ze)
                  return [Dt];
            }
            return [];
          }
        }), I.find.TAG = z.getElementsByTagName ? function(ze, Ze) {
          if (typeof Ze.getElementsByTagName < "u")
            return Ze.getElementsByTagName(ze);
          if (z.qsa)
            return Ze.querySelectorAll(ze);
        } : function(ze, Ze) {
          var rt, pt = [], St = 0, Dt = Ze.getElementsByTagName(ze);
          if (ze === "*") {
            for (; rt = Dt[St++]; )
              rt.nodeType === 1 && pt.push(rt);
            return pt;
          }
          return Dt;
        }, I.find.CLASS = z.getElementsByClassName && function(ze, Ze) {
          if (typeof Ze.getElementsByClassName < "u" && en)
            return Ze.getElementsByClassName(ze);
        }, Qn = [], Ft = [], (z.qsa = pi.test(_e.querySelectorAll)) && (ee(function(ze) {
          var Ze;
          Xt.appendChild(ze).innerHTML = "<a id='" + Nn + "'></a><select id='" + Nn + "-\r\\' msallowcapture=''><option selected=''></option></select>", ze.querySelectorAll("[msallowcapture^='']").length && Ft.push("[*^$]=" + zn + `*(?:''|"")`), ze.querySelectorAll("[selected]").length || Ft.push("\\[" + zn + "*(?:value|" + el + ")"), ze.querySelectorAll("[id~=" + Nn + "-]").length || Ft.push("~="), Ze = _e.createElement("input"), Ze.setAttribute("name", ""), ze.appendChild(Ze), ze.querySelectorAll("[name='']").length || Ft.push("\\[" + zn + "*name" + zn + "*=" + zn + `*(?:''|"")`), ze.querySelectorAll(":checked").length || Ft.push(":checked"), ze.querySelectorAll("a#" + Nn + "+*").length || Ft.push(".#.+[+~]"), ze.querySelectorAll("\\\f"), Ft.push("[\\r\\n\\f]");
        }), ee(function(ze) {
          ze.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
          var Ze = _e.createElement("input");
          Ze.setAttribute("type", "hidden"), ze.appendChild(Ze).setAttribute("name", "D"), ze.querySelectorAll("[name=d]").length && Ft.push("name" + zn + "*[*^$|!~]?="), ze.querySelectorAll(":enabled").length !== 2 && Ft.push(":enabled", ":disabled"), Xt.appendChild(ze).disabled = !0, ze.querySelectorAll(":disabled").length !== 2 && Ft.push(":enabled", ":disabled"), ze.querySelectorAll("*,:x"), Ft.push(",.*:");
        })), (z.matchesSelector = pi.test(Kn = Xt.matches || Xt.webkitMatchesSelector || Xt.mozMatchesSelector || Xt.oMatchesSelector || Xt.msMatchesSelector)) && ee(function(ze) {
          z.disconnectedMatch = Kn.call(ze, "*"), Kn.call(ze, "[s!='']:x"), Qn.push("!=", bs);
        }), Ft = Ft.length && new RegExp(Ft.join("|")), Qn = Qn.length && new RegExp(Qn.join("|")), fe = pi.test(Xt.compareDocumentPosition), ur = fe || pi.test(Xt.contains) ? function(ze, Ze) {
          var rt = ze.nodeType === 9 ? ze.documentElement : ze, pt = Ze && Ze.parentNode;
          return ze === pt || !!(pt && pt.nodeType === 1 && (rt.contains ? rt.contains(pt) : ze.compareDocumentPosition && ze.compareDocumentPosition(pt) & 16));
        } : function(ze, Ze) {
          if (Ze) {
            for (; Ze = Ze.parentNode; )
              if (Ze === ze)
                return !0;
          }
          return !1;
        }, aa = fe ? function(ze, Ze) {
          if (ze === Ze)
            return it = !0, 0;
          var rt = !ze.compareDocumentPosition - !Ze.compareDocumentPosition;
          return rt || (rt = (ze.ownerDocument || ze) == (Ze.ownerDocument || Ze) ? ze.compareDocumentPosition(Ze) : 1, rt & 1 || !z.sortDetached && Ze.compareDocumentPosition(ze) === rt ? ze == _e || ze.ownerDocument == tn && ur(tn, ze) ? -1 : Ze == _e || Ze.ownerDocument == tn && ur(tn, Ze) ? 1 : Xe ? Ja(Xe, ze) - Ja(Xe, Ze) : 0 : rt & 4 ? -1 : 1);
        } : function(ze, Ze) {
          if (ze === Ze)
            return it = !0, 0;
          var rt, pt = 0, St = ze.parentNode, Dt = Ze.parentNode, Vt = [ze], Rt = [Ze];
          if (!St || !Dt)
            return ze == _e ? -1 : Ze == _e ? 1 : St ? -1 : Dt ? 1 : Xe ? Ja(Xe, ze) - Ja(Xe, Ze) : 0;
          if (St === Dt)
            return O(ze, Ze);
          for (rt = ze; rt = rt.parentNode; )
            Vt.unshift(rt);
          for (rt = Ze; rt = rt.parentNode; )
            Rt.unshift(rt);
          for (; Vt[pt] === Rt[pt]; )
            pt++;
          return pt ? O(Vt[pt], Rt[pt]) : Vt[pt] == tn ? -1 : Rt[pt] == tn ? 1 : 0;
        }), _e;
      }, Rn.matches = function(ie, fe) {
        return Rn(ie, null, null, fe);
      }, Rn.matchesSelector = function(ie, fe) {
        if (Be(ie), z.matchesSelector && en && !cr[fe + " "] && (!Qn || !Qn.test(fe)) && (!Ft || !Ft.test(fe)))
          try {
            var we = Kn.call(ie, fe);
            if (we || z.disconnectedMatch || ie.document && ie.document.nodeType !== 11)
              return we;
          } catch {
            cr(fe, !0);
          }
        return Rn(fe, _e, null, [ie]).length > 0;
      }, Rn.contains = function(ie, fe) {
        return (ie.ownerDocument || ie) != _e && Be(ie), ur(ie, fe);
      }, Rn.attr = function(ie, fe) {
        (ie.ownerDocument || ie) != _e && Be(ie);
        var we = I.attrHandle[fe.toLowerCase()], Ge = we && Fr.call(I.attrHandle, fe.toLowerCase()) ? we(ie, fe, !en) : void 0;
        return Ge !== void 0 ? Ge : z.attributes || !en ? ie.getAttribute(fe) : (Ge = ie.getAttributeNode(fe)) && Ge.specified ? Ge.value : null;
      }, Rn.escape = function(ie) {
        return (ie + "").replace(s1, l1);
      }, Rn.error = function(ie) {
        throw new Error("Syntax error, unrecognized expression: " + ie);
      }, Rn.uniqueSort = function(ie) {
        var fe, we = [], Ge = 0, ze = 0;
        if (it = !z.detectDuplicates, Xe = !z.sortStable && ie.slice(0), ie.sort(aa), it) {
          for (; fe = ie[ze++]; )
            fe === ie[ze] && (Ge = we.push(ze));
          for (; Ge--; )
            ie.splice(we[Ge], 1);
        }
        return Xe = null, ie;
      }, _ = Rn.getText = function(ie) {
        var fe, we = "", Ge = 0, ze = ie.nodeType;
        if (ze) {
          if (ze === 1 || ze === 9 || ze === 11) {
            if (typeof ie.textContent == "string")
              return ie.textContent;
            for (ie = ie.firstChild; ie; ie = ie.nextSibling)
              we += _(ie);
          } else if (ze === 3 || ze === 4)
            return ie.nodeValue;
        } else
          for (; fe = ie[Ge++]; )
            we += _(fe);
        return we;
      }, I = Rn.selectors = {
        cacheLength: 50,
        createPseudo: Cr,
        match: nu,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(ie) {
            return ie[1] = ie[1].replace(sa, Da), ie[3] = (ie[3] || ie[4] || ie[5] || "").replace(sa, Da), ie[2] === "~=" && (ie[3] = " " + ie[3] + " "), ie.slice(0, 4);
          },
          CHILD: function(ie) {
            return ie[1] = ie[1].toLowerCase(), ie[1].slice(0, 3) === "nth" ? (ie[3] || Rn.error(ie[0]), ie[4] = +(ie[4] ? ie[5] + (ie[6] || 1) : 2 * (ie[3] === "even" || ie[3] === "odd")), ie[5] = +(ie[7] + ie[8] || ie[3] === "odd")) : ie[3] && Rn.error(ie[0]), ie;
          },
          PSEUDO: function(ie) {
            var fe, we = !ie[6] && ie[2];
            return nu.CHILD.test(ie[0]) ? null : (ie[3] ? ie[2] = ie[4] || ie[5] || "" : we && Uc.test(we) && (fe = ne(we, !0)) && (fe = we.indexOf(")", we.length - fe) - we.length) && (ie[0] = ie[0].slice(0, fe), ie[2] = we.slice(0, fe)), ie.slice(0, 3));
          }
        },
        filter: {
          TAG: function(ie) {
            var fe = ie.replace(sa, Da).toLowerCase();
            return ie === "*" ? function() {
              return !0;
            } : function(we) {
              return we.nodeName && we.nodeName.toLowerCase() === fe;
            };
          },
          CLASS: function(ie) {
            var fe = Zn[ie + " "];
            return fe || (fe = new RegExp("(^|" + zn + ")" + ie + "(" + zn + "|$)")) && Zn(
              ie,
              function(we) {
                return fe.test(
                  typeof we.className == "string" && we.className || typeof we.getAttribute < "u" && we.getAttribute("class") || ""
                );
              }
            );
          },
          ATTR: function(ie, fe, we) {
            return function(Ge) {
              var ze = Rn.attr(Ge, ie);
              return ze == null ? fe === "!=" : fe ? (ze += "", fe === "=" ? ze === we : fe === "!=" ? ze !== we : fe === "^=" ? we && ze.indexOf(we) === 0 : fe === "*=" ? we && ze.indexOf(we) > -1 : fe === "$=" ? we && ze.slice(-we.length) === we : fe === "~=" ? (" " + ze.replace(N2, " ") + " ").indexOf(we) > -1 : fe === "|=" ? ze === we || ze.slice(0, we.length + 1) === we + "-" : !1) : !0;
            };
          },
          CHILD: function(ie, fe, we, Ge, ze) {
            var Ze = ie.slice(0, 3) !== "nth", rt = ie.slice(-4) !== "last", pt = fe === "of-type";
            return Ge === 1 && ze === 0 ? function(St) {
              return !!St.parentNode;
            } : function(St, Dt, Vt) {
              var Rt, gn, qn, Yt, Oi, Qi, Xr = Ze !== rt ? "nextSibling" : "previousSibling", ri = St.parentNode, _c = pt && St.nodeName.toLowerCase(), Wc = !Vt && !pt, Rr = !1;
              if (ri) {
                if (Ze) {
                  for (; Xr; ) {
                    for (Yt = St; Yt = Yt[Xr]; )
                      if (pt ? Yt.nodeName.toLowerCase() === _c : Yt.nodeType === 1)
                        return !1;
                    Qi = Xr = ie === "only" && !Qi && "nextSibling";
                  }
                  return !0;
                }
                if (Qi = [rt ? ri.firstChild : ri.lastChild], rt && Wc) {
                  for (Yt = ri, qn = Yt[Nn] || (Yt[Nn] = {}), gn = qn[Yt.uniqueID] || (qn[Yt.uniqueID] = {}), Rt = gn[ie] || [], Oi = Rt[0] === Gi && Rt[1], Rr = Oi && Rt[2], Yt = Oi && ri.childNodes[Oi]; Yt = ++Oi && Yt && Yt[Xr] || (Rr = Oi = 0) || Qi.pop(); )
                    if (Yt.nodeType === 1 && ++Rr && Yt === St) {
                      gn[ie] = [Gi, Oi, Rr];
                      break;
                    }
                } else if (Wc && (Yt = St, qn = Yt[Nn] || (Yt[Nn] = {}), gn = qn[Yt.uniqueID] || (qn[Yt.uniqueID] = {}), Rt = gn[ie] || [], Oi = Rt[0] === Gi && Rt[1], Rr = Oi), Rr === !1)
                  for (; (Yt = ++Oi && Yt && Yt[Xr] || (Rr = Oi = 0) || Qi.pop()) && !((pt ? Yt.nodeName.toLowerCase() === _c : Yt.nodeType === 1) && ++Rr && (Wc && (qn = Yt[Nn] || (Yt[Nn] = {}), gn = qn[Yt.uniqueID] || (qn[Yt.uniqueID] = {}), gn[ie] = [Gi, Rr]), Yt === St)); )
                    ;
                return Rr -= ze, Rr === Ge || Rr % Ge === 0 && Rr / Ge >= 0;
              }
            };
          },
          PSEUDO: function(ie, fe) {
            var we, Ge = I.pseudos[ie] || I.setFilters[ie.toLowerCase()] || Rn.error("unsupported pseudo: " + ie);
            return Ge[Nn] ? Ge(fe) : Ge.length > 1 ? (we = [ie, ie, "", fe], I.setFilters.hasOwnProperty(ie.toLowerCase()) ? Cr(function(ze, Ze) {
              for (var rt, pt = Ge(ze, fe), St = pt.length; St--; )
                rt = Ja(ze, pt[St]), ze[rt] = !(Ze[rt] = pt[St]);
            }) : function(ze) {
              return Ge(ze, 0, we);
            }) : Ge;
          }
        },
        pseudos: {
          not: Cr(function(ie) {
            var fe = [], we = [], Ge = me(ie.replace(tu, "$1"));
            return Ge[Nn] ? Cr(function(ze, Ze, rt, pt) {
              for (var St, Dt = Ge(ze, null, pt, []), Vt = ze.length; Vt--; )
                (St = Dt[Vt]) && (ze[Vt] = !(Ze[Vt] = St));
            }) : function(ze, Ze, rt) {
              return fe[0] = ze, Ge(fe, null, rt, we), fe[0] = null, !we.pop();
            };
          }),
          has: Cr(function(ie) {
            return function(fe) {
              return Rn(ie, fe).length > 0;
            };
          }),
          contains: Cr(function(ie) {
            return ie = ie.replace(sa, Da), function(fe) {
              return (fe.textContent || _(fe)).indexOf(ie) > -1;
            };
          }),
          lang: Cr(function(ie) {
            return X2.test(ie || "") || Rn.error("unsupported lang: " + ie), ie = ie.replace(sa, Da).toLowerCase(), function(fe) {
              var we;
              do
                if (we = en ? fe.lang : fe.getAttribute("xml:lang") || fe.getAttribute("lang"))
                  return we = we.toLowerCase(), we === ie || we.indexOf(ie + "-") === 0;
              while ((fe = fe.parentNode) && fe.nodeType === 1);
              return !1;
            };
          }),
          target: function(ie) {
            var fe = g.location && g.location.hash;
            return fe && fe.slice(1) === ie.id;
          },
          root: function(ie) {
            return ie === Xt;
          },
          focus: function(ie) {
            return ie === _e.activeElement && (!_e.hasFocus || _e.hasFocus()) && !!(ie.type || ie.href || ~ie.tabIndex);
          },
          enabled: X(!1),
          disabled: X(!0),
          checked: function(ie) {
            var fe = ie.nodeName.toLowerCase();
            return fe === "input" && !!ie.checked || fe === "option" && !!ie.selected;
          },
          selected: function(ie) {
            return ie.parentNode && ie.parentNode.selectedIndex, ie.selected === !0;
          },
          empty: function(ie) {
            for (ie = ie.firstChild; ie; ie = ie.nextSibling)
              if (ie.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(ie) {
            return !I.pseudos.empty(ie);
          },
          header: function(ie) {
            return Co.test(ie.nodeName);
          },
          input: function(ie) {
            return Hn.test(ie.nodeName);
          },
          button: function(ie) {
            var fe = ie.nodeName.toLowerCase();
            return fe === "input" && ie.type === "button" || fe === "button";
          },
          text: function(ie) {
            var fe;
            return ie.nodeName.toLowerCase() === "input" && ie.type === "text" && ((fe = ie.getAttribute("type")) == null || fe.toLowerCase() === "text");
          },
          first: U(function() {
            return [0];
          }),
          last: U(function(ie, fe) {
            return [fe - 1];
          }),
          eq: U(function(ie, fe, we) {
            return [we < 0 ? we + fe : we];
          }),
          even: U(function(ie, fe) {
            for (var we = 0; we < fe; we += 2)
              ie.push(we);
            return ie;
          }),
          odd: U(function(ie, fe) {
            for (var we = 1; we < fe; we += 2)
              ie.push(we);
            return ie;
          }),
          lt: U(function(ie, fe, we) {
            for (var Ge = we < 0 ? we + fe : we > fe ? fe : we; --Ge >= 0; )
              ie.push(Ge);
            return ie;
          }),
          gt: U(function(ie, fe, we) {
            for (var Ge = we < 0 ? we + fe : we; ++Ge < fe; )
              ie.push(Ge);
            return ie;
          })
        }
      }, I.pseudos.nth = I.pseudos.eq;
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        I.pseudos[w] = k(w);
      for (w in { submit: !0, reset: !0 })
        I.pseudos[w] = M(w);
      function le() {
      }
      le.prototype = I.filters = I.pseudos, I.setFilters = new le(), ne = Rn.tokenize = function(ie, fe) {
        var we, Ge, ze, Ze, rt, pt, St, Dt = $s[ie + " "];
        if (Dt)
          return fe ? 0 : Dt.slice(0);
        for (rt = ie, pt = [], St = I.preFilter; rt; ) {
          (!we || (Ge = j2.exec(rt))) && (Ge && (rt = rt.slice(Ge[0].length) || rt), pt.push(ze = [])), we = !1, (Ge = o1.exec(rt)) && (we = Ge.shift(), ze.push({
            value: we,
            type: Ge[0].replace(tu, " ")
          }), rt = rt.slice(we.length));
          for (Ze in I.filter)
            (Ge = nu[Ze].exec(rt)) && (!St[Ze] || (Ge = St[Ze](Ge))) && (we = Ge.shift(), ze.push({
              value: we,
              type: Ze,
              matches: Ge
            }), rt = rt.slice(we.length));
          if (!we)
            break;
        }
        return fe ? rt.length : rt ? Rn.error(ie) : $s(ie, pt).slice(0);
      };
      function be(ie) {
        for (var fe = 0, we = ie.length, Ge = ""; fe < we; fe++)
          Ge += ie[fe].value;
        return Ge;
      }
      function ge(ie, fe, we) {
        var Ge = fe.dir, ze = fe.next, Ze = ze || Ge, rt = we && Ze === "parentNode", pt = xn++;
        return fe.first ? function(St, Dt, Vt) {
          for (; St = St[Ge]; )
            if (St.nodeType === 1 || rt)
              return ie(St, Dt, Vt);
          return !1;
        } : function(St, Dt, Vt) {
          var Rt, gn, qn, Yt = [Gi, pt];
          if (Vt) {
            for (; St = St[Ge]; )
              if ((St.nodeType === 1 || rt) && ie(St, Dt, Vt))
                return !0;
          } else
            for (; St = St[Ge]; )
              if (St.nodeType === 1 || rt)
                if (qn = St[Nn] || (St[Nn] = {}), gn = qn[St.uniqueID] || (qn[St.uniqueID] = {}), ze && ze === St.nodeName.toLowerCase())
                  St = St[Ge] || St;
                else {
                  if ((Rt = gn[Ze]) && Rt[0] === Gi && Rt[1] === pt)
                    return Yt[2] = Rt[2];
                  if (gn[Ze] = Yt, Yt[2] = ie(St, Dt, Vt))
                    return !0;
                }
          return !1;
        };
      }
      function xe(ie) {
        return ie.length > 1 ? function(fe, we, Ge) {
          for (var ze = ie.length; ze--; )
            if (!ie[ze](fe, we, Ge))
              return !1;
          return !0;
        } : ie[0];
      }
      function qe(ie, fe, we) {
        for (var Ge = 0, ze = fe.length; Ge < ze; Ge++)
          Rn(ie, fe[Ge], we);
        return we;
      }
      function ht(ie, fe, we, Ge, ze) {
        for (var Ze, rt = [], pt = 0, St = ie.length, Dt = fe != null; pt < St; pt++)
          (Ze = ie[pt]) && (!we || we(Ze, Ge, ze)) && (rt.push(Ze), Dt && fe.push(pt));
        return rt;
      }
      function Ot(ie, fe, we, Ge, ze, Ze) {
        return Ge && !Ge[Nn] && (Ge = Ot(Ge)), ze && !ze[Nn] && (ze = Ot(ze, Ze)), Cr(function(rt, pt, St, Dt) {
          var Vt, Rt, gn, qn = [], Yt = [], Oi = pt.length, Qi = rt || qe(
            fe || "*",
            St.nodeType ? [St] : St,
            []
          ), Xr = ie && (rt || !fe) ? ht(Qi, qn, ie, St, Dt) : Qi, ri = we ? ze || (rt ? ie : Oi || Ge) ? [] : pt : Xr;
          if (we && we(Xr, ri, St, Dt), Ge)
            for (Vt = ht(ri, Yt), Ge(Vt, [], St, Dt), Rt = Vt.length; Rt--; )
              (gn = Vt[Rt]) && (ri[Yt[Rt]] = !(Xr[Yt[Rt]] = gn));
          if (rt) {
            if (ze || ie) {
              if (ze) {
                for (Vt = [], Rt = ri.length; Rt--; )
                  (gn = ri[Rt]) && Vt.push(Xr[Rt] = gn);
                ze(null, ri = [], Vt, Dt);
              }
              for (Rt = ri.length; Rt--; )
                (gn = ri[Rt]) && (Vt = ze ? Ja(rt, gn) : qn[Rt]) > -1 && (rt[Vt] = !(pt[Vt] = gn));
            }
          } else
            ri = ht(
              ri === pt ? ri.splice(Oi, ri.length) : ri
            ), ze ? ze(null, pt, ri, Dt) : za.apply(pt, ri);
        });
      }
      function ut(ie) {
        for (var fe, we, Ge, ze = ie.length, Ze = I.relative[ie[0].type], rt = Ze || I.relative[" "], pt = Ze ? 1 : 0, St = ge(function(Rt) {
          return Rt === fe;
        }, rt, !0), Dt = ge(function(Rt) {
          return Ja(fe, Rt) > -1;
        }, rt, !0), Vt = [function(Rt, gn, qn) {
          var Yt = !Ze && (qn || gn !== Oe) || ((fe = gn).nodeType ? St(Rt, gn, qn) : Dt(Rt, gn, qn));
          return fe = null, Yt;
        }]; pt < ze; pt++)
          if (we = I.relative[ie[pt].type])
            Vt = [ge(xe(Vt), we)];
          else {
            if (we = I.filter[ie[pt].type].apply(null, ie[pt].matches), we[Nn]) {
              for (Ge = ++pt; Ge < ze && !I.relative[ie[Ge].type]; Ge++)
                ;
              return Ot(
                pt > 1 && xe(Vt),
                pt > 1 && be(
                  ie.slice(0, pt - 1).concat({ value: ie[pt - 2].type === " " ? "*" : "" })
                ).replace(tu, "$1"),
                we,
                pt < Ge && ut(ie.slice(pt, Ge)),
                Ge < ze && ut(ie = ie.slice(Ge)),
                Ge < ze && be(ie)
              );
            }
            Vt.push(we);
          }
        return xe(Vt);
      }
      function Wt(ie, fe) {
        var we = fe.length > 0, Ge = ie.length > 0, ze = function(Ze, rt, pt, St, Dt) {
          var Vt, Rt, gn, qn = 0, Yt = "0", Oi = Ze && [], Qi = [], Xr = Oe, ri = Ze || Ge && I.find.TAG("*", Dt), _c = Gi += Xr == null ? 1 : Math.random() || 0.1, Wc = ri.length;
          for (Dt && (Oe = rt == _e || rt || Dt); Yt !== Wc && (Vt = ri[Yt]) != null; Yt++) {
            if (Ge && Vt) {
              for (Rt = 0, !rt && Vt.ownerDocument != _e && (Be(Vt), pt = !en); gn = ie[Rt++]; )
                if (gn(Vt, rt || _e, pt)) {
                  St.push(Vt);
                  break;
                }
              Dt && (Gi = _c);
            }
            we && ((Vt = !gn && Vt) && qn--, Ze && Oi.push(Vt));
          }
          if (qn += Yt, we && Yt !== qn) {
            for (Rt = 0; gn = fe[Rt++]; )
              gn(Oi, Qi, rt, pt);
            if (Ze) {
              if (qn > 0)
                for (; Yt--; )
                  Oi[Yt] || Qi[Yt] || (Qi[Yt] = Oa.call(St));
              Qi = ht(Qi);
            }
            za.apply(St, Qi), Dt && !Ze && Qi.length > 0 && qn + fe.length > 1 && Rn.uniqueSort(St);
          }
          return Dt && (Gi = _c, Oe = Xr), Oi;
        };
        return we ? Cr(ze) : ze;
      }
      return me = Rn.compile = function(ie, fe) {
        var we, Ge = [], ze = [], Ze = eu[ie + " "];
        if (!Ze) {
          for (fe || (fe = ne(ie)), we = fe.length; we--; )
            Ze = ut(fe[we]), Ze[Nn] ? Ge.push(Ze) : ze.push(Ze);
          Ze = eu(
            ie,
            Wt(ze, Ge)
          ), Ze.selector = ie;
        }
        return Ze;
      }, ye = Rn.select = function(ie, fe, we, Ge) {
        var ze, Ze, rt, pt, St, Dt = typeof ie == "function" && ie, Vt = !Ge && ne(ie = Dt.selector || ie);
        if (we = we || [], Vt.length === 1) {
          if (Ze = Vt[0] = Vt[0].slice(0), Ze.length > 2 && (rt = Ze[0]).type === "ID" && fe.nodeType === 9 && en && I.relative[Ze[1].type]) {
            if (fe = (I.find.ID(rt.matches[0].replace(sa, Da), fe) || [])[0], fe)
              Dt && (fe = fe.parentNode);
            else
              return we;
            ie = ie.slice(Ze.shift().value.length);
          }
          for (ze = nu.needsContext.test(ie) ? 0 : Ze.length; ze-- && (rt = Ze[ze], !I.relative[pt = rt.type]); )
            if ((St = I.find[pt]) && (Ge = St(
              rt.matches[0].replace(sa, Da),
              qc.test(Ze[0].type) && ae(fe.parentNode) || fe
            ))) {
              if (Ze.splice(ze, 1), ie = Ge.length && be(Ze), !ie)
                return za.apply(we, Ge), we;
              break;
            }
        }
        return (Dt || me(ie, Vt))(
          Ge,
          fe,
          !en,
          we,
          !fe || qc.test(ie) && ae(fe.parentNode) || fe
        ), we;
      }, z.sortStable = Nn.split("").sort(aa).join("") === Nn, z.detectDuplicates = !!it, Be(), z.sortDetached = ee(function(ie) {
        return ie.compareDocumentPosition(_e.createElement("fieldset")) & 1;
      }), ee(function(ie) {
        return ie.innerHTML = "<a href='#'></a>", ie.firstChild.getAttribute("href") === "#";
      }) || A("type|href|height|width", function(ie, fe, we) {
        if (!we)
          return ie.getAttribute(fe, fe.toLowerCase() === "type" ? 1 : 2);
      }), (!z.attributes || !ee(function(ie) {
        return ie.innerHTML = "<input/>", ie.firstChild.setAttribute("value", ""), ie.firstChild.getAttribute("value") === "";
      })) && A("value", function(ie, fe, we) {
        if (!we && ie.nodeName.toLowerCase() === "input")
          return ie.defaultValue;
      }), ee(function(ie) {
        return ie.getAttribute("disabled") == null;
      }) || A(el, function(ie, fe, we) {
        var Ge;
        if (!we)
          return ie[fe] === !0 ? fe.toLowerCase() : (Ge = ie.getAttributeNode(fe)) && Ge.specified ? Ge.value : null;
      }), Rn;
    }(t);
    v.find = V, v.expr = V.selectors, v.expr[":"] = v.expr.pseudos, v.uniqueSort = v.unique = V.uniqueSort, v.text = V.getText, v.isXMLDoc = V.isXML, v.contains = V.contains, v.escapeSelector = V.escape;
    var R = function(g, w, z) {
      for (var I = [], _ = z !== void 0; (g = g[w]) && g.nodeType !== 9; )
        if (g.nodeType === 1) {
          if (_ && v(g).is(z))
            break;
          I.push(g);
        }
      return I;
    }, F = function(g, w) {
      for (var z = []; g; g = g.nextSibling)
        g.nodeType === 1 && g !== w && z.push(g);
      return z;
    }, K = v.expr.match.needsContext;
    function q(g, w) {
      return g.nodeName && g.nodeName.toLowerCase() === w.toLowerCase();
    }
    var G = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function te(g, w, z) {
      return y(w) ? v.grep(g, function(I, _) {
        return !!w.call(I, _, I) !== z;
      }) : w.nodeType ? v.grep(g, function(I) {
        return I === w !== z;
      }) : typeof w != "string" ? v.grep(g, function(I) {
        return l.call(w, I) > -1 !== z;
      }) : v.filter(w, g, z);
    }
    v.filter = function(g, w, z) {
      var I = w[0];
      return z && (g = ":not(" + g + ")"), w.length === 1 && I.nodeType === 1 ? v.find.matchesSelector(I, g) ? [I] : [] : v.find.matches(g, v.grep(w, function(_) {
        return _.nodeType === 1;
      }));
    }, v.fn.extend({
      find: function(g) {
        var w, z, I = this.length, _ = this;
        if (typeof g != "string")
          return this.pushStack(v(g).filter(function() {
            for (w = 0; w < I; w++)
              if (v.contains(_[w], this))
                return !0;
          }));
        for (z = this.pushStack([]), w = 0; w < I; w++)
          v.find(g, _[w], z);
        return I > 1 ? v.uniqueSort(z) : z;
      },
      filter: function(g) {
        return this.pushStack(te(this, g || [], !1));
      },
      not: function(g) {
        return this.pushStack(te(this, g || [], !0));
      },
      is: function(g) {
        return !!te(
          this,
          typeof g == "string" && K.test(g) ? v(g) : g || [],
          !1
        ).length;
      }
    });
    var Q, Y = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, Z = v.fn.init = function(g, w, z) {
      var I, _;
      if (!g)
        return this;
      if (z = z || Q, typeof g == "string")
        if (g[0] === "<" && g[g.length - 1] === ">" && g.length >= 3 ? I = [null, g, null] : I = Y.exec(g), I && (I[1] || !w))
          if (I[1]) {
            if (w = w instanceof v ? w[0] : w, v.merge(this, v.parseHTML(
              I[1],
              w && w.nodeType ? w.ownerDocument || w : b,
              !0
            )), G.test(I[1]) && v.isPlainObject(w))
              for (I in w)
                y(this[I]) ? this[I](w[I]) : this.attr(I, w[I]);
            return this;
          } else
            return _ = b.getElementById(I[2]), _ && (this[0] = _, this.length = 1), this;
        else
          return !w || w.jquery ? (w || z).find(g) : this.constructor(w).find(g);
      else {
        if (g.nodeType)
          return this[0] = g, this.length = 1, this;
        if (y(g))
          return z.ready !== void 0 ? z.ready(g) : g(v);
      }
      return v.makeArray(g, this);
    };
    Z.prototype = v.fn, Q = v(b);
    var oe = /^(?:parents|prev(?:Until|All))/, he = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    v.fn.extend({
      has: function(g) {
        var w = v(g, this), z = w.length;
        return this.filter(function() {
          for (var I = 0; I < z; I++)
            if (v.contains(this, w[I]))
              return !0;
        });
      },
      closest: function(g, w) {
        var z, I = 0, _ = this.length, W = [], ne = typeof g != "string" && v(g);
        if (!K.test(g)) {
          for (; I < _; I++)
            for (z = this[I]; z && z !== w; z = z.parentNode)
              if (z.nodeType < 11 && (ne ? ne.index(z) > -1 : z.nodeType === 1 && v.find.matchesSelector(z, g))) {
                W.push(z);
                break;
              }
        }
        return this.pushStack(W.length > 1 ? v.uniqueSort(W) : W);
      },
      index: function(g) {
        return g ? typeof g == "string" ? l.call(v(g), this[0]) : l.call(
          this,
          g.jquery ? g[0] : g
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(g, w) {
        return this.pushStack(
          v.uniqueSort(
            v.merge(this.get(), v(g, w))
          )
        );
      },
      addBack: function(g) {
        return this.add(
          g == null ? this.prevObject : this.prevObject.filter(g)
        );
      }
    });
    function Ae(g, w) {
      for (; (g = g[w]) && g.nodeType !== 1; )
        ;
      return g;
    }
    v.each({
      parent: function(g) {
        var w = g.parentNode;
        return w && w.nodeType !== 11 ? w : null;
      },
      parents: function(g) {
        return R(g, "parentNode");
      },
      parentsUntil: function(g, w, z) {
        return R(g, "parentNode", z);
      },
      next: function(g) {
        return Ae(g, "nextSibling");
      },
      prev: function(g) {
        return Ae(g, "previousSibling");
      },
      nextAll: function(g) {
        return R(g, "nextSibling");
      },
      prevAll: function(g) {
        return R(g, "previousSibling");
      },
      nextUntil: function(g, w, z) {
        return R(g, "nextSibling", z);
      },
      prevUntil: function(g, w, z) {
        return R(g, "previousSibling", z);
      },
      siblings: function(g) {
        return F((g.parentNode || {}).firstChild, g);
      },
      children: function(g) {
        return F(g.firstChild);
      },
      contents: function(g) {
        return g.contentDocument != null && i(g.contentDocument) ? g.contentDocument : (q(g, "template") && (g = g.content || g), v.merge([], g.childNodes));
      }
    }, function(g, w) {
      v.fn[g] = function(z, I) {
        var _ = v.map(this, w, z);
        return g.slice(-5) !== "Until" && (I = z), I && typeof I == "string" && (_ = v.filter(I, _)), this.length > 1 && (he[g] || v.uniqueSort(_), oe.test(g) && _.reverse()), this.pushStack(_);
      };
    });
    var We = /[^\x20\t\r\n\f]+/g;
    function ke(g) {
      var w = {};
      return v.each(g.match(We) || [], function(z, I) {
        w[I] = !0;
      }), w;
    }
    v.Callbacks = function(g) {
      g = typeof g == "string" ? ke(g) : v.extend({}, g);
      var w, z, I, _, W = [], ne = [], me = -1, ye = function() {
        for (_ = _ || g.once, I = w = !0; ne.length; me = -1)
          for (z = ne.shift(); ++me < W.length; )
            W[me].apply(z[0], z[1]) === !1 && g.stopOnFalse && (me = W.length, z = !1);
        g.memory || (z = !1), w = !1, _ && (z ? W = [] : W = "");
      }, Oe = {
        add: function() {
          return W && (z && !w && (me = W.length - 1, ne.push(z)), function Xe(it) {
            v.each(it, function(Be, _e) {
              y(_e) ? (!g.unique || !Oe.has(_e)) && W.push(_e) : _e && _e.length && S(_e) !== "string" && Xe(_e);
            });
          }(arguments), z && !w && ye()), this;
        },
        remove: function() {
          return v.each(arguments, function(Xe, it) {
            for (var Be; (Be = v.inArray(it, W, Be)) > -1; )
              W.splice(Be, 1), Be <= me && me--;
          }), this;
        },
        has: function(Xe) {
          return Xe ? v.inArray(Xe, W) > -1 : W.length > 0;
        },
        empty: function() {
          return W && (W = []), this;
        },
        disable: function() {
          return _ = ne = [], W = z = "", this;
        },
        disabled: function() {
          return !W;
        },
        lock: function() {
          return _ = ne = [], !z && !w && (W = z = ""), this;
        },
        locked: function() {
          return !!_;
        },
        fireWith: function(Xe, it) {
          return _ || (it = it || [], it = [Xe, it.slice ? it.slice() : it], ne.push(it), w || ye()), this;
        },
        fire: function() {
          return Oe.fireWith(this, arguments), this;
        },
        fired: function() {
          return !!I;
        }
      };
      return Oe;
    };
    function Re(g) {
      return g;
    }
    function ve(g) {
      throw g;
    }
    function Ye(g, w, z, I) {
      var _;
      try {
        g && y(_ = g.promise) ? _.call(g).done(w).fail(z) : g && y(_ = g.then) ? _.call(g, w, z) : w.apply(void 0, [g].slice(I));
      } catch (W) {
        z.apply(void 0, [W]);
      }
    }
    v.extend({
      Deferred: function(g) {
        var w = [
          [
            "notify",
            "progress",
            v.Callbacks("memory"),
            v.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            v.Callbacks("once memory"),
            v.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            v.Callbacks("once memory"),
            v.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], z = "pending", I = {
          state: function() {
            return z;
          },
          always: function() {
            return _.done(arguments).fail(arguments), this;
          },
          catch: function(W) {
            return I.then(null, W);
          },
          pipe: function() {
            var W = arguments;
            return v.Deferred(function(ne) {
              v.each(w, function(me, ye) {
                var Oe = y(W[ye[4]]) && W[ye[4]];
                _[ye[1]](function() {
                  var Xe = Oe && Oe.apply(this, arguments);
                  Xe && y(Xe.promise) ? Xe.promise().progress(ne.notify).done(ne.resolve).fail(ne.reject) : ne[ye[0] + "With"](
                    this,
                    Oe ? [Xe] : arguments
                  );
                });
              }), W = null;
            }).promise();
          },
          then: function(W, ne, me) {
            var ye = 0;
            function Oe(Xe, it, Be, _e) {
              return function() {
                var Xt = this, en = arguments, Ft = function() {
                  var Kn, ur;
                  if (!(Xe < ye)) {
                    if (Kn = Be.apply(Xt, en), Kn === it.promise())
                      throw new TypeError("Thenable self-resolution");
                    ur = Kn && (typeof Kn == "object" || typeof Kn == "function") && Kn.then, y(ur) ? _e ? ur.call(
                      Kn,
                      Oe(ye, it, Re, _e),
                      Oe(ye, it, ve, _e)
                    ) : (ye++, ur.call(
                      Kn,
                      Oe(ye, it, Re, _e),
                      Oe(ye, it, ve, _e),
                      Oe(
                        ye,
                        it,
                        Re,
                        it.notifyWith
                      )
                    )) : (Be !== Re && (Xt = void 0, en = [Kn]), (_e || it.resolveWith)(Xt, en));
                  }
                }, Qn = _e ? Ft : function() {
                  try {
                    Ft();
                  } catch (Kn) {
                    v.Deferred.exceptionHook && v.Deferred.exceptionHook(
                      Kn,
                      Qn.stackTrace
                    ), Xe + 1 >= ye && (Be !== ve && (Xt = void 0, en = [Kn]), it.rejectWith(Xt, en));
                  }
                };
                Xe ? Qn() : (v.Deferred.getStackHook && (Qn.stackTrace = v.Deferred.getStackHook()), t.setTimeout(Qn));
              };
            }
            return v.Deferred(function(Xe) {
              w[0][3].add(
                Oe(
                  0,
                  Xe,
                  y(me) ? me : Re,
                  Xe.notifyWith
                )
              ), w[1][3].add(
                Oe(
                  0,
                  Xe,
                  y(W) ? W : Re
                )
              ), w[2][3].add(
                Oe(
                  0,
                  Xe,
                  y(ne) ? ne : ve
                )
              );
            }).promise();
          },
          promise: function(W) {
            return W != null ? v.extend(W, I) : I;
          }
        }, _ = {};
        return v.each(w, function(W, ne) {
          var me = ne[2], ye = ne[5];
          I[ne[1]] = me.add, ye && me.add(
            function() {
              z = ye;
            },
            w[3 - W][2].disable,
            w[3 - W][3].disable,
            w[0][2].lock,
            w[0][3].lock
          ), me.add(ne[3].fire), _[ne[0]] = function() {
            return _[ne[0] + "With"](this === _ ? void 0 : this, arguments), this;
          }, _[ne[0] + "With"] = me.fireWith;
        }), I.promise(_), g && g.call(_, _), _;
      },
      when: function(g) {
        var w = arguments.length, z = w, I = Array(z), _ = a.call(arguments), W = v.Deferred(), ne = function(me) {
          return function(ye) {
            I[me] = this, _[me] = arguments.length > 1 ? a.call(arguments) : ye, --w || W.resolveWith(I, _);
          };
        };
        if (w <= 1 && (Ye(
          g,
          W.done(ne(z)).resolve,
          W.reject,
          !w
        ), W.state() === "pending" || y(_[z] && _[z].then)))
          return W.then();
        for (; z--; )
          Ye(_[z], ne(z), W.reject);
        return W.promise();
      }
    });
    var Qe = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    v.Deferred.exceptionHook = function(g, w) {
      t.console && t.console.warn && g && Qe.test(g.name) && t.console.warn("jQuery.Deferred exception: " + g.message, g.stack, w);
    }, v.readyException = function(g) {
      t.setTimeout(function() {
        throw g;
      });
    };
    var ot = v.Deferred();
    v.fn.ready = function(g) {
      return ot.then(g).catch(function(w) {
        v.readyException(w);
      }), this;
    }, v.extend({
      isReady: !1,
      readyWait: 1,
      ready: function(g) {
        (g === !0 ? --v.readyWait : v.isReady) || (v.isReady = !0, !(g !== !0 && --v.readyWait > 0) && ot.resolveWith(b, [v]));
      }
    }), v.ready.then = ot.then;
    function Ve() {
      b.removeEventListener("DOMContentLoaded", Ve), t.removeEventListener("load", Ve), v.ready();
    }
    b.readyState === "complete" || b.readyState !== "loading" && !b.documentElement.doScroll ? t.setTimeout(v.ready) : (b.addEventListener("DOMContentLoaded", Ve), t.addEventListener("load", Ve));
    var Te = function(g, w, z, I, _, W, ne) {
      var me = 0, ye = g.length, Oe = z == null;
      if (S(z) === "object") {
        _ = !0;
        for (me in z)
          Te(g, w, me, z[me], !0, W, ne);
      } else if (I !== void 0 && (_ = !0, y(I) || (ne = !0), Oe && (ne ? (w.call(g, I), w = null) : (Oe = w, w = function(Xe, it, Be) {
        return Oe.call(v(Xe), Be);
      })), w))
        for (; me < ye; me++)
          w(
            g[me],
            z,
            ne ? I : I.call(g[me], me, w(g[me], z))
          );
      return _ ? g : Oe ? w.call(g) : ye ? w(g[0], z) : W;
    }, Me = /^-ms-/, Je = /-([a-z])/g;
    function mt(g, w) {
      return w.toUpperCase();
    }
    function It(g) {
      return g.replace(Me, "ms-").replace(Je, mt);
    }
    var ln = function(g) {
      return g.nodeType === 1 || g.nodeType === 9 || !+g.nodeType;
    };
    function gt() {
      this.expando = v.expando + gt.uid++;
    }
    gt.uid = 1, gt.prototype = {
      cache: function(g) {
        var w = g[this.expando];
        return w || (w = {}, ln(g) && (g.nodeType ? g[this.expando] = w : Object.defineProperty(g, this.expando, {
          value: w,
          configurable: !0
        }))), w;
      },
      set: function(g, w, z) {
        var I, _ = this.cache(g);
        if (typeof w == "string")
          _[It(w)] = z;
        else
          for (I in w)
            _[It(I)] = w[I];
        return _;
      },
      get: function(g, w) {
        return w === void 0 ? this.cache(g) : g[this.expando] && g[this.expando][It(w)];
      },
      access: function(g, w, z) {
        return w === void 0 || w && typeof w == "string" && z === void 0 ? this.get(g, w) : (this.set(g, w, z), z !== void 0 ? z : w);
      },
      remove: function(g, w) {
        var z, I = g[this.expando];
        if (I !== void 0) {
          if (w !== void 0)
            for (Array.isArray(w) ? w = w.map(It) : (w = It(w), w = w in I ? [w] : w.match(We) || []), z = w.length; z--; )
              delete I[w[z]];
          (w === void 0 || v.isEmptyObject(I)) && (g.nodeType ? g[this.expando] = void 0 : delete g[this.expando]);
        }
      },
      hasData: function(g) {
        var w = g[this.expando];
        return w !== void 0 && !v.isEmptyObject(w);
      }
    };
    var Pe = new gt(), $e = new gt(), Ke = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, lt = /[A-Z]/g;
    function He(g) {
      return g === "true" ? !0 : g === "false" ? !1 : g === "null" ? null : g === +g + "" ? +g : Ke.test(g) ? JSON.parse(g) : g;
    }
    function Le(g, w, z) {
      var I;
      if (z === void 0 && g.nodeType === 1)
        if (I = "data-" + w.replace(lt, "-$&").toLowerCase(), z = g.getAttribute(I), typeof z == "string") {
          try {
            z = He(z);
          } catch {
          }
          $e.set(g, w, z);
        } else
          z = void 0;
      return z;
    }
    v.extend({
      hasData: function(g) {
        return $e.hasData(g) || Pe.hasData(g);
      },
      data: function(g, w, z) {
        return $e.access(g, w, z);
      },
      removeData: function(g, w) {
        $e.remove(g, w);
      },
      _data: function(g, w, z) {
        return Pe.access(g, w, z);
      },
      _removeData: function(g, w) {
        Pe.remove(g, w);
      }
    }), v.fn.extend({
      data: function(g, w) {
        var z, I, _, W = this[0], ne = W && W.attributes;
        if (g === void 0) {
          if (this.length && (_ = $e.get(W), W.nodeType === 1 && !Pe.get(W, "hasDataAttrs"))) {
            for (z = ne.length; z--; )
              ne[z] && (I = ne[z].name, I.indexOf("data-") === 0 && (I = It(I.slice(5)), Le(W, I, _[I])));
            Pe.set(W, "hasDataAttrs", !0);
          }
          return _;
        }
        return typeof g == "object" ? this.each(function() {
          $e.set(this, g);
        }) : Te(this, function(me) {
          var ye;
          if (W && me === void 0)
            return ye = $e.get(W, g), ye !== void 0 || (ye = Le(W, g), ye !== void 0) ? ye : void 0;
          this.each(function() {
            $e.set(this, g, me);
          });
        }, null, w, arguments.length > 1, null, !0);
      },
      removeData: function(g) {
        return this.each(function() {
          $e.remove(this, g);
        });
      }
    }), v.extend({
      queue: function(g, w, z) {
        var I;
        if (g)
          return w = (w || "fx") + "queue", I = Pe.get(g, w), z && (!I || Array.isArray(z) ? I = Pe.access(g, w, v.makeArray(z)) : I.push(z)), I || [];
      },
      dequeue: function(g, w) {
        w = w || "fx";
        var z = v.queue(g, w), I = z.length, _ = z.shift(), W = v._queueHooks(g, w), ne = function() {
          v.dequeue(g, w);
        };
        _ === "inprogress" && (_ = z.shift(), I--), _ && (w === "fx" && z.unshift("inprogress"), delete W.stop, _.call(g, ne, W)), !I && W && W.empty.fire();
      },
      _queueHooks: function(g, w) {
        var z = w + "queueHooks";
        return Pe.get(g, z) || Pe.access(g, z, {
          empty: v.Callbacks("once memory").add(function() {
            Pe.remove(g, [w + "queue", z]);
          })
        });
      }
    }), v.fn.extend({
      queue: function(g, w) {
        var z = 2;
        return typeof g != "string" && (w = g, g = "fx", z--), arguments.length < z ? v.queue(this[0], g) : w === void 0 ? this : this.each(function() {
          var I = v.queue(this, g, w);
          v._queueHooks(this, g), g === "fx" && I[0] !== "inprogress" && v.dequeue(this, g);
        });
      },
      dequeue: function(g) {
        return this.each(function() {
          v.dequeue(this, g);
        });
      },
      clearQueue: function(g) {
        return this.queue(g || "fx", []);
      },
      promise: function(g, w) {
        var z, I = 1, _ = v.Deferred(), W = this, ne = this.length, me = function() {
          --I || _.resolveWith(W, [W]);
        };
        for (typeof g != "string" && (w = g, g = void 0), g = g || "fx"; ne--; )
          z = Pe.get(W[ne], g + "queueHooks"), z && z.empty && (I++, z.empty.add(me));
        return me(), _.promise(w);
      }
    });
    var ct = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Qt = new RegExp("^(?:([+-])=|)(" + ct + ")([a-z%]*)$", "i"), Zt = ["Top", "Right", "Bottom", "Left"], Pn = b.documentElement, Mn = function(g) {
      return v.contains(g.ownerDocument, g);
    }, Mt = { composed: !0 };
    Pn.getRootNode && (Mn = function(g) {
      return v.contains(g.ownerDocument, g) || g.getRootNode(Mt) === g.ownerDocument;
    });
    var Nt = function(g, w) {
      return g = w || g, g.style.display === "none" || g.style.display === "" && Mn(g) && v.css(g, "display") === "none";
    };
    function De(g, w, z, I) {
      var _, W, ne = 20, me = I ? function() {
        return I.cur();
      } : function() {
        return v.css(g, w, "");
      }, ye = me(), Oe = z && z[3] || (v.cssNumber[w] ? "" : "px"), Xe = g.nodeType && (v.cssNumber[w] || Oe !== "px" && +ye) && Qt.exec(v.css(g, w));
      if (Xe && Xe[3] !== Oe) {
        for (ye = ye / 2, Oe = Oe || Xe[3], Xe = +ye || 1; ne--; )
          v.style(g, w, Xe + Oe), (1 - W) * (1 - (W = me() / ye || 0.5)) <= 0 && (ne = 0), Xe = Xe / W;
        Xe = Xe * 2, v.style(g, w, Xe + Oe), z = z || [];
      }
      return z && (Xe = +Xe || +ye || 0, _ = z[1] ? Xe + (z[1] + 1) * z[2] : +z[2], I && (I.unit = Oe, I.start = Xe, I.end = _)), _;
    }
    var Ue = {};
    function Se(g) {
      var w, z = g.ownerDocument, I = g.nodeName, _ = Ue[I];
      return _ || (w = z.body.appendChild(z.createElement(I)), _ = v.css(w, "display"), w.parentNode.removeChild(w), _ === "none" && (_ = "block"), Ue[I] = _, _);
    }
    function st(g, w) {
      for (var z, I, _ = [], W = 0, ne = g.length; W < ne; W++)
        I = g[W], I.style && (z = I.style.display, w ? (z === "none" && (_[W] = Pe.get(I, "display") || null, _[W] || (I.style.display = "")), I.style.display === "" && Nt(I) && (_[W] = Se(I))) : z !== "none" && (_[W] = "none", Pe.set(I, "display", z)));
      for (W = 0; W < ne; W++)
        _[W] != null && (g[W].style.display = _[W]);
      return g;
    }
    v.fn.extend({
      show: function() {
        return st(this, !0);
      },
      hide: function() {
        return st(this);
      },
      toggle: function(g) {
        return typeof g == "boolean" ? g ? this.show() : this.hide() : this.each(function() {
          Nt(this) ? v(this).show() : v(this).hide();
        });
      }
    });
    var kt = /^(?:checkbox|radio)$/i, mn = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, cn = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var g = b.createDocumentFragment(), w = g.appendChild(b.createElement("div")), z = b.createElement("input");
      z.setAttribute("type", "radio"), z.setAttribute("checked", "checked"), z.setAttribute("name", "t"), w.appendChild(z), p.checkClone = w.cloneNode(!0).cloneNode(!0).lastChild.checked, w.innerHTML = "<textarea>x</textarea>", p.noCloneChecked = !!w.cloneNode(!0).lastChild.defaultValue, w.innerHTML = "<option></option>", p.option = !!w.lastChild;
    })();
    var kn = {
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    kn.tbody = kn.tfoot = kn.colgroup = kn.caption = kn.thead, kn.th = kn.td, p.option || (kn.optgroup = kn.option = [1, "<select multiple='multiple'>", "</select>"]);
    function Tn(g, w) {
      var z;
      return typeof g.getElementsByTagName < "u" ? z = g.getElementsByTagName(w || "*") : typeof g.querySelectorAll < "u" ? z = g.querySelectorAll(w || "*") : z = [], w === void 0 || w && q(g, w) ? v.merge([g], z) : z;
    }
    function sr(g, w) {
      for (var z = 0, I = g.length; z < I; z++)
        Pe.set(
          g[z],
          "globalEval",
          !w || Pe.get(w[z], "globalEval")
        );
    }
    var wi = /<|&#?\w+;/;
    function Hi(g, w, z, I, _) {
      for (var W, ne, me, ye, Oe, Xe, it = w.createDocumentFragment(), Be = [], _e = 0, Xt = g.length; _e < Xt; _e++)
        if (W = g[_e], W || W === 0)
          if (S(W) === "object")
            v.merge(Be, W.nodeType ? [W] : W);
          else if (!wi.test(W))
            Be.push(w.createTextNode(W));
          else {
            for (ne = ne || it.appendChild(w.createElement("div")), me = (mn.exec(W) || ["", ""])[1].toLowerCase(), ye = kn[me] || kn._default, ne.innerHTML = ye[1] + v.htmlPrefilter(W) + ye[2], Xe = ye[0]; Xe--; )
              ne = ne.lastChild;
            v.merge(Be, ne.childNodes), ne = it.firstChild, ne.textContent = "";
          }
      for (it.textContent = "", _e = 0; W = Be[_e++]; ) {
        if (I && v.inArray(W, I) > -1) {
          _ && _.push(W);
          continue;
        }
        if (Oe = Mn(W), ne = Tn(it.appendChild(W), "script"), Oe && sr(ne), z)
          for (Xe = 0; W = ne[Xe++]; )
            cn.test(W.type || "") && z.push(W);
      }
      return it;
    }
    var Qa = /^([^.]*)(?:\.(.+)|)/;
    function ii() {
      return !0;
    }
    function Fe() {
      return !1;
    }
    function xt(g, w) {
      return g === an() == (w === "focus");
    }
    function an() {
      try {
        return b.activeElement;
      } catch {
      }
    }
    function Fn(g, w, z, I, _, W) {
      var ne, me;
      if (typeof w == "object") {
        typeof z != "string" && (I = I || z, z = void 0);
        for (me in w)
          Fn(g, me, z, I, w[me], W);
        return g;
      }
      if (I == null && _ == null ? (_ = z, I = z = void 0) : _ == null && (typeof z == "string" ? (_ = I, I = void 0) : (_ = I, I = z, z = void 0)), _ === !1)
        _ = Fe;
      else if (!_)
        return g;
      return W === 1 && (ne = _, _ = function(ye) {
        return v().off(ye), ne.apply(this, arguments);
      }, _.guid = ne.guid || (ne.guid = v.guid++)), g.each(function() {
        v.event.add(this, w, _, I, z);
      });
    }
    v.event = {
      global: {},
      add: function(g, w, z, I, _) {
        var W, ne, me, ye, Oe, Xe, it, Be, _e, Xt, en, Ft = Pe.get(g);
        if (!!ln(g))
          for (z.handler && (W = z, z = W.handler, _ = W.selector), _ && v.find.matchesSelector(Pn, _), z.guid || (z.guid = v.guid++), (ye = Ft.events) || (ye = Ft.events = /* @__PURE__ */ Object.create(null)), (ne = Ft.handle) || (ne = Ft.handle = function(Qn) {
            return typeof v < "u" && v.event.triggered !== Qn.type ? v.event.dispatch.apply(g, arguments) : void 0;
          }), w = (w || "").match(We) || [""], Oe = w.length; Oe--; )
            me = Qa.exec(w[Oe]) || [], _e = en = me[1], Xt = (me[2] || "").split(".").sort(), _e && (it = v.event.special[_e] || {}, _e = (_ ? it.delegateType : it.bindType) || _e, it = v.event.special[_e] || {}, Xe = v.extend({
              type: _e,
              origType: en,
              data: I,
              handler: z,
              guid: z.guid,
              selector: _,
              needsContext: _ && v.expr.match.needsContext.test(_),
              namespace: Xt.join(".")
            }, W), (Be = ye[_e]) || (Be = ye[_e] = [], Be.delegateCount = 0, (!it.setup || it.setup.call(g, I, Xt, ne) === !1) && g.addEventListener && g.addEventListener(_e, ne)), it.add && (it.add.call(g, Xe), Xe.handler.guid || (Xe.handler.guid = z.guid)), _ ? Be.splice(Be.delegateCount++, 0, Xe) : Be.push(Xe), v.event.global[_e] = !0);
      },
      remove: function(g, w, z, I, _) {
        var W, ne, me, ye, Oe, Xe, it, Be, _e, Xt, en, Ft = Pe.hasData(g) && Pe.get(g);
        if (!(!Ft || !(ye = Ft.events))) {
          for (w = (w || "").match(We) || [""], Oe = w.length; Oe--; ) {
            if (me = Qa.exec(w[Oe]) || [], _e = en = me[1], Xt = (me[2] || "").split(".").sort(), !_e) {
              for (_e in ye)
                v.event.remove(g, _e + w[Oe], z, I, !0);
              continue;
            }
            for (it = v.event.special[_e] || {}, _e = (I ? it.delegateType : it.bindType) || _e, Be = ye[_e] || [], me = me[2] && new RegExp("(^|\\.)" + Xt.join("\\.(?:.*\\.|)") + "(\\.|$)"), ne = W = Be.length; W--; )
              Xe = Be[W], (_ || en === Xe.origType) && (!z || z.guid === Xe.guid) && (!me || me.test(Xe.namespace)) && (!I || I === Xe.selector || I === "**" && Xe.selector) && (Be.splice(W, 1), Xe.selector && Be.delegateCount--, it.remove && it.remove.call(g, Xe));
            ne && !Be.length && ((!it.teardown || it.teardown.call(g, Xt, Ft.handle) === !1) && v.removeEvent(g, _e, Ft.handle), delete ye[_e]);
          }
          v.isEmptyObject(ye) && Pe.remove(g, "handle events");
        }
      },
      dispatch: function(g) {
        var w, z, I, _, W, ne, me = new Array(arguments.length), ye = v.event.fix(g), Oe = (Pe.get(this, "events") || /* @__PURE__ */ Object.create(null))[ye.type] || [], Xe = v.event.special[ye.type] || {};
        for (me[0] = ye, w = 1; w < arguments.length; w++)
          me[w] = arguments[w];
        if (ye.delegateTarget = this, !(Xe.preDispatch && Xe.preDispatch.call(this, ye) === !1)) {
          for (ne = v.event.handlers.call(this, ye, Oe), w = 0; (_ = ne[w++]) && !ye.isPropagationStopped(); )
            for (ye.currentTarget = _.elem, z = 0; (W = _.handlers[z++]) && !ye.isImmediatePropagationStopped(); )
              (!ye.rnamespace || W.namespace === !1 || ye.rnamespace.test(W.namespace)) && (ye.handleObj = W, ye.data = W.data, I = ((v.event.special[W.origType] || {}).handle || W.handler).apply(_.elem, me), I !== void 0 && (ye.result = I) === !1 && (ye.preventDefault(), ye.stopPropagation()));
          return Xe.postDispatch && Xe.postDispatch.call(this, ye), ye.result;
        }
      },
      handlers: function(g, w) {
        var z, I, _, W, ne, me = [], ye = w.delegateCount, Oe = g.target;
        if (ye && Oe.nodeType && !(g.type === "click" && g.button >= 1)) {
          for (; Oe !== this; Oe = Oe.parentNode || this)
            if (Oe.nodeType === 1 && !(g.type === "click" && Oe.disabled === !0)) {
              for (W = [], ne = {}, z = 0; z < ye; z++)
                I = w[z], _ = I.selector + " ", ne[_] === void 0 && (ne[_] = I.needsContext ? v(_, this).index(Oe) > -1 : v.find(_, this, null, [Oe]).length), ne[_] && W.push(I);
              W.length && me.push({ elem: Oe, handlers: W });
            }
        }
        return Oe = this, ye < w.length && me.push({ elem: Oe, handlers: w.slice(ye) }), me;
      },
      addProp: function(g, w) {
        Object.defineProperty(v.Event.prototype, g, {
          enumerable: !0,
          configurable: !0,
          get: y(w) ? function() {
            if (this.originalEvent)
              return w(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[g];
          },
          set: function(z) {
            Object.defineProperty(this, g, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: z
            });
          }
        });
      },
      fix: function(g) {
        return g[v.expando] ? g : new v.Event(g);
      },
      special: {
        load: {
          noBubble: !0
        },
        click: {
          setup: function(g) {
            var w = this || g;
            return kt.test(w.type) && w.click && q(w, "input") && Pr(w, "click", ii), !1;
          },
          trigger: function(g) {
            var w = this || g;
            return kt.test(w.type) && w.click && q(w, "input") && Pr(w, "click"), !0;
          },
          _default: function(g) {
            var w = g.target;
            return kt.test(w.type) && w.click && q(w, "input") && Pe.get(w, "click") || q(w, "a");
          }
        },
        beforeunload: {
          postDispatch: function(g) {
            g.result !== void 0 && g.originalEvent && (g.originalEvent.returnValue = g.result);
          }
        }
      }
    };
    function Pr(g, w, z) {
      if (!z) {
        Pe.get(g, w) === void 0 && v.event.add(g, w, ii);
        return;
      }
      Pe.set(g, w, !1), v.event.add(g, w, {
        namespace: !1,
        handler: function(I) {
          var _, W, ne = Pe.get(this, w);
          if (I.isTrigger & 1 && this[w]) {
            if (ne.length)
              (v.event.special[w] || {}).delegateType && I.stopPropagation();
            else if (ne = a.call(arguments), Pe.set(this, w, ne), _ = z(this, w), this[w](), W = Pe.get(this, w), ne !== W || _ ? Pe.set(this, w, !1) : W = {}, ne !== W)
              return I.stopImmediatePropagation(), I.preventDefault(), W && W.value;
          } else
            ne.length && (Pe.set(this, w, {
              value: v.event.trigger(
                v.extend(ne[0], v.Event.prototype),
                ne.slice(1),
                this
              )
            }), I.stopImmediatePropagation());
        }
      });
    }
    v.removeEvent = function(g, w, z) {
      g.removeEventListener && g.removeEventListener(w, z);
    }, v.Event = function(g, w) {
      if (!(this instanceof v.Event))
        return new v.Event(g, w);
      g && g.type ? (this.originalEvent = g, this.type = g.type, this.isDefaultPrevented = g.defaultPrevented || g.defaultPrevented === void 0 && g.returnValue === !1 ? ii : Fe, this.target = g.target && g.target.nodeType === 3 ? g.target.parentNode : g.target, this.currentTarget = g.currentTarget, this.relatedTarget = g.relatedTarget) : this.type = g, w && v.extend(this, w), this.timeStamp = g && g.timeStamp || Date.now(), this[v.expando] = !0;
    }, v.Event.prototype = {
      constructor: v.Event,
      isDefaultPrevented: Fe,
      isPropagationStopped: Fe,
      isImmediatePropagationStopped: Fe,
      isSimulated: !1,
      preventDefault: function() {
        var g = this.originalEvent;
        this.isDefaultPrevented = ii, g && !this.isSimulated && g.preventDefault();
      },
      stopPropagation: function() {
        var g = this.originalEvent;
        this.isPropagationStopped = ii, g && !this.isSimulated && g.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var g = this.originalEvent;
        this.isImmediatePropagationStopped = ii, g && !this.isSimulated && g.stopImmediatePropagation(), this.stopPropagation();
      }
    }, v.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, v.event.addProp), v.each({ focus: "focusin", blur: "focusout" }, function(g, w) {
      v.event.special[g] = {
        setup: function() {
          return Pr(this, g, xt), !1;
        },
        trigger: function() {
          return Pr(this, g), !0;
        },
        _default: function() {
          return !0;
        },
        delegateType: w
      };
    }), v.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(g, w) {
      v.event.special[g] = {
        delegateType: w,
        bindType: w,
        handle: function(z) {
          var I, _ = this, W = z.relatedTarget, ne = z.handleObj;
          return (!W || W !== _ && !v.contains(_, W)) && (z.type = ne.origType, I = ne.handler.apply(this, arguments), z.type = w), I;
        }
      };
    }), v.fn.extend({
      on: function(g, w, z, I) {
        return Fn(this, g, w, z, I);
      },
      one: function(g, w, z, I) {
        return Fn(this, g, w, z, I, 1);
      },
      off: function(g, w, z) {
        var I, _;
        if (g && g.preventDefault && g.handleObj)
          return I = g.handleObj, v(g.delegateTarget).off(
            I.namespace ? I.origType + "." + I.namespace : I.origType,
            I.selector,
            I.handler
          ), this;
        if (typeof g == "object") {
          for (_ in g)
            this.off(_, w, g[_]);
          return this;
        }
        return (w === !1 || typeof w == "function") && (z = w, w = void 0), z === !1 && (z = Fe), this.each(function() {
          v.event.remove(this, g, z, w);
        });
      }
    });
    var xr = /<script|<style|<link/i, na = /checked\s*(?:[^=]|=\s*.checked.)/i, lr = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Xf(g, w) {
      return q(g, "table") && q(w.nodeType !== 11 ? w : w.firstChild, "tr") && v(g).children("tbody")[0] || g;
    }
    function S2(g) {
      return g.type = (g.getAttribute("type") !== null) + "/" + g.type, g;
    }
    function Kl(g) {
      return (g.type || "").slice(0, 5) === "true/" ? g.type = g.type.slice(5) : g.removeAttribute("type"), g;
    }
    function ia(g, w) {
      var z, I, _, W, ne, me, ye;
      if (w.nodeType === 1) {
        if (Pe.hasData(g) && (W = Pe.get(g), ye = W.events, ye)) {
          Pe.remove(w, "handle events");
          for (_ in ye)
            for (z = 0, I = ye[_].length; z < I; z++)
              v.event.add(w, _, ye[_][z]);
        }
        $e.hasData(g) && (ne = $e.access(g), me = v.extend({}, ne), $e.set(w, me));
      }
    }
    function Gl(g, w) {
      var z = w.nodeName.toLowerCase();
      z === "input" && kt.test(g.type) ? w.checked = g.checked : (z === "input" || z === "textarea") && (w.defaultValue = g.defaultValue);
    }
    function On(g, w, z, I) {
      w = o(w);
      var _, W, ne, me, ye, Oe, Xe = 0, it = g.length, Be = it - 1, _e = w[0], Xt = y(_e);
      if (Xt || it > 1 && typeof _e == "string" && !p.checkClone && na.test(_e))
        return g.each(function(en) {
          var Ft = g.eq(en);
          Xt && (w[0] = _e.call(this, en, Ft.html())), On(Ft, w, z, I);
        });
      if (it && (_ = Hi(w, g[0].ownerDocument, !1, g, I), W = _.firstChild, _.childNodes.length === 1 && (_ = W), W || I)) {
        for (ne = v.map(Tn(_, "script"), S2), me = ne.length; Xe < it; Xe++)
          ye = _, Xe !== Be && (ye = v.clone(ye, !0, !0), me && v.merge(ne, Tn(ye, "script"))), z.call(g[Xe], ye, Xe);
        if (me)
          for (Oe = ne[ne.length - 1].ownerDocument, v.map(ne, Kl), Xe = 0; Xe < me; Xe++)
            ye = ne[Xe], cn.test(ye.type || "") && !Pe.access(ye, "globalEval") && v.contains(Oe, ye) && (ye.src && (ye.type || "").toLowerCase() !== "module" ? v._evalUrl && !ye.noModule && v._evalUrl(ye.src, {
              nonce: ye.nonce || ye.getAttribute("nonce")
            }, Oe) : D(ye.textContent.replace(lr, ""), ye, Oe));
      }
      return g;
    }
    function Rf(g, w, z) {
      for (var I, _ = w ? v.filter(w, g) : g, W = 0; (I = _[W]) != null; W++)
        !z && I.nodeType === 1 && v.cleanData(Tn(I)), I.parentNode && (z && Mn(I) && sr(Tn(I, "script")), I.parentNode.removeChild(I));
      return g;
    }
    v.extend({
      htmlPrefilter: function(g) {
        return g;
      },
      clone: function(g, w, z) {
        var I, _, W, ne, me = g.cloneNode(!0), ye = Mn(g);
        if (!p.noCloneChecked && (g.nodeType === 1 || g.nodeType === 11) && !v.isXMLDoc(g))
          for (ne = Tn(me), W = Tn(g), I = 0, _ = W.length; I < _; I++)
            Gl(W[I], ne[I]);
        if (w)
          if (z)
            for (W = W || Tn(g), ne = ne || Tn(me), I = 0, _ = W.length; I < _; I++)
              ia(W[I], ne[I]);
          else
            ia(g, me);
        return ne = Tn(me, "script"), ne.length > 0 && sr(ne, !ye && Tn(g, "script")), me;
      },
      cleanData: function(g) {
        for (var w, z, I, _ = v.event.special, W = 0; (z = g[W]) !== void 0; W++)
          if (ln(z)) {
            if (w = z[Pe.expando]) {
              if (w.events)
                for (I in w.events)
                  _[I] ? v.event.remove(z, I) : v.removeEvent(z, I, w.handle);
              z[Pe.expando] = void 0;
            }
            z[$e.expando] && (z[$e.expando] = void 0);
          }
      }
    }), v.fn.extend({
      detach: function(g) {
        return Rf(this, g, !0);
      },
      remove: function(g) {
        return Rf(this, g);
      },
      text: function(g) {
        return Te(this, function(w) {
          return w === void 0 ? v.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = w);
          });
        }, null, g, arguments.length);
      },
      append: function() {
        return On(this, arguments, function(g) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var w = Xf(this, g);
            w.appendChild(g);
          }
        });
      },
      prepend: function() {
        return On(this, arguments, function(g) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var w = Xf(this, g);
            w.insertBefore(g, w.firstChild);
          }
        });
      },
      before: function() {
        return On(this, arguments, function(g) {
          this.parentNode && this.parentNode.insertBefore(g, this);
        });
      },
      after: function() {
        return On(this, arguments, function(g) {
          this.parentNode && this.parentNode.insertBefore(g, this.nextSibling);
        });
      },
      empty: function() {
        for (var g, w = 0; (g = this[w]) != null; w++)
          g.nodeType === 1 && (v.cleanData(Tn(g, !1)), g.textContent = "");
        return this;
      },
      clone: function(g, w) {
        return g = g == null ? !1 : g, w = w == null ? g : w, this.map(function() {
          return v.clone(this, g, w);
        });
      },
      html: function(g) {
        return Te(this, function(w) {
          var z = this[0] || {}, I = 0, _ = this.length;
          if (w === void 0 && z.nodeType === 1)
            return z.innerHTML;
          if (typeof w == "string" && !xr.test(w) && !kn[(mn.exec(w) || ["", ""])[1].toLowerCase()]) {
            w = v.htmlPrefilter(w);
            try {
              for (; I < _; I++)
                z = this[I] || {}, z.nodeType === 1 && (v.cleanData(Tn(z, !1)), z.innerHTML = w);
              z = 0;
            } catch {
            }
          }
          z && this.empty().append(w);
        }, null, g, arguments.length);
      },
      replaceWith: function() {
        var g = [];
        return On(this, arguments, function(w) {
          var z = this.parentNode;
          v.inArray(this, g) < 0 && (v.cleanData(Tn(this)), z && z.replaceChild(w, this));
        }, g);
      }
    }), v.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(g, w) {
      v.fn[g] = function(z) {
        for (var I, _ = [], W = v(z), ne = W.length - 1, me = 0; me <= ne; me++)
          I = me === ne ? this : this.clone(!0), v(W[me])[w](I), s.apply(_, I.get());
        return this.pushStack(_);
      };
    });
    var cs = new RegExp("^(" + ct + ")(?!px)[a-z%]+$", "i"), bo = function(g) {
      var w = g.ownerDocument.defaultView;
      return (!w || !w.opener) && (w = t), w.getComputedStyle(g);
    }, Vf = function(g, w, z) {
      var I, _, W = {};
      for (_ in w)
        W[_] = g.style[_], g.style[_] = w[_];
      I = z.call(g);
      for (_ in w)
        g.style[_] = W[_];
      return I;
    }, Ao = new RegExp(Zt.join("|"), "i");
    (function() {
      function g() {
        if (!!Oe) {
          ye.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Oe.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", Pn.appendChild(ye).appendChild(Oe);
          var Xe = t.getComputedStyle(Oe);
          z = Xe.top !== "1%", me = w(Xe.marginLeft) === 12, Oe.style.right = "60%", W = w(Xe.right) === 36, I = w(Xe.width) === 36, Oe.style.position = "absolute", _ = w(Oe.offsetWidth / 3) === 12, Pn.removeChild(ye), Oe = null;
        }
      }
      function w(Xe) {
        return Math.round(parseFloat(Xe));
      }
      var z, I, _, W, ne, me, ye = b.createElement("div"), Oe = b.createElement("div");
      !Oe.style || (Oe.style.backgroundClip = "content-box", Oe.cloneNode(!0).style.backgroundClip = "", p.clearCloneStyle = Oe.style.backgroundClip === "content-box", v.extend(p, {
        boxSizingReliable: function() {
          return g(), I;
        },
        pixelBoxStyles: function() {
          return g(), W;
        },
        pixelPosition: function() {
          return g(), z;
        },
        reliableMarginLeft: function() {
          return g(), me;
        },
        scrollboxSize: function() {
          return g(), _;
        },
        reliableTrDimensions: function() {
          var Xe, it, Be, _e;
          return ne == null && (Xe = b.createElement("table"), it = b.createElement("tr"), Be = b.createElement("div"), Xe.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", it.style.cssText = "border:1px solid", it.style.height = "1px", Be.style.height = "9px", Be.style.display = "block", Pn.appendChild(Xe).appendChild(it).appendChild(Be), _e = t.getComputedStyle(it), ne = parseInt(_e.height, 10) + parseInt(_e.borderTopWidth, 10) + parseInt(_e.borderBottomWidth, 10) === it.offsetHeight, Pn.removeChild(Xe)), ne;
        }
      }));
    })();
    function Xn(g, w, z) {
      var I, _, W, ne, me = g.style;
      return z = z || bo(g), z && (ne = z.getPropertyValue(w) || z[w], ne === "" && !Mn(g) && (ne = v.style(g, w)), !p.pixelBoxStyles() && cs.test(ne) && Ao.test(w) && (I = me.width, _ = me.minWidth, W = me.maxWidth, me.minWidth = me.maxWidth = me.width = ne, ne = z.width, me.width = I, me.minWidth = _, me.maxWidth = W)), ne !== void 0 ? ne + "" : ne;
    }
    function Ws(g, w) {
      return {
        get: function() {
          if (g()) {
            delete this.get;
            return;
          }
          return (this.get = w).apply(this, arguments);
        }
      };
    }
    var Pi = ["Webkit", "Moz", "ms"], Uf = b.createElement("div").style, qf = {};
    function _f(g) {
      for (var w = g[0].toUpperCase() + g.slice(1), z = Pi.length; z--; )
        if (g = Pi[z] + w, g in Uf)
          return g;
    }
    function Ks(g) {
      var w = v.cssProps[g] || qf[g];
      return w || (g in Uf ? g : qf[g] = _f(g) || g);
    }
    var Wf = /^(none|table(?!-c[ea]).+)/, Hc = /^--/, Kf = { position: "absolute", visibility: "hidden", display: "block" }, Gs = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Gf(g, w, z) {
      var I = Qt.exec(w);
      return I ? Math.max(0, I[2] - (z || 0)) + (I[3] || "px") : w;
    }
    function ds(g, w, z, I, _, W) {
      var ne = w === "width" ? 1 : 0, me = 0, ye = 0;
      if (z === (I ? "border" : "content"))
        return 0;
      for (; ne < 4; ne += 2)
        z === "margin" && (ye += v.css(g, z + Zt[ne], !0, _)), I ? (z === "content" && (ye -= v.css(g, "padding" + Zt[ne], !0, _)), z !== "margin" && (ye -= v.css(g, "border" + Zt[ne] + "Width", !0, _))) : (ye += v.css(g, "padding" + Zt[ne], !0, _), z !== "padding" ? ye += v.css(g, "border" + Zt[ne] + "Width", !0, _) : me += v.css(g, "border" + Zt[ne] + "Width", !0, _));
      return !I && W >= 0 && (ye += Math.max(0, Math.ceil(
        g["offset" + w[0].toUpperCase() + w.slice(1)] - W - ye - me - 0.5
      )) || 0), ye;
    }
    function Ic(g, w, z) {
      var I = bo(g), _ = !p.boxSizingReliable() || z, W = _ && v.css(g, "boxSizing", !1, I) === "border-box", ne = W, me = Xn(g, w, I), ye = "offset" + w[0].toUpperCase() + w.slice(1);
      if (cs.test(me)) {
        if (!z)
          return me;
        me = "auto";
      }
      return (!p.boxSizingReliable() && W || !p.reliableTrDimensions() && q(g, "tr") || me === "auto" || !parseFloat(me) && v.css(g, "display", !1, I) === "inline") && g.getClientRects().length && (W = v.css(g, "boxSizing", !1, I) === "border-box", ne = ye in g, ne && (me = g[ye])), me = parseFloat(me) || 0, me + ds(
        g,
        w,
        z || (W ? "border" : "content"),
        ne,
        I,
        me
      ) + "px";
    }
    v.extend({
      cssHooks: {
        opacity: {
          get: function(g, w) {
            if (w) {
              var z = Xn(g, "opacity");
              return z === "" ? "1" : z;
            }
          }
        }
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0
      },
      cssProps: {},
      style: function(g, w, z, I) {
        if (!(!g || g.nodeType === 3 || g.nodeType === 8 || !g.style)) {
          var _, W, ne, me = It(w), ye = Hc.test(w), Oe = g.style;
          if (ye || (w = Ks(me)), ne = v.cssHooks[w] || v.cssHooks[me], z !== void 0) {
            if (W = typeof z, W === "string" && (_ = Qt.exec(z)) && _[1] && (z = De(g, w, _), W = "number"), z == null || z !== z)
              return;
            W === "number" && !ye && (z += _ && _[3] || (v.cssNumber[me] ? "" : "px")), !p.clearCloneStyle && z === "" && w.indexOf("background") === 0 && (Oe[w] = "inherit"), (!ne || !("set" in ne) || (z = ne.set(g, z, I)) !== void 0) && (ye ? Oe.setProperty(w, z) : Oe[w] = z);
          } else
            return ne && "get" in ne && (_ = ne.get(g, !1, I)) !== void 0 ? _ : Oe[w];
        }
      },
      css: function(g, w, z, I) {
        var _, W, ne, me = It(w), ye = Hc.test(w);
        return ye || (w = Ks(me)), ne = v.cssHooks[w] || v.cssHooks[me], ne && "get" in ne && (_ = ne.get(g, !0, z)), _ === void 0 && (_ = Xn(g, w, I)), _ === "normal" && w in Gs && (_ = Gs[w]), z === "" || z ? (W = parseFloat(_), z === !0 || isFinite(W) ? W || 0 : _) : _;
      }
    }), v.each(["height", "width"], function(g, w) {
      v.cssHooks[w] = {
        get: function(z, I, _) {
          if (I)
            return Wf.test(v.css(z, "display")) && (!z.getClientRects().length || !z.getBoundingClientRect().width) ? Vf(z, Kf, function() {
              return Ic(z, w, _);
            }) : Ic(z, w, _);
        },
        set: function(z, I, _) {
          var W, ne = bo(z), me = !p.scrollboxSize() && ne.position === "absolute", ye = me || _, Oe = ye && v.css(z, "boxSizing", !1, ne) === "border-box", Xe = _ ? ds(
            z,
            w,
            _,
            Oe,
            ne
          ) : 0;
          return Oe && me && (Xe -= Math.ceil(
            z["offset" + w[0].toUpperCase() + w.slice(1)] - parseFloat(ne[w]) - ds(z, w, "border", !1, ne) - 0.5
          )), Xe && (W = Qt.exec(I)) && (W[3] || "px") !== "px" && (z.style[w] = I, I = v.css(z, w)), Gf(z, I, Xe);
        }
      };
    }), v.cssHooks.marginLeft = Ws(
      p.reliableMarginLeft,
      function(g, w) {
        if (w)
          return (parseFloat(Xn(g, "marginLeft")) || g.getBoundingClientRect().left - Vf(g, { marginLeft: 0 }, function() {
            return g.getBoundingClientRect().left;
          })) + "px";
      }
    ), v.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(g, w) {
      v.cssHooks[g + w] = {
        expand: function(z) {
          for (var I = 0, _ = {}, W = typeof z == "string" ? z.split(" ") : [z]; I < 4; I++)
            _[g + Zt[I] + w] = W[I] || W[I - 2] || W[0];
          return _;
        }
      }, g !== "margin" && (v.cssHooks[g + w].set = Gf);
    }), v.fn.extend({
      css: function(g, w) {
        return Te(this, function(z, I, _) {
          var W, ne, me = {}, ye = 0;
          if (Array.isArray(I)) {
            for (W = bo(z), ne = I.length; ye < ne; ye++)
              me[I[ye]] = v.css(z, I[ye], !1, W);
            return me;
          }
          return _ !== void 0 ? v.style(z, I, _) : v.css(z, I);
        }, g, w, arguments.length > 1);
      }
    });
    function ki(g, w, z, I, _) {
      return new ki.prototype.init(g, w, z, I, _);
    }
    v.Tween = ki, ki.prototype = {
      constructor: ki,
      init: function(g, w, z, I, _, W) {
        this.elem = g, this.prop = z, this.easing = _ || v.easing._default, this.options = w, this.start = this.now = this.cur(), this.end = I, this.unit = W || (v.cssNumber[z] ? "" : "px");
      },
      cur: function() {
        var g = ki.propHooks[this.prop];
        return g && g.get ? g.get(this) : ki.propHooks._default.get(this);
      },
      run: function(g) {
        var w, z = ki.propHooks[this.prop];
        return this.options.duration ? this.pos = w = v.easing[this.easing](
          g,
          this.options.duration * g,
          0,
          1,
          this.options.duration
        ) : this.pos = w = g, this.now = (this.end - this.start) * w + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), z && z.set ? z.set(this) : ki.propHooks._default.set(this), this;
      }
    }, ki.prototype.init.prototype = ki.prototype, ki.propHooks = {
      _default: {
        get: function(g) {
          var w;
          return g.elem.nodeType !== 1 || g.elem[g.prop] != null && g.elem.style[g.prop] == null ? g.elem[g.prop] : (w = v.css(g.elem, g.prop, ""), !w || w === "auto" ? 0 : w);
        },
        set: function(g) {
          v.fx.step[g.prop] ? v.fx.step[g.prop](g) : g.elem.nodeType === 1 && (v.cssHooks[g.prop] || g.elem.style[Ks(g.prop)] != null) ? v.style(g.elem, g.prop, g.now + g.unit) : g.elem[g.prop] = g.now;
        }
      }
    }, ki.propHooks.scrollTop = ki.propHooks.scrollLeft = {
      set: function(g) {
        g.elem.nodeType && g.elem.parentNode && (g.elem[g.prop] = g.now);
      }
    }, v.easing = {
      linear: function(g) {
        return g;
      },
      swing: function(g) {
        return 0.5 - Math.cos(g * Math.PI) / 2;
      },
      _default: "swing"
    }, v.fx = ki.prototype.init, v.fx.step = {};
    var fs, Yl, Ql = /^(?:toggle|show|hide)$/, Ys = /queueHooks$/;
    function hs() {
      Yl && (b.hidden === !1 && t.requestAnimationFrame ? t.requestAnimationFrame(hs) : t.setTimeout(hs, v.fx.interval), v.fx.tick());
    }
    function To() {
      return t.setTimeout(function() {
        fs = void 0;
      }), fs = Date.now();
    }
    function ps(g, w) {
      var z, I = 0, _ = { height: g };
      for (w = w ? 1 : 0; I < 4; I += 2 - w)
        z = Zt[I], _["margin" + z] = _["padding" + z] = g;
      return w && (_.opacity = _.width = g), _;
    }
    function Lc(g, w, z) {
      for (var I, _ = (jr.tweeners[w] || []).concat(jr.tweeners["*"]), W = 0, ne = _.length; W < ne; W++)
        if (I = _[W].call(z, w, g))
          return I;
    }
    function Bc(g, w, z) {
      var I, _, W, ne, me, ye, Oe, Xe, it = "width" in w || "height" in w, Be = this, _e = {}, Xt = g.style, en = g.nodeType && Nt(g), Ft = Pe.get(g, "fxshow");
      z.queue || (ne = v._queueHooks(g, "fx"), ne.unqueued == null && (ne.unqueued = 0, me = ne.empty.fire, ne.empty.fire = function() {
        ne.unqueued || me();
      }), ne.unqueued++, Be.always(function() {
        Be.always(function() {
          ne.unqueued--, v.queue(g, "fx").length || ne.empty.fire();
        });
      }));
      for (I in w)
        if (_ = w[I], Ql.test(_)) {
          if (delete w[I], W = W || _ === "toggle", _ === (en ? "hide" : "show"))
            if (_ === "show" && Ft && Ft[I] !== void 0)
              en = !0;
            else
              continue;
          _e[I] = Ft && Ft[I] || v.style(g, I);
        }
      if (ye = !v.isEmptyObject(w), !(!ye && v.isEmptyObject(_e))) {
        it && g.nodeType === 1 && (z.overflow = [Xt.overflow, Xt.overflowX, Xt.overflowY], Oe = Ft && Ft.display, Oe == null && (Oe = Pe.get(g, "display")), Xe = v.css(g, "display"), Xe === "none" && (Oe ? Xe = Oe : (st([g], !0), Oe = g.style.display || Oe, Xe = v.css(g, "display"), st([g]))), (Xe === "inline" || Xe === "inline-block" && Oe != null) && v.css(g, "float") === "none" && (ye || (Be.done(function() {
          Xt.display = Oe;
        }), Oe == null && (Xe = Xt.display, Oe = Xe === "none" ? "" : Xe)), Xt.display = "inline-block")), z.overflow && (Xt.overflow = "hidden", Be.always(function() {
          Xt.overflow = z.overflow[0], Xt.overflowX = z.overflow[1], Xt.overflowY = z.overflow[2];
        })), ye = !1;
        for (I in _e)
          ye || (Ft ? "hidden" in Ft && (en = Ft.hidden) : Ft = Pe.access(g, "fxshow", { display: Oe }), W && (Ft.hidden = !en), en && st([g], !0), Be.done(function() {
            en || st([g]), Pe.remove(g, "fxshow");
            for (I in _e)
              v.style(g, I, _e[I]);
          })), ye = Lc(en ? Ft[I] : 0, I, Be), I in Ft || (Ft[I] = ye.start, en && (ye.end = ye.start, ye.start = 0));
      }
    }
    function ka(g, w) {
      var z, I, _, W, ne;
      for (z in g)
        if (I = It(z), _ = w[I], W = g[z], Array.isArray(W) && (_ = W[1], W = g[z] = W[0]), z !== I && (g[I] = W, delete g[z]), ne = v.cssHooks[I], ne && "expand" in ne) {
          W = ne.expand(W), delete g[I];
          for (z in W)
            z in g || (g[z] = W[z], w[z] = _);
        } else
          w[I] = _;
    }
    function jr(g, w, z) {
      var I, _, W = 0, ne = jr.prefilters.length, me = v.Deferred().always(function() {
        delete ye.elem;
      }), ye = function() {
        if (_)
          return !1;
        for (var it = fs || To(), Be = Math.max(0, Oe.startTime + Oe.duration - it), _e = Be / Oe.duration || 0, Xt = 1 - _e, en = 0, Ft = Oe.tweens.length; en < Ft; en++)
          Oe.tweens[en].run(Xt);
        return me.notifyWith(g, [Oe, Xt, Be]), Xt < 1 && Ft ? Be : (Ft || me.notifyWith(g, [Oe, 1, 0]), me.resolveWith(g, [Oe]), !1);
      }, Oe = me.promise({
        elem: g,
        props: v.extend({}, w),
        opts: v.extend(!0, {
          specialEasing: {},
          easing: v.easing._default
        }, z),
        originalProperties: w,
        originalOptions: z,
        startTime: fs || To(),
        duration: z.duration,
        tweens: [],
        createTween: function(it, Be) {
          var _e = v.Tween(
            g,
            Oe.opts,
            it,
            Be,
            Oe.opts.specialEasing[it] || Oe.opts.easing
          );
          return Oe.tweens.push(_e), _e;
        },
        stop: function(it) {
          var Be = 0, _e = it ? Oe.tweens.length : 0;
          if (_)
            return this;
          for (_ = !0; Be < _e; Be++)
            Oe.tweens[Be].run(1);
          return it ? (me.notifyWith(g, [Oe, 1, 0]), me.resolveWith(g, [Oe, it])) : me.rejectWith(g, [Oe, it]), this;
        }
      }), Xe = Oe.props;
      for (ka(Xe, Oe.opts.specialEasing); W < ne; W++)
        if (I = jr.prefilters[W].call(Oe, g, Xe, Oe.opts), I)
          return y(I.stop) && (v._queueHooks(Oe.elem, Oe.opts.queue).stop = I.stop.bind(I)), I;
      return v.map(Xe, Lc, Oe), y(Oe.opts.start) && Oe.opts.start.call(g, Oe), Oe.progress(Oe.opts.progress).done(Oe.opts.done, Oe.opts.complete).fail(Oe.opts.fail).always(Oe.opts.always), v.fx.timer(
        v.extend(ye, {
          elem: g,
          anim: Oe,
          queue: Oe.opts.queue
        })
      ), Oe;
    }
    v.Animation = v.extend(jr, {
      tweeners: {
        "*": [function(g, w) {
          var z = this.createTween(g, w);
          return De(z.elem, g, Qt.exec(w), z), z;
        }]
      },
      tweener: function(g, w) {
        y(g) ? (w = g, g = ["*"]) : g = g.match(We);
        for (var z, I = 0, _ = g.length; I < _; I++)
          z = g[I], jr.tweeners[z] = jr.tweeners[z] || [], jr.tweeners[z].unshift(w);
      },
      prefilters: [Bc],
      prefilter: function(g, w) {
        w ? jr.prefilters.unshift(g) : jr.prefilters.push(g);
      }
    }), v.speed = function(g, w, z) {
      var I = g && typeof g == "object" ? v.extend({}, g) : {
        complete: z || !z && w || y(g) && g,
        duration: g,
        easing: z && w || w && !y(w) && w
      };
      return v.fx.off ? I.duration = 0 : typeof I.duration != "number" && (I.duration in v.fx.speeds ? I.duration = v.fx.speeds[I.duration] : I.duration = v.fx.speeds._default), (I.queue == null || I.queue === !0) && (I.queue = "fx"), I.old = I.complete, I.complete = function() {
        y(I.old) && I.old.call(this), I.queue && v.dequeue(this, I.queue);
      }, I;
    }, v.fn.extend({
      fadeTo: function(g, w, z, I) {
        return this.filter(Nt).css("opacity", 0).show().end().animate({ opacity: w }, g, z, I);
      },
      animate: function(g, w, z, I) {
        var _ = v.isEmptyObject(g), W = v.speed(w, z, I), ne = function() {
          var me = jr(this, v.extend({}, g), W);
          (_ || Pe.get(this, "finish")) && me.stop(!0);
        };
        return ne.finish = ne, _ || W.queue === !1 ? this.each(ne) : this.queue(W.queue, ne);
      },
      stop: function(g, w, z) {
        var I = function(_) {
          var W = _.stop;
          delete _.stop, W(z);
        };
        return typeof g != "string" && (z = w, w = g, g = void 0), w && this.queue(g || "fx", []), this.each(function() {
          var _ = !0, W = g != null && g + "queueHooks", ne = v.timers, me = Pe.get(this);
          if (W)
            me[W] && me[W].stop && I(me[W]);
          else
            for (W in me)
              me[W] && me[W].stop && Ys.test(W) && I(me[W]);
          for (W = ne.length; W--; )
            ne[W].elem === this && (g == null || ne[W].queue === g) && (ne[W].anim.stop(z), _ = !1, ne.splice(W, 1));
          (_ || !z) && v.dequeue(this, g);
        });
      },
      finish: function(g) {
        return g !== !1 && (g = g || "fx"), this.each(function() {
          var w, z = Pe.get(this), I = z[g + "queue"], _ = z[g + "queueHooks"], W = v.timers, ne = I ? I.length : 0;
          for (z.finish = !0, v.queue(this, g, []), _ && _.stop && _.stop.call(this, !0), w = W.length; w--; )
            W[w].elem === this && W[w].queue === g && (W[w].anim.stop(!0), W.splice(w, 1));
          for (w = 0; w < ne; w++)
            I[w] && I[w].finish && I[w].finish.call(this);
          delete z.finish;
        });
      }
    }), v.each(["toggle", "show", "hide"], function(g, w) {
      var z = v.fn[w];
      v.fn[w] = function(I, _, W) {
        return I == null || typeof I == "boolean" ? z.apply(this, arguments) : this.animate(ps(w, !0), I, _, W);
      };
    }), v.each({
      slideDown: ps("show"),
      slideUp: ps("hide"),
      slideToggle: ps("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(g, w) {
      v.fn[g] = function(z, I, _) {
        return this.animate(w, z, I, _);
      };
    }), v.timers = [], v.fx.tick = function() {
      var g, w = 0, z = v.timers;
      for (fs = Date.now(); w < z.length; w++)
        g = z[w], !g() && z[w] === g && z.splice(w--, 1);
      z.length || v.fx.stop(), fs = void 0;
    }, v.fx.timer = function(g) {
      v.timers.push(g), v.fx.start();
    }, v.fx.interval = 13, v.fx.start = function() {
      Yl || (Yl = !0, hs());
    }, v.fx.stop = function() {
      Yl = null;
    }, v.fx.speeds = {
      slow: 600,
      fast: 200,
      _default: 400
    }, v.fn.delay = function(g, w) {
      return g = v.fx && v.fx.speeds[g] || g, w = w || "fx", this.queue(w, function(z, I) {
        var _ = t.setTimeout(z, g);
        I.stop = function() {
          t.clearTimeout(_);
        };
      });
    }, function() {
      var g = b.createElement("input"), w = b.createElement("select"), z = w.appendChild(b.createElement("option"));
      g.type = "checkbox", p.checkOn = g.value !== "", p.optSelected = z.selected, g = b.createElement("input"), g.value = "t", g.type = "radio", p.radioValue = g.value === "t";
    }();
    var Qs, vs = v.expr.attrHandle;
    v.fn.extend({
      attr: function(g, w) {
        return Te(this, v.attr, g, w, arguments.length > 1);
      },
      removeAttr: function(g) {
        return this.each(function() {
          v.removeAttr(this, g);
        });
      }
    }), v.extend({
      attr: function(g, w, z) {
        var I, _, W = g.nodeType;
        if (!(W === 3 || W === 8 || W === 2)) {
          if (typeof g.getAttribute > "u")
            return v.prop(g, w, z);
          if ((W !== 1 || !v.isXMLDoc(g)) && (_ = v.attrHooks[w.toLowerCase()] || (v.expr.match.bool.test(w) ? Qs : void 0)), z !== void 0) {
            if (z === null) {
              v.removeAttr(g, w);
              return;
            }
            return _ && "set" in _ && (I = _.set(g, z, w)) !== void 0 ? I : (g.setAttribute(w, z + ""), z);
          }
          return _ && "get" in _ && (I = _.get(g, w)) !== null ? I : (I = v.find.attr(g, w), I == null ? void 0 : I);
        }
      },
      attrHooks: {
        type: {
          set: function(g, w) {
            if (!p.radioValue && w === "radio" && q(g, "input")) {
              var z = g.value;
              return g.setAttribute("type", w), z && (g.value = z), w;
            }
          }
        }
      },
      removeAttr: function(g, w) {
        var z, I = 0, _ = w && w.match(We);
        if (_ && g.nodeType === 1)
          for (; z = _[I++]; )
            g.removeAttribute(z);
      }
    }), Qs = {
      set: function(g, w, z) {
        return w === !1 ? v.removeAttr(g, z) : g.setAttribute(z, z), z;
      }
    }, v.each(v.expr.match.bool.source.match(/\w+/g), function(g, w) {
      var z = vs[w] || v.find.attr;
      vs[w] = function(I, _, W) {
        var ne, me, ye = _.toLowerCase();
        return W || (me = vs[ye], vs[ye] = ne, ne = z(I, _, W) != null ? ye : null, vs[ye] = me), ne;
      };
    });
    var Yf = /^(?:input|select|textarea|button)$/i, Qf = /^(?:a|area)$/i;
    v.fn.extend({
      prop: function(g, w) {
        return Te(this, v.prop, g, w, arguments.length > 1);
      },
      removeProp: function(g) {
        return this.each(function() {
          delete this[v.propFix[g] || g];
        });
      }
    }), v.extend({
      prop: function(g, w, z) {
        var I, _, W = g.nodeType;
        if (!(W === 3 || W === 8 || W === 2))
          return (W !== 1 || !v.isXMLDoc(g)) && (w = v.propFix[w] || w, _ = v.propHooks[w]), z !== void 0 ? _ && "set" in _ && (I = _.set(g, z, w)) !== void 0 ? I : g[w] = z : _ && "get" in _ && (I = _.get(g, w)) !== null ? I : g[w];
      },
      propHooks: {
        tabIndex: {
          get: function(g) {
            var w = v.find.attr(g, "tabindex");
            return w ? parseInt(w, 10) : Yf.test(g.nodeName) || Qf.test(g.nodeName) && g.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), p.optSelected || (v.propHooks.selected = {
      get: function(g) {
        var w = g.parentNode;
        return w && w.parentNode && w.parentNode.selectedIndex, null;
      },
      set: function(g) {
        var w = g.parentNode;
        w && (w.selectedIndex, w.parentNode && w.parentNode.selectedIndex);
      }
    }), v.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      v.propFix[this.toLowerCase()] = this;
    });
    function wo(g) {
      var w = g.match(We) || [];
      return w.join(" ");
    }
    function ra(g) {
      return g.getAttribute && g.getAttribute("class") || "";
    }
    function Po(g) {
      return Array.isArray(g) ? g : typeof g == "string" ? g.match(We) || [] : [];
    }
    v.fn.extend({
      addClass: function(g) {
        var w, z, I, _, W, ne, me, ye = 0;
        if (y(g))
          return this.each(function(Oe) {
            v(this).addClass(g.call(this, Oe, ra(this)));
          });
        if (w = Po(g), w.length) {
          for (; z = this[ye++]; )
            if (_ = ra(z), I = z.nodeType === 1 && " " + wo(_) + " ", I) {
              for (ne = 0; W = w[ne++]; )
                I.indexOf(" " + W + " ") < 0 && (I += W + " ");
              me = wo(I), _ !== me && z.setAttribute("class", me);
            }
        }
        return this;
      },
      removeClass: function(g) {
        var w, z, I, _, W, ne, me, ye = 0;
        if (y(g))
          return this.each(function(Oe) {
            v(this).removeClass(g.call(this, Oe, ra(this)));
          });
        if (!arguments.length)
          return this.attr("class", "");
        if (w = Po(g), w.length) {
          for (; z = this[ye++]; )
            if (_ = ra(z), I = z.nodeType === 1 && " " + wo(_) + " ", I) {
              for (ne = 0; W = w[ne++]; )
                for (; I.indexOf(" " + W + " ") > -1; )
                  I = I.replace(" " + W + " ", " ");
              me = wo(I), _ !== me && z.setAttribute("class", me);
            }
        }
        return this;
      },
      toggleClass: function(g, w) {
        var z = typeof g, I = z === "string" || Array.isArray(g);
        return typeof w == "boolean" && I ? w ? this.addClass(g) : this.removeClass(g) : y(g) ? this.each(function(_) {
          v(this).toggleClass(
            g.call(this, _, ra(this), w),
            w
          );
        }) : this.each(function() {
          var _, W, ne, me;
          if (I)
            for (W = 0, ne = v(this), me = Po(g); _ = me[W++]; )
              ne.hasClass(_) ? ne.removeClass(_) : ne.addClass(_);
          else
            (g === void 0 || z === "boolean") && (_ = ra(this), _ && Pe.set(this, "__className__", _), this.setAttribute && this.setAttribute(
              "class",
              _ || g === !1 ? "" : Pe.get(this, "__className__") || ""
            ));
        });
      },
      hasClass: function(g) {
        var w, z, I = 0;
        for (w = " " + g + " "; z = this[I++]; )
          if (z.nodeType === 1 && (" " + wo(ra(z)) + " ").indexOf(w) > -1)
            return !0;
        return !1;
      }
    });
    var Zf = /\r/g;
    v.fn.extend({
      val: function(g) {
        var w, z, I, _ = this[0];
        return arguments.length ? (I = y(g), this.each(function(W) {
          var ne;
          this.nodeType === 1 && (I ? ne = g.call(this, W, v(this).val()) : ne = g, ne == null ? ne = "" : typeof ne == "number" ? ne += "" : Array.isArray(ne) && (ne = v.map(ne, function(me) {
            return me == null ? "" : me + "";
          })), w = v.valHooks[this.type] || v.valHooks[this.nodeName.toLowerCase()], (!w || !("set" in w) || w.set(this, ne, "value") === void 0) && (this.value = ne));
        })) : _ ? (w = v.valHooks[_.type] || v.valHooks[_.nodeName.toLowerCase()], w && "get" in w && (z = w.get(_, "value")) !== void 0 ? z : (z = _.value, typeof z == "string" ? z.replace(Zf, "") : z == null ? "" : z)) : void 0;
      }
    }), v.extend({
      valHooks: {
        option: {
          get: function(g) {
            var w = v.find.attr(g, "value");
            return w != null ? w : wo(v.text(g));
          }
        },
        select: {
          get: function(g) {
            var w, z, I, _ = g.options, W = g.selectedIndex, ne = g.type === "select-one", me = ne ? null : [], ye = ne ? W + 1 : _.length;
            for (W < 0 ? I = ye : I = ne ? W : 0; I < ye; I++)
              if (z = _[I], (z.selected || I === W) && !z.disabled && (!z.parentNode.disabled || !q(z.parentNode, "optgroup"))) {
                if (w = v(z).val(), ne)
                  return w;
                me.push(w);
              }
            return me;
          },
          set: function(g, w) {
            for (var z, I, _ = g.options, W = v.makeArray(w), ne = _.length; ne--; )
              I = _[ne], (I.selected = v.inArray(v.valHooks.option.get(I), W) > -1) && (z = !0);
            return z || (g.selectedIndex = -1), W;
          }
        }
      }
    }), v.each(["radio", "checkbox"], function() {
      v.valHooks[this] = {
        set: function(g, w) {
          if (Array.isArray(w))
            return g.checked = v.inArray(v(g).val(), w) > -1;
        }
      }, p.checkOn || (v.valHooks[this].get = function(g) {
        return g.getAttribute("value") === null ? "on" : g.value;
      });
    }), p.focusin = "onfocusin" in t;
    var Jf = /^(?:focusinfocus|focusoutblur)$/, $f = function(g) {
      g.stopPropagation();
    };
    v.extend(v.event, {
      trigger: function(g, w, z, I) {
        var _, W, ne, me, ye, Oe, Xe, it, Be = [z || b], _e = f.call(g, "type") ? g.type : g, Xt = f.call(g, "namespace") ? g.namespace.split(".") : [];
        if (W = it = ne = z = z || b, !(z.nodeType === 3 || z.nodeType === 8) && !Jf.test(_e + v.event.triggered) && (_e.indexOf(".") > -1 && (Xt = _e.split("."), _e = Xt.shift(), Xt.sort()), ye = _e.indexOf(":") < 0 && "on" + _e, g = g[v.expando] ? g : new v.Event(_e, typeof g == "object" && g), g.isTrigger = I ? 2 : 3, g.namespace = Xt.join("."), g.rnamespace = g.namespace ? new RegExp("(^|\\.)" + Xt.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, g.result = void 0, g.target || (g.target = z), w = w == null ? [g] : v.makeArray(w, [g]), Xe = v.event.special[_e] || {}, !(!I && Xe.trigger && Xe.trigger.apply(z, w) === !1))) {
          if (!I && !Xe.noBubble && !m(z)) {
            for (me = Xe.delegateType || _e, Jf.test(me + _e) || (W = W.parentNode); W; W = W.parentNode)
              Be.push(W), ne = W;
            ne === (z.ownerDocument || b) && Be.push(ne.defaultView || ne.parentWindow || t);
          }
          for (_ = 0; (W = Be[_++]) && !g.isPropagationStopped(); )
            it = W, g.type = _ > 1 ? me : Xe.bindType || _e, Oe = (Pe.get(W, "events") || /* @__PURE__ */ Object.create(null))[g.type] && Pe.get(W, "handle"), Oe && Oe.apply(W, w), Oe = ye && W[ye], Oe && Oe.apply && ln(W) && (g.result = Oe.apply(W, w), g.result === !1 && g.preventDefault());
          return g.type = _e, !I && !g.isDefaultPrevented() && (!Xe._default || Xe._default.apply(Be.pop(), w) === !1) && ln(z) && ye && y(z[_e]) && !m(z) && (ne = z[ye], ne && (z[ye] = null), v.event.triggered = _e, g.isPropagationStopped() && it.addEventListener(_e, $f), z[_e](), g.isPropagationStopped() && it.removeEventListener(_e, $f), v.event.triggered = void 0, ne && (z[ye] = ne)), g.result;
        }
      },
      simulate: function(g, w, z) {
        var I = v.extend(
          new v.Event(),
          z,
          {
            type: g,
            isSimulated: !0
          }
        );
        v.event.trigger(I, null, w);
      }
    }), v.fn.extend({
      trigger: function(g, w) {
        return this.each(function() {
          v.event.trigger(g, w, this);
        });
      },
      triggerHandler: function(g, w) {
        var z = this[0];
        if (z)
          return v.event.trigger(g, w, z, !0);
      }
    }), p.focusin || v.each({ focus: "focusin", blur: "focusout" }, function(g, w) {
      var z = function(I) {
        v.event.simulate(w, I.target, v.event.fix(I));
      };
      v.event.special[w] = {
        setup: function() {
          var I = this.ownerDocument || this.document || this, _ = Pe.access(I, w);
          _ || I.addEventListener(g, z, !0), Pe.access(I, w, (_ || 0) + 1);
        },
        teardown: function() {
          var I = this.ownerDocument || this.document || this, _ = Pe.access(I, w) - 1;
          _ ? Pe.access(I, w, _) : (I.removeEventListener(g, z, !0), Pe.remove(I, w));
        }
      };
    });
    var ms = t.location, e1 = { guid: Date.now() }, Nc = /\?/;
    v.parseXML = function(g) {
      var w, z;
      if (!g || typeof g != "string")
        return null;
      try {
        w = new t.DOMParser().parseFromString(g, "text/xml");
      } catch {
      }
      return z = w && w.getElementsByTagName("parsererror")[0], (!w || z) && v.error("Invalid XML: " + (z ? v.map(z.childNodes, function(I) {
        return I.textContent;
      }).join(`
`) : g)), w;
    };
    var t1 = /\[\]$/, n1 = /\r?\n/g, E2 = /^(?:submit|button|image|reset|file)$/i, k2 = /^(?:input|select|textarea|keygen)/i;
    function jc(g, w, z, I) {
      var _;
      if (Array.isArray(w))
        v.each(w, function(W, ne) {
          z || t1.test(g) ? I(g, ne) : jc(
            g + "[" + (typeof ne == "object" && ne != null ? W : "") + "]",
            ne,
            z,
            I
          );
        });
      else if (!z && S(w) === "object")
        for (_ in w)
          jc(g + "[" + _ + "]", w[_], z, I);
      else
        I(g, w);
    }
    v.param = function(g, w) {
      var z, I = [], _ = function(W, ne) {
        var me = y(ne) ? ne() : ne;
        I[I.length] = encodeURIComponent(W) + "=" + encodeURIComponent(me == null ? "" : me);
      };
      if (g == null)
        return "";
      if (Array.isArray(g) || g.jquery && !v.isPlainObject(g))
        v.each(g, function() {
          _(this.name, this.value);
        });
      else
        for (z in g)
          jc(z, g[z], w, _);
      return I.join("&");
    }, v.fn.extend({
      serialize: function() {
        return v.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var g = v.prop(this, "elements");
          return g ? v.makeArray(g) : this;
        }).filter(function() {
          var g = this.type;
          return this.name && !v(this).is(":disabled") && k2.test(this.nodeName) && !E2.test(g) && (this.checked || !kt.test(g));
        }).map(function(g, w) {
          var z = v(this).val();
          return z == null ? null : Array.isArray(z) ? v.map(z, function(I) {
            return { name: w.name, value: I.replace(n1, `\r
`) };
          }) : { name: w.name, value: z.replace(n1, `\r
`) };
        }).get();
      }
    });
    var O2 = /%20/g, z2 = /#.*$/, Zl = /([?&])_=[^&]*/, Jl = /^(.*?):[ \t]*([^\r\n]*)$/mg, D2 = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, M2 = /^(?:GET|HEAD)$/, Fc = /^\/\//, i1 = {}, Zs = {}, r1 = "*/".concat("*"), Xc = b.createElement("a");
    Xc.href = ms.href;
    function a1(g) {
      return function(w, z) {
        typeof w != "string" && (z = w, w = "*");
        var I, _ = 0, W = w.toLowerCase().match(We) || [];
        if (y(z))
          for (; I = W[_++]; )
            I[0] === "+" ? (I = I.slice(1) || "*", (g[I] = g[I] || []).unshift(z)) : (g[I] = g[I] || []).push(z);
      };
    }
    function gs(g, w, z, I) {
      var _ = {}, W = g === Zs;
      function ne(me) {
        var ye;
        return _[me] = !0, v.each(g[me] || [], function(Oe, Xe) {
          var it = Xe(w, z, I);
          if (typeof it == "string" && !W && !_[it])
            return w.dataTypes.unshift(it), ne(it), !1;
          if (W)
            return !(ye = it);
        }), ye;
      }
      return ne(w.dataTypes[0]) || !_["*"] && ne("*");
    }
    function Za(g, w) {
      var z, I, _ = v.ajaxSettings.flatOptions || {};
      for (z in w)
        w[z] !== void 0 && ((_[z] ? g : I || (I = {}))[z] = w[z]);
      return I && v.extend(!0, g, I), g;
    }
    function $l(g, w, z) {
      for (var I, _, W, ne, me = g.contents, ye = g.dataTypes; ye[0] === "*"; )
        ye.shift(), I === void 0 && (I = g.mimeType || w.getResponseHeader("Content-Type"));
      if (I) {
        for (_ in me)
          if (me[_] && me[_].test(I)) {
            ye.unshift(_);
            break;
          }
      }
      if (ye[0] in z)
        W = ye[0];
      else {
        for (_ in z) {
          if (!ye[0] || g.converters[_ + " " + ye[0]]) {
            W = _;
            break;
          }
          ne || (ne = _);
        }
        W = W || ne;
      }
      if (W)
        return W !== ye[0] && ye.unshift(W), z[W];
    }
    function xo(g, w, z, I) {
      var _, W, ne, me, ye, Oe = {}, Xe = g.dataTypes.slice();
      if (Xe[1])
        for (ne in g.converters)
          Oe[ne.toLowerCase()] = g.converters[ne];
      for (W = Xe.shift(); W; )
        if (g.responseFields[W] && (z[g.responseFields[W]] = w), !ye && I && g.dataFilter && (w = g.dataFilter(w, g.dataType)), ye = W, W = Xe.shift(), W) {
          if (W === "*")
            W = ye;
          else if (ye !== "*" && ye !== W) {
            if (ne = Oe[ye + " " + W] || Oe["* " + W], !ne) {
              for (_ in Oe)
                if (me = _.split(" "), me[1] === W && (ne = Oe[ye + " " + me[0]] || Oe["* " + me[0]], ne)) {
                  ne === !0 ? ne = Oe[_] : Oe[_] !== !0 && (W = me[0], Xe.unshift(me[1]));
                  break;
                }
            }
            if (ne !== !0)
              if (ne && g.throws)
                w = ne(w);
              else
                try {
                  w = ne(w);
                } catch (it) {
                  return {
                    state: "parsererror",
                    error: ne ? it : "No conversion from " + ye + " to " + W
                  };
                }
          }
        }
      return { state: "success", data: w };
    }
    v.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: ms.href,
        type: "GET",
        isLocal: D2.test(ms.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": r1,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": v.parseXML
        },
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      ajaxSetup: function(g, w) {
        return w ? Za(Za(g, v.ajaxSettings), w) : Za(v.ajaxSettings, g);
      },
      ajaxPrefilter: a1(i1),
      ajaxTransport: a1(Zs),
      ajax: function(g, w) {
        typeof g == "object" && (w = g, g = void 0), w = w || {};
        var z, I, _, W, ne, me, ye, Oe, Xe, it, Be = v.ajaxSetup({}, w), _e = Be.context || Be, Xt = Be.context && (_e.nodeType || _e.jquery) ? v(_e) : v.event, en = v.Deferred(), Ft = v.Callbacks("once memory"), Qn = Be.statusCode || {}, Kn = {}, ur = {}, Nn = "canceled", tn = {
          readyState: 0,
          getResponseHeader: function(xn) {
            var Zn;
            if (ye) {
              if (!W)
                for (W = {}; Zn = Jl.exec(_); )
                  W[Zn[1].toLowerCase() + " "] = (W[Zn[1].toLowerCase() + " "] || []).concat(Zn[2]);
              Zn = W[xn.toLowerCase() + " "];
            }
            return Zn == null ? null : Zn.join(", ");
          },
          getAllResponseHeaders: function() {
            return ye ? _ : null;
          },
          setRequestHeader: function(xn, Zn) {
            return ye == null && (xn = ur[xn.toLowerCase()] = ur[xn.toLowerCase()] || xn, Kn[xn] = Zn), this;
          },
          overrideMimeType: function(xn) {
            return ye == null && (Be.mimeType = xn), this;
          },
          statusCode: function(xn) {
            var Zn;
            if (xn)
              if (ye)
                tn.always(xn[tn.status]);
              else
                for (Zn in xn)
                  Qn[Zn] = [Qn[Zn], xn[Zn]];
            return this;
          },
          abort: function(xn) {
            var Zn = xn || Nn;
            return z && z.abort(Zn), Gi(0, Zn), this;
          }
        };
        if (en.promise(tn), Be.url = ((g || Be.url || ms.href) + "").replace(Fc, ms.protocol + "//"), Be.type = w.method || w.type || Be.method || Be.type, Be.dataTypes = (Be.dataType || "*").toLowerCase().match(We) || [""], Be.crossDomain == null) {
          me = b.createElement("a");
          try {
            me.href = Be.url, me.href = me.href, Be.crossDomain = Xc.protocol + "//" + Xc.host != me.protocol + "//" + me.host;
          } catch {
            Be.crossDomain = !0;
          }
        }
        if (Be.data && Be.processData && typeof Be.data != "string" && (Be.data = v.param(Be.data, Be.traditional)), gs(i1, Be, w, tn), ye)
          return tn;
        Oe = v.event && Be.global, Oe && v.active++ === 0 && v.event.trigger("ajaxStart"), Be.type = Be.type.toUpperCase(), Be.hasContent = !M2.test(Be.type), I = Be.url.replace(z2, ""), Be.hasContent ? Be.data && Be.processData && (Be.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (Be.data = Be.data.replace(O2, "+")) : (it = Be.url.slice(I.length), Be.data && (Be.processData || typeof Be.data == "string") && (I += (Nc.test(I) ? "&" : "?") + Be.data, delete Be.data), Be.cache === !1 && (I = I.replace(Zl, "$1"), it = (Nc.test(I) ? "&" : "?") + "_=" + e1.guid++ + it), Be.url = I + it), Be.ifModified && (v.lastModified[I] && tn.setRequestHeader("If-Modified-Since", v.lastModified[I]), v.etag[I] && tn.setRequestHeader("If-None-Match", v.etag[I])), (Be.data && Be.hasContent && Be.contentType !== !1 || w.contentType) && tn.setRequestHeader("Content-Type", Be.contentType), tn.setRequestHeader(
          "Accept",
          Be.dataTypes[0] && Be.accepts[Be.dataTypes[0]] ? Be.accepts[Be.dataTypes[0]] + (Be.dataTypes[0] !== "*" ? ", " + r1 + "; q=0.01" : "") : Be.accepts["*"]
        );
        for (Xe in Be.headers)
          tn.setRequestHeader(Xe, Be.headers[Xe]);
        if (Be.beforeSend && (Be.beforeSend.call(_e, tn, Be) === !1 || ye))
          return tn.abort();
        if (Nn = "abort", Ft.add(Be.complete), tn.done(Be.success), tn.fail(Be.error), z = gs(Zs, Be, w, tn), !z)
          Gi(-1, "No Transport");
        else {
          if (tn.readyState = 1, Oe && Xt.trigger("ajaxSend", [tn, Be]), ye)
            return tn;
          Be.async && Be.timeout > 0 && (ne = t.setTimeout(function() {
            tn.abort("timeout");
          }, Be.timeout));
          try {
            ye = !1, z.send(Kn, Gi);
          } catch (xn) {
            if (ye)
              throw xn;
            Gi(-1, xn);
          }
        }
        function Gi(xn, Zn, $s, eu) {
          var cr, aa, Fr, Yi, Oa, dr = Zn;
          ye || (ye = !0, ne && t.clearTimeout(ne), z = void 0, _ = eu || "", tn.readyState = xn > 0 ? 4 : 0, cr = xn >= 200 && xn < 300 || xn === 304, $s && (Yi = $l(Be, tn, $s)), !cr && v.inArray("script", Be.dataTypes) > -1 && v.inArray("json", Be.dataTypes) < 0 && (Be.converters["text script"] = function() {
          }), Yi = xo(Be, Yi, tn, cr), cr ? (Be.ifModified && (Oa = tn.getResponseHeader("Last-Modified"), Oa && (v.lastModified[I] = Oa), Oa = tn.getResponseHeader("etag"), Oa && (v.etag[I] = Oa)), xn === 204 || Be.type === "HEAD" ? dr = "nocontent" : xn === 304 ? dr = "notmodified" : (dr = Yi.state, aa = Yi.data, Fr = Yi.error, cr = !Fr)) : (Fr = dr, (xn || !dr) && (dr = "error", xn < 0 && (xn = 0))), tn.status = xn, tn.statusText = (Zn || dr) + "", cr ? en.resolveWith(_e, [aa, dr, tn]) : en.rejectWith(_e, [tn, dr, Fr]), tn.statusCode(Qn), Qn = void 0, Oe && Xt.trigger(
            cr ? "ajaxSuccess" : "ajaxError",
            [tn, Be, cr ? aa : Fr]
          ), Ft.fireWith(_e, [tn, dr]), Oe && (Xt.trigger("ajaxComplete", [tn, Be]), --v.active || v.event.trigger("ajaxStop")));
        }
        return tn;
      },
      getJSON: function(g, w, z) {
        return v.get(g, w, z, "json");
      },
      getScript: function(g, w) {
        return v.get(g, void 0, w, "script");
      }
    }), v.each(["get", "post"], function(g, w) {
      v[w] = function(z, I, _, W) {
        return y(I) && (W = W || _, _ = I, I = void 0), v.ajax(v.extend({
          url: z,
          type: w,
          dataType: W,
          data: I,
          success: _
        }, v.isPlainObject(z) && z));
      };
    }), v.ajaxPrefilter(function(g) {
      var w;
      for (w in g.headers)
        w.toLowerCase() === "content-type" && (g.contentType = g.headers[w] || "");
    }), v._evalUrl = function(g, w, z) {
      return v.ajax({
        url: g,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(I) {
          v.globalEval(I, w, z);
        }
      });
    }, v.fn.extend({
      wrapAll: function(g) {
        var w;
        return this[0] && (y(g) && (g = g.call(this[0])), w = v(g, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && w.insertBefore(this[0]), w.map(function() {
          for (var z = this; z.firstElementChild; )
            z = z.firstElementChild;
          return z;
        }).append(this)), this;
      },
      wrapInner: function(g) {
        return y(g) ? this.each(function(w) {
          v(this).wrapInner(g.call(this, w));
        }) : this.each(function() {
          var w = v(this), z = w.contents();
          z.length ? z.wrapAll(g) : w.append(g);
        });
      },
      wrap: function(g) {
        var w = y(g);
        return this.each(function(z) {
          v(this).wrapAll(w ? g.call(this, z) : g);
        });
      },
      unwrap: function(g) {
        return this.parent(g).not("body").each(function() {
          v(this).replaceWith(this.childNodes);
        }), this;
      }
    }), v.expr.pseudos.hidden = function(g) {
      return !v.expr.pseudos.visible(g);
    }, v.expr.pseudos.visible = function(g) {
      return !!(g.offsetWidth || g.offsetHeight || g.getClientRects().length);
    }, v.ajaxSettings.xhr = function() {
      try {
        return new t.XMLHttpRequest();
      } catch {
      }
    };
    var H2 = {
      0: 200,
      1223: 204
    }, ys = v.ajaxSettings.xhr();
    p.cors = !!ys && "withCredentials" in ys, p.ajax = ys = !!ys, v.ajaxTransport(function(g) {
      var w, z;
      if (p.cors || ys && !g.crossDomain)
        return {
          send: function(I, _) {
            var W, ne = g.xhr();
            if (ne.open(
              g.type,
              g.url,
              g.async,
              g.username,
              g.password
            ), g.xhrFields)
              for (W in g.xhrFields)
                ne[W] = g.xhrFields[W];
            g.mimeType && ne.overrideMimeType && ne.overrideMimeType(g.mimeType), !g.crossDomain && !I["X-Requested-With"] && (I["X-Requested-With"] = "XMLHttpRequest");
            for (W in I)
              ne.setRequestHeader(W, I[W]);
            w = function(me) {
              return function() {
                w && (w = z = ne.onload = ne.onerror = ne.onabort = ne.ontimeout = ne.onreadystatechange = null, me === "abort" ? ne.abort() : me === "error" ? typeof ne.status != "number" ? _(0, "error") : _(
                  ne.status,
                  ne.statusText
                ) : _(
                  H2[ne.status] || ne.status,
                  ne.statusText,
                  (ne.responseType || "text") !== "text" || typeof ne.responseText != "string" ? { binary: ne.response } : { text: ne.responseText },
                  ne.getAllResponseHeaders()
                ));
              };
            }, ne.onload = w(), z = ne.onerror = ne.ontimeout = w("error"), ne.onabort !== void 0 ? ne.onabort = z : ne.onreadystatechange = function() {
              ne.readyState === 4 && t.setTimeout(function() {
                w && z();
              });
            }, w = w("abort");
            try {
              ne.send(g.hasContent && g.data || null);
            } catch (me) {
              if (w)
                throw me;
            }
          },
          abort: function() {
            w && w();
          }
        };
    }), v.ajaxPrefilter(function(g) {
      g.crossDomain && (g.contents.script = !1);
    }), v.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(g) {
          return v.globalEval(g), g;
        }
      }
    }), v.ajaxPrefilter("script", function(g) {
      g.cache === void 0 && (g.cache = !1), g.crossDomain && (g.type = "GET");
    }), v.ajaxTransport("script", function(g) {
      if (g.crossDomain || g.scriptAttrs) {
        var w, z;
        return {
          send: function(I, _) {
            w = v("<script>").attr(g.scriptAttrs || {}).prop({ charset: g.scriptCharset, src: g.url }).on("load error", z = function(W) {
              w.remove(), z = null, W && _(W.type === "error" ? 404 : 200, W.type);
            }), b.head.appendChild(w[0]);
          },
          abort: function() {
            z && z();
          }
        };
      }
    });
    var Rc = [], Js = /(=)\?(?=&|$)|\?\?/;
    v.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var g = Rc.pop() || v.expando + "_" + e1.guid++;
        return this[g] = !0, g;
      }
    }), v.ajaxPrefilter("json jsonp", function(g, w, z) {
      var I, _, W, ne = g.jsonp !== !1 && (Js.test(g.url) ? "url" : typeof g.data == "string" && (g.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Js.test(g.data) && "data");
      if (ne || g.dataTypes[0] === "jsonp")
        return I = g.jsonpCallback = y(g.jsonpCallback) ? g.jsonpCallback() : g.jsonpCallback, ne ? g[ne] = g[ne].replace(Js, "$1" + I) : g.jsonp !== !1 && (g.url += (Nc.test(g.url) ? "&" : "?") + g.jsonp + "=" + I), g.converters["script json"] = function() {
          return W || v.error(I + " was not called"), W[0];
        }, g.dataTypes[0] = "json", _ = t[I], t[I] = function() {
          W = arguments;
        }, z.always(function() {
          _ === void 0 ? v(t).removeProp(I) : t[I] = _, g[I] && (g.jsonpCallback = w.jsonpCallback, Rc.push(I)), W && y(_) && _(W[0]), W = _ = void 0;
        }), "script";
    }), p.createHTMLDocument = function() {
      var g = b.implementation.createHTMLDocument("").body;
      return g.innerHTML = "<form></form><form></form>", g.childNodes.length === 2;
    }(), v.parseHTML = function(g, w, z) {
      if (typeof g != "string")
        return [];
      typeof w == "boolean" && (z = w, w = !1);
      var I, _, W;
      return w || (p.createHTMLDocument ? (w = b.implementation.createHTMLDocument(""), I = w.createElement("base"), I.href = b.location.href, w.head.appendChild(I)) : w = b), _ = G.exec(g), W = !z && [], _ ? [w.createElement(_[1])] : (_ = Hi([g], w, W), W && W.length && v(W).remove(), v.merge([], _.childNodes));
    }, v.fn.load = function(g, w, z) {
      var I, _, W, ne = this, me = g.indexOf(" ");
      return me > -1 && (I = wo(g.slice(me)), g = g.slice(0, me)), y(w) ? (z = w, w = void 0) : w && typeof w == "object" && (_ = "POST"), ne.length > 0 && v.ajax({
        url: g,
        type: _ || "GET",
        dataType: "html",
        data: w
      }).done(function(ye) {
        W = arguments, ne.html(I ? v("<div>").append(v.parseHTML(ye)).find(I) : ye);
      }).always(z && function(ye, Oe) {
        ne.each(function() {
          z.apply(this, W || [ye.responseText, Oe, ye]);
        });
      }), this;
    }, v.expr.pseudos.animated = function(g) {
      return v.grep(v.timers, function(w) {
        return g === w.elem;
      }).length;
    }, v.offset = {
      setOffset: function(g, w, z) {
        var I, _, W, ne, me, ye, Oe, Xe = v.css(g, "position"), it = v(g), Be = {};
        Xe === "static" && (g.style.position = "relative"), me = it.offset(), W = v.css(g, "top"), ye = v.css(g, "left"), Oe = (Xe === "absolute" || Xe === "fixed") && (W + ye).indexOf("auto") > -1, Oe ? (I = it.position(), ne = I.top, _ = I.left) : (ne = parseFloat(W) || 0, _ = parseFloat(ye) || 0), y(w) && (w = w.call(g, z, v.extend({}, me))), w.top != null && (Be.top = w.top - me.top + ne), w.left != null && (Be.left = w.left - me.left + _), "using" in w ? w.using.call(g, Be) : it.css(Be);
      }
    }, v.fn.extend({
      offset: function(g) {
        if (arguments.length)
          return g === void 0 ? this : this.each(function(_) {
            v.offset.setOffset(this, g, _);
          });
        var w, z, I = this[0];
        if (!!I)
          return I.getClientRects().length ? (w = I.getBoundingClientRect(), z = I.ownerDocument.defaultView, {
            top: w.top + z.pageYOffset,
            left: w.left + z.pageXOffset
          }) : { top: 0, left: 0 };
      },
      position: function() {
        if (!!this[0]) {
          var g, w, z, I = this[0], _ = { top: 0, left: 0 };
          if (v.css(I, "position") === "fixed")
            w = I.getBoundingClientRect();
          else {
            for (w = this.offset(), z = I.ownerDocument, g = I.offsetParent || z.documentElement; g && (g === z.body || g === z.documentElement) && v.css(g, "position") === "static"; )
              g = g.parentNode;
            g && g !== I && g.nodeType === 1 && (_ = v(g).offset(), _.top += v.css(g, "borderTopWidth", !0), _.left += v.css(g, "borderLeftWidth", !0));
          }
          return {
            top: w.top - _.top - v.css(I, "marginTop", !0),
            left: w.left - _.left - v.css(I, "marginLeft", !0)
          };
        }
      },
      offsetParent: function() {
        return this.map(function() {
          for (var g = this.offsetParent; g && v.css(g, "position") === "static"; )
            g = g.offsetParent;
          return g || Pn;
        });
      }
    }), v.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(g, w) {
      var z = w === "pageYOffset";
      v.fn[g] = function(I) {
        return Te(this, function(_, W, ne) {
          var me;
          if (m(_) ? me = _ : _.nodeType === 9 && (me = _.defaultView), ne === void 0)
            return me ? me[w] : _[W];
          me ? me.scrollTo(
            z ? me.pageXOffset : ne,
            z ? ne : me.pageYOffset
          ) : _[W] = ne;
        }, g, I, arguments.length);
      };
    }), v.each(["top", "left"], function(g, w) {
      v.cssHooks[w] = Ws(
        p.pixelPosition,
        function(z, I) {
          if (I)
            return I = Xn(z, w), cs.test(I) ? v(z).position()[w] + "px" : I;
        }
      );
    }), v.each({ Height: "height", Width: "width" }, function(g, w) {
      v.each({
        padding: "inner" + g,
        content: w,
        "": "outer" + g
      }, function(z, I) {
        v.fn[I] = function(_, W) {
          var ne = arguments.length && (z || typeof _ != "boolean"), me = z || (_ === !0 || W === !0 ? "margin" : "border");
          return Te(this, function(ye, Oe, Xe) {
            var it;
            return m(ye) ? I.indexOf("outer") === 0 ? ye["inner" + g] : ye.document.documentElement["client" + g] : ye.nodeType === 9 ? (it = ye.documentElement, Math.max(
              ye.body["scroll" + g],
              it["scroll" + g],
              ye.body["offset" + g],
              it["offset" + g],
              it["client" + g]
            )) : Xe === void 0 ? v.css(ye, Oe, me) : v.style(ye, Oe, Xe, me);
          }, w, ne ? _ : void 0, ne);
        };
      });
    }), v.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(g, w) {
      v.fn[w] = function(z) {
        return this.on(w, z);
      };
    }), v.fn.extend({
      bind: function(g, w, z) {
        return this.on(g, null, w, z);
      },
      unbind: function(g, w) {
        return this.off(g, null, w);
      },
      delegate: function(g, w, z, I) {
        return this.on(w, g, z, I);
      },
      undelegate: function(g, w, z) {
        return arguments.length === 1 ? this.off(g, "**") : this.off(w, g || "**", z);
      },
      hover: function(g, w) {
        return this.mouseenter(g).mouseleave(w || g);
      }
    }), v.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(g, w) {
        v.fn[w] = function(z, I) {
          return arguments.length > 0 ? this.on(w, null, z, I) : this.trigger(w);
        };
      }
    );
    var I2 = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    v.proxy = function(g, w) {
      var z, I, _;
      if (typeof w == "string" && (z = g[w], w = g, g = z), !!y(g))
        return I = a.call(arguments, 2), _ = function() {
          return g.apply(w || this, I.concat(a.call(arguments)));
        }, _.guid = g.guid = g.guid || v.guid++, _;
    }, v.holdReady = function(g) {
      g ? v.readyWait++ : v.ready(!0);
    }, v.isArray = Array.isArray, v.parseJSON = JSON.parse, v.nodeName = q, v.isFunction = y, v.isWindow = m, v.camelCase = It, v.type = S, v.now = Date.now, v.isNumeric = function(g) {
      var w = v.type(g);
      return (w === "number" || w === "string") && !isNaN(g - parseFloat(g));
    }, v.trim = function(g) {
      return g == null ? "" : (g + "").replace(I2, "");
    };
    var L2 = t.jQuery, B2 = t.$;
    return v.noConflict = function(g) {
      return t.$ === v && (t.$ = B2), g && t.jQuery === v && (t.jQuery = L2), v;
    }, typeof n > "u" && (t.jQuery = t.$ = v), v;
  });
})(UT);
const ha = UT.exports;
function is() {
}
is.prototype = {
  diff: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.callback;
    typeof r == "function" && (i = r, r = {}), this.options = r;
    var a = this;
    function o(y) {
      return i ? (setTimeout(function() {
        i(void 0, y);
      }, 0), !0) : y;
    }
    t = this.castInput(t), n = this.castInput(n), t = this.removeEmpty(this.tokenize(t)), n = this.removeEmpty(this.tokenize(n));
    var s = n.length, l = t.length, u = 1, c = s + l;
    r.maxEditLength && (c = Math.min(c, r.maxEditLength));
    var f = [{
      newPos: -1,
      components: []
    }], d = this.extractCommon(f[0], n, t, 0);
    if (f[0].newPos + 1 >= s && d + 1 >= l)
      return o([{
        value: this.join(n),
        count: n.length
      }]);
    function h() {
      for (var y = -1 * u; y <= u; y += 2) {
        var m = void 0, b = f[y - 1], x = f[y + 1], D = (x ? x.newPos : 0) - y;
        b && (f[y - 1] = void 0);
        var S = b && b.newPos + 1 < s, C = x && 0 <= D && D < l;
        if (!S && !C) {
          f[y] = void 0;
          continue;
        }
        if (!S || C && b.newPos < x.newPos ? (m = Jne(x), a.pushComponent(m.components, void 0, !0)) : (m = b, m.newPos++, a.pushComponent(m.components, !0, void 0)), D = a.extractCommon(m, n, t, y), m.newPos + 1 >= s && D + 1 >= l)
          return o(Zne(a, m.components, n, t, a.useLongestToken));
        f[y] = m;
      }
      u++;
    }
    if (i)
      (function y() {
        setTimeout(function() {
          if (u > c)
            return i();
          h() || y();
        }, 0);
      })();
    else
      for (; u <= c; ) {
        var p = h();
        if (p)
          return p;
      }
  },
  pushComponent: function(t, n, r) {
    var i = t[t.length - 1];
    i && i.added === n && i.removed === r ? t[t.length - 1] = {
      count: i.count + 1,
      added: n,
      removed: r
    } : t.push({
      count: 1,
      added: n,
      removed: r
    });
  },
  extractCommon: function(t, n, r, i) {
    for (var a = n.length, o = r.length, s = t.newPos, l = s - i, u = 0; s + 1 < a && l + 1 < o && this.equals(n[s + 1], r[l + 1]); )
      s++, l++, u++;
    return u && t.components.push({
      count: u
    }), t.newPos = s, l;
  },
  equals: function(t, n) {
    return this.options.comparator ? this.options.comparator(t, n) : t === n || this.options.ignoreCase && t.toLowerCase() === n.toLowerCase();
  },
  removeEmpty: function(t) {
    for (var n = [], r = 0; r < t.length; r++)
      t[r] && n.push(t[r]);
    return n;
  },
  castInput: function(t) {
    return t;
  },
  tokenize: function(t) {
    return t.split("");
  },
  join: function(t) {
    return t.join("");
  }
};
function Zne(e, t, n, r, i) {
  for (var a = 0, o = t.length, s = 0, l = 0; a < o; a++) {
    var u = t[a];
    if (u.removed) {
      if (u.value = e.join(r.slice(l, l + u.count)), l += u.count, a && t[a - 1].added) {
        var f = t[a - 1];
        t[a - 1] = t[a], t[a] = f;
      }
    } else {
      if (!u.added && i) {
        var c = n.slice(s, s + u.count);
        c = c.map(function(h, p) {
          var y = r[l + p];
          return y.length > h.length ? y : h;
        }), u.value = e.join(c);
      } else
        u.value = e.join(n.slice(s, s + u.count));
      s += u.count, u.added || (l += u.count);
    }
  }
  var d = t[o - 1];
  return o > 1 && typeof d.value == "string" && (d.added || d.removed) && e.equals("", d.value) && (t[o - 2].value += d.value, t.pop()), t;
}
function Jne(e) {
  return {
    newPos: e.newPos,
    components: e.components.slice(0)
  };
}
var $ne = new is();
function eie(e, t, n) {
  return $ne.diff(e, t, n);
}
var V7 = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, U7 = /\S/, qT = new is();
qT.equals = function(e, t) {
  return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !U7.test(e) && !U7.test(t);
};
qT.tokenize = function(e) {
  for (var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0; n < t.length - 1; n++)
    !t[n + 1] && t[n + 2] && V7.test(t[n]) && V7.test(t[n + 2]) && (t[n] += t[n + 2], t.splice(n + 1, 2), n--);
  return t;
};
var _T = new is();
_T.tokenize = function(e) {
  var t = [], n = e.split(/(\n|\r\n)/);
  n[n.length - 1] || n.pop();
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    r % 2 && !this.options.newlineIsToken ? t[t.length - 1] += i : (this.options.ignoreWhitespace && (i = i.trim()), t.push(i));
  }
  return t;
};
var tie = new is();
tie.tokenize = function(e) {
  return e.split(/(\S.+?[.!?])(?=\s+|$)/);
};
var nie = new is();
nie.tokenize = function(e) {
  return e.split(/([{}:;,]|\s+)/);
};
function f0(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f0 = function(t) {
    return typeof t;
  } : f0 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, f0(e);
}
var iie = Object.prototype.toString, Kd = new is();
Kd.useLongestToken = !0;
Kd.tokenize = _T.tokenize;
Kd.castInput = function(e) {
  var t = this.options, n = t.undefinedReplacement, r = t.stringifyReplacer, i = r === void 0 ? function(a, o) {
    return typeof o > "u" ? n : o;
  } : r;
  return typeof e == "string" ? e : JSON.stringify(n4(e, null, null, i), i, "  ");
};
Kd.equals = function(e, t) {
  return is.prototype.equals.call(Kd, e.replace(/,([\r\n])/g, "$1"), t.replace(/,([\r\n])/g, "$1"));
};
function n4(e, t, n, r, i) {
  t = t || [], n = n || [], r && (e = r(i, e));
  var a;
  for (a = 0; a < t.length; a += 1)
    if (t[a] === e)
      return n[a];
  var o;
  if (iie.call(e) === "[object Array]") {
    for (t.push(e), o = new Array(e.length), n.push(o), a = 0; a < e.length; a += 1)
      o[a] = n4(e[a], t, n, r, i);
    return t.pop(), n.pop(), o;
  }
  if (e && e.toJSON && (e = e.toJSON()), f0(e) === "object" && e !== null) {
    t.push(e), o = {}, n.push(o);
    var s = [], l;
    for (l in e)
      e.hasOwnProperty(l) && s.push(l);
    for (s.sort(), a = 0; a < s.length; a += 1)
      l = s[a], o[l] = n4(e[l], t, n, r, l);
    t.pop(), n.pop();
  } else
    o = e;
  return o;
}
var i4 = new is();
i4.tokenize = function(e) {
  return e.slice();
};
i4.join = i4.removeEmpty = function(e) {
  return e;
};
const h0 = "red";
function rie(e) {
  const t = {
    prevContent: null,
    currContent: null,
    complete: null,
    offset: 0,
    shouldScroll: !1,
    isLog: !0,
    ...e
  };
  var n = new Date().getTime(), r = ":^b", i = ":^n", a = ha(t.prevContent).clone();
  a.find(`span.${h0}:first`).prepend(r), a.find(`span.${h0}:last`).append(i), console.log(a.find(`span.${h0}:last`));
  var o = a.text(), s = o.indexOf(r), l = o.lastIndexOf(i) - r.length, u = eie(t.prevContent.textContent, t.currContent.textContent);
  if (t.isLog && console.log(t.prevContent, u, s, l), l > 0) {
    var c = aie(u, s, l, t);
    t.isLog && console.log(c);
    var f = t.currContent.textContent;
    t.isLog && console.log(f.substring(0, c.begin)), oie(t.currContent, c, t);
    var d = new Date().getTime();
    ha.isFunction(t.complete) && t.complete.call(this, d - n + "ms");
  }
  return { currContent: t.currContent, pos: c };
}
function aie(e, t, n, r) {
  var i = 0, a = 0, o = 0, s = 0, l = 0, u = 0;
  return e.some(function(c, f) {
    if (c.added ? o += c.count : (c.removed || (o += c.count), s += c.count), l == 0 && s >= t && (l = 1, !c.added && !c.removed && (u = s - t, i = o - u), c.removed && (i = o), console.log("1:\u627E\u5230\u5F00\u59CB\u4F4D\u7F6E[" + o + "]\uFF1A" + i)), l == 1 && s >= n && (l = 9, !c.added && !c.removed && (a = o - (s - n)), c.removed && (a = o), console.log("2:\u627E\u5230\u7ED3\u675F\u4F4D\u7F6E[" + o + "]\uFF1A" + a)), r.isLog && console.log("idx=" + f, "currPos=" + o, "prevPos=" + s, "Begin=" + i, " End=" + a), l == 9)
      return !0;
  }), {
    begin: t == 0 ? 0 : i,
    end: a
  };
}
function oie(e, t, n) {
  var r = 0, i = 0;
  function a(o) {
    o.hasChildNodes() ? o.childNodes.forEach((s) => {
      if (s.firstChild != null)
        a(s);
      else {
        var l = s.textContent;
        if (r += l.length, n.isLog && console.log("==nodeType:" + s.nodeType, "[" + t.begin + "/" + r + "][" + l.length + "]", l), r > t.begin && i == 0) {
          var u = r - t.begin, c = l.length - u;
          const f = document.createElement("span"), d = s.textContent;
          f.innerHTML = `${s.textContent.substring(0, c)}<a id="_beginAnchor"></a>${d.substring(c)}`, s.parentElement.insertBefore(f, s), s.parentElement.removeChild(s), sie(o, t.begin, t.end, n), i = 1;
        }
      }
    }) : console.error("\u53C2\u6570\u5FC5\u987B\u62E5\u6709\u4E00\u4E2A\u552F\u4E00\u7684\u8DDF\u8282\u70B9\uFF01");
  }
  ha(e).find("#_beginAnchor").remove(), a(e);
}
function sie(e, t, n, r) {
  var i = n - t, a = ha(e).find("#_beginAnchor"), o = a[0];
  let s = hl(o);
  for (; i > 0; ) {
    let l = 0, u = (s.nodeType === 3 ? s : s.firstChild) || hl(s);
    if (u.nodeType === 3) {
      l = Math.min(u.textContent.length, i);
      let c = document.createElement("span");
      c.classList.add("red"), r.isLog && console.log("add", h0, c.classList, c), c.innerHTML = u.textContent.substr(0, l), u.parentElement.insertBefore(c, u), u.textContent = u.textContent.substr(l), l < i && (s = u.nextSibling || hl(s)), i -= l;
    } else
      u.nodeType === 1 ? s = u.firstChild || hl(u) : s = u.nextSibling || hl(u);
  }
  r.shouldScroll && ha("html,body").animate({ scrollTop: ha(o).offset().top + r.offset }, 500);
}
function lie(e) {
  return (e.nodeType === 1 || e.nodeType === 3) && (e.textContent || "").replace(/\r|\n/g, "");
}
function hl(e) {
  let t = e.nextSibling;
  return t ? lie(t) ? t : hl(t) : hl(e.parentElement);
}
const uie = "data:image/png;base64,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", cie = (e) => (yn("data-v-42909f66"), e = e(), bn(), e), die = { class: "message-body" }, fie = /* @__PURE__ */ cie(() => /* @__PURE__ */ T("img", {
  src: uie,
  class: "message-image",
  alt: ""
}, null, -1)), hie = { class: "message-footer" }, pie = /* @__PURE__ */ Ee({
  props: {
    modelValue: Boolean,
    cancelText: {
      type: String,
      default: "\u53D6\u6D88"
    },
    confirmText: {
      type: String,
      default: "\u786E\u8BA4"
    },
    showCancel: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "handleConfirm"],
  setup(e, { emit: t }) {
    const n = () => {
      t("update:modelValue", !1);
    }, r = () => {
      n(), t("handleConfirm");
    };
    return (i, a) => {
      const o = fn, s = ni;
      return P(), ue(s, {
        modelValue: e.modelValue,
        "onUpdate:modelValue": a[0] || (a[0] = (l) => Bn(modelValue) ? modelValue.value = l : null),
        width: "580px",
        "close-on-click-modal": !1,
        "before-close": n,
        "append-to-body": "",
        title: "\u63D0\u793A"
      }, {
        footer: N(() => [
          T("div", hie, [
            e.showCancel ? (P(), ue(o, {
              key: 0,
              class: "message-btn",
              size: "large",
              plain: "",
              onClick: n
            }, {
              default: N(() => [
                je(de(e.cancelText), 1)
              ]),
              _: 1
            })) : re("", !0),
            B(o, {
              class: "message-btn",
              size: "large",
              plain: "",
              type: "primary",
              onClick: r
            }, {
              default: N(() => [
                je(de(e.confirmText), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          T("div", die, [
            fie,
            tt(i.$slots, "default", {}, void 0, !0)
          ])
        ]),
        _: 3
      }, 8, ["modelValue"]);
    };
  }
});
const vie = /* @__PURE__ */ Ht(pie, [["__scopeId", "data-v-42909f66"]]);
const mie = {
  props: {
    moduleList: Array,
    activeModule: String
  },
  setup(e) {
    const t = e, n = ce("pageMode"), r = j(""), i = j(!1), a = j(null), o = j(null), s = J(() => n.value == 1 ? t.moduleList : t.moduleList.filter((h) => h.status == 1)), l = (h) => {
      h.preventDefault();
    }, u = (h) => {
      r.value = h || t.activeModule;
    }, c = (h = s.value.length, p = 44) => {
      let y = 0;
      for (let m = 0; m < h; m++)
        y += o.value[m].$el.offsetWidth + p;
      return y - p;
    }, f = (h) => {
      const p = c(2, 0);
      h === "left" ? a.value.scrollLeft -= p : a.value.scrollLeft += p;
    }, d = () => {
      i.value = c() > a.value.offsetWidth;
    };
    return rn(() => {
      d();
    }), (h, p) => {
      const y = qt;
      return P(), ue(E(JC), {
        showInkInFixed: !1,
        affix: !0,
        targetOffset: 55,
        wrapperClass: "anchor-box",
        onChange: u,
        onClick: l
      }, {
        default: N(() => [
          i.value ? (P(), L("span", {
            key: 0,
            class: "arrow-icon",
            onClick: p[0] || (p[0] = (m) => f("left"))
          }, [
            B(y, null, {
              default: N(() => [
                B(E(ute))
              ]),
              _: 1
            })
          ])) : re("", !0),
          T("div", {
            class: "anchor-list",
            ref_key: "anchorListRef",
            ref: a
          }, [
            (P(!0), L(nt, null, Lt(E(s), (m) => (P(), ue(E($C), {
              key: m.id,
              href: `#${m.id}`,
              title: m.columnTitle,
              ref_for: !0,
              ref_key: "anchorItemRef",
              ref: o,
              class: se(`#${m.id}` === r.value ? "ant-anchor-link-active" : "")
            }, null, 8, ["href", "title", "class"]))), 128))
          ], 512),
          i.value ? (P(), L("span", {
            key: 1,
            class: "arrow-icon",
            onClick: p[1] || (p[1] = (m) => f("right"))
          }, [
            B(y, null, {
              default: N(() => [
                B(E(FT))
              ]),
              _: 1
            })
          ])) : re("", !0)
        ]),
        _: 1
      });
    };
  }
}, gie = /* @__PURE__ */ Ht(mie, [["__scopeId", "data-v-ec0da6a3"]]);
var so = navigator.userAgent.toLowerCase(), r4 = window.opera, hn = {
  ie: /(msie\s|trident.*rv:)([\w.]+)/i.test(so),
  opera: !!r4 && r4.version,
  webkit: so.indexOf(" applewebkit/") > -1,
  mac: so.indexOf("macintosh") > -1,
  quirks: document.compatMode == "BackCompat"
};
hn.gecko = navigator.product == "Gecko" && !hn.webkit && !hn.opera && !hn.ie;
var zi = 0;
if (hn.ie) {
  var uu = so.match(/(?:msie\s([\w.]+))/), cu = so.match(/(?:trident.*rv:([\w.]+))/);
  uu && cu && uu[1] && cu[1] ? zi = Math.max(uu[1] * 1, cu[1] * 1) : uu && uu[1] ? zi = uu[1] * 1 : cu && cu[1] ? zi = cu[1] * 1 : zi = 0, hn.ie11Compat = document.documentMode == 11, hn.ie9Compat = document.documentMode == 9, hn.ie8 = !!document.documentMode, hn.ie8Compat = document.documentMode == 8, hn.ie7Compat = zi == 7 && !document.documentMode || document.documentMode == 7, hn.ie6Compat = zi < 7 || hn.quirks, hn.ie9above = zi > 8, hn.ie9below = zi < 9, hn.ie11above = zi > 10, hn.ie11below = zi < 11;
}
if (hn.gecko) {
  var du = so.match(/rv:([\d\.]+)/);
  du && (du = du[1].split("."), zi = du[0] * 1e4 + (du[1] || 0) * 100 + (du[2] || 0) * 1);
}
/chrome\/(\d+\.\d)/i.test(so) && (hn.chrome = +RegExp.$1);
/(\d+\.\d)?(?:\.\d)?\s+safari\/?(\d+\.\d+)?/i.test(so) && !/chrome/i.test(so) && (hn.safari = +(RegExp.$1 || RegExp.$2));
hn.opera && (zi = parseFloat(r4.version()));
hn.webkit && (zi = parseFloat(so.match(/ applewebkit\/(\d+)/)[1]));
hn.version = zi;
hn.isCompatible = !hn.mobile && (hn.ie && zi >= 6 || hn.gecko && zi >= 10801 || hn.opera && zi >= 9.5 || hn.air && zi >= 1 || hn.webkit && zi >= 522 || !1);
var Ci = {
  each: function(e, t, n) {
    if (e != null) {
      if (e.length === +e.length) {
        for (var r = 0, i = e.length; r < i; r++)
          if (t.call(n, e[r], r, e) === !1)
            return !1;
      } else
        for (var a in e)
          if (e.hasOwnProperty(a) && t.call(n, e[a], a, e) === !1)
            return !1;
    }
  },
  bind: function(e, t) {
    return function() {
      return e.apply(t, arguments);
    };
  },
  indexOf: function(e, t, n) {
    var r = -1;
    return n = this.isNumber(n) ? n : 0, this.each(e, function(i, a) {
      if (a >= n && i === t)
        return r = a, !1;
    }), r;
  },
  trim: function(e) {
    return e.replace(/(^[ \t\n\r]+)|([ \t\n\r]+$)/g, "");
  },
  listToMap: function(e) {
    if (!e)
      return {};
    e = Ci.isArray(e) ? e : e.split(",");
    for (var t = 0, n, r = {}; n = e[t++]; )
      r[n.toUpperCase()] = r[n] = 1;
    return r;
  },
  cssStyleToDomStyle: function() {
    var e = document.createElement("div").style, t = {
      float: e.cssFloat != null ? "cssFloat" : e.styleFloat != null ? "styleFloat" : "float"
    };
    return function(n) {
      return t[n] || (t[n] = n.toLowerCase().replace(/-./g, function(r) {
        return r.charAt(1).toUpperCase();
      }));
    };
  }(),
  fixColor: function(e, t) {
    if (/color/i.test(e) && /rgba?/.test(t)) {
      var n = t.split(",");
      if (n.length > 3)
        return "";
      t = "#";
      for (var r = 0, i; i = n[r++]; )
        i = parseInt(i.replace(/[^\d]/gi, ""), 10).toString(16), t += i.length == 1 ? "0" + i : i;
      t = t.toUpperCase();
    }
    return t;
  },
  transUnitToPx: function(e) {
    if (!/(pt|cm)/.test(e))
      return e;
    var t;
    switch (e.replace(/([\d.]+)(\w+)/, function(n, r, i) {
      e = r, t = i;
    }), t) {
      case "cm":
        e = parseFloat(e) * 25;
        break;
      case "pt":
        e = Math.round(parseFloat(e) * 96 / 72);
    }
    return e + (e ? "px" : "");
  }
};
Ci.each(
  ["String", "Function", "Array", "Number", "RegExp", "Object", "Date"],
  function(e) {
    Ci["is" + e] = function(t) {
      return Object.prototype.toString.apply(t) == "[object " + e + "]";
    };
  }
);
var Kr = function() {
  function e(F) {
    for (var K in F)
      F[K.toUpperCase()] = F[K];
    return F;
  }
  var t = function(F) {
    for (var K = arguments, q = 1; q < K.length; q++) {
      var G = K[q];
      for (var te in G)
        F.hasOwnProperty(te) || (F[te] = G[te]);
    }
    return F;
  }, n = e({ isindex: 1, fieldset: 1 }), r = e({ input: 1, button: 1, select: 1, textarea: 1, label: 1 }), i = t(e({ a: 1 }), r), a = t({ iframe: 1 }, i), o = e({
    hr: 1,
    ul: 1,
    menu: 1,
    div: 1,
    blockquote: 1,
    noscript: 1,
    table: 1,
    center: 1,
    address: 1,
    dir: 1,
    pre: 1,
    h5: 1,
    dl: 1,
    h4: 1,
    noframes: 1,
    h6: 1,
    ol: 1,
    h1: 1,
    h3: 1,
    h2: 1
  }), s = e({ ins: 1, del: 1, script: 1, style: 1 }), l = t(
    e({
      mark: 1,
      b: 1,
      acronym: 1,
      bdo: 1,
      var: 1,
      "#": 1,
      abbr: 1,
      code: 1,
      br: 1,
      i: 1,
      cite: 1,
      kbd: 1,
      u: 1,
      strike: 1,
      s: 1,
      tt: 1,
      strong: 1,
      q: 1,
      samp: 1,
      em: 1,
      dfn: 1,
      span: 1
    }),
    s
  ), u = t(
    e({
      sub: 1,
      img: 1,
      embed: 1,
      object: 1,
      sup: 1,
      basefont: 1,
      map: 1,
      applet: 1,
      font: 1,
      big: 1,
      small: 1
    }),
    l
  ), c = t(e({ p: 1 }), u), f = t(e({ iframe: 1 }), u, r), d = e({
    img: 1,
    embed: 1,
    noscript: 1,
    br: 1,
    kbd: 1,
    center: 1,
    button: 1,
    basefont: 1,
    h5: 1,
    h4: 1,
    samp: 1,
    h6: 1,
    ol: 1,
    h1: 1,
    h3: 1,
    h2: 1,
    form: 1,
    font: 1,
    "#": 1,
    select: 1,
    menu: 1,
    ins: 1,
    abbr: 1,
    label: 1,
    code: 1,
    table: 1,
    script: 1,
    cite: 1,
    input: 1,
    iframe: 1,
    strong: 1,
    textarea: 1,
    noframes: 1,
    big: 1,
    small: 1,
    span: 1,
    hr: 1,
    sub: 1,
    bdo: 1,
    var: 1,
    div: 1,
    object: 1,
    sup: 1,
    strike: 1,
    dir: 1,
    map: 1,
    dl: 1,
    applet: 1,
    del: 1,
    isindex: 1,
    fieldset: 1,
    ul: 1,
    b: 1,
    acronym: 1,
    a: 1,
    blockquote: 1,
    i: 1,
    u: 1,
    s: 1,
    tt: 1,
    address: 1,
    q: 1,
    pre: 1,
    p: 1,
    em: 1,
    dfn: 1
  }), h = t(e({ a: 0 }), f), p = e({ tr: 1 }), y = e({ "#": 1 }), m = t(e({ param: 1 }), d), b = t(e({ form: 1 }), n, a, o, c), x = e({ li: 1, ol: 1, ul: 1 }), D = e({ style: 1, script: 1 }), S = e({ base: 1, link: 1, meta: 1, title: 1 }), C = t(S, D), v = e({ head: 1, body: 1 }), H = e({ html: 1 }), V = e({
    address: 1,
    blockquote: 1,
    center: 1,
    dir: 1,
    div: 1,
    dl: 1,
    fieldset: 1,
    form: 1,
    h1: 1,
    h2: 1,
    h3: 1,
    h4: 1,
    h5: 1,
    h6: 1,
    hr: 1,
    isindex: 1,
    menu: 1,
    noframes: 1,
    ol: 1,
    p: 1,
    pre: 1,
    table: 1,
    ul: 1
  }), R = e({
    area: 1,
    base: 1,
    basefont: 1,
    br: 1,
    col: 1,
    command: 1,
    dialog: 1,
    embed: 1,
    hr: 1,
    img: 1,
    input: 1,
    isindex: 1,
    keygen: 1,
    link: 1,
    meta: 1,
    param: 1,
    source: 1,
    track: 1,
    wbr: 1
  });
  return e({
    $nonBodyContent: t(H, v, S),
    $block: V,
    $inline: h,
    $inlineWithA: t(e({ a: 1 }), h),
    $body: t(e({ script: 1, style: 1 }), V),
    $cdata: e({ script: 1, style: 1 }),
    $empty: R,
    $nonChild: e({ iframe: 1, textarea: 1 }),
    $listItem: e({ dd: 1, dt: 1, li: 1 }),
    $list: e({ ul: 1, ol: 1, dl: 1 }),
    $isNotEmpty: e({
      table: 1,
      ul: 1,
      ol: 1,
      dl: 1,
      iframe: 1,
      area: 1,
      base: 1,
      col: 1,
      hr: 1,
      img: 1,
      embed: 1,
      input: 1,
      textarea: 1,
      link: 1,
      meta: 1,
      param: 1,
      h1: 1,
      h2: 1,
      h3: 1,
      h4: 1,
      h5: 1,
      h6: 1
    }),
    $removeEmpty: e({
      a: 1,
      abbr: 1,
      acronym: 1,
      address: 1,
      b: 1,
      bdo: 1,
      big: 1,
      cite: 1,
      code: 1,
      del: 1,
      dfn: 1,
      em: 1,
      font: 1,
      i: 1,
      ins: 1,
      label: 1,
      kbd: 1,
      q: 1,
      s: 1,
      samp: 1,
      small: 1,
      span: 1,
      strike: 1,
      strong: 1,
      sub: 1,
      sup: 1,
      tt: 1,
      u: 1,
      var: 1
    }),
    $removeEmptyBlock: e({ p: 1, div: 1 }),
    $tableContent: e({
      caption: 1,
      col: 1,
      colgroup: 1,
      tbody: 1,
      td: 1,
      tfoot: 1,
      th: 1,
      thead: 1,
      tr: 1,
      table: 1
    }),
    $notTransContent: e({ pre: 1, script: 1, style: 1, textarea: 1 }),
    html: v,
    head: C,
    style: y,
    script: y,
    body: b,
    base: {},
    link: {},
    meta: {},
    title: y,
    col: {},
    tr: e({ td: 1, th: 1 }),
    img: {},
    embed: {},
    colgroup: e({ thead: 1, col: 1, tbody: 1, tr: 1, tfoot: 1 }),
    noscript: b,
    td: b,
    br: {},
    th: b,
    center: b,
    kbd: h,
    button: t(c, o),
    basefont: {},
    h5: h,
    h4: h,
    samp: h,
    h6: h,
    ol: x,
    h1: h,
    h3: h,
    option: y,
    h2: h,
    form: t(n, a, o, c),
    select: e({ optgroup: 1, option: 1 }),
    font: h,
    ins: h,
    menu: x,
    abbr: h,
    label: h,
    table: e({
      thead: 1,
      col: 1,
      tbody: 1,
      tr: 1,
      colgroup: 1,
      caption: 1,
      tfoot: 1
    }),
    code: h,
    tfoot: p,
    cite: h,
    li: b,
    input: {},
    iframe: b,
    strong: h,
    textarea: y,
    noframes: b,
    big: h,
    small: h,
    span: e({
      "#": 1,
      br: 1,
      b: 1,
      strong: 1,
      u: 1,
      i: 1,
      em: 1,
      sub: 1,
      sup: 1,
      strike: 1,
      span: 1
    }),
    hr: h,
    dt: h,
    sub: h,
    optgroup: e({ option: 1 }),
    param: {},
    bdo: h,
    var: h,
    div: b,
    object: m,
    sup: h,
    dd: b,
    strike: h,
    area: {},
    dir: x,
    map: t(e({ area: 1, form: 1, p: 1 }), n, s, o),
    applet: m,
    dl: e({ dt: 1, dd: 1 }),
    del: h,
    isindex: {},
    fieldset: t(e({ legend: 1 }), d),
    thead: p,
    ul: x,
    acronym: h,
    b: h,
    a: t(e({ a: 1 }), f),
    blockquote: t(e({ td: 1, tr: 1, tbody: 1, li: 1 }), b),
    caption: h,
    i: h,
    u: h,
    tbody: p,
    s: h,
    address: t(a, c),
    tt: h,
    legend: h,
    q: h,
    pre: t(l, i),
    p: t(e({ a: 1 }), h),
    em: h,
    dfn: h,
    mark: h
  });
}();
function WT(e, t, n, r, i, a) {
  var o = r && e[t], s;
  for (!o && (o = e[n]); !o && (s = (s || e).parentNode); ) {
    if (s.tagName == "BODY" || a && !a(s))
      return null;
    o = s[n];
  }
  return o && i && !i(o) ? WT(o, t, n, !1, i) : o;
}
var yie = {
  tabindex: "tabIndex",
  readonly: "readOnly"
}, bie = Ci.listToMap([
  "-webkit-box",
  "-moz-box",
  "block",
  "list-item",
  "table",
  "table-row-group",
  "table-header-group",
  "table-footer-group",
  "table-row",
  "table-column-group",
  "table-column",
  "table-cell",
  "table-caption"
]), dt = {
  NODE_ELEMENT: 1,
  NODE_DOCUMENT: 9,
  NODE_TEXT: 3,
  NODE_COMMENT: 8,
  NODE_DOCUMENT_FRAGMENT: 11,
  POSITION_IDENTICAL: 0,
  POSITION_DISCONNECTED: 1,
  POSITION_FOLLOWING: 2,
  POSITION_PRECEDING: 4,
  POSITION_IS_CONTAINED: 8,
  POSITION_CONTAINS: 16,
  fillChar: "\u200B",
  keys: {
    8: 1,
    46: 1,
    16: 1,
    17: 1,
    18: 1,
    37: 1,
    38: 1,
    39: 1,
    40: 1,
    13: 1
  },
  getPosition: function(e, t) {
    if (e === t)
      return 0;
    var n, r = [e], i = [t];
    for (n = e; n = n.parentNode; ) {
      if (n === t)
        return 10;
      r.push(n);
    }
    for (n = t; n = n.parentNode; ) {
      if (n === e)
        return 20;
      i.push(n);
    }
    if (r.reverse(), i.reverse(), r[0] !== i[0])
      return 1;
    for (var a = -1; a++, r[a] === i[a]; )
      ;
    for (e = r[a], t = i[a]; e = e.nextSibling; )
      if (e === t)
        return 4;
    return 2;
  },
  getNodeIndex: function(e, t) {
    for (var n = e, r = 0; n = n.previousSibling; ) {
      if (t && n.nodeType == 3) {
        n.nodeType != n.nextSibling.nodeType && r++;
        continue;
      }
      r++;
    }
    return r;
  },
  inDoc: function(e, t) {
    return dt.getPosition(e, t) == 10;
  },
  findParent: function(e, t, n) {
    if (e && !dt.isBody(e))
      for (e = n ? e : e.parentNode; e; ) {
        if (!t || t(e) || dt.isBody(e))
          return t && !t(e) && dt.isBody(e) ? null : e;
        e = e.parentNode;
      }
    return null;
  },
  findParentByTagName: function(e, t, n, r) {
    return t = Ci.listToMap(Ci.isArray(t) ? t : [t]), dt.findParent(
      e,
      function(i) {
        return t[i.tagName] && !(r && r(i));
      },
      n
    );
  },
  findParents: function(e, t, n, r) {
    for (var i = t && (n && n(e) || !n) ? [e] : []; e = dt.findParent(e, n); )
      i.push(e);
    return r ? i : i.reverse();
  },
  insertAfter: function(e, t) {
    return e.nextSibling ? e.parentNode.insertBefore(t, e.nextSibling) : e.parentNode.appendChild(t);
  },
  remove: function(e, t) {
    var n = e.parentNode, r;
    if (n) {
      if (t && e.hasChildNodes())
        for (; r = e.firstChild; )
          n.insertBefore(r, e);
      n.removeChild(e);
    }
    return e;
  },
  getNextDomNode: function(e, t, n, r) {
    return WT(
      e,
      "firstChild",
      "nextSibling",
      t,
      n,
      r
    );
  },
  isBookmarkNode: function(e) {
    return e.nodeType == 1 && e.id && /^_baidu_bookmark_/i.test(e.id);
  },
  clearEmptySibling: function(e, t, n) {
    function r(i, a) {
      for (var o; i && !dt.isBookmarkNode(i) && (dt.isEmptyInlineElement(i) || !new RegExp(`[^	
\r` + dt.fillChar + "]").test(
        i.nodeValue
      )); )
        o = i[a], dt.remove(i), i = o;
    }
    !t && r(e.nextSibling, "nextSibling"), !n && r(e.previousSibling, "previousSibling");
  },
  split: function(e, t) {
    var n = e.ownerDocument;
    if (hn.ie && t == e.nodeValue.length) {
      var r = n.createTextNode("");
      return dt.insertAfter(e, r);
    }
    var i = e.splitText(t);
    return i;
  },
  isWhitespace: function(e) {
    return !new RegExp(`[^ 	
\r` + dt.fillChar + "]").test(
      e.nodeValue
    );
  },
  isSameElement: function(e, t) {
    if (e.tagName != t.tagName)
      return !1;
    var n = e.attributes, r = t.attributes;
    if (!hn.ie && n.length != r.length)
      return !1;
    for (var i, a, o = 0, s = 0, l = 0; i = n[l++]; ) {
      if (i.nodeName == "style") {
        if (i.specified && o++, dt.isSameStyle(e, t))
          continue;
        return !1;
      }
      if (hn.ie)
        if (i.specified)
          o++, a = r.getNamedItem(i.nodeName);
        else
          continue;
      else
        a = t.attributes[i.nodeName];
      if (!a || !a.specified || i.nodeValue != a.nodeValue)
        return !1;
    }
    if (hn.ie) {
      for (l = 0; a = r[l++]; )
        a.specified && s++;
      if (o != s)
        return !1;
    }
    return !0;
  },
  isSameStyle: function(e, t) {
    var n = e.style.cssText.replace(/( ?; ?)/g, ";").replace(/( ?: ?)/g, ":"), r = t.style.cssText.replace(/( ?; ?)/g, ";").replace(/( ?: ?)/g, ":");
    if (hn.opera) {
      if (n = e.style, r = t.style, n.length != r.length)
        return !1;
      for (var i in n)
        if (!/^(\d+|csstext)$/i.test(i) && n[i] != r[i])
          return !1;
      return !0;
    }
    if (!n || !r)
      return n == r;
    if (n = n.split(";"), r = r.split(";"), n.length != r.length)
      return !1;
    for (var a = 0, o; o = n[a++]; )
      if (Ci.indexOf(r, o) == -1)
        return !1;
    return !0;
  },
  isBlockElm: function(e) {
    return e.nodeType == 1 && (Kr.$block[e.tagName] || bie[dt.getComputedStyle(e, "display")]) && !Kr.$nonChild[e.tagName];
  },
  isBody: function(e) {
    return e && e.nodeType == 1 && e.tagName.toLowerCase() == "body";
  },
  isEmptyInlineElement: function(e) {
    if (e.nodeType != 1 || !Kr.$removeEmpty[e.tagName])
      return 0;
    for (e = e.firstChild; e; ) {
      if (dt.isBookmarkNode(e) || e.nodeType == 1 && !dt.isEmptyInlineElement(e) || e.nodeType == 3 && !dt.isWhitespace(e))
        return 0;
      e = e.nextSibling;
    }
    return 1;
  },
  trimWhiteTextNode: function(e) {
    function t(n) {
      for (var r; (r = e[n]) && r.nodeType == 3 && dt.isWhitespace(r); )
        e.removeChild(r);
    }
    t("firstChild"), t("lastChild");
  },
  mergeChild: function(e, t, n) {
    for (var r = dt.getElementsByTagName(e, e.tagName.toLowerCase()), i = 0, a; a = r[i++]; )
      if (!(!a.parentNode || dt.isBookmarkNode(a))) {
        if (a.tagName.toLowerCase() == "span") {
          if (e === a.parentNode && (dt.trimWhiteTextNode(e), e.childNodes.length == 1)) {
            e.style.cssText = a.style.cssText + ";" + e.style.cssText, dt.remove(a, !0);
            continue;
          }
          if (a.style.cssText = e.style.cssText + ";" + a.style.cssText, n) {
            var o = n.style;
            if (o) {
              o = o.split(";");
              for (var s = 0, l; l = o[s++]; )
                a.style[Ci.cssStyleToDomStyle(l.split(":")[0])] = l.split(
                  ":"
                )[1];
            }
          }
          dt.isSameStyle(a, e) && dt.remove(a, !0);
          continue;
        }
        dt.isSameElement(e, a) && dt.remove(a, !0);
      }
  },
  getElementsByTagName: function(e, t, n) {
    if (n && Ci.isString(n)) {
      var r = n;
      n = function(c) {
        return dt.hasClass(c, r);
      };
    }
    t = Ci.trim(t).replace(/[ ]{2,}/g, " ").split(" ");
    for (var i = [], a = 0, o; o = t[a++]; )
      for (var s = e.getElementsByTagName(o), l = 0, u; u = s[l++]; )
        (!n || n(u)) && i.push(u);
    return i;
  },
  mergeToParent: function(e) {
    for (var t = e.parentNode; t && Kr.$removeEmpty[t.tagName]; ) {
      if (t.tagName == e.tagName && t.className == e.className || t.tagName == "A") {
        if (dt.trimWhiteTextNode(t), t.tagName == "SPAN" && !dt.isSameStyle(t, e) || t.tagName == "A" && e.tagName == "SPAN")
          if (t.childNodes.length > 1 || t !== e.parentNode) {
            e.style.cssText = t.style.cssText + ";" + e.style.cssText, t = t.parentNode;
            continue;
          } else
            t.style.cssText += ";" + e.style.cssText, t.tagName == "A" && (t.style.textDecoration = "underline");
        if (t.tagName != "A") {
          t === e.parentNode && dt.remove(e, !0);
          break;
        }
      }
      t = t.parentNode;
    }
  },
  mergeSibling: function(e, t, n) {
    function r(i, a, o) {
      var s;
      if ((s = o[i]) && !dt.isBookmarkNode(s) && s.nodeType == 1 && dt.isSameElement(o, s)) {
        for (; s.firstChild; )
          a == "firstChild" ? o.insertBefore(s.lastChild, o.firstChild) : o.appendChild(s.firstChild);
        dt.remove(s);
      }
    }
    !t && r("previousSibling", "firstChild", e), !n && r("nextSibling", "lastChild", e);
  },
  unSelectable: hn.opera ? function(e) {
    e.onselectstart = function() {
      return !1;
    }, e.onclick = e.onkeyup = e.onkeydown = function() {
      return !1;
    }, e.unselectable = "on", e.setAttribute("unselectable", "on");
    for (var t = 0, n; n = e.all[t++]; )
      switch (n.tagName.toLowerCase()) {
        case "iframe":
        case "textarea":
        case "input":
        case "select":
          break;
        default:
          n.unselectable = "on", e.setAttribute("unselectable", "on");
      }
  } : function(e) {
    e.style.MozUserSelect = e.style.webkitUserSelect = e.style.msUserSelect = e.style.KhtmlUserSelect = "none";
  },
  createElement: function(e, t, n) {
    return dt.setAttributes(e.createElement(t), n);
  },
  setAttributes: function(e, t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        switch (n) {
          case "class":
            e.className = r;
            break;
          case "style":
            e.style.cssText = e.style.cssText + ";" + r;
            break;
          case "innerHTML":
            e[n] = r;
            break;
          case "value":
            e.value = r;
            break;
          default:
            e.setAttribute(yie[n] || n, r);
        }
      }
    return e;
  },
  getComputedStyle: function(e, t) {
    var n = "width height top left";
    if (n.indexOf(t) > -1)
      return e["offset" + t.replace(/^\w/, function(i) {
        return i.toUpperCase();
      })] + "px";
    e.nodeType == 3 && (e = e.parentNode);
    try {
      var r = dt.getStyle(e, t) || (window.getComputedStyle ? window.getComputedStyle(e, "").getPropertyValue(t) : (e.currentStyle || e.style)[Ci.cssStyleToDomStyle(t)]);
    } catch {
      return "";
    }
    return Ci.transUnitToPx(Ci.fixColor(t, r));
  },
  hasClass: function(e, t) {
    if (Ci.isRegExp(t))
      return t.test(e.className);
    t = Ci.trim(t).replace(/[ ]{2,}/g, " ").split(" ");
    for (var n = 0, r, i = e.className; r = t[n++]; )
      if (!new RegExp("\\b" + r + "\\b", "i").test(i))
        return !1;
    return n - 1 == t.length;
  },
  isBr: function(e) {
    return e.nodeType == 1 && e.tagName == "BR";
  },
  isFillChar: function(e, t) {
    if (e.nodeType != 3)
      return !1;
    var n = e.nodeValue;
    return t ? new RegExp("^" + dt.fillChar).test(n) : !n.replace(new RegExp(dt.fillChar, "g"), "").length;
  }
}, q7 = new RegExp(dt.fillChar, "g"), _7 = 0, kp = dt.fillChar, Ba;
function Aie(e) {
  e.collapsed = e.startContainer && e.endContainer && e.startContainer === e.endContainer && e.startOffset == e.endOffset;
}
function Tie(e) {
  return !e.collapsed && e.startContainer.nodeType == 1 && e.startContainer === e.endContainer && e.endOffset - e.startOffset == 1;
}
function W7(e, t, n, r) {
  return t.nodeType == 1 && (Kr.$empty[t.tagName] || Kr.$nonChild[t.tagName]) && (n = dt.getNodeIndex(t) + (e ? 0 : 1), t = t.parentNode), e ? (r.startContainer = t, r.startOffset = n, r.endContainer || r.collapse(!0)) : (r.endContainer = t, r.endOffset = n, r.startContainer || r.collapse(!1)), Aie(r), r;
}
function wie(e, t) {
  var n = e.startContainer, r = e.endContainer, i = e.startOffset, a = e.endOffset, o = document, s = o.createDocumentFragment(), l, u;
  if (n.nodeType == 1 && (n = n.childNodes[i] || (l = n.appendChild(o.createTextNode("")))), r.nodeType == 1 && (r = r.childNodes[a] || (u = r.appendChild(o.createTextNode("")))), n === r && n.nodeType == 3)
    return s.appendChild(
      o.createTextNode(
        n.substringData(i, a - i)
      )
    ), t && (n.deleteData(i, a - i), e.collapse(!0)), s;
  for (var c, f, d = s, h = dt.findParents(n, !0), p = dt.findParents(r, !0), y = 0; h[y] == p[y]; )
    y++;
  for (var m = y, b; b = h[m]; m++) {
    for (c = b.nextSibling, b == n ? l || (e.startContainer.nodeType == 3 ? (d.appendChild(
      o.createTextNode(n.nodeValue.slice(i))
    ), t && n.deleteData(
      i,
      n.nodeValue.length - i
    )) : d.appendChild(t ? n : n.cloneNode(!0))) : (f = b.cloneNode(!1), d.appendChild(f)); c && !(c === r || c === p[m]); )
      b = c.nextSibling, d.appendChild(t ? c : c.cloneNode(!0)), c = b;
    d = f;
  }
  d = s, h[y] || (d.appendChild(h[y - 1].cloneNode(!1)), d = d.firstChild);
  for (var m = y, x; x = p[m]; m++) {
    if (c = x.previousSibling, x == r ? !u && e.endContainer.nodeType == 3 && (d.appendChild(
      o.createTextNode(r.substringData(0, a))
    ), t && r.deleteData(0, a)) : (f = x.cloneNode(!1), d.appendChild(f)), m != y || !h[y])
      for (; c && c !== n; )
        x = c.previousSibling, d.insertBefore(
          t ? c : c.cloneNode(!0),
          d.firstChild
        ), c = x;
    d = f;
  }
  return t && e.setStartBefore(
    p[y] ? h[y] ? p[y] : h[y - 1] : p[y - 1]
  ).collapse(!0), l && dt.remove(l), u && dt.remove(u), s;
}
var a4 = function(e) {
  var t = window;
  t.startContainer = t.startOffset = t.endContainer = t.endOffset = null, t.collapsed = !0;
};
function K7(e, t) {
  try {
    if (Ba && dt.inDoc(Ba, e))
      if (Ba.nodeValue.replace(q7, "").length)
        Ba.nodeValue = Ba.nodeValue.replace(q7, "");
      else {
        var n = Ba.parentNode;
        for (dt.remove(Ba); n && dt.isEmptyInlineElement(n) && !n.contains(t); )
          Ba = n.parentNode, dt.remove(n), n = Ba;
      }
  } catch {
  }
}
function b1(e, t) {
  var n;
  for (e = e[t]; e && dt.isFillChar(e); )
    n = e[t], dt.remove(e), e = n;
}
a4.prototype = {
  extractContents: function() {
    return this.collapsed ? null : wie(this, 2);
  },
  setStart: function(e, t) {
    return W7(!0, e, t, this);
  },
  setEnd: function(e, t) {
    return W7(!1, e, t, this);
  },
  setStartAfter: function(e) {
    return this.setStart(e.parentNode, dt.getNodeIndex(e) + 1);
  },
  setStartBefore: function(e) {
    return this.setStart(e.parentNode, dt.getNodeIndex(e));
  },
  setEndAfter: function(e) {
    return this.setEnd(e.parentNode, dt.getNodeIndex(e) + 1);
  },
  setEndBefore: function(e) {
    return this.setEnd(e.parentNode, dt.getNodeIndex(e));
  },
  cloneRange: function() {
    var e = this;
    return new a4(e.document).setStart(e.startContainer, e.startOffset).setEnd(e.endContainer, e.endOffset);
  },
  collapse: function(e) {
    var t = this;
    return e ? (t.endContainer = t.startContainer, t.endOffset = t.startOffset) : (t.startContainer = t.endContainer, t.startOffset = t.endOffset), t.collapsed = !0, t;
  },
  shrinkBoundary: function(e) {
    var t = this, n, r = t.collapsed;
    function i(a) {
      return a.nodeType == 1 && !dt.isBookmarkNode(a) && !Kr.$empty[a.tagName] && !Kr.$nonChild[a.tagName];
    }
    for (; t.startContainer.nodeType == 1 && (n = t.startContainer.childNodes[t.startOffset]) && i(n); )
      t.setStart(n, 0);
    if (r)
      return t.collapse(!0);
    if (!e)
      for (; t.endContainer.nodeType == 1 && t.endOffset > 0 && (n = t.endContainer.childNodes[t.endOffset - 1]) && i(n); )
        t.setEnd(n, n.childNodes.length);
    return t;
  },
  trimBoundary: function(e) {
    this.txtToElmBoundary();
    var t = this.startContainer, n = this.startOffset, r = this.collapsed, i = this.endContainer;
    if (t.nodeType == 3) {
      if (n == 0)
        this.setStartBefore(t);
      else if (n >= t.nodeValue.length)
        this.setStartAfter(t);
      else {
        var a = dt.split(t, n);
        t === i ? this.setEnd(a, this.endOffset - n) : t.parentNode === i && (this.endOffset += 1), this.setStartBefore(a);
      }
      if (r)
        return this.collapse(!0);
    }
    return e || (n = this.endOffset, i = this.endContainer, i.nodeType == 3 && (n == 0 ? this.setEndBefore(i) : (n < i.nodeValue.length && dt.split(i, n), this.setEndAfter(i)))), this;
  },
  txtToElmBoundary: function(e) {
    function t(n, r) {
      var i = n[r + "Container"], a = n[r + "Offset"];
      i.nodeType == 3 && (a ? a >= i.nodeValue.length && n["set" + r.replace(/(\w)/, function(o) {
        return o.toUpperCase();
      }) + "After"](i) : n["set" + r.replace(/(\w)/, function(o) {
        return o.toUpperCase();
      }) + "Before"](i));
    }
    return (e || !this.collapsed) && (t(this, "start"), t(this, "end")), this;
  },
  insertNode: function(e) {
    var t = e, n = 1;
    e.nodeType == 11 && (t = e.firstChild, n = e.childNodes.length), this.trimBoundary(!0);
    var r = this.startContainer, i = this.startOffset, a = r.childNodes[i];
    return a ? r.insertBefore(e, a) : r.appendChild(e), t.parentNode === this.endContainer && (this.endOffset = this.endOffset + n), this.setStartBefore(t);
  },
  createBookmark: function(e, t) {
    var n, r = document.createElement("span");
    return r.style.cssText = "display:none;line-height:0px;", r.appendChild(document.createTextNode("\u200D")), r.id = "_baidu_bookmark_start_" + (t ? "" : _7++), this.collapsed || (n = r.cloneNode(!0), n.id = "_baidu_bookmark_end_" + (t ? "" : _7++)), this.insertNode(r), n && this.collapse().insertNode(n).setEndBefore(n), this.setStartAfter(r), {
      start: e ? r.id : r,
      end: n ? e ? n.id : n : null,
      id: e
    };
  },
  moveToBookmark: function(e) {
    var t = e.id ? document.getElementById(e.start) : e.start, n = e.end && e.id ? document.getElementById(e.end) : e.end;
    return this.setStartBefore(t), dt.remove(t), n ? (this.setEndBefore(n), dt.remove(n)) : this.collapse(!0), this;
  },
  enlarge: function(e, t) {
    var n = dt.isBody, r, i, a = document.createTextNode("");
    if (e) {
      for (i = this.startContainer, i.nodeType == 1 ? i.childNodes[this.startOffset] ? r = i = i.childNodes[this.startOffset] : (i.appendChild(a), r = i = a) : r = i; ; ) {
        if (dt.isBlockElm(i)) {
          for (i = r; (r = i.previousSibling) && !dt.isBlockElm(r); )
            i = r;
          this.setStartBefore(i);
          break;
        }
        r = i, i = i.parentNode;
      }
      for (i = this.endContainer, i.nodeType == 1 ? ((r = i.childNodes[this.endOffset]) ? i.insertBefore(a, r) : i.appendChild(a), r = i = a) : r = i; ; ) {
        if (dt.isBlockElm(i)) {
          for (i = r; (r = i.nextSibling) && !dt.isBlockElm(r); )
            i = r;
          this.setEndAfter(i);
          break;
        }
        r = i, i = i.parentNode;
      }
      a.parentNode === this.endContainer && this.endOffset--, dt.remove(a);
    }
    if (!this.collapsed) {
      for (; this.startOffset == 0 && !(t && t(this.startContainer) || n(this.startContainer)); )
        this.setStartBefore(this.startContainer);
      for (; this.endOffset == (this.endContainer.nodeType == 1 ? this.endContainer.childNodes.length : this.endContainer.nodeValue.length) && !(t && t(this.endContainer) || n(this.endContainer)); )
        this.setEndAfter(this.endContainer);
    }
    return this;
  },
  adjustmentBoundary: function() {
    if (!this.collapsed) {
      for (; !dt.isBody(this.startContainer) && this.startOffset == this.startContainer[this.startContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length && this.startContainer[this.startContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length; )
        this.setStartAfter(this.startContainer);
      for (; !dt.isBody(this.endContainer) && !this.endOffset && this.endContainer[this.endContainer.nodeType == 3 ? "nodeValue" : "childNodes"].length; )
        this.setEndBefore(this.endContainer);
    }
    return this;
  },
  applyInlineStyle: function(e, t, n) {
    if (this.collapsed)
      return this;
    this.trimBoundary().enlarge(!1, function(b) {
      return b.nodeType == 1 && dt.isBlockElm(b);
    }).adjustmentBoundary();
    for (var r = this.createBookmark(), i = r.end, a = function(b) {
      return b.nodeType == 1 ? b.tagName.toLowerCase() != "br" : !dt.isWhitespace(b);
    }, o = dt.getNextDomNode(r.start, !1, a), s, l, u = this.cloneRange(); o && dt.getPosition(o, i) & dt.POSITION_PRECEDING; )
      if (o.nodeType == 3 || Kr[e][o.tagName]) {
        for (u.setStartBefore(o), s = o; s && (s.nodeType == 3 || Kr[e][s.tagName]) && s !== i; )
          l = s, s = dt.getNextDomNode(
            s,
            s.nodeType == 1,
            null,
            function(b) {
              return Kr[e][b.tagName];
            }
          );
        var c = u.setEndAfter(l).extractContents(), f;
        if (n && n.length > 0) {
          var d, h;
          h = d = n[0].cloneNode(!1);
          for (var p = 1, y; y = n[p++]; )
            d.appendChild(y.cloneNode(!1)), d = d.firstChild;
          f = d;
        } else
          f = document.createElement(e);
        t && dt.setAttributes(f, t), f.appendChild(c), f.tagName == "SPAN" && t && t.style && Ci.each(f.getElementsByTagName("span"), function(b) {
          b.style.cssText = b.style.cssText + ";" + t.style;
        }), u.insertNode(n ? h : f);
        var m;
        if (e == "span" && t.style && /text\-decoration/.test(t.style) && (m = dt.findParentByTagName(f, "a", !0)) ? (dt.setAttributes(m, t), dt.remove(f, !0), f = m) : (dt.mergeSibling(f), dt.clearEmptySibling(f)), dt.mergeChild(f, t), o = dt.getNextDomNode(f, !1, a), dt.mergeToParent(f), s === i)
          break;
      } else
        o = dt.getNextDomNode(o, !0, a);
    return this.moveToBookmark(r);
  },
  removeInlineStyle: function(e, t) {
    if (this.collapsed)
      return this;
    e = Ci.isArray(e) ? e : [e], this.shrinkBoundary().adjustmentBoundary();
    for (var n = this.startContainer, r = this.endContainer; ; ) {
      if (n.nodeType == 1) {
        if (Ci.indexOf(e, n.tagName.toLowerCase()) > -1)
          break;
        if (n.tagName.toLowerCase() == "body") {
          n = null;
          break;
        }
      }
      n = n.parentNode;
    }
    for (; ; ) {
      if (r.nodeType == 1) {
        if (Ci.indexOf(e, r.tagName.toLowerCase()) > -1)
          break;
        if (r.tagName.toLowerCase() == "body") {
          r = null;
          break;
        }
      }
      r = r.parentNode;
    }
    var i = this.createBookmark(), a, o;
    n && (o = this.cloneRange().setEndBefore(i.start).setStartBefore(n), a = o.extractContents(), o.insertNode(a), dt.clearEmptySibling(n, !0), n.parentNode.insertBefore(i.start, n)), r && (o = this.cloneRange().setStartAfter(i.end).setEndAfter(r), a = o.extractContents(), o.insertNode(a), dt.clearEmptySibling(r, !1, !0), r.parentNode.insertBefore(i.end, r.nextSibling));
    for (var s = dt.getNextDomNode(i.start, !1, function(u) {
      return u.nodeType == 1;
    }), l; s && s !== i.end; )
      l = dt.getNextDomNode(s, !0, function(u) {
        return u.nodeType == 1;
      }), Ci.indexOf(e, s.tagName.toLowerCase()) > -1 && s.className === t && dt.remove(s, !0), s = l;
    return this.moveToBookmark(i);
  },
  getClosedNode: function() {
    var e;
    if (!this.collapsed) {
      var t = this.cloneRange().adjustmentBoundary().shrinkBoundary();
      if (Tie(t)) {
        var n = t.startContainer.childNodes[t.startOffset];
        n && n.nodeType == 1 && (Kr.$empty[n.tagName] || Kr.$nonChild[n.tagName]) && (e = n);
      }
    }
    return e;
  },
  select: hn.ie ? function(e, t) {
    var n;
    this.collapsed || this.shrinkBoundary();
    var r = this.getClosedNode();
    if (r && !t) {
      try {
        n = document.body.createControlRange(), n.addElement(r), n.select();
      } catch {
      }
      return this;
    }
    var i = this.createBookmark(), a = i.start, o;
    if (n = document.body.createTextRange(), n.moveToElementText(a), n.moveStart("character", 1), this.collapsed) {
      if (!e && this.startContainer.nodeType != 3) {
        var l = document.createTextNode(kp), u = document.createElement("span");
        u.appendChild(document.createTextNode(kp)), a.parentNode.insertBefore(u, a), a.parentNode.insertBefore(l, a), K7(document, l), Ba = l, b1(u, "previousSibling"), b1(a, "nextSibling"), n.moveStart("character", -1), n.collapse(!0);
      }
    } else {
      var s = document.body.createTextRange();
      o = i.end, s.moveToElementText(o), n.setEndPoint("EndToEnd", s);
    }
    this.moveToBookmark(i), u && dt.remove(u);
    try {
      n.select();
    } catch {
    }
    return this;
  } : function(e) {
    function t(l) {
      function u(c, f, d) {
        c.nodeType == 3 && c.nodeValue.length < f && (l[d + "Offset"] = c.nodeValue.length);
      }
      u(l.startContainer, l.startOffset, "start"), u(l.endContainer, l.endOffset, "end");
    }
    var n = window, r = n.getSelection(), i;
    if (hn.gecko ? document.body.focus() : n.focus(), r) {
      if (r.removeAllRanges(), this.collapsed && !e) {
        var a = this.startContainer, o = a;
        a.nodeType == 1 && (o = a.childNodes[this.startOffset]), !(a.nodeType == 3 && this.startOffset) && (o ? !o.previousSibling || o.previousSibling.nodeType != 3 : !a.lastChild || a.lastChild.nodeType != 3) && (i = document.createTextNode(kp), this.insertNode(i), K7(document, i), b1(i, "previousSibling"), b1(i, "nextSibling"), Ba = i, this.setStart(i, hn.webkit ? 1 : 0).collapse(!0));
      }
      var s = document.createRange();
      if (this.collapsed && hn.opera && this.startContainer.nodeType == 1) {
        var o = this.startContainer.childNodes[this.startOffset];
        if (!o)
          o = this.startContainer.lastChild, o && dt.isBr(o) && this.setStartBefore(o).collapse(!0);
        else {
          for (; o && dt.isBlockElm(o) && (o.nodeType == 1 && o.childNodes[0]); )
            o = o.childNodes[0];
          o && this.setStartBefore(o).collapse(!0);
        }
      }
      t(this), s.setStart(this.startContainer, this.startOffset), s.setEnd(this.endContainer, this.endOffset), r.addRange(s);
    }
    return this;
  }
};
class Pie {
  constructor(t) {
    this.parentDom = t, this.addUnderline();
  }
  removeInlineStyle() {
  }
  addUnderline() {
    this.replaceSelectedStrByEle("red");
  }
  enableNiteWriterPen() {
    this.replaceSelectedStrByEle("red");
  }
  getTargetNode(t) {
    return !t || t === document ? !1 : t === this.parentDom ? !0 : this.getTargetNode(t.parentNode, this.parentDom);
  }
  replaceSelectedStrByEle(t) {
    var n = () => {
      var i = new a4(), a = window.getSelection();
      if (a && a.rangeCount) {
        var o = a.getRangeAt(0);
        this.getTargetNode(o.commonAncestorContainer) ? i.setStart(o.startContainer, o.startOffset) : i.setStart(this.parentDom, 0);
        var s = a.getRangeAt(a.rangeCount - 1);
        i.setEnd(s.endContainer, s.endOffset);
      }
      return i;
    }, r = n();
    this.removeInlineStyle = r.removeInlineStyle.bind(r), r.applyInlineStyle("span", {
      class: t
    }), r.select();
  }
}
const xie = { class: "switch-tips" }, Cie = {
  key: 0,
  class: "tips"
}, Sie = { class: "dialog-footer" }, Eie = /* @__PURE__ */ je("\u53D6\u6D88"), kie = /* @__PURE__ */ je(" \u5220\u9664 "), Oie = /* @__PURE__ */ je("\u786E\u5B9A"), zie = /* @__PURE__ */ Ee({
  props: {
    isEditTitle: Boolean,
    fieldsForm: Object,
    isAdd: {
      type: Boolean,
      default: !0
    },
    isDelete: {
      type: Boolean,
      default: !0
    },
    tips: {
      type: String,
      default: ""
    }
  },
  emits: ["update:isEditTitle", "handleTitleDel", "handleTitleSave"],
  setup(e, { emit: t }) {
    const n = e, r = Vs(n, "isEditTitle", t), i = j(), a = j({ field_title: "", status: 0 }), o = {
      field_title: [{ required: !0, message: "\u8BF7\u8F93\u5165\u540D\u79F0", trigger: "blur" }]
    }, s = () => {
      r.value = !1;
    }, l = () => {
      t("handleTitleDel", a.value);
    }, u = () => {
      i.value.validate(async (c) => {
        c && (t("handleTitleSave", a.value, n.isAdd), s());
      });
    };
    return Ne(
      () => r.value,
      async (c) => {
        c ? (await bt(), i.value.clearValidate(), n.fieldsForm && (a.value = Dl(n.fieldsForm))) : a.value = {
          field_title: "",
          status: 0
        };
      }
    ), (c, f) => {
      const d = ti, h = Sa, p = yT, y = Ca, m = fn, b = ni;
      return P(), ue(b, {
        modelValue: E(r),
        "onUpdate:modelValue": f[3] || (f[3] = (x) => Bn(r) ? r.value = x : null),
        title: e.isAdd ? "\u6DFB\u52A0\u65B0\u6A21\u5757" : "\u7F16\u8F91",
        width: "500px",
        "before-close": s
      }, {
        footer: N(() => [
          T("span", Sie, [
            B(m, {
              class: "btn",
              onClick: s
            }, {
              default: N(() => [
                Eie
              ]),
              _: 1
            }),
            e.isDelete && !e.isAdd ? (P(), ue(m, {
              key: 0,
              class: "btn",
              type: "warning",
              onClick: l
            }, {
              default: N(() => [
                kie
              ]),
              _: 1
            })) : re("", !0),
            B(m, {
              class: "btn",
              type: "primary",
              onClick: u
            }, {
              default: N(() => [
                Oie
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(y, {
            ref_key: "formRef",
            ref: i,
            model: a.value,
            "label-width": "60px",
            rules: o,
            onSubmit: f[2] || (f[2] = wt(() => {
            }, ["prevent"]))
          }, {
            default: N(() => [
              B(h, {
                label: "\u540D\u79F0",
                prop: "field_title"
              }, {
                default: N(() => [
                  B(d, {
                    modelValue: a.value.field_title,
                    "onUpdate:modelValue": f[0] || (f[0] = (x) => a.value.field_title = x),
                    placeholder: "\u8BF7\u8F93\u5165\u540D\u79F0",
                    style: { width: "380px" }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              e.isAdd ? re("", !0) : (P(), ue(h, {
                key: 0,
                label: "\u5F00\u5173",
                prop: "status"
              }, {
                default: N(() => [
                  B(p, {
                    modelValue: a.value.status,
                    "onUpdate:modelValue": f[1] || (f[1] = (x) => a.value.status = x),
                    "active-value": 1,
                    "inactive-value": 0,
                    "active-color": "var(--el-color-primary)",
                    "inactive-color": "#dddddd"
                  }, null, 8, ["modelValue"]),
                  T("span", xie, de(a.value.status === 1 ? "\u5173\u95ED\u540E\u7F51\u9875\u4E0A\u5C06\u9690\u85CF\u8BE5\u6A21\u5757\u5185\u5BB9" : "\u6253\u5F00\u540E\u7F51\u9875\u4E0A\u5C06\u663E\u793A\u8BE5\u6A21\u5757\u5185\u5BB9"), 1)
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["model"]),
          e.isAdd && e.tips ? (P(), L("div", Cie, de(e.tips), 1)) : re("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});
const R3 = /* @__PURE__ */ Ht(zie, [["__scopeId", "data-v-fd6e7486"]]);
const Die = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "30",
  height: "30"
}, Mie = /* @__PURE__ */ T("path", {
  d: "M15 0C6.717 0 0 6.717 0 15c0 8.284 6.717 15 15 15 8.284 0 15-6.716 15-15 0-8.283-6.716-15-15-15Zm-.804 7.5a.269.269 0 0 0-.267.268v9.107c0 .147.12.268.267.268h1.608c.147 0 .267-.12.267-.268V7.768a.269.269 0 0 0-.267-.268h-1.608Zm.804 15a1.607 1.607 0 1 1 0-3.215 1.607 1.607 0 0 1 0 3.215Z",
  "fill-rule": "evenodd",
  fill: "currentColor",
  style: { "mix-blend-mode": "passthrough" }
}, null, -1), Hie = [
  Mie
];
function Iie(e, t) {
  return P(), L("svg", Die, Hie);
}
const Lie = { render: Iie }, di = (e) => {
  const { tipTitle: t, tipText: n, headerTitle: r, boxType: i = "confirm", ...a } = e, o = Object.assign(
    {
      confirmButtonText: "\u786E \u8BA4",
      cancelButtonText: "\u53D6 \u6D88",
      dangerouslyUseHTMLString: !0,
      type: "warning",
      icon: og(Lie)
    },
    a
  );
  return eS[i === "confirm" ? "confirm" : "alert"](
    `<div class="tip-title">${t}</div>
      <span class="tip-text">${n}</span>`,
    r,
    o
  );
}, KT = (e, t) => {
  const n = ce("$http"), r = zt({
    column_title: "",
    parent_id: "",
    site_id: e,
    column_type: -1
  }), i = zt({
    column_title: "",
    id: "",
    status: 0
  });
  return {
    editMenuForm: i,
    addMenuInfo: async (l, u, c) => {
      r.column_title = l, r.parent_id = u, c === 33 && (r.column_type = 1), await n.addCaseMenu(r), r.column_type = -1, t.emit("contentChange", 3);
    },
    updateMenuInfo: async () => {
      await n.updateCaseMenu(i), t.emit("contentChange", 3);
    },
    deleteMenu: async (l) => {
      await di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8FD9\u9879\u5185\u5BB9\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001\u3002"
      }), await n.delCaseMenu({ site_id: e, ids: l }) > 0 && (yi.success("\u5220\u9664\u6210\u529F"), t.emit("contentChange", 3));
    }
  };
}, Bie = { class: "left" }, Nie = { class: "title" }, jie = /* @__PURE__ */ je("\u5DF2\u5173\u95ED"), Fie = { class: "right" }, Xie = /* @__PURE__ */ Ee({
  props: {
    styleProps: Object,
    columnInfo: Object
  },
  setup(e) {
    const t = e, n = [-1, 1, 2, 3, 4], r = j(!1), i = ce("$bus"), a = ce("siteId"), o = ce("pageMode"), { editMenuForm: s, updateMenuInfo: l, deleteMenu: u } = KT(a, i), c = J(() => ({
      field_title: t.columnInfo.columnTitle,
      status: t.columnInfo.status
    })), f = (p) => {
      s.column_title = p.field_title, s.status = p.status, s.id = t.columnInfo.id, l();
    }, d = async () => {
      await u(t.columnInfo.id), r.value = !1;
    }, h = J(() => n.includes(t.columnInfo.columnType));
    return (p, y) => {
      const m = hf;
      return P(), L(nt, null, [
        T("div", {
          class: "common-header",
          style: Pt(e.styleProps)
        }, [
          T("div", Bie, [
            T("div", Nie, de(e.columnInfo.columnTitle), 1),
            E(o) === 1 ? (P(), L(nt, { key: 0 }, [
              T("i", {
                class: "iconfont icon-bianji edit-icon",
                onClick: y[0] || (y[0] = (b) => r.value = !0)
              }),
              e.columnInfo.status === 0 ? (P(), ue(m, {
                key: 0,
                type: "warning"
              }, {
                default: N(() => [
                  jie
                ]),
                _: 1
              })) : re("", !0)
            ], 64)) : re("", !0)
          ]),
          T("div", Fie, [
            E(o) === 1 ? tt(p.$slots, "right", { key: 0 }, void 0, !0) : re("", !0)
          ])
        ], 4),
        B(R3, {
          isEditTitle: r.value,
          "onUpdate:isEditTitle": y[1] || (y[1] = (b) => r.value = b),
          "is-add": !1,
          "is-delete": E(h),
          "fields-form": E(c),
          onHandleTitleSave: f,
          onHandleTitleDel: d
        }, null, 8, ["isEditTitle", "is-delete", "fields-form"])
      ], 64);
    };
  }
});
const V3 = /* @__PURE__ */ Ht(Xie, [["__scopeId", "data-v-fedc95f6"]]);
const Pc = (e) => (yn("data-v-6a584725"), e = e(), bn(), e), Rie = { key: 0 }, Vie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji edit-icon" }, null, -1)), Uie = /* @__PURE__ */ je(" \u7F16\u8F91 "), qie = {
  key: 1,
  class: "common-flex"
}, _ie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shanchu1" }, null, -1)), Wie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("span", null, "\u5220\u9664", -1)), Kie = [
  _ie,
  Wie
], Gie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tihuan" }, null, -1)), Yie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("span", null, "\u66FF\u6362\u89C6\u9891", -1)), Qie = [
  Gie,
  Yie
], Zie = { key: 2 }, Jie = /* @__PURE__ */ Pc(() => /* @__PURE__ */ T("span", null, "\u4E0A\u4F20\u9644\u4EF6", -1)), $ie = {
  props: {
    columnInfo: Object,
    isEdit: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:isEdit", "handleUpdateVideo", "handleUploadFile"],
  setup(e, { emit: t }) {
    const n = () => {
      t("update:isEdit", !0);
    }, r = (i) => {
      t("handleUpdateVideo", i);
    };
    return (i, a) => {
      const o = E3, s = qt, l = fn;
      return P(), ue(V3, { "column-info": e.columnInfo }, {
        right: N(() => [
          e.columnInfo.columnContent ? (P(), L("div", Rie, [
            !e.isEdit && e.columnInfo.columnType == 1 ? (P(), ue(o, {
              key: 0,
              underline: !1,
              type: "primary",
              size: "default",
              onClick: n
            }, {
              default: N(() => [
                Vie,
                Uie
              ]),
              _: 1
            })) : re("", !0),
            e.columnInfo.columnType === 3 ? (P(), L("div", qie, [
              T("div", {
                class: "operate-btn",
                style: { "margin-right": "20px" },
                onClick: a[0] || (a[0] = (u) => r("delete"))
              }, Kie),
              T("div", {
                class: "operate-btn",
                onClick: a[1] || (a[1] = (u) => r("replace"))
              }, Qie)
            ])) : re("", !0),
            e.columnInfo.columnType === 2 ? (P(), L("div", Zie, [
              B(l, {
                plain: !0,
                class: "upload-btn",
                onClick: a[2] || (a[2] = (u) => t("handleUploadFile"))
              }, {
                default: N(() => [
                  B(s, null, {
                    default: N(() => [
                      B(E(Zte))
                    ]),
                    _: 1
                  }),
                  Jie
                ]),
                _: 1
              })
            ])) : re("", !0)
          ])) : re("", !0)
        ]),
        _: 1
      }, 8, ["column-info"]);
    };
  }
}, ere = /* @__PURE__ */ Ht($ie, [["__scopeId", "data-v-6a584725"]]);
const tre = ["src", "alt"], nre = { class: "name" }, ire = { class: "description" }, rre = /* @__PURE__ */ je("\u9009\u62E9 >"), are = {
  props: {
    width: {
      type: String,
      default: "226px"
    },
    mode: Number,
    title: String,
    description: String,
    banner: {
      type: Object,
      default: () => ({ url: "", width: "" })
    }
  },
  emits: ["handleSelectedMode"],
  setup(e, { emit: t }) {
    const n = e, r = () => {
      t("handleSelectedMode", n.mode);
    };
    return (i, a) => {
      const o = fn;
      return P(), L("div", {
        class: "mode-box",
        style: Pt({ width: e.width })
      }, [
        T("img", {
          src: e.banner.url,
          style: Pt({ width: e.banner.width + "px" }),
          alt: e.title
        }, null, 12, tre),
        T("span", nre, de(e.title), 1),
        T("p", ire, de(e.description), 1),
        B(o, {
          type: "primary",
          class: "select-btn",
          onClick: r
        }, {
          default: N(() => [
            rre
          ]),
          _: 1
        })
      ], 4);
    };
  }
}, ore = /* @__PURE__ */ Ht(are, [["__scopeId", "data-v-ad8b3a6c"]]);
const sre = (e) => (yn("data-v-19eb0fc8"), e = e(), bn(), e), lre = {
  key: 0,
  class: "upload-progress"
}, ure = /* @__PURE__ */ sre(() => /* @__PURE__ */ T("div", { class: "progress-text" }, "\u89C6\u9891\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u7A0D\u7B49", -1)), cre = /* @__PURE__ */ je("\u4E0A\u4F20\u89C6\u9891"), dre = {
  emits: ["handleBeforeUpload", "handleUploadSuccess"],
  setup(e, { expose: t, emit: n }) {
    const r = ce("$http"), i = j(null);
    let a = zt({
      name: "",
      progress: 0
    }), o = j(""), s = j(null);
    const l = () => {
      bt(() => {
        i.value.$refs.uploadRef.handleClick();
      });
    }, u = (h) => new Promise(async (p, y) => {
      try {
        const m = await r.getPolicy({ fileName: h.name });
        if (!m)
          return;
        const b = JSON.parse(m);
        o.value = b.host;
        let x = {};
        x.key = b.dir + b.fileUUID + "." + h.name.split(".")[h.name.split(".").length - 1], x.policy = b.policy, x.OSSAccessKeyId = b.accessid, x.success_action_status = 200, x.callback = b.callback, x.signature = b.signature, x["Content-Disposition"] = "attachment;filename=" + h.name, s.value = x, a.name = h.name, a.progress = 0, p(!0), n("handleBeforeUpload");
      } catch (m) {
        console.log(m), y(!1);
      }
    }), c = (h, p, y) => {
      const m = Math.floor(h.percent);
      a.progress = m === 100 ? 99 : m;
    }, f = (h, p, y) => {
      console.log("onUploadSuccess", h, p), a.progress = 100;
      const { id: m } = h.data;
      n("handleUploadSuccess", m), setTimeout(() => {
        a.progress = 0, i.value.clearFiles();
      }, 500);
    }, d = (h, p, y) => {
      console.log(h), An.error(`${a.name}\u4E0A\u4F20\u5931\u8D25`);
    };
    return t({
      handleTriggerUpload: l
    }), (h, p) => {
      const y = M3, m = fn, b = yf;
      return P(), L("div", null, [
        E(a).progress ? (P(), L("div", lre, [
          B(y, {
            type: "circle",
            width: 80,
            percentage: E(a).progress,
            color: "var(--el-color-primary)"
          }, null, 8, ["percentage"]),
          ure
        ])) : re("", !0),
        B(b, {
          style: { display: "none" },
          ref_key: "uploadDom",
          ref: i,
          action: E(o),
          limit: 1,
          data: E(s),
          accept: ".mp4,.webm,.ogg",
          "show-file-list": !1,
          "before-upload": u,
          "on-progress": c,
          "on-error": d,
          "on-success": f
        }, {
          default: N(() => [
            B(m, {
              type: "primary",
              plain: "",
              size: "large",
              style: { width: "150px" }
            }, {
              default: N(() => [
                cre
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["action", "data"])
      ]);
    };
  }
}, fre = /* @__PURE__ */ Ht(dre, [["__scopeId", "data-v-19eb0fc8"]]);
var od;
typeof window < "u" ? od = window : typeof Ir < "u" ? od = Ir : typeof self < "u" ? od = self : od = {};
var pe = od;
const hre = {}, pre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hre
}, Symbol.toStringTag, { value: "Module" })), vre = /* @__PURE__ */ Kg(pre);
var G7 = typeof Ir < "u" ? Ir : typeof window < "u" ? window : {}, mre = vre, sd;
typeof document < "u" ? sd = document : (sd = G7["__GLOBAL_DOCUMENT_CACHE@4"], sd || (sd = G7["__GLOBAL_DOCUMENT_CACHE@4"] = mre));
var ft = sd;
function Ta() {
  return Ta = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ta.apply(this, arguments);
}
const gre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ta
}, Symbol.toStringTag, { value: "Module" }));
var o4 = { exports: {} };
(function(e, t) {
  function n(l) {
    if (l && typeof l == "object") {
      var u = l.which || l.keyCode || l.charCode;
      u && (l = u);
    }
    if (typeof l == "number")
      return o[l];
    var c = String(l), f = r[c.toLowerCase()];
    if (f)
      return f;
    var f = i[c.toLowerCase()];
    if (f)
      return f;
    if (c.length === 1)
      return c.charCodeAt(0);
  }
  n.isEventKey = function(u, c) {
    if (u && typeof u == "object") {
      var f = u.which || u.keyCode || u.charCode;
      if (f == null)
        return !1;
      if (typeof c == "string") {
        var d = r[c.toLowerCase()];
        if (d)
          return d === f;
        var d = i[c.toLowerCase()];
        if (d)
          return d === f;
      } else if (typeof c == "number")
        return c === f;
      return !1;
    }
  }, t = e.exports = n;
  var r = t.code = t.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, i = t.aliases = {
    windows: 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (a = 97; a < 123; a++)
    r[String.fromCharCode(a)] = a - 32;
  for (var a = 48; a < 58; a++)
    r[a - 48] = a;
  for (a = 1; a < 13; a++)
    r["f" + a] = a + 111;
  for (a = 0; a < 10; a++)
    r["numpad " + a] = a + 96;
  var o = t.names = t.title = {};
  for (a in r)
    o[r[a]] = a;
  for (var s in i)
    r[s] = i[s];
})(o4, o4.exports);
const un = o4.exports;
function on(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gd(e, t) {
  return Gd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Gd(e, t);
}
function At(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Gd(e, t);
}
var yre = bre;
function bre(e, t) {
  var n, r = null;
  try {
    n = JSON.parse(e, t);
  } catch (i) {
    r = i;
  }
  return [r, n];
}
var Yh = { exports: {} };
const Are = /* @__PURE__ */ Kg(gre);
var Tre = Pre, wre = Object.prototype.toString;
function Pre(e) {
  if (!e)
    return !1;
  var t = wre.call(e);
  return t === "[object Function]" || typeof e == "function" && t !== "[object RegExp]" || typeof window < "u" && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
}
var xre = pe, Cre = function(t, n) {
  return n === void 0 && (n = !1), function(r, i, a) {
    if (r) {
      t(r);
      return;
    }
    if (i.statusCode >= 400 && i.statusCode <= 599) {
      var o = a;
      if (n)
        if (xre.TextDecoder) {
          var s = Sre(i.headers && i.headers["content-type"]);
          try {
            o = new TextDecoder(s).decode(a);
          } catch {
          }
        } else
          o = String.fromCharCode.apply(null, new Uint8Array(a));
      t({
        cause: o
      });
      return;
    }
    t(null, a);
  };
};
function Sre(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(";").reduce(function(t, n) {
    var r = n.split("="), i = r[0], a = r[1];
    return i.trim() === "charset" ? a.trim() : t;
  }, "utf-8");
}
var Ere = Cre, GT = pe, kre = Are, Ore = Tre;
lo.httpHandler = Ere;
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var zre = function(t) {
  var n = {};
  return t && t.trim().split(`
`).forEach(function(r) {
    var i = r.indexOf(":"), a = r.slice(0, i).trim().toLowerCase(), o = r.slice(i + 1).trim();
    typeof n[a] > "u" ? n[a] = o : Array.isArray(n[a]) ? n[a].push(o) : n[a] = [n[a], o];
  }), n;
};
Yh.exports = lo;
Yh.exports.default = lo;
lo.XMLHttpRequest = GT.XMLHttpRequest || Ire;
lo.XDomainRequest = "withCredentials" in new lo.XMLHttpRequest() ? lo.XMLHttpRequest : GT.XDomainRequest;
Dre(["get", "put", "post", "patch", "head", "delete"], function(e) {
  lo[e === "delete" ? "del" : e] = function(t, n, r) {
    return n = YT(t, n, r), n.method = e.toUpperCase(), QT(n);
  };
});
function Dre(e, t) {
  for (var n = 0; n < e.length; n++)
    t(e[n]);
}
function Mre(e) {
  for (var t in e)
    if (e.hasOwnProperty(t))
      return !1;
  return !0;
}
function YT(e, t, n) {
  var r = e;
  return Ore(t) ? (n = t, typeof e == "string" && (r = {
    uri: e
  })) : r = kre({}, t, {
    uri: e
  }), r.callback = n, r;
}
function lo(e, t, n) {
  return t = YT(e, t, n), QT(t);
}
function QT(e) {
  if (typeof e.callback > "u")
    throw new Error("callback argument missing");
  var t = !1, n = function(D, S, C) {
    t || (t = !0, e.callback(D, S, C));
  };
  function r() {
    s.readyState === 4 && setTimeout(o, 0);
  }
  function i() {
    var x = void 0;
    if (s.response ? x = s.response : x = s.responseText || Hre(s), y)
      try {
        x = JSON.parse(x);
      } catch {
      }
    return x;
  }
  function a(x) {
    return clearTimeout(m), x instanceof Error || (x = new Error("" + (x || "Unknown XMLHttpRequest Error"))), x.statusCode = 0, n(x, b);
  }
  function o() {
    if (!u) {
      var x;
      clearTimeout(m), e.useXDR && s.status === void 0 ? x = 200 : x = s.status === 1223 ? 204 : s.status;
      var D = b, S = null;
      return x !== 0 ? (D = {
        body: i(),
        statusCode: x,
        method: f,
        headers: {},
        url: c,
        rawRequest: s
      }, s.getAllResponseHeaders && (D.headers = zre(s.getAllResponseHeaders()))) : S = new Error("Internal XMLHttpRequest Error"), n(S, D, D.body);
    }
  }
  var s = e.xhr || null;
  s || (e.cors || e.useXDR ? s = new lo.XDomainRequest() : s = new lo.XMLHttpRequest());
  var l, u, c = s.url = e.uri || e.url, f = s.method = e.method || "GET", d = e.body || e.data, h = s.headers = e.headers || {}, p = !!e.sync, y = !1, m, b = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: f,
    url: c,
    rawRequest: s
  };
  if ("json" in e && e.json !== !1 && (y = !0, h.accept || h.Accept || (h.Accept = "application/json"), f !== "GET" && f !== "HEAD" && (h["content-type"] || h["Content-Type"] || (h["Content-Type"] = "application/json"), d = JSON.stringify(e.json === !0 ? d : e.json))), s.onreadystatechange = r, s.onload = o, s.onerror = a, s.onprogress = function() {
  }, s.onabort = function() {
    u = !0;
  }, s.ontimeout = a, s.open(f, c, !p, e.username, e.password), p || (s.withCredentials = !!e.withCredentials), !p && e.timeout > 0 && (m = setTimeout(function() {
    if (!u) {
      u = !0, s.abort("timeout");
      var x = new Error("XMLHttpRequest timeout");
      x.code = "ETIMEDOUT", a(x);
    }
  }, e.timeout)), s.setRequestHeader)
    for (l in h)
      h.hasOwnProperty(l) && s.setRequestHeader(l, h[l]);
  else if (e.headers && !Mre(e.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in e && (s.responseType = e.responseType), "beforeSend" in e && typeof e.beforeSend == "function" && e.beforeSend(s), s.send(d || null), s;
}
function Hre(e) {
  try {
    if (e.responseType === "document")
      return e.responseXML;
    var t = e.responseXML && e.responseXML.documentElement.nodeName === "parsererror";
    if (e.responseType === "" && !t)
      return e.responseXML;
  } catch {
  }
  return null;
}
function Ire() {
}
var s4 = { exports: {} }, Y7 = ft, U3 = Object.create || function() {
  function e() {
  }
  return function(t) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return e.prototype = t, new e();
  };
}();
function Yr(e, t) {
  this.name = "ParsingError", this.code = e.code, this.message = t || e.message;
}
Yr.prototype = U3(Error.prototype);
Yr.prototype.constructor = Yr;
Yr.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function q3(e) {
  function t(r, i, a, o) {
    return (r | 0) * 3600 + (i | 0) * 60 + (a | 0) + (o | 0) / 1e3;
  }
  var n = e.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return n ? n[3] ? t(n[1], n[2], n[3].replace(":", ""), n[4]) : n[1] > 59 ? t(n[1], n[2], 0, n[4]) : t(0, n[1], n[2], n[4]) : null;
}
function Pd() {
  this.values = U3(null);
}
Pd.prototype = {
  set: function(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  },
  get: function(e, t, n) {
    return n ? this.has(e) ? this.values[e] : t[n] : this.has(e) ? this.values[e] : t;
  },
  has: function(e) {
    return e in this.values;
  },
  alt: function(e, t, n) {
    for (var r = 0; r < n.length; ++r)
      if (t === n[r]) {
        this.set(e, t);
        break;
      }
  },
  integer: function(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  },
  percent: function(e, t) {
    return t.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (t = parseFloat(t), t >= 0 && t <= 100) ? (this.set(e, t), !0) : !1;
  }
};
function ld(e, t, n, r) {
  var i = r ? e.split(r) : [e];
  for (var a in i)
    if (typeof i[a] == "string") {
      var o = i[a].split(n);
      if (o.length === 2) {
        var s = o[0].trim(), l = o[1].trim();
        t(s, l);
      }
    }
}
function Lre(e, t, n) {
  var r = e;
  function i() {
    var s = q3(e);
    if (s === null)
      throw new Yr(
        Yr.Errors.BadTimeStamp,
        "Malformed timestamp: " + r
      );
    return e = e.replace(/^[^\sa-zA-Z-]+/, ""), s;
  }
  function a(s, l) {
    var u = new Pd();
    ld(s, function(c, f) {
      switch (c) {
        case "region":
          for (var d = n.length - 1; d >= 0; d--)
            if (n[d].id === f) {
              u.set(c, n[d].region);
              break;
            }
          break;
        case "vertical":
          u.alt(c, f, ["rl", "lr"]);
          break;
        case "line":
          var h = f.split(","), p = h[0];
          u.integer(c, p), u.percent(c, p) && u.set("snapToLines", !1), u.alt(c, p, ["auto"]), h.length === 2 && u.alt("lineAlign", h[1], ["start", "center", "end"]);
          break;
        case "position":
          h = f.split(","), u.percent(c, h[0]), h.length === 2 && u.alt("positionAlign", h[1], ["start", "center", "end"]);
          break;
        case "size":
          u.percent(c, f);
          break;
        case "align":
          u.alt(c, f, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = u.get("region", null), l.vertical = u.get("vertical", "");
    try {
      l.line = u.get("line", "auto");
    } catch {
    }
    l.lineAlign = u.get("lineAlign", "start"), l.snapToLines = u.get("snapToLines", !0), l.size = u.get("size", 100);
    try {
      l.align = u.get("align", "center");
    } catch {
      l.align = u.get("align", "middle");
    }
    try {
      l.position = u.get("position", "auto");
    } catch {
      l.position = u.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, l.align);
    }
    l.positionAlign = u.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, l.align);
  }
  function o() {
    e = e.replace(/^\s+/, "");
  }
  if (o(), t.startTime = i(), o(), e.substr(0, 3) !== "-->")
    throw new Yr(
      Yr.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + r
    );
  e = e.substr(3), o(), t.endTime = i(), o(), a(e, t);
}
var Op = Y7.createElement && Y7.createElement("textarea"), Bre = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, Q7 = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, Nre = {
  v: "title",
  lang: "lang"
}, Z7 = {
  rt: "ruby"
};
function ZT(e, t) {
  function n() {
    if (!t)
      return null;
    function p(m) {
      return t = t.substr(m.length), m;
    }
    var y = t.match(/^([^<]*)(<[^>]*>?)?/);
    return p(y[1] ? y[1] : y[2]);
  }
  function r(p) {
    return Op.innerHTML = p, p = Op.textContent, Op.textContent = "", p;
  }
  function i(p, y) {
    return !Z7[y.localName] || Z7[y.localName] === p.localName;
  }
  function a(p, y) {
    var m = Bre[p];
    if (!m)
      return null;
    var b = e.document.createElement(m), x = Nre[p];
    return x && y && (b[x] = y.trim()), b;
  }
  for (var o = e.document.createElement("div"), s = o, l, u = []; (l = n()) !== null; ) {
    if (l[0] === "<") {
      if (l[1] === "/") {
        u.length && u[u.length - 1] === l.substr(2).replace(">", "") && (u.pop(), s = s.parentNode);
        continue;
      }
      var c = q3(l.substr(1, l.length - 2)), f;
      if (c) {
        f = e.document.createProcessingInstruction("timestamp", c), s.appendChild(f);
        continue;
      }
      var d = l.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!d || (f = a(d[1], d[3]), !f) || !i(s, f))
        continue;
      if (d[2]) {
        var h = d[2].split(".");
        h.forEach(function(p) {
          var y = /^bg_/.test(p), m = y ? p.slice(3) : p;
          if (Q7.hasOwnProperty(m)) {
            var b = y ? "background-color" : "color", x = Q7[m];
            f.style[b] = x;
          }
        }), f.className = h.join(" ");
      }
      u.push(d[1]), s.appendChild(f), s = f;
      continue;
    }
    s.appendChild(e.document.createTextNode(r(l)));
  }
  return o;
}
var J7 = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function jre(e) {
  for (var t = 0; t < J7.length; t++) {
    var n = J7[t];
    if (e >= n[0] && e <= n[1])
      return !0;
  }
  return !1;
}
function Fre(e) {
  var t = [], n = "", r;
  if (!e || !e.childNodes)
    return "ltr";
  function i(s, l) {
    for (var u = l.childNodes.length - 1; u >= 0; u--)
      s.push(l.childNodes[u]);
  }
  function a(s) {
    if (!s || !s.length)
      return null;
    var l = s.pop(), u = l.textContent || l.innerText;
    if (u) {
      var c = u.match(/^.*(\n|\r)/);
      return c ? (s.length = 0, c[0]) : u;
    }
    if (l.tagName === "ruby")
      return a(s);
    if (l.childNodes)
      return i(s, l), a(s);
  }
  for (i(t, e); n = a(t); )
    for (var o = 0; o < n.length; o++)
      if (r = n.charCodeAt(o), jre(r))
        return "rtl";
  return "ltr";
}
function Xre(e) {
  if (typeof e.line == "number" && (e.snapToLines || e.line >= 0 && e.line <= 100))
    return e.line;
  if (!e.track || !e.track.textTrackList || !e.track.textTrackList.mediaElement)
    return -1;
  for (var t = e.track, n = t.textTrackList, r = 0, i = 0; i < n.length && n[i] !== t; i++)
    n[i].mode === "showing" && r++;
  return ++r * -1;
}
function Qh() {
}
Qh.prototype.applyStyles = function(e, t) {
  t = t || this.div;
  for (var n in e)
    e.hasOwnProperty(n) && (t.style[n] = e[n]);
};
Qh.prototype.formatStyle = function(e, t) {
  return e === 0 ? 0 : e + t;
};
function K0(e, t, n) {
  Qh.call(this), this.cue = t, this.cueDiv = ZT(e, t.text);
  var r = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(r, this.cueDiv), this.div = e.document.createElement("div"), r = {
    direction: Fre(this.cueDiv),
    writingMode: t.vertical === "" ? "horizontal-tb" : t.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: t.align === "middle" ? "center" : t.align,
    font: n.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(r), this.div.appendChild(this.cueDiv);
  var i = 0;
  switch (t.positionAlign) {
    case "start":
      i = t.position;
      break;
    case "center":
      i = t.position - t.size / 2;
      break;
    case "end":
      i = t.position - t.size;
      break;
  }
  t.vertical === "" ? this.applyStyles({
    left: this.formatStyle(i, "%"),
    width: this.formatStyle(t.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(i, "%"),
    height: this.formatStyle(t.size, "%")
  }), this.move = function(a) {
    this.applyStyles({
      top: this.formatStyle(a.top, "px"),
      bottom: this.formatStyle(a.bottom, "px"),
      left: this.formatStyle(a.left, "px"),
      right: this.formatStyle(a.right, "px"),
      height: this.formatStyle(a.height, "px"),
      width: this.formatStyle(a.width, "px")
    });
  };
}
K0.prototype = U3(Qh.prototype);
K0.prototype.constructor = K0;
function mr(e) {
  var t, n, r, i;
  if (e.div) {
    n = e.div.offsetHeight, r = e.div.offsetWidth, i = e.div.offsetTop;
    var a = (a = e.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
    e = e.div.getBoundingClientRect(), t = a ? Math.max(a[0] && a[0].height || 0, e.height / a.length) : 0;
  }
  this.left = e.left, this.right = e.right, this.top = e.top || i, this.height = e.height || n, this.bottom = e.bottom || i + (e.height || n), this.width = e.width || r, this.lineHeight = t !== void 0 ? t : e.lineHeight;
}
mr.prototype.move = function(e, t) {
  switch (t = t !== void 0 ? t : this.lineHeight, e) {
    case "+x":
      this.left += t, this.right += t;
      break;
    case "-x":
      this.left -= t, this.right -= t;
      break;
    case "+y":
      this.top += t, this.bottom += t;
      break;
    case "-y":
      this.top -= t, this.bottom -= t;
      break;
  }
};
mr.prototype.overlaps = function(e) {
  return this.left < e.right && this.right > e.left && this.top < e.bottom && this.bottom > e.top;
};
mr.prototype.overlapsAny = function(e) {
  for (var t = 0; t < e.length; t++)
    if (this.overlaps(e[t]))
      return !0;
  return !1;
};
mr.prototype.within = function(e) {
  return this.top >= e.top && this.bottom <= e.bottom && this.left >= e.left && this.right <= e.right;
};
mr.prototype.overlapsOppositeAxis = function(e, t) {
  switch (t) {
    case "+x":
      return this.left < e.left;
    case "-x":
      return this.right > e.right;
    case "+y":
      return this.top < e.top;
    case "-y":
      return this.bottom > e.bottom;
  }
};
mr.prototype.intersectPercentage = function(e) {
  var t = Math.max(0, Math.min(this.right, e.right) - Math.max(this.left, e.left)), n = Math.max(0, Math.min(this.bottom, e.bottom) - Math.max(this.top, e.top)), r = t * n;
  return r / (this.height * this.width);
};
mr.prototype.toCSSCompatValues = function(e) {
  return {
    top: this.top - e.top,
    bottom: e.bottom - this.bottom,
    left: this.left - e.left,
    right: e.right - this.right,
    height: this.height,
    width: this.width
  };
};
mr.getSimpleBoxPosition = function(e) {
  var t = e.div ? e.div.offsetHeight : e.tagName ? e.offsetHeight : 0, n = e.div ? e.div.offsetWidth : e.tagName ? e.offsetWidth : 0, r = e.div ? e.div.offsetTop : e.tagName ? e.offsetTop : 0;
  e = e.div ? e.div.getBoundingClientRect() : e.tagName ? e.getBoundingClientRect() : e;
  var i = {
    left: e.left,
    right: e.right,
    top: e.top || r,
    height: e.height || t,
    bottom: e.bottom || r + (e.height || t),
    width: e.width || n
  };
  return i;
};
function Rre(e, t, n, r) {
  function i(m, b) {
    for (var x, D = new mr(m), S = 1, C = 0; C < b.length; C++) {
      for (; m.overlapsOppositeAxis(n, b[C]) || m.within(n) && m.overlapsAny(r); )
        m.move(b[C]);
      if (m.within(n))
        return m;
      var v = m.intersectPercentage(n);
      S > v && (x = new mr(m), S = v), m = new mr(D);
    }
    return x || D;
  }
  var a = new mr(t), o = t.cue, s = Xre(o), l = [];
  if (o.snapToLines) {
    var u;
    switch (o.vertical) {
      case "":
        l = ["+y", "-y"], u = "height";
        break;
      case "rl":
        l = ["+x", "-x"], u = "width";
        break;
      case "lr":
        l = ["-x", "+x"], u = "width";
        break;
    }
    var c = a.lineHeight, f = c * Math.round(s), d = n[u] + c, h = l[0];
    Math.abs(f) > d && (f = f < 0 ? -1 : 1, f *= Math.ceil(d / c) * c), s < 0 && (f += o.vertical === "" ? n.height : n.width, l = l.reverse()), a.move(h, f);
  } else {
    var p = a.lineHeight / n.height * 100;
    switch (o.lineAlign) {
      case "center":
        s -= p / 2;
        break;
      case "end":
        s -= p;
        break;
    }
    switch (o.vertical) {
      case "":
        t.applyStyles({
          top: t.formatStyle(s, "%")
        });
        break;
      case "rl":
        t.applyStyles({
          left: t.formatStyle(s, "%")
        });
        break;
      case "lr":
        t.applyStyles({
          right: t.formatStyle(s, "%")
        });
        break;
    }
    l = ["+y", "-x", "+x", "-y"], a = new mr(t);
  }
  var y = i(a, l);
  t.move(y.toCSSCompatValues(n));
}
function xc() {
}
xc.StringDecoder = function() {
  return {
    decode: function(e) {
      if (!e)
        return "";
      if (typeof e != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(e));
    }
  };
};
xc.convertCueToDOMTree = function(e, t) {
  return !e || !t ? null : ZT(e, t);
};
var Vre = 0.05, Ure = "sans-serif", qre = "1.5%";
xc.processCues = function(e, t, n) {
  if (!e || !t || !n)
    return null;
  for (; n.firstChild; )
    n.removeChild(n.firstChild);
  var r = e.document.createElement("div");
  r.style.position = "absolute", r.style.left = "0", r.style.right = "0", r.style.top = "0", r.style.bottom = "0", r.style.margin = qre, n.appendChild(r);
  function i(c) {
    for (var f = 0; f < c.length; f++)
      if (c[f].hasBeenReset || !c[f].displayState)
        return !0;
    return !1;
  }
  if (!i(t)) {
    for (var a = 0; a < t.length; a++)
      r.appendChild(t[a].displayState);
    return;
  }
  var o = [], s = mr.getSimpleBoxPosition(r), l = Math.round(s.height * Vre * 100) / 100, u = {
    font: l + "px " + Ure
  };
  (function() {
    for (var c, f, d = 0; d < t.length; d++)
      f = t[d], c = new K0(e, f, u), r.appendChild(c.div), Rre(e, c, s, o), f.displayState = c.div, o.push(mr.getSimpleBoxPosition(c));
  })();
};
xc.Parser = function(e, t, n) {
  n || (n = t, t = {}), t || (t = {}), this.window = e, this.vttjs = t, this.state = "INITIAL", this.buffer = "", this.decoder = n || new TextDecoder("utf8"), this.regionList = [];
};
xc.Parser.prototype = {
  reportOrThrowError: function(e) {
    if (e instanceof Yr)
      this.onparsingerror && this.onparsingerror(e);
    else
      throw e;
  },
  parse: function(e) {
    var t = this;
    e && (t.buffer += t.decoder.decode(e, { stream: !0 }));
    function n() {
      for (var c = t.buffer, f = 0; f < c.length && c[f] !== "\r" && c[f] !== `
`; )
        ++f;
      var d = c.substr(0, f);
      return c[f] === "\r" && ++f, c[f] === `
` && ++f, t.buffer = c.substr(f), d;
    }
    function r(c) {
      var f = new Pd();
      if (ld(c, function(h, p) {
        switch (h) {
          case "id":
            f.set(h, p);
            break;
          case "width":
            f.percent(h, p);
            break;
          case "lines":
            f.integer(h, p);
            break;
          case "regionanchor":
          case "viewportanchor":
            var y = p.split(",");
            if (y.length !== 2)
              break;
            var m = new Pd();
            if (m.percent("x", y[0]), m.percent("y", y[1]), !m.has("x") || !m.has("y"))
              break;
            f.set(h + "X", m.get("x")), f.set(h + "Y", m.get("y"));
            break;
          case "scroll":
            f.alt(h, p, ["up"]);
            break;
        }
      }, /=/, /\s/), f.has("id")) {
        var d = new (t.vttjs.VTTRegion || t.window.VTTRegion)();
        d.width = f.get("width", 100), d.lines = f.get("lines", 3), d.regionAnchorX = f.get("regionanchorX", 0), d.regionAnchorY = f.get("regionanchorY", 100), d.viewportAnchorX = f.get("viewportanchorX", 0), d.viewportAnchorY = f.get("viewportanchorY", 100), d.scroll = f.get("scroll", ""), t.onregion && t.onregion(d), t.regionList.push({
          id: f.get("id"),
          region: d
        });
      }
    }
    function i(c) {
      var f = new Pd();
      ld(c, function(d, h) {
        switch (d) {
          case "MPEGT":
            f.integer(d + "S", h);
            break;
          case "LOCA":
            f.set(d + "L", q3(h));
            break;
        }
      }, /[^\d]:/, /,/), t.ontimestampmap && t.ontimestampmap({
        MPEGTS: f.get("MPEGTS"),
        LOCAL: f.get("LOCAL")
      });
    }
    function a(c) {
      c.match(/X-TIMESTAMP-MAP/) ? ld(c, function(f, d) {
        switch (f) {
          case "X-TIMESTAMP-MAP":
            i(d);
            break;
        }
      }, /=/) : ld(c, function(f, d) {
        switch (f) {
          case "Region":
            r(d);
            break;
        }
      }, /:/);
    }
    try {
      var o;
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        o = n();
        var s = o.match(/^WEBVTT([ \t].*)?$/);
        if (!s || !s[0])
          throw new Yr(Yr.Errors.BadSignature);
        t.state = "HEADER";
      }
      for (var l = !1; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (l ? l = !1 : o = n(), t.state) {
          case "HEADER":
            /:/.test(o) ? a(o) : o || (t.state = "ID");
            continue;
          case "NOTE":
            o || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(o)) {
              t.state = "NOTE";
              break;
            }
            if (!o)
              continue;
            t.cue = new (t.vttjs.VTTCue || t.window.VTTCue)(0, 0, "");
            try {
              t.cue.align = "center";
            } catch {
              t.cue.align = "middle";
            }
            if (t.state = "CUE", o.indexOf("-->") === -1) {
              t.cue.id = o;
              continue;
            }
          case "CUE":
            try {
              Lre(o, t.cue, t.regionList);
            } catch (c) {
              t.reportOrThrowError(c), t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var u = o.indexOf("-->") !== -1;
            if (!o || u && (l = !0)) {
              t.oncue && t.oncue(t.cue), t.cue = null, t.state = "ID";
              continue;
            }
            t.cue.text && (t.cue.text += `
`), t.cue.text += o.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            o || (t.state = "ID");
            continue;
        }
      }
    } catch (c) {
      t.reportOrThrowError(c), t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var e = this;
    try {
      if (e.buffer += e.decoder.decode(), (e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL")
        throw new Yr(Yr.Errors.BadSignature);
    } catch (t) {
      e.reportOrThrowError(t);
    }
    return e.onflush && e.onflush(), this;
  }
};
var _re = xc, Wre = "auto", Kre = {
  "": 1,
  lr: 1,
  rl: 1
}, Gre = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function Yre(e) {
  if (typeof e != "string")
    return !1;
  var t = Kre[e.toLowerCase()];
  return t ? e.toLowerCase() : !1;
}
function zp(e) {
  if (typeof e != "string")
    return !1;
  var t = Gre[e.toLowerCase()];
  return t ? e.toLowerCase() : !1;
}
function JT(e, t, n) {
  this.hasBeenReset = !1;
  var r = "", i = !1, a = e, o = t, s = n, l = null, u = "", c = !0, f = "auto", d = "start", h = "auto", p = "auto", y = 100, m = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(b) {
        r = "" + b;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(b) {
        i = !!b;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(b) {
        if (typeof b != "number")
          throw new TypeError("Start time must be set to a number.");
        a = b, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(b) {
        if (typeof b != "number")
          throw new TypeError("End time must be set to a number.");
        o = b, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(b) {
        s = "" + b, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(b) {
        l = b, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return u;
      },
      set: function(b) {
        var x = Yre(b);
        if (x === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        u = x, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return c;
      },
      set: function(b) {
        c = !!b, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return f;
      },
      set: function(b) {
        if (typeof b != "number" && b !== Wre)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        f = b, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return d;
      },
      set: function(b) {
        var x = zp(b);
        x ? (d = x, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return h;
      },
      set: function(b) {
        if (b < 0 || b > 100)
          throw new Error("Position must be between 0 and 100.");
        h = b, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return p;
      },
      set: function(b) {
        var x = zp(b);
        x ? (p = x, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return y;
      },
      set: function(b) {
        if (b < 0 || b > 100)
          throw new Error("Size must be between 0 and 100.");
        y = b, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return m;
      },
      set: function(b) {
        var x = zp(b);
        if (!x)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        m = x, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
JT.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var Qre = JT, Zre = {
  "": !0,
  up: !0
};
function Jre(e) {
  if (typeof e != "string")
    return !1;
  var t = Zre[e.toLowerCase()];
  return t ? e.toLowerCase() : !1;
}
function Qc(e) {
  return typeof e == "number" && e >= 0 && e <= 100;
}
function $re() {
  var e = 100, t = 3, n = 0, r = 100, i = 0, a = 100, o = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(s) {
        if (!Qc(s))
          throw new Error("Width must be between 0 and 100.");
        e = s;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(s) {
        if (typeof s != "number")
          throw new TypeError("Lines must be set to a number.");
        t = s;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(s) {
        if (!Qc(s))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        r = s;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(s) {
        if (!Qc(s))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        n = s;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(s) {
        if (!Qc(s))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        a = s;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(s) {
        if (!Qc(s))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        i = s;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(s) {
        var l = Jre(s);
        l === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : o = l;
      }
    }
  });
}
var eae = $re, Wo = pe, Ul = s4.exports = {
  WebVTT: _re,
  VTTCue: Qre,
  VTTRegion: eae
};
Wo.vttjs = Ul;
Wo.WebVTT = Ul.WebVTT;
var tae = Ul.VTTCue, nae = Ul.VTTRegion, iae = Wo.VTTCue, rae = Wo.VTTRegion;
Ul.shim = function() {
  Wo.VTTCue = tae, Wo.VTTRegion = nae;
};
Ul.restore = function() {
  Wo.VTTCue = iae, Wo.VTTRegion = rae;
};
Wo.VTTCue || Ul.shim();
function aae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function p0(e, t, n) {
  return aae() ? p0 = Reflect.construct.bind() : p0 = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(i, s), u = new l();
    return o && Gd(u, o.prototype), u;
  }, p0.apply(null, arguments);
}
function oae(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Gd(e, t);
}
var $T = { exports: {} };
(function(e, t) {
  (function(n) {
    var r = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, a = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, s = {
      buildAbsoluteURL: function(l, u, c) {
        if (c = c || {}, l = l.trim(), u = u.trim(), !u) {
          if (!c.alwaysNormalize)
            return l;
          var f = s.parseURL(l);
          if (!f)
            throw new Error("Error trying to parse base URL.");
          return f.path = s.normalizePath(
            f.path
          ), s.buildURLFromParts(f);
        }
        var d = s.parseURL(u);
        if (!d)
          throw new Error("Error trying to parse relative URL.");
        if (d.scheme)
          return c.alwaysNormalize ? (d.path = s.normalizePath(d.path), s.buildURLFromParts(d)) : u;
        var h = s.parseURL(l);
        if (!h)
          throw new Error("Error trying to parse base URL.");
        if (!h.netLoc && h.path && h.path[0] !== "/") {
          var p = i.exec(h.path);
          h.netLoc = p[1], h.path = p[2];
        }
        h.netLoc && !h.path && (h.path = "/");
        var y = {
          scheme: h.scheme,
          netLoc: d.netLoc,
          path: null,
          params: d.params,
          query: d.query,
          fragment: d.fragment
        };
        if (!d.netLoc && (y.netLoc = h.netLoc, d.path[0] !== "/"))
          if (!d.path)
            y.path = h.path, d.params || (y.params = h.params, d.query || (y.query = h.query));
          else {
            var m = h.path, b = m.substring(0, m.lastIndexOf("/") + 1) + d.path;
            y.path = s.normalizePath(b);
          }
        return y.path === null && (y.path = c.alwaysNormalize ? s.normalizePath(d.path) : d.path), s.buildURLFromParts(y);
      },
      parseURL: function(l) {
        var u = r.exec(l);
        return u ? {
          scheme: u[1] || "",
          netLoc: u[2] || "",
          path: u[3] || "",
          params: u[4] || "",
          query: u[5] || "",
          fragment: u[6] || ""
        } : null;
      },
      normalizePath: function(l) {
        for (l = l.split("").reverse().join("").replace(a, ""); l.length !== (l = l.replace(o, "")).length; )
          ;
        return l.split("").reverse().join("");
      },
      buildURLFromParts: function(l) {
        return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
      }
    };
    e.exports = s;
  })();
})($T);
const $7 = $T.exports;
var em = "http://example.com", Zh = function(t, n) {
  if (/^[a-z]+:/i.test(n))
    return n;
  /^data:/.test(t) && (t = pe.location && pe.location.href || "");
  var r = typeof pe.URL == "function", i = /^\/\//.test(t), a = !pe.location && !/\/\//i.test(t);
  if (r ? t = new pe.URL(t, pe.location || em) : /\/\//i.test(t) || (t = $7.buildAbsoluteURL(pe.location && pe.location.href || "", t)), r) {
    var o = new URL(n, t);
    return a ? o.href.slice(em.length) : i ? o.href.slice(o.protocol.length) : o.href;
  }
  return $7.buildAbsoluteURL(t, n);
}, _3 = /* @__PURE__ */ function() {
  function e() {
    this.listeners = {};
  }
  var t = e.prototype;
  return t.on = function(r, i) {
    this.listeners[r] || (this.listeners[r] = []), this.listeners[r].push(i);
  }, t.off = function(r, i) {
    if (!this.listeners[r])
      return !1;
    var a = this.listeners[r].indexOf(i);
    return this.listeners[r] = this.listeners[r].slice(0), this.listeners[r].splice(a, 1), a > -1;
  }, t.trigger = function(r) {
    var i = this.listeners[r];
    if (!!i)
      if (arguments.length === 2)
        for (var a = i.length, o = 0; o < a; ++o)
          i[o].call(this, arguments[1]);
      else
        for (var s = Array.prototype.slice.call(arguments, 1), l = i.length, u = 0; u < l; ++u)
          i[u].apply(this, s);
  }, t.dispose = function() {
    this.listeners = {};
  }, t.pipe = function(r) {
    this.on("data", function(i) {
      r.push(i);
    });
  }, e;
}(), sae = function(t) {
  return pe.atob ? pe.atob(t) : Buffer.from(t, "base64").toString("binary");
};
function ew(e) {
  for (var t = sae(e), n = new Uint8Array(t.length), r = 0; r < t.length; r++)
    n[r] = t.charCodeAt(r);
  return n;
}
/*! @name m3u8-parser @version 4.7.1 @license Apache-2.0 */
var lae = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    var r;
    return r = e.call(this) || this, r.buffer = "", r;
  }
  var n = t.prototype;
  return n.push = function(i) {
    var a;
    for (this.buffer += i, a = this.buffer.indexOf(`
`); a > -1; a = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, a)), this.buffer = this.buffer.substring(a + 1);
  }, t;
}(_3), uae = String.fromCharCode(9), Dp = function(t) {
  var n = /([0-9.]*)?@?([0-9.]*)?/.exec(t || ""), r = {};
  return n[1] && (r.length = parseInt(n[1], 10)), n[2] && (r.offset = parseInt(n[2], 10)), r;
}, cae = function() {
  var t = "[^=]*", n = '"[^"]*"|[^,]*', r = "(?:" + t + ")=(?:" + n + ")";
  return new RegExp("(?:^|,)(" + r + ")");
}, Ha = function(t) {
  for (var n = t.split(cae()), r = {}, i = n.length, a; i--; )
    n[i] !== "" && (a = /([^=]*)=(.*)/.exec(n[i]).slice(1), a[0] = a[0].replace(/^\s+|\s+$/g, ""), a[1] = a[1].replace(/^\s+|\s+$/g, ""), a[1] = a[1].replace(/^['"](.*)['"]$/g, "$1"), r[a[0]] = a[1]);
  return r;
}, dae = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    var r;
    return r = e.call(this) || this, r.customParsers = [], r.tagMappers = [], r;
  }
  var n = t.prototype;
  return n.push = function(i) {
    var a = this, o, s;
    if (i = i.trim(), i.length !== 0) {
      if (i[0] !== "#") {
        this.trigger("data", {
          type: "uri",
          uri: i
        });
        return;
      }
      var l = this.tagMappers.reduce(function(u, c) {
        var f = c(i);
        return f === i ? u : u.concat([f]);
      }, [i]);
      l.forEach(function(u) {
        for (var c = 0; c < a.customParsers.length; c++)
          if (a.customParsers[c].call(a, u))
            return;
        if (u.indexOf("#EXT") !== 0) {
          a.trigger("data", {
            type: "comment",
            text: u.slice(1)
          });
          return;
        }
        if (u = u.replace("\r", ""), o = /^#EXTM3U/.exec(u), o) {
          a.trigger("data", {
            type: "tag",
            tagType: "m3u"
          });
          return;
        }
        if (o = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "inf"
          }, o[1] && (s.duration = parseFloat(o[1])), o[2] && (s.title = o[2]), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "targetduration"
          }, o[1] && (s.duration = parseInt(o[1], 10)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "version"
          }, o[1] && (s.version = parseInt(o[1], 10)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "media-sequence"
          }, o[1] && (s.number = parseInt(o[1], 10)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "discontinuity-sequence"
          }, o[1] && (s.number = parseInt(o[1], 10)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "playlist-type"
          }, o[1] && (s.playlistType = o[1]), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(u), o) {
          s = Ta(Dp(o[1]), {
            type: "tag",
            tagType: "byterange"
          }), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "allow-cache"
          }, o[1] && (s.allowed = !/NO/.test(o[1])), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-MAP:?(.*)$/.exec(u), o) {
          if (s = {
            type: "tag",
            tagType: "map"
          }, o[1]) {
            var f = Ha(o[1]);
            f.URI && (s.uri = f.URI), f.BYTERANGE && (s.byterange = Dp(f.BYTERANGE));
          }
          a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-STREAM-INF:?(.*)$/.exec(u), o) {
          if (s = {
            type: "tag",
            tagType: "stream-inf"
          }, o[1]) {
            if (s.attributes = Ha(o[1]), s.attributes.RESOLUTION) {
              var d = s.attributes.RESOLUTION.split("x"), h = {};
              d[0] && (h.width = parseInt(d[0], 10)), d[1] && (h.height = parseInt(d[1], 10)), s.attributes.RESOLUTION = h;
            }
            s.attributes.BANDWIDTH && (s.attributes.BANDWIDTH = parseInt(s.attributes.BANDWIDTH, 10)), s.attributes["PROGRAM-ID"] && (s.attributes["PROGRAM-ID"] = parseInt(s.attributes["PROGRAM-ID"], 10));
          }
          a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-MEDIA:?(.*)$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "media"
          }, o[1] && (s.attributes = Ha(o[1])), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-ENDLIST/.exec(u), o) {
          a.trigger("data", {
            type: "tag",
            tagType: "endlist"
          });
          return;
        }
        if (o = /^#EXT-X-DISCONTINUITY/.exec(u), o) {
          a.trigger("data", {
            type: "tag",
            tagType: "discontinuity"
          });
          return;
        }
        if (o = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "program-date-time"
          }, o[1] && (s.dateTimeString = o[1], s.dateTimeObject = new Date(o[1])), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-KEY:?(.*)$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "key"
          }, o[1] && (s.attributes = Ha(o[1]), s.attributes.IV && (s.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (s.attributes.IV = s.attributes.IV.substring(2)), s.attributes.IV = s.attributes.IV.match(/.{8}/g), s.attributes.IV[0] = parseInt(s.attributes.IV[0], 16), s.attributes.IV[1] = parseInt(s.attributes.IV[1], 16), s.attributes.IV[2] = parseInt(s.attributes.IV[2], 16), s.attributes.IV[3] = parseInt(s.attributes.IV[3], 16), s.attributes.IV = new Uint32Array(s.attributes.IV))), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-START:?(.*)$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "start"
          }, o[1] && (s.attributes = Ha(o[1]), s.attributes["TIME-OFFSET"] = parseFloat(s.attributes["TIME-OFFSET"]), s.attributes.PRECISE = /YES/.test(s.attributes.PRECISE)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "cue-out-cont"
          }, o[1] ? s.data = o[1] : s.data = "", a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "cue-out"
          }, o[1] ? s.data = o[1] : s.data = "", a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-CUE-IN:?(.*)?$/.exec(u), o) {
          s = {
            type: "tag",
            tagType: "cue-in"
          }, o[1] ? s.data = o[1] : s.data = "", a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-SKIP:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "skip"
          }, s.attributes = Ha(o[1]), s.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (s.attributes["SKIPPED-SEGMENTS"] = parseInt(s.attributes["SKIPPED-SEGMENTS"], 10)), s.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (s.attributes["RECENTLY-REMOVED-DATERANGES"] = s.attributes["RECENTLY-REMOVED-DATERANGES"].split(uae)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-PART:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "part"
          }, s.attributes = Ha(o[1]), ["DURATION"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = parseFloat(s.attributes[p]));
          }), ["INDEPENDENT", "GAP"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = /YES/.test(s.attributes[p]));
          }), s.attributes.hasOwnProperty("BYTERANGE") && (s.attributes.byterange = Dp(s.attributes.BYTERANGE)), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "server-control"
          }, s.attributes = Ha(o[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = parseFloat(s.attributes[p]));
          }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = /YES/.test(s.attributes[p]));
          }), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-PART-INF:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "part-inf"
          }, s.attributes = Ha(o[1]), ["PART-TARGET"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = parseFloat(s.attributes[p]));
          }), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "preload-hint"
          }, s.attributes = Ha(o[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(p) {
            if (s.attributes.hasOwnProperty(p)) {
              s.attributes[p] = parseInt(s.attributes[p], 10);
              var y = p === "BYTERANGE-LENGTH" ? "length" : "offset";
              s.attributes.byterange = s.attributes.byterange || {}, s.attributes.byterange[y] = s.attributes[p], delete s.attributes[p];
            }
          }), a.trigger("data", s);
          return;
        }
        if (o = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(u), o && o[1]) {
          s = {
            type: "tag",
            tagType: "rendition-report"
          }, s.attributes = Ha(o[1]), ["LAST-MSN", "LAST-PART"].forEach(function(p) {
            s.attributes.hasOwnProperty(p) && (s.attributes[p] = parseInt(s.attributes[p], 10));
          }), a.trigger("data", s);
          return;
        }
        a.trigger("data", {
          type: "tag",
          data: u.slice(4)
        });
      });
    }
  }, n.addParser = function(i) {
    var a = this, o = i.expression, s = i.customType, l = i.dataParser, u = i.segment;
    typeof l != "function" && (l = function(f) {
      return f;
    }), this.customParsers.push(function(c) {
      var f = o.exec(c);
      if (f)
        return a.trigger("data", {
          type: "custom",
          data: l(c),
          customType: s,
          segment: u
        }), !0;
    });
  }, n.addTagMapper = function(i) {
    var a = i.expression, o = i.map, s = function(u) {
      return a.test(u) ? o(u) : u;
    };
    this.tagMappers.push(s);
  }, t;
}(_3), fae = function(t) {
  return t.toLowerCase().replace(/-(\w)/g, function(n) {
    return n[1].toUpperCase();
  });
}, fu = function(t) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    n[fae(r)] = t[r];
  }), n;
}, Mp = function(t) {
  var n = t.serverControl, r = t.targetDuration, i = t.partTargetDuration;
  if (!!n) {
    var a = "#EXT-X-SERVER-CONTROL", o = "holdBack", s = "partHoldBack", l = r && r * 3, u = i && i * 2;
    r && !n.hasOwnProperty(o) && (n[o] = l, this.trigger("info", {
      message: a + " defaulting HOLD-BACK to targetDuration * 3 (" + l + ")."
    })), l && n[o] < l && (this.trigger("warn", {
      message: a + " clamping HOLD-BACK (" + n[o] + ") to targetDuration * 3 (" + l + ")"
    }), n[o] = l), i && !n.hasOwnProperty(s) && (n[s] = i * 3, this.trigger("info", {
      message: a + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + n[s] + ")."
    })), i && n[s] < u && (this.trigger("warn", {
      message: a + " clamping PART-HOLD-BACK (" + n[s] + ") to partTargetDuration * 2 (" + u + ")."
    }), n[s] = u);
  }
}, hae = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    var r;
    r = e.call(this) || this, r.lineStream = new lae(), r.parseStream = new dae(), r.lineStream.pipe(r.parseStream);
    var i = on(r), a = [], o = {}, s, l, u = !1, c = function() {
    }, f = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, d = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", h = 0;
    r.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      segments: []
    };
    var p = 0, y = 0;
    return r.on("end", function() {
      o.uri || !o.parts && !o.preloadHints || (!o.map && s && (o.map = s), !o.key && l && (o.key = l), !o.timeline && typeof h == "number" && (o.timeline = h), r.manifest.preloadSegment = o);
    }), r.parseStream.on("data", function(m) {
      var b, x;
      ({
        tag: function() {
          ({
            version: function() {
              m.version && (this.manifest.version = m.version);
            },
            "allow-cache": function() {
              this.manifest.allowCache = m.allowed, "allowed" in m || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange: function() {
              var C = {};
              "length" in m && (o.byterange = C, C.length = m.length, "offset" in m || (m.offset = p)), "offset" in m && (o.byterange = C, C.offset = m.offset), p = C.offset + C.length;
            },
            endlist: function() {
              this.manifest.endList = !0;
            },
            inf: function() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), m.duration > 0 && (o.duration = m.duration), m.duration === 0 && (o.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = a;
            },
            key: function() {
              if (!m.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (m.attributes.METHOD === "NONE") {
                l = null;
                return;
              }
              if (!m.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (m.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: m.attributes
                };
                return;
              }
              if (m.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: m.attributes.URI
                };
                return;
              }
              if (m.attributes.KEYFORMAT === d) {
                var C = ["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"];
                if (C.indexOf(m.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (m.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), m.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(m.attributes.KEYID && m.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: m.attributes.KEYFORMAT,
                    keyId: m.attributes.KEYID.substring(2)
                  },
                  pssh: ew(m.attributes.URI.split(",")[1])
                };
                return;
              }
              m.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), l = {
                method: m.attributes.METHOD || "AES-128",
                uri: m.attributes.URI
              }, typeof m.attributes.IV < "u" && (l.iv = m.attributes.IV);
            },
            "media-sequence": function() {
              if (!isFinite(m.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + m.number
                });
                return;
              }
              this.manifest.mediaSequence = m.number;
            },
            "discontinuity-sequence": function() {
              if (!isFinite(m.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + m.number
                });
                return;
              }
              this.manifest.discontinuitySequence = m.number, h = m.number;
            },
            "playlist-type": function() {
              if (!/VOD|EVENT/.test(m.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + m.playlist
                });
                return;
              }
              this.manifest.playlistType = m.playlistType;
            },
            map: function() {
              s = {}, m.uri && (s.uri = m.uri), m.byterange && (s.byterange = m.byterange), l && (s.key = l);
            },
            "stream-inf": function() {
              if (this.manifest.playlists = a, this.manifest.mediaGroups = this.manifest.mediaGroups || f, !m.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              o.attributes || (o.attributes = {}), Ta(o.attributes, m.attributes);
            },
            media: function() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || f, !(m.attributes && m.attributes.TYPE && m.attributes["GROUP-ID"] && m.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              var C = this.manifest.mediaGroups[m.attributes.TYPE];
              C[m.attributes["GROUP-ID"]] = C[m.attributes["GROUP-ID"]] || {}, b = C[m.attributes["GROUP-ID"]], x = {
                default: /yes/i.test(m.attributes.DEFAULT)
              }, x.default ? x.autoselect = !0 : x.autoselect = /yes/i.test(m.attributes.AUTOSELECT), m.attributes.LANGUAGE && (x.language = m.attributes.LANGUAGE), m.attributes.URI && (x.uri = m.attributes.URI), m.attributes["INSTREAM-ID"] && (x.instreamId = m.attributes["INSTREAM-ID"]), m.attributes.CHARACTERISTICS && (x.characteristics = m.attributes.CHARACTERISTICS), m.attributes.FORCED && (x.forced = /yes/i.test(m.attributes.FORCED)), b[m.attributes.NAME] = x;
            },
            discontinuity: function() {
              h += 1, o.discontinuity = !0, this.manifest.discontinuityStarts.push(a.length);
            },
            "program-date-time": function() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = m.dateTimeString, this.manifest.dateTimeObject = m.dateTimeObject), o.dateTimeString = m.dateTimeString, o.dateTimeObject = m.dateTimeObject;
            },
            targetduration: function() {
              if (!isFinite(m.duration) || m.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + m.duration
                });
                return;
              }
              this.manifest.targetDuration = m.duration, Mp.call(this, this.manifest);
            },
            start: function() {
              if (!m.attributes || isNaN(m.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: m.attributes["TIME-OFFSET"],
                precise: m.attributes.PRECISE
              };
            },
            "cue-out": function() {
              o.cueOut = m.data;
            },
            "cue-out-cont": function() {
              o.cueOutCont = m.data;
            },
            "cue-in": function() {
              o.cueIn = m.data;
            },
            skip: function() {
              this.manifest.skip = fu(m.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", m.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part: function() {
              var C = this;
              u = !0;
              var v = this.manifest.segments.length, H = fu(m.attributes);
              o.parts = o.parts || [], o.parts.push(H), H.byterange && (H.byterange.hasOwnProperty("offset") || (H.byterange.offset = y), y = H.byterange.offset + H.byterange.length);
              var V = o.parts.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PART #" + V + " for segment #" + v, m.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach(function(R, F) {
                R.hasOwnProperty("lastPart") || C.trigger("warn", {
                  message: "#EXT-X-RENDITION-REPORT #" + F + " lacks required attribute(s): LAST-PART"
                });
              });
            },
            "server-control": function() {
              var C = this.manifest.serverControl = fu(m.attributes);
              C.hasOwnProperty("canBlockReload") || (C.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), Mp.call(this, this.manifest), C.canSkipDateranges && !C.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint": function() {
              var C = this.manifest.segments.length, v = fu(m.attributes), H = v.type && v.type === "PART";
              o.preloadHints = o.preloadHints || [], o.preloadHints.push(v), v.byterange && (v.byterange.hasOwnProperty("offset") || (v.byterange.offset = H ? y : 0, H && (y = v.byterange.offset + v.byterange.length)));
              var V = o.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + V + " for segment #" + C, m.attributes, ["TYPE", "URI"]), !!v.type)
                for (var R = 0; R < o.preloadHints.length - 1; R++) {
                  var F = o.preloadHints[R];
                  !F.type || F.type === v.type && this.trigger("warn", {
                    message: "#EXT-X-PRELOAD-HINT #" + V + " for segment #" + C + " has the same TYPE " + v.type + " as preload hint #" + R
                  });
                }
            },
            "rendition-report": function() {
              var C = fu(m.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(C);
              var v = this.manifest.renditionReports.length - 1, H = ["LAST-MSN", "URI"];
              u && H.push("LAST-PART"), this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + v, m.attributes, H);
            },
            "part-inf": function() {
              this.manifest.partInf = fu(m.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", m.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), Mp.call(this, this.manifest);
            }
          }[m.tagType] || c).call(i);
        },
        uri: function() {
          o.uri = m.uri, a.push(o), this.manifest.targetDuration && !("duration" in o) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), o.duration = this.manifest.targetDuration), l && (o.key = l), o.timeline = h, s && (o.map = s), y = 0, o = {};
        },
        comment: function() {
        },
        custom: function() {
          m.segment ? (o.custom = o.custom || {}, o.custom[m.customType] = m.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[m.customType] = m.data);
        }
      })[m.type].call(i);
    }), r;
  }
  var n = t.prototype;
  return n.warnOnMissingAttributes_ = function(i, a, o) {
    var s = [];
    o.forEach(function(l) {
      a.hasOwnProperty(l) || s.push(l);
    }), s.length && this.trigger("warn", {
      message: i + " lacks required attribute(s): " + s.join(", ")
    });
  }, n.push = function(i) {
    this.lineStream.push(i);
  }, n.end = function() {
    this.lineStream.push(`
`), this.trigger("end");
  }, n.addParser = function(i) {
    this.parseStream.addParser(i);
  }, n.addTagMapper = function(i) {
    this.parseStream.addTagMapper(i);
  }, t;
}(_3), Cl = {
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  muxerText: /a^/
}, pae = ["video", "audio", "text"], tm = ["Video", "Audio", "Text"], tw = function(t) {
  return t && t.replace(/avc1\.(\d+)\.(\d+)/i, function(n, r, i) {
    var a = ("00" + Number(r).toString(16)).slice(-2), o = ("00" + Number(i).toString(16)).slice(-2);
    return "avc1." + a + "00" + o;
  });
}, eo = function(t) {
  t === void 0 && (t = "");
  var n = t.split(","), r = [];
  return n.forEach(function(i) {
    i = i.trim();
    var a;
    pae.forEach(function(o) {
      var s = Cl[o].exec(i.toLowerCase());
      if (!(!s || s.length <= 1)) {
        a = o;
        var l = i.substring(0, s[1].length), u = i.replace(l, "");
        r.push({
          type: l,
          details: u,
          mediaType: o
        });
      }
    }), a || r.push({
      type: i,
      details: "",
      mediaType: "unknown"
    });
  }), r;
}, vae = function(t, n) {
  if (!t.mediaGroups.AUDIO || !n)
    return null;
  var r = t.mediaGroups.AUDIO[n];
  if (!r)
    return null;
  for (var i in r) {
    var a = r[i];
    if (a.default && a.playlists)
      return eo(a.playlists[0].attributes.CODECS);
  }
  return null;
}, nw = function(t) {
  return t === void 0 && (t = ""), Cl.audio.test(t.trim().toLowerCase());
}, mae = function(t) {
  return t === void 0 && (t = ""), Cl.text.test(t.trim().toLowerCase());
}, Yd = function(t) {
  if (!(!t || typeof t != "string")) {
    var n = t.toLowerCase().split(",").map(function(a) {
      return tw(a.trim());
    }), r = "video";
    n.length === 1 && nw(n[0]) ? r = "audio" : n.length === 1 && mae(n[0]) && (r = "application");
    var i = "mp4";
    return n.every(function(a) {
      return Cl.mp4.test(a);
    }) ? i = "mp4" : n.every(function(a) {
      return Cl.webm.test(a);
    }) ? i = "webm" : n.every(function(a) {
      return Cl.ogg.test(a);
    }) && (i = "ogg"), r + "/" + i + ';codecs="' + t + '"';
  }
}, v0 = function(t) {
  return t === void 0 && (t = ""), pe.MediaSource && pe.MediaSource.isTypeSupported && pe.MediaSource.isTypeSupported(Yd(t)) || !1;
}, Hp = function(t) {
  return t === void 0 && (t = ""), t.toLowerCase().split(",").every(function(n) {
    n = n.trim();
    for (var r = 0; r < tm.length; r++) {
      var i = tm[r];
      if (Cl["muxer" + i].test(n))
        return !0;
    }
    return !1;
  });
}, nm = "mp4a.40.2", gae = "avc1.4d400d", yae = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, bae = /^application\/dash\+xml/i, iw = function(t) {
  return yae.test(t) ? "hls" : bae.test(t) ? "dash" : t === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, Aae = function(t) {
  return t.toString(2).length;
}, Tae = function(t) {
  return Math.ceil(Aae(t) / 8);
}, rw = function(t) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(t) : t && t.buffer instanceof ArrayBuffer;
}, wae = function(t) {
  return rw(t);
}, Kt = function(t) {
  return t instanceof Uint8Array ? t : (!Array.isArray(t) && !wae(t) && !(t instanceof ArrayBuffer) && (typeof t != "number" || typeof t == "number" && t !== t ? t = 0 : t = [t]), new Uint8Array(t && t.buffer || t, t && t.byteOffset || 0, t && t.byteLength || 0));
}, Ri = pe.BigInt || Number, l4 = [Ri("0x1"), Ri("0x100"), Ri("0x10000"), Ri("0x1000000"), Ri("0x100000000"), Ri("0x10000000000"), Ri("0x1000000000000"), Ri("0x100000000000000"), Ri("0x10000000000000000")];
(function() {
  var e = new Uint16Array([65484]), t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  return t[0] === 255 ? "big" : t[0] === 204 ? "little" : "unknown";
})();
var Pae = function(t, n) {
  var r = n === void 0 ? {} : n, i = r.signed, a = i === void 0 ? !1 : i, o = r.le, s = o === void 0 ? !1 : o;
  t = Kt(t);
  var l = s ? "reduce" : "reduceRight", u = t[l] ? t[l] : Array.prototype[l], c = u.call(t, function(d, h, p) {
    var y = s ? p : Math.abs(p + 1 - t.length);
    return d + Ri(h) * l4[y];
  }, Ri(0));
  if (a) {
    var f = l4[t.length] / Ri(2) - Ri(1);
    c = Ri(c), c > f && (c -= f, c -= f, c -= Ri(2));
  }
  return Number(c);
}, xae = function(t, n) {
  var r = n === void 0 ? {} : n, i = r.le, a = i === void 0 ? !1 : i;
  (typeof t != "bigint" && typeof t != "number" || typeof t == "number" && t !== t) && (t = 0), t = Ri(t);
  for (var o = Tae(t), s = new Uint8Array(new ArrayBuffer(o)), l = 0; l < o; l++) {
    var u = a ? l : Math.abs(l + 1 - s.length);
    s[u] = Number(t / l4[l] & Ri(255)), t < 0 && (s[u] = Math.abs(~s[u]), s[u] -= l === 0 ? 1 : 2);
  }
  return s;
}, aw = function(t, n) {
  if (typeof t != "string" && t && typeof t.toString == "function" && (t = t.toString()), typeof t != "string")
    return new Uint8Array();
  n || (t = unescape(encodeURIComponent(t)));
  for (var r = new Uint8Array(t.length), i = 0; i < t.length; i++)
    r[i] = t.charCodeAt(i);
  return r;
}, Cae = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  if (n = n.filter(function(s) {
    return s && (s.byteLength || s.length) && typeof s != "string";
  }), n.length <= 1)
    return Kt(n[0]);
  var i = n.reduce(function(s, l, u) {
    return s + (l.byteLength || l.length);
  }, 0), a = new Uint8Array(i), o = 0;
  return n.forEach(function(s) {
    s = Kt(s), a.set(s, o), o += s.byteLength;
  }), a;
}, oi = function(t, n, r) {
  var i = r === void 0 ? {} : r, a = i.offset, o = a === void 0 ? 0 : a, s = i.mask, l = s === void 0 ? [] : s;
  t = Kt(t), n = Kt(n);
  var u = n.every ? n.every : Array.prototype.every;
  return n.length && t.length - o >= n.length && u.call(n, function(c, f) {
    var d = l[f] ? l[f] & t[o + f] : t[o + f];
    return c === d;
  });
}, Sae = function(t, n, r) {
  n.forEach(function(i) {
    for (var a in t.mediaGroups[i])
      for (var o in t.mediaGroups[i][a]) {
        var s = t.mediaGroups[i][a][o];
        r(s, i, a, o);
      }
  });
}, Us = {}, ql = {};
function W3(e, t) {
  return t === void 0 && (t = Object), t && typeof t.freeze == "function" ? t.freeze(e) : e;
}
var ow = W3({
  HTML: "text/html",
  isHTML: function(e) {
    return e === ow.HTML;
  },
  XML_APPLICATION: "application/xml",
  XML_TEXT: "text/xml",
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  XML_SVG_IMAGE: "image/svg+xml"
}), sw = W3({
  HTML: "http://www.w3.org/1999/xhtml",
  isHTML: function(e) {
    return e === sw.HTML;
  },
  SVG: "http://www.w3.org/2000/svg",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
ql.freeze = W3;
ql.MIME_TYPE = ow;
ql.NAMESPACE = sw;
var Eae = ql, Qd = Eae.NAMESPACE;
function kae(e) {
  return e !== "";
}
function Oae(e) {
  return e ? e.split(/[\t\n\f\r ]+/).filter(kae) : [];
}
function zae(e, t) {
  return e.hasOwnProperty(t) || (e[t] = !0), e;
}
function im(e) {
  if (!e)
    return [];
  var t = Oae(e);
  return Object.keys(t.reduce(zae, {}));
}
function Dae(e) {
  return function(t) {
    return e && e.indexOf(t) !== -1;
  };
}
function Tf(e, t) {
  for (var n in e)
    t[n] = e[n];
}
function Br(e, t) {
  var n = e.prototype;
  if (!(n instanceof t)) {
    let r = function() {
    };
    r.prototype = t.prototype, r = new r(), Tf(n, r), e.prototype = n = r;
  }
  n.constructor != e && (typeof e != "function" && console.error("unknown Class:" + e), n.constructor = e);
}
var Nr = {}, Ra = Nr.ELEMENT_NODE = 1, Qu = Nr.ATTRIBUTE_NODE = 2, G0 = Nr.TEXT_NODE = 3, lw = Nr.CDATA_SECTION_NODE = 4, uw = Nr.ENTITY_REFERENCE_NODE = 5, Mae = Nr.ENTITY_NODE = 6, cw = Nr.PROCESSING_INSTRUCTION_NODE = 7, dw = Nr.COMMENT_NODE = 8, fw = Nr.DOCUMENT_NODE = 9, hw = Nr.DOCUMENT_TYPE_NODE = 10, Ko = Nr.DOCUMENT_FRAGMENT_NODE = 11, Hae = Nr.NOTATION_NODE = 12, ar = {}, Ni = {};
ar.INDEX_SIZE_ERR = (Ni[1] = "Index size error", 1);
ar.DOMSTRING_SIZE_ERR = (Ni[2] = "DOMString size error", 2);
var Iae = ar.HIERARCHY_REQUEST_ERR = (Ni[3] = "Hierarchy request error", 3);
ar.WRONG_DOCUMENT_ERR = (Ni[4] = "Wrong document", 4);
ar.INVALID_CHARACTER_ERR = (Ni[5] = "Invalid character", 5);
ar.NO_DATA_ALLOWED_ERR = (Ni[6] = "No data allowed", 6);
ar.NO_MODIFICATION_ALLOWED_ERR = (Ni[7] = "No modification allowed", 7);
var Lae = ar.NOT_FOUND_ERR = (Ni[8] = "Not found", 8);
ar.NOT_SUPPORTED_ERR = (Ni[9] = "Not supported", 9);
var rm = ar.INUSE_ATTRIBUTE_ERR = (Ni[10] = "Attribute in use", 10);
ar.INVALID_STATE_ERR = (Ni[11] = "Invalid state", 11);
ar.SYNTAX_ERR = (Ni[12] = "Syntax error", 12);
ar.INVALID_MODIFICATION_ERR = (Ni[13] = "Invalid modification", 13);
ar.NAMESPACE_ERR = (Ni[14] = "Invalid namespace", 14);
ar.INVALID_ACCESS_ERR = (Ni[15] = "Invalid access", 15);
function Il(e, t) {
  if (t instanceof Error)
    var n = t;
  else
    n = this, Error.call(this, Ni[e]), this.message = Ni[e], Error.captureStackTrace && Error.captureStackTrace(this, Il);
  return n.code = e, t && (this.message = this.message + ": " + t), n;
}
Il.prototype = Error.prototype;
Tf(ar, Il);
function Fo() {
}
Fo.prototype = {
  length: 0,
  item: function(e) {
    return this[e] || null;
  },
  toString: function(e, t) {
    for (var n = [], r = 0; r < this.length; r++)
      xu(this[r], n, e, t);
    return n.join("");
  }
};
function Zu(e, t) {
  this._node = e, this._refresh = t, K3(this);
}
function K3(e) {
  var t = e._node._inc || e._node.ownerDocument._inc;
  if (e._inc != t) {
    var n = e._refresh(e._node);
    Cw(e, "length", n.length), Tf(n, e), e._inc = t;
  }
}
Zu.prototype.item = function(e) {
  return K3(this), this[e];
};
Br(Zu, Fo);
function Y0() {
}
function pw(e, t) {
  for (var n = e.length; n--; )
    if (e[n] === t)
      return n;
}
function am(e, t, n, r) {
  if (r ? t[pw(t, r)] = n : t[t.length++] = n, e) {
    n.ownerElement = e;
    var i = e.ownerDocument;
    i && (r && gw(i, e, r), Bae(i, e, n));
  }
}
function om(e, t, n) {
  var r = pw(t, n);
  if (r >= 0) {
    for (var i = t.length - 1; r < i; )
      t[r] = t[++r];
    if (t.length = i, e) {
      var a = e.ownerDocument;
      a && (gw(a, e, n), n.ownerElement = null);
    }
  } else
    throw Il(Lae, new Error(e.tagName + "@" + n));
}
Y0.prototype = {
  length: 0,
  item: Fo.prototype.item,
  getNamedItem: function(e) {
    for (var t = this.length; t--; ) {
      var n = this[t];
      if (n.nodeName == e)
        return n;
    }
  },
  setNamedItem: function(e) {
    var t = e.ownerElement;
    if (t && t != this._ownerElement)
      throw new Il(rm);
    var n = this.getNamedItem(e.nodeName);
    return am(this._ownerElement, this, e, n), n;
  },
  setNamedItemNS: function(e) {
    var t = e.ownerElement, n;
    if (t && t != this._ownerElement)
      throw new Il(rm);
    return n = this.getNamedItemNS(e.namespaceURI, e.localName), am(this._ownerElement, this, e, n), n;
  },
  removeNamedItem: function(e) {
    var t = this.getNamedItem(e);
    return om(this._ownerElement, this, t), t;
  },
  removeNamedItemNS: function(e, t) {
    var n = this.getNamedItemNS(e, t);
    return om(this._ownerElement, this, n), n;
  },
  getNamedItemNS: function(e, t) {
    for (var n = this.length; n--; ) {
      var r = this[n];
      if (r.localName == t && r.namespaceURI == e)
        return r;
    }
    return null;
  }
};
function vw() {
}
vw.prototype = {
  hasFeature: function(e, t) {
    return !0;
  },
  createDocument: function(e, t, n) {
    var r = new wf();
    if (r.implementation = this, r.childNodes = new Fo(), r.doctype = n || null, n && r.appendChild(n), t) {
      var i = r.createElementNS(e, t);
      r.appendChild(i);
    }
    return r;
  },
  createDocumentType: function(e, t, n) {
    var r = new Jh();
    return r.name = e, r.nodeName = e, r.publicId = t || "", r.systemId = n || "", r;
  }
};
function or() {
}
or.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  insertBefore: function(e, t) {
    return bw(this, e, t);
  },
  replaceChild: function(e, t) {
    this.insertBefore(e, t), t && this.removeChild(t);
  },
  removeChild: function(e) {
    return yw(this, e);
  },
  appendChild: function(e) {
    return this.insertBefore(e, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(e) {
    return u4(this.ownerDocument || this, this, e);
  },
  normalize: function() {
    for (var e = this.firstChild; e; ) {
      var t = e.nextSibling;
      t && t.nodeType == G0 && e.nodeType == G0 ? (this.removeChild(t), e.appendData(t.data)) : (e.normalize(), e = t);
    }
  },
  isSupported: function(e, t) {
    return this.ownerDocument.implementation.hasFeature(e, t);
  },
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  lookupPrefix: function(e) {
    for (var t = this; t; ) {
      var n = t._nsMap;
      if (n) {
        for (var r in n)
          if (n[r] == e)
            return r;
      }
      t = t.nodeType == Qu ? t.ownerDocument : t.parentNode;
    }
    return null;
  },
  lookupNamespaceURI: function(e) {
    for (var t = this; t; ) {
      var n = t._nsMap;
      if (n && e in n)
        return n[e];
      t = t.nodeType == Qu ? t.ownerDocument : t.parentNode;
    }
    return null;
  },
  isDefaultNamespace: function(e) {
    var t = this.lookupPrefix(e);
    return t == null;
  }
};
function mw(e) {
  return e == "<" && "&lt;" || e == ">" && "&gt;" || e == "&" && "&amp;" || e == '"' && "&quot;" || "&#" + e.charCodeAt() + ";";
}
Tf(Nr, or);
Tf(Nr, or.prototype);
function Zd(e, t) {
  if (t(e))
    return !0;
  if (e = e.firstChild)
    do
      if (Zd(e, t))
        return !0;
    while (e = e.nextSibling);
}
function wf() {
}
function Bae(e, t, n) {
  e && e._inc++;
  var r = n.namespaceURI;
  r === Qd.XMLNS && (t._nsMap[n.prefix ? n.localName : ""] = n.value);
}
function gw(e, t, n, r) {
  e && e._inc++;
  var i = n.namespaceURI;
  i === Qd.XMLNS && delete t._nsMap[n.prefix ? n.localName : ""];
}
function G3(e, t, n) {
  if (e && e._inc) {
    e._inc++;
    var r = t.childNodes;
    if (n)
      r[r.length++] = n;
    else {
      for (var i = t.firstChild, a = 0; i; )
        r[a++] = i, i = i.nextSibling;
      r.length = a;
    }
  }
}
function yw(e, t) {
  var n = t.previousSibling, r = t.nextSibling;
  return n ? n.nextSibling = r : e.firstChild = r, r ? r.previousSibling = n : e.lastChild = n, G3(e.ownerDocument, e), t;
}
function bw(e, t, n) {
  var r = t.parentNode;
  if (r && r.removeChild(t), t.nodeType === Ko) {
    var i = t.firstChild;
    if (i == null)
      return t;
    var a = t.lastChild;
  } else
    i = a = t;
  var o = n ? n.previousSibling : e.lastChild;
  i.previousSibling = o, a.nextSibling = n, o ? o.nextSibling = i : e.firstChild = i, n == null ? e.lastChild = a : n.previousSibling = a;
  do
    i.parentNode = e;
  while (i !== a && (i = i.nextSibling));
  return G3(e.ownerDocument || e, e), t.nodeType == Ko && (t.firstChild = t.lastChild = null), t;
}
function Nae(e, t) {
  var n = t.parentNode;
  if (n) {
    var r = e.lastChild;
    n.removeChild(t);
    var r = e.lastChild;
  }
  var r = e.lastChild;
  return t.parentNode = e, t.previousSibling = r, t.nextSibling = null, r ? r.nextSibling = t : e.firstChild = t, e.lastChild = t, G3(e.ownerDocument, e, t), t;
}
wf.prototype = {
  nodeName: "#document",
  nodeType: fw,
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(e, t) {
    if (e.nodeType == Ko) {
      for (var n = e.firstChild; n; ) {
        var r = n.nextSibling;
        this.insertBefore(n, t), n = r;
      }
      return e;
    }
    return this.documentElement == null && e.nodeType == Ra && (this.documentElement = e), bw(this, e, t), e.ownerDocument = this, e;
  },
  removeChild: function(e) {
    return this.documentElement == e && (this.documentElement = null), yw(this, e);
  },
  importNode: function(e, t) {
    return xw(this, e, t);
  },
  getElementById: function(e) {
    var t = null;
    return Zd(this.documentElement, function(n) {
      if (n.nodeType == Ra && n.getAttribute("id") == e)
        return t = n, !0;
    }), t;
  },
  getElementsByClassName: function(e) {
    var t = im(e);
    return new Zu(this, function(n) {
      var r = [];
      return t.length > 0 && Zd(n.documentElement, function(i) {
        if (i !== n && i.nodeType === Ra) {
          var a = i.getAttribute("class");
          if (a) {
            var o = e === a;
            if (!o) {
              var s = im(a);
              o = t.every(Dae(s));
            }
            o && r.push(i);
          }
        }
      }), r;
    });
  },
  createElement: function(e) {
    var t = new Ll();
    t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.localName = e, t.childNodes = new Fo();
    var n = t.attributes = new Y0();
    return n._ownerElement = t, t;
  },
  createDocumentFragment: function() {
    var e = new $h();
    return e.ownerDocument = this, e.childNodes = new Fo(), e;
  },
  createTextNode: function(e) {
    var t = new Y3();
    return t.ownerDocument = this, t.appendData(e), t;
  },
  createComment: function(e) {
    var t = new Q3();
    return t.ownerDocument = this, t.appendData(e), t;
  },
  createCDATASection: function(e) {
    var t = new Z3();
    return t.ownerDocument = this, t.appendData(e), t;
  },
  createProcessingInstruction: function(e, t) {
    var n = new $3();
    return n.ownerDocument = this, n.tagName = n.target = e, n.nodeValue = n.data = t, n;
  },
  createAttribute: function(e) {
    var t = new Q0();
    return t.ownerDocument = this, t.name = e, t.nodeName = e, t.localName = e, t.specified = !0, t;
  },
  createEntityReference: function(e) {
    var t = new J3();
    return t.ownerDocument = this, t.nodeName = e, t;
  },
  createElementNS: function(e, t) {
    var n = new Ll(), r = t.split(":"), i = n.attributes = new Y0();
    return n.childNodes = new Fo(), n.ownerDocument = this, n.nodeName = t, n.tagName = t, n.namespaceURI = e, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, i._ownerElement = n, n;
  },
  createAttributeNS: function(e, t) {
    var n = new Q0(), r = t.split(":");
    return n.ownerDocument = this, n.nodeName = t, n.name = t, n.namespaceURI = e, n.specified = !0, r.length == 2 ? (n.prefix = r[0], n.localName = r[1]) : n.localName = t, n;
  }
};
Br(wf, or);
function Ll() {
  this._nsMap = {};
}
Ll.prototype = {
  nodeType: Ra,
  hasAttribute: function(e) {
    return this.getAttributeNode(e) != null;
  },
  getAttribute: function(e) {
    var t = this.getAttributeNode(e);
    return t && t.value || "";
  },
  getAttributeNode: function(e) {
    return this.attributes.getNamedItem(e);
  },
  setAttribute: function(e, t) {
    var n = this.ownerDocument.createAttribute(e);
    n.value = n.nodeValue = "" + t, this.setAttributeNode(n);
  },
  removeAttribute: function(e) {
    var t = this.getAttributeNode(e);
    t && this.removeAttributeNode(t);
  },
  appendChild: function(e) {
    return e.nodeType === Ko ? this.insertBefore(e, null) : Nae(this, e);
  },
  setAttributeNode: function(e) {
    return this.attributes.setNamedItem(e);
  },
  setAttributeNodeNS: function(e) {
    return this.attributes.setNamedItemNS(e);
  },
  removeAttributeNode: function(e) {
    return this.attributes.removeNamedItem(e.nodeName);
  },
  removeAttributeNS: function(e, t) {
    var n = this.getAttributeNodeNS(e, t);
    n && this.removeAttributeNode(n);
  },
  hasAttributeNS: function(e, t) {
    return this.getAttributeNodeNS(e, t) != null;
  },
  getAttributeNS: function(e, t) {
    var n = this.getAttributeNodeNS(e, t);
    return n && n.value || "";
  },
  setAttributeNS: function(e, t, n) {
    var r = this.ownerDocument.createAttributeNS(e, t);
    r.value = r.nodeValue = "" + n, this.setAttributeNode(r);
  },
  getAttributeNodeNS: function(e, t) {
    return this.attributes.getNamedItemNS(e, t);
  },
  getElementsByTagName: function(e) {
    return new Zu(this, function(t) {
      var n = [];
      return Zd(t, function(r) {
        r !== t && r.nodeType == Ra && (e === "*" || r.tagName == e) && n.push(r);
      }), n;
    });
  },
  getElementsByTagNameNS: function(e, t) {
    return new Zu(this, function(n) {
      var r = [];
      return Zd(n, function(i) {
        i !== n && i.nodeType === Ra && (e === "*" || i.namespaceURI === e) && (t === "*" || i.localName == t) && r.push(i);
      }), r;
    });
  }
};
wf.prototype.getElementsByTagName = Ll.prototype.getElementsByTagName;
wf.prototype.getElementsByTagNameNS = Ll.prototype.getElementsByTagNameNS;
Br(Ll, or);
function Q0() {
}
Q0.prototype.nodeType = Qu;
Br(Q0, or);
function Pf() {
}
Pf.prototype = {
  data: "",
  substringData: function(e, t) {
    return this.data.substring(e, e + t);
  },
  appendData: function(e) {
    e = this.data + e, this.nodeValue = this.data = e, this.length = e.length;
  },
  insertData: function(e, t) {
    this.replaceData(e, 0, t);
  },
  appendChild: function(e) {
    throw new Error(Ni[Iae]);
  },
  deleteData: function(e, t) {
    this.replaceData(e, t, "");
  },
  replaceData: function(e, t, n) {
    var r = this.data.substring(0, e), i = this.data.substring(e + t);
    n = r + n + i, this.nodeValue = this.data = n, this.length = n.length;
  }
};
Br(Pf, or);
function Y3() {
}
Y3.prototype = {
  nodeName: "#text",
  nodeType: G0,
  splitText: function(e) {
    var t = this.data, n = t.substring(e);
    t = t.substring(0, e), this.data = this.nodeValue = t, this.length = t.length;
    var r = this.ownerDocument.createTextNode(n);
    return this.parentNode && this.parentNode.insertBefore(r, this.nextSibling), r;
  }
};
Br(Y3, Pf);
function Q3() {
}
Q3.prototype = {
  nodeName: "#comment",
  nodeType: dw
};
Br(Q3, Pf);
function Z3() {
}
Z3.prototype = {
  nodeName: "#cdata-section",
  nodeType: lw
};
Br(Z3, Pf);
function Jh() {
}
Jh.prototype.nodeType = hw;
Br(Jh, or);
function Aw() {
}
Aw.prototype.nodeType = Hae;
Br(Aw, or);
function Tw() {
}
Tw.prototype.nodeType = Mae;
Br(Tw, or);
function J3() {
}
J3.prototype.nodeType = uw;
Br(J3, or);
function $h() {
}
$h.prototype.nodeName = "#document-fragment";
$h.prototype.nodeType = Ko;
Br($h, or);
function $3() {
}
$3.prototype.nodeType = cw;
Br($3, or);
function ww() {
}
ww.prototype.serializeToString = function(e, t, n) {
  return Pw.call(e, t, n);
};
or.prototype.toString = Pw;
function Pw(e, t) {
  var n = [], r = this.nodeType == 9 && this.documentElement || this, i = r.prefix, a = r.namespaceURI;
  if (a && i == null) {
    var i = r.lookupPrefix(a);
    if (i == null)
      var o = [
        { namespace: a, prefix: null }
      ];
  }
  return xu(this, n, e, t, o), n.join("");
}
function sm(e, t, n) {
  var r = e.prefix || "", i = e.namespaceURI;
  if (!i || r === "xml" && i === Qd.XML || i === Qd.XMLNS)
    return !1;
  for (var a = n.length; a--; ) {
    var o = n[a];
    if (o.prefix === r)
      return o.namespace !== i;
  }
  return !0;
}
function Ip(e, t, n) {
  e.push(" ", t, '="', n.replace(/[<&"]/g, mw), '"');
}
function xu(e, t, n, r, i) {
  if (i || (i = []), r)
    if (e = r(e), e) {
      if (typeof e == "string") {
        t.push(e);
        return;
      }
    } else
      return;
  switch (e.nodeType) {
    case Ra:
      var a = e.attributes, o = a.length, b = e.firstChild, s = e.tagName;
      n = Qd.isHTML(e.namespaceURI) || n;
      var l = s;
      if (!n && !e.prefix && e.namespaceURI) {
        for (var u, c = 0; c < a.length; c++)
          if (a.item(c).name === "xmlns") {
            u = a.item(c).value;
            break;
          }
        if (!u)
          for (var f = i.length - 1; f >= 0; f--) {
            var d = i[f];
            if (d.prefix === "" && d.namespace === e.namespaceURI) {
              u = d.namespace;
              break;
            }
          }
        if (u !== e.namespaceURI)
          for (var f = i.length - 1; f >= 0; f--) {
            var d = i[f];
            if (d.namespace === e.namespaceURI) {
              d.prefix && (l = d.prefix + ":" + s);
              break;
            }
          }
      }
      t.push("<", l);
      for (var h = 0; h < o; h++) {
        var p = a.item(h);
        p.prefix == "xmlns" ? i.push({ prefix: p.localName, namespace: p.value }) : p.nodeName == "xmlns" && i.push({ prefix: "", namespace: p.value });
      }
      for (var h = 0; h < o; h++) {
        var p = a.item(h);
        if (sm(p, n, i)) {
          var y = p.prefix || "", m = p.namespaceURI;
          Ip(t, y ? "xmlns:" + y : "xmlns", m), i.push({ prefix: y, namespace: m });
        }
        xu(p, t, n, r, i);
      }
      if (s === l && sm(e, n, i)) {
        var y = e.prefix || "", m = e.namespaceURI;
        Ip(t, y ? "xmlns:" + y : "xmlns", m), i.push({ prefix: y, namespace: m });
      }
      if (b || n && !/^(?:meta|link|img|br|hr|input)$/i.test(s)) {
        if (t.push(">"), n && /^script$/i.test(s))
          for (; b; )
            b.data ? t.push(b.data) : xu(b, t, n, r, i.slice()), b = b.nextSibling;
        else
          for (; b; )
            xu(b, t, n, r, i.slice()), b = b.nextSibling;
        t.push("</", l, ">");
      } else
        t.push("/>");
      return;
    case fw:
    case Ko:
      for (var b = e.firstChild; b; )
        xu(b, t, n, r, i.slice()), b = b.nextSibling;
      return;
    case Qu:
      return Ip(t, e.name, e.value);
    case G0:
      return t.push(
        e.data.replace(/[<&]/g, mw).replace(/]]>/g, "]]&gt;")
      );
    case lw:
      return t.push("<![CDATA[", e.data, "]]>");
    case dw:
      return t.push("<!--", e.data, "-->");
    case hw:
      var x = e.publicId, D = e.systemId;
      if (t.push("<!DOCTYPE ", e.name), x)
        t.push(" PUBLIC ", x), D && D != "." && t.push(" ", D), t.push(">");
      else if (D && D != ".")
        t.push(" SYSTEM ", D, ">");
      else {
        var S = e.internalSubset;
        S && t.push(" [", S, "]"), t.push(">");
      }
      return;
    case cw:
      return t.push("<?", e.target, " ", e.data, "?>");
    case uw:
      return t.push("&", e.nodeName, ";");
    default:
      t.push("??", e.nodeName);
  }
}
function xw(e, t, n) {
  var r;
  switch (t.nodeType) {
    case Ra:
      r = t.cloneNode(!1), r.ownerDocument = e;
    case Ko:
      break;
    case Qu:
      n = !0;
      break;
  }
  if (r || (r = t.cloneNode(!1)), r.ownerDocument = e, r.parentNode = null, n)
    for (var i = t.firstChild; i; )
      r.appendChild(xw(e, i, n)), i = i.nextSibling;
  return r;
}
function u4(e, t, n) {
  var r = new t.constructor();
  for (var i in t) {
    var a = t[i];
    typeof a != "object" && a != r[i] && (r[i] = a);
  }
  switch (t.childNodes && (r.childNodes = new Fo()), r.ownerDocument = e, r.nodeType) {
    case Ra:
      var o = t.attributes, s = r.attributes = new Y0(), l = o.length;
      s._ownerElement = r;
      for (var u = 0; u < l; u++)
        r.setAttributeNode(u4(e, o.item(u), !0));
      break;
    case Qu:
      n = !0;
  }
  if (n)
    for (var c = t.firstChild; c; )
      r.appendChild(u4(e, c, n)), c = c.nextSibling;
  return r;
}
function Cw(e, t, n) {
  e[t] = n;
}
try {
  if (Object.defineProperty) {
    let e = function(t) {
      switch (t.nodeType) {
        case Ra:
        case Ko:
          var n = [];
          for (t = t.firstChild; t; )
            t.nodeType !== 7 && t.nodeType !== 8 && n.push(e(t)), t = t.nextSibling;
          return n.join("");
        default:
          return t.nodeValue;
      }
    };
    Object.defineProperty(Zu.prototype, "length", {
      get: function() {
        return K3(this), this.$$length;
      }
    }), Object.defineProperty(or.prototype, "textContent", {
      get: function() {
        return e(this);
      },
      set: function(t) {
        switch (this.nodeType) {
          case Ra:
          case Ko:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (t || String(t)) && this.appendChild(this.ownerDocument.createTextNode(t));
            break;
          default:
            this.data = t, this.value = t, this.nodeValue = t;
        }
      }
    }), Cw = function(t, n, r) {
      t["$$" + n] = r;
    };
  }
} catch {
}
Us.DocumentType = Jh;
Us.DOMException = Il;
Us.DOMImplementation = vw;
Us.Element = Ll;
Us.Node = or;
Us.NodeList = Fo;
Us.XMLSerializer = ww;
var xf = {}, Sw = {};
(function(e) {
  var t = ql.freeze;
  e.XML_ENTITIES = t({ amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' }), e.HTML_ENTITIES = t({
    lt: "<",
    gt: ">",
    amp: "&",
    quot: '"',
    apos: "'",
    Agrave: "\xC0",
    Aacute: "\xC1",
    Acirc: "\xC2",
    Atilde: "\xC3",
    Auml: "\xC4",
    Aring: "\xC5",
    AElig: "\xC6",
    Ccedil: "\xC7",
    Egrave: "\xC8",
    Eacute: "\xC9",
    Ecirc: "\xCA",
    Euml: "\xCB",
    Igrave: "\xCC",
    Iacute: "\xCD",
    Icirc: "\xCE",
    Iuml: "\xCF",
    ETH: "\xD0",
    Ntilde: "\xD1",
    Ograve: "\xD2",
    Oacute: "\xD3",
    Ocirc: "\xD4",
    Otilde: "\xD5",
    Ouml: "\xD6",
    Oslash: "\xD8",
    Ugrave: "\xD9",
    Uacute: "\xDA",
    Ucirc: "\xDB",
    Uuml: "\xDC",
    Yacute: "\xDD",
    THORN: "\xDE",
    szlig: "\xDF",
    agrave: "\xE0",
    aacute: "\xE1",
    acirc: "\xE2",
    atilde: "\xE3",
    auml: "\xE4",
    aring: "\xE5",
    aelig: "\xE6",
    ccedil: "\xE7",
    egrave: "\xE8",
    eacute: "\xE9",
    ecirc: "\xEA",
    euml: "\xEB",
    igrave: "\xEC",
    iacute: "\xED",
    icirc: "\xEE",
    iuml: "\xEF",
    eth: "\xF0",
    ntilde: "\xF1",
    ograve: "\xF2",
    oacute: "\xF3",
    ocirc: "\xF4",
    otilde: "\xF5",
    ouml: "\xF6",
    oslash: "\xF8",
    ugrave: "\xF9",
    uacute: "\xFA",
    ucirc: "\xFB",
    uuml: "\xFC",
    yacute: "\xFD",
    thorn: "\xFE",
    yuml: "\xFF",
    nbsp: "\xA0",
    iexcl: "\xA1",
    cent: "\xA2",
    pound: "\xA3",
    curren: "\xA4",
    yen: "\xA5",
    brvbar: "\xA6",
    sect: "\xA7",
    uml: "\xA8",
    copy: "\xA9",
    ordf: "\xAA",
    laquo: "\xAB",
    not: "\xAC",
    shy: "\xAD\xAD",
    reg: "\xAE",
    macr: "\xAF",
    deg: "\xB0",
    plusmn: "\xB1",
    sup2: "\xB2",
    sup3: "\xB3",
    acute: "\xB4",
    micro: "\xB5",
    para: "\xB6",
    middot: "\xB7",
    cedil: "\xB8",
    sup1: "\xB9",
    ordm: "\xBA",
    raquo: "\xBB",
    frac14: "\xBC",
    frac12: "\xBD",
    frac34: "\xBE",
    iquest: "\xBF",
    times: "\xD7",
    divide: "\xF7",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    fnof: "\u0192",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    bull: "\u2022",
    hellip: "\u2026",
    permil: "\u2030",
    prime: "\u2032",
    Prime: "\u2033",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    oline: "\u203E",
    euro: "\u20AC",
    trade: "\u2122",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666"
  }), e.entityMap = e.HTML_ENTITIES;
})(Sw);
var e6 = {}, Jd = ql.NAMESPACE, c4 = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, lm = new RegExp("[\\-\\.0-9" + c4.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), um = new RegExp("^" + c4.source + lm.source + "*(?::" + c4.source + lm.source + "*)?$"), Zc = 0, ws = 1, hu = 2, Jc = 3, pu = 4, vu = 5, $c = 6, A1 = 7;
function Ju(e, t) {
  this.message = e, this.locator = t, Error.captureStackTrace && Error.captureStackTrace(this, Ju);
}
Ju.prototype = new Error();
Ju.prototype.name = Ju.name;
function Ew() {
}
Ew.prototype = {
  parse: function(e, t, n) {
    var r = this.domBuilder;
    r.startDocument(), kw(t, t = {}), jae(
      e,
      t,
      n,
      r,
      this.errorHandler
    ), r.endDocument();
  }
};
function jae(e, t, n, r, i) {
  function a(Y) {
    if (Y > 65535) {
      Y -= 65536;
      var Z = 55296 + (Y >> 10), oe = 56320 + (Y & 1023);
      return String.fromCharCode(Z, oe);
    } else
      return String.fromCharCode(Y);
  }
  function o(Y) {
    var Z = Y.slice(1, -1);
    return Z in n ? n[Z] : Z.charAt(0) === "#" ? a(parseInt(Z.substr(1).replace("x", "0x"))) : (i.error("entity not found:" + Y), Y);
  }
  function s(Y) {
    if (Y > y) {
      var Z = e.substring(y, Y).replace(/&#?\w+;/g, o);
      d && l(y), r.characters(Z, 0, Y - y), y = Y;
    }
  }
  function l(Y, Z) {
    for (; Y >= c && (Z = f.exec(e)); )
      u = Z.index, c = u + Z[0].length, d.lineNumber++;
    d.columnNumber = Y - u + 1;
  }
  for (var u = 0, c = 0, f = /.*(?:\r\n?|\n)|.*$/g, d = r.locator, h = [{ currentNSMap: t }], p = {}, y = 0; ; ) {
    try {
      var m = e.indexOf("<", y);
      if (m < 0) {
        if (!e.substr(y).match(/^\s*$/)) {
          var b = r.doc, x = b.createTextNode(e.substr(y));
          b.appendChild(x), r.currentElement = x;
        }
        return;
      }
      switch (m > y && s(m), e.charAt(m + 1)) {
        case "/":
          var K = e.indexOf(">", m + 3), D = e.substring(m + 2, K).replace(/[ \t\n\r]+$/g, ""), S = h.pop();
          K < 0 ? (D = e.substring(m + 2).replace(/[\s<].*/, ""), i.error("end tag name: " + D + " is not complete:" + S.tagName), K = m + 1 + D.length) : D.match(/\s</) && (D = D.replace(/[\s<].*/, ""), i.error("end tag name: " + D + " maybe not complete"), K = m + 1 + D.length);
          var C = S.localNSMap, v = S.tagName == D, H = v || S.tagName && S.tagName.toLowerCase() == D.toLowerCase();
          if (H) {
            if (r.endElement(S.uri, S.localName, D), C)
              for (var V in C)
                r.endPrefixMapping(V);
            v || i.fatalError("end tag name: " + D + " is not match the current start tagName:" + S.tagName);
          } else
            h.push(S);
          K++;
          break;
        case "?":
          d && l(m), K = Uae(e, m, r);
          break;
        case "!":
          d && l(m), K = Vae(e, m, r, i);
          break;
        default:
          d && l(m);
          var R = new Ow(), F = h[h.length - 1].currentNSMap, K = Fae(e, m, R, F, o, i), q = R.length;
          if (!R.closed && Rae(e, K, R.tagName, p) && (R.closed = !0, n.nbsp || i.warning("unclosed xml attribute")), d && q) {
            for (var G = cm(d, {}), te = 0; te < q; te++) {
              var Q = R[te];
              l(Q.offset), Q.locator = cm(d, {});
            }
            r.locator = G, dm(R, r, F) && h.push(R), r.locator = d;
          } else
            dm(R, r, F) && h.push(R);
          Jd.isHTML(R.uri) && !R.closed ? K = Xae(e, K, R.tagName, o, r) : K++;
      }
    } catch (Y) {
      if (Y instanceof Ju)
        throw Y;
      i.error("element parse error: " + Y), K = -1;
    }
    K > y ? y = K : s(Math.max(m, y) + 1);
  }
}
function cm(e, t) {
  return t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber, t;
}
function Fae(e, t, n, r, i, a) {
  function o(d, h, p) {
    n.attributeNames.hasOwnProperty(d) && a.fatalError("Attribute " + d + " redefined"), n.addValue(d, h, p);
  }
  for (var s, l, u = ++t, c = Zc; ; ) {
    var f = e.charAt(u);
    switch (f) {
      case "=":
        if (c === ws)
          s = e.slice(t, u), c = Jc;
        else if (c === hu)
          c = Jc;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (c === Jc || c === ws)
          if (c === ws && (a.warning('attribute value must after "="'), s = e.slice(t, u)), t = u + 1, u = e.indexOf(f, t), u > 0)
            l = e.slice(t, u).replace(/&#?\w+;/g, i), o(s, l, t - 1), c = vu;
          else
            throw new Error("attribute value no end '" + f + "' match");
        else if (c == pu)
          l = e.slice(t, u).replace(/&#?\w+;/g, i), o(s, l, t), a.warning('attribute "' + s + '" missed start quot(' + f + ")!!"), t = u + 1, c = vu;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (c) {
          case Zc:
            n.setTagName(e.slice(t, u));
          case vu:
          case $c:
          case A1:
            c = A1, n.closed = !0;
          case pu:
          case ws:
          case hu:
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return a.error("unexpected end of input"), c == Zc && n.setTagName(e.slice(t, u)), u;
      case ">":
        switch (c) {
          case Zc:
            n.setTagName(e.slice(t, u));
          case vu:
          case $c:
          case A1:
            break;
          case pu:
          case ws:
            l = e.slice(t, u), l.slice(-1) === "/" && (n.closed = !0, l = l.slice(0, -1));
          case hu:
            c === hu && (l = s), c == pu ? (a.warning('attribute "' + l + '" missed quot(")!'), o(s, l.replace(/&#?\w+;/g, i), t)) : ((!Jd.isHTML(r[""]) || !l.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + l + '" missed value!! "' + l + '" instead!!'), o(l, l, t));
            break;
          case Jc:
            throw new Error("attribute value missed!!");
        }
        return u;
      case "\x80":
        f = " ";
      default:
        if (f <= " ")
          switch (c) {
            case Zc:
              n.setTagName(e.slice(t, u)), c = $c;
              break;
            case ws:
              s = e.slice(t, u), c = hu;
              break;
            case pu:
              var l = e.slice(t, u).replace(/&#?\w+;/g, i);
              a.warning('attribute "' + l + '" missed quot(")!!'), o(s, l, t);
            case vu:
              c = $c;
              break;
          }
        else
          switch (c) {
            case hu:
              n.tagName, (!Jd.isHTML(r[""]) || !s.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + s + '" missed value!! "' + s + '" instead2!!'), o(s, s, t), t = u, c = ws;
              break;
            case vu:
              a.warning('attribute space is required"' + s + '"!!');
            case $c:
              c = ws, t = u;
              break;
            case Jc:
              c = pu, t = u;
              break;
            case A1:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    u++;
  }
}
function dm(e, t, n) {
  for (var r = e.tagName, i = null, f = e.length; f--; ) {
    var a = e[f], o = a.qName, s = a.value, d = o.indexOf(":");
    if (d > 0)
      var l = a.prefix = o.slice(0, d), u = o.slice(d + 1), c = l === "xmlns" && u;
    else
      u = o, l = null, c = o === "xmlns" && "";
    a.localName = u, c !== !1 && (i == null && (i = {}, kw(n, n = {})), n[c] = i[c] = s, a.uri = Jd.XMLNS, t.startPrefixMapping(c, s));
  }
  for (var f = e.length; f--; ) {
    a = e[f];
    var l = a.prefix;
    l && (l === "xml" && (a.uri = Jd.XML), l !== "xmlns" && (a.uri = n[l || ""]));
  }
  var d = r.indexOf(":");
  d > 0 ? (l = e.prefix = r.slice(0, d), u = e.localName = r.slice(d + 1)) : (l = null, u = e.localName = r);
  var h = e.uri = n[l || ""];
  if (t.startElement(h, u, r, e), e.closed) {
    if (t.endElement(h, u, r), i)
      for (l in i)
        t.endPrefixMapping(l);
  } else
    return e.currentNSMap = n, e.localNSMap = i, !0;
}
function Xae(e, t, n, r, i) {
  if (/^(?:script|textarea)$/i.test(n)) {
    var a = e.indexOf("</" + n + ">", t), o = e.substring(t + 1, a);
    if (/[&<]/.test(o))
      return /^script$/i.test(n) ? (i.characters(o, 0, o.length), a) : (o = o.replace(/&#?\w+;/g, r), i.characters(o, 0, o.length), a);
  }
  return t + 1;
}
function Rae(e, t, n, r) {
  var i = r[n];
  return i == null && (i = e.lastIndexOf("</" + n + ">"), i < t && (i = e.lastIndexOf("</" + n)), r[n] = i), i < t;
}
function kw(e, t) {
  for (var n in e)
    t[n] = e[n];
}
function Vae(e, t, n, r) {
  var i = e.charAt(t + 2);
  switch (i) {
    case "-":
      if (e.charAt(t + 3) === "-") {
        var a = e.indexOf("-->", t + 4);
        return a > t ? (n.comment(e, t + 4, a - t - 4), a + 3) : (r.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (e.substr(t + 3, 6) == "CDATA[") {
        var a = e.indexOf("]]>", t + 9);
        return n.startCDATA(), n.characters(e, t + 9, a - t - 9), n.endCDATA(), a + 3;
      }
      var o = qae(e, t), s = o.length;
      if (s > 1 && /!doctype/i.test(o[0][0])) {
        var l = o[1][0], u = !1, c = !1;
        s > 3 && (/^public$/i.test(o[2][0]) ? (u = o[3][0], c = s > 4 && o[4][0]) : /^system$/i.test(o[2][0]) && (c = o[3][0]));
        var f = o[s - 1];
        return n.startDTD(l, u, c), n.endDTD(), f.index + f[0].length;
      }
  }
  return -1;
}
function Uae(e, t, n) {
  var r = e.indexOf("?>", t);
  if (r) {
    var i = e.substring(t, r).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return i ? (i[0].length, n.processingInstruction(i[1], i[2]), r + 2) : -1;
  }
  return -1;
}
function Ow() {
  this.attributeNames = {};
}
Ow.prototype = {
  setTagName: function(e) {
    if (!um.test(e))
      throw new Error("invalid tagName:" + e);
    this.tagName = e;
  },
  addValue: function(e, t, n) {
    if (!um.test(e))
      throw new Error("invalid attribute:" + e);
    this.attributeNames[e] = this.length, this[this.length++] = { qName: e, value: t, offset: n };
  },
  length: 0,
  getLocalName: function(e) {
    return this[e].localName;
  },
  getLocator: function(e) {
    return this[e].locator;
  },
  getQName: function(e) {
    return this[e].qName;
  },
  getURI: function(e) {
    return this[e].uri;
  },
  getValue: function(e) {
    return this[e].value;
  }
};
function qae(e, t) {
  var n, r = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (i.lastIndex = t, i.exec(e); n = i.exec(e); )
    if (r.push(n), n[1])
      return r;
}
e6.XMLReader = Ew;
e6.ParseError = Ju;
var _ae = ql, t6 = Us, fm = Sw, zw = e6, Wae = t6.DOMImplementation, hm = _ae.NAMESPACE, Kae = zw.ParseError, Gae = zw.XMLReader;
function Dw(e) {
  this.options = e || { locator: {} };
}
Dw.prototype.parseFromString = function(e, t) {
  var n = this.options, r = new Gae(), i = n.domBuilder || new Cf(), a = n.errorHandler, o = n.locator, s = n.xmlns || {}, l = /\/x?html?$/.test(t), u = l ? fm.HTML_ENTITIES : fm.XML_ENTITIES;
  return o && i.setDocumentLocator(o), r.errorHandler = Yae(a, i, o), r.domBuilder = n.domBuilder || i, l && (s[""] = hm.HTML), s.xml = s.xml || hm.XML, e && typeof e == "string" ? r.parse(e, s, u) : r.errorHandler.error("invalid doc source"), i.doc;
};
function Yae(e, t, n) {
  if (!e) {
    if (t instanceof Cf)
      return t;
    e = t;
  }
  var r = {}, i = e instanceof Function;
  n = n || {};
  function a(o) {
    var s = e[o];
    !s && i && (s = e.length == 2 ? function(l) {
      e(o, l);
    } : e), r[o] = s && function(l) {
      s("[xmldom " + o + "]	" + l + d4(n));
    } || function() {
    };
  }
  return a("warning"), a("error"), a("fatalError"), r;
}
function Cf() {
  this.cdata = !1;
}
function mu(e, t) {
  t.lineNumber = e.lineNumber, t.columnNumber = e.columnNumber;
}
Cf.prototype = {
  startDocument: function() {
    this.doc = new Wae().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(e, t, n, r) {
    var i = this.doc, a = i.createElementNS(e, n || t), o = r.length;
    T1(this, a), this.currentElement = a, this.locator && mu(this.locator, a);
    for (var s = 0; s < o; s++) {
      var e = r.getURI(s), l = r.getValue(s), n = r.getQName(s), u = i.createAttributeNS(e, n);
      this.locator && mu(r.getLocator(s), u), u.value = u.nodeValue = l, a.setAttributeNode(u);
    }
  },
  endElement: function(e, t, n) {
    var r = this.currentElement;
    r.tagName, this.currentElement = r.parentNode;
  },
  startPrefixMapping: function(e, t) {
  },
  endPrefixMapping: function(e) {
  },
  processingInstruction: function(e, t) {
    var n = this.doc.createProcessingInstruction(e, t);
    this.locator && mu(this.locator, n), T1(this, n);
  },
  ignorableWhitespace: function(e, t, n) {
  },
  characters: function(e, t, n) {
    if (e = pm.apply(this, arguments), e) {
      if (this.cdata)
        var r = this.doc.createCDATASection(e);
      else
        var r = this.doc.createTextNode(e);
      this.currentElement ? this.currentElement.appendChild(r) : /^\s*$/.test(e) && this.doc.appendChild(r), this.locator && mu(this.locator, r);
    }
  },
  skippedEntity: function(e) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(e) {
    (this.locator = e) && (e.lineNumber = 0);
  },
  comment: function(e, t, n) {
    e = pm.apply(this, arguments);
    var r = this.doc.createComment(e);
    this.locator && mu(this.locator, r), T1(this, r);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(e, t, n) {
    var r = this.doc.implementation;
    if (r && r.createDocumentType) {
      var i = r.createDocumentType(e, t, n);
      this.locator && mu(this.locator, i), T1(this, i), this.doc.doctype = i;
    }
  },
  warning: function(e) {
    console.warn("[xmldom warning]	" + e, d4(this.locator));
  },
  error: function(e) {
    console.error("[xmldom error]	" + e, d4(this.locator));
  },
  fatalError: function(e) {
    throw new Kae(e, this.locator);
  }
};
function d4(e) {
  if (e)
    return `
@` + (e.systemId || "") + "#[line:" + e.lineNumber + ",col:" + e.columnNumber + "]";
}
function pm(e, t, n) {
  return typeof e == "string" ? e.substr(t, n) : e.length >= t + n || t ? new java.lang.String(e, t, n) + "" : e;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(e) {
  Cf.prototype[e] = function() {
    return null;
  };
});
function T1(e, t) {
  e.currentElement ? e.currentElement.appendChild(t) : e.doc.appendChild(t);
}
xf.__DOMHandler = Cf;
xf.DOMParser = Dw;
xf.DOMImplementation = t6.DOMImplementation;
xf.XMLSerializer = t6.XMLSerializer;
var Qae = xf.DOMParser;
/*! @name mpd-parser @version 0.21.1 @license Apache-2.0 */
var vm = function(t) {
  return !!t && typeof t == "object";
}, gr = function e() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.reduce(function(i, a) {
    return typeof a != "object" || Object.keys(a).forEach(function(o) {
      Array.isArray(i[o]) && Array.isArray(a[o]) ? i[o] = i[o].concat(a[o]) : vm(i[o]) && vm(a[o]) ? i[o] = e(i[o], a[o]) : i[o] = a[o];
    }), i;
  }, {});
}, Mw = function(t) {
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}, Zae = function(t, n) {
  for (var r = [], i = t; i < n; i++)
    r.push(i);
  return r;
}, e2 = function(t) {
  return t.reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, Hw = function(t) {
  if (!t.length)
    return [];
  for (var n = [], r = 0; r < t.length; r++)
    n.push(t[r]);
  return n;
}, Jae = function(t, n) {
  return t.reduce(function(r, i, a) {
    return i[n] && r.push(a), r;
  }, []);
}, f4 = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (n(t[r]))
      return r;
  return -1;
}, $ae = function(t, n) {
  return Mw(t.reduce(function(r, i) {
    return i.forEach(function(a) {
      r[n(a)] = a;
    }), r;
  }, {}));
}, $u = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
}, $d = function(t) {
  var n = t.baseUrl, r = n === void 0 ? "" : n, i = t.source, a = i === void 0 ? "" : i, o = t.range, s = o === void 0 ? "" : o, l = t.indexRange, u = l === void 0 ? "" : l, c = {
    uri: a,
    resolvedUri: Zh(r || "", a)
  };
  if (s || u) {
    var f = s || u, d = f.split("-"), h = pe.BigInt ? pe.BigInt(d[0]) : parseInt(d[0], 10), p = pe.BigInt ? pe.BigInt(d[1]) : parseInt(d[1], 10);
    h < Number.MAX_SAFE_INTEGER && typeof h == "bigint" && (h = Number(h)), p < Number.MAX_SAFE_INTEGER && typeof p == "bigint" && (p = Number(p));
    var y;
    typeof p == "bigint" || typeof h == "bigint" ? y = pe.BigInt(p) - pe.BigInt(h) + pe.BigInt(1) : y = p - h + 1, typeof y == "bigint" && y < Number.MAX_SAFE_INTEGER && (y = Number(y)), c.byterange = {
      length: y,
      offset: h
    };
  }
  return c;
}, eoe = function(t) {
  var n;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? n = pe.BigInt(t.offset) + pe.BigInt(t.length) - pe.BigInt(1) : n = t.offset + t.length - 1, t.offset + "-" + n;
}, mm = function(t) {
  return t && typeof t != "number" && (t = parseInt(t, 10)), isNaN(t) ? null : t;
}, toe = {
  static: function(t) {
    var n = t.duration, r = t.timescale, i = r === void 0 ? 1 : r, a = t.sourceDuration, o = t.periodDuration, s = mm(t.endNumber), l = n / i;
    return typeof s == "number" ? {
      start: 0,
      end: s
    } : typeof o == "number" ? {
      start: 0,
      end: o / l
    } : {
      start: 0,
      end: a / l
    };
  },
  dynamic: function(t) {
    var n = t.NOW, r = t.clientOffset, i = t.availabilityStartTime, a = t.timescale, o = a === void 0 ? 1 : a, s = t.duration, l = t.periodStart, u = l === void 0 ? 0 : l, c = t.minimumUpdatePeriod, f = c === void 0 ? 0 : c, d = t.timeShiftBufferDepth, h = d === void 0 ? 1 / 0 : d, p = mm(t.endNumber), y = (n + r) / 1e3, m = i + u, b = y + f, x = b - m, D = Math.ceil(x * o / s), S = Math.floor((y - m - h) * o / s), C = Math.floor((y - m) * o / s);
    return {
      start: Math.max(0, S),
      end: typeof p == "number" ? p : Math.min(D, C)
    };
  }
}, noe = function(t) {
  return function(n) {
    var r = t.duration, i = t.timescale, a = i === void 0 ? 1 : i, o = t.periodStart, s = t.startNumber, l = s === void 0 ? 1 : s;
    return {
      number: l + n,
      duration: r / a,
      timeline: o,
      time: n * r
    };
  };
}, n6 = function(t) {
  var n = t.type, r = t.duration, i = t.timescale, a = i === void 0 ? 1 : i, o = t.periodDuration, s = t.sourceDuration, l = toe[n](t), u = l.start, c = l.end, f = Zae(u, c).map(noe(t));
  if (n === "static") {
    var d = f.length - 1, h = typeof o == "number" ? o : s;
    f[d].duration = h - r / a * d;
  }
  return f;
}, Iw = function(t) {
  var n = t.baseUrl, r = t.initialization, i = r === void 0 ? {} : r, a = t.sourceDuration, o = t.indexRange, s = o === void 0 ? "" : o, l = t.periodStart, u = t.presentationTime, c = t.number, f = c === void 0 ? 0 : c, d = t.duration;
  if (!n)
    throw new Error($u.NO_BASE_URL);
  var h = $d({
    baseUrl: n,
    source: i.sourceURL,
    range: i.range
  }), p = $d({
    baseUrl: n,
    source: n,
    indexRange: s
  });
  if (p.map = h, d) {
    var y = n6(t);
    y.length && (p.duration = y[0].duration, p.timeline = y[0].timeline);
  } else
    a && (p.duration = a, p.timeline = l);
  return p.presentationTime = u || l, p.number = f, [p];
}, i6 = function(t, n, r) {
  var i = t.sidx.map ? t.sidx.map : null, a = t.sidx.duration, o = t.timeline || 0, s = t.sidx.byterange, l = s.offset + s.length, u = n.timescale, c = n.references.filter(function(R) {
    return R.referenceType !== 1;
  }), f = [], d = t.endList ? "static" : "dynamic", h = t.sidx.timeline, p = h, y = t.mediaSequence || 0, m;
  typeof n.firstOffset == "bigint" ? m = pe.BigInt(l) + n.firstOffset : m = l + n.firstOffset;
  for (var b = 0; b < c.length; b++) {
    var x = n.references[b], D = x.referencedSize, S = x.subsegmentDuration, C = void 0;
    typeof m == "bigint" ? C = m + pe.BigInt(D) - pe.BigInt(1) : C = m + D - 1;
    var v = m + "-" + C, H = {
      baseUrl: r,
      timescale: u,
      timeline: o,
      periodStart: h,
      presentationTime: p,
      number: y,
      duration: S,
      sourceDuration: a,
      indexRange: v,
      type: d
    }, V = Iw(H)[0];
    i && (V.map = i), f.push(V), typeof m == "bigint" ? m += pe.BigInt(D) : m += D, p += S / u, y++;
  }
  return t.segments = f, t;
}, ioe = ["AUDIO", "SUBTITLES"], roe = 1 / 60, Lw = function(t) {
  return $ae(t, function(n) {
    var r = n.timeline;
    return r;
  }).sort(function(n, r) {
    return n.timeline > r.timeline ? 1 : -1;
  });
}, aoe = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].attributes.NAME === n)
      return t[r];
  return null;
}, gm = function(t) {
  var n = [];
  return Sae(t, ioe, function(r, i, a, o) {
    n = n.concat(r.playlists || []);
  }), n;
}, ym = function(t) {
  var n = t.playlist, r = t.mediaSequence;
  n.mediaSequence = r, n.segments.forEach(function(i, a) {
    i.number = n.mediaSequence + a;
  });
}, ooe = function(t) {
  var n = t.oldPlaylists, r = t.newPlaylists, i = t.timelineStarts;
  r.forEach(function(a) {
    a.discontinuitySequence = f4(i, function(c) {
      var f = c.timeline;
      return f === a.timeline;
    });
    var o = aoe(n, a.attributes.NAME);
    if (!!o && !a.sidx) {
      var s = a.segments[0], l = f4(o.segments, function(c) {
        return Math.abs(c.presentationTime - s.presentationTime) < roe;
      });
      if (l === -1) {
        ym({
          playlist: a,
          mediaSequence: o.mediaSequence + o.segments.length
        }), a.segments[0].discontinuity = !0, a.discontinuityStarts.unshift(0), (!o.segments.length && a.timeline > o.timeline || o.segments.length && a.timeline > o.segments[o.segments.length - 1].timeline) && a.discontinuitySequence--;
        return;
      }
      var u = o.segments[l];
      u.discontinuity && !s.discontinuity && (s.discontinuity = !0, a.discontinuityStarts.unshift(0), a.discontinuitySequence--), ym({
        playlist: a,
        mediaSequence: o.segments[l].number
      });
    }
  });
}, soe = function(t) {
  var n = t.oldManifest, r = t.newManifest, i = n.playlists.concat(gm(n)), a = r.playlists.concat(gm(r));
  return r.timelineStarts = Lw([n.timelineStarts, r.timelineStarts]), ooe({
    oldPlaylists: i,
    newPlaylists: a,
    timelineStarts: r.timelineStarts
  }), r;
}, t2 = function(t) {
  return t && t.uri + "-" + eoe(t.byterange);
}, Lp = function(t) {
  var n = Mw(t.reduce(function(r, i) {
    var a = i.attributes.id + (i.attributes.lang || "");
    if (!r[a])
      r[a] = i, r[a].attributes.timelineStarts = [];
    else {
      if (i.segments) {
        var o;
        i.segments[0] && (i.segments[0].discontinuity = !0), (o = r[a].segments).push.apply(o, i.segments);
      }
      i.attributes.contentProtection && (r[a].attributes.contentProtection = i.attributes.contentProtection);
    }
    return r[a].attributes.timelineStarts.push({
      start: i.attributes.periodStart,
      timeline: i.attributes.periodStart
    }), r;
  }, {}));
  return n.map(function(r) {
    return r.discontinuityStarts = Jae(r.segments || [], "discontinuity"), r;
  });
}, r6 = function(t, n) {
  var r = t2(t.sidx), i = r && n[r] && n[r].sidx;
  return i && i6(t, i, t.sidx.resolvedUri), t;
}, loe = function(t, n) {
  if (n === void 0 && (n = {}), !Object.keys(n).length)
    return t;
  for (var r in t)
    t[r] = r6(t[r], n);
  return t;
}, uoe = function(t, n) {
  var r, i = t.attributes, a = t.segments, o = t.sidx, s = t.mediaSequence, l = t.discontinuitySequence, u = t.discontinuityStarts, c = {
    attributes: (r = {
      NAME: i.id,
      BANDWIDTH: i.bandwidth,
      CODECS: i.codecs
    }, r["PROGRAM-ID"] = 1, r),
    uri: "",
    endList: i.type === "static",
    timeline: i.periodStart,
    resolvedUri: "",
    targetDuration: i.duration,
    discontinuitySequence: l,
    discontinuityStarts: u,
    timelineStarts: i.timelineStarts,
    mediaSequence: s,
    segments: a
  };
  return i.contentProtection && (c.contentProtection = i.contentProtection), o && (c.sidx = o), n && (c.attributes.AUDIO = "audio", c.attributes.SUBTITLES = "subs"), c;
}, coe = function(t) {
  var n, r = t.attributes, i = t.segments, a = t.mediaSequence, o = t.discontinuityStarts, s = t.discontinuitySequence;
  typeof i > "u" && (i = [{
    uri: r.baseUrl,
    timeline: r.periodStart,
    resolvedUri: r.baseUrl || "",
    duration: r.sourceDuration,
    number: 0
  }], r.duration = r.sourceDuration);
  var l = (n = {
    NAME: r.id,
    BANDWIDTH: r.bandwidth
  }, n["PROGRAM-ID"] = 1, n);
  return r.codecs && (l.CODECS = r.codecs), {
    attributes: l,
    uri: "",
    endList: r.type === "static",
    timeline: r.periodStart,
    resolvedUri: r.baseUrl || "",
    targetDuration: r.duration,
    timelineStarts: r.timelineStarts,
    discontinuityStarts: o,
    discontinuitySequence: s,
    mediaSequence: a,
    segments: i
  };
}, doe = function(t, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = !1);
  var i, a = t.reduce(function(s, l) {
    var u = l.attributes.role && l.attributes.role.value || "", c = l.attributes.lang || "", f = l.attributes.label || "main";
    if (c && !l.attributes.label) {
      var d = u ? " (" + u + ")" : "";
      f = "" + l.attributes.lang + d;
    }
    s[f] || (s[f] = {
      language: c,
      autoselect: !0,
      default: u === "main",
      playlists: [],
      uri: ""
    });
    var h = r6(uoe(l, r), n);
    return s[f].playlists.push(h), typeof i > "u" && u === "main" && (i = l, i.default = !0), s;
  }, {});
  if (!i) {
    var o = Object.keys(a)[0];
    a[o].default = !0;
  }
  return a;
}, foe = function(t, n) {
  return n === void 0 && (n = {}), t.reduce(function(r, i) {
    var a = i.attributes.lang || "text";
    return r[a] || (r[a] = {
      language: a,
      default: !1,
      autoselect: !1,
      playlists: [],
      uri: ""
    }), r[a].playlists.push(r6(coe(i), n)), r;
  }, {});
}, hoe = function(t) {
  return t.reduce(function(n, r) {
    return r && r.forEach(function(i) {
      var a = i.channel, o = i.language;
      n[o] = {
        autoselect: !1,
        default: !1,
        instreamId: a,
        language: o
      }, i.hasOwnProperty("aspectRatio") && (n[o].aspectRatio = i.aspectRatio), i.hasOwnProperty("easyReader") && (n[o].easyReader = i.easyReader), i.hasOwnProperty("3D") && (n[o]["3D"] = i["3D"]);
    }), n;
  }, {});
}, poe = function(t) {
  var n, r = t.attributes, i = t.segments, a = t.sidx, o = t.discontinuityStarts, s = {
    attributes: (n = {
      NAME: r.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: r.width,
        height: r.height
      },
      CODECS: r.codecs,
      BANDWIDTH: r.bandwidth
    }, n["PROGRAM-ID"] = 1, n),
    uri: "",
    endList: r.type === "static",
    timeline: r.periodStart,
    resolvedUri: "",
    targetDuration: r.duration,
    discontinuityStarts: o,
    timelineStarts: r.timelineStarts,
    segments: i
  };
  return r.contentProtection && (s.contentProtection = r.contentProtection), a && (s.sidx = a), s;
}, voe = function(t) {
  var n = t.attributes;
  return n.mimeType === "video/mp4" || n.mimeType === "video/webm" || n.contentType === "video";
}, moe = function(t) {
  var n = t.attributes;
  return n.mimeType === "audio/mp4" || n.mimeType === "audio/webm" || n.contentType === "audio";
}, goe = function(t) {
  var n = t.attributes;
  return n.mimeType === "text/vtt" || n.contentType === "text";
}, yoe = function(t, n) {
  t.forEach(function(r) {
    r.mediaSequence = 0, r.discontinuitySequence = f4(n, function(i) {
      var a = i.timeline;
      return a === r.timeline;
    }), r.segments && r.segments.forEach(function(i, a) {
      i.number = a;
    });
  });
}, bm = function(t) {
  return t ? Object.keys(t).reduce(function(n, r) {
    var i = t[r];
    return n.concat(i.playlists);
  }, []) : [];
}, boe = function(t) {
  var n, r = t.dashPlaylists, i = t.locations, a = t.sidxMapping, o = a === void 0 ? {} : a, s = t.previousManifest;
  if (!r.length)
    return {};
  var l = r[0].attributes, u = l.sourceDuration, c = l.type, f = l.suggestedPresentationDelay, d = l.minimumUpdatePeriod, h = Lp(r.filter(voe)).map(poe), p = Lp(r.filter(moe)), y = Lp(r.filter(goe)), m = r.map(function(H) {
    return H.attributes.captionServices;
  }).filter(Boolean), b = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: (n = {
      AUDIO: {},
      VIDEO: {}
    }, n["CLOSED-CAPTIONS"] = {}, n.SUBTITLES = {}, n),
    uri: "",
    duration: u,
    playlists: loe(h, o)
  };
  d >= 0 && (b.minimumUpdatePeriod = d * 1e3), i && (b.locations = i), c === "dynamic" && (b.suggestedPresentationDelay = f);
  var x = b.playlists.length === 0, D = p.length ? doe(p, o, x) : null, S = y.length ? foe(y, o) : null, C = h.concat(bm(D), bm(S)), v = C.map(function(H) {
    var V = H.timelineStarts;
    return V;
  });
  return b.timelineStarts = Lw(v), yoe(C, b.timelineStarts), D && (b.mediaGroups.AUDIO.audio = D), S && (b.mediaGroups.SUBTITLES.subs = S), m.length && (b.mediaGroups["CLOSED-CAPTIONS"].cc = hoe(m)), s ? soe({
    oldManifest: s,
    newManifest: b
  }) : b;
}, Aoe = function(t, n, r) {
  var i = t.NOW, a = t.clientOffset, o = t.availabilityStartTime, s = t.timescale, l = s === void 0 ? 1 : s, u = t.periodStart, c = u === void 0 ? 0 : u, f = t.minimumUpdatePeriod, d = f === void 0 ? 0 : f, h = (i + a) / 1e3, p = o + c, y = h + d, m = y - p;
  return Math.ceil((m * l - n) / r);
}, Bw = function(t, n) {
  for (var r = t.type, i = t.minimumUpdatePeriod, a = i === void 0 ? 0 : i, o = t.media, s = o === void 0 ? "" : o, l = t.sourceDuration, u = t.timescale, c = u === void 0 ? 1 : u, f = t.startNumber, d = f === void 0 ? 1 : f, h = t.periodStart, p = [], y = -1, m = 0; m < n.length; m++) {
    var b = n[m], x = b.d, D = b.r || 0, S = b.t || 0;
    y < 0 && (y = S), S && S > y && (y = S);
    var C = void 0;
    if (D < 0) {
      var v = m + 1;
      v === n.length ? r === "dynamic" && a > 0 && s.indexOf("$Number$") > 0 ? C = Aoe(t, y, x) : C = (l * c - y) / x : C = (n[v].t - y) / x;
    } else
      C = D + 1;
    for (var H = d + p.length + C, V = d + p.length; V < H; )
      p.push({
        number: V,
        duration: x / c,
        time: y,
        timeline: h
      }), y += x, V++;
  }
  return p;
}, Toe = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, woe = function(t) {
  return function(n, r, i, a) {
    if (n === "$$")
      return "$";
    if (typeof t[r] > "u")
      return n;
    var o = "" + t[r];
    return r === "RepresentationID" || (i ? a = parseInt(a, 10) : a = 1, o.length >= a) ? o : "" + new Array(a - o.length + 1).join("0") + o;
  };
}, Am = function(t, n) {
  return t.replace(Toe, woe(n));
}, Poe = function(t, n) {
  return !t.duration && !n ? [{
    number: t.startNumber || 1,
    duration: t.sourceDuration,
    time: 0,
    timeline: t.periodStart
  }] : t.duration ? n6(t) : Bw(t, n);
}, xoe = function(t, n) {
  var r = {
    RepresentationID: t.id,
    Bandwidth: t.bandwidth || 0
  }, i = t.initialization, a = i === void 0 ? {
    sourceURL: "",
    range: ""
  } : i, o = $d({
    baseUrl: t.baseUrl,
    source: Am(a.sourceURL, r),
    range: a.range
  }), s = Poe(t, n);
  return s.map(function(l) {
    r.Number = l.number, r.Time = l.time;
    var u = Am(t.media || "", r), c = t.timescale || 1, f = t.presentationTimeOffset || 0, d = t.periodStart + (l.time - f) / c, h = {
      uri: u,
      timeline: l.timeline,
      duration: l.duration,
      resolvedUri: Zh(t.baseUrl || "", u),
      map: o,
      number: l.number,
      presentationTime: d
    };
    return h;
  });
}, Coe = function(t, n) {
  var r = t.baseUrl, i = t.initialization, a = i === void 0 ? {} : i, o = $d({
    baseUrl: r,
    source: a.sourceURL,
    range: a.range
  }), s = $d({
    baseUrl: r,
    source: n.media,
    range: n.mediaRange
  });
  return s.map = o, s;
}, Soe = function(t, n) {
  var r = t.duration, i = t.segmentUrls, a = i === void 0 ? [] : i, o = t.periodStart;
  if (!r && !n || r && n)
    throw new Error($u.SEGMENT_TIME_UNSPECIFIED);
  var s = a.map(function(c) {
    return Coe(t, c);
  }), l;
  r && (l = n6(t)), n && (l = Bw(t, n));
  var u = l.map(function(c, f) {
    if (s[f]) {
      var d = s[f], h = t.timescale || 1, p = t.presentationTimeOffset || 0;
      return d.timeline = c.timeline, d.duration = c.duration, d.number = c.number, d.presentationTime = o + (c.time - p) / h, d;
    }
  }).filter(function(c) {
    return c;
  });
  return u;
}, Eoe = function(t) {
  var n = t.attributes, r = t.segmentInfo, i, a;
  r.template ? (a = xoe, i = gr(n, r.template)) : r.base ? (a = Iw, i = gr(n, r.base)) : r.list && (a = Soe, i = gr(n, r.list));
  var o = {
    attributes: n
  };
  if (!a)
    return o;
  var s = a(i, r.segmentTimeline);
  if (i.duration) {
    var l = i, u = l.duration, c = l.timescale, f = c === void 0 ? 1 : c;
    i.duration = u / f;
  } else
    s.length ? i.duration = s.reduce(function(d, h) {
      return Math.max(d, Math.ceil(h.duration));
    }, 0) : i.duration = 0;
  return o.attributes = i, o.segments = s, r.base && i.indexRange && (o.sidx = s[0], o.segments = []), o;
}, koe = function(t) {
  return t.map(Eoe);
}, mi = function(t, n) {
  return Hw(t.childNodes).filter(function(r) {
    var i = r.tagName;
    return i === n;
  });
}, a6 = function(t) {
  return t.textContent.trim();
}, gu = function(t) {
  var n = 31536e3, r = 30 * 24 * 60 * 60, i = 24 * 60 * 60, a = 60 * 60, o = 60, s = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/, l = s.exec(t);
  if (!l)
    return 0;
  var u = l.slice(1), c = u[0], f = u[1], d = u[2], h = u[3], p = u[4], y = u[5];
  return parseFloat(c || 0) * n + parseFloat(f || 0) * r + parseFloat(d || 0) * i + parseFloat(h || 0) * a + parseFloat(p || 0) * o + parseFloat(y || 0);
}, Ooe = function(t) {
  var n = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
  return n.test(t) && (t += "Z"), Date.parse(t);
}, Tm = {
  mediaPresentationDuration: function(t) {
    return gu(t);
  },
  availabilityStartTime: function(t) {
    return Ooe(t) / 1e3;
  },
  minimumUpdatePeriod: function(t) {
    return gu(t);
  },
  suggestedPresentationDelay: function(t) {
    return gu(t);
  },
  type: function(t) {
    return t;
  },
  timeShiftBufferDepth: function(t) {
    return gu(t);
  },
  start: function(t) {
    return gu(t);
  },
  width: function(t) {
    return parseInt(t, 10);
  },
  height: function(t) {
    return parseInt(t, 10);
  },
  bandwidth: function(t) {
    return parseInt(t, 10);
  },
  startNumber: function(t) {
    return parseInt(t, 10);
  },
  timescale: function(t) {
    return parseInt(t, 10);
  },
  presentationTimeOffset: function(t) {
    return parseInt(t, 10);
  },
  duration: function(t) {
    var n = parseInt(t, 10);
    return isNaN(n) ? gu(t) : n;
  },
  d: function(t) {
    return parseInt(t, 10);
  },
  t: function(t) {
    return parseInt(t, 10);
  },
  r: function(t) {
    return parseInt(t, 10);
  },
  DEFAULT: function(t) {
    return t;
  }
}, $i = function(t) {
  return t && t.attributes ? Hw(t.attributes).reduce(function(n, r) {
    var i = Tm[r.name] || Tm.DEFAULT;
    return n[r.name] = i(r.value), n;
  }, {}) : {};
}, zoe = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
}, n2 = function(t, n) {
  return n.length ? e2(t.map(function(r) {
    return n.map(function(i) {
      return Zh(r, a6(i));
    });
  })) : t;
}, o6 = function(t) {
  var n = mi(t, "SegmentTemplate")[0], r = mi(t, "SegmentList")[0], i = r && mi(r, "SegmentURL").map(function(d) {
    return gr({
      tag: "SegmentURL"
    }, $i(d));
  }), a = mi(t, "SegmentBase")[0], o = r || n, s = o && mi(o, "SegmentTimeline")[0], l = r || a || n, u = l && mi(l, "Initialization")[0], c = n && $i(n);
  c && u ? c.initialization = u && $i(u) : c && c.initialization && (c.initialization = {
    sourceURL: c.initialization
  });
  var f = {
    template: c,
    segmentTimeline: s && mi(s, "S").map(function(d) {
      return $i(d);
    }),
    list: r && gr($i(r), {
      segmentUrls: i,
      initialization: $i(u)
    }),
    base: a && gr($i(a), {
      initialization: $i(u)
    })
  };
  return Object.keys(f).forEach(function(d) {
    f[d] || delete f[d];
  }), f;
}, Doe = function(t, n, r) {
  return function(i) {
    var a = mi(i, "BaseURL"), o = n2(n, a), s = gr(t, $i(i)), l = o6(i);
    return o.map(function(u) {
      return {
        segmentInfo: gr(r, l),
        attributes: gr(s, {
          baseUrl: u
        })
      };
    });
  };
}, Moe = function(t) {
  return t.reduce(function(n, r) {
    var i = $i(r);
    i.schemeIdUri && (i.schemeIdUri = i.schemeIdUri.toLowerCase());
    var a = zoe[i.schemeIdUri];
    if (a) {
      n[a] = {
        attributes: i
      };
      var o = mi(r, "cenc:pssh")[0];
      if (o) {
        var s = a6(o);
        n[a].pssh = s && ew(s);
      }
    }
    return n;
  }, {});
}, Hoe = function(t) {
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
    var n = typeof t.value != "string" ? [] : t.value.split(";");
    return n.map(function(i) {
      var a, o;
      if (o = i, /^CC\d=/.test(i)) {
        var s = i.split("=");
        a = s[0], o = s[1];
      } else
        /^CC\d$/.test(i) && (a = i);
      return {
        channel: a,
        language: o
      };
    });
  } else if (t.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
    var r = typeof t.value != "string" ? [] : t.value.split(";");
    return r.map(function(i) {
      var a = {
        channel: void 0,
        language: void 0,
        aspectRatio: 1,
        easyReader: 0,
        "3D": 0
      };
      if (/=/.test(i)) {
        var o = i.split("="), s = o[0], l = o[1], u = l === void 0 ? "" : l;
        a.channel = s, a.language = i, u.split(",").forEach(function(c) {
          var f = c.split(":"), d = f[0], h = f[1];
          d === "lang" ? a.language = h : d === "er" ? a.easyReader = Number(h) : d === "war" ? a.aspectRatio = Number(h) : d === "3D" && (a["3D"] = Number(h));
        });
      } else
        a.language = i;
      return a.channel && (a.channel = "SERVICE" + a.channel), a;
    });
  }
}, Ioe = function(t, n, r) {
  return function(i) {
    var a = $i(i), o = n2(n, mi(i, "BaseURL")), s = mi(i, "Role")[0], l = {
      role: $i(s)
    }, u = gr(t, a, l), c = mi(i, "Accessibility")[0], f = Hoe($i(c));
    f && (u = gr(u, {
      captionServices: f
    }));
    var d = mi(i, "Label")[0];
    if (d && d.childNodes.length) {
      var h = d.childNodes[0].nodeValue.trim();
      u = gr(u, {
        label: h
      });
    }
    var p = Moe(mi(i, "ContentProtection"));
    Object.keys(p).length && (u = gr(u, {
      contentProtection: p
    }));
    var y = o6(i), m = mi(i, "Representation"), b = gr(r, y);
    return e2(m.map(Doe(u, o, b)));
  };
}, Loe = function(t, n) {
  return function(r, i) {
    var a = n2(n, mi(r.node, "BaseURL")), o = gr(t, {
      periodStart: r.attributes.start
    });
    typeof r.attributes.duration == "number" && (o.periodDuration = r.attributes.duration);
    var s = mi(r.node, "AdaptationSet"), l = o6(r.node);
    return e2(s.map(Ioe(o, a, l)));
  };
}, Boe = function(t) {
  var n = t.attributes, r = t.priorPeriodAttributes, i = t.mpdType;
  return typeof n.start == "number" ? n.start : r && typeof r.start == "number" && typeof r.duration == "number" ? r.start + r.duration : !r && i === "static" ? 0 : null;
}, Noe = function(t, n) {
  n === void 0 && (n = {});
  var r = n, i = r.manifestUri, a = i === void 0 ? "" : i, o = r.NOW, s = o === void 0 ? Date.now() : o, l = r.clientOffset, u = l === void 0 ? 0 : l, c = mi(t, "Period");
  if (!c.length)
    throw new Error($u.INVALID_NUMBER_OF_PERIOD);
  var f = mi(t, "Location"), d = $i(t), h = n2([a], mi(t, "BaseURL"));
  d.type = d.type || "static", d.sourceDuration = d.mediaPresentationDuration || 0, d.NOW = s, d.clientOffset = u, f.length && (d.locations = f.map(a6));
  var p = [];
  return c.forEach(function(y, m) {
    var b = $i(y), x = p[m - 1];
    b.start = Boe({
      attributes: b,
      priorPeriodAttributes: x ? x.attributes : null,
      mpdType: d.type
    }), p.push({
      node: y,
      attributes: b
    });
  }), {
    locations: d.locations,
    representationInfo: e2(p.map(Loe(d, h)))
  };
}, Nw = function(t) {
  if (t === "")
    throw new Error($u.DASH_EMPTY_MANIFEST);
  var n = new Qae(), r, i;
  try {
    r = n.parseFromString(t, "application/xml"), i = r && r.documentElement.tagName === "MPD" ? r.documentElement : null;
  } catch {
  }
  if (!i || i && i.getElementsByTagName("parsererror").length > 0)
    throw new Error($u.DASH_INVALID_XML);
  return i;
}, joe = function(t) {
  var n = mi(t, "UTCTiming")[0];
  if (!n)
    return null;
  var r = $i(n);
  switch (r.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      r.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      r.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      r.method = "DIRECT", r.value = Date.parse(r.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error($u.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return r;
}, Foe = function(t, n) {
  n === void 0 && (n = {});
  var r = Noe(Nw(t), n), i = koe(r.representationInfo);
  return boe({
    dashPlaylists: i,
    locations: r.locations,
    sidxMapping: n.sidxMapping,
    previousManifest: n.previousManifest
  });
}, Xoe = function(t) {
  return joe(Nw(t));
}, jw = Math.pow(2, 32), Roe = function(e) {
  var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n;
  return t.getBigUint64 ? (n = t.getBigUint64(0), n < Number.MAX_SAFE_INTEGER ? Number(n) : n) : t.getUint32(0) * jw + t.getUint32(4);
}, Voe = {
  getUint64: Roe,
  MAX_UINT32: jw
}, wm = Voe.getUint64, Uoe = function(e) {
  var t = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
    version: e[0],
    flags: new Uint8Array(e.subarray(1, 4)),
    references: [],
    referenceId: t.getUint32(4),
    timescale: t.getUint32(8)
  }, r = 12;
  n.version === 0 ? (n.earliestPresentationTime = t.getUint32(r), n.firstOffset = t.getUint32(r + 4), r += 8) : (n.earliestPresentationTime = wm(e.subarray(r)), n.firstOffset = wm(e.subarray(r + 8)), r += 16), r += 2;
  var i = t.getUint16(r);
  for (r += 2; i > 0; r += 12, i--)
    n.references.push({
      referenceType: (e[r] & 128) >>> 7,
      referencedSize: t.getUint32(r) & 2147483647,
      subsegmentDuration: t.getUint32(r + 4),
      startsWithSap: !!(e[r + 8] & 128),
      sapType: (e[r + 8] & 112) >>> 4,
      sapDeltaTime: t.getUint32(r + 8) & 268435455
    });
  return n;
}, qoe = Uoe, _oe = Kt([73, 68, 51]), Woe = function(t, n) {
  n === void 0 && (n = 0), t = Kt(t);
  var r = t[n + 5], i = t[n + 6] << 21 | t[n + 7] << 14 | t[n + 8] << 7 | t[n + 9], a = (r & 16) >> 4;
  return a ? i + 20 : i + 10;
}, ud = function e(t, n) {
  return n === void 0 && (n = 0), t = Kt(t), t.length - n < 10 || !oi(t, _oe, {
    offset: n
  }) ? n : (n += Woe(t, n), e(t, n));
}, Pm = function(t) {
  return typeof t == "string" ? aw(t) : t;
}, Koe = function(t) {
  return Array.isArray(t) ? t.map(function(n) {
    return Pm(n);
  }) : [Pm(t)];
}, Goe = function e(t, n, r) {
  r === void 0 && (r = !1), n = Koe(n), t = Kt(t);
  var i = [];
  if (!n.length)
    return i;
  for (var a = 0; a < t.length; ) {
    var o = (t[a] << 24 | t[a + 1] << 16 | t[a + 2] << 8 | t[a + 3]) >>> 0, s = t.subarray(a + 4, a + 8);
    if (o === 0)
      break;
    var l = a + o;
    if (l > t.length) {
      if (r)
        break;
      l = t.length;
    }
    var u = t.subarray(a + 8, l);
    oi(s, n[0]) && (n.length === 1 ? i.push(u) : i.push.apply(i, e(u, n.slice(1), r))), a = l;
  }
  return i;
}, w1 = {
  EBML: Kt([26, 69, 223, 163]),
  DocType: Kt([66, 130]),
  Segment: Kt([24, 83, 128, 103]),
  SegmentInfo: Kt([21, 73, 169, 102]),
  Tracks: Kt([22, 84, 174, 107]),
  Track: Kt([174]),
  TrackNumber: Kt([215]),
  DefaultDuration: Kt([35, 227, 131]),
  TrackEntry: Kt([174]),
  TrackType: Kt([131]),
  FlagDefault: Kt([136]),
  CodecID: Kt([134]),
  CodecPrivate: Kt([99, 162]),
  VideoTrack: Kt([224]),
  AudioTrack: Kt([225]),
  Cluster: Kt([31, 67, 182, 117]),
  Timestamp: Kt([231]),
  TimestampScale: Kt([42, 215, 177]),
  BlockGroup: Kt([160]),
  BlockDuration: Kt([155]),
  Block: Kt([161]),
  SimpleBlock: Kt([163])
}, h4 = [128, 64, 32, 16, 8, 4, 2, 1], Yoe = function(t) {
  for (var n = 1, r = 0; r < h4.length && !(t & h4[r]); r++)
    n++;
  return n;
}, Z0 = function(t, n, r, i) {
  r === void 0 && (r = !0), i === void 0 && (i = !1);
  var a = Yoe(t[n]), o = t.subarray(n, n + a);
  return r && (o = Array.prototype.slice.call(t, n, n + a), o[0] ^= h4[a - 1]), {
    length: a,
    value: Pae(o, {
      signed: i
    }),
    bytes: o
  };
}, xm = function e(t) {
  return typeof t == "string" ? t.match(/.{1,2}/g).map(function(n) {
    return e(n);
  }) : typeof t == "number" ? xae(t) : t;
}, Qoe = function(t) {
  return Array.isArray(t) ? t.map(function(n) {
    return xm(n);
  }) : [xm(t)];
}, Zoe = function e(t, n, r) {
  if (r >= n.length)
    return n.length;
  var i = Z0(n, r, !1);
  if (oi(t.bytes, i.bytes))
    return r;
  var a = Z0(n, r + i.length);
  return e(t, n, r + a.length + a.value + i.length);
}, Cm = function e(t, n) {
  n = Qoe(n), t = Kt(t);
  var r = [];
  if (!n.length)
    return r;
  for (var i = 0; i < t.length; ) {
    var a = Z0(t, i, !1), o = Z0(t, i + a.length), s = i + a.length + o.length;
    o.value === 127 && (o.value = Zoe(a, t, s), o.value !== t.length && (o.value -= s));
    var l = s + o.value > t.length ? t.length : s + o.value, u = t.subarray(s, l);
    oi(n[0], a.bytes) && (n.length === 1 ? r.push(u) : r = r.concat(e(u, n.slice(1))));
    var c = a.length + o.length + u.length;
    i += c;
  }
  return r;
}, Joe = Kt([0, 0, 0, 1]), $oe = Kt([0, 0, 1]), ese = Kt([0, 0, 3]), tse = function(t) {
  for (var n = [], r = 1; r < t.length - 2; )
    oi(t.subarray(r, r + 3), ese) && (n.push(r + 2), r++), r++;
  if (n.length === 0)
    return t;
  var i = t.length - n.length, a = new Uint8Array(i), o = 0;
  for (r = 0; r < i; o++, r++)
    o === n[0] && (o++, n.shift()), a[r] = t[o];
  return a;
}, Fw = function(t, n, r, i) {
  i === void 0 && (i = 1 / 0), t = Kt(t), r = [].concat(r);
  for (var a = 0, o, s = 0; a < t.length && (s < i || o); ) {
    var l = void 0;
    if (oi(t.subarray(a), Joe) ? l = 4 : oi(t.subarray(a), $oe) && (l = 3), !l) {
      a++;
      continue;
    }
    if (s++, o)
      return tse(t.subarray(o, a));
    var u = void 0;
    n === "h264" ? u = t[a + l] & 31 : n === "h265" && (u = t[a + l] >> 1 & 63), r.indexOf(u) !== -1 && (o = a + l), a += l + (n === "h264" ? 1 : 2);
  }
  return t.subarray(0, 0);
}, nse = function(t, n, r) {
  return Fw(t, "h264", n, r);
}, ise = function(t, n, r) {
  return Fw(t, "h265", n, r);
}, hr = {
  webm: Kt([119, 101, 98, 109]),
  matroska: Kt([109, 97, 116, 114, 111, 115, 107, 97]),
  flac: Kt([102, 76, 97, 67]),
  ogg: Kt([79, 103, 103, 83]),
  ac3: Kt([11, 119]),
  riff: Kt([82, 73, 70, 70]),
  avi: Kt([65, 86, 73]),
  wav: Kt([87, 65, 86, 69]),
  "3gp": Kt([102, 116, 121, 112, 51, 103]),
  mp4: Kt([102, 116, 121, 112]),
  fmp4: Kt([115, 116, 121, 112]),
  mov: Kt([102, 116, 121, 112, 113, 116]),
  moov: Kt([109, 111, 111, 118]),
  moof: Kt([109, 111, 111, 102])
}, ec = {
  aac: function(t) {
    var n = ud(t);
    return oi(t, [255, 16], {
      offset: n,
      mask: [255, 22]
    });
  },
  mp3: function(t) {
    var n = ud(t);
    return oi(t, [255, 2], {
      offset: n,
      mask: [255, 6]
    });
  },
  webm: function(t) {
    var n = Cm(t, [w1.EBML, w1.DocType])[0];
    return oi(n, hr.webm);
  },
  mkv: function(t) {
    var n = Cm(t, [w1.EBML, w1.DocType])[0];
    return oi(n, hr.matroska);
  },
  mp4: function(t) {
    if (ec["3gp"](t) || ec.mov(t))
      return !1;
    if (oi(t, hr.mp4, {
      offset: 4
    }) || oi(t, hr.fmp4, {
      offset: 4
    }) || oi(t, hr.moof, {
      offset: 4
    }) || oi(t, hr.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(t) {
    return oi(t, hr.mov, {
      offset: 4
    });
  },
  "3gp": function(t) {
    return oi(t, hr["3gp"], {
      offset: 4
    });
  },
  ac3: function(t) {
    var n = ud(t);
    return oi(t, hr.ac3, {
      offset: n
    });
  },
  ts: function(t) {
    if (t.length < 189 && t.length >= 1)
      return t[0] === 71;
    for (var n = 0; n + 188 < t.length && n < 188; ) {
      if (t[n] === 71 && t[n + 188] === 71)
        return !0;
      n += 1;
    }
    return !1;
  },
  flac: function(t) {
    var n = ud(t);
    return oi(t, hr.flac, {
      offset: n
    });
  },
  ogg: function(t) {
    return oi(t, hr.ogg);
  },
  avi: function(t) {
    return oi(t, hr.riff) && oi(t, hr.avi, {
      offset: 8
    });
  },
  wav: function(t) {
    return oi(t, hr.riff) && oi(t, hr.wav, {
      offset: 8
    });
  },
  h264: function(t) {
    return nse(t, 7, 3).length;
  },
  h265: function(t) {
    return ise(t, [32, 33], 3).length;
  }
}, p4 = Object.keys(ec).filter(function(e) {
  return e !== "ts" && e !== "h264" && e !== "h265";
}).concat(["ts", "h264", "h265"]);
p4.forEach(function(e) {
  var t = ec[e];
  ec[e] = function(n) {
    return t(Kt(n));
  };
});
var rse = ec, s6 = function(t) {
  t = Kt(t);
  for (var n = 0; n < p4.length; n++) {
    var r = p4[n];
    if (rse[r](t))
      return r;
  }
  return "";
}, ase = function(t) {
  return Goe(t, ["moof"]).length > 0;
}, l6 = 9e4, u6, c6, i2, d6, Xw, Rw, Vw;
u6 = function(e) {
  return e * l6;
};
c6 = function(e, t) {
  return e * t;
};
i2 = function(e) {
  return e / l6;
};
d6 = function(e, t) {
  return e / t;
};
Xw = function(e, t) {
  return u6(d6(e, t));
};
Rw = function(e, t) {
  return c6(i2(e), t);
};
Vw = function(e, t, n) {
  return i2(n ? e : e - t);
};
var J0 = {
  ONE_SECOND_IN_TS: l6,
  secondsToVideoTs: u6,
  secondsToAudioTs: c6,
  videoTsToSeconds: i2,
  audioTsToSeconds: d6,
  audioTsToVideoTs: Xw,
  videoTsToAudioTs: Rw,
  metadataTsToSeconds: Vw
};
/**
 * @license
 * Video.js 7.20.2 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var Uw = "7.20.2", Io = {}, Ns = function(t, n) {
  return Io[t] = Io[t] || [], n && (Io[t] = Io[t].concat(n)), Io[t];
}, ose = function(t, n) {
  Ns(t, n);
}, qw = function(t, n) {
  var r = Ns(t).indexOf(n);
  return r <= -1 ? !1 : (Io[t] = Io[t].slice(), Io[t].splice(r, 1), !0);
}, sse = function(t, n) {
  Ns(t, [].concat(n).map(function(r) {
    var i = function a() {
      return qw(t, a), r.apply(void 0, arguments);
    };
    return i;
  }));
}, $0 = {
  prefixed: !0
}, m0 = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
  ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
  ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
], Sm = m0[0], cd;
for (var P1 = 0; P1 < m0.length; P1++)
  if (m0[P1][1] in ft) {
    cd = m0[P1];
    break;
  }
if (cd) {
  for (var x1 = 0; x1 < cd.length; x1++)
    $0[Sm[x1]] = cd[x1];
  $0.prefixed = cd[0] !== Sm[0];
}
var Or = [], lse = function(t, n) {
  return function(r, i, a) {
    var o = n.levels[i], s = new RegExp("^(" + o + ")$");
    if (r !== "log" && a.unshift(r.toUpperCase() + ":"), a.unshift(t + ":"), Or) {
      Or.push([].concat(a));
      var l = Or.length - 1e3;
      Or.splice(0, l > 0 ? l : 0);
    }
    if (!!pe.console) {
      var u = pe.console[r];
      !u && r === "debug" && (u = pe.console.info || pe.console.log), !(!u || !o || !s.test(r)) && u[Array.isArray(a) ? "apply" : "call"](pe.console, a);
    }
  };
};
function _w(e) {
  var t = "info", n, r = function() {
    for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++)
      o[s] = arguments[s];
    n("log", t, o);
  };
  return n = lse(e, r), r.createLogger = function(i) {
    return _w(e + ": " + i);
  }, r.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: t
  }, r.level = function(i) {
    if (typeof i == "string") {
      if (!r.levels.hasOwnProperty(i))
        throw new Error('"' + i + '" in not a valid log level');
      t = i;
    }
    return t;
  }, r.history = function() {
    return Or ? [].concat(Or) : [];
  }, r.history.filter = function(i) {
    return (Or || []).filter(function(a) {
      return new RegExp(".*" + i + ".*").test(a[0]);
    });
  }, r.history.clear = function() {
    Or && (Or.length = 0);
  }, r.history.disable = function() {
    Or !== null && (Or.length = 0, Or = null);
  }, r.history.enable = function() {
    Or === null && (Or = []);
  }, r.error = function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n("error", t, a);
  }, r.warn = function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n("warn", t, a);
  }, r.debug = function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return n("debug", t, a);
  }, r;
}
var pn = _w("VIDEOJS"), Ww = pn.createLogger, use = Object.prototype.toString, Kw = function(t) {
  return Go(t) ? Object.keys(t) : [];
};
function Iu(e, t) {
  Kw(e).forEach(function(n) {
    return t(e[n], n);
  });
}
function cse(e, t, n) {
  return n === void 0 && (n = 0), Kw(e).reduce(function(r, i) {
    return t(r, e[i], i);
  }, n);
}
function ci(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return Object.assign ? Ta.apply(void 0, [e].concat(n)) : (n.forEach(function(i) {
    !i || Iu(i, function(a, o) {
      e[o] = a;
    });
  }), e);
}
function Go(e) {
  return !!e && typeof e == "object";
}
function ef(e) {
  return Go(e) && use.call(e) === "[object Object]" && e.constructor === Object;
}
function tf(e, t) {
  if (!e || !t)
    return "";
  if (typeof pe.getComputedStyle == "function") {
    var n;
    try {
      n = pe.getComputedStyle(e);
    } catch {
      return "";
    }
    return n ? n.getPropertyValue(t) || n[t] : "";
  }
  return "";
}
var Li = pe.navigator && pe.navigator.userAgent || "", Em = /AppleWebKit\/([\d.]+)/i.exec(Li), dse = Em ? parseFloat(Em.pop()) : null, Gw = /iPod/i.test(Li), fse = function() {
  var e = Li.match(/OS (\d+)_/i);
  return e && e[1] ? e[1] : null;
}(), rs = /Android/i.test(Li), f6 = function() {
  var e = Li.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
  if (!e)
    return null;
  var t = e[1] && parseFloat(e[1]), n = e[2] && parseFloat(e[2]);
  return t && n ? parseFloat(e[1] + "." + e[2]) : t || null;
}(), Yw = rs && f6 < 5 && dse < 537, Qw = /Firefox/i.test(Li), Sf = /Edg/i.test(Li), as = !Sf && (/Chrome/i.test(Li) || /CriOS/i.test(Li)), Zw = function() {
  var e = Li.match(/(Chrome|CriOS)\/(\d+)/);
  return e && e[2] ? parseFloat(e[2]) : null;
}(), Ef = function() {
  var e = /MSIE\s(\d+)\.\d/.exec(Li), t = e && parseFloat(e[1]);
  return !t && /Trident\/7.0/i.test(Li) && /rv:11.0/.test(Li) && (t = 11), t;
}(), h6 = /Safari/i.test(Li) && !as && !rs && !Sf, Jw = /Windows/i.test(Li), tc = Boolean(Cc() && ("ontouchstart" in pe || pe.navigator.maxTouchPoints || pe.DocumentTouch && pe.document instanceof pe.DocumentTouch)), p6 = /iPad/i.test(Li) || h6 && tc && !/iPhone/i.test(Li), v6 = /iPhone/i.test(Li) && !p6, Ar = v6 || p6 || Gw, r2 = (h6 || Ar) && !as, hse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  IS_IPOD: Gw,
  IOS_VERSION: fse,
  IS_ANDROID: rs,
  ANDROID_VERSION: f6,
  IS_NATIVE_ANDROID: Yw,
  IS_FIREFOX: Qw,
  IS_EDGE: Sf,
  IS_CHROME: as,
  CHROME_VERSION: Zw,
  IE_VERSION: Ef,
  IS_SAFARI: h6,
  IS_WINDOWS: Jw,
  TOUCH_ENABLED: tc,
  IS_IPAD: p6,
  IS_IPHONE: v6,
  IS_IOS: Ar,
  IS_ANY_SAFARI: r2
});
function km(e) {
  return typeof e == "string" && Boolean(e.trim());
}
function $w(e) {
  if (e.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function pse(e) {
  return new RegExp("(^|\\s)" + e + "($|\\s)");
}
function Cc() {
  return ft === pe.document;
}
function Sc(e) {
  return Go(e) && e.nodeType === 1;
}
function eP() {
  try {
    return pe.parent !== pe.self;
  } catch {
    return !0;
  }
}
function tP(e) {
  return function(t, n) {
    if (!km(t))
      return ft[e](null);
    km(n) && (n = ft.querySelector(n));
    var r = Sc(n) ? n : ft;
    return r[e] && r[e](t);
  };
}
function En(e, t, n, r) {
  e === void 0 && (e = "div"), t === void 0 && (t = {}), n === void 0 && (n = {});
  var i = ft.createElement(e);
  return Object.getOwnPropertyNames(t).forEach(function(a) {
    var o = t[a];
    a.indexOf("aria-") !== -1 || a === "role" || a === "type" ? (pn.warn(`Setting attributes in the second argument of createEl()
has been deprecated. Use the third argument instead.
` + ("createEl(type, properties, attributes). Attempting to set " + a + " to " + o + ".")), i.setAttribute(a, o)) : a === "textContent" ? _l(i, o) : (i[a] !== o || a === "tabIndex") && (i[a] = o);
  }), Object.getOwnPropertyNames(n).forEach(function(a) {
    i.setAttribute(a, n[a]);
  }), r && g6(i, r), i;
}
function _l(e, t) {
  return typeof e.textContent > "u" ? e.innerText = t : e.textContent = t, e;
}
function v4(e, t) {
  t.firstChild ? t.insertBefore(e, t.firstChild) : t.appendChild(e);
}
function Sl(e, t) {
  return $w(t), e.classList ? e.classList.contains(t) : pse(t).test(e.className);
}
function Xo(e, t) {
  return e.classList ? e.classList.add(t) : Sl(e, t) || (e.className = (e.className + " " + t).trim()), e;
}
function kf(e, t) {
  return e ? (e.classList ? e.classList.remove(t) : ($w(t), e.className = e.className.split(/\s+/).filter(function(n) {
    return n !== t;
  }).join(" ")), e) : (pn.warn("removeClass was called with an element that doesn't exist"), null);
}
function nP(e, t, n) {
  var r = Sl(e, t);
  if (typeof n == "function" && (n = n(e, t)), typeof n != "boolean" && (n = !r), n !== r)
    return n ? Xo(e, t) : kf(e, t), e;
}
function iP(e, t) {
  Object.getOwnPropertyNames(t).forEach(function(n) {
    var r = t[n];
    r === null || typeof r > "u" || r === !1 ? e.removeAttribute(n) : e.setAttribute(n, r === !0 ? "" : r);
  });
}
function ko(e) {
  var t = {}, n = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
  if (e && e.attributes && e.attributes.length > 0)
    for (var r = e.attributes, i = r.length - 1; i >= 0; i--) {
      var a = r[i].name, o = r[i].value;
      (typeof e[a] == "boolean" || n.indexOf("," + a + ",") !== -1) && (o = o !== null), t[a] = o;
    }
  return t;
}
function rP(e, t) {
  return e.getAttribute(t);
}
function nc(e, t, n) {
  e.setAttribute(t, n);
}
function a2(e, t) {
  e.removeAttribute(t);
}
function aP() {
  ft.body.focus(), ft.onselectstart = function() {
    return !1;
  };
}
function oP() {
  ft.onselectstart = function() {
    return !0;
  };
}
function ic(e) {
  if (e && e.getBoundingClientRect && e.parentNode) {
    var t = e.getBoundingClientRect(), n = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach(function(r) {
      t[r] !== void 0 && (n[r] = t[r]);
    }), n.height || (n.height = parseFloat(tf(e, "height"))), n.width || (n.width = parseFloat(tf(e, "width"))), n;
  }
}
function nf(e) {
  if (!e || e && !e.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  for (var t = e.offsetWidth, n = e.offsetHeight, r = 0, i = 0; e.offsetParent && e !== ft[$0.fullscreenElement]; )
    r += e.offsetLeft, i += e.offsetTop, e = e.offsetParent;
  return {
    left: r,
    top: i,
    width: t,
    height: n
  };
}
function o2(e, t) {
  var n = {
    x: 0,
    y: 0
  };
  if (Ar)
    for (var r = e; r && r.nodeName.toLowerCase() !== "html"; ) {
      var i = tf(r, "transform");
      if (/^matrix/.test(i)) {
        var a = i.slice(7, -1).split(/,\s/).map(Number);
        n.x += a[4], n.y += a[5];
      } else if (/^matrix3d/.test(i)) {
        var o = i.slice(9, -1).split(/,\s/).map(Number);
        n.x += o[12], n.y += o[13];
      }
      r = r.parentNode;
    }
  var s = {}, l = nf(t.target), u = nf(e), c = u.width, f = u.height, d = t.offsetY - (u.top - l.top), h = t.offsetX - (u.left - l.left);
  return t.changedTouches && (h = t.changedTouches[0].pageX - u.left, d = t.changedTouches[0].pageY + u.top, Ar && (h -= n.x, d -= n.y)), s.y = 1 - Math.max(0, Math.min(1, d / f)), s.x = Math.max(0, Math.min(1, h / c)), s;
}
function sP(e) {
  return Go(e) && e.nodeType === 3;
}
function m6(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
  return e;
}
function lP(e) {
  return typeof e == "function" && (e = e()), (Array.isArray(e) ? e : [e]).map(function(t) {
    if (typeof t == "function" && (t = t()), Sc(t) || sP(t))
      return t;
    if (typeof t == "string" && /\S/.test(t))
      return ft.createTextNode(t);
  }).filter(function(t) {
    return t;
  });
}
function g6(e, t) {
  return lP(t).forEach(function(n) {
    return e.appendChild(n);
  }), e;
}
function uP(e, t) {
  return g6(m6(e), t);
}
function rf(e) {
  return e.button === void 0 && e.buttons === void 0 || e.button === 0 && e.buttons === void 0 || e.type === "mouseup" && e.button === 0 && e.buttons === 0 ? !0 : !(e.button !== 0 || e.buttons !== 1);
}
var js = tP("querySelector"), cP = tP("querySelectorAll"), dP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: Cc,
  isEl: Sc,
  isInFrame: eP,
  createEl: En,
  textContent: _l,
  prependTo: v4,
  hasClass: Sl,
  addClass: Xo,
  removeClass: kf,
  toggleClass: nP,
  setAttributes: iP,
  getAttributes: ko,
  getAttribute: rP,
  setAttribute: nc,
  removeAttribute: a2,
  blockTextSelection: aP,
  unblockTextSelection: oP,
  getBoundingClientRect: ic,
  findPosition: nf,
  getPointerPosition: o2,
  isTextNode: sP,
  emptyEl: m6,
  normalizeContent: lP,
  appendContent: g6,
  insertContent: uP,
  isSingleLeftClick: rf,
  $: js,
  $$: cP
}), fP = !1, m4, vse = function() {
  if (m4.options.autoSetup !== !1) {
    var t = Array.prototype.slice.call(ft.getElementsByTagName("video")), n = Array.prototype.slice.call(ft.getElementsByTagName("audio")), r = Array.prototype.slice.call(ft.getElementsByTagName("video-js")), i = t.concat(n, r);
    if (i && i.length > 0)
      for (var a = 0, o = i.length; a < o; a++) {
        var s = i[a];
        if (s && s.getAttribute) {
          if (s.player === void 0) {
            var l = s.getAttribute("data-setup");
            l !== null && m4(s);
          }
        } else {
          g4(1);
          break;
        }
      }
    else
      fP || g4(1);
  }
};
function g4(e, t) {
  !Cc() || (t && (m4 = t), pe.setTimeout(vse, e));
}
function y4() {
  fP = !0, pe.removeEventListener("load", y4);
}
Cc() && (ft.readyState === "complete" ? y4() : pe.addEventListener("load", y4));
var hP = function(t) {
  var n = ft.createElement("style");
  return n.className = t, n;
}, pP = function(t, n) {
  t.styleSheet ? t.styleSheet.cssText = n : t.textContent = n;
}, mse = 3, gse = mse;
function os() {
  return gse++;
}
var vP;
pe.WeakMap || (vP = /* @__PURE__ */ function() {
  function e() {
    this.vdata = "vdata" + Math.floor(pe.performance && pe.performance.now() || Date.now()), this.data = {};
  }
  var t = e.prototype;
  return t.set = function(r, i) {
    var a = r[this.vdata] || os();
    return r[this.vdata] || (r[this.vdata] = a), this.data[a] = i, this;
  }, t.get = function(r) {
    var i = r[this.vdata];
    if (i)
      return this.data[i];
    pn("We have no data for this element", r);
  }, t.has = function(r) {
    var i = r[this.vdata];
    return i in this.data;
  }, t.delete = function(r) {
    var i = r[this.vdata];
    i && (delete this.data[i], delete r[this.vdata]);
  }, e;
}());
var yr = pe.WeakMap ? /* @__PURE__ */ new WeakMap() : new vP();
function Om(e, t) {
  if (!!yr.has(e)) {
    var n = yr.get(e);
    n.handlers[t].length === 0 && (delete n.handlers[t], e.removeEventListener ? e.removeEventListener(t, n.dispatcher, !1) : e.detachEvent && e.detachEvent("on" + t, n.dispatcher)), Object.getOwnPropertyNames(n.handlers).length <= 0 && (delete n.handlers, delete n.dispatcher, delete n.disabled), Object.getOwnPropertyNames(n).length === 0 && yr.delete(e);
  }
}
function y6(e, t, n, r) {
  n.forEach(function(i) {
    e(t, i, r);
  });
}
function s2(e) {
  if (e.fixed_)
    return e;
  function t() {
    return !0;
  }
  function n() {
    return !1;
  }
  if (!e || !e.isPropagationStopped || !e.isImmediatePropagationStopped) {
    var r = e || pe.event;
    e = {};
    for (var i in r)
      i !== "layerX" && i !== "layerY" && i !== "keyLocation" && i !== "webkitMovementX" && i !== "webkitMovementY" && i !== "path" && (i === "returnValue" && r.preventDefault || (e[i] = r[i]));
    if (e.target || (e.target = e.srcElement || ft), e.relatedTarget || (e.relatedTarget = e.fromElement === e.target ? e.toElement : e.fromElement), e.preventDefault = function() {
      r.preventDefault && r.preventDefault(), e.returnValue = !1, r.returnValue = !1, e.defaultPrevented = !0;
    }, e.defaultPrevented = !1, e.stopPropagation = function() {
      r.stopPropagation && r.stopPropagation(), e.cancelBubble = !0, r.cancelBubble = !0, e.isPropagationStopped = t;
    }, e.isPropagationStopped = n, e.stopImmediatePropagation = function() {
      r.stopImmediatePropagation && r.stopImmediatePropagation(), e.isImmediatePropagationStopped = t, e.stopPropagation();
    }, e.isImmediatePropagationStopped = n, e.clientX !== null && e.clientX !== void 0) {
      var a = ft.documentElement, o = ft.body;
      e.pageX = e.clientX + (a && a.scrollLeft || o && o.scrollLeft || 0) - (a && a.clientLeft || o && o.clientLeft || 0), e.pageY = e.clientY + (a && a.scrollTop || o && o.scrollTop || 0) - (a && a.clientTop || o && o.clientTop || 0);
    }
    e.which = e.charCode || e.keyCode, e.button !== null && e.button !== void 0 && (e.button = e.button & 1 ? 0 : e.button & 4 ? 1 : e.button & 2 ? 2 : 0);
  }
  return e.fixed_ = !0, e;
}
var C1, yse = function() {
  if (typeof C1 != "boolean") {
    C1 = !1;
    try {
      var t = Object.defineProperty({}, "passive", {
        get: function() {
          C1 = !0;
        }
      });
      pe.addEventListener("test", null, t), pe.removeEventListener("test", null, t);
    } catch {
    }
  }
  return C1;
}, bse = ["touchstart", "touchmove"];
function ea(e, t, n) {
  if (Array.isArray(t))
    return y6(ea, e, t, n);
  yr.has(e) || yr.set(e, {});
  var r = yr.get(e);
  if (r.handlers || (r.handlers = {}), r.handlers[t] || (r.handlers[t] = []), n.guid || (n.guid = os()), r.handlers[t].push(n), r.dispatcher || (r.disabled = !1, r.dispatcher = function(a, o) {
    if (!r.disabled) {
      a = s2(a);
      var s = r.handlers[a.type];
      if (s)
        for (var l = s.slice(0), u = 0, c = l.length; u < c && !a.isImmediatePropagationStopped(); u++)
          try {
            l[u].call(e, a, o);
          } catch (f) {
            pn.error(f);
          }
    }
  }), r.handlers[t].length === 1)
    if (e.addEventListener) {
      var i = !1;
      yse() && bse.indexOf(t) > -1 && (i = {
        passive: !0
      }), e.addEventListener(t, r.dispatcher, i);
    } else
      e.attachEvent && e.attachEvent("on" + t, r.dispatcher);
}
function nr(e, t, n) {
  if (!!yr.has(e)) {
    var r = yr.get(e);
    if (!!r.handlers) {
      if (Array.isArray(t))
        return y6(nr, e, t, n);
      var i = function(u, c) {
        r.handlers[c] = [], Om(u, c);
      };
      if (t === void 0) {
        for (var a in r.handlers)
          Object.prototype.hasOwnProperty.call(r.handlers || {}, a) && i(e, a);
        return;
      }
      var o = r.handlers[t];
      if (!!o) {
        if (!n) {
          i(e, t);
          return;
        }
        if (n.guid)
          for (var s = 0; s < o.length; s++)
            o[s].guid === n.guid && o.splice(s--, 1);
        Om(e, t);
      }
    }
  }
}
function Ec(e, t, n) {
  var r = yr.has(e) ? yr.get(e) : {}, i = e.parentNode || e.ownerDocument;
  if (typeof t == "string" ? t = {
    type: t,
    target: e
  } : t.target || (t.target = e), t = s2(t), r.dispatcher && r.dispatcher.call(e, t, n), i && !t.isPropagationStopped() && t.bubbles === !0)
    Ec.call(null, i, t, n);
  else if (!i && !t.defaultPrevented && t.target && t.target[t.type]) {
    yr.has(t.target) || yr.set(t.target, {});
    var a = yr.get(t.target);
    t.target[t.type] && (a.disabled = !0, typeof t.target[t.type] == "function" && t.target[t.type](), a.disabled = !1);
  }
  return !t.defaultPrevented;
}
function l2(e, t, n) {
  if (Array.isArray(t))
    return y6(l2, e, t, n);
  var r = function i() {
    nr(e, t, i), n.apply(this, arguments);
  };
  r.guid = n.guid = n.guid || os(), ea(e, t, r);
}
function mP(e, t, n) {
  var r = function i() {
    nr(e, t, i), n.apply(this, arguments);
  };
  r.guid = n.guid = n.guid || os(), ea(e, t, r);
}
var Ase = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: s2,
  on: ea,
  off: nr,
  trigger: Ec,
  one: l2,
  any: mP
}), Ka = 30, ei = function(t, n, r) {
  n.guid || (n.guid = os());
  var i = n.bind(t);
  return i.guid = r ? r + "_" + n.guid : n.guid, i;
}, Yo = function(t, n) {
  var r = pe.performance.now(), i = function() {
    var o = pe.performance.now();
    o - r >= n && (t.apply(void 0, arguments), r = o);
  };
  return i;
}, Tse = function(t, n, r, i) {
  i === void 0 && (i = pe);
  var a, o = function() {
    i.clearTimeout(a), a = null;
  }, s = function() {
    var u = this, c = arguments, f = function() {
      a = null, f = null, r || t.apply(u, c);
    };
    !a && r && t.apply(u, c), i.clearTimeout(a), a = i.setTimeout(f, n);
  };
  return s.cancel = o, s;
}, ji = function() {
};
ji.prototype.allowedEvents_ = {};
ji.prototype.on = function(e, t) {
  var n = this.addEventListener;
  this.addEventListener = function() {
  }, ea(this, e, t), this.addEventListener = n;
};
ji.prototype.addEventListener = ji.prototype.on;
ji.prototype.off = function(e, t) {
  nr(this, e, t);
};
ji.prototype.removeEventListener = ji.prototype.off;
ji.prototype.one = function(e, t) {
  var n = this.addEventListener;
  this.addEventListener = function() {
  }, l2(this, e, t), this.addEventListener = n;
};
ji.prototype.any = function(e, t) {
  var n = this.addEventListener;
  this.addEventListener = function() {
  }, mP(this, e, t), this.addEventListener = n;
};
ji.prototype.trigger = function(e) {
  var t = e.type || e;
  typeof e == "string" && (e = {
    type: t
  }), e = s2(e), this.allowedEvents_[t] && this["on" + t] && this["on" + t](e), Ec(this, e);
};
ji.prototype.dispatchEvent = ji.prototype.trigger;
var ed;
ji.prototype.queueTrigger = function(e) {
  var t = this;
  ed || (ed = /* @__PURE__ */ new Map());
  var n = e.type || e, r = ed.get(this);
  r || (r = /* @__PURE__ */ new Map(), ed.set(this, r));
  var i = r.get(n);
  r.delete(n), pe.clearTimeout(i);
  var a = pe.setTimeout(function() {
    r.size === 0 && (r = null, ed.delete(t)), t.trigger(e);
  }, 0);
  r.set(n, a);
};
var u2 = function(t) {
  return typeof t.name == "function" ? t.name() : typeof t.name == "string" ? t.name : t.name_ ? t.name_ : t.constructor && t.constructor.name ? t.constructor.name : typeof t;
}, Ro = function(t) {
  return t instanceof ji || !!t.eventBusEl_ && ["on", "one", "off", "trigger"].every(function(n) {
    return typeof t[n] == "function";
  });
}, wse = function(t, n) {
  Ro(t) ? n() : (t.eventedCallbacks || (t.eventedCallbacks = []), t.eventedCallbacks.push(n));
}, b4 = function(t) {
  return typeof t == "string" && /\S/.test(t) || Array.isArray(t) && !!t.length;
}, eh = function(t, n, r) {
  if (!t || !t.nodeName && !Ro(t))
    throw new Error("Invalid target for " + u2(n) + "#" + r + "; must be a DOM node or evented object.");
}, gP = function(t, n, r) {
  if (!b4(t))
    throw new Error("Invalid event type for " + u2(n) + "#" + r + "; must be a non-empty string or array.");
}, yP = function(t, n, r) {
  if (typeof t != "function")
    throw new Error("Invalid listener for " + u2(n) + "#" + r + "; must be a function.");
}, Bp = function(t, n, r) {
  var i = n.length < 3 || n[0] === t || n[0] === t.eventBusEl_, a, o, s;
  return i ? (a = t.eventBusEl_, n.length >= 3 && n.shift(), o = n[0], s = n[1]) : (a = n[0], o = n[1], s = n[2]), eh(a, t, r), gP(o, t, r), yP(s, t, r), s = ei(t, s), {
    isTargetingSelf: i,
    target: a,
    type: o,
    listener: s
  };
}, rl = function(t, n, r, i) {
  eh(t, t, n), t.nodeName ? Ase[n](t, r, i) : t[n](r, i);
}, Pse = {
  on: function() {
    for (var t = this, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var a = Bp(this, r, "on"), o = a.isTargetingSelf, s = a.target, l = a.type, u = a.listener;
    if (rl(s, "on", l, u), !o) {
      var c = function() {
        return t.off(s, l, u);
      };
      c.guid = u.guid;
      var f = function() {
        return t.off("dispose", c);
      };
      f.guid = u.guid, rl(this, "on", "dispose", c), rl(s, "on", "dispose", f);
    }
  },
  one: function() {
    for (var t = this, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var a = Bp(this, r, "one"), o = a.isTargetingSelf, s = a.target, l = a.type, u = a.listener;
    if (o)
      rl(s, "one", l, u);
    else {
      var c = function f() {
        t.off(s, l, f);
        for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
          h[p] = arguments[p];
        u.apply(null, h);
      };
      c.guid = u.guid, rl(s, "one", l, c);
    }
  },
  any: function() {
    for (var t = this, n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var a = Bp(this, r, "any"), o = a.isTargetingSelf, s = a.target, l = a.type, u = a.listener;
    if (o)
      rl(s, "any", l, u);
    else {
      var c = function f() {
        t.off(s, l, f);
        for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
          h[p] = arguments[p];
        u.apply(null, h);
      };
      c.guid = u.guid, rl(s, "any", l, c);
    }
  },
  off: function(t, n, r) {
    if (!t || b4(t))
      nr(this.eventBusEl_, t, n);
    else {
      var i = t, a = n;
      eh(i, this, "off"), gP(a, this, "off"), yP(r, this, "off"), r = ei(this, r), this.off("dispose", r), i.nodeName ? (nr(i, a, r), nr(i, "dispose", r)) : Ro(i) && (i.off(a, r), i.off("dispose", r));
    }
  },
  trigger: function(t, n) {
    eh(this.eventBusEl_, this, "trigger");
    var r = t && typeof t != "string" ? t.type : t;
    if (!b4(r)) {
      var i = "Invalid event type for " + u2(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
      if (t)
        (this.log || pn).error(i);
      else
        throw new Error(i);
    }
    return Ec(this.eventBusEl_, t, n);
  }
};
function b6(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.eventBusKey;
  if (r) {
    if (!e[r].nodeName)
      throw new Error('The eventBusKey "' + r + '" does not refer to an element.');
    e.eventBusEl_ = e[r];
  } else
    e.eventBusEl_ = En("span", {
      className: "vjs-event-bus"
    });
  return ci(e, Pse), e.eventedCallbacks && e.eventedCallbacks.forEach(function(i) {
    i();
  }), e.on("dispose", function() {
    e.off(), [e, e.el_, e.eventBusEl_].forEach(function(i) {
      i && yr.has(i) && yr.delete(i);
    }), pe.setTimeout(function() {
      e.eventBusEl_ = null;
    }, 0);
  }), e;
}
var xse = {
  state: {},
  setState: function(t) {
    var n = this;
    typeof t == "function" && (t = t());
    var r;
    return Iu(t, function(i, a) {
      n.state[a] !== i && (r = r || {}, r[a] = {
        from: n.state[a],
        to: i
      }), n.state[a] = i;
    }), r && Ro(this) && this.trigger({
      changes: r,
      type: "statechanged"
    }), r;
  }
};
function bP(e, t) {
  return ci(e, xse), e.state = ci({}, e.state, t), typeof e.handleStateChanged == "function" && Ro(e) && e.on("statechanged", e.handleStateChanged), e;
}
var g0 = function(t) {
  return typeof t != "string" ? t : t.replace(/./, function(n) {
    return n.toLowerCase();
  });
}, gi = function(t) {
  return typeof t != "string" ? t : t.replace(/./, function(n) {
    return n.toUpperCase();
  });
}, Cse = function(t, n) {
  return gi(t) === gi(n);
};
function $n() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(i) {
    !i || Iu(i, function(a, o) {
      if (!ef(a)) {
        e[o] = a;
        return;
      }
      ef(e[o]) || (e[o] = {}), e[o] = $n(e[o], a);
    });
  }), e;
}
var Sse = /* @__PURE__ */ function() {
  function e() {
    this.map_ = {};
  }
  var t = e.prototype;
  return t.has = function(r) {
    return r in this.map_;
  }, t.delete = function(r) {
    var i = this.has(r);
    return delete this.map_[r], i;
  }, t.set = function(r, i) {
    return this.map_[r] = i, this;
  }, t.forEach = function(r, i) {
    for (var a in this.map_)
      r.call(i, this.map_[a], a, this);
  }, e;
}(), Ese = pe.Map ? pe.Map : Sse, kse = /* @__PURE__ */ function() {
  function e() {
    this.set_ = {};
  }
  var t = e.prototype;
  return t.has = function(r) {
    return r in this.set_;
  }, t.delete = function(r) {
    var i = this.has(r);
    return delete this.set_[r], i;
  }, t.add = function(r) {
    return this.set_[r] = 1, this;
  }, t.forEach = function(r, i) {
    for (var a in this.set_)
      r.call(i, a, a, this);
  }, e;
}(), Np = pe.Set ? pe.Set : kse, at = /* @__PURE__ */ function() {
  function e(n, r, i) {
    var a = this;
    if (!n && this.play ? this.player_ = n = this : this.player_ = n, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = $n({}, this.options_), r = this.options_ = $n(this.options_, r), this.id_ = r.id || r.el && r.el.id, !this.id_) {
      var o = n && n.id && n.id() || "no_player";
      this.id_ = o + "_component_" + os();
    }
    this.name_ = r.name || null, r.el ? this.el_ = r.el : r.createEl !== !1 && (this.el_ = this.createEl()), r.className && this.el_ && r.className.split(" ").forEach(function(s) {
      return a.addClass(s);
    }), r.evented !== !1 && (b6(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), bP(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = new Np(), this.setIntervalIds_ = new Np(), this.rafIds_ = new Np(), this.namedRafs_ = new Ese(), this.clearingTimersOnDispose_ = !1, r.initChildren !== !1 && this.initChildren(), this.ready(i), r.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  var t = e.prototype;
  return t.dispose = function(r) {
    if (r === void 0 && (r = {}), !this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (var i = this.children_.length - 1; i >= 0; i--)
          this.children_[i].dispose && this.children_[i].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (r.restoreEl ? this.el_.parentNode.replaceChild(r.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }, t.isDisposed = function() {
    return Boolean(this.isDisposed_);
  }, t.player = function() {
    return this.player_;
  }, t.options = function(r) {
    return r ? (this.options_ = $n(this.options_, r), this.options_) : this.options_;
  }, t.el = function() {
    return this.el_;
  }, t.createEl = function(r, i, a) {
    return En(r, i, a);
  }, t.localize = function(r, i, a) {
    a === void 0 && (a = r);
    var o = this.player_.language && this.player_.language(), s = this.player_.languages && this.player_.languages(), l = s && s[o], u = o && o.split("-")[0], c = s && s[u], f = a;
    return l && l[r] ? f = l[r] : c && c[r] && (f = c[r]), i && (f = f.replace(/\{(\d+)\}/g, function(d, h) {
      var p = i[h - 1], y = p;
      return typeof p > "u" && (y = d), y;
    })), f;
  }, t.handleLanguagechange = function() {
  }, t.contentEl = function() {
    return this.contentEl_ || this.el_;
  }, t.id = function() {
    return this.id_;
  }, t.name = function() {
    return this.name_;
  }, t.children = function() {
    return this.children_;
  }, t.getChildById = function(r) {
    return this.childIndex_[r];
  }, t.getChild = function(r) {
    if (!!r)
      return this.childNameIndex_[r];
  }, t.getDescendant = function() {
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    i = i.reduce(function(l, u) {
      return l.concat(u);
    }, []);
    for (var o = this, s = 0; s < i.length; s++)
      if (o = o.getChild(i[s]), !o || !o.getChild)
        return;
    return o;
  }, t.addChild = function(r, i, a) {
    i === void 0 && (i = {}), a === void 0 && (a = this.children_.length);
    var o, s;
    if (typeof r == "string") {
      s = gi(r);
      var l = i.componentClass || s;
      i.name = s;
      var u = e.getComponent(l);
      if (!u)
        throw new Error("Component " + l + " does not exist");
      if (typeof u != "function")
        return null;
      o = new u(this.player_ || this, i);
    } else
      o = r;
    if (o.parentComponent_ && o.parentComponent_.removeChild(o), this.children_.splice(a, 0, o), o.parentComponent_ = this, typeof o.id == "function" && (this.childIndex_[o.id()] = o), s = s || o.name && gi(o.name()), s && (this.childNameIndex_[s] = o, this.childNameIndex_[g0(s)] = o), typeof o.el == "function" && o.el()) {
      var c = null;
      this.children_[a + 1] && (this.children_[a + 1].el_ ? c = this.children_[a + 1].el_ : Sc(this.children_[a + 1]) && (c = this.children_[a + 1])), this.contentEl().insertBefore(o.el(), c);
    }
    return o;
  }, t.removeChild = function(r) {
    if (typeof r == "string" && (r = this.getChild(r)), !(!r || !this.children_)) {
      for (var i = !1, a = this.children_.length - 1; a >= 0; a--)
        if (this.children_[a] === r) {
          i = !0, this.children_.splice(a, 1);
          break;
        }
      if (!!i) {
        r.parentComponent_ = null, this.childIndex_[r.id()] = null, this.childNameIndex_[gi(r.name())] = null, this.childNameIndex_[g0(r.name())] = null;
        var o = r.el();
        o && o.parentNode === this.contentEl() && this.contentEl().removeChild(r.el());
      }
    }
  }, t.initChildren = function() {
    var r = this, i = this.options_.children;
    if (i) {
      var a = this.options_, o = function(c) {
        var f = c.name, d = c.opts;
        if (a[f] !== void 0 && (d = a[f]), d !== !1) {
          d === !0 && (d = {}), d.playerOptions = r.options_.playerOptions;
          var h = r.addChild(f, d);
          h && (r[f] = h);
        }
      }, s, l = e.getComponent("Tech");
      Array.isArray(i) ? s = i : s = Object.keys(i), s.concat(Object.keys(this.options_).filter(function(u) {
        return !s.some(function(c) {
          return typeof c == "string" ? u === c : u === c.name;
        });
      })).map(function(u) {
        var c, f;
        return typeof u == "string" ? (c = u, f = i[c] || r.options_[c] || {}) : (c = u.name, f = u), {
          name: c,
          opts: f
        };
      }).filter(function(u) {
        var c = e.getComponent(u.opts.componentClass || gi(u.name));
        return c && !l.isTech(c);
      }).forEach(o);
    }
  }, t.buildCSSClass = function() {
    return "";
  }, t.ready = function(r, i) {
    if (i === void 0 && (i = !1), !!r) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(r);
        return;
      }
      i ? r.call(this) : this.setTimeout(r, 1);
    }
  }, t.triggerReady = function() {
    this.isReady_ = !0, this.setTimeout(function() {
      var r = this.readyQueue_;
      this.readyQueue_ = [], r && r.length > 0 && r.forEach(function(i) {
        i.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }, t.$ = function(r, i) {
    return js(r, i || this.contentEl());
  }, t.$$ = function(r, i) {
    return cP(r, i || this.contentEl());
  }, t.hasClass = function(r) {
    return Sl(this.el_, r);
  }, t.addClass = function(r) {
    Xo(this.el_, r);
  }, t.removeClass = function(r) {
    kf(this.el_, r);
  }, t.toggleClass = function(r, i) {
    nP(this.el_, r, i);
  }, t.show = function() {
    this.removeClass("vjs-hidden");
  }, t.hide = function() {
    this.addClass("vjs-hidden");
  }, t.lockShowing = function() {
    this.addClass("vjs-lock-showing");
  }, t.unlockShowing = function() {
    this.removeClass("vjs-lock-showing");
  }, t.getAttribute = function(r) {
    return rP(this.el_, r);
  }, t.setAttribute = function(r, i) {
    nc(this.el_, r, i);
  }, t.removeAttribute = function(r) {
    a2(this.el_, r);
  }, t.width = function(r, i) {
    return this.dimension("width", r, i);
  }, t.height = function(r, i) {
    return this.dimension("height", r, i);
  }, t.dimensions = function(r, i) {
    this.width(r, !0), this.height(i);
  }, t.dimension = function(r, i, a) {
    if (i !== void 0) {
      (i === null || i !== i) && (i = 0), ("" + i).indexOf("%") !== -1 || ("" + i).indexOf("px") !== -1 ? this.el_.style[r] = i : i === "auto" ? this.el_.style[r] = "" : this.el_.style[r] = i + "px", a || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    var o = this.el_.style[r], s = o.indexOf("px");
    return parseInt(s !== -1 ? o.slice(0, s) : this.el_["offset" + gi(r)], 10);
  }, t.currentDimension = function(r) {
    var i = 0;
    if (r !== "width" && r !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (i = tf(this.el_, r), i = parseFloat(i), i === 0 || isNaN(i)) {
      var a = "offset" + gi(r);
      i = this.el_[a];
    }
    return i;
  }, t.currentDimensions = function() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }, t.currentWidth = function() {
    return this.currentDimension("width");
  }, t.currentHeight = function() {
    return this.currentDimension("height");
  }, t.focus = function() {
    this.el_.focus();
  }, t.blur = function() {
    this.el_.blur();
  }, t.handleKeyDown = function(r) {
    this.player_ && (un.isEventKey(r, "Tab") || r.stopPropagation(), this.player_.handleKeyDown(r));
  }, t.handleKeyPress = function(r) {
    this.handleKeyDown(r);
  }, t.emitTapEvents = function() {
    var r = 0, i = null, a = 10, o = 200, s;
    this.on("touchstart", function(u) {
      u.touches.length === 1 && (i = {
        pageX: u.touches[0].pageX,
        pageY: u.touches[0].pageY
      }, r = pe.performance.now(), s = !0);
    }), this.on("touchmove", function(u) {
      if (u.touches.length > 1)
        s = !1;
      else if (i) {
        var c = u.touches[0].pageX - i.pageX, f = u.touches[0].pageY - i.pageY, d = Math.sqrt(c * c + f * f);
        d > a && (s = !1);
      }
    });
    var l = function() {
      s = !1;
    };
    this.on("touchleave", l), this.on("touchcancel", l), this.on("touchend", function(u) {
      if (i = null, s === !0) {
        var c = pe.performance.now() - r;
        c < o && (u.preventDefault(), this.trigger("tap"));
      }
    });
  }, t.enableTouchActivity = function() {
    if (!(!this.player() || !this.player().reportUserActivity)) {
      var r = ei(this.player(), this.player().reportUserActivity), i;
      this.on("touchstart", function() {
        r(), this.clearInterval(i), i = this.setInterval(r, 250);
      });
      var a = function(s) {
        r(), this.clearInterval(i);
      };
      this.on("touchmove", r), this.on("touchend", a), this.on("touchcancel", a);
    }
  }, t.setTimeout = function(r, i) {
    var a = this, o;
    return r = ei(this, r), this.clearTimersOnDispose_(), o = pe.setTimeout(function() {
      a.setTimeoutIds_.has(o) && a.setTimeoutIds_.delete(o), r();
    }, i), this.setTimeoutIds_.add(o), o;
  }, t.clearTimeout = function(r) {
    return this.setTimeoutIds_.has(r) && (this.setTimeoutIds_.delete(r), pe.clearTimeout(r)), r;
  }, t.setInterval = function(r, i) {
    r = ei(this, r), this.clearTimersOnDispose_();
    var a = pe.setInterval(r, i);
    return this.setIntervalIds_.add(a), a;
  }, t.clearInterval = function(r) {
    return this.setIntervalIds_.has(r) && (this.setIntervalIds_.delete(r), pe.clearInterval(r)), r;
  }, t.requestAnimationFrame = function(r) {
    var i = this;
    if (!this.supportsRaf_)
      return this.setTimeout(r, 1e3 / 60);
    this.clearTimersOnDispose_();
    var a;
    return r = ei(this, r), a = pe.requestAnimationFrame(function() {
      i.rafIds_.has(a) && i.rafIds_.delete(a), r();
    }), this.rafIds_.add(a), a;
  }, t.requestNamedAnimationFrame = function(r, i) {
    var a = this;
    if (!this.namedRafs_.has(r)) {
      this.clearTimersOnDispose_(), i = ei(this, i);
      var o = this.requestAnimationFrame(function() {
        i(), a.namedRafs_.has(r) && a.namedRafs_.delete(r);
      });
      return this.namedRafs_.set(r, o), r;
    }
  }, t.cancelNamedAnimationFrame = function(r) {
    !this.namedRafs_.has(r) || (this.cancelAnimationFrame(this.namedRafs_.get(r)), this.namedRafs_.delete(r));
  }, t.cancelAnimationFrame = function(r) {
    return this.supportsRaf_ ? (this.rafIds_.has(r) && (this.rafIds_.delete(r), pe.cancelAnimationFrame(r)), r) : this.clearTimeout(r);
  }, t.clearTimersOnDispose_ = function() {
    var r = this;
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function() {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function(i) {
        var a = i[0], o = i[1];
        r[a].forEach(function(s, l) {
          return r[o](l);
        });
      }), r.clearingTimersOnDispose_ = !1;
    }));
  }, e.registerComponent = function(r, i) {
    if (typeof r != "string" || !r)
      throw new Error('Illegal component name, "' + r + '"; must be a non-empty string.');
    var a = e.getComponent("Tech"), o = a && a.isTech(i), s = e === i || e.prototype.isPrototypeOf(i.prototype);
    if (o || !s) {
      var l;
      throw o ? l = "techs must be registered using Tech.registerTech()" : l = "must be a Component subclass", new Error('Illegal component, "' + r + '"; ' + l + ".");
    }
    r = gi(r), e.components_ || (e.components_ = {});
    var u = e.getComponent("Player");
    if (r === "Player" && u && u.players) {
      var c = u.players, f = Object.keys(c);
      if (c && f.length > 0 && f.map(function(d) {
        return c[d];
      }).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return e.components_[r] = i, e.components_[g0(r)] = i, i;
  }, e.getComponent = function(r) {
    if (!(!r || !e.components_))
      return e.components_[r];
  }, e;
}();
at.prototype.supportsRaf_ = typeof pe.requestAnimationFrame == "function" && typeof pe.cancelAnimationFrame == "function";
at.registerComponent("Component", at);
function Ose(e, t, n) {
  if (typeof t != "number" || t < 0 || t > n)
    throw new Error("Failed to execute '" + e + "' on 'TimeRanges': The index provided (" + t + ") is non-numeric or out of bounds (0-" + n + ").");
}
function zm(e, t, n, r) {
  return Ose(e, r, n.length - 1), n[r][t];
}
function jp(e) {
  var t;
  return e === void 0 || e.length === 0 ? t = {
    length: 0,
    start: function() {
      throw new Error("This TimeRanges object is empty");
    },
    end: function() {
      throw new Error("This TimeRanges object is empty");
    }
  } : t = {
    length: e.length,
    start: zm.bind(null, "start", 0, e),
    end: zm.bind(null, "end", 1, e)
  }, pe.Symbol && pe.Symbol.iterator && (t[pe.Symbol.iterator] = function() {
    return (e || []).values();
  }), t;
}
function El(e, t) {
  return Array.isArray(e) ? jp(e) : e === void 0 || t === void 0 ? jp() : jp([[e, t]]);
}
function AP(e, t) {
  var n = 0, r, i;
  if (!t)
    return 0;
  (!e || !e.length) && (e = El(0, 0));
  for (var a = 0; a < e.length; a++)
    r = e.start(a), i = e.end(a), i > t && (i = t), n += i - r;
  return n / t;
}
function br(e) {
  if (e instanceof br)
    return e;
  typeof e == "number" ? this.code = e : typeof e == "string" ? this.message = e : Go(e) && (typeof e.code == "number" && (this.code = e.code), ci(this, e)), this.message || (this.message = br.defaultMessages[this.code] || "");
}
br.prototype.code = 0;
br.prototype.message = "";
br.prototype.status = null;
br.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
br.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
for (var yu = 0; yu < br.errorTypes.length; yu++)
  br[br.errorTypes[yu]] = yu, br.prototype[br.errorTypes[yu]] = yu;
function xd(e) {
  return e != null && typeof e.then == "function";
}
function io(e) {
  xd(e) && e.then(null, function(t) {
  });
}
var A4 = function(t) {
  var n = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function(r, i, a) {
    return t[i] && (r[i] = t[i]), r;
  }, {
    cues: t.cues && Array.prototype.map.call(t.cues, function(r) {
      return {
        startTime: r.startTime,
        endTime: r.endTime,
        text: r.text,
        id: r.id
      };
    })
  });
  return n;
}, zse = function(t) {
  var n = t.$$("track"), r = Array.prototype.map.call(n, function(a) {
    return a.track;
  }), i = Array.prototype.map.call(n, function(a) {
    var o = A4(a.track);
    return a.src && (o.src = a.src), o;
  });
  return i.concat(Array.prototype.filter.call(t.textTracks(), function(a) {
    return r.indexOf(a) === -1;
  }).map(A4));
}, Dse = function(t, n) {
  return t.forEach(function(r) {
    var i = n.addRemoteTextTrack(r).track;
    !r.src && r.cues && r.cues.forEach(function(a) {
      return i.addCue(a);
    });
  }), n.textTracks();
}, Dm = {
  textTracksToJson: zse,
  jsonToTextTracks: Dse,
  trackToJson_: A4
}, Fp = "vjs-modal-dialog", kc = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.handleKeyDown_ = function(o) {
      return a.handleKeyDown(o);
    }, a.close_ = function(o) {
      return a.close(o);
    }, a.opened_ = a.hasBeenOpened_ = a.hasBeenFilled_ = !1, a.closeable(!a.options_.uncloseable), a.content(a.options_.content), a.contentEl_ = En("div", {
      className: Fp + "-content"
    }, {
      role: "document"
    }), a.descEl_ = En("p", {
      className: Fp + "-description vjs-control-text",
      id: a.el().getAttribute("aria-describedby")
    }), _l(a.descEl_, a.description()), a.el_.appendChild(a.descEl_), a.el_.appendChild(a.contentEl_), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": this.id() + "_description",
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog"
    });
  }, n.dispose = function() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, e.prototype.dispose.call(this);
  }, n.buildCSSClass = function() {
    return Fp + " vjs-hidden " + e.prototype.buildCSSClass.call(this);
  }, n.label = function() {
    return this.localize(this.options_.label || "Modal Window");
  }, n.description = function() {
    var i = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (i += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), i;
  }, n.open = function() {
    if (!this.opened_) {
      var i = this.player();
      this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !i.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && i.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = i.controls(), i.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
    }
  }, n.opened = function(i) {
    return typeof i == "boolean" && this[i ? "open" : "close"](), this.opened_;
  }, n.close = function() {
    if (!!this.opened_) {
      var i = this.player();
      this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && i.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && i.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose();
    }
  }, n.closeable = function(i) {
    if (typeof i == "boolean") {
      var a = this.closeable_ = !!i, o = this.getChild("closeButton");
      if (a && !o) {
        var s = this.contentEl_;
        this.contentEl_ = this.el_, o = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = s, this.on(o, "close", this.close_);
      }
      !a && o && (this.off(o, "close", this.close_), this.removeChild(o), o.dispose());
    }
    return this.closeable_;
  }, n.fill = function() {
    this.fillWith(this.content());
  }, n.fillWith = function(i) {
    var a = this.contentEl(), o = a.parentNode, s = a.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, o.removeChild(a), this.empty(), uP(a, i), this.trigger("modalfill"), s ? o.insertBefore(a, s) : o.appendChild(a);
    var l = this.getChild("closeButton");
    l && o.appendChild(l.el_);
  }, n.empty = function() {
    this.trigger("beforemodalempty"), m6(this.contentEl()), this.trigger("modalempty");
  }, n.content = function(i) {
    return typeof i < "u" && (this.content_ = i), this.content_;
  }, n.conditionalFocus_ = function() {
    var i = ft.activeElement, a = this.player_.el_;
    this.previouslyActiveEl_ = null, (a.contains(i) || a === i) && (this.previouslyActiveEl_ = i, this.focus());
  }, n.conditionalBlur_ = function() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }, n.handleKeyDown = function(i) {
    if (i.stopPropagation(), un.isEventKey(i, "Escape") && this.closeable()) {
      i.preventDefault(), this.close();
      return;
    }
    if (!!un.isEventKey(i, "Tab")) {
      for (var a = this.focusableEls_(), o = this.el_.querySelector(":focus"), s, l = 0; l < a.length; l++)
        if (o === a[l]) {
          s = l;
          break;
        }
      ft.activeElement === this.el_ && (s = 0), i.shiftKey && s === 0 ? (a[a.length - 1].focus(), i.preventDefault()) : !i.shiftKey && s === a.length - 1 && (a[0].focus(), i.preventDefault());
    }
  }, n.focusableEls_ = function() {
    var i = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(i, function(a) {
      return (a instanceof pe.HTMLAnchorElement || a instanceof pe.HTMLAreaElement) && a.hasAttribute("href") || (a instanceof pe.HTMLInputElement || a instanceof pe.HTMLSelectElement || a instanceof pe.HTMLTextAreaElement || a instanceof pe.HTMLButtonElement) && !a.hasAttribute("disabled") || a instanceof pe.HTMLIFrameElement || a instanceof pe.HTMLObjectElement || a instanceof pe.HTMLEmbedElement || a.hasAttribute("tabindex") && a.getAttribute("tabindex") !== -1 || a.hasAttribute("contenteditable");
    });
  }, t;
}(at);
kc.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
at.registerComponent("ModalDialog", kc);
var rc = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    r === void 0 && (r = []), i = e.call(this) || this, i.tracks_ = [], Object.defineProperty(on(i), "length", {
      get: function() {
        return this.tracks_.length;
      }
    });
    for (var a = 0; a < r.length; a++)
      i.addTrack(r[a]);
    return i;
  }
  var n = t.prototype;
  return n.addTrack = function(i) {
    var a = this, o = this.tracks_.length;
    "" + o in this || Object.defineProperty(this, o, {
      get: function() {
        return this.tracks_[o];
      }
    }), this.tracks_.indexOf(i) === -1 && (this.tracks_.push(i), this.trigger({
      track: i,
      type: "addtrack",
      target: this
    })), i.labelchange_ = function() {
      a.trigger({
        track: i,
        type: "labelchange",
        target: a
      });
    }, Ro(i) && i.addEventListener("labelchange", i.labelchange_);
  }, n.removeTrack = function(i) {
    for (var a, o = 0, s = this.length; o < s; o++)
      if (this[o] === i) {
        a = this[o], a.off && a.off(), this.tracks_.splice(o, 1);
        break;
      }
    !a || this.trigger({
      track: a,
      type: "removetrack",
      target: this
    });
  }, n.getTrackById = function(i) {
    for (var a = null, o = 0, s = this.length; o < s; o++) {
      var l = this[o];
      if (l.id === i) {
        a = l;
        break;
      }
    }
    return a;
  }, t;
}(ji);
rc.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (var Mse in rc.prototype.allowedEvents_)
  rc.prototype["on" + Mse] = null;
var Xp = function(t, n) {
  for (var r = 0; r < t.length; r++)
    !Object.keys(t[r]).length || n.id === t[r].id || (t[r].enabled = !1);
}, Hse = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    r === void 0 && (r = []);
    for (var a = r.length - 1; a >= 0; a--)
      if (r[a].enabled) {
        Xp(r, r[a]);
        break;
      }
    return i = e.call(this, r) || this, i.changing_ = !1, i;
  }
  var n = t.prototype;
  return n.addTrack = function(i) {
    var a = this;
    i.enabled && Xp(this, i), e.prototype.addTrack.call(this, i), i.addEventListener && (i.enabledChange_ = function() {
      a.changing_ || (a.changing_ = !0, Xp(a, i), a.changing_ = !1, a.trigger("change"));
    }, i.addEventListener("enabledchange", i.enabledChange_));
  }, n.removeTrack = function(i) {
    e.prototype.removeTrack.call(this, i), i.removeEventListener && i.enabledChange_ && (i.removeEventListener("enabledchange", i.enabledChange_), i.enabledChange_ = null);
  }, t;
}(rc), Rp = function(t, n) {
  for (var r = 0; r < t.length; r++)
    !Object.keys(t[r]).length || n.id === t[r].id || (t[r].selected = !1);
}, Ise = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    r === void 0 && (r = []);
    for (var a = r.length - 1; a >= 0; a--)
      if (r[a].selected) {
        Rp(r, r[a]);
        break;
      }
    return i = e.call(this, r) || this, i.changing_ = !1, Object.defineProperty(on(i), "selectedIndex", {
      get: function() {
        for (var s = 0; s < this.length; s++)
          if (this[s].selected)
            return s;
        return -1;
      },
      set: function() {
      }
    }), i;
  }
  var n = t.prototype;
  return n.addTrack = function(i) {
    var a = this;
    i.selected && Rp(this, i), e.prototype.addTrack.call(this, i), i.addEventListener && (i.selectedChange_ = function() {
      a.changing_ || (a.changing_ = !0, Rp(a, i), a.changing_ = !1, a.trigger("change"));
    }, i.addEventListener("selectedchange", i.selectedChange_));
  }, n.removeTrack = function(i) {
    e.prototype.removeTrack.call(this, i), i.removeEventListener && i.selectedChange_ && (i.removeEventListener("selectedchange", i.selectedChange_), i.selectedChange_ = null);
  }, t;
}(rc), TP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.addTrack = function(i) {
    var a = this;
    e.prototype.addTrack.call(this, i), this.queueChange_ || (this.queueChange_ = function() {
      return a.queueTrigger("change");
    }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function() {
      return a.trigger("selectedlanguagechange");
    }), i.addEventListener("modechange", this.queueChange_);
    var o = ["metadata", "chapters"];
    o.indexOf(i.kind) === -1 && i.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }, n.removeTrack = function(i) {
    e.prototype.removeTrack.call(this, i), i.removeEventListener && (this.queueChange_ && i.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && i.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }, t;
}(rc), Lse = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
      get: function() {
        return this.trackElements_.length;
      }
    });
    for (var r = 0, i = n.length; r < i; r++)
      this.addTrackElement_(n[r]);
  }
  var t = e.prototype;
  return t.addTrackElement_ = function(r) {
    var i = this.trackElements_.length;
    "" + i in this || Object.defineProperty(this, i, {
      get: function() {
        return this.trackElements_[i];
      }
    }), this.trackElements_.indexOf(r) === -1 && this.trackElements_.push(r);
  }, t.getTrackElementByTrack_ = function(r) {
    for (var i, a = 0, o = this.trackElements_.length; a < o; a++)
      if (r === this.trackElements_[a].track) {
        i = this.trackElements_[a];
        break;
      }
    return i;
  }, t.removeTrackElement_ = function(r) {
    for (var i = 0, a = this.trackElements_.length; i < a; i++)
      if (r === this.trackElements_[i]) {
        this.trackElements_[i].track && typeof this.trackElements_[i].track.off == "function" && this.trackElements_[i].track.off(), typeof this.trackElements_[i].off == "function" && this.trackElements_[i].off(), this.trackElements_.splice(i, 1);
        break;
      }
  }, e;
}(), Mm = /* @__PURE__ */ function() {
  function e(n) {
    e.prototype.setCues_.call(this, n), Object.defineProperty(this, "length", {
      get: function() {
        return this.length_;
      }
    });
  }
  var t = e.prototype;
  return t.setCues_ = function(r) {
    var i = this.length || 0, a = 0, o = r.length;
    this.cues_ = r, this.length_ = r.length;
    var s = function(u) {
      "" + u in this || Object.defineProperty(this, "" + u, {
        get: function() {
          return this.cues_[u];
        }
      });
    };
    if (i < o)
      for (a = i; a < o; a++)
        s.call(this, a);
  }, t.getCueById = function(r) {
    for (var i = null, a = 0, o = this.length; a < o; a++) {
      var s = this[a];
      if (s.id === r) {
        i = s;
        break;
      }
    }
    return i;
  }, e;
}(), Bse = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, Nse = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, jse = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, Hm = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
}, A6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n) {
    var r;
    n === void 0 && (n = {}), r = e.call(this) || this;
    var i = {
      id: n.id || "vjs_track_" + os(),
      kind: n.kind || "",
      language: n.language || ""
    }, a = n.label || "", o = function(u) {
      Object.defineProperty(on(r), u, {
        get: function() {
          return i[u];
        },
        set: function() {
        }
      });
    };
    for (var s in i)
      o(s);
    return Object.defineProperty(on(r), "label", {
      get: function() {
        return a;
      },
      set: function(u) {
        u !== a && (a = u, this.trigger("labelchange"));
      }
    }), r;
  }
  return t;
}(ji), T6 = function(t) {
  var n = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"], r = ft.createElement("a");
  r.href = t;
  for (var i = {}, a = 0; a < n.length; a++)
    i[n[a]] = r[n[a]];
  return i.protocol === "http:" && (i.host = i.host.replace(/:80$/, "")), i.protocol === "https:" && (i.host = i.host.replace(/:443$/, "")), i.protocol || (i.protocol = pe.location.protocol), i.host || (i.host = pe.location.host), i;
}, wP = function(t) {
  if (!t.match(/^https?:\/\//)) {
    var n = ft.createElement("a");
    n.href = t, t = n.href;
  }
  return t;
}, w6 = function(t) {
  if (typeof t == "string") {
    var n = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/, r = n.exec(t);
    if (r)
      return r.pop().toLowerCase();
  }
  return "";
}, c2 = function(t, n) {
  n === void 0 && (n = pe.location);
  var r = T6(t), i = r.protocol === ":" ? n.protocol : r.protocol, a = i + r.host !== n.protocol + n.host;
  return a;
}, Fse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: T6,
  getAbsoluteURL: wP,
  getFileExtension: w6,
  isCrossOrigin: c2
}), Im = function(t, n) {
  var r = new pe.WebVTT.Parser(pe, pe.vttjs, pe.WebVTT.StringDecoder()), i = [];
  r.oncue = function(a) {
    n.addCue(a);
  }, r.onparsingerror = function(a) {
    i.push(a);
  }, r.onflush = function() {
    n.trigger({
      type: "loadeddata",
      target: n
    });
  }, r.parse(t), i.length > 0 && (pe.console && pe.console.groupCollapsed && pe.console.groupCollapsed("Text Track parsing errors for " + n.src), i.forEach(function(a) {
    return pn.error(a);
  }), pe.console && pe.console.groupEnd && pe.console.groupEnd()), r.flush();
}, Lm = function(t, n) {
  var r = {
    uri: t
  }, i = c2(t);
  i && (r.cors = i);
  var a = n.tech_.crossOrigin() === "use-credentials";
  a && (r.withCredentials = a), Yh.exports(r, ei(this, function(o, s, l) {
    if (o)
      return pn.error(o, s);
    n.loaded_ = !0, typeof pe.WebVTT != "function" ? n.tech_ && n.tech_.any(["vttjsloaded", "vttjserror"], function(u) {
      if (u.type === "vttjserror") {
        pn.error("vttjs failed to load, stopping trying to process " + n.src);
        return;
      }
      return Im(l, n);
    }) : Im(l, n);
  }));
}, Of = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    if (r === void 0 && (r = {}), !r.tech)
      throw new Error("A tech was not provided.");
    var a = $n(r, {
      kind: jse[r.kind] || "subtitles",
      language: r.language || r.srclang || ""
    }), o = Hm[a.mode] || "disabled", s = a.default;
    (a.kind === "metadata" || a.kind === "chapters") && (o = "hidden"), i = e.call(this, a) || this, i.tech_ = a.tech, i.cues_ = [], i.activeCues_ = [], i.preload_ = i.tech_.preloadTextTracks !== !1;
    var l = new Mm(i.cues_), u = new Mm(i.activeCues_), c = !1;
    i.timeupdateHandler = ei(on(i), function() {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
          return;
        }
        this.activeCues = this.activeCues, c && (this.trigger("cuechange"), c = !1), this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
      }
    });
    var f = function() {
      i.stopTracking();
    };
    return i.tech_.one("dispose", f), o !== "disabled" && i.startTracking(), Object.defineProperties(on(i), {
      default: {
        get: function() {
          return s;
        },
        set: function() {
        }
      },
      mode: {
        get: function() {
          return o;
        },
        set: function(h) {
          !Hm[h] || o !== h && (o = h, !this.preload_ && o !== "disabled" && this.cues.length === 0 && Lm(this.src, this), this.stopTracking(), o !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      cues: {
        get: function() {
          return this.loaded_ ? l : null;
        },
        set: function() {
        }
      },
      activeCues: {
        get: function() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return u;
          for (var h = this.tech_.currentTime(), p = [], y = 0, m = this.cues.length; y < m; y++) {
            var b = this.cues[y];
            (b.startTime <= h && b.endTime >= h || b.startTime === b.endTime && b.startTime <= h && b.startTime + 0.5 >= h) && p.push(b);
          }
          if (c = !1, p.length !== this.activeCues_.length)
            c = !0;
          else
            for (var x = 0; x < p.length; x++)
              this.activeCues_.indexOf(p[x]) === -1 && (c = !0);
          return this.activeCues_ = p, u.setCues_(this.activeCues_), u;
        },
        set: function() {
        }
      }
    }), a.src ? (i.src = a.src, i.preload_ || (i.loaded_ = !0), (i.preload_ || a.kind !== "subtitles" && a.kind !== "captions") && Lm(i.src, on(i))) : i.loaded_ = !0, i;
  }
  var n = t.prototype;
  return n.startTracking = function() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
  }, n.stopTracking = function() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0);
  }, n.addCue = function(i) {
    var a = i;
    if (pe.vttjs && !(i instanceof pe.vttjs.VTTCue)) {
      a = new pe.vttjs.VTTCue(i.startTime, i.endTime, i.text);
      for (var o in i)
        o in a || (a[o] = i[o]);
      a.id = i.id, a.originalCue_ = i;
    }
    for (var s = this.tech_.textTracks(), l = 0; l < s.length; l++)
      s[l] !== this && s[l].removeCue(a);
    this.cues_.push(a), this.cues.setCues_(this.cues_);
  }, n.removeCue = function(i) {
    for (var a = this.cues_.length; a--; ) {
      var o = this.cues_[a];
      if (o === i || o.originalCue_ && o.originalCue_ === i) {
        this.cues_.splice(a, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }, t;
}(A6);
Of.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
var PP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n) {
    var r;
    n === void 0 && (n = {});
    var i = $n(n, {
      kind: Nse[n.kind] || ""
    });
    r = e.call(this, i) || this;
    var a = !1;
    return Object.defineProperty(on(r), "enabled", {
      get: function() {
        return a;
      },
      set: function(s) {
        typeof s != "boolean" || s === a || (a = s, this.trigger("enabledchange"));
      }
    }), i.enabled && (r.enabled = i.enabled), r.loaded_ = !0, r;
  }
  return t;
}(A6), xP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n) {
    var r;
    n === void 0 && (n = {});
    var i = $n(n, {
      kind: Bse[n.kind] || ""
    });
    r = e.call(this, i) || this;
    var a = !1;
    return Object.defineProperty(on(r), "selected", {
      get: function() {
        return a;
      },
      set: function(s) {
        typeof s != "boolean" || s === a || (a = s, this.trigger("selectedchange"));
      }
    }), i.selected && (r.selected = i.selected), r;
  }
  return t;
}(A6), CP = 0, Xse = 1, SP = 2, Rse = 3, Oc = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n) {
    var r;
    n === void 0 && (n = {}), r = e.call(this) || this;
    var i, a = new Of(n);
    return r.kind = a.kind, r.src = a.src, r.srclang = a.language, r.label = a.label, r.default = a.default, Object.defineProperties(on(r), {
      readyState: {
        get: function() {
          return i;
        }
      },
      track: {
        get: function() {
          return a;
        }
      }
    }), i = CP, a.addEventListener("loadeddata", function() {
      i = SP, r.trigger({
        type: "load",
        target: on(r)
      });
    }), r;
  }
  return t;
}(ji);
Oc.prototype.allowedEvents_ = {
  load: "load"
};
Oc.NONE = CP;
Oc.LOADING = Xse;
Oc.LOADED = SP;
Oc.ERROR = Rse;
var pa = {
  audio: {
    ListClass: Hse,
    TrackClass: PP,
    capitalName: "Audio"
  },
  video: {
    ListClass: Ise,
    TrackClass: xP,
    capitalName: "Video"
  },
  text: {
    ListClass: TP,
    TrackClass: Of,
    capitalName: "Text"
  }
};
Object.keys(pa).forEach(function(e) {
  pa[e].getterName = e + "Tracks", pa[e].privateName = e + "Tracks_";
});
var ac = {
  remoteText: {
    ListClass: TP,
    TrackClass: Of,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: Lse,
    TrackClass: Oc,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, vr = Ta({}, pa, ac);
ac.names = Object.keys(ac);
pa.names = Object.keys(pa);
vr.names = [].concat(ac.names).concat(pa.names);
function Vse(e, t, n, r, i) {
  i === void 0 && (i = {});
  var a = e.textTracks();
  i.kind = t, n && (i.label = n), r && (i.language = r), i.tech = e;
  var o = new vr.text.TrackClass(i);
  return a.addTrack(o), o;
}
var Wn = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return r === void 0 && (r = {}), i === void 0 && (i = function() {
    }), r.reportTouchActivity = !1, a = e.call(this, null, r, i) || this, a.onDurationChange_ = function(o) {
      return a.onDurationChange(o);
    }, a.trackProgress_ = function(o) {
      return a.trackProgress(o);
    }, a.trackCurrentTime_ = function(o) {
      return a.trackCurrentTime(o);
    }, a.stopTrackingCurrentTime_ = function(o) {
      return a.stopTrackingCurrentTime(o);
    }, a.disposeSourceHandler_ = function(o) {
      return a.disposeSourceHandler(o);
    }, a.queuedHanders_ = /* @__PURE__ */ new Set(), a.hasStarted_ = !1, a.on("playing", function() {
      this.hasStarted_ = !0;
    }), a.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), vr.names.forEach(function(o) {
      var s = vr[o];
      r && r[s.getterName] && (a[s.privateName] = r[s.getterName]);
    }), a.featuresProgressEvents || a.manualProgressOn(), a.featuresTimeupdateEvents || a.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function(o) {
      r["native" + o + "Tracks"] === !1 && (a["featuresNative" + o + "Tracks"] = !1);
    }), r.nativeCaptions === !1 || r.nativeTextTracks === !1 ? a.featuresNativeTextTracks = !1 : (r.nativeCaptions === !0 || r.nativeTextTracks === !0) && (a.featuresNativeTextTracks = !0), a.featuresNativeTextTracks || a.emulateTextTracks(), a.preloadTextTracks = r.preloadTextTracks !== !1, a.autoRemoteTextTracks_ = new vr.text.ListClass(), a.initTrackListeners(), r.nativeControlsForTouch || a.emitTapEvents(), a.constructor && (a.name_ = a.constructor.name || "Unknown Tech"), a;
  }
  var n = t.prototype;
  return n.triggerSourceset = function(i) {
    var a = this;
    this.isReady_ || this.one("ready", function() {
      return a.setTimeout(function() {
        return a.triggerSourceset(i);
      }, 1);
    }), this.trigger({
      src: i,
      type: "sourceset"
    });
  }, n.manualProgressOn = function() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }, n.manualProgressOff = function() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }, n.trackProgress = function(i) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(ei(this, function() {
      var a = this.bufferedPercent();
      this.bufferedPercent_ !== a && this.trigger("progress"), this.bufferedPercent_ = a, a === 1 && this.stopTrackingProgress();
    }), 500);
  }, n.onDurationChange = function(i) {
    this.duration_ = this.duration();
  }, n.buffered = function() {
    return El(0, 0);
  }, n.bufferedPercent = function() {
    return AP(this.buffered(), this.duration_);
  }, n.stopTrackingProgress = function() {
    this.clearInterval(this.progressInterval);
  }, n.manualTimeUpdatesOn = function() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }, n.manualTimeUpdatesOff = function() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }, n.trackCurrentTime = function() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }, n.stopTrackingCurrentTime = function() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, n.dispose = function() {
    this.clearTracks(pa.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), e.prototype.dispose.call(this);
  }, n.clearTracks = function(i) {
    var a = this;
    i = [].concat(i), i.forEach(function(o) {
      for (var s = a[o + "Tracks"]() || [], l = s.length; l--; ) {
        var u = s[l];
        o === "text" && a.removeRemoteTextTrack(u), s.removeTrack(u);
      }
    });
  }, n.cleanupAutoTextTracks = function() {
    for (var i = this.autoRemoteTextTracks_ || [], a = i.length; a--; ) {
      var o = i[a];
      this.removeRemoteTextTrack(o);
    }
  }, n.reset = function() {
  }, n.crossOrigin = function() {
  }, n.setCrossOrigin = function() {
  }, n.error = function(i) {
    return i !== void 0 && (this.error_ = new br(i), this.trigger("error")), this.error_;
  }, n.played = function() {
    return this.hasStarted_ ? El(0, 0) : El();
  }, n.play = function() {
  }, n.setScrubbing = function() {
  }, n.scrubbing = function() {
  }, n.setCurrentTime = function() {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, n.initTrackListeners = function() {
    var i = this;
    pa.names.forEach(function(a) {
      var o = pa[a], s = function() {
        i.trigger(a + "trackchange");
      }, l = i[o.getterName]();
      l.addEventListener("removetrack", s), l.addEventListener("addtrack", s), i.on("dispose", function() {
        l.removeEventListener("removetrack", s), l.removeEventListener("addtrack", s);
      });
    });
  }, n.addWebVttScript_ = function() {
    var i = this;
    if (!pe.WebVTT)
      if (ft.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && ef(s4.exports) && Object.keys(s4.exports).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        var a = ft.createElement("script");
        a.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", a.onload = function() {
          i.trigger("vttjsloaded");
        }, a.onerror = function() {
          i.trigger("vttjserror");
        }, this.on("dispose", function() {
          a.onload = null, a.onerror = null;
        }), pe.WebVTT = !0, this.el().parentNode.appendChild(a);
      } else
        this.ready(this.addWebVttScript_);
  }, n.emulateTextTracks = function() {
    var i = this, a = this.textTracks(), o = this.remoteTextTracks(), s = function(d) {
      return a.addTrack(d.track);
    }, l = function(d) {
      return a.removeTrack(d.track);
    };
    o.on("addtrack", s), o.on("removetrack", l), this.addWebVttScript_();
    var u = function() {
      return i.trigger("texttrackchange");
    }, c = function() {
      u();
      for (var d = 0; d < a.length; d++) {
        var h = a[d];
        h.removeEventListener("cuechange", u), h.mode === "showing" && h.addEventListener("cuechange", u);
      }
    };
    c(), a.addEventListener("change", c), a.addEventListener("addtrack", c), a.addEventListener("removetrack", c), this.on("dispose", function() {
      o.off("addtrack", s), o.off("removetrack", l), a.removeEventListener("change", c), a.removeEventListener("addtrack", c), a.removeEventListener("removetrack", c);
      for (var f = 0; f < a.length; f++) {
        var d = a[f];
        d.removeEventListener("cuechange", u);
      }
    });
  }, n.addTextTrack = function(i, a, o) {
    if (!i)
      throw new Error("TextTrack kind is required but was not provided");
    return Vse(this, i, a, o);
  }, n.createRemoteTextTrack = function(i) {
    var a = $n(i, {
      tech: this
    });
    return new ac.remoteTextEl.TrackClass(a);
  }, n.addRemoteTextTrack = function(i, a) {
    var o = this;
    i === void 0 && (i = {});
    var s = this.createRemoteTextTrack(i);
    return a !== !0 && a !== !1 && (pn.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), a = !0), this.remoteTextTrackEls().addTrackElement_(s), this.remoteTextTracks().addTrack(s.track), a !== !0 && this.ready(function() {
      return o.autoRemoteTextTracks_.addTrack(s.track);
    }), s;
  }, n.removeRemoteTextTrack = function(i) {
    var a = this.remoteTextTrackEls().getTrackElementByTrack_(i);
    this.remoteTextTrackEls().removeTrackElement_(a), this.remoteTextTracks().removeTrack(i), this.autoRemoteTextTracks_.removeTrack(i);
  }, n.getVideoPlaybackQuality = function() {
    return {};
  }, n.requestPictureInPicture = function() {
    var i = this.options_.Promise || pe.Promise;
    if (i)
      return i.reject();
  }, n.disablePictureInPicture = function() {
    return !0;
  }, n.setDisablePictureInPicture = function() {
  }, n.requestVideoFrameCallback = function(i) {
    var a = this, o = os();
    return this.paused() ? (this.queuedHanders_.add(o), this.one("playing", function() {
      a.queuedHanders_.has(o) && (a.queuedHanders_.delete(o), i());
    })) : this.requestNamedAnimationFrame(o, i), o;
  }, n.cancelVideoFrameCallback = function(i) {
    this.queuedHanders_.has(i) ? this.queuedHanders_.delete(i) : this.cancelNamedAnimationFrame(i);
  }, n.setPoster = function() {
  }, n.playsinline = function() {
  }, n.setPlaysinline = function() {
  }, n.overrideNativeAudioTracks = function() {
  }, n.overrideNativeVideoTracks = function() {
  }, n.canPlayType = function() {
    return "";
  }, t.canPlayType = function() {
    return "";
  }, t.canPlaySource = function(i, a) {
    return t.canPlayType(i.type);
  }, t.isTech = function(i) {
    return i.prototype instanceof t || i instanceof t || i === t;
  }, t.registerTech = function(i, a) {
    if (t.techs_ || (t.techs_ = {}), !t.isTech(a))
      throw new Error("Tech " + i + " must be a Tech");
    if (!t.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!t.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return i = gi(i), t.techs_[i] = a, t.techs_[g0(i)] = a, i !== "Tech" && t.defaultTechOrder_.push(i), a;
  }, t.getTech = function(i) {
    if (!!i) {
      if (t.techs_ && t.techs_[i])
        return t.techs_[i];
      if (i = gi(i), pe && pe.videojs && pe.videojs[i])
        return pn.warn("The " + i + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), pe.videojs[i];
    }
  }, t;
}(at);
vr.names.forEach(function(e) {
  var t = vr[e];
  Wn.prototype[t.getterName] = function() {
    return this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName];
  };
});
Wn.prototype.featuresVolumeControl = !0;
Wn.prototype.featuresMuteControl = !0;
Wn.prototype.featuresFullscreenResize = !1;
Wn.prototype.featuresPlaybackRate = !1;
Wn.prototype.featuresProgressEvents = !1;
Wn.prototype.featuresSourceset = !1;
Wn.prototype.featuresTimeupdateEvents = !1;
Wn.prototype.featuresNativeTextTracks = !1;
Wn.prototype.featuresVideoFrameCallback = !1;
Wn.withSourceHandlers = function(e) {
  e.registerSourceHandler = function(n, r) {
    var i = e.sourceHandlers;
    i || (i = e.sourceHandlers = []), r === void 0 && (r = i.length), i.splice(r, 0, n);
  }, e.canPlayType = function(n) {
    for (var r = e.sourceHandlers || [], i, a = 0; a < r.length; a++)
      if (i = r[a].canPlayType(n), i)
        return i;
    return "";
  }, e.selectSourceHandler = function(n, r) {
    for (var i = e.sourceHandlers || [], a, o = 0; o < i.length; o++)
      if (a = i[o].canHandleSource(n, r), a)
        return i[o];
    return null;
  }, e.canPlaySource = function(n, r) {
    var i = e.selectSourceHandler(n, r);
    return i ? i.canHandleSource(n, r) : "";
  };
  var t = ["seekable", "seeking", "duration"];
  t.forEach(function(n) {
    var r = this[n];
    typeof r == "function" && (this[n] = function() {
      return this.sourceHandler_ && this.sourceHandler_[n] ? this.sourceHandler_[n].apply(this.sourceHandler_, arguments) : r.apply(this, arguments);
    });
  }, e.prototype), e.prototype.setSource = function(n) {
    var r = e.selectSourceHandler(n, this.options_);
    r || (e.nativeSourceHandler ? r = e.nativeSourceHandler : pn.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), r !== e.nativeSourceHandler && (this.currentSource_ = n), this.sourceHandler_ = r.handleSource(n, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, e.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
at.registerComponent("Tech", Wn);
Wn.registerTech("Tech", Wn);
Wn.defaultTechOrder_ = [];
var kl = {}, T4 = {}, th = {};
function Use(e, t) {
  kl[e] = kl[e] || [], kl[e].push(t);
}
function qse(e, t, n) {
  e.setTimeout(function() {
    return cl(t, kl[t.type], n, e);
  }, 1);
}
function _se(e, t) {
  e.forEach(function(n) {
    return n.setTech && n.setTech(t);
  });
}
function Wse(e, t, n) {
  return e.reduceRight(P6(n), t[n]());
}
function Kse(e, t, n, r) {
  return t[n](e.reduce(P6(n), r));
}
function Bm(e, t, n, r) {
  r === void 0 && (r = null);
  var i = "call" + gi(n), a = e.reduce(P6(i), r), o = a === th, s = o ? null : t[n](a);
  return Qse(e, n, s, o), s;
}
var Gse = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, Yse = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, Nm = {
  play: 1,
  pause: 1
};
function P6(e) {
  return function(t, n) {
    return t === th ? th : n[e] ? n[e](t) : t;
  };
}
function Qse(e, t, n, r) {
  for (var i = e.length - 1; i >= 0; i--) {
    var a = e[i];
    a[t] && a[t](r, n);
  }
}
function Zse(e) {
  T4[e.id()] = null;
}
function Jse(e, t) {
  var n = T4[e.id()], r = null;
  if (n == null)
    return r = t(e), T4[e.id()] = [[t, r]], r;
  for (var i = 0; i < n.length; i++) {
    var a = n[i], o = a[0], s = a[1];
    o === t && (r = s);
  }
  return r === null && (r = t(e), n.push([t, r])), r;
}
function cl(e, t, n, r, i, a) {
  e === void 0 && (e = {}), t === void 0 && (t = []), i === void 0 && (i = []), a === void 0 && (a = !1);
  var o = t, s = o[0], l = o.slice(1);
  if (typeof s == "string")
    cl(e, kl[s], n, r, i, a);
  else if (s) {
    var u = Jse(r, s);
    if (!u.setSource)
      return i.push(u), cl(e, l, n, r, i, a);
    u.setSource(ci({}, e), function(c, f) {
      if (c)
        return cl(e, l, n, r, i, a);
      i.push(u), cl(f, e.type === f.type ? l : kl[f.type], n, r, i, a);
    });
  } else
    l.length ? cl(e, l, n, r, i, a) : a ? n(e, i) : cl(e, kl["*"], n, r, i, !0);
}
var $se = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, nh = function(t) {
  t === void 0 && (t = "");
  var n = w6(t), r = $se[n.toLowerCase()];
  return r || "";
}, ele = function(t, n) {
  if (!n)
    return "";
  if (t.cache_.source.src === n && t.cache_.source.type)
    return t.cache_.source.type;
  var r = t.cache_.sources.filter(function(s) {
    return s.src === n;
  });
  if (r.length)
    return r[0].type;
  for (var i = t.$$("source"), a = 0; a < i.length; a++) {
    var o = i[a];
    if (o.type && o.src && o.src === n)
      return o.type;
  }
  return nh(n);
}, tle = function e(t) {
  if (Array.isArray(t)) {
    var n = [];
    t.forEach(function(r) {
      r = e(r), Array.isArray(r) ? n = n.concat(r) : Go(r) && n.push(r);
    }), t = n;
  } else
    typeof t == "string" && t.trim() ? t = [jm({
      src: t
    })] : Go(t) && typeof t.src == "string" && t.src && t.src.trim() ? t = [jm(t)] : t = [];
  return t;
};
function jm(e) {
  if (!e.type) {
    var t = nh(e.src);
    t && (e.type = t);
  }
  return e;
}
var nle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n, r, i) {
    var a, o = $n({
      createEl: !1
    }, r);
    if (a = e.call(this, n, o, i) || this, !r.playerOptions.sources || r.playerOptions.sources.length === 0)
      for (var s = 0, l = r.playerOptions.techOrder; s < l.length; s++) {
        var u = gi(l[s]), c = Wn.getTech(u);
        if (u || (c = at.getComponent(u)), c && c.isSupported()) {
          n.loadTech_(u);
          break;
        }
      }
    else
      n.src(r.playerOptions.sources);
    return a;
  }
  return t;
}(at);
at.registerComponent("MediaLoader", nle);
var d2 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.options_.controlText && a.controlText(a.options_.controlText), a.handleMouseOver_ = function(o) {
      return a.handleMouseOver(o);
    }, a.handleMouseOut_ = function(o) {
      return a.handleMouseOut(o);
    }, a.handleClick_ = function(o) {
      return a.handleClick(o);
    }, a.handleKeyDown_ = function(o) {
      return a.handleKeyDown(o);
    }, a.emitTapEvents(), a.enable(), a;
  }
  var n = t.prototype;
  return n.createEl = function(i, a, o) {
    i === void 0 && (i = "div"), a === void 0 && (a = {}), o === void 0 && (o = {}), a = ci({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, a), i === "button" && pn.error("Creating a ClickableComponent with an HTML element of " + i + " is not supported; use a Button instead."), o = ci({
      role: "button"
    }, o), this.tabIndex_ = a.tabIndex;
    var s = En(i, a, o);
    return s.appendChild(En("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(s), s;
  }, n.dispose = function() {
    this.controlTextEl_ = null, e.prototype.dispose.call(this);
  }, n.createControlTextEl = function(i) {
    return this.controlTextEl_ = En("span", {
      className: "vjs-control-text"
    }, {
      "aria-live": "polite"
    }), i && i.appendChild(this.controlTextEl_), this.controlText(this.controlText_, i), this.controlTextEl_;
  }, n.controlText = function(i, a) {
    if (a === void 0 && (a = this.el()), i === void 0)
      return this.controlText_ || "Need Text";
    var o = this.localize(i);
    this.controlText_ = i, _l(this.controlTextEl_, o), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && a.setAttribute("title", o);
  }, n.buildCSSClass = function() {
    return "vjs-control vjs-button " + e.prototype.buildCSSClass.call(this);
  }, n.enable = function() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }, n.disable = function() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }, n.handleLanguagechange = function() {
    this.controlText(this.controlText_);
  }, n.handleClick = function(i) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }, n.handleKeyDown = function(i) {
    un.isEventKey(i, "Space") || un.isEventKey(i, "Enter") ? (i.preventDefault(), i.stopPropagation(), this.trigger("click")) : e.prototype.handleKeyDown.call(this, i);
  }, t;
}(at);
at.registerComponent("ClickableComponent", d2);
var ile = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update(), a.update_ = function(o) {
      return a.update(o);
    }, r.on("posterchange", a.update_), a;
  }
  var n = t.prototype;
  return n.dispose = function() {
    this.player().off("posterchange", this.update_), e.prototype.dispose.call(this);
  }, n.createEl = function() {
    var i = En("div", {
      className: "vjs-poster",
      tabIndex: -1
    });
    return i;
  }, n.update = function(i) {
    var a = this.player().poster();
    this.setSrc(a), a ? this.show() : this.hide();
  }, n.setSrc = function(i) {
    var a = "";
    i && (a = 'url("' + i + '")'), this.el_.style.backgroundImage = a;
  }, n.handleClick = function(i) {
    if (!!this.player_.controls()) {
      var a = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
      this.player_.tech(!0) && !((Ef || Sf) && a) && this.player_.tech(!0).focus(), this.player_.paused() ? io(this.player_.play()) : this.player_.pause();
    }
  }, t;
}(d2);
at.registerComponent("PosterImage", ile);
var la = "#222", Fm = "#ccc", rle = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Vp(e, t) {
  var n;
  if (e.length === 4)
    n = e[1] + e[1] + e[2] + e[2] + e[3] + e[3];
  else if (e.length === 7)
    n = e.slice(1);
  else
    throw new Error("Invalid color code provided, " + e + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(n.slice(0, 2), 16) + "," + parseInt(n.slice(2, 4), 16) + "," + parseInt(n.slice(4, 6), 16) + "," + t + ")";
}
function Up(e, t, n) {
  try {
    e.style[t] = n;
  } catch {
    return;
  }
}
var ale = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    o = e.call(this, r, i, a) || this;
    var s = function(u) {
      return o.updateDisplay(u);
    };
    return r.on("loadstart", function(l) {
      return o.toggleDisplay(l);
    }), r.on("texttrackchange", s), r.on("loadedmetadata", function(l) {
      return o.preselectTrack(l);
    }), r.ready(ei(on(o), function() {
      if (r.tech_ && r.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      r.on("fullscreenchange", s), r.on("playerresize", s), pe.addEventListener("orientationchange", s), r.on("dispose", function() {
        return pe.removeEventListener("orientationchange", s);
      });
      for (var l = this.options_.playerOptions.tracks || [], u = 0; u < l.length; u++)
        this.player_.addRemoteTextTrack(l[u], !0);
      this.preselectTrack();
    })), o;
  }
  var n = t.prototype;
  return n.preselectTrack = function() {
    for (var i = {
      captions: 1,
      subtitles: 1
    }, a = this.player_.textTracks(), o = this.player_.cache_.selectedLanguage, s, l, u, c = 0; c < a.length; c++) {
      var f = a[c];
      o && o.enabled && o.language && o.language === f.language && f.kind in i ? f.kind === o.kind ? u = f : u || (u = f) : o && !o.enabled ? (u = null, s = null, l = null) : f.default && (f.kind === "descriptions" && !s ? s = f : f.kind in i && !l && (l = f));
    }
    u ? u.mode = "showing" : l ? l.mode = "showing" : s && (s.mode = "showing");
  }, n.toggleDisplay = function() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }, n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }, n.clearDisplay = function() {
    typeof pe.WebVTT == "function" && pe.WebVTT.processCues(pe, [], this.el_);
  }, n.updateDisplay = function() {
    var i = this.player_.textTracks(), a = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), a) {
      for (var o = [], s = 0; s < i.length; ++s) {
        var l = i[s];
        l.mode === "showing" && o.push(l);
      }
      this.updateForTrack(o);
      return;
    }
    for (var u = null, c = null, f = i.length; f--; ) {
      var d = i[f];
      d.mode === "showing" && (d.kind === "descriptions" ? u = d : c = d);
    }
    c ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(c)) : u && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(u));
  }, n.updateDisplayState = function(i) {
    for (var a = this.player_.textTrackSettings.getValues(), o = i.activeCues, s = o.length; s--; ) {
      var l = o[s];
      if (!!l) {
        var u = l.displayState;
        if (a.color && (u.firstChild.style.color = a.color), a.textOpacity && Up(u.firstChild, "color", Vp(a.color || "#fff", a.textOpacity)), a.backgroundColor && (u.firstChild.style.backgroundColor = a.backgroundColor), a.backgroundOpacity && Up(u.firstChild, "backgroundColor", Vp(a.backgroundColor || "#000", a.backgroundOpacity)), a.windowColor && (a.windowOpacity ? Up(u, "backgroundColor", Vp(a.windowColor, a.windowOpacity)) : u.style.backgroundColor = a.windowColor), a.edgeStyle && (a.edgeStyle === "dropshadow" ? u.firstChild.style.textShadow = "2px 2px 3px " + la + ", 2px 2px 4px " + la + ", 2px 2px 5px " + la : a.edgeStyle === "raised" ? u.firstChild.style.textShadow = "1px 1px " + la + ", 2px 2px " + la + ", 3px 3px " + la : a.edgeStyle === "depressed" ? u.firstChild.style.textShadow = "1px 1px " + Fm + ", 0 1px " + Fm + ", -1px -1px " + la + ", 0 -1px " + la : a.edgeStyle === "uniform" && (u.firstChild.style.textShadow = "0 0 4px " + la + ", 0 0 4px " + la + ", 0 0 4px " + la + ", 0 0 4px " + la)), a.fontPercent && a.fontPercent !== 1) {
          var c = pe.parseFloat(u.style.fontSize);
          u.style.fontSize = c * a.fontPercent + "px", u.style.height = "auto", u.style.top = "auto";
        }
        a.fontFamily && a.fontFamily !== "default" && (a.fontFamily === "small-caps" ? u.firstChild.style.fontVariant = "small-caps" : u.firstChild.style.fontFamily = rle[a.fontFamily]);
      }
    }
  }, n.updateForTrack = function(i) {
    if (Array.isArray(i) || (i = [i]), !(typeof pe.WebVTT != "function" || i.every(function(h) {
      return !h.activeCues;
    }))) {
      for (var a = [], o = 0; o < i.length; ++o)
        for (var s = i[o], l = 0; l < s.activeCues.length; ++l)
          a.push(s.activeCues[l]);
      pe.WebVTT.processCues(pe, a, this.el_);
      for (var u = 0; u < i.length; ++u) {
        for (var c = i[u], f = 0; f < c.activeCues.length; ++f) {
          var d = c.activeCues[f].displayState;
          Xo(d, "vjs-text-track-cue"), Xo(d, "vjs-text-track-cue-" + (c.language ? c.language : u)), c.language && nc(d, "lang", c.language);
        }
        this.player_.textTrackSettings && this.updateDisplayState(c);
      }
    }
  }, t;
}(at);
at.registerComponent("TextTrackDisplay", ale);
var ole = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = this.player_.isAudio(), a = this.localize(i ? "Audio Player" : "Video Player"), o = En("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [a])
    }), s = e.prototype.createEl.call(this, "div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return s.appendChild(o), s;
  }, t;
}(at);
at.registerComponent("LoadingSpinner", ole);
var Va = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function(i, a, o) {
    a === void 0 && (a = {}), o === void 0 && (o = {}), i = "button", a = ci({
      className: this.buildCSSClass()
    }, a), o = ci({
      type: "button"
    }, o);
    var s = En(i, a, o);
    return s.appendChild(En("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(s), s;
  }, n.addChild = function(i, a) {
    a === void 0 && (a = {});
    var o = this.constructor.name;
    return pn.warn("Adding an actionable (user controllable) child to a Button (" + o + ") is not supported; use a ClickableComponent instead."), at.prototype.addChild.call(this, i, a);
  }, n.enable = function() {
    e.prototype.enable.call(this), this.el_.removeAttribute("disabled");
  }, n.disable = function() {
    e.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled");
  }, n.handleKeyDown = function(i) {
    if (un.isEventKey(i, "Space") || un.isEventKey(i, "Enter")) {
      i.stopPropagation();
      return;
    }
    e.prototype.handleKeyDown.call(this, i);
  }, t;
}(d2);
at.registerComponent("Button", Va);
var EP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.mouseused_ = !1, a.on("mousedown", function(o) {
      return a.handleMouseDown(o);
    }), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-big-play-button";
  }, n.handleClick = function(i) {
    var a = this.player_.play();
    if (this.mouseused_ && i.clientX && i.clientY) {
      var o = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
      io(a), this.player_.tech(!0) && !((Ef || Sf) && o) && this.player_.tech(!0).focus();
      return;
    }
    var s = this.player_.getChild("controlBar"), l = s && s.getChild("playToggle");
    if (!l) {
      this.player_.tech(!0).focus();
      return;
    }
    var u = function() {
      return l.focus();
    };
    xd(a) ? a.then(u, function() {
    }) : this.setTimeout(u, 1);
  }, n.handleKeyDown = function(i) {
    this.mouseused_ = !1, e.prototype.handleKeyDown.call(this, i);
  }, n.handleMouseDown = function(i) {
    this.mouseused_ = !0;
  }, t;
}(Va);
EP.prototype.controlText_ = "Play Video";
at.registerComponent("BigPlayButton", EP);
var sle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.controlText(i && i.controlText || a.localize("Close")), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-close-button " + e.prototype.buildCSSClass.call(this);
  }, n.handleClick = function(i) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }, n.handleKeyDown = function(i) {
    un.isEventKey(i, "Esc") ? (i.preventDefault(), i.stopPropagation(), this.trigger("click")) : e.prototype.handleKeyDown.call(this, i);
  }, t;
}(Va);
at.registerComponent("CloseButton", sle);
var kP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i === void 0 && (i = {}), a = e.call(this, r, i) || this, i.replay = i.replay === void 0 || i.replay, a.on(r, "play", function(o) {
      return a.handlePlay(o);
    }), a.on(r, "pause", function(o) {
      return a.handlePause(o);
    }), i.replay && a.on(r, "ended", function(o) {
      return a.handleEnded(o);
    }), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-play-control " + e.prototype.buildCSSClass.call(this);
  }, n.handleClick = function(i) {
    this.player_.paused() ? io(this.player_.play()) : this.player_.pause();
  }, n.handleSeeked = function(i) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(i) : this.handlePlay(i);
  }, n.handlePlay = function(i) {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause");
  }, n.handlePause = function(i) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play");
  }, n.handleEnded = function(i) {
    var a = this;
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", function(o) {
      return a.handleSeeked(o);
    });
  }, t;
}(Va);
kP.prototype.controlText_ = "Play";
at.registerComponent("PlayToggle", kP);
var OP = function(t, n) {
  t = t < 0 ? 0 : t;
  var r = Math.floor(t % 60), i = Math.floor(t / 60 % 60), a = Math.floor(t / 3600), o = Math.floor(n / 60 % 60), s = Math.floor(n / 3600);
  return (isNaN(t) || t === 1 / 0) && (a = i = r = "-"), a = a > 0 || s > 0 ? a + ":" : "", i = ((a || o >= 10) && i < 10 ? "0" + i : i) + ":", r = r < 10 ? "0" + r : r, a + i + r;
}, x6 = OP;
function lle(e) {
  x6 = e;
}
function ule() {
  x6 = OP;
}
function oc(e, t) {
  return t === void 0 && (t = e), x6(e, t);
}
var zc = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on(r, ["timeupdate", "ended"], function(o) {
      return a.updateContent(o);
    }), a.updateTextNode_(), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = this.buildCSSClass(), a = e.prototype.createEl.call(this, "div", {
      className: i + " vjs-time-control vjs-control"
    }), o = En("span", {
      className: "vjs-control-text",
      textContent: this.localize(this.labelText_) + "\xA0"
    }, {
      role: "presentation"
    });
    return a.appendChild(o), this.contentEl_ = En("span", {
      className: i + "-display"
    }, {
      "aria-live": "off",
      role: "presentation"
    }), a.appendChild(this.contentEl_), a;
  }, n.dispose = function() {
    this.contentEl_ = null, this.textNode_ = null, e.prototype.dispose.call(this);
  }, n.updateTextNode_ = function(i) {
    var a = this;
    i === void 0 && (i = 0), i = oc(i), this.formattedTime_ !== i && (this.formattedTime_ = i, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function() {
      if (!!a.contentEl_) {
        var o = a.textNode_;
        o && a.contentEl_.firstChild !== o && (o = null, pn.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), a.textNode_ = ft.createTextNode(a.formattedTime_), a.textNode_ && (o ? a.contentEl_.replaceChild(a.textNode_, o) : a.contentEl_.appendChild(a.textNode_));
      }
    }));
  }, n.updateContent = function(i) {
  }, t;
}(at);
zc.prototype.labelText_ = "Time";
zc.prototype.controlText_ = "Time";
at.registerComponent("TimeDisplay", zc);
var C6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-current-time";
  }, n.updateContent = function(i) {
    var a;
    this.player_.ended() ? a = this.player_.duration() : a = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(a);
  }, t;
}(zc);
C6.prototype.labelText_ = "Current Time";
C6.prototype.controlText_ = "Current Time";
at.registerComponent("CurrentTimeDisplay", C6);
var S6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    a = e.call(this, r, i) || this;
    var o = function(l) {
      return a.updateContent(l);
    };
    return a.on(r, "durationchange", o), a.on(r, "loadstart", o), a.on(r, "loadedmetadata", o), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-duration";
  }, n.updateContent = function(i) {
    var a = this.player_.duration();
    this.updateTextNode_(a);
  }, t;
}(zc);
S6.prototype.labelText_ = "Duration";
S6.prototype.controlText_ = "Duration";
at.registerComponent("DurationDisplay", S6);
var cle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this, "div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      "aria-hidden": !0
    }), a = e.prototype.createEl.call(this, "div"), o = e.prototype.createEl.call(this, "span", {
      textContent: "/"
    });
    return a.appendChild(o), i.appendChild(a), i;
  }, t;
}(at);
at.registerComponent("TimeDivider", cle);
var E6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on(r, "durationchange", function(o) {
      return a.updateContent(o);
    }), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-remaining-time";
  }, n.createEl = function() {
    var i = e.prototype.createEl.call(this);
    return this.options_.displayNegative !== !1 && i.insertBefore(En("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), i;
  }, n.updateContent = function(i) {
    if (typeof this.player_.duration() == "number") {
      var a;
      this.player_.ended() ? a = 0 : this.player_.remainingTimeDisplay ? a = this.player_.remainingTimeDisplay() : a = this.player_.remainingTime(), this.updateTextNode_(a);
    }
  }, t;
}(zc);
E6.prototype.labelText_ = "Remaining Time";
E6.prototype.controlText_ = "Remaining Time";
at.registerComponent("RemainingTimeDisplay", E6);
var dle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.updateShowing(), a.on(a.player(), "durationchange", function(o) {
      return a.updateShowing(o);
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this, "div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = En("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(En("span", {
      className: "vjs-control-text",
      textContent: this.localize("Stream Type") + "\xA0"
    })), this.contentEl_.appendChild(ft.createTextNode(this.localize("LIVE"))), i.appendChild(this.contentEl_), i;
  }, n.dispose = function() {
    this.contentEl_ = null, e.prototype.dispose.call(this);
  }, n.updateShowing = function(i) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }, t;
}(at);
at.registerComponent("LiveDisplay", dle);
var zP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.updateLiveEdgeStatus(), a.player_.liveTracker && (a.updateLiveEdgeStatusHandler_ = function(o) {
      return a.updateLiveEdgeStatus(o);
    }, a.on(a.player_.liveTracker, "liveedgechange", a.updateLiveEdgeStatusHandler_)), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this, "button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.textEl_ = En("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), i.appendChild(this.textEl_), i;
  }, n.updateLiveEdgeStatus = function() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }, n.handleClick = function() {
    this.player_.liveTracker.seekToLiveEdge();
  }, n.dispose = function() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, e.prototype.dispose.call(this);
  }, t;
}(Va);
zP.prototype.controlText_ = "Seek to live, currently playing live";
at.registerComponent("SeekToLive", zP);
var f2 = function(t, n, r) {
  return t = Number(t), Math.min(r, Math.max(n, isNaN(t) ? n : t));
}, k6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.handleMouseDown_ = function(o) {
      return a.handleMouseDown(o);
    }, a.handleMouseUp_ = function(o) {
      return a.handleMouseUp(o);
    }, a.handleKeyDown_ = function(o) {
      return a.handleKeyDown(o);
    }, a.handleClick_ = function(o) {
      return a.handleClick(o);
    }, a.handleMouseMove_ = function(o) {
      return a.handleMouseMove(o);
    }, a.update_ = function(o) {
      return a.update(o);
    }, a.bar = a.getChild(a.options_.barName), a.vertical(!!a.options_.vertical), a.enable(), a;
  }
  var n = t.prototype;
  return n.enabled = function() {
    return this.enabled_;
  }, n.enable = function() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }, n.disable = function() {
    if (!!this.enabled()) {
      var i = this.bar.el_.ownerDocument;
      this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(i, "mousemove", this.handleMouseMove_), this.off(i, "mouseup", this.handleMouseUp_), this.off(i, "touchmove", this.handleMouseMove_), this.off(i, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
    }
  }, n.createEl = function(i, a, o) {
    return a === void 0 && (a = {}), o === void 0 && (o = {}), a.className = a.className + " vjs-slider", a = ci({
      tabIndex: 0
    }, a), o = ci({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      tabIndex: 0
    }, o), e.prototype.createEl.call(this, i, a, o);
  }, n.handleMouseDown = function(i) {
    var a = this.bar.el_.ownerDocument;
    i.type === "mousedown" && i.preventDefault(), i.type === "touchstart" && !as && i.preventDefault(), aP(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(a, "mousemove", this.handleMouseMove_), this.on(a, "mouseup", this.handleMouseUp_), this.on(a, "touchmove", this.handleMouseMove_), this.on(a, "touchend", this.handleMouseUp_), this.handleMouseMove(i, !0);
  }, n.handleMouseMove = function(i) {
  }, n.handleMouseUp = function() {
    var i = this.bar.el_.ownerDocument;
    oP(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(i, "mousemove", this.handleMouseMove_), this.off(i, "mouseup", this.handleMouseUp_), this.off(i, "touchmove", this.handleMouseMove_), this.off(i, "touchend", this.handleMouseUp_), this.update();
  }, n.update = function() {
    var i = this;
    if (!(!this.el_ || !this.bar)) {
      var a = this.getProgress();
      return a === this.progress_ || (this.progress_ = a, this.requestNamedAnimationFrame("Slider#update", function() {
        var o = i.vertical() ? "height" : "width";
        i.bar.el().style[o] = (a * 100).toFixed(2) + "%";
      })), a;
    }
  }, n.getProgress = function() {
    return Number(f2(this.getPercent(), 0, 1).toFixed(4));
  }, n.calculateDistance = function(i) {
    var a = o2(this.el_, i);
    return this.vertical() ? a.y : a.x;
  }, n.handleKeyDown = function(i) {
    un.isEventKey(i, "Left") || un.isEventKey(i, "Down") ? (i.preventDefault(), i.stopPropagation(), this.stepBack()) : un.isEventKey(i, "Right") || un.isEventKey(i, "Up") ? (i.preventDefault(), i.stopPropagation(), this.stepForward()) : e.prototype.handleKeyDown.call(this, i);
  }, n.handleClick = function(i) {
    i.stopPropagation(), i.preventDefault();
  }, n.vertical = function(i) {
    if (i === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!i, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }, t;
}(at);
at.registerComponent("Slider", k6);
var qp = function(t, n) {
  return f2(t / n * 100, 0, 100).toFixed(2) + "%";
}, fle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.partEls_ = [], a.on(r, "progress", function(o) {
      return a.update(o);
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this, "div", {
      className: "vjs-load-progress"
    }), a = En("span", {
      className: "vjs-control-text"
    }), o = En("span", {
      textContent: this.localize("Loaded")
    }), s = ft.createTextNode(": ");
    return this.percentageEl_ = En("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), i.appendChild(a), a.appendChild(o), a.appendChild(s), a.appendChild(this.percentageEl_), i;
  }, n.dispose = function() {
    this.partEls_ = null, this.percentageEl_ = null, e.prototype.dispose.call(this);
  }, n.update = function(i) {
    var a = this;
    this.requestNamedAnimationFrame("LoadProgressBar#update", function() {
      var o = a.player_.liveTracker, s = a.player_.buffered(), l = o && o.isLive() ? o.seekableEnd() : a.player_.duration(), u = a.player_.bufferedEnd(), c = a.partEls_, f = qp(u, l);
      a.percent_ !== f && (a.el_.style.width = f, _l(a.percentageEl_, f), a.percent_ = f);
      for (var d = 0; d < s.length; d++) {
        var h = s.start(d), p = s.end(d), y = c[d];
        y || (y = a.el_.appendChild(En()), c[d] = y), !(y.dataset.start === h && y.dataset.end === p) && (y.dataset.start = h, y.dataset.end = p, y.style.left = qp(h, u), y.style.width = qp(p - h, u));
      }
      for (var m = c.length; m > s.length; m--)
        a.el_.removeChild(c[m - 1]);
      c.length = s.length;
    });
  }, t;
}(at);
at.registerComponent("LoadProgressBar", fle);
var hle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update = Yo(ei(on(a), a.update), Ka), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }, n.update = function(i, a, o) {
    var s = nf(this.el_), l = ic(this.player_.el()), u = i.width * a;
    if (!(!l || !s)) {
      var c = i.left - l.left + u, f = i.width - u + (l.right - i.right), d = s.width / 2;
      c < d ? d += d - c : f < d && (d = f), d < 0 ? d = 0 : d > s.width && (d = s.width), d = Math.round(d), this.el_.style.right = "-" + d + "px", this.write(o);
    }
  }, n.write = function(i) {
    _l(this.el_, i);
  }, n.updateTime = function(i, a, o, s) {
    var l = this;
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", function() {
      var u, c = l.player_.duration();
      if (l.player_.liveTracker && l.player_.liveTracker.isLive()) {
        var f = l.player_.liveTracker.liveWindow(), d = f - a * f;
        u = (d < 1 ? "" : "-") + oc(d, f);
      } else
        u = oc(o, c);
      l.update(i, a, u), s && s();
    });
  }, t;
}(at);
at.registerComponent("TimeTooltip", hle);
var O6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update = Yo(ei(on(a), a.update), Ka), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }, n.update = function(i, a) {
    var o = this.getChild("timeTooltip");
    if (!!o) {
      var s = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
      o.updateTime(i, a, s);
    }
  }, t;
}(at);
O6.prototype.options_ = {
  children: []
};
!Ar && !rs && O6.prototype.options_.children.push("timeTooltip");
at.registerComponent("PlayProgressBar", O6);
var DP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update = Yo(ei(on(a), a.update), Ka), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  }, n.update = function(i, a) {
    var o = this, s = a * this.player_.duration();
    this.getChild("timeTooltip").updateTime(i, a, s, function() {
      o.el_.style.left = i.width * a + "px";
    });
  }, t;
}(at);
DP.prototype.options_ = {
  children: ["timeTooltip"]
};
at.registerComponent("MouseTimeDisplay", DP);
var S1 = 5, Xm = 12, z6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.setEventHandlers_(), a;
  }
  var n = t.prototype;
  return n.setEventHandlers_ = function() {
    var i = this;
    this.update_ = ei(this, this.update), this.update = Yo(this.update_, Ka), this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = function(a) {
      return i.enableInterval_(a);
    }, this.disableIntervalHandler_ = function(a) {
      return i.disableInterval_(a);
    }, this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in ft && "visibilityState" in ft && this.on(ft, "visibilitychange", this.toggleVisibility_);
  }, n.toggleVisibility_ = function(i) {
    ft.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(i)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }, n.enableInterval_ = function() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, Ka));
  }, n.disableInterval_ = function(i) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && i && i.type !== "ended" || !this.updateInterval || (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }, n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }, n.update = function(i) {
    var a = this;
    if (ft.visibilityState !== "hidden") {
      var o = e.prototype.update.call(this);
      return this.requestNamedAnimationFrame("SeekBar#update", function() {
        var s = a.player_.ended() ? a.player_.duration() : a.getCurrentTime_(), l = a.player_.liveTracker, u = a.player_.duration();
        l && l.isLive() && (u = a.player_.liveTracker.liveCurrentTime()), a.percent_ !== o && (a.el_.setAttribute("aria-valuenow", (o * 100).toFixed(2)), a.percent_ = o), (a.currentTime_ !== s || a.duration_ !== u) && (a.el_.setAttribute("aria-valuetext", a.localize("progress bar timing: currentTime={1} duration={2}", [oc(s, u), oc(u, u)], "{1} of {2}")), a.currentTime_ = s, a.duration_ = u), a.bar && a.bar.update(ic(a.el()), a.getProgress());
      }), o;
    }
  }, n.userSeek_ = function(i) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(i);
  }, n.getCurrentTime_ = function() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }, n.getPercent = function() {
    var i = this.getCurrentTime_(), a, o = this.player_.liveTracker;
    return o && o.isLive() ? (a = (i - o.seekableStart()) / o.liveWindow(), o.atLiveEdge() && (a = 1)) : a = i / this.player_.duration(), a;
  }, n.handleMouseDown = function(i) {
    !rf(i) || (i.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), e.prototype.handleMouseDown.call(this, i));
  }, n.handleMouseMove = function(i, a) {
    if (a === void 0 && (a = !1), !!rf(i)) {
      !a && !this.player_.scrubbing() && this.player_.scrubbing(!0);
      var o, s = this.calculateDistance(i), l = this.player_.liveTracker;
      if (!l || !l.isLive())
        o = s * this.player_.duration(), o === this.player_.duration() && (o = o - 0.1);
      else {
        if (s >= 0.99) {
          l.seekToLiveEdge();
          return;
        }
        var u = l.seekableStart(), c = l.liveCurrentTime();
        if (o = u + s * l.liveWindow(), o >= c && (o = c), o <= u && (o = u + 0.1), o === 1 / 0)
          return;
      }
      this.userSeek_(o);
    }
  }, n.enable = function() {
    e.prototype.enable.call(this);
    var i = this.getChild("mouseTimeDisplay");
    !i || i.show();
  }, n.disable = function() {
    e.prototype.disable.call(this);
    var i = this.getChild("mouseTimeDisplay");
    !i || i.hide();
  }, n.handleMouseUp = function(i) {
    e.prototype.handleMouseUp.call(this, i), i && i.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? io(this.player_.play()) : this.update_();
  }, n.stepForward = function() {
    this.userSeek_(this.player_.currentTime() + S1);
  }, n.stepBack = function() {
    this.userSeek_(this.player_.currentTime() - S1);
  }, n.handleAction = function(i) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }, n.handleKeyDown = function(i) {
    var a = this.player_.liveTracker;
    if (un.isEventKey(i, "Space") || un.isEventKey(i, "Enter"))
      i.preventDefault(), i.stopPropagation(), this.handleAction(i);
    else if (un.isEventKey(i, "Home"))
      i.preventDefault(), i.stopPropagation(), this.userSeek_(0);
    else if (un.isEventKey(i, "End"))
      i.preventDefault(), i.stopPropagation(), a && a.isLive() ? this.userSeek_(a.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(un(i))) {
      i.preventDefault(), i.stopPropagation();
      var o = (un.codes[un(i)] - un.codes[0]) * 10 / 100;
      a && a.isLive() ? this.userSeek_(a.seekableStart() + a.liveWindow() * o) : this.userSeek_(this.player_.duration() * o);
    } else
      un.isEventKey(i, "PgDn") ? (i.preventDefault(), i.stopPropagation(), this.userSeek_(this.player_.currentTime() - S1 * Xm)) : un.isEventKey(i, "PgUp") ? (i.preventDefault(), i.stopPropagation(), this.userSeek_(this.player_.currentTime() + S1 * Xm)) : e.prototype.handleKeyDown.call(this, i);
  }, n.dispose = function() {
    this.disableInterval_(), this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in ft && "visibilityState" in ft && this.off(ft, "visibilitychange", this.toggleVisibility_), e.prototype.dispose.call(this);
  }, t;
}(k6);
z6.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
!Ar && !rs && z6.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
at.registerComponent("SeekBar", z6);
var MP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.handleMouseMove = Yo(ei(on(a), a.handleMouseMove), Ka), a.throttledHandleMouseSeek = Yo(ei(on(a), a.handleMouseSeek), Ka), a.handleMouseUpHandler_ = function(o) {
      return a.handleMouseUp(o);
    }, a.handleMouseDownHandler_ = function(o) {
      return a.handleMouseDown(o);
    }, a.enable(), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-progress-control vjs-control"
    });
  }, n.handleMouseMove = function(i) {
    var a = this.getChild("seekBar");
    if (!!a) {
      var o = a.getChild("playProgressBar"), s = a.getChild("mouseTimeDisplay");
      if (!(!o && !s)) {
        var l = a.el(), u = nf(l), c = o2(l, i).x;
        c = f2(c, 0, 1), s && s.update(u, c), o && o.update(u, a.getProgress());
      }
    }
  }, n.handleMouseSeek = function(i) {
    var a = this.getChild("seekBar");
    a && a.handleMouseMove(i);
  }, n.enabled = function() {
    return this.enabled_;
  }, n.disable = function() {
    if (this.children().forEach(function(a) {
      return a.disable && a.disable();
    }), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      var i = this.getChild("seekBar");
      this.player_.scrubbing(!1), i.videoWasPlaying && io(this.player_.play());
    }
  }, n.enable = function() {
    this.children().forEach(function(i) {
      return i.enable && i.enable();
    }), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }, n.removeListenersAddedOnMousedownAndTouchstart = function() {
    var i = this.el_.ownerDocument;
    this.off(i, "mousemove", this.throttledHandleMouseSeek), this.off(i, "touchmove", this.throttledHandleMouseSeek), this.off(i, "mouseup", this.handleMouseUpHandler_), this.off(i, "touchend", this.handleMouseUpHandler_);
  }, n.handleMouseDown = function(i) {
    var a = this.el_.ownerDocument, o = this.getChild("seekBar");
    o && o.handleMouseDown(i), this.on(a, "mousemove", this.throttledHandleMouseSeek), this.on(a, "touchmove", this.throttledHandleMouseSeek), this.on(a, "mouseup", this.handleMouseUpHandler_), this.on(a, "touchend", this.handleMouseUpHandler_);
  }, n.handleMouseUp = function(i) {
    var a = this.getChild("seekBar");
    a && a.handleMouseUp(i), this.removeListenersAddedOnMousedownAndTouchstart();
  }, t;
}(at);
MP.prototype.options_ = {
  children: ["seekBar"]
};
at.registerComponent("ProgressControl", MP);
var HP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on(r, ["enterpictureinpicture", "leavepictureinpicture"], function(o) {
      return a.handlePictureInPictureChange(o);
    }), a.on(r, ["disablepictureinpicturechanged", "loadedmetadata"], function(o) {
      return a.handlePictureInPictureEnabledChange(o);
    }), a.on(r, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], function() {
      var o = r.currentType().substring(0, 5) === "audio";
      o || r.audioPosterMode() || r.audioOnlyMode() ? (r.isInPictureInPicture() && r.exitPictureInPicture(), a.hide()) : a.show();
    }), a.disable(), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-picture-in-picture-control " + e.prototype.buildCSSClass.call(this);
  }, n.handlePictureInPictureEnabledChange = function() {
    ft.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 ? this.enable() : this.disable();
  }, n.handlePictureInPictureChange = function(i) {
    this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture"), this.handlePictureInPictureEnabledChange();
  }, n.handleClick = function(i) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }, t;
}(Va);
HP.prototype.controlText_ = "Picture-in-Picture";
at.registerComponent("PictureInPictureToggle", HP);
var IP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on(r, "fullscreenchange", function(o) {
      return a.handleFullscreenChange(o);
    }), ft[r.fsApi_.fullscreenEnabled] === !1 && a.disable(), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-fullscreen-control " + e.prototype.buildCSSClass.call(this);
  }, n.handleFullscreenChange = function(i) {
    this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen");
  }, n.handleClick = function(i) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }, t;
}(Va);
IP.prototype.controlText_ = "Fullscreen";
at.registerComponent("FullscreenToggle", IP);
var ple = function(t, n) {
  n.tech_ && !n.tech_.featuresVolumeControl && t.addClass("vjs-hidden"), t.on(n, "loadstart", function() {
    n.tech_.featuresVolumeControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
}, vle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-level"
    });
    return i.appendChild(e.prototype.createEl.call(this, "span", {
      className: "vjs-control-text"
    })), i;
  }, t;
}(at);
at.registerComponent("VolumeLevel", vle);
var mle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update = Yo(ei(on(a), a.update), Ka), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }, n.update = function(i, a, o, s) {
    if (!o) {
      var l = ic(this.el_), u = ic(this.player_.el()), c = i.width * a;
      if (!u || !l)
        return;
      var f = i.left - u.left + c, d = i.width - c + (u.right - i.right), h = l.width / 2;
      f < h ? h += h - f : d < h && (h = d), h < 0 ? h = 0 : h > l.width && (h = l.width), this.el_.style.right = "-" + h + "px";
    }
    this.write(s + "%");
  }, n.write = function(i) {
    _l(this.el_, i);
  }, n.updateVolume = function(i, a, o, s, l) {
    var u = this;
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function() {
      u.update(i, a, o, s.toFixed(0)), l && l();
    });
  }, t;
}(at);
at.registerComponent("VolumeLevelTooltip", mle);
var LP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.update = Yo(ei(on(a), a.update), Ka), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  }, n.update = function(i, a, o) {
    var s = this, l = 100 * a;
    this.getChild("volumeLevelTooltip").updateVolume(i, a, o, l, function() {
      o ? s.el_.style.bottom = i.height * a + "px" : s.el_.style.left = i.width * a + "px";
    });
  }, t;
}(at);
LP.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
at.registerComponent("MouseVolumeLevelDisplay", LP);
var h2 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on("slideractive", function(o) {
      return a.updateLastVolume_(o);
    }), a.on(r, "volumechange", function(o) {
      return a.updateARIAAttributes(o);
    }), r.ready(function() {
      return a.updateARIAAttributes();
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }, n.handleMouseDown = function(i) {
    !rf(i) || e.prototype.handleMouseDown.call(this, i);
  }, n.handleMouseMove = function(i) {
    var a = this.getChild("mouseVolumeLevelDisplay");
    if (a) {
      var o = this.el(), s = ic(o), l = this.vertical(), u = o2(o, i);
      u = l ? u.y : u.x, u = f2(u, 0, 1), a.update(s, u, l);
    }
    !rf(i) || (this.checkMuted(), this.player_.volume(this.calculateDistance(i)));
  }, n.checkMuted = function() {
    this.player_.muted() && this.player_.muted(!1);
  }, n.getPercent = function() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }, n.stepForward = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }, n.stepBack = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }, n.updateARIAAttributes = function(i) {
    var a = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", a), this.el_.setAttribute("aria-valuetext", a + "%");
  }, n.volumeAsPercentage_ = function() {
    return Math.round(this.player_.volume() * 100);
  }, n.updateLastVolume_ = function() {
    var i = this, a = this.player_.volume();
    this.one("sliderinactive", function() {
      i.player_.volume() === 0 && i.player_.lastVolume_(a);
    });
  }, t;
}(k6);
h2.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!Ar && !rs && h2.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
h2.prototype.playerEvent = "volumechange";
at.registerComponent("VolumeBar", h2);
var BP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i === void 0 && (i = {}), i.vertical = i.vertical || !1, (typeof i.volumeBar > "u" || ef(i.volumeBar)) && (i.volumeBar = i.volumeBar || {}, i.volumeBar.vertical = i.vertical), a = e.call(this, r, i) || this, ple(on(a), r), a.throttledHandleMouseMove = Yo(ei(on(a), a.handleMouseMove), Ka), a.handleMouseUpHandler_ = function(o) {
      return a.handleMouseUp(o);
    }, a.on("mousedown", function(o) {
      return a.handleMouseDown(o);
    }), a.on("touchstart", function(o) {
      return a.handleMouseDown(o);
    }), a.on("mousemove", function(o) {
      return a.handleMouseMove(o);
    }), a.on(a.volumeBar, ["focus", "slideractive"], function() {
      a.volumeBar.addClass("vjs-slider-active"), a.addClass("vjs-slider-active"), a.trigger("slideractive");
    }), a.on(a.volumeBar, ["blur", "sliderinactive"], function() {
      a.volumeBar.removeClass("vjs-slider-active"), a.removeClass("vjs-slider-active"), a.trigger("sliderinactive");
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = "vjs-volume-horizontal";
    return this.options_.vertical && (i = "vjs-volume-vertical"), e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-control vjs-control " + i
    });
  }, n.handleMouseDown = function(i) {
    var a = this.el_.ownerDocument;
    this.on(a, "mousemove", this.throttledHandleMouseMove), this.on(a, "touchmove", this.throttledHandleMouseMove), this.on(a, "mouseup", this.handleMouseUpHandler_), this.on(a, "touchend", this.handleMouseUpHandler_);
  }, n.handleMouseUp = function(i) {
    var a = this.el_.ownerDocument;
    this.off(a, "mousemove", this.throttledHandleMouseMove), this.off(a, "touchmove", this.throttledHandleMouseMove), this.off(a, "mouseup", this.handleMouseUpHandler_), this.off(a, "touchend", this.handleMouseUpHandler_);
  }, n.handleMouseMove = function(i) {
    this.volumeBar.handleMouseMove(i);
  }, t;
}(at);
BP.prototype.options_ = {
  children: ["volumeBar"]
};
at.registerComponent("VolumeControl", BP);
var gle = function(t, n) {
  n.tech_ && !n.tech_.featuresMuteControl && t.addClass("vjs-hidden"), t.on(n, "loadstart", function() {
    n.tech_.featuresMuteControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
}, NP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, gle(on(a), r), a.on(r, ["loadstart", "volumechange"], function(o) {
      return a.update(o);
    }), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-mute-control " + e.prototype.buildCSSClass.call(this);
  }, n.handleClick = function(i) {
    var a = this.player_.volume(), o = this.player_.lastVolume_();
    if (a === 0) {
      var s = o < 0.1 ? 0.1 : o;
      this.player_.volume(s), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }, n.update = function(i) {
    this.updateIcon_(), this.updateControlText_();
  }, n.updateIcon_ = function() {
    var i = this.player_.volume(), a = 3;
    Ar && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), i === 0 || this.player_.muted() ? a = 0 : i < 0.33 ? a = 1 : i < 0.67 && (a = 2);
    for (var o = 0; o < 4; o++)
      kf(this.el_, "vjs-vol-" + o);
    Xo(this.el_, "vjs-vol-" + a);
  }, n.updateControlText_ = function() {
    var i = this.player_.muted() || this.player_.volume() === 0, a = i ? "Unmute" : "Mute";
    this.controlText() !== a && this.controlText(a);
  }, t;
}(Va);
NP.prototype.controlText_ = "Mute";
at.registerComponent("MuteToggle", NP);
var jP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i === void 0 && (i = {}), typeof i.inline < "u" ? i.inline = i.inline : i.inline = !0, (typeof i.volumeControl > "u" || ef(i.volumeControl)) && (i.volumeControl = i.volumeControl || {}, i.volumeControl.vertical = !i.inline), a = e.call(this, r, i) || this, a.handleKeyPressHandler_ = function(o) {
      return a.handleKeyPress(o);
    }, a.on(r, ["loadstart"], function(o) {
      return a.volumePanelState_(o);
    }), a.on(a.muteToggle, "keyup", function(o) {
      return a.handleKeyPress(o);
    }), a.on(a.volumeControl, "keyup", function(o) {
      return a.handleVolumeControlKeyUp(o);
    }), a.on("keydown", function(o) {
      return a.handleKeyPress(o);
    }), a.on("mouseover", function(o) {
      return a.handleMouseOver(o);
    }), a.on("mouseout", function(o) {
      return a.handleMouseOut(o);
    }), a.on(a.volumeControl, ["slideractive"], a.sliderActive_), a.on(a.volumeControl, ["sliderinactive"], a.sliderInactive_), a;
  }
  var n = t.prototype;
  return n.sliderActive_ = function() {
    this.addClass("vjs-slider-active");
  }, n.sliderInactive_ = function() {
    this.removeClass("vjs-slider-active");
  }, n.volumePanelState_ = function() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }, n.createEl = function() {
    var i = "vjs-volume-panel-horizontal";
    return this.options_.inline || (i = "vjs-volume-panel-vertical"), e.prototype.createEl.call(this, "div", {
      className: "vjs-volume-panel vjs-control " + i
    });
  }, n.dispose = function() {
    this.handleMouseOut(), e.prototype.dispose.call(this);
  }, n.handleVolumeControlKeyUp = function(i) {
    un.isEventKey(i, "Esc") && this.muteToggle.focus();
  }, n.handleMouseOver = function(i) {
    this.addClass("vjs-hover"), ea(ft, "keyup", this.handleKeyPressHandler_);
  }, n.handleMouseOut = function(i) {
    this.removeClass("vjs-hover"), nr(ft, "keyup", this.handleKeyPressHandler_);
  }, n.handleKeyPress = function(i) {
    un.isEventKey(i, "Esc") && this.handleMouseOut();
  }, t;
}(at);
jP.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
at.registerComponent("VolumePanel", jP);
var FP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, i && (a.menuButton_ = i.menuButton), a.focusedChild_ = -1, a.on("keydown", function(o) {
      return a.handleKeyDown(o);
    }), a.boundHandleBlur_ = function(o) {
      return a.handleBlur(o);
    }, a.boundHandleTapClick_ = function(o) {
      return a.handleTapClick(o);
    }, a;
  }
  var n = t.prototype;
  return n.addEventListenerForItem = function(i) {
    i instanceof at && (this.on(i, "blur", this.boundHandleBlur_), this.on(i, ["tap", "click"], this.boundHandleTapClick_));
  }, n.removeEventListenerForItem = function(i) {
    i instanceof at && (this.off(i, "blur", this.boundHandleBlur_), this.off(i, ["tap", "click"], this.boundHandleTapClick_));
  }, n.removeChild = function(i) {
    typeof i == "string" && (i = this.getChild(i)), this.removeEventListenerForItem(i), e.prototype.removeChild.call(this, i);
  }, n.addItem = function(i) {
    var a = this.addChild(i);
    a && this.addEventListenerForItem(a);
  }, n.createEl = function() {
    var i = this.options_.contentElType || "ul";
    this.contentEl_ = En(i, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    var a = e.prototype.createEl.call(this, "div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return a.appendChild(this.contentEl_), ea(a, "click", function(o) {
      o.preventDefault(), o.stopImmediatePropagation();
    }), a;
  }, n.dispose = function() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, e.prototype.dispose.call(this);
  }, n.handleBlur = function(i) {
    var a = i.relatedTarget || ft.activeElement;
    if (!this.children().some(function(s) {
      return s.el() === a;
    })) {
      var o = this.menuButton_;
      o && o.buttonPressed_ && a !== o.el().firstChild && o.unpressButton();
    }
  }, n.handleTapClick = function(i) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      var a = this.children();
      if (!Array.isArray(a))
        return;
      var o = a.filter(function(s) {
        return s.el() === i.target;
      })[0];
      if (!o)
        return;
      o.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }, n.handleKeyDown = function(i) {
    un.isEventKey(i, "Left") || un.isEventKey(i, "Down") ? (i.preventDefault(), i.stopPropagation(), this.stepForward()) : (un.isEventKey(i, "Right") || un.isEventKey(i, "Up")) && (i.preventDefault(), i.stopPropagation(), this.stepBack());
  }, n.stepForward = function() {
    var i = 0;
    this.focusedChild_ !== void 0 && (i = this.focusedChild_ + 1), this.focus(i);
  }, n.stepBack = function() {
    var i = 0;
    this.focusedChild_ !== void 0 && (i = this.focusedChild_ - 1), this.focus(i);
  }, n.focus = function(i) {
    i === void 0 && (i = 0);
    var a = this.children().slice(), o = a.length && a[0].hasClass("vjs-menu-title");
    o && a.shift(), a.length > 0 && (i < 0 ? i = 0 : i >= a.length && (i = a.length - 1), this.focusedChild_ = i, a[i].el_.focus());
  }, t;
}(at);
at.registerComponent("Menu", FP);
var D6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    i === void 0 && (i = {}), a = e.call(this, r, i) || this, a.menuButton_ = new Va(r, i), a.menuButton_.controlText(a.controlText_), a.menuButton_.el_.setAttribute("aria-haspopup", "true");
    var o = Va.prototype.buildCSSClass();
    a.menuButton_.el_.className = a.buildCSSClass() + " " + o, a.menuButton_.removeClass("vjs-control"), a.addChild(a.menuButton_), a.update(), a.enabled_ = !0;
    var s = function(u) {
      return a.handleClick(u);
    };
    return a.handleMenuKeyUp_ = function(l) {
      return a.handleMenuKeyUp(l);
    }, a.on(a.menuButton_, "tap", s), a.on(a.menuButton_, "click", s), a.on(a.menuButton_, "keydown", function(l) {
      return a.handleKeyDown(l);
    }), a.on(a.menuButton_, "mouseenter", function() {
      a.addClass("vjs-hover"), a.menu.show(), ea(ft, "keyup", a.handleMenuKeyUp_);
    }), a.on("mouseleave", function(l) {
      return a.handleMouseLeave(l);
    }), a.on("keydown", function(l) {
      return a.handleSubmenuKeyDown(l);
    }), a;
  }
  var n = t.prototype;
  return n.update = function() {
    var i = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = i, this.addChild(i), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }, n.createMenu = function() {
    var i = new FP(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      var a = En("li", {
        className: "vjs-menu-title",
        textContent: gi(this.options_.title),
        tabIndex: -1
      }), o = new at(this.player_, {
        el: a
      });
      i.addItem(o);
    }
    if (this.items = this.createItems(), this.items)
      for (var s = 0; s < this.items.length; s++)
        i.addItem(this.items[s]);
    return i;
  }, n.createItems = function() {
  }, n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }, n.buildWrapperCSSClass = function() {
    var i = "vjs-menu-button";
    this.options_.inline === !0 ? i += "-inline" : i += "-popup";
    var a = Va.prototype.buildCSSClass();
    return "vjs-menu-button " + i + " " + a + " " + e.prototype.buildCSSClass.call(this);
  }, n.buildCSSClass = function() {
    var i = "vjs-menu-button";
    return this.options_.inline === !0 ? i += "-inline" : i += "-popup", "vjs-menu-button " + i + " " + e.prototype.buildCSSClass.call(this);
  }, n.controlText = function(i, a) {
    return a === void 0 && (a = this.menuButton_.el()), this.menuButton_.controlText(i, a);
  }, n.dispose = function() {
    this.handleMouseLeave(), e.prototype.dispose.call(this);
  }, n.handleClick = function(i) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }, n.handleMouseLeave = function(i) {
    this.removeClass("vjs-hover"), nr(ft, "keyup", this.handleMenuKeyUp_);
  }, n.focus = function() {
    this.menuButton_.focus();
  }, n.blur = function() {
    this.menuButton_.blur();
  }, n.handleKeyDown = function(i) {
    un.isEventKey(i, "Esc") || un.isEventKey(i, "Tab") ? (this.buttonPressed_ && this.unpressButton(), un.isEventKey(i, "Tab") || (i.preventDefault(), this.menuButton_.focus())) : (un.isEventKey(i, "Up") || un.isEventKey(i, "Down")) && (this.buttonPressed_ || (i.preventDefault(), this.pressButton()));
  }, n.handleMenuKeyUp = function(i) {
    (un.isEventKey(i, "Esc") || un.isEventKey(i, "Tab")) && this.removeClass("vjs-hover");
  }, n.handleSubmenuKeyPress = function(i) {
    this.handleSubmenuKeyDown(i);
  }, n.handleSubmenuKeyDown = function(i) {
    (un.isEventKey(i, "Esc") || un.isEventKey(i, "Tab")) && (this.buttonPressed_ && this.unpressButton(), un.isEventKey(i, "Tab") || (i.preventDefault(), this.menuButton_.focus()));
  }, n.pressButton = function() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), Ar && eP())
        return;
      this.menu.focus();
    }
  }, n.unpressButton = function() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }, n.disable = function() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }, n.enable = function() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }, t;
}(at);
at.registerComponent("MenuButton", D6);
var M6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(n, r) {
    var i, a = r.tracks;
    if (i = e.call(this, n, r) || this, i.items.length <= 1 && i.hide(), !a)
      return on(i);
    var o = ei(on(i), i.update);
    return a.addEventListener("removetrack", o), a.addEventListener("addtrack", o), a.addEventListener("labelchange", o), i.player_.on("ready", o), i.player_.on("dispose", function() {
      a.removeEventListener("removetrack", o), a.removeEventListener("addtrack", o), a.removeEventListener("labelchange", o);
    }), i;
  }
  return t;
}(D6);
at.registerComponent("TrackButton", M6);
var yle = ["Tab", "Esc", "Up", "Down", "Right", "Left"], zf = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.selectable = i.selectable, a.isSelected_ = i.selected || !1, a.multiSelectable = i.multiSelectable, a.selected(a.isSelected_), a.selectable ? a.multiSelectable ? a.el_.setAttribute("role", "menuitemcheckbox") : a.el_.setAttribute("role", "menuitemradio") : a.el_.setAttribute("role", "menuitem"), a;
  }
  var n = t.prototype;
  return n.createEl = function(i, a, o) {
    this.nonIconControl = !0;
    var s = e.prototype.createEl.call(this, "li", ci({
      className: "vjs-menu-item",
      tabIndex: -1
    }, a), o);
    return s.replaceChild(En("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    }), s.querySelector(".vjs-icon-placeholder")), s;
  }, n.handleKeyDown = function(i) {
    yle.some(function(a) {
      return un.isEventKey(i, a);
    }) || e.prototype.handleKeyDown.call(this, i);
  }, n.handleClick = function(i) {
    this.selected(!0);
  }, n.selected = function(i) {
    this.selectable && (i ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }, t;
}(d2);
at.registerComponent("MenuItem", zf);
var Df = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = i.track, s = r.textTracks();
    i.label = o.label || o.language || "Unknown", i.selected = o.mode === "showing", a = e.call(this, r, i) || this, a.track = o, a.kinds = (i.kinds || [i.kind || a.track.kind]).filter(Boolean);
    var l = function() {
      for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
        h[p] = arguments[p];
      a.handleTracksChange.apply(on(a), h);
    }, u = function() {
      for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
        h[p] = arguments[p];
      a.handleSelectedLanguageChange.apply(on(a), h);
    };
    if (r.on(["loadstart", "texttrackchange"], l), s.addEventListener("change", l), s.addEventListener("selectedlanguagechange", u), a.on("dispose", function() {
      r.off(["loadstart", "texttrackchange"], l), s.removeEventListener("change", l), s.removeEventListener("selectedlanguagechange", u);
    }), s.onchange === void 0) {
      var c;
      a.on(["tap", "click"], function() {
        if (typeof pe.Event != "object")
          try {
            c = new pe.Event("change");
          } catch {
          }
        c || (c = ft.createEvent("Event"), c.initEvent("change", !0, !0)), s.dispatchEvent(c);
      });
    }
    return a.handleTracksChange(), a;
  }
  var n = t.prototype;
  return n.handleClick = function(i) {
    var a = this.track, o = this.player_.textTracks();
    if (e.prototype.handleClick.call(this, i), !!o)
      for (var s = 0; s < o.length; s++) {
        var l = o[s];
        this.kinds.indexOf(l.kind) !== -1 && (l === a ? l.mode !== "showing" && (l.mode = "showing") : l.mode !== "disabled" && (l.mode = "disabled"));
      }
  }, n.handleTracksChange = function(i) {
    var a = this.track.mode === "showing";
    a !== this.isSelected_ && this.selected(a);
  }, n.handleSelectedLanguageChange = function(i) {
    if (this.track.mode === "showing") {
      var a = this.player_.cache_.selectedLanguage;
      if (a && a.enabled && a.language === this.track.language && a.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }, n.dispose = function() {
    this.track = null, e.prototype.dispose.call(this);
  }, t;
}(zf);
at.registerComponent("TextTrackMenuItem", Df);
var XP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    return i.track = {
      player: r,
      kind: i.kind,
      kinds: i.kinds,
      default: !1,
      mode: "disabled"
    }, i.kinds || (i.kinds = [i.kind]), i.label ? i.track.label = i.label : i.track.label = i.kinds.join(" and ") + " off", i.selectable = !0, i.multiSelectable = !1, e.call(this, r, i) || this;
  }
  var n = t.prototype;
  return n.handleTracksChange = function(i) {
    for (var a = this.player().textTracks(), o = !0, s = 0, l = a.length; s < l; s++) {
      var u = a[s];
      if (this.options_.kinds.indexOf(u.kind) > -1 && u.mode === "showing") {
        o = !1;
        break;
      }
    }
    o !== this.isSelected_ && this.selected(o);
  }, n.handleSelectedLanguageChange = function(i) {
    for (var a = this.player().textTracks(), o = !0, s = 0, l = a.length; s < l; s++) {
      var u = a[s];
      if (["captions", "descriptions", "subtitles"].indexOf(u.kind) > -1 && u.mode === "showing") {
        o = !1;
        break;
      }
    }
    o && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }, t;
}(Df);
at.registerComponent("OffTextTrackMenuItem", XP);
var Dc = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    return i === void 0 && (i = {}), i.tracks = r.textTracks(), e.call(this, r, i) || this;
  }
  var n = t.prototype;
  return n.createItems = function(i, a) {
    i === void 0 && (i = []), a === void 0 && (a = Df);
    var o;
    this.label_ && (o = this.label_ + " off"), i.push(new XP(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: o
    })), this.hideThreshold_ += 1;
    var s = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (var l = 0; l < s.length; l++) {
      var u = s[l];
      if (this.kinds_.indexOf(u.kind) > -1) {
        var c = new a(this.player_, {
          track: u,
          kinds: this.kinds_,
          kind: this.kind_,
          selectable: !0,
          multiSelectable: !1
        });
        c.addClass("vjs-" + u.kind + "-menu-item"), i.push(c);
      }
    }
    return i;
  }, t;
}(M6);
at.registerComponent("TextTrackButton", Dc);
var RP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = i.track, s = i.cue, l = r.currentTime();
    return i.selectable = !0, i.multiSelectable = !1, i.label = s.text, i.selected = s.startTime <= l && l < s.endTime, a = e.call(this, r, i) || this, a.track = o, a.cue = s, a;
  }
  var n = t.prototype;
  return n.handleClick = function(i) {
    e.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime);
  }, t;
}(zf);
at.registerComponent("ChaptersTrackMenuItem", RP);
var H6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    return o = e.call(this, r, i, a) || this, o.selectCurrentItem_ = function() {
      o.items.forEach(function(s) {
        s.selected(o.track_.activeCues[0] === s.cue);
      });
    }, o;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-chapters-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-chapters-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, n.update = function(i) {
    if (!(i && i.track && i.track.kind !== "chapters")) {
      var a = this.findChaptersTrack();
      a !== this.track_ ? (this.setTrack(a), e.prototype.update.call(this)) : (!this.items || a && a.cues && a.cues.length !== this.items.length) && e.prototype.update.call(this);
    }
  }, n.setTrack = function(i) {
    if (this.track_ !== i) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        var a = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        a && a.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = i, this.track_) {
        this.track_.mode = "hidden";
        var o = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        o && o.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }, n.findChaptersTrack = function() {
    for (var i = this.player_.textTracks() || [], a = i.length - 1; a >= 0; a--) {
      var o = i[a];
      if (o.kind === this.kind_)
        return o;
    }
  }, n.getMenuCaption = function() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(gi(this.kind_));
  }, n.createMenu = function() {
    return this.options_.title = this.getMenuCaption(), e.prototype.createMenu.call(this);
  }, n.createItems = function() {
    var i = [];
    if (!this.track_)
      return i;
    var a = this.track_.cues;
    if (!a)
      return i;
    for (var o = 0, s = a.length; o < s; o++) {
      var l = a[o], u = new RP(this.player_, {
        track: this.track_,
        cue: l
      });
      i.push(u);
    }
    return i;
  }, t;
}(Dc);
H6.prototype.kind_ = "chapters";
H6.prototype.controlText_ = "Chapters";
at.registerComponent("ChaptersButton", H6);
var I6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    o = e.call(this, r, i, a) || this;
    var s = r.textTracks(), l = ei(on(o), o.handleTracksChange);
    return s.addEventListener("change", l), o.on("dispose", function() {
      s.removeEventListener("change", l);
    }), o;
  }
  var n = t.prototype;
  return n.handleTracksChange = function(i) {
    for (var a = this.player().textTracks(), o = !1, s = 0, l = a.length; s < l; s++) {
      var u = a[s];
      if (u.kind !== this.kind_ && u.mode === "showing") {
        o = !0;
        break;
      }
    }
    o ? this.disable() : this.enable();
  }, n.buildCSSClass = function() {
    return "vjs-descriptions-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-descriptions-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, t;
}(Dc);
I6.prototype.kind_ = "descriptions";
I6.prototype.controlText_ = "Descriptions";
at.registerComponent("DescriptionsButton", I6);
var L6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    return e.call(this, r, i, a) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-subtitles-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-subtitles-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, t;
}(Dc);
L6.prototype.kind_ = "subtitles";
L6.prototype.controlText_ = "Subtitles";
at.registerComponent("SubtitlesButton", L6);
var B6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i.track = {
      player: r,
      kind: i.kind,
      label: i.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, i.selectable = !1, i.name = "CaptionSettingsMenuItem", a = e.call(this, r, i) || this, a.addClass("vjs-texttrack-settings"), a.controlText(", opens " + i.kind + " settings dialog"), a;
  }
  var n = t.prototype;
  return n.handleClick = function(i) {
    this.player().getChild("textTrackSettings").open();
  }, t;
}(Df);
at.registerComponent("CaptionSettingsMenuItem", B6);
var N6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    return e.call(this, r, i, a) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-captions-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-captions-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, n.createItems = function() {
    var i = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (i.push(new B6(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), e.prototype.createItems.call(this, i);
  }, t;
}(Dc);
N6.prototype.kind_ = "captions";
N6.prototype.controlText_ = "Captions";
at.registerComponent("CaptionsButton", N6);
var VP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function(i, a, o) {
    var s = e.prototype.createEl.call(this, i, a, o), l = s.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (l.appendChild(En("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), l.appendChild(En("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Captions")
    }))), s;
  }, t;
}(Df);
at.registerComponent("SubsCapsMenuItem", VP);
var j6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i === void 0 && (i = {}), a = e.call(this, r, i) || this, a.label_ = "subtitles", ["en", "en-us", "en-ca", "fr-ca"].indexOf(a.player_.language_) > -1 && (a.label_ = "captions"), a.menuButton_.controlText(gi(a.label_)), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-subs-caps-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-subs-caps-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, n.createItems = function() {
    var i = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (i.push(new B6(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), i = e.prototype.createItems.call(this, i, VP), i;
  }, t;
}(Dc);
j6.prototype.kinds_ = ["captions", "subtitles"];
j6.prototype.controlText_ = "Subtitles";
at.registerComponent("SubsCapsButton", j6);
var UP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = i.track, s = r.audioTracks();
    i.label = o.label || o.language || "Unknown", i.selected = o.enabled, a = e.call(this, r, i) || this, a.track = o, a.addClass("vjs-" + o.kind + "-menu-item");
    var l = function() {
      for (var c = arguments.length, f = new Array(c), d = 0; d < c; d++)
        f[d] = arguments[d];
      a.handleTracksChange.apply(on(a), f);
    };
    return s.addEventListener("change", l), a.on("dispose", function() {
      s.removeEventListener("change", l);
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function(i, a, o) {
    var s = e.prototype.createEl.call(this, i, a, o), l = s.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "main-desc" && (l.appendChild(En("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), l.appendChild(En("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), s;
  }, n.handleClick = function(i) {
    if (e.prototype.handleClick.call(this, i), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks)
      for (var a = this.player_.audioTracks(), o = 0; o < a.length; o++) {
        var s = a[o];
        s !== this.track && (s.enabled = s === this.track);
      }
  }, n.handleTracksChange = function(i) {
    this.selected(this.track.enabled);
  }, t;
}(zf);
at.registerComponent("AudioTrackMenuItem", UP);
var qP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    return i === void 0 && (i = {}), i.tracks = r.audioTracks(), e.call(this, r, i) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-audio-button " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-audio-button " + e.prototype.buildWrapperCSSClass.call(this);
  }, n.createItems = function(i) {
    i === void 0 && (i = []), this.hideThreshold_ = 1;
    for (var a = this.player_.audioTracks(), o = 0; o < a.length; o++) {
      var s = a[o];
      i.push(new UP(this.player_, {
        track: s,
        selectable: !0,
        multiSelectable: !1
      }));
    }
    return i;
  }, t;
}(M6);
qP.prototype.controlText_ = "Audio Track";
at.registerComponent("AudioTrackButton", qP);
var F6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = i.rate, s = parseFloat(o, 10);
    return i.label = o, i.selected = s === r.playbackRate(), i.selectable = !0, i.multiSelectable = !1, a = e.call(this, r, i) || this, a.label = o, a.rate = s, a.on(r, "ratechange", function(l) {
      return a.update(l);
    }), a;
  }
  var n = t.prototype;
  return n.handleClick = function(i) {
    e.prototype.handleClick.call(this), this.player().playbackRate(this.rate);
  }, n.update = function(i) {
    this.selected(this.player().playbackRate() === this.rate);
  }, t;
}(zf);
F6.prototype.contentElType = "button";
at.registerComponent("PlaybackRateMenuItem", F6);
var _P = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.menuButton_.el_.setAttribute("aria-describedby", a.labelElId_), a.updateVisibility(), a.updateLabel(), a.on(r, "loadstart", function(o) {
      return a.updateVisibility(o);
    }), a.on(r, "ratechange", function(o) {
      return a.updateLabel(o);
    }), a.on(r, "playbackrateschange", function(o) {
      return a.handlePlaybackRateschange(o);
    }), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    var i = e.prototype.createEl.call(this);
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = En("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), i.appendChild(this.labelEl_), i;
  }, n.dispose = function() {
    this.labelEl_ = null, e.prototype.dispose.call(this);
  }, n.buildCSSClass = function() {
    return "vjs-playback-rate " + e.prototype.buildCSSClass.call(this);
  }, n.buildWrapperCSSClass = function() {
    return "vjs-playback-rate " + e.prototype.buildWrapperCSSClass.call(this);
  }, n.createItems = function() {
    for (var i = this.playbackRates(), a = [], o = i.length - 1; o >= 0; o--)
      a.push(new F6(this.player(), {
        rate: i[o] + "x"
      }));
    return a;
  }, n.updateARIAAttributes = function() {
    this.el().setAttribute("aria-valuenow", this.player().playbackRate());
  }, n.handleClick = function(i) {
    var a = this.player().playbackRate(), o = this.playbackRates(), s = o.indexOf(a), l = (s + 1) % o.length;
    this.player().playbackRate(o[l]);
  }, n.handlePlaybackRateschange = function(i) {
    this.update();
  }, n.playbackRates = function() {
    var i = this.player();
    return i.playbackRates && i.playbackRates() || [];
  }, n.playbackRateSupported = function() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }, n.updateVisibility = function(i) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }, n.updateLabel = function(i) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }, t;
}(D6);
_P.prototype.controlText_ = "Playback Rate";
at.registerComponent("PlaybackRateMenuButton", _P);
var WP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-spacer " + e.prototype.buildCSSClass.call(this);
  }, n.createEl = function(i, a, o) {
    return i === void 0 && (i = "div"), a === void 0 && (a = {}), o === void 0 && (o = {}), a.className || (a.className = this.buildCSSClass()), e.prototype.createEl.call(this, i, a, o);
  }, t;
}(at);
at.registerComponent("Spacer", WP);
var ble = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-custom-control-spacer " + e.prototype.buildCSSClass.call(this);
  }, n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      textContent: "\xA0"
    });
  }, t;
}(WP);
at.registerComponent("CustomControlSpacer", ble);
var ih = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }, t;
}(at);
ih.prototype.options_ = {
  children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
};
"exitPictureInPicture" in ft && ih.prototype.options_.children.splice(ih.prototype.options_.children.length - 1, 0, "pictureInPictureToggle");
at.registerComponent("ControlBar", ih);
var KP = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return a = e.call(this, r, i) || this, a.on(r, "error", function(o) {
      return a.open(o);
    }), a;
  }
  var n = t.prototype;
  return n.buildCSSClass = function() {
    return "vjs-error-display " + e.prototype.buildCSSClass.call(this);
  }, n.content = function() {
    var i = this.player().error();
    return i ? this.localize(i.message) : "";
  }, t;
}(kc);
KP.prototype.options_ = Ta({}, kc.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
at.registerComponent("ErrorDisplay", KP);
var _p = "vjs-text-track-settings", Rm = ["#000", "Black"], Vm = ["#00F", "Blue"], Um = ["#0FF", "Cyan"], qm = ["#0F0", "Green"], _m = ["#F0F", "Magenta"], Wm = ["#F00", "Red"], Km = ["#FFF", "White"], Gm = ["#FF0", "Yellow"], Wp = ["1", "Opaque"], Kp = ["0.5", "Semi-Transparent"], Ym = ["0", "Transparent"], pl = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [Rm, Km, Wm, qm, Vm, Gm, _m, Um]
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Transparency",
    options: [Wp, Kp, Ym]
  },
  color: {
    selector: ".vjs-fg-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [Km, Rm, Wm, qm, Vm, Gm, _m, Um]
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "%s",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "captions-font-family-%s",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "captions-font-size-%s",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: function(t) {
      return t === "1.00" ? null : Number(t);
    }
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Transparency",
    options: [Wp, Kp]
  },
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color"
  },
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Transparency",
    options: [Ym, Kp, Wp]
  }
};
pl.windowColor.options = pl.backgroundColor.options;
function GP(e, t) {
  if (t && (e = t(e)), e && e !== "none")
    return e;
}
function Ale(e, t) {
  var n = e.options[e.options.selectedIndex].value;
  return GP(n, t);
}
function Tle(e, t, n) {
  if (!!t) {
    for (var r = 0; r < e.options.length; r++)
      if (GP(e.options[r].value, n) === t) {
        e.selectedIndex = r;
        break;
      }
  }
}
var wle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i.temporary = !1, a = e.call(this, r, i) || this, a.updateDisplay = a.updateDisplay.bind(on(a)), a.fill(), a.hasBeenOpened_ = a.hasBeenFilled_ = !0, a.endDialog = En("p", {
      className: "vjs-control-text",
      textContent: a.localize("End of dialog window.")
    }), a.el().appendChild(a.endDialog), a.setDefaults(), i.persistTextTrackSettings === void 0 && (a.options_.persistTextTrackSettings = a.options_.playerOptions.persistTextTrackSettings), a.on(a.$(".vjs-done-button"), "click", function() {
      a.saveSettings(), a.close();
    }), a.on(a.$(".vjs-default-button"), "click", function() {
      a.setDefaults(), a.updateDisplay();
    }), Iu(pl, function(o) {
      a.on(a.$(o.selector), "change", a.updateDisplay);
    }), a.options_.persistTextTrackSettings && a.restoreSettings(), a;
  }
  var n = t.prototype;
  return n.dispose = function() {
    this.endDialog = null, e.prototype.dispose.call(this);
  }, n.createElSelect_ = function(i, a, o) {
    var s = this;
    a === void 0 && (a = ""), o === void 0 && (o = "label");
    var l = pl[i], u = l.id.replace("%s", this.id_), c = [a, u].join(" ").trim();
    return ["<" + o + ' id="' + u + '" class="' + (o === "label" ? "vjs-label" : "") + '">', this.localize(l.label), "</" + o + ">", '<select aria-labelledby="' + c + '">'].concat(l.options.map(function(f) {
      var d = u + "-" + f[1].replace(/\W+/g, "");
      return ['<option id="' + d + '" value="' + f[0] + '" ', 'aria-labelledby="' + c + " " + d + '">', s.localize(f[1]), "</option>"].join("");
    })).concat("</select>").join("");
  }, n.createElFgColor_ = function() {
    var i = "captions-text-legend-" + this.id_;
    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", i), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", i), "</span>", "</fieldset>"].join("");
  }, n.createElBgColor_ = function() {
    var i = "captions-background-" + this.id_;
    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", i), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", i), "</span>", "</fieldset>"].join("");
  }, n.createElWinColor_ = function() {
    var i = "captions-window-" + this.id_;
    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", i), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", i), "</span>", "</fieldset>"].join("");
  }, n.createElColors_ = function() {
    return En("div", {
      className: "vjs-track-settings-colors",
      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
    });
  }, n.createElFont_ = function() {
    return En("div", {
      className: "vjs-track-settings-font",
      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
    });
  }, n.createElControls_ = function() {
    var i = this.localize("restore all settings to the default values");
    return En("div", {
      className: "vjs-track-settings-controls",
      innerHTML: ['<button type="button" class="vjs-default-button" title="' + i + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + i + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
    });
  }, n.content = function() {
    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
  }, n.label = function() {
    return this.localize("Caption Settings Dialog");
  }, n.description = function() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }, n.buildCSSClass = function() {
    return e.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
  }, n.getValues = function() {
    var i = this;
    return cse(pl, function(a, o, s) {
      var l = Ale(i.$(o.selector), o.parser);
      return l !== void 0 && (a[s] = l), a;
    }, {});
  }, n.setValues = function(i) {
    var a = this;
    Iu(pl, function(o, s) {
      Tle(a.$(o.selector), i[s], o.parser);
    });
  }, n.setDefaults = function() {
    var i = this;
    Iu(pl, function(a) {
      var o = a.hasOwnProperty("default") ? a.default : 0;
      i.$(a.selector).selectedIndex = o;
    });
  }, n.restoreSettings = function() {
    var i;
    try {
      i = JSON.parse(pe.localStorage.getItem(_p));
    } catch (a) {
      pn.warn(a);
    }
    i && this.setValues(i);
  }, n.saveSettings = function() {
    if (!!this.options_.persistTextTrackSettings) {
      var i = this.getValues();
      try {
        Object.keys(i).length ? pe.localStorage.setItem(_p, JSON.stringify(i)) : pe.localStorage.removeItem(_p);
      } catch (a) {
        pn.warn(a);
      }
    }
  }, n.updateDisplay = function() {
    var i = this.player_.getChild("textTrackDisplay");
    i && i.updateDisplay();
  }, n.conditionalBlur_ = function() {
    this.previouslyActiveEl_ = null;
    var i = this.player_.controlBar, a = i && i.subsCapsButton, o = i && i.captionsButton;
    a ? a.focus() : o && o.focus();
  }, t;
}(kc);
at.registerComponent("TextTrackSettings", wle);
var Ple = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = i.ResizeObserver || pe.ResizeObserver;
    i.ResizeObserver === null && (o = !1);
    var s = $n({
      createEl: !o,
      reportTouchActivity: !1
    }, i);
    return a = e.call(this, r, s) || this, a.ResizeObserver = i.ResizeObserver || pe.ResizeObserver, a.loadListener_ = null, a.resizeObserver_ = null, a.debouncedHandler_ = Tse(function() {
      a.resizeHandler();
    }, 100, !1, on(a)), o ? (a.resizeObserver_ = new a.ResizeObserver(a.debouncedHandler_), a.resizeObserver_.observe(r.el())) : (a.loadListener_ = function() {
      if (!(!a.el_ || !a.el_.contentWindow)) {
        var l = a.debouncedHandler_, u = a.unloadListener_ = function() {
          nr(this, "resize", l), nr(this, "unload", u), u = null;
        };
        ea(a.el_.contentWindow, "unload", u), ea(a.el_.contentWindow, "resize", l);
      }
    }, a.one("load", a.loadListener_)), a;
  }
  var n = t.prototype;
  return n.createEl = function() {
    return e.prototype.createEl.call(this, "iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }, n.resizeHandler = function() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }, n.dispose = function() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, e.prototype.dispose.call(this);
  }, t;
}(at);
at.registerComponent("ResizeManager", Ple);
var xle = {
  trackingThreshold: 20,
  liveTolerance: 15
}, Cle = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a, o = $n(xle, i, {
      createEl: !1
    });
    return a = e.call(this, r, o) || this, a.handleVisibilityChange_ = function(s) {
      return a.handleVisibilityChange(s);
    }, a.trackLiveHandler_ = function() {
      return a.trackLive_();
    }, a.handlePlay_ = function(s) {
      return a.handlePlay(s);
    }, a.handleFirstTimeupdate_ = function(s) {
      return a.handleFirstTimeupdate(s);
    }, a.handleSeeked_ = function(s) {
      return a.handleSeeked(s);
    }, a.seekToLiveEdge_ = function(s) {
      return a.seekToLiveEdge(s);
    }, a.reset_(), a.on(a.player_, "durationchange", function(s) {
      return a.handleDurationchange(s);
    }), a.on(a.player_, "canplay", function() {
      return a.toggleTracking();
    }), Ef && "hidden" in ft && "visibilityState" in ft && a.on(ft, "visibilitychange", a.handleVisibilityChange_), a;
  }
  var n = t.prototype;
  return n.handleVisibilityChange = function() {
    this.player_.duration() === 1 / 0 && (ft.hidden ? this.stopTracking() : this.startTracking());
  }, n.trackLive_ = function() {
    var i = this.player_.seekable();
    if (!(!i || !i.length)) {
      var a = Number(pe.performance.now().toFixed(4)), o = this.lastTime_ === -1 ? 0 : (a - this.lastTime_) / 1e3;
      this.lastTime_ = a, this.pastSeekEnd_ = this.pastSeekEnd() + o;
      var s = this.liveCurrentTime(), l = this.player_.currentTime(), u = this.player_.paused() || this.seekedBehindLive_ || Math.abs(s - l) > this.options_.liveTolerance;
      (!this.timeupdateSeen_ || s === 1 / 0) && (u = !1), u !== this.behindLiveEdge_ && (this.behindLiveEdge_ = u, this.trigger("liveedgechange"));
    }
  }, n.handleDurationchange = function() {
    this.toggleTracking();
  }, n.toggleTracking = function() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }, n.startTracking = function() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, Ka), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }, n.handleFirstTimeupdate = function() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }, n.handleSeeked = function() {
    var i = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && i > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }, n.handlePlay = function() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }, n.reset_ = function() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }, n.nextSeekedFromUser = function() {
    this.nextSeekedFromUser_ = !0;
  }, n.stopTracking = function() {
    !this.isTracking() || (this.reset_(), this.trigger("liveedgechange"));
  }, n.seekableEnd = function() {
    for (var i = this.player_.seekable(), a = [], o = i ? i.length : 0; o--; )
      a.push(i.end(o));
    return a.length ? a.sort()[a.length - 1] : 1 / 0;
  }, n.seekableStart = function() {
    for (var i = this.player_.seekable(), a = [], o = i ? i.length : 0; o--; )
      a.push(i.start(o));
    return a.length ? a.sort()[0] : 0;
  }, n.liveWindow = function() {
    var i = this.liveCurrentTime();
    return i === 1 / 0 ? 0 : i - this.seekableStart();
  }, n.isLive = function() {
    return this.isTracking();
  }, n.atLiveEdge = function() {
    return !this.behindLiveEdge();
  }, n.liveCurrentTime = function() {
    return this.pastSeekEnd() + this.seekableEnd();
  }, n.pastSeekEnd = function() {
    var i = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && i !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = i, this.pastSeekEnd_;
  }, n.behindLiveEdge = function() {
    return this.behindLiveEdge_;
  }, n.isTracking = function() {
    return typeof this.trackingInterval_ == "number";
  }, n.seekToLiveEdge = function() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }, n.dispose = function() {
    this.off(ft, "visibilitychange", this.handleVisibilityChange_), this.stopTracking(), e.prototype.dispose.call(this);
  }, t;
}(at);
at.registerComponent("LiveTracker", Cle);
var w4 = function(t) {
  var n = t.el();
  if (n.hasAttribute("src"))
    return t.triggerSourceset(n.src), !0;
  var r = t.$$("source"), i = [], a = "";
  if (!r.length)
    return !1;
  for (var o = 0; o < r.length; o++) {
    var s = r[o].src;
    s && i.indexOf(s) === -1 && i.push(s);
  }
  return i.length ? (i.length === 1 && (a = i[0]), t.triggerSourceset(a), !0) : !1;
}, Sle = Object.defineProperty({}, "innerHTML", {
  get: function() {
    return this.cloneNode(!0).innerHTML;
  },
  set: function(t) {
    var n = ft.createElement(this.nodeName.toLowerCase());
    n.innerHTML = t;
    for (var r = ft.createDocumentFragment(); n.childNodes.length; )
      r.appendChild(n.childNodes[0]);
    return this.innerText = "", pe.Element.prototype.appendChild.call(this, r), this.innerHTML;
  }
}), YP = function(t, n) {
  for (var r = {}, i = 0; i < t.length && (r = Object.getOwnPropertyDescriptor(t[i], n), !(r && r.set && r.get)); i++)
    ;
  return r.enumerable = !0, r.configurable = !0, r;
}, Ele = function(t) {
  return YP([t.el(), pe.HTMLMediaElement.prototype, pe.Element.prototype, Sle], "innerHTML");
}, Qm = function(t) {
  var n = t.el();
  if (!n.resetSourceWatch_) {
    var r = {}, i = Ele(t), a = function(s) {
      return function() {
        for (var l = arguments.length, u = new Array(l), c = 0; c < l; c++)
          u[c] = arguments[c];
        var f = s.apply(n, u);
        return w4(t), f;
      };
    };
    ["append", "appendChild", "insertAdjacentHTML"].forEach(function(o) {
      !n[o] || (r[o] = n[o], n[o] = a(r[o]));
    }), Object.defineProperty(n, "innerHTML", $n(i, {
      set: a(i.set)
    })), n.resetSourceWatch_ = function() {
      n.resetSourceWatch_ = null, Object.keys(r).forEach(function(o) {
        n[o] = r[o];
      }), Object.defineProperty(n, "innerHTML", i);
    }, t.one("sourceset", n.resetSourceWatch_);
  }
}, kle = Object.defineProperty({}, "src", {
  get: function() {
    return this.hasAttribute("src") ? wP(pe.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set: function(t) {
    return pe.Element.prototype.setAttribute.call(this, "src", t), t;
  }
}), Ole = function(t) {
  return YP([t.el(), pe.HTMLMediaElement.prototype, kle], "src");
}, zle = function(t) {
  if (!!t.featuresSourceset) {
    var n = t.el();
    if (!n.resetSourceset_) {
      var r = Ole(t), i = n.setAttribute, a = n.load;
      Object.defineProperty(n, "src", $n(r, {
        set: function(s) {
          var l = r.set.call(n, s);
          return t.triggerSourceset(n.src), l;
        }
      })), n.setAttribute = function(o, s) {
        var l = i.call(n, o, s);
        return /src/i.test(o) && t.triggerSourceset(n.src), l;
      }, n.load = function() {
        var o = a.call(n);
        return w4(t) || (t.triggerSourceset(""), Qm(t)), o;
      }, n.currentSrc ? t.triggerSourceset(n.currentSrc) : w4(t) || Qm(t), n.resetSourceset_ = function() {
        n.resetSourceset_ = null, n.load = a, n.setAttribute = i, Object.defineProperty(n, "src", r), n.resetSourceWatch_ && n.resetSourceWatch_();
      };
    }
  }
}, X6 = function(t, n, r, i) {
  i === void 0 && (i = !0);
  var a = function(l) {
    return Object.defineProperty(t, n, {
      value: l,
      enumerable: !0,
      writable: !0
    });
  }, o = {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var l = r();
      return a(l), l;
    }
  };
  return i && (o.set = a), Object.defineProperty(t, n, o);
}, Et = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    a = e.call(this, r, i) || this;
    var o = r.source, s = !1;
    if (a.featuresVideoFrameCallback = a.featuresVideoFrameCallback && a.el_.tagName === "VIDEO", o && (a.el_.currentSrc !== o.src || r.tag && r.tag.initNetworkState_ === 3) ? a.setSource(o) : a.handleLateInit_(a.el_), r.enableSourceset && a.setupSourcesetHandling_(), a.isScrubbing_ = !1, a.el_.hasChildNodes()) {
      for (var l = a.el_.childNodes, u = l.length, c = []; u--; ) {
        var f = l[u], d = f.nodeName.toLowerCase();
        d === "track" && (a.featuresNativeTextTracks ? (a.remoteTextTrackEls().addTrackElement_(f), a.remoteTextTracks().addTrack(f.track), a.textTracks().addTrack(f.track), !s && !a.el_.hasAttribute("crossorigin") && c2(f.src) && (s = !0)) : c.push(f));
      }
      for (var h = 0; h < c.length; h++)
        a.el_.removeChild(c[h]);
    }
    return a.proxyNativeTracks_(), a.featuresNativeTextTracks && s && pn.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), a.restoreMetadataTracksInIOSNativePlayer_(), (tc || v6 || Yw) && r.nativeControlsForTouch === !0 && a.setControls(!0), a.proxyWebkitFullscreen_(), a.triggerReady(), a;
  }
  var n = t.prototype;
  return n.dispose = function() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), t.disposeMediaElement(this.el_), this.options_ = null, e.prototype.dispose.call(this);
  }, n.setupSourcesetHandling_ = function() {
    zle(this);
  }, n.restoreMetadataTracksInIOSNativePlayer_ = function() {
    var i = this.textTracks(), a, o = function() {
      a = [];
      for (var u = 0; u < i.length; u++) {
        var c = i[u];
        c.kind === "metadata" && a.push({
          track: c,
          storedMode: c.mode
        });
      }
    };
    o(), i.addEventListener("change", o), this.on("dispose", function() {
      return i.removeEventListener("change", o);
    });
    var s = function l() {
      for (var u = 0; u < a.length; u++) {
        var c = a[u];
        c.track.mode === "disabled" && c.track.mode !== c.storedMode && (c.track.mode = c.storedMode);
      }
      i.removeEventListener("change", l);
    };
    this.on("webkitbeginfullscreen", function() {
      i.removeEventListener("change", o), i.removeEventListener("change", s), i.addEventListener("change", s);
    }), this.on("webkitendfullscreen", function() {
      i.removeEventListener("change", o), i.addEventListener("change", o), i.removeEventListener("change", s);
    });
  }, n.overrideNative_ = function(i, a) {
    var o = this;
    if (a === this["featuresNative" + i + "Tracks"]) {
      var s = i.toLowerCase();
      this[s + "TracksListeners_"] && Object.keys(this[s + "TracksListeners_"]).forEach(function(l) {
        var u = o.el()[s + "Tracks"];
        u.removeEventListener(l, o[s + "TracksListeners_"][l]);
      }), this["featuresNative" + i + "Tracks"] = !a, this[s + "TracksListeners_"] = null, this.proxyNativeTracksForType_(s);
    }
  }, n.overrideNativeAudioTracks = function(i) {
    this.overrideNative_("Audio", i);
  }, n.overrideNativeVideoTracks = function(i) {
    this.overrideNative_("Video", i);
  }, n.proxyNativeTracksForType_ = function(i) {
    var a = this, o = pa[i], s = this.el()[o.getterName], l = this[o.getterName]();
    if (!(!this["featuresNative" + o.capitalName + "Tracks"] || !s || !s.addEventListener)) {
      var u = {
        change: function(d) {
          var h = {
            type: "change",
            target: l,
            currentTarget: l,
            srcElement: l
          };
          l.trigger(h), i === "text" && a[ac.remoteText.getterName]().trigger(h);
        },
        addtrack: function(d) {
          l.addTrack(d.track);
        },
        removetrack: function(d) {
          l.removeTrack(d.track);
        }
      }, c = function() {
        for (var d = [], h = 0; h < l.length; h++) {
          for (var p = !1, y = 0; y < s.length; y++)
            if (s[y] === l[h]) {
              p = !0;
              break;
            }
          p || d.push(l[h]);
        }
        for (; d.length; )
          l.removeTrack(d.shift());
      };
      this[o.getterName + "Listeners_"] = u, Object.keys(u).forEach(function(f) {
        var d = u[f];
        s.addEventListener(f, d), a.on("dispose", function(h) {
          return s.removeEventListener(f, d);
        });
      }), this.on("loadstart", c), this.on("dispose", function(f) {
        return a.off("loadstart", c);
      });
    }
  }, n.proxyNativeTracks_ = function() {
    var i = this;
    pa.names.forEach(function(a) {
      i.proxyNativeTracksForType_(a);
    });
  }, n.createEl = function() {
    var i = this.options_.tag;
    if (!i || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (i) {
        var a = i.cloneNode(!0);
        i.parentNode && i.parentNode.insertBefore(a, i), t.disposeMediaElement(i), i = a;
      } else {
        i = ft.createElement("video");
        var o = this.options_.tag && ko(this.options_.tag), s = $n({}, o);
        (!tc || this.options_.nativeControlsForTouch !== !0) && delete s.controls, iP(i, ci(s, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      i.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && nc(i, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (i.disablePictureInPicture = this.options_.disablePictureInPicture);
    for (var l = ["loop", "muted", "playsinline", "autoplay"], u = 0; u < l.length; u++) {
      var c = l[u], f = this.options_[c];
      typeof f < "u" && (f ? nc(i, c, c) : a2(i, c), i[c] = f);
    }
    return i;
  }, n.handleLateInit_ = function(i) {
    if (!(i.networkState === 0 || i.networkState === 3)) {
      if (i.readyState === 0) {
        var a = !1, o = function() {
          a = !0;
        };
        this.on("loadstart", o);
        var s = function() {
          a || this.trigger("loadstart");
        };
        this.on("loadedmetadata", s), this.ready(function() {
          this.off("loadstart", o), this.off("loadedmetadata", s), a || this.trigger("loadstart");
        });
        return;
      }
      var l = ["loadstart"];
      l.push("loadedmetadata"), i.readyState >= 2 && l.push("loadeddata"), i.readyState >= 3 && l.push("canplay"), i.readyState >= 4 && l.push("canplaythrough"), this.ready(function() {
        l.forEach(function(u) {
          this.trigger(u);
        }, this);
      });
    }
  }, n.setScrubbing = function(i) {
    this.isScrubbing_ = i;
  }, n.scrubbing = function() {
    return this.isScrubbing_;
  }, n.setCurrentTime = function(i) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && r2 ? this.el_.fastSeek(i) : this.el_.currentTime = i;
    } catch (a) {
      pn(a, "Video is not ready. (Video.js)");
    }
  }, n.duration = function() {
    var i = this;
    if (this.el_.duration === 1 / 0 && rs && as && this.el_.currentTime === 0) {
      var a = function o() {
        i.el_.currentTime > 0 && (i.el_.duration === 1 / 0 && i.trigger("durationchange"), i.off("timeupdate", o));
      };
      return this.on("timeupdate", a), NaN;
    }
    return this.el_.duration || NaN;
  }, n.width = function() {
    return this.el_.offsetWidth;
  }, n.height = function() {
    return this.el_.offsetHeight;
  }, n.proxyWebkitFullscreen_ = function() {
    var i = this;
    if ("webkitDisplayingFullscreen" in this.el_) {
      var a = function() {
        this.trigger("fullscreenchange", {
          isFullscreen: !1
        }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
      }, o = function() {
        "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", a), this.trigger("fullscreenchange", {
          isFullscreen: !0,
          nativeIOSFullscreen: !0
        }));
      };
      this.on("webkitbeginfullscreen", o), this.on("dispose", function() {
        i.off("webkitbeginfullscreen", o), i.off("webkitendfullscreen", a);
      });
    }
  }, n.supportsFullScreen = function() {
    if (typeof this.el_.webkitEnterFullScreen == "function") {
      var i = pe.navigator && pe.navigator.userAgent || "";
      if (/Android/.test(i) || !/Chrome|Mac OS X 10.5/.test(i))
        return !0;
    }
    return !1;
  }, n.enterFullScreen = function() {
    var i = this.el_;
    if (i.paused && i.networkState <= i.HAVE_METADATA)
      io(this.el_.play()), this.setTimeout(function() {
        i.pause();
        try {
          i.webkitEnterFullScreen();
        } catch (a) {
          this.trigger("fullscreenerror", a);
        }
      }, 0);
    else
      try {
        i.webkitEnterFullScreen();
      } catch (a) {
        this.trigger("fullscreenerror", a);
      }
  }, n.exitFullScreen = function() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }, n.requestPictureInPicture = function() {
    return this.el_.requestPictureInPicture();
  }, n.requestVideoFrameCallback = function(i) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(i) : e.prototype.requestVideoFrameCallback.call(this, i);
  }, n.cancelVideoFrameCallback = function(i) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(i) : e.prototype.cancelVideoFrameCallback.call(this, i);
  }, n.src = function(i) {
    if (i === void 0)
      return this.el_.src;
    this.setSrc(i);
  }, n.reset = function() {
    t.resetMediaElement(this.el_);
  }, n.currentSrc = function() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }, n.setControls = function(i) {
    this.el_.controls = !!i;
  }, n.addTextTrack = function(i, a, o) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(i, a, o) : e.prototype.addTextTrack.call(this, i, a, o);
  }, n.createRemoteTextTrack = function(i) {
    if (!this.featuresNativeTextTracks)
      return e.prototype.createRemoteTextTrack.call(this, i);
    var a = ft.createElement("track");
    return i.kind && (a.kind = i.kind), i.label && (a.label = i.label), (i.language || i.srclang) && (a.srclang = i.language || i.srclang), i.default && (a.default = i.default), i.id && (a.id = i.id), i.src && (a.src = i.src), a;
  }, n.addRemoteTextTrack = function(i, a) {
    var o = e.prototype.addRemoteTextTrack.call(this, i, a);
    return this.featuresNativeTextTracks && this.el().appendChild(o), o;
  }, n.removeRemoteTextTrack = function(i) {
    if (e.prototype.removeRemoteTextTrack.call(this, i), this.featuresNativeTextTracks)
      for (var a = this.$$("track"), o = a.length; o--; )
        (i === a[o] || i === a[o].track) && this.el().removeChild(a[o]);
  }, n.getVideoPlaybackQuality = function() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    var i = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (i.droppedVideoFrames = this.el().webkitDroppedFrameCount, i.totalVideoFrames = this.el().webkitDecodedFrameCount), pe.performance && typeof pe.performance.now == "function" ? i.creationTime = pe.performance.now() : pe.performance && pe.performance.timing && typeof pe.performance.timing.navigationStart == "number" && (i.creationTime = pe.Date.now() - pe.performance.timing.navigationStart), i;
  }, t;
}(Wn);
X6(Et, "TEST_VID", function() {
  if (!!Cc()) {
    var e = ft.createElement("video"), t = ft.createElement("track");
    return t.kind = "captions", t.srclang = "en", t.label = "English", e.appendChild(t), e;
  }
});
Et.isSupported = function() {
  try {
    Et.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(Et.TEST_VID && Et.TEST_VID.canPlayType);
};
Et.canPlayType = function(e) {
  return Et.TEST_VID.canPlayType(e);
};
Et.canPlaySource = function(e, t) {
  return Et.canPlayType(e.type);
};
Et.canControlVolume = function() {
  try {
    var e = Et.TEST_VID.volume;
    Et.TEST_VID.volume = e / 2 + 0.1;
    var t = e !== Et.TEST_VID.volume;
    return t && Ar ? (pe.setTimeout(function() {
      Et && Et.prototype && (Et.prototype.featuresVolumeControl = e !== Et.TEST_VID.volume);
    }), !1) : t;
  } catch {
    return !1;
  }
};
Et.canMuteVolume = function() {
  try {
    var e = Et.TEST_VID.muted;
    return Et.TEST_VID.muted = !e, Et.TEST_VID.muted ? nc(Et.TEST_VID, "muted", "muted") : a2(Et.TEST_VID, "muted", "muted"), e !== Et.TEST_VID.muted;
  } catch {
    return !1;
  }
};
Et.canControlPlaybackRate = function() {
  if (rs && as && Zw < 58)
    return !1;
  try {
    var e = Et.TEST_VID.playbackRate;
    return Et.TEST_VID.playbackRate = e / 2 + 0.1, e !== Et.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
Et.canOverrideAttributes = function() {
  try {
    var e = function() {
    };
    Object.defineProperty(ft.createElement("video"), "src", {
      get: e,
      set: e
    }), Object.defineProperty(ft.createElement("audio"), "src", {
      get: e,
      set: e
    }), Object.defineProperty(ft.createElement("video"), "innerHTML", {
      get: e,
      set: e
    }), Object.defineProperty(ft.createElement("audio"), "innerHTML", {
      get: e,
      set: e
    });
  } catch {
    return !1;
  }
  return !0;
};
Et.supportsNativeTextTracks = function() {
  return r2 || Ar && as;
};
Et.supportsNativeVideoTracks = function() {
  return !!(Et.TEST_VID && Et.TEST_VID.videoTracks);
};
Et.supportsNativeAudioTracks = function() {
  return !!(Et.TEST_VID && Et.TEST_VID.audioTracks);
};
Et.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function(e) {
  var t = e[0], n = e[1];
  X6(Et.prototype, t, function() {
    return Et[n]();
  }, !0);
});
Et.prototype.featuresVolumeControl = Et.canControlVolume();
Et.prototype.movingMediaElementInDOM = !Ar;
Et.prototype.featuresFullscreenResize = !0;
Et.prototype.featuresProgressEvents = !0;
Et.prototype.featuresTimeupdateEvents = !0;
Et.prototype.featuresVideoFrameCallback = !!(Et.TEST_VID && Et.TEST_VID.requestVideoFrameCallback);
var rh;
Et.patchCanPlayType = function() {
  f6 >= 4 && !Qw && !as && (rh = Et.TEST_VID && Et.TEST_VID.constructor.prototype.canPlayType, Et.TEST_VID.constructor.prototype.canPlayType = function(e) {
    var t = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
    return e && t.test(e) ? "maybe" : rh.call(this, e);
  });
};
Et.unpatchCanPlayType = function() {
  var e = Et.TEST_VID.constructor.prototype.canPlayType;
  return rh && (Et.TEST_VID.constructor.prototype.canPlayType = rh), e;
};
Et.patchCanPlayType();
Et.disposeMediaElement = function(e) {
  if (!!e) {
    for (e.parentNode && e.parentNode.removeChild(e); e.hasChildNodes(); )
      e.removeChild(e.firstChild);
    e.removeAttribute("src"), typeof e.load == "function" && function() {
      try {
        e.load();
      } catch {
      }
    }();
  }
};
Et.resetMediaElement = function(e) {
  if (!!e) {
    for (var t = e.querySelectorAll("source"), n = t.length; n--; )
      e.removeChild(t[n]);
    e.removeAttribute("src"), typeof e.load == "function" && function() {
      try {
        e.load();
      } catch {
      }
    }();
  }
};
[
  "muted",
  "defaultMuted",
  "autoplay",
  "controls",
  "loop",
  "playsinline"
].forEach(function(e) {
  Et.prototype[e] = function() {
    return this.el_[e] || this.el_.hasAttribute(e);
  };
});
[
  "muted",
  "defaultMuted",
  "autoplay",
  "loop",
  "playsinline"
].forEach(function(e) {
  Et.prototype["set" + gi(e)] = function(t) {
    this.el_[e] = t, t ? this.el_.setAttribute(e, e) : this.el_.removeAttribute(e);
  };
});
[
  "paused",
  "currentTime",
  "buffered",
  "volume",
  "poster",
  "preload",
  "error",
  "seeking",
  "seekable",
  "ended",
  "playbackRate",
  "defaultPlaybackRate",
  "disablePictureInPicture",
  "played",
  "networkState",
  "readyState",
  "videoWidth",
  "videoHeight",
  "crossOrigin"
].forEach(function(e) {
  Et.prototype[e] = function() {
    return this.el_[e];
  };
});
[
  "volume",
  "src",
  "poster",
  "preload",
  "playbackRate",
  "defaultPlaybackRate",
  "disablePictureInPicture",
  "crossOrigin"
].forEach(function(e) {
  Et.prototype["set" + gi(e)] = function(t) {
    this.el_[e] = t;
  };
});
[
  "pause",
  "load",
  "play"
].forEach(function(e) {
  Et.prototype[e] = function() {
    return this.el_[e]();
  };
});
Wn.withSourceHandlers(Et);
Et.nativeSourceHandler = {};
Et.nativeSourceHandler.canPlayType = function(e) {
  try {
    return Et.TEST_VID.canPlayType(e);
  } catch {
    return "";
  }
};
Et.nativeSourceHandler.canHandleSource = function(e, t) {
  if (e.type)
    return Et.nativeSourceHandler.canPlayType(e.type);
  if (e.src) {
    var n = w6(e.src);
    return Et.nativeSourceHandler.canPlayType("video/" + n);
  }
  return "";
};
Et.nativeSourceHandler.handleSource = function(e, t, n) {
  t.setSrc(e.src);
};
Et.nativeSourceHandler.dispose = function() {
};
Et.registerSourceHandler(Et.nativeSourceHandler);
Wn.registerTech("Html5", Et);
var QP = [
  "progress",
  "abort",
  "suspend",
  "emptied",
  "stalled",
  "loadedmetadata",
  "loadeddata",
  "timeupdate",
  "resize",
  "volumechange",
  "texttrackchange"
], Gp = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, P4 = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], y0 = {};
P4.forEach(function(e) {
  var t = e.charAt(0) === "x" ? "x-" + e.substring(1) : e;
  y0[e] = "vjs-layout-" + t;
});
var Dle = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
}, Ei = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    if (r.id = r.id || i.id || "vjs_video_" + os(), i = ci(t.getTagSettings(r), i), i.initChildren = !1, i.createEl = !1, i.evented = !1, i.reportTouchActivity = !1, !i.language)
      if (typeof r.closest == "function") {
        var s = r.closest("[lang]");
        s && s.getAttribute && (i.language = s.getAttribute("lang"));
      } else
        for (var l = r; l && l.nodeType === 1; ) {
          if (ko(l).hasOwnProperty("lang")) {
            i.language = l.getAttribute("lang");
            break;
          }
          l = l.parentNode;
        }
    if (o = e.call(this, null, i, a) || this, o.boundDocumentFullscreenChange_ = function(d) {
      return o.documentFullscreenChange_(d);
    }, o.boundFullWindowOnEscKey_ = function(d) {
      return o.fullWindowOnEscKey(d);
    }, o.boundUpdateStyleEl_ = function(d) {
      return o.updateStyleEl_(d);
    }, o.boundApplyInitTime_ = function(d) {
      return o.applyInitTime_(d);
    }, o.boundUpdateCurrentBreakpoint_ = function(d) {
      return o.updateCurrentBreakpoint_(d);
    }, o.boundHandleTechClick_ = function(d) {
      return o.handleTechClick_(d);
    }, o.boundHandleTechDoubleClick_ = function(d) {
      return o.handleTechDoubleClick_(d);
    }, o.boundHandleTechTouchStart_ = function(d) {
      return o.handleTechTouchStart_(d);
    }, o.boundHandleTechTouchMove_ = function(d) {
      return o.handleTechTouchMove_(d);
    }, o.boundHandleTechTouchEnd_ = function(d) {
      return o.handleTechTouchEnd_(d);
    }, o.boundHandleTechTap_ = function(d) {
      return o.handleTechTap_(d);
    }, o.isFullscreen_ = !1, o.log = Ww(o.id_), o.fsApi_ = $0, o.isPosterFromTech_ = !1, o.queuedCallbacks_ = [], o.isReady_ = !1, o.hasStarted_ = !1, o.userActive_ = !1, o.debugEnabled_ = !1, o.audioOnlyMode_ = !1, o.audioPosterMode_ = !1, o.audioOnlyCache_ = {
      playerHeight: null,
      hiddenChildren: []
    }, !o.options_ || !o.options_.techOrder || !o.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (o.tag = r, o.tagAttributes = r && ko(r), o.language(o.options_.language), i.languages) {
      var u = {};
      Object.getOwnPropertyNames(i.languages).forEach(function(d) {
        u[d.toLowerCase()] = i.languages[d];
      }), o.languages_ = u;
    } else
      o.languages_ = t.prototype.options_.languages;
    o.resetCache_(), o.poster_ = i.poster || "", o.controls_ = !!i.controls, r.controls = !1, r.removeAttribute("controls"), o.changingSrc_ = !1, o.playCallbacks_ = [], o.playTerminatedQueue_ = [], r.hasAttribute("autoplay") ? o.autoplay(!0) : o.autoplay(o.options_.autoplay), i.plugins && Object.keys(i.plugins).forEach(function(d) {
      if (typeof o[d] != "function")
        throw new Error('plugin "' + d + '" does not exist');
    }), o.scrubbing_ = !1, o.el_ = o.createEl(), b6(on(o), {
      eventBusKey: "el_"
    }), o.fsApi_.requestFullscreen && (ea(ft, o.fsApi_.fullscreenchange, o.boundDocumentFullscreenChange_), o.on(o.fsApi_.fullscreenchange, o.boundDocumentFullscreenChange_)), o.fluid_ && o.on(["playerreset", "resize"], o.boundUpdateStyleEl_);
    var c = $n(o.options_);
    i.plugins && Object.keys(i.plugins).forEach(function(d) {
      o[d](i.plugins[d]);
    }), i.debug && o.debug(!0), o.options_.playerOptions = c, o.middleware_ = [], o.playbackRates(i.playbackRates), o.initChildren(), o.isAudio(r.nodeName.toLowerCase() === "audio"), o.controls() ? o.addClass("vjs-controls-enabled") : o.addClass("vjs-controls-disabled"), o.el_.setAttribute("role", "region"), o.isAudio() ? o.el_.setAttribute("aria-label", o.localize("Audio Player")) : o.el_.setAttribute("aria-label", o.localize("Video Player")), o.isAudio() && o.addClass("vjs-audio"), o.flexNotSupported_() && o.addClass("vjs-no-flex"), tc && o.addClass("vjs-touch-enabled"), Ar || o.addClass("vjs-workinghover"), t.players[o.id_] = on(o);
    var f = Uw.split(".")[0];
    return o.addClass("vjs-v" + f), o.userActive(!0), o.reportUserActivity(), o.one("play", function(d) {
      return o.listenForUserActivity_(d);
    }), o.on("stageclick", function(d) {
      return o.handleStageClick_(d);
    }), o.on("keydown", function(d) {
      return o.handleKeyDown(d);
    }), o.on("languagechange", function(d) {
      return o.handleLanguagechange(d);
    }), o.breakpoints(o.options_.breakpoints), o.responsive(o.options_.responsive), o.on("ready", function() {
      o.audioPosterMode(o.options_.audioPosterMode), o.audioOnlyMode(o.options_.audioOnlyMode);
    }), o;
  }
  var n = t.prototype;
  return n.dispose = function() {
    var i = this;
    this.trigger("dispose"), this.off("dispose"), nr(ft, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), nr(ft, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), t.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), Zse(this), vr.names.forEach(function(a) {
      var o = vr[a], s = i[o.getterName]();
      s && s.off && s.off();
    }), e.prototype.dispose.call(this, {
      restoreEl: this.options_.restoreEl
    });
  }, n.createEl = function() {
    var i = this.tag, a, o = this.playerElIngest_ = i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player"), s = this.tag.tagName.toLowerCase() === "video-js";
    o ? a = this.el_ = i.parentNode : s || (a = this.el_ = e.prototype.createEl.call(this, "div"));
    var l = ko(i);
    if (s) {
      for (a = this.el_ = i, i = this.tag = ft.createElement("video"); a.children.length; )
        i.appendChild(a.firstChild);
      Sl(a, "video-js") || Xo(a, "video-js"), a.appendChild(i), o = this.playerElIngest_ = a, Object.keys(a).forEach(function(p) {
        try {
          i[p] = a[p];
        } catch {
        }
      });
    }
    if (i.setAttribute("tabindex", "-1"), l.tabindex = "-1", (Ef || as && Jw) && (i.setAttribute("role", "application"), l.role = "application"), i.removeAttribute("width"), i.removeAttribute("height"), "width" in l && delete l.width, "height" in l && delete l.height, Object.getOwnPropertyNames(l).forEach(function(p) {
      s && p === "class" || a.setAttribute(p, l[p]), s && i.setAttribute(p, l[p]);
    }), i.playerId = i.id, i.id += "_html5_api", i.className = "vjs-tech", i.player = a.player = this, this.addClass("vjs-paused"), pe.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = hP("vjs-styles-dimensions");
      var u = js(".vjs-styles-defaults"), c = js("head");
      c.insertBefore(this.styleEl_, u ? u.nextSibling : c.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    for (var f = i.getElementsByTagName("a"), d = 0; d < f.length; d++) {
      var h = f.item(d);
      Xo(h, "vjs-hidden"), h.setAttribute("hidden", "hidden");
    }
    return i.initNetworkState_ = i.networkState, i.parentNode && !o && i.parentNode.insertBefore(a, i), v4(i, a), this.children_.unshift(i), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = a, a;
  }, n.crossOrigin = function(i) {
    if (!i)
      return this.techGet_("crossOrigin");
    if (i !== "anonymous" && i !== "use-credentials") {
      pn.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + i + '"');
      return;
    }
    this.techCall_("setCrossOrigin", i);
  }, n.width = function(i) {
    return this.dimension("width", i);
  }, n.height = function(i) {
    return this.dimension("height", i);
  }, n.dimension = function(i, a) {
    var o = i + "_";
    if (a === void 0)
      return this[o] || 0;
    if (a === "" || a === "auto") {
      this[o] = void 0, this.updateStyleEl_();
      return;
    }
    var s = parseFloat(a);
    if (isNaN(s)) {
      pn.error('Improper value "' + a + '" supplied for for ' + i);
      return;
    }
    this[o] = s, this.updateStyleEl_();
  }, n.fluid = function(i) {
    var a = this;
    if (i === void 0)
      return !!this.fluid_;
    this.fluid_ = !!i, Ro(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), i ? (this.addClass("vjs-fluid"), this.fill(!1), wse(this, function() {
      a.on(["playerreset", "resize"], a.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }, n.fill = function(i) {
    if (i === void 0)
      return !!this.fill_;
    this.fill_ = !!i, i ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }, n.aspectRatio = function(i) {
    if (i === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(i))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = i, this.fluid(!0), this.updateStyleEl_();
  }, n.updateStyleEl_ = function() {
    if (pe.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      var i = typeof this.width_ == "number" ? this.width_ : this.options_.width, a = typeof this.height_ == "number" ? this.height_ : this.options_.height, o = this.tech_ && this.tech_.el();
      o && (i >= 0 && (o.width = i), a >= 0 && (o.height = a));
      return;
    }
    var s, l, u, c;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? u = this.aspectRatio_ : this.videoWidth() > 0 ? u = this.videoWidth() + ":" + this.videoHeight() : u = "16:9";
    var f = u.split(":"), d = f[1] / f[0];
    this.width_ !== void 0 ? s = this.width_ : this.height_ !== void 0 ? s = this.height_ / d : s = this.videoWidth() || 300, this.height_ !== void 0 ? l = this.height_ : l = s * d, /^[^a-zA-Z]/.test(this.id()) ? c = "dimensions-" + this.id() : c = this.id() + "-dimensions", this.addClass(c), pP(this.styleEl_, `
      .` + c + ` {
        width: ` + s + `px;
        height: ` + l + `px;
      }

      .` + c + `.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ` + d * 100 + `%;
      }
    `);
  }, n.loadTech_ = function(i, a) {
    var o = this;
    this.tech_ && this.unloadTech_();
    var s = gi(i), l = i.charAt(0).toLowerCase() + i.slice(1);
    s !== "Html5" && this.tag && (Wn.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = s, this.isReady_ = !1;
    var u = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (u = !1);
    var c = {
      source: a,
      autoplay: u,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: this.id() + "_" + l + "_api",
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset,
      Promise: this.options_.Promise
    };
    vr.names.forEach(function(d) {
      var h = vr[d];
      c[h.getterName] = o[h.privateName];
    }), ci(c, this.options_[s]), ci(c, this.options_[l]), ci(c, this.options_[i.toLowerCase()]), this.tag && (c.tag = this.tag), a && a.src === this.cache_.src && this.cache_.currentTime > 0 && (c.startTime = this.cache_.currentTime);
    var f = Wn.getTech(i);
    if (!f)
      throw new Error("No Tech named '" + s + "' exists! '" + s + "' should be registered using videojs.registerTech()'");
    this.tech_ = new f(c), this.tech_.ready(ei(this, this.handleTechReady_), !0), Dm.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), QP.forEach(function(d) {
      o.on(o.tech_, d, function(h) {
        return o["handleTech" + gi(d) + "_"](h);
      });
    }), Object.keys(Gp).forEach(function(d) {
      o.on(o.tech_, d, function(h) {
        if (o.tech_.playbackRate() === 0 && o.tech_.seeking()) {
          o.queuedCallbacks_.push({
            callback: o["handleTech" + Gp[d] + "_"].bind(o),
            event: h
          });
          return;
        }
        o["handleTech" + Gp[d] + "_"](h);
      });
    }), this.on(this.tech_, "loadstart", function(d) {
      return o.handleTechLoadStart_(d);
    }), this.on(this.tech_, "sourceset", function(d) {
      return o.handleTechSourceset_(d);
    }), this.on(this.tech_, "waiting", function(d) {
      return o.handleTechWaiting_(d);
    }), this.on(this.tech_, "ended", function(d) {
      return o.handleTechEnded_(d);
    }), this.on(this.tech_, "seeking", function(d) {
      return o.handleTechSeeking_(d);
    }), this.on(this.tech_, "play", function(d) {
      return o.handleTechPlay_(d);
    }), this.on(this.tech_, "firstplay", function(d) {
      return o.handleTechFirstPlay_(d);
    }), this.on(this.tech_, "pause", function(d) {
      return o.handleTechPause_(d);
    }), this.on(this.tech_, "durationchange", function(d) {
      return o.handleTechDurationChange_(d);
    }), this.on(this.tech_, "fullscreenchange", function(d, h) {
      return o.handleTechFullscreenChange_(d, h);
    }), this.on(this.tech_, "fullscreenerror", function(d, h) {
      return o.handleTechFullscreenError_(d, h);
    }), this.on(this.tech_, "enterpictureinpicture", function(d) {
      return o.handleTechEnterPictureInPicture_(d);
    }), this.on(this.tech_, "leavepictureinpicture", function(d) {
      return o.handleTechLeavePictureInPicture_(d);
    }), this.on(this.tech_, "error", function(d) {
      return o.handleTechError_(d);
    }), this.on(this.tech_, "posterchange", function(d) {
      return o.handleTechPosterChange_(d);
    }), this.on(this.tech_, "textdata", function(d) {
      return o.handleTechTextData_(d);
    }), this.on(this.tech_, "ratechange", function(d) {
      return o.handleTechRateChange_(d);
    }), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (s !== "Html5" || !this.tag) && v4(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }, n.unloadTech_ = function() {
    var i = this;
    vr.names.forEach(function(a) {
      var o = vr[a];
      i[o.privateName] = i[o.getterName]();
    }), this.textTracksJson_ = Dm.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }, n.tech = function(i) {
    return i === void 0 && pn.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }, n.addTechControlsListeners_ = function() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }, n.removeTechControlsListeners_ = function() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }, n.handleTechReady_ = function() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }, n.handleTechLoadStart_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }, n.manualAutoplay_ = function(i) {
    var a = this;
    if (!(!this.tech_ || typeof i != "string")) {
      var o = function() {
        var u = a.muted();
        a.muted(!0);
        var c = function() {
          a.muted(u);
        };
        a.playTerminatedQueue_.push(c);
        var f = a.play();
        if (!!xd(f))
          return f.catch(function(d) {
            throw c(), new Error("Rejection at manualAutoplay. Restoring muted value. " + (d || ""));
          });
      }, s;
      if (i === "any" && !this.muted() ? (s = this.play(), xd(s) && (s = s.catch(o))) : i === "muted" && !this.muted() ? s = o() : s = this.play(), !!xd(s))
        return s.then(function() {
          a.trigger({
            type: "autoplay-success",
            autoplay: i
          });
        }).catch(function() {
          a.trigger({
            type: "autoplay-failure",
            autoplay: i
          });
        });
    }
  }, n.updateSourceCaches_ = function(i) {
    i === void 0 && (i = "");
    var a = i, o = "";
    typeof a != "string" && (a = i.src, o = i.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], a && !o && (o = ele(this, a)), this.cache_.source = $n({}, i, {
      src: a,
      type: o
    });
    for (var s = this.cache_.sources.filter(function(h) {
      return h.src && h.src === a;
    }), l = [], u = this.$$("source"), c = [], f = 0; f < u.length; f++) {
      var d = ko(u[f]);
      l.push(d), d.src && d.src === a && c.push(d.src);
    }
    c.length && !s.length ? this.cache_.sources = l : s.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = a;
  }, n.handleTechSourceset_ = function(i) {
    var a = this;
    if (!this.changingSrc_) {
      var o = function(c) {
        return a.updateSourceCaches_(c);
      }, s = this.currentSource().src, l = i.src;
      s && !/^blob:/.test(s) && /^blob:/.test(l) && (!this.lastSource_ || this.lastSource_.tech !== l && this.lastSource_.player !== s) && (o = function() {
      }), o(l), i.src || this.tech_.any(["sourceset", "loadstart"], function(u) {
        if (u.type !== "sourceset") {
          var c = a.techGet("currentSrc");
          a.lastSource_.tech = c, a.updateSourceCaches_(c);
        }
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: i.src
    }, this.trigger({
      src: i.src,
      type: "sourceset"
    });
  }, n.hasStarted = function(i) {
    if (i === void 0)
      return this.hasStarted_;
    i !== this.hasStarted_ && (this.hasStarted_ = i, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"));
  }, n.handleTechPlay_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }, n.handleTechRateChange_ = function() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach(function(i) {
      return i.callback(i.event);
    }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }, n.handleTechWaiting_ = function() {
    var i = this;
    this.addClass("vjs-waiting"), this.trigger("waiting");
    var a = this.currentTime(), o = function s() {
      a !== i.currentTime() && (i.removeClass("vjs-waiting"), i.off("timeupdate", s));
    };
    this.on("timeupdate", o);
  }, n.handleTechCanPlay_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }, n.handleTechCanPlayThrough_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }, n.handleTechPlaying_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }, n.handleTechSeeking_ = function() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }, n.handleTechSeeked_ = function() {
    this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked");
  }, n.handleTechFirstPlay_ = function() {
    this.options_.starttime && (pn.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay");
  }, n.handleTechPause_ = function() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }, n.handleTechEnded_ = function() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }, n.handleTechDurationChange_ = function() {
    this.duration(this.techGet_("duration"));
  }, n.handleTechClick_ = function(i) {
    !this.controls_ || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, i) : this.paused() ? io(this.play()) : this.pause());
  }, n.handleTechDoubleClick_ = function(i) {
    if (!!this.controls_) {
      var a = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function(o) {
        return o.contains(i.target);
      });
      a || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, i) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
    }
  }, n.handleTechTap_ = function() {
    this.userActive(!this.userActive());
  }, n.handleTechTouchStart_ = function() {
    this.userWasActive = this.userActive();
  }, n.handleTechTouchMove_ = function() {
    this.userWasActive && this.reportUserActivity();
  }, n.handleTechTouchEnd_ = function(i) {
    i.cancelable && i.preventDefault();
  }, n.handleStageClick_ = function() {
    this.reportUserActivity();
  }, n.toggleFullscreenClass_ = function() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }, n.documentFullscreenChange_ = function(i) {
    var a = i.target.player;
    if (!(a && a !== this)) {
      var o = this.el(), s = ft[this.fsApi_.fullscreenElement] === o;
      !s && o.matches ? s = o.matches(":" + this.fsApi_.fullscreen) : !s && o.msMatchesSelector && (s = o.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(s);
    }
  }, n.handleTechFullscreenChange_ = function(i, a) {
    var o = this;
    a && (a.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", function() {
      o.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(a.isFullscreen));
  }, n.handleTechFullscreenError_ = function(i, a) {
    this.trigger("fullscreenerror", a);
  }, n.togglePictureInPictureClass_ = function() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }, n.handleTechEnterPictureInPicture_ = function(i) {
    this.isInPictureInPicture(!0);
  }, n.handleTechLeavePictureInPicture_ = function(i) {
    this.isInPictureInPicture(!1);
  }, n.handleTechError_ = function() {
    var i = this.tech_.error();
    this.error(i);
  }, n.handleTechTextData_ = function() {
    var i = null;
    arguments.length > 1 && (i = arguments[1]), this.trigger("textdata", i);
  }, n.getCache = function() {
    return this.cache_;
  }, n.resetCache_ = function() {
    this.cache_ = {
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }, n.techCall_ = function(i, a) {
    this.ready(function() {
      if (i in Yse)
        return Kse(this.middleware_, this.tech_, i, a);
      if (i in Nm)
        return Bm(this.middleware_, this.tech_, i, a);
      try {
        this.tech_ && this.tech_[i](a);
      } catch (o) {
        throw pn(o), o;
      }
    }, !0);
  }, n.techGet_ = function(i) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (i in Gse)
        return Wse(this.middleware_, this.tech_, i);
      if (i in Nm)
        return Bm(this.middleware_, this.tech_, i);
      try {
        return this.tech_[i]();
      } catch (a) {
        throw this.tech_[i] === void 0 ? (pn("Video.js: " + i + " method not defined for " + this.techName_ + " playback technology.", a), a) : a.name === "TypeError" ? (pn("Video.js: " + i + " unavailable on " + this.techName_ + " playback technology element.", a), this.tech_.isReady_ = !1, a) : (pn(a), a);
      }
    }
  }, n.play = function() {
    var i = this, a = this.options_.Promise || pe.Promise;
    return a ? new a(function(o) {
      i.play_(o);
    }) : this.play_();
  }, n.play_ = function(i) {
    var a = this;
    i === void 0 && (i = io), this.playCallbacks_.push(i);
    var o = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !o) {
      this.waitToPlay_ = function(l) {
        a.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !o && (r2 || Ar) && this.load();
      return;
    }
    var s = this.techGet_("play");
    s === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(s);
  }, n.runPlayTerminatedQueue_ = function() {
    var i = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], i.forEach(function(a) {
      a();
    });
  }, n.runPlayCallbacks_ = function(i) {
    var a = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], a.forEach(function(o) {
      o(i);
    });
  }, n.pause = function() {
    this.techCall_("pause");
  }, n.paused = function() {
    return this.techGet_("paused") !== !1;
  }, n.played = function() {
    return this.techGet_("played") || El(0, 0);
  }, n.scrubbing = function(i) {
    if (typeof i > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!i, this.techCall_("setScrubbing", this.scrubbing_), i ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }, n.currentTime = function(i) {
    if (typeof i < "u") {
      if (i < 0 && (i = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
        this.cache_.initTime = i, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
        return;
      }
      this.techCall_("setCurrentTime", i), this.cache_.initTime = 0;
      return;
    }
    return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
  }, n.applyInitTime_ = function() {
    this.currentTime(this.cache_.initTime);
  }, n.duration = function(i) {
    if (i === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    i = parseFloat(i), i < 0 && (i = 1 / 0), i !== this.cache_.duration && (this.cache_.duration = i, i === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(i) || this.trigger("durationchange"));
  }, n.remainingTime = function() {
    return this.duration() - this.currentTime();
  }, n.remainingTimeDisplay = function() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }, n.buffered = function() {
    var i = this.techGet_("buffered");
    return (!i || !i.length) && (i = El(0, 0)), i;
  }, n.bufferedPercent = function() {
    return AP(this.buffered(), this.duration());
  }, n.bufferedEnd = function() {
    var i = this.buffered(), a = this.duration(), o = i.end(i.length - 1);
    return o > a && (o = a), o;
  }, n.volume = function(i) {
    var a;
    if (i !== void 0) {
      a = Math.max(0, Math.min(1, parseFloat(i))), this.cache_.volume = a, this.techCall_("setVolume", a), a > 0 && this.lastVolume_(a);
      return;
    }
    return a = parseFloat(this.techGet_("volume")), isNaN(a) ? 1 : a;
  }, n.muted = function(i) {
    if (i !== void 0) {
      this.techCall_("setMuted", i);
      return;
    }
    return this.techGet_("muted") || !1;
  }, n.defaultMuted = function(i) {
    return i !== void 0 ? this.techCall_("setDefaultMuted", i) : this.techGet_("defaultMuted") || !1;
  }, n.lastVolume_ = function(i) {
    if (i !== void 0 && i !== 0) {
      this.cache_.lastVolume = i;
      return;
    }
    return this.cache_.lastVolume;
  }, n.supportsFullScreen = function() {
    return this.techGet_("supportsFullScreen") || !1;
  }, n.isFullscreen = function(i) {
    if (i !== void 0) {
      var a = this.isFullscreen_;
      this.isFullscreen_ = Boolean(i), this.isFullscreen_ !== a && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }, n.requestFullscreen = function(i) {
    var a = this.options_.Promise || pe.Promise;
    if (a) {
      var o = this;
      return new a(function(s, l) {
        function u() {
          o.off("fullscreenerror", f), o.off("fullscreenchange", c);
        }
        function c() {
          u(), s();
        }
        function f(h, p) {
          u(), l(p);
        }
        o.one("fullscreenchange", c), o.one("fullscreenerror", f);
        var d = o.requestFullscreenHelper_(i);
        d && (d.then(u, u), d.then(s, l));
      });
    }
    return this.requestFullscreenHelper_();
  }, n.requestFullscreenHelper_ = function(i) {
    var a = this, o;
    if (this.fsApi_.prefixed || (o = this.options_.fullscreen && this.options_.fullscreen.options || {}, i !== void 0 && (o = i)), this.fsApi_.requestFullscreen) {
      var s = this.el_[this.fsApi_.requestFullscreen](o);
      return s && s.then(function() {
        return a.isFullscreen(!0);
      }, function() {
        return a.isFullscreen(!1);
      }), s;
    } else
      this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }, n.exitFullscreen = function() {
    var i = this.options_.Promise || pe.Promise;
    if (i) {
      var a = this;
      return new i(function(o, s) {
        function l() {
          a.off("fullscreenerror", c), a.off("fullscreenchange", u);
        }
        function u() {
          l(), o();
        }
        function c(d, h) {
          l(), s(h);
        }
        a.one("fullscreenchange", u), a.one("fullscreenerror", c);
        var f = a.exitFullscreenHelper_();
        f && (f.then(l, l), f.then(o, s));
      });
    }
    return this.exitFullscreenHelper_();
  }, n.exitFullscreenHelper_ = function() {
    var i = this;
    if (this.fsApi_.requestFullscreen) {
      var a = ft[this.fsApi_.exitFullscreen]();
      return a && io(a.then(function() {
        return i.isFullscreen(!1);
      })), a;
    } else
      this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }, n.enterFullWindow = function() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = ft.documentElement.style.overflow, ea(ft, "keydown", this.boundFullWindowOnEscKey_), ft.documentElement.style.overflow = "hidden", Xo(ft.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }, n.fullWindowOnEscKey = function(i) {
    un.isEventKey(i, "Esc") && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }, n.exitFullWindow = function() {
    this.isFullscreen(!1), this.isFullWindow = !1, nr(ft, "keydown", this.boundFullWindowOnEscKey_), ft.documentElement.style.overflow = this.docOrigOverflow, kf(ft.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }, n.disablePictureInPicture = function(i) {
    if (i === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", i), this.options_.disablePictureInPicture = i, this.trigger("disablepictureinpicturechanged");
  }, n.isInPictureInPicture = function(i) {
    if (i !== void 0) {
      this.isInPictureInPicture_ = !!i, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }, n.requestPictureInPicture = function() {
    if ("pictureInPictureEnabled" in ft && this.disablePictureInPicture() === !1)
      return this.techGet_("requestPictureInPicture");
  }, n.exitPictureInPicture = function() {
    if ("pictureInPictureEnabled" in ft)
      return ft.exitPictureInPicture();
  }, n.handleKeyDown = function(i) {
    var a = this.options_.userActions;
    if (!(!a || !a.hotkeys)) {
      var o = function(l) {
        var u = l.tagName.toLowerCase();
        if (l.isContentEditable)
          return !0;
        var c = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
        if (u === "input")
          return c.indexOf(l.type) === -1;
        var f = ["textarea"];
        return f.indexOf(u) !== -1;
      };
      o(this.el_.ownerDocument.activeElement) || (typeof a.hotkeys == "function" ? a.hotkeys.call(this, i) : this.handleHotkeys(i));
    }
  }, n.handleHotkeys = function(i) {
    var a = this.options_.userActions ? this.options_.userActions.hotkeys : {}, o = a.fullscreenKey, s = o === void 0 ? function(y) {
      return un.isEventKey(y, "f");
    } : o, l = a.muteKey, u = l === void 0 ? function(y) {
      return un.isEventKey(y, "m");
    } : l, c = a.playPauseKey, f = c === void 0 ? function(y) {
      return un.isEventKey(y, "k") || un.isEventKey(y, "Space");
    } : c;
    if (s.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var d = at.getComponent("FullscreenToggle");
      ft[this.fsApi_.fullscreenEnabled] !== !1 && d.prototype.handleClick.call(this, i);
    } else if (u.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var h = at.getComponent("MuteToggle");
      h.prototype.handleClick.call(this, i);
    } else if (f.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var p = at.getComponent("PlayToggle");
      p.prototype.handleClick.call(this, i);
    }
  }, n.canPlayType = function(i) {
    for (var a, o = 0, s = this.options_.techOrder; o < s.length; o++) {
      var l = s[o], u = Wn.getTech(l);
      if (u || (u = at.getComponent(l)), !u) {
        pn.error('The "' + l + '" tech is undefined. Skipped browser support check for that tech.');
        continue;
      }
      if (u.isSupported() && (a = u.canPlayType(i), a))
        return a;
    }
    return "";
  }, n.selectSource = function(i) {
    var a = this, o = this.options_.techOrder.map(function(f) {
      return [f, Wn.getTech(f)];
    }).filter(function(f) {
      var d = f[0], h = f[1];
      return h ? h.isSupported() : (pn.error('The "' + d + '" tech is undefined. Skipped browser support check for that tech.'), !1);
    }), s = function(d, h, p) {
      var y;
      return d.some(function(m) {
        return h.some(function(b) {
          if (y = p(m, b), y)
            return !0;
        });
      }), y;
    }, l, u = function(d) {
      return function(h, p) {
        return d(p, h);
      };
    }, c = function(d, h) {
      var p = d[0], y = d[1];
      if (y.canPlaySource(h, a.options_[p.toLowerCase()]))
        return {
          source: h,
          tech: p
        };
    };
    return this.options_.sourceOrder ? l = s(i, o, u(c)) : l = s(o, i, c), l || !1;
  }, n.handleSrc_ = function(i, a) {
    var o = this;
    if (typeof i > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    var s = tle(i);
    if (!s.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, a || (this.cache_.sources = s), this.updateSourceCaches_(s[0]), qse(this, s[0], function(c, f) {
      o.middleware_ = f, a || (o.cache_.sources = s), o.updateSourceCaches_(c);
      var d = o.src_(c);
      if (d) {
        if (s.length > 1)
          return o.handleSrc_(s.slice(1));
        o.changingSrc_ = !1, o.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), o.triggerReady();
        return;
      }
      _se(f, o.tech_);
    }), this.options_.retryOnError && s.length > 1) {
      var l = function() {
        o.error(null), o.handleSrc_(s.slice(1), !0);
      }, u = function() {
        o.off("error", l);
      };
      this.one("error", l), this.one("playing", u), this.resetRetryOnError_ = function() {
        o.off("error", l), o.off("playing", u);
      };
    }
  }, n.src = function(i) {
    return this.handleSrc_(i, !1);
  }, n.src_ = function(i) {
    var a = this, o = this.selectSource([i]);
    return o ? Cse(o.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", i) : this.techCall_("src", i.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(o.tech, o.source), this.tech_.ready(function() {
      a.changingSrc_ = !1;
    }), !1) : !0;
  }, n.load = function() {
    this.techCall_("load");
  }, n.reset = function() {
    var i = this, a = this.options_.Promise || pe.Promise;
    if (this.paused() || !a)
      this.doReset_();
    else {
      var o = this.play();
      io(o.then(function() {
        return i.doReset_();
      }));
    }
  }, n.doReset_ = function() {
    this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), Ro(this) && this.trigger("playerreset");
  }, n.resetControlBarUI_ = function() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }, n.resetProgressBar_ = function() {
    this.currentTime(0);
    var i = this.controlBar || {}, a = i.durationDisplay, o = i.remainingTimeDisplay;
    a && a.updateContent(), o && o.updateContent();
  }, n.resetPlaybackRate_ = function() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }, n.resetVolumeBar_ = function() {
    this.volume(1), this.trigger("volumechange");
  }, n.currentSources = function() {
    var i = this.currentSource(), a = [];
    return Object.keys(i).length !== 0 && a.push(i), this.cache_.sources || a;
  }, n.currentSource = function() {
    return this.cache_.source || {};
  }, n.currentSrc = function() {
    return this.currentSource() && this.currentSource().src || "";
  }, n.currentType = function() {
    return this.currentSource() && this.currentSource().type || "";
  }, n.preload = function(i) {
    if (i !== void 0) {
      this.techCall_("setPreload", i), this.options_.preload = i;
      return;
    }
    return this.techGet_("preload");
  }, n.autoplay = function(i) {
    if (i === void 0)
      return this.options_.autoplay || !1;
    var a;
    typeof i == "string" && /(any|play|muted)/.test(i) || i === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = i, this.manualAutoplay_(typeof i == "string" ? i : "play"), a = !1) : i ? this.options_.autoplay = !0 : this.options_.autoplay = !1, a = typeof a > "u" ? this.options_.autoplay : a, this.tech_ && this.techCall_("setAutoplay", a);
  }, n.playsinline = function(i) {
    return i !== void 0 ? (this.techCall_("setPlaysinline", i), this.options_.playsinline = i, this) : this.techGet_("playsinline");
  }, n.loop = function(i) {
    if (i !== void 0) {
      this.techCall_("setLoop", i), this.options_.loop = i;
      return;
    }
    return this.techGet_("loop");
  }, n.poster = function(i) {
    if (i === void 0)
      return this.poster_;
    i || (i = ""), i !== this.poster_ && (this.poster_ = i, this.techCall_("setPoster", i), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }, n.handleTechPosterChange_ = function() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      var i = this.tech_.poster() || "";
      i !== this.poster_ && (this.poster_ = i, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }, n.controls = function(i) {
    if (i === void 0)
      return !!this.controls_;
    i = !!i, this.controls_ !== i && (this.controls_ = i, this.usingNativeControls() && this.techCall_("setControls", i), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }, n.usingNativeControls = function(i) {
    if (i === void 0)
      return !!this.usingNativeControls_;
    i = !!i, this.usingNativeControls_ !== i && (this.usingNativeControls_ = i, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }, n.error = function(i) {
    var a = this;
    if (i === void 0)
      return this.error_ || null;
    if (Ns("beforeerror").forEach(function(s) {
      var l = s(a, i);
      if (!(Go(l) && !Array.isArray(l) || typeof l == "string" || typeof l == "number" || l === null)) {
        a.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      i = l;
    }), this.options_.suppressNotSupportedError && i && i.code === 4) {
      var o = function() {
        this.error(i);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], o), this.one("loadstart", function() {
        this.off(["click", "touchstart"], o);
      });
      return;
    }
    if (i === null) {
      this.error_ = i, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new br(i), this.addClass("vjs-error"), pn.error("(CODE:" + this.error_.code + " " + br.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error"), Ns("error").forEach(function(s) {
      return s(a, a.error_);
    });
  }, n.reportUserActivity = function(i) {
    this.userActivity_ = !0;
  }, n.userActive = function(i) {
    if (i === void 0)
      return this.userActive_;
    if (i = !!i, i !== this.userActive_) {
      if (this.userActive_ = i, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(a) {
        a.stopPropagation(), a.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }, n.listenForUserActivity_ = function() {
    var i, a, o, s = ei(this, this.reportUserActivity), l = function(p) {
      (p.screenX !== a || p.screenY !== o) && (a = p.screenX, o = p.screenY, s());
    }, u = function() {
      s(), this.clearInterval(i), i = this.setInterval(s, 250);
    }, c = function(p) {
      s(), this.clearInterval(i);
    };
    this.on("mousedown", u), this.on("mousemove", l), this.on("mouseup", c), this.on("mouseleave", c);
    var f = this.getChild("controlBar");
    f && !Ar && !rs && (f.on("mouseenter", function(h) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), f.on("mouseleave", function(h) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", s), this.on("keyup", s);
    var d;
    this.setInterval(function() {
      if (!!this.userActivity_) {
        this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(d);
        var h = this.options_.inactivityTimeout;
        h <= 0 || (d = this.setTimeout(function() {
          this.userActivity_ || this.userActive(!1);
        }, h));
      }
    }, 250);
  }, n.playbackRate = function(i) {
    if (i !== void 0) {
      this.techCall_("setPlaybackRate", i);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }, n.defaultPlaybackRate = function(i) {
    return i !== void 0 ? this.techCall_("setDefaultPlaybackRate", i) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }, n.isAudio = function(i) {
    if (i !== void 0) {
      this.isAudio_ = !!i;
      return;
    }
    return !!this.isAudio_;
  }, n.enableAudioOnlyUI_ = function() {
    var i = this;
    this.addClass("vjs-audio-only-mode");
    var a = this.children(), o = this.getChild("ControlBar"), s = o && o.currentHeight();
    a.forEach(function(l) {
      l !== o && l.el_ && !l.hasClass("vjs-hidden") && (l.hide(), i.audioOnlyCache_.hiddenChildren.push(l));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.height(s), this.trigger("audioonlymodechange");
  }, n.disableAudioOnlyUI_ = function() {
    this.removeClass("vjs-audio-only-mode"), this.audioOnlyCache_.hiddenChildren.forEach(function(i) {
      return i.show();
    }), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }, n.audioOnlyMode = function(i) {
    var a = this;
    if (typeof i != "boolean" || i === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    this.audioOnlyMode_ = i;
    var o = this.options_.Promise || pe.Promise;
    if (o) {
      if (i) {
        var s = [];
        return this.isInPictureInPicture() && s.push(this.exitPictureInPicture()), this.isFullscreen() && s.push(this.exitFullscreen()), this.audioPosterMode() && s.push(this.audioPosterMode(!1)), o.all(s).then(function() {
          return a.enableAudioOnlyUI_();
        });
      }
      return o.resolve().then(function() {
        return a.disableAudioOnlyUI_();
      });
    }
    i ? (this.isInPictureInPicture() && this.exitPictureInPicture(), this.isFullscreen() && this.exitFullscreen(), this.enableAudioOnlyUI_()) : this.disableAudioOnlyUI_();
  }, n.enablePosterModeUI_ = function() {
    var i = this.tech_ && this.tech_;
    i.hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }, n.disablePosterModeUI_ = function() {
    var i = this.tech_ && this.tech_;
    i.show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }, n.audioPosterMode = function(i) {
    var a = this;
    if (typeof i != "boolean" || i === this.audioPosterMode_)
      return this.audioPosterMode_;
    this.audioPosterMode_ = i;
    var o = this.options_.Promise || pe.Promise;
    if (o) {
      if (i) {
        if (this.audioOnlyMode()) {
          var s = this.audioOnlyMode(!1);
          return s.then(function() {
            a.enablePosterModeUI_();
          });
        }
        return o.resolve().then(function() {
          a.enablePosterModeUI_();
        });
      }
      return o.resolve().then(function() {
        a.disablePosterModeUI_();
      });
    }
    if (i) {
      this.audioOnlyMode() && this.audioOnlyMode(!1), this.enablePosterModeUI_();
      return;
    }
    this.disablePosterModeUI_();
  }, n.addTextTrack = function(i, a, o) {
    if (this.tech_)
      return this.tech_.addTextTrack(i, a, o);
  }, n.addRemoteTextTrack = function(i, a) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(i, a);
  }, n.removeRemoteTextTrack = function(i) {
    i === void 0 && (i = {});
    var a = i, o = a.track;
    if (o || (o = i), this.tech_)
      return this.tech_.removeRemoteTextTrack(o);
  }, n.getVideoPlaybackQuality = function() {
    return this.techGet_("getVideoPlaybackQuality");
  }, n.videoWidth = function() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }, n.videoHeight = function() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }, n.language = function(i) {
    if (i === void 0)
      return this.language_;
    this.language_ !== String(i).toLowerCase() && (this.language_ = String(i).toLowerCase(), Ro(this) && this.trigger("languagechange"));
  }, n.languages = function() {
    return $n(t.prototype.options_.languages, this.languages_);
  }, n.toJSON = function() {
    var i = $n(this.options_), a = i.tracks;
    i.tracks = [];
    for (var o = 0; o < a.length; o++) {
      var s = a[o];
      s = $n(s), s.player = void 0, i.tracks[o] = s;
    }
    return i;
  }, n.createModal = function(i, a) {
    var o = this;
    a = a || {}, a.content = i || "";
    var s = new kc(this, a);
    return this.addChild(s), s.on("dispose", function() {
      o.removeChild(s);
    }), s.open(), s;
  }, n.updateCurrentBreakpoint_ = function() {
    if (!!this.responsive())
      for (var i = this.currentBreakpoint(), a = this.currentWidth(), o = 0; o < P4.length; o++) {
        var s = P4[o], l = this.breakpoints_[s];
        if (a <= l) {
          if (i === s)
            return;
          i && this.removeClass(y0[i]), this.addClass(y0[s]), this.breakpoint_ = s;
          break;
        }
      }
  }, n.removeCurrentBreakpoint_ = function() {
    var i = this.currentBreakpointClass();
    this.breakpoint_ = "", i && this.removeClass(i);
  }, n.breakpoints = function(i) {
    return i === void 0 ? ci(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = ci({}, Dle, i), this.updateCurrentBreakpoint_(), ci(this.breakpoints_));
  }, n.responsive = function(i) {
    if (i === void 0)
      return this.responsive_;
    i = Boolean(i);
    var a = this.responsive_;
    if (i !== a)
      return this.responsive_ = i, i ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), i;
  }, n.currentBreakpoint = function() {
    return this.breakpoint_;
  }, n.currentBreakpointClass = function() {
    return y0[this.breakpoint_] || "";
  }, n.loadMedia = function(i, a) {
    var o = this;
    if (!(!i || typeof i != "object")) {
      this.reset(), this.cache_.media = $n(i);
      var s = this.cache_.media, l = s.artwork, u = s.poster, c = s.src, f = s.textTracks;
      !l && u && (this.cache_.media.artwork = [{
        src: u,
        type: nh(u)
      }]), c && this.src(c), u && this.poster(u), Array.isArray(f) && f.forEach(function(d) {
        return o.addRemoteTextTrack(d, !1);
      }), this.ready(a);
    }
  }, n.getMedia = function() {
    if (!this.cache_.media) {
      var i = this.poster(), a = this.currentSources(), o = Array.prototype.map.call(this.remoteTextTracks(), function(l) {
        return {
          kind: l.kind,
          label: l.label,
          language: l.language,
          src: l.src
        };
      }), s = {
        src: a,
        textTracks: o
      };
      return i && (s.poster = i, s.artwork = [{
        src: s.poster,
        type: nh(s.poster)
      }]), s;
    }
    return $n(this.cache_.media);
  }, t.getTagSettings = function(i) {
    var a = {
      sources: [],
      tracks: []
    }, o = ko(i), s = o["data-setup"];
    if (Sl(i, "vjs-fill") && (o.fill = !0), Sl(i, "vjs-fluid") && (o.fluid = !0), s !== null) {
      var l = yre(s || "{}"), u = l[0], c = l[1];
      u && pn.error(u), ci(o, c);
    }
    if (ci(a, o), i.hasChildNodes())
      for (var f = i.childNodes, d = 0, h = f.length; d < h; d++) {
        var p = f[d], y = p.nodeName.toLowerCase();
        y === "source" ? a.sources.push(ko(p)) : y === "track" && a.tracks.push(ko(p));
      }
    return a;
  }, n.flexNotSupported_ = function() {
    var i = ft.createElement("i");
    return !("flexBasis" in i.style || "webkitFlexBasis" in i.style || "mozFlexBasis" in i.style || "msFlexBasis" in i.style || "msFlexOrder" in i.style);
  }, n.debug = function(i) {
    if (i === void 0)
      return this.debugEnabled_;
    i ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }, n.playbackRates = function(i) {
    if (i === void 0)
      return this.cache_.playbackRates;
    !Array.isArray(i) || !i.every(function(a) {
      return typeof a == "number";
    }) || (this.cache_.playbackRates = i, this.trigger("playbackrateschange"));
  }, t;
}(at);
vr.names.forEach(function(e) {
  var t = vr[e];
  Ei.prototype[t.getterName] = function() {
    return this.tech_ ? this.tech_[t.getterName]() : (this[t.privateName] = this[t.privateName] || new t.ListClass(), this[t.privateName]);
  };
});
Ei.prototype.crossorigin = Ei.prototype.crossOrigin;
Ei.players = {};
var td = pe.navigator;
Ei.prototype.options_ = {
  techOrder: Wn.defaultTechOrder_,
  html5: {},
  inactivityTimeout: 2e3,
  playbackRates: [],
  liveui: !1,
  children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: td && (td.languages && td.languages[0] || td.userLanguage || td.language) || "en",
  languages: {},
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1
};
[
  "ended",
  "seeking",
  "seekable",
  "networkState",
  "readyState"
].forEach(function(e) {
  Ei.prototype[e] = function() {
    return this.techGet_(e);
  };
});
QP.forEach(function(e) {
  Ei.prototype["handleTech" + gi(e) + "_"] = function() {
    return this.trigger(e);
  };
});
at.registerComponent("Player", Ei);
var ah = "plugin", Lu = "activePlugins_", Cu = {}, oh = function(t) {
  return Cu.hasOwnProperty(t);
}, b0 = function(t) {
  return oh(t) ? Cu[t] : void 0;
}, ZP = function(t, n) {
  t[Lu] = t[Lu] || {}, t[Lu][n] = !0;
}, sh = function(t, n, r) {
  var i = (r ? "before" : "") + "pluginsetup";
  t.trigger(i, n), t.trigger(i + ":" + n.name, n);
}, Mle = function(t, n) {
  var r = function() {
    sh(this, {
      name: t,
      plugin: n,
      instance: null
    }, !0);
    var a = n.apply(this, arguments);
    return ZP(this, t), sh(this, {
      name: t,
      plugin: n,
      instance: a
    }), a;
  };
  return Object.keys(n).forEach(function(i) {
    r[i] = n[i];
  }), r;
}, Zm = function(t, n) {
  return n.prototype.name = t, function() {
    sh(this, {
      name: t,
      plugin: n,
      instance: null
    }, !0);
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++)
      i[a] = arguments[a];
    var o = p0(n, [this].concat(i));
    return this[t] = function() {
      return o;
    }, sh(this, o.getEventHash()), o;
  };
}, po = /* @__PURE__ */ function() {
  function e(n) {
    if (this.constructor === e)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = n, this.log || (this.log = this.player.log.createLogger(this.name)), b6(this), delete this.trigger, bP(this, this.constructor.defaultState), ZP(n, this.name), this.dispose = this.dispose.bind(this), n.on("dispose", this.dispose);
  }
  var t = e.prototype;
  return t.version = function() {
    return this.constructor.VERSION;
  }, t.getEventHash = function(r) {
    return r === void 0 && (r = {}), r.name = this.name, r.plugin = this.constructor, r.instance = this, r;
  }, t.trigger = function(r, i) {
    return i === void 0 && (i = {}), Ec(this.eventBusEl_, r, this.getEventHash(i));
  }, t.handleStateChanged = function(r) {
  }, t.dispose = function() {
    var r = this.name, i = this.player;
    this.trigger("dispose"), this.off(), i.off("dispose", this.dispose), i[Lu][r] = !1, this.player = this.state = null, i[r] = Zm(r, Cu[r]);
  }, e.isBasic = function(r) {
    var i = typeof r == "string" ? b0(r) : r;
    return typeof i == "function" && !e.prototype.isPrototypeOf(i.prototype);
  }, e.registerPlugin = function(r, i) {
    if (typeof r != "string")
      throw new Error('Illegal plugin name, "' + r + '", must be a string, was ' + typeof r + ".");
    if (oh(r))
      pn.warn('A plugin named "' + r + '" already exists. You may want to avoid re-registering plugins!');
    else if (Ei.prototype.hasOwnProperty(r))
      throw new Error('Illegal plugin name, "' + r + '", cannot share a name with an existing player method!');
    if (typeof i != "function")
      throw new Error('Illegal plugin for "' + r + '", must be a function, was ' + typeof i + ".");
    return Cu[r] = i, r !== ah && (e.isBasic(i) ? Ei.prototype[r] = Mle(r, i) : Ei.prototype[r] = Zm(r, i)), i;
  }, e.deregisterPlugin = function(r) {
    if (r === ah)
      throw new Error("Cannot de-register base plugin.");
    oh(r) && (delete Cu[r], delete Ei.prototype[r]);
  }, e.getPlugins = function(r) {
    r === void 0 && (r = Object.keys(Cu));
    var i;
    return r.forEach(function(a) {
      var o = b0(a);
      o && (i = i || {}, i[a] = o);
    }), i;
  }, e.getPluginVersion = function(r) {
    var i = b0(r);
    return i && i.VERSION || "";
  }, e;
}();
po.getPlugin = b0;
po.BASE_PLUGIN_NAME = ah;
po.registerPlugin(ah, po);
Ei.prototype.usingPlugin = function(e) {
  return !!this[Lu] && this[Lu][e] === !0;
};
Ei.prototype.hasPlugin = function(e) {
  return !!oh(e);
};
var Hle = function(t, n) {
  n === void 0 && (n = {});
  var r = function() {
    t.apply(this, arguments);
  }, i = {};
  typeof n == "object" ? (n.constructor !== Object.prototype.constructor && (r = n.constructor), i = n) : typeof n == "function" && (r = n), oae(r, t), t && (r.super_ = t);
  for (var a in i)
    i.hasOwnProperty(a) && (r.prototype[a] = i[a]);
  return r;
}, JP = function(t) {
  return t.indexOf("#") === 0 ? t.slice(1) : t;
};
function Ce(e, t, n) {
  var r = Ce.getPlayer(e);
  if (r)
    return t && pn.warn('Player "' + e + '" is already initialised. Options will not be applied.'), n && r.ready(n), r;
  var i = typeof e == "string" ? js("#" + JP(e)) : e;
  if (!Sc(i))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  (!i.ownerDocument.defaultView || !i.ownerDocument.body.contains(i)) && pn.warn("The element supplied is not included in the DOM"), t = t || {}, t.restoreEl === !0 && (t.restoreEl = (i.parentNode && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), Ns("beforesetup").forEach(function(o) {
    var s = o(i, $n(t));
    if (!Go(s) || Array.isArray(s)) {
      pn.error("please return an object in beforesetup hooks");
      return;
    }
    t = $n(t, s);
  });
  var a = at.getComponent("Player");
  return r = new a(i, t, n), Ns("setup").forEach(function(o) {
    return o(r);
  }), r;
}
Ce.hooks_ = Io;
Ce.hooks = Ns;
Ce.hook = ose;
Ce.hookOnce = sse;
Ce.removeHook = qw;
if (pe.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && Cc()) {
  var E1 = js(".vjs-styles-defaults");
  if (!E1) {
    E1 = hP("vjs-styles-defaults");
    var Yp = js("head");
    Yp && Yp.insertBefore(E1, Yp.firstChild), pP(E1, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
g4(1, Ce);
Ce.VERSION = Uw;
Ce.options = Ei.prototype.options_;
Ce.getPlayers = function() {
  return Ei.players;
};
Ce.getPlayer = function(e) {
  var t = Ei.players, n;
  if (typeof e == "string") {
    var r = JP(e), i = t[r];
    if (i)
      return i;
    n = js("#" + r);
  } else
    n = e;
  if (Sc(n)) {
    var a = n, o = a.player, s = a.playerId;
    if (o || t[s])
      return o || t[s];
  }
};
Ce.getAllPlayers = function() {
  return Object.keys(Ei.players).map(function(e) {
    return Ei.players[e];
  }).filter(Boolean);
};
Ce.players = Ei.players;
Ce.getComponent = at.getComponent;
Ce.registerComponent = function(e, t) {
  Wn.isTech(t) && pn.warn("The " + e + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), at.registerComponent.call(at, e, t);
};
Ce.getTech = Wn.getTech;
Ce.registerTech = Wn.registerTech;
Ce.use = Use;
Object.defineProperty(Ce, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(Ce.middleware, "TERMINATOR", {
  value: th,
  writeable: !1,
  enumerable: !0
});
Ce.browser = hse;
Ce.TOUCH_ENABLED = tc;
Ce.extend = Hle;
Ce.mergeOptions = $n;
Ce.bind = ei;
Ce.registerPlugin = po.registerPlugin;
Ce.deregisterPlugin = po.deregisterPlugin;
Ce.plugin = function(e, t) {
  return pn.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), po.registerPlugin(e, t);
};
Ce.getPlugins = po.getPlugins;
Ce.getPlugin = po.getPlugin;
Ce.getPluginVersion = po.getPluginVersion;
Ce.addLanguage = function(e, t) {
  var n;
  return e = ("" + e).toLowerCase(), Ce.options.languages = $n(Ce.options.languages, (n = {}, n[e] = t, n)), Ce.options.languages[e];
};
Ce.log = pn;
Ce.createLogger = Ww;
Ce.createTimeRange = Ce.createTimeRanges = El;
Ce.formatTime = oc;
Ce.setFormatTime = lle;
Ce.resetFormatTime = ule;
Ce.parseUrl = T6;
Ce.isCrossOrigin = c2;
Ce.EventTarget = ji;
Ce.on = ea;
Ce.one = l2;
Ce.off = nr;
Ce.trigger = Ec;
Ce.xhr = Yh.exports;
Ce.TextTrack = Of;
Ce.AudioTrack = PP;
Ce.VideoTrack = xP;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function(e) {
  Ce[e] = function() {
    return pn.warn("videojs." + e + "() is deprecated; use videojs.dom." + e + "() instead"), dP[e].apply(null, arguments);
  };
});
Ce.computedStyle = tf;
Ce.dom = dP;
Ce.url = Fse;
Ce.defineLazyProperty = X6;
Ce.addLanguage("en", {
  "Non-Fullscreen": "Exit Fullscreen"
});
/*! @name @videojs/http-streaming @version 2.14.2 @license Apache-2.0 */
var Na = Zh, lh = function(t, n, r) {
  return t && r && r.responseURL && n !== r.responseURL ? r.responseURL : n;
}, Ya = function(t) {
  return Ce.log.debug ? Ce.log.debug.bind(Ce, "VHS:", t + " >") : function() {
  };
}, Fs = 1 / 30, ro = Fs * 3, $P = function(t, n) {
  var r = [], i;
  if (t && t.length)
    for (i = 0; i < t.length; i++)
      n(t.start(i), t.end(i)) && r.push([t.start(i), t.end(i)]);
  return Ce.createTimeRanges(r);
}, Su = function(t, n) {
  return $P(t, function(r, i) {
    return r - ro <= n && i + ro >= n;
  });
}, k1 = function(t, n) {
  return $P(t, function(r) {
    return r - Fs >= n;
  });
}, Ile = function(t) {
  if (t.length < 2)
    return Ce.createTimeRanges();
  for (var n = [], r = 1; r < t.length; r++) {
    var i = t.end(r - 1), a = t.start(r);
    n.push([i, a]);
  }
  return Ce.createTimeRanges(n);
}, Lle = function(t, n) {
  var r = null, i = null, a = 0, o = [], s = [];
  if (!t || !t.length || !n || !n.length)
    return Ce.createTimeRange();
  for (var l = t.length; l--; )
    o.push({
      time: t.start(l),
      type: "start"
    }), o.push({
      time: t.end(l),
      type: "end"
    });
  for (l = n.length; l--; )
    o.push({
      time: n.start(l),
      type: "start"
    }), o.push({
      time: n.end(l),
      type: "end"
    });
  for (o.sort(function(u, c) {
    return u.time - c.time;
  }), l = 0; l < o.length; l++)
    o[l].type === "start" ? (a++, a === 2 && (r = o[l].time)) : o[l].type === "end" && (a--, a === 1 && (i = o[l].time)), r !== null && i !== null && (s.push([r, i]), r = null, i = null);
  return Ce.createTimeRanges(s);
}, ex = function(t) {
  var n = [];
  if (!t || !t.length)
    return "";
  for (var r = 0; r < t.length; r++)
    n.push(t.start(r) + " => " + t.end(r));
  return n.join(", ");
}, Ble = function(t, n, r) {
  r === void 0 && (r = 1);
  var i = t.length ? t.end(t.length - 1) : 0;
  return (i - n) / r;
}, bl = function(t) {
  for (var n = [], r = 0; r < t.length; r++)
    n.push({
      start: t.start(r),
      end: t.end(r)
    });
  return n;
}, Nle = function(t, n) {
  if (t === n)
    return !1;
  if (!t && n || !n && t || t.length !== n.length)
    return !0;
  for (var r = 0; r < t.length; r++)
    if (t.start(r) !== n.start(r) || t.end(r) !== n.end(r))
      return !0;
  return !1;
}, Jm = function(t) {
  if (!(!t || !t.length || !t.end))
    return t.end(t.length - 1);
}, R6 = function(t, n) {
  var r = 0;
  if (!t || !t.length)
    return r;
  for (var i = 0; i < t.length; i++) {
    var a = t.start(i), o = t.end(i);
    if (!(n > o)) {
      if (n > a && n <= o) {
        r += o - n;
        continue;
      }
      r += o - a;
    }
  }
  return r;
}, $m = Ce.createTimeRange, V6 = function(t, n) {
  if (!n.preload)
    return n.duration;
  var r = 0;
  return (n.parts || []).forEach(function(i) {
    r += i.duration;
  }), (n.preloadHints || []).forEach(function(i) {
    i.type === "PART" && (r += t.partTargetDuration);
  }), r;
}, x4 = function(t) {
  return (t.segments || []).reduce(function(n, r, i) {
    return r.parts ? r.parts.forEach(function(a, o) {
      n.push({
        duration: a.duration,
        segmentIndex: i,
        partIndex: o,
        part: a,
        segment: r
      });
    }) : n.push({
      duration: r.duration,
      segmentIndex: i,
      partIndex: null,
      segment: r,
      part: null
    }), n;
  }, []);
}, tx = function(t) {
  var n = t.segments && t.segments.length && t.segments[t.segments.length - 1];
  return n && n.parts || [];
}, nx = function(t) {
  var n = t.preloadSegment;
  if (!!n) {
    var r = n.parts, i = n.preloadHints, a = (i || []).reduce(function(o, s) {
      return o + (s.type === "PART" ? 1 : 0);
    }, 0);
    return a += r && r.length ? r.length : 0, a;
  }
}, ix = function(t, n) {
  if (n.endList)
    return 0;
  if (t && t.suggestedPresentationDelay)
    return t.suggestedPresentationDelay;
  var r = tx(n).length > 0;
  return r && n.serverControl && n.serverControl.partHoldBack ? n.serverControl.partHoldBack : r && n.partTargetDuration ? n.partTargetDuration * 3 : n.serverControl && n.serverControl.holdBack ? n.serverControl.holdBack : n.targetDuration ? n.targetDuration * 3 : 0;
}, jle = function(t, n) {
  var r = 0, i = n - t.mediaSequence, a = t.segments[i];
  if (a) {
    if (typeof a.start < "u")
      return {
        result: a.start,
        precise: !0
      };
    if (typeof a.end < "u")
      return {
        result: a.end - a.duration,
        precise: !0
      };
  }
  for (; i--; ) {
    if (a = t.segments[i], typeof a.end < "u")
      return {
        result: r + a.end,
        precise: !0
      };
    if (r += V6(t, a), typeof a.start < "u")
      return {
        result: r + a.start,
        precise: !0
      };
  }
  return {
    result: r,
    precise: !1
  };
}, Fle = function(t, n) {
  for (var r = 0, i, a = n - t.mediaSequence; a < t.segments.length; a++) {
    if (i = t.segments[a], typeof i.start < "u")
      return {
        result: i.start - r,
        precise: !0
      };
    if (r += V6(t, i), typeof i.end < "u")
      return {
        result: i.end - r,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, rx = function(t, n, r) {
  if (typeof n > "u" && (n = t.mediaSequence + t.segments.length), n < t.mediaSequence)
    return 0;
  var i = jle(t, n);
  if (i.precise)
    return i.result;
  var a = Fle(t, n);
  return a.precise ? a.result : i.result + r;
}, ax = function(t, n, r) {
  if (!t)
    return 0;
  if (typeof r != "number" && (r = 0), typeof n > "u") {
    if (t.totalDuration)
      return t.totalDuration;
    if (!t.endList)
      return pe.Infinity;
  }
  return rx(t, n, r);
}, Cd = function(t) {
  var n = t.defaultDuration, r = t.durationList, i = t.startIndex, a = t.endIndex, o = 0;
  if (i > a) {
    var s = [a, i];
    i = s[0], a = s[1];
  }
  if (i < 0) {
    for (var l = i; l < Math.min(0, a); l++)
      o += n;
    i = 0;
  }
  for (var u = i; u < a; u++)
    o += r[u].duration;
  return o;
}, ox = function(t, n, r, i) {
  if (!t || !t.segments)
    return null;
  if (t.endList)
    return ax(t);
  if (n === null)
    return null;
  n = n || 0;
  var a = rx(t, t.mediaSequence + t.segments.length, n);
  return r && (i = typeof i == "number" ? i : ix(null, t), a -= i), Math.max(0, a);
}, Xle = function(t, n, r) {
  var i = !0, a = n || 0, o = ox(t, n, i, r);
  return o === null ? $m() : $m(a, o);
}, Rle = function(t) {
  for (var n = t.playlist, r = t.currentTime, i = t.startingSegmentIndex, a = t.startingPartIndex, o = t.startTime, s = t.experimentalExactManifestTimings, l = r - o, u = x4(n), c = 0, f = 0; f < u.length; f++) {
    var d = u[f];
    if (i === d.segmentIndex && !(typeof a == "number" && typeof d.partIndex == "number" && a !== d.partIndex)) {
      c = f;
      break;
    }
  }
  if (l < 0) {
    if (c > 0)
      for (var h = c - 1; h >= 0; h--) {
        var p = u[h];
        if (l += p.duration, s) {
          if (l < 0)
            continue;
        } else if (l + Fs <= 0)
          continue;
        return {
          partIndex: p.partIndex,
          segmentIndex: p.segmentIndex,
          startTime: o - Cd({
            defaultDuration: n.targetDuration,
            durationList: u,
            startIndex: c,
            endIndex: h
          })
        };
      }
    return {
      partIndex: u[0] && u[0].partIndex || null,
      segmentIndex: u[0] && u[0].segmentIndex || 0,
      startTime: r
    };
  }
  if (c < 0) {
    for (var y = c; y < 0; y++)
      if (l -= n.targetDuration, l < 0)
        return {
          partIndex: u[0] && u[0].partIndex || null,
          segmentIndex: u[0] && u[0].segmentIndex || 0,
          startTime: r
        };
    c = 0;
  }
  for (var m = c; m < u.length; m++) {
    var b = u[m];
    if (l -= b.duration, s) {
      if (l > 0)
        continue;
    } else if (l - Fs >= 0)
      continue;
    return {
      partIndex: b.partIndex,
      segmentIndex: b.segmentIndex,
      startTime: o + Cd({
        defaultDuration: n.targetDuration,
        durationList: u,
        startIndex: c,
        endIndex: m
      })
    };
  }
  return {
    segmentIndex: u[u.length - 1].segmentIndex,
    partIndex: u[u.length - 1].partIndex,
    startTime: r
  };
}, sx = function(t) {
  return t.excludeUntil && t.excludeUntil > Date.now();
}, U6 = function(t) {
  return t.excludeUntil && t.excludeUntil === 1 / 0;
}, p2 = function(t) {
  var n = sx(t);
  return !t.disabled && !n;
}, Vle = function(t) {
  return t.disabled;
}, Ule = function(t) {
  for (var n = 0; n < t.segments.length; n++)
    if (t.segments[n].key)
      return !0;
  return !1;
}, lx = function(t, n) {
  return n.attributes && n.attributes[t];
}, qle = function(t, n, r, i) {
  if (i === void 0 && (i = 0), !lx("BANDWIDTH", r))
    return NaN;
  var a = t * r.attributes.BANDWIDTH;
  return (a - i * 8) / n;
}, C4 = function(t, n) {
  if (t.playlists.length === 1)
    return !0;
  var r = n.attributes.BANDWIDTH || Number.MAX_VALUE;
  return t.playlists.filter(function(i) {
    return p2(i) ? (i.attributes.BANDWIDTH || 0) < r : !1;
  }).length === 0;
}, q6 = function(t, n) {
  return !t && !n || !t && n || t && !n ? !1 : !!(t === n || t.id && n.id && t.id === n.id || t.resolvedUri && n.resolvedUri && t.resolvedUri === n.resolvedUri || t.uri && n.uri && t.uri === n.uri);
}, e9 = function(t, n) {
  var r = t && t.mediaGroups && t.mediaGroups.AUDIO || {}, i = !1;
  for (var a in r) {
    for (var o in r[a])
      if (i = n(r[a][o]), i)
        break;
    if (i)
      break;
  }
  return !!i;
}, Mf = function(t) {
  if (!t || !t.playlists || !t.playlists.length) {
    var n = e9(t, function(o) {
      return o.playlists && o.playlists.length || o.uri;
    });
    return n;
  }
  for (var r = function(s) {
    var l = t.playlists[s], u = l.attributes && l.attributes.CODECS;
    if (u && u.split(",").every(function(f) {
      return nw(f);
    }))
      return "continue";
    var c = e9(t, function(f) {
      return q6(l, f);
    });
    return c ? "continue" : {
      v: !1
    };
  }, i = 0; i < t.playlists.length; i++) {
    var a = r(i);
    if (a !== "continue" && typeof a == "object")
      return a.v;
  }
  return !0;
}, Dr = {
  liveEdgeDelay: ix,
  duration: ax,
  seekable: Xle,
  getMediaInfoForTime: Rle,
  isEnabled: p2,
  isDisabled: Vle,
  isBlacklisted: sx,
  isIncompatible: U6,
  playlistEnd: ox,
  isAes: Ule,
  hasAttribute: lx,
  estimateSegmentRequestTime: qle,
  isLowestEnabledRendition: C4,
  isAudioOnly: Mf,
  playlistMatch: q6,
  segmentDurationWithParts: V6
}, ux = Ce.log, _6 = function(t, n) {
  return t + "-" + n;
}, _le = function(t) {
  var n = t.onwarn, r = t.oninfo, i = t.manifestString, a = t.customTagParsers, o = a === void 0 ? [] : a, s = t.customTagMappers, l = s === void 0 ? [] : s, u = t.experimentalLLHLS, c = new hae();
  n && c.on("warn", n), r && c.on("info", r), o.forEach(function(y) {
    return c.addParser(y);
  }), l.forEach(function(y) {
    return c.addTagMapper(y);
  }), c.push(i), c.end();
  var f = c.manifest;
  if (u || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(y) {
    f.hasOwnProperty(y) && delete f[y];
  }), f.segments && f.segments.forEach(function(y) {
    ["parts", "preloadHints"].forEach(function(m) {
      y.hasOwnProperty(m) && delete y[m];
    });
  })), !f.targetDuration) {
    var d = 10;
    f.segments && f.segments.length && (d = f.segments.reduce(function(y, m) {
      return Math.max(y, m.duration);
    }, 0)), n && n("manifest has no targetDuration defaulting to " + d), f.targetDuration = d;
  }
  var h = tx(f);
  if (h.length && !f.partTargetDuration) {
    var p = h.reduce(function(y, m) {
      return Math.max(y, m.duration);
    }, 0);
    n && (n("manifest has no partTargetDuration defaulting to " + p), ux.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), f.partTargetDuration = p;
  }
  return f;
}, Hf = function(t, n) {
  !t.mediaGroups || ["AUDIO", "SUBTITLES"].forEach(function(r) {
    if (!!t.mediaGroups[r])
      for (var i in t.mediaGroups[r])
        for (var a in t.mediaGroups[r][i]) {
          var o = t.mediaGroups[r][i][a];
          n(o, r, i, a);
        }
  });
}, cx = function(t) {
  var n = t.playlist, r = t.uri, i = t.id;
  n.id = i, n.playlistErrors_ = 0, r && (n.uri = r), n.attributes = n.attributes || {};
}, Wle = function(t) {
  for (var n = t.playlists.length; n--; ) {
    var r = t.playlists[n];
    cx({
      playlist: r,
      id: _6(n, r.uri)
    }), r.resolvedUri = Na(t.uri, r.uri), t.playlists[r.id] = r, t.playlists[r.uri] = r, r.attributes.BANDWIDTH || ux.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, Kle = function(t) {
  Hf(t, function(n) {
    n.uri && (n.resolvedUri = Na(t.uri, n.uri));
  });
}, Gle = function(t, n) {
  var r = _6(0, n), i = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: pe.location.href,
    resolvedUri: pe.location.href,
    playlists: [{
      uri: n,
      id: r,
      resolvedUri: n,
      attributes: {}
    }]
  };
  return i.playlists[r] = i.playlists[0], i.playlists[n] = i.playlists[0], i;
}, dx = function(t, n) {
  t.uri = n;
  for (var r = 0; r < t.playlists.length; r++)
    if (!t.playlists[r].uri) {
      var i = "placeholder-uri-" + r;
      t.playlists[r].uri = i;
    }
  var a = Mf(t);
  Hf(t, function(o, s, l, u) {
    var c = "placeholder-uri-" + s + "-" + l + "-" + u;
    if (!o.playlists || !o.playlists.length) {
      if (a && s === "AUDIO" && !o.uri)
        for (var f = 0; f < t.playlists.length; f++) {
          var d = t.playlists[f];
          if (d.attributes && d.attributes.AUDIO && d.attributes.AUDIO === l)
            return;
        }
      o.playlists = [Ta({}, o)];
    }
    o.playlists.forEach(function(h, p) {
      var y = _6(p, c);
      h.uri ? h.resolvedUri = h.resolvedUri || Na(t.uri, h.uri) : (h.uri = p === 0 ? c : y, h.resolvedUri = h.uri), h.id = h.id || y, h.attributes = h.attributes || {}, t.playlists[h.id] = h, t.playlists[h.uri] = h;
    });
  }), Wle(t), Kle(t);
}, uh = Ce.mergeOptions, Yle = Ce.EventTarget, Qle = function(t, n) {
  if (n.endList || !n.serverControl)
    return t;
  var r = {};
  if (n.serverControl.canBlockReload) {
    var i = n.preloadSegment, a = n.mediaSequence + n.segments.length;
    if (i) {
      var o = i.parts || [], s = nx(n) - 1;
      s > -1 && s !== o.length - 1 && (r._HLS_part = s), (s > -1 || o.length) && a--;
    }
    r._HLS_msn = a;
  }
  if (n.serverControl && n.serverControl.canSkipUntil && (r._HLS_skip = n.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(r).length) {
    var l = new pe.URL(t);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(u) {
      !r.hasOwnProperty(u) || l.searchParams.set(u, r[u]);
    }), t = l.toString();
  }
  return t;
}, Zle = function(t, n) {
  if (!t)
    return n;
  var r = uh(t, n);
  if (t.preloadHints && !n.preloadHints && delete r.preloadHints, t.parts && !n.parts)
    delete r.parts;
  else if (t.parts && n.parts)
    for (var i = 0; i < n.parts.length; i++)
      t.parts && t.parts[i] && (r.parts[i] = uh(t.parts[i], n.parts[i]));
  return !t.skipped && n.skipped && (r.skipped = !1), t.preload && !n.preload && (r.preload = !1), r;
}, Jle = function(t, n, r) {
  var i = t.slice(), a = n.slice();
  r = r || 0;
  for (var o = [], s, l = 0; l < a.length; l++) {
    var u = i[l + r], c = a[l];
    u ? (s = u.map || s, o.push(Zle(u, c))) : (s && !c.map && (c.map = s), o.push(c));
  }
  return o;
}, fx = function(t, n) {
  !t.resolvedUri && t.uri && (t.resolvedUri = Na(n, t.uri)), t.key && !t.key.resolvedUri && (t.key.resolvedUri = Na(n, t.key.uri)), t.map && !t.map.resolvedUri && (t.map.resolvedUri = Na(n, t.map.uri)), t.map && t.map.key && !t.map.key.resolvedUri && (t.map.key.resolvedUri = Na(n, t.map.key.uri)), t.parts && t.parts.length && t.parts.forEach(function(r) {
    r.resolvedUri || (r.resolvedUri = Na(n, r.uri));
  }), t.preloadHints && t.preloadHints.length && t.preloadHints.forEach(function(r) {
    r.resolvedUri || (r.resolvedUri = Na(n, r.uri));
  });
}, hx = function(t) {
  var n = t.segments || [], r = t.preloadSegment;
  if (r && r.parts && r.parts.length) {
    if (r.preloadHints) {
      for (var i = 0; i < r.preloadHints.length; i++)
        if (r.preloadHints[i].type === "MAP")
          return n;
    }
    r.duration = t.targetDuration, r.preload = !0, n.push(r);
  }
  return n;
}, px = function(t, n) {
  return t === n || t.segments && n.segments && t.segments.length === n.segments.length && t.endList === n.endList && t.mediaSequence === n.mediaSequence && t.preloadSegment === n.preloadSegment;
}, S4 = function(t, n, r) {
  r === void 0 && (r = px);
  var i = uh(t, {}), a = i.playlists[n.id];
  if (!a || r(a, n))
    return null;
  n.segments = hx(n);
  var o = uh(a, n);
  if (o.preloadSegment && !n.preloadSegment && delete o.preloadSegment, a.segments) {
    if (n.skip) {
      n.segments = n.segments || [];
      for (var s = 0; s < n.skip.skippedSegments; s++)
        n.segments.unshift({
          skipped: !0
        });
    }
    o.segments = Jle(a.segments, n.segments, n.mediaSequence - a.mediaSequence);
  }
  o.segments.forEach(function(u) {
    fx(u, o.resolvedUri);
  });
  for (var l = 0; l < i.playlists.length; l++)
    i.playlists[l].id === n.id && (i.playlists[l] = o);
  return i.playlists[n.id] = o, i.playlists[n.uri] = o, Hf(t, function(u, c, f, d) {
    if (!!u.playlists)
      for (var h = 0; h < u.playlists.length; h++)
        n.id === u.playlists[h].id && (u.playlists[h] = o);
  }), i;
}, E4 = function(t, n) {
  var r = t.segments || [], i = r[r.length - 1], a = i && i.parts && i.parts[i.parts.length - 1], o = a && a.duration || i && i.duration;
  return n && o ? o * 1e3 : (t.partTargetDuration || t.targetDuration || 10) * 500;
}, Eu = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    if (a === void 0 && (a = {}), o = e.call(this) || this, !r)
      throw new Error("A non-empty playlist URL or object is required");
    o.logger_ = Ya("PlaylistLoader");
    var s = a, l = s.withCredentials, u = l === void 0 ? !1 : l, c = s.handleManifestRedirects, f = c === void 0 ? !1 : c;
    o.src = r, o.vhs_ = i, o.withCredentials = u, o.handleManifestRedirects = f;
    var d = i.options_;
    return o.customTagParsers = d && d.customTagParsers || [], o.customTagMappers = d && d.customTagMappers || [], o.experimentalLLHLS = d && d.experimentalLLHLS || !1, Ce.browser.IE_VERSION && (o.experimentalLLHLS = !1), o.state = "HAVE_NOTHING", o.handleMediaupdatetimeout_ = o.handleMediaupdatetimeout_.bind(on(o)), o.on("mediaupdatetimeout", o.handleMediaupdatetimeout_), o;
  }
  var n = t.prototype;
  return n.handleMediaupdatetimeout_ = function() {
    var i = this;
    if (this.state === "HAVE_METADATA") {
      var a = this.media(), o = Na(this.master.uri, a.uri);
      this.experimentalLLHLS && (o = Qle(o, a)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
        uri: o,
        withCredentials: this.withCredentials
      }, function(s, l) {
        if (!!i.request) {
          if (s)
            return i.playlistRequestError(i.request, i.media(), "HAVE_METADATA");
          i.haveMetadata({
            playlistString: i.request.responseText,
            url: i.media().uri,
            id: i.media().id
          });
        }
      });
    }
  }, n.playlistRequestError = function(i, a, o) {
    var s = a.uri, l = a.id;
    this.request = null, o && (this.state = o), this.error = {
      playlist: this.master.playlists[l],
      status: i.status,
      message: "HLS playlist request error at URL: " + s + ".",
      responseText: i.responseText,
      code: i.status >= 500 ? 4 : 2
    }, this.trigger("error");
  }, n.parseManifest_ = function(i) {
    var a = this, o = i.url, s = i.manifestString;
    return _le({
      onwarn: function(u) {
        var c = u.message;
        return a.logger_("m3u8-parser warn for " + o + ": " + c);
      },
      oninfo: function(u) {
        var c = u.message;
        return a.logger_("m3u8-parser info for " + o + ": " + c);
      },
      manifestString: s,
      customTagParsers: this.customTagParsers,
      customTagMappers: this.customTagMappers,
      experimentalLLHLS: this.experimentalLLHLS
    });
  }, n.haveMetadata = function(i) {
    var a = i.playlistString, o = i.playlistObject, s = i.url, l = i.id;
    this.request = null, this.state = "HAVE_METADATA";
    var u = o || this.parseManifest_({
      url: s,
      manifestString: a
    });
    u.lastRequest = Date.now(), cx({
      playlist: u,
      uri: s,
      id: l
    });
    var c = S4(this.master, u);
    this.targetDuration = u.partTargetDuration || u.targetDuration, this.pendingMedia_ = null, c ? (this.master = c, this.media_ = this.master.playlists[l]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(E4(this.media(), !!c)), this.trigger("loadedplaylist");
  }, n.dispose = function() {
    this.trigger("dispose"), this.stopRequest(), pe.clearTimeout(this.mediaUpdateTimeout), pe.clearTimeout(this.finalRenditionTimeout), this.off();
  }, n.stopRequest = function() {
    if (this.request) {
      var i = this.request;
      this.request = null, i.onreadystatechange = null, i.abort();
    }
  }, n.media = function(i, a) {
    var o = this;
    if (!i)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof i == "string") {
      if (!this.master.playlists[i])
        throw new Error("Unknown playlist URI: " + i);
      i = this.master.playlists[i];
    }
    if (pe.clearTimeout(this.finalRenditionTimeout), a) {
      var s = (i.partTargetDuration || i.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = pe.setTimeout(this.media.bind(this, i, !1), s);
      return;
    }
    var l = this.state, u = !this.media_ || i.id !== this.media_.id, c = this.master.playlists[i.id];
    if (c && c.endList || i.endList && i.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = i, u && (this.trigger("mediachanging"), l === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(E4(i, !0)), !!u) {
      if (this.state = "SWITCHING_MEDIA", this.request) {
        if (i.resolvedUri === this.request.url)
          return;
        this.request.onreadystatechange = null, this.request.abort(), this.request = null;
      }
      this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = i, this.request = this.vhs_.xhr({
        uri: i.resolvedUri,
        withCredentials: this.withCredentials
      }, function(f, d) {
        if (!!o.request) {
          if (i.lastRequest = Date.now(), i.resolvedUri = lh(o.handleManifestRedirects, i.resolvedUri, d), f)
            return o.playlistRequestError(o.request, i, l);
          o.haveMetadata({
            playlistString: d.responseText,
            url: i.uri,
            id: i.id
          }), l === "HAVE_MASTER" ? o.trigger("loadedmetadata") : o.trigger("mediachange");
        }
      });
    }
  }, n.pause = function() {
    this.mediaUpdateTimeout && (pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MASTER" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }, n.load = function(i) {
    var a = this;
    this.mediaUpdateTimeout && (pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    var o = this.media();
    if (i) {
      var s = o ? (o.partTargetDuration || o.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = pe.setTimeout(function() {
        a.mediaUpdateTimeout = null, a.load();
      }, s);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    o && !o.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }, n.updateMediaUpdateTimeout_ = function(i) {
    var a = this;
    this.mediaUpdateTimeout && (pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = pe.setTimeout(function() {
      a.mediaUpdateTimeout = null, a.trigger("mediaupdatetimeout"), a.updateMediaUpdateTimeout_(i);
    }, i));
  }, n.start = function() {
    var i = this;
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = pe.location.href), this.src.resolvedUri = this.src.uri, setTimeout(function() {
        i.setupInitialPlaylist(i.src);
      }, 0);
      return;
    }
    this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials
    }, function(a, o) {
      if (!!i.request) {
        if (i.request = null, a)
          return i.error = {
            status: o.status,
            message: "HLS playlist request error at URL: " + i.src + ".",
            responseText: o.responseText,
            code: 2
          }, i.state === "HAVE_NOTHING" && (i.started = !1), i.trigger("error");
        i.src = lh(i.handleManifestRedirects, i.src, o);
        var s = i.parseManifest_({
          manifestString: o.responseText,
          url: i.src
        });
        i.setupInitialPlaylist(s);
      }
    });
  }, n.srcUri = function() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }, n.setupInitialPlaylist = function(i) {
    if (this.state = "HAVE_MASTER", i.playlists) {
      this.master = i, dx(this.master, this.srcUri()), i.playlists.forEach(function(o) {
        o.segments = hx(o), o.segments.forEach(function(s) {
          fx(s, o.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.master.playlists[0]);
      return;
    }
    var a = this.srcUri() || pe.location.href;
    this.master = Gle(i, a), this.haveMetadata({
      playlistObject: i,
      url: a,
      id: this.master.playlists[0].id
    }), this.trigger("loadedmetadata");
  }, t;
}(Yle), $le = Ce.xhr, eue = Ce.mergeOptions, k4 = function(t, n, r, i) {
  var a = t.responseType === "arraybuffer" ? t.response : t.responseText;
  !n && a && (t.responseTime = Date.now(), t.roundTripTime = t.responseTime - t.requestTime, t.bytesReceived = a.byteLength || a.length, t.bandwidth || (t.bandwidth = Math.floor(t.bytesReceived / t.roundTripTime * 8 * 1e3))), r.headers && (t.responseHeaders = r.headers), n && n.code === "ETIMEDOUT" && (t.timedout = !0), !n && !t.aborted && r.statusCode !== 200 && r.statusCode !== 206 && r.statusCode !== 0 && (n = new Error("XHR Failed with a response of: " + (t && (a || t.responseText)))), i(n, t);
}, vx = function() {
  var t = function n(r, i) {
    r = eue({
      timeout: 45e3
    }, r);
    var a = n.beforeRequest || Ce.Vhs.xhr.beforeRequest;
    if (a && typeof a == "function") {
      var o = a(r);
      o && (r = o);
    }
    var s = Ce.Vhs.xhr.original === !0 ? $le : Ce.Vhs.xhr, l = s(r, function(c, f) {
      return k4(l, c, f, i);
    }), u = l.abort;
    return l.abort = function() {
      return l.aborted = !0, u.apply(l, arguments);
    }, l.uri = r.uri, l.requestTime = Date.now(), l;
  };
  return t.original = !0, t;
}, tue = function(t) {
  var n, r = t.offset;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? n = pe.BigInt(t.offset) + pe.BigInt(t.length) - pe.BigInt(1) : n = t.offset + t.length - 1, "bytes=" + r + "-" + n;
}, O4 = function(t) {
  var n = {};
  return t.byterange && (n.Range = tue(t.byterange)), n;
}, nue = function(t, n) {
  return t.start(n) + "-" + t.end(n);
}, iue = function(t, n) {
  var r = t.toString(16);
  return "00".substring(0, 2 - r.length) + r + (n % 2 ? " " : "");
}, rue = function(t) {
  return t >= 32 && t < 126 ? String.fromCharCode(t) : ".";
}, mx = function(t) {
  var n = {};
  return Object.keys(t).forEach(function(r) {
    var i = t[r];
    rw(i) ? n[r] = {
      bytes: i.buffer,
      byteOffset: i.byteOffset,
      byteLength: i.byteLength
    } : n[r] = i;
  }), n;
}, ch = function(t) {
  var n = t.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [n.length, n.offset, t.resolvedUri].join(",");
}, gx = function(t) {
  return t.resolvedUri;
}, yx = function(t) {
  for (var n = Array.prototype.slice.call(t), r = 16, i = "", a, o, s = 0; s < n.length / r; s++)
    a = n.slice(s * r, s * r + r).map(iue).join(""), o = n.slice(s * r, s * r + r).map(rue).join(""), i += a + " " + o + `
`;
  return i;
}, aue = function(t) {
  var n = t.bytes;
  return yx(n);
}, oue = function(t) {
  var n = "", r;
  for (r = 0; r < t.length; r++)
    n += nue(t, r) + " ";
  return n;
}, sue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: mx,
  initSegmentId: ch,
  segmentKeyId: gx,
  hexDump: yx,
  tagDump: aue,
  textRanges: oue
}), bx = 0.25, lue = function(t, n) {
  if (!n.dateTimeObject)
    return null;
  var r = n.videoTimingInfo.transmuxerPrependedSeconds, i = n.videoTimingInfo.transmuxedPresentationStart, a = i + r, o = t - a;
  return new Date(n.dateTimeObject.getTime() + o * 1e3);
}, uue = function(t) {
  return t.transmuxedPresentationEnd - t.transmuxedPresentationStart - t.transmuxerPrependedSeconds;
}, cue = function(t, n) {
  var r;
  try {
    r = new Date(t);
  } catch {
    return null;
  }
  if (!n || !n.segments || n.segments.length === 0)
    return null;
  var i = n.segments[0];
  if (r < i.dateTimeObject)
    return null;
  for (var a = 0; a < n.segments.length - 1; a++) {
    i = n.segments[a];
    var o = n.segments[a + 1].dateTimeObject;
    if (r < o)
      break;
  }
  var s = n.segments[n.segments.length - 1], l = s.dateTimeObject, u = s.videoTimingInfo ? uue(s.videoTimingInfo) : s.duration + s.duration * bx, c = new Date(l.getTime() + u * 1e3);
  return r > c ? null : (r > l && (i = s), {
    segment: i,
    estimatedStart: i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationStart : Dr.duration(n, n.mediaSequence + n.segments.indexOf(i)),
    type: i.videoTimingInfo ? "accurate" : "estimate"
  });
}, due = function(t, n) {
  if (!n || !n.segments || n.segments.length === 0)
    return null;
  for (var r = 0, i, a = 0; a < n.segments.length && (i = n.segments[a], r = i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationEnd : r + i.duration, !(t <= r)); a++)
    ;
  var o = n.segments[n.segments.length - 1];
  if (o.videoTimingInfo && o.videoTimingInfo.transmuxedPresentationEnd < t)
    return null;
  if (t > r) {
    if (t > r + o.duration * bx)
      return null;
    i = o;
  }
  return {
    segment: i,
    estimatedStart: i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationStart : r - i.duration,
    type: i.videoTimingInfo ? "accurate" : "estimate"
  };
}, fue = function(t, n) {
  var r, i;
  try {
    r = new Date(t), i = new Date(n);
  } catch {
  }
  var a = r.getTime(), o = i.getTime();
  return (o - a) / 1e3;
}, hue = function(t) {
  if (!t.segments || t.segments.length === 0)
    return !1;
  for (var n = 0; n < t.segments.length; n++) {
    var r = t.segments[n];
    if (!r.dateTimeObject)
      return !1;
  }
  return !0;
}, pue = function(t) {
  var n = t.playlist, r = t.time, i = r === void 0 ? void 0 : r, a = t.callback;
  if (!a)
    throw new Error("getProgramTime: callback must be provided");
  if (!n || i === void 0)
    return a({
      message: "getProgramTime: playlist and time must be provided"
    });
  var o = due(i, n);
  if (!o)
    return a({
      message: "valid programTime was not found"
    });
  if (o.type === "estimate")
    return a({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: o.estimatedStart
    });
  var s = {
    mediaSeconds: i
  }, l = lue(i, o.segment);
  return l && (s.programDateTime = l.toISOString()), a(null, s);
}, vue = function e(t) {
  var n = t.programTime, r = t.playlist, i = t.retryCount, a = i === void 0 ? 2 : i, o = t.seekTo, s = t.pauseAfterSeek, l = s === void 0 ? !0 : s, u = t.tech, c = t.callback;
  if (!c)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof n > "u" || !r || !o)
    return c({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!r.endList && !u.hasStarted_)
    return c({
      message: "player must be playing a live stream to start buffering"
    });
  if (!hue(r))
    return c({
      message: "programDateTime tags must be provided in the manifest " + r.resolvedUri
    });
  var f = cue(n, r);
  if (!f)
    return c({
      message: n + " was not found in the stream"
    });
  var d = f.segment, h = fue(d.dateTimeObject, n);
  if (f.type === "estimate") {
    if (a === 0)
      return c({
        message: n + " is not buffered yet. Try again"
      });
    o(f.estimatedStart + h), u.one("seeked", function() {
      e({
        programTime: n,
        playlist: r,
        retryCount: a - 1,
        seekTo: o,
        pauseAfterSeek: l,
        tech: u,
        callback: c
      });
    });
    return;
  }
  var p = d.start + h, y = function() {
    return c(null, u.currentTime());
  };
  u.one("seeked", y), l && u.pause(), o(p);
}, Qp = function(t, n) {
  if (t.readyState === 4)
    return n();
}, mue = function(t, n, r) {
  var i = [], a, o = !1, s = function(d, h, p, y) {
    return h.abort(), o = !0, r(d, h, p, y);
  }, l = function(d, h) {
    if (!o) {
      if (d)
        return s(d, h, "", i);
      var p = h.responseText.substring(i && i.byteLength || 0, h.responseText.length);
      if (i = Cae(i, aw(p, !0)), a = a || ud(i), i.length < 10 || a && i.length < a + 2)
        return Qp(h, function() {
          return s(d, h, "", i);
        });
      var y = s6(i);
      return y === "ts" && i.length < 188 ? Qp(h, function() {
        return s(d, h, "", i);
      }) : !y && i.length < 376 ? Qp(h, function() {
        return s(d, h, "", i);
      }) : s(null, h, y, i);
    }
  }, u = {
    uri: t,
    beforeSend: function(d) {
      d.overrideMimeType("text/plain; charset=x-user-defined"), d.addEventListener("progress", function(h) {
        return h.total, h.loaded, k4(d, null, {
          statusCode: d.status
        }, l);
      });
    }
  }, c = n(u, function(f, d) {
    return k4(c, f, d, l);
  });
  return c;
}, gue = Ce.EventTarget, Ax = Ce.mergeOptions, t9 = function(t, n) {
  if (!px(t, n) || t.sidx && n.sidx && (t.sidx.offset !== n.sidx.offset || t.sidx.length !== n.sidx.length))
    return !1;
  if (!t.sidx && n.sidx || t.sidx && !n.sidx || t.segments && !n.segments || !t.segments && n.segments)
    return !1;
  if (!t.segments && !n.segments)
    return !0;
  for (var r = 0; r < t.segments.length; r++) {
    var i = t.segments[r], a = n.segments[r];
    if (i.uri !== a.uri)
      return !1;
    if (!(!i.byterange && !a.byterange)) {
      var o = i.byterange, s = a.byterange;
      if (o && !s || !o && s || o.offset !== s.offset || o.length !== s.length)
        return !1;
    }
  }
  return !0;
}, yue = function(t) {
  var n = t.masterXml, r = t.srcUrl, i = t.clientOffset, a = t.sidxMapping, o = t.previousManifest, s = Foe(n, {
    manifestUri: r,
    clientOffset: i,
    sidxMapping: a,
    previousManifest: o
  });
  return dx(s, r), s;
}, bue = function(t, n, r) {
  for (var i = !0, a = Ax(t, {
    duration: n.duration,
    minimumUpdatePeriod: n.minimumUpdatePeriod,
    timelineStarts: n.timelineStarts
  }), o = 0; o < n.playlists.length; o++) {
    var s = n.playlists[o];
    if (s.sidx) {
      var l = t2(s.sidx);
      r && r[l] && r[l].sidx && i6(s, r[l].sidx, s.sidx.resolvedUri);
    }
    var u = S4(a, s, t9);
    u && (a = u, i = !1);
  }
  return Hf(n, function(c, f, d, h) {
    if (c.playlists && c.playlists.length) {
      var p = c.playlists[0].id, y = S4(a, c.playlists[0], t9);
      y && (a = y, a.mediaGroups[f][d][h].playlists[0] = a.playlists[p], i = !1);
    }
  }), n.minimumUpdatePeriod !== t.minimumUpdatePeriod && (i = !1), i ? null : a;
}, Aue = function(t, n) {
  var r = Boolean(!t.map && !n.map), i = r || Boolean(t.map && n.map && t.map.byterange.offset === n.map.byterange.offset && t.map.byterange.length === n.map.byterange.length);
  return i && t.uri === n.uri && t.byterange.offset === n.byterange.offset && t.byterange.length === n.byterange.length;
}, n9 = function(t, n) {
  var r = {};
  for (var i in t) {
    var a = t[i], o = a.sidx;
    if (o) {
      var s = t2(o);
      if (!n[s])
        break;
      var l = n[s].sidxInfo;
      Aue(l, o) && (r[s] = n[s]);
    }
  }
  return r;
}, Tue = function(t, n) {
  var r = n9(t.playlists, n), i = r;
  return Hf(t, function(a, o, s, l) {
    if (a.playlists && a.playlists.length) {
      var u = a.playlists;
      i = Ax(i, n9(u, n));
    }
  }), i;
}, z4 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a, o) {
    var s;
    a === void 0 && (a = {}), s = e.call(this) || this, s.masterPlaylistLoader_ = o || on(s), o || (s.isMaster_ = !0);
    var l = a, u = l.withCredentials, c = u === void 0 ? !1 : u, f = l.handleManifestRedirects, d = f === void 0 ? !1 : f;
    if (s.vhs_ = i, s.withCredentials = c, s.handleManifestRedirects = d, !r)
      throw new Error("A non-empty playlist URL or object is required");
    return s.on("minimumUpdatePeriod", function() {
      s.refreshXml_();
    }), s.on("mediaupdatetimeout", function() {
      s.refreshMedia_(s.media().id);
    }), s.state = "HAVE_NOTHING", s.loadedPlaylists_ = {}, s.logger_ = Ya("DashPlaylistLoader"), s.isMaster_ ? (s.masterPlaylistLoader_.srcUrl = r, s.masterPlaylistLoader_.sidxMapping_ = {}) : s.childPlaylist_ = r, s;
  }
  var n = t.prototype;
  return n.requestErrored_ = function(i, a, o) {
    if (!this.request)
      return !0;
    if (this.request = null, i)
      return this.error = typeof i == "object" && !(i instanceof Error) ? i : {
        status: a.status,
        message: "DASH request error at URL: " + a.uri,
        response: a.response,
        code: 2
      }, o && (this.state = o), this.trigger("error"), !0;
  }, n.addSidxSegments_ = function(i, a, o) {
    var s = this, l = i.sidx && t2(i.sidx);
    if (!i.sidx || !l || this.masterPlaylistLoader_.sidxMapping_[l]) {
      this.mediaRequest_ = pe.setTimeout(function() {
        return o(!1);
      }, 0);
      return;
    }
    var u = lh(this.handleManifestRedirects, i.sidx.resolvedUri), c = function(d, h) {
      if (!s.requestErrored_(d, h, a)) {
        var p = s.masterPlaylistLoader_.sidxMapping_, y;
        try {
          y = qoe(Kt(h.response).subarray(8));
        } catch (m) {
          s.requestErrored_(m, h, a);
          return;
        }
        return p[l] = {
          sidxInfo: i.sidx,
          sidx: y
        }, i6(i, y, i.sidx.resolvedUri), o(!0);
      }
    };
    this.request = mue(u, this.vhs_.xhr, function(f, d, h, p) {
      if (f)
        return c(f, d);
      if (!h || h !== "mp4")
        return c({
          status: d.status,
          message: "Unsupported " + (h || "unknown") + " container type for sidx segment at URL: " + u,
          response: "",
          playlist: i,
          internal: !0,
          blacklistDuration: 1 / 0,
          code: 2
        }, d);
      var y = i.sidx.byterange, m = y.offset, b = y.length;
      if (p.length >= b + m)
        return c(f, {
          response: p.subarray(m, m + b),
          status: d.status,
          uri: d.uri
        });
      s.request = s.vhs_.xhr({
        uri: u,
        responseType: "arraybuffer",
        headers: O4({
          byterange: i.sidx.byterange
        })
      }, c);
    });
  }, n.dispose = function() {
    this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, pe.clearTimeout(this.minimumUpdatePeriodTimeout_), pe.clearTimeout(this.mediaRequest_), pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }, n.hasPendingRequest = function() {
    return this.request || this.mediaRequest_;
  }, n.stopRequest = function() {
    if (this.request) {
      var i = this.request;
      this.request = null, i.onreadystatechange = null, i.abort();
    }
  }, n.media = function(i) {
    var a = this;
    if (!i)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    var o = this.state;
    if (typeof i == "string") {
      if (!this.masterPlaylistLoader_.master.playlists[i])
        throw new Error("Unknown playlist URI: " + i);
      i = this.masterPlaylistLoader_.master.playlists[i];
    }
    var s = !this.media_ || i.id !== this.media_.id;
    if (s && this.loadedPlaylists_[i.id] && this.loadedPlaylists_[i.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = i, s && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    !s || (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(i, o, function(l) {
      a.haveMetadata({
        startingState: o,
        playlist: i
      });
    }));
  }, n.haveMetadata = function(i) {
    var a = i.startingState, o = i.playlist;
    this.state = "HAVE_METADATA", this.loadedPlaylists_[o.id] = o, this.mediaRequest_ = null, this.refreshMedia_(o.id), a === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }, n.pause = function() {
    this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMaster_ && (pe.clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_), this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }, n.load = function(i) {
    var a = this;
    pe.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    var o = this.media();
    if (i) {
      var s = o ? o.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = pe.setTimeout(function() {
        return a.load();
      }, s);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    o && !o.endList ? (this.isMaster_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }, n.start = function() {
    var i = this;
    if (this.started = !0, !this.isMaster_) {
      this.mediaRequest_ = pe.setTimeout(function() {
        return i.haveMaster_();
      }, 0);
      return;
    }
    this.requestMaster_(function(a, o) {
      i.haveMaster_(), !i.hasPendingRequest() && !i.media_ && i.media(i.masterPlaylistLoader_.master.playlists[0]);
    });
  }, n.requestMaster_ = function(i) {
    var a = this;
    this.request = this.vhs_.xhr({
      uri: this.masterPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials
    }, function(o, s) {
      if (a.requestErrored_(o, s)) {
        a.state === "HAVE_NOTHING" && (a.started = !1);
        return;
      }
      var l = s.responseText !== a.masterPlaylistLoader_.masterXml_;
      if (a.masterPlaylistLoader_.masterXml_ = s.responseText, s.responseHeaders && s.responseHeaders.date ? a.masterLoaded_ = Date.parse(s.responseHeaders.date) : a.masterLoaded_ = Date.now(), a.masterPlaylistLoader_.srcUrl = lh(a.handleManifestRedirects, a.masterPlaylistLoader_.srcUrl, s), l) {
        a.handleMaster_(), a.syncClientServerClock_(function() {
          return i(s, l);
        });
        return;
      }
      return i(s, l);
    });
  }, n.syncClientServerClock_ = function(i) {
    var a = this, o = Xoe(this.masterPlaylistLoader_.masterXml_);
    if (o === null)
      return this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now(), i();
    if (o.method === "DIRECT")
      return this.masterPlaylistLoader_.clientOffset_ = o.value - Date.now(), i();
    this.request = this.vhs_.xhr({
      uri: Na(this.masterPlaylistLoader_.srcUrl, o.value),
      method: o.method,
      withCredentials: this.withCredentials
    }, function(s, l) {
      if (!!a.request) {
        if (s)
          return a.masterPlaylistLoader_.clientOffset_ = a.masterLoaded_ - Date.now(), i();
        var u;
        o.method === "HEAD" ? !l.responseHeaders || !l.responseHeaders.date ? u = a.masterLoaded_ : u = Date.parse(l.responseHeaders.date) : u = Date.parse(l.responseText), a.masterPlaylistLoader_.clientOffset_ = u - Date.now(), i();
      }
    });
  }, n.haveMaster_ = function() {
    this.state = "HAVE_MASTER", this.isMaster_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }, n.handleMaster_ = function() {
    this.mediaRequest_ = null;
    var i = this.masterPlaylistLoader_.master, a = yue({
      masterXml: this.masterPlaylistLoader_.masterXml_,
      srcUrl: this.masterPlaylistLoader_.srcUrl,
      clientOffset: this.masterPlaylistLoader_.clientOffset_,
      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
      previousManifest: i
    });
    i && (a = bue(i, a, this.masterPlaylistLoader_.sidxMapping_)), this.masterPlaylistLoader_.master = a || i;
    var o = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
    return o && o !== this.masterPlaylistLoader_.srcUrl && (this.masterPlaylistLoader_.srcUrl = o), (!i || a && a.minimumUpdatePeriod !== i.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), Boolean(a);
  }, n.updateMinimumUpdatePeriodTimeout_ = function() {
    var i = this.masterPlaylistLoader_;
    i.createMupOnMedia_ && (i.off("loadedmetadata", i.createMupOnMedia_), i.createMupOnMedia_ = null), i.minimumUpdatePeriodTimeout_ && (pe.clearTimeout(i.minimumUpdatePeriodTimeout_), i.minimumUpdatePeriodTimeout_ = null);
    var a = i.master && i.master.minimumUpdatePeriod;
    if (a === 0 && (i.media() ? a = i.media().targetDuration * 1e3 : (i.createMupOnMedia_ = i.updateMinimumUpdatePeriodTimeout_, i.one("loadedmetadata", i.createMupOnMedia_))), typeof a != "number" || a <= 0) {
      a < 0 && this.logger_("found invalid minimumUpdatePeriod of " + a + ", not setting a timeout");
      return;
    }
    this.createMUPTimeout_(a);
  }, n.createMUPTimeout_ = function(i) {
    var a = this.masterPlaylistLoader_;
    a.minimumUpdatePeriodTimeout_ = pe.setTimeout(function() {
      a.minimumUpdatePeriodTimeout_ = null, a.trigger("minimumUpdatePeriod"), a.createMUPTimeout_(i);
    }, i);
  }, n.refreshXml_ = function() {
    var i = this;
    this.requestMaster_(function(a, o) {
      !o || (i.media_ && (i.media_ = i.masterPlaylistLoader_.master.playlists[i.media_.id]), i.masterPlaylistLoader_.sidxMapping_ = Tue(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.sidxMapping_), i.addSidxSegments_(i.media(), i.state, function(s) {
        i.refreshMedia_(i.media().id);
      }));
    });
  }, n.refreshMedia_ = function(i) {
    var a = this;
    if (!i)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMaster_ && this.handleMaster_();
    var o = this.masterPlaylistLoader_.master.playlists, s = !this.media_ || this.media_ !== o[i];
    if (s ? this.media_ = o[i] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      var l = function u() {
        a.media().endList || (a.mediaUpdateTimeout = pe.setTimeout(function() {
          a.trigger("mediaupdatetimeout"), u();
        }, E4(a.media(), Boolean(s))));
      };
      l();
    }
    this.trigger("loadedplaylist");
  }, t;
}(gue), Ii = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  INITIAL_BANDWIDTH: 4194304,
  BANDWIDTH_VARIANCE: 1.2,
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  BUFFER_HIGH_WATER_LINE: 30
}, wue = function(t) {
  for (var n = new Uint8Array(new ArrayBuffer(t.length)), r = 0; r < t.length; r++)
    n[r] = t.charCodeAt(r);
  return n.buffer;
}, Tx = function(t) {
  return t.on = t.addEventListener, t.off = t.removeEventListener, t;
}, Pue = function(t) {
  try {
    return URL.createObjectURL(new Blob([t], {
      type: "application/javascript"
    }));
  } catch {
    var n = new BlobBuilder();
    return n.append(t), URL.createObjectURL(n.getBlob());
  }
}, wx = function(t) {
  return function() {
    var n = Pue(t), r = Tx(new Worker(n));
    r.objURL = n;
    var i = r.terminate;
    return r.on = r.addEventListener, r.off = r.removeEventListener, r.terminate = function() {
      return URL.revokeObjectURL(n), i.call(this);
    }, r;
  };
}, Px = function(t) {
  return "var browserWorkerPolyFill = " + Tx.toString() + `;
browserWorkerPolyFill(self);
` + t;
}, xx = function(t) {
  return t.toString().replace(/^function.+?{/, "").slice(0, -1);
}, xue = Px(xx(function() {
  var e = function() {
    this.init = function() {
      var A = {};
      this.on = function(O, k) {
        A[O] || (A[O] = []), A[O] = A[O].concat(k);
      }, this.off = function(O, k) {
        var M;
        return A[O] ? (M = A[O].indexOf(k), A[O] = A[O].slice(), A[O].splice(M, 1), M > -1) : !1;
      }, this.trigger = function(O) {
        var k, M, X, U;
        if (k = A[O], !!k)
          if (arguments.length === 2)
            for (X = k.length, M = 0; M < X; ++M)
              k[M].call(this, arguments[1]);
          else {
            for (U = [], M = arguments.length, M = 1; M < arguments.length; ++M)
              U.push(arguments[M]);
            for (X = k.length, M = 0; M < X; ++M)
              k[M].apply(this, U);
          }
      }, this.dispose = function() {
        A = {};
      };
    };
  };
  e.prototype.pipe = function(ee) {
    return this.on("data", function(A) {
      ee.push(A);
    }), this.on("done", function(A) {
      ee.flush(A);
    }), this.on("partialdone", function(A) {
      ee.partialFlush(A);
    }), this.on("endedtimeline", function(A) {
      ee.endTimeline(A);
    }), this.on("reset", function(A) {
      ee.reset(A);
    }), ee;
  }, e.prototype.push = function(ee) {
    this.trigger("data", ee);
  }, e.prototype.flush = function(ee) {
    this.trigger("done", ee);
  }, e.prototype.partialFlush = function(ee) {
    this.trigger("partialdone", ee);
  }, e.prototype.endTimeline = function(ee) {
    this.trigger("endedtimeline", ee);
  }, e.prototype.reset = function(ee) {
    this.trigger("reset", ee);
  };
  var t = e, n = Math.pow(2, 32), r = function(A) {
    var O = new DataView(A.buffer, A.byteOffset, A.byteLength), k;
    return O.getBigUint64 ? (k = O.getBigUint64(0), k < Number.MAX_SAFE_INTEGER ? Number(k) : k) : O.getUint32(0) * n + O.getUint32(4);
  }, i = {
    getUint64: r,
    MAX_UINT32: n
  }, a = i.MAX_UINT32, o, s, l, u, c, f, d, h, p, y, m, b, x, D, S, C, v, H, V, R, F, K, q, G, te, Q, Y, Z, oe, he, Ae, We, ke, Re, ve, Ye;
  (function() {
    var ee;
    if (q = {
      avc1: [],
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (ee in q)
        q.hasOwnProperty(ee) && (q[ee] = [ee.charCodeAt(0), ee.charCodeAt(1), ee.charCodeAt(2), ee.charCodeAt(3)]);
      G = new Uint8Array(["i".charCodeAt(0), "s".charCodeAt(0), "o".charCodeAt(0), "m".charCodeAt(0)]), Q = new Uint8Array(["a".charCodeAt(0), "v".charCodeAt(0), "c".charCodeAt(0), "1".charCodeAt(0)]), te = new Uint8Array([0, 0, 0, 1]), Y = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        118,
        105,
        100,
        101,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
      ]), Z = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        115,
        111,
        117,
        110,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
      ]), oe = {
        video: Y,
        audio: Z
      }, We = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        12,
        117,
        114,
        108,
        32,
        0,
        0,
        0,
        1
      ]), Ae = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]), ke = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]), Re = ke, ve = new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]), Ye = ke, he = new Uint8Array([
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ]);
    }
  })(), o = function(A) {
    var O = [], k = 0, M, X, U;
    for (M = 1; M < arguments.length; M++)
      O.push(arguments[M]);
    for (M = O.length; M--; )
      k += O[M].byteLength;
    for (X = new Uint8Array(k + 8), U = new DataView(X.buffer, X.byteOffset, X.byteLength), U.setUint32(0, X.byteLength), X.set(A, 4), M = 0, k = 8; M < O.length; M++)
      X.set(O[M], k), k += O[M].byteLength;
    return X;
  }, s = function() {
    return o(q.dinf, o(q.dref, We));
  }, l = function(A) {
    return o(q.esds, new Uint8Array([
      0,
      0,
      0,
      0,
      3,
      25,
      0,
      0,
      0,
      4,
      17,
      64,
      21,
      0,
      6,
      0,
      0,
      0,
      218,
      192,
      0,
      0,
      218,
      192,
      5,
      2,
      A.audioobjecttype << 3 | A.samplingfrequencyindex >>> 1,
      A.samplingfrequencyindex << 7 | A.channelcount << 3,
      6,
      1,
      2
    ]));
  }, u = function() {
    return o(q.ftyp, G, te, G, Q);
  }, C = function(A) {
    return o(q.hdlr, oe[A]);
  }, c = function(A) {
    return o(q.mdat, A);
  }, S = function(A) {
    var O = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      0,
      0,
      0,
      3,
      0,
      1,
      95,
      144,
      A.duration >>> 24 & 255,
      A.duration >>> 16 & 255,
      A.duration >>> 8 & 255,
      A.duration & 255,
      85,
      196,
      0,
      0
    ]);
    return A.samplerate && (O[12] = A.samplerate >>> 24 & 255, O[13] = A.samplerate >>> 16 & 255, O[14] = A.samplerate >>> 8 & 255, O[15] = A.samplerate & 255), o(q.mdhd, O);
  }, D = function(A) {
    return o(q.mdia, S(A), C(A.type), d(A));
  }, f = function(A) {
    return o(q.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      (A & 4278190080) >> 24,
      (A & 16711680) >> 16,
      (A & 65280) >> 8,
      A & 255
    ]));
  }, d = function(A) {
    return o(q.minf, A.type === "video" ? o(q.vmhd, he) : o(q.smhd, Ae), s(), H(A));
  }, h = function(A, O) {
    for (var k = [], M = O.length; M--; )
      k[M] = R(O[M]);
    return o.apply(null, [q.moof, f(A)].concat(k));
  }, p = function(A) {
    for (var O = A.length, k = []; O--; )
      k[O] = b(A[O]);
    return o.apply(null, [q.moov, m(4294967295)].concat(k).concat(y(A)));
  }, y = function(A) {
    for (var O = A.length, k = []; O--; )
      k[O] = F(A[O]);
    return o.apply(null, [q.mvex].concat(k));
  }, m = function(A) {
    var O = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      2,
      0,
      1,
      95,
      144,
      (A & 4278190080) >> 24,
      (A & 16711680) >> 16,
      (A & 65280) >> 8,
      A & 255,
      0,
      1,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      255,
      255,
      255,
      255
    ]);
    return o(q.mvhd, O);
  }, v = function(A) {
    var O = A.samples || [], k = new Uint8Array(4 + O.length), M, X;
    for (X = 0; X < O.length; X++)
      M = O[X].flags, k[X + 4] = M.dependsOn << 4 | M.isDependedOn << 2 | M.hasRedundancy;
    return o(q.sdtp, k);
  }, H = function(A) {
    return o(q.stbl, V(A), o(q.stts, Ye), o(q.stsc, Re), o(q.stsz, ve), o(q.stco, ke));
  }, function() {
    var ee, A;
    V = function(k) {
      return o(q.stsd, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
      ]), k.type === "video" ? ee(k) : A(k));
    }, ee = function(k) {
      var M = k.sps || [], X = k.pps || [], U = [], ae = [], le, be;
      for (le = 0; le < M.length; le++)
        U.push((M[le].byteLength & 65280) >>> 8), U.push(M[le].byteLength & 255), U = U.concat(Array.prototype.slice.call(M[le]));
      for (le = 0; le < X.length; le++)
        ae.push((X[le].byteLength & 65280) >>> 8), ae.push(X[le].byteLength & 255), ae = ae.concat(Array.prototype.slice.call(X[le]));
      if (be = [q.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        (k.width & 65280) >> 8,
        k.width & 255,
        (k.height & 65280) >> 8,
        k.height & 255,
        0,
        72,
        0,
        0,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        17,
        17
      ]), o(q.avcC, new Uint8Array([
        1,
        k.profileIdc,
        k.profileCompatibility,
        k.levelIdc,
        255
      ].concat(
        [M.length],
        U,
        [X.length],
        ae
      ))), o(q.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        0,
        45,
        198,
        192,
        0,
        45,
        198,
        192
      ]))], k.sarRatio) {
        var ge = k.sarRatio[0], xe = k.sarRatio[1];
        be.push(o(q.pasp, new Uint8Array([(ge & 4278190080) >> 24, (ge & 16711680) >> 16, (ge & 65280) >> 8, ge & 255, (xe & 4278190080) >> 24, (xe & 16711680) >> 16, (xe & 65280) >> 8, xe & 255])));
      }
      return o.apply(null, be);
    }, A = function(k) {
      return o(q.mp4a, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        (k.channelcount & 65280) >> 8,
        k.channelcount & 255,
        (k.samplesize & 65280) >> 8,
        k.samplesize & 255,
        0,
        0,
        0,
        0,
        (k.samplerate & 65280) >> 8,
        k.samplerate & 255,
        0,
        0
      ]), l(k));
    };
  }(), x = function(A) {
    var O = new Uint8Array([
      0,
      0,
      0,
      7,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      (A.id & 4278190080) >> 24,
      (A.id & 16711680) >> 16,
      (A.id & 65280) >> 8,
      A.id & 255,
      0,
      0,
      0,
      0,
      (A.duration & 4278190080) >> 24,
      (A.duration & 16711680) >> 16,
      (A.duration & 65280) >> 8,
      A.duration & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      (A.width & 65280) >> 8,
      A.width & 255,
      0,
      0,
      (A.height & 65280) >> 8,
      A.height & 255,
      0,
      0
    ]);
    return o(q.tkhd, O);
  }, R = function(A) {
    var O, k, M, X, U, ae, le;
    return O = o(q.tfhd, new Uint8Array([
      0,
      0,
      0,
      58,
      (A.id & 4278190080) >> 24,
      (A.id & 16711680) >> 16,
      (A.id & 65280) >> 8,
      A.id & 255,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ])), ae = Math.floor(A.baseMediaDecodeTime / a), le = Math.floor(A.baseMediaDecodeTime % a), k = o(q.tfdt, new Uint8Array([
      1,
      0,
      0,
      0,
      ae >>> 24 & 255,
      ae >>> 16 & 255,
      ae >>> 8 & 255,
      ae & 255,
      le >>> 24 & 255,
      le >>> 16 & 255,
      le >>> 8 & 255,
      le & 255
    ])), U = 32 + 20 + 8 + 16 + 8 + 8, A.type === "audio" ? (M = K(A, U), o(q.traf, O, k, M)) : (X = v(A), M = K(A, X.length + U), o(q.traf, O, k, M, X));
  }, b = function(A) {
    return A.duration = A.duration || 4294967295, o(q.trak, x(A), D(A));
  }, F = function(A) {
    var O = new Uint8Array([
      0,
      0,
      0,
      0,
      (A.id & 4278190080) >> 24,
      (A.id & 16711680) >> 16,
      (A.id & 65280) >> 8,
      A.id & 255,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      1
    ]);
    return A.type !== "video" && (O[O.length - 1] = 0), o(q.trex, O);
  }, function() {
    var ee, A, O;
    O = function(M, X) {
      var U = 0, ae = 0, le = 0, be = 0;
      return M.length && (M[0].duration !== void 0 && (U = 1), M[0].size !== void 0 && (ae = 2), M[0].flags !== void 0 && (le = 4), M[0].compositionTimeOffset !== void 0 && (be = 8)), [
        0,
        0,
        U | ae | le | be,
        1,
        (M.length & 4278190080) >>> 24,
        (M.length & 16711680) >>> 16,
        (M.length & 65280) >>> 8,
        M.length & 255,
        (X & 4278190080) >>> 24,
        (X & 16711680) >>> 16,
        (X & 65280) >>> 8,
        X & 255
      ];
    }, A = function(M, X) {
      var U, ae, le, be, ge, xe;
      for (be = M.samples || [], X += 8 + 12 + 16 * be.length, le = O(be, X), ae = new Uint8Array(le.length + be.length * 16), ae.set(le), U = le.length, xe = 0; xe < be.length; xe++)
        ge = be[xe], ae[U++] = (ge.duration & 4278190080) >>> 24, ae[U++] = (ge.duration & 16711680) >>> 16, ae[U++] = (ge.duration & 65280) >>> 8, ae[U++] = ge.duration & 255, ae[U++] = (ge.size & 4278190080) >>> 24, ae[U++] = (ge.size & 16711680) >>> 16, ae[U++] = (ge.size & 65280) >>> 8, ae[U++] = ge.size & 255, ae[U++] = ge.flags.isLeading << 2 | ge.flags.dependsOn, ae[U++] = ge.flags.isDependedOn << 6 | ge.flags.hasRedundancy << 4 | ge.flags.paddingValue << 1 | ge.flags.isNonSyncSample, ae[U++] = ge.flags.degradationPriority & 240 << 8, ae[U++] = ge.flags.degradationPriority & 15, ae[U++] = (ge.compositionTimeOffset & 4278190080) >>> 24, ae[U++] = (ge.compositionTimeOffset & 16711680) >>> 16, ae[U++] = (ge.compositionTimeOffset & 65280) >>> 8, ae[U++] = ge.compositionTimeOffset & 255;
      return o(q.trun, ae);
    }, ee = function(M, X) {
      var U, ae, le, be, ge, xe;
      for (be = M.samples || [], X += 8 + 12 + 8 * be.length, le = O(be, X), U = new Uint8Array(le.length + be.length * 8), U.set(le), ae = le.length, xe = 0; xe < be.length; xe++)
        ge = be[xe], U[ae++] = (ge.duration & 4278190080) >>> 24, U[ae++] = (ge.duration & 16711680) >>> 16, U[ae++] = (ge.duration & 65280) >>> 8, U[ae++] = ge.duration & 255, U[ae++] = (ge.size & 4278190080) >>> 24, U[ae++] = (ge.size & 16711680) >>> 16, U[ae++] = (ge.size & 65280) >>> 8, U[ae++] = ge.size & 255;
      return o(q.trun, U);
    }, K = function(M, X) {
      return M.type === "audio" ? ee(M, X) : A(M, X);
    };
  }();
  var Qe = {
    ftyp: u,
    mdat: c,
    moof: h,
    moov: p,
    initSegment: function(A) {
      var O = u(), k = p(A), M;
      return M = new Uint8Array(O.byteLength + k.byteLength), M.set(O), M.set(k, O.byteLength), M;
    }
  }, ot = function(A) {
    var O, k, M = [], X = [];
    for (X.byteLength = 0, X.nalCount = 0, X.duration = 0, M.byteLength = 0, O = 0; O < A.length; O++)
      k = A[O], k.nalUnitType === "access_unit_delimiter_rbsp" ? (M.length && (M.duration = k.dts - M.dts, X.byteLength += M.byteLength, X.nalCount += M.length, X.duration += M.duration, X.push(M)), M = [k], M.byteLength = k.data.byteLength, M.pts = k.pts, M.dts = k.dts) : (k.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (M.keyFrame = !0), M.duration = k.dts - M.dts, M.byteLength += k.data.byteLength, M.push(k));
    return X.length && (!M.duration || M.duration <= 0) && (M.duration = X[X.length - 1].duration), X.byteLength += M.byteLength, X.nalCount += M.length, X.duration += M.duration, X.push(M), X;
  }, Ve = function(A) {
    var O, k, M = [], X = [];
    for (M.byteLength = 0, M.nalCount = 0, M.duration = 0, M.pts = A[0].pts, M.dts = A[0].dts, X.byteLength = 0, X.nalCount = 0, X.duration = 0, X.pts = A[0].pts, X.dts = A[0].dts, O = 0; O < A.length; O++)
      k = A[O], k.keyFrame ? (M.length && (X.push(M), X.byteLength += M.byteLength, X.nalCount += M.nalCount, X.duration += M.duration), M = [k], M.nalCount = k.length, M.byteLength = k.byteLength, M.pts = k.pts, M.dts = k.dts, M.duration = k.duration) : (M.duration += k.duration, M.nalCount += k.length, M.byteLength += k.byteLength, M.push(k));
    return X.length && M.duration <= 0 && (M.duration = X[X.length - 1].duration), X.byteLength += M.byteLength, X.nalCount += M.nalCount, X.duration += M.duration, X.push(M), X;
  }, Te = function(A) {
    var O;
    return !A[0][0].keyFrame && A.length > 1 && (O = A.shift(), A.byteLength -= O.byteLength, A.nalCount -= O.nalCount, A[0][0].dts = O.dts, A[0][0].pts = O.pts, A[0][0].duration += O.duration), A;
  }, Me = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, Je = function(A, O) {
    var k = Me();
    return k.dataOffset = O, k.compositionTimeOffset = A.pts - A.dts, k.duration = A.duration, k.size = 4 * A.length, k.size += A.byteLength, A.keyFrame && (k.flags.dependsOn = 2, k.flags.isNonSyncSample = 0), k;
  }, mt = function(A, O) {
    var k, M, X, U, ae, le = O || 0, be = [];
    for (k = 0; k < A.length; k++)
      for (U = A[k], M = 0; M < U.length; M++)
        ae = U[M], X = Je(ae, le), le += X.size, be.push(X);
    return be;
  }, It = function(A) {
    var O, k, M, X, U, ae, le = 0, be = A.byteLength, ge = A.nalCount, xe = be + 4 * ge, qe = new Uint8Array(xe), ht = new DataView(qe.buffer);
    for (O = 0; O < A.length; O++)
      for (X = A[O], k = 0; k < X.length; k++)
        for (U = X[k], M = 0; M < U.length; M++)
          ae = U[M], ht.setUint32(le, ae.data.byteLength), le += 4, qe.set(ae.data, le), le += ae.data.byteLength;
    return qe;
  }, ln = function(A, O) {
    var k, M = O || 0, X = [];
    return k = Je(A, M), X.push(k), X;
  }, gt = function(A) {
    var O, k, M = 0, X = A.byteLength, U = A.length, ae = X + 4 * U, le = new Uint8Array(ae), be = new DataView(le.buffer);
    for (O = 0; O < A.length; O++)
      k = A[O], be.setUint32(M, k.data.byteLength), M += 4, le.set(k.data, M), M += k.data.byteLength;
    return le;
  }, Pe = {
    groupNalsIntoFrames: ot,
    groupFramesIntoGops: Ve,
    extendFirstKeyFrame: Te,
    generateSampleTable: mt,
    concatenateNalData: It,
    generateSampleTableForFrame: ln,
    concatenateNalDataForFrame: gt
  }, $e = [33, 16, 5, 32, 164, 27], Ke = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], lt = function(A) {
    for (var O = []; A--; )
      O.push(0);
    return O;
  }, He = function(A) {
    return Object.keys(A).reduce(function(O, k) {
      return O[k] = new Uint8Array(A[k].reduce(function(M, X) {
        return M.concat(X);
      }, [])), O;
    }, {});
  }, Le, ct = function() {
    if (!Le) {
      var A = {
        96e3: [$e, [227, 64], lt(154), [56]],
        88200: [$e, [231], lt(170), [56]],
        64e3: [$e, [248, 192], lt(240), [56]],
        48e3: [$e, [255, 192], lt(268), [55, 148, 128], lt(54), [112]],
        44100: [$e, [255, 192], lt(268), [55, 163, 128], lt(84), [112]],
        32e3: [$e, [255, 192], lt(268), [55, 234], lt(226), [112]],
        24e3: [$e, [255, 192], lt(268), [55, 255, 128], lt(268), [111, 112], lt(126), [224]],
        16e3: [$e, [255, 192], lt(268), [55, 255, 128], lt(268), [111, 255], lt(269), [223, 108], lt(195), [1, 192]],
        12e3: [Ke, lt(268), [3, 127, 248], lt(268), [6, 255, 240], lt(268), [13, 255, 224], lt(268), [27, 253, 128], lt(259), [56]],
        11025: [Ke, lt(268), [3, 127, 248], lt(268), [6, 255, 240], lt(268), [13, 255, 224], lt(268), [27, 255, 192], lt(268), [55, 175, 128], lt(108), [112]],
        8e3: [Ke, lt(268), [3, 121, 16], lt(47), [7]]
      };
      Le = He(A);
    }
    return Le;
  }, Qt = 9e4, Zt, Pn, Mn, Mt, Nt, De, Ue;
  Zt = function(A) {
    return A * Qt;
  }, Pn = function(A, O) {
    return A * O;
  }, Mn = function(A) {
    return A / Qt;
  }, Mt = function(A, O) {
    return A / O;
  }, Nt = function(A, O) {
    return Zt(Mt(A, O));
  }, De = function(A, O) {
    return Pn(Mn(A), O);
  }, Ue = function(A, O, k) {
    return Mn(k ? A : A - O);
  };
  var Se = {
    ONE_SECOND_IN_TS: Qt,
    secondsToVideoTs: Zt,
    secondsToAudioTs: Pn,
    videoTsToSeconds: Mn,
    audioTsToSeconds: Mt,
    audioTsToVideoTs: Nt,
    videoTsToAudioTs: De,
    metadataTsToSeconds: Ue
  }, st = function(A) {
    var O, k, M = 0;
    for (O = 0; O < A.length; O++)
      k = A[O], M += k.data.byteLength;
    return M;
  }, kt = function(A, O, k, M) {
    var X, U = 0, ae = 0, le = 0, be = 0, ge, xe, qe;
    if (!!O.length && (X = Se.audioTsToVideoTs(A.baseMediaDecodeTime, A.samplerate), U = Math.ceil(Se.ONE_SECOND_IN_TS / (A.samplerate / 1024)), k && M && (ae = X - Math.max(k, M), le = Math.floor(ae / U), be = le * U), !(le < 1 || be > Se.ONE_SECOND_IN_TS / 2))) {
      for (ge = ct()[A.samplerate], ge || (ge = O[0].data), xe = 0; xe < le; xe++)
        qe = O[0], O.splice(0, 0, {
          data: ge,
          dts: qe.dts - U,
          pts: qe.pts - U
        });
      return A.baseMediaDecodeTime -= Math.floor(Se.videoTsToAudioTs(be, A.samplerate)), be;
    }
  }, mn = function(A, O, k) {
    return O.minSegmentDts >= k ? A : (O.minSegmentDts = 1 / 0, A.filter(function(M) {
      return M.dts >= k ? (O.minSegmentDts = Math.min(O.minSegmentDts, M.dts), O.minSegmentPts = O.minSegmentDts, !0) : !1;
    }));
  }, cn = function(A) {
    var O, k, M = [];
    for (O = 0; O < A.length; O++)
      k = A[O], M.push({
        size: k.data.byteLength,
        duration: 1024
      });
    return M;
  }, kn = function(A) {
    var O, k, M = 0, X = new Uint8Array(st(A));
    for (O = 0; O < A.length; O++)
      k = A[O], X.set(k.data, M), M += k.data.byteLength;
    return X;
  }, Tn = {
    prefixWithSilence: kt,
    trimAdtsFramesByEarliestDts: mn,
    generateSampleTable: cn,
    concatenateFrameData: kn
  }, sr = Se.ONE_SECOND_IN_TS, wi = function(A, O) {
    typeof O.pts == "number" && (A.timelineStartInfo.pts === void 0 && (A.timelineStartInfo.pts = O.pts), A.minSegmentPts === void 0 ? A.minSegmentPts = O.pts : A.minSegmentPts = Math.min(A.minSegmentPts, O.pts), A.maxSegmentPts === void 0 ? A.maxSegmentPts = O.pts : A.maxSegmentPts = Math.max(A.maxSegmentPts, O.pts)), typeof O.dts == "number" && (A.timelineStartInfo.dts === void 0 && (A.timelineStartInfo.dts = O.dts), A.minSegmentDts === void 0 ? A.minSegmentDts = O.dts : A.minSegmentDts = Math.min(A.minSegmentDts, O.dts), A.maxSegmentDts === void 0 ? A.maxSegmentDts = O.dts : A.maxSegmentDts = Math.max(A.maxSegmentDts, O.dts));
  }, Hi = function(A) {
    delete A.minSegmentDts, delete A.maxSegmentDts, delete A.minSegmentPts, delete A.maxSegmentPts;
  }, Qa = function(A, O) {
    var k, M, X = A.minSegmentDts;
    return O || (X -= A.timelineStartInfo.dts), k = A.timelineStartInfo.baseMediaDecodeTime, k += X, k = Math.max(0, k), A.type === "audio" && (M = A.samplerate / sr, k *= M, k = Math.floor(k)), k;
  }, ii = {
    clearDtsInfo: Hi,
    calculateTrackBaseMediaDecodeTime: Qa,
    collectDtsInfo: wi
  }, Fe = 4, xt = 128, an = function(A) {
    for (var O = 0, k = {
      payloadType: -1,
      payloadSize: 0
    }, M = 0, X = 0; O < A.byteLength && A[O] !== xt; ) {
      for (; A[O] === 255; )
        M += 255, O++;
      for (M += A[O++]; A[O] === 255; )
        X += 255, O++;
      if (X += A[O++], !k.payload && M === Fe) {
        var U = String.fromCharCode(A[O + 3], A[O + 4], A[O + 5], A[O + 6]);
        if (U === "GA94") {
          k.payloadType = M, k.payloadSize = X, k.payload = A.subarray(O, O + X);
          break;
        } else
          k.payload = void 0;
      }
      O += X, M = 0, X = 0;
    }
    return k;
  }, Fn = function(A) {
    return A.payload[0] !== 181 || (A.payload[1] << 8 | A.payload[2]) !== 49 || String.fromCharCode(A.payload[3], A.payload[4], A.payload[5], A.payload[6]) !== "GA94" || A.payload[7] !== 3 ? null : A.payload.subarray(8, A.payload.length - 1);
  }, Pr = function(A, O) {
    var k = [], M, X, U, ae;
    if (!(O[0] & 64))
      return k;
    for (X = O[0] & 31, M = 0; M < X; M++)
      U = M * 3, ae = {
        type: O[U + 2] & 3,
        pts: A
      }, O[U + 2] & 4 && (ae.ccData = O[U + 3] << 8 | O[U + 4], k.push(ae));
    return k;
  }, xr = function(A) {
    for (var O = A.byteLength, k = [], M = 1, X, U; M < O - 2; )
      A[M] === 0 && A[M + 1] === 0 && A[M + 2] === 3 ? (k.push(M + 2), M += 2) : M++;
    if (k.length === 0)
      return A;
    X = O - k.length, U = new Uint8Array(X);
    var ae = 0;
    for (M = 0; M < X; ae++, M++)
      ae === k[0] && (ae++, k.shift()), U[M] = A[ae];
    return U;
  }, na = {
    parseSei: an,
    parseUserData: Fn,
    parseCaptionPackets: Pr,
    discardEmulationPreventionBytes: xr,
    USER_DATA_REGISTERED_ITU_T_T35: Fe
  }, lr = function ee(A) {
    A = A || {}, ee.prototype.init.call(this), this.parse708captions_ = typeof A.parse708captions == "boolean" ? A.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new Xn(0, 0),
      new Xn(0, 1),
      new Xn(1, 0),
      new Xn(1, 1)
    ], this.parse708captions_ && (this.cc708Stream_ = new On({
      captionServices: A.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(O) {
      O.on("data", this.trigger.bind(this, "data")), O.on("partialdone", this.trigger.bind(this, "partialdone")), O.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  lr.prototype = new t(), lr.prototype.push = function(ee) {
    var A, O, k;
    if (ee.nalUnitType === "sei_rbsp" && (A = na.parseSei(ee.escapedRBSP), !!A.payload && A.payloadType === na.USER_DATA_REGISTERED_ITU_T_T35 && (O = na.parseUserData(A), !!O))) {
      if (ee.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (ee.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      k = na.parseCaptionPackets(ee.pts, O), this.captionPackets_ = this.captionPackets_.concat(k), this.latestDts_ !== ee.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = ee.dts;
    }
  }, lr.prototype.flushCCStreams = function(ee) {
    this.ccStreams_.forEach(function(A) {
      return ee === "flush" ? A.flush() : A.partialFlush();
    }, this);
  }, lr.prototype.flushStream = function(ee) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(ee);
      return;
    }
    this.captionPackets_.forEach(function(A, O) {
      A.presortIndex = O;
    }), this.captionPackets_.sort(function(A, O) {
      return A.pts === O.pts ? A.presortIndex - O.presortIndex : A.pts - O.pts;
    }), this.captionPackets_.forEach(function(A) {
      A.type < 2 ? this.dispatchCea608Packet(A) : this.dispatchCea708Packet(A);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(ee);
  }, lr.prototype.flush = function() {
    return this.flushStream("flush");
  }, lr.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, lr.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(ee) {
      ee.reset();
    });
  }, lr.prototype.dispatchCea608Packet = function(ee) {
    this.setsTextOrXDSActive(ee) ? this.activeCea608Channel_[ee.type] = null : this.setsChannel1Active(ee) ? this.activeCea608Channel_[ee.type] = 0 : this.setsChannel2Active(ee) && (this.activeCea608Channel_[ee.type] = 1), this.activeCea608Channel_[ee.type] !== null && this.ccStreams_[(ee.type << 1) + this.activeCea608Channel_[ee.type]].push(ee);
  }, lr.prototype.setsChannel1Active = function(ee) {
    return (ee.ccData & 30720) === 4096;
  }, lr.prototype.setsChannel2Active = function(ee) {
    return (ee.ccData & 30720) === 6144;
  }, lr.prototype.setsTextOrXDSActive = function(ee) {
    return (ee.ccData & 28928) === 256 || (ee.ccData & 30974) === 4138 || (ee.ccData & 30974) === 6186;
  }, lr.prototype.dispatchCea708Packet = function(ee) {
    this.parse708captions_ && this.cc708Stream_.push(ee);
  };
  var Xf = {
    127: 9834,
    4128: 32,
    4129: 160,
    4133: 8230,
    4138: 352,
    4140: 338,
    4144: 9608,
    4145: 8216,
    4146: 8217,
    4147: 8220,
    4148: 8221,
    4149: 8226,
    4153: 8482,
    4154: 353,
    4156: 339,
    4157: 8480,
    4159: 376,
    4214: 8539,
    4215: 8540,
    4216: 8541,
    4217: 8542,
    4218: 9168,
    4219: 9124,
    4220: 9123,
    4221: 9135,
    4222: 9126,
    4223: 9121,
    4256: 12600
  }, S2 = function(A) {
    var O = Xf[A] || A;
    return A & 4096 && A === O ? "" : String.fromCharCode(O);
  }, Kl = function(A) {
    return 32 <= A && A <= 127 || 160 <= A && A <= 255;
  }, ia = function(A) {
    this.windowNum = A, this.reset();
  };
  ia.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, ia.prototype.getText = function() {
    return this.rows.join(`
`);
  }, ia.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, ia.prototype.newLine = function(ee) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(ee), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, ia.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, ia.prototype.addText = function(ee) {
    this.rows[this.rowIdx] += ee;
  }, ia.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var ee = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = ee.substr(0, ee.length - 1);
    }
  };
  var Gl = function(A, O, k) {
    this.serviceNum = A, this.text = "", this.currentWindow = new ia(-1), this.windows = [], this.stream = k, typeof O == "string" && this.createTextDecoder(O);
  };
  Gl.prototype.init = function(ee, A) {
    this.startPts = ee;
    for (var O = 0; O < 8; O++)
      this.windows[O] = new ia(O), typeof A == "function" && (this.windows[O].beforeRowOverflow = A);
  }, Gl.prototype.setCurrentWindow = function(ee) {
    this.currentWindow = this.windows[ee];
  }, Gl.prototype.createTextDecoder = function(ee) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(ee);
      } catch (A) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + ee + " encoding. " + A
        });
      }
  };
  var On = function ee(A) {
    A = A || {}, ee.prototype.init.call(this);
    var O = this, k = A.captionServices || {}, M = {}, X;
    Object.keys(k).forEach(function(U) {
      X = k[U], /^SERVICE/.test(U) && (M[U] = X.encoding);
    }), this.serviceEncodings = M, this.current708Packet = null, this.services = {}, this.push = function(U) {
      U.type === 3 ? (O.new708Packet(), O.add708Bytes(U)) : (O.current708Packet === null && O.new708Packet(), O.add708Bytes(U));
    };
  };
  On.prototype = new t(), On.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, On.prototype.add708Bytes = function(ee) {
    var A = ee.ccData, O = A >>> 8, k = A & 255;
    this.current708Packet.ptsVals.push(ee.pts), this.current708Packet.data.push(O), this.current708Packet.data.push(k);
  }, On.prototype.push708Packet = function() {
    var ee = this.current708Packet, A = ee.data, O = null, k = null, M = 0, X = A[M++];
    for (ee.seq = X >> 6, ee.sizeCode = X & 63; M < A.length; M++)
      X = A[M++], O = X >> 5, k = X & 31, O === 7 && k > 0 && (X = A[M++], O = X), this.pushServiceBlock(O, M, k), k > 0 && (M += k - 1);
  }, On.prototype.pushServiceBlock = function(ee, A, O) {
    var k, M = A, X = this.current708Packet.data, U = this.services[ee];
    for (U || (U = this.initService(ee, M)); M < A + O && M < X.length; M++)
      k = X[M], Kl(k) ? M = this.handleText(M, U) : k === 24 ? M = this.multiByteCharacter(M, U) : k === 16 ? M = this.extendedCommands(M, U) : 128 <= k && k <= 135 ? M = this.setCurrentWindow(M, U) : 152 <= k && k <= 159 ? M = this.defineWindow(M, U) : k === 136 ? M = this.clearWindows(M, U) : k === 140 ? M = this.deleteWindows(M, U) : k === 137 ? M = this.displayWindows(M, U) : k === 138 ? M = this.hideWindows(M, U) : k === 139 ? M = this.toggleWindows(M, U) : k === 151 ? M = this.setWindowAttributes(M, U) : k === 144 ? M = this.setPenAttributes(M, U) : k === 145 ? M = this.setPenColor(M, U) : k === 146 ? M = this.setPenLocation(M, U) : k === 143 ? U = this.reset(M, U) : k === 8 ? U.currentWindow.backspace() : k === 12 ? U.currentWindow.clearText() : k === 13 ? U.currentWindow.pendingNewLine = !0 : k === 14 ? U.currentWindow.clearText() : k === 141 && M++;
  }, On.prototype.extendedCommands = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee];
    return Kl(k) && (ee = this.handleText(ee, A, {
      isExtended: !0
    })), ee;
  }, On.prototype.getPts = function(ee) {
    return this.current708Packet.ptsVals[Math.floor(ee / 2)];
  }, On.prototype.initService = function(ee, A) {
    var k = "SERVICE" + ee, O = this, k, M;
    return k in this.serviceEncodings && (M = this.serviceEncodings[k]), this.services[ee] = new Gl(ee, M, O), this.services[ee].init(this.getPts(A), function(X) {
      O.flushDisplayed(X, O.services[ee]);
    }), this.services[ee];
  }, On.prototype.handleText = function(ee, A, O) {
    var k = O && O.isExtended, M = O && O.isMultiByte, X = this.current708Packet.data, U = k ? 4096 : 0, ae = X[ee], le = X[ee + 1], be = A.currentWindow, ge, xe;
    return A.textDecoder_ && !k ? (M ? (xe = [ae, le], ee++) : xe = [ae], ge = A.textDecoder_.decode(new Uint8Array(xe))) : ge = S2(U | ae), be.pendingNewLine && !be.isEmpty() && be.newLine(this.getPts(ee)), be.pendingNewLine = !1, be.addText(ge), ee;
  }, On.prototype.multiByteCharacter = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee + 1], M = O[ee + 2];
    return Kl(k) && Kl(M) && (ee = this.handleText(++ee, A, {
      isMultiByte: !0
    })), ee;
  }, On.prototype.setCurrentWindow = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = k & 7;
    return A.setCurrentWindow(M), ee;
  }, On.prototype.defineWindow = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = k & 7;
    A.setCurrentWindow(M);
    var X = A.currentWindow;
    return k = O[++ee], X.visible = (k & 32) >> 5, X.rowLock = (k & 16) >> 4, X.columnLock = (k & 8) >> 3, X.priority = k & 7, k = O[++ee], X.relativePositioning = (k & 128) >> 7, X.anchorVertical = k & 127, k = O[++ee], X.anchorHorizontal = k, k = O[++ee], X.anchorPoint = (k & 240) >> 4, X.rowCount = k & 15, k = O[++ee], X.columnCount = k & 63, k = O[++ee], X.windowStyle = (k & 56) >> 3, X.penStyle = k & 7, X.virtualRowCount = X.rowCount + 1, ee;
  }, On.prototype.setWindowAttributes = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = A.currentWindow.winAttr;
    return k = O[++ee], M.fillOpacity = (k & 192) >> 6, M.fillRed = (k & 48) >> 4, M.fillGreen = (k & 12) >> 2, M.fillBlue = k & 3, k = O[++ee], M.borderType = (k & 192) >> 6, M.borderRed = (k & 48) >> 4, M.borderGreen = (k & 12) >> 2, M.borderBlue = k & 3, k = O[++ee], M.borderType += (k & 128) >> 5, M.wordWrap = (k & 64) >> 6, M.printDirection = (k & 48) >> 4, M.scrollDirection = (k & 12) >> 2, M.justify = k & 3, k = O[++ee], M.effectSpeed = (k & 240) >> 4, M.effectDirection = (k & 12) >> 2, M.displayEffect = k & 3, ee;
  }, On.prototype.flushDisplayed = function(ee, A) {
    for (var O = [], k = 0; k < 8; k++)
      A.windows[k].visible && !A.windows[k].isEmpty() && O.push(A.windows[k].getText());
    A.endPts = ee, A.text = O.join(`

`), this.pushCaption(A), A.startPts = ee;
  }, On.prototype.pushCaption = function(ee) {
    ee.text !== "" && (this.trigger("data", {
      startPts: ee.startPts,
      endPts: ee.endPts,
      text: ee.text,
      stream: "cc708_" + ee.serviceNum
    }), ee.text = "", ee.startPts = ee.endPts);
  }, On.prototype.displayWindows = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee], M = this.getPts(ee);
    this.flushDisplayed(M, A);
    for (var X = 0; X < 8; X++)
      k & 1 << X && (A.windows[X].visible = 1);
    return ee;
  }, On.prototype.hideWindows = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee], M = this.getPts(ee);
    this.flushDisplayed(M, A);
    for (var X = 0; X < 8; X++)
      k & 1 << X && (A.windows[X].visible = 0);
    return ee;
  }, On.prototype.toggleWindows = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee], M = this.getPts(ee);
    this.flushDisplayed(M, A);
    for (var X = 0; X < 8; X++)
      k & 1 << X && (A.windows[X].visible ^= 1);
    return ee;
  }, On.prototype.clearWindows = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee], M = this.getPts(ee);
    this.flushDisplayed(M, A);
    for (var X = 0; X < 8; X++)
      k & 1 << X && A.windows[X].clearText();
    return ee;
  }, On.prototype.deleteWindows = function(ee, A) {
    var O = this.current708Packet.data, k = O[++ee], M = this.getPts(ee);
    this.flushDisplayed(M, A);
    for (var X = 0; X < 8; X++)
      k & 1 << X && A.windows[X].reset();
    return ee;
  }, On.prototype.setPenAttributes = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = A.currentWindow.penAttr;
    return k = O[++ee], M.textTag = (k & 240) >> 4, M.offset = (k & 12) >> 2, M.penSize = k & 3, k = O[++ee], M.italics = (k & 128) >> 7, M.underline = (k & 64) >> 6, M.edgeType = (k & 56) >> 3, M.fontStyle = k & 7, ee;
  }, On.prototype.setPenColor = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = A.currentWindow.penColor;
    return k = O[++ee], M.fgOpacity = (k & 192) >> 6, M.fgRed = (k & 48) >> 4, M.fgGreen = (k & 12) >> 2, M.fgBlue = k & 3, k = O[++ee], M.bgOpacity = (k & 192) >> 6, M.bgRed = (k & 48) >> 4, M.bgGreen = (k & 12) >> 2, M.bgBlue = k & 3, k = O[++ee], M.edgeRed = (k & 48) >> 4, M.edgeGreen = (k & 12) >> 2, M.edgeBlue = k & 3, ee;
  }, On.prototype.setPenLocation = function(ee, A) {
    var O = this.current708Packet.data, k = O[ee], M = A.currentWindow.penLoc;
    return A.currentWindow.pendingNewLine = !0, k = O[++ee], M.row = k & 15, k = O[++ee], M.column = k & 63, ee;
  }, On.prototype.reset = function(ee, A) {
    var O = this.getPts(ee);
    return this.flushDisplayed(O, A), this.initService(A.serviceNum, ee);
  };
  var Rf = {
    42: 225,
    92: 233,
    94: 237,
    95: 243,
    96: 250,
    123: 231,
    124: 247,
    125: 209,
    126: 241,
    127: 9608,
    304: 174,
    305: 176,
    306: 189,
    307: 191,
    308: 8482,
    309: 162,
    310: 163,
    311: 9834,
    312: 224,
    313: 160,
    314: 232,
    315: 226,
    316: 234,
    317: 238,
    318: 244,
    319: 251,
    544: 193,
    545: 201,
    546: 211,
    547: 218,
    548: 220,
    549: 252,
    550: 8216,
    551: 161,
    552: 42,
    553: 39,
    554: 8212,
    555: 169,
    556: 8480,
    557: 8226,
    558: 8220,
    559: 8221,
    560: 192,
    561: 194,
    562: 199,
    563: 200,
    564: 202,
    565: 203,
    566: 235,
    567: 206,
    568: 207,
    569: 239,
    570: 212,
    571: 217,
    572: 249,
    573: 219,
    574: 171,
    575: 187,
    800: 195,
    801: 227,
    802: 205,
    803: 204,
    804: 236,
    805: 210,
    806: 242,
    807: 213,
    808: 245,
    809: 123,
    810: 125,
    811: 92,
    812: 94,
    813: 95,
    814: 124,
    815: 126,
    816: 196,
    817: 228,
    818: 214,
    819: 246,
    820: 223,
    821: 165,
    822: 164,
    823: 9474,
    824: 197,
    825: 229,
    826: 216,
    827: 248,
    828: 9484,
    829: 9488,
    830: 9492,
    831: 9496
  }, cs = function(A) {
    return A === null ? "" : (A = Rf[A] || A, String.fromCharCode(A));
  }, bo = 14, Vf = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], Ao = function() {
    for (var A = [], O = bo + 1; O--; )
      A.push("");
    return A;
  }, Xn = function ee(A, O) {
    ee.prototype.init.call(this), this.field_ = A || 0, this.dataChannel_ = O || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(k) {
      var M, X, U, ae, le;
      if (M = k.ccData & 32639, M === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((M & 61440) === 4096 ? this.lastControlCode_ = M : M !== this.PADDING_ && (this.lastControlCode_ = null), U = M >>> 8, ae = M & 255, M !== this.PADDING_)
        if (M === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (M === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(k.pts), this.flushDisplayed(k.pts), X = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = X, this.startPts_ = k.pts;
        else if (M === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(k.pts);
        else if (M === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(k.pts);
        else if (M === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(k.pts);
        else if (M === this.CARRIAGE_RETURN_)
          this.clearFormatting(k.pts), this.flushDisplayed(k.pts), this.shiftRowsUp_(), this.startPts_ = k.pts;
        else if (M === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
        else if (M === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(k.pts), this.displayed_ = Ao();
        else if (M === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = Ao();
        else if (M === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(k.pts), this.displayed_ = Ao()), this.mode_ = "paintOn", this.startPts_ = k.pts;
        else if (this.isSpecialCharacter(U, ae))
          U = (U & 3) << 8, le = cs(U | ae), this[this.mode_](k.pts, le), this.column_++;
        else if (this.isExtCharacter(U, ae))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), U = (U & 3) << 8, le = cs(U | ae), this[this.mode_](k.pts, le), this.column_++;
        else if (this.isMidRowCode(U, ae))
          this.clearFormatting(k.pts), this[this.mode_](k.pts, " "), this.column_++, (ae & 14) === 14 && this.addFormatting(k.pts, ["i"]), (ae & 1) === 1 && this.addFormatting(k.pts, ["u"]);
        else if (this.isOffsetControlCode(U, ae))
          this.column_ += ae & 3;
        else if (this.isPAC(U, ae)) {
          var be = Vf.indexOf(M & 7968);
          this.mode_ === "rollUp" && (be - this.rollUpRows_ + 1 < 0 && (be = this.rollUpRows_ - 1), this.setRollUp(k.pts, be)), be !== this.row_ && (this.clearFormatting(k.pts), this.row_ = be), ae & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(k.pts, ["u"]), (M & 16) === 16 && (this.column_ = ((M & 14) >> 1) * 4), this.isColorPAC(ae) && (ae & 14) === 14 && this.addFormatting(k.pts, ["i"]);
        } else
          this.isNormalChar(U) && (ae === 0 && (ae = null), le = cs(U), le += cs(ae), this[this.mode_](k.pts, le), this.column_ += le.length);
    };
  };
  Xn.prototype = new t(), Xn.prototype.flushDisplayed = function(ee) {
    var A = this.displayed_.map(function(O, k) {
      try {
        return O.trim();
      } catch {
        return this.trigger("log", {
          level: "warn",
          message: "Skipping a malformed 608 caption at index " + k + "."
        }), "";
      }
    }, this).join(`
`).replace(/^\n+|\n+$/g, "");
    A.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: ee,
      text: A,
      stream: this.name_
    });
  }, Xn.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Ao(), this.nonDisplayed_ = Ao(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = bo, this.rollUpRows_ = 2, this.formatting_ = [];
  }, Xn.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, Xn.prototype.isSpecialCharacter = function(ee, A) {
    return ee === this.EXT_ && A >= 48 && A <= 63;
  }, Xn.prototype.isExtCharacter = function(ee, A) {
    return (ee === this.EXT_ + 1 || ee === this.EXT_ + 2) && A >= 32 && A <= 63;
  }, Xn.prototype.isMidRowCode = function(ee, A) {
    return ee === this.EXT_ && A >= 32 && A <= 47;
  }, Xn.prototype.isOffsetControlCode = function(ee, A) {
    return ee === this.OFFSET_ && A >= 33 && A <= 35;
  }, Xn.prototype.isPAC = function(ee, A) {
    return ee >= this.BASE_ && ee < this.BASE_ + 8 && A >= 64 && A <= 127;
  }, Xn.prototype.isColorPAC = function(ee) {
    return ee >= 64 && ee <= 79 || ee >= 96 && ee <= 127;
  }, Xn.prototype.isNormalChar = function(ee) {
    return ee >= 32 && ee <= 127;
  }, Xn.prototype.setRollUp = function(ee, A) {
    if (this.mode_ !== "rollUp" && (this.row_ = bo, this.mode_ = "rollUp", this.flushDisplayed(ee), this.nonDisplayed_ = Ao(), this.displayed_ = Ao()), A !== void 0 && A !== this.row_)
      for (var O = 0; O < this.rollUpRows_; O++)
        this.displayed_[A - O] = this.displayed_[this.row_ - O], this.displayed_[this.row_ - O] = "";
    A === void 0 && (A = this.row_), this.topRow_ = A - this.rollUpRows_ + 1;
  }, Xn.prototype.addFormatting = function(ee, A) {
    this.formatting_ = this.formatting_.concat(A);
    var O = A.reduce(function(k, M) {
      return k + "<" + M + ">";
    }, "");
    this[this.mode_](ee, O);
  }, Xn.prototype.clearFormatting = function(ee) {
    if (!!this.formatting_.length) {
      var A = this.formatting_.reverse().reduce(function(O, k) {
        return O + "</" + k + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](ee, A);
    }
  }, Xn.prototype.popOn = function(ee, A) {
    var O = this.nonDisplayed_[this.row_];
    O += A, this.nonDisplayed_[this.row_] = O;
  }, Xn.prototype.rollUp = function(ee, A) {
    var O = this.displayed_[this.row_];
    O += A, this.displayed_[this.row_] = O;
  }, Xn.prototype.shiftRowsUp_ = function() {
    var ee;
    for (ee = 0; ee < this.topRow_; ee++)
      this.displayed_[ee] = "";
    for (ee = this.row_ + 1; ee < bo + 1; ee++)
      this.displayed_[ee] = "";
    for (ee = this.topRow_; ee < this.row_; ee++)
      this.displayed_[ee] = this.displayed_[ee + 1];
    this.displayed_[this.row_] = "";
  }, Xn.prototype.paintOn = function(ee, A) {
    var O = this.displayed_[this.row_];
    O += A, this.displayed_[this.row_] = O;
  };
  var Ws = {
    CaptionStream: lr,
    Cea608Stream: Xn,
    Cea708Stream: On
  }, Pi = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, Uf = 8589934592, qf = 4294967296, _f = "shared", Ks = function(A, O) {
    var k = 1;
    for (A > O && (k = -1); Math.abs(O - A) > qf; )
      A += k * Uf;
    return A;
  }, Wf = function ee(A) {
    var O, k;
    ee.prototype.init.call(this), this.type_ = A || _f, this.push = function(M) {
      this.type_ !== _f && M.type !== this.type_ || (k === void 0 && (k = M.dts), M.dts = Ks(M.dts, k), M.pts = Ks(M.pts, k), O = M.dts, this.trigger("data", M));
    }, this.flush = function() {
      k = O, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      k = void 0, O = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  Wf.prototype = new t();
  var Hc = {
    TimestampRolloverStream: Wf,
    handleRollover: Ks
  }, Kf = function(A, O, k) {
    var M, X = "";
    for (M = O; M < k; M++)
      X += "%" + ("00" + A[M].toString(16)).slice(-2);
    return X;
  }, Gs = function(A, O, k) {
    return decodeURIComponent(Kf(A, O, k));
  }, Gf = function(A, O, k) {
    return unescape(Kf(A, O, k));
  }, ds = function(A) {
    return A[0] << 21 | A[1] << 14 | A[2] << 7 | A[3];
  }, Ic = {
    TXXX: function(A) {
      var O;
      if (A.data[0] === 3) {
        for (O = 1; O < A.data.length; O++)
          if (A.data[O] === 0) {
            A.description = Gs(A.data, 1, O), A.value = Gs(A.data, O + 1, A.data.length).replace(/\0*$/, "");
            break;
          }
        A.data = A.value;
      }
    },
    WXXX: function(A) {
      var O;
      if (A.data[0] === 3) {
        for (O = 1; O < A.data.length; O++)
          if (A.data[O] === 0) {
            A.description = Gs(A.data, 1, O), A.url = Gs(A.data, O + 1, A.data.length);
            break;
          }
      }
    },
    PRIV: function(A) {
      var O;
      for (O = 0; O < A.data.length; O++)
        if (A.data[O] === 0) {
          A.owner = Gf(A.data, 0, O);
          break;
        }
      A.privateData = A.data.subarray(O + 1), A.data = A.privateData;
    }
  }, ki;
  ki = function(A) {
    var O = {
      descriptor: A && A.descriptor
    }, k = 0, M = [], X = 0, U;
    if (ki.prototype.init.call(this), this.dispatchType = Pi.METADATA_STREAM_TYPE.toString(16), O.descriptor)
      for (U = 0; U < O.descriptor.length; U++)
        this.dispatchType += ("00" + O.descriptor[U].toString(16)).slice(-2);
    this.push = function(ae) {
      var le, be, ge, xe, qe, ht;
      if (ae.type === "timed-metadata") {
        if (ae.dataAlignmentIndicator && (X = 0, M.length = 0), M.length === 0 && (ae.data.length < 10 || ae.data[0] !== "I".charCodeAt(0) || ae.data[1] !== "D".charCodeAt(0) || ae.data[2] !== "3".charCodeAt(0))) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (M.push(ae), X += ae.data.byteLength, M.length === 1 && (k = ds(ae.data.subarray(6, 10)), k += 10), !(X < k)) {
          for (le = {
            data: new Uint8Array(k),
            frames: [],
            pts: M[0].pts,
            dts: M[0].dts
          }, qe = 0; qe < k; )
            le.data.set(M[0].data.subarray(0, k - qe), qe), qe += M[0].data.byteLength, X -= M[0].data.byteLength, M.shift();
          be = 10, le.data[5] & 64 && (be += 4, be += ds(le.data.subarray(10, 14)), k -= ds(le.data.subarray(16, 20)));
          do {
            if (ge = ds(le.data.subarray(be + 4, be + 8)), ge < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping metadata parsing."
              });
              return;
            }
            if (ht = String.fromCharCode(le.data[be], le.data[be + 1], le.data[be + 2], le.data[be + 3]), xe = {
              id: ht,
              data: le.data.subarray(be + 10, be + ge + 10)
            }, xe.key = xe.id, Ic[xe.id] && (Ic[xe.id](xe), xe.owner === "com.apple.streaming.transportStreamTimestamp")) {
              var Ot = xe.data, ut = (Ot[3] & 1) << 30 | Ot[4] << 22 | Ot[5] << 14 | Ot[6] << 6 | Ot[7] >>> 2;
              ut *= 4, ut += Ot[7] & 3, xe.timeStamp = ut, le.pts === void 0 && le.dts === void 0 && (le.pts = xe.timeStamp, le.dts = xe.timeStamp), this.trigger("timestamp", xe);
            }
            le.frames.push(xe), be += 10, be += ge;
          } while (be < k);
          this.trigger("data", le);
        }
      }
    };
  }, ki.prototype = new t();
  var fs = ki, Yl = Hc.TimestampRolloverStream, Ql, Ys, hs, To = 188, ps = 71;
  Ql = function() {
    var A = new Uint8Array(To), O = 0;
    Ql.prototype.init.call(this), this.push = function(k) {
      var M = 0, X = To, U;
      for (O ? (U = new Uint8Array(k.byteLength + O), U.set(A.subarray(0, O)), U.set(k, O), O = 0) : U = k; X < U.byteLength; ) {
        if (U[M] === ps && U[X] === ps) {
          this.trigger("data", U.subarray(M, X)), M += To, X += To;
          continue;
        }
        M++, X++;
      }
      M < U.byteLength && (A.set(U.subarray(M), 0), O = U.byteLength - M);
    }, this.flush = function() {
      O === To && A[0] === ps && (this.trigger("data", A), O = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      O = 0, this.trigger("reset");
    };
  }, Ql.prototype = new t(), Ys = function() {
    var A, O, k, M;
    Ys.prototype.init.call(this), M = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, A = function(U, ae) {
      var le = 0;
      ae.payloadUnitStartIndicator && (le += U[le] + 1), ae.type === "pat" ? O(U.subarray(le), ae) : k(U.subarray(le), ae);
    }, O = function(U, ae) {
      ae.section_number = U[7], ae.last_section_number = U[8], M.pmtPid = (U[10] & 31) << 8 | U[11], ae.pmtPid = M.pmtPid;
    }, k = function(U, ae) {
      var le, be, ge, xe;
      if (!!(U[5] & 1)) {
        for (M.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, le = (U[1] & 15) << 8 | U[2], be = 3 + le - 4, ge = (U[10] & 15) << 8 | U[11], xe = 12 + ge; xe < be; ) {
          var qe = U[xe], ht = (U[xe + 1] & 31) << 8 | U[xe + 2];
          qe === Pi.H264_STREAM_TYPE && M.programMapTable.video === null ? M.programMapTable.video = ht : qe === Pi.ADTS_STREAM_TYPE && M.programMapTable.audio === null ? M.programMapTable.audio = ht : qe === Pi.METADATA_STREAM_TYPE && (M.programMapTable["timed-metadata"][ht] = qe), xe += ((U[xe + 3] & 15) << 8 | U[xe + 4]) + 5;
        }
        ae.programMapTable = M.programMapTable;
      }
    }, this.push = function(X) {
      var U = {}, ae = 4;
      if (U.payloadUnitStartIndicator = !!(X[1] & 64), U.pid = X[1] & 31, U.pid <<= 8, U.pid |= X[2], (X[3] & 48) >>> 4 > 1 && (ae += X[ae] + 1), U.pid === 0)
        U.type = "pat", A(X.subarray(ae), U), this.trigger("data", U);
      else if (U.pid === this.pmtPid)
        for (U.type = "pmt", A(X.subarray(ae), U), this.trigger("data", U); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else
        this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([X, ae, U]) : this.processPes_(X, ae, U);
    }, this.processPes_ = function(X, U, ae) {
      ae.pid === this.programMapTable.video ? ae.streamType = Pi.H264_STREAM_TYPE : ae.pid === this.programMapTable.audio ? ae.streamType = Pi.ADTS_STREAM_TYPE : ae.streamType = this.programMapTable["timed-metadata"][ae.pid], ae.type = "pes", ae.data = X.subarray(U), this.trigger("data", ae);
    };
  }, Ys.prototype = new t(), Ys.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, hs = function() {
    var A = this, O = !1, k = {
      data: [],
      size: 0
    }, M = {
      data: [],
      size: 0
    }, X = {
      data: [],
      size: 0
    }, U, ae = function(ge, xe) {
      var qe, ht = ge[0] << 16 | ge[1] << 8 | ge[2];
      xe.data = new Uint8Array(), ht === 1 && (xe.packetLength = 6 + (ge[4] << 8 | ge[5]), xe.dataAlignmentIndicator = (ge[6] & 4) !== 0, qe = ge[7], qe & 192 && (xe.pts = (ge[9] & 14) << 27 | (ge[10] & 255) << 20 | (ge[11] & 254) << 12 | (ge[12] & 255) << 5 | (ge[13] & 254) >>> 3, xe.pts *= 4, xe.pts += (ge[13] & 6) >>> 1, xe.dts = xe.pts, qe & 64 && (xe.dts = (ge[14] & 14) << 27 | (ge[15] & 255) << 20 | (ge[16] & 254) << 12 | (ge[17] & 255) << 5 | (ge[18] & 254) >>> 3, xe.dts *= 4, xe.dts += (ge[18] & 6) >>> 1)), xe.data = ge.subarray(9 + ge[8]));
    }, le = function(ge, xe, qe) {
      var ht = new Uint8Array(ge.size), Ot = {
        type: xe
      }, ut = 0, Wt = 0, ie = !1, fe;
      if (!(!ge.data.length || ge.size < 9)) {
        for (Ot.trackId = ge.data[0].pid, ut = 0; ut < ge.data.length; ut++)
          fe = ge.data[ut], ht.set(fe.data, Wt), Wt += fe.data.byteLength;
        ae(ht, Ot), ie = xe === "video" || Ot.packetLength <= ge.size, (qe || ie) && (ge.size = 0, ge.data.length = 0), ie && A.trigger("data", Ot);
      }
    };
    hs.prototype.init.call(this), this.push = function(be) {
      ({
        pat: function() {
        },
        pes: function() {
          var xe, qe;
          switch (be.streamType) {
            case Pi.H264_STREAM_TYPE:
              xe = k, qe = "video";
              break;
            case Pi.ADTS_STREAM_TYPE:
              xe = M, qe = "audio";
              break;
            case Pi.METADATA_STREAM_TYPE:
              xe = X, qe = "timed-metadata";
              break;
            default:
              return;
          }
          be.payloadUnitStartIndicator && le(xe, qe, !0), xe.data.push(be), xe.size += be.data.byteLength;
        },
        pmt: function() {
          var xe = {
            type: "metadata",
            tracks: []
          };
          U = be.programMapTable, U.video !== null && xe.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +U.video,
            codec: "avc",
            type: "video"
          }), U.audio !== null && xe.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +U.audio,
            codec: "adts",
            type: "audio"
          }), O = !0, A.trigger("data", xe);
        }
      })[be.type]();
    }, this.reset = function() {
      k.size = 0, k.data.length = 0, M.size = 0, M.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      le(k, "video"), le(M, "audio"), le(X, "timed-metadata");
    }, this.flush = function() {
      if (!O && U) {
        var be = {
          type: "metadata",
          tracks: []
        };
        U.video !== null && be.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +U.video,
          codec: "avc",
          type: "video"
        }), U.audio !== null && be.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +U.audio,
          codec: "adts",
          type: "audio"
        }), A.trigger("data", be);
      }
      O = !1, this.flushStreams_(), this.trigger("done");
    };
  }, hs.prototype = new t();
  var Lc = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: To,
    TransportPacketStream: Ql,
    TransportParseStream: Ys,
    ElementaryStream: hs,
    TimestampRolloverStream: Yl,
    CaptionStream: Ws.CaptionStream,
    Cea608Stream: Ws.Cea608Stream,
    Cea708Stream: Ws.Cea708Stream,
    MetadataStream: fs
  };
  for (var Bc in Pi)
    Pi.hasOwnProperty(Bc) && (Lc[Bc] = Pi[Bc]);
  var ka = Lc, jr = Se.ONE_SECOND_IN_TS, Qs, vs = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  Qs = function(A) {
    var O, k = 0;
    Qs.prototype.init.call(this), this.skipWarn_ = function(M, X) {
      this.trigger("log", {
        level: "warn",
        message: "adts skiping bytes " + M + " to " + X + " in frame " + k + " outside syncword"
      });
    }, this.push = function(M) {
      var X = 0, U, ae, le, be, ge;
      if (A || (k = 0), M.type === "audio") {
        O && O.length ? (le = O, O = new Uint8Array(le.byteLength + M.data.byteLength), O.set(le), O.set(M.data, le.byteLength)) : O = M.data;
        for (var xe; X + 7 < O.length; ) {
          if (O[X] !== 255 || (O[X + 1] & 246) !== 240) {
            typeof xe != "number" && (xe = X), X++;
            continue;
          }
          if (typeof xe == "number" && (this.skipWarn_(xe, X), xe = null), ae = (~O[X + 1] & 1) * 2, U = (O[X + 3] & 3) << 11 | O[X + 4] << 3 | (O[X + 5] & 224) >> 5, be = ((O[X + 6] & 3) + 1) * 1024, ge = be * jr / vs[(O[X + 2] & 60) >>> 2], O.byteLength - X < U)
            break;
          this.trigger("data", {
            pts: M.pts + k * ge,
            dts: M.dts + k * ge,
            sampleCount: be,
            audioobjecttype: (O[X + 2] >>> 6 & 3) + 1,
            channelcount: (O[X + 2] & 1) << 2 | (O[X + 3] & 192) >>> 6,
            samplerate: vs[(O[X + 2] & 60) >>> 2],
            samplingfrequencyindex: (O[X + 2] & 60) >>> 2,
            samplesize: 16,
            data: O.subarray(X + 7 + ae, X + U)
          }), k++, X += U;
        }
        typeof xe == "number" && (this.skipWarn_(xe, X), xe = null), O = O.subarray(X);
      }
    }, this.flush = function() {
      k = 0, this.trigger("done");
    }, this.reset = function() {
      O = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      O = void 0, this.trigger("endedtimeline");
    };
  }, Qs.prototype = new t();
  var Yf = Qs, Qf;
  Qf = function(A) {
    var O = A.byteLength, k = 0, M = 0;
    this.length = function() {
      return 8 * O;
    }, this.bitsAvailable = function() {
      return 8 * O + M;
    }, this.loadWord = function() {
      var X = A.byteLength - O, U = new Uint8Array(4), ae = Math.min(4, O);
      if (ae === 0)
        throw new Error("no bytes available");
      U.set(A.subarray(X, X + ae)), k = new DataView(U.buffer).getUint32(0), M = ae * 8, O -= ae;
    }, this.skipBits = function(X) {
      var U;
      M > X ? (k <<= X, M -= X) : (X -= M, U = Math.floor(X / 8), X -= U * 8, O -= U, this.loadWord(), k <<= X, M -= X);
    }, this.readBits = function(X) {
      var U = Math.min(M, X), ae = k >>> 32 - U;
      return M -= U, M > 0 ? k <<= U : O > 0 && this.loadWord(), U = X - U, U > 0 ? ae << U | this.readBits(U) : ae;
    }, this.skipLeadingZeros = function() {
      var X;
      for (X = 0; X < M; ++X)
        if ((k & 2147483648 >>> X) !== 0)
          return k <<= X, M -= X, X;
      return this.loadWord(), X + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var X = this.skipLeadingZeros();
      return this.readBits(X + 1) - 1;
    }, this.readExpGolomb = function() {
      var X = this.readUnsignedExpGolomb();
      return 1 & X ? 1 + X >>> 1 : -1 * (X >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var wo = Qf, ra, Po, Zf;
  Po = function() {
    var A = 0, O, k;
    Po.prototype.init.call(this), this.push = function(M) {
      var X;
      k ? (X = new Uint8Array(k.byteLength + M.data.byteLength), X.set(k), X.set(M.data, k.byteLength), k = X) : k = M.data;
      for (var U = k.byteLength; A < U - 3; A++)
        if (k[A + 2] === 1) {
          O = A + 5;
          break;
        }
      for (; O < U; )
        switch (k[O]) {
          case 0:
            if (k[O - 1] !== 0) {
              O += 2;
              break;
            } else if (k[O - 2] !== 0) {
              O++;
              break;
            }
            A + 3 !== O - 2 && this.trigger("data", k.subarray(A + 3, O - 2));
            do
              O++;
            while (k[O] !== 1 && O < U);
            A = O - 2, O += 3;
            break;
          case 1:
            if (k[O - 1] !== 0 || k[O - 2] !== 0) {
              O += 3;
              break;
            }
            this.trigger("data", k.subarray(A + 3, O - 2)), A = O - 2, O += 3;
            break;
          default:
            O += 3;
            break;
        }
      k = k.subarray(A), O -= A, A = 0;
    }, this.reset = function() {
      k = null, A = 0, this.trigger("reset");
    }, this.flush = function() {
      k && k.byteLength > 3 && this.trigger("data", k.subarray(A + 3)), k = null, A = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, Po.prototype = new t(), Zf = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    138: !0,
    139: !0,
    134: !0
  }, ra = function() {
    var A = new Po(), O, k, M, X, U, ae, le;
    ra.prototype.init.call(this), O = this, this.push = function(be) {
      be.type === "video" && (k = be.trackId, M = be.pts, X = be.dts, A.push(be));
    }, A.on("data", function(be) {
      var ge = {
        trackId: k,
        pts: M,
        dts: X,
        data: be,
        nalUnitTypeCode: be[0] & 31
      };
      switch (ge.nalUnitTypeCode) {
        case 5:
          ge.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          ge.nalUnitType = "sei_rbsp", ge.escapedRBSP = U(be.subarray(1));
          break;
        case 7:
          ge.nalUnitType = "seq_parameter_set_rbsp", ge.escapedRBSP = U(be.subarray(1)), ge.config = ae(ge.escapedRBSP);
          break;
        case 8:
          ge.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          ge.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      O.trigger("data", ge);
    }), A.on("done", function() {
      O.trigger("done");
    }), A.on("partialdone", function() {
      O.trigger("partialdone");
    }), A.on("reset", function() {
      O.trigger("reset");
    }), A.on("endedtimeline", function() {
      O.trigger("endedtimeline");
    }), this.flush = function() {
      A.flush();
    }, this.partialFlush = function() {
      A.partialFlush();
    }, this.reset = function() {
      A.reset();
    }, this.endTimeline = function() {
      A.endTimeline();
    }, le = function(ge, xe) {
      var qe = 8, ht = 8, Ot, ut;
      for (Ot = 0; Ot < ge; Ot++)
        ht !== 0 && (ut = xe.readExpGolomb(), ht = (qe + ut + 256) % 256), qe = ht === 0 ? qe : ht;
    }, U = function(ge) {
      for (var xe = ge.byteLength, qe = [], ht = 1, Ot, ut; ht < xe - 2; )
        ge[ht] === 0 && ge[ht + 1] === 0 && ge[ht + 2] === 3 ? (qe.push(ht + 2), ht += 2) : ht++;
      if (qe.length === 0)
        return ge;
      Ot = xe - qe.length, ut = new Uint8Array(Ot);
      var Wt = 0;
      for (ht = 0; ht < Ot; Wt++, ht++)
        Wt === qe[0] && (Wt++, qe.shift()), ut[ht] = ge[Wt];
      return ut;
    }, ae = function(ge) {
      var xe = 0, qe = 0, ht = 0, Ot = 0, ut, Wt, ie, fe, we, Ge, ze, Ze, rt, pt, St, Dt = [1, 1], Vt, Rt;
      if (ut = new wo(ge), Wt = ut.readUnsignedByte(), fe = ut.readUnsignedByte(), ie = ut.readUnsignedByte(), ut.skipUnsignedExpGolomb(), Zf[Wt] && (we = ut.readUnsignedExpGolomb(), we === 3 && ut.skipBits(1), ut.skipUnsignedExpGolomb(), ut.skipUnsignedExpGolomb(), ut.skipBits(1), ut.readBoolean()))
        for (St = we !== 3 ? 8 : 12, Rt = 0; Rt < St; Rt++)
          ut.readBoolean() && (Rt < 6 ? le(16, ut) : le(64, ut));
      if (ut.skipUnsignedExpGolomb(), Ge = ut.readUnsignedExpGolomb(), Ge === 0)
        ut.readUnsignedExpGolomb();
      else if (Ge === 1)
        for (ut.skipBits(1), ut.skipExpGolomb(), ut.skipExpGolomb(), ze = ut.readUnsignedExpGolomb(), Rt = 0; Rt < ze; Rt++)
          ut.skipExpGolomb();
      if (ut.skipUnsignedExpGolomb(), ut.skipBits(1), Ze = ut.readUnsignedExpGolomb(), rt = ut.readUnsignedExpGolomb(), pt = ut.readBits(1), pt === 0 && ut.skipBits(1), ut.skipBits(1), ut.readBoolean() && (xe = ut.readUnsignedExpGolomb(), qe = ut.readUnsignedExpGolomb(), ht = ut.readUnsignedExpGolomb(), Ot = ut.readUnsignedExpGolomb()), ut.readBoolean() && ut.readBoolean()) {
        switch (Vt = ut.readUnsignedByte(), Vt) {
          case 1:
            Dt = [1, 1];
            break;
          case 2:
            Dt = [12, 11];
            break;
          case 3:
            Dt = [10, 11];
            break;
          case 4:
            Dt = [16, 11];
            break;
          case 5:
            Dt = [40, 33];
            break;
          case 6:
            Dt = [24, 11];
            break;
          case 7:
            Dt = [20, 11];
            break;
          case 8:
            Dt = [32, 11];
            break;
          case 9:
            Dt = [80, 33];
            break;
          case 10:
            Dt = [18, 11];
            break;
          case 11:
            Dt = [15, 11];
            break;
          case 12:
            Dt = [64, 33];
            break;
          case 13:
            Dt = [160, 99];
            break;
          case 14:
            Dt = [4, 3];
            break;
          case 15:
            Dt = [3, 2];
            break;
          case 16:
            Dt = [2, 1];
            break;
          case 255: {
            Dt = [ut.readUnsignedByte() << 8 | ut.readUnsignedByte(), ut.readUnsignedByte() << 8 | ut.readUnsignedByte()];
            break;
          }
        }
        Dt && Dt[0] / Dt[1];
      }
      return {
        profileIdc: Wt,
        levelIdc: ie,
        profileCompatibility: fe,
        width: (Ze + 1) * 16 - xe * 2 - qe * 2,
        height: (2 - pt) * (rt + 1) * 16 - ht * 2 - Ot * 2,
        sarRatio: Dt
      };
    };
  }, ra.prototype = new t();
  var Jf = {
    H264Stream: ra,
    NalByteStream: Po
  }, $f = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], ms = function(A, O) {
    var k = A[O + 6] << 21 | A[O + 7] << 14 | A[O + 8] << 7 | A[O + 9], M = A[O + 5], X = (M & 16) >> 4;
    return k = k >= 0 ? k : 0, X ? k + 20 : k + 10;
  }, e1 = function ee(A, O) {
    return A.length - O < 10 || A[O] !== "I".charCodeAt(0) || A[O + 1] !== "D".charCodeAt(0) || A[O + 2] !== "3".charCodeAt(0) ? O : (O += ms(A, O), ee(A, O));
  }, Nc = function(A) {
    var O = e1(A, 0);
    return A.length >= O + 2 && (A[O] & 255) === 255 && (A[O + 1] & 240) === 240 && (A[O + 1] & 22) === 16;
  }, t1 = function(A) {
    return A[0] << 21 | A[1] << 14 | A[2] << 7 | A[3];
  }, n1 = function(A, O, k) {
    var M, X = "";
    for (M = O; M < k; M++)
      X += "%" + ("00" + A[M].toString(16)).slice(-2);
    return X;
  }, E2 = function(A, O, k) {
    return unescape(n1(A, O, k));
  }, k2 = function(A, O) {
    var k = (A[O + 5] & 224) >> 5, M = A[O + 4] << 3, X = A[O + 3] & 3 << 11;
    return X | M | k;
  }, jc = function(A, O) {
    return A[O] === "I".charCodeAt(0) && A[O + 1] === "D".charCodeAt(0) && A[O + 2] === "3".charCodeAt(0) ? "timed-metadata" : A[O] & !0 && (A[O + 1] & 240) === 240 ? "audio" : null;
  }, O2 = function(A) {
    for (var O = 0; O + 5 < A.length; ) {
      if (A[O] !== 255 || (A[O + 1] & 246) !== 240) {
        O++;
        continue;
      }
      return $f[(A[O + 2] & 60) >>> 2];
    }
    return null;
  }, z2 = function(A) {
    var O, k, M, X;
    O = 10, A[5] & 64 && (O += 4, O += t1(A.subarray(10, 14)));
    do {
      if (k = t1(A.subarray(O + 4, O + 8)), k < 1)
        return null;
      if (X = String.fromCharCode(A[O], A[O + 1], A[O + 2], A[O + 3]), X === "PRIV") {
        M = A.subarray(O + 10, O + k + 10);
        for (var U = 0; U < M.byteLength; U++)
          if (M[U] === 0) {
            var ae = E2(M, 0, U);
            if (ae === "com.apple.streaming.transportStreamTimestamp") {
              var le = M.subarray(U + 1), be = (le[3] & 1) << 30 | le[4] << 22 | le[5] << 14 | le[6] << 6 | le[7] >>> 2;
              return be *= 4, be += le[7] & 3, be;
            }
            break;
          }
      }
      O += 10, O += k;
    } while (O < A.byteLength);
    return null;
  }, Zl = {
    isLikelyAacData: Nc,
    parseId3TagSize: ms,
    parseAdtsSize: k2,
    parseType: jc,
    parseSampleRate: O2,
    parseAacTimestamp: z2
  }, Jl;
  Jl = function() {
    var A = new Uint8Array(), O = 0;
    Jl.prototype.init.call(this), this.setTimestamp = function(k) {
      O = k;
    }, this.push = function(k) {
      var M = 0, X = 0, U, ae, le, be;
      for (A.length ? (be = A.length, A = new Uint8Array(k.byteLength + be), A.set(A.subarray(0, be)), A.set(k, be)) : A = k; A.length - X >= 3; ) {
        if (A[X] === "I".charCodeAt(0) && A[X + 1] === "D".charCodeAt(0) && A[X + 2] === "3".charCodeAt(0)) {
          if (A.length - X < 10 || (M = Zl.parseId3TagSize(A, X), X + M > A.length))
            break;
          ae = {
            type: "timed-metadata",
            data: A.subarray(X, X + M)
          }, this.trigger("data", ae), X += M;
          continue;
        } else if ((A[X] & 255) === 255 && (A[X + 1] & 240) === 240) {
          if (A.length - X < 7 || (M = Zl.parseAdtsSize(A, X), X + M > A.length))
            break;
          le = {
            type: "audio",
            data: A.subarray(X, X + M),
            pts: O,
            dts: O
          }, this.trigger("data", le), X += M;
          continue;
        }
        X++;
      }
      U = A.length - X, U > 0 ? A = A.subarray(X) : A = new Uint8Array();
    }, this.reset = function() {
      A = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      A = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, Jl.prototype = new t();
  var D2 = Jl, M2 = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], Fc = M2, i1 = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], Zs = i1, r1 = Jf.H264Stream, Xc = Zl.isLikelyAacData, a1 = Se.ONE_SECOND_IN_TS, gs, Za, $l, xo, H2 = function(A, O) {
    O.stream = A, this.trigger("log", O);
  }, ys = function(A, O) {
    for (var k = Object.keys(O), M = 0; M < k.length; M++) {
      var X = k[M];
      X === "headOfPipeline" || !O[X].on || O[X].on("log", H2.bind(A, X));
    }
  }, Rc = function(A, O) {
    var k;
    if (A.length !== O.length)
      return !1;
    for (k = 0; k < A.length; k++)
      if (A[k] !== O[k])
        return !1;
    return !0;
  }, Js = function(A, O, k, M, X, U) {
    var ae = k - O, le = M - O, be = X - k;
    return {
      start: {
        dts: A,
        pts: A + ae
      },
      end: {
        dts: A + le,
        pts: A + be
      },
      prependedContentDuration: U,
      baseMediaDecodeTime: A
    };
  };
  Za = function(A, O) {
    var k = [], M, X = 0, U = 0, ae = 1 / 0;
    O = O || {}, M = O.firstSequenceNumber || 0, Za.prototype.init.call(this), this.push = function(le) {
      ii.collectDtsInfo(A, le), A && Fc.forEach(function(be) {
        A[be] = le[be];
      }), k.push(le);
    }, this.setEarliestDts = function(le) {
      X = le;
    }, this.setVideoBaseMediaDecodeTime = function(le) {
      ae = le;
    }, this.setAudioAppendStart = function(le) {
      U = le;
    }, this.flush = function() {
      var le, be, ge, xe, qe, ht, Ot;
      if (k.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      le = Tn.trimAdtsFramesByEarliestDts(k, A, X), A.baseMediaDecodeTime = ii.calculateTrackBaseMediaDecodeTime(A, O.keepOriginalTimestamps), Ot = Tn.prefixWithSilence(A, le, U, ae), A.samples = Tn.generateSampleTable(le), ge = Qe.mdat(Tn.concatenateFrameData(le)), k = [], be = Qe.moof(M, [A]), xe = new Uint8Array(be.byteLength + ge.byteLength), M++, xe.set(be), xe.set(ge, be.byteLength), ii.clearDtsInfo(A), qe = Math.ceil(a1 * 1024 / A.samplerate), le.length && (ht = le.length * qe, this.trigger("segmentTimingInfo", Js(
        Se.audioTsToVideoTs(A.baseMediaDecodeTime, A.samplerate),
        le[0].dts,
        le[0].pts,
        le[0].dts + ht,
        le[0].pts + ht,
        Ot || 0
      )), this.trigger("timingInfo", {
        start: le[0].pts,
        end: le[0].pts + ht
      })), this.trigger("data", {
        track: A,
        boxes: xe
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      ii.clearDtsInfo(A), k = [], this.trigger("reset");
    };
  }, Za.prototype = new t(), gs = function(A, O) {
    var k, M = [], X = [], U, ae;
    O = O || {}, k = O.firstSequenceNumber || 0, gs.prototype.init.call(this), delete A.minPTS, this.gopCache_ = [], this.push = function(le) {
      ii.collectDtsInfo(A, le), le.nalUnitType === "seq_parameter_set_rbsp" && !U && (U = le.config, A.sps = [le.data], Zs.forEach(function(be) {
        A[be] = U[be];
      }, this)), le.nalUnitType === "pic_parameter_set_rbsp" && !ae && (ae = le.data, A.pps = [le.data]), M.push(le);
    }, this.flush = function() {
      for (var le, be, ge, xe, qe, ht, Ot = 0, ut, Wt; M.length && M[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        M.shift();
      if (M.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (le = Pe.groupNalsIntoFrames(M), ge = Pe.groupFramesIntoGops(le), ge[0][0].keyFrame || (be = this.getGopForFusion_(M[0], A), be ? (Ot = be.duration, ge.unshift(be), ge.byteLength += be.byteLength, ge.nalCount += be.nalCount, ge.pts = be.pts, ge.dts = be.dts, ge.duration += be.duration) : ge = Pe.extendFirstKeyFrame(ge)), X.length) {
        var ie;
        if (O.alignGopsAtEnd ? ie = this.alignGopsAtEnd_(ge) : ie = this.alignGopsAtStart_(ge), !ie) {
          this.gopCache_.unshift({
            gop: ge.pop(),
            pps: A.pps,
            sps: A.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), M = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        ii.clearDtsInfo(A), ge = ie;
      }
      ii.collectDtsInfo(A, ge), A.samples = Pe.generateSampleTable(ge), qe = Qe.mdat(Pe.concatenateNalData(ge)), A.baseMediaDecodeTime = ii.calculateTrackBaseMediaDecodeTime(A, O.keepOriginalTimestamps), this.trigger("processedGopsInfo", ge.map(function(fe) {
        return {
          pts: fe.pts,
          dts: fe.dts,
          byteLength: fe.byteLength
        };
      })), ut = ge[0], Wt = ge[ge.length - 1], this.trigger("segmentTimingInfo", Js(A.baseMediaDecodeTime, ut.dts, ut.pts, Wt.dts + Wt.duration, Wt.pts + Wt.duration, Ot)), this.trigger("timingInfo", {
        start: ge[0].pts,
        end: ge[ge.length - 1].pts + ge[ge.length - 1].duration
      }), this.gopCache_.unshift({
        gop: ge.pop(),
        pps: A.pps,
        sps: A.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), M = [], this.trigger("baseMediaDecodeTime", A.baseMediaDecodeTime), this.trigger("timelineStartInfo", A.timelineStartInfo), xe = Qe.moof(k, [A]), ht = new Uint8Array(xe.byteLength + qe.byteLength), k++, ht.set(xe), ht.set(qe, xe.byteLength), this.trigger("data", {
        track: A,
        boxes: ht
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), M = [], this.gopCache_.length = 0, X.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      ii.clearDtsInfo(A), U = void 0, ae = void 0;
    }, this.getGopForFusion_ = function(le) {
      var be = 45e3, ge = 1e4, xe = 1 / 0, qe, ht, Ot, ut, Wt;
      for (Wt = 0; Wt < this.gopCache_.length; Wt++)
        ut = this.gopCache_[Wt], Ot = ut.gop, !(!(A.pps && Rc(A.pps[0], ut.pps[0])) || !(A.sps && Rc(A.sps[0], ut.sps[0]))) && (Ot.dts < A.timelineStartInfo.dts || (qe = le.dts - Ot.dts - Ot.duration, qe >= -ge && qe <= be && (!ht || xe > qe) && (ht = ut, xe = qe)));
      return ht ? ht.gop : null;
    }, this.alignGopsAtStart_ = function(le) {
      var be, ge, xe, qe, ht, Ot, ut, Wt;
      for (ht = le.byteLength, Ot = le.nalCount, ut = le.duration, be = ge = 0; be < X.length && ge < le.length && (xe = X[be], qe = le[ge], xe.pts !== qe.pts); ) {
        if (qe.pts > xe.pts) {
          be++;
          continue;
        }
        ge++, ht -= qe.byteLength, Ot -= qe.nalCount, ut -= qe.duration;
      }
      return ge === 0 ? le : ge === le.length ? null : (Wt = le.slice(ge), Wt.byteLength = ht, Wt.duration = ut, Wt.nalCount = Ot, Wt.pts = Wt[0].pts, Wt.dts = Wt[0].dts, Wt);
    }, this.alignGopsAtEnd_ = function(le) {
      var be, ge, xe, qe, ht, Ot;
      for (be = X.length - 1, ge = le.length - 1, ht = null, Ot = !1; be >= 0 && ge >= 0; ) {
        if (xe = X[be], qe = le[ge], xe.pts === qe.pts) {
          Ot = !0;
          break;
        }
        if (xe.pts > qe.pts) {
          be--;
          continue;
        }
        be === X.length - 1 && (ht = ge), ge--;
      }
      if (!Ot && ht === null)
        return null;
      var ut;
      if (Ot ? ut = ge : ut = ht, ut === 0)
        return le;
      var Wt = le.slice(ut), ie = Wt.reduce(function(fe, we) {
        return fe.byteLength += we.byteLength, fe.duration += we.duration, fe.nalCount += we.nalCount, fe;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return Wt.byteLength = ie.byteLength, Wt.duration = ie.duration, Wt.nalCount = ie.nalCount, Wt.pts = Wt[0].pts, Wt.dts = Wt[0].dts, Wt;
    }, this.alignGopsWith = function(le) {
      X = le;
    };
  }, gs.prototype = new t(), xo = function(A, O) {
    this.numberOfTracks = 0, this.metadataStream = O, A = A || {}, typeof A.remux < "u" ? this.remuxTracks = !!A.remux : this.remuxTracks = !0, typeof A.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = A.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, xo.prototype.init.call(this), this.push = function(k) {
      if (k.text)
        return this.pendingCaptions.push(k);
      if (k.frames)
        return this.pendingMetadata.push(k);
      this.pendingTracks.push(k.track), this.pendingBytes += k.boxes.byteLength, k.track.type === "video" && (this.videoTrack = k.track, this.pendingBoxes.push(k.boxes)), k.track.type === "audio" && (this.audioTrack = k.track, this.pendingBoxes.unshift(k.boxes));
    };
  }, xo.prototype = new t(), xo.prototype.flush = function(ee) {
    var A = 0, O = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, k, M, X, U = 0, ae;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (ee !== "VideoSegmentStream" && ee !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (U = this.videoTrack.timelineStartInfo.pts, Zs.forEach(function(le) {
      O.info[le] = this.videoTrack[le];
    }, this)) : this.audioTrack && (U = this.audioTrack.timelineStartInfo.pts, Fc.forEach(function(le) {
      O.info[le] = this.audioTrack[le];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? O.type = this.pendingTracks[0].type : O.type = "combined", this.emittedTracks += this.pendingTracks.length, X = Qe.initSegment(this.pendingTracks), O.initSegment = new Uint8Array(X.byteLength), O.initSegment.set(X), O.data = new Uint8Array(this.pendingBytes), ae = 0; ae < this.pendingBoxes.length; ae++)
        O.data.set(this.pendingBoxes[ae], A), A += this.pendingBoxes[ae].byteLength;
      for (ae = 0; ae < this.pendingCaptions.length; ae++)
        k = this.pendingCaptions[ae], k.startTime = Se.metadataTsToSeconds(k.startPts, U, this.keepOriginalTimestamps), k.endTime = Se.metadataTsToSeconds(k.endPts, U, this.keepOriginalTimestamps), O.captionStreams[k.stream] = !0, O.captions.push(k);
      for (ae = 0; ae < this.pendingMetadata.length; ae++)
        M = this.pendingMetadata[ae], M.cueTime = Se.metadataTsToSeconds(M.pts, U, this.keepOriginalTimestamps), O.metadata.push(M);
      for (O.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", O), ae = 0; ae < O.captions.length; ae++)
        k = O.captions[ae], this.trigger("caption", k);
      for (ae = 0; ae < O.metadata.length; ae++)
        M = O.metadata[ae], this.trigger("id3Frame", M);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, xo.prototype.setRemux = function(ee) {
    this.remuxTracks = ee;
  }, $l = function(A) {
    var O = this, k = !0, M, X;
    $l.prototype.init.call(this), A = A || {}, this.baseMediaDecodeTime = A.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var U = {};
      this.transmuxPipeline_ = U, U.type = "aac", U.metadataStream = new ka.MetadataStream(), U.aacStream = new D2(), U.audioTimestampRolloverStream = new ka.TimestampRolloverStream("audio"), U.timedMetadataTimestampRolloverStream = new ka.TimestampRolloverStream("timed-metadata"), U.adtsStream = new Yf(), U.coalesceStream = new xo(A, U.metadataStream), U.headOfPipeline = U.aacStream, U.aacStream.pipe(U.audioTimestampRolloverStream).pipe(U.adtsStream), U.aacStream.pipe(U.timedMetadataTimestampRolloverStream).pipe(U.metadataStream).pipe(U.coalesceStream), U.metadataStream.on("timestamp", function(ae) {
        U.aacStream.setTimestamp(ae.timeStamp);
      }), U.aacStream.on("data", function(ae) {
        ae.type !== "timed-metadata" && ae.type !== "audio" || U.audioSegmentStream || (X = X || {
          timelineStartInfo: {
            baseMediaDecodeTime: O.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, U.coalesceStream.numberOfTracks++, U.audioSegmentStream = new Za(X, A), U.audioSegmentStream.on("log", O.getLogTrigger_("audioSegmentStream")), U.audioSegmentStream.on("timingInfo", O.trigger.bind(O, "audioTimingInfo")), U.adtsStream.pipe(U.audioSegmentStream).pipe(U.coalesceStream), O.trigger("trackinfo", {
          hasAudio: !!X,
          hasVideo: !!M
        }));
      }), U.coalesceStream.on("data", this.trigger.bind(this, "data")), U.coalesceStream.on("done", this.trigger.bind(this, "done")), ys(this, U);
    }, this.setupTsPipeline = function() {
      var U = {};
      this.transmuxPipeline_ = U, U.type = "ts", U.metadataStream = new ka.MetadataStream(), U.packetStream = new ka.TransportPacketStream(), U.parseStream = new ka.TransportParseStream(), U.elementaryStream = new ka.ElementaryStream(), U.timestampRolloverStream = new ka.TimestampRolloverStream(), U.adtsStream = new Yf(), U.h264Stream = new r1(), U.captionStream = new ka.CaptionStream(A), U.coalesceStream = new xo(A, U.metadataStream), U.headOfPipeline = U.packetStream, U.packetStream.pipe(U.parseStream).pipe(U.elementaryStream).pipe(U.timestampRolloverStream), U.timestampRolloverStream.pipe(U.h264Stream), U.timestampRolloverStream.pipe(U.adtsStream), U.timestampRolloverStream.pipe(U.metadataStream).pipe(U.coalesceStream), U.h264Stream.pipe(U.captionStream).pipe(U.coalesceStream), U.elementaryStream.on("data", function(ae) {
        var le;
        if (ae.type === "metadata") {
          for (le = ae.tracks.length; le--; )
            !M && ae.tracks[le].type === "video" ? (M = ae.tracks[le], M.timelineStartInfo.baseMediaDecodeTime = O.baseMediaDecodeTime) : !X && ae.tracks[le].type === "audio" && (X = ae.tracks[le], X.timelineStartInfo.baseMediaDecodeTime = O.baseMediaDecodeTime);
          M && !U.videoSegmentStream && (U.coalesceStream.numberOfTracks++, U.videoSegmentStream = new gs(M, A), U.videoSegmentStream.on("log", O.getLogTrigger_("videoSegmentStream")), U.videoSegmentStream.on("timelineStartInfo", function(be) {
            X && !A.keepOriginalTimestamps && (X.timelineStartInfo = be, U.audioSegmentStream.setEarliestDts(be.dts - O.baseMediaDecodeTime));
          }), U.videoSegmentStream.on("processedGopsInfo", O.trigger.bind(O, "gopInfo")), U.videoSegmentStream.on("segmentTimingInfo", O.trigger.bind(O, "videoSegmentTimingInfo")), U.videoSegmentStream.on("baseMediaDecodeTime", function(be) {
            X && U.audioSegmentStream.setVideoBaseMediaDecodeTime(be);
          }), U.videoSegmentStream.on("timingInfo", O.trigger.bind(O, "videoTimingInfo")), U.h264Stream.pipe(U.videoSegmentStream).pipe(U.coalesceStream)), X && !U.audioSegmentStream && (U.coalesceStream.numberOfTracks++, U.audioSegmentStream = new Za(X, A), U.audioSegmentStream.on("log", O.getLogTrigger_("audioSegmentStream")), U.audioSegmentStream.on("timingInfo", O.trigger.bind(O, "audioTimingInfo")), U.audioSegmentStream.on("segmentTimingInfo", O.trigger.bind(O, "audioSegmentTimingInfo")), U.adtsStream.pipe(U.audioSegmentStream).pipe(U.coalesceStream)), O.trigger("trackinfo", {
            hasAudio: !!X,
            hasVideo: !!M
          });
        }
      }), U.coalesceStream.on("data", this.trigger.bind(this, "data")), U.coalesceStream.on("id3Frame", function(ae) {
        ae.dispatchType = U.metadataStream.dispatchType, O.trigger("id3Frame", ae);
      }), U.coalesceStream.on("caption", this.trigger.bind(this, "caption")), U.coalesceStream.on("done", this.trigger.bind(this, "done")), ys(this, U);
    }, this.setBaseMediaDecodeTime = function(U) {
      var ae = this.transmuxPipeline_;
      A.keepOriginalTimestamps || (this.baseMediaDecodeTime = U), X && (X.timelineStartInfo.dts = void 0, X.timelineStartInfo.pts = void 0, ii.clearDtsInfo(X), ae.audioTimestampRolloverStream && ae.audioTimestampRolloverStream.discontinuity()), M && (ae.videoSegmentStream && (ae.videoSegmentStream.gopCache_ = []), M.timelineStartInfo.dts = void 0, M.timelineStartInfo.pts = void 0, ii.clearDtsInfo(M), ae.captionStream.reset()), ae.timestampRolloverStream && ae.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(U) {
      X && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(U);
    }, this.setRemux = function(U) {
      var ae = this.transmuxPipeline_;
      A.remux = U, ae && ae.coalesceStream && ae.coalesceStream.setRemux(U);
    }, this.alignGopsWith = function(U) {
      M && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(U);
    }, this.getLogTrigger_ = function(U) {
      var ae = this;
      return function(le) {
        le.stream = U, ae.trigger("log", le);
      };
    }, this.push = function(U) {
      if (k) {
        var ae = Xc(U);
        ae && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !ae && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), k = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(U);
    }, this.flush = function() {
      k = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, $l.prototype = new t();
  var I2 = {
    Transmuxer: $l,
    VideoSegmentStream: gs,
    AudioSegmentStream: Za,
    AUDIO_PROPERTIES: Fc,
    VIDEO_PROPERTIES: Zs,
    generateSegmentTimingInfo: Js
  }, L2 = function(A) {
    return A >>> 0;
  }, B2 = function(A) {
    return ("00" + A.toString(16)).slice(-2);
  }, g = {
    toUnsigned: L2,
    toHexString: B2
  }, w = function(A) {
    var O = "";
    return O += String.fromCharCode(A[0]), O += String.fromCharCode(A[1]), O += String.fromCharCode(A[2]), O += String.fromCharCode(A[3]), O;
  }, z = w, I = g.toUnsigned, _ = function ee(A, O) {
    var k = [], M, X, U, ae, le;
    if (!O.length)
      return null;
    for (M = 0; M < A.byteLength; )
      X = I(A[M] << 24 | A[M + 1] << 16 | A[M + 2] << 8 | A[M + 3]), U = z(A.subarray(M + 4, M + 8)), ae = X > 1 ? M + X : A.byteLength, U === O[0] && (O.length === 1 ? k.push(A.subarray(M + 8, ae)) : (le = ee(A.subarray(M + 8, ae), O.slice(1)), le.length && (k = k.concat(le)))), M = ae;
    return k;
  }, W = _, ne = g.toUnsigned, me = i.getUint64, ye = function(A) {
    var O = {
      version: A[0],
      flags: new Uint8Array(A.subarray(1, 4))
    };
    return O.version === 1 ? O.baseMediaDecodeTime = me(A.subarray(4)) : O.baseMediaDecodeTime = ne(A[4] << 24 | A[5] << 16 | A[6] << 8 | A[7]), O;
  }, Oe = ye, Xe = function(A) {
    return {
      isLeading: (A[0] & 12) >>> 2,
      dependsOn: A[0] & 3,
      isDependedOn: (A[1] & 192) >>> 6,
      hasRedundancy: (A[1] & 48) >>> 4,
      paddingValue: (A[1] & 14) >>> 1,
      isNonSyncSample: A[1] & 1,
      degradationPriority: A[2] << 8 | A[3]
    };
  }, it = Xe, Be = function(A) {
    var O = {
      version: A[0],
      flags: new Uint8Array(A.subarray(1, 4)),
      samples: []
    }, k = new DataView(A.buffer, A.byteOffset, A.byteLength), M = O.flags[2] & 1, X = O.flags[2] & 4, U = O.flags[1] & 1, ae = O.flags[1] & 2, le = O.flags[1] & 4, be = O.flags[1] & 8, ge = k.getUint32(4), xe = 8, qe;
    for (M && (O.dataOffset = k.getInt32(xe), xe += 4), X && ge && (qe = {
      flags: it(A.subarray(xe, xe + 4))
    }, xe += 4, U && (qe.duration = k.getUint32(xe), xe += 4), ae && (qe.size = k.getUint32(xe), xe += 4), be && (O.version === 1 ? qe.compositionTimeOffset = k.getInt32(xe) : qe.compositionTimeOffset = k.getUint32(xe), xe += 4), O.samples.push(qe), ge--); ge--; )
      qe = {}, U && (qe.duration = k.getUint32(xe), xe += 4), ae && (qe.size = k.getUint32(xe), xe += 4), le && (qe.flags = it(A.subarray(xe, xe + 4)), xe += 4), be && (O.version === 1 ? qe.compositionTimeOffset = k.getInt32(xe) : qe.compositionTimeOffset = k.getUint32(xe), xe += 4), O.samples.push(qe);
    return O;
  }, _e = Be, Xt = function(A) {
    var O = new DataView(A.buffer, A.byteOffset, A.byteLength), k = {
      version: A[0],
      flags: new Uint8Array(A.subarray(1, 4)),
      trackId: O.getUint32(4)
    }, M = k.flags[2] & 1, X = k.flags[2] & 2, U = k.flags[2] & 8, ae = k.flags[2] & 16, le = k.flags[2] & 32, be = k.flags[0] & 65536, ge = k.flags[0] & 131072, xe;
    return xe = 8, M && (xe += 4, k.baseDataOffset = O.getUint32(12), xe += 4), X && (k.sampleDescriptionIndex = O.getUint32(xe), xe += 4), U && (k.defaultSampleDuration = O.getUint32(xe), xe += 4), ae && (k.defaultSampleSize = O.getUint32(xe), xe += 4), le && (k.defaultSampleFlags = O.getUint32(xe)), be && (k.durationIsEmpty = !0), !M && ge && (k.baseDataOffsetIsMoof = !0), k;
  }, en = Xt, Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Qn;
  typeof window < "u" ? Qn = window : typeof Ft < "u" ? Qn = Ft : typeof self < "u" ? Qn = self : Qn = {};
  var Kn = Qn, ur = na.discardEmulationPreventionBytes, Nn = Ws.CaptionStream, tn = function(A, O) {
    for (var k = A, M = 0; M < O.length; M++) {
      var X = O[M];
      if (k < X.size)
        return X;
      k -= X.size;
    }
    return null;
  }, Gi = function(A, O, k) {
    var M = new DataView(A.buffer, A.byteOffset, A.byteLength), X = {
      logs: [],
      seiNals: []
    }, U, ae, le, be;
    for (ae = 0; ae + 4 < A.length; ae += le)
      if (le = M.getUint32(ae), ae += 4, !(le <= 0))
        switch (A[ae] & 31) {
          case 6:
            var ge = A.subarray(ae + 1, ae + 1 + le), xe = tn(ae, O);
            if (U = {
              nalUnitType: "sei_rbsp",
              size: le,
              data: ge,
              escapedRBSP: ur(ge),
              trackId: k
            }, xe)
              U.pts = xe.pts, U.dts = xe.dts, be = xe;
            else if (be)
              U.pts = be.pts, U.dts = be.dts;
            else {
              X.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + ae + " for trackId " + k + ". See mux.js#223."
              });
              break;
            }
            X.seiNals.push(U);
            break;
        }
    return X;
  }, xn = function(A, O, k) {
    var M = O, X = k.defaultSampleDuration || 0, U = k.defaultSampleSize || 0, ae = k.trackId, le = [];
    return A.forEach(function(be) {
      var ge = _e(be), xe = ge.samples;
      xe.forEach(function(qe) {
        qe.duration === void 0 && (qe.duration = X), qe.size === void 0 && (qe.size = U), qe.trackId = ae, qe.dts = M, qe.compositionTimeOffset === void 0 && (qe.compositionTimeOffset = 0), typeof M == "bigint" ? (qe.pts = M + Kn.BigInt(qe.compositionTimeOffset), M += Kn.BigInt(qe.duration)) : (qe.pts = M + qe.compositionTimeOffset, M += qe.duration);
      }), le = le.concat(xe);
    }), le;
  }, Zn = function(A, O) {
    var k = W(A, ["moof", "traf"]), M = W(A, ["mdat"]), X = {}, U = [];
    return M.forEach(function(ae, le) {
      var be = k[le];
      U.push({
        mdat: ae,
        traf: be
      });
    }), U.forEach(function(ae) {
      var le = ae.mdat, be = ae.traf, ge = W(be, ["tfhd"]), xe = en(ge[0]), qe = xe.trackId, ht = W(be, ["tfdt"]), Ot = ht.length > 0 ? Oe(ht[0]).baseMediaDecodeTime : 0, ut = W(be, ["trun"]), Wt, ie;
      O === qe && ut.length > 0 && (Wt = xn(ut, Ot, xe), ie = Gi(le, Wt, qe), X[qe] || (X[qe] = {
        seiNals: [],
        logs: []
      }), X[qe].seiNals = X[qe].seiNals.concat(ie.seiNals), X[qe].logs = X[qe].logs.concat(ie.logs));
    }), X;
  }, $s = function(A, O, k) {
    var M;
    if (O === null)
      return null;
    M = Zn(A, O);
    var X = M[O] || {};
    return {
      seiNals: X.seiNals,
      logs: X.logs,
      timescale: k
    };
  }, eu = function() {
    var A = !1, O, k, M, X, U, ae;
    this.isInitialized = function() {
      return A;
    }, this.init = function(le) {
      O = new Nn(), A = !0, ae = le ? le.isPartial : !1, O.on("data", function(be) {
        be.startTime = be.startPts / X, be.endTime = be.endPts / X, U.captions.push(be), U.captionStreams[be.stream] = !0;
      }), O.on("log", function(be) {
        U.logs.push(be);
      });
    }, this.isNewInit = function(le, be) {
      return le && le.length === 0 || be && typeof be == "object" && Object.keys(be).length === 0 ? !1 : M !== le[0] || X !== be[M];
    }, this.parse = function(le, be, ge) {
      var xe;
      if (this.isInitialized()) {
        if (!be || !ge)
          return null;
        if (this.isNewInit(be, ge))
          M = be[0], X = ge[M];
        else if (M === null || !X)
          return k.push(le), null;
      } else
        return null;
      for (; k.length > 0; ) {
        var qe = k.shift();
        this.parse(qe, be, ge);
      }
      return xe = $s(le, M, X), xe && xe.logs && (U.logs = U.logs.concat(xe.logs)), xe === null || !xe.seiNals ? U.logs.length ? {
        logs: U.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(xe.seiNals), this.flushStream(), U);
    }, this.pushNals = function(le) {
      if (!this.isInitialized() || !le || le.length === 0)
        return null;
      le.forEach(function(be) {
        O.push(be);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      ae ? O.partialFlush() : O.flush();
    }, this.clearParsedCaptions = function() {
      U.captions = [], U.captionStreams = {}, U.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      O.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      k = [], M = null, X = null, U ? this.clearParsedCaptions() : U = {
        captions: [],
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, cr = eu, aa = g.toUnsigned, Fr = g.toHexString, Yi = i.getUint64, Oa, dr, za, Vc, Ja, el;
  Oa = function(A) {
    var O = {}, k = W(A, ["moov", "trak"]);
    return k.reduce(function(M, X) {
      var U, ae, le, be, ge;
      return U = W(X, ["tkhd"])[0], !U || (ae = U[0], le = ae === 0 ? 12 : 20, be = aa(U[le] << 24 | U[le + 1] << 16 | U[le + 2] << 8 | U[le + 3]), ge = W(X, ["mdia", "mdhd"])[0], !ge) ? null : (ae = ge[0], le = ae === 0 ? 12 : 20, M[be] = aa(ge[le] << 24 | ge[le + 1] << 16 | ge[le + 2] << 8 | ge[le + 3]), M);
    }, O);
  }, dr = function(A, O) {
    var k;
    k = W(O, ["moof", "traf"]);
    var M = k.reduce(function(X, U) {
      var ae = W(U, ["tfhd"])[0], le = aa(ae[4] << 24 | ae[5] << 16 | ae[6] << 8 | ae[7]), be = A[le] || 9e4, ge = W(U, ["tfdt"])[0], xe = new DataView(ge.buffer, ge.byteOffset, ge.byteLength), qe;
      ge[0] === 1 ? qe = Yi(ge.subarray(4, 12)) : qe = xe.getUint32(4);
      var ht;
      return typeof qe == "bigint" ? ht = qe / Kn.BigInt(be) : typeof qe == "number" && !isNaN(qe) && (ht = qe / be), ht < Number.MAX_SAFE_INTEGER && (ht = Number(ht)), ht < X && (X = ht), X;
    }, 1 / 0);
    return typeof M == "bigint" || isFinite(M) ? M : 0;
  }, za = function(A, O) {
    var k = W(O, ["moof", "traf"]), M = 0, X = 0, U;
    if (k && k.length) {
      var ae = W(k[0], ["tfhd"])[0], le = W(k[0], ["trun"])[0], be = W(k[0], ["tfdt"])[0];
      if (ae) {
        var ge = en(ae);
        U = ge.trackId;
      }
      if (be) {
        var xe = Oe(be);
        M = xe.baseMediaDecodeTime;
      }
      if (le) {
        var qe = _e(le);
        qe.samples && qe.samples.length && (X = qe.samples[0].compositionTimeOffset || 0);
      }
    }
    var ht = A[U] || 9e4;
    typeof M == "bigint" && (X = Kn.BigInt(X), ht = Kn.BigInt(ht));
    var Ot = (M + X) / ht;
    return typeof Ot == "bigint" && Ot < Number.MAX_SAFE_INTEGER && (Ot = Number(Ot)), Ot;
  }, Vc = function(A) {
    var O = W(A, ["moov", "trak"]), k = [];
    return O.forEach(function(M) {
      var X = W(M, ["mdia", "hdlr"]), U = W(M, ["tkhd"]);
      X.forEach(function(ae, le) {
        var be = z(ae.subarray(8, 12)), ge = U[le], xe, qe, ht;
        be === "vide" && (xe = new DataView(ge.buffer, ge.byteOffset, ge.byteLength), qe = xe.getUint8(0), ht = qe === 0 ? xe.getUint32(12) : xe.getUint32(20), k.push(ht));
      });
    }), k;
  }, el = function(A) {
    var O = A[0], k = O === 0 ? 12 : 20;
    return aa(A[k] << 24 | A[k + 1] << 16 | A[k + 2] << 8 | A[k + 3]);
  }, Ja = function(A) {
    var O = W(A, ["moov", "trak"]), k = [];
    return O.forEach(function(M) {
      var X = {}, U = W(M, ["tkhd"])[0], ae, le;
      U && (ae = new DataView(U.buffer, U.byteOffset, U.byteLength), le = ae.getUint8(0), X.id = le === 0 ? ae.getUint32(12) : ae.getUint32(20));
      var be = W(M, ["mdia", "hdlr"])[0];
      if (be) {
        var ge = z(be.subarray(8, 12));
        ge === "vide" ? X.type = "video" : ge === "soun" ? X.type = "audio" : X.type = ge;
      }
      var xe = W(M, ["mdia", "minf", "stbl", "stsd"])[0];
      if (xe) {
        var qe = xe.subarray(8);
        X.codec = z(qe.subarray(4, 8));
        var ht = W(qe, [X.codec])[0], Ot, ut;
        ht && (/^[asm]vc[1-9]$/i.test(X.codec) ? (Ot = ht.subarray(78), ut = z(Ot.subarray(4, 8)), ut === "avcC" && Ot.length > 11 ? (X.codec += ".", X.codec += Fr(Ot[9]), X.codec += Fr(Ot[10]), X.codec += Fr(Ot[11])) : X.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(X.codec) ? (Ot = ht.subarray(28), ut = z(Ot.subarray(4, 8)), ut === "esds" && Ot.length > 20 && Ot[19] !== 0 ? (X.codec += "." + Fr(Ot[19]), X.codec += "." + Fr(Ot[20] >>> 2 & 63).replace(/^0/, "")) : X.codec = "mp4a.40.2") : X.codec = X.codec.toLowerCase());
      }
      var Wt = W(M, ["mdia", "mdhd"])[0];
      Wt && (X.timescale = el(Wt)), k.push(X);
    }), k;
  };
  var zn = {
    findBox: W,
    parseType: z,
    timescale: Oa,
    startTime: dr,
    compositionStartTime: za,
    videoTrackIds: Vc,
    tracks: Ja,
    getTimescaleFromMediaHeader: el
  }, $a = function(A) {
    var O = A[1] & 31;
    return O <<= 8, O |= A[2], O;
  }, tl = function(A) {
    return !!(A[1] & 64);
  }, bs = function(A) {
    var O = 0;
    return (A[3] & 48) >>> 4 > 1 && (O += A[4] + 1), O;
  }, N2 = function(A, O) {
    var k = $a(A);
    return k === 0 ? "pat" : k === O ? "pmt" : O ? "pes" : null;
  }, tu = function(A) {
    var O = tl(A), k = 4 + bs(A);
    return O && (k += A[k] + 1), (A[k + 10] & 31) << 8 | A[k + 11];
  }, j2 = function(A) {
    var O = {}, k = tl(A), M = 4 + bs(A);
    if (k && (M += A[M] + 1), !!(A[M + 5] & 1)) {
      var X, U, ae;
      X = (A[M + 1] & 15) << 8 | A[M + 2], U = 3 + X - 4, ae = (A[M + 10] & 15) << 8 | A[M + 11];
      for (var le = 12 + ae; le < U; ) {
        var be = M + le;
        O[(A[be + 1] & 31) << 8 | A[be + 2]] = A[be], le += ((A[be + 3] & 15) << 8 | A[be + 4]) + 5;
      }
      return O;
    }
  }, o1 = function(A, O) {
    var k = $a(A), M = O[k];
    switch (M) {
      case Pi.H264_STREAM_TYPE:
        return "video";
      case Pi.ADTS_STREAM_TYPE:
        return "audio";
      case Pi.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, F2 = function(A) {
    var O = tl(A);
    if (!O)
      return null;
    var k = 4 + bs(A);
    if (k >= A.byteLength)
      return null;
    var M = null, X;
    return X = A[k + 7], X & 192 && (M = {}, M.pts = (A[k + 9] & 14) << 27 | (A[k + 10] & 255) << 20 | (A[k + 11] & 254) << 12 | (A[k + 12] & 255) << 5 | (A[k + 13] & 254) >>> 3, M.pts *= 4, M.pts += (A[k + 13] & 6) >>> 1, M.dts = M.pts, X & 64 && (M.dts = (A[k + 14] & 14) << 27 | (A[k + 15] & 255) << 20 | (A[k + 16] & 254) << 12 | (A[k + 17] & 255) << 5 | (A[k + 18] & 254) >>> 3, M.dts *= 4, M.dts += (A[k + 18] & 6) >>> 1)), M;
  }, Uc = function(A) {
    switch (A) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, X2 = function(A) {
    for (var O = 4 + bs(A), k = A.subarray(O), M = 0, X = 0, U = !1, ae; X < k.byteLength - 3; X++)
      if (k[X + 2] === 1) {
        M = X + 5;
        break;
      }
    for (; M < k.byteLength; )
      switch (k[M]) {
        case 0:
          if (k[M - 1] !== 0) {
            M += 2;
            break;
          } else if (k[M - 2] !== 0) {
            M++;
            break;
          }
          X + 3 !== M - 2 && (ae = Uc(k[X + 3] & 31), ae === "slice_layer_without_partitioning_rbsp_idr" && (U = !0));
          do
            M++;
          while (k[M] !== 1 && M < k.length);
          X = M - 2, M += 3;
          break;
        case 1:
          if (k[M - 1] !== 0 || k[M - 2] !== 0) {
            M += 3;
            break;
          }
          ae = Uc(k[X + 3] & 31), ae === "slice_layer_without_partitioning_rbsp_idr" && (U = !0), X = M - 2, M += 3;
          break;
        default:
          M += 3;
          break;
      }
    return k = k.subarray(X), M -= X, X = 0, k && k.byteLength > 3 && (ae = Uc(k[X + 3] & 31), ae === "slice_layer_without_partitioning_rbsp_idr" && (U = !0)), U;
  }, nu = {
    parseType: N2,
    parsePat: tu,
    parsePmt: j2,
    parsePayloadUnitStartIndicator: tl,
    parsePesType: o1,
    parsePesTime: F2,
    videoPacketContainsKeyFrame: X2
  }, As = Hc.handleRollover, Hn = {};
  Hn.ts = nu, Hn.aac = Zl;
  var Co = Se.ONE_SECOND_IN_TS, pi = 188, oa = 71, qc = function(A, O) {
    for (var k = 0, M = pi, X, U; M < A.byteLength; ) {
      if (A[k] === oa && A[M] === oa) {
        switch (X = A.subarray(k, M), U = Hn.ts.parseType(X, O.pid), U) {
          case "pat":
            O.pid = Hn.ts.parsePat(X);
            break;
          case "pmt":
            var ae = Hn.ts.parsePmt(X);
            O.table = O.table || {}, Object.keys(ae).forEach(function(le) {
              O.table[le] = ae[le];
            });
            break;
        }
        k += pi, M += pi;
        continue;
      }
      k++, M++;
    }
  }, sa = function(A, O, k) {
    for (var M = 0, X = pi, U, ae, le, be, ge, xe = !1; X <= A.byteLength; ) {
      if (A[M] === oa && (A[X] === oa || X === A.byteLength)) {
        switch (U = A.subarray(M, X), ae = Hn.ts.parseType(U, O.pid), ae) {
          case "pes":
            le = Hn.ts.parsePesType(U, O.table), be = Hn.ts.parsePayloadUnitStartIndicator(U), le === "audio" && be && (ge = Hn.ts.parsePesTime(U), ge && (ge.type = "audio", k.audio.push(ge), xe = !0));
            break;
        }
        if (xe)
          break;
        M += pi, X += pi;
        continue;
      }
      M++, X++;
    }
    for (X = A.byteLength, M = X - pi, xe = !1; M >= 0; ) {
      if (A[M] === oa && (A[X] === oa || X === A.byteLength)) {
        switch (U = A.subarray(M, X), ae = Hn.ts.parseType(U, O.pid), ae) {
          case "pes":
            le = Hn.ts.parsePesType(U, O.table), be = Hn.ts.parsePayloadUnitStartIndicator(U), le === "audio" && be && (ge = Hn.ts.parsePesTime(U), ge && (ge.type = "audio", k.audio.push(ge), xe = !0));
            break;
        }
        if (xe)
          break;
        M -= pi, X -= pi;
        continue;
      }
      M--, X--;
    }
  }, Da = function(A, O, k) {
    for (var M = 0, X = pi, U, ae, le, be, ge, xe, qe, ht, Ot = !1, ut = {
      data: [],
      size: 0
    }; X < A.byteLength; ) {
      if (A[M] === oa && A[X] === oa) {
        switch (U = A.subarray(M, X), ae = Hn.ts.parseType(U, O.pid), ae) {
          case "pes":
            if (le = Hn.ts.parsePesType(U, O.table), be = Hn.ts.parsePayloadUnitStartIndicator(U), le === "video" && (be && !Ot && (ge = Hn.ts.parsePesTime(U), ge && (ge.type = "video", k.video.push(ge), Ot = !0)), !k.firstKeyFrame)) {
              if (be && ut.size !== 0) {
                for (xe = new Uint8Array(ut.size), qe = 0; ut.data.length; )
                  ht = ut.data.shift(), xe.set(ht, qe), qe += ht.byteLength;
                if (Hn.ts.videoPacketContainsKeyFrame(xe)) {
                  var Wt = Hn.ts.parsePesTime(xe);
                  Wt ? (k.firstKeyFrame = Wt, k.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                ut.size = 0;
              }
              ut.data.push(U), ut.size += U.byteLength;
            }
            break;
        }
        if (Ot && k.firstKeyFrame)
          break;
        M += pi, X += pi;
        continue;
      }
      M++, X++;
    }
    for (X = A.byteLength, M = X - pi, Ot = !1; M >= 0; ) {
      if (A[M] === oa && A[X] === oa) {
        switch (U = A.subarray(M, X), ae = Hn.ts.parseType(U, O.pid), ae) {
          case "pes":
            le = Hn.ts.parsePesType(U, O.table), be = Hn.ts.parsePayloadUnitStartIndicator(U), le === "video" && be && (ge = Hn.ts.parsePesTime(U), ge && (ge.type = "video", k.video.push(ge), Ot = !0));
            break;
        }
        if (Ot)
          break;
        M -= pi, X -= pi;
        continue;
      }
      M--, X--;
    }
  }, s1 = function(A, O) {
    if (A.audio && A.audio.length) {
      var k = O;
      (typeof k > "u" || isNaN(k)) && (k = A.audio[0].dts), A.audio.forEach(function(U) {
        U.dts = As(U.dts, k), U.pts = As(U.pts, k), U.dtsTime = U.dts / Co, U.ptsTime = U.pts / Co;
      });
    }
    if (A.video && A.video.length) {
      var M = O;
      if ((typeof M > "u" || isNaN(M)) && (M = A.video[0].dts), A.video.forEach(function(U) {
        U.dts = As(U.dts, M), U.pts = As(U.pts, M), U.dtsTime = U.dts / Co, U.ptsTime = U.pts / Co;
      }), A.firstKeyFrame) {
        var X = A.firstKeyFrame;
        X.dts = As(X.dts, M), X.pts = As(X.pts, M), X.dtsTime = X.dts / Co, X.ptsTime = X.pts / Co;
      }
    }
  }, l1 = function(A) {
    for (var O = !1, k = 0, M = null, X = null, U = 0, ae = 0, le; A.length - ae >= 3; ) {
      var be = Hn.aac.parseType(A, ae);
      switch (be) {
        case "timed-metadata":
          if (A.length - ae < 10) {
            O = !0;
            break;
          }
          if (U = Hn.aac.parseId3TagSize(A, ae), U > A.length) {
            O = !0;
            break;
          }
          X === null && (le = A.subarray(ae, ae + U), X = Hn.aac.parseAacTimestamp(le)), ae += U;
          break;
        case "audio":
          if (A.length - ae < 7) {
            O = !0;
            break;
          }
          if (U = Hn.aac.parseAdtsSize(A, ae), U > A.length) {
            O = !0;
            break;
          }
          M === null && (le = A.subarray(ae, ae + U), M = Hn.aac.parseSampleRate(le)), k++, ae += U;
          break;
        default:
          ae++;
          break;
      }
      if (O)
        return null;
    }
    if (M === null || X === null)
      return null;
    var ge = Co / M, xe = {
      audio: [{
        type: "audio",
        dts: X,
        pts: X
      }, {
        type: "audio",
        dts: X + k * 1024 * ge,
        pts: X + k * 1024 * ge
      }]
    };
    return xe;
  }, u1 = function(A) {
    var O = {
      pid: null,
      table: null
    }, k = {};
    qc(A, O);
    for (var M in O.table)
      if (O.table.hasOwnProperty(M)) {
        var X = O.table[M];
        switch (X) {
          case Pi.H264_STREAM_TYPE:
            k.video = [], Da(A, O, k), k.video.length === 0 && delete k.video;
            break;
          case Pi.ADTS_STREAM_TYPE:
            k.audio = [], sa(A, O, k), k.audio.length === 0 && delete k.audio;
            break;
        }
      }
    return k;
  }, R2 = function(A, O) {
    var k = Hn.aac.isLikelyAacData(A), M;
    return k ? M = l1(A) : M = u1(A), !M || !M.audio && !M.video ? null : (s1(M, O), M);
  }, Rn = {
    inspect: R2,
    parseAudioPes_: sa
  }, iu = function(A, O) {
    O.on("data", function(k) {
      var M = k.initSegment;
      k.initSegment = {
        data: M.buffer,
        byteOffset: M.byteOffset,
        byteLength: M.byteLength
      };
      var X = k.data;
      k.data = X.buffer, A.postMessage({
        action: "data",
        segment: k,
        byteOffset: X.byteOffset,
        byteLength: X.byteLength
      }, [k.data]);
    }), O.on("done", function(k) {
      A.postMessage({
        action: "done"
      });
    }), O.on("gopInfo", function(k) {
      A.postMessage({
        action: "gopInfo",
        gopInfo: k
      });
    }), O.on("videoSegmentTimingInfo", function(k) {
      var M = {
        start: {
          decode: Se.videoTsToSeconds(k.start.dts),
          presentation: Se.videoTsToSeconds(k.start.pts)
        },
        end: {
          decode: Se.videoTsToSeconds(k.end.dts),
          presentation: Se.videoTsToSeconds(k.end.pts)
        },
        baseMediaDecodeTime: Se.videoTsToSeconds(k.baseMediaDecodeTime)
      };
      k.prependedContentDuration && (M.prependedContentDuration = Se.videoTsToSeconds(k.prependedContentDuration)), A.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: M
      });
    }), O.on("audioSegmentTimingInfo", function(k) {
      var M = {
        start: {
          decode: Se.videoTsToSeconds(k.start.dts),
          presentation: Se.videoTsToSeconds(k.start.pts)
        },
        end: {
          decode: Se.videoTsToSeconds(k.end.dts),
          presentation: Se.videoTsToSeconds(k.end.pts)
        },
        baseMediaDecodeTime: Se.videoTsToSeconds(k.baseMediaDecodeTime)
      };
      k.prependedContentDuration && (M.prependedContentDuration = Se.videoTsToSeconds(k.prependedContentDuration)), A.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: M
      });
    }), O.on("id3Frame", function(k) {
      A.postMessage({
        action: "id3Frame",
        id3Frame: k
      });
    }), O.on("caption", function(k) {
      A.postMessage({
        action: "caption",
        caption: k
      });
    }), O.on("trackinfo", function(k) {
      A.postMessage({
        action: "trackinfo",
        trackInfo: k
      });
    }), O.on("audioTimingInfo", function(k) {
      A.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: Se.videoTsToSeconds(k.start),
          end: Se.videoTsToSeconds(k.end)
        }
      });
    }), O.on("videoTimingInfo", function(k) {
      A.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: Se.videoTsToSeconds(k.start),
          end: Se.videoTsToSeconds(k.end)
        }
      });
    }), O.on("log", function(k) {
      A.postMessage({
        action: "log",
        log: k
      });
    });
  }, Cr = /* @__PURE__ */ function() {
    function ee(O, k) {
      this.options = k || {}, this.self = O, this.init();
    }
    var A = ee.prototype;
    return A.init = function() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new I2.Transmuxer(this.options), iu(this.self, this.transmuxer);
    }, A.pushMp4Captions = function(k) {
      this.captionParser || (this.captionParser = new cr(), this.captionParser.init());
      var M = new Uint8Array(k.data, k.byteOffset, k.byteLength), X = this.captionParser.parse(M, k.trackIds, k.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: X && X.captions || [],
        logs: X && X.logs || [],
        data: M.buffer
      }, [M.buffer]);
    }, A.probeMp4StartTime = function(k) {
      var M = k.timescales, X = k.data, U = zn.startTime(M, X);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: U,
        data: X
      }, [X.buffer]);
    }, A.probeMp4Tracks = function(k) {
      var M = k.data, X = zn.tracks(M);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: X,
        data: M
      }, [M.buffer]);
    }, A.probeTs = function(k) {
      var M = k.data, X = k.baseStartTime, U = typeof X == "number" && !isNaN(X) ? X * Se.ONE_SECOND_IN_TS : void 0, ae = Rn.inspect(M, U), le = null;
      ae && (le = {
        hasVideo: ae.video && ae.video.length === 2 || !1,
        hasAudio: ae.audio && ae.audio.length === 2 || !1
      }, le.hasVideo && (le.videoStart = ae.video[0].ptsTime), le.hasAudio && (le.audioStart = ae.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: le,
        data: M
      }, [M.buffer]);
    }, A.clearAllMp4Captions = function() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }, A.clearParsedMp4Captions = function() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }, A.push = function(k) {
      var M = new Uint8Array(k.data, k.byteOffset, k.byteLength);
      this.transmuxer.push(M);
    }, A.reset = function() {
      this.transmuxer.reset();
    }, A.setTimestampOffset = function(k) {
      var M = k.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(Se.secondsToVideoTs(M)));
    }, A.setAudioAppendStart = function(k) {
      this.transmuxer.setAudioAppendStart(Math.ceil(Se.secondsToVideoTs(k.appendStart)));
    }, A.setRemux = function(k) {
      this.transmuxer.setRemux(k.remux);
    }, A.flush = function(k) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }, A.endTimeline = function() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }, A.alignGopsWith = function(k) {
      this.transmuxer.alignGopsWith(k.gopsToAlignWith.slice());
    }, ee;
  }();
  self.onmessage = function(ee) {
    if (ee.data.action === "init" && ee.data.options) {
      this.messageHandlers = new Cr(self, ee.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new Cr(self)), ee.data && ee.data.action && ee.data.action !== "init" && this.messageHandlers[ee.data.action] && this.messageHandlers[ee.data.action](ee.data);
  };
})), Cue = wx(xue), Sue = function(t, n, r) {
  var i = t.data.segment, a = i.type, o = i.initSegment, s = i.captions, l = i.captionStreams, u = i.metadata, c = i.videoFrameDtsTime, f = i.videoFramePtsTime;
  n.buffer.push({
    captions: s,
    captionStreams: l,
    metadata: u
  });
  var d = t.data.segment.boxes || {
    data: t.data.segment.data
  }, h = {
    type: a,
    data: new Uint8Array(d.data, d.data.byteOffset, d.data.byteLength),
    initSegment: new Uint8Array(o.data, o.byteOffset, o.byteLength)
  };
  typeof c < "u" && (h.videoFrameDtsTime = c), typeof f < "u" && (h.videoFramePtsTime = f), r(h);
}, Eue = function(t) {
  var n = t.transmuxedData, r = t.callback;
  n.buffer = [], r(n);
}, kue = function(t, n) {
  n.gopInfo = t.data.gopInfo;
}, Cx = function(t) {
  var n = t.transmuxer, r = t.bytes, i = t.audioAppendStart, a = t.gopsToAlignWith, o = t.remux, s = t.onData, l = t.onTrackInfo, u = t.onAudioTimingInfo, c = t.onVideoTimingInfo, f = t.onVideoSegmentTimingInfo, d = t.onAudioSegmentTimingInfo, h = t.onId3, p = t.onCaptions, y = t.onDone, m = t.onEndedTimeline, b = t.onTransmuxerLog, x = t.isEndOfTimeline, D = {
    buffer: []
  }, S = x, C = function(R) {
    n.currentTransmux === t && (R.data.action === "data" && Sue(R, D, s), R.data.action === "trackinfo" && l(R.data.trackInfo), R.data.action === "gopInfo" && kue(R, D), R.data.action === "audioTimingInfo" && u(R.data.audioTimingInfo), R.data.action === "videoTimingInfo" && c(R.data.videoTimingInfo), R.data.action === "videoSegmentTimingInfo" && f(R.data.videoSegmentTimingInfo), R.data.action === "audioSegmentTimingInfo" && d(R.data.audioSegmentTimingInfo), R.data.action === "id3Frame" && h([R.data.id3Frame], R.data.id3Frame.dispatchType), R.data.action === "caption" && p(R.data.caption), R.data.action === "endedtimeline" && (S = !1, m()), R.data.action === "log" && b(R.data.log), R.data.type === "transmuxed" && (S || (n.onmessage = null, Eue({
      transmuxedData: D,
      callback: y
    }), Sx(n))));
  };
  if (n.onmessage = C, i && n.postMessage({
    action: "setAudioAppendStart",
    appendStart: i
  }), Array.isArray(a) && n.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: a
  }), typeof o < "u" && n.postMessage({
    action: "setRemux",
    remux: o
  }), r.byteLength) {
    var v = r instanceof ArrayBuffer ? r : r.buffer, H = r instanceof ArrayBuffer ? 0 : r.byteOffset;
    n.postMessage({
      action: "push",
      data: v,
      byteOffset: H,
      byteLength: r.byteLength
    }, [v]);
  }
  x && n.postMessage({
    action: "endTimeline"
  }), n.postMessage({
    action: "flush"
  });
}, Sx = function(t) {
  t.currentTransmux = null, t.transmuxQueue.length && (t.currentTransmux = t.transmuxQueue.shift(), typeof t.currentTransmux == "function" ? t.currentTransmux() : Cx(t.currentTransmux));
}, i9 = function(t, n) {
  t.postMessage({
    action: n
  }), Sx(t);
}, Ex = function(t, n) {
  if (!n.currentTransmux) {
    n.currentTransmux = t, i9(n, t);
    return;
  }
  n.transmuxQueue.push(i9.bind(null, n, t));
}, Oue = function(t) {
  Ex("reset", t);
}, zue = function(t) {
  Ex("endTimeline", t);
}, kx = function(t) {
  if (!t.transmuxer.currentTransmux) {
    t.transmuxer.currentTransmux = t, Cx(t);
    return;
  }
  t.transmuxer.transmuxQueue.push(t);
}, Due = function(t) {
  var n = new Cue();
  n.currentTransmux = null, n.transmuxQueue = [];
  var r = n.terminate;
  return n.terminate = function() {
    return n.currentTransmux = null, n.transmuxQueue.length = 0, r.call(n);
  }, n.postMessage({
    action: "init",
    options: t
  }), n;
}, Zp = {
  reset: Oue,
  endTimeline: zue,
  transmux: kx,
  createTransmuxer: Due
}, dh = function(t) {
  var n = t.transmuxer, r = t.endAction || t.action, i = t.callback, a = Ta({}, t, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), o = function u(c) {
    c.data.action === r && (n.removeEventListener("message", u), c.data.data && (c.data.data = new Uint8Array(c.data.data, t.byteOffset || 0, t.byteLength || c.data.data.byteLength), t.data && (t.data = c.data.data)), i(c.data));
  };
  if (n.addEventListener("message", o), t.data) {
    var s = t.data instanceof ArrayBuffer;
    a.byteOffset = s ? 0 : t.data.byteOffset, a.byteLength = t.data.byteLength;
    var l = [s ? t.data : t.data.buffer];
    n.postMessage(a, l);
  } else
    n.postMessage(a);
}, ao = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, D4 = function(t) {
  t.forEach(function(n) {
    n.abort();
  });
}, Mue = function(t) {
  return {
    bandwidth: t.bandwidth,
    bytesReceived: t.bytesReceived || 0,
    roundTripTime: t.roundTripTime || 0
  };
}, Hue = function(t) {
  var n = t.target, r = Date.now() - n.requestTime, i = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: r || 0
  };
  return i.bytesReceived = t.loaded, i.bandwidth = Math.floor(i.bytesReceived / i.roundTripTime * 8 * 1e3), i;
}, W6 = function(t, n) {
  return n.timedout ? {
    status: n.status,
    message: "HLS request timed-out at URL: " + n.uri,
    code: ao.TIMEOUT,
    xhr: n
  } : n.aborted ? {
    status: n.status,
    message: "HLS request aborted at URL: " + n.uri,
    code: ao.ABORTED,
    xhr: n
  } : t ? {
    status: n.status,
    message: "HLS request errored at URL: " + n.uri,
    code: ao.FAILURE,
    xhr: n
  } : n.responseType === "arraybuffer" && n.response.byteLength === 0 ? {
    status: n.status,
    message: "Empty HLS response at URL: " + n.uri,
    code: ao.FAILURE,
    xhr: n
  } : null;
}, r9 = function(t, n, r) {
  return function(i, a) {
    var o = a.response, s = W6(i, a);
    if (s)
      return r(s, t);
    if (o.byteLength !== 16)
      return r({
        status: a.status,
        message: "Invalid HLS key at URL: " + a.uri,
        code: ao.FAILURE,
        xhr: a
      }, t);
    for (var l = new DataView(o), u = new Uint32Array([l.getUint32(0), l.getUint32(4), l.getUint32(8), l.getUint32(12)]), c = 0; c < n.length; c++)
      n[c].bytes = u;
    return r(null, t);
  };
}, Ox = function(t, n) {
  var r = s6(t.map.bytes);
  if (r !== "mp4") {
    var i = t.map.resolvedUri || t.map.uri;
    return n({
      internal: !0,
      message: "Found unsupported " + (r || "unknown") + " container for initialization segment at URL: " + i,
      code: ao.FAILURE
    });
  }
  dh({
    action: "probeMp4Tracks",
    data: t.map.bytes,
    transmuxer: t.transmuxer,
    callback: function(o) {
      var s = o.tracks, l = o.data;
      return t.map.bytes = l, s.forEach(function(u) {
        t.map.tracks = t.map.tracks || {}, !t.map.tracks[u.type] && (t.map.tracks[u.type] = u, typeof u.id == "number" && u.timescale && (t.map.timescales = t.map.timescales || {}, t.map.timescales[u.id] = u.timescale));
      }), n(null);
    }
  });
}, Iue = function(t) {
  var n = t.segment, r = t.finishProcessingFn;
  return function(i, a) {
    var o = W6(i, a);
    if (o)
      return r(o, n);
    var s = new Uint8Array(a.response);
    if (n.map.key)
      return n.map.encryptedBytes = s, r(null, n);
    n.map.bytes = s, Ox(n, function(l) {
      if (l)
        return l.xhr = a, l.status = a.status, r(l, n);
      r(null, n);
    });
  };
}, Lue = function(t) {
  var n = t.segment, r = t.finishProcessingFn, i = t.responseType;
  return function(a, o) {
    var s = W6(a, o);
    if (s)
      return r(s, n);
    var l = i === "arraybuffer" || !o.responseText ? o.response : wue(o.responseText.substring(n.lastReachedChar || 0));
    return n.stats = Mue(o), n.key ? n.encryptedBytes = new Uint8Array(l) : n.bytes = new Uint8Array(l), r(null, n);
  };
}, Bue = function(t) {
  var n = t.segment, r = t.bytes, i = t.trackInfoFn, a = t.timingInfoFn, o = t.videoSegmentTimingInfoFn, s = t.audioSegmentTimingInfoFn, l = t.id3Fn, u = t.captionsFn, c = t.isEndOfTimeline, f = t.endedTimelineFn, d = t.dataFn, h = t.doneFn, p = t.onTransmuxerLog, y = n.map && n.map.tracks || {}, m = Boolean(y.audio && y.video), b = a.bind(null, n, "audio", "start"), x = a.bind(null, n, "audio", "end"), D = a.bind(null, n, "video", "start"), S = a.bind(null, n, "video", "end"), C = function() {
    return kx({
      bytes: r,
      transmuxer: n.transmuxer,
      audioAppendStart: n.audioAppendStart,
      gopsToAlignWith: n.gopsToAlignWith,
      remux: m,
      onData: function(V) {
        V.type = V.type === "combined" ? "video" : V.type, d(n, V);
      },
      onTrackInfo: function(V) {
        i && (m && (V.isMuxed = !0), i(n, V));
      },
      onAudioTimingInfo: function(V) {
        b && typeof V.start < "u" && (b(V.start), b = null), x && typeof V.end < "u" && x(V.end);
      },
      onVideoTimingInfo: function(V) {
        D && typeof V.start < "u" && (D(V.start), D = null), S && typeof V.end < "u" && S(V.end);
      },
      onVideoSegmentTimingInfo: function(V) {
        o(V);
      },
      onAudioSegmentTimingInfo: function(V) {
        s(V);
      },
      onId3: function(V, R) {
        l(n, V, R);
      },
      onCaptions: function(V) {
        u(n, [V]);
      },
      isEndOfTimeline: c,
      onEndedTimeline: function() {
        f();
      },
      onTransmuxerLog: p,
      onDone: function(V) {
        !h || (V.type = V.type === "combined" ? "video" : V.type, h(null, n, V));
      }
    });
  };
  dh({
    action: "probeTs",
    transmuxer: n.transmuxer,
    data: r,
    baseStartTime: n.baseStartTime,
    callback: function(H) {
      n.bytes = r = H.data;
      var V = H.result;
      V && (i(n, {
        hasAudio: V.hasAudio,
        hasVideo: V.hasVideo,
        isMuxed: m
      }), i = null, V.hasAudio && !m && b(V.audioStart), V.hasVideo && D(V.videoStart), b = null, D = null), C();
    }
  });
}, zx = function(t) {
  var n = t.segment, r = t.bytes, i = t.trackInfoFn, a = t.timingInfoFn, o = t.videoSegmentTimingInfoFn, s = t.audioSegmentTimingInfoFn, l = t.id3Fn, u = t.captionsFn, c = t.isEndOfTimeline, f = t.endedTimelineFn, d = t.dataFn, h = t.doneFn, p = t.onTransmuxerLog, y = new Uint8Array(r);
  if (ase(y)) {
    n.isFmp4 = !0;
    var m = n.map.tracks, b = {
      isFmp4: !0,
      hasVideo: !!m.video,
      hasAudio: !!m.audio
    };
    m.audio && m.audio.codec && m.audio.codec !== "enca" && (b.audioCodec = m.audio.codec), m.video && m.video.codec && m.video.codec !== "encv" && (b.videoCodec = m.video.codec), m.video && m.audio && (b.isMuxed = !0), i(n, b);
    var x = function(S) {
      d(n, {
        data: y,
        type: b.hasAudio && !b.isMuxed ? "audio" : "video"
      }), S && S.length && u(n, S), h(null, n, {});
    };
    dh({
      action: "probeMp4StartTime",
      timescales: n.map.timescales,
      data: y,
      transmuxer: n.transmuxer,
      callback: function(S) {
        var C = S.data, v = S.startTime;
        if (r = C.buffer, n.bytes = y = C, b.hasAudio && !b.isMuxed && a(n, "audio", "start", v), b.hasVideo && a(n, "video", "start", v), !m.video || !C.byteLength || !n.transmuxer) {
          x();
          return;
        }
        dh({
          action: "pushMp4Captions",
          endAction: "mp4Captions",
          transmuxer: n.transmuxer,
          data: y,
          timescales: n.map.timescales,
          trackIds: [m.video.id],
          callback: function(V) {
            r = V.data.buffer, n.bytes = y = V.data, V.logs.forEach(function(R) {
              p(Ce.mergeOptions(R, {
                stream: "mp4CaptionParser"
              }));
            }), x(V.captions);
          }
        });
      }
    });
    return;
  }
  if (!n.transmuxer) {
    h(null, n, {});
    return;
  }
  if (typeof n.container > "u" && (n.container = s6(y)), n.container !== "ts" && n.container !== "aac") {
    i(n, {
      hasAudio: !1,
      hasVideo: !1
    }), h(null, n, {});
    return;
  }
  Bue({
    segment: n,
    bytes: r,
    trackInfoFn: i,
    timingInfoFn: a,
    videoSegmentTimingInfoFn: o,
    audioSegmentTimingInfoFn: s,
    id3Fn: l,
    captionsFn: u,
    isEndOfTimeline: c,
    endedTimelineFn: f,
    dataFn: d,
    doneFn: h,
    onTransmuxerLog: p
  });
}, Dx = function(t, n) {
  var r = t.id, i = t.key, a = t.encryptedBytes, o = t.decryptionWorker, s = function u(c) {
    if (c.data.source === r) {
      o.removeEventListener("message", u);
      var f = c.data.decrypted;
      n(new Uint8Array(f.bytes, f.byteOffset, f.byteLength));
    }
  };
  o.addEventListener("message", s);
  var l;
  i.bytes.slice ? l = i.bytes.slice() : l = new Uint32Array(Array.prototype.slice.call(i.bytes)), o.postMessage(mx({
    source: r,
    encrypted: a,
    key: l,
    iv: i.iv
  }), [a.buffer, l.buffer]);
}, Nue = function(t) {
  var n = t.decryptionWorker, r = t.segment, i = t.trackInfoFn, a = t.timingInfoFn, o = t.videoSegmentTimingInfoFn, s = t.audioSegmentTimingInfoFn, l = t.id3Fn, u = t.captionsFn, c = t.isEndOfTimeline, f = t.endedTimelineFn, d = t.dataFn, h = t.doneFn, p = t.onTransmuxerLog;
  Dx({
    id: r.requestId,
    key: r.key,
    encryptedBytes: r.encryptedBytes,
    decryptionWorker: n
  }, function(y) {
    r.bytes = y, zx({
      segment: r,
      bytes: r.bytes,
      trackInfoFn: i,
      timingInfoFn: a,
      videoSegmentTimingInfoFn: o,
      audioSegmentTimingInfoFn: s,
      id3Fn: l,
      captionsFn: u,
      isEndOfTimeline: c,
      endedTimelineFn: f,
      dataFn: d,
      doneFn: h,
      onTransmuxerLog: p
    });
  });
}, jue = function(t) {
  var n = t.activeXhrs, r = t.decryptionWorker, i = t.trackInfoFn, a = t.timingInfoFn, o = t.videoSegmentTimingInfoFn, s = t.audioSegmentTimingInfoFn, l = t.id3Fn, u = t.captionsFn, c = t.isEndOfTimeline, f = t.endedTimelineFn, d = t.dataFn, h = t.doneFn, p = t.onTransmuxerLog, y = 0, m = !1;
  return function(b, x) {
    if (!m) {
      if (b)
        return m = !0, D4(n), h(b, x);
      if (y += 1, y === n.length) {
        var D = function() {
          if (x.encryptedBytes)
            return Nue({
              decryptionWorker: r,
              segment: x,
              trackInfoFn: i,
              timingInfoFn: a,
              videoSegmentTimingInfoFn: o,
              audioSegmentTimingInfoFn: s,
              id3Fn: l,
              captionsFn: u,
              isEndOfTimeline: c,
              endedTimelineFn: f,
              dataFn: d,
              doneFn: h,
              onTransmuxerLog: p
            });
          zx({
            segment: x,
            bytes: x.bytes,
            trackInfoFn: i,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: o,
            audioSegmentTimingInfoFn: s,
            id3Fn: l,
            captionsFn: u,
            isEndOfTimeline: c,
            endedTimelineFn: f,
            dataFn: d,
            doneFn: h,
            onTransmuxerLog: p
          });
        };
        if (x.endOfAllRequests = Date.now(), x.map && x.map.encryptedBytes && !x.map.bytes)
          return Dx({
            decryptionWorker: r,
            id: x.requestId + "-init",
            encryptedBytes: x.map.encryptedBytes,
            key: x.map.key
          }, function(S) {
            x.map.bytes = S, Ox(x, function(C) {
              if (C)
                return D4(n), h(C, x);
              D();
            });
          });
        D();
      }
    }
  };
}, Fue = function(t) {
  var n = t.loadendState, r = t.abortFn;
  return function(i) {
    var a = i.target;
    a.aborted && r && !n.calledAbortFn && (r(), n.calledAbortFn = !0);
  };
}, Xue = function(t) {
  var n = t.segment, r = t.progressFn;
  return t.trackInfoFn, t.timingInfoFn, t.videoSegmentTimingInfoFn, t.audioSegmentTimingInfoFn, t.id3Fn, t.captionsFn, t.isEndOfTimeline, t.endedTimelineFn, t.dataFn, function(i) {
    var a = i.target;
    if (!a.aborted)
      return n.stats = Ce.mergeOptions(n.stats, Hue(i)), !n.stats.firstBytesReceivedAt && n.stats.bytesReceived && (n.stats.firstBytesReceivedAt = Date.now()), r(i, n);
  };
}, Rue = function(t) {
  var n = t.xhr, r = t.xhrOptions, i = t.decryptionWorker, a = t.segment, o = t.abortFn, s = t.progressFn, l = t.trackInfoFn, u = t.timingInfoFn, c = t.videoSegmentTimingInfoFn, f = t.audioSegmentTimingInfoFn, d = t.id3Fn, h = t.captionsFn, p = t.isEndOfTimeline, y = t.endedTimelineFn, m = t.dataFn, b = t.doneFn, x = t.onTransmuxerLog, D = [], S = jue({
    activeXhrs: D,
    decryptionWorker: i,
    trackInfoFn: l,
    timingInfoFn: u,
    videoSegmentTimingInfoFn: c,
    audioSegmentTimingInfoFn: f,
    id3Fn: d,
    captionsFn: h,
    isEndOfTimeline: p,
    endedTimelineFn: y,
    dataFn: m,
    doneFn: b,
    onTransmuxerLog: x
  });
  if (a.key && !a.key.bytes) {
    var C = [a.key];
    a.map && !a.map.bytes && a.map.key && a.map.key.resolvedUri === a.key.resolvedUri && C.push(a.map.key);
    var v = Ce.mergeOptions(r, {
      uri: a.key.resolvedUri,
      responseType: "arraybuffer"
    }), H = r9(a, C, S), V = n(v, H);
    D.push(V);
  }
  if (a.map && !a.map.bytes) {
    var R = a.map.key && (!a.key || a.key.resolvedUri !== a.map.key.resolvedUri);
    if (R) {
      var F = Ce.mergeOptions(r, {
        uri: a.map.key.resolvedUri,
        responseType: "arraybuffer"
      }), K = r9(a, [a.map.key], S), q = n(F, K);
      D.push(q);
    }
    var G = Ce.mergeOptions(r, {
      uri: a.map.resolvedUri,
      responseType: "arraybuffer",
      headers: O4(a.map)
    }), te = Iue({
      segment: a,
      finishProcessingFn: S
    }), Q = n(G, te);
    D.push(Q);
  }
  var Y = Ce.mergeOptions(r, {
    uri: a.part && a.part.resolvedUri || a.resolvedUri,
    responseType: "arraybuffer",
    headers: O4(a)
  }), Z = Lue({
    segment: a,
    finishProcessingFn: S,
    responseType: Y.responseType
  }), oe = n(Y, Z);
  oe.addEventListener("progress", Xue({
    segment: a,
    progressFn: s,
    trackInfoFn: l,
    timingInfoFn: u,
    videoSegmentTimingInfoFn: c,
    audioSegmentTimingInfoFn: f,
    id3Fn: d,
    captionsFn: h,
    isEndOfTimeline: p,
    endedTimelineFn: y,
    dataFn: m
  })), D.push(oe);
  var he = {};
  return D.forEach(function(Ae) {
    Ae.addEventListener("loadend", Fue({
      loadendState: he,
      abortFn: o
    }));
  }), function() {
    return D4(D);
  };
}, Uue = Ya("CodecUtils"), que = function(t) {
  var n = t.attributes || {};
  if (n.CODECS)
    return eo(n.CODECS);
}, Mx = function(t, n) {
  var r = n.attributes || {};
  return t && t.mediaGroups && t.mediaGroups.AUDIO && r.AUDIO && t.mediaGroups.AUDIO[r.AUDIO];
}, _ue = function(t, n) {
  if (!Mx(t, n))
    return !0;
  var r = n.attributes || {}, i = t.mediaGroups.AUDIO[r.AUDIO];
  for (var a in i)
    if (!i[a].uri && !i[a].playlists)
      return !0;
  return !1;
}, fh = function(t) {
  var n = {};
  return t.forEach(function(r) {
    var i = r.mediaType, a = r.type, o = r.details;
    n[i] = n[i] || [], n[i].push(tw("" + a + o));
  }), Object.keys(n).forEach(function(r) {
    if (n[r].length > 1) {
      Uue("multiple " + r + " codecs found as attributes: " + n[r].join(", ") + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs."), n[r] = null;
      return;
    }
    n[r] = n[r][0];
  }), n;
}, a9 = function(t) {
  var n = 0;
  return t.audio && n++, t.video && n++, n;
}, Sd = function(t, n) {
  var r = n.attributes || {}, i = fh(que(n) || []);
  if (Mx(t, n) && !i.audio && !_ue(t, n)) {
    var a = fh(vae(t, r.AUDIO) || []);
    a.audio && (i.audio = a.audio);
  }
  return i;
}, O1 = Ya("PlaylistSelector"), o9 = function(t) {
  if (!(!t || !t.playlist)) {
    var n = t.playlist;
    return JSON.stringify({
      id: n.id,
      bandwidth: t.bandwidth,
      width: t.width,
      height: t.height,
      codecs: n.attributes && n.attributes.CODECS || ""
    });
  }
}, hh = function(t, n) {
  if (!t)
    return "";
  var r = pe.getComputedStyle(t);
  return r ? r[n] : "";
}, Bu = function(t, n) {
  var r = t.slice();
  t.sort(function(i, a) {
    var o = n(i, a);
    return o === 0 ? r.indexOf(i) - r.indexOf(a) : o;
  });
}, K6 = function(t, n) {
  var r, i;
  return t.attributes.BANDWIDTH && (r = t.attributes.BANDWIDTH), r = r || pe.Number.MAX_VALUE, n.attributes.BANDWIDTH && (i = n.attributes.BANDWIDTH), i = i || pe.Number.MAX_VALUE, r - i;
}, Wue = function(t, n) {
  var r, i;
  return t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (r = t.attributes.RESOLUTION.width), r = r || pe.Number.MAX_VALUE, n.attributes.RESOLUTION && n.attributes.RESOLUTION.width && (i = n.attributes.RESOLUTION.width), i = i || pe.Number.MAX_VALUE, r === i && t.attributes.BANDWIDTH && n.attributes.BANDWIDTH ? t.attributes.BANDWIDTH - n.attributes.BANDWIDTH : r - i;
}, Hx = function(t, n, r, i, a, o) {
  if (!!t) {
    var s = {
      bandwidth: n,
      width: r,
      height: i,
      limitRenditionByPlayerDimensions: a
    }, l = t.playlists;
    Dr.isAudioOnly(t) && (l = o.getAudioTrackPlaylists_(), s.audioOnly = !0);
    var u = l.map(function(F) {
      var K, q = F.attributes && F.attributes.RESOLUTION && F.attributes.RESOLUTION.width, G = F.attributes && F.attributes.RESOLUTION && F.attributes.RESOLUTION.height;
      return K = F.attributes && F.attributes.BANDWIDTH, K = K || pe.Number.MAX_VALUE, {
        bandwidth: K,
        width: q,
        height: G,
        playlist: F
      };
    });
    Bu(u, function(F, K) {
      return F.bandwidth - K.bandwidth;
    }), u = u.filter(function(F) {
      return !Dr.isIncompatible(F.playlist);
    });
    var c = u.filter(function(F) {
      return Dr.isEnabled(F.playlist);
    });
    c.length || (c = u.filter(function(F) {
      return !Dr.isDisabled(F.playlist);
    }));
    var f = c.filter(function(F) {
      return F.bandwidth * Ii.BANDWIDTH_VARIANCE < n;
    }), d = f[f.length - 1], h = f.filter(function(F) {
      return F.bandwidth === d.bandwidth;
    })[0];
    if (a === !1) {
      var p = h || c[0] || u[0];
      if (p && p.playlist) {
        var y = "sortedPlaylistReps";
        return h && (y = "bandwidthBestRep"), c[0] && (y = "enabledPlaylistReps"), O1("choosing " + o9(p) + " using " + y + " with options", s), p.playlist;
      }
      return O1("could not choose a playlist with options", s), null;
    }
    var m = f.filter(function(F) {
      return F.width && F.height;
    });
    Bu(m, function(F, K) {
      return F.width - K.width;
    });
    var b = m.filter(function(F) {
      return F.width === r && F.height === i;
    });
    d = b[b.length - 1];
    var x = b.filter(function(F) {
      return F.bandwidth === d.bandwidth;
    })[0], D, S, C;
    x || (D = m.filter(function(F) {
      return F.width > r || F.height > i;
    }), S = D.filter(function(F) {
      return F.width === D[0].width && F.height === D[0].height;
    }), d = S[S.length - 1], C = S.filter(function(F) {
      return F.bandwidth === d.bandwidth;
    })[0]);
    var v;
    if (o.experimentalLeastPixelDiffSelector) {
      var H = m.map(function(F) {
        return F.pixelDiff = Math.abs(F.width - r) + Math.abs(F.height - i), F;
      });
      Bu(H, function(F, K) {
        return F.pixelDiff === K.pixelDiff ? K.bandwidth - F.bandwidth : F.pixelDiff - K.pixelDiff;
      }), v = H[0];
    }
    var V = v || C || x || h || c[0] || u[0];
    if (V && V.playlist) {
      var R = "sortedPlaylistReps";
      return v ? R = "leastPixelDiffRep" : C ? R = "resolutionPlusOneRep" : x ? R = "resolutionBestRep" : h ? R = "bandwidthBestRep" : c[0] && (R = "enabledPlaylistReps"), O1("choosing " + o9(V) + " using " + R + " with options", s), V.playlist;
    }
    return O1("could not choose a playlist with options", s), null;
  }
}, s9 = function() {
  var t = this.useDevicePixelRatio && pe.devicePixelRatio || 1;
  return Hx(this.playlists.master, this.systemBandwidth, parseInt(hh(this.tech_.el(), "width"), 10) * t, parseInt(hh(this.tech_.el(), "height"), 10) * t, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
}, Kue = function(t) {
  var n = -1, r = -1;
  if (t < 0 || t > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    var i = this.useDevicePixelRatio && pe.devicePixelRatio || 1;
    return n < 0 && (n = this.systemBandwidth, r = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== r && (n = t * this.systemBandwidth + (1 - t) * n, r = this.systemBandwidth), Hx(this.playlists.master, n, parseInt(hh(this.tech_.el(), "width"), 10) * i, parseInt(hh(this.tech_.el(), "height"), 10) * i, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
  };
}, Gue = function(t) {
  var n = t.master, r = t.currentTime, i = t.bandwidth, a = t.duration, o = t.segmentDuration, s = t.timeUntilRebuffer, l = t.currentTimeline, u = t.syncController, c = n.playlists.filter(function(y) {
    return !Dr.isIncompatible(y);
  }), f = c.filter(Dr.isEnabled);
  f.length || (f = c.filter(function(y) {
    return !Dr.isDisabled(y);
  }));
  var d = f.filter(Dr.hasAttribute.bind(null, "BANDWIDTH")), h = d.map(function(y) {
    var m = u.getSyncPoint(y, a, l, r), b = m ? 1 : 2, x = Dr.estimateSegmentRequestTime(o, i, y), D = x * b - s;
    return {
      playlist: y,
      rebufferingImpact: D
    };
  }), p = h.filter(function(y) {
    return y.rebufferingImpact <= 0;
  });
  return Bu(p, function(y, m) {
    return K6(m.playlist, y.playlist);
  }), p.length ? p[0] : (Bu(h, function(y, m) {
    return y.rebufferingImpact - m.rebufferingImpact;
  }), h[0] || null);
}, Yue = function() {
  var t = this, n = this.playlists.master.playlists.filter(Dr.isEnabled);
  Bu(n, function(i, a) {
    return K6(i, a);
  });
  var r = n.filter(function(i) {
    return !!Sd(t.playlists.master, i).video;
  });
  return r[0] || null;
}, Que = function(t) {
  var n = 0, r;
  return t.bytes && (r = new Uint8Array(t.bytes), t.segments.forEach(function(i) {
    r.set(i, n), n += i.byteLength;
  })), r;
}, Zue = function(t, n, r) {
  if (!t[r]) {
    n.trigger({
      type: "usage",
      name: "vhs-608"
    }), n.trigger({
      type: "usage",
      name: "hls-608"
    });
    var i = r;
    /^cc708_/.test(r) && (i = "SERVICE" + r.split("_")[1]);
    var a = n.textTracks().getTrackById(i);
    if (a)
      t[r] = a;
    else {
      var o = n.options_.vhs && n.options_.vhs.captionServices || {}, s = r, l = r, u = !1, c = o[i];
      c && (s = c.label, l = c.language, u = c.default), t[r] = n.addRemoteTextTrack({
        kind: "captions",
        id: i,
        default: u,
        label: s,
        language: l
      }, !1).track;
    }
  }
}, Jue = function(t) {
  var n = t.inbandTextTracks, r = t.captionArray, i = t.timestampOffset;
  if (!!r) {
    var a = pe.WebKitDataCue || pe.VTTCue;
    r.forEach(function(o) {
      var s = o.stream;
      n[s].addCue(new a(o.startTime + i, o.endTime + i, o.text));
    });
  }
}, $ue = function(t) {
  Object.defineProperties(t.frame, {
    id: {
      get: function() {
        return Ce.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), t.value.key;
      }
    },
    value: {
      get: function() {
        return Ce.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), t.value.data;
      }
    },
    privateData: {
      get: function() {
        return Ce.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), t.value.data;
      }
    }
  });
}, ece = function(t) {
  var n = t.inbandTextTracks, r = t.metadataArray, i = t.timestampOffset, a = t.videoDuration;
  if (!!r) {
    var o = pe.WebKitDataCue || pe.VTTCue, s = n.metadataTrack_;
    if (!!s && (r.forEach(function(h) {
      var p = h.cueTime + i;
      typeof p != "number" || pe.isNaN(p) || p < 0 || !(p < 1 / 0) || h.frames.forEach(function(y) {
        var m = new o(p, p, y.value || y.url || y.data || "");
        m.frame = y, m.value = y, $ue(m), s.addCue(m);
      });
    }), !(!s.cues || !s.cues.length))) {
      for (var l = s.cues, u = [], c = 0; c < l.length; c++)
        l[c] && u.push(l[c]);
      var f = u.reduce(function(h, p) {
        var y = h[p.startTime] || [];
        return y.push(p), h[p.startTime] = y, h;
      }, {}), d = Object.keys(f).sort(function(h, p) {
        return Number(h) - Number(p);
      });
      d.forEach(function(h, p) {
        var y = f[h], m = Number(d[p + 1]) || a;
        y.forEach(function(b) {
          b.endTime = m;
        });
      });
    }
  }
}, tce = function(t, n, r) {
  t.metadataTrack_ || (t.metadataTrack_ = r.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, t.metadataTrack_.inBandMetadataTrackDispatchType = n);
}, dd = function(t, n, r) {
  var i, a;
  if (!!r && !!r.cues)
    for (i = r.cues.length; i--; )
      a = r.cues[i], a.startTime >= t && a.endTime <= n && r.removeCue(a);
}, nce = function(t) {
  var n = t.cues;
  if (!!n)
    for (var r = 0; r < n.length; r++) {
      for (var i = [], a = 0, o = 0; o < n.length; o++)
        n[r].startTime === n[o].startTime && n[r].endTime === n[o].endTime && n[r].text === n[o].text && (a++, a > 1 && i.push(n[o]));
      i.length && i.forEach(function(s) {
        return t.removeCue(s);
      });
    }
}, ice = function(t, n, r) {
  if (typeof n > "u" || n === null || !t.length)
    return [];
  var i = Math.ceil((n - r + 3) * J0.ONE_SECOND_IN_TS), a;
  for (a = 0; a < t.length && !(t[a].pts > i); a++)
    ;
  return t.slice(a);
}, rce = function(t, n, r) {
  if (!n.length)
    return t;
  if (r)
    return n.slice();
  var i = n[0].pts, a = 0;
  for (a; a < t.length && !(t[a].pts >= i); a++)
    ;
  return t.slice(0, a).concat(n);
}, ace = function(t, n, r, i) {
  for (var a = Math.ceil((n - i) * J0.ONE_SECOND_IN_TS), o = Math.ceil((r - i) * J0.ONE_SECOND_IN_TS), s = t.slice(), l = t.length; l-- && !(t[l].pts <= o); )
    ;
  if (l === -1)
    return s;
  for (var u = l + 1; u-- && !(t[u].pts <= a); )
    ;
  return u = Math.max(u, 0), s.splice(u, l - u + 1), s;
}, oce = function(t, n) {
  if (!t && !n || !t && n || t && !n)
    return !1;
  if (t === n)
    return !0;
  var r = Object.keys(t).sort(), i = Object.keys(n).sort();
  if (r.length !== i.length)
    return !1;
  for (var a = 0; a < r.length; a++) {
    var o = r[a];
    if (o !== i[a] || t[o] !== n[o])
      return !1;
  }
  return !0;
}, Ix = 22, sce = function(t, n, r) {
  n = n || [];
  for (var i = [], a = 0, o = 0; o < n.length; o++) {
    var s = n[o];
    if (t === s.timeline && (i.push(o), a += s.duration, a > r))
      return o;
  }
  return i.length === 0 ? 0 : i[i.length - 1];
}, nd = 1, lce = 500, l9 = function(t) {
  return typeof t == "number" && isFinite(t);
}, z1 = 1 / 60, uce = function(t, n, r) {
  return t !== "main" || !n || !r ? null : !r.hasAudio && !r.hasVideo ? "Neither audio nor video found in segment." : n.hasVideo && !r.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !n.hasVideo && r.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null;
}, cce = function(t, n, r) {
  var i = n - Ii.BACK_BUFFER_LENGTH;
  t.length && (i = Math.max(i, t.start(0)));
  var a = n - r;
  return Math.min(a, i);
}, bu = function(t) {
  var n = t.startOfSegment, r = t.duration, i = t.segment, a = t.part, o = t.playlist, s = o.mediaSequence, l = o.id, u = o.segments, c = u === void 0 ? [] : u, f = t.mediaIndex, d = t.partIndex, h = t.timeline, p = c.length - 1, y = "mediaIndex/partIndex increment";
  t.getMediaInfoForTime ? y = "getMediaInfoForTime (" + t.getMediaInfoForTime + ")" : t.isSyncRequest && (y = "getSyncSegmentCandidate (isSyncRequest)"), t.independent && (y += " with independent " + t.independent);
  var m = typeof d == "number", b = t.segment.uri ? "segment" : "pre-segment", x = m ? nx({
    preloadSegment: i
  }) - 1 : 0;
  return b + " [" + (s + f) + "/" + (s + p) + "]" + (m ? " part [" + d + "/" + x + "]" : "") + (" segment start/end [" + i.start + " => " + i.end + "]") + (m ? " part start/end [" + a.start + " => " + a.end + "]" : "") + (" startOfSegment [" + n + "]") + (" duration [" + r + "]") + (" timeline [" + h + "]") + (" selected by [" + y + "]") + (" playlist [" + l + "]");
}, u9 = function(t) {
  return t + "TimingInfo";
}, dce = function(t) {
  var n = t.segmentTimeline, r = t.currentTimeline, i = t.startOfSegment, a = t.buffered, o = t.overrideCheck;
  return !o && n === r ? null : n < r ? i : a.length ? a.end(a.length - 1) : i;
}, c9 = function(t) {
  var n = t.timelineChangeController, r = t.currentTimeline, i = t.segmentTimeline, a = t.loaderType, o = t.audioDisabled;
  if (r === i)
    return !1;
  if (a === "audio") {
    var s = n.lastTimelineChange({
      type: "main"
    });
    return !s || s.to !== i;
  }
  if (a === "main" && o) {
    var l = n.pendingTimelineChange({
      type: "audio"
    });
    return !(l && l.to === i);
  }
  return !1;
}, fce = function(t) {
  var n = 0;
  return ["video", "audio"].forEach(function(r) {
    var i = t[r + "TimingInfo"];
    if (!!i) {
      var a = i.start, o = i.end, s;
      typeof a == "bigint" || typeof o == "bigint" ? s = pe.BigInt(o) - pe.BigInt(a) : typeof a == "number" && typeof o == "number" && (s = o - a), typeof s < "u" && s > n && (n = s);
    }
  }), typeof n == "bigint" && n < Number.MAX_SAFE_INTEGER && (n = Number(n)), n;
}, d9 = function(t) {
  var n = t.segmentDuration, r = t.maxDuration;
  return n ? Math.round(n) > r + Fs : !1;
}, hce = function(t, n) {
  if (n !== "hls")
    return null;
  var r = fce({
    audioTimingInfo: t.audioTimingInfo,
    videoTimingInfo: t.videoTimingInfo
  });
  if (!r)
    return null;
  var i = t.playlist.targetDuration, a = d9({
    segmentDuration: r,
    maxDuration: i * 2
  }), o = d9({
    segmentDuration: r,
    maxDuration: i
  }), s = "Segment with index " + t.mediaIndex + " " + ("from playlist " + t.playlist.id + " ") + ("has a duration of " + r + " ") + ("when the reported duration is " + t.duration + " ") + ("and the target duration is " + i + ". ") + "For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
  return a || o ? {
    severity: a ? "warn" : "info",
    message: s
  } : null;
}, M4 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    if (a = e.call(this) || this, !r)
      throw new TypeError("Initialization settings are required");
    if (typeof r.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!r.mediaSource)
      throw new TypeError("No MediaSource specified");
    return a.bandwidth = r.bandwidth, a.throughput = {
      rate: 0,
      count: 0
    }, a.roundTrip = NaN, a.resetStats_(), a.mediaIndex = null, a.partIndex = null, a.hasPlayed_ = r.hasPlayed, a.currentTime_ = r.currentTime, a.seekable_ = r.seekable, a.seeking_ = r.seeking, a.duration_ = r.duration, a.mediaSource_ = r.mediaSource, a.vhs_ = r.vhs, a.loaderType_ = r.loaderType, a.currentMediaInfo_ = void 0, a.startingMediaInfo_ = void 0, a.segmentMetadataTrack_ = r.segmentMetadataTrack, a.goalBufferLength_ = r.goalBufferLength, a.sourceType_ = r.sourceType, a.sourceUpdater_ = r.sourceUpdater, a.inbandTextTracks_ = r.inbandTextTracks, a.state_ = "INIT", a.timelineChangeController_ = r.timelineChangeController, a.shouldSaveSegmentTimingInfo_ = !0, a.parse708captions_ = r.parse708captions, a.useDtsForTimestampOffset_ = r.useDtsForTimestampOffset, a.captionServices_ = r.captionServices, a.experimentalExactManifestTimings = r.experimentalExactManifestTimings, a.checkBufferTimeout_ = null, a.error_ = void 0, a.currentTimeline_ = -1, a.pendingSegment_ = null, a.xhrOptions_ = null, a.pendingSegments_ = [], a.audioDisabled_ = !1, a.isPendingTimestampOffset_ = !1, a.gopBuffer_ = [], a.timeMapping_ = 0, a.safeAppend_ = Ce.browser.IE_VERSION >= 11, a.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, a.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, a.callQueue_ = [], a.loadQueue_ = [], a.metadataQueue_ = {
      id3: [],
      caption: []
    }, a.waitingOnRemove_ = !1, a.quotaExceededErrorRetryTimeout_ = null, a.activeInitSegmentId_ = null, a.initSegments_ = {}, a.cacheEncryptionKeys_ = r.cacheEncryptionKeys, a.keyCache_ = {}, a.decrypter_ = r.decrypter, a.syncController_ = r.syncController, a.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, a.transmuxer_ = a.createTransmuxer_(), a.triggerSyncInfoUpdate_ = function() {
      return a.trigger("syncinfoupdate");
    }, a.syncController_.on("syncinfoupdate", a.triggerSyncInfoUpdate_), a.mediaSource_.addEventListener("sourceopen", function() {
      a.isEndOfStream_() || (a.ended_ = !1);
    }), a.fetchAtBuffer_ = !1, a.logger_ = Ya("SegmentLoader[" + a.loaderType_ + "]"), Object.defineProperty(on(a), "state", {
      get: function() {
        return this.state_;
      },
      set: function(s) {
        s !== this.state_ && (this.logger_(this.state_ + " -> " + s), this.state_ = s, this.trigger("statechange"));
      }
    }), a.sourceUpdater_.on("ready", function() {
      a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a.loaderType_ === "main" && a.timelineChangeController_.on("pendingtimelinechange", function() {
      a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a.loaderType_ === "audio" && a.timelineChangeController_.on("timelinechange", function() {
      a.hasEnoughInfoToLoad_() && a.processLoadQueue_(), a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a;
  }
  var n = t.prototype;
  return n.createTransmuxer_ = function() {
    return Zp.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }, n.resetStats_ = function() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }, n.dispose = function() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && pe.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }, n.setAudio = function(i) {
    this.audioDisabled_ = !i, i ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }, n.abort = function() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }, n.abort_ = function() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, pe.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }, n.checkForAbort_ = function(i) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== i;
  }, n.error = function(i) {
    return typeof i < "u" && (this.logger_("error occurred:", i), this.error_ = i), this.pendingSegment_ = null, this.error_;
  }, n.endOfStream = function() {
    this.ended_ = !0, this.transmuxer_ && Zp.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }, n.buffered_ = function() {
    var i = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !i)
      return Ce.createTimeRanges();
    if (this.loaderType_ === "main") {
      var a = i.hasAudio, o = i.hasVideo, s = i.isMuxed;
      if (o && a && !this.audioDisabled_ && !s)
        return this.sourceUpdater_.buffered();
      if (o)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }, n.initSegmentForMap = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var o = ch(i), s = this.initSegments_[o];
    return a && !s && i.bytes && (this.initSegments_[o] = s = {
      resolvedUri: i.resolvedUri,
      byterange: i.byterange,
      bytes: i.bytes,
      tracks: i.tracks,
      timescales: i.timescales
    }), s || i;
  }, n.segmentKey = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var o = gx(i), s = this.keyCache_[o];
    this.cacheEncryptionKeys_ && a && !s && i.bytes && (this.keyCache_[o] = s = {
      resolvedUri: i.resolvedUri,
      bytes: i.bytes
    });
    var l = {
      resolvedUri: (s || i).resolvedUri
    };
    return s && (l.bytes = s.bytes), l;
  }, n.couldBeginLoading_ = function() {
    return this.playlist_ && !this.paused();
  }, n.load = function() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }, n.init_ = function() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }, n.playlist = function(i, a) {
    if (a === void 0 && (a = {}), !!i) {
      var o = this.playlist_, s = this.pendingSegment_;
      this.playlist_ = i, this.xhrOptions_ = a, this.state === "INIT" && (i.syncInfo = {
        mediaSequence: i.mediaSequence,
        time: 0
      }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(i));
      var l = null;
      if (o && (o.id ? l = o.id : o.uri && (l = o.uri)), this.logger_("playlist update [" + l + " => " + (i.id || i.uri) + "]"), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      if (!o || o.uri !== i.uri) {
        this.mediaIndex !== null && (i.endList ? this.resyncLoader() : this.resetLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
        return;
      }
      var u = i.mediaSequence - o.mediaSequence;
      if (this.logger_("live window shift [" + u + "]"), this.mediaIndex !== null)
        if (this.mediaIndex -= u, this.mediaIndex < 0)
          this.mediaIndex = null, this.partIndex = null;
        else {
          var c = this.playlist_.segments[this.mediaIndex];
          if (this.partIndex && (!c.parts || !c.parts.length || !c.parts[this.partIndex])) {
            var f = this.mediaIndex;
            this.logger_("currently processing part (index " + this.partIndex + ") no longer exists."), this.resetLoader(), this.mediaIndex = f;
          }
        }
      s && (s.mediaIndex -= u, s.mediaIndex < 0 ? (s.mediaIndex = null, s.partIndex = null) : (s.mediaIndex >= 0 && (s.segment = i.segments[s.mediaIndex]), s.partIndex >= 0 && s.segment.parts && (s.part = s.segment.parts[s.partIndex]))), this.syncController_.saveExpiredSegmentInfo(o, i);
    }
  }, n.pause = function() {
    this.checkBufferTimeout_ && (pe.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }, n.paused = function() {
    return this.checkBufferTimeout_ === null;
  }, n.resetEverything = function(i) {
    this.ended_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, i), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }, n.resetLoader = function() {
    this.fetchAtBuffer_ = !1, this.resyncLoader();
  }, n.resyncLoader = function() {
    this.transmuxer_ && Zp.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }, n.remove = function(i, a, o, s) {
    if (o === void 0 && (o = function() {
    }), s === void 0 && (s = !1), a === 1 / 0 && (a = this.duration_()), a <= i) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    var l = 1, u = function() {
      l--, l === 0 && o();
    };
    (s || !this.audioDisabled_) && (l++, this.sourceUpdater_.removeAudio(i, a, u)), (s || this.loaderType_ === "main") && (this.gopBuffer_ = ace(this.gopBuffer_, i, a, this.timeMapping_), l++, this.sourceUpdater_.removeVideo(i, a, u));
    for (var c in this.inbandTextTracks_)
      dd(i, a, this.inbandTextTracks_[c]);
    dd(i, a, this.segmentMetadataTrack_), u();
  }, n.monitorBuffer_ = function() {
    this.checkBufferTimeout_ && pe.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = pe.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }, n.monitorBufferTick_ = function() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && pe.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = pe.setTimeout(this.monitorBufferTick_.bind(this), lce);
  }, n.fillBuffer_ = function() {
    if (!this.sourceUpdater_.updating()) {
      var i = this.chooseNextRequest_();
      !i || (typeof i.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
        type: this.loaderType_,
        from: this.currentTimeline_,
        to: i.timeline
      })), this.loadSegment_(i));
    }
  }, n.isEndOfStream_ = function(i, a, o) {
    if (i === void 0 && (i = this.mediaIndex), a === void 0 && (a = this.playlist_), o === void 0 && (o = this.partIndex), !a || !this.mediaSource_)
      return !1;
    var s = typeof i == "number" && a.segments[i], l = i + 1 === a.segments.length, u = !s || !s.parts || o + 1 === s.parts.length;
    return a.endList && this.mediaSource_.readyState === "open" && l && u;
  }, n.chooseNextRequest_ = function() {
    var i = this.buffered_(), a = Jm(i) || 0, o = R6(i, this.currentTime_()), s = !this.hasPlayed_() && o >= 1, l = o >= this.goalBufferLength_(), u = this.playlist_.segments;
    if (!u.length || s || l)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
    var c = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: Boolean(!this.syncPoint_)
    };
    if (c.isSyncRequest)
      c.mediaIndex = sce(this.currentTimeline_, u, a);
    else if (this.mediaIndex !== null) {
      var f = u[this.mediaIndex], d = typeof this.partIndex == "number" ? this.partIndex : -1;
      c.startOfSegment = f.end ? f.end : a, f.parts && f.parts[d + 1] ? (c.mediaIndex = this.mediaIndex, c.partIndex = d + 1) : c.mediaIndex = this.mediaIndex + 1;
    } else {
      var h = Dr.getMediaInfoForTime({
        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
        playlist: this.playlist_,
        currentTime: this.fetchAtBuffer_ ? a : this.currentTime_(),
        startingPartIndex: this.syncPoint_.partIndex,
        startingSegmentIndex: this.syncPoint_.segmentIndex,
        startTime: this.syncPoint_.time
      }), p = h.segmentIndex, y = h.startTime, m = h.partIndex;
      c.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + a : "currentTime " + this.currentTime_(), c.mediaIndex = p, c.startOfSegment = y, c.partIndex = m;
    }
    var b = u[c.mediaIndex], x = b && typeof c.partIndex == "number" && b.parts && b.parts[c.partIndex];
    if (!b || typeof c.partIndex == "number" && !x)
      return null;
    if (typeof c.partIndex != "number" && b.parts && (c.partIndex = 0, x = b.parts[0]), !o && x && !x.independent)
      if (c.partIndex === 0) {
        var D = u[c.mediaIndex - 1], S = D.parts && D.parts.length && D.parts[D.parts.length - 1];
        S && S.independent && (c.mediaIndex -= 1, c.partIndex = D.parts.length - 1, c.independent = "previous segment");
      } else
        b.parts[c.partIndex - 1].independent && (c.partIndex -= 1, c.independent = "previous part");
    var C = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return c.mediaIndex >= u.length - 1 && C && !this.seeking_() ? null : this.generateSegmentInfo_(c);
  }, n.generateSegmentInfo_ = function(i) {
    var a = i.independent, o = i.playlist, s = i.mediaIndex, l = i.startOfSegment, u = i.isSyncRequest, c = i.partIndex, f = i.forceTimestampOffset, d = i.getMediaInfoForTime, h = o.segments[s], p = typeof c == "number" && h.parts[c], y = {
      requestId: "segment-loader-" + Math.random(),
      uri: p && p.resolvedUri || h.resolvedUri,
      mediaIndex: s,
      partIndex: p ? c : null,
      isSyncRequest: u,
      startOfSegment: l,
      playlist: o,
      bytes: null,
      encryptedBytes: null,
      timestampOffset: null,
      timeline: h.timeline,
      duration: p && p.duration || h.duration,
      segment: h,
      part: p,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      getMediaInfoForTime: d,
      independent: a
    }, m = typeof f < "u" ? f : this.isPendingTimestampOffset_;
    y.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: h.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: l,
      buffered: this.buffered_(),
      overrideCheck: m
    });
    var b = Jm(this.sourceUpdater_.audioBuffered());
    return typeof b == "number" && (y.audioAppendStart = b - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (y.gopsToAlignWith = ice(
      this.gopBuffer_,
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), y;
  }, n.timestampOffsetForSegment_ = function(i) {
    return dce(i);
  }, n.earlyAbortWhenNeeded_ = function(i) {
    if (!(this.vhs_.tech_.paused() || !this.xhrOptions_.timeout || !this.playlist_.attributes.BANDWIDTH) && !(Date.now() - (i.firstBytesReceivedAt || Date.now()) < 1e3)) {
      var a = this.currentTime_(), o = i.bandwidth, s = this.pendingSegment_.duration, l = Dr.estimateSegmentRequestTime(s, o, this.playlist_, i.bytesReceived), u = Ble(this.buffered_(), a, this.vhs_.tech_.playbackRate()) - 1;
      if (!(l <= u)) {
        var c = Gue({
          master: this.vhs_.playlists.master,
          currentTime: a,
          bandwidth: o,
          duration: this.duration_(),
          segmentDuration: s,
          timeUntilRebuffer: u,
          currentTimeline: this.currentTimeline_,
          syncController: this.syncController_
        });
        if (!!c) {
          var f = l - u, d = f - c.rebufferingImpact, h = 0.5;
          u <= Fs && (h = 1), !(!c.playlist || c.playlist.uri === this.playlist_.uri || d < h) && (this.bandwidth = c.playlist.attributes.BANDWIDTH * Ii.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
        }
      }
    }
  }, n.handleAbort_ = function(i) {
    this.logger_("Aborting " + bu(i)), this.mediaRequestsAborted += 1;
  }, n.handleProgress_ = function(i, a) {
    this.earlyAbortWhenNeeded_(a.stats), !this.checkForAbort_(a.requestId) && this.trigger("progress");
  }, n.handleTrackInfo_ = function(i, a) {
    this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId) && (this.checkForIllegalMediaSwitch(a) || (a = a || {}, oce(this.currentMediaInfo_, a) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = a, this.currentMediaInfo_ = a, this.logger_("trackinfo update", a), this.trigger("trackinfo")), !this.checkForAbort_(i.requestId) && (this.pendingSegment_.trackInfo = a, this.hasEnoughInfoToAppend_() && this.processCallQueue_())));
  }, n.handleTimingInfo_ = function(i, a, o, s) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      var l = this.pendingSegment_, u = u9(a);
      l[u] = l[u] || {}, l[u][o] = s, this.logger_("timinginfo: " + a + " - " + o + " - " + s), this.hasEnoughInfoToAppend_() && this.processCallQueue_();
    }
  }, n.handleCaptions_ = function(i, a) {
    var o = this;
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      if (a.length === 0) {
        this.logger_("SegmentLoader received no captions from a caption event");
        return;
      }
      var s = this.pendingSegment_;
      if (!s.hasAppendedData_) {
        this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, i, a));
        return;
      }
      var l = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), u = {};
      a.forEach(function(c) {
        u[c.stream] = u[c.stream] || {
          startTime: 1 / 0,
          captions: [],
          endTime: 0
        };
        var f = u[c.stream];
        f.startTime = Math.min(f.startTime, c.startTime + l), f.endTime = Math.max(f.endTime, c.endTime + l), f.captions.push(c);
      }), Object.keys(u).forEach(function(c) {
        var f = u[c], d = f.startTime, h = f.endTime, p = f.captions, y = o.inbandTextTracks_;
        o.logger_("adding cues from " + d + " -> " + h + " for " + c), Zue(y, o.vhs_.tech_, c), dd(d, h, y[c]), Jue({
          captionArray: p,
          inbandTextTracks: y,
          timestampOffset: l
        });
      }), this.transmuxer_ && this.transmuxer_.postMessage({
        action: "clearParsedMp4Captions"
      });
    }
  }, n.handleId3_ = function(i, a, o) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      var s = this.pendingSegment_;
      if (!s.hasAppendedData_) {
        this.metadataQueue_.id3.push(this.handleId3_.bind(this, i, a, o));
        return;
      }
      var l = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
      tce(this.inbandTextTracks_, o, this.vhs_.tech_), ece({
        inbandTextTracks: this.inbandTextTracks_,
        metadataArray: a,
        timestampOffset: l,
        videoDuration: this.duration_()
      });
    }
  }, n.processMetadataQueue_ = function() {
    this.metadataQueue_.id3.forEach(function(i) {
      return i();
    }), this.metadataQueue_.caption.forEach(function(i) {
      return i();
    }), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }, n.processCallQueue_ = function() {
    var i = this.callQueue_;
    this.callQueue_ = [], i.forEach(function(a) {
      return a();
    });
  }, n.processLoadQueue_ = function() {
    var i = this.loadQueue_;
    this.loadQueue_ = [], i.forEach(function(a) {
      return a();
    });
  }, n.hasEnoughInfoToLoad_ = function() {
    if (this.loaderType_ !== "audio")
      return !0;
    var i = this.pendingSegment_;
    return i ? this.getCurrentMediaInfo_() ? !c9({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: i.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }) : !0 : !1;
  }, n.getCurrentMediaInfo_ = function(i) {
    return i === void 0 && (i = this.pendingSegment_), i && i.trackInfo || this.currentMediaInfo_;
  }, n.getMediaInfo_ = function(i) {
    return i === void 0 && (i = this.pendingSegment_), this.getCurrentMediaInfo_(i) || this.startingMediaInfo_;
  }, n.hasEnoughInfoToAppend_ = function() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    var i = this.pendingSegment_, a = this.getCurrentMediaInfo_();
    if (!i || !a)
      return !1;
    var o = a.hasAudio, s = a.hasVideo, l = a.isMuxed;
    return !(s && !i.videoTimingInfo || o && !this.audioDisabled_ && !l && !i.audioTimingInfo || c9({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: i.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }, n.handleData_ = function(i, a) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
        this.callQueue_.push(this.handleData_.bind(this, i, a));
        return;
      }
      var o = this.pendingSegment_;
      if (this.setTimeMapping_(o.timeline), this.updateMediaSecondsLoaded_(o.part || o.segment), this.mediaSource_.readyState !== "closed") {
        if (i.map && (i.map = this.initSegmentForMap(i.map, !0), o.segment.map = i.map), i.key && this.segmentKey(i.key, !0), o.isFmp4 = i.isFmp4, o.timingInfo = o.timingInfo || {}, o.isFmp4)
          this.trigger("fmp4"), o.timingInfo.start = o[u9(a.type)].start;
        else {
          var s = this.getCurrentMediaInfo_(), l = this.loaderType_ === "main" && s && s.hasVideo, u;
          l && (u = o.videoTimingInfo.start), o.timingInfo.start = this.trueSegmentStart_({
            currentStart: o.timingInfo.start,
            playlist: o.playlist,
            mediaIndex: o.mediaIndex,
            currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
            useVideoTimingInfo: l,
            firstVideoFrameTimeForData: u,
            videoTimingInfo: o.videoTimingInfo,
            audioTimingInfo: o.audioTimingInfo
          });
        }
        if (this.updateAppendInitSegmentStatus(o, a.type), this.updateSourceBufferTimestampOffset_(o), o.isSyncRequest) {
          this.updateTimingInfoEnd_(o), this.syncController_.saveSegmentTimingInfo({
            segmentInfo: o,
            shouldSaveTimelineMapping: this.loaderType_ === "main"
          });
          var c = this.chooseNextRequest_();
          if (c.mediaIndex !== o.mediaIndex || c.partIndex !== o.partIndex) {
            this.logger_("sync segment was incorrect, not appending");
            return;
          }
          this.logger_("sync segment was correct, appending");
        }
        o.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(o, a);
      }
    }
  }, n.updateAppendInitSegmentStatus = function(i, a) {
    this.loaderType_ === "main" && typeof i.timestampOffset == "number" && !i.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[a] !== i.playlist && (this.appendInitSegment_[a] = !0);
  }, n.getInitSegmentAndUpdateState_ = function(i) {
    var a = i.type, o = i.initSegment, s = i.map, l = i.playlist;
    if (s) {
      var u = ch(s);
      if (this.activeInitSegmentId_ === u)
        return null;
      o = this.initSegmentForMap(s, !0).bytes, this.activeInitSegmentId_ = u;
    }
    return o && this.appendInitSegment_[a] ? (this.playlistOfLastInitSegment_[a] = l, this.appendInitSegment_[a] = !1, this.activeInitSegmentId_ = null, o) : null;
  }, n.handleQuotaExceededError_ = function(i, a) {
    var o = this, s = i.segmentInfo, l = i.type, u = i.bytes, c = this.sourceUpdater_.audioBuffered(), f = this.sourceUpdater_.videoBuffered();
    c.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + bl(c).join(", ")), f.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + bl(f).join(", "));
    var d = c.length ? c.start(0) : 0, h = c.length ? c.end(c.length - 1) : 0, p = f.length ? f.start(0) : 0, y = f.length ? f.end(f.length - 1) : 0;
    if (h - d <= nd && y - p <= nd) {
      this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + ("Appended byte length: " + u.byteLength + ", ") + ("audio buffer: " + bl(c).join(", ") + ", ") + ("video buffer: " + bl(f).join(", ") + ", ")), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: s,
      type: l,
      bytes: u
    }));
    var m = this.currentTime_(), b = m - nd;
    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + b), this.remove(0, b, function() {
      o.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + nd + "s"), o.waitingOnRemove_ = !1, o.quotaExceededErrorRetryTimeout_ = pe.setTimeout(function() {
        o.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), o.quotaExceededErrorRetryTimeout_ = null, o.processCallQueue_();
      }, nd * 1e3);
    }, !0);
  }, n.handleAppendError_ = function(i, a) {
    var o = i.segmentInfo, s = i.type, l = i.bytes;
    if (!!a) {
      if (a.code === Ix) {
        this.handleQuotaExceededError_({
          segmentInfo: o,
          type: s,
          bytes: l
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", a), this.error(s + " append of " + l.length + "b failed for segment " + ("#" + o.mediaIndex + " in playlist " + o.playlist.id)), this.trigger("appenderror");
    }
  }, n.appendToSourceBuffer_ = function(i) {
    var a = i.segmentInfo, o = i.type, s = i.initSegment, l = i.data, u = i.bytes;
    if (!u) {
      var c = [l], f = l.byteLength;
      s && (c.unshift(s), f += s.byteLength), u = Que({
        bytes: f,
        segments: c
      });
    }
    this.sourceUpdater_.appendBuffer({
      segmentInfo: a,
      type: o,
      bytes: u
    }, this.handleAppendError_.bind(this, {
      segmentInfo: a,
      type: o,
      bytes: u
    }));
  }, n.handleSegmentTimingInfo_ = function(i, a, o) {
    if (!(!this.pendingSegment_ || a !== this.pendingSegment_.requestId)) {
      var s = this.pendingSegment_.segment, l = i + "TimingInfo";
      s[l] || (s[l] = {}), s[l].transmuxerPrependedSeconds = o.prependedContentDuration || 0, s[l].transmuxedPresentationStart = o.start.presentation, s[l].transmuxedDecodeStart = o.start.decode, s[l].transmuxedPresentationEnd = o.end.presentation, s[l].transmuxedDecodeEnd = o.end.decode, s[l].baseMediaDecodeTime = o.baseMediaDecodeTime;
    }
  }, n.appendData_ = function(i, a) {
    var o = a.type, s = a.data;
    if (!(!s || !s.byteLength) && !(o === "audio" && this.audioDisabled_)) {
      var l = this.getInitSegmentAndUpdateState_({
        type: o,
        initSegment: a.initSegment,
        playlist: i.playlist,
        map: i.isFmp4 ? i.segment.map : null
      });
      this.appendToSourceBuffer_({
        segmentInfo: i,
        type: o,
        initSegment: l,
        data: s
      });
    }
  }, n.loadSegment_ = function(i) {
    var a = this;
    if (this.state = "WAITING", this.pendingSegment_ = i, this.trimBackBuffer_(i), typeof i.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      this.loadQueue_.push(function() {
        var o = Ta({}, i, {
          forceTimestampOffset: !0
        });
        Ta(i, a.generateSegmentInfo_(o)), a.isPendingTimestampOffset_ = !1, a.updateTransmuxerAndRequestSegment_(i);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(i);
  }, n.updateTransmuxerAndRequestSegment_ = function(i) {
    var a = this;
    this.shouldUpdateTransmuxerTimestampOffset_(i.timestampOffset) && (this.gopBuffer_.length = 0, i.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: i.timestampOffset
    }));
    var o = this.createSimplifiedSegmentObj_(i), s = this.isEndOfStream_(i.mediaIndex, i.playlist, i.partIndex), l = this.mediaIndex !== null, u = i.timeline !== this.currentTimeline_ && i.timeline > 0, c = s || l && u;
    this.logger_("Requesting " + bu(i)), o.map && !o.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), i.abortRequests = Rue({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: o,
      abortFn: this.handleAbort_.bind(this, i),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", i.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", i.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: c,
      endedTimelineFn: function() {
        a.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: function(d) {
        var h = d.message, p = d.level, y = d.stream;
        a.logger_(bu(i) + " logged from transmuxer stream " + y + " as a " + p + ": " + h);
      }
    });
  }, n.trimBackBuffer_ = function(i) {
    var a = cce(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    a > 0 && this.remove(0, a);
  }, n.createSimplifiedSegmentObj_ = function(i) {
    var a = i.segment, o = i.part, s = {
      resolvedUri: o ? o.resolvedUri : a.resolvedUri,
      byterange: o ? o.byterange : a.byterange,
      requestId: i.requestId,
      transmuxer: i.transmuxer,
      audioAppendStart: i.audioAppendStart,
      gopsToAlignWith: i.gopsToAlignWith,
      part: i.part
    }, l = i.playlist.segments[i.mediaIndex - 1];
    if (l && l.timeline === a.timeline && (l.videoTimingInfo ? s.baseStartTime = l.videoTimingInfo.transmuxedDecodeEnd : l.audioTimingInfo && (s.baseStartTime = l.audioTimingInfo.transmuxedDecodeEnd)), a.key) {
      var u = a.key.iv || new Uint32Array([0, 0, 0, i.mediaIndex + i.playlist.mediaSequence]);
      s.key = this.segmentKey(a.key), s.key.iv = u;
    }
    return a.map && (s.map = this.initSegmentForMap(a.map)), s;
  }, n.saveTransferStats_ = function(i) {
    this.mediaRequests += 1, i && (this.mediaBytesTransferred += i.bytesReceived, this.mediaTransferDuration += i.roundTripTime);
  }, n.saveBandwidthRelatedStats_ = function(i, a) {
    if (this.pendingSegment_.byteLength = a.bytesReceived, i < z1) {
      this.logger_("Ignoring segment's bandwidth because its duration of " + i + (" is less than the min to record " + z1));
      return;
    }
    this.bandwidth = a.bandwidth, this.roundTrip = a.roundTripTime;
  }, n.handleTimeout_ = function() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate");
  }, n.segmentRequestFinished_ = function(i, a, o) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, i, a, o));
      return;
    }
    if (this.saveTransferStats_(a.stats), !!this.pendingSegment_ && a.requestId === this.pendingSegment_.requestId) {
      if (i) {
        if (this.pendingSegment_ = null, this.state = "READY", i.code === ao.ABORTED)
          return;
        if (this.pause(), i.code === ao.TIMEOUT) {
          this.handleTimeout_();
          return;
        }
        this.mediaRequestsErrored += 1, this.error(i), this.trigger("error");
        return;
      }
      var s = this.pendingSegment_;
      this.saveBandwidthRelatedStats_(s.duration, a.stats), s.endOfAllRequests = a.endOfAllRequests, o.gopInfo && (this.gopBuffer_ = rce(this.gopBuffer_, o.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(s);
    }
  }, n.setTimeMapping_ = function(i) {
    var a = this.syncController_.mappingForTimeline(i);
    a !== null && (this.timeMapping_ = a);
  }, n.updateMediaSecondsLoaded_ = function(i) {
    typeof i.start == "number" && typeof i.end == "number" ? this.mediaSecondsLoaded += i.end - i.start : this.mediaSecondsLoaded += i.duration;
  }, n.shouldUpdateTransmuxerTimestampOffset_ = function(i) {
    return i === null ? !1 : this.loaderType_ === "main" && i !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && i !== this.sourceUpdater_.audioTimestampOffset();
  }, n.trueSegmentStart_ = function(i) {
    var a = i.currentStart, o = i.playlist, s = i.mediaIndex, l = i.firstVideoFrameTimeForData, u = i.currentVideoTimestampOffset, c = i.useVideoTimingInfo, f = i.videoTimingInfo, d = i.audioTimingInfo;
    if (typeof a < "u")
      return a;
    if (!c)
      return d.start;
    var h = o.segments[s - 1];
    return s === 0 || !h || typeof h.start > "u" || h.end !== l + u ? l : f.start;
  }, n.waitForAppendsToComplete_ = function(i) {
    var a = this.getCurrentMediaInfo_(i);
    if (!a) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        blacklistDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    var o = a.hasAudio, s = a.hasVideo, l = a.isMuxed, u = this.loaderType_ === "main" && s, c = !this.audioDisabled_ && o && !l;
    if (i.waitingOnAppends = 0, !i.hasAppendedData_) {
      !i.timingInfo && typeof i.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), i.timingInfo = {
        start: 0
      }, i.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(i), this.processMetadataQueue_()), this.checkAppendsDone_(i);
      return;
    }
    u && i.waitingOnAppends++, c && i.waitingOnAppends++, u && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, i)), c && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, i));
  }, n.checkAppendsDone_ = function(i) {
    this.checkForAbort_(i.requestId) || (i.waitingOnAppends--, i.waitingOnAppends === 0 && this.handleAppendsDone_());
  }, n.checkForIllegalMediaSwitch = function(i) {
    var a = uce(this.loaderType_, this.getCurrentMediaInfo_(), i);
    return a ? (this.error({
      message: a,
      blacklistDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }, n.updateSourceBufferTimestampOffset_ = function(i) {
    if (!(i.timestampOffset === null || typeof i.timingInfo.start != "number" || i.changedTimestampOffset || this.loaderType_ !== "main")) {
      var a = !1;
      i.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
        videoTimingInfo: i.segment.videoTimingInfo,
        audioTimingInfo: i.segment.audioTimingInfo,
        timingInfo: i.timingInfo
      }), i.changedTimestampOffset = !0, i.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(i.timestampOffset), a = !0), i.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(i.timestampOffset), a = !0), a && this.trigger("timestampoffset");
    }
  }, n.getSegmentStartTimeForTimestampOffsetCalculation_ = function(i) {
    var a = i.videoTimingInfo, o = i.audioTimingInfo, s = i.timingInfo;
    return this.useDtsForTimestampOffset_ ? a && typeof a.transmuxedDecodeStart == "number" ? a.transmuxedDecodeStart : o && typeof o.transmuxedDecodeStart == "number" ? o.transmuxedDecodeStart : s.start : s.start;
  }, n.updateTimingInfoEnd_ = function(i) {
    i.timingInfo = i.timingInfo || {};
    var a = this.getMediaInfo_(), o = this.loaderType_ === "main" && a && a.hasVideo, s = o && i.videoTimingInfo ? i.videoTimingInfo : i.audioTimingInfo;
    !s || (i.timingInfo.end = typeof s.end == "number" ? s.end : s.start + i.duration);
  }, n.handleAppendsDone_ = function() {
    if (this.pendingSegment_ && this.trigger("appendsdone"), !this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    var i = this.pendingSegment_;
    this.updateTimingInfoEnd_(i), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: i,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    var a = hce(i, this.sourceType_);
    if (a && (a.severity === "warn" ? Ce.log.warn(a.message) : this.logger_(a.message)), this.recordThroughput_(i), this.pendingSegment_ = null, this.state = "READY", i.isSyncRequest && (this.trigger("syncinfoupdate"), !i.hasAppendedData_)) {
      this.logger_("Throwing away un-appended sync request " + bu(i));
      return;
    }
    this.logger_("Appended " + bu(i)), this.addSegmentMetadataCue_(i), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== i.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: i.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: i.timeline
    })), this.currentTimeline_ = i.timeline, this.trigger("syncinfoupdate");
    var o = i.segment, s = i.part, l = o.end && this.currentTime_() - o.end > i.playlist.targetDuration * 3, u = s && s.end && this.currentTime_() - s.end > i.playlist.partTargetDuration * 3;
    if (l || u) {
      this.logger_("bad " + (l ? "segment" : "part") + " " + bu(i)), this.resetEverything();
      return;
    }
    var c = this.mediaIndex !== null;
    c && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = i.mediaIndex, this.partIndex = i.partIndex, this.isEndOfStream_(i.mediaIndex, i.playlist, i.partIndex) && this.endOfStream(), this.trigger("appended"), i.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }, n.recordThroughput_ = function(i) {
    if (i.duration < z1) {
      this.logger_("Ignoring segment's throughput because its duration of " + i.duration + (" is less than the min to record " + z1));
      return;
    }
    var a = this.throughput.rate, o = Date.now() - i.endOfAllRequests + 1, s = Math.floor(i.byteLength / o * 8 * 1e3);
    this.throughput.rate += (s - a) / ++this.throughput.count;
  }, n.addSegmentMetadataCue_ = function(i) {
    if (!!this.segmentMetadataTrack_) {
      var a = i.segment, o = a.start, s = a.end;
      if (!(!l9(o) || !l9(s))) {
        dd(o, s, this.segmentMetadataTrack_);
        var l = pe.WebKitDataCue || pe.VTTCue, u = {
          custom: a.custom,
          dateTimeObject: a.dateTimeObject,
          dateTimeString: a.dateTimeString,
          bandwidth: i.playlist.attributes.BANDWIDTH,
          resolution: i.playlist.attributes.RESOLUTION,
          codecs: i.playlist.attributes.CODECS,
          byteLength: i.byteLength,
          uri: i.uri,
          timeline: i.timeline,
          playlist: i.playlist.id,
          start: o,
          end: s
        }, c = JSON.stringify(u), f = new l(o, s, c);
        f.value = u, this.segmentMetadataTrack_.addCue(f);
      }
    }
  }, t;
}(Ce.EventTarget);
function Lo() {
}
var Lx = function(t) {
  return typeof t != "string" ? t : t.replace(/./, function(n) {
    return n.toUpperCase();
  });
}, pce = ["video", "audio"], H4 = function(t, n) {
  var r = n[t + "Buffer"];
  return r && r.updating || n.queuePending[t];
}, vce = function(t, n) {
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    if (i.type === "mediaSource")
      return null;
    if (i.type === t)
      return r;
  }
  return null;
}, G6 = function e(t, n) {
  if (n.queue.length !== 0) {
    var r = 0, i = n.queue[r];
    if (i.type === "mediaSource") {
      !n.updating() && n.mediaSource.readyState !== "closed" && (n.queue.shift(), i.action(n), i.doneFn && i.doneFn(), e("audio", n), e("video", n));
      return;
    }
    if (t !== "mediaSource" && !(!n.ready() || n.mediaSource.readyState === "closed" || H4(t, n))) {
      if (i.type !== t) {
        if (r = vce(t, n.queue), r === null)
          return;
        i = n.queue[r];
      }
      if (n.queue.splice(r, 1), n.queuePending[t] = i, i.action(t, n), !i.doneFn) {
        n.queuePending[t] = null, e(t, n);
        return;
      }
    }
  }
}, Bx = function(t, n) {
  var r = n[t + "Buffer"], i = Lx(t);
  !r || (r.removeEventListener("updateend", n["on" + i + "UpdateEnd_"]), r.removeEventListener("error", n["on" + i + "Error_"]), n.codecs[t] = null, n[t + "Buffer"] = null);
}, no = function(t, n) {
  return t && n && Array.prototype.indexOf.call(t.sourceBuffers, n) !== -1;
}, Vr = {
  appendBuffer: function(t, n, r) {
    return function(i, a) {
      var o = a[i + "Buffer"];
      if (!!no(a.mediaSource, o)) {
        a.logger_("Appending segment " + n.mediaIndex + "'s " + t.length + " bytes to " + i + "Buffer");
        try {
          o.appendBuffer(t);
        } catch (s) {
          a.logger_("Error with code " + s.code + " " + (s.code === Ix ? "(QUOTA_EXCEEDED_ERR) " : "") + ("when appending segment " + n.mediaIndex + " to " + i + "Buffer")), a.queuePending[i] = null, r(s);
        }
      }
    };
  },
  remove: function(t, n) {
    return function(r, i) {
      var a = i[r + "Buffer"];
      if (!!no(i.mediaSource, a)) {
        i.logger_("Removing " + t + " to " + n + " from " + r + "Buffer");
        try {
          a.remove(t, n);
        } catch {
          i.logger_("Remove " + t + " to " + n + " from " + r + "Buffer failed");
        }
      }
    };
  },
  timestampOffset: function(t) {
    return function(n, r) {
      var i = r[n + "Buffer"];
      !no(r.mediaSource, i) || (r.logger_("Setting " + n + "timestampOffset to " + t), i.timestampOffset = t);
    };
  },
  callback: function(t) {
    return function(n, r) {
      t();
    };
  },
  endOfStream: function(t) {
    return function(n) {
      if (n.mediaSource.readyState === "open") {
        n.logger_("Calling mediaSource endOfStream(" + (t || "") + ")");
        try {
          n.mediaSource.endOfStream(t);
        } catch (r) {
          Ce.log.warn("Failed to call media source endOfStream", r);
        }
      }
    };
  },
  duration: function(t) {
    return function(n) {
      n.logger_("Setting mediaSource duration to " + t);
      try {
        n.mediaSource.duration = t;
      } catch (r) {
        Ce.log.warn("Failed to set media source duration", r);
      }
    };
  },
  abort: function() {
    return function(t, n) {
      if (n.mediaSource.readyState === "open") {
        var r = n[t + "Buffer"];
        if (!!no(n.mediaSource, r)) {
          n.logger_("calling abort on " + t + "Buffer");
          try {
            r.abort();
          } catch (i) {
            Ce.log.warn("Failed to abort on " + t + "Buffer", i);
          }
        }
      }
    };
  },
  addSourceBuffer: function(t, n) {
    return function(r) {
      var i = Lx(t), a = Yd(n);
      r.logger_("Adding " + t + "Buffer with codec " + n + " to mediaSource");
      var o = r.mediaSource.addSourceBuffer(a);
      o.addEventListener("updateend", r["on" + i + "UpdateEnd_"]), o.addEventListener("error", r["on" + i + "Error_"]), r.codecs[t] = n, r[t + "Buffer"] = o;
    };
  },
  removeSourceBuffer: function(t) {
    return function(n) {
      var r = n[t + "Buffer"];
      if (Bx(t, n), !!no(n.mediaSource, r)) {
        n.logger_("Removing " + t + "Buffer with codec " + n.codecs[t] + " from mediaSource");
        try {
          n.mediaSource.removeSourceBuffer(r);
        } catch (i) {
          Ce.log.warn("Failed to removeSourceBuffer " + t + "Buffer", i);
        }
      }
    };
  },
  changeType: function(t) {
    return function(n, r) {
      var i = r[n + "Buffer"], a = Yd(t);
      !no(r.mediaSource, i) || r.codecs[n] !== t && (r.logger_("changing " + n + "Buffer codec from " + r.codecs[n] + " to " + t), i.changeType(a), r.codecs[n] = t);
    };
  }
}, Ur = function(t) {
  var n = t.type, r = t.sourceUpdater, i = t.action, a = t.doneFn, o = t.name;
  r.queue.push({
    type: n,
    action: i,
    doneFn: a,
    name: o
  }), G6(n, r);
}, f9 = function(t, n) {
  return function(r) {
    if (n.queuePending[t]) {
      var i = n.queuePending[t].doneFn;
      n.queuePending[t] = null, i && i(n[t + "Error_"]);
    }
    G6(t, n);
  };
}, Nx = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    return i = e.call(this) || this, i.mediaSource = r, i.sourceopenListener_ = function() {
      return G6("mediaSource", on(i));
    }, i.mediaSource.addEventListener("sourceopen", i.sourceopenListener_), i.logger_ = Ya("SourceUpdater"), i.audioTimestampOffset_ = 0, i.videoTimestampOffset_ = 0, i.queue = [], i.queuePending = {
      audio: null,
      video: null
    }, i.delayedAudioAppendQueue_ = [], i.videoAppendQueued_ = !1, i.codecs = {}, i.onVideoUpdateEnd_ = f9("video", on(i)), i.onAudioUpdateEnd_ = f9("audio", on(i)), i.onVideoError_ = function(a) {
      i.videoError_ = a;
    }, i.onAudioError_ = function(a) {
      i.audioError_ = a;
    }, i.createdSourceBuffers_ = !1, i.initializedEme_ = !1, i.triggeredReady_ = !1, i;
  }
  var n = t.prototype;
  return n.initializedEme = function() {
    this.initializedEme_ = !0, this.triggerReady();
  }, n.hasCreatedSourceBuffers = function() {
    return this.createdSourceBuffers_;
  }, n.hasInitializedAnyEme = function() {
    return this.initializedEme_;
  }, n.ready = function() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }, n.createSourceBuffers = function(i) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(i), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }, n.triggerReady = function() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }, n.addSourceBuffer = function(i, a) {
    Ur({
      type: "mediaSource",
      sourceUpdater: this,
      action: Vr.addSourceBuffer(i, a),
      name: "addSourceBuffer"
    });
  }, n.abort = function(i) {
    Ur({
      type: i,
      sourceUpdater: this,
      action: Vr.abort(i),
      name: "abort"
    });
  }, n.removeSourceBuffer = function(i) {
    if (!this.canRemoveSourceBuffer()) {
      Ce.log.error("removeSourceBuffer is not supported!");
      return;
    }
    Ur({
      type: "mediaSource",
      sourceUpdater: this,
      action: Vr.removeSourceBuffer(i),
      name: "removeSourceBuffer"
    });
  }, n.canRemoveSourceBuffer = function() {
    return !Ce.browser.IE_VERSION && !Ce.browser.IS_FIREFOX && pe.MediaSource && pe.MediaSource.prototype && typeof pe.MediaSource.prototype.removeSourceBuffer == "function";
  }, t.canChangeType = function() {
    return pe.SourceBuffer && pe.SourceBuffer.prototype && typeof pe.SourceBuffer.prototype.changeType == "function";
  }, n.canChangeType = function() {
    return this.constructor.canChangeType();
  }, n.changeType = function(i, a) {
    if (!this.canChangeType()) {
      Ce.log.error("changeType is not supported!");
      return;
    }
    Ur({
      type: i,
      sourceUpdater: this,
      action: Vr.changeType(a),
      name: "changeType"
    });
  }, n.addOrChangeSourceBuffers = function(i) {
    var a = this;
    if (!i || typeof i != "object" || Object.keys(i).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(i).forEach(function(o) {
      var s = i[o];
      if (!a.hasCreatedSourceBuffers())
        return a.addSourceBuffer(o, s);
      a.canChangeType() && a.changeType(o, s);
    });
  }, n.appendBuffer = function(i, a) {
    var o = this, s = i.segmentInfo, l = i.type, u = i.bytes;
    if (this.processedAppend_ = !0, l === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([i, a]), this.logger_("delayed audio append of " + u.length + " until video append");
      return;
    }
    var c = a;
    if (Ur({
      type: l,
      sourceUpdater: this,
      action: Vr.appendBuffer(u, s || {
        mediaIndex: -1
      }, c),
      doneFn: a,
      name: "appendBuffer"
    }), l === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      var f = this.delayedAudioAppendQueue_.slice();
      this.logger_("queuing delayed audio " + f.length + " appendBuffers"), this.delayedAudioAppendQueue_.length = 0, f.forEach(function(d) {
        o.appendBuffer.apply(o, d);
      });
    }
  }, n.audioBuffered = function() {
    return no(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : Ce.createTimeRange();
  }, n.videoBuffered = function() {
    return no(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : Ce.createTimeRange();
  }, n.buffered = function() {
    var i = no(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, a = no(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return a && !i ? this.audioBuffered() : i && !a ? this.videoBuffered() : Lle(this.audioBuffered(), this.videoBuffered());
  }, n.setDuration = function(i, a) {
    a === void 0 && (a = Lo), Ur({
      type: "mediaSource",
      sourceUpdater: this,
      action: Vr.duration(i),
      name: "duration",
      doneFn: a
    });
  }, n.endOfStream = function(i, a) {
    i === void 0 && (i = null), a === void 0 && (a = Lo), typeof i != "string" && (i = void 0), Ur({
      type: "mediaSource",
      sourceUpdater: this,
      action: Vr.endOfStream(i),
      name: "endOfStream",
      doneFn: a
    });
  }, n.removeAudio = function(i, a, o) {
    if (o === void 0 && (o = Lo), !this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      o();
      return;
    }
    Ur({
      type: "audio",
      sourceUpdater: this,
      action: Vr.remove(i, a),
      doneFn: o,
      name: "remove"
    });
  }, n.removeVideo = function(i, a, o) {
    if (o === void 0 && (o = Lo), !this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      o();
      return;
    }
    Ur({
      type: "video",
      sourceUpdater: this,
      action: Vr.remove(i, a),
      doneFn: o,
      name: "remove"
    });
  }, n.updating = function() {
    return !!(H4("audio", this) || H4("video", this));
  }, n.audioTimestampOffset = function(i) {
    return typeof i < "u" && this.audioBuffer && this.audioTimestampOffset_ !== i && (Ur({
      type: "audio",
      sourceUpdater: this,
      action: Vr.timestampOffset(i),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = i), this.audioTimestampOffset_;
  }, n.videoTimestampOffset = function(i) {
    return typeof i < "u" && this.videoBuffer && this.videoTimestampOffset !== i && (Ur({
      type: "video",
      sourceUpdater: this,
      action: Vr.timestampOffset(i),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = i), this.videoTimestampOffset_;
  }, n.audioQueueCallback = function(i) {
    !this.audioBuffer || Ur({
      type: "audio",
      sourceUpdater: this,
      action: Vr.callback(i),
      name: "callback"
    });
  }, n.videoQueueCallback = function(i) {
    !this.videoBuffer || Ur({
      type: "video",
      sourceUpdater: this,
      action: Vr.callback(i),
      name: "callback"
    });
  }, n.dispose = function() {
    var i = this;
    this.trigger("dispose"), pce.forEach(function(a) {
      i.abort(a), i.canRemoveSourceBuffer() ? i.removeSourceBuffer(a) : i[a + "QueueCallback"](function() {
        return Bx(a, i);
      });
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }, t;
}(Ce.EventTarget), h9 = function(t) {
  return decodeURIComponent(escape(String.fromCharCode.apply(null, t)));
}, p9 = new Uint8Array(`

`.split("").map(function(e) {
  return e.charCodeAt(0);
})), mce = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i) {
    var a;
    return i === void 0 && (i = {}), a = e.call(this, r, i) || this, a.mediaSource_ = null, a.subtitlesTrack_ = null, a.loaderType_ = "subtitle", a.featuresNativeTextTracks_ = r.featuresNativeTextTracks, a.shouldSaveSegmentTimingInfo_ = !1, a;
  }
  var n = t.prototype;
  return n.createTransmuxer_ = function() {
    return null;
  }, n.buffered_ = function() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return Ce.createTimeRanges();
    var i = this.subtitlesTrack_.cues, a = i[0].startTime, o = i[i.length - 1].startTime;
    return Ce.createTimeRanges([[a, o]]);
  }, n.initSegmentForMap = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var o = ch(i), s = this.initSegments_[o];
    if (a && !s && i.bytes) {
      var l = p9.byteLength + i.bytes.byteLength, u = new Uint8Array(l);
      u.set(i.bytes), u.set(p9, i.bytes.byteLength), this.initSegments_[o] = s = {
        resolvedUri: i.resolvedUri,
        byterange: i.byterange,
        bytes: u
      };
    }
    return s || i;
  }, n.couldBeginLoading_ = function() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }, n.init_ = function() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }, n.track = function(i) {
    return typeof i > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = i, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }, n.remove = function(i, a) {
    dd(i, a, this.subtitlesTrack_);
  }, n.fillBuffer_ = function() {
    var i = this, a = this.chooseNextRequest_();
    if (!!a) {
      if (this.syncController_.timestampOffsetForTimeline(a.timeline) === null) {
        var o = function() {
          i.state = "READY", i.paused() || i.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", o), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(a);
    }
  }, n.timestampOffsetForSegment_ = function() {
    return null;
  }, n.chooseNextRequest_ = function() {
    return this.skipEmptySegments_(e.prototype.chooseNextRequest_.call(this));
  }, n.skipEmptySegments_ = function(i) {
    for (; i && i.segment.empty; ) {
      if (i.mediaIndex + 1 >= i.playlist.segments.length) {
        i = null;
        break;
      }
      i = this.generateSegmentInfo_({
        playlist: i.playlist,
        mediaIndex: i.mediaIndex + 1,
        startOfSegment: i.startOfSegment + i.duration,
        isSyncRequest: i.isSyncRequest
      });
    }
    return i;
  }, n.stopForError = function(i) {
    this.error(i), this.state = "READY", this.pause(), this.trigger("error");
  }, n.segmentRequestFinished_ = function(i, a, o) {
    var s = this;
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(a.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (i) {
      i.code === ao.TIMEOUT && this.handleTimeout_(), i.code === ao.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(i);
      return;
    }
    var l = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(l.duration, a.stats), this.state = "APPENDING", this.trigger("appending");
    var u = l.segment;
    if (u.map && (u.map.bytes = a.map.bytes), l.bytes = a.bytes, typeof pe.WebVTT != "function" && this.subtitlesTrack_ && this.subtitlesTrack_.tech_) {
      var c, f = function() {
        s.subtitlesTrack_.tech_.off("vttjsloaded", c), s.stopForError({
          message: "Error loading vtt.js"
        });
      };
      c = function() {
        s.subtitlesTrack_.tech_.off("vttjserror", f), s.segmentRequestFinished_(i, a, o);
      }, this.state = "WAITING_ON_VTTJS", this.subtitlesTrack_.tech_.one("vttjsloaded", c), this.subtitlesTrack_.tech_.one("vttjserror", f);
      return;
    }
    u.requested = !0;
    try {
      this.parseVTTCues_(l);
    } catch (d) {
      this.stopForError({
        message: d.message
      });
      return;
    }
    if (this.updateTimeMapping_(l, this.syncController_.timelines[l.timeline], this.playlist_), l.cues.length ? l.timingInfo = {
      start: l.cues[0].startTime,
      end: l.cues[l.cues.length - 1].endTime
    } : l.timingInfo = {
      start: l.startOfSegment,
      end: l.startOfSegment + l.duration
    }, l.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    l.byteLength = l.bytes.byteLength, this.mediaSecondsLoaded += u.duration, l.cues.forEach(function(d) {
      s.subtitlesTrack_.addCue(s.featuresNativeTextTracks_ ? new pe.VTTCue(d.startTime, d.endTime, d.text) : d);
    }), nce(this.subtitlesTrack_), this.handleAppendsDone_();
  }, n.handleData_ = function() {
  }, n.updateTimingInfoEnd_ = function() {
  }, n.parseVTTCues_ = function(i) {
    var a, o = !1;
    typeof pe.TextDecoder == "function" ? a = new pe.TextDecoder("utf8") : (a = pe.WebVTT.StringDecoder(), o = !0);
    var s = new pe.WebVTT.Parser(pe, pe.vttjs, a);
    if (i.cues = [], i.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, s.oncue = i.cues.push.bind(i.cues), s.ontimestampmap = function(c) {
      i.timestampmap = c;
    }, s.onparsingerror = function(c) {
      Ce.log.warn("Error encountered when parsing cues: " + c.message);
    }, i.segment.map) {
      var l = i.segment.map.bytes;
      o && (l = h9(l)), s.parse(l);
    }
    var u = i.bytes;
    o && (u = h9(u)), s.parse(u), s.flush();
  }, n.updateTimeMapping_ = function(i, a, o) {
    var s = i.segment;
    if (!!a) {
      if (!i.cues.length) {
        s.empty = !0;
        return;
      }
      var l = i.timestampmap, u = l.MPEGTS / J0.ONE_SECOND_IN_TS - l.LOCAL + a.mapping;
      if (i.cues.forEach(function(d) {
        d.startTime += u, d.endTime += u;
      }), !o.syncInfo) {
        var c = i.cues[0].startTime, f = i.cues[i.cues.length - 1].startTime;
        o.syncInfo = {
          mediaSequence: o.mediaSequence + i.mediaIndex,
          time: Math.min(c, f - s.duration)
        };
      }
    }
  }, t;
}(M4), gce = function(t, n) {
  for (var r = t.cues, i = 0; i < r.length; i++) {
    var a = r[i];
    if (n >= a.adStartTime && n <= a.adEndTime)
      return a;
  }
  return null;
}, yce = function(t, n, r) {
  if (r === void 0 && (r = 0), !!t.segments)
    for (var i = r, a, o = 0; o < t.segments.length; o++) {
      var s = t.segments[o];
      if (a || (a = gce(n, i + s.duration / 2)), a) {
        if ("cueIn" in s) {
          a.endTime = i, a.adEndTime = i, i += s.duration, a = null;
          continue;
        }
        if (i < a.endTime) {
          i += s.duration;
          continue;
        }
        a.endTime += s.duration;
      } else if ("cueOut" in s && (a = new pe.VTTCue(i, i + s.duration, s.cueOut), a.adStartTime = i, a.adEndTime = i + parseFloat(s.cueOut), n.addCue(a)), "cueOutCont" in s) {
        var l = s.cueOutCont.split("/").map(parseFloat), u = l[0], c = l[1];
        a = new pe.VTTCue(i, i + s.duration, ""), a.adStartTime = i - u, a.adEndTime = a.adStartTime + c, n.addCue(a);
      }
      i += s.duration;
    }
}, bce = 86400, v9 = [
  {
    name: "VOD",
    run: function(t, n, r, i, a) {
      if (r !== 1 / 0) {
        var o = {
          time: 0,
          segmentIndex: 0,
          partIndex: null
        };
        return o;
      }
      return null;
    }
  },
  {
    name: "ProgramDateTime",
    run: function(t, n, r, i, a) {
      if (!Object.keys(t.timelineToDatetimeMappings).length)
        return null;
      var o = null, s = null, l = x4(n);
      a = a || 0;
      for (var u = 0; u < l.length; u++) {
        var c = n.endList || a === 0 ? u : l.length - (u + 1), f = l[c], d = f.segment, h = t.timelineToDatetimeMappings[d.timeline];
        if (!(!h || !d.dateTimeObject)) {
          var p = d.dateTimeObject.getTime() / 1e3, y = p + h;
          if (d.parts && typeof f.partIndex == "number")
            for (var m = 0; m < f.partIndex; m++)
              y += d.parts[m].duration;
          var b = Math.abs(a - y);
          if (s !== null && (b === 0 || s < b))
            break;
          s = b, o = {
            time: y,
            segmentIndex: f.segmentIndex,
            partIndex: f.partIndex
          };
        }
      }
      return o;
    }
  },
  {
    name: "Segment",
    run: function(t, n, r, i, a) {
      var o = null, s = null;
      a = a || 0;
      for (var l = x4(n), u = 0; u < l.length; u++) {
        var c = n.endList || a === 0 ? u : l.length - (u + 1), f = l[c], d = f.segment, h = f.part && f.part.start || d && d.start;
        if (d.timeline === i && typeof h < "u") {
          var p = Math.abs(a - h);
          if (s !== null && s < p)
            break;
          (!o || s === null || s >= p) && (s = p, o = {
            time: h,
            segmentIndex: f.segmentIndex,
            partIndex: f.partIndex
          });
        }
      }
      return o;
    }
  },
  {
    name: "Discontinuity",
    run: function(t, n, r, i, a) {
      var o = null;
      if (a = a || 0, n.discontinuityStarts && n.discontinuityStarts.length)
        for (var s = null, l = 0; l < n.discontinuityStarts.length; l++) {
          var u = n.discontinuityStarts[l], c = n.discontinuitySequence + l + 1, f = t.discontinuities[c];
          if (f) {
            var d = Math.abs(a - f.time);
            if (s !== null && s < d)
              break;
            (!o || s === null || s >= d) && (s = d, o = {
              time: f.time,
              segmentIndex: u,
              partIndex: null
            });
          }
        }
      return o;
    }
  },
  {
    name: "Playlist",
    run: function(t, n, r, i, a) {
      if (n.syncInfo) {
        var o = {
          time: n.syncInfo.time,
          segmentIndex: n.syncInfo.mediaSequence - n.mediaSequence,
          partIndex: null
        };
        return o;
      }
      return null;
    }
  }
], Ace = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    return i = e.call(this) || this, i.timelines = [], i.discontinuities = [], i.timelineToDatetimeMappings = {}, i.logger_ = Ya("SyncController"), i;
  }
  var n = t.prototype;
  return n.getSyncPoint = function(i, a, o, s) {
    var l = this.runStrategies_(i, a, o, s);
    return l.length ? this.selectSyncPoint_(l, {
      key: "time",
      value: s
    }) : null;
  }, n.getExpiredTime = function(i, a) {
    if (!i || !i.segments)
      return null;
    var o = this.runStrategies_(i, a, i.discontinuitySequence, 0);
    if (!o.length)
      return null;
    var s = this.selectSyncPoint_(o, {
      key: "segmentIndex",
      value: 0
    });
    return s.segmentIndex > 0 && (s.time *= -1), Math.abs(s.time + Cd({
      defaultDuration: i.targetDuration,
      durationList: i.segments,
      startIndex: s.segmentIndex,
      endIndex: 0
    }));
  }, n.runStrategies_ = function(i, a, o, s) {
    for (var l = [], u = 0; u < v9.length; u++) {
      var c = v9[u], f = c.run(this, i, a, o, s);
      f && (f.strategy = c.name, l.push({
        strategy: c.name,
        syncPoint: f
      }));
    }
    return l;
  }, n.selectSyncPoint_ = function(i, a) {
    for (var o = i[0].syncPoint, s = Math.abs(i[0].syncPoint[a.key] - a.value), l = i[0].strategy, u = 1; u < i.length; u++) {
      var c = Math.abs(i[u].syncPoint[a.key] - a.value);
      c < s && (s = c, o = i[u].syncPoint, l = i[u].strategy);
    }
    return this.logger_("syncPoint for [" + a.key + ": " + a.value + "] chosen with strategy" + (" [" + l + "]: [time:" + o.time + ",") + (" segmentIndex:" + o.segmentIndex) + (typeof o.partIndex == "number" ? ",partIndex:" + o.partIndex : "") + "]"), o;
  }, n.saveExpiredSegmentInfo = function(i, a) {
    var o = a.mediaSequence - i.mediaSequence;
    if (o > bce) {
      Ce.log.warn("Not saving expired segment info. Media sequence gap " + o + " is too large.");
      return;
    }
    for (var s = o - 1; s >= 0; s--) {
      var l = i.segments[s];
      if (l && typeof l.start < "u") {
        a.syncInfo = {
          mediaSequence: i.mediaSequence + s,
          time: l.start
        }, this.logger_("playlist refresh sync: [time:" + a.syncInfo.time + "," + (" mediaSequence: " + a.syncInfo.mediaSequence + "]")), this.trigger("syncinfoupdate");
        break;
      }
    }
  }, n.setDateTimeMappingForStart = function(i) {
    if (this.timelineToDatetimeMappings = {}, i.segments && i.segments.length && i.segments[0].dateTimeObject) {
      var a = i.segments[0], o = a.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[a.timeline] = -o;
    }
  }, n.saveSegmentTimingInfo = function(i) {
    var a = i.segmentInfo, o = i.shouldSaveTimelineMapping, s = this.calculateSegmentTimeMapping_(a, a.timingInfo, o), l = a.segment;
    s && (this.saveDiscontinuitySyncInfo_(a), a.playlist.syncInfo || (a.playlist.syncInfo = {
      mediaSequence: a.playlist.mediaSequence + a.mediaIndex,
      time: l.start
    }));
    var u = l.dateTimeObject;
    l.discontinuity && o && u && (this.timelineToDatetimeMappings[l.timeline] = -(u.getTime() / 1e3));
  }, n.timestampOffsetForTimeline = function(i) {
    return typeof this.timelines[i] > "u" ? null : this.timelines[i].time;
  }, n.mappingForTimeline = function(i) {
    return typeof this.timelines[i] > "u" ? null : this.timelines[i].mapping;
  }, n.calculateSegmentTimeMapping_ = function(i, a, o) {
    var s = i.segment, l = i.part, u = this.timelines[i.timeline], c, f;
    if (typeof i.timestampOffset == "number")
      u = {
        time: i.startOfSegment,
        mapping: i.startOfSegment - a.start
      }, o && (this.timelines[i.timeline] = u, this.trigger("timestampoffset"), this.logger_("time mapping for timeline " + i.timeline + ": " + ("[time: " + u.time + "] [mapping: " + u.mapping + "]"))), c = i.startOfSegment, f = a.end + u.mapping;
    else if (u)
      c = a.start + u.mapping, f = a.end + u.mapping;
    else
      return !1;
    return l && (l.start = c, l.end = f), (!s.start || c < s.start) && (s.start = c), s.end = f, !0;
  }, n.saveDiscontinuitySyncInfo_ = function(i) {
    var a = i.playlist, o = i.segment;
    if (o.discontinuity)
      this.discontinuities[o.timeline] = {
        time: o.start,
        accuracy: 0
      };
    else if (a.discontinuityStarts && a.discontinuityStarts.length)
      for (var s = 0; s < a.discontinuityStarts.length; s++) {
        var l = a.discontinuityStarts[s], u = a.discontinuitySequence + s + 1, c = l - i.mediaIndex, f = Math.abs(c);
        if (!this.discontinuities[u] || this.discontinuities[u].accuracy > f) {
          var d = void 0;
          c < 0 ? d = o.start - Cd({
            defaultDuration: a.targetDuration,
            durationList: a.segments,
            startIndex: i.mediaIndex,
            endIndex: l
          }) : d = o.end + Cd({
            defaultDuration: a.targetDuration,
            durationList: a.segments,
            startIndex: i.mediaIndex + 1,
            endIndex: l
          }), this.discontinuities[u] = {
            time: d,
            accuracy: f
          };
        }
      }
  }, n.dispose = function() {
    this.trigger("dispose"), this.off();
  }, t;
}(Ce.EventTarget), Tce = /* @__PURE__ */ function(e) {
  At(t, e);
  function t() {
    var r;
    return r = e.call(this) || this, r.pendingTimelineChanges_ = {}, r.lastTimelineChanges_ = {}, r;
  }
  var n = t.prototype;
  return n.clearPendingTimelineChange = function(i) {
    this.pendingTimelineChanges_[i] = null, this.trigger("pendingtimelinechange");
  }, n.pendingTimelineChange = function(i) {
    var a = i.type, o = i.from, s = i.to;
    return typeof o == "number" && typeof s == "number" && (this.pendingTimelineChanges_[a] = {
      type: a,
      from: o,
      to: s
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[a];
  }, n.lastTimelineChange = function(i) {
    var a = i.type, o = i.from, s = i.to;
    return typeof o == "number" && typeof s == "number" && (this.lastTimelineChanges_[a] = {
      type: a,
      from: o,
      to: s
    }, delete this.pendingTimelineChanges_[a], this.trigger("timelinechange")), this.lastTimelineChanges_[a];
  }, n.dispose = function() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }, t;
}(Ce.EventTarget), wce = Px(xx(function() {
  var e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
  function t(S, C, v) {
    return v = {
      path: C,
      exports: {},
      require: function(V, R) {
        return n(V, R == null ? v.path : R);
      }
    }, S(v, v.exports), v.exports;
  }
  function n() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }
  var r = t(function(S) {
    function C(H, V) {
      for (var R = 0; R < V.length; R++) {
        var F = V[R];
        F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(H, F.key, F);
      }
    }
    function v(H, V, R) {
      return V && C(H.prototype, V), R && C(H, R), H;
    }
    S.exports = v, S.exports.default = S.exports, S.exports.__esModule = !0;
  }), i = t(function(S) {
    function C(v, H) {
      return S.exports = C = Object.setPrototypeOf || function(R, F) {
        return R.__proto__ = F, R;
      }, S.exports.default = S.exports, S.exports.__esModule = !0, C(v, H);
    }
    S.exports = C, S.exports.default = S.exports, S.exports.__esModule = !0;
  }), a = t(function(S) {
    function C(v, H) {
      v.prototype = Object.create(H.prototype), v.prototype.constructor = v, i(v, H);
    }
    S.exports = C, S.exports.default = S.exports, S.exports.__esModule = !0;
  }), o = /* @__PURE__ */ function() {
    function S() {
      this.listeners = {};
    }
    var C = S.prototype;
    return C.on = function(H, V) {
      this.listeners[H] || (this.listeners[H] = []), this.listeners[H].push(V);
    }, C.off = function(H, V) {
      if (!this.listeners[H])
        return !1;
      var R = this.listeners[H].indexOf(V);
      return this.listeners[H] = this.listeners[H].slice(0), this.listeners[H].splice(R, 1), R > -1;
    }, C.trigger = function(H) {
      var V = this.listeners[H];
      if (!!V)
        if (arguments.length === 2)
          for (var R = V.length, F = 0; F < R; ++F)
            V[F].call(this, arguments[1]);
        else
          for (var K = Array.prototype.slice.call(arguments, 1), q = V.length, G = 0; G < q; ++G)
            V[G].apply(this, K);
    }, C.dispose = function() {
      this.listeners = {};
    }, C.pipe = function(H) {
      this.on("data", function(V) {
        H.push(V);
      });
    }, S;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function s(S) {
    return S.subarray(0, S.byteLength - S[S.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
  var l = function() {
    var C = [[[], [], [], [], []], [[], [], [], [], []]], v = C[0], H = C[1], V = v[4], R = H[4], F, K, q, G = [], te = [], Q, Y, Z, oe, he, Ae;
    for (F = 0; F < 256; F++)
      te[(G[F] = F << 1 ^ (F >> 7) * 283) ^ F] = F;
    for (K = q = 0; !V[K]; K ^= Q || 1, q = te[q] || 1)
      for (oe = q ^ q << 1 ^ q << 2 ^ q << 3 ^ q << 4, oe = oe >> 8 ^ oe & 255 ^ 99, V[K] = oe, R[oe] = K, Z = G[Y = G[Q = G[K]]], Ae = Z * 16843009 ^ Y * 65537 ^ Q * 257 ^ K * 16843008, he = G[oe] * 257 ^ oe * 16843008, F = 0; F < 4; F++)
        v[F][K] = he = he << 24 ^ he >>> 8, H[F][oe] = Ae = Ae << 24 ^ Ae >>> 8;
    for (F = 0; F < 5; F++)
      v[F] = v[F].slice(0), H[F] = H[F].slice(0);
    return C;
  }, u = null, c = /* @__PURE__ */ function() {
    function S(v) {
      u || (u = l()), this._tables = [[u[0][0].slice(), u[0][1].slice(), u[0][2].slice(), u[0][3].slice(), u[0][4].slice()], [u[1][0].slice(), u[1][1].slice(), u[1][2].slice(), u[1][3].slice(), u[1][4].slice()]];
      var H, V, R, F = this._tables[0][4], K = this._tables[1], q = v.length, G = 1;
      if (q !== 4 && q !== 6 && q !== 8)
        throw new Error("Invalid aes key size");
      var te = v.slice(0), Q = [];
      for (this._key = [te, Q], H = q; H < 4 * q + 28; H++)
        R = te[H - 1], (H % q === 0 || q === 8 && H % q === 4) && (R = F[R >>> 24] << 24 ^ F[R >> 16 & 255] << 16 ^ F[R >> 8 & 255] << 8 ^ F[R & 255], H % q === 0 && (R = R << 8 ^ R >>> 24 ^ G << 24, G = G << 1 ^ (G >> 7) * 283)), te[H] = te[H - q] ^ R;
      for (V = 0; H; V++, H--)
        R = te[V & 3 ? H : H - 4], H <= 4 || V < 4 ? Q[V] = R : Q[V] = K[0][F[R >>> 24]] ^ K[1][F[R >> 16 & 255]] ^ K[2][F[R >> 8 & 255]] ^ K[3][F[R & 255]];
    }
    var C = S.prototype;
    return C.decrypt = function(H, V, R, F, K, q) {
      var G = this._key[1], te = H ^ G[0], Q = F ^ G[1], Y = R ^ G[2], Z = V ^ G[3], oe, he, Ae, We = G.length / 4 - 2, ke, Re = 4, ve = this._tables[1], Ye = ve[0], Qe = ve[1], ot = ve[2], Ve = ve[3], Te = ve[4];
      for (ke = 0; ke < We; ke++)
        oe = Ye[te >>> 24] ^ Qe[Q >> 16 & 255] ^ ot[Y >> 8 & 255] ^ Ve[Z & 255] ^ G[Re], he = Ye[Q >>> 24] ^ Qe[Y >> 16 & 255] ^ ot[Z >> 8 & 255] ^ Ve[te & 255] ^ G[Re + 1], Ae = Ye[Y >>> 24] ^ Qe[Z >> 16 & 255] ^ ot[te >> 8 & 255] ^ Ve[Q & 255] ^ G[Re + 2], Z = Ye[Z >>> 24] ^ Qe[te >> 16 & 255] ^ ot[Q >> 8 & 255] ^ Ve[Y & 255] ^ G[Re + 3], Re += 4, te = oe, Q = he, Y = Ae;
      for (ke = 0; ke < 4; ke++)
        K[(3 & -ke) + q] = Te[te >>> 24] << 24 ^ Te[Q >> 16 & 255] << 16 ^ Te[Y >> 8 & 255] << 8 ^ Te[Z & 255] ^ G[Re++], oe = te, te = Q, Q = Y, Y = Z, Z = oe;
    }, S;
  }(), f = /* @__PURE__ */ function(S) {
    a(C, S);
    function C() {
      var H;
      return H = S.call(this, o) || this, H.jobs = [], H.delay = 1, H.timeout_ = null, H;
    }
    var v = C.prototype;
    return v.processJob_ = function() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }, v.push = function(V) {
      this.jobs.push(V), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }, C;
  }(o), d = function(C) {
    return C << 24 | (C & 65280) << 8 | (C & 16711680) >> 8 | C >>> 24;
  }, h = function(C, v, H) {
    var V = new Int32Array(C.buffer, C.byteOffset, C.byteLength >> 2), R = new c(Array.prototype.slice.call(v)), F = new Uint8Array(C.byteLength), K = new Int32Array(F.buffer), q, G, te, Q, Y, Z, oe, he, Ae;
    for (q = H[0], G = H[1], te = H[2], Q = H[3], Ae = 0; Ae < V.length; Ae += 4)
      Y = d(V[Ae]), Z = d(V[Ae + 1]), oe = d(V[Ae + 2]), he = d(V[Ae + 3]), R.decrypt(Y, Z, oe, he, K, Ae), K[Ae] = d(K[Ae] ^ q), K[Ae + 1] = d(K[Ae + 1] ^ G), K[Ae + 2] = d(K[Ae + 2] ^ te), K[Ae + 3] = d(K[Ae + 3] ^ Q), q = Y, G = Z, te = oe, Q = he;
    return F;
  }, p = /* @__PURE__ */ function() {
    function S(v, H, V, R) {
      var F = S.STEP, K = new Int32Array(v.buffer), q = new Uint8Array(v.byteLength), G = 0;
      for (this.asyncStream_ = new f(), this.asyncStream_.push(this.decryptChunk_(K.subarray(G, G + F), H, V, q)), G = F; G < K.length; G += F)
        V = new Uint32Array([d(K[G - 4]), d(K[G - 3]), d(K[G - 2]), d(K[G - 1])]), this.asyncStream_.push(this.decryptChunk_(K.subarray(G, G + F), H, V, q));
      this.asyncStream_.push(function() {
        R(null, s(q));
      });
    }
    var C = S.prototype;
    return C.decryptChunk_ = function(H, V, R, F) {
      return function() {
        var K = h(H, V, R);
        F.set(K, H.byteOffset);
      };
    }, r(S, null, [{
      key: "STEP",
      get: function() {
        return 32e3;
      }
    }]), S;
  }(), y;
  typeof window < "u" ? y = window : typeof e < "u" ? y = e : typeof self < "u" ? y = self : y = {};
  var m = y, b = function(C) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(C) : C && C.buffer instanceof ArrayBuffer;
  }, x = m.BigInt || Number;
  x("0x1"), x("0x100"), x("0x10000"), x("0x1000000"), x("0x100000000"), x("0x10000000000"), x("0x1000000000000"), x("0x100000000000000"), x("0x10000000000000000");
  var D = function(C) {
    var v = {};
    return Object.keys(C).forEach(function(H) {
      var V = C[H];
      b(V) ? v[H] = {
        bytes: V.buffer,
        byteOffset: V.byteOffset,
        byteLength: V.byteLength
      } : v[H] = V;
    }), v;
  };
  self.onmessage = function(S) {
    var C = S.data, v = new Uint8Array(C.encrypted.bytes, C.encrypted.byteOffset, C.encrypted.byteLength), H = new Uint32Array(C.key.bytes, C.key.byteOffset, C.key.byteLength / 4), V = new Uint32Array(C.iv.bytes, C.iv.byteOffset, C.iv.byteLength / 4);
    new p(v, H, V, function(R, F) {
      self.postMessage(D({
        source: C.source,
        decrypted: F
      }), [F.buffer]);
    });
  };
})), Pce = wx(wce), xce = function(t) {
  var n = t.default ? "main" : "alternative";
  return t.characteristics && t.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (n = "main-desc"), n;
}, ph = function(t, n) {
  t.abort(), t.pause(), n && n.activePlaylistLoader && (n.activePlaylistLoader.pause(), n.activePlaylistLoader = null);
}, I4 = function(t, n) {
  n.activePlaylistLoader = t, t.load();
}, Cce = function(t, n) {
  return function() {
    var r = n.segmentLoaders, i = r[t], a = r.main, o = n.mediaTypes[t], s = o.activeTrack(), l = o.getActiveGroup(), u = o.activePlaylistLoader, c = o.lastGroup_;
    if (!(l && c && l.id === c.id) && (o.lastGroup_ = l, o.lastTrack_ = s, ph(i, o), !(!l || l.isMasterPlaylist))) {
      if (!l.playlistLoader) {
        u && a.resetEverything();
        return;
      }
      i.resyncLoader(), I4(l.playlistLoader, o);
    }
  };
}, Sce = function(t, n) {
  return function() {
    var r = n.segmentLoaders[t], i = n.mediaTypes[t];
    i.lastGroup_ = null, r.abort(), r.pause();
  };
}, Ece = function(t, n) {
  return function() {
    var r = n.masterPlaylistLoader, i = n.segmentLoaders, a = i[t], o = i.main, s = n.mediaTypes[t], l = s.activeTrack(), u = s.getActiveGroup(), c = s.activePlaylistLoader, f = s.lastTrack_;
    if (!(f && l && f.id === l.id) && (s.lastGroup_ = u, s.lastTrack_ = l, ph(a, s), !!u)) {
      if (u.isMasterPlaylist) {
        if (!l || !f || l.id === f.id)
          return;
        var d = n.vhs.masterPlaylistController_, h = d.selectPlaylist();
        if (d.media() === h)
          return;
        s.logger_("track change. Switching master audio from " + f.id + " to " + l.id), r.pause(), o.resetEverything(), d.fastQualityChange_(h);
        return;
      }
      if (t === "AUDIO") {
        if (!u.playlistLoader) {
          o.setAudio(!0), o.resetEverything();
          return;
        }
        a.setAudio(!0), o.setAudio(!1);
      }
      if (c === u.playlistLoader) {
        I4(u.playlistLoader, s);
        return;
      }
      a.track && a.track(l), a.resetEverything(), I4(u.playlistLoader, s);
    }
  };
}, vh = {
  AUDIO: function(t, n) {
    return function() {
      var r = n.segmentLoaders[t], i = n.mediaTypes[t], a = n.blacklistCurrentPlaylist;
      ph(r, i);
      var o = i.activeTrack(), s = i.activeGroup(), l = (s.filter(function(f) {
        return f.default;
      })[0] || s[0]).id, u = i.tracks[l];
      if (o === u) {
        a({
          message: "Problem encountered loading the default audio track."
        });
        return;
      }
      Ce.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
      for (var c in i.tracks)
        i.tracks[c].enabled = i.tracks[c] === u;
      i.onTrackChanged();
    };
  },
  SUBTITLES: function(t, n) {
    return function() {
      var r = n.segmentLoaders[t], i = n.mediaTypes[t];
      Ce.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track."), ph(r, i);
      var a = i.activeTrack();
      a && (a.mode = "disabled"), i.onTrackChanged();
    };
  }
}, m9 = {
  AUDIO: function(t, n, r) {
    if (!!n) {
      var i = r.tech, a = r.requestOptions, o = r.segmentLoaders[t];
      n.on("loadedmetadata", function() {
        var s = n.media();
        o.playlist(s, a), (!i.paused() || s.endList && i.preload() !== "none") && o.load();
      }), n.on("loadedplaylist", function() {
        o.playlist(n.media(), a), i.paused() || o.load();
      }), n.on("error", vh[t](t, r));
    }
  },
  SUBTITLES: function(t, n, r) {
    var i = r.tech, a = r.requestOptions, o = r.segmentLoaders[t], s = r.mediaTypes[t];
    n.on("loadedmetadata", function() {
      var l = n.media();
      o.playlist(l, a), o.track(s.activeTrack()), (!i.paused() || l.endList && i.preload() !== "none") && o.load();
    }), n.on("loadedplaylist", function() {
      o.playlist(n.media(), a), i.paused() || o.load();
    }), n.on("error", vh[t](t, r));
  }
}, kce = {
  AUDIO: function(t, n) {
    var r = n.vhs, i = n.sourceType, a = n.segmentLoaders[t], o = n.requestOptions, s = n.master.mediaGroups, l = n.mediaTypes[t], u = l.groups, c = l.tracks, f = l.logger_, d = n.masterPlaylistLoader, h = Mf(d.master);
    (!s[t] || Object.keys(s[t]).length === 0) && (s[t] = {
      main: {
        default: {
          default: !0
        }
      }
    }, h && (s[t].main.default.playlists = d.master.playlists));
    for (var p in s[t]) {
      u[p] || (u[p] = []);
      for (var y in s[t][p]) {
        var m = s[t][p][y], b = void 0;
        if (h ? (f("AUDIO group '" + p + "' label '" + y + "' is a master playlist"), m.isMasterPlaylist = !0, b = null) : i === "vhs-json" && m.playlists ? b = new Eu(m.playlists[0], r, o) : m.resolvedUri ? b = new Eu(m.resolvedUri, r, o) : m.playlists && i === "dash" ? b = new z4(m.playlists[0], r, o, d) : b = null, m = Ce.mergeOptions({
          id: y,
          playlistLoader: b
        }, m), m9[t](t, m.playlistLoader, n), u[p].push(m), typeof c[y] > "u") {
          var x = new Ce.AudioTrack({
            id: y,
            kind: xce(m),
            enabled: !1,
            language: m.language,
            default: m.default,
            label: y
          });
          c[y] = x;
        }
      }
    }
    a.on("error", vh[t](t, n));
  },
  SUBTITLES: function(t, n) {
    var r = n.tech, i = n.vhs, a = n.sourceType, o = n.segmentLoaders[t], s = n.requestOptions, l = n.master.mediaGroups, u = n.mediaTypes[t], c = u.groups, f = u.tracks, d = n.masterPlaylistLoader;
    for (var h in l[t]) {
      c[h] || (c[h] = []);
      for (var p in l[t][h])
        if (!l[t][h][p].forced) {
          var y = l[t][h][p], m = void 0;
          if (a === "hls")
            m = new Eu(y.resolvedUri, i, s);
          else if (a === "dash") {
            var b = y.playlists.filter(function(D) {
              return D.excludeUntil !== 1 / 0;
            });
            if (!b.length)
              return;
            m = new z4(y.playlists[0], i, s, d);
          } else
            a === "vhs-json" && (m = new Eu(
              y.playlists ? y.playlists[0] : y.resolvedUri,
              i,
              s
            ));
          if (y = Ce.mergeOptions({
            id: p,
            playlistLoader: m
          }, y), m9[t](t, y.playlistLoader, n), c[h].push(y), typeof f[p] > "u") {
            var x = r.addRemoteTextTrack({
              id: p,
              kind: "subtitles",
              default: y.default && y.autoselect,
              language: y.language,
              label: p
            }, !1).track;
            f[p] = x;
          }
        }
    }
    o.on("error", vh[t](t, n));
  },
  "CLOSED-CAPTIONS": function(t, n) {
    var r = n.tech, i = n.master.mediaGroups, a = n.mediaTypes[t], o = a.groups, s = a.tracks;
    for (var l in i[t]) {
      o[l] || (o[l] = []);
      for (var u in i[t][l]) {
        var c = i[t][l][u];
        if (!!/^(?:CC|SERVICE)/.test(c.instreamId)) {
          var f = r.options_.vhs && r.options_.vhs.captionServices || {}, d = {
            label: u,
            language: c.language,
            instreamId: c.instreamId,
            default: c.default && c.autoselect
          };
          if (f[d.instreamId] && (d = Ce.mergeOptions(d, f[d.instreamId])), d.default === void 0 && delete d.default, o[l].push(Ce.mergeOptions({
            id: u
          }, c)), typeof s[u] > "u") {
            var h = r.addRemoteTextTrack({
              id: d.instreamId,
              kind: "captions",
              default: d.default,
              language: d.language,
              label: d.label
            }, !1).track;
            s[u] = h;
          }
        }
      }
    }
  }
}, Oce = function e(t, n) {
  for (var r = 0; r < t.length; r++)
    if (q6(n, t[r]) || t[r].playlists && e(t[r].playlists, n))
      return !0;
  return !1;
}, zce = function(t, n) {
  return function(r) {
    var i = n.masterPlaylistLoader, a = n.mediaTypes[t].groups, o = i.media();
    if (!o)
      return null;
    var s = null;
    o.attributes[t] && (s = a[o.attributes[t]]);
    var l = Object.keys(a);
    if (!s)
      if (t === "AUDIO" && l.length > 1 && Mf(n.master))
        for (var u = 0; u < l.length; u++) {
          var c = a[l[u]];
          if (Oce(c, o)) {
            s = c;
            break;
          }
        }
      else
        a.main ? s = a.main : l.length === 1 && (s = a[l[0]]);
    return typeof r > "u" ? s : r === null || !s ? null : s.filter(function(f) {
      return f.id === r.id;
    })[0] || null;
  };
}, Dce = {
  AUDIO: function(t, n) {
    return function() {
      var r = n.mediaTypes[t].tracks;
      for (var i in r)
        if (r[i].enabled)
          return r[i];
      return null;
    };
  },
  SUBTITLES: function(t, n) {
    return function() {
      var r = n.mediaTypes[t].tracks;
      for (var i in r)
        if (r[i].mode === "showing" || r[i].mode === "hidden")
          return r[i];
      return null;
    };
  }
}, Mce = function(t, n) {
  var r = n.mediaTypes;
  return function() {
    var i = r[t].activeTrack();
    return i ? r[t].activeGroup(i) : null;
  };
}, Hce = function(t) {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(p) {
    kce[p](p, t);
  });
  var n = t.mediaTypes, r = t.masterPlaylistLoader, i = t.tech, a = t.vhs, o = t.segmentLoaders, s = o.AUDIO, l = o.main;
  ["AUDIO", "SUBTITLES"].forEach(function(p) {
    n[p].activeGroup = zce(p, t), n[p].activeTrack = Dce[p](p, t), n[p].onGroupChanged = Cce(p, t), n[p].onGroupChanging = Sce(p, t), n[p].onTrackChanged = Ece(p, t), n[p].getActiveGroup = Mce(p, t);
  });
  var u = n.AUDIO.activeGroup();
  if (u) {
    var c = (u.filter(function(p) {
      return p.default;
    })[0] || u[0]).id;
    n.AUDIO.tracks[c].enabled = !0, n.AUDIO.onGroupChanged(), n.AUDIO.onTrackChanged();
    var f = n.AUDIO.getActiveGroup();
    f.playlistLoader ? (l.setAudio(!1), s.setAudio(!0)) : l.setAudio(!0);
  }
  r.on("mediachange", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(p) {
      return n[p].onGroupChanged();
    });
  }), r.on("mediachanging", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(p) {
      return n[p].onGroupChanging();
    });
  });
  var d = function() {
    n.AUDIO.onTrackChanged(), i.trigger({
      type: "usage",
      name: "vhs-audio-change"
    }), i.trigger({
      type: "usage",
      name: "hls-audio-change"
    });
  };
  i.audioTracks().addEventListener("change", d), i.remoteTextTracks().addEventListener("change", n.SUBTITLES.onTrackChanged), a.on("dispose", function() {
    i.audioTracks().removeEventListener("change", d), i.remoteTextTracks().removeEventListener("change", n.SUBTITLES.onTrackChanged);
  }), i.clearTracks("audio");
  for (var h in n.AUDIO.tracks)
    i.audioTracks().addTrack(n.AUDIO.tracks[h]);
}, Ice = function() {
  var t = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(n) {
    t[n] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Lo,
      activeTrack: Lo,
      getActiveGroup: Lo,
      onGroupChanged: Lo,
      onTrackChanged: Lo,
      lastTrack_: null,
      logger_: Ya("MediaGroups[" + n + "]")
    };
  }), t;
}, Lce = 60 * 2, Eo, Bce = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], Nce = function(t) {
  return this.audioSegmentLoader_[t] + this.mainSegmentLoader_[t];
}, jce = function(t) {
  var n = t.currentPlaylist, r = t.buffered, i = t.currentTime, a = t.nextPlaylist, o = t.bufferLowWaterLine, s = t.bufferHighWaterLine, l = t.duration, u = t.experimentalBufferBasedABR, c = t.log;
  if (!a)
    return Ce.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  var f = "allowing switch " + (n && n.id || "null") + " -> " + a.id;
  if (!n)
    return c(f + " as current playlist is not set"), !0;
  if (a.id === n.id)
    return !1;
  var d = Boolean(Su(r, i).length);
  if (!n.endList)
    return !d && typeof n.partTargetDuration == "number" ? (c("not " + f + " as current playlist is live llhls, but currentTime isn't in buffered."), !1) : (c(f + " as current playlist is live"), !0);
  var h = R6(r, i), p = u ? Ii.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Ii.MAX_BUFFER_LOW_WATER_LINE;
  if (l < p)
    return c(f + " as duration < max low water line (" + l + " < " + p + ")"), !0;
  var y = a.attributes.BANDWIDTH, m = n.attributes.BANDWIDTH;
  if (y < m && (!u || h < s)) {
    var b = f + " as next bandwidth < current bandwidth (" + y + " < " + m + ")";
    return u && (b += " and forwardBuffer < bufferHighWaterLine (" + h + " < " + s + ")"), c(b), !0;
  }
  if ((!u || y > m) && h >= o) {
    var x = f + " as forwardBuffer >= bufferLowWaterLine (" + h + " >= " + o + ")";
    return u && (x += " and next bandwidth > current bandwidth (" + y + " > " + m + ")"), c(x), !0;
  }
  return c("not " + f + " as no switching criteria met"), !1;
}, Fce = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r) {
    var i;
    i = e.call(this) || this;
    var a = r.src, o = r.handleManifestRedirects, s = r.withCredentials, l = r.tech, u = r.bandwidth, c = r.externVhs, f = r.useCueTags, d = r.blacklistDuration, h = r.enableLowInitialPlaylist, p = r.sourceType, y = r.cacheEncryptionKeys, m = r.experimentalBufferBasedABR, b = r.experimentalLeastPixelDiffSelector, x = r.captionServices;
    if (!a)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    var D = r.maxPlaylistRetries;
    (D === null || typeof D > "u") && (D = 1 / 0), Eo = c, i.experimentalBufferBasedABR = Boolean(m), i.experimentalLeastPixelDiffSelector = Boolean(b), i.withCredentials = s, i.tech_ = l, i.vhs_ = l.vhs, i.sourceType_ = p, i.useCueTags_ = f, i.blacklistDuration = d, i.maxPlaylistRetries = D, i.enableLowInitialPlaylist = h, i.useCueTags_ && (i.cueTagsTrack_ = i.tech_.addTextTrack("metadata", "ad-cues"), i.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), i.requestOptions_ = {
      withCredentials: s,
      handleManifestRedirects: o,
      maxPlaylistRetries: D,
      timeout: null
    }, i.on("error", i.pauseLoading), i.mediaTypes_ = Ice(), i.mediaSource = new pe.MediaSource(), i.handleDurationChange_ = i.handleDurationChange_.bind(on(i)), i.handleSourceOpen_ = i.handleSourceOpen_.bind(on(i)), i.handleSourceEnded_ = i.handleSourceEnded_.bind(on(i)), i.mediaSource.addEventListener("durationchange", i.handleDurationChange_), i.mediaSource.addEventListener("sourceopen", i.handleSourceOpen_), i.mediaSource.addEventListener("sourceended", i.handleSourceEnded_), i.seekable_ = Ce.createTimeRanges(), i.hasPlayed_ = !1, i.syncController_ = new Ace(r), i.segmentMetadataTrack_ = l.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, i.decrypter_ = new Pce(), i.sourceUpdater_ = new Nx(i.mediaSource), i.inbandTextTracks_ = {}, i.timelineChangeController_ = new Tce();
    var S = {
      vhs: i.vhs_,
      parse708captions: r.parse708captions,
      useDtsForTimestampOffset: r.useDtsForTimestampOffset,
      captionServices: x,
      mediaSource: i.mediaSource,
      currentTime: i.tech_.currentTime.bind(i.tech_),
      seekable: function() {
        return i.seekable();
      },
      seeking: function() {
        return i.tech_.seeking();
      },
      duration: function() {
        return i.duration();
      },
      hasPlayed: function() {
        return i.hasPlayed_;
      },
      goalBufferLength: function() {
        return i.goalBufferLength();
      },
      bandwidth: u,
      syncController: i.syncController_,
      decrypter: i.decrypter_,
      sourceType: i.sourceType_,
      inbandTextTracks: i.inbandTextTracks_,
      cacheEncryptionKeys: y,
      sourceUpdater: i.sourceUpdater_,
      timelineChangeController: i.timelineChangeController_,
      experimentalExactManifestTimings: r.experimentalExactManifestTimings
    };
    i.masterPlaylistLoader_ = i.sourceType_ === "dash" ? new z4(a, i.vhs_, i.requestOptions_) : new Eu(a, i.vhs_, i.requestOptions_), i.setupMasterPlaylistLoaderListeners_(), i.mainSegmentLoader_ = new M4(Ce.mergeOptions(S, {
      segmentMetadataTrack: i.segmentMetadataTrack_,
      loaderType: "main"
    }), r), i.audioSegmentLoader_ = new M4(Ce.mergeOptions(S, {
      loaderType: "audio"
    }), r), i.subtitleSegmentLoader_ = new mce(Ce.mergeOptions(S, {
      loaderType: "vtt",
      featuresNativeTextTracks: i.tech_.featuresNativeTextTracks
    }), r), i.setupSegmentLoaderListeners_(), i.experimentalBufferBasedABR && (i.masterPlaylistLoader_.one("loadedplaylist", function() {
      return i.startABRTimer_();
    }), i.tech_.on("pause", function() {
      return i.stopABRTimer_();
    }), i.tech_.on("play", function() {
      return i.startABRTimer_();
    })), Bce.forEach(function(v) {
      i[v + "_"] = Nce.bind(on(i), v);
    }), i.logger_ = Ya("MPC"), i.triggeredFmp4Usage = !1, i.tech_.preload() === "none" ? (i.loadOnPlay_ = function() {
      i.loadOnPlay_ = null, i.masterPlaylistLoader_.load();
    }, i.tech_.one("play", i.loadOnPlay_)) : i.masterPlaylistLoader_.load(), i.timeToLoadedData__ = -1, i.mainAppendsToLoadedData__ = -1, i.audioAppendsToLoadedData__ = -1;
    var C = i.tech_.preload() === "none" ? "play" : "loadstart";
    return i.tech_.one(C, function() {
      var v = Date.now();
      i.tech_.one("loadeddata", function() {
        i.timeToLoadedData__ = Date.now() - v, i.mainAppendsToLoadedData__ = i.mainSegmentLoader_.mediaAppends, i.audioAppendsToLoadedData__ = i.audioSegmentLoader_.mediaAppends;
      });
    }), i;
  }
  var n = t.prototype;
  return n.mainAppendsToLoadedData_ = function() {
    return this.mainAppendsToLoadedData__;
  }, n.audioAppendsToLoadedData_ = function() {
    return this.audioAppendsToLoadedData__;
  }, n.appendsToLoadedData_ = function() {
    var i = this.mainAppendsToLoadedData_(), a = this.audioAppendsToLoadedData_();
    return i === -1 || a === -1 ? -1 : i + a;
  }, n.timeToLoadedData_ = function() {
    return this.timeToLoadedData__;
  }, n.checkABR_ = function() {
    var i = this.selectPlaylist();
    i && this.shouldSwitchToMedia_(i) && this.switchMedia_(i, "abr");
  }, n.switchMedia_ = function(i, a, o) {
    var s = this.media(), l = s && (s.id || s.uri), u = i.id || i.uri;
    l && l !== u && (this.logger_("switch media " + l + " -> " + u + " from " + a), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-change-" + a
    })), this.masterPlaylistLoader_.media(i, o);
  }, n.startABRTimer_ = function() {
    var i = this;
    this.stopABRTimer_(), this.abrTimer_ = pe.setInterval(function() {
      return i.checkABR_();
    }, 250);
  }, n.stopABRTimer_ = function() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (pe.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }, n.getAudioTrackPlaylists_ = function() {
    var i = this.master(), a = i && i.playlists || [];
    if (!i || !i.mediaGroups || !i.mediaGroups.AUDIO)
      return a;
    var o = i.mediaGroups.AUDIO, s = Object.keys(o), l;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      l = this.mediaTypes_.AUDIO.activeTrack();
    else {
      var u = o.main || s.length && o[s[0]];
      for (var c in u)
        if (u[c].default) {
          l = {
            label: c
          };
          break;
        }
    }
    if (!l)
      return a;
    var f = [];
    for (var d in o)
      if (o[d][l.label]) {
        var h = o[d][l.label];
        if (h.playlists && h.playlists.length)
          f.push.apply(f, h.playlists);
        else if (h.uri)
          f.push(h);
        else if (i.playlists.length)
          for (var p = 0; p < i.playlists.length; p++) {
            var y = i.playlists[p];
            y.attributes && y.attributes.AUDIO && y.attributes.AUDIO === d && f.push(y);
          }
      }
    return f.length ? f : a;
  }, n.setupMasterPlaylistLoaderListeners_ = function() {
    var i = this;
    this.masterPlaylistLoader_.on("loadedmetadata", function() {
      var a = i.masterPlaylistLoader_.media(), o = a.targetDuration * 1.5 * 1e3;
      C4(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = o, a.endList && i.tech_.preload() !== "none" && (i.mainSegmentLoader_.playlist(a, i.requestOptions_), i.mainSegmentLoader_.load()), Hce({
        sourceType: i.sourceType_,
        segmentLoaders: {
          AUDIO: i.audioSegmentLoader_,
          SUBTITLES: i.subtitleSegmentLoader_,
          main: i.mainSegmentLoader_
        },
        tech: i.tech_,
        requestOptions: i.requestOptions_,
        masterPlaylistLoader: i.masterPlaylistLoader_,
        vhs: i.vhs_,
        master: i.master(),
        mediaTypes: i.mediaTypes_,
        blacklistCurrentPlaylist: i.blacklistCurrentPlaylist.bind(i)
      }), i.triggerPresenceUsage_(i.master(), a), i.setupFirstPlay(), !i.mediaTypes_.AUDIO.activePlaylistLoader || i.mediaTypes_.AUDIO.activePlaylistLoader.media() ? i.trigger("selectedinitialmedia") : i.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function() {
        i.trigger("selectedinitialmedia");
      });
    }), this.masterPlaylistLoader_.on("loadedplaylist", function() {
      i.loadOnPlay_ && i.tech_.off("play", i.loadOnPlay_);
      var a = i.masterPlaylistLoader_.media();
      if (!a) {
        i.excludeUnsupportedVariants_();
        var o;
        if (i.enableLowInitialPlaylist && (o = i.selectInitialPlaylist()), o || (o = i.selectPlaylist()), !o || !i.shouldSwitchToMedia_(o))
          return;
        i.initialMedia_ = o, i.switchMedia_(i.initialMedia_, "initial");
        var s = i.sourceType_ === "vhs-json" && i.initialMedia_.segments;
        if (!s)
          return;
        a = i.initialMedia_;
      }
      i.handleUpdatedMediaPlaylist(a);
    }), this.masterPlaylistLoader_.on("error", function() {
      i.blacklistCurrentPlaylist(i.masterPlaylistLoader_.error);
    }), this.masterPlaylistLoader_.on("mediachanging", function() {
      i.mainSegmentLoader_.abort(), i.mainSegmentLoader_.pause();
    }), this.masterPlaylistLoader_.on("mediachange", function() {
      var a = i.masterPlaylistLoader_.media(), o = a.targetDuration * 1.5 * 1e3;
      C4(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = o, i.mainSegmentLoader_.playlist(a, i.requestOptions_), i.mainSegmentLoader_.load(), i.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.masterPlaylistLoader_.on("playlistunchanged", function() {
      var a = i.masterPlaylistLoader_.media();
      if (a.lastExcludeReason_ !== "playlist-unchanged") {
        var o = i.stuckAtPlaylistEnd_(a);
        o && (i.blacklistCurrentPlaylist({
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }), i.tech_.trigger("playliststuck"));
      }
    }), this.masterPlaylistLoader_.on("renditiondisabled", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-rendition-disabled"
      });
    }), this.masterPlaylistLoader_.on("renditionenabled", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-rendition-enabled"
      });
    });
  }, n.handleUpdatedMediaPlaylist = function(i) {
    this.useCueTags_ && this.updateAdCues_(i), this.mainSegmentLoader_.playlist(i, this.requestOptions_), this.updateDuration(!i.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }, n.triggerPresenceUsage_ = function(i, a) {
    var o = i.mediaGroups || {}, s = !0, l = Object.keys(o.AUDIO);
    for (var u in o.AUDIO)
      for (var c in o.AUDIO[u]) {
        var f = o.AUDIO[u][c];
        f.uri || (s = !1);
      }
    s && (this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-demuxed"
    })), Object.keys(o.SUBTITLES).length && (this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-webvtt"
    })), Eo.Playlist.isAes(a) && (this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-aes"
    })), l.length && Object.keys(o.AUDIO[l[0]]).length > 1 && (this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-alternate-audio"
    })), this.useCueTags_ && (this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-playlist-cue-tags"
    }));
  }, n.shouldSwitchToMedia_ = function(i) {
    var a = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_, o = this.tech_.currentTime(), s = this.bufferLowWaterLine(), l = this.bufferHighWaterLine(), u = this.tech_.buffered();
    return jce({
      buffered: u,
      currentTime: o,
      currentPlaylist: a,
      nextPlaylist: i,
      bufferLowWaterLine: s,
      bufferHighWaterLine: l,
      duration: this.duration(),
      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
      log: this.logger_
    });
  }, n.setupSegmentLoaderListeners_ = function() {
    var i = this;
    this.experimentalBufferBasedABR || (this.mainSegmentLoader_.on("bandwidthupdate", function() {
      var o = i.selectPlaylist();
      i.shouldSwitchToMedia_(o) && i.switchMedia_(o, "bandwidthupdate"), i.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("progress", function() {
      i.trigger("progress");
    })), this.mainSegmentLoader_.on("error", function() {
      i.blacklistCurrentPlaylist(i.mainSegmentLoader_.error());
    }), this.mainSegmentLoader_.on("appenderror", function() {
      i.error = i.mainSegmentLoader_.error_, i.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", function() {
      i.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", function() {
      i.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", function() {
      i.error = i.audioSegmentLoader_.error_, i.trigger("error");
    }), this.mainSegmentLoader_.on("ended", function() {
      i.logger_("main segment loader ended"), i.onEndOfStream();
    }), this.mainSegmentLoader_.on("earlyabort", function(o) {
      i.experimentalBufferBasedABR || (i.delegateLoaders_("all", ["abort"]), i.blacklistCurrentPlaylist({
        message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
      }, Lce));
    });
    var a = function() {
      if (!i.sourceUpdater_.hasCreatedSourceBuffers())
        return i.tryToCreateSourceBuffers_();
      var s = i.getCodecsOrExclude_();
      !s || i.sourceUpdater_.addOrChangeSourceBuffers(s);
    };
    this.mainSegmentLoader_.on("trackinfo", a), this.audioSegmentLoader_.on("trackinfo", a), this.mainSegmentLoader_.on("fmp4", function() {
      i.triggeredFmp4Usage || (i.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-fmp4"
      }), i.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", function() {
      i.triggeredFmp4Usage || (i.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-fmp4"
      }), i.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", function() {
      i.logger_("audioSegmentLoader ended"), i.onEndOfStream();
    });
  }, n.mediaSecondsLoaded_ = function() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }, n.load = function() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }, n.smoothQualityChange_ = function(i) {
    i === void 0 && (i = this.selectPlaylist()), this.fastQualityChange_(i);
  }, n.fastQualityChange_ = function(i) {
    var a = this;
    if (i === void 0 && (i = this.selectPlaylist()), i === this.masterPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(i, "fast-quality"), this.mainSegmentLoader_.resetEverything(function() {
      Ce.browser.IE_VERSION || Ce.browser.IS_EDGE ? a.tech_.setCurrentTime(a.tech_.currentTime() + 0.04) : a.tech_.setCurrentTime(a.tech_.currentTime());
    });
  }, n.play = function() {
    if (!this.setupFirstPlay()) {
      this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
      var i = this.tech_.seekable();
      if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < i.start(0))
        return this.tech_.setCurrentTime(i.end(i.length - 1));
    }
  }, n.setupFirstPlay = function() {
    var i = this, a = this.masterPlaylistLoader_.media();
    if (!a || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!a.endList) {
      var o = this.seekable();
      if (!o.length)
        return !1;
      if (Ce.browser.IE_VERSION && this.tech_.readyState() === 0)
        return this.tech_.one("loadedmetadata", function() {
          i.trigger("firstplay"), i.tech_.setCurrentTime(o.end(0)), i.hasPlayed_ = !0;
        }), !1;
      this.trigger("firstplay"), this.tech_.setCurrentTime(o.end(0));
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }, n.handleSourceOpen_ = function() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      var i = this.tech_.play();
      typeof i < "u" && typeof i.then == "function" && i.then(null, function(a) {
      });
    }
    this.trigger("sourceopen");
  }, n.handleSourceEnded_ = function() {
    if (!!this.inbandTextTracks_.metadataTrack_) {
      var i = this.inbandTextTracks_.metadataTrack_.cues;
      if (!(!i || !i.length)) {
        var a = this.duration();
        i[i.length - 1].endTime = isNaN(a) || Math.abs(a) === 1 / 0 ? Number.MAX_VALUE : a;
      }
    }
  }, n.handleDurationChange_ = function() {
    this.tech_.trigger("durationchange");
  }, n.onEndOfStream = function() {
    var i = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      var a = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !a || a.hasVideo ? i = i && this.audioSegmentLoader_.ended_ : i = this.audioSegmentLoader_.ended_;
    }
    !i || (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }, n.stuckAtPlaylistEnd_ = function(i) {
    var a = this.seekable();
    if (!a.length)
      return !1;
    var o = this.syncController_.getExpiredTime(i, this.duration());
    if (o === null)
      return !1;
    var s = Eo.Playlist.playlistEnd(i, o), l = this.tech_.currentTime(), u = this.tech_.buffered();
    if (!u.length)
      return s - l <= ro;
    var c = u.end(u.length - 1);
    return c - l <= ro && s - c <= ro;
  }, n.blacklistCurrentPlaylist = function(i, a) {
    i === void 0 && (i = {});
    var o = i.playlist || this.masterPlaylistLoader_.media();
    if (a = a || i.blacklistDuration || this.blacklistDuration, !o) {
      this.error = i, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    o.playlistErrors_++;
    var s = this.masterPlaylistLoader_.master.playlists, l = s.filter(p2), u = l.length === 1 && l[0] === o;
    if (s.length === 1 && a !== 1 / 0)
      return Ce.log.warn("Problem encountered with playlist " + o.id + ". Trying again since it is the only playlist."), this.tech_.trigger("retryplaylist"), this.masterPlaylistLoader_.load(u);
    if (u) {
      var c = !1;
      s.forEach(function(b) {
        if (b !== o) {
          var x = b.excludeUntil;
          typeof x < "u" && x !== 1 / 0 && (c = !0, delete b.excludeUntil);
        }
      }), c && (Ce.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    var f;
    o.playlistErrors_ > this.maxPlaylistRetries ? f = 1 / 0 : f = Date.now() + a * 1e3, o.excludeUntil = f, i.reason && (o.lastExcludeReason_ = i.reason), this.tech_.trigger("blacklistplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-blacklisted"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-rendition-blacklisted"
    });
    var d = this.selectPlaylist();
    if (!d) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    var h = i.internal ? this.logger_ : Ce.log.warn, p = i.message ? " " + i.message : "";
    h((i.internal ? "Internal problem" : "Problem") + " encountered with playlist " + o.id + "." + (p + " Switching to playlist " + d.id + ".")), d.attributes.AUDIO !== o.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), d.attributes.SUBTITLES !== o.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    var y = d.targetDuration / 2 * 1e3 || 5 * 1e3, m = typeof d.lastRequest == "number" && Date.now() - d.lastRequest <= y;
    return this.switchMedia_(d, "exclude", u || m);
  }, n.pauseLoading = function() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }, n.delegateLoaders_ = function(i, a) {
    var o = this, s = [], l = i === "all";
    (l || i === "main") && s.push(this.masterPlaylistLoader_);
    var u = [];
    (l || i === "audio") && u.push("AUDIO"), (l || i === "subtitle") && (u.push("CLOSED-CAPTIONS"), u.push("SUBTITLES")), u.forEach(function(c) {
      var f = o.mediaTypes_[c] && o.mediaTypes_[c].activePlaylistLoader;
      f && s.push(f);
    }), ["main", "audio", "subtitle"].forEach(function(c) {
      var f = o[c + "SegmentLoader_"];
      f && (i === c || i === "all") && s.push(f);
    }), s.forEach(function(c) {
      return a.forEach(function(f) {
        typeof c[f] == "function" && c[f]();
      });
    });
  }, n.setCurrentTime = function(i) {
    var a = Su(this.tech_.buffered(), i);
    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media()) || !this.masterPlaylistLoader_.media().segments)
      return 0;
    if (a && a.length)
      return i;
    this.mainSegmentLoader_.resetEverything(), this.mainSegmentLoader_.abort(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.resetEverything(), this.audioSegmentLoader_.abort()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.resetEverything(), this.subtitleSegmentLoader_.abort()), this.load();
  }, n.duration = function() {
    if (!this.masterPlaylistLoader_)
      return 0;
    var i = this.masterPlaylistLoader_.media();
    return i ? i.endList ? this.mediaSource ? this.mediaSource.duration : Eo.Playlist.duration(i) : 1 / 0 : 0;
  }, n.seekable = function() {
    return this.seekable_;
  }, n.onSyncInfoUpdate_ = function() {
    var i;
    if (!!this.masterPlaylistLoader_) {
      var a = this.masterPlaylistLoader_.media();
      if (!!a) {
        var o = this.syncController_.getExpiredTime(a, this.duration());
        if (o !== null) {
          var s = this.masterPlaylistLoader_.master, l = Eo.Playlist.seekable(a, o, Eo.Playlist.liveEdgeDelay(s, a));
          if (l.length !== 0 && !(this.mediaTypes_.AUDIO.activePlaylistLoader && (a = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), o = this.syncController_.getExpiredTime(a, this.duration()), o === null || (i = Eo.Playlist.seekable(a, o, Eo.Playlist.liveEdgeDelay(s, a)), i.length === 0)))) {
            var u, c;
            this.seekable_ && this.seekable_.length && (u = this.seekable_.end(0), c = this.seekable_.start(0)), i ? i.start(0) > l.end(0) || l.start(0) > i.end(0) ? this.seekable_ = l : this.seekable_ = Ce.createTimeRanges([[i.start(0) > l.start(0) ? i.start(0) : l.start(0), i.end(0) < l.end(0) ? i.end(0) : l.end(0)]]) : this.seekable_ = l, !(this.seekable_ && this.seekable_.length && this.seekable_.end(0) === u && this.seekable_.start(0) === c) && (this.logger_("seekable updated [" + ex(this.seekable_) + "]"), this.tech_.trigger("seekablechanged"));
          }
        }
      }
    }
  }, n.updateDuration = function(i) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, i), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (i) {
      var a = this.seekable();
      if (!a.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < a.end(a.length - 1)) && this.sourceUpdater_.setDuration(a.end(a.length - 1));
      return;
    }
    var o = this.tech_.buffered(), s = Eo.Playlist.duration(this.masterPlaylistLoader_.media());
    o.length > 0 && (s = Math.max(s, o.end(o.length - 1))), this.mediaSource.duration !== s && this.sourceUpdater_.setDuration(s);
  }, n.dispose = function() {
    var i = this;
    this.trigger("dispose"), this.decrypter_.terminate(), this.masterPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach(function(a) {
      var o = i.mediaTypes_[a].groups;
      for (var s in o)
        o[s].forEach(function(l) {
          l.playlistLoader && l.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }, n.master = function() {
    return this.masterPlaylistLoader_.master;
  }, n.media = function() {
    return this.masterPlaylistLoader_.media() || this.initialMedia_;
  }, n.areMediaTypesKnown_ = function() {
    var i = !!this.mediaTypes_.AUDIO.activePlaylistLoader, a = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), o = i ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!a || !o);
  }, n.getCodecsOrExclude_ = function() {
    var i = this, a = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    };
    a.video = a.main;
    var o = Sd(this.master(), this.media()), s = {}, l = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (a.main.hasVideo && (s.video = o.video || a.main.videoCodec || gae), a.main.isMuxed && (s.video += "," + (o.audio || a.main.audioCodec || nm)), (a.main.hasAudio && !a.main.isMuxed || a.audio.hasAudio || l) && (s.audio = o.audio || a.main.audioCodec || a.audio.audioCodec || nm, a.audio.isFmp4 = a.main.hasAudio && !a.main.isMuxed ? a.main.isFmp4 : a.audio.isFmp4), !s.audio && !s.video) {
      this.blacklistCurrentPlaylist({
        playlist: this.media(),
        message: "Could not determine codecs for playlist.",
        blacklistDuration: 1 / 0
      });
      return;
    }
    var u = function(m, b) {
      return m ? v0(b) : Hp(b);
    }, c = {}, f;
    if (["video", "audio"].forEach(function(y) {
      if (s.hasOwnProperty(y) && !u(a[y].isFmp4, s[y])) {
        var m = a[y].isFmp4 ? "browser" : "muxer";
        c[m] = c[m] || [], c[m].push(s[y]), y === "audio" && (f = m);
      }
    }), l && f && this.media().attributes.AUDIO) {
      var d = this.media().attributes.AUDIO;
      this.master().playlists.forEach(function(y) {
        var m = y.attributes && y.attributes.AUDIO;
        m === d && y !== i.media() && (y.excludeUntil = 1 / 0);
      }), this.logger_("excluding audio group " + d + " as " + f + ' does not support codec(s): "' + s.audio + '"');
    }
    if (Object.keys(c).length) {
      var h = Object.keys(c).reduce(function(y, m) {
        return y && (y += ", "), y += m + ' does not support codec(s): "' + c[m].join(",") + '"', y;
      }, "") + ".";
      this.blacklistCurrentPlaylist({
        playlist: this.media(),
        internal: !0,
        message: h,
        blacklistDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      var p = [];
      if (["video", "audio"].forEach(function(y) {
        var m = (eo(i.sourceUpdater_.codecs[y] || "")[0] || {}).type, b = (eo(s[y] || "")[0] || {}).type;
        m && b && m.toLowerCase() !== b.toLowerCase() && p.push('"' + i.sourceUpdater_.codecs[y] + '" -> "' + s[y] + '"');
      }), p.length) {
        this.blacklistCurrentPlaylist({
          playlist: this.media(),
          message: "Codec switching not supported: " + p.join(", ") + ".",
          blacklistDuration: 1 / 0,
          internal: !0
        });
        return;
      }
    }
    return s;
  }, n.tryToCreateSourceBuffers_ = function() {
    if (!(this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers()) && !!this.areMediaTypesKnown_()) {
      var i = this.getCodecsOrExclude_();
      if (!!i) {
        this.sourceUpdater_.createSourceBuffers(i);
        var a = [i.video, i.audio].filter(Boolean).join(",");
        this.excludeIncompatibleVariants_(a);
      }
    }
  }, n.excludeUnsupportedVariants_ = function() {
    var i = this, a = this.master().playlists, o = [];
    Object.keys(a).forEach(function(s) {
      var l = a[s];
      if (o.indexOf(l.id) === -1) {
        o.push(l.id);
        var u = Sd(i.master, l), c = [];
        u.audio && !Hp(u.audio) && !v0(u.audio) && c.push("audio codec " + u.audio), u.video && !Hp(u.video) && !v0(u.video) && c.push("video codec " + u.video), u.text && u.text === "stpp.ttml.im1t" && c.push("text codec " + u.text), c.length && (l.excludeUntil = 1 / 0, i.logger_("excluding " + l.id + " for unsupported: " + c.join(", ")));
      }
    });
  }, n.excludeIncompatibleVariants_ = function(i) {
    var a = this, o = [], s = this.master().playlists, l = fh(eo(i)), u = a9(l), c = l.video && eo(l.video)[0] || null, f = l.audio && eo(l.audio)[0] || null;
    Object.keys(s).forEach(function(d) {
      var h = s[d];
      if (!(o.indexOf(h.id) !== -1 || h.excludeUntil === 1 / 0)) {
        o.push(h.id);
        var p = [], y = Sd(a.masterPlaylistLoader_.master, h), m = a9(y);
        if (!(!y.audio && !y.video)) {
          if (m !== u && p.push('codec count "' + m + '" !== "' + u + '"'), !a.sourceUpdater_.canChangeType()) {
            var b = y.video && eo(y.video)[0] || null, x = y.audio && eo(y.audio)[0] || null;
            b && c && b.type.toLowerCase() !== c.type.toLowerCase() && p.push('video codec "' + b.type + '" !== "' + c.type + '"'), x && f && x.type.toLowerCase() !== f.type.toLowerCase() && p.push('audio codec "' + x.type + '" !== "' + f.type + '"');
          }
          p.length && (h.excludeUntil = 1 / 0, a.logger_("blacklisting " + h.id + ": " + p.join(" && ")));
        }
      }
    });
  }, n.updateAdCues_ = function(i) {
    var a = 0, o = this.seekable();
    o.length && (a = o.start(0)), yce(i, this.cueTagsTrack_, a);
  }, n.goalBufferLength = function() {
    var i = this.tech_.currentTime(), a = Ii.GOAL_BUFFER_LENGTH, o = Ii.GOAL_BUFFER_LENGTH_RATE, s = Math.max(a, Ii.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(a + i * o, s);
  }, n.bufferLowWaterLine = function() {
    var i = this.tech_.currentTime(), a = Ii.BUFFER_LOW_WATER_LINE, o = Ii.BUFFER_LOW_WATER_LINE_RATE, s = Math.max(a, Ii.MAX_BUFFER_LOW_WATER_LINE), l = Math.max(a, Ii.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(a + i * o, this.experimentalBufferBasedABR ? l : s);
  }, n.bufferHighWaterLine = function() {
    return Ii.BUFFER_HIGH_WATER_LINE;
  }, t;
}(Ce.EventTarget), Xce = function(t, n, r) {
  return function(i) {
    var a = t.master.playlists[n], o = U6(a), s = p2(a);
    return typeof i > "u" ? s : (i ? delete a.disabled : a.disabled = !0, i !== s && !o && (r(), i ? t.trigger("renditionenabled") : t.trigger("renditiondisabled")), i);
  };
}, Rce = function(t, n, r) {
  var i = t.masterPlaylistController_, a = t.options_.smoothQualityChange, o = a ? "smooth" : "fast", s = i[o + "QualityChange_"].bind(i);
  if (n.attributes) {
    var l = n.attributes.RESOLUTION;
    this.width = l && l.width, this.height = l && l.height, this.bandwidth = n.attributes.BANDWIDTH;
  }
  this.codecs = Sd(i.master(), n), this.playlist = n, this.id = r, this.enabled = Xce(t.playlists, n.id, s);
}, Vce = function(t) {
  t.representations = function() {
    var n = t.masterPlaylistController_.master(), r = Mf(n) ? t.masterPlaylistController_.getAudioTrackPlaylists_() : n.playlists;
    return r ? r.filter(function(i) {
      return !U6(i);
    }).map(function(i, a) {
      return new Rce(t, i, i.id);
    }) : [];
  };
}, g9 = ["seeking", "seeked", "pause", "playing", "error"], Uce = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this.masterPlaylistController_ = n.masterPlaylistController, this.tech_ = n.tech, this.seekable = n.seekable, this.allowSeeksWithinUnsafeLiveWindow = n.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = n.liveRangeSafeTimeDelta, this.media = n.media, this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.timer_ = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Ya("PlaybackWatcher"), this.logger_("initialize");
    var i = function() {
      return r.monitorCurrentTime_();
    }, a = function() {
      return r.monitorCurrentTime_();
    }, o = function() {
      return r.techWaiting_();
    }, s = function() {
      return r.cancelTimer_();
    }, l = this.masterPlaylistController_, u = ["main", "subtitle", "audio"], c = {};
    u.forEach(function(d) {
      c[d] = {
        reset: function() {
          return r.resetSegmentDownloads_(d);
        },
        updateend: function() {
          return r.checkSegmentDownloads_(d);
        }
      }, l[d + "SegmentLoader_"].on("appendsdone", c[d].updateend), l[d + "SegmentLoader_"].on("playlistupdate", c[d].reset), r.tech_.on(["seeked", "seeking"], c[d].reset);
    });
    var f = function(h) {
      ["main", "audio"].forEach(function(p) {
        l[p + "SegmentLoader_"][h]("appended", r.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = function() {
      r.fixesBadSeeks_() && (r.consecutiveUpdates = 0, r.lastRecordedTime = r.tech_.currentTime(), f("off"));
    }, this.clearSeekingAppendCheck_ = function() {
      return f("off");
    }, this.watchForBadSeeking_ = function() {
      r.clearSeekingAppendCheck_(), f("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", o), this.tech_.on(g9, s), this.tech_.on("canplay", a), this.tech_.one("play", i), this.dispose = function() {
      r.clearSeekingAppendCheck_(), r.logger_("dispose"), r.tech_.off("waiting", o), r.tech_.off(g9, s), r.tech_.off("canplay", a), r.tech_.off("play", i), r.tech_.off("seeking", r.watchForBadSeeking_), r.tech_.off("seeked", r.clearSeekingAppendCheck_), u.forEach(function(d) {
        l[d + "SegmentLoader_"].off("appendsdone", c[d].updateend), l[d + "SegmentLoader_"].off("playlistupdate", c[d].reset), r.tech_.off(["seeked", "seeking"], c[d].reset);
      }), r.checkCurrentTimeTimeout_ && pe.clearTimeout(r.checkCurrentTimeTimeout_), r.cancelTimer_();
    };
  }
  var t = e.prototype;
  return t.monitorCurrentTime_ = function() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && pe.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = pe.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }, t.resetSegmentDownloads_ = function(r) {
    var i = this.masterPlaylistController_[r + "SegmentLoader_"];
    this[r + "StalledDownloads_"] > 0 && this.logger_("resetting possible stalled download count for " + r + " loader"), this[r + "StalledDownloads_"] = 0, this[r + "Buffered_"] = i.buffered_();
  }, t.checkSegmentDownloads_ = function(r) {
    var i = this.masterPlaylistController_, a = i[r + "SegmentLoader_"], o = a.buffered_(), s = Nle(this[r + "Buffered_"], o);
    if (this[r + "Buffered_"] = o, s) {
      this.resetSegmentDownloads_(r);
      return;
    }
    this[r + "StalledDownloads_"]++, this.logger_("found #" + this[r + "StalledDownloads_"] + " " + r + " appends that did not increase buffer (possible stalled download)", {
      playlistId: a.playlist_ && a.playlist_.id,
      buffered: bl(o)
    }), !(this[r + "StalledDownloads_"] < 10) && (this.logger_(r + " loader stalled download exclusion"), this.resetSegmentDownloads_(r), this.tech_.trigger({
      type: "usage",
      name: "vhs-" + r + "-download-exclusion"
    }), r !== "subtitle" && i.blacklistCurrentPlaylist({
      message: "Excessive " + r + " segment downloading detected."
    }, 1 / 0));
  }, t.checkCurrentTime_ = function() {
    if (!(this.tech_.paused() || this.tech_.seeking())) {
      var r = this.tech_.currentTime(), i = this.tech_.buffered();
      if (this.lastRecordedTime === r && (!i.length || r + ro >= i.end(i.length - 1)))
        return this.techWaiting_();
      this.consecutiveUpdates >= 5 && r === this.lastRecordedTime ? (this.consecutiveUpdates++, this.waiting_()) : r === this.lastRecordedTime ? this.consecutiveUpdates++ : (this.consecutiveUpdates = 0, this.lastRecordedTime = r);
    }
  }, t.cancelTimer_ = function() {
    this.consecutiveUpdates = 0, this.timer_ && (this.logger_("cancelTimer_"), clearTimeout(this.timer_)), this.timer_ = null;
  }, t.fixesBadSeeks_ = function() {
    var r = this.tech_.seeking();
    if (!r)
      return !1;
    var i = this.seekable(), a = this.tech_.currentTime(), o = this.afterSeekableWindow_(i, a, this.media(), this.allowSeeksWithinUnsafeLiveWindow), s;
    if (o) {
      var l = i.end(i.length - 1);
      s = l;
    }
    if (this.beforeSeekableWindow_(i, a)) {
      var u = i.start(0);
      s = u + (u === i.end(0) ? 0 : ro);
    }
    if (typeof s < "u")
      return this.logger_("Trying to seek outside of seekable at time " + a + " with " + ("seekable range " + ex(i) + ". Seeking to ") + (s + ".")), this.tech_.setCurrentTime(s), !0;
    for (var c = this.masterPlaylistController_.sourceUpdater_, f = this.tech_.buffered(), d = c.audioBuffer ? c.audioBuffered() : null, h = c.videoBuffer ? c.videoBuffered() : null, p = this.media(), y = p.partTargetDuration ? p.partTargetDuration : (p.targetDuration - Fs) * 2, m = [d, h], b = 0; b < m.length; b++)
      if (!!m[b]) {
        var x = R6(m[b], a);
        if (x < y)
          return !1;
      }
    var D = k1(f, a);
    return D.length === 0 ? !1 : (s = D.start(0) + ro, this.logger_("Buffered region starts (" + D.start(0) + ") " + (" just beyond seek point (" + a + "). Seeking to " + s + ".")), this.tech_.setCurrentTime(s), !0);
  }, t.waiting_ = function() {
    if (!this.techWaiting_()) {
      var r = this.tech_.currentTime(), i = this.tech_.buffered(), a = Su(i, r);
      if (a.length && r + 3 <= a.end(0)) {
        this.cancelTimer_(), this.tech_.setCurrentTime(r), this.logger_("Stopped at " + r + " while inside a buffered region " + ("[" + a.start(0) + " -> " + a.end(0) + "]. Attempting to resume ") + "playback by seeking to the current time."), this.tech_.trigger({
          type: "usage",
          name: "vhs-unknown-waiting"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-unknown-waiting"
        });
        return;
      }
    }
  }, t.techWaiting_ = function() {
    var r = this.seekable(), i = this.tech_.currentTime();
    if (this.tech_.seeking() || this.timer_ !== null)
      return !0;
    if (this.beforeSeekableWindow_(r, i)) {
      var a = r.end(r.length - 1);
      return this.logger_("Fell out of live window at time " + i + ". Seeking to " + ("live point (seekable end) " + a)), this.cancelTimer_(), this.tech_.setCurrentTime(a), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-live-resync"
      }), !0;
    }
    var o = this.tech_.vhs.masterPlaylistController_.sourceUpdater_, s = this.tech_.buffered(), l = this.videoUnderflow_({
      audioBuffered: o.audioBuffered(),
      videoBuffered: o.videoBuffered(),
      currentTime: i
    });
    if (l)
      return this.cancelTimer_(), this.tech_.setCurrentTime(i), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-video-underflow"
      }), !0;
    var u = k1(s, i);
    if (u.length > 0) {
      var c = u.start(0) - i;
      return this.logger_("Stopped at " + i + ", setting timer for " + c + ", seeking " + ("to " + u.start(0))), this.cancelTimer_(), this.timer_ = setTimeout(this.skipTheGap_.bind(this), c * 1e3, i), !0;
    }
    return !1;
  }, t.afterSeekableWindow_ = function(r, i, a, o) {
    if (o === void 0 && (o = !1), !r.length)
      return !1;
    var s = r.end(r.length - 1) + ro, l = !a.endList;
    return l && o && (s = r.end(r.length - 1) + a.targetDuration * 3), i > s;
  }, t.beforeSeekableWindow_ = function(r, i) {
    return !!(r.length && r.start(0) > 0 && i < r.start(0) - this.liveRangeSafeTimeDelta);
  }, t.videoUnderflow_ = function(r) {
    var i = r.videoBuffered, a = r.audioBuffered, o = r.currentTime;
    if (!!i) {
      var s;
      if (i.length && a.length) {
        var l = Su(i, o - 3), u = Su(i, o), c = Su(a, o);
        c.length && !u.length && l.length && (s = {
          start: l.end(0),
          end: c.end(0)
        });
      } else {
        var f = k1(i, o);
        f.length || (s = this.gapFromVideoUnderflow_(i, o));
      }
      return s ? (this.logger_("Encountered a gap in video from " + s.start + " to " + s.end + ". " + ("Seeking to current time " + o)), !0) : !1;
    }
  }, t.skipTheGap_ = function(r) {
    var i = this.tech_.buffered(), a = this.tech_.currentTime(), o = k1(i, a);
    this.cancelTimer_(), !(o.length === 0 || a !== r) && (this.logger_("skipTheGap_:", "currentTime:", a, "scheduled currentTime:", r, "nextRange start:", o.start(0)), this.tech_.setCurrentTime(o.start(0) + Fs), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-gap-skip"
    }));
  }, t.gapFromVideoUnderflow_ = function(r, i) {
    for (var a = Ile(r), o = 0; o < a.length; o++) {
      var s = a.start(o), l = a.end(o);
      if (i - s < 4 && i - s > 2)
        return {
          start: s,
          end: l
        };
    }
    return null;
  }, e;
}(), qce = {
  errorInterval: 30,
  getSource: function(t) {
    var n = this.tech({
      IWillNotUseThisInPlugins: !0
    }), r = n.currentSource_ || this.currentSource();
    return t(r);
  }
}, _ce = function e(t, n) {
  var r = 0, i = 0, a = Ce.mergeOptions(qce, n);
  t.ready(function() {
    t.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    }), t.trigger({
      type: "usage",
      name: "hls-error-reload-initialized"
    });
  });
  var o = function() {
    i && t.currentTime(i);
  }, s = function(d) {
    d != null && (i = t.duration() !== 1 / 0 && t.currentTime() || 0, t.one("loadedmetadata", o), t.src(d), t.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), t.trigger({
      type: "usage",
      name: "hls-error-reload"
    }), t.play());
  }, l = function() {
    if (Date.now() - r < a.errorInterval * 1e3) {
      t.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      }), t.trigger({
        type: "usage",
        name: "hls-error-reload-canceled"
      });
      return;
    }
    if (!a.getSource || typeof a.getSource != "function") {
      Ce.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return r = Date.now(), a.getSource.call(t, s);
  }, u = function f() {
    t.off("loadedmetadata", o), t.off("error", l), t.off("dispose", f);
  }, c = function(d) {
    u(), e(t, d);
  };
  t.on("error", l), t.on("dispose", u), t.reloadSourceOnError = c;
}, Wce = function(t) {
  _ce(this, t);
}, jx = "2.14.2", Kce = "6.0.1", Gce = "0.21.1", Yce = "4.7.1", Qce = "3.1.3", Ui = {
  PlaylistLoader: Eu,
  Playlist: Dr,
  utils: sue,
  STANDARD_PLAYLIST_SELECTOR: s9,
  INITIAL_PLAYLIST_SELECTOR: Yue,
  lastBandwidthSelector: s9,
  movingAverageBandwidthSelector: Kue,
  comparePlaylistBandwidth: K6,
  comparePlaylistResolution: Wue,
  xhr: vx()
};
Object.keys(Ii).forEach(function(e) {
  Object.defineProperty(Ui, e, {
    get: function() {
      return Ce.log.warn("using Vhs." + e + " is UNSAFE be sure you know what you are doing"), Ii[e];
    },
    set: function(n) {
      if (Ce.log.warn("using Vhs." + e + " is UNSAFE be sure you know what you are doing"), typeof n != "number" || n < 0) {
        Ce.log.warn("value of Vhs." + e + " must be greater than or equal to 0");
        return;
      }
      Ii[e] = n;
    }
  });
});
var Fx = "videojs-vhs", Xx = function(t, n) {
  for (var r = n.media(), i = -1, a = 0; a < t.length; a++)
    if (t[a].id === r.id) {
      i = a;
      break;
    }
  t.selectedIndex_ = i, t.trigger({
    selectedIndex: i,
    type: "change"
  });
}, Zce = function(t, n) {
  n.representations().forEach(function(r) {
    t.addQualityLevel(r);
  }), Xx(t, n.playlists);
};
Ui.canPlaySource = function() {
  return Ce.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var Jce = function(t, n, r) {
  if (!t)
    return t;
  var i = {};
  n && n.attributes && n.attributes.CODECS && (i = fh(eo(n.attributes.CODECS))), r && r.attributes && r.attributes.CODECS && (i.audio = r.attributes.CODECS);
  var a = Yd(i.video), o = Yd(i.audio), s = {};
  for (var l in t)
    s[l] = {}, o && (s[l].audioContentType = o), a && (s[l].videoContentType = a), n.contentProtection && n.contentProtection[l] && n.contentProtection[l].pssh && (s[l].pssh = n.contentProtection[l].pssh), typeof t[l] == "string" && (s[l].url = t[l]);
  return Ce.mergeOptions(t, s);
}, $ce = function(t, n) {
  return t.reduce(function(r, i) {
    if (!i.contentProtection)
      return r;
    var a = n.reduce(function(o, s) {
      var l = i.contentProtection[s];
      return l && l.pssh && (o[s] = {
        pssh: l.pssh
      }), o;
    }, {});
    return Object.keys(a).length && r.push(a), r;
  }, []);
}, ede = function(t) {
  var n = t.player, r = t.sourceKeySystems, i = t.audioMedia, a = t.mainPlaylists;
  if (!n.eme.initializeMediaKeys)
    return Promise.resolve();
  var o = i ? a.concat([i]) : a, s = $ce(o, Object.keys(r)), l = [], u = [];
  return s.forEach(function(c) {
    u.push(new Promise(function(f, d) {
      n.tech_.one("keysessioncreated", f);
    })), l.push(new Promise(function(f, d) {
      n.eme.initializeMediaKeys({
        keySystems: c
      }, function(h) {
        if (h) {
          d(h);
          return;
        }
        f();
      });
    }));
  }), Promise.race([
    Promise.all(l),
    Promise.race(u)
  ]);
}, tde = function(t) {
  var n = t.player, r = t.sourceKeySystems, i = t.media, a = t.audioMedia, o = Jce(r, i, a);
  return o ? (n.currentSource().keySystems = o, o && !n.eme ? (Ce.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, Rx = function() {
  if (!pe.localStorage)
    return null;
  var t = pe.localStorage.getItem(Fx);
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, nde = function(t) {
  if (!pe.localStorage)
    return !1;
  var n = Rx();
  n = n ? Ce.mergeOptions(n, t) : t;
  try {
    pe.localStorage.setItem(Fx, JSON.stringify(n));
  } catch {
    return !1;
  }
  return n;
}, ide = function(t) {
  return t.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(t.substring(t.indexOf(",") + 1)) : t;
};
Ui.supportsNativeHls = function() {
  if (!ft || !ft.createElement)
    return !1;
  var e = ft.createElement("video");
  if (!Ce.getTech("Html5").isSupported())
    return !1;
  var t = [
    "application/vnd.apple.mpegurl",
    "audio/mpegurl",
    "audio/x-mpegurl",
    "application/x-mpegurl",
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ];
  return t.some(function(n) {
    return /maybe|probably/i.test(e.canPlayType(n));
  });
}();
Ui.supportsNativeDash = function() {
  return !ft || !ft.createElement || !Ce.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(ft.createElement("video").canPlayType("application/dash+xml"));
}();
Ui.supportsTypeNatively = function(e) {
  return e === "hls" ? Ui.supportsNativeHls : e === "dash" ? Ui.supportsNativeDash : !1;
};
Ui.isSupported = function() {
  return Ce.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var rde = Ce.getComponent("Component"), Y6 = /* @__PURE__ */ function(e) {
  At(t, e);
  function t(r, i, a) {
    var o;
    if (o = e.call(this, i, Ce.mergeOptions(a.hls, a.vhs)) || this, a.hls && Object.keys(a.hls).length && Ce.log.warn("Using hls options is deprecated. Please rename `hls` to `vhs` in your options object."), typeof a.initialBandwidth == "number" && (o.options_.bandwidth = a.initialBandwidth), o.logger_ = Ya("VhsHandler"), i.options_ && i.options_.playerId) {
      var s = Ce(i.options_.playerId);
      s.hasOwnProperty("hls") || Object.defineProperty(s, "hls", {
        get: function() {
          return Ce.log.warn("player.hls is deprecated. Use player.tech().vhs instead."), i.trigger({
            type: "usage",
            name: "hls-player-access"
          }), on(o);
        },
        configurable: !0
      }), s.hasOwnProperty("vhs") || Object.defineProperty(s, "vhs", {
        get: function() {
          return Ce.log.warn("player.vhs is deprecated. Use player.tech().vhs instead."), i.trigger({
            type: "usage",
            name: "vhs-player-access"
          }), on(o);
        },
        configurable: !0
      }), s.hasOwnProperty("dash") || Object.defineProperty(s, "dash", {
        get: function() {
          return Ce.log.warn("player.dash is deprecated. Use player.tech().vhs instead."), on(o);
        },
        configurable: !0
      }), o.player_ = s;
    }
    if (o.tech_ = i, o.source_ = r, o.stats = {}, o.ignoreNextSeekingEvent_ = !1, o.setOptions_(), o.options_.overrideNative && i.overrideNativeAudioTracks && i.overrideNativeVideoTracks)
      i.overrideNativeAudioTracks(!0), i.overrideNativeVideoTracks(!0);
    else if (o.options_.overrideNative && (i.featuresNativeVideoTracks || i.featuresNativeAudioTracks))
      throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
    return o.on(ft, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function(l) {
      var u = ft.fullscreenElement || ft.webkitFullscreenElement || ft.mozFullScreenElement || ft.msFullscreenElement;
      u && u.contains(o.tech_.el()) ? o.masterPlaylistController_.fastQualityChange_() : o.masterPlaylistController_.checkABR_();
    }), o.on(o.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), o.on(o.tech_, "error", function() {
      this.tech_.error() && this.masterPlaylistController_ && this.masterPlaylistController_.pauseLoading();
    }), o.on(o.tech_, "play", o.play), o;
  }
  var n = t.prototype;
  return n.setOptions_ = function() {
    var i = this;
    if (this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.handleManifestRedirects = this.options_.handleManifestRedirects !== !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.smoothQualityChange = this.options_.smoothQualityChange || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, typeof this.options_.blacklistDuration != "number" && (this.options_.blacklistDuration = 5 * 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      var a = Rx();
      a && a.bandwidth && (this.options_.bandwidth = a.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-bandwidth-from-local-storage"
      })), a && a.throughput && (this.options_.throughput = a.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Ii.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Ii.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "experimentalBufferBasedABR", "liveRangeSafeTimeDelta", "experimentalLLHLS", "useNetworkInformationApi", "useDtsForTimestampOffset", "experimentalExactManifestTimings", "experimentalLeastPixelDiffSelector"].forEach(function(o) {
      typeof i.source_[o] < "u" && (i.options_[o] = i.source_[o]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
  }, n.src = function(i, a) {
    var o = this;
    if (!!i) {
      this.setOptions_(), this.options_.src = ide(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = Ui, this.options_.sourceType = iw(a), this.options_.seekTo = function(u) {
        o.tech_.setCurrentTime(u);
      }, this.options_.smoothQualityChange && Ce.log.warn("smoothQualityChange is deprecated and will be removed in the next major version"), this.masterPlaylistController_ = new Fce(this.options_);
      var s = Ce.mergeOptions({
        liveRangeSafeTimeDelta: ro
      }, this.options_, {
        seekable: function() {
          return o.seekable();
        },
        media: function() {
          return o.masterPlaylistController_.media();
        },
        masterPlaylistController: this.masterPlaylistController_
      });
      this.playbackWatcher_ = new Uce(s), this.masterPlaylistController_.on("error", function() {
        var u = Ce.players[o.tech_.options_.playerId], c = o.masterPlaylistController_.error;
        typeof c == "object" && !c.code ? c.code = 3 : typeof c == "string" && (c = {
          message: c,
          code: 3
        }), u.error(c);
      });
      var l = this.options_.experimentalBufferBasedABR ? Ui.movingAverageBandwidthSelector(0.55) : Ui.STANDARD_PLAYLIST_SELECTOR;
      this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : l.bind(this), this.masterPlaylistController_.selectInitialPlaylist = Ui.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.masterPlaylistController_.masterPlaylistLoader_, this.mediaSource = this.masterPlaylistController_.mediaSource, Object.defineProperties(this, {
        selectPlaylist: {
          get: function() {
            return this.masterPlaylistController_.selectPlaylist;
          },
          set: function(c) {
            this.masterPlaylistController_.selectPlaylist = c.bind(this);
          }
        },
        throughput: {
          get: function() {
            return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
          },
          set: function(c) {
            this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = c, this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
          }
        },
        bandwidth: {
          get: function() {
            var c = this.masterPlaylistController_.mainSegmentLoader_.bandwidth, f = pe.navigator.connection || pe.navigator.mozConnection || pe.navigator.webkitConnection, d = 1e7;
            if (this.options_.useNetworkInformationApi && f) {
              var h = f.downlink * 1e3 * 1e3;
              h >= d && c >= d ? c = Math.max(c, h) : c = h;
            }
            return c;
          },
          set: function(c) {
            this.masterPlaylistController_.mainSegmentLoader_.bandwidth = c, this.masterPlaylistController_.mainSegmentLoader_.throughput = {
              rate: 0,
              count: 0
            };
          }
        },
        systemBandwidth: {
          get: function() {
            var c = 1 / (this.bandwidth || 1), f;
            this.throughput > 0 ? f = 1 / this.throughput : f = 0;
            var d = Math.floor(1 / (c + f));
            return d;
          },
          set: function() {
            Ce.log.error('The "systemBandwidth" property is read-only');
          }
        }
      }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
        bandwidth: {
          get: function() {
            return o.bandwidth || 0;
          },
          enumerable: !0
        },
        mediaRequests: {
          get: function() {
            return o.masterPlaylistController_.mediaRequests_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsAborted: {
          get: function() {
            return o.masterPlaylistController_.mediaRequestsAborted_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsTimedout: {
          get: function() {
            return o.masterPlaylistController_.mediaRequestsTimedout_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsErrored: {
          get: function() {
            return o.masterPlaylistController_.mediaRequestsErrored_() || 0;
          },
          enumerable: !0
        },
        mediaTransferDuration: {
          get: function() {
            return o.masterPlaylistController_.mediaTransferDuration_() || 0;
          },
          enumerable: !0
        },
        mediaBytesTransferred: {
          get: function() {
            return o.masterPlaylistController_.mediaBytesTransferred_() || 0;
          },
          enumerable: !0
        },
        mediaSecondsLoaded: {
          get: function() {
            return o.masterPlaylistController_.mediaSecondsLoaded_() || 0;
          },
          enumerable: !0
        },
        mediaAppends: {
          get: function() {
            return o.masterPlaylistController_.mediaAppends_() || 0;
          },
          enumerable: !0
        },
        mainAppendsToLoadedData: {
          get: function() {
            return o.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        audioAppendsToLoadedData: {
          get: function() {
            return o.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        appendsToLoadedData: {
          get: function() {
            return o.masterPlaylistController_.appendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        timeToLoadedData: {
          get: function() {
            return o.masterPlaylistController_.timeToLoadedData_() || 0;
          },
          enumerable: !0
        },
        buffered: {
          get: function() {
            return bl(o.tech_.buffered());
          },
          enumerable: !0
        },
        currentTime: {
          get: function() {
            return o.tech_.currentTime();
          },
          enumerable: !0
        },
        currentSource: {
          get: function() {
            return o.tech_.currentSource_;
          },
          enumerable: !0
        },
        currentTech: {
          get: function() {
            return o.tech_.name_;
          },
          enumerable: !0
        },
        duration: {
          get: function() {
            return o.tech_.duration();
          },
          enumerable: !0
        },
        master: {
          get: function() {
            return o.playlists.master;
          },
          enumerable: !0
        },
        playerDimensions: {
          get: function() {
            return o.tech_.currentDimensions();
          },
          enumerable: !0
        },
        seekable: {
          get: function() {
            return bl(o.tech_.seekable());
          },
          enumerable: !0
        },
        timestamp: {
          get: function() {
            return Date.now();
          },
          enumerable: !0
        },
        videoPlaybackQuality: {
          get: function() {
            return o.tech_.getVideoPlaybackQuality();
          },
          enumerable: !0
        }
      }), this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_)), this.tech_.on("bandwidthupdate", function() {
        o.options_.useBandwidthFromLocalStorage && nde({
          bandwidth: o.bandwidth,
          throughput: Math.round(o.throughput)
        });
      }), this.masterPlaylistController_.on("selectedinitialmedia", function() {
        Vce(o);
      }), this.masterPlaylistController_.sourceUpdater_.on("createdsourcebuffers", function() {
        o.setupEme_();
      }), this.on(this.masterPlaylistController_, "progress", function() {
        this.tech_.trigger("progress");
      }), this.on(this.masterPlaylistController_, "firstplay", function() {
        this.ignoreNextSeekingEvent_ = !0;
      }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = pe.URL.createObjectURL(this.masterPlaylistController_.mediaSource), this.tech_.src(this.mediaSourceUrl_));
    }
  }, n.createKeySessions_ = function() {
    var i = this, a = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), ede({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: a && a.media(),
      mainPlaylists: this.playlists.master.playlists
    }).then(function() {
      i.logger_("created EME key session"), i.masterPlaylistController_.sourceUpdater_.initializedEme();
    }).catch(function(o) {
      i.logger_("error while creating EME key session", o), i.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }, n.handleWaitingForKey_ = function() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }, n.setupEme_ = function() {
    var i = this, a = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader, o = tde({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: a && a.media()
    });
    if (this.player_.tech_.on("keystatuschange", function(s) {
      s.status === "output-restricted" && i.masterPlaylistController_.blacklistCurrentPlaylist({
        playlist: i.masterPlaylistController_.media(),
        message: "DRM keystatus changed to " + s.status + ". Playlist will fail to play. Check for HDCP content.",
        blacklistDuration: 1 / 0
      });
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), Ce.browser.IE_VERSION === 11 || !o) {
      this.masterPlaylistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }, n.setupQualityLevels_ = function() {
    var i = this, a = Ce.players[this.tech_.options_.playerId];
    !a || !a.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = a.qualityLevels(), this.masterPlaylistController_.on("selectedinitialmedia", function() {
      Zce(i.qualityLevels_, i);
    }), this.playlists.on("mediachange", function() {
      Xx(i.qualityLevels_, i.playlists);
    }));
  }, t.version = function() {
    return {
      "@videojs/http-streaming": jx,
      "mux.js": Kce,
      "mpd-parser": Gce,
      "m3u8-parser": Yce,
      "aes-decrypter": Qce
    };
  }, n.version = function() {
    return this.constructor.version();
  }, n.canChangeType = function() {
    return Nx.canChangeType();
  }, n.play = function() {
    this.masterPlaylistController_.play();
  }, n.setCurrentTime = function(i) {
    this.masterPlaylistController_.setCurrentTime(i);
  }, n.duration = function() {
    return this.masterPlaylistController_.duration();
  }, n.seekable = function() {
    return this.masterPlaylistController_.seekable();
  }, n.dispose = function() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.masterPlaylistController_ && this.masterPlaylistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.player_ && (delete this.player_.vhs, delete this.player_.dash, delete this.player_.hls), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.tech_ && delete this.tech_.hls, this.mediaSourceUrl_ && pe.URL.revokeObjectURL && (pe.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), e.prototype.dispose.call(this);
  }, n.convertToProgramTime = function(i, a) {
    return pue({
      playlist: this.masterPlaylistController_.media(),
      time: i,
      callback: a
    });
  }, n.seekToProgramTime = function(i, a, o, s) {
    return o === void 0 && (o = !0), s === void 0 && (s = 2), vue({
      programTime: i,
      playlist: this.masterPlaylistController_.media(),
      retryCount: s,
      pauseAfterSeek: o,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: a
    });
  }, t;
}(rde), v2 = {
  name: "videojs-http-streaming",
  VERSION: jx,
  canHandleSource: function(t, n) {
    n === void 0 && (n = {});
    var r = Ce.mergeOptions(Ce.options, n);
    return v2.canPlayType(t.type, r);
  },
  handleSource: function(t, n, r) {
    r === void 0 && (r = {});
    var i = Ce.mergeOptions(Ce.options, r);
    return n.vhs = new Y6(t, n, i), Ce.hasOwnProperty("hls") || Object.defineProperty(n, "hls", {
      get: function() {
        return Ce.log.warn("player.tech().hls is deprecated. Use player.tech().vhs instead."), n.vhs;
      },
      configurable: !0
    }), n.vhs.xhr = vx(), n.vhs.src(t.src, t.type), n.vhs;
  },
  canPlayType: function(t, n) {
    n === void 0 && (n = {});
    var r = Ce.mergeOptions(Ce.options, n), i = r.vhs;
    i = i === void 0 ? {} : i;
    var a = i.overrideNative, o = a === void 0 ? !Ce.browser.IS_ANY_SAFARI : a, s = r.hls;
    s = s === void 0 ? {} : s;
    var l = s.overrideNative, u = l === void 0 ? !1 : l, c = iw(t), f = c && (!Ui.supportsTypeNatively(c) || u || o);
    return f ? "maybe" : "";
  }
}, ade = function() {
  return v0("avc1.4d400d,mp4a.40.2");
};
ade() && Ce.getTech("Html5").registerSourceHandler(v2, 0);
Ce.VhsHandler = Y6;
Object.defineProperty(Ce, "HlsHandler", {
  get: function() {
    return Ce.log.warn("videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead."), Y6;
  },
  configurable: !0
});
Ce.VhsSourceHandler = v2;
Object.defineProperty(Ce, "HlsSourceHandler", {
  get: function() {
    return Ce.log.warn("videojs.HlsSourceHandler is deprecated. Use videojs.VhsSourceHandler instead."), v2;
  },
  configurable: !0
});
Ce.Vhs = Ui;
Object.defineProperty(Ce, "Hls", {
  get: function() {
    return Ce.log.warn("videojs.Hls is deprecated. Use videojs.Vhs instead."), Ui;
  },
  configurable: !0
});
Ce.use || (Ce.registerComponent("Hls", Ui), Ce.registerComponent("Vhs", Ui));
Ce.options.vhs = Ce.options.vhs || {};
Ce.options.hls = Ce.options.hls || {};
if (!Ce.getPlugin || !Ce.getPlugin("reloadSourceOnError")) {
  var ode = Ce.registerPlugin || Ce.plugin;
  ode("reloadSourceOnError", Wce);
}
const sde = "\u64AD\u653E", lde = "\u6682\u505C", ude = "\u65F6\u957F", cde = "\u76F4\u64AD", dde = "\u52A0\u8F7D\u5B8C\u6210", fde = "\u8FDB\u5EA6", hde = "\u5168\u5C4F", pde = "\u9759\u97F3", vde = "\u53D6\u6D88\u9759\u97F3", mde = "\u5B57\u5E55", gde = "\u5185\u5D4C\u5B57\u5E55", yde = "\u8282\u76EE\u6BB5\u843D", bde = "\u63CF\u8FF0", Ade = "\u5173\u95ED", Tde = "\u91CD\u65B0\u64AD\u653E", wde = "\u6587\u5B57", Pde = "\u767D", xde = "\u9ED1", Cde = "\u7EA2", Sde = "\u7EFF", Ede = "\u84DD", kde = "\u9EC4", Ode = "\u7D2B\u7EA2", zde = "\u9752", Dde = "\u80CC\u666F", Mde = "\u7A97\u53E3", Hde = "\u900F\u660E", Ide = "\u4E0D\u900F\u660E", Lde = "\u65E0", Bde = "\u6D6E\u96D5", Nde = "\u538B\u4F4E", jde = "\u5747\u5300", Fde = "\u4E0B\u9634\u5F71", Xde = "\u8212\u9002", Rde = "\u624B\u5199\u4F53", Vde = "\u91CD\u7F6E", Ude = "\u5B8C\u6210", Vx = {
  Play: sde,
  Pause: lde,
  "Current Time": "\u5F53\u524D\u65F6\u95F4",
  Duration: ude,
  "Remaining Time": "\u5269\u4F59\u65F6\u95F4",
  "Stream Type": "\u5A92\u4F53\u6D41\u7C7B\u578B",
  LIVE: cde,
  Loaded: dde,
  Progress: fde,
  Fullscreen: hde,
  "Non-Fullscreen": "\u9000\u51FA\u5168\u5C4F",
  "Picture-in-Picture": "\u753B\u4E2D\u753B",
  "Exit Picture-in-Picture": "\u9000\u51FA\u753B\u4E2D\u753B",
  Mute: pde,
  Unmute: vde,
  "Playback Rate": "\u64AD\u653E\u901F\u5EA6",
  Subtitles: mde,
  "subtitles off": "\u5173\u95ED\u5B57\u5E55",
  Captions: gde,
  "captions off": "\u5173\u95ED\u5185\u5D4C\u5B57\u5E55",
  Chapters: yde,
  "Close Modal Dialog": "\u5173\u95ED\u5F39\u7A97",
  Descriptions: bde,
  "descriptions off": "\u5173\u95ED\u63CF\u8FF0",
  "Audio Track": "\u97F3\u8F68",
  "You aborted the media playback": "\u89C6\u9891\u64AD\u653E\u88AB\u7EC8\u6B62",
  "A network error caused the media download to fail part-way.": "\u7F51\u7EDC\u9519\u8BEF\u5BFC\u81F4\u89C6\u9891\u4E0B\u8F7D\u4E2D\u9014\u5931\u8D25\u3002",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "\u89C6\u9891\u56E0\u683C\u5F0F\u4E0D\u652F\u6301\u6216\u8005\u670D\u52A1\u5668\u6216\u7F51\u7EDC\u7684\u95EE\u9898\u65E0\u6CD5\u52A0\u8F7D\u3002",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "\u7531\u4E8E\u89C6\u9891\u6587\u4EF6\u635F\u574F\u6216\u662F\u8BE5\u89C6\u9891\u4F7F\u7528\u4E86\u4F60\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u7684\u529F\u80FD\uFF0C\u64AD\u653E\u7EC8\u6B62\u3002",
  "No compatible source was found for this media.": "\u65E0\u6CD5\u627E\u5230\u6B64\u89C6\u9891\u517C\u5BB9\u7684\u6E90\u3002",
  "The media is encrypted and we do not have the keys to decrypt it.": "\u89C6\u9891\u5DF2\u52A0\u5BC6\uFF0C\u65E0\u6CD5\u89E3\u5BC6\u3002",
  "Play Video": "\u64AD\u653E\u89C6\u9891",
  Close: Ade,
  "Modal Window": "\u5F39\u7A97",
  "This is a modal window": "\u8FD9\u662F\u4E00\u4E2A\u5F39\u7A97",
  "This modal can be closed by pressing the Escape key or activating the close button.": "\u53EF\u4EE5\u6309ESC\u6309\u952E\u6216\u542F\u7528\u5173\u95ED\u6309\u94AE\u6765\u5173\u95ED\u6B64\u5F39\u7A97\u3002",
  ", opens captions settings dialog": ", \u5F00\u542F\u6807\u9898\u8BBE\u7F6E\u5F39\u7A97",
  ", opens subtitles settings dialog": ", \u5F00\u542F\u5B57\u5E55\u8BBE\u7F6E\u5F39\u7A97",
  ", opens descriptions settings dialog": ", \u5F00\u542F\u63CF\u8FF0\u8BBE\u7F6E\u5F39\u7A97",
  ", selected": ", \u9009\u62E9",
  "captions settings": "\u5B57\u5E55\u8BBE\u5B9A",
  "Audio Player": "\u97F3\u9891\u64AD\u653E\u5668",
  "Video Player": "\u89C6\u9891\u64AD\u653E\u5668",
  Replay: Tde,
  "Progress Bar": "\u8FDB\u5EA6\u6761",
  "Volume Level": "\u97F3\u91CF",
  "subtitles settings": "\u5B57\u5E55\u8BBE\u5B9A",
  "descriptions settings": "\u63CF\u8FF0\u8BBE\u5B9A",
  Text: wde,
  White: Pde,
  Black: xde,
  Red: Cde,
  Green: Sde,
  Blue: Ede,
  Yellow: kde,
  Magenta: Ode,
  Cyan: zde,
  Background: Dde,
  Window: Mde,
  Transparent: Hde,
  "Semi-Transparent": "\u534A\u900F\u660E",
  Opaque: Ide,
  "Font Size": "\u5B57\u4F53\u5C3A\u5BF8",
  "Text Edge Style": "\u5B57\u4F53\u8FB9\u7F18\u6837\u5F0F",
  None: Lde,
  Raised: Bde,
  Depressed: Nde,
  Uniform: jde,
  Dropshadow: Fde,
  "Font Family": "\u5B57\u4F53\u5E93",
  "Proportional Sans-Serif": "\u6BD4\u4F8B\u65E0\u7EC6\u4F53",
  "Monospace Sans-Serif": "\u5355\u95F4\u9694\u65E0\u7EC6\u4F53",
  "Proportional Serif": "\u6BD4\u4F8B\u7EC6\u4F53",
  "Monospace Serif": "\u5355\u95F4\u9694\u7EC6\u4F53",
  Casual: Xde,
  Script: Rde,
  "Small Caps": "\u5C0F\u578B\u5927\u5199\u5B57\u4F53",
  Reset: Vde,
  "restore all settings to the default values": "\u6062\u590D\u5168\u90E8\u8BBE\u5B9A\u81F3\u9884\u8BBE\u503C",
  Done: Ude,
  "Caption Settings Dialog": "\u5B57\u5E55\u8BBE\u5B9A\u7A97\u53E3",
  "Beginning of dialog window. Escape will cancel and close the window.": "\u6253\u5F00\u5BF9\u8BDD\u7A97\u53E3\u3002Escape\u952E\u5C06\u53D6\u6D88\u5E76\u5173\u95ED\u5BF9\u8BDD\u7A97\u53E3",
  "End of dialog window.": "\u7ED3\u675F\u5BF9\u8BDD\u7A97\u53E3",
  "Seek to live, currently behind live": "\u5C1D\u8BD5\u76F4\u64AD\uFF0C\u5F53\u524D\u4E3A\u5EF6\u65F6\u64AD\u653E",
  "Seek to live, currently playing live": "\u5C1D\u8BD5\u76F4\u64AD\uFF0C\u5F53\u524D\u4E3A\u5B9E\u65F6\u64AD\u653E",
  "progress bar timing: currentTime={1} duration={2}": "{1}/{2}",
  "{1} is loading.": "\u6B63\u5728\u52A0\u8F7D {1}\u3002"
};
const Ux = (e) => (yn("data-v-e66695c3"), e = e(), bn(), e), qde = {
  key: 0,
  class: "comment-body"
}, _de = ["src"], Wde = { class: "name" }, Kde = /* @__PURE__ */ je("\u53D6\u6D88"), Gde = /* @__PURE__ */ je("\u4FDD\u5B58"), Yde = /* @__PURE__ */ Ux(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tianjia" }, null, -1)), Qde = /* @__PURE__ */ Ux(() => /* @__PURE__ */ T("span", null, "\u6DFB\u52A0\u6279\u6CE8", -1)), Zde = [
  Yde,
  Qde
], Jde = {
  props: {
    show: Boolean,
    left: {
      type: String,
      default: "10%"
    },
    showAnchor: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:show", "update:showAnchor", "saveAnchor"],
  setup(e, { emit: t }) {
    const n = e, r = ce("userInfo"), i = ce("$utils");
    let a = j(!1);
    const o = j(null);
    let s = zt({
      comment: ""
    });
    const l = {
      comment: [{ required: !0, message: "\u6279\u6CE8\u5FC5\u586B" }]
    };
    Ne(
      () => n.showAnchor,
      (f, d) => {
        a.value = f, s.comment = "";
      },
      { immediate: !0 }
    ), Ne(
      () => n.show,
      (f) => {
        f || (s.comment = "");
      }
    );
    const u = () => {
      a.value = !1, t("update:showAnchor", !1), t("update:show", !1);
    }, c = () => {
      o.value.validate(async (f) => {
        f && t("saveAnchor", s.comment);
      });
    };
    return (f, d) => {
      const h = ti, p = Sa, y = fn, m = Ca;
      return e.show ? (P(), L("div", {
        key: 0,
        class: "comment-box",
        style: Pt({ left: e.left, top: E(a) ? "-199px" : "-48px" })
      }, [
        E(a) ? (P(), L("div", qde, [
          T("img", {
            src: E(r).avatar || E(i).getImage("diffMark/user_icon.png"),
            class: "user-avatar",
            alt: ""
          }, null, 8, _de),
          B(m, {
            model: E(s),
            rules: l,
            class: "comment-form",
            ref_key: "anchor",
            ref: o
          }, {
            default: N(() => [
              T("div", Wde, de(E(r).realname), 1),
              B(p, { prop: "comment" }, {
                default: N(() => [
                  B(h, {
                    rows: 5,
                    resize: "none",
                    type: "textarea",
                    modelValue: E(s).comment,
                    "onUpdate:modelValue": d[0] || (d[0] = (b) => E(s).comment = b),
                    placeholder: "\u8BF7\u8F93\u5165\u6279\u6CE8"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(p, { style: { "text-align": "right" } }, {
                default: N(() => [
                  B(y, {
                    type: "primary",
                    plain: "",
                    onClick: u
                  }, {
                    default: N(() => [
                      Kde
                    ]),
                    _: 1
                  }),
                  B(y, {
                    type: "primary",
                    onClick: c
                  }, {
                    default: N(() => [
                      Gde
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])) : (P(), L("div", {
          key: 1,
          class: "anchor-box",
          onClick: d[1] || (d[1] = (b) => Bn(a) ? a.value = !0 : a = !0)
        }, Zde))
      ], 4)) : re("", !0);
    };
  }
}, $de = /* @__PURE__ */ Ht(Jde, [["__scopeId", "data-v-e66695c3"]]);
const qx = (e) => (yn("data-v-88d1a508"), e = e(), bn(), e), efe = { class: "video-box" }, tfe = {
  key: 0,
  class: "video-operate"
}, nfe = /* @__PURE__ */ qx(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tianjiapizhu add-icon" }, null, -1)), ife = /* @__PURE__ */ qx(() => /* @__PURE__ */ T("span", null, "\u6DFB\u52A0\u65B0\u6279\u6CE8", -1)), rfe = [
  nfe,
  ife
], afe = { class: "video-btn" }, ofe = { class: "slider-wrap" }, sfe = {
  props: {
    videoUrl: String,
    videoId: String,
    isPreview: {
      type: Boolean,
      default: !1
    },
    isAutoPlay: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    Ce.addLanguage("zh-CN", Vx);
    const n = ce("$http"), r = ce("siteId"), i = ce("columnId"), a = ce("pageMode"), o = ce("$bus");
    let s = j(null), l = j(null);
    const u = {
      controls: !0,
      autoplay: t.isAutoPlay,
      preload: "auto",
      aspectRatio: "16:9",
      fluid: !1,
      controlBar: {
        children: [
          {
            name: "playToggle"
          },
          {
            name: "currentTimeDisplay"
          },
          {
            name: "progressControl"
          },
          {
            name: "durationDisplay"
          },
          {
            name: "volumePanel",
            inline: !1
          },
          {
            name: "FullscreenToggle"
          }
        ]
      }
    };
    let c = j(0), f = zt({
      duration: 0,
      selectedVideoTime: [0, 0],
      leftSliderValue: 0,
      rightSliderValue: 0,
      showSlider: !1,
      subTime: 20
    }), d = zt({
      showModal: !1,
      showAnchor: !1,
      left: ""
    });
    const h = () => {
      s.value.currentTime(f.selectedVideoTime[0]), c.value ? s.value.pause() : s.value.play(), c.value = !c.value;
    }, p = (S) => {
      f.leftSliderValue = S[0], f.rightSliderValue = S[1], d.left = S[0] / f.duration * 100 + "%", d.showModal = !0;
    };
    Ne(
      () => [...f.selectedVideoTime],
      (S, C) => {
        C.toString() === "0,0" || S.toString() === C.toString() || (S[0] > 0 && S[1] === f.rightSliderValue ? s.value.currentTime(S[0]) : S[0] === f.leftSliderValue && S[1] < f.duration && s.value.currentTime(S[1]));
      }
    ), Ne(
      () => t.videoUrl,
      (S, C) => {
        s.value.pause(), s.value.src(S), s.value.load();
      }
    );
    const y = () => {
      d.showModal = !0, d.showAnchor = !0;
    }, m = async (S) => {
      let C = {
        annotation_text: parseInt(f.selectedVideoTime[0]) + "-" + parseInt(f.selectedVideoTime[1]),
        annotation_content: t.videoId,
        site_id: r,
        annotation_message: S,
        column_id: i
      };
      await n.saveAnnotation(C) && (An.success("\u6279\u6CE8\u6DFB\u52A0\u6210\u529F\uFF01"), d.showModal = !1, d.showAnchor = !1, f.selectedVideoTime[1] + f.subTime < f.duration ? f.selectedVideoTime = [
        f.selectedVideoTime[1],
        f.selectedVideoTime[1] + f.subTime
      ] : f.selectedVideoTime = [f.selectedVideoTime[1], f.duration], d.left = f.selectedVideoTime[0] / f.duration * 100 + "%", o.emit("updateContent"));
    }, b = ({ annotationText: S, columnId: C }) => {
      f.showSlider = !0;
      let v = parseInt(S.split("-")[0]), H = parseInt(S.split("-")[1]);
      f.selectedVideoTime = [v, H], s.value.currentTime(v), d.left = v / f.duration * 100 + "%", ha("html,body").animate(
        {
          scrollTop: ha(`#${C}`).offset().top
        },
        500
      );
    };
    rn(() => {
      x(t.videoUrl), o.on("videoAnnotation", (S) => {
        S.annotationContent == t.videoId && b(S);
      });
    }), hc(() => {
      s.value.dispose();
    });
    const x = (S) => {
      s.value = Ce(l.value, u, function() {
        console.log("onPlayerReady", this), this.src(S), this.on("loadedmetadata", function() {
          f.duration = this.duration() ? parseInt(this.duration()) : 0, a.value === 2 && (f.selectedVideoTime = [
            f.duration / 3,
            f.duration / 3 + f.subTime
          ], d.left = f.selectedVideoTime[0] / f.duration * 100 + "%", f.leftSliderValue = f.selectedVideoTime[0], f.rightSliderValue = f.selectedVideoTime[1]);
        }), this.on("play", function() {
          console.log("play"), c.value = 1;
        }), this.on("pause", function() {
          console.log("pause"), c.value = 0;
        }), this.on("timeupdate", function() {
          console.log("timeupdate");
        });
      });
    };
    function D(S) {
      return O0(S);
    }
    return (S, C) => {
      const v = hJ;
      return P(), L("section", null, [
        T("div", efe, [
          T("video", {
            class: "video-js vjs-big-play-centered",
            ref_key: "videoPlayer",
            ref: l
          }, null, 512)
        ]),
        !e.isPreview && (E(a) == 2 || E(f).showSlider) ? (P(), L("div", tfe, [
          E(a) === 2 ? (P(), L("div", {
            key: 0,
            class: "add-btn",
            onClick: y
          }, rfe)) : re("", !0),
          T("div", afe, [
            T("i", {
              class: se(["iconfont paly-icon", E(c) ? "icon-zanting" : "icon-ziyuan"]),
              onClick: h
            }, null, 2),
            T("div", ofe, [
              B(v, {
                modelValue: E(f).selectedVideoTime,
                "onUpdate:modelValue": C[0] || (C[0] = (H) => E(f).selectedVideoTime = H),
                range: "",
                max: E(f).duration,
                "format-tooltip": D,
                disabled: E(a) === 1,
                onChange: p
              }, null, 8, ["modelValue", "max", "disabled"]),
              B($de, {
                show: E(d).showModal,
                "onUpdate:show": C[1] || (C[1] = (H) => E(d).showModal = H),
                showAnchor: E(d).showAnchor,
                "onUpdate:showAnchor": C[2] || (C[2] = (H) => E(d).showAnchor = H),
                left: E(d).left,
                onSaveAnchor: m
              }, null, 8, ["show", "showAnchor", "left"])
            ])
          ])
        ])) : re("", !0)
      ]);
    };
  }
}, _x = /* @__PURE__ */ Ht(sfe, [["__scopeId", "data-v-88d1a508"]]);
const lfe = (e) => (yn("data-v-023a197e"), e = e(), bn(), e), ufe = /* @__PURE__ */ lfe(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tianjia" }, null, -1)), cfe = /* @__PURE__ */ je(" \u6DFB\u52A0\u6807\u6CE8 "), dfe = [
  ufe,
  cfe
], ffe = {
  key: 1,
  class: "comment"
}, hfe = { class: "name" }, pfe = { class: "comment-btn" }, vfe = /* @__PURE__ */ je("\u53D6\u6D88"), mfe = /* @__PURE__ */ je("\u4FDD\u5B58"), gfe = {
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    isAddAnchor: {
      type: Boolean,
      default: !0
    },
    tooltipOffset: {
      type: Array,
      default: [200, 100]
    }
  },
  emits: [
    "handleAddAnchor",
    "handleCancel",
    "update:isAddAnchor"
  ],
  setup(e, { emit: t }) {
    const n = e, r = ce("userInfo"), i = ce("$utils"), a = j(null), o = zt({
      comment: ""
    }), s = {
      comment: [{ required: !0, message: "\u6279\u6CE8\u5FC5\u586B" }]
    }, l = J(() => n.isAddAnchor ? 136 : 312), u = () => {
      o.comment = "", t("update:isAddAnchor", !1);
    }, c = () => {
      t("handleCancel");
    }, f = () => {
      a.value.validate((d) => {
        d && t("handleAddAnchor", o.comment);
      });
    };
    return (d, h) => {
      const p = lU, y = ti, m = Sa, b = fn, x = Ca, D = gf;
      return P(), ue(D, {
        placement: "bottom",
        width: E(l),
        "popper-options": {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: e.tooltipOffset
              }
            }
          ],
          removeOnDestroy: !0
        },
        teleported: !0,
        trigger: "manual",
        visible: e.visible,
        "onUpdate:visible": h[2] || (h[2] = (S) => Bn(visible) ? visible.value = S : null)
      }, {
        reference: N(() => [
          T("div", null, [
            tt(d.$slots, "default", {}, void 0, !0)
          ])
        ]),
        default: N(() => [
          T("div", {
            onClick: h[1] || (h[1] = wt(() => {
            }, ["stop"]))
          }, [
            e.isAddAnchor ? (P(), L("div", {
              key: 0,
              onClick: u,
              class: "add-anchor"
            }, dfe)) : (P(), L("div", ffe, [
              B(p, {
                class: "comment-avatar",
                size: 40,
                src: E(r).avatar || E(i).getImage("diffMark/user_icon.png")
              }, null, 8, ["src"]),
              B(x, {
                model: E(o),
                rules: s,
                class: "comment-form",
                ref_key: "anchorDom",
                ref: a
              }, {
                default: N(() => [
                  T("div", hfe, de(E(r).realname), 1),
                  B(m, {
                    label: "",
                    prop: "comment"
                  }, {
                    default: N(() => [
                      B(y, {
                        rows: 5,
                        resize: "none",
                        type: "textarea",
                        modelValue: E(o).comment,
                        "onUpdate:modelValue": h[0] || (h[0] = (S) => E(o).comment = S),
                        placeholder: "\u8BF7\u8F93\u5165\u6279\u6CE8"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  T("div", pfe, [
                    B(b, {
                      type: "primary",
                      plain: "",
                      onClick: c
                    }, {
                      default: N(() => [
                        vfe
                      ]),
                      _: 1
                    }),
                    B(b, {
                      type: "primary",
                      onClick: f
                    }, {
                      default: N(() => [
                        mfe
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          ])
        ]),
        _: 3
      }, 8, ["width", "popper-options", "visible"]);
    };
  }
}, yfe = /* @__PURE__ */ Ht(gfe, [["__scopeId", "data-v-023a197e"]]);
const bfe = { class: "wrapper" }, Afe = { class: "text" }, Tfe = {
  props: {
    btnText: {
      type: String,
      default: "\u7F16\u8F91\u5185\u5BB9"
    },
    content: {
      type: String,
      default: "\u8FD8\u672A\u7F16\u8F91\u5185\u5BB9\uFF0C\u5FEB\u70B9\u51FB\u7F16\u8F91\u5427"
    }
  },
  emits: ["edit"],
  setup(e, { emit: t }) {
    return (n, r) => {
      const i = fn;
      return P(), L("div", bfe, [
        B(i, {
          type: "primary",
          size: "large",
          class: "edit-btn",
          onClick: r[0] || (r[0] = (a) => t("edit")),
          plain: ""
        }, {
          default: N(() => [
            je(de(e.btnText), 1)
          ]),
          _: 1
        }),
        T("p", Afe, de(e.content), 1)
      ]);
    };
  }
}, sc = /* @__PURE__ */ Ht(Tfe, [["__scopeId", "data-v-5b1a6f64"]]);
const wfe = /* @__PURE__ */ wh('<link type="text/css" rel="stylesheet" href="//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/css/fineuploader-4.1.0.css" data-v-407c48e8><link type="text/css" rel="stylesheet" href="//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/css/reset.css" data-v-407c48e8><link type="text/css" rel="stylesheet" href="//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/css/aspupload.css" data-v-407c48e8><link type="text/css" rel="stylesheet" href="//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/css/uploadComponent.css" data-v-407c48e8><link rel="stylesheet" type="text/css" href="//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/layui/css/layui.css" data-v-407c48e8><div id="resource-upload" data-v-407c48e8></div>', 6), Pfe = {
  emits: ["handleUploadSuccess"],
  setup(e, { expose: t, emit: n }) {
    const r = ce("userInfo"), { courseId: i } = ce("caseOther"), a = ce("$http"), o = j(0), s = j(0), l = () => {
      $("#resource-upload :file").click();
    }, u = () => {
      $("#resource-upload").Ableuploader({
        videoConvert: "true",
        appName: "teaching_case",
        modelName: "TEACHING_CASE",
        userId: r.id,
        userName: r.realname,
        smallImgSize: "100:100",
        bigImgSize: "966:488",
        middleImgSize: "360:250",
        autoConvert: "true",
        targetId: "resource-upload",
        showProgress: "true",
        buttonText: "",
        buttonClass: "",
        allowSuffix: "",
        fileSizeLimit: 2147483648,
        buttonWidth: "60",
        buttonTextTopPadding: "1",
        watermark: !1,
        host: "//base1.zhihuishu.com/able-commons",
        callbacks: {
          onFileDialogStart: function(c) {
          },
          onError: function(c, f, d) {
            o.value--;
          },
          onUpload: function(c, f) {
            if (o.value + s.value >= 20)
              return !1;
            o.value++;
          },
          onComplete: async function(c, f, d) {
            if (console.log("success upload", d), o.value--, s.value++, d.code == 200) {
              let h = d.data;
              const p = {
                courseId: i,
                downloadUrl: h.filePath,
                fileId: h.fileId,
                name: h.fileName,
                size: h.size,
                suffix: h.suffix
              }, y = await a.saveZHSResource(p);
              n("handleUploadSuccess", y);
            }
          },
          onCancel: function() {
            o.value = 0;
          },
          onDeleteComplete: function(c, f, d) {
            o.value--;
          }
        }
      });
    };
    return rn(async () => {
      console.log("\u{1F92A} >>:", window.$), window.$ || (await kr(
        "//base1.zhihuishu.com/able-commons/resources/uploader/client/js/jquery/jquery-1.7.2.min.js"
      ), await kr("//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/layui/layui.js"), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/jquery.fineuploader-4.1.0.js"
      ), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/ableuploader.js"
      ), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/jquery-ui-1.9.1.custom.min.js"
      ), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/fineuploader.js"
      ), await kr("//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/swfupload.js"), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/swfupload.queue.js"
      ), await kr(
        "//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/swfupload.speed.js"
      ), await kr("//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/handlers_01.js"), await kr("//base1.zhihuishu.com/able-commons/resources/cdn/ableuploader/0.3/html5upload.js"), await kr(
        "//assets.zhihuishu.com/jquery.nanoscroller/0.8.7/javascripts/jquery.nanoscroller.min.js"
      )), u();
    }), t({
      uploadClick: l
    }), (c, f) => wfe;
  }
}, xfe = /* @__PURE__ */ Ht(Pfe, [["__scopeId", "data-v-407c48e8"]]);
const Cfe = (e) => (yn("data-v-2090fda8"), e = e(), bn(), e), Sfe = { class: "list-top" }, Efe = { class: "title" }, kfe = { class: "search-box" }, Ofe = /* @__PURE__ */ Cfe(() => /* @__PURE__ */ T("span", { class: "load-text" }, "\u5DF2\u5168\u90E8\u52A0\u8F7D", -1)), zfe = {
  class: "title",
  style: { "margin-right": "17px" }
}, Dfe = { class: "table-container table-box" }, Mfe = { class: "file-info" }, Hfe = ["src"], Ife = /* @__PURE__ */ je("\u67E5\u770B"), Lfe = { class: "page-box" }, Bfe = { class: "dialog-footer" }, Nfe = /* @__PURE__ */ je("\u53D6\u6D88"), jfe = /* @__PURE__ */ je(" \u786E\u5B9A\u5F15\u7528 "), Ffe = {
  props: {
    show: Boolean,
    source: Number,
    chapter: Object
  },
  emits: ["update:show", "selectedFile"],
  setup(e, { emit: t }) {
    const n = e, r = J(() => n.source === 1 ? "\u4ECE\u56E2\u961F\u8D44\u6E90\u5E93\u5F15\u7528" : n.source === 2 ? "\u5B66\u6821\u8D44\u6E90\u5E93" : "\u5F15\u7528\u8BFE\u7A0B\u8D44\u6E90"), i = ce("$http"), a = ce("$utils"), o = ce("siteId"), s = ce("columnId"), l = ce("caseOther"), u = j(""), c = j([]), f = zt({
      pageNum: 1,
      pageSize: 10,
      total: 0
    }), d = j([]), h = (v) => a.getImage(`diffMark/types_icon/${a.formatIcons(v)}.png`), p = () => {
      t("update:show", !1);
    }, y = () => {
      f.pageNum = 1, C();
    }, m = (v, H) => v.chooseStatus == 0, b = (v) => {
      d.value = v;
    }, x = async (v) => {
      let H = {
        cloudId: v.cloudId,
        fileId: v.fileId,
        id: v.id || void 0
      };
      await i.resourceIsPreview(H) && (v.fileType == 1 || v.fileType == 3 ? window.open(`/preview.html?id=${v.cloudId}&type=${v.fileType}&groupId=${l.groupId}`, "_blank") : window.open(`/preview.html?id=${v.cloudId}&type=${v.fileType}`, "_blank"));
    }, D = (v) => {
      f.pageNum = v, C();
    }, S = async () => {
      const v = d.value.map((H) => ({
        cloudId: H.cloudId,
        fileId: H.fileId,
        fileSize: H.fileSize,
        fileUrl: H.fileUrl,
        name: H.name,
        suffix: H.suffix,
        type: H.type,
        fileType: H.fileType
      }));
      t("selectedFile", v), p();
    }, C = async () => {
      let v = {
        columnId: s,
        pageNum: f.pageNum,
        pageSize: f.pageSize,
        queryType: n.source,
        siteId: o,
        fileName: u.value || void 0,
        courseId: l.courseId,
        outlineId: n.source === 3 ? n.chapter.chapterId : void 0
      };
      const { list: H, rowCount: V } = await i.getQuoteTeachingResource(v);
      c.value = H || [], f.total = V || 0;
    };
    return C(), (v, H) => {
      const V = qt, R = ti, F = Kh, K = fn, q = Wh, G = D3, te = ni;
      return P(), L("div", null, [
        B(te, {
          modelValue: e.show,
          "onUpdate:modelValue": H[1] || (H[1] = (Q) => Bn(show) ? show.value = Q : null),
          width: "980px",
          "append-to-body": !0,
          title: E(r),
          "before-close": p,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", Bfe, [
              B(K, {
                size: "large",
                onClick: p
              }, {
                default: N(() => [
                  Nfe
                ]),
                _: 1
              }),
              B(K, {
                type: "primary",
                size: "large",
                disabled: !d.value.length,
                onClick: S
              }, {
                default: N(() => [
                  jfe
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          default: N(() => [
            T("div", null, [
              T("div", Sfe, [
                T("span", Efe, de(e.source === 3 ? e.chapter.chapterName : "\u5168\u90E8\u6587\u4EF6"), 1),
                T("div", kfe, [
                  Ofe,
                  T("span", zfe, "\u5171" + de(E(f).total || 0) + "\u4E2A", 1),
                  B(R, {
                    modelValue: u.value,
                    "onUpdate:modelValue": H[0] || (H[0] = (Q) => u.value = Q),
                    size: "large",
                    style: { width: "204px" },
                    onKeyup: nn(y, ["native", "enter"]),
                    placeholder: "\u8BF7\u8F93\u5165\u6587\u4EF6\u540D\u79F0\u641C\u7D22"
                  }, {
                    suffix: N(() => [
                      B(V, { onClick: y }, {
                        default: N(() => [
                          B(E(Gh))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onKeyup"])
                ])
              ]),
              T("div", Dfe, [
                B(q, {
                  data: c.value,
                  height: "500",
                  ref: "resourceTable",
                  onSelectionChange: b
                }, {
                  default: N(() => [
                    B(F, {
                      type: "selection",
                      width: "55",
                      selectable: m
                    }),
                    B(F, {
                      label: "\u6587\u4EF6\u540D\u79F0",
                      "min-width": "300"
                    }, {
                      default: N((Q) => [
                        T("div", Mfe, [
                          T("img", {
                            src: h(Q.row.suffix),
                            alt: "",
                            class: "file-icon"
                          }, null, 8, Hfe),
                          T("span", null, de(Q.row.name), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    B(F, {
                      label: "\u6587\u4EF6\u5927\u5C0F",
                      "min-width": "100",
                      align: "center"
                    }, {
                      default: N((Q) => [
                        T("span", null, de(E(a).converByte(Q.row.fileSize)), 1)
                      ]),
                      _: 1
                    }),
                    B(F, {
                      property: "updateTime",
                      label: "\u4FEE\u6539\u65F6\u95F4",
                      align: "center",
                      "min-width": "130"
                    }),
                    B(F, {
                      label: "\u64CD\u4F5C",
                      "min-width": "100",
                      align: "center"
                    }, {
                      default: N((Q) => [
                        B(K, {
                          type: "text",
                          onClick: (Y) => x(Q.row)
                        }, {
                          default: N(() => [
                            Ife
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              T("div", Lfe, [
                B(G, {
                  onCurrentChange: D,
                  "current-page": E(f).pageNum,
                  layout: "prev, pager, next",
                  total: E(f).total
                }, null, 8, ["current-page", "total"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]);
    };
  }
}, Xfe = /* @__PURE__ */ Ht(Ffe, [["__scopeId", "data-v-2090fda8"]]);
const Rfe = { class: "file-info" }, Vfe = ["src"], Ufe = { class: "file-name" }, qfe = {
  key: 0,
  class: "file-btn"
}, _fe = {
  props: {
    fileInfo: Object
  },
  emits: ["handlePreviewFile"],
  setup(e, { emit: t }) {
    const n = ce("$utils"), r = ce("pageMode"), i = (o) => n.getImage(`diffMark/types_icon/${n.formatIcons(o)}.png`), a = (o) => {
      t("handlePreviewFile", o);
    };
    return (o, s) => (P(), L("div", {
      class: "file-list",
      onClick: s[0] || (s[0] = (l) => a(e.fileInfo))
    }, [
      T("div", Rfe, [
        T("img", {
          src: i(e.fileInfo.suffix),
          alt: "",
          class: "file-icon"
        }, null, 8, Vfe),
        T("div", Ufe, de(e.fileInfo.name || e.fileInfo.fileName), 1)
      ]),
      E(r) == 1 ? (P(), L("div", qfe, [
        tt(o.$slots, "default", {}, void 0, !0)
      ])) : re("", !0)
    ]));
  }
}, Wx = /* @__PURE__ */ Ht(_fe, [["__scopeId", "data-v-beabf39c"]]);
const Wfe = { class: "tree-box" }, Kfe = { key: 0 }, Gfe = { class: "dialog-footer" }, Yfe = /* @__PURE__ */ je("\u53D6\u6D88"), Qfe = /* @__PURE__ */ je("\u786E\u5B9A"), Zfe = {
  props: {
    show: Boolean,
    type: {
      type: Number,
      default: 0
    },
    courseId: String,
    selected: String
  },
  emits: ["update:show", "handleSelectedChapter"],
  setup(e, { emit: t }) {
    const n = e, r = J(() => {
      if (n.type === 1)
        return "\u9009\u62E9\u7AE0\u8282";
      if (n.type === 2)
        return "\u5F15\u7528\u8BFE\u7A0B\u8D44\u6E90";
    }), i = ce("$http"), a = j(), o = {
      value: "id",
      label: "name",
      children: "children"
    }, s = j([]), l = () => {
      t("update:show", !1);
    }, u = () => {
      const d = a.value.getCurrentNode();
      if (!d || n.type == 1 && d.id == 0) {
        An.warning("\u5F53\u524D\u672A\u9009\u62E9\u4EFB\u4F55\u7AE0\u8282");
        return;
      }
      console.log("selected", d), t("handleSelectedChapter", d), l();
    }, c = async (d) => {
      const h = await i.getBKChapterTree({ course_id: d });
      h && h.length && (s.value = [
        {
          id: 0,
          name: "\u5168\u90E8",
          children: h || []
        }
      ]);
    }, f = async (d) => {
      const h = await i.getCourseResourceTree({ courseId: d, type: 2 });
      s.value = h || [];
    };
    return Ne(
      () => n.courseId,
      (d) => {
        d && (n.type == 1 ? c(d) : n.type == 2 && f(d));
      },
      {
        immediate: !0
      }
    ), (d, h) => {
      const p = aee, y = fn, m = ni;
      return P(), L("div", null, [
        B(m, {
          modelValue: e.show,
          "onUpdate:modelValue": h[1] || (h[1] = (b) => Bn(show) ? show.value = b : null),
          width: "550px",
          title: E(r),
          "before-close": l,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", Gfe, [
              B(y, {
                size: "large",
                onClick: l
              }, {
                default: N(() => [
                  Yfe
                ]),
                _: 1
              }),
              B(y, {
                type: "primary",
                size: "large",
                onClick: h[0] || (h[0] = (b) => u())
              }, {
                default: N(() => [
                  Qfe
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", Wfe, [
              B(p, {
                ref_key: "chapterTree",
                ref: a,
                "node-key": "id",
                data: s.value,
                "current-node-key": e.selected,
                "highlight-current": !0,
                "default-expand-all": !0,
                "expand-on-click-node": !1,
                props: o,
                "empty-text": "\u6682\u65E0\u7AE0\u8282"
              }, {
                default: N(({ node: b, data: x }) => [
                  T("div", null, [
                    T("span", null, de(b.label), 1),
                    e.type == 2 ? (P(), L("span", Kfe, "(" + de(x.fileNum) + ")", 1)) : re("", !0)
                  ])
                ]),
                _: 1
              }, 8, ["data", "current-node-key"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]);
    };
  }
}, Kx = /* @__PURE__ */ Ht(Zfe, [["__scopeId", "data-v-dc284ea9"]]), go = (e) => (yn("data-v-d555faf5"), e = e(), bn(), e), Jfe = { class: "resource-box" }, $fe = ["onClick"], e1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("i", { class: "iconfont icon-wenjian-shanchu" }, null, -1)), t1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("span", { style: { "margin-left": "5px" } }, "\u5220\u9664", -1)), n1e = [
  e1e,
  t1e
], i1e = {
  key: 0,
  class: "edit-box"
}, r1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("div", { class: "resource-btn" }, [
  /* @__PURE__ */ T("i", { class: "add-icon" }),
  /* @__PURE__ */ T("span", null, "\u6DFB\u52A0\u6559\u5B66\u8D44\u6E90")
], -1)), a1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("span", null, "\u8BFE\u7A0B\u8D44\u6E90\u4E2D\u5F15\u7528", -1)), o1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiaoziyuan" }, null, -1)), s1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528\u5B66\u6821\u8D44\u6E90\u5E93", -1)), l1e = [
  o1e,
  s1e
], u1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shujuku" }, null, -1)), c1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528\u56E2\u961F\u8D44\u6E90\u5E93", -1)), d1e = [
  u1e,
  c1e
], f1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shangchuanbendi" }, null, -1)), h1e = /* @__PURE__ */ go(() => /* @__PURE__ */ T("span", null, "\u4E0A\u4F20\u672C\u5730\u8D44\u6E90", -1)), p1e = [
  f1e,
  h1e
], v1e = /* @__PURE__ */ Ee({
  props: {
    isEdit: {
      type: Boolean,
      default: !1
    },
    resourceList: Array
  },
  emits: ["handleSelectedFile", "handleSuccessFile", "handleDeleteResource"],
  setup(e, { emit: t }) {
    const n = ce("caseOther"), r = j(), i = j(!1), a = j(1), o = (h) => {
      const p = h.cloudId;
      h.fileType == 1 || h.fileType == 3 ? window.open(`/preview.html?id=${p}&type=${h.fileType}&groupId=${n.groupId}`, "_blank") : window.open(`/preview.html?id=${p}&type=${h.fileType}`, "_blank");
    }, s = (h, p) => {
      t("handleDeleteResource", { id: h, index: p });
    }, l = j(!1), u = (h) => {
      a.value = h, h == 3 ? l.value = !0 : i.value = !0;
    }, c = () => {
      r.value.uploadClick();
    }, f = zt({
      chapterId: "",
      chapterName: ""
    }), d = (h) => {
      f.chapterId = h.id, f.chapterName = h.name, i.value = !0;
    };
    return (h, p) => {
      const y = qt, m = gf;
      return P(), L(nt, null, [
        T("div", Jfe, [
          (P(!0), L(nt, null, Lt(e.resourceList, (b, x) => (P(), L("div", {
            class: "resource-item",
            key: b.fileId
          }, [
            B(Wx, {
              fileInfo: b,
              onHandlePreviewFile: o
            }, {
              default: N(() => [
                e.isEdit ? (P(), L("div", {
                  key: 0,
                  class: "delete-btn",
                  onClick: wt((D) => s(b.id, x), ["stop"])
                }, n1e, 8, $fe)) : re("", !0)
              ]),
              _: 2
            }, 1032, ["fileInfo"])
          ]))), 128))
        ]),
        e.isEdit ? (P(), L("div", i1e, [
          B(m, {
            placement: "bottom",
            trigger: "hover",
            width: 136,
            teleported: !1
          }, {
            reference: N(() => [
              r1e
            ]),
            default: N(() => [
              T("div", null, [
                T("div", {
                  class: "add-resource-way",
                  onClick: p[0] || (p[0] = (b) => u(3))
                }, [
                  B(y, { class: "document-icon" }, {
                    default: N(() => [
                      B(E(_te))
                    ]),
                    _: 1
                  }),
                  a1e
                ]),
                T("div", {
                  class: "add-resource-way",
                  onClick: p[1] || (p[1] = (b) => u(2))
                }, l1e),
                T("div", {
                  class: "add-resource-way",
                  onClick: p[2] || (p[2] = (b) => u(1))
                }, d1e),
                T("div", {
                  class: "add-resource-way",
                  onClick: c
                }, p1e),
                B(xfe, {
                  ref_key: "resourceUploadDom",
                  ref: r,
                  onHandleUploadSuccess: p[3] || (p[3] = (b) => t("handleSuccessFile", b))
                }, null, 512)
              ])
            ]),
            _: 1
          }),
          tt(h.$slots, "default", {}, void 0, !0)
        ])) : re("", !0),
        i.value ? (P(), ue(Xfe, {
          key: 1,
          show: i.value,
          "onUpdate:show": p[4] || (p[4] = (b) => i.value = b),
          source: a.value,
          chapter: E(f),
          onSelectedFile: p[5] || (p[5] = (b) => t("handleSelectedFile", b))
        }, null, 8, ["show", "source", "chapter"])) : re("", !0),
        l.value ? (P(), ue(Kx, {
          key: 2,
          show: l.value,
          "onUpdate:show": p[6] || (p[6] = (b) => l.value = b),
          type: 2,
          courseId: E(n).courseId,
          onHandleSelectedChapter: d
        }, null, 8, ["show", "courseId"])) : re("", !0)
      ], 64);
    };
  }
});
const m1e = /* @__PURE__ */ Ht(v1e, [["__scopeId", "data-v-d555faf5"]]);
const g1e = ["src"], y1e = {
  props: {
    videoUrl: String,
    coverUrl: String,
    videoId: String,
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    isAutoPlay: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    Ce.addLanguage("zh-CN", Vx);
    let n = j(null), r = j(null);
    const i = {
      controls: !0,
      autoplay: t.isAutoPlay,
      poster: t.coverUrl,
      preload: "auto",
      aspectRatio: "16:9",
      fluid: !1,
      controlBar: {
        children: [
          {
            name: "playToggle"
          },
          {
            name: "currentTimeDisplay"
          },
          {
            name: "progressControl"
          },
          {
            name: "durationDisplay"
          },
          {
            name: "volumePanel",
            inline: !1
          },
          {
            name: "FullscreenToggle"
          }
        ]
      }
    }, a = (o) => {
      n.value = Ce(
        E(r),
        i,
        s
      );
      function s() {
        console.log("onPlayerReady", this), this.src(o), this.on("play", function() {
          console.log("play");
        }), this.on("pause", function() {
          console.log("pause");
        });
      }
    };
    return rn(() => {
      t.videoUrl && a(t.videoUrl);
    }), hc(() => {
      n.value.dispose();
    }), (o, s) => (P(), L("div", {
      class: "video-box",
      style: Pt({ width: e.width, height: e.height })
    }, [
      e.videoUrl ? (P(), L("video", {
        key: 0,
        class: "video-js vjs-big-play-centered",
        ref_key: "videoPlayer",
        ref: r
      }, null, 512)) : (P(), L("img", {
        key: 1,
        src: e.coverUrl,
        class: "video-cover",
        alt: ""
      }, null, 8, g1e))
    ], 4));
  }
}, y9 = /* @__PURE__ */ Ht(y1e, [["__scopeId", "data-v-04fb7a5b"]]);
const b1e = { class: "file-header" }, A1e = ["src"], T1e = { class: "file-name" }, w1e = { class: "preview-wrapper" }, P1e = { class: "preview-box" }, x1e = ["src"], C1e = ["src"], S1e = {
  props: {
    show: Boolean,
    fileInfo: Object
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, r = ce("apiPrefix"), i = J(() => {
      const l = n.fileInfo.suffix;
      if (xy.includes(l))
        return "img";
      if (wy.includes(l))
        return "audio";
      if (Py.includes(l))
        return "video";
    }), a = (l) => new URL((/* @__PURE__ */ Object.assign({ "../../../assets/img/diffMark/types_icon/icon-excel.png": cy, "../../../assets/img/diffMark/types_icon/icon-image.png": dy, "../../../assets/img/diffMark/types_icon/icon-link.png": fy, "../../../assets/img/diffMark/types_icon/icon-music.png": hy, "../../../assets/img/diffMark/types_icon/icon-other.png": py, "../../../assets/img/diffMark/types_icon/icon-pdf.png": vy, "../../../assets/img/diffMark/types_icon/icon-ppt.png": my, "../../../assets/img/diffMark/types_icon/icon-txt.png": gy, "../../../assets/img/diffMark/types_icon/icon-video.png": yy, "../../../assets/img/diffMark/types_icon/icon-word.png": by, "../../../assets/img/diffMark/types_icon/icon-zip.png": Ay }))[`../../../assets/img/diffMark/types_icon/${Sy(l)}.png`], self.location).href, o = () => {
      t("update:show", !1);
    }, s = (l = "preview-iframe") => {
      const u = document.getElementById(l);
      if (u) {
        var c = u.contentWindow || u.contentDocument.parentWindow;
        console.log(u), u.style.height = c.document.documentElement.scrollHeight || c.document.body.scrollHeight;
      }
    };
    return (l, u) => {
      const c = ni;
      return P(), ue(c, {
        modelValue: e.show,
        "onUpdate:modelValue": u[1] || (u[1] = (f) => Bn(show) ? show.value = f : null),
        width: "800px",
        "append-to-body": !0,
        "before-close": o,
        "destroy-on-close": "",
        "close-on-click-modal": !1
      }, {
        title: N(() => [
          T("div", b1e, [
            T("img", {
              src: a(e.fileInfo.suffix),
              alt: "",
              class: "file-icon"
            }, null, 8, A1e),
            T("div", T1e, de(e.fileInfo.name), 1)
          ])
        ]),
        default: N(() => [
          T("div", w1e, [
            T("div", P1e, [
              E(i) === "img" ? (P(), L("img", {
                key: 0,
                class: "img",
                src: e.fileInfo.fileUrl,
                alt: ""
              }, null, 8, x1e)) : E(i) === "audio" ? (P(), ue(y9, {
                key: 1,
                videoUrl: e.fileInfo.fileUrl,
                height: "40px",
                width: "700px"
              }, null, 8, ["videoUrl"])) : E(i) === "video" ? (P(), ue(y9, {
                key: 2,
                videoUrl: e.fileInfo.fileUrl,
                height: "480px",
                width: "700px"
              }, null, 8, ["videoUrl"])) : (P(), L("iframe", {
                key: 3,
                onLoad: u[0] || (u[0] = (f) => s()),
                id: "preview-iframe",
                name: "preview-iframe",
                src: `/aliyuncs/previewdoc/index.html?fileId=${e.fileInfo.fileId}&prefix=${E(r)}`,
                style: { width: "700px", height: "500px" }
              }, null, 40, C1e))
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}, E1e = /* @__PURE__ */ Ht(S1e, [["__scopeId", "data-v-f5f424b3"]]);
const Gx = (e) => (yn("data-v-4f15233c"), e = e(), bn(), e), k1e = {
  key: 0,
  class: "file-box"
}, O1e = ["onClick"], z1e = /* @__PURE__ */ Gx(() => /* @__PURE__ */ T("span", { class: "text" }, "\u4E0A\u79FB", -1)), D1e = ["onClick"], M1e = /* @__PURE__ */ Gx(() => /* @__PURE__ */ T("span", { class: "text" }, "\u4E0B\u79FB", -1)), H1e = ["onClick"], I1e = {
  props: {
    fileList: Array
  },
  emits: ["handleUpload", "updateFile"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$utils"), i = ce("pageMode"), a = j(!1), o = zt({
      fileId: "",
      name: "",
      fileUrl: "",
      suffix: ""
    }), s = (c) => {
      o.fileId = c.fileId, o.name = c.fileName, o.fileUrl = c.fileUrl, o.suffix = c.suffix, a.value = !0;
    }, l = (c, f) => {
      let d = r.deepClone(n.fileList);
      [d[f], d[f + c]] = [d[f + c], d[f]];
      const h = d.map((p) => p.fileId).join(",");
      t("updateFile", h);
    }, u = (c) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u6587\u4EF6\u5417",
        tipText: "\u5220\u9664\u540E\u8BE5\u6587\u4EF6\u5C06\u4E0D\u5B58\u5728",
        confirmButtonText: "\u786E \u5B9A"
      }).then(() => {
        const f = r.deepClone(n.fileList);
        f.splice(c, 1);
        const d = f.map((h) => h.fileId).join(",");
        t("updateFile", d);
      }).catch((f) => {
        console.log(f);
      });
    };
    return (c, f) => (P(), L(nt, null, [
      T("div", null, [
        e.fileList && e.fileList.length ? (P(), L("div", k1e, [
          (P(!0), L(nt, null, Lt(e.fileList, (d, h) => (P(), ue(Wx, {
            fileInfo: d,
            key: d.fileId,
            onHandlePreviewFile: s
          }, {
            default: N(() => [
              T("div", {
                class: se(["move-btn move-up", { "move-disable": h == 0 }]),
                onClick: wt((p) => l(-1, h), ["stop"])
              }, [
                B(E(qi), { name: "\u4E0B\u79FB" }),
                z1e
              ], 10, O1e),
              T("div", {
                class: se(["move-btn", { "move-disable": h == e.fileList.length - 1 }]),
                onClick: wt((p) => l(1, h), ["stop"])
              }, [
                B(E(qi), { name: "\u4E0B\u79FB" }),
                M1e
              ], 10, D1e),
              T("span", {
                class: "delete-btn",
                onClick: wt((p) => u(h), ["stop"])
              }, "\u5220\u9664", 8, H1e)
            ]),
            _: 2
          }, 1032, ["fileInfo"]))), 128))
        ])) : re("", !0),
        E(i) == 1 && !e.fileList ? (P(), ue(sc, {
          key: 1,
          btnText: "\u4E0A\u4F20\u9644\u4EF6",
          content: "\u4EC5\u652F\u6301\u4E0A\u4F20Word/PDF/PPT/Excel/\u56FE\u7247/\u89C6\u9891\u6587\u4EF6\uFF0C\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC72G",
          onEdit: f[0] || (f[0] = (d) => t("handleUpload"))
        })) : re("", !0)
      ]),
      B(E1e, {
        show: a.value,
        "onUpdate:show": f[1] || (f[1] = (d) => a.value = d),
        fileInfo: E(o)
      }, null, 8, ["show", "fileInfo"])
    ], 64));
  }
}, L1e = /* @__PURE__ */ Ht(I1e, [["__scopeId", "data-v-4f15233c"]]);
const B1e = (e) => (yn("data-v-0eebaacf"), e = e(), bn(), e), N1e = { class: "progress-box" }, j1e = ["src"], F1e = { class: "progress-info" }, X1e = { class: "progress-tit" }, R1e = { class: "progress-name" }, V1e = { class: "progress-size" }, U1e = /* @__PURE__ */ je("\u9009\u62E9\u9644\u4EF6"), q1e = /* @__PURE__ */ B1e(() => /* @__PURE__ */ T("div", {
  slot: "tip",
  class: "el-upload__tip"
}, " \u4EC5\u652F\u6301\u4E0A\u4F20Word/PDF/PPT/Excel/\u56FE\u7247/\u89C6\u9891\u6587\u4EF6\uFF0C\u6587\u4EF6\u5927\u5C0F\u4E0D\u8D85\u8FC72G ", -1)), _1e = {
  emits: ["handleBeforeUpload", "handleUploadSuccess"],
  setup(e, { expose: t, emit: n }) {
    const r = ce("$http"), i = ce("$utils"), a = j(), o = zt({
      name: "",
      progress: 0
    }), s = j(""), l = j(), u = j([]), c = j([]), f = () => {
      bt(() => {
        a.value.$refs.uploadRef.handleClick();
      });
    }, d = (b) => i.getImage(`diffMark/types_icon/${i.formatIcons(b)}.png`), h = (b) => new Promise(async (x, D) => {
      try {
        const S = await r.getPolicy({ fileName: b.name });
        if (!S)
          return;
        const C = JSON.parse(S);
        console.log(C), s.value = C.host;
        let v = {};
        v.key = C.dir + C.fileUUID + "." + b.name.split(".")[b.name.split(".").length - 1], v.policy = C.policy, v.OSSAccessKeyId = C.accessid, v.success_action_status = 200, v.callback = C.callback, v.signature = C.signature, v["Content-Disposition"] = "attachment;filename=" + b.name, l.value = v, o.name = b.name, o.progress = 0, x(!0), n("handleBeforeUpload");
      } catch (S) {
        console.log(S), D(!1);
      }
    }), p = (b, x, D) => {
      let S = [];
      D.forEach((C) => {
        C.percentage < 100 && S.push({
          uid: C.uid,
          name: C.name,
          size: C.size,
          percentage: parseInt(C.percentage),
          suffix: C.name.split(".")[x.name.split(".").length - 1]
        });
      }), u.value = S;
    }, y = (b, x, D) => {
      u.value = u.value.filter((v) => v.uid != x.uid);
      const { id: S } = b.data;
      c.value.push(S), D.every((v) => v.status == "success" || v.status == "fail") && (n("handleUploadSuccess", c.value.join(",")), c.value = []);
    }, m = (b, x, D) => {
      console.log(b), An.error(`${o.name}\u4E0A\u4F20\u5931\u8D25`);
    };
    return t({
      handleTriggerUpload: f
    }), (b, x) => {
      const D = M3, S = fn, C = yf;
      return P(), L("div", null, [
        T("div", N1e, [
          (P(!0), L(nt, null, Lt(u.value, (v) => (P(), L("div", {
            class: "progress-item",
            key: v.uid
          }, [
            T("img", {
              src: d(v.suffix),
              alt: "",
              class: "file-icon"
            }, null, 8, j1e),
            T("div", F1e, [
              T("div", X1e, [
                T("span", R1e, de(v.name), 1),
                T("span", V1e, "(" + de(E(i).converByte(v.size)) + ")", 1)
              ]),
              T("div", null, [
                B(D, {
                  percentage: v.percentage
                }, null, 8, ["percentage"])
              ])
            ])
          ]))), 128))
        ]),
        B(C, {
          style: { display: "none" },
          ref_key: "uploadDom",
          ref: a,
          class: "upload-demo",
          action: s.value,
          data: l.value,
          "show-file-list": !1,
          "on-progress": (v, H, V) => p(v, H, V),
          "on-success": y,
          "before-upload": h,
          "on-error": m,
          multiple: "",
          accept: "*"
        }, {
          default: N(() => [
            B(S, {
              size: "small",
              type: "primary",
              icon: "el-icon-upload2"
            }, {
              default: N(() => [
                U1e
              ]),
              _: 1
            }),
            q1e
          ]),
          _: 1
        }, 8, ["action", "data", "on-progress"])
      ]);
    };
  }
}, W1e = /* @__PURE__ */ Ht(_1e, [["__scopeId", "data-v-0eebaacf"]]), K1e = (e) => {
  const t = ce("$http"), n = j([]), r = j([]);
  return {
    resourceList: n,
    getColumnFile: async (u) => {
      let c = {
        columnId: u,
        siteId: e
      };
      const f = await t.getColumnResource(c);
      n.value = f || [];
    },
    handleDeleteResource: (u) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u6559\u5B66\u8D44\u6E90\u5417",
        tipText: "\u5220\u9664\u540E\u8BE5\u6559\u5B66\u8D44\u6E90\u5C06\u4E0D\u5B58\u5728",
        confirmButtonText: "\u786E \u5B9A"
      }).then(() => {
        n.value.splice(u.index, 1), u.id && r.value.push(u.id);
      }).catch((c) => {
        console.log(c);
      });
    },
    saveColumnFile: async (u) => {
      let c = {
        columnId: u,
        list: n.value,
        siteId: e,
        delId: r.value.length ? r.value : void 0
      };
      await t.saveColumnResource(c), r.value = [];
    },
    selectedFile: (u) => {
      n.value.push(...u);
    },
    handleSuccessFile: (u) => {
      n.value.push(u);
    }
  };
};
const G1e = (e) => (yn("data-v-a0538fbf"), e = e(), bn(), e), Y1e = {
  key: 0,
  class: "module-content"
}, Q1e = {
  key: 0,
  class: "module-mode"
}, Z1e = /* @__PURE__ */ G1e(() => /* @__PURE__ */ T("div", { class: "hint" }, "\u8BF7\u9009\u62E9\u6A21\u5757\u6A21\u5F0F", -1)), J1e = { class: "mode-list" }, $1e = {
  key: 1,
  class: "empty-box"
}, e0e = {
  key: 1,
  class: "module-content"
}, t0e = {
  key: 2,
  class: "empty-box"
}, n0e = {
  key: 2,
  class: "module-content"
}, i0e = ["innerHTML"], r0e = { class: "btn-box" }, a0e = /* @__PURE__ */ je("\u53D6\u6D88"), o0e = /* @__PURE__ */ je("\u4FDD\u5B58"), s0e = {
  key: 3,
  class: "edit-box"
}, l0e = { class: "btn-box" }, u0e = /* @__PURE__ */ je("\u53D6\u6D88"), c0e = /* @__PURE__ */ je("\u4FDD\u5B58"), d0e = {
  key: 4,
  class: "empty-box"
}, f0e = {
  key: 3,
  class: "module-content"
}, h0e = {
  key: 0,
  class: "empty-box"
}, p0e = {
  props: {
    moduleInfo: Object,
    isTag: Boolean
  },
  emits: ["update:isTag"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$utils"), i = ce("caseOther"), a = [
      {
        mode: 1,
        title: "\u56FE\u6587",
        description: "\u5185\u5BB9\u5C06\u4EE5\u56FE\u7247\u6587\u5B57\u5F62\u5F0F\u6DF7\u6392",
        banner: {
          url: r.getImage("diffMark/image_text_icon.png"),
          width: 50
        }
      },
      {
        mode: 3,
        title: "\u89C6\u9891",
        description: "\u5185\u5BB9\u5C06\u4EE5\u89C6\u9891\u5F62\u5F0F\u663E\u793A",
        banner: {
          url: r.getImage("diffMark/video_icon.png"),
          width: 50
        }
      },
      {
        mode: 2,
        title: "\u9644\u4EF6",
        description: "\u5185\u5BB9\u5C06\u4EE5\u6587\u4EF6\u6392\u5217\u5F62\u5F0F\u663E\u793A",
        banner: {
          url: r.getImage("diffMark/attachment_icon.png"),
          width: 50
        }
      }
    ], o = ce("$http"), s = ce("$bus"), l = ce("siteId"), u = ce("pageMode"), c = j(!1), f = j(), d = j(0), h = j(), p = j(!1), y = zt({
      videoUrl: "",
      videoId: ""
    }), m = zt({
      column_content: n.moduleInfo.columnContent,
      id: n.moduleInfo.id
    }), b = j(null), x = j(!0), D = j(null), S = j([200, 100]), C = zt({
      column_id: n.moduleInfo.id,
      annotation_text: "",
      annotation_content: "",
      site_id: l,
      annotation_message: ""
    }), { resourceList: v, getColumnFile: H, selectedFile: V, handleSuccessFile: R, handleDeleteResource: F, saveColumnFile: K } = K1e(l);
    _t("columnId", n.moduleInfo.id), rn(() => {
      window.addEventListener("click", (Te) => {
        if (n.isTag) {
          We(!1);
          return;
        }
        q(Te.target, D.value) || We();
      });
    });
    const q = (Te, Me) => !Te || Te === document ? !1 : Te === Me ? !0 : q(Te.parentNode, Me), G = (Te) => {
      console.log("\u6A21\u5F0F", Te), Qe(Te);
    }, te = (Te) => {
      Te == "video" ? f.value.handleTriggerUpload() : h.value.handleTriggerUpload();
    }, Q = (Te) => {
      Te === "delete" ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u89C6\u9891\u5417",
        tipText: "\u5220\u9664\u540E\u8BE5\u89C6\u9891\u5C06\u4E0D\u5B58\u5728",
        confirmButtonText: "\u786E \u5B9A"
      }).then(() => {
        m.column_content = "", d.value = 0, ot();
      }).catch((Me) => {
        console.log(Me);
      }) : Te === "replace" && (d.value = 2, te("video"));
    }, Y = () => {
      m.column_content = "", d.value = 1;
    }, Z = (Te, Me) => {
      Me == "video" ? m.column_content = Te : m.column_content = m.column_content ? m.column_content + "," + Te : Te, ot();
    }, oe = (Te) => {
      m.column_content = Te, ot();
    }, he = (Te) => {
      if (u.value == 2)
        try {
          setTimeout(() => {
            let Me = ve();
            if (!Me) {
              C.annotation_text = "", We();
              return;
            }
            t("update:isTag", !1), b.value ? (b.value.removeInlineStyle("span", "red"), b.value = null) : ke(), console.log("==============", ve()), b.value = new Pie(D.value), x.value = !0, setTimeout(() => {
              Re();
              const Je = D.value.clientHeight, mt = D.value.clientWidth;
              console.log(Te);
              let It, ln;
              It = Te.pageX - Ye(D.value) - mt / 2, ln = -(Je - Te.layerY - 20), S.value = [It, ln], p.value = !0, C.annotation_text = Me;
            });
          });
        } catch (Me) {
          console.log("error", Me);
        }
    }, Ae = async (Te) => {
      C.annotation_content = D.value.innerHTML, C.annotation_message = Te, await o.saveAnnotation(C), An.success("\u6279\u6CE8\u6DFB\u52A0\u6210\u529F"), We(), Ve();
    }, We = (Te = !0) => {
      p.value = !1, b.value = null, Te && ke(), x.value = !0;
    }, ke = () => {
      if (!D.value)
        return;
      let Me = D.value.querySelectorAll(".red");
      Me.forEach((Je) => {
        Je.classList.remove("red");
      }), Me = null;
    }, Re = () => {
      if (window.getSelection) {
        var Te = window.getSelection();
        Te.removeAllRanges();
      } else
        document.selection && document.selection.empty && document.selection.empty();
    }, ve = () => {
      let Te = "";
      return window.getSelection ? Te = window.getSelection().toString() : window.document.getSelection ? Te = window.document.getSelection().toString() : window.document.selection && (Te = window.document.selection.createRange().text), Te;
    }, Ye = (Te) => {
      for (var Me = Te.offsetLeft, Je = Te.offsetParent; Je !== null; )
        Me += Je.offsetLeft, Je = Je.offsetParent;
      return console.log("left", Me), Me;
    }, Qe = async (Te) => {
      let Me = {
        ...m,
        column_type: Te || void 0
      };
      await o.updateCaseMenu(Me) && (c.value = !1, Ve());
    }, ot = async () => {
      i.source == 3 && n.moduleInfo.columnType == 1 && K(m.id), await o.updateCaseMenuContent(m) && (c.value = !1, Ve());
    }, Ve = () => {
      s.emit("updateContent");
    };
    return Ne(
      () => n.moduleInfo,
      (Te) => {
        m.column_content = Te.columnContent, Te.columnType == 3 && Te.files && Te.files.length && (y.videoUrl = Te.files[0].fileUrl, y.videoId = Te.files[0].fileId), i.source == 3 && Te.columnType == 1 && H(Te.id);
      },
      { immediate: !0 }
    ), (Te, Me) => {
      const Je = fn;
      return P(), L(nt, null, [
        B(ere, {
          columnInfo: e.moduleInfo,
          isEdit: c.value,
          "onUpdate:isEdit": Me[0] || (Me[0] = (mt) => c.value = mt),
          onHandleUpdateVideo: Q,
          onHandleUploadFile: Me[1] || (Me[1] = (mt) => te("file"))
        }, null, 8, ["columnInfo", "isEdit"]),
        e.moduleInfo.columnType === -1 ? (P(), L("div", Y1e, [
          E(u) == 1 ? (P(), L("div", Q1e, [
            Z1e,
            T("div", J1e, [
              (P(), L(nt, null, Lt(a, (mt) => B(ore, {
                key: mt.mode,
                mode: mt.mode,
                title: mt.title,
                description: mt.description,
                banner: mt.banner,
                onHandleSelectedMode: G
              }, null, 8, ["mode", "title", "description", "banner"])), 64))
            ])
          ])) : (P(), L("div", $1e, [
            B(E(bi), { text: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
          ]))
        ])) : e.moduleInfo.columnType === 3 ? (P(), L("div", e0e, [
          E(m).column_content ? (P(), ue(_x, {
            key: 0,
            videoUrl: E(y).videoUrl,
            videoId: E(y).videoId
          }, null, 8, ["videoUrl", "videoId"])) : re("", !0),
          E(u) == 1 && !E(m).column_content && d.value == 0 ? (P(), ue(sc, {
            key: 1,
            btnText: "\u4E0A\u4F20\u89C6\u9891",
            content: "\u8FD8\u672A\u4E0A\u4F20\u89C6\u9891\uFF0C\u5FEB\u70B9\u51FB\u4E0A\u4F20\u5427",
            onEdit: Me[2] || (Me[2] = (mt) => te("video"))
          })) : re("", !0),
          B(fre, {
            ref_key: "videoUploadRef",
            ref: f,
            onHandleBeforeUpload: Y,
            onHandleUploadSuccess: Me[3] || (Me[3] = (mt) => Z(mt, "video"))
          }, null, 512),
          !E(m).column_content && E(u) != 1 ? (P(), L("div", t0e, [
            B(E(bi), { text: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
          ])) : re("", !0)
        ])) : e.moduleInfo.columnType === 1 ? (P(), L("div", n0e, [
          c.value ? (P(), ue(E(zs), {
            key: 0,
            modelValue: E(m).column_content,
            "onUpdate:modelValue": Me[4] || (Me[4] = (mt) => E(m).column_content = mt)
          }, null, 8, ["modelValue"])) : re("", !0),
          !c.value && e.moduleInfo.columnContent ? (P(), ue(yfe, {
            key: 1,
            visible: p.value,
            "onUpdate:visible": Me[5] || (Me[5] = (mt) => p.value = mt),
            isAddAnchor: x.value,
            "onUpdate:isAddAnchor": Me[6] || (Me[6] = (mt) => x.value = mt),
            tooltipOffset: S.value,
            onHandleAddAnchor: Ae,
            onHandleCancel: We
          }, {
            default: N(() => [
              T("div", {
                id: "anchorContent",
                style: { position: "relative" },
                ref_key: "anchorDom",
                ref: D,
                "data-html": "",
                innerHTML: e.moduleInfo.columnContent,
                onMouseup: he
              }, null, 40, i0e)
            ]),
            _: 1
          }, 8, ["visible", "isAddAnchor", "tooltipOffset"])) : re("", !0),
          E(i).source == 3 ? (P(), ue(m1e, {
            key: 2,
            isEdit: c.value,
            resourceList: E(v),
            onHandleSelectedFile: E(V),
            onHandleSuccessFile: E(R),
            onHandleDeleteResource: E(F)
          }, {
            default: N(() => [
              T("div", r0e, [
                B(Je, {
                  class: "btn",
                  plain: "",
                  onClick: Me[7] || (Me[7] = (mt) => c.value = !1)
                }, {
                  default: N(() => [
                    a0e
                  ]),
                  _: 1
                }),
                B(Je, {
                  type: "primary",
                  class: "btn",
                  onClick: Me[8] || (Me[8] = (mt) => ot())
                }, {
                  default: N(() => [
                    o0e
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["isEdit", "resourceList", "onHandleSelectedFile", "onHandleSuccessFile", "onHandleDeleteResource"])) : re("", !0),
          E(i).source != 3 && c.value ? (P(), L("div", s0e, [
            T("div", l0e, [
              B(Je, {
                class: "btn",
                plain: "",
                onClick: Me[9] || (Me[9] = (mt) => c.value = !1)
              }, {
                default: N(() => [
                  u0e
                ]),
                _: 1
              }),
              B(Je, {
                type: "primary",
                class: "btn",
                onClick: Me[10] || (Me[10] = (mt) => ot())
              }, {
                default: N(() => [
                  c0e
                ]),
                _: 1
              })
            ])
          ])) : re("", !0),
          !e.moduleInfo.columnContent && E(u) != 1 ? (P(), L("div", d0e, [
            B(E(bi), { description: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
          ])) : re("", !0),
          !e.moduleInfo.columnContent && E(u) == 1 && !c.value ? (P(), ue(sc, {
            key: 5,
            onEdit: Me[11] || (Me[11] = (mt) => c.value = !0)
          })) : re("", !0)
        ])) : e.moduleInfo.columnType === 2 ? (P(), L("div", f0e, [
          B(L1e, {
            fileList: e.moduleInfo.files,
            onHandleUpload: Me[12] || (Me[12] = (mt) => te("file")),
            onUpdateFile: oe
          }, null, 8, ["fileList"]),
          B(W1e, {
            ref_key: "fileUploadRef",
            ref: h,
            onHandleUploadSuccess: Me[13] || (Me[13] = (mt) => Z(mt, "file"))
          }, null, 512),
          !E(m).column_content && E(u) != 1 ? (P(), L("div", h0e, [
            B(E(bi), { text: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
          ])) : re("", !0)
        ])) : re("", !0)
      ], 64);
    };
  }
}, Yx = /* @__PURE__ */ Ht(p0e, [["__scopeId", "data-v-a0538fbf"]]);
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function b9(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? b9(Object(n), !0).forEach(function(r) {
      v0e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b9(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A0(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? A0 = function(t) {
    return typeof t;
  } : A0 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, A0(e);
}
function v0e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Qo() {
  return Qo = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qo.apply(this, arguments);
}
function m0e(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function g0e(e, t) {
  if (e == null)
    return {};
  var n = m0e(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, r) || (n[r] = e[r]));
  }
  return n;
}
var y0e = "1.14.0";
function Vo(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var ss = Vo(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), If = Vo(/Edge/i), A9 = Vo(/firefox/i), Ed = Vo(/safari/i) && !Vo(/chrome/i) && !Vo(/android/i), Qx = Vo(/iP(ad|od|hone)/i), b0e = Vo(/chrome/i) && Vo(/android/i), Zx = {
  capture: !1,
  passive: !1
};
function In(e, t, n) {
  e.addEventListener(t, n, !ss && Zx);
}
function Dn(e, t, n) {
  e.removeEventListener(t, n, !ss && Zx);
}
function mh(e, t) {
  if (!!t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function A0e(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function to(e, t, n, r) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && mh(e, t) : mh(e, t)) || r && e === n)
        return e;
      if (e === n)
        break;
    } while (e = A0e(e));
  }
  return null;
}
var T9 = /\s+/g;
function _r(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var r = (" " + e.className + " ").replace(T9, " ").replace(" " + t + " ", " ");
      e.className = (r + (n ? " " + t : "")).replace(T9, " ");
    }
}
function Jt(e, t, n) {
  var r = e && e.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function Nu(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var r = Jt(e, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!t && (e = e.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(n);
}
function Jx(e, t, n) {
  if (e) {
    var r = e.getElementsByTagName(t), i = 0, a = r.length;
    if (n)
      for (; i < a; i++)
        n(r[i], i);
    return r;
  }
  return [];
}
function uo() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Di(e, t, n, r, i) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var a, o, s, l, u, c, f;
    if (e !== window && e.parentNode && e !== uo() ? (a = e.getBoundingClientRect(), o = a.top, s = a.left, l = a.bottom, u = a.right, c = a.height, f = a.width) : (o = 0, s = 0, l = window.innerHeight, u = window.innerWidth, c = window.innerHeight, f = window.innerWidth), (t || n) && e !== window && (i = i || e.parentNode, !ss))
      do
        if (i && i.getBoundingClientRect && (Jt(i, "transform") !== "none" || n && Jt(i, "position") !== "static")) {
          var d = i.getBoundingClientRect();
          o -= d.top + parseInt(Jt(i, "border-top-width")), s -= d.left + parseInt(Jt(i, "border-left-width")), l = o + a.height, u = s + a.width;
          break;
        }
      while (i = i.parentNode);
    if (r && e !== window) {
      var h = Nu(i || e), p = h && h.a, y = h && h.d;
      h && (o /= y, s /= p, f /= p, c /= y, l = o + c, u = s + f);
    }
    return {
      top: o,
      left: s,
      bottom: l,
      right: u,
      width: f,
      height: c
    };
  }
}
function w9(e, t, n) {
  for (var r = ks(e, !0), i = Di(e)[t]; r; ) {
    var a = Di(r)[n], o = void 0;
    if (n === "top" || n === "left" ? o = i >= a : o = i <= a, !o)
      return r;
    if (r === uo())
      break;
    r = ks(r, !1);
  }
  return !1;
}
function lc(e, t, n, r) {
  for (var i = 0, a = 0, o = e.children; a < o.length; ) {
    if (o[a].style.display !== "none" && o[a] !== $t.ghost && (r || o[a] !== $t.dragged) && to(o[a], n.draggable, e, !1)) {
      if (i === t)
        return o[a];
      i++;
    }
    a++;
  }
  return null;
}
function Q6(e, t) {
  for (var n = e.lastElementChild; n && (n === $t.ghost || Jt(n, "display") === "none" || t && !mh(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function ca(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== $t.clone && (!t || mh(e, t)) && n++;
  return n;
}
function P9(e) {
  var t = 0, n = 0, r = uo();
  if (e)
    do {
      var i = Nu(e), a = i.a, o = i.d;
      t += e.scrollLeft * a, n += e.scrollTop * o;
    } while (e !== r && (e = e.parentNode));
  return [t, n];
}
function T0e(e, t) {
  for (var n in e)
    if (!!e.hasOwnProperty(n)) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r] === e[n][r])
          return Number(n);
    }
  return -1;
}
function ks(e, t) {
  if (!e || !e.getBoundingClientRect)
    return uo();
  var n = e, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var i = Jt(n);
      if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return uo();
        if (r || t)
          return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return uo();
}
function w0e(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function Jp(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var kd;
function $x(e, t) {
  return function() {
    if (!kd) {
      var n = arguments, r = this;
      n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), kd = setTimeout(function() {
        kd = void 0;
      }, t);
    }
  };
}
function P0e() {
  clearTimeout(kd), kd = void 0;
}
function eC(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function tC(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
var Qr = "Sortable" + new Date().getTime();
function x0e() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(i) {
          if (!(Jt(i, "display") === "none" || i === $t.ghost)) {
            e.push({
              target: i,
              rect: Di(i)
            });
            var a = vo({}, e[e.length - 1].rect);
            if (i.thisAnimationDuration) {
              var o = Nu(i, !0);
              o && (a.top -= o.f, a.left -= o.e);
            }
            i.fromRect = a;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(T0e(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var i = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof r == "function" && r();
        return;
      }
      var a = !1, o = 0;
      e.forEach(function(s) {
        var l = 0, u = s.target, c = u.fromRect, f = Di(u), d = u.prevFromRect, h = u.prevToRect, p = s.rect, y = Nu(u, !0);
        y && (f.top -= y.f, f.left -= y.e), u.toRect = f, u.thisAnimationDuration && Jp(d, f) && !Jp(c, f) && (p.top - f.top) / (p.left - f.left) === (c.top - f.top) / (c.left - f.left) && (l = S0e(p, d, h, i.options)), Jp(f, c) || (u.prevFromRect = c, u.prevToRect = f, l || (l = i.options.animation), i.animate(u, p, f, l)), l && (a = !0, o = Math.max(o, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(t), a ? t = setTimeout(function() {
        typeof r == "function" && r();
      }, o) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, i, a, o) {
      if (o) {
        Jt(r, "transition", ""), Jt(r, "transform", "");
        var s = Nu(this.el), l = s && s.a, u = s && s.d, c = (i.left - a.left) / (l || 1), f = (i.top - a.top) / (u || 1);
        r.animatingX = !!c, r.animatingY = !!f, Jt(r, "transform", "translate3d(" + c + "px," + f + "px,0)"), this.forRepaintDummy = C0e(r), Jt(r, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), Jt(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          Jt(r, "transition", ""), Jt(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, o);
      }
    }
  };
}
function C0e(e) {
  return e.offsetWidth;
}
function S0e(e, t, n, r) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
}
var Au = [], $p = {
  initializeByDefault: !0
}, Lf = {
  mount: function(t) {
    for (var n in $p)
      $p.hasOwnProperty(n) && !(n in t) && (t[n] = $p[n]);
    Au.forEach(function(r) {
      if (r.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), Au.push(t);
  },
  pluginEvent: function(t, n, r) {
    var i = this;
    this.eventCanceled = !1, r.cancel = function() {
      i.eventCanceled = !0;
    };
    var a = t + "Global";
    Au.forEach(function(o) {
      !n[o.pluginName] || (n[o.pluginName][a] && n[o.pluginName][a](vo({
        sortable: n
      }, r)), n.options[o.pluginName] && n[o.pluginName][t] && n[o.pluginName][t](vo({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(t, n, r, i) {
    Au.forEach(function(s) {
      var l = s.pluginName;
      if (!(!t.options[l] && !s.initializeByDefault)) {
        var u = new s(t, n, t.options);
        u.sortable = t, u.options = t.options, t[l] = u, Qo(r, u.defaults);
      }
    });
    for (var a in t.options)
      if (!!t.options.hasOwnProperty(a)) {
        var o = this.modifyOption(t, a, t.options[a]);
        typeof o < "u" && (t.options[a] = o);
      }
  },
  getEventProperties: function(t, n) {
    var r = {};
    return Au.forEach(function(i) {
      typeof i.eventProperties == "function" && Qo(r, i.eventProperties.call(n[i.pluginName], t));
    }), r;
  },
  modifyOption: function(t, n, r) {
    var i;
    return Au.forEach(function(a) {
      !t[a.pluginName] || a.optionListeners && typeof a.optionListeners[n] == "function" && (i = a.optionListeners[n].call(t[a.pluginName], r));
    }), i;
  }
};
function E0e(e) {
  var t = e.sortable, n = e.rootEl, r = e.name, i = e.targetEl, a = e.cloneEl, o = e.toEl, s = e.fromEl, l = e.oldIndex, u = e.newIndex, c = e.oldDraggableIndex, f = e.newDraggableIndex, d = e.originalEvent, h = e.putSortable, p = e.extraEventProperties;
  if (t = t || n && n[Qr], !!t) {
    var y, m = t.options, b = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !ss && !If ? y = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (y = document.createEvent("Event"), y.initEvent(r, !0, !0)), y.to = o || n, y.from = s || n, y.item = i || n, y.clone = a, y.oldIndex = l, y.newIndex = u, y.oldDraggableIndex = c, y.newDraggableIndex = f, y.originalEvent = d, y.pullMode = h ? h.lastPutMode : void 0;
    var x = vo(vo({}, p), Lf.getEventProperties(r, t));
    for (var D in x)
      y[D] = x[D];
    n && n.dispatchEvent(y), m[b] && m[b].call(t, y);
  }
}
var k0e = ["evt"], Er = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.evt, a = g0e(r, k0e);
  Lf.pluginEvent.bind($t)(t, n, vo({
    dragEl: Tt,
    parentEl: li,
    ghostEl: dn,
    rootEl: ai,
    nextEl: dl,
    lastDownEl: T0,
    cloneEl: ui,
    cloneHidden: Cs,
    dragStarted: fd,
    putSortable: Fi,
    activeSortable: $t.active,
    originalEvent: i,
    oldIndex: ku,
    oldDraggableIndex: Od,
    newIndex: Wr,
    newDraggableIndex: xs,
    hideGhostForTarget: aC,
    unhideGhostForTarget: oC,
    cloneNowHidden: function() {
      Cs = !0;
    },
    cloneNowShown: function() {
      Cs = !1;
    },
    dispatchSortableEvent: function(s) {
      pr({
        sortable: n,
        name: s,
        originalEvent: i
      });
    }
  }, a));
};
function pr(e) {
  E0e(vo({
    putSortable: Fi,
    cloneEl: ui,
    targetEl: Tt,
    rootEl: ai,
    oldIndex: ku,
    oldDraggableIndex: Od,
    newIndex: Wr,
    newDraggableIndex: xs
  }, e));
}
var Tt, li, dn, ai, dl, T0, ui, Cs, ku, Wr, Od, xs, D1, Fi, wu = !1, gh = !1, yh = [], al, Ia, e8, t8, x9, C9, fd, Tu, zd, Dd = !1, M1 = !1, w0, Ji, n8 = [], L4 = !1, bh = [], m2 = typeof document < "u", H1 = Qx, S9 = If || ss ? "cssFloat" : "float", O0e = m2 && !b0e && !Qx && "draggable" in document.createElement("div"), nC = function() {
  if (!!m2) {
    if (ss)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), iC = function(t, n) {
  var r = Jt(t), i = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), a = lc(t, 0, n), o = lc(t, 1, n), s = a && Jt(a), l = o && Jt(o), u = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + Di(a).width, c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Di(o).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (a && s.float && s.float !== "none") {
    var f = s.float === "left" ? "left" : "right";
    return o && (l.clear === "both" || l.clear === f) ? "vertical" : "horizontal";
  }
  return a && (s.display === "block" || s.display === "flex" || s.display === "table" || s.display === "grid" || u >= i && r[S9] === "none" || o && r[S9] === "none" && u + c > i) ? "vertical" : "horizontal";
}, z0e = function(t, n, r) {
  var i = r ? t.left : t.top, a = r ? t.right : t.bottom, o = r ? t.width : t.height, s = r ? n.left : n.top, l = r ? n.right : n.bottom, u = r ? n.width : n.height;
  return i === s || a === l || i + o / 2 === s + u / 2;
}, D0e = function(t, n) {
  var r;
  return yh.some(function(i) {
    var a = i[Qr].options.emptyInsertThreshold;
    if (!(!a || Q6(i))) {
      var o = Di(i), s = t >= o.left - a && t <= o.right + a, l = n >= o.top - a && n <= o.bottom + a;
      if (s && l)
        return r = i;
    }
  }), r;
}, rC = function(t) {
  function n(a, o) {
    return function(s, l, u, c) {
      var f = s.options.group.name && l.options.group.name && s.options.group.name === l.options.group.name;
      if (a == null && (o || f))
        return !0;
      if (a == null || a === !1)
        return !1;
      if (o && a === "clone")
        return a;
      if (typeof a == "function")
        return n(a(s, l, u, c), o)(s, l, u, c);
      var d = (o ? s : l).options.group.name;
      return a === !0 || typeof a == "string" && a === d || a.join && a.indexOf(d) > -1;
    };
  }
  var r = {}, i = t.group;
  (!i || A0(i) != "object") && (i = {
    name: i
  }), r.name = i.name, r.checkPull = n(i.pull, !0), r.checkPut = n(i.put), r.revertClone = i.revertClone, t.group = r;
}, aC = function() {
  !nC && dn && Jt(dn, "display", "none");
}, oC = function() {
  !nC && dn && Jt(dn, "display", "");
};
m2 && document.addEventListener("click", function(e) {
  if (gh)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), gh = !1, !1;
}, !0);
var ol = function(t) {
  if (Tt) {
    t = t.touches ? t.touches[0] : t;
    var n = D0e(t.clientX, t.clientY);
    if (n) {
      var r = {};
      for (var i in t)
        t.hasOwnProperty(i) && (r[i] = t[i]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[Qr]._onDragOver(r);
    }
  }
}, M0e = function(t) {
  Tt && Tt.parentNode[Qr]._isOutsideThisEl(t.target);
};
function $t(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = Qo({}, t), e[Qr] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: !1,
    invertedSwapThreshold: null,
    removeCloneOnHide: !0,
    direction: function() {
      return iC(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(o, s) {
      o.setData("Text", s.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: $t.supportPointer !== !1 && "PointerEvent" in window && !Ed,
    emptyInsertThreshold: 5
  };
  Lf.initializePlugins(this, e, n);
  for (var r in n)
    !(r in t) && (t[r] = n[r]);
  rC(t);
  for (var i in this)
    i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : O0e, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? In(e, "pointerdown", this._onTapStart) : (In(e, "mousedown", this._onTapStart), In(e, "touchstart", this._onTapStart)), this.nativeDraggable && (In(e, "dragover", this), In(e, "dragenter", this)), yh.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), Qo(this, x0e());
}
$t.prototype = {
  constructor: $t,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Tu = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, Tt) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (!!t.cancelable) {
      var n = this, r = this.el, i = this.options, a = i.preventOnFilter, o = t.type, s = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, l = (s || t).target, u = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || l, c = i.filter;
      if (X0e(r), !Tt && !(/mousedown|pointerdown/.test(o) && t.button !== 0 || i.disabled) && !u.isContentEditable && !(!this.nativeDraggable && Ed && l && l.tagName.toUpperCase() === "SELECT") && (l = to(l, i.draggable, r, !1), !(l && l.animated) && T0 !== l)) {
        if (ku = ca(l), Od = ca(l, i.draggable), typeof c == "function") {
          if (c.call(this, t, l, this)) {
            pr({
              sortable: n,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: r,
              fromEl: r
            }), Er("filter", n, {
              evt: t
            }), a && t.cancelable && t.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(f) {
          if (f = to(u, f.trim(), r, !1), f)
            return pr({
              sortable: n,
              rootEl: f,
              name: "filter",
              targetEl: l,
              fromEl: r,
              toEl: r
            }), Er("filter", n, {
              evt: t
            }), !0;
        }), c)) {
          a && t.cancelable && t.preventDefault();
          return;
        }
        i.handle && !to(u, i.handle, r, !1) || this._prepareDragStart(t, s, l);
      }
    }
  },
  _prepareDragStart: function(t, n, r) {
    var i = this, a = i.el, o = i.options, s = a.ownerDocument, l;
    if (r && !Tt && r.parentNode === a) {
      var u = Di(r);
      if (ai = a, Tt = r, li = Tt.parentNode, dl = Tt.nextSibling, T0 = r, D1 = o.group, $t.dragged = Tt, al = {
        target: Tt,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, x9 = al.clientX - u.left, C9 = al.clientY - u.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, Tt.style["will-change"] = "all", l = function() {
        if (Er("delayEnded", i, {
          evt: t
        }), $t.eventCanceled) {
          i._onDrop();
          return;
        }
        i._disableDelayedDragEvents(), !A9 && i.nativeDraggable && (Tt.draggable = !0), i._triggerDragStart(t, n), pr({
          sortable: i,
          name: "choose",
          originalEvent: t
        }), _r(Tt, o.chosenClass, !0);
      }, o.ignore.split(",").forEach(function(c) {
        Jx(Tt, c.trim(), i8);
      }), In(s, "dragover", ol), In(s, "mousemove", ol), In(s, "touchmove", ol), In(s, "mouseup", i._onDrop), In(s, "touchend", i._onDrop), In(s, "touchcancel", i._onDrop), A9 && this.nativeDraggable && (this.options.touchStartThreshold = 4, Tt.draggable = !0), Er("delayStart", this, {
        evt: t
      }), o.delay && (!o.delayOnTouchOnly || n) && (!this.nativeDraggable || !(If || ss))) {
        if ($t.eventCanceled) {
          this._onDrop();
          return;
        }
        In(s, "mouseup", i._disableDelayedDrag), In(s, "touchend", i._disableDelayedDrag), In(s, "touchcancel", i._disableDelayedDrag), In(s, "mousemove", i._delayedDragTouchMoveHandler), In(s, "touchmove", i._delayedDragTouchMoveHandler), o.supportPointer && In(s, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(l, o.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    Tt && i8(Tt), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    Dn(t, "mouseup", this._disableDelayedDrag), Dn(t, "touchend", this._disableDelayedDrag), Dn(t, "touchcancel", this._disableDelayedDrag), Dn(t, "mousemove", this._delayedDragTouchMoveHandler), Dn(t, "touchmove", this._delayedDragTouchMoveHandler), Dn(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? In(document, "pointermove", this._onTouchMove) : n ? In(document, "touchmove", this._onTouchMove) : In(document, "mousemove", this._onTouchMove) : (In(Tt, "dragend", this), In(ai, "dragstart", this._onDragStart));
    try {
      document.selection ? P0(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (wu = !1, ai && Tt) {
      Er("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && In(document, "dragover", M0e);
      var r = this.options;
      !t && _r(Tt, r.dragClass, !1), _r(Tt, r.ghostClass, !0), $t.active = this, t && this._appendGhost(), pr({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Ia) {
      this._lastX = Ia.clientX, this._lastY = Ia.clientY, aC();
      for (var t = document.elementFromPoint(Ia.clientX, Ia.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(Ia.clientX, Ia.clientY), t !== n); )
        n = t;
      if (Tt.parentNode[Qr]._isOutsideThisEl(t), n)
        do {
          if (n[Qr]) {
            var r = void 0;
            if (r = n[Qr]._onDragOver({
              clientX: Ia.clientX,
              clientY: Ia.clientY,
              target: t,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = n.parentNode);
      oC();
    }
  },
  _onTouchMove: function(t) {
    if (al) {
      var n = this.options, r = n.fallbackTolerance, i = n.fallbackOffset, a = t.touches ? t.touches[0] : t, o = dn && Nu(dn, !0), s = dn && o && o.a, l = dn && o && o.d, u = H1 && Ji && P9(Ji), c = (a.clientX - al.clientX + i.x) / (s || 1) + (u ? u[0] - n8[0] : 0) / (s || 1), f = (a.clientY - al.clientY + i.y) / (l || 1) + (u ? u[1] - n8[1] : 0) / (l || 1);
      if (!$t.active && !wu) {
        if (r && Math.max(Math.abs(a.clientX - this._lastX), Math.abs(a.clientY - this._lastY)) < r)
          return;
        this._onDragStart(t, !0);
      }
      if (dn) {
        o ? (o.e += c - (e8 || 0), o.f += f - (t8 || 0)) : o = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f
        };
        var d = "matrix(".concat(o.a, ",").concat(o.b, ",").concat(o.c, ",").concat(o.d, ",").concat(o.e, ",").concat(o.f, ")");
        Jt(dn, "webkitTransform", d), Jt(dn, "mozTransform", d), Jt(dn, "msTransform", d), Jt(dn, "transform", d), e8 = c, t8 = f, Ia = a;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!dn) {
      var t = this.options.fallbackOnBody ? document.body : ai, n = Di(Tt, !0, H1, !0, t), r = this.options;
      if (H1) {
        for (Ji = t; Jt(Ji, "position") === "static" && Jt(Ji, "transform") === "none" && Ji !== document; )
          Ji = Ji.parentNode;
        Ji !== document.body && Ji !== document.documentElement ? (Ji === document && (Ji = uo()), n.top += Ji.scrollTop, n.left += Ji.scrollLeft) : Ji = uo(), n8 = P9(Ji);
      }
      dn = Tt.cloneNode(!0), _r(dn, r.ghostClass, !1), _r(dn, r.fallbackClass, !0), _r(dn, r.dragClass, !0), Jt(dn, "transition", ""), Jt(dn, "transform", ""), Jt(dn, "box-sizing", "border-box"), Jt(dn, "margin", 0), Jt(dn, "top", n.top), Jt(dn, "left", n.left), Jt(dn, "width", n.width), Jt(dn, "height", n.height), Jt(dn, "opacity", "0.8"), Jt(dn, "position", H1 ? "absolute" : "fixed"), Jt(dn, "zIndex", "100000"), Jt(dn, "pointerEvents", "none"), $t.ghost = dn, t.appendChild(dn), Jt(dn, "transform-origin", x9 / parseInt(dn.style.width) * 100 + "% " + C9 / parseInt(dn.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var r = this, i = t.dataTransfer, a = r.options;
    if (Er("dragStart", this, {
      evt: t
    }), $t.eventCanceled) {
      this._onDrop();
      return;
    }
    Er("setupClone", this), $t.eventCanceled || (ui = tC(Tt), ui.draggable = !1, ui.style["will-change"] = "", this._hideClone(), _r(ui, this.options.chosenClass, !1), $t.clone = ui), r.cloneId = P0(function() {
      Er("clone", r), !$t.eventCanceled && (r.options.removeCloneOnHide || ai.insertBefore(ui, Tt), r._hideClone(), pr({
        sortable: r,
        name: "clone"
      }));
    }), !n && _r(Tt, a.dragClass, !0), n ? (gh = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (Dn(document, "mouseup", r._onDrop), Dn(document, "touchend", r._onDrop), Dn(document, "touchcancel", r._onDrop), i && (i.effectAllowed = "move", a.setData && a.setData.call(r, i, Tt)), In(document, "drop", r), Jt(Tt, "transform", "translateZ(0)")), wu = !0, r._dragStartId = P0(r._dragStarted.bind(r, n, t)), In(document, "selectstart", r), fd = !0, Ed && Jt(document.body, "user-select", "none");
  },
  _onDragOver: function(t) {
    var n = this.el, r = t.target, i, a, o, s = this.options, l = s.group, u = $t.active, c = D1 === l, f = s.sort, d = Fi || u, h, p = this, y = !1;
    if (L4)
      return;
    function m(oe, he) {
      Er(oe, p, vo({
        evt: t,
        isOwner: c,
        axis: h ? "vertical" : "horizontal",
        revert: o,
        dragRect: i,
        targetRect: a,
        canSort: f,
        fromSortable: d,
        target: r,
        completed: x,
        onMove: function(We, ke) {
          return I1(ai, n, Tt, i, We, Di(We), t, ke);
        },
        changed: D
      }, he));
    }
    function b() {
      m("dragOverAnimationCapture"), p.captureAnimationState(), p !== d && d.captureAnimationState();
    }
    function x(oe) {
      return m("dragOverCompleted", {
        insertion: oe
      }), oe && (c ? u._hideClone() : u._showClone(p), p !== d && (_r(Tt, Fi ? Fi.options.ghostClass : u.options.ghostClass, !1), _r(Tt, s.ghostClass, !0)), Fi !== p && p !== $t.active ? Fi = p : p === $t.active && Fi && (Fi = null), d === p && (p._ignoreWhileAnimating = r), p.animateAll(function() {
        m("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
      }), p !== d && (d.animateAll(), d._ignoreWhileAnimating = null)), (r === Tt && !Tt.animated || r === n && !r.animated) && (Tu = null), !s.dragoverBubble && !t.rootEl && r !== document && (Tt.parentNode[Qr]._isOutsideThisEl(t.target), !oe && ol(t)), !s.dragoverBubble && t.stopPropagation && t.stopPropagation(), y = !0;
    }
    function D() {
      Wr = ca(Tt), xs = ca(Tt, s.draggable), pr({
        sortable: p,
        name: "change",
        toEl: n,
        newIndex: Wr,
        newDraggableIndex: xs,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), r = to(r, s.draggable, n, !0), m("dragOver"), $t.eventCanceled)
      return y;
    if (Tt.contains(t.target) || r.animated && r.animatingX && r.animatingY || p._ignoreWhileAnimating === r)
      return x(!1);
    if (gh = !1, u && !s.disabled && (c ? f || (o = li !== ai) : Fi === this || (this.lastPutMode = D1.checkPull(this, u, Tt, t)) && l.checkPut(this, u, Tt, t))) {
      if (h = this._getDirection(t, r) === "vertical", i = Di(Tt), m("dragOverValid"), $t.eventCanceled)
        return y;
      if (o)
        return li = ai, b(), this._hideClone(), m("revert"), $t.eventCanceled || (dl ? ai.insertBefore(Tt, dl) : ai.appendChild(Tt)), x(!0);
      var S = Q6(n, s.draggable);
      if (!S || B0e(t, h, this) && !S.animated) {
        if (S === Tt)
          return x(!1);
        if (S && n === t.target && (r = S), r && (a = Di(r)), I1(ai, n, Tt, i, r, a, t, !!r) !== !1)
          return b(), n.appendChild(Tt), li = n, D(), x(!0);
      } else if (S && L0e(t, h, this)) {
        var C = lc(n, 0, s, !0);
        if (C === Tt)
          return x(!1);
        if (r = C, a = Di(r), I1(ai, n, Tt, i, r, a, t, !1) !== !1)
          return b(), n.insertBefore(Tt, C), li = n, D(), x(!0);
      } else if (r.parentNode === n) {
        a = Di(r);
        var v = 0, H, V = Tt.parentNode !== n, R = !z0e(Tt.animated && Tt.toRect || i, r.animated && r.toRect || a, h), F = h ? "top" : "left", K = w9(r, "top", "top") || w9(Tt, "top", "top"), q = K ? K.scrollTop : void 0;
        Tu !== r && (H = a[F], Dd = !1, M1 = !R && s.invertSwap || V), v = N0e(t, r, a, h, R ? 1 : s.swapThreshold, s.invertedSwapThreshold == null ? s.swapThreshold : s.invertedSwapThreshold, M1, Tu === r);
        var G;
        if (v !== 0) {
          var te = ca(Tt);
          do
            te -= v, G = li.children[te];
          while (G && (Jt(G, "display") === "none" || G === dn));
        }
        if (v === 0 || G === r)
          return x(!1);
        Tu = r, zd = v;
        var Q = r.nextElementSibling, Y = !1;
        Y = v === 1;
        var Z = I1(ai, n, Tt, i, r, a, t, Y);
        if (Z !== !1)
          return (Z === 1 || Z === -1) && (Y = Z === 1), L4 = !0, setTimeout(I0e, 30), b(), Y && !Q ? n.appendChild(Tt) : r.parentNode.insertBefore(Tt, Y ? Q : r), K && eC(K, 0, q - K.scrollTop), li = Tt.parentNode, H !== void 0 && !M1 && (w0 = Math.abs(H - Di(r)[F])), D(), x(!0);
      }
      if (n.contains(Tt))
        return x(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Dn(document, "mousemove", this._onTouchMove), Dn(document, "touchmove", this._onTouchMove), Dn(document, "pointermove", this._onTouchMove), Dn(document, "dragover", ol), Dn(document, "mousemove", ol), Dn(document, "touchmove", ol);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    Dn(t, "mouseup", this._onDrop), Dn(t, "touchend", this._onDrop), Dn(t, "pointerup", this._onDrop), Dn(t, "touchcancel", this._onDrop), Dn(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, r = this.options;
    if (Wr = ca(Tt), xs = ca(Tt, r.draggable), Er("drop", this, {
      evt: t
    }), li = Tt && Tt.parentNode, Wr = ca(Tt), xs = ca(Tt, r.draggable), $t.eventCanceled) {
      this._nulling();
      return;
    }
    wu = !1, M1 = !1, Dd = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), B4(this.cloneId), B4(this._dragStartId), this.nativeDraggable && (Dn(document, "drop", this), Dn(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Ed && Jt(document.body, "user-select", ""), Jt(Tt, "transform", ""), t && (fd && (t.cancelable && t.preventDefault(), !r.dropBubble && t.stopPropagation()), dn && dn.parentNode && dn.parentNode.removeChild(dn), (ai === li || Fi && Fi.lastPutMode !== "clone") && ui && ui.parentNode && ui.parentNode.removeChild(ui), Tt && (this.nativeDraggable && Dn(Tt, "dragend", this), i8(Tt), Tt.style["will-change"] = "", fd && !wu && _r(Tt, Fi ? Fi.options.ghostClass : this.options.ghostClass, !1), _r(Tt, this.options.chosenClass, !1), pr({
      sortable: this,
      name: "unchoose",
      toEl: li,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), ai !== li ? (Wr >= 0 && (pr({
      rootEl: li,
      name: "add",
      toEl: li,
      fromEl: ai,
      originalEvent: t
    }), pr({
      sortable: this,
      name: "remove",
      toEl: li,
      originalEvent: t
    }), pr({
      rootEl: li,
      name: "sort",
      toEl: li,
      fromEl: ai,
      originalEvent: t
    }), pr({
      sortable: this,
      name: "sort",
      toEl: li,
      originalEvent: t
    })), Fi && Fi.save()) : Wr !== ku && Wr >= 0 && (pr({
      sortable: this,
      name: "update",
      toEl: li,
      originalEvent: t
    }), pr({
      sortable: this,
      name: "sort",
      toEl: li,
      originalEvent: t
    })), $t.active && ((Wr == null || Wr === -1) && (Wr = ku, xs = Od), pr({
      sortable: this,
      name: "end",
      toEl: li,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Er("nulling", this), ai = Tt = li = dn = dl = ui = T0 = Cs = al = Ia = fd = Wr = xs = ku = Od = Tu = zd = Fi = D1 = $t.dragged = $t.ghost = $t.clone = $t.active = null, bh.forEach(function(t) {
      t.checked = !0;
    }), bh.length = e8 = t8 = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        Tt && (this._onDragOver(t), H0e(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  toArray: function() {
    for (var t = [], n, r = this.el.children, i = 0, a = r.length, o = this.options; i < a; i++)
      n = r[i], to(n, o.draggable, this.el, !1) && t.push(n.getAttribute(o.dataIdAttr) || F0e(n));
    return t;
  },
  sort: function(t, n) {
    var r = {}, i = this.el;
    this.toArray().forEach(function(a, o) {
      var s = i.children[o];
      to(s, this.options.draggable, i, !1) && (r[a] = s);
    }, this), n && this.captureAnimationState(), t.forEach(function(a) {
      r[a] && (i.removeChild(r[a]), i.appendChild(r[a]));
    }), n && this.animateAll();
  },
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  closest: function(t, n) {
    return to(t, n || this.options.draggable, this.el, !1);
  },
  option: function(t, n) {
    var r = this.options;
    if (n === void 0)
      return r[t];
    var i = Lf.modifyOption(this, t, n);
    typeof i < "u" ? r[t] = i : r[t] = n, t === "group" && rC(r);
  },
  destroy: function() {
    Er("destroy", this);
    var t = this.el;
    t[Qr] = null, Dn(t, "mousedown", this._onTapStart), Dn(t, "touchstart", this._onTapStart), Dn(t, "pointerdown", this._onTapStart), this.nativeDraggable && (Dn(t, "dragover", this), Dn(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), yh.splice(yh.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Cs) {
      if (Er("hideClone", this), $t.eventCanceled)
        return;
      Jt(ui, "display", "none"), this.options.removeCloneOnHide && ui.parentNode && ui.parentNode.removeChild(ui), Cs = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Cs) {
      if (Er("showClone", this), $t.eventCanceled)
        return;
      Tt.parentNode == ai && !this.options.group.revertClone ? ai.insertBefore(ui, Tt) : dl ? ai.insertBefore(ui, dl) : ai.appendChild(ui), this.options.group.revertClone && this.animate(Tt, ui), Jt(ui, "display", ""), Cs = !1;
    }
  }
};
function H0e(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function I1(e, t, n, r, i, a, o, s) {
  var l, u = e[Qr], c = u.options.onMove, f;
  return window.CustomEvent && !ss && !If ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = t, l.from = e, l.dragged = n, l.draggedRect = r, l.related = i || t, l.relatedRect = a || Di(t), l.willInsertAfter = s, l.originalEvent = o, e.dispatchEvent(l), c && (f = c.call(u, l, o)), f;
}
function i8(e) {
  e.draggable = !1;
}
function I0e() {
  L4 = !1;
}
function L0e(e, t, n) {
  var r = Di(lc(n.el, 0, n.options, !0)), i = 10;
  return t ? e.clientX < r.left - i || e.clientY < r.top && e.clientX < r.right : e.clientY < r.top - i || e.clientY < r.bottom && e.clientX < r.left;
}
function B0e(e, t, n) {
  var r = Di(Q6(n.el, n.options.draggable)), i = 10;
  return t ? e.clientX > r.right + i || e.clientX <= r.right && e.clientY > r.bottom && e.clientX >= r.left : e.clientX > r.right && e.clientY > r.top || e.clientX <= r.right && e.clientY > r.bottom + i;
}
function N0e(e, t, n, r, i, a, o, s) {
  var l = r ? e.clientY : e.clientX, u = r ? n.height : n.width, c = r ? n.top : n.left, f = r ? n.bottom : n.right, d = !1;
  if (!o) {
    if (s && w0 < u * i) {
      if (!Dd && (zd === 1 ? l > c + u * a / 2 : l < f - u * a / 2) && (Dd = !0), Dd)
        d = !0;
      else if (zd === 1 ? l < c + w0 : l > f - w0)
        return -zd;
    } else if (l > c + u * (1 - i) / 2 && l < f - u * (1 - i) / 2)
      return j0e(t);
  }
  return d = d || o, d && (l < c + u * a / 2 || l > f - u * a / 2) ? l > c + u / 2 ? 1 : -1 : 0;
}
function j0e(e) {
  return ca(Tt) < ca(e) ? 1 : -1;
}
function F0e(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--; )
    r += t.charCodeAt(n);
  return r.toString(36);
}
function X0e(e) {
  bh.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var r = t[n];
    r.checked && bh.push(r);
  }
}
function P0(e) {
  return setTimeout(e, 0);
}
function B4(e) {
  return clearTimeout(e);
}
m2 && In(document, "touchmove", function(e) {
  ($t.active || wu) && e.cancelable && e.preventDefault();
});
$t.utils = {
  on: In,
  off: Dn,
  css: Jt,
  find: Jx,
  is: function(t, n) {
    return !!to(t, n, t, !1);
  },
  extend: w0e,
  throttle: $x,
  closest: to,
  toggleClass: _r,
  clone: tC,
  index: ca,
  nextTick: P0,
  cancelNextTick: B4,
  detectDirection: iC,
  getChild: lc
};
$t.get = function(e) {
  return e[Qr];
};
$t.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && ($t.utils = vo(vo({}, $t.utils), r.utils)), Lf.mount(r);
  });
};
$t.create = function(e, t) {
  return new $t(e, t);
};
$t.version = y0e;
var xi = [], hd, N4, j4 = !1, r8, a8, Ah, pd;
function R0e() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? In(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? In(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? In(document, "touchmove", this._handleFallbackAutoScroll) : In(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Dn(document, "dragover", this._handleAutoScroll) : (Dn(document, "pointermove", this._handleFallbackAutoScroll), Dn(document, "touchmove", this._handleFallbackAutoScroll), Dn(document, "mousemove", this._handleFallbackAutoScroll)), E9(), x0(), P0e();
    },
    nulling: function() {
      Ah = N4 = hd = j4 = pd = r8 = a8 = null, xi.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var i = this, a = (n.touches ? n.touches[0] : n).clientX, o = (n.touches ? n.touches[0] : n).clientY, s = document.elementFromPoint(a, o);
      if (Ah = n, r || this.options.forceAutoScrollFallback || If || ss || Ed) {
        o8(n, this.options, s, r);
        var l = ks(s, !0);
        j4 && (!pd || a !== r8 || o !== a8) && (pd && E9(), pd = setInterval(function() {
          var u = ks(document.elementFromPoint(a, o), !0);
          u !== l && (l = u, x0()), o8(n, i.options, u, r);
        }, 10), r8 = a, a8 = o);
      } else {
        if (!this.options.bubbleScroll || ks(s, !0) === uo()) {
          x0();
          return;
        }
        o8(n, this.options, ks(s, !1), !1);
      }
    }
  }, Qo(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function x0() {
  xi.forEach(function(e) {
    clearInterval(e.pid);
  }), xi = [];
}
function E9() {
  clearInterval(pd);
}
var o8 = $x(function(e, t, n, r) {
  if (!!t.scroll) {
    var i = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, s = t.scrollSpeed, l = uo(), u = !1, c;
    N4 !== n && (N4 = n, x0(), hd = t.scroll, c = t.scrollFn, hd === !0 && (hd = ks(n, !0)));
    var f = 0, d = hd;
    do {
      var h = d, p = Di(h), y = p.top, m = p.bottom, b = p.left, x = p.right, D = p.width, S = p.height, C = void 0, v = void 0, H = h.scrollWidth, V = h.scrollHeight, R = Jt(h), F = h.scrollLeft, K = h.scrollTop;
      h === l ? (C = D < H && (R.overflowX === "auto" || R.overflowX === "scroll" || R.overflowX === "visible"), v = S < V && (R.overflowY === "auto" || R.overflowY === "scroll" || R.overflowY === "visible")) : (C = D < H && (R.overflowX === "auto" || R.overflowX === "scroll"), v = S < V && (R.overflowY === "auto" || R.overflowY === "scroll"));
      var q = C && (Math.abs(x - i) <= o && F + D < H) - (Math.abs(b - i) <= o && !!F), G = v && (Math.abs(m - a) <= o && K + S < V) - (Math.abs(y - a) <= o && !!K);
      if (!xi[f])
        for (var te = 0; te <= f; te++)
          xi[te] || (xi[te] = {});
      (xi[f].vx != q || xi[f].vy != G || xi[f].el !== h) && (xi[f].el = h, xi[f].vx = q, xi[f].vy = G, clearInterval(xi[f].pid), (q != 0 || G != 0) && (u = !0, xi[f].pid = setInterval(function() {
        r && this.layer === 0 && $t.active._onTouchMove(Ah);
        var Q = xi[this.layer].vy ? xi[this.layer].vy * s : 0, Y = xi[this.layer].vx ? xi[this.layer].vx * s : 0;
        typeof c == "function" && c.call($t.dragged.parentNode[Qr], Y, Q, e, Ah, xi[this.layer].el) !== "continue" || eC(xi[this.layer].el, Y, Q);
      }.bind({
        layer: f
      }), 24))), f++;
    } while (t.bubbleScroll && d !== l && (d = ks(d, !1)));
    j4 = u;
  }
}, 30), sC = function(t) {
  var n = t.originalEvent, r = t.putSortable, i = t.dragEl, a = t.activeSortable, o = t.dispatchSortableEvent, s = t.hideGhostForTarget, l = t.unhideGhostForTarget;
  if (!!n) {
    var u = r || a;
    s();
    var c = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, f = document.elementFromPoint(c.clientX, c.clientY);
    l(), u && !u.el.contains(f) && (o("spill"), this.onSpill({
      dragEl: i,
      putSortable: r
    }));
  }
};
function Z6() {
}
Z6.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var i = lc(this.sortable.el, this.startIndex, this.options);
    i ? this.sortable.el.insertBefore(n, i) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: sC
};
Qo(Z6, {
  pluginName: "revertOnSpill"
});
function J6() {
}
J6.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable, i = r || this.sortable;
    i.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), i.animateAll();
  },
  drop: sC
};
Qo(J6, {
  pluginName: "removeOnSpill"
});
$t.mount(new R0e());
$t.mount(J6, Z6);
function s8(e) {
  e.parentElement !== null && e.parentElement.removeChild(e);
}
function k9(e, t, n) {
  const r = n === 0 ? e.children[0] : e.children[n - 1].nextSibling;
  e.insertBefore(t, r);
}
function V0e() {
  return typeof window < "u" ? window.console : global.console;
}
const U0e = V0e();
function q0e(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] || (t[r] = e(r));
  };
}
const _0e = /-(\w)/g, W0e = q0e((e) => e.replace(_0e, (t, n) => n.toUpperCase())), lC = ["Start", "Add", "Remove", "Update", "End"], uC = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], cC = ["Move"], K0e = [cC, lC, uC].flatMap((e) => e).map((e) => `on${e}`), F4 = {
  manage: cC,
  manageAndEmit: lC,
  emit: uC
};
function G0e(e) {
  return K0e.indexOf(e) !== -1;
}
const Y0e = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "math",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rb",
  "rp",
  "rt",
  "rtc",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
];
function Q0e(e) {
  return Y0e.includes(e);
}
function Z0e(e) {
  return ["transition-group", "TransitionGroup"].includes(e);
}
function dC(e) {
  return ["id", "class", "role", "style"].includes(e) || e.startsWith("data-") || e.startsWith("aria-") || e.startsWith("on");
}
function fC(e) {
  return e.reduce((t, [n, r]) => (t[n] = r, t), {});
}
function J0e({ $attrs: e, componentData: t = {} }) {
  return {
    ...fC(
      Object.entries(e).filter(([r, i]) => dC(r))
    ),
    ...t
  };
}
function $0e({ $attrs: e, callBackBuilder: t }) {
  const n = fC(hC(e));
  Object.entries(t).forEach(([i, a]) => {
    F4[i].forEach((o) => {
      n[`on${o}`] = a(o);
    });
  });
  const r = `[data-draggable]${n.draggable || ""}`;
  return {
    ...n,
    draggable: r
  };
}
function hC(e) {
  return Object.entries(e).filter(([t, n]) => !dC(t)).map(([t, n]) => [W0e(t), n]).filter(([t, n]) => !G0e(t));
}
const O9 = ({ el: e }) => e, ehe = (e, t) => e.__draggable_context = t, z9 = (e) => e.__draggable_context;
class the {
  constructor({
    nodes: { header: t, default: n, footer: r },
    root: i,
    realList: a
  }) {
    this.defaultNodes = n, this.children = [...t, ...n, ...r], this.externalComponent = i.externalComponent, this.rootTransition = i.transition, this.tag = i.tag, this.realList = a;
  }
  get _isRootComponent() {
    return this.externalComponent || this.rootTransition;
  }
  render(t, n) {
    const { tag: r, children: i, _isRootComponent: a } = this;
    return t(r, n, a ? { default: () => i } : i);
  }
  updated() {
    const { defaultNodes: t, realList: n } = this;
    t.forEach((r, i) => {
      ehe(O9(r), {
        element: n[i],
        index: i
      });
    });
  }
  getUnderlyingVm(t) {
    return z9(t);
  }
  getVmIndexFromDomIndex(t, n) {
    const { defaultNodes: r } = this, { length: i } = r, a = n.children, o = a.item(t);
    if (o === null)
      return i;
    const s = z9(o);
    if (s)
      return s.index;
    if (i === 0)
      return 0;
    const l = O9(r[0]), u = [...a].findIndex(
      (c) => c === l
    );
    return t < u ? 0 : i;
  }
}
function nhe(e, t) {
  const n = e[t];
  return n ? n() : [];
}
function ihe({ $slots: e, realList: t, getKey: n }) {
  const r = t || [], [i, a] = ["header", "footer"].map(
    (l) => nhe(e, l)
  ), { item: o } = e;
  if (!o)
    throw new Error("draggable element must have an item slot");
  const s = r.flatMap(
    (l, u) => o({ element: l, index: u }).map((c) => (c.key = n(l), c.props = { ...c.props || {}, "data-draggable": !0 }, c))
  );
  if (s.length !== r.length)
    throw new Error("Item slot must have only one child");
  return {
    header: i,
    footer: a,
    default: s
  };
}
function rhe(e) {
  const t = Z0e(e), n = !Q0e(e) && !t;
  return {
    transition: t,
    externalComponent: n,
    tag: n ? Ie(e) : t ? Y4 : e
  };
}
function ahe({ $slots: e, tag: t, realList: n, getKey: r }) {
  const i = ihe({ $slots: e, realList: n, getKey: r }), a = rhe(t);
  return new the({ nodes: i, root: a, realList: n });
}
function pC(e, t) {
  bt(() => this.$emit(e.toLowerCase(), t));
}
function vC(e) {
  return (t, n) => {
    if (this.realList !== null)
      return this[`onDrag${e}`](t, n);
  };
}
function ohe(e) {
  const t = vC.call(this, e);
  return (n, r) => {
    t.call(this, n, r), pC.call(this, e, n);
  };
}
let l8 = null;
const she = {
  list: {
    type: Array,
    required: !1,
    default: null
  },
  modelValue: {
    type: Array,
    required: !1,
    default: null
  },
  itemKey: {
    type: [String, Function],
    required: !0
  },
  clone: {
    type: Function,
    default: (e) => e
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: !1,
    default: null
  }
}, lhe = [
  "update:modelValue",
  "change",
  ...[...F4.manageAndEmit, ...F4.emit].map((e) => e.toLowerCase())
], mC = Ee({
  name: "draggable",
  inheritAttrs: !1,
  props: she,
  emits: lhe,
  data() {
    return {
      error: !1
    };
  },
  render() {
    try {
      this.error = !1;
      const { $slots: e, $attrs: t, tag: n, componentData: r, realList: i, getKey: a } = this, o = ahe({
        $slots: e,
        tag: n,
        realList: i,
        getKey: a
      });
      this.componentStructure = o;
      const s = J0e({ $attrs: t, componentData: r });
      return o.render(et, s);
    } catch (e) {
      return this.error = !0, et("pre", { style: { color: "red" } }, e.stack);
    }
  },
  created() {
    this.list !== null && this.modelValue !== null && U0e.error(
      "modelValue and list props are mutually exclusive! Please set one or another."
    );
  },
  mounted() {
    if (this.error)
      return;
    const { $attrs: e, $el: t, componentStructure: n } = this;
    n.updated();
    const r = $0e({
      $attrs: e,
      callBackBuilder: {
        manageAndEmit: (a) => ohe.call(this, a),
        emit: (a) => pC.bind(this, a),
        manage: (a) => vC.call(this, a)
      }
    }), i = t.nodeType === 1 ? t : t.parentElement;
    this._sortable = new $t(i, r), this.targetDomElement = i, i.__draggable_component__ = this;
  },
  updated() {
    this.componentStructure.updated();
  },
  beforeUnmount() {
    this._sortable !== void 0 && this._sortable.destroy();
  },
  computed: {
    realList() {
      const { list: e } = this;
      return e || this.modelValue;
    },
    getKey() {
      const { itemKey: e } = this;
      return typeof e == "function" ? e : (t) => t[e];
    }
  },
  watch: {
    $attrs: {
      handler(e) {
        const { _sortable: t } = this;
        !t || hC(e).forEach(([n, r]) => {
          t.option(n, r);
        });
      },
      deep: !0
    }
  },
  methods: {
    getUnderlyingVm(e) {
      return this.componentStructure.getUnderlyingVm(e) || null;
    },
    getUnderlyingPotencialDraggableComponent(e) {
      return e.__draggable_component__;
    },
    emitChanges(e) {
      bt(() => this.$emit("change", e));
    },
    alterList(e) {
      if (this.list) {
        e(this.list);
        return;
      }
      const t = [...this.modelValue];
      e(t), this.$emit("update:modelValue", t);
    },
    spliceList() {
      const e = (t) => t.splice(...arguments);
      this.alterList(e);
    },
    updatePosition(e, t) {
      const n = (r) => r.splice(t, 0, r.splice(e, 1)[0]);
      this.alterList(n);
    },
    getRelatedContextFromMoveEvent({ to: e, related: t }) {
      const n = this.getUnderlyingPotencialDraggableComponent(e);
      if (!n)
        return { component: n };
      const r = n.realList, i = { list: r, component: n };
      return e !== t && r ? { ...n.getUnderlyingVm(t) || {}, ...i } : i;
    },
    getVmIndexFromDomIndex(e) {
      return this.componentStructure.getVmIndexFromDomIndex(
        e,
        this.targetDomElement
      );
    },
    onDragStart(e) {
      this.context = this.getUnderlyingVm(e.item), e.item._underlying_vm_ = this.clone(this.context.element), l8 = e.item;
    },
    onDragAdd(e) {
      const t = e.item._underlying_vm_;
      if (t === void 0)
        return;
      s8(e.item);
      const n = this.getVmIndexFromDomIndex(e.newIndex);
      this.spliceList(n, 0, t);
      const r = { element: t, newIndex: n };
      this.emitChanges({ added: r });
    },
    onDragRemove(e) {
      if (k9(this.$el, e.item, e.oldIndex), e.pullMode === "clone") {
        s8(e.clone);
        return;
      }
      const { index: t, element: n } = this.context;
      this.spliceList(t, 1);
      const r = { element: n, oldIndex: t };
      this.emitChanges({ removed: r });
    },
    onDragUpdate(e) {
      s8(e.item), k9(e.from, e.item, e.oldIndex);
      const t = this.context.index, n = this.getVmIndexFromDomIndex(e.newIndex);
      this.updatePosition(t, n);
      const r = { element: this.context.element, oldIndex: t, newIndex: n };
      this.emitChanges({ moved: r });
    },
    computeFutureIndex(e, t) {
      if (!e.element)
        return 0;
      const n = [...t.to.children].filter(
        (o) => o.style.display !== "none"
      ), r = n.indexOf(t.related), i = e.component.getVmIndexFromDomIndex(
        r
      );
      return n.indexOf(l8) !== -1 || !t.willInsertAfter ? i : i + 1;
    },
    onDragMove(e, t) {
      const { move: n, realList: r } = this;
      if (!n || !r)
        return !0;
      const i = this.getRelatedContextFromMoveEvent(e), a = this.computeFutureIndex(i, e), o = {
        ...this.context,
        futureIndex: a
      }, s = {
        ...e,
        relatedContext: i,
        draggedContext: o
      };
      return n(s, t);
    },
    onDragEnd() {
      l8 = null;
    }
  }
}), $6 = (e) => (yn("data-v-416753d8"), e = e(), bn(), e), uhe = { class: "content" }, che = /* @__PURE__ */ $6(() => /* @__PURE__ */ T("div", { class: "left" }, "*\u957F\u6309\u56FE\u6807\u62D6\u52A8\u6392\u5E8F", -1)), dhe = { class: "draggable-box" }, fhe = /* @__PURE__ */ $6(() => /* @__PURE__ */ T("div", { class: "content-head" }, [
  /* @__PURE__ */ T("div", { class: "drag-icon" }),
  /* @__PURE__ */ T("div", { class: "menu-name" }, "\u83DC\u5355\u540D\u79F0"),
  /* @__PURE__ */ T("div", { class: "menu-open" }, "\u5F00\u5173"),
  /* @__PURE__ */ T("div", { class: "menu-action" }, "\u64CD\u4F5C")
], -1)), hhe = { class: "content-body" }, phe = { class: "menu-item" }, vhe = /* @__PURE__ */ $6(() => /* @__PURE__ */ T("div", { class: "drag-pic" }, [
  /* @__PURE__ */ T("i", { class: "iconfont icon-santiaoxian" })
], -1)), mhe = { class: "menu-item-name" }, ghe = {
  key: 0,
  class: "only-show"
}, yhe = { class: "menu-item-open" }, bhe = { class: "menu-item-do" }, Ahe = ["onClick"], The = /* @__PURE__ */ je(" \u5220\u9664 "), whe = {
  key: 1,
  class: "empty-box"
}, Phe = Ee({
  components: {
    draggable: mC
  }
}), xhe = /* @__PURE__ */ Ee({
  ...Phe,
  props: {
    menuList: Array,
    showMenuSet: Boolean
  },
  emits: ["update:showMenuSet"],
  setup(e, { emit: t }) {
    const n = e;
    document.body.ondrop = function(q) {
      q.preventDefault(), q.stopPropagation();
    };
    const r = ce("$bus"), i = j([]), a = ce("siteId"), { beforwDelMenu: o, delCaseMenu: s, sortCaseMenu: l, updateCaseMenu: u, addCaseMenu: c } = ce(
      "$http"
    ), f = ce("$utils"), d = ce("currentMenuId"), h = j(!1), p = {
      column_title: [
        { required: !0, message: "\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A", trigger: "change" },
        { min: 1, max: 10, message: "\u957F\u5EA6\u8981\u6C4210\u4E2A\u5B57\u4EE5\u5185", trigger: "change" }
      ]
    }, y = j(""), m = j(""), b = j(0), x = j({});
    Ne(
      () => n.menuList,
      (q) => {
        i.value = f.deepClone(q), h.value = !1;
      },
      {
        immediate: !0
      }
    );
    const D = async (q, G) => {
      if (console.log("remove", q), !q.id) {
        i.value.splice(G, 1);
        return;
      }
      const te = await o({
        column_id: q.id
      });
      console.log(te), te == 0 ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u6B64\u5185\u5BB9\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001",
        confirmButtonText: "\u5220 \u9664"
      }).then(async () => {
        await s({
          site_id: a,
          ids: q.id
        }) > 0 && (i.value.splice(G, 1), q.id === E(d) && (h.value = !0), yi({
          type: "success",
          message: "\u5DF2\u5220\u9664"
        }));
      }).catch(() => {
      }) : di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u5DF2\u586B\u5199\u5185\u5BB9\u4E0D\u5141\u8BB8\u5220\u9664",
        tipText: "\u5982\u8981\u5220\u9664\uFF0C\u8BF7\u6E05\u7A7A\u5185\u5BB9\u540E\u518D\u5C1D\u8BD5",
        confirmButtonText: "\u6211\u77E5\u9053\u4E86",
        boxType: "alert"
      }).then(() => {
      }).catch(() => {
      });
    }, S = (q) => {
      console.log("add", q);
      let G = i.value.length;
      b.value = G + 1, i.value.splice(G, 0, {
        column_title: "",
        type: -1,
        status: 1
      }), bt(() => {
        let te = document.getElementsByClassName("content-body")[0];
        te.scrollTop = te.scrollHeight, document.getElementById(b.value + "").focus();
      });
    }, C = (q) => {
      b.value = q + 1, bt(() => {
        document.getElementById(b.value + "").focus();
      });
    }, v = async () => {
      let q = [];
      i.value.map((G) => {
        G.id && q.push(G.id);
      }), q.length && await l({
        column_ids: q.join(",")
      }), r.emit("updateMenu", !h.value), t("update:showMenuSet", !1);
    }, H = (q, G) => {
      q && (x.value[G] = q);
    }, V = (q, G) => {
      let te = {
        id: q.id,
        column_title: q.column_title || void 0
      };
      x.value[q.id].validate(async (Q) => {
        if (Q) {
          if (q.id) {
            const Y = await u(te);
            console.log("\u4FEE\u6539", Y), Y > 0 && yi.success("\u4FEE\u6539\u6210\u529F");
          } else {
            const Y = await c({
              column_title: q.column_title,
              parent_id: 0,
              site_id: a,
              column_type: -1
            });
            console.log("\u65B0\u589E", Y, G), q.id = Y, i.value.splice(G, 1, q);
          }
          b.value = 0;
        } else
          return yi.error("\u64CD\u4F5C\u5931\u8D25\uFF0C\u8BF7\u6309\u7167\u89C4\u8303\u8FDB\u884C\u4FEE\u6539"), i.value[G].column_title = m.value, !1;
      });
    }, R = (q, G) => {
      !q.column_title || V(q, G);
    }, F = async (q) => {
      console.log(q), y.value = q.id, await u({
        id: y.value,
        status: +q.status
      }) > 0 && yi.success("\u4FEE\u6539\u6210\u529F");
    }, K = (q) => {
      m.value = q.column_title, console.log("this.oldMenuName", m.value);
    };
    return (q, G) => {
      const te = ti, Q = Sa, Y = Ca, Z = yT, oe = fn, he = ni;
      return P(), L("div", null, [
        B(he, {
          title: "\u83DC\u5355\u8BBE\u7F6E",
          modelValue: e.showMenuSet,
          "onUpdate:modelValue": G[1] || (G[1] = (Ae) => Bn(showMenuSet) ? showMenuSet.value = Ae : null),
          width: 680,
          "before-close": v
        }, {
          footer: N(() => [
            T("div", { class: "dialog-footer" }, [
              T("div", {
                class: "submit-btn",
                onClick: v
              }, "\u5B8C\u6210")
            ])
          ]),
          default: N(() => [
            T("div", uhe, [
              T("div", { class: "tip" }, [
                che,
                T("div", { class: "right" }, [
                  T("div", {
                    class: "add-box",
                    onClick: S
                  }, "+\u65B0\u589E")
                ])
              ]),
              T("div", dhe, [
                fhe,
                T("ul", hhe, [
                  i.value && i.value.length ? (P(), ue(E(mC), {
                    key: 0,
                    list: i.value,
                    tag: "li",
                    "item-key": "index",
                    handle: ".icon-santiaoxian"
                  }, {
                    item: N(({ element: Ae, index: We }) => [
                      T("div", phe, [
                        vhe,
                        T("div", mhe, [
                          b.value != We + 1 ? (P(), L("div", ghe, de(Ae.column_title), 1)) : re("", !0),
                          b.value == We + 1 ? (P(), ue(Y, {
                            key: 1,
                            model: Ae,
                            rules: p,
                            ref: (ke) => H(ke, Ae.id),
                            onSubmit: G[0] || (G[0] = wt(() => {
                            }, ["prevent"]))
                          }, {
                            default: N(() => [
                              B(Q, { prop: "column_title" }, {
                                default: N(() => [
                                  B(te, {
                                    type: "text",
                                    id: b.value,
                                    modelValue: Ae.column_title,
                                    "onUpdate:modelValue": (ke) => Ae.column_title = ke,
                                    placeholder: "\u8BF7\u8F93\u5165\u83DC\u5355\u540D\u79F0\uFF0C\u5EFA\u8BAE6\u4E2A\u5B57\u4EE5\u5185",
                                    onFocus: (ke) => K(Ae),
                                    onBlur: (ke) => R(Ae, We)
                                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["model"])) : re("", !0)
                        ]),
                        T("div", yhe, [
                          B(Z, {
                            modelValue: Ae.status,
                            "onUpdate:modelValue": (ke) => Ae.status = ke,
                            "active-value": 1,
                            "inactive-value": 0,
                            "inactive-color": "#E5E5E5",
                            width: 38,
                            onChange: (ke) => F(Ae)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                        ]),
                        T("div", bhe, [
                          T("span", {
                            class: "add-item",
                            onClick: (ke) => C(We)
                          }, "\u7F16\u8F91", 8, Ahe),
                          B(oe, {
                            type: "text",
                            class: "delete-item",
                            disabled: Ae.column_type == 31 || Ae.column_type == 33,
                            onClick: (ke) => D(Ae, We)
                          }, {
                            default: N(() => [
                              The
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["list"])) : (P(), L("div", whe, [
                    B(bi, { description: "\u6682\u65E0\u6570\u636E" })
                  ]))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
});
const gC = /* @__PURE__ */ Ht(xhe, [["__scopeId", "data-v-416753d8"]]), Che = /* @__PURE__ */ Ee({
  props: {
    offset: { default: 0 },
    zIndex: { default: 100 },
    position: { default: "top" }
  },
  setup(e) {
    const t = e, n = Uo(), r = j(!1), { height: i, width: a, top: o, bottom: s, update: l } = Zee(n), { height: u } = Jee(), c = Uo(), f = J(() => ({
      width: r.value ? `${a.value}px` : "",
      height: r.value ? `${i.value}px` : ""
    })), d = J(() => r.value ? {
      width: `${a.value}px`,
      height: `${i.value}px`,
      top: t.position === "top" ? `${t.offset}px` : "",
      bottom: t.position === "bottom" ? `${t.offset}px` : "",
      zIndex: t.zIndex
    } : {});
    return Bo(() => {
      !c.value || (t.position === "top" ? r.value = t.offset >= o.value : r.value = u.value - t.offset < s.value);
    }), rn(() => {
      c.value = window, l();
    }), (p, y) => (P(), L("div", {
      class: "affix",
      ref_key: "root",
      ref: n,
      style: Pt(E(f))
    }, [
      T("div", {
        class: se(["affix-content", { fixed: r.value }]),
        style: Pt(E(d))
      }, [
        tt(p.$slots, "default", {}, void 0, !0)
      ], 6)
    ], 4));
  }
});
const Ol = /* @__PURE__ */ Ht(Che, [["__scopeId", "data-v-52427939"]]);
Ol.name = "affix";
Ol.install = (e) => {
  e.component(Ol.name, Ol);
};
const yC = (e) => (yn("data-v-8ed042c4"), e = e(), bn(), e), She = { class: "menu-box" }, Ehe = ["title"], khe = /* @__PURE__ */ yC(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shezhi menu-icon" }, null, -1)), Ohe = /* @__PURE__ */ yC(() => /* @__PURE__ */ T("span", null, "\u83DC\u5355\u8BBE\u7F6E", -1)), zhe = [
  khe,
  Ohe
], Dhe = {
  props: {
    menuList: Array
  },
  emits: ["handleMenu", "contentChange"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$bus"), i = ce("currentMenuId"), a = ce("pageMode"), o = j([]), s = ce("topHeight"), l = ce("$http"), u = ce("caseOther"), c = J(() => `calc(100vh - ${E(s)} - 120px)`);
    Ne(
      () => n.menuList,
      (m) => {
        o.value = m.filter((b) => b.status);
      },
      { immediate: !0 }
    );
    const f = j(!1), d = () => {
      f.value = !0, console.log("menuList", n.menuList);
    }, h = (m) => r.emit("handleMenu", m), p = j(!0), y = async () => {
      const m = await l.getCaseMenuSetStatus();
      p.value = !(m && m.length);
    };
    return [1, 2].includes(u.source) && y(), (m, b) => {
      const x = nT, D = tT, S = ns;
      return P(), L("div", She, [
        B(E(Ol), null, {
          default: N(() => [
            T("div", null, [
              B(S, { "max-height": E(c) }, {
                default: N(() => [
                  o.value.length ? (P(), ue(D, {
                    key: 0,
                    "default-active": E(i),
                    class: "el-menu-vertical-demo"
                  }, {
                    default: N(() => [
                      (P(!0), L(nt, null, Lt(o.value, (C) => Bt((P(), ue(x, {
                        index: C.id + "",
                        key: C.id,
                        onClick: (v) => h(C)
                      }, {
                        default: N(() => [
                          T("span", {
                            title: C.column_title
                          }, de(C.column_title), 9, Ehe)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"])), [
                        [Cn, C.column_title]
                      ])), 128))
                    ]),
                    _: 1
                  }, 8, ["default-active"])) : re("", !0)
                ]),
                _: 1
              }, 8, ["max-height"]),
              p.value && E(a) == 1 ? (P(), L("div", {
                key: 0,
                class: "menu-set",
                onClick: d
              }, zhe)) : re("", !0)
            ])
          ]),
          _: 1
        }),
        B(gC, {
          showMenuSet: f.value,
          "onUpdate:showMenuSet": b[0] || (b[0] = (C) => f.value = C),
          menuList: e.menuList
        }, null, 8, ["showMenuSet", "menuList"])
      ]);
    };
  }
}, Mhe = /* @__PURE__ */ Ht(Dhe, [["__scopeId", "data-v-8ed042c4"]]);
const bC = (e) => (yn("data-v-b0f154d0"), e = e(), bn(), e), Hhe = { class: "menu-box" }, Ihe = { class: "menu-item" }, Lhe = ["title"], Bhe = /* @__PURE__ */ bC(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shezhi menu-icon" }, null, -1)), Nhe = /* @__PURE__ */ bC(() => /* @__PURE__ */ T("span", null, "\u83DC\u5355\u8BBE\u7F6E", -1)), jhe = [
  Bhe,
  Nhe
], Fhe = {
  props: {
    menuList: Array
  },
  emits: ["handleMenu", "contentChange"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$bus"), i = ce("currentMenuId"), a = ce("pageMode"), o = j([]), s = ce("topHeight"), l = J(() => `calc(100vh - ${E(s)} - 120px)`);
    Ne(
      () => n.menuList,
      (p) => {
        o.value = p.filter((y) => y.status);
      },
      { immediate: !0 }
    );
    const u = j(["\u57FA\u672C\u4FE1\u606F", "\u5EFA\u8BBE\u89C4\u5212", "\u6574\u4F53\u60C5\u51B5", "goal-plan", "other", "sum-review"]), c = (p) => p > u.value.length - 1 ? u.value[p % u.value.length] : u.value[p], f = j(!1), d = () => {
      f.value = !0, console.log("menuList", n.menuList);
    }, h = (p) => r.emit("handleMenu", p);
    return (p, y) => {
      const m = nT, b = tT, x = ns;
      return P(), L("div", Hhe, [
        B(E(Ol), null, {
          default: N(() => [
            T("div", null, [
              B(x, { "max-height": E(l) }, {
                default: N(() => [
                  o.value.length ? (P(), ue(b, {
                    key: 0,
                    "default-active": E(i),
                    class: "el-menu-vertical-demo"
                  }, {
                    default: N(() => [
                      (P(!0), L(nt, null, Lt(o.value, (D, S) => Bt((P(), ue(m, {
                        index: D.id + "",
                        key: D.id,
                        onClick: (C) => h(D)
                      }, {
                        default: N(() => [
                          T("div", Ihe, [
                            B(E(qi), {
                              name: c(S),
                              "icon-class": "menu-item-icon"
                            }, null, 8, ["name"]),
                            T("span", {
                              title: D.column_title,
                              class: "menu-name"
                            }, de(D.column_title), 9, Lhe)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"])), [
                        [Cn, D.column_title]
                      ])), 128))
                    ]),
                    _: 1
                  }, 8, ["default-active"])) : re("", !0)
                ]),
                _: 1
              }, 8, ["max-height"]),
              E(a) == 1 ? (P(), L("div", {
                key: 0,
                class: "menu-set",
                onClick: d
              }, jhe)) : re("", !0)
            ])
          ]),
          _: 1
        }),
        B(gC, {
          showMenuSet: f.value,
          "onUpdate:showMenuSet": y[0] || (y[0] = (D) => f.value = D),
          menuList: e.menuList
        }, null, 8, ["showMenuSet", "menuList"])
      ]);
    };
  }
}, Xhe = /* @__PURE__ */ Ht(Fhe, [["__scopeId", "data-v-b0f154d0"]]);
/*!
 * better-scroll / core
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var X4 = function(e, t) {
  return X4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, X4(e, t);
};
function g2(e, t) {
  X4(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var af = function() {
  return af = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, af.apply(this, arguments);
};
function AC() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++)
    e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var a = arguments[t], o = 0, s = a.length; o < s; o++, i++)
      r[i] = a[o];
  return r;
}
var Rhe = [
  {
    sourceKey: "scroller.scrollBehaviorX.currentPos",
    key: "x"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.currentPos",
    key: "y"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.hasScroll",
    key: "hasHorizontalScroll"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.hasScroll",
    key: "hasVerticalScroll"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.contentSize",
    key: "scrollerWidth"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.contentSize",
    key: "scrollerHeight"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.maxScrollPos",
    key: "maxScrollX"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.maxScrollPos",
    key: "maxScrollY"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.minScrollPos",
    key: "minScrollX"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.minScrollPos",
    key: "minScrollY"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.movingDirection",
    key: "movingDirectionX"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.movingDirection",
    key: "movingDirectionY"
  },
  {
    sourceKey: "scroller.scrollBehaviorX.direction",
    key: "directionX"
  },
  {
    sourceKey: "scroller.scrollBehaviorY.direction",
    key: "directionY"
  },
  {
    sourceKey: "scroller.actions.enabled",
    key: "enabled"
  },
  {
    sourceKey: "scroller.animater.pending",
    key: "pending"
  },
  {
    sourceKey: "scroller.animater.stop",
    key: "stop"
  },
  {
    sourceKey: "scroller.scrollTo",
    key: "scrollTo"
  },
  {
    sourceKey: "scroller.scrollBy",
    key: "scrollBy"
  },
  {
    sourceKey: "scroller.scrollToElement",
    key: "scrollToElement"
  },
  {
    sourceKey: "scroller.resetPosition",
    key: "resetPosition"
  }
];
function C0(e) {
  console.error("[BScroll warn]: " + e);
}
var yo = typeof window < "u", uc = yo && navigator.userAgent.toLowerCase(), Vhe = !!(uc && /wechatdevtools/.test(uc)), Uhe = uc && uc.indexOf("android") > 0, qhe = function() {
  if (typeof uc == "string") {
    var e = /os (\d\d?_\d(_\d)?)/, t = e.exec(uc);
    if (!t)
      return !1;
    var n = t[1].split("_").map(function(r) {
      return parseInt(r, 10);
    });
    return n[0] === 13 && n[1] >= 4;
  }
  return !1;
}(), TC = !1;
if (yo) {
  var _he = "test-passive";
  try {
    var D9 = {};
    Object.defineProperty(D9, "passive", {
      get: function() {
        TC = !0;
      }
    }), window.addEventListener(_he, function() {
    }, D9);
  } catch {
  }
}
function zl() {
  return window.performance && window.performance.now && window.performance.timing ? window.performance.now() + window.performance.timing.navigationStart : +new Date();
}
var R4 = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
};
function V4(e) {
  return e == null;
}
function M9(e, t, n) {
  return e < t ? t : e > n ? n : e;
}
var ev = yo && document.createElement("div").style, ju = function() {
  if (!yo)
    return !1;
  for (var e = [
    {
      key: "standard",
      value: "transform"
    },
    {
      key: "webkit",
      value: "webkitTransform"
    },
    {
      key: "Moz",
      value: "MozTransform"
    },
    {
      key: "O",
      value: "OTransform"
    },
    {
      key: "ms",
      value: "msTransform"
    }
  ], t = 0, n = e; t < n.length; t++) {
    var r = n[t];
    if (ev[r.value] !== void 0)
      return r.key;
  }
  return !1;
}();
function Oo(e) {
  return ju === !1 ? e : ju === "standard" ? e === "transitionEnd" ? "transitionend" : e : ju + e.charAt(0).toUpperCase() + e.substr(1);
}
function wC(e) {
  return typeof e == "string" ? document.querySelector(e) : e;
}
function Whe(e, t, n, r) {
  var i = TC ? {
    passive: !1,
    capture: !!r
  } : !!r;
  e.addEventListener(t, n, i);
}
function Khe(e, t, n, r) {
  e.removeEventListener(t, n, {
    capture: !!r
  });
}
function H9(e) {
  for (var t = 0, n = 0; e; )
    t -= e.offsetLeft, n -= e.offsetTop, e = e.offsetParent;
  return {
    left: t,
    top: n
  };
}
ju && ju !== "standard" && "" + ju.toLowerCase();
var Ghe = Oo("transform"), PC = Oo("transition"), Yhe = yo && Oo("perspective") in ev, I9 = yo && ("ontouchstart" in window || Vhe), Qhe = yo && PC in ev, Al = {
  transform: Ghe,
  transition: PC,
  transitionTimingFunction: Oo("transitionTimingFunction"),
  transitionDuration: Oo("transitionDuration"),
  transitionDelay: Oo("transitionDelay"),
  transformOrigin: Oo("transformOrigin"),
  transitionEnd: Oo("transitionEnd"),
  transitionProperty: Oo("transitionProperty")
}, u8 = {
  touchstart: 1,
  touchmove: 1,
  touchend: 1,
  touchcancel: 1,
  mousedown: 2,
  mousemove: 2,
  mouseup: 2
};
function L9(e) {
  if (e instanceof window.SVGElement) {
    var t = e.getBoundingClientRect();
    return {
      top: t.top,
      left: t.left,
      width: t.width,
      height: t.height
    };
  } else
    return {
      top: e.offsetTop,
      left: e.offsetLeft,
      width: e.offsetWidth,
      height: e.offsetHeight
    };
}
function of(e, t) {
  for (var n in t)
    if (t[n].test(e[n]))
      return !0;
  return !1;
}
var Zhe = of;
function Jhe(e, t) {
  var n = document.createEvent("Event");
  n.initEvent(t, !0, !0), n.pageX = e.pageX, n.pageY = e.pageY, e.target.dispatchEvent(n);
}
function xC(e, t) {
  t === void 0 && (t = "click");
  var n;
  e.type === "mouseup" ? n = e : (e.type === "touchend" || e.type === "touchcancel") && (n = e.changedTouches[0]);
  var r = {};
  n && (r.screenX = n.screenX || 0, r.screenY = n.screenY || 0, r.clientX = n.clientX || 0, r.clientY = n.clientY || 0);
  var i, a = !0, o = !0, s = e.ctrlKey, l = e.shiftKey, u = e.altKey, c = e.metaKey, f = {
    ctrlKey: s,
    shiftKey: l,
    altKey: u,
    metaKey: c
  };
  if (typeof MouseEvent < "u")
    try {
      i = new MouseEvent(t, R4(af({
        bubbles: a,
        cancelable: o
      }, f), r));
    } catch {
      d();
    }
  else
    d();
  function d() {
    i = document.createEvent("Event"), i.initEvent(t, a, o), R4(i, r);
  }
  i.forwardedTouchEvent = !0, i._constructed = !0, e.target.dispatchEvent(i);
}
function $he(e) {
  xC(e, "dblclick");
}
var sl = {
  swipe: {
    style: "cubic-bezier(0.23, 1, 0.32, 1)",
    fn: function(e) {
      return 1 + --e * e * e * e * e;
    }
  },
  swipeBounce: {
    style: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    fn: function(e) {
      return e * (2 - e);
    }
  },
  bounce: {
    style: "cubic-bezier(0.165, 0.84, 0.44, 1)",
    fn: function(e) {
      return 1 - --e * e * e * e;
    }
  }
}, e2e = 1e3 / 60, Os = yo && window;
function CC() {
}
var SC = function() {
  return yo ? Os.requestAnimationFrame || Os.webkitRequestAnimationFrame || Os.mozRequestAnimationFrame || Os.oRequestAnimationFrame || function(e) {
    return window.setTimeout(e, e.interval || e2e);
  } : CC;
}(), Bl = function() {
  return yo ? Os.cancelAnimationFrame || Os.webkitCancelAnimationFrame || Os.mozCancelAnimationFrame || Os.oCancelAnimationFrame || function(e) {
    window.clearTimeout(e);
  } : CC;
}(), B9 = function(e) {
}, c8 = {
  enumerable: !0,
  configurable: !0,
  get: B9,
  set: B9
}, t2e = function(e, t) {
  for (var n = t.split("."), r = 0; r < n.length - 1; r++)
    if (e = e[n[r]], typeof e != "object" || !e)
      return;
  var i = n.pop();
  return typeof e[i] == "function" ? function() {
    return e[i].apply(e, arguments);
  } : e[i];
}, n2e = function(e, t, n) {
  for (var r = t.split("."), i, a = 0; a < r.length - 1; a++)
    i = r[a], e[i] || (e[i] = {}), e = e[i];
  e[r.pop()] = n;
};
function i2e(e, t, n) {
  c8.get = function() {
    return t2e(this, t);
  }, c8.set = function(i) {
    n2e(this, t, i);
  }, Object.defineProperty(e, n, c8);
}
var Xs = function() {
  function e(t) {
    this.events = {}, this.eventTypes = {}, this.registerType(t);
  }
  return e.prototype.on = function(t, n, r) {
    return r === void 0 && (r = this), this.hasType(t), this.events[t] || (this.events[t] = []), this.events[t].push([n, r]), this;
  }, e.prototype.once = function(t, n, r) {
    var i = this;
    r === void 0 && (r = this), this.hasType(t);
    var a = function() {
      for (var o = [], s = 0; s < arguments.length; s++)
        o[s] = arguments[s];
      i.off(t, a);
      var l = n.apply(r, o);
      if (l === !0)
        return l;
    };
    return a.fn = n, this.on(t, a), this;
  }, e.prototype.off = function(t, n) {
    if (!t && !n)
      return this.events = {}, this;
    if (t) {
      if (this.hasType(t), !n)
        return this.events[t] = [], this;
      var r = this.events[t];
      if (!r)
        return this;
      for (var i = r.length; i--; )
        (r[i][0] === n || r[i][0] && r[i][0].fn === n) && r.splice(i, 1);
      return this;
    }
  }, e.prototype.trigger = function(t) {
    for (var n = [], r = 1; r < arguments.length; r++)
      n[r - 1] = arguments[r];
    this.hasType(t);
    var i = this.events[t];
    if (!!i)
      for (var a = i.length, o = AC(i), s, l = 0; l < a; l++) {
        var u = o[l], c = u[0], f = u[1];
        if (c && (s = c.apply(f, n), s === !0))
          return s;
      }
  }, e.prototype.registerType = function(t) {
    var n = this;
    t.forEach(function(r) {
      n.eventTypes[r] = r;
    });
  }, e.prototype.destroy = function() {
    this.events = {}, this.eventTypes = {};
  }, e.prototype.hasType = function(t) {
    var n = this.eventTypes, r = n[t] === t;
    r || C0('EventEmitter has used unknown event type: "' + t + '", should be oneof [' + ("" + Object.keys(n).map(function(i) {
      return JSON.stringify(i);
    })) + "]");
  }, e;
}(), Th = function() {
  function e(t, n) {
    this.wrapper = t, this.events = n, this.addDOMEvents();
  }
  return e.prototype.destroy = function() {
    this.removeDOMEvents(), this.events = [];
  }, e.prototype.addDOMEvents = function() {
    this.handleDOMEvents(Whe);
  }, e.prototype.removeDOMEvents = function() {
    this.handleDOMEvents(Khe);
  }, e.prototype.handleDOMEvents = function(t) {
    var n = this, r = this.wrapper;
    this.events.forEach(function(i) {
      t(r, i.name, n, !!i.capture);
    });
  }, e.prototype.handleEvent = function(t) {
    var n = t.type;
    this.events.some(function(r) {
      return r.name === n ? (r.handler(t), !0) : !1;
    });
  }, e;
}(), r2e = function() {
  function e() {
  }
  return e;
}(), a2e = function(e) {
  g2(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.startX = 0, n.startY = 0, n.scrollX = !1, n.scrollY = !0, n.freeScroll = !1, n.directionLockThreshold = 0, n.eventPassthrough = "", n.click = !1, n.dblclick = !1, n.tap = "", n.bounce = {
      top: !0,
      bottom: !0,
      left: !0,
      right: !0
    }, n.bounceTime = 800, n.momentum = !0, n.momentumLimitTime = 300, n.momentumLimitDistance = 15, n.swipeTime = 2500, n.swipeBounceTime = 500, n.deceleration = 15e-4, n.flickLimitTime = 200, n.flickLimitDistance = 100, n.resizePolling = 60, n.probeType = 0, n.stopPropagation = !1, n.preventDefault = !0, n.preventDefaultException = {
      tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|AUDIO)$/
    }, n.tagException = {
      tagName: /^TEXTAREA$/
    }, n.HWCompositing = !0, n.useTransition = !0, n.bindToWrapper = !1, n.bindToTarget = !1, n.disableMouse = I9, n.disableTouch = !I9, n.autoBlur = !0, n.autoEndDistance = 5, n.outOfBoundaryDampingFactor = 1 / 3, n.specifiedIndexAsContent = 0, n.quadrant = 1, n;
  }
  return t.prototype.merge = function(n) {
    if (!n)
      return this;
    for (var r in n) {
      if (r === "bounce") {
        this.bounce = this.resolveBounce(n[r]);
        continue;
      }
      this[r] = n[r];
    }
    return this;
  }, t.prototype.process = function() {
    return this.translateZ = this.HWCompositing && Yhe ? " translateZ(1px)" : "", this.useTransition = this.useTransition && Qhe, this.preventDefault = !this.eventPassthrough && this.preventDefault, this.scrollX = this.eventPassthrough === "horizontal" ? !1 : this.scrollX, this.scrollY = this.eventPassthrough === "vertical" ? !1 : this.scrollY, this.freeScroll = this.freeScroll && !this.eventPassthrough, this.scrollX = this.freeScroll ? !0 : this.scrollX, this.scrollY = this.freeScroll ? !0 : this.scrollY, this.directionLockThreshold = this.eventPassthrough ? 0 : this.directionLockThreshold, this;
  }, t.prototype.resolveBounce = function(n) {
    var r = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    }, i = {
      top: !1,
      right: !1,
      bottom: !1,
      left: !1
    }, a;
    return typeof n == "object" ? a = R4(r, n) : a = n ? r : i, a;
  }, t;
}(r2e), o2e = function() {
  function e(t, n) {
    this.wrapper = t, this.options = n, this.hooks = new Xs([
      "beforeStart",
      "start",
      "move",
      "end",
      "click"
    ]), this.handleDOMEvents();
  }
  return e.prototype.handleDOMEvents = function() {
    var t = this.options, n = t.bindToWrapper, r = t.disableMouse, i = t.disableTouch, a = t.click, o = this.wrapper, s = n ? o : window, l = [], u = [], c = !i, f = !r;
    a && l.push({
      name: "click",
      handler: this.click.bind(this),
      capture: !0
    }), c && (l.push({
      name: "touchstart",
      handler: this.start.bind(this)
    }), u.push({
      name: "touchmove",
      handler: this.move.bind(this)
    }, {
      name: "touchend",
      handler: this.end.bind(this)
    }, {
      name: "touchcancel",
      handler: this.end.bind(this)
    })), f && (l.push({
      name: "mousedown",
      handler: this.start.bind(this)
    }), u.push({
      name: "mousemove",
      handler: this.move.bind(this)
    }, {
      name: "mouseup",
      handler: this.end.bind(this)
    })), this.wrapperEventRegister = new Th(o, l), this.targetEventRegister = new Th(s, u);
  }, e.prototype.beforeHandler = function(t, n) {
    var r = this.options, i = r.preventDefault, a = r.stopPropagation, o = r.preventDefaultException, s = {
      start: function() {
        return i && !of(t.target, o);
      },
      end: function() {
        return i && !of(t.target, o);
      },
      move: function() {
        return i;
      }
    };
    s[n]() && t.preventDefault(), a && t.stopPropagation();
  }, e.prototype.setInitiated = function(t) {
    t === void 0 && (t = 0), this.initiated = t;
  }, e.prototype.start = function(t) {
    var n = u8[t.type];
    if (!(this.initiated && this.initiated !== n)) {
      if (this.setInitiated(n), Zhe(t.target, this.options.tagException)) {
        this.setInitiated();
        return;
      }
      if (!(n === 2 && t.button !== 0) && !this.hooks.trigger(this.hooks.eventTypes.beforeStart, t)) {
        this.beforeHandler(t, "start");
        var r = t.touches ? t.touches[0] : t;
        this.pointX = r.pageX, this.pointY = r.pageY, this.hooks.trigger(this.hooks.eventTypes.start, t);
      }
    }
  }, e.prototype.move = function(t) {
    if (u8[t.type] === this.initiated) {
      this.beforeHandler(t, "move");
      var n = t.touches ? t.touches[0] : t, r = n.pageX - this.pointX, i = n.pageY - this.pointY;
      if (this.pointX = n.pageX, this.pointY = n.pageY, !this.hooks.trigger(this.hooks.eventTypes.move, {
        deltaX: r,
        deltaY: i,
        e: t
      })) {
        var a = document.documentElement.scrollLeft || window.pageXOffset || document.body.scrollLeft, o = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop, s = this.pointX - a, l = this.pointY - o, u = this.options.autoEndDistance;
        (s > document.documentElement.clientWidth - u || l > document.documentElement.clientHeight - u || s < u || l < u) && this.end(t);
      }
    }
  }, e.prototype.end = function(t) {
    u8[t.type] === this.initiated && (this.setInitiated(), this.beforeHandler(t, "end"), this.hooks.trigger(this.hooks.eventTypes.end, t));
  }, e.prototype.click = function(t) {
    this.hooks.trigger(this.hooks.eventTypes.click, t);
  }, e.prototype.setContent = function(t) {
    t !== this.wrapper && (this.wrapper = t, this.rebindDOMEvents());
  }, e.prototype.rebindDOMEvents = function() {
    this.wrapperEventRegister.destroy(), this.targetEventRegister.destroy(), this.handleDOMEvents();
  }, e.prototype.destroy = function() {
    this.wrapperEventRegister.destroy(), this.targetEventRegister.destroy(), this.hooks.destroy();
  }, e;
}(), d8 = {
  x: ["translateX", "px"],
  y: ["translateY", "px"]
}, s2e = function() {
  function e(t) {
    this.setContent(t), this.hooks = new Xs(["beforeTranslate", "translate"]);
  }
  return e.prototype.getComputedPosition = function() {
    var t = window.getComputedStyle(this.content, null), n = t[Al.transform].split(")")[0].split(", "), r = +(n[12] || n[4]) || 0, i = +(n[13] || n[5]) || 0;
    return {
      x: r,
      y: i
    };
  }, e.prototype.translate = function(t) {
    var n = [];
    Object.keys(t).forEach(function(r) {
      if (!!d8[r]) {
        var i = d8[r][0];
        if (i) {
          var a = d8[r][1], o = t[r];
          n.push(i + "(" + o + a + ")");
        }
      }
    }), this.hooks.trigger(this.hooks.eventTypes.beforeTranslate, n, t), this.style[Al.transform] = n.join(" "), this.hooks.trigger(this.hooks.eventTypes.translate, t);
  }, e.prototype.setContent = function(t) {
    this.content !== t && (this.content = t, this.style = t.style);
  }, e.prototype.destroy = function() {
    this.hooks.destroy();
  }, e;
}(), EC = function() {
  function e(t, n, r) {
    this.translater = n, this.options = r, this.timer = 0, this.hooks = new Xs([
      "move",
      "end",
      "beforeForceStop",
      "forceStop",
      "callStop",
      "time",
      "timeFunction"
    ]), this.setContent(t);
  }
  return e.prototype.translate = function(t) {
    this.translater.translate(t);
  }, e.prototype.setPending = function(t) {
    this.pending = t;
  }, e.prototype.setForceStopped = function(t) {
    this.forceStopped = t;
  }, e.prototype.setCallStop = function(t) {
    this.callStopWhenPending = t;
  }, e.prototype.setContent = function(t) {
    this.content !== t && (this.content = t, this.style = t.style, this.stop());
  }, e.prototype.clearTimer = function() {
    this.timer && (Bl(this.timer), this.timer = 0);
  }, e.prototype.destroy = function() {
    this.hooks.destroy(), Bl(this.timer);
  }, e;
}(), l2e = function(e, t, n, r) {
  var i = function(u, c) {
    var f = u - c, d = f > 0 ? -1 : f < 0 ? 1 : 0;
    return d;
  }, a = i(t.x, e.x), o = i(t.y, e.y), s = n.x - r.x, l = n.y - r.y;
  return a * s <= 0 && o * l <= 0;
}, u2e = function(e) {
  g2(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.startProbe = function(n, r) {
    var i = this, a = n, o = function() {
      var s = i.translater.getComputedPosition();
      l2e(n, r, s, a) && i.hooks.trigger(i.hooks.eventTypes.move, s), i.pending || (i.callStopWhenPending ? i.callStopWhenPending = !1 : i.hooks.trigger(i.hooks.eventTypes.end, s)), a = s, i.pending && (i.timer = SC(o));
    };
    this.callStopWhenPending && this.setCallStop(!1), Bl(this.timer), o();
  }, t.prototype.transitionTime = function(n) {
    n === void 0 && (n = 0), this.style[Al.transitionDuration] = n + "ms", this.hooks.trigger(this.hooks.eventTypes.time, n);
  }, t.prototype.transitionTimingFunction = function(n) {
    this.style[Al.transitionTimingFunction] = n, this.hooks.trigger(this.hooks.eventTypes.timeFunction, n);
  }, t.prototype.transitionProperty = function() {
    this.style[Al.transitionProperty] = Al.transform;
  }, t.prototype.move = function(n, r, i, a) {
    this.setPending(i > 0), this.transitionTimingFunction(a), this.transitionProperty(), this.transitionTime(i), this.translate(r);
    var o = this.options.probeType === 3;
    i && o && this.startProbe(n, r), i || (this._reflow = this.content.offsetHeight, o && this.hooks.trigger(this.hooks.eventTypes.move, r), this.hooks.trigger(this.hooks.eventTypes.end, r));
  }, t.prototype.doStop = function() {
    var n = this.pending;
    if (this.setForceStopped(!1), this.setCallStop(!1), n) {
      this.setPending(!1), Bl(this.timer);
      var r = this.translater.getComputedPosition(), i = r.x, a = r.y;
      this.transitionTime(), this.translate({ x: i, y: a }), this.setForceStopped(!0), this.setCallStop(!0), this.hooks.trigger(this.hooks.eventTypes.forceStop, { x: i, y: a });
    }
    return n;
  }, t.prototype.stop = function() {
    var n = this.doStop();
    n && this.hooks.trigger(this.hooks.eventTypes.callStop);
  }, t;
}(EC), c2e = function(e) {
  g2(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.move = function(n, r, i, a) {
    if (!i) {
      this.translate(r), this.options.probeType === 3 && this.hooks.trigger(this.hooks.eventTypes.move, r), this.hooks.trigger(this.hooks.eventTypes.end, r);
      return;
    }
    this.animate(n, r, i, a);
  }, t.prototype.animate = function(n, r, i, a) {
    var o = this, s = zl(), l = s + i, u = this.options.probeType === 3, c = function() {
      var f = zl();
      if (f >= l) {
        o.translate(r), u && o.hooks.trigger(o.hooks.eventTypes.move, r), o.hooks.trigger(o.hooks.eventTypes.end, r);
        return;
      }
      f = (f - s) / i;
      var d = a(f), h = {};
      Object.keys(r).forEach(function(p) {
        var y = n[p], m = r[p];
        h[p] = (m - y) * d + y;
      }), o.translate(h), u && o.hooks.trigger(o.hooks.eventTypes.move, h), o.pending && (o.timer = SC(c)), o.pending || (o.callStopWhenPending ? o.callStopWhenPending = !1 : o.hooks.trigger(o.hooks.eventTypes.end, r));
    };
    this.setPending(!0), this.callStopWhenPending && this.setCallStop(!1), Bl(this.timer), c();
  }, t.prototype.doStop = function() {
    var n = this.pending;
    if (this.setForceStopped(!1), this.setCallStop(!1), n) {
      this.setPending(!1), Bl(this.timer);
      var r = this.translater.getComputedPosition();
      this.setForceStopped(!0), this.setCallStop(!0), this.hooks.trigger(this.hooks.eventTypes.forceStop, r);
    }
    return n;
  }, t.prototype.stop = function() {
    var n = this.doStop();
    n && this.hooks.trigger(this.hooks.eventTypes.callStop);
  }, t;
}(EC);
function d2e(e, t, n) {
  var r = n.useTransition, i = {};
  return Object.defineProperty(i, "probeType", {
    enumerable: !0,
    configurable: !1,
    get: function() {
      return n.probeType;
    }
  }), r ? new u2e(e, t, i) : new c2e(e, t, i);
}
var N9 = function() {
  function e(t, n, r) {
    this.wrapper = t, this.options = r, this.hooks = new Xs([
      "beforeComputeBoundary",
      "computeBoundary",
      "momentum",
      "end",
      "ignoreHasScroll"
    ]), this.refresh(n);
  }
  return e.prototype.start = function() {
    this.dist = 0, this.setMovingDirection(0), this.setDirection(0);
  }, e.prototype.move = function(t) {
    return t = this.hasScroll ? t : 0, this.setMovingDirection(t), this.performDampingAlgorithm(t, this.options.outOfBoundaryDampingFactor);
  }, e.prototype.setMovingDirection = function(t) {
    this.movingDirection = t > 0 ? -1 : t < 0 ? 1 : 0;
  }, e.prototype.setDirection = function(t) {
    this.direction = t > 0 ? -1 : t < 0 ? 1 : 0;
  }, e.prototype.performDampingAlgorithm = function(t, n) {
    var r = this.currentPos + t;
    return (r > this.minScrollPos || r < this.maxScrollPos) && (r > this.minScrollPos && this.options.bounces[0] || r < this.maxScrollPos && this.options.bounces[1] ? r = this.currentPos + t * n : r = r > this.minScrollPos ? this.minScrollPos : this.maxScrollPos), r;
  }, e.prototype.end = function(t) {
    var n = {
      duration: 0
    }, r = Math.abs(this.currentPos - this.startPos);
    if (this.options.momentum && t < this.options.momentumLimitTime && r > this.options.momentumLimitDistance) {
      var i = this.direction === -1 && this.options.bounces[0] || this.direction === 1 && this.options.bounces[1] ? this.wrapperSize : 0;
      n = this.hasScroll ? this.momentum(this.currentPos, this.startPos, t, this.maxScrollPos, this.minScrollPos, i, this.options) : { destination: this.currentPos, duration: 0 };
    } else
      this.hooks.trigger(this.hooks.eventTypes.end, n);
    return n;
  }, e.prototype.momentum = function(t, n, r, i, a, o, s) {
    s === void 0 && (s = this.options);
    var l = t - n, u = Math.abs(l) / r, c = s.deceleration, f = s.swipeBounceTime, d = s.swipeTime, h = Math.min(d, u * 2 / c), p = {
      destination: t + u * u / c * (l < 0 ? -1 : 1),
      duration: h,
      rate: 15
    };
    return this.hooks.trigger(this.hooks.eventTypes.momentum, p, l), p.destination < i ? (p.destination = o ? Math.max(i - o / 4, i - o / p.rate * u) : i, p.duration = f) : p.destination > a && (p.destination = o ? Math.min(a + o / 4, a + o / p.rate * u) : a, p.duration = f), p.destination = Math.round(p.destination), p;
  }, e.prototype.updateDirection = function() {
    var t = this.currentPos - this.absStartPos;
    this.setDirection(t);
  }, e.prototype.refresh = function(t) {
    var n = this.options.rect, r = n.size, i = n.position, a = window.getComputedStyle(this.wrapper, null).position === "static", o = L9(this.wrapper);
    this.wrapperSize = this.wrapper[r === "width" ? "clientWidth" : "clientHeight"], this.setContent(t);
    var s = L9(this.content);
    this.contentSize = s[r], this.relativeOffset = s[i], a && (this.relativeOffset -= o[i]), this.computeBoundary(), this.setDirection(0);
  }, e.prototype.setContent = function(t) {
    t !== this.content && (this.content = t, this.resetState());
  }, e.prototype.resetState = function() {
    this.currentPos = 0, this.startPos = 0, this.dist = 0, this.setDirection(0), this.setMovingDirection(0), this.resetStartPos();
  }, e.prototype.computeBoundary = function() {
    this.hooks.trigger(this.hooks.eventTypes.beforeComputeBoundary);
    var t = {
      minScrollPos: 0,
      maxScrollPos: this.wrapperSize - this.contentSize
    };
    t.maxScrollPos < 0 && (t.maxScrollPos -= this.relativeOffset, this.options.specifiedIndexAsContent === 0 && (t.minScrollPos = -this.relativeOffset)), this.hooks.trigger(this.hooks.eventTypes.computeBoundary, t), this.minScrollPos = t.minScrollPos, this.maxScrollPos = t.maxScrollPos, this.hasScroll = this.options.scrollable && this.maxScrollPos < this.minScrollPos, !this.hasScroll && this.minScrollPos < this.maxScrollPos && (this.maxScrollPos = this.minScrollPos, this.contentSize = this.wrapperSize);
  }, e.prototype.updatePosition = function(t) {
    this.currentPos = t;
  }, e.prototype.getCurrentPos = function() {
    return this.currentPos;
  }, e.prototype.checkInBoundary = function() {
    var t = this.adjustPosition(this.currentPos), n = t === this.getCurrentPos();
    return {
      position: t,
      inBoundary: n
    };
  }, e.prototype.adjustPosition = function(t) {
    return !this.hasScroll && !this.hooks.trigger(this.hooks.eventTypes.ignoreHasScroll) ? t = this.minScrollPos : t > this.minScrollPos ? t = this.minScrollPos : t < this.maxScrollPos && (t = this.maxScrollPos), t;
  }, e.prototype.updateStartPos = function() {
    this.startPos = this.currentPos;
  }, e.prototype.updateAbsStartPos = function() {
    this.absStartPos = this.currentPos;
  }, e.prototype.resetStartPos = function() {
    this.updateStartPos(), this.updateAbsStartPos();
  }, e.prototype.getAbsDist = function(t) {
    return this.dist += t, Math.abs(this.dist);
  }, e.prototype.destroy = function() {
    this.hooks.destroy();
  }, e;
}(), L1, B1, N1, j1, j9 = (L1 = {}, L1.yes = function(e) {
  return !0;
}, L1.no = function(e) {
  return e.preventDefault(), !1;
}, L1), f2e = (B1 = {}, B1.horizontal = (N1 = {}, N1.yes = "horizontal", N1.no = "vertical", N1), B1.vertical = (j1 = {}, j1.yes = "vertical", j1.no = "horizontal", j1), B1), h2e = function() {
  function e(t, n, r) {
    this.directionLockThreshold = t, this.freeScroll = n, this.eventPassthrough = r, this.reset();
  }
  return e.prototype.reset = function() {
    this.directionLocked = "";
  }, e.prototype.checkMovingDirection = function(t, n, r) {
    return this.computeDirectionLock(t, n), this.handleEventPassthrough(r);
  }, e.prototype.adjustDelta = function(t, n) {
    return this.directionLocked === "horizontal" ? n = 0 : this.directionLocked === "vertical" && (t = 0), {
      deltaX: t,
      deltaY: n
    };
  }, e.prototype.computeDirectionLock = function(t, n) {
    this.directionLocked === "" && !this.freeScroll && (t > n + this.directionLockThreshold ? this.directionLocked = "horizontal" : n >= t + this.directionLockThreshold ? this.directionLocked = "vertical" : this.directionLocked = "none");
  }, e.prototype.handleEventPassthrough = function(t) {
    var n = f2e[this.directionLocked];
    if (n) {
      if (this.eventPassthrough === n.yes)
        return j9.yes(t);
      if (this.eventPassthrough === n.no)
        return j9.no(t);
    }
    return !1;
  }, e;
}(), p2e = function(e, t, n) {
  return n === 2 ? [t, -e] : n === 3 ? [-e, -t] : n === 4 ? [-t, e] : [e, t];
}, v2e = function() {
  function e(t, n, r, i, a) {
    this.hooks = new Xs([
      "start",
      "beforeMove",
      "scrollStart",
      "scroll",
      "beforeEnd",
      "end",
      "scrollEnd",
      "contentNotMoved",
      "detectMovingDirection",
      "coordinateTransformation"
    ]), this.scrollBehaviorX = t, this.scrollBehaviorY = n, this.actionsHandler = r, this.animater = i, this.options = a, this.directionLockAction = new h2e(a.directionLockThreshold, a.freeScroll, a.eventPassthrough), this.enabled = !0, this.bindActionsHandler();
  }
  return e.prototype.bindActionsHandler = function() {
    var t = this;
    this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.start, function(n) {
      return t.enabled ? t.handleStart(n) : !0;
    }), this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.move, function(n) {
      var r = n.deltaX, i = n.deltaY, a = n.e;
      if (!t.enabled)
        return !0;
      var o = p2e(r, i, t.options.quadrant), s = o[0], l = o[1], u = {
        deltaX: s,
        deltaY: l
      };
      return t.hooks.trigger(t.hooks.eventTypes.coordinateTransformation, u), t.handleMove(u.deltaX, u.deltaY, a);
    }), this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.end, function(n) {
      return t.enabled ? t.handleEnd(n) : !0;
    }), this.actionsHandler.hooks.on(this.actionsHandler.hooks.eventTypes.click, function(n) {
      t.enabled && !n._constructed && t.handleClick(n);
    });
  }, e.prototype.handleStart = function(t) {
    var n = zl();
    this.fingerMoved = !1, this.contentMoved = !1, this.startTime = n, this.directionLockAction.reset(), this.scrollBehaviorX.start(), this.scrollBehaviorY.start(), this.animater.doStop(), this.scrollBehaviorX.resetStartPos(), this.scrollBehaviorY.resetStartPos(), this.hooks.trigger(this.hooks.eventTypes.start, t);
  }, e.prototype.handleMove = function(t, n, r) {
    if (!this.hooks.trigger(this.hooks.eventTypes.beforeMove, r)) {
      var i = this.scrollBehaviorX.getAbsDist(t), a = this.scrollBehaviorY.getAbsDist(n), o = zl();
      if (this.checkMomentum(i, a, o))
        return !0;
      if (this.directionLockAction.checkMovingDirection(i, a, r))
        return this.actionsHandler.setInitiated(), !0;
      var s = this.directionLockAction.adjustDelta(t, n), l = this.scrollBehaviorX.getCurrentPos(), u = this.scrollBehaviorX.move(s.deltaX), c = this.scrollBehaviorY.getCurrentPos(), f = this.scrollBehaviorY.move(s.deltaY);
      if (!this.hooks.trigger(this.hooks.eventTypes.detectMovingDirection)) {
        this.fingerMoved || (this.fingerMoved = !0);
        var d = u !== l || f !== c;
        !this.contentMoved && !d && this.hooks.trigger(this.hooks.eventTypes.contentNotMoved), !this.contentMoved && d && (this.contentMoved = !0, this.hooks.trigger(this.hooks.eventTypes.scrollStart)), this.contentMoved && d && (this.animater.translate({
          x: u,
          y: f
        }), this.dispatchScroll(o));
      }
    }
  }, e.prototype.dispatchScroll = function(t) {
    t - this.startTime > this.options.momentumLimitTime && (this.startTime = t, this.scrollBehaviorX.updateStartPos(), this.scrollBehaviorY.updateStartPos(), this.options.probeType === 1 && this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos())), this.options.probeType > 1 && this.hooks.trigger(this.hooks.eventTypes.scroll, this.getCurrentPos());
  }, e.prototype.checkMomentum = function(t, n, r) {
    return r - this.endTime > this.options.momentumLimitTime && n < this.options.momentumLimitDistance && t < this.options.momentumLimitDistance;
  }, e.prototype.handleEnd = function(t) {
    if (!this.hooks.trigger(this.hooks.eventTypes.beforeEnd, t)) {
      var n = this.getCurrentPos();
      if (this.scrollBehaviorX.updateDirection(), this.scrollBehaviorY.updateDirection(), this.hooks.trigger(this.hooks.eventTypes.end, t, n))
        return !0;
      n = this.ensureIntegerPos(n), this.animater.translate(n), this.endTime = zl();
      var r = this.endTime - this.startTime;
      this.hooks.trigger(this.hooks.eventTypes.scrollEnd, n, r);
    }
  }, e.prototype.ensureIntegerPos = function(t) {
    this.ensuringInteger = !0;
    var n = t.x, r = t.y, i = this.scrollBehaviorX, a = i.minScrollPos, o = i.maxScrollPos, s = this.scrollBehaviorY, l = s.minScrollPos, u = s.maxScrollPos;
    return n = n > 0 ? Math.ceil(n) : Math.floor(n), r = r > 0 ? Math.ceil(r) : Math.floor(r), n = M9(n, o, a), r = M9(r, u, l), { x: n, y: r };
  }, e.prototype.handleClick = function(t) {
    of(t.target, this.options.preventDefaultException) || (t.preventDefault(), t.stopPropagation());
  }, e.prototype.getCurrentPos = function() {
    return {
      x: this.scrollBehaviorX.getCurrentPos(),
      y: this.scrollBehaviorY.getCurrentPos()
    };
  }, e.prototype.refresh = function() {
    this.endTime = 0;
  }, e.prototype.destroy = function() {
    this.hooks.destroy();
  }, e;
}();
function m2e(e) {
  var t = [
    "click",
    "bindToWrapper",
    "disableMouse",
    "disableTouch",
    "preventDefault",
    "stopPropagation",
    "tagException",
    "preventDefaultException",
    "autoEndDistance"
  ].reduce(function(n, r) {
    return n[r] = e[r], n;
  }, {});
  return t;
}
function F9(e, t, n, r) {
  var i = [
    "momentum",
    "momentumLimitTime",
    "momentumLimitDistance",
    "deceleration",
    "swipeBounceTime",
    "swipeTime",
    "outOfBoundaryDampingFactor",
    "specifiedIndexAsContent"
  ].reduce(function(a, o) {
    return a[o] = e[o], a;
  }, {});
  return i.scrollable = !!e[t], i.bounces = n, i.rect = r, i;
}
function U4(e, t, n) {
  n.forEach(function(r) {
    var i, a;
    typeof r == "string" ? i = a = r : (i = r.source, a = r.target), e.on(i, function() {
      for (var o = [], s = 0; s < arguments.length; s++)
        o[s] = arguments[s];
      return t.trigger.apply(t, AC([a], o));
    });
  });
}
function g2e(e, t) {
  for (var n = Object.keys(e), r = 0, i = n; r < i.length; r++) {
    var a = i[r];
    if (e[a] !== t[a])
      return !1;
  }
  return !0;
}
var X9 = 1, y2e = function() {
  function e(t, n, r) {
    this.wrapper = t, this.content = n, this.resizeTimeout = 0, this.hooks = new Xs([
      "beforeStart",
      "beforeMove",
      "beforeScrollStart",
      "scrollStart",
      "scroll",
      "beforeEnd",
      "scrollEnd",
      "resize",
      "touchEnd",
      "end",
      "flick",
      "scrollCancel",
      "momentum",
      "scrollTo",
      "minDistanceScroll",
      "scrollToElement",
      "beforeRefresh"
    ]), this.options = r;
    var i = this.options.bounce, a = i.left, o = i.right, s = i.top, l = i.bottom;
    this.scrollBehaviorX = new N9(t, n, F9(r, "scrollX", [a, o], {
      size: "width",
      position: "left"
    })), this.scrollBehaviorY = new N9(t, n, F9(r, "scrollY", [s, l], {
      size: "height",
      position: "top"
    })), this.translater = new s2e(this.content), this.animater = d2e(this.content, this.translater, this.options), this.actionsHandler = new o2e(this.options.bindToTarget ? this.content : t, m2e(this.options)), this.actions = new v2e(this.scrollBehaviorX, this.scrollBehaviorY, this.actionsHandler, this.animater, this.options);
    var u = this.resize.bind(this);
    this.resizeRegister = new Th(window, [
      {
        name: "orientationchange",
        handler: u
      },
      {
        name: "resize",
        handler: u
      }
    ]), this.registerTransitionEnd(), this.init();
  }
  return e.prototype.init = function() {
    var t = this;
    this.bindTranslater(), this.bindAnimater(), this.bindActions(), this.hooks.on(this.hooks.eventTypes.scrollEnd, function() {
      t.togglePointerEvents(!0);
    });
  }, e.prototype.registerTransitionEnd = function() {
    this.transitionEndRegister = new Th(this.content, [
      {
        name: Al.transitionEnd,
        handler: this.transitionEnd.bind(this)
      }
    ]);
  }, e.prototype.bindTranslater = function() {
    var t = this, n = this.translater.hooks;
    n.on(n.eventTypes.beforeTranslate, function(r) {
      t.options.translateZ && r.push(t.options.translateZ);
    }), n.on(n.eventTypes.translate, function(r) {
      var i = t.getCurrentPos();
      if (t.updatePositions(r), t.actions.ensuringInteger === !0) {
        t.actions.ensuringInteger = !1;
        return;
      }
      (r.x !== i.x || r.y !== i.y) && t.togglePointerEvents(!1);
    });
  }, e.prototype.bindAnimater = function() {
    var t = this;
    this.animater.hooks.on(this.animater.hooks.eventTypes.end, function(n) {
      t.resetPosition(t.options.bounceTime) || (t.animater.setPending(!1), t.hooks.trigger(t.hooks.eventTypes.scrollEnd, n));
    }), U4(this.animater.hooks, this.hooks, [
      {
        source: this.animater.hooks.eventTypes.move,
        target: this.hooks.eventTypes.scroll
      },
      {
        source: this.animater.hooks.eventTypes.forceStop,
        target: this.hooks.eventTypes.scrollEnd
      }
    ]);
  }, e.prototype.bindActions = function() {
    var t = this, n = this.actions;
    U4(n.hooks, this.hooks, [
      {
        source: n.hooks.eventTypes.start,
        target: this.hooks.eventTypes.beforeStart
      },
      {
        source: n.hooks.eventTypes.start,
        target: this.hooks.eventTypes.beforeScrollStart
      },
      {
        source: n.hooks.eventTypes.beforeMove,
        target: this.hooks.eventTypes.beforeMove
      },
      {
        source: n.hooks.eventTypes.scrollStart,
        target: this.hooks.eventTypes.scrollStart
      },
      {
        source: n.hooks.eventTypes.scroll,
        target: this.hooks.eventTypes.scroll
      },
      {
        source: n.hooks.eventTypes.beforeEnd,
        target: this.hooks.eventTypes.beforeEnd
      }
    ]), n.hooks.on(n.hooks.eventTypes.end, function(r, i) {
      if (t.hooks.trigger(t.hooks.eventTypes.touchEnd, i), t.hooks.trigger(t.hooks.eventTypes.end, i) || !n.fingerMoved && (t.hooks.trigger(t.hooks.eventTypes.scrollCancel), t.checkClick(r)))
        return !0;
      if (t.resetPosition(t.options.bounceTime, sl.bounce))
        return t.animater.setForceStopped(!1), !0;
    }), n.hooks.on(n.hooks.eventTypes.scrollEnd, function(r, i) {
      var a = Math.abs(r.x - t.scrollBehaviorX.startPos), o = Math.abs(r.y - t.scrollBehaviorY.startPos);
      if (t.checkFlick(i, a, o)) {
        t.animater.setForceStopped(!1), t.hooks.trigger(t.hooks.eventTypes.flick);
        return;
      }
      if (t.momentum(r, i)) {
        t.animater.setForceStopped(!1);
        return;
      }
      n.contentMoved && t.hooks.trigger(t.hooks.eventTypes.scrollEnd, r), t.animater.forceStopped && t.animater.setForceStopped(!1);
    });
  }, e.prototype.checkFlick = function(t, n, r) {
    var i = 1;
    if (this.hooks.events.flick.length > 1 && t < this.options.flickLimitTime && n < this.options.flickLimitDistance && r < this.options.flickLimitDistance && (r > i || n > i))
      return !0;
  }, e.prototype.momentum = function(t, n) {
    var r = {
      time: 0,
      easing: sl.swiper,
      newX: t.x,
      newY: t.y
    }, i = this.scrollBehaviorX.end(n), a = this.scrollBehaviorY.end(n);
    if (r.newX = V4(i.destination) ? r.newX : i.destination, r.newY = V4(a.destination) ? r.newY : a.destination, r.time = Math.max(i.duration, a.duration), this.hooks.trigger(this.hooks.eventTypes.momentum, r, this), r.newX !== t.x || r.newY !== t.y)
      return (r.newX > this.scrollBehaviorX.minScrollPos || r.newX < this.scrollBehaviorX.maxScrollPos || r.newY > this.scrollBehaviorY.minScrollPos || r.newY < this.scrollBehaviorY.maxScrollPos) && (r.easing = sl.swipeBounce), this.scrollTo(r.newX, r.newY, r.time, r.easing), !0;
  }, e.prototype.checkClick = function(t) {
    var n = {
      preventClick: this.animater.forceStopped
    };
    if (this.hooks.trigger(this.hooks.eventTypes.checkClick))
      return this.animater.setForceStopped(!1), !0;
    if (!n.preventClick) {
      var r = this.options.dblclick, i = !1;
      if (r && this.lastClickTime) {
        var a = r.delay, o = a === void 0 ? 300 : a;
        zl() - this.lastClickTime < o && (i = !0, $he(t));
      }
      return this.options.tap && Jhe(t, this.options.tap), this.options.click && !of(t.target, this.options.preventDefaultException) && xC(t), this.lastClickTime = i ? null : zl(), !0;
    }
    return !1;
  }, e.prototype.resize = function() {
    var t = this;
    !this.actions.enabled || (Uhe && (this.wrapper.scrollTop = 0), clearTimeout(this.resizeTimeout), this.resizeTimeout = window.setTimeout(function() {
      t.hooks.trigger(t.hooks.eventTypes.resize);
    }, this.options.resizePolling));
  }, e.prototype.transitionEnd = function(t) {
    if (!(t.target !== this.content || !this.animater.pending)) {
      var n = this.animater;
      n.transitionTime(), this.resetPosition(this.options.bounceTime, sl.bounce) || (this.animater.setPending(!1), this.options.probeType !== 3 && this.hooks.trigger(this.hooks.eventTypes.scrollEnd, this.getCurrentPos()));
    }
  }, e.prototype.togglePointerEvents = function(t) {
    t === void 0 && (t = !0);
    for (var n = this.content.children.length ? this.content.children : [this.content], r = t ? "auto" : "none", i = 0; i < n.length; i++) {
      var a = n[i];
      a.isBScrollContainer || (a.style.pointerEvents = r);
    }
  }, e.prototype.refresh = function(t) {
    var n = this.setContent(t);
    this.hooks.trigger(this.hooks.eventTypes.beforeRefresh), this.scrollBehaviorX.refresh(t), this.scrollBehaviorY.refresh(t), n && (this.translater.setContent(t), this.animater.setContent(t), this.transitionEndRegister.destroy(), this.registerTransitionEnd(), this.options.bindToTarget && this.actionsHandler.setContent(t)), this.actions.refresh(), this.wrapperOffset = H9(this.wrapper);
  }, e.prototype.setContent = function(t) {
    var n = t !== this.content;
    return n && (this.content = t), n;
  }, e.prototype.scrollBy = function(t, n, r, i) {
    r === void 0 && (r = 0);
    var a = this.getCurrentPos(), o = a.x, s = a.y;
    i = i || sl.bounce, t += o, n += s, this.scrollTo(t, n, r, i);
  }, e.prototype.scrollTo = function(t, n, r, i, a) {
    r === void 0 && (r = 0), i === void 0 && (i = sl.bounce), a === void 0 && (a = {
      start: {},
      end: {}
    });
    var o = this.options.useTransition ? i.style : i.fn, s = this.getCurrentPos(), l = af({ x: s.x, y: s.y }, a.start), u = af({
      x: t,
      y: n
    }, a.end);
    if (this.hooks.trigger(this.hooks.eventTypes.scrollTo, u), !g2e(l, u)) {
      var c = Math.abs(u.x - l.x), f = Math.abs(u.y - l.y);
      c < X9 && f < X9 && (r = 0, this.hooks.trigger(this.hooks.eventTypes.minDistanceScroll)), this.animater.move(l, u, r, o);
    }
  }, e.prototype.scrollToElement = function(t, n, r, i, a) {
    var o = wC(t), s = H9(o), l = function(c, f, d) {
      return typeof c == "number" ? c : c ? Math.round(f / 2 - d / 2) : 0;
    };
    r = l(r, o.offsetWidth, this.wrapper.offsetWidth), i = l(i, o.offsetHeight, this.wrapper.offsetHeight);
    var u = function(c, f, d, h) {
      return c -= f, c = h.adjustPosition(c - d), c;
    };
    s.left = u(s.left, this.wrapperOffset.left, r, this.scrollBehaviorX), s.top = u(s.top, this.wrapperOffset.top, i, this.scrollBehaviorY), !this.hooks.trigger(this.hooks.eventTypes.scrollToElement, o, s) && this.scrollTo(s.left, s.top, n, a);
  }, e.prototype.resetPosition = function(t, n) {
    t === void 0 && (t = 0), n === void 0 && (n = sl.bounce);
    var r = this.scrollBehaviorX.checkInBoundary(), i = r.position, a = r.inBoundary, o = this.scrollBehaviorY.checkInBoundary(), s = o.position, l = o.inBoundary;
    return a && l ? !1 : (qhe && this.reflow(), this.scrollTo(i, s, t, n), !0);
  }, e.prototype.reflow = function() {
    this._reflow = this.content.offsetHeight;
  }, e.prototype.updatePositions = function(t) {
    this.scrollBehaviorX.updatePosition(t.x), this.scrollBehaviorY.updatePosition(t.y);
  }, e.prototype.getCurrentPos = function() {
    return this.actions.getCurrentPos();
  }, e.prototype.enable = function() {
    this.actions.enabled = !0;
  }, e.prototype.disable = function() {
    Bl(this.animater.timer), this.actions.enabled = !1;
  }, e.prototype.destroy = function() {
    var t = this, n = [
      "resizeRegister",
      "transitionEndRegister",
      "actionsHandler",
      "actions",
      "hooks",
      "animater",
      "translater",
      "scrollBehaviorX",
      "scrollBehaviorY"
    ];
    n.forEach(function(r) {
      return t[r].destroy();
    });
  }, e;
}(), y2 = function(e) {
  g2(t, e);
  function t(n, r) {
    var i = e.call(this, [
      "refresh",
      "contentChanged",
      "enable",
      "disable",
      "beforeScrollStart",
      "scrollStart",
      "scroll",
      "scrollEnd",
      "scrollCancel",
      "touchEnd",
      "flick",
      "destroy"
    ]) || this, a = wC(n);
    return a ? (i.plugins = {}, i.options = new a2e().merge(r).process(), i.setContent(a).valid && (i.hooks = new Xs([
      "refresh",
      "enable",
      "disable",
      "destroy",
      "beforeInitialScrollTo",
      "contentChanged"
    ]), i.init(a)), i) : (C0("Can not resolve the wrapper DOM."), i);
  }
  return t.use = function(n) {
    var r = n.pluginName, i = t.plugins.some(function(a) {
      return n === a.ctor;
    });
    return i ? t : V4(r) ? (C0("Plugin Class must specify plugin's name in static property by 'pluginName' field."), t) : (t.pluginsMap[r] = !0, t.plugins.push({
      name: r,
      applyOrder: n.applyOrder,
      ctor: n
    }), t);
  }, t.prototype.setContent = function(n) {
    var r = !1, i = !0, a = n.children[this.options.specifiedIndexAsContent];
    return a ? (r = this.content !== a, r && (this.content = a)) : (C0("The wrapper need at least one child element to be content element to scroll."), i = !1), {
      valid: i,
      contentChanged: r
    };
  }, t.prototype.init = function(n) {
    var r = this;
    this.wrapper = n, n.isBScrollContainer = !0, this.scroller = new y2e(n, this.content, this.options), this.scroller.hooks.on(this.scroller.hooks.eventTypes.resize, function() {
      r.refresh();
    }), this.eventBubbling(), this.handleAutoBlur(), this.enable(), this.proxy(Rhe), this.applyPlugins(), this.refreshWithoutReset(this.content);
    var i = this.options, a = i.startX, o = i.startY, s = {
      x: a,
      y: o
    };
    this.hooks.trigger(this.hooks.eventTypes.beforeInitialScrollTo, s) || this.scroller.scrollTo(s.x, s.y);
  }, t.prototype.applyPlugins = function() {
    var n = this, r = this.options;
    t.plugins.sort(function(i, a) {
      var o, s = (o = {}, o.pre = -1, o.post = 1, o), l = i.applyOrder ? s[i.applyOrder] : 0, u = a.applyOrder ? s[a.applyOrder] : 0;
      return l - u;
    }).forEach(function(i) {
      var a = i.ctor;
      r[i.name] && typeof a == "function" && (n.plugins[i.name] = new a(n));
    });
  }, t.prototype.handleAutoBlur = function() {
    this.options.autoBlur && this.on(this.eventTypes.beforeScrollStart, function() {
      var n = document.activeElement;
      n && (n.tagName === "INPUT" || n.tagName === "TEXTAREA") && n.blur();
    });
  }, t.prototype.eventBubbling = function() {
    U4(this.scroller.hooks, this, [
      this.eventTypes.beforeScrollStart,
      this.eventTypes.scrollStart,
      this.eventTypes.scroll,
      this.eventTypes.scrollEnd,
      this.eventTypes.scrollCancel,
      this.eventTypes.touchEnd,
      this.eventTypes.flick
    ]);
  }, t.prototype.refreshWithoutReset = function(n) {
    this.scroller.refresh(n), this.hooks.trigger(this.hooks.eventTypes.refresh, n), this.trigger(this.eventTypes.refresh, n);
  }, t.prototype.proxy = function(n) {
    var r = this;
    n.forEach(function(i) {
      var a = i.key, o = i.sourceKey;
      i2e(r, o, a);
    });
  }, t.prototype.refresh = function() {
    var n = this.setContent(this.wrapper), r = n.contentChanged, i = n.valid;
    if (i) {
      var a = this.content;
      this.refreshWithoutReset(a), r && (this.hooks.trigger(this.hooks.eventTypes.contentChanged, a), this.trigger(this.eventTypes.contentChanged, a)), this.scroller.resetPosition();
    }
  }, t.prototype.enable = function() {
    this.scroller.enable(), this.hooks.trigger(this.hooks.eventTypes.enable), this.trigger(this.eventTypes.enable);
  }, t.prototype.disable = function() {
    this.scroller.disable(), this.hooks.trigger(this.hooks.eventTypes.disable), this.trigger(this.eventTypes.disable);
  }, t.prototype.destroy = function() {
    this.hooks.trigger(this.hooks.eventTypes.destroy), this.trigger(this.eventTypes.destroy), this.scroller.destroy();
  }, t.prototype.eventRegister = function(n) {
    this.registerType(n);
  }, t.plugins = [], t.pluginsMap = {}, t;
}(Xs);
function b2(e, t) {
  var n = new y2(e, t);
  return n;
}
b2.use = y2.use;
b2.plugins = y2.plugins;
b2.pluginsMap = y2.pluginsMap;
var A2 = b2;
/*!
 * better-scroll / pull-down
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
var Bf = typeof window < "u", cc = Bf && navigator.userAgent.toLowerCase();
cc && /wechatdevtools/.test(cc);
cc && cc.indexOf("android") > 0;
(function() {
  if (typeof cc == "string") {
    var e = /os (\d\d?_\d(_\d)?)/, t = e.exec(cc);
    if (!t)
      return !1;
    var n = t[1].split("_").map(function(r) {
      return parseInt(r, 10);
    });
    return n[0] === 13 && n[1] >= 4;
  }
  return !1;
})();
var b2e = !1;
if (Bf) {
  var A2e = "test-passive";
  try {
    var R9 = {};
    Object.defineProperty(R9, "passive", {
      get: function() {
        b2e = !0;
      }
    }), window.addEventListener(A2e, function() {
    }, R9);
  } catch {
  }
}
var T2e = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, kC = Bf && document.createElement("div").style, Fu = function() {
  if (!Bf)
    return !1;
  for (var e = [
    {
      key: "standard",
      value: "transform"
    },
    {
      key: "webkit",
      value: "webkitTransform"
    },
    {
      key: "Moz",
      value: "MozTransform"
    },
    {
      key: "O",
      value: "OTransform"
    },
    {
      key: "ms",
      value: "msTransform"
    }
  ], t = 0, n = e; t < n.length; t++) {
    var r = n[t];
    if (kC[r.value] !== void 0)
      return r.key;
  }
  return !1;
}();
function zo(e) {
  return Fu === !1 ? e : Fu === "standard" ? e === "transitionEnd" ? "transitionend" : e : Fu + e.charAt(0).toUpperCase() + e.substr(1);
}
Fu && Fu !== "standard" && "" + Fu.toLowerCase();
var w2e = zo("transform"), P2e = zo("transition");
Bf && zo("perspective") in kC;
zo("transitionTimingFunction"), zo("transitionDuration"), zo("transitionDelay"), zo("transformOrigin"), zo("transitionEnd"), zo("transitionProperty");
var f8 = {
  swipe: {
    style: "cubic-bezier(0.23, 1, 0.32, 1)",
    fn: function(e) {
      return 1 + --e * e * e * e * e;
    }
  },
  swipeBounce: {
    style: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    fn: function(e) {
      return e * (2 - e);
    }
  },
  bounce: {
    style: "cubic-bezier(0.165, 0.84, 0.44, 1)",
    fn: function(e) {
      return 1 - --e * e * e * e;
    }
  }
}, x2e = "plugins.pullDownRefresh", C2e = [
  {
    key: "finishPullDown",
    name: "finishPullDown"
  },
  {
    key: "openPullDown",
    name: "openPullDown"
  },
  {
    key: "closePullDown",
    name: "closePullDown"
  },
  {
    key: "autoPullDownRefresh",
    name: "autoPullDownRefresh"
  }
], S2e = C2e.map(function(e) {
  return {
    key: e.key,
    sourceKey: x2e + "." + e.name
  };
}), h8 = "pullingDown", V9 = "enterThreshold", U9 = "leaveThreshold", E2e = function() {
  function e(t) {
    this.scroll = t, this.pulling = 0, this.thresholdBoundary = 0, this.init();
  }
  return e.prototype.setPulling = function(t) {
    this.pulling = t;
  }, e.prototype.setThresholdBoundary = function(t) {
    this.thresholdBoundary = t;
  }, e.prototype.init = function() {
    this.handleBScroll(), this.handleOptions(this.scroll.options.pullDownRefresh), this.handleHooks(), this.watch();
  }, e.prototype.handleBScroll = function() {
    this.scroll.registerType([
      h8,
      V9,
      U9
    ]), this.scroll.proxy(S2e);
  }, e.prototype.handleOptions = function(t) {
    t === void 0 && (t = {}), t = t === !0 ? {} : t;
    var n = {
      threshold: 90,
      stop: 40
    };
    this.options = T2e(n, t), this.scroll.options.probeType = 3;
  }, e.prototype.handleHooks = function() {
    var t = this;
    this.hooksFn = [];
    var n = this.scroll.scroller, r = n.scrollBehaviorY;
    this.currentMinScrollY = this.cachedOriginanMinScrollY = r.minScrollPos, this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.contentChanged, function() {
      t.finishPullDown();
    }), this.registerHooks(r.hooks, r.hooks.eventTypes.computeBoundary, function(i) {
      i.maxScrollPos > 0 && (i.maxScrollPos = -1), i.minScrollPos = t.currentMinScrollY;
    }), this.hasMouseWheelPlugin() && (this.registerHooks(this.scroll, this.scroll.eventTypes.alterOptions, function(i) {
      var a = 300, o = 350;
      i.discreteTime = a, i.easeTime = o;
    }), this.registerHooks(this.scroll, this.scroll.eventTypes.mousewheelEnd, function() {
      n.hooks.trigger(n.hooks.eventTypes.end);
    }));
  }, e.prototype.registerHooks = function(t, n, r) {
    t.on(n, r, this), this.hooksFn.push([t, n, r]);
  }, e.prototype.hasMouseWheelPlugin = function() {
    return !!this.scroll.eventTypes.alterOptions;
  }, e.prototype.watch = function() {
    var t = this.scroll.scroller;
    this.watching = !0, this.registerHooks(t.hooks, t.hooks.eventTypes.end, this.checkPullDown), this.registerHooks(this.scroll, this.scroll.eventTypes.scrollStart, this.resetStateBeforeScrollStart), this.registerHooks(this.scroll, this.scroll.eventTypes.scroll, this.checkLocationOfThresholdBoundary), this.hasMouseWheelPlugin() && this.registerHooks(this.scroll, this.scroll.eventTypes.mousewheelStart, this.resetStateBeforeScrollStart);
  }, e.prototype.resetStateBeforeScrollStart = function() {
    this.isFetchingStatus() || (this.setPulling(1), this.setThresholdBoundary(0));
  }, e.prototype.checkLocationOfThresholdBoundary = function() {
    if (this.pulling === 1) {
      var t = this.scroll, n = this.thresholdBoundary !== 1 && this.locateInsideThresholdBoundary(), r = this.thresholdBoundary !== 2 && !this.locateInsideThresholdBoundary();
      n && (this.setThresholdBoundary(1), t.trigger(V9)), r && (this.setThresholdBoundary(2), t.trigger(U9));
    }
  }, e.prototype.locateInsideThresholdBoundary = function() {
    return this.scroll.y <= this.options.threshold;
  }, e.prototype.unwatch = function() {
    var t = this.scroll, n = t.scroller;
    this.watching = !1, n.hooks.off(n.hooks.eventTypes.end, this.checkPullDown), t.off(t.eventTypes.scrollStart, this.resetStateBeforeScrollStart), t.off(t.eventTypes.scroll, this.checkLocationOfThresholdBoundary), this.hasMouseWheelPlugin() && t.off(t.eventTypes.mousewheelStart, this.resetStateBeforeScrollStart);
  }, e.prototype.checkPullDown = function() {
    var t = this.options, n = t.threshold, r = t.stop;
    return this.scroll.y < n ? !1 : (this.pulling === 1 && (this.modifyBehaviorYBoundary(r), this.setPulling(2), this.scroll.trigger(h8)), this.scroll.scrollTo(this.scroll.x, r, this.scroll.options.bounceTime, f8.bounce), this.isFetchingStatus());
  }, e.prototype.isFetchingStatus = function() {
    return this.pulling === 2;
  }, e.prototype.modifyBehaviorYBoundary = function(t) {
    var n = this.scroll.scroller.scrollBehaviorY;
    this.cachedOriginanMinScrollY = n.minScrollPos, this.currentMinScrollY = t, n.computeBoundary();
  }, e.prototype.finishPullDown = function() {
    if (this.isFetchingStatus()) {
      var t = this.scroll.scroller.scrollBehaviorY;
      this.currentMinScrollY = this.cachedOriginanMinScrollY, t.computeBoundary(), this.setPulling(0), this.scroll.resetPosition(this.scroll.options.bounceTime, f8.bounce);
    }
  }, e.prototype.openPullDown = function(t) {
    t === void 0 && (t = {}), this.handleOptions(t), this.watching || this.watch();
  }, e.prototype.closePullDown = function() {
    this.unwatch();
  }, e.prototype.autoPullDownRefresh = function() {
    var t = this.options, n = t.threshold, r = t.stop;
    this.isFetchingStatus() || !this.watching || (this.modifyBehaviorYBoundary(r), this.scroll.trigger(this.scroll.eventTypes.scrollStart), this.scroll.scrollTo(this.scroll.x, n), this.setPulling(2), this.scroll.trigger(h8), this.scroll.scrollTo(this.scroll.x, r, this.scroll.options.bounceTime, f8.bounce));
  }, e.pluginName = "pullDownRefresh", e;
}();
/*!
 * better-scroll / mouse-wheel
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
function k2e(e) {
  console.error("[BScroll warn]: " + e);
}
var Nf = typeof window < "u", dc = Nf && navigator.userAgent.toLowerCase();
dc && /wechatdevtools/.test(dc);
dc && dc.indexOf("android") > 0;
(function() {
  if (typeof dc == "string") {
    var e = /os (\d\d?_\d(_\d)?)/, t = e.exec(dc);
    if (!t)
      return !1;
    var n = t[1].split("_").map(function(r) {
      return parseInt(r, 10);
    });
    return n[0] === 13 && n[1] >= 4;
  }
  return !1;
})();
var OC = !1;
if (Nf) {
  var O2e = "test-passive";
  try {
    var q9 = {};
    Object.defineProperty(q9, "passive", {
      get: function() {
        OC = !0;
      }
    }), window.addEventListener(O2e, function() {
    }, q9);
  } catch {
  }
}
var z2e = function(e, t) {
  for (var n in t)
    e[n] = t[n];
  return e;
}, zC = Nf && document.createElement("div").style, Xu = function() {
  if (!Nf)
    return !1;
  for (var e = [
    {
      key: "standard",
      value: "transform"
    },
    {
      key: "webkit",
      value: "webkitTransform"
    },
    {
      key: "Moz",
      value: "MozTransform"
    },
    {
      key: "O",
      value: "OTransform"
    },
    {
      key: "ms",
      value: "msTransform"
    }
  ], t = 0, n = e; t < n.length; t++) {
    var r = n[t];
    if (zC[r.value] !== void 0)
      return r.key;
  }
  return !1;
}();
function Do(e) {
  return Xu === !1 ? e : Xu === "standard" ? e === "transitionEnd" ? "transitionend" : e : Xu + e.charAt(0).toUpperCase() + e.substr(1);
}
function D2e(e, t, n, r) {
  var i = OC ? {
    passive: !1,
    capture: !!r
  } : !!r;
  e.addEventListener(t, n, i);
}
function M2e(e, t, n, r) {
  e.removeEventListener(t, n, {
    capture: !!r
  });
}
Xu && Xu !== "standard" && "" + Xu.toLowerCase();
var H2e = Do("transform"), I2e = Do("transition");
Nf && Do("perspective") in zC;
Do("transitionTimingFunction"), Do("transitionDuration"), Do("transitionDelay"), Do("transformOrigin"), Do("transitionEnd"), Do("transitionProperty");
function L2e(e, t) {
  for (var n in t)
    if (t[n].test(e[n]))
      return !0;
  return !1;
}
var B2e = function() {
  function e(t, n) {
    this.wrapper = t, this.events = n, this.addDOMEvents();
  }
  return e.prototype.destroy = function() {
    this.removeDOMEvents(), this.events = [];
  }, e.prototype.addDOMEvents = function() {
    this.handleDOMEvents(D2e);
  }, e.prototype.removeDOMEvents = function() {
    this.handleDOMEvents(M2e);
  }, e.prototype.handleDOMEvents = function(t) {
    var n = this, r = this.wrapper;
    this.events.forEach(function(i) {
      t(r, i.name, n, !!i.capture);
    });
  }, e.prototype.handleEvent = function(t) {
    var n = t.type;
    this.events.some(function(r) {
      return r.name === n ? (r.handler(t), !0) : !1;
    });
  }, e;
}(), N2e = function() {
  function e(t) {
    this.scroll = t, this.wheelEndTimer = 0, this.wheelMoveTimer = 0, this.wheelStart = !1, this.init();
  }
  return e.prototype.init = function() {
    this.handleBScroll(), this.handleOptions(), this.handleHooks(), this.registerEvent();
  }, e.prototype.handleBScroll = function() {
    this.scroll.registerType([
      "alterOptions",
      "mousewheelStart",
      "mousewheelMove",
      "mousewheelEnd"
    ]);
  }, e.prototype.handleOptions = function() {
    var t = this.scroll.options.mouseWheel === !0 ? {} : this.scroll.options.mouseWheel, n = {
      speed: 20,
      invert: !1,
      easeTime: 300,
      discreteTime: 400,
      throttleTime: 0,
      dampingFactor: 0.1
    };
    this.mouseWheelOpt = z2e(n, t);
  }, e.prototype.handleHooks = function() {
    this.hooksFn = [], this.registerHooks(this.scroll.hooks, "destroy", this.destroy);
  }, e.prototype.registerEvent = function() {
    this.eventRegister = new B2e(this.scroll.scroller.wrapper, [
      {
        name: "wheel",
        handler: this.wheelHandler.bind(this)
      },
      {
        name: "mousewheel",
        handler: this.wheelHandler.bind(this)
      },
      {
        name: "DOMMouseScroll",
        handler: this.wheelHandler.bind(this)
      }
    ]);
  }, e.prototype.registerHooks = function(t, n, r) {
    t.on(n, r, this), this.hooksFn.push([t, n, r]);
  }, e.prototype.wheelHandler = function(t) {
    if (!!this.scroll.enabled) {
      this.beforeHandler(t), this.wheelStart || (this.wheelStartHandler(t), this.wheelStart = !0);
      var n = this.getWheelDelta(t);
      this.wheelMoveHandler(n), this.wheelEndDetector(n);
    }
  }, e.prototype.wheelStartHandler = function(t) {
    this.cleanCache();
    var n = this.scroll.scroller, r = n.scrollBehaviorX, i = n.scrollBehaviorY;
    r.setMovingDirection(0), i.setMovingDirection(0), r.setDirection(0), i.setDirection(0), this.scroll.trigger(this.scroll.eventTypes.alterOptions, this.mouseWheelOpt), this.scroll.trigger(this.scroll.eventTypes.mousewheelStart);
  }, e.prototype.cleanCache = function() {
    this.deltaCache = [];
  }, e.prototype.wheelMoveHandler = function(t) {
    var n = this, r = this.mouseWheelOpt, i = r.throttleTime, a = r.dampingFactor;
    if (i && this.wheelMoveTimer)
      this.deltaCache.push(t);
    else {
      var o = this.deltaCache.reduce(function(h, p) {
        return {
          x: h.x + p.x,
          y: h.y + p.y
        };
      }, { x: 0, y: 0 });
      this.cleanCache();
      var s = this.scroll.scroller, l = s.scrollBehaviorX, u = s.scrollBehaviorY;
      l.setMovingDirection(-t.directionX), u.setMovingDirection(-t.directionY), l.setDirection(t.x), u.setDirection(t.y);
      var c = l.performDampingAlgorithm(Math.round(t.x) + o.x, a), f = u.performDampingAlgorithm(Math.round(t.y) + o.x, a);
      if (!this.scroll.trigger(this.scroll.eventTypes.mousewheelMove, {
        x: c,
        y: f
      })) {
        var d = this.getEaseTime();
        (c !== this.scroll.x || f !== this.scroll.y) && this.scroll.scrollTo(c, f, d);
      }
      i && (this.wheelMoveTimer = window.setTimeout(function() {
        n.wheelMoveTimer = 0;
      }, i));
    }
  }, e.prototype.wheelEndDetector = function(t) {
    var n = this;
    window.clearTimeout(this.wheelEndTimer), this.wheelEndTimer = window.setTimeout(function() {
      n.wheelStart = !1, window.clearTimeout(n.wheelMoveTimer), n.wheelMoveTimer = 0, n.scroll.trigger(n.scroll.eventTypes.mousewheelEnd, t);
    }, this.mouseWheelOpt.discreteTime);
  }, e.prototype.getWheelDelta = function(t) {
    var n = this.mouseWheelOpt, r = n.speed, i = n.invert, a = 0, o = 0, s = i ? -1 : 1;
    switch (!0) {
      case "deltaX" in t:
        t.deltaMode === 1 ? (a = -t.deltaX * r, o = -t.deltaY * r) : (a = -t.deltaX, o = -t.deltaY);
        break;
      case "wheelDeltaX" in t:
        a = t.wheelDeltaX / 120 * r, o = t.wheelDeltaY / 120 * r;
        break;
      case "wheelDelta" in t:
        a = o = t.wheelDelta / 120 * r;
        break;
      case "detail" in t:
        a = o = -t.detail / 3 * r;
        break;
    }
    a *= s, o *= s, this.scroll.hasVerticalScroll || (Math.abs(o) > Math.abs(a) && (a = o), o = 0), this.scroll.hasHorizontalScroll || (a = 0);
    var l = a > 0 ? -1 : a < 0 ? 1 : 0, u = o > 0 ? -1 : o < 0 ? 1 : 0;
    return {
      x: a,
      y: o,
      directionX: l,
      directionY: u
    };
  }, e.prototype.beforeHandler = function(t) {
    var n = this.scroll.options, r = n.preventDefault, i = n.stopPropagation, a = n.preventDefaultException;
    r && !L2e(t.target, a) && t.preventDefault(), i && t.stopPropagation();
  }, e.prototype.getEaseTime = function() {
    var t = 100, n = this.mouseWheelOpt.easeTime;
    return n < t && k2e("easeTime should be greater than 100.If mouseWheel easeTime is too small,scrollEnd will be triggered many times."), Math.max(n, t);
  }, e.prototype.destroy = function() {
    this.eventRegister.destroy(), window.clearTimeout(this.wheelEndTimer), window.clearTimeout(this.wheelMoveTimer), this.hooksFn.forEach(function(t) {
      var n = t[0], r = t[1], i = t[2];
      n.off(r, i);
    });
  }, e.pluginName = "mouseWheel", e.applyOrder = "pre", e;
}();
/*!
 * better-scroll / observe-dom
 * (c) 2016-2021 ustbhuangyi
 * Released under the MIT License.
 */
var jf = typeof window < "u", fc = jf && navigator.userAgent.toLowerCase();
fc && /wechatdevtools/.test(fc);
fc && fc.indexOf("android") > 0;
(function() {
  if (typeof fc == "string") {
    var e = /os (\d\d?_\d(_\d)?)/, t = e.exec(fc);
    if (!t)
      return !1;
    var n = t[1].split("_").map(function(r) {
      return parseInt(r, 10);
    });
    return n[0] === 13 && n[1] >= 4;
  }
  return !1;
})();
var j2e = !1;
if (jf) {
  var F2e = "test-passive";
  try {
    var _9 = {};
    Object.defineProperty(_9, "passive", {
      get: function() {
        j2e = !0;
      }
    }), window.addEventListener(F2e, function() {
    }, _9);
  } catch {
  }
}
var DC = jf && document.createElement("div").style, Ru = function() {
  if (!jf)
    return !1;
  for (var e = [
    {
      key: "standard",
      value: "transform"
    },
    {
      key: "webkit",
      value: "webkitTransform"
    },
    {
      key: "Moz",
      value: "MozTransform"
    },
    {
      key: "O",
      value: "OTransform"
    },
    {
      key: "ms",
      value: "msTransform"
    }
  ], t = 0, n = e; t < n.length; t++) {
    var r = n[t];
    if (DC[r.value] !== void 0)
      return r.key;
  }
  return !1;
}();
function Mo(e) {
  return Ru === !1 ? e : Ru === "standard" ? e === "transitionEnd" ? "transitionend" : e : Ru + e.charAt(0).toUpperCase() + e.substr(1);
}
Ru && Ru !== "standard" && "" + Ru.toLowerCase();
var X2e = Mo("transform"), R2e = Mo("transition");
jf && Mo("perspective") in DC;
Mo("transitionTimingFunction"), Mo("transitionDuration"), Mo("transitionDelay"), Mo("transformOrigin"), Mo("transitionEnd"), Mo("transitionProperty");
function W9(e) {
  if (e instanceof window.SVGElement) {
    var t = e.getBoundingClientRect();
    return {
      top: t.top,
      left: t.left,
      width: t.width,
      height: t.height
    };
  } else
    return {
      top: e.offsetTop,
      left: e.offsetLeft,
      width: e.offsetWidth,
      height: e.offsetHeight
    };
}
var V2e = function() {
  function e(t) {
    this.scroll = t, this.stopObserver = !1, this.init();
  }
  return e.prototype.init = function() {
    this.handleMutationObserver(), this.handleHooks();
  }, e.prototype.handleMutationObserver = function() {
    var t = this;
    if (typeof MutationObserver < "u") {
      var n = 0;
      this.observer = new MutationObserver(function(r) {
        t.mutationObserverHandler(r, n);
      }), this.startObserve(this.observer);
    } else
      this.checkDOMUpdate();
  }, e.prototype.handleHooks = function() {
    var t = this;
    this.hooksFn = [], this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.contentChanged, function() {
      t.stopObserve(), t.handleMutationObserver();
    }), this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.enable, function() {
      t.stopObserver && t.handleMutationObserver();
    }), this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.disable, function() {
      t.stopObserve();
    }), this.registerHooks(this.scroll.hooks, this.scroll.hooks.eventTypes.destroy, function() {
      t.destroy();
    });
  }, e.prototype.mutationObserverHandler = function(t, n) {
    var r = this;
    if (!this.shouldNotRefresh()) {
      for (var i = !1, a = !1, o = 0; o < t.length; o++) {
        var s = t[o];
        if (s.type !== "attributes") {
          i = !0;
          break;
        } else if (s.target !== this.scroll.scroller.content) {
          a = !0;
          break;
        }
      }
      i ? this.scroll.refresh() : a && (clearTimeout(n), n = window.setTimeout(function() {
        r.shouldNotRefresh() || r.scroll.refresh();
      }, 60));
    }
  }, e.prototype.startObserve = function(t) {
    var n = {
      attributes: !0,
      childList: !0,
      subtree: !0
    };
    t.observe(this.scroll.scroller.content, n);
  }, e.prototype.shouldNotRefresh = function() {
    var t = this.scroll.scroller, n = t.scrollBehaviorX, r = t.scrollBehaviorY, i = n.currentPos > n.minScrollPos || n.currentPos < n.maxScrollPos || r.currentPos > r.minScrollPos || r.currentPos < r.maxScrollPos;
    return t.animater.pending || i;
  }, e.prototype.checkDOMUpdate = function() {
    var t = this, n = this.scroll.scroller.content, r = W9(n), i = r.width, a = r.height, o = function() {
      if (!t.stopObserver) {
        r = W9(n);
        var l = r.width, u = r.height;
        (i !== l || a !== u) && t.scroll.refresh(), i = l, a = u, s();
      }
    }, s = function() {
      setTimeout(function() {
        o();
      }, 1e3);
    };
    s();
  }, e.prototype.registerHooks = function(t, n, r) {
    t.on(n, r, this), this.hooksFn.push([t, n, r]);
  }, e.prototype.stopObserve = function() {
    this.stopObserver = !0, this.observer && this.observer.disconnect();
  }, e.prototype.destroy = function() {
    this.stopObserve(), this.hooksFn.forEach(function(t) {
      var n = t[0], r = t[1], i = t[2];
      n.off(r, i);
    }), this.hooksFn.length = 0;
  }, e.pluginName = "observeDOM", e;
}();
A2.use(V2e);
A2.use(E2e);
A2.use(N2e);
const U2e = {
  props: {
    scrollEl: {
      type: String,
      default: "scroll" + new Date().getTime()
    },
    listData: {
      type: Array,
      default: null
    },
    isScrollBottom: {
      type: Boolean,
      default: !1
    },
    pullDown: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      bscroll: null,
      beforePullDown: !0,
      isPullingDown: !1,
      isFinish: !1
    };
  },
  methods: {
    initScroll() {
      this.bscroll = new A2(document.getElementById(this.scrollEl), {
        bounceTime: 800,
        scrollY: !0,
        observeDOM: !0,
        mouseWheel: !0,
        pullDownRefresh: {
          threshold: 20,
          stop: 56
        }
      }), this.bscroll.on("scroll", (e) => {
        this.isFinish = !1, e.y > 56 && (this.pullDown && this.beforePullDown ? this.pullingDownHandler() : this.pullDown || (this.isFinish = !0));
      });
    },
    scrollBottom() {
      this.bscroll.scrollTo(0, this.bscroll.maxScrollY);
    },
    pullingDownHandler() {
      console.log("trigger pullDown"), this.beforePullDown = !1, this.isPullingDown = !0, this.$emit("handlePullDown");
    },
    async finishPullDown() {
      await new Promise((e) => {
        setTimeout(() => {
          this.bscroll.finishPullDown(), e();
        }, 56);
      }), setTimeout(() => {
        this.beforePullDown = !0, this.bscroll.refresh();
      }, 800);
    }
  },
  watch: {
    listData: {
      handler(e) {
        this.isScrollBottom || (this.isPullingDown = !1, this.finishPullDown());
      },
      deep: !0
    },
    isScrollBottom(e) {
      e && this.$nextTick(() => {
        this.bscroll.refresh(), this.scrollBottom();
      });
    }
  },
  mounted() {
    setTimeout(() => {
      this.initScroll(), this.scrollBottom();
    }, 500);
  }
}, q2e = (e) => (yn("data-v-8ac7ea3e"), e = e(), bn(), e), _2e = ["id"], W2e = { class: "scroll-content" }, K2e = {
  key: 0,
  class: "loading-icon"
}, G2e = /* @__PURE__ */ q2e(() => /* @__PURE__ */ T("i", { class: "el-icon-loading" }, null, -1)), Y2e = [
  G2e
], Q2e = {
  key: 1,
  class: "no-more"
};
function Z2e(e, t, n, r, i, a) {
  return P(), L("div", {
    class: "scroll-wrapper",
    id: n.scrollEl
  }, [
    T("div", W2e, [
      i.beforePullDown ? re("", !0) : (P(), L("div", K2e, Y2e)),
      i.isFinish ? (P(), L("div", Q2e, "\u6CA1\u6709\u66F4\u591A\u5185\u5BB9\u4E86....")) : re("", !0),
      tt(e.$slots, "default", {}, void 0, !0)
    ])
  ], 8, _2e);
}
const MC = /* @__PURE__ */ Ht(U2e, [["render", Z2e], ["__scopeId", "data-v-8ac7ea3e"]]);
const tv = Ee({
  components: {
    BScroll: MC
  },
  setup(e, t) {
    const n = ce("$http"), r = ce("siteId"), i = ce("$utils"), a = ce("userInfo"), o = ce("topHeight");
    let s = j(!1), l = j(!1), u = j([]), c = zt({
      user_id: a.id,
      site_id: r,
      content: ""
    }), f = zt({
      site_id: r,
      pageIndex: 0,
      pageSize: 10
    });
    const d = () => {
      s.value = !1, f.pageIndex++, p();
    }, h = async () => {
      if (!c.content)
        return;
      s.value = !1, await n.sendMessage(c) && (c.content = "", f.pageIndex = 0, p());
    };
    async function p() {
      let y = await n.getCaseMessageList({
        site_id: f.site_id,
        "_pageable.page": f.pageIndex,
        "_pageable.size": f.pageSize
      });
      f.pageIndex ? u.value = [...y.content.reverse(), ...u.value] : (u.value = y.content.reverse() || [], s.value = !0), (f.pageIndex + 1) * f.pageSize > +y.totalElements ? l.value = !1 : l.value = !0;
    }
    return p(), {
      utils: i,
      pullDown: l,
      isScrollBottom: s,
      sendInfo: c,
      messageList: u,
      topHeight: o,
      loadData: d,
      sendText: h,
      getMessageList: p
    };
  }
}), K9 = () => {
  xh((e) => ({
    "4a928e17": e.topHeight
  }));
}, G9 = tv.setup;
tv.setup = G9 ? (e, t) => (K9(), G9(e, t)) : K9;
const J2e = tv, $2e = { class: "message-container" }, epe = { class: "message-box" }, tpe = { class: "message-time" }, npe = {
  key: 0,
  class: "message-item send-message"
}, ipe = { class: "message-border send-border" }, rpe = ["src"], ape = {
  key: 1,
  class: "message-item"
}, ope = ["src"], spe = { class: "right" }, lpe = { class: "user-name" }, upe = { class: "message-border receive-border" }, cpe = { class: "send-input" }, dpe = /* @__PURE__ */ je("\u53D1\u9001");
function fpe(e, t, n, r, i, a) {
  const o = MC, s = ti, l = fn;
  return P(), L("div", $2e, [
    T("div", epe, [
      e.messageList.length ? (P(), ue(o, {
        key: 0,
        ref: "messageScroll",
        listData: e.messageList,
        pullDown: e.pullDown,
        isScrollBottom: e.isScrollBottom,
        onHandlePullDown: e.loadData
      }, {
        default: N(() => [
          (P(!0), L(nt, null, Lt(e.messageList, (u) => (P(), L("div", {
            class: "message-list",
            key: u.id
          }, [
            T("div", tpe, de(u.create_time), 1),
            u.user_id == e.sendInfo.user_id ? (P(), L("div", npe, [
              T("div", ipe, [
                T("span", null, de(u.content), 1)
              ]),
              T("img", {
                src: u.avatar || e.utils.getImage("diffMark/user_icon.png"),
                alt: "",
                class: "user-headimg"
              }, null, 8, rpe)
            ])) : (P(), L("div", ape, [
              T("img", {
                src: u.avatar || e.utils.getImage("diffMark/user_icon.png"),
                alt: "",
                class: "user-headimg"
              }, null, 8, ope),
              T("div", spe, [
                T("span", lpe, de(u.realname), 1),
                T("div", upe, [
                  T("span", null, de(u.content), 1)
                ])
              ])
            ]))
          ]))), 128))
        ]),
        _: 1
      }, 8, ["listData", "pullDown", "isScrollBottom", "onHandlePullDown"])) : re("", !0)
    ]),
    T("div", cpe, [
      B(s, {
        type: "textarea",
        modelValue: e.sendInfo.content,
        "onUpdate:modelValue": t[0] || (t[0] = (u) => e.sendInfo.content = u),
        autosize: { minRows: 1, maxRows: 2 },
        placeholder: "\u8BF4\u51E0\u53E5\u5427\u2026.",
        class: "input"
      }, null, 8, ["modelValue"]),
      B(l, {
        type: "primary",
        class: "send-btn",
        onClick: e.sendText
      }, {
        default: N(() => [
          dpe
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]);
}
const hpe = /* @__PURE__ */ Ht(J2e, [["render", fpe], ["__scopeId", "data-v-d1489920"]]);
const ua = "@@InfiniteScroll";
var ppe = function(e, t) {
  var n, r, i, a, o, s = function() {
    e.apply(a, o), r = n;
  };
  return function() {
    if (a = this, o = arguments, n = Date.now(), i && (clearTimeout(i), i = null), r) {
      var l = t - (n - r);
      l < 0 ? s() : i = setTimeout(() => {
        s();
      }, l);
    } else
      s();
  };
}, q4 = function(e) {
  return e === window ? Math.max(window.pageYOffset || 0, document.documentElement.scrollTop) : e.scrollTop;
}, vpe = document.defaultView.getComputedStyle, mpe = function(e) {
  for (var t = e; t && t.tagName !== "HTML" && t.tagName !== "BODY" && t.nodeType === 1; ) {
    var n = vpe(t).overflowY;
    if (n === "scroll" || n === "auto")
      return t;
    t = t.parentNode;
  }
  return window;
}, gpe = function(e) {
  return e === window ? document.documentElement.clientHeight : e.clientHeight;
}, Y9 = function(e) {
  return e === window ? q4(window) : e.getBoundingClientRect().top + q4(window);
}, Q9 = function(e) {
  for (var t = e.parentNode; t; ) {
    if (t.tagName === "HTML")
      return !0;
    if (t.nodeType === 11)
      return !1;
    t = t.parentNode;
  }
  return !1;
}, Z9 = function() {
  if (!this.binded) {
    this.binded = !0;
    var e = this, t = e.el, n = t.getAttribute("infinite-scroll-throttle-delay"), r = 200;
    n && (r = Number(e.vm[n] || n), (isNaN(r) || r < 0) && (r = 200)), e.throttleDelay = r, e.scrollEventTarget = mpe(t), e.scrollListener = ppe(F1.bind(e), e.throttleDelay), e.scrollEventTarget.addEventListener("scroll", e.scrollListener), this.vm.$on("hook:beforeDestroy", function() {
      e.scrollEventTarget.removeEventListener("scroll", e.scrollListener);
    });
    var i = t.getAttribute("infinite-scroll-disabled"), a = !1;
    i && (this.vm.$watch(i, function(f) {
      e.disabled = f, !f && e.immediateCheck && F1.call(e);
    }), a = Boolean(e.vm[i])), e.disabled = a;
    var o = t.getAttribute("infinite-scroll-distance"), s = 0;
    o && (s = Number(e.vm[o] || o), isNaN(s) && (s = 0)), e.distance = s;
    var l = t.getAttribute("infinite-scroll-immediate-check"), u = !0;
    l && (u = Boolean(e.vm[l])), e.immediateCheck = u, u && F1.call(e);
    var c = t.getAttribute("infinite-scroll-listen-for-event");
    c && e.vm.$on(c, function() {
      F1.call(e);
    });
  }
}, F1 = function(e) {
  var t = this.scrollEventTarget, n = this.el, r = this.distance;
  if (!(e !== !0 && this.disabled)) {
    var i = q4(t), a = i + gpe(t), o = !1;
    if (t === n)
      o = t.scrollHeight - a <= r;
    else {
      var s = Y9(n) - Y9(t) + n.offsetHeight + i;
      o = a + r >= s;
    }
    o && this.expression && this.expression();
  }
};
const T2 = {
  bind(e, t, n) {
    e[ua] = {
      el: e,
      vm: n.context,
      expression: t.value
    };
    const r = arguments;
    e[ua].vm.$on("hook:mounted", function() {
      e[ua].vm.$nextTick(function() {
        Q9(e) && Z9.call(e[ua], r), e[ua].bindTryCount = 0;
        var i = function() {
          e[ua].bindTryCount > 10 || (e[ua].bindTryCount++, Q9(e) ? Z9.call(e[ua], r) : setTimeout(i, 50));
        };
        i();
      });
    });
  },
  unbind(e) {
    e && e[ua] && e[ua].scrollEventTarget && e[ua].scrollEventTarget.removeEventListener("scroll", e[ua].scrollListener);
  }
}, HC = function(e) {
  e.directive("InfiniteScroll", T2);
};
window.Vue && (window.infiniteScroll = T2, Vue.use(HC));
T2.install = HC;
const nv = (e) => (yn("data-v-e4ac12d9"), e = e(), bn(), e), ype = { class: "note-container" }, bpe = { class: "note-list" }, Ape = /* @__PURE__ */ nv(() => /* @__PURE__ */ T("div", { class: "note-list-tips" }, "*\u4EC5\u5C55\u793A\u5F53\u524D\u83DC\u5355\u4E0B\u7684\u6279\u6CE8\u5217\u8868", -1)), Tpe = { class: "unsubmitted-header" }, wpe = { class: "unsubmitted-header-title" }, Ppe = /* @__PURE__ */ je("\u63D0\u4EA4\u5168\u90E8"), xpe = { class: "unsubmitted" }, Cpe = {
  key: 0,
  class: "unsubmitted-list"
}, Spe = ["onClick"], Epe = { class: "unsubmitted-list-item-title" }, kpe = { class: "unsubmitted-list-item-title-avatar" }, Ope = ["src"], zpe = { class: "unsubmitted-list-item-title-info" }, Dpe = ["onClick"], Mpe = { class: "unsubmitted-list-item-message" }, Hpe = {
  key: 0,
  class: "unsubmitted-list-item-content"
}, Ipe = {
  key: 1,
  class: "unsubmitted-list-item-content"
}, Lpe = { key: 1 }, Bpe = { class: "unsubmitted-header adopted-header" }, Npe = { class: "unsubmitted-header-title" }, jpe = { class: "submitted-header" }, Fpe = { class: "submitted-header-select" }, Xpe = { class: "el-dropdown-link" }, Rpe = { class: "submitted-header-sort" }, Vpe = { class: "el-dropdown-link" }, Upe = ["infinite-scroll-disabled"], qpe = ["onClick"], _pe = { class: "submitted-list-item-title" }, Wpe = { class: "submitted-list-item-title-avatar" }, Kpe = ["src"], Gpe = { class: "submitted-list-item-title-info" }, Ype = { class: "submitted-list-item-title-info-name" }, Qpe = { class: "reply-tools-bar" }, Zpe = ["onClick"], Jpe = ["onClick"], $pe = ["onClick"], e8e = ["onClick"], t8e = { class: "submitted-list-item-message" }, n8e = {
  key: 0,
  class: "icon",
  "aria-hidden": "true"
}, i8e = /* @__PURE__ */ nv(() => /* @__PURE__ */ T("use", { "xlink:href": "#icon-yicaina" }, null, -1)), r8e = [
  i8e
], a8e = {
  key: 0,
  class: "submitted-list-item-content"
}, o8e = {
  key: 1,
  class: "submitted-list-item-content"
}, s8e = ["onClick"], l8e = {
  key: 3,
  class: "submitted-list-item-replybox"
}, u8e = { class: "submitted-list-item-reply-list" }, c8e = { class: "submitted-list-item-reply-list-item" }, d8e = { class: "reply-avatar" }, f8e = ["src"], h8e = { class: "reply-right" }, p8e = { class: "reply-header" }, v8e = { class: "reply-info" }, m8e = { class: "reply-name text-overflow" }, g8e = { class: "reply-time" }, y8e = { class: "reply-tools" }, b8e = ["onClick"], A8e = ["onClick"], T8e = { class: "reply-content" }, w8e = ["onClick"], P8e = {
  key: 0,
  class: "nomore"
}, x8e = { key: 1 }, C8e = /* @__PURE__ */ nv(() => /* @__PURE__ */ T("div", { class: "unsubmitted-header adopted-header" }, [
  /* @__PURE__ */ T("div", { class: "unsubmitted-header-title" }, " \u5DF2\u91C7\u7EB3\u6279\u6CE8 ")
], -1)), S8e = {
  key: 0,
  class: "unsubmitted adopted"
}, E8e = ["infinite-scroll-disabled"], k8e = ["onClick"], O8e = { class: "unsubmitted-list-item-title" }, z8e = { class: "unsubmitted-list-item-title-avatar" }, D8e = ["src"], M8e = { class: "unsubmitted-list-item-title-info" }, H8e = { class: "unsubmitted-list-item-message" }, I8e = {
  key: 0,
  class: "unsubmitted-list-item-content"
}, L8e = {
  key: 1,
  class: "unsubmitted-list-item-content"
}, B8e = {
  key: 2,
  class: "submitted-list-item-replybox"
}, N8e = { class: "submitted-list-item-reply-list" }, j8e = { class: "submitted-list-item-reply-list-item" }, F8e = { class: "reply-avatar" }, X8e = ["src"], R8e = { class: "reply-right" }, V8e = { class: "reply-header" }, U8e = { class: "reply-info" }, q8e = { class: "reply-name" }, _8e = { class: "reply-content" }, W8e = {
  key: 0,
  class: "nomore"
}, K8e = { key: 1 }, G8e = {
  props: {
    unsubmittedNoteList: Array,
    compareText: String
  },
  emits: ["getUnsubmittedNoteList", "compareText"],
  setup(e, { expose: t, emit: n }) {
    const r = e;
    xh((Ve) => ({
      "05de8a02": E(l)
    }));
    const i = T2, a = ce("$http"), o = ce("siteId"), s = ce("$utils"), l = ce("topHeight"), u = ce("pageMode"), c = ce("currentMenuId"), f = ce("caseOther");
    async function d(Ve) {
      n("getUnsubmittedNoteList", Ve);
    }
    const h = j([]);
    j(!1);
    const p = j(0), y = j(1), m = zt({
      pageSize: 50,
      pageNum: 1
    }), b = j(!1), x = j("\u5168\u90E8\u6279\u6CE8"), D = j("\u6309\u6700\u65B0\u6279\u6CE8"), S = j(""), C = j(null), v = j("");
    let H = zt([
      { label: "\u5168\u90E8\u6279\u6CE8", value: "0" },
      { label: "\u6211\u7684\u6279\u6CE8", value: "1" },
      { label: "\u4ED6\u4EBA\u7684\u6279\u6CE8", value: "2" },
      { label: "\u672A\u91C7\u7EB3\u7684\u6279\u6CE8", value: "3" },
      { label: "\u5DF2\u91C7\u7EB3\u7684\u6279\u6CE8", value: "4" }
    ]);
    const V = [
      { value: "1", label: "\u6309\u6700\u65B0\u6279\u6CE8" },
      { value: "2", label: "\u6309\u6700\u65B0\u56DE\u590D" }
    ];
    let R = j("submitted");
    Ne(r.unsubmittedNoteList, (Ve, Te) => {
      val && val.length ? R.value = "unsubmitted" : R.value = "submitted";
    }), Ne(c, (Ve, Te) => {
      Ve && F(), Ve && u.value == 1 && Q(), Ve && u.value == 2 && d(E(Ve));
    });
    const F = async () => {
      const Ve = {
        column_id: E(c),
        sortType: y.value,
        screenType: p.value,
        "_pageable.size": m.pageSize,
        "_pageable.page": m.pageNum - 1
      };
      let Te;
      u.value == 1 ? (Ve.status = 1, Te = await a.getAnnotationListByCreater(Ve)) : u.value == 2 && (Te = await a.getAnnotationList(Ve));
      let Me = Te.content;
      Me && Me.length && Me.forEach((Je) => {
        Je.replyInputShow = !1, Je.replyList && Je.replyList.length && Je.replyList.forEach((mt) => {
          mt.replyInputShow = !1;
        });
      }), Te.first ? h.value = Me : h.value = h.value.concat(Me), Te.last && (b.value = !0);
    };
    function K() {
      m.pageNum = m.pageNum + 1, F();
    }
    let q = j({
      pageSize: 50,
      pageNum: 1
    }), G = j([]), te = j(!1);
    async function Q() {
      const Ve = {
        column_id: E(c),
        sortType: "",
        screenType: "",
        status: 2,
        "_pageable.size": q.value.pageSize,
        "_pageable.page": q.value.pageNum - 1
      };
      let Te = await a.getAnnotationListByCreater(Ve), Me = Te.content;
      Te.first ? G.value = Me : G.value = G.value.concat(Me), Te.last && (te.value = !0);
    }
    function Y() {
      q.value.pageNum = q.value.pageNum + 1, Q();
    }
    const Z = (Ve) => {
      if (Ve) {
        let Te = Ve.split("-");
        return `[${f.caseTypeName}\u89C6\u9891] ` + O0(parseInt(Te[0])) + "-" + O0(parseInt(Te[1]));
      }
      return "";
    }, oe = (Ve) => {
      n("compareText", Ve);
    }, he = async (Ve) => {
      oe(Ve), Ve.isRead || (await a.lookAnnotation({ annotation_id: Ve.id }), Ve.isRead = 1);
    }, Ae = async () => {
      const Ve = {
        site_id: o,
        column_id: E(c)
      };
      await a.annotationSubmit(Ve) > 0 && (yi({
        type: "success",
        message: "\u63D0\u4EA4\u6210\u529F"
      }), d(E(c)), d(), m.pageNum = 1, F());
    }, We = (Ve) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u6279\u6CE8\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001",
        confirmButtonText: "\u5220 \u9664"
      }).then(async () => {
        await a.delAnnotation({ id: Ve }) > 0 && (yi({
          type: "success",
          message: "\u5220\u9664\u6210\u529F"
        }), F(), u.value == 2 && (d(E(c)), d()));
      }).catch((Te) => {
        console.log(Te);
      });
    }, ke = (Ve) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u56DE\u590D\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001",
        confirmButtonText: "\u5220 \u9664"
      }).then(async () => {
        await a.delReply({ id: Ve }) > 0 && (yi({
          type: "success",
          message: "\u5220\u9664\u6210\u529F"
        }), F());
      }).catch((Te) => {
        console.log(Te);
      });
    }, Re = (Ve, Te) => {
      C.value && (C.value.replyInputShow = !1), S.value = Te, v.value = `\u56DE\u590D${Ve.userName}\uFF1A`, Ve.replyInputShow = !0, bt(() => {
        document.querySelector(".reply-input textarea").focus();
      }), C.value = Ve;
    }, ve = async () => {
      let Ve = {
        annotation_id: S.value,
        reply_content: v.value
      };
      await a.replyAnnotation(Ve) > 0 && (yi({
        type: "success",
        message: "\u63D0\u4EA4\u6210\u529F"
      }), F());
    }, Ye = (Ve) => {
      p.value = Ve.value, x.value = Ve.label, m.pageNum = 1, b.value = !1, F();
    }, Qe = (Ve) => {
      y.value = Ve.value, D.value = Ve.label, m.pageNum = 1, b.value = !1, F();
    }, ot = (Ve) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u91C7\u7EB3\u8BE5\u6279\u6CE8\u5417\uFF1F",
        tipText: "\u91C7\u7EB3\u540E\uFF0C\u5C06\u53EA\u62E5\u6709\u67E5\u770B\u529F\u80FD",
        confirmButtonText: "\u91C7 \u7EB3"
      }).then(async () => {
        let Te = {
          annotation_id: Ve
        };
        await a.adoptAnnotation(Te) > 0 && (yi({
          type: "success",
          message: "\u91C7\u7EB3\u6210\u529F"
        }), F(), Q());
      }).catch((Te) => {
        console.log(Te);
      });
    };
    return F(), u.value == 1 && (R = "submitted", Q()), u.value == 2 && (R = "unsubmitted", d(E(c))), t({
      getsubmittedNoteList: F
    }), (Ve, Te) => {
      const Me = fn, Je = PA, mt = qt, It = xG, ln = vf, gt = pf, Pe = ti, $e = wA;
      return P(), L("div", ype, [
        T("div", bpe, [
          Ape,
          B($e, {
            modelValue: E(R),
            "onUpdate:modelValue": Te[4] || (Te[4] = (Ke) => Bn(R) ? R.value = Ke : R = Ke),
            accordion: ""
          }, {
            default: N(() => [
              E(u) == 2 ? (P(), ue(Je, {
                key: 0,
                name: "unsubmitted"
              }, {
                title: N(() => [
                  T("div", Tpe, [
                    T("div", wpe, "\u672A\u63D0\u4EA4\u6279\u6CE8\uFF08" + de(e.unsubmittedNoteList.length) + "\uFF09", 1),
                    E(R) == "unsubmitted" && e.unsubmittedNoteList && e.unsubmittedNoteList.length ? (P(), ue(Me, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      onClick: Ae
                    }, {
                      default: N(() => [
                        Ppe
                      ]),
                      _: 1
                    })) : re("", !0)
                  ])
                ]),
                default: N(() => [
                  T("div", xpe, [
                    e.unsubmittedNoteList && e.unsubmittedNoteList.length ? (P(), L("div", Cpe, [
                      (P(!0), L(nt, null, Lt(e.unsubmittedNoteList, (Ke) => (P(), L("div", {
                        class: "unsubmitted-list-item",
                        onClick: (lt) => oe(Ke),
                        key: Ke.id
                      }, [
                        T("div", Epe, [
                          T("div", kpe, [
                            T("img", {
                              src: Ke.avatar ? Ke.avatar : E(s).getImage("diffMark/user_icon.png")
                            }, null, 8, Ope)
                          ]),
                          T("div", zpe, [
                            T("div", null, de(Ke.userName), 1),
                            T("div", null, de(E(s).formatDate(Ke.createTime)), 1)
                          ]),
                          Ke.isMyCreate == 1 ? (P(), L("div", {
                            key: 0,
                            class: "unsubmitted-list-item-title-del",
                            onClick: wt((lt) => We(Ke.id), ["stop"])
                          }, " \u5220\u9664 ", 8, Dpe)) : re("", !0)
                        ]),
                        T("div", Mpe, de(Ke.annotationMessage), 1),
                        +Ke.columnType == 3 ? (P(), L("div", Hpe, de(Z(Ke.annotationText)), 1)) : (P(), L("div", Ipe, de(Ke.annotationText), 1))
                      ], 8, Spe))), 128))
                    ])) : (P(), L("div", Lpe, [
                      B(E(bi), {
                        type: "message",
                        description: "\u6682\u65E0\u6279\u6CE8"
                      })
                    ]))
                  ])
                ]),
                _: 1
              })) : re("", !0),
              B(Je, { name: "submitted" }, {
                title: N(() => [
                  T("div", Bpe, [
                    T("div", Npe, de(E(u) == 1 ? "\u672A\u91C7\u7EB3\u6279\u6CE8" : "\u5168\u90E8\u6279\u6CE8"), 1)
                  ])
                ]),
                default: N(() => [
                  T("div", jpe, [
                    T("div", Fpe, [
                      E(u) == 2 ? (P(), ue(gt, {
                        key: 0,
                        onCommand: Ye
                      }, {
                        dropdown: N(() => [
                          B(ln, null, {
                            default: N(() => [
                              (P(!0), L(nt, null, Lt(E(H), (Ke) => (P(), ue(It, {
                                key: Ke.value,
                                command: Ke
                              }, {
                                default: N(() => [
                                  je(de(Ke.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["command"]))), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        default: N(() => [
                          T("span", Xpe, [
                            je(de(x.value) + " ", 1),
                            B(mt, {
                              class: "el-icon--right",
                              size: 15,
                              style: { "vertical-align": "sub" }
                            }, {
                              default: N(() => [
                                B(E(W0))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })) : re("", !0)
                    ]),
                    T("div", Rpe, [
                      B(gt, { onCommand: Qe }, {
                        dropdown: N(() => [
                          B(ln, null, {
                            default: N(() => [
                              (P(), L(nt, null, Lt(V, (Ke) => B(It, {
                                key: Ke.value,
                                command: Ke
                              }, {
                                default: N(() => [
                                  je(de(Ke.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["command"])), 64))
                            ]),
                            _: 1
                          })
                        ]),
                        default: N(() => [
                          T("span", Vpe, [
                            je(de(D.value) + " ", 1),
                            B(mt, {
                              class: "el-icon--right",
                              size: 15,
                              style: { "vertical-align": "sub" }
                            }, {
                              default: N(() => [
                                B(E(W0))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  T("div", {
                    class: se(["submitted", E(u) == 2 && e.unsubmittedNoteList && e.unsubmittedNoteList.length || E(u) == 1 ? "" : "helper"])
                  }, [
                    h.value && h.value.length ? Bt((P(), L("div", {
                      key: 0,
                      class: "submitted-list",
                      "infinite-scroll-disabled": b.value,
                      "infinite-scroll-immediate": !1,
                      "infinite-scroll-distance": "30"
                    }, [
                      (P(!0), L(nt, null, Lt(h.value, (Ke) => (P(), L("div", {
                        class: "submitted-list-item",
                        onClick: (lt) => he(Ke),
                        key: Ke.id
                      }, [
                        T("div", _pe, [
                          T("div", Wpe, [
                            T("img", {
                              src: Ke.avatar ? Ke.avatar : E(s).getImage("diffMark/user_icon.png")
                            }, null, 8, Kpe)
                          ]),
                          T("div", Gpe, [
                            T("div", Ype, [
                              T("div", {
                                class: se(["name", E(u) == 1 && Ke.isRead == 0 ? "noRead" : ""])
                              }, de(Ke.userName), 3),
                              T("div", Qpe, [
                                E(u) == 1 ? (P(), L("div", {
                                  key: 0,
                                  role: "button",
                                  tabindex: "0",
                                  class: "reply-btn",
                                  onClick: wt((lt) => Re(Ke, Ke.id), ["stop"])
                                }, " \u56DE\u590D ", 8, Zpe)) : re("", !0),
                                E(u) == 1 ? (P(), L("div", {
                                  key: 1,
                                  role: "button",
                                  tabindex: "0",
                                  class: "resolve-btn",
                                  onClick: wt((lt) => ot(Ke.id), ["stop"])
                                }, " \u91C7\u7EB3 ", 8, Jpe)) : re("", !0),
                                E(u) == 2 && Ke.isMyCreate == 1 ? (P(), L("div", {
                                  key: 2,
                                  class: "submitted-list-item-title-del",
                                  onClick: wt((lt) => We(Ke.id), ["stop"])
                                }, " \u5220\u9664 ", 8, $pe)) : re("", !0),
                                E(u) == 2 ? (P(), L("div", {
                                  key: 3,
                                  class: "submitted-list-item-title-reply",
                                  onClick: wt((lt) => Re(Ke, Ke.id), ["stop"])
                                }, " \u56DE\u590D ", 8, e8e)) : re("", !0)
                              ])
                            ]),
                            T("div", null, de(E(s).formatDate(Ke.createTime)), 1)
                          ])
                        ]),
                        T("div", t8e, [
                          E(u) == 2 && Ke.status == 2 ? (P(), L("svg", n8e, r8e)) : re("", !0),
                          je(" " + de(Ke.annotationMessage), 1)
                        ]),
                        +Ke.columnType == 3 ? (P(), L("div", a8e, de(Z(Ke.annotationText)), 1)) : (P(), L("div", o8e, de(Ke.annotationText), 1)),
                        Ke.replyInputShow ? (P(), L("div", {
                          key: 2,
                          class: "reply-input",
                          onClick: Te[1] || (Te[1] = wt(() => {
                          }, ["stop"]))
                        }, [
                          B(Pe, {
                            modelValue: v.value,
                            "onUpdate:modelValue": Te[0] || (Te[0] = (lt) => v.value = lt),
                            onKeyup: nn(ve, ["enter"]),
                            type: "textarea",
                            autofocus: "",
                            autosize: { minRows: 2, maxRows: 4 },
                            resize: "none",
                            placeholder: "\u8BF7\u63CF\u8FF0\u56DE\u590D\u5185\u5BB9",
                            "input-style": { paddingRight: "45px" }
                          }, null, 8, ["modelValue", "onKeyup"]),
                          T("div", {
                            role: "button",
                            tabindex: "0",
                            class: "reply-input-btn",
                            onClick: wt(ve, ["stop"])
                          }, " \u53D1\u9001 ", 8, s8e)
                        ])) : re("", !0),
                        Ke.replyList && Ke.replyList.length > 0 ? (P(), L("div", l8e, [
                          T("div", u8e, [
                            (P(!0), L(nt, null, Lt(Ke.replyList, (lt) => (P(), L("div", {
                              key: lt.id
                            }, [
                              T("div", c8e, [
                                T("div", d8e, [
                                  T("img", {
                                    src: lt.avatar ? lt.avatar : E(s).getImage("diffMark/user_icon.png")
                                  }, null, 8, f8e)
                                ]),
                                T("div", h8e, [
                                  T("div", p8e, [
                                    T("div", v8e, [
                                      T("div", m8e, de(lt.userName), 1),
                                      T("div", g8e, de(E(s).formatDate(lt.createTime)), 1)
                                    ]),
                                    T("div", y8e, [
                                      lt.isMyCreate == 1 ? (P(), L("div", {
                                        key: 0,
                                        class: "reply-del",
                                        onClick: wt((He) => ke(lt.id), ["stop"])
                                      }, " \u5220\u9664 ", 8, b8e)) : re("", !0),
                                      T("div", {
                                        class: "reply-reply",
                                        onClick: wt((He) => Re(lt, Ke.id), ["stop"])
                                      }, " \u56DE\u590D ", 8, A8e)
                                    ])
                                  ]),
                                  T("div", T8e, de(lt.replyContent), 1)
                                ])
                              ]),
                              lt.replyInputShow ? (P(), L("div", {
                                key: 0,
                                class: "reply-input",
                                onClick: Te[3] || (Te[3] = wt(() => {
                                }, ["stop"]))
                              }, [
                                B(Pe, {
                                  modelValue: v.value,
                                  "onUpdate:modelValue": Te[2] || (Te[2] = (He) => v.value = He),
                                  onKeyup: nn(ve, ["enter"]),
                                  type: "textarea",
                                  autofocus: "",
                                  autosize: { minRows: 2, maxRows: 4 },
                                  resize: "none",
                                  placeholder: "\u8BF7\u63CF\u8FF0\u56DE\u590D\u5185\u5BB9",
                                  "input-style": { paddingRight: "45px" }
                                }, null, 8, ["modelValue", "onKeyup"]),
                                T("div", {
                                  role: "button",
                                  tabindex: "0",
                                  class: "reply-input-btn",
                                  onClick: wt(ve, ["stop"])
                                }, " \u53D1\u9001 ", 8, w8e)
                              ])) : re("", !0)
                            ]))), 128))
                          ])
                        ])) : re("", !0)
                      ], 8, qpe))), 128)),
                      b.value ? (P(), L("div", P8e, "\u6CA1\u6709\u66F4\u591A\u4E86")) : re("", !0)
                    ], 8, Upe)), [
                      [E(i), K]
                    ]) : (P(), L("div", x8e, [
                      B(E(bi), {
                        type: "message",
                        description: "\u6682\u65E0\u6279\u6CE8"
                      })
                    ]))
                  ], 2)
                ]),
                _: 1
              }),
              E(u) == 1 ? (P(), ue(Je, {
                key: 1,
                name: "adopted"
              }, {
                title: N(() => [
                  C8e
                ]),
                default: N(() => [
                  (P(), L("div", S8e, [
                    E(G) && E(G).length ? Bt((P(), L("div", {
                      key: 0,
                      class: "unsubmitted-list",
                      "infinite-scroll-disabled": E(te),
                      "infinite-scroll-immediate": !1,
                      "infinite-scroll-distance": "30"
                    }, [
                      (P(!0), L(nt, null, Lt(E(G), (Ke) => (P(), L("div", {
                        class: "unsubmitted-list-item",
                        onClick: (lt) => oe(Ke),
                        key: Ke.id
                      }, [
                        T("div", O8e, [
                          T("div", z8e, [
                            T("img", {
                              src: Ke.avatar ? Ke.avatar : E(s).getImage("diffMark/user_icon.png")
                            }, null, 8, D8e)
                          ]),
                          T("div", M8e, [
                            T("div", null, de(Ke.userName), 1),
                            T("div", null, de(E(s).formatDate(Ke.createTime)), 1)
                          ])
                        ]),
                        T("div", H8e, de(Ke.annotationMessage), 1),
                        +Ke.columnType == 3 ? (P(), L("div", I8e, de(Z(Ke.annotationText)), 1)) : (P(), L("div", L8e, de(Ke.annotationText), 1)),
                        Ke.replyList && Ke.replyList.length > 0 ? (P(), L("div", B8e, [
                          T("div", N8e, [
                            (P(!0), L(nt, null, Lt(Ke.replyList, (lt) => (P(), L("div", {
                              key: lt.id
                            }, [
                              T("div", j8e, [
                                T("div", F8e, [
                                  T("img", {
                                    src: lt.avatar ? lt.avatar : E(s).getImage("diffMark/user_icon.png")
                                  }, null, 8, X8e)
                                ]),
                                T("div", R8e, [
                                  T("div", V8e, [
                                    T("div", U8e, [
                                      T("div", q8e, de(lt.userName), 1),
                                      T("div", null, de(E(s).formatDate(lt.createTime)), 1)
                                    ])
                                  ]),
                                  T("div", _8e, de(lt.replyContent), 1)
                                ])
                              ])
                            ]))), 128))
                          ])
                        ])) : re("", !0)
                      ], 8, k8e))), 128)),
                      E(te) ? (P(), L("div", W8e, "\u6CA1\u6709\u66F4\u591A\u4E86")) : re("", !0)
                    ], 8, E8e)), [
                      [E(i), Y]
                    ]) : (P(), L("div", K8e, [
                      B(E(bi), {
                        type: "message",
                        description: "\u6682\u65E0\u6279\u6CE8"
                      })
                    ]))
                  ]))
                ]),
                _: 1
              })) : re("", !0)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]);
    };
  }
}, Y8e = /* @__PURE__ */ Ht(G8e, [["__scopeId", "data-v-e4ac12d9"]]);
const iv = {
  components: {
    CaseVideo: _x
  },
  props: ["reviseList", "pageMode"],
  emits: ["contentChange"],
  setup(e, t) {
    const n = ce("$http"), { getContentText: r } = ce("$utils"), i = ce("topHeight");
    let a = j(!1);
    const { emit: o } = t;
    let s = j(!1), l = j(""), u = j({}), c = j("");
    function f({ id: h, createTime: p }) {
      s.value = !0, di({
        headerTitle: "\u63D0\u793A",
        tipTitle: `\u786E\u5B9A\u8981\u5C06\u6587\u6863\u8FD8\u539F\u5230${this.dayjs(p).format(
          "YYYY-MM-DD HH:mm:ss"
        )}\u7684\u5185\u5BB9\u5417\uFF1F`,
        tipText: "\u8FD8\u539F\u540E\u73B0\u6709\u6587\u6863\u5C06\u88AB\u66FF\u6362",
        confirmButtonText: "\u786E \u5B9A"
      }).then(async () => {
        await n.resetRevise({ revise_id: h }), yi.success({
          message: "\u7248\u672C\u8FD8\u539F\u6210\u529F!"
        }), a.value = !1, o("contentChange", 3);
      }).catch((y) => {
        console.log(y);
      });
    }
    async function d(h, p) {
      if (s.value) {
        s.value = !1;
        return;
      }
      const y = await n.getRevise({ id: h });
      u.value = y, p === 3 && y.files && y.files.length && (c.value = y.files[0].fileUrl), a.value = !0;
    }
    return Ne(
      () => e.reviseList,
      (h) => {
        h && h.length && (l.value = h[0].id);
      }
    ), {
      reviseDialogVisible: a,
      activeName: l,
      reviseDetailInfo: u,
      caseVideoUrl: c,
      topHeight: i,
      getReviseDetail: d,
      reset: f,
      getContentText: r,
      dayjs: Ut
    };
  }
}, J9 = () => {
  xh((e) => ({
    "338b1b8c": e.topHeight
  }));
}, $9 = iv.setup;
iv.setup = $9 ? (e, t) => (J9(), $9(e, t)) : J9;
const Q8e = iv, IC = (e) => (yn("data-v-6e28c769"), e = e(), bn(), e), Z8e = { class: "revise-wrapper" }, J8e = /* @__PURE__ */ IC(() => /* @__PURE__ */ T("div", { class: "revise-wrapper-tips" }, "*\u4EC5\u5C55\u793A\u5F53\u524D\u83DC\u5355\u4E0B\u7684\u4FEE\u8BA2\u8BB0\u5F55", -1)), $8e = { class: "revise-list" }, e4e = ["onClick"], t4e = { class: "time" }, n4e = ["onClick"], i4e = /* @__PURE__ */ IC(() => /* @__PURE__ */ T("i", { class: "iconfont icon-huanyuan" }, null, -1)), r4e = /* @__PURE__ */ je("\u8FD8\u539F"), a4e = [
  i4e,
  r4e
], o4e = { class: "title" }, s4e = { class: "content" }, l4e = ["innerHTML"], u4e = {
  key: 0,
  class: "modal"
}, c4e = { class: "revise-dialog-header" }, d4e = { class: "title" }, f4e = { class: "time" }, h4e = /* @__PURE__ */ je("\u8FD8\u539F"), p4e = {
  key: 0,
  class: "revise-dialog-body"
}, v4e = ["innerHTML"];
function m4e(e, t, n, r, i, a) {
  const o = PA, s = wA, l = fn, u = Ie("CaseVideo"), c = ni;
  return P(), L("div", Z8e, [
    J8e,
    B(s, {
      modelValue: r.activeName,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => r.activeName = f),
      accordion: ""
    }, {
      default: N(() => [
        (P(!0), L(nt, null, Lt(n.reviseList, ({ name: f, id: d, reviseList: h }) => (P(), ue(o, {
          key: d,
          title: f,
          name: d
        }, {
          default: N(() => [
            T("div", $8e, [
              (P(!0), L(nt, null, Lt(h, ({
                createTime: p,
                reviseContent: y,
                reviseTitle: m,
                id: b,
                columnType: x
              }) => (P(), L("div", {
                class: "revise-item",
                key: b,
                onClick: (D) => r.getReviseDetail(b, x)
              }, [
                T("div", t4e, [
                  je(de(r.dayjs(p).format("YYYY-MM-DD HH:mm:ss")) + " ", 1),
                  n.pageMode === 1 ? (P(), L("span", {
                    key: 0,
                    class: "reset",
                    onClick: (D) => r.reset({ id: b, createTime: p })
                  }, a4e, 8, n4e)) : re("", !0)
                ]),
                T("div", o4e, de(m), 1),
                T("div", s4e, [
                  T("div", {
                    class: "content-overflow",
                    innerHTML: y
                  }, null, 8, l4e),
                  (r.getContentText(y) || "").endsWith("\u2026") ? (P(), L("div", u4e)) : re("", !0)
                ])
              ], 8, e4e))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["title", "name"]))), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    B(c, {
      width: 800,
      "custom-class": "revise-dialog",
      "append-to-body": "",
      modelValue: r.reviseDialogVisible,
      "onUpdate:modelValue": t[2] || (t[2] = (f) => r.reviseDialogVisible = f)
    }, {
      title: N(() => [
        T("div", c4e, [
          T("span", d4e, de(r.reviseDetailInfo.column_title), 1),
          T("span", f4e, de(r.dayjs(r.reviseDetailInfo.createTime).format("YYYY-MM-DD HH:mm:ss")) + "\u7F16\u8F91\u4E86\u5185\u5BB9 ", 1),
          n.pageMode === 1 ? (P(), ue(l, {
            key: 0,
            class: "reset-btn",
            onClick: t[1] || (t[1] = (f) => r.reset(r.reviseDetailInfo))
          }, {
            default: N(() => [
              h4e
            ]),
            _: 1
          })) : re("", !0)
        ])
      ]),
      default: N(() => [
        r.reviseDetailInfo.column_type === 3 ? (P(), L("div", p4e, [
          r.caseVideoUrl ? (P(), ue(u, {
            key: 0,
            videoUrl: r.caseVideoUrl,
            isPreview: !0,
            isAutoPlay: !0
          }, null, 8, ["videoUrl"])) : re("", !0)
        ])) : (P(), L("div", {
          key: 1,
          class: "revise-dialog-body",
          innerHTML: r.reviseDetailInfo.revise_complete
        }, null, 8, v4e))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const g4e = /* @__PURE__ */ Ht(Q8e, [["render", m4e], ["__scopeId", "data-v-6e28c769"]]);
const y4e = (e) => (yn("data-v-bf2f2a88"), e = e(), bn(), e), b4e = { class: "simple-wrapper" }, A4e = ["onClick"], T4e = { class: "label" }, w4e = {
  key: 0,
  class: "tag-detail"
}, P4e = /* @__PURE__ */ y4e(() => /* @__PURE__ */ T("span", null, "\u7559\u8A00", -1)), x4e = {
  key: 0,
  class: "message-count"
}, C4e = {
  props: {
    tagIconList: {
      type: Array,
      default: []
    },
    unsubmittedNoteList: {
      type: Array,
      default: []
    },
    reviseList: {
      type: Array,
      default: []
    },
    messageCount: Number
  },
  emits: ["getUnreadMessage", "getUnreadAnnotation", "getUnsubmittedNoteList", "compareText", "contentChange", "update:messageCount"],
  setup(e, { expose: t, emit: n }) {
    xh((y) => ({
      "0c698a1f": E(s)
    }));
    const r = ce("pageMode"), i = ce("caseOther"), a = j(!1), o = j("noteList"), s = ce("topHeight"), l = () => {
      a.value = !1, n("getUnreadMessage"), n("getUnreadAnnotation");
    }, u = (y) => {
      o.value = y, y === "messageList" && n("update:messageCount", 0), a.value = !0;
    }, c = (y) => {
      n("getUnsubmittedNoteList", y);
    }, f = (y) => {
      n("compareText", y);
    }, d = (y) => {
      y.paneName == "messageList" && n("update:messageCount", 0);
    }, h = j(null);
    return t({
      tagOpen: u,
      getsubmittedNoteList: () => {
        h.value.getsubmittedNoteList();
      },
      activeName: o
    }), (y, m) => {
      const b = Jb, x = qt, D = F$, S = j$;
      return (E(r) == 1 || E(r) == 2) && E(i).source !== 2 ? (P(), ue(E(Ol), {
        key: 0,
        class: "tag-wrapper"
      }, {
        default: N(() => [
          Bt(T("div", b4e, [
            (P(!0), L(nt, null, Lt(e.tagIconList, ({ title: C, icon: v, name: H, count: V }) => (P(), L("div", {
              class: "item",
              key: v,
              onClick: (R) => u(H)
            }, [
              B(b, {
                value: V,
                hidden: E(r) != 1 && H == "noteList" || !V
              }, {
                default: N(() => [
                  T("i", {
                    class: se(["iconfont", `icon-${v}`])
                  }, null, 2),
                  T("div", T4e, de(C), 1)
                ]),
                _: 2
              }, 1032, ["value", "hidden"])
            ], 8, A4e))), 128))
          ], 512), [
            [Cn, !a.value]
          ]),
          a.value ? (P(), L("div", w4e, [
            B(x, {
              class: "close-btn",
              onClick: l
            }, {
              default: N(() => [
                B(E(XT))
              ]),
              _: 1
            }),
            B(S, {
              modelValue: o.value,
              "onUpdate:modelValue": m[1] || (m[1] = (C) => o.value = C),
              onTabClick: d
            }, {
              default: N(() => [
                B(D, {
                  label: "\u6279\u6CE8\u5217\u8868",
                  name: "noteList"
                }, {
                  default: N(() => [
                    B(Y8e, {
                      ref_key: "noteList",
                      ref: h,
                      unsubmittedNoteList: e.unsubmittedNoteList,
                      onCompareText: f,
                      onGetUnsubmittedNoteList: c
                    }, null, 8, ["unsubmittedNoteList"])
                  ]),
                  _: 1
                }),
                B(D, {
                  label: "\u4FEE\u8BA2\u8BB0\u5F55",
                  name: "reviseList"
                }, {
                  default: N(() => [
                    B(g4e, {
                      reviseList: e.reviseList,
                      pageMode: E(r),
                      onContentChange: m[0] || (m[0] = (C) => y.$emit("contentChange", C))
                    }, null, 8, ["reviseList", "pageMode"])
                  ]),
                  _: 1
                }),
                B(D, { name: "messageList" }, {
                  label: N(() => [
                    P4e,
                    e.messageCount ? (P(), L("span", x4e, de(e.messageCount > 100 ? "99+" : e.messageCount), 1)) : re("", !0)
                  ]),
                  default: N(() => [
                    o.value === "messageList" ? (P(), ue(hpe, { key: 0 })) : re("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])) : re("", !0)
        ]),
        _: 1
      })) : re("", !0);
    };
  }
}, S4e = /* @__PURE__ */ Ht(C4e, [["__scopeId", "data-v-bf2f2a88"]]), w2 = (e, t) => {
  const n = ce("$http"), r = j([]), i = j(0);
  return {
    authList: r,
    authNum: i,
    getCooperationList: async (l) => {
      let u = {
        "_pageable.page": 0,
        "_pageable.size": 99,
        site_id: e,
        keyWord: l && l.keyWord || void 0,
        organ_id: l && l.organ_id || void 0
      };
      const c = await n.getAuthList(u);
      console.log("\u534F\u4F5C\u8005\u5217\u8868", c), r.value = c.content, i.value = c.content.filter((f) => f.status == 1).length;
    },
    confirmSubmit: () => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u63D0\u4EA4\u65B0\u7248\u672C\u7ED9\u534F\u4F5C\u8005\u5417\uFF1F",
        tipText: "\u65B0\u7248\u672C\u63D0\u4EA4\u540E\uFF0C\u534F\u4F5C\u8005\u5C06\u53EA\u80FD\u5728\u65B0\u7248\u672C\u4E0A\u505A\u6807\u6CE8",
        confirmButtonText: "\u63D0 \u4EA4"
      }).then(async () => {
        const l = await n.submitCollaboration(e);
        console.log(l), yi({
          type: "success",
          message: "\u63D0\u4EA4\u6210\u529F!"
        }), t.emit("contentChange", 1);
      }).catch(() => {
      });
    },
    collaboratorApply: async (l, u) => {
      const c = await n.isApplyJoin({
        site_id: e
      });
      c && !c.length ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u7533\u8BF7\u52A0\u5165\u534F\u4F5C\u5417\uFF1F",
        tipText: "\u7533\u8BF7\u540E\u9700\u7B49\u5F85\u521B\u5EFA\u8005\u5BA1\u6838\u540C\u610F\u540E\uFF0C\u65B9\u53EF\u5171\u540C\u534F\u4F5C",
        confirmButtonText: "\u786E \u5B9A"
      }).then(async () => {
        const f = await n.addCollaboration({
          user_id: l,
          site_id: e,
          status: 3
        });
        console.log(f), yi({
          type: "success",
          message: "\u5DF2\u7533\u8BF7!"
        });
      }).catch(() => {
      }) : c[0].status == 3 ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u534F\u4F5C\u7533\u8BF7\u7B49\u5F85\u521B\u5EFA\u8005\u5BA1\u6838\u4E2D",
        tipText: "\u7533\u8BF7\u540E\u9700\u7B49\u5F85\u521B\u5EFA\u8005\u5BA1\u6838\u540C\u610F\u540E\uFF0C\u65B9\u53EF\u5171\u540C\u534F\u4F5C",
        confirmButtonText: "\u6211\u77E5\u9053\u4E86",
        boxType: "alert"
      }).then(() => {
      }).catch(() => {
      }) : c[0].status == 2 && di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u521B\u5EFA\u8005\u5DF2\u9080\u8BF7\u60A8\u52A0\u5165\u534F\u4F5C",
        tipText: "\u540C\u610F\u534F\u4F5C\u540E\u53EF\u6279\u6CE8\u548C\u7559\u8A00",
        confirmButtonText: "\u540C\u610F\u534F\u4F5C",
        cancelButtonText: "\u62D2\u7EDD\u534F\u4F5C"
      }).then(async () => {
        let f = {
          user_id: l,
          site_id: e,
          status: 1
        };
        const d = await n.addCollaboration(f);
        console.log("\u540C\u610F", d), d > 0 && (yi({
          type: "success",
          message: "\u5DF2\u540C\u610F!"
        }), u === 4 ? window.location.replace(`${window.location.origin}/outlineDetail.html?siteId=${e}&type=4`) : window.location.replace(`${window.location.origin}/caseDetail.html?siteId=${e}&type=4`));
      }).catch(async () => {
        let f = {
          user_id: l,
          site_id: e,
          status: "0"
        };
        const d = await n.addCollaboration(f);
        console.log("\u62D2\u7EDD", d), d > 0 && yi({
          type: "success",
          message: "\u5DF2\u62D2\u7EDD!"
        });
      });
    }
  };
};
const E4e = { class: "search-box" }, k4e = { class: "table-container table-box" }, O4e = { class: "page-box" }, z4e = { class: "dialog-footer" }, D4e = /* @__PURE__ */ je("\u53D6\u6D88"), M4e = /* @__PURE__ */ je("\u6DFB\u52A0"), H4e = {
  props: {
    show: Boolean
  },
  emits: ["update:show", "updateAuthList"],
  setup(e, { emit: t }) {
    const n = ce("$http"), r = ce("siteId"), i = zt({
      keyWord: "",
      organ_id: ""
    }), a = j([]), o = zt({
      checkStrictly: !0,
      emitPath: !1,
      value: "id",
      label: "organName"
    }), s = j([]), l = zt({
      pageNum: 1,
      pageSize: 10,
      total: 0
    }), u = j([]), c = () => {
      t("update:show", !1);
    }, f = () => {
      l.pageNum = 1, m();
    }, d = (x) => {
      u.value = x.map((D) => D.user_id);
    }, h = (x) => {
      l.pageNum = x, m();
    }, p = (x) => {
      l.pageSize = x, l.pageNum = 1, m();
    }, y = async () => {
      const x = await n.getOrganTree();
      a.value = x;
    }, m = async () => {
      let x = {
        "_pageable.page": l.pageNum - 1,
        "_pageable.size": l.pageSize,
        site_id: r,
        keyWord: i.keyWord || void 0,
        organ_id: i.organ_id || void 0
      };
      const D = await n.addCollaborationByChoice(x);
      s.value = D.content || [], l.total = +D.totalElements;
    };
    y(), m();
    const b = async () => {
      if (!u.value.length) {
        An.warning("\u672A\u9009\u62E9\u4EFB\u4F55\u534F\u4F5C\u8005");
        return;
      }
      let x = {
        user_id: u.value.join(),
        site_id: r,
        status: 2
      };
      await n.addCollaboration(x), An.success("\u5DF2\u9080\u8BF7"), t("updateAuthList"), c();
    };
    return (x, D) => {
      const S = qt, C = ti, v = Ac, H = Kh, V = Wh, R = D3, F = fn, K = ni;
      return P(), L("div", null, [
        B(K, {
          modelValue: e.show,
          "onUpdate:modelValue": D[4] || (D[4] = (q) => Bn(show) ? show.value = q : null),
          width: "980px",
          "append-to-body": !0,
          title: "\u6DFB\u52A0\u534F\u4F5C\u8005",
          "before-close": c,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", z4e, [
              B(F, {
                size: "large",
                onClick: c
              }, {
                default: N(() => [
                  D4e
                ]),
                _: 1
              }),
              B(F, {
                type: "primary",
                size: "large",
                onClick: b
              }, {
                default: N(() => [
                  M4e
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", null, [
              T("div", E4e, [
                B(C, {
                  modelValue: E(i).keyWord,
                  "onUpdate:modelValue": D[0] || (D[0] = (q) => E(i).keyWord = q),
                  class: "input-box",
                  size: "large",
                  onKeyup: nn(f, ["native", "enter"]),
                  placeholder: "\u8BF7\u8F93\u5165\u6559\u5E08\u540D\u79F0"
                }, {
                  suffix: N(() => [
                    B(S, { onClick: f }, {
                      default: N(() => [
                        B(E(Gh))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup"]),
                B(v, {
                  modelValue: E(i).organ_id,
                  "onUpdate:modelValue": D[1] || (D[1] = (q) => E(i).organ_id = q),
                  onChange: f,
                  clearable: !0,
                  size: "large",
                  "show-all-levels": !1,
                  options: a.value,
                  props: E(o),
                  placeholder: "\u6240\u5C5E\u673A\u6784",
                  style: { width: "236px" }
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              T("div", k4e, [
                B(V, {
                  data: s.value,
                  height: "300",
                  onSelectionChange: d
                }, {
                  default: N(() => [
                    B(H, {
                      type: "selection",
                      width: "55"
                    }),
                    B(H, {
                      property: "usercode",
                      align: "center",
                      label: "\u5DE5\u53F7",
                      "min-width": "100"
                    }),
                    B(H, {
                      property: "realname",
                      align: "center",
                      label: "\u59D3\u540D",
                      "min-width": "100"
                    }),
                    B(H, {
                      property: "organ_name",
                      align: "center",
                      label: "\u6240\u5C5E\u673A\u6784",
                      "min-width": "130"
                    }),
                    B(H, {
                      property: "phone",
                      align: "center",
                      label: "\u7ED1\u5B9A\u624B\u673A\u53F7",
                      "min-width": "130"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              T("div", O4e, [
                B(R, {
                  onCurrentChange: h,
                  "page-size": E(l).pageSize,
                  "onUpdate:page-size": D[2] || (D[2] = (q) => E(l).pageSize = q),
                  "page-sizes": [10, 20, 30, 40],
                  "current-page": E(l).pageNum,
                  "onUpdate:current-page": D[3] || (D[3] = (q) => E(l).pageNum = q),
                  onSizeChange: p,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: E(l).total
                }, null, 8, ["page-size", "current-page", "total"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
}, I4e = /* @__PURE__ */ Ht(H4e, [["__scopeId", "data-v-73f13162"]]);
const LC = (e) => (yn("data-v-6130b5bf"), e = e(), bn(), e), L4e = { class: "search-box" }, B4e = { class: "table-container table-box" }, N4e = { key: 0 }, j4e = {
  key: 1,
  style: { color: "#A2A2A2" }
}, F4e = { key: 2 }, X4e = /* @__PURE__ */ je(" \u79FB\u9664\u534F\u4F5C\u8005"), R4e = { key: 1 }, V4e = /* @__PURE__ */ je("\u540C\u610F"), U4e = /* @__PURE__ */ je(" \u62D2\u7EDD"), q4e = { class: "footer-btn" }, _4e = /* @__PURE__ */ LC(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tianjia1 add-icon" }, null, -1)), W4e = /* @__PURE__ */ LC(() => /* @__PURE__ */ T("span", null, "\u6DFB\u52A0\u534F\u4F5C\u8005", -1)), K4e = [
  _4e,
  W4e
], G4e = /* @__PURE__ */ je("\u5B8C\u6210"), Y4e = {
  props: {
    showAuthListDialog: Boolean,
    authList: Array
  },
  emits: ["update:showAuthListDialog", "getAuthList"],
  setup(e, { emit: t }) {
    const n = ce("siteId"), r = ce("$http"), i = ce("caseOther"), a = zt({
      keyWord: "",
      organ_id: ""
    }), o = j([]), s = zt({
      checkStrictly: !0,
      emitPath: !1,
      value: "id",
      label: "organName"
    }), l = j(!1), u = () => {
      t("update:showAuthListDialog", !1);
    };
    (async () => {
      const h = await r.getOrganTree();
      o.value = h;
    })();
    const f = () => {
      t("getAuthList", a);
    }, d = async (h, p) => {
      let y = {
        user_id: h.user_id,
        site_id: n,
        status: p
      };
      p === -1 ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u79FB\u9664\u534F\u4F5C\u8005\u5417\uFF1F",
        tipText: `\u79FB\u9664\u540E\u5C06\u4E0D\u80FD\u534F\u4F5C${i.caseTypeName}`,
        confirmButtonText: "\u786E \u5B9A"
      }).then(async () => {
        await r.addCollaboration(y) > 0 && (An.success("\u79FB\u9664\u6210\u529F"), t("getAuthList"));
      }).catch(() => {
      }) : p === 0 ? di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u62D2\u7EDD\u534F\u4F5C\u7533\u8BF7\u5417\uFF1F",
        tipText: `\u62D2\u7EDD\u540E\u7533\u8BF7\u4EBA\u5C06\u4E0D\u80FD\u534F\u4F5C${i.caseTypeName}`,
        confirmButtonText: "\u786E \u5B9A"
      }).then(async () => {
        await r.addCollaboration(y) > 0 && (An.success("\u5DF2\u62D2\u7EDD"), t("getAuthList"));
      }).catch(() => {
      }) : await r.addCollaboration(y) > 0 && (An.success("\u5DF2\u901A\u8FC7"), t("getAuthList"));
    };
    return (h, p) => {
      const y = qt, m = ti, b = Ac, x = Kh, D = fn, S = Wh, C = ni;
      return P(), L(nt, null, [
        B(C, {
          modelValue: e.showAuthListDialog,
          "onUpdate:modelValue": p[3] || (p[3] = (v) => Bn(showAuthListDialog) ? showAuthListDialog.value = v : null),
          width: 980,
          "append-to-body": "",
          "before-close": u,
          title: `${E(i).caseTypeName}\u534F\u4F5C\u8005`
        }, {
          footer: N(() => [
            T("div", q4e, [
              T("div", {
                class: "add-btn",
                onClick: p[2] || (p[2] = (v) => l.value = !0)
              }, K4e),
              B(D, {
                type: "primary",
                size: "large",
                onClick: u
              }, {
                default: N(() => [
                  G4e
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", null, [
              T("div", L4e, [
                B(m, {
                  modelValue: E(a).keyWord,
                  "onUpdate:modelValue": p[0] || (p[0] = (v) => E(a).keyWord = v),
                  class: "input-box",
                  onKeyup: nn(f, ["native", "enter"]),
                  size: "large",
                  placeholder: "\u8BF7\u8F93\u5165\u6559\u5E08\u540D\u79F0"
                }, {
                  suffix: N(() => [
                    B(y, { onClick: f }, {
                      default: N(() => [
                        B(E(Gh))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup"]),
                B(b, {
                  modelValue: E(a).organ_id,
                  "onUpdate:modelValue": p[1] || (p[1] = (v) => E(a).organ_id = v),
                  clearable: !0,
                  onChange: f,
                  "show-all-levels": !1,
                  options: o.value,
                  props: E(s),
                  size: "large",
                  style: { width: "236px" },
                  placeholder: "\u6240\u5C5E\u673A\u6784"
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              T("div", B4e, [
                B(S, {
                  data: e.authList,
                  height: "300"
                }, {
                  default: N(() => [
                    B(x, {
                      property: "usercode",
                      label: "\u5DE5\u53F7",
                      align: "center",
                      "min-width": "100"
                    }),
                    B(x, {
                      property: "realname",
                      label: "\u59D3\u540D",
                      align: "center",
                      "min-width": "100"
                    }),
                    B(x, {
                      property: "organ_name",
                      label: "\u6240\u5C5E\u673A\u6784",
                      align: "center",
                      "min-width": "130"
                    }),
                    B(x, {
                      label: "\u72B6\u6001",
                      align: "center",
                      "min-width": "130"
                    }, {
                      default: N((v) => [
                        v.row.status == 1 ? (P(), L("span", N4e, "\u534F\u4F5C\u8005")) : v.row.status == 2 ? (P(), L("span", j4e, "\u5F85\u63A5\u53D7\u9080\u8BF7")) : (P(), L("span", F4e, "\u7533\u8BF7\u534F\u4F5C"))
                      ]),
                      _: 1
                    }),
                    B(x, {
                      label: "\u64CD\u4F5C",
                      align: "center",
                      "min-width": "130"
                    }, {
                      default: N((v) => [
                        v.row.status == 1 ? (P(), ue(D, {
                          key: 0,
                          type: "text",
                          style: { color: "#FF4800" },
                          onClick: (H) => d(v.row, -1)
                        }, {
                          default: N(() => [
                            X4e
                          ]),
                          _: 2
                        }, 1032, ["onClick"])) : v.row.status == 3 ? (P(), L("div", R4e, [
                          B(D, {
                            type: "text",
                            class: "table-btn",
                            onClick: (H) => d(v.row, 1)
                          }, {
                            default: N(() => [
                              V4e
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          B(D, {
                            type: "text",
                            class: "table-btn",
                            style: { color: "#EE8337" },
                            onClick: (H) => d(v.row, 0)
                          }, {
                            default: N(() => [
                              U4e
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])) : re("", !0)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        l.value ? (P(), ue(I4e, {
          key: 0,
          show: l.value,
          "onUpdate:show": p[4] || (p[4] = (v) => l.value = v),
          onUpdateAuthList: p[5] || (p[5] = () => t("getAuthList"))
        }, null, 8, ["show"])) : re("", !0)
      ], 64);
    };
  }
}, P2 = /* @__PURE__ */ Ht(Y4e, [["__scopeId", "data-v-6130b5bf"]]), rv = (e) => {
  const t = ce("$http"), n = async (f) => {
    const d = await t.caseIsNeedCheck({ business_type: f });
    return e.isNeedCheck = d.switch_status, e.isNeedCheck == 2 ? Promise.resolve() : Promise.reject();
  }, r = async (f) => {
    const d = {
      task_id: f
    }, { status: h, review_ed: p, role_name: y } = await t.getCaseCheckStatus(d);
    e.checkStatus = +h, e.checkIsStart = p, e.roleName = y;
  };
  return {
    checkInfo: e,
    getCaseIsNeedCheck: n,
    getCaseCheckStatus: r,
    handleResetCheckStatus: (f) => {
      e.checkStatus = f;
    },
    updateCheckInfo: (f, d) => {
      window.location.replace(`${document.URL}&progressId=${f}`), r(d);
    },
    getCheckComment: async (f) => {
      const {
        create_time: d,
        review_comments: h,
        operation_type: p,
        realname_valid: y,
        review_comments_valid: m,
        valid_status: b
      } = await t.getCaseCheckComment({ review_progress_id: f });
      e.checkTime = d, e.comment = h, e.operation_type = p, e.realname_valid = y, e.review_comments_valid = m, e.valid_status = b;
    },
    handleSubmitCheck: async (f, d, h) => {
      await di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u8BF7\u786E\u4FDD\u60A8\u521B\u5EFA\u7684\u6848\u4F8B\u5185\u5BB9\u51C6\u786E\u65E0\u8BEF",
        tipText: "\u63D0\u4EA4\u540E\u5C06\u65E0\u6CD5\u4FEE\u6539\uFF0C\u82E5\u65E0\u8BEF\u8BF7\u70B9\u51FB\u3010\u786E\u8BA4\u63D0\u4EA4\u3011\u6309\u94AE",
        confirmButtonText: "\u786E\u8BA4\u63D0\u4EA4",
        cancelButtonText: "\u8FD4\u56DE\u4FEE\u6539"
      });
      try {
        d == 1 && await t.submitCollaboration(f), await t.caseSubmitCheck({ taskId: h }), r(h);
      } catch (p) {
        yi.error(p.message);
      }
    },
    handleCancelCheck: (f) => {
      e.checkIsStart || di({
        headerTitle: "\u64A4\u56DE\u5BA1\u6838",
        tipTitle: "\u786E\u5B9A\u64A4\u56DE\u5417\uFF1F",
        tipText: "\u64A4\u56DE\u540E\uFF0C\u60A8\u53EF\u91CD\u65B0\u4FEE\u6539\u6848\u4F8B\u5185\u5BB9\u540E\u518D\u63D0\u4EA4"
      }).then(async () => {
        await t.caseCancelCheck({ taskId: f }), r(f);
      }).catch(() => {
      });
    },
    creatorCheckText: () => {
      if (e.checkIsStart && e.checkStatus == 1)
        return e.roleName + "\u5BA1\u6838\u4E2D";
      if (e.checkStatus == 2)
        return "\u9A73\u56DE\u5F85\u63D0\u4EA4";
      if (!e.checkIsStart && e.checkStatus == 1)
        return "\u5DF2\u63D0\u4EA4\u5F85\u5BA1\u6838";
      if (e.checkStatus == 3)
        return "\u5BA1\u6838\u901A\u8FC7";
    },
    allCheckText: () => e.checkStatus == 0 ? "\u672A\u63D0\u4EA4\u5BA1\u6838" : e.checkStatus == 1 ? e.roleName + "\u5BA1\u6838\u4E2D" : e.checkStatus == 2 ? "\u5BA1\u6838\u9A73\u56DE\u5F85\u63D0\u4EA4" : e.checkStatus == 3 ? "\u5BA1\u6838\u901A\u8FC7" : "\u64A4\u56DE\u5F85\u63D0\u4EA4"
  };
}, Wl = (e) => {
  const t = ce("$http"), n = j([]), r = j([]);
  return {
    allUnsubmittedNoteList: n,
    unsubmittedNoteList: r,
    getUnsubmittedNoteList: async (s) => {
      const l = {
        column_id: s || 0,
        site_id: e
      };
      let u = await t.getNoSubmitAnnotationList(l);
      s ? r.value = u : n.value = u;
    },
    delComments: (s, l) => {
      console.log("delid", s), di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8BE5\u6279\u6CE8\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001",
        confirmButtonText: "\u5220 \u9664"
      }).then(async () => {
        const u = await t.delAnnotation({ id: s });
        console.log(u), yi({
          type: "success",
          message: "\u5220\u9664\u6210\u529F!"
        }), l();
      }).catch(() => {
      });
    },
    submitAnnotation: (s) => {
      di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u63D0\u4EA4\u6240\u6709\u6279\u6CE8\u5417\uFF1F",
        tipText: "\u6279\u6CE8\u63D0\u4EA4\u540E\uFF0C\u521B\u5EFA\u8005\u5C06\u53EF\u4EE5\u770B\u5230\u6240\u6709\u7684\u6279\u6CE8\u5185\u5BB9",
        confirmButtonText: "\u63D0 \u4EA4"
      }).then(async () => {
        const l = await t.annotationSubmit({
          site_id: e,
          column_id: 0
        });
        console.log(l), yi({
          type: "success",
          message: "\u63D0\u4EA4\u6210\u529F!"
        }), s();
      }).catch(() => {
      });
    }
  };
}, Q4e = { class: "unsubmitted-item-title" }, Z4e = { class: "unsubmitted-item-title-avatar" }, J4e = ["src"], $4e = { class: "unsubmitted-item-title-info" }, e3e = { class: "unsubmitted-item-message" }, t3e = {
  key: 0,
  class: "unsubmitted-item-content"
}, n3e = {
  key: 1,
  class: "unsubmitted-item-content"
}, i3e = /* @__PURE__ */ Ee({
  props: {
    item: {
      type: Object
    }
  },
  setup(e) {
    const t = ce("$utils"), n = ce("siteId"), r = ce("$bus"), i = ce("caseOther"), { delComments: a } = Wl(n), o = (u) => {
      if (u) {
        let c = u.split("-");
        return `[${i == null ? void 0 : i.caseTypeName}\u89C6\u9891] ` + t.dateTransfer(parseInt(c[0])) + "-" + t.dateTransfer(parseInt(c[1]));
      }
      return "";
    }, s = (u) => {
      a(u, function() {
        r.emit("updateContent");
      });
    }, l = (u) => {
      r.emit("goCommentPosition", u);
    };
    return (u, c) => e.item ? (P(), L("div", {
      key: 0,
      class: "unsubmitted-item",
      onClick: c[1] || (c[1] = (f) => l(e.item))
    }, [
      T("div", Q4e, [
        T("div", Z4e, [
          T("img", {
            src: e.item.avatar ? e.item.avatar : E(t).getImage("diffMark/user_icon.png")
          }, null, 8, J4e)
        ]),
        T("div", $4e, [
          T("div", null, de(e.item.userName), 1),
          T("div", null, de(E(t).formatDate(e.item.createTime)), 1)
        ]),
        +e.item.isMyCreate == 1 ? (P(), L("div", {
          key: 0,
          class: "unsubmitted-item-title-del",
          onClick: c[0] || (c[0] = wt((f) => s(e.item.id), ["stop"]))
        }, " \u5220\u9664 ")) : re("", !0)
      ]),
      T("div", e3e, de(e.item.annotationMessage), 1),
      +e.item.columnType == 3 ? (P(), L("div", t3e, de(o(e.item.annotationText)), 1)) : (P(), L("div", n3e, de(e.item.annotationText), 1))
    ])) : re("", !0);
  }
});
const av = /* @__PURE__ */ Ht(i3e, [["__scopeId", "data-v-91e73ecd"]]), r3e = "/video/addAnnotionVideo.mp4";
const BC = (e) => (yn("data-v-63ec2983"), e = e(), bn(), e), a3e = { class: "tip-dialog-wrapper" }, o3e = /* @__PURE__ */ BC(() => /* @__PURE__ */ T("div", { class: "tip-title" }, [
  /* @__PURE__ */ T("div", { class: "top" }, "\u5982\u4F55\u6DFB\u52A0\u6279\u6CE8\uFF1F"),
  /* @__PURE__ */ T("div", { class: "text" }, " \u5728\u6587\u672C\u5C55\u793A\u533A\u57DF\u7528\u9F20\u6807\u9009\u4E2D\u8981\u6279\u6CE8\u7684\u5185\u5BB9\uFF0C\u70B9\u51FB\u6DFB\u52A0\u6279\u6CE8,\u8F93\u5165\u6279\u6CE8\u5185\u5BB9\u4FDD\u5B58\u5373\u53EF ")
], -1)), s3e = /* @__PURE__ */ BC(() => /* @__PURE__ */ T("div", { class: "video-area" }, [
  /* @__PURE__ */ T("video", {
    class: "video-box",
    controls: "",
    autoplay: ""
  }, [
    /* @__PURE__ */ T("source", {
      src: r3e,
      type: "video/mp4"
    })
  ])
], -1)), l3e = {
  props: {
    showTipDialog: Boolean
  },
  emits: ["closeTipDialog", "update:showTipDialog"],
  setup(e, { emit: t }) {
    const n = () => {
      t("update:showTipDialog", !1);
    };
    return (r, i) => {
      const a = ni;
      return P(), L("div", a3e, [
        B(a, {
          modelValue: e.showTipDialog,
          "onUpdate:modelValue": i[0] || (i[0] = (o) => Bn(showTipDialog) ? showTipDialog.value = o : null),
          width: "818px",
          "before-close": n,
          "destroy-on-close": ""
        }, {
          title: N(() => [
            o3e
          ]),
          default: N(() => [
            s3e
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
}, u3e = /* @__PURE__ */ Ht(l3e, [["__scopeId", "data-v-63ec2983"]]);
const c3e = {
  key: 0,
  class: "opinion"
}, d3e = ["innerHTML"], f3e = {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = j(!0), r = j(!1), i = j(null), a = J(() => E(n) ? "auto" : "40px"), o = async () => {
      n.value = !0, r.value = !1, await bt();
      let s = i.value.offsetHeight;
      console.log("offsetHeight :>> ", s), s > 40 && (n.value = !1, r.value = !0);
    };
    return Ne(
      () => t.content,
      (s) => {
        s && o();
      },
      {
        immediate: !0
      }
    ), (s, l) => {
      const u = qt;
      return e.content ? (P(), L("div", c3e, [
        T("div", {
          class: "info",
          innerHTML: e.content,
          ref_key: "opinion",
          ref: i,
          style: Pt({ height: E(a) })
        }, null, 12, d3e),
        r.value ? (P(), ue(u, {
          key: 0,
          class: se(["icon", { rotate: n.value }]),
          size: 16,
          onClick: l[0] || (l[0] = (c) => n.value = !n.value)
        }, {
          default: N(() => [
            B(E(FT))
          ]),
          _: 1
        }, 8, ["class"])) : re("", !0)
      ])) : re("", !0);
    };
  }
}, h3e = /* @__PURE__ */ Ht(f3e, [["__scopeId", "data-v-b234f926"]]);
const p3e = { class: "checker-dialog-wrapper" }, v3e = { class: "title" }, m3e = { class: "checker-list" }, g3e = {
  props: {
    show: Boolean,
    userIds: Array,
    checkRoleInfo: String
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, { getCheckerInfo: r } = ce("$http"), i = () => {
      t("update:show", !1);
    }, a = j([]);
    return (async () => {
      const s = await r({ userIds: n.userIds.join(",") });
      a.value = s || [];
    })(), (s, l) => {
      const u = ni;
      return P(), L("div", p3e, [
        B(u, {
          modelValue: e.show,
          "onUpdate:modelValue": l[0] || (l[0] = (c) => Bn(show) ? show.value = c : null),
          width: "500px",
          "before-close": i,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          title: N(() => [
            T("span", v3e, de(e.checkRoleInfo), 1)
          ]),
          default: N(() => [
            T("ol", m3e, [
              (P(!0), L(nt, null, Lt(a.value, (c, f) => (P(), L("li", {
                class: "checker-item",
                key: f
              }, de(`${f + 1}\u3001${c.userName}\uFF08${c.orgName || "-"}\uFF09`), 1))), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
}, y3e = /* @__PURE__ */ Ht(g3e, [["__scopeId", "data-v-8e2929b1"]]);
const b3e = (e) => (yn("data-v-0f02644a"), e = e(), bn(), e), A3e = /* @__PURE__ */ b3e(() => /* @__PURE__ */ T("div", { class: "progress_drawer_title" }, "\u5BA1\u6838\u8FDB\u5EA6", -1)), T3e = { class: "info-title" }, w3e = { class: "info-title_left" }, P3e = ["onClick"], x3e = { key: 1 }, C3e = { class: "operate-roleName" }, S3e = { class: "info-title_right" }, E3e = {
  key: 0,
  class: "info-content"
}, k3e = {
  props: {
    isFounder: {
      type: Boolean,
      default: !1
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    taskId: {
      type: [Number, String],
      default: 0
    }
  },
  emits: ["update:isShow"],
  setup(e, { emit: t }) {
    const n = e, r = j(!1), i = j([]), a = j(""), o = (m) => {
      i.value = m.userIds, a.value = m.operateRoleName, r.value = !0;
    }, { getTaskReviewProgress: s, getCreateUserTaskReviewProgress: l } = ce("$http");
    let u = j([]);
    const c = async () => {
      const m = await (n.isFounder ? l : s)({
        taskId: n.taskId
      }), b = m[m.length - 1];
      u.value = [
        ...m,
        {
          progressTitle: "\u5B8C\u6210\u5BA1\u6838",
          operateStatus: b.operateStatus === 5 ? 0 : b.operateStatus
        }
      ];
    }, f = () => {
      t("update:isShow", !1);
    }, d = (m) => Cy(m, "YYYY/MM/DD HH:mm:ss"), h = (m) => {
      switch (m) {
        case 0:
          return "\u5F85\u5904\u7406";
        case 1:
          return "\u63D0\u4EA4\u5BA1\u6838";
        case 2:
          return "\u5BA1\u6838\u901A\u8FC7";
        case 3:
          return "\u5BA1\u6838\u9A73\u56DE";
        case 4:
          return "\u5BA1\u6838\u64A4\u56DE";
        case 5:
          return "\u6D41\u7A0B\u65E0\u4EBA\u5BA1\u6838";
        default:
          return "\u5BA1\u6838\u4E2D";
      }
    }, p = (m) => {
      switch (m) {
        case 1:
        case 2:
          return "#19AD7E";
        case 3:
        case 4:
        case 5:
        case 6:
          return "#FA5151";
        default:
          return "#666666";
      }
    }, y = (m, b) => {
      switch (m) {
        case 2:
          return "\u901A\u8FC7\u610F\u89C1\uFF1A" + b;
        case 3:
          return "\u9A73\u56DE\u610F\u89C1\uFF1A" + b;
        default:
          return b;
      }
    };
    return rn(() => {
      c();
    }), (m, b) => {
      const x = _$, D = q$, S = SK;
      return P(), L(nt, null, [
        E(u) ? (P(), ue(S, {
          key: 0,
          "before-close": f,
          "custom-class": "progress_drawer",
          modelValue: e.isShow,
          "onUpdate:modelValue": b[0] || (b[0] = (C) => Bn(isShow) ? isShow.value = C : null),
          direction: "rtl",
          "append-to-body": !0,
          "lock-scroll": !0
        }, {
          title: N(() => [
            A3e
          ]),
          default: N(() => [
            E(u) ? (P(), ue(D, { key: 0 }, {
              default: N(() => [
                (P(!0), L(nt, null, Lt(E(u), (C, v) => (P(), ue(x, {
                  key: v,
                  size: "normal",
                  class: se({
                    active: C.operateStatus !== 0
                  })
                }, {
                  default: N(() => [
                    T("div", T3e, [
                      T("div", w3e, [
                        T("span", {
                          class: se(["progress-title", {
                            "red-title": C.progressTitle === "\u672A\u8BBE\u7F6E\u5BA1\u6838\u5458"
                          }])
                        }, [
                          C.userIds && C.userIds.length > 3 ? (P(), L("span", {
                            key: 0,
                            style: { cursor: "pointer" },
                            onClick: (H) => o(C)
                          }, de(C.progressTitle + " >"), 9, P3e)) : (P(), L("span", x3e, de(C.progressTitle), 1))
                        ], 2),
                        T("span", C3e, de(C.operateRoleName) + " " + de(C.approvalMethod), 1)
                      ]),
                      T("div", S3e, de(d(C.operateTime)), 1)
                    ]),
                    C.progressTitle != "\u5B8C\u6210\u5BA1\u6838" ? (P(), L("div", E3e, [
                      T("div", {
                        class: "info-content_title",
                        style: Pt({ color: p(C.operateStatus) })
                      }, de(h(C.operateStatus)), 5),
                      C.reviewComments ? (P(), ue(h3e, {
                        key: 0,
                        content: y(C.operateStatus, C.reviewComments)
                      }, null, 8, ["content"])) : re("", !0)
                    ])) : re("", !0)
                  ]),
                  _: 2
                }, 1032, ["class"]))), 128))
              ]),
              _: 1
            })) : re("", !0)
          ]),
          _: 1
        }, 8, ["modelValue"])) : re("", !0),
        r.value ? (P(), ue(y3e, {
          key: 1,
          show: r.value,
          "onUpdate:show": b[1] || (b[1] = (C) => r.value = C),
          "user-ids": i.value,
          checkRoleInfo: a.value
        }, null, 8, ["show", "user-ids", "checkRoleInfo"])) : re("", !0)
      ], 64);
    };
  }
}, NC = /* @__PURE__ */ Ht(k3e, [["__scopeId", "data-v-0f02644a"]]), O3e = { class: "check-dialog-wrapper" }, z3e = { class: "title" }, D3e = { class: "operate-box" }, M3e = /* @__PURE__ */ je("\u53D6\u6D88"), H3e = /* @__PURE__ */ je("\u786E\u5B9A"), I3e = /* @__PURE__ */ Ee({
  props: {
    show: Boolean,
    checkType: Number
  },
  emits: ["update:show", "updateCheckInfo"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$http"), i = ce("caseOther"), a = zt({
      reviewComments: "",
      status: 1,
      taskId: ""
    }), o = () => {
      t("update:show", !1);
    }, s = async () => {
      a.status = n.checkType, a.taskId = i.taskId;
      try {
        const l = await r.caseCheck(a);
        t("updateCheckInfo", l), o(), window.history.back();
      } catch (l) {
        l.code == 40001 ? setTimeout(() => {
          window.history.back();
        }, 3e3) : l.code == 40002 && t("updateCheckInfo", l.data), yi.error(l.message), o();
      }
    };
    return (l, u) => {
      const c = ti, f = fn, d = ni;
      return P(), L("div", O3e, [
        B(d, {
          modelValue: e.show,
          "onUpdate:modelValue": u[1] || (u[1] = (h) => Bn(show) ? show.value = h : null),
          width: "630px",
          "before-close": o,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          title: N(() => [
            T("span", z3e, de(e.checkType == 1 ? "\u5BA1\u6838\u901A\u8FC7" : "\u5BA1\u6838\u9A73\u56DE"), 1)
          ]),
          footer: N(() => [
            T("div", D3e, [
              B(f, {
                size: "large",
                class: "btn",
                onClick: o
              }, {
                default: N(() => [
                  M3e
                ]),
                _: 1
              }),
              B(f, {
                type: "primary",
                class: "btn",
                size: "large",
                onClick: s
              }, {
                default: N(() => [
                  H3e
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", null, [
              B(c, {
                modelValue: E(a).reviewComments,
                "onUpdate:modelValue": u[0] || (u[0] = (h) => E(a).reviewComments = h),
                type: "textarea",
                rows: 7,
                maxlength: "1000",
                resize: "none",
                "show-word-limit": !0,
                placeholder: "\u8BF7\u8F93\u5165\u5BA1\u6838\u610F\u89C1\uFF0C1000\u5B57\u4EE5\u5185"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
});
const jC = /* @__PURE__ */ Ht(I3e, [["__scopeId", "data-v-d7fa1525"]]);
const L3e = (e) => (yn("data-v-ea8d708b"), e = e(), bn(), e), B3e = { class: "comment-dialog-wrapper" }, N3e = /* @__PURE__ */ L3e(() => /* @__PURE__ */ T("span", { class: "title" }, "\u5BA1\u6838\u610F\u89C1", -1)), j3e = ["innerHTML"], F3e = {
  props: {
    show: Boolean,
    comment: String
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = () => {
      t("update:show", !1);
    };
    return (r, i) => {
      const a = ni;
      return P(), L("div", B3e, [
        B(a, {
          modelValue: e.show,
          "onUpdate:modelValue": i[0] || (i[0] = (o) => Bn(show) ? show.value = o : null),
          width: "500px",
          "before-close": n,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          title: N(() => [
            N3e
          ]),
          default: N(() => [
            T("div", {
              class: "check-content",
              innerHTML: e.comment
            }, null, 8, j3e)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
}, FC = /* @__PURE__ */ Ht(F3e, [["__scopeId", "data-v-ea8d708b"]]), XC = (e, t) => {
  const n = ce("$http"), r = j({}), i = zt({
    id: "",
    caseAuth: 1,
    courseId: "",
    groupId: "",
    source: 0,
    caseRole: 0,
    taskId: "",
    caseTypeName: "",
    caseType: ""
  }), a = j([]), o = j([
    {
      id: -1,
      major_name: "\u5168\u90E8\u4E13\u4E1A"
    }
  ]), s = async () => {
    const p = await n.getIdeologyTree();
    a.value = p || [], a.value = l(p, 2, {
      id: "add",
      ideologyName: "+\u6DFB\u52A0\u65B0\u5143\u7D20",
      leaf: "leaf",
      disabled: "disabled",
      level: 3
    });
  }, l = (p, y, m) => (p.forEach((b) => {
    b.level === y && b.children && (b.children.find((x) => x.id === m.id) || b.children.unshift(m)), b.children && b.level < 2 && l(b.children, y, m);
  }), p), u = async () => {
    const p = await n.getMajorList();
    o.value = o.value.concat(p);
  }, c = async (p) => {
    await n.editCase(p), yi.success("\u4FDD\u5B58\u6210\u529F"), t.emit("contentChange", 1);
  }, f = async () => {
    const p = await n.getCaseSimInfo({ site_id: e });
    if (console.log("info", p), r.value = p, i.id = p.business_id, p.business_type.includes("bk_case") ? (i.source = 3, i.caseTypeName = p.business_type_name || "\u6559\u6848", h(i.courseId)) : p.business_type == "al_course_case" ? (i.source = 1, i.caseTypeName = "\u6848\u4F8B") : p.business_type == "al_course_model" ? (i.source = 2, i.caseTypeName = "\u8BFE\u7A0B") : p.business_type == "bk_syllabi_outline" && (i.source = 4, i.caseTypeName = "\u5927\u7EB2"), i.caseType = p.business_type, !p.extend) {
      yi.error(`${i.caseTypeName}\u5DF2\u5220\u9664`);
      return;
    }
    i.caseAuth = p.extend.permission, i.courseId = p.extend.course_id, i.taskId = p.extend.task_id;
  }, d = async () => {
    const p = await n.getCaseUserRole(e);
    i.caseRole = p;
  }, h = async (p) => {
    const { zhs_group_id: y } = await n.getTeamIdByCourse({ courseId: p });
    i.groupId = y;
  };
  return {
    caseInfo: r,
    caseOther: i,
    ideologyList: a,
    majorList: o,
    getCaseInfo: f,
    updateCaseBase: c,
    getIdeology: s,
    getMajorList: u,
    getCaseUserRole: d
  };
}, RC = (e) => {
  const t = ce("$http"), n = j(0);
  return {
    caseQuoteConfig: n,
    isNeedQuoteCase: async () => {
      const o = (await t.quoteCaseConfig()).find((s) => s.function_key == 1);
      o && (n.value = o == null ? void 0 : o.function_value);
    },
    quoteCaseInfo: async (a) => {
      let o = {
        ...a,
        site_id: e
      };
      const s = await t.quoteCaseCenter(o);
      An.success("\u5F15\u7528\u6210\u529F"), setTimeout(() => {
        window.localStorage.setItem("currentUrl", document.URL), window.location.href = `${document.URL.split("?")[0]}?siteId=${s}&type=3`;
      }, 2e3);
    }
  };
}, X3e = { class: "search-box" }, R3e = { class: "table-container table-box" }, V3e = { class: "page-box" }, U3e = { class: "dialog-footer" }, q3e = /* @__PURE__ */ je("\u53D6\u6D88"), _3e = /* @__PURE__ */ je("\u786E\u5B9A"), W3e = /* @__PURE__ */ Ee({
  props: {
    show: Boolean
  },
  emits: ["update:show", "handleSelectedCourse"],
  setup(e, { emit: t }) {
    const n = ce("$http"), r = ce("userInfo"), i = zt({
      keyWord: r.realname,
      organ_id: ""
    }), a = j([]), o = zt({
      checkStrictly: !0,
      emitPath: !1,
      value: "id",
      label: "organName"
    }), s = j([]), l = zt({
      pageNum: 1,
      pageSize: 10,
      total: 0
    }), u = zt({
      id: "",
      course_name: ""
    }), c = j(""), f = () => {
      t("update:show", !1);
    }, d = () => {
      l.pageNum = 1, b();
    }, h = (D) => {
      u.id = D.id, u.course_name = D.course_name;
    }, p = (D) => {
      l.pageNum = D, b();
    }, y = (D) => {
      l.pageSize = D, l.pageNum = 1, b();
    }, m = async () => {
      const D = await n.getOrganTree();
      a.value = D;
    }, b = async () => {
      let D = {
        "_pageable.page": l.pageNum - 1,
        "_pageable.size": l.pageSize,
        keyWord: i.keyWord || void 0,
        organ_id: i.organ_id || void 0
      };
      const S = await n.getCaseCourseList(D);
      s.value = S.content || [], l.total = +S.totalElements;
    };
    m(), b();
    const x = () => {
      if (!u.id) {
        An.warning("\u8BF7\u9009\u62E9\u8BFE\u7A0B");
        return;
      }
      t("handleSelectedCourse", u), f();
    };
    return (D, S) => {
      const C = qt, v = ti, H = Ac, V = b3, R = Kh, F = Wh, K = D3, q = fn, G = ni;
      return P(), L("div", null, [
        B(G, {
          modelValue: e.show,
          "onUpdate:modelValue": S[5] || (S[5] = (te) => Bn(show) ? show.value = te : null),
          width: "980px",
          "append-to-body": !0,
          title: "\u9009\u62E9\u8BFE\u7A0B",
          "before-close": f,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", U3e, [
              B(q, {
                size: "large",
                onClick: f
              }, {
                default: N(() => [
                  q3e
                ]),
                _: 1
              }),
              B(q, {
                type: "primary",
                size: "large",
                onClick: x
              }, {
                default: N(() => [
                  _3e
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", null, [
              T("div", X3e, [
                B(v, {
                  modelValue: E(i).keyWord,
                  "onUpdate:modelValue": S[0] || (S[0] = (te) => E(i).keyWord = te),
                  class: "input-box",
                  size: "large",
                  onKeyup: nn(d, ["native", "enter"]),
                  placeholder: "\u8BF7\u8F93\u5165\u8001\u5E08/\u8BFE\u7A0B\u540D\u79F0"
                }, {
                  suffix: N(() => [
                    B(C, { onClick: d }, {
                      default: N(() => [
                        B(E(Gh))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup"]),
                B(H, {
                  modelValue: E(i).organ_id,
                  "onUpdate:modelValue": S[1] || (S[1] = (te) => E(i).organ_id = te),
                  onChange: d,
                  clearable: !0,
                  size: "large",
                  "show-all-levels": !1,
                  options: a.value,
                  props: E(o),
                  placeholder: "\u6240\u5C5E\u673A\u6784",
                  style: { width: "236px" }
                }, null, 8, ["modelValue", "options", "props"])
              ]),
              T("div", R3e, [
                B(F, {
                  data: s.value,
                  height: "300"
                }, {
                  default: N(() => [
                    B(R, {
                      property: "id",
                      align: "center",
                      width: "50"
                    }, {
                      default: N((te) => [
                        B(V, {
                          modelValue: c.value,
                          "onUpdate:modelValue": S[2] || (S[2] = (Q) => c.value = Q),
                          label: te.row.id,
                          class: "table-radio",
                          onChange: (Q) => h(te.row)
                        }, null, 8, ["modelValue", "label", "onChange"])
                      ]),
                      _: 1
                    }),
                    B(R, {
                      property: "course_code",
                      align: "center",
                      label: "\u8BFE\u7A0B\u7F16\u53F7",
                      width: "100"
                    }),
                    B(R, {
                      property: "course_name",
                      align: "center",
                      label: "\u8BFE\u7A0B\u540D\u79F0",
                      "min-width": "120"
                    }),
                    B(R, {
                      property: "classify_name",
                      align: "center",
                      label: "\u8BFE\u7A0B\u7C7B\u578B",
                      "min-width": "100"
                    }),
                    B(R, {
                      property: "organ_name",
                      align: "center",
                      label: "\u5F00\u8BFE\u673A\u6784",
                      "min-width": "120"
                    }),
                    B(R, {
                      property: "user_name",
                      align: "center",
                      label: "\u8BFE\u7A0B\u8D1F\u8D23\u4EBA",
                      "min-width": "100"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              T("div", V3e, [
                B(K, {
                  onCurrentChange: p,
                  "page-size": E(l).pageSize,
                  "onUpdate:page-size": S[3] || (S[3] = (te) => E(l).pageSize = te),
                  "page-sizes": [10, 20, 30, 40],
                  "current-page": E(l).pageNum,
                  "onUpdate:current-page": S[4] || (S[4] = (te) => E(l).pageNum = te),
                  onSizeChange: y,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: E(l).total
                }, null, 8, ["page-size", "current-page", "total"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]);
    };
  }
});
const K3e = /* @__PURE__ */ Ht(W3e, [["__scopeId", "data-v-ab45d01b"]]), G3e = { class: "dialog-footer" }, Y3e = /* @__PURE__ */ je("\u53D6\u6D88"), Q3e = /* @__PURE__ */ je("\u4FDD\u5B58"), Z3e = /* @__PURE__ */ Ee({
  props: {
    isShow: {
      type: Boolean,
      default: !1
    },
    addForm: Object
  },
  emits: ["update:isShow", "updateIdeology"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$http"), i = j(), a = j({ ideology_name: "", level: 0, parent_id: "" }), o = {
      ideology_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u5143\u7D20\u540D\u79F0", trigger: "blur" }]
    };
    Ne(
      () => n.addForm,
      (u) => {
        u && (a.value = u);
      },
      { immediate: !0 }
    );
    const s = () => {
      a.value.ideology_name = "", t("update:isShow", !1);
    }, l = () => {
      i.value.validate(async (u) => {
        if (u) {
          const c = await r.addIdeologyItem(a.value);
          if (c.count > 0)
            return An.error(c.msg);
          An({
            type: "success",
            message: "\u4FDD\u5B58\u6210\u529F!"
          }), s(), t("updateIdeology");
        } else
          return console.log("error submit!!"), !1;
      });
    };
    return (u, c) => {
      const f = ti, d = Sa, h = Ca, p = fn, y = ni;
      return e.isShow ? (P(), ue(y, {
        key: 0,
        title: "\u65B0\u589E\u5143\u7D20",
        modelValue: e.isShow,
        "onUpdate:modelValue": c[2] || (c[2] = (m) => Bn(isShow) ? isShow.value = m : null),
        width: "500px",
        "before-close": s,
        "close-on-click-modal": !1
      }, {
        footer: N(() => [
          T("div", G3e, [
            B(p, {
              plain: "",
              onClick: s
            }, {
              default: N(() => [
                Y3e
              ]),
              _: 1
            }),
            B(p, {
              plain: "",
              type: "primary",
              onClick: c[1] || (c[1] = (m) => l())
            }, {
              default: N(() => [
                Q3e
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(h, {
            ref_key: "formRef",
            ref: i,
            model: a.value,
            "label-width": "80px",
            rules: o
          }, {
            default: N(() => [
              B(d, {
                label: "\u5143\u7D20\u540D\u79F0",
                prop: "ideology_name"
              }, {
                default: N(() => [
                  B(f, {
                    modelValue: a.value.ideology_name,
                    "onUpdate:modelValue": c[0] || (c[0] = (m) => a.value.ideology_name = m),
                    placeholder: "\u8BF7\u8F93\u5165\u5143\u7D20\u540D\u79F0",
                    maxlength: "50"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"])) : re("", !0);
    };
  }
}), J3e = ["onClick"], $3e = { key: 1 }, e6e = { class: "dialog-footer" }, t6e = /* @__PURE__ */ je("\u4FDD \u5B58"), n6e = /* @__PURE__ */ Ee({
  props: {
    show: Boolean,
    fieldsForm: Object,
    type: {
      type: Number,
      default: 1
    }
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, r = Vs(n, "show", t), i = ce("$bus"), a = ce("siteId"), o = ce("$http"), s = j(!1), l = j(), u = j({
      id: "",
      case_name: "",
      course_id: "",
      course_name: "",
      major_ids: "",
      ideology_ids: "",
      chapter_name: "",
      ideologyIds: [],
      majorIds: []
    }), c = {
      multiple: !0,
      emitPath: !1,
      value: "id",
      label: "ideologyName"
    }, f = zt({
      status: !0,
      functionId: "11008"
    }), d = zt({
      status: !0,
      functionId: "11004"
    }), h = {
      case_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u6848\u4F8B\u540D\u79F0", trigger: "blur" }],
      course_id: [{ required: !0, message: "\u8BF7\u8F93\u5165\u8BFE\u7A0B\u8D1F\u8D23\u4EBA", trigger: "change" }],
      chapter_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u7AE0\u8282\u540D\u79F0", trigger: "blur" }],
      ideologyIds: [{ required: !0, message: "\u8BF7\u9009\u62E9\u601D\u653F\u5143\u7D20", trigger: "change" }],
      majorIds: [{ required: !0, message: "\u8BF7\u9009\u62E9\u9002\u7528\u4E13\u4E1A", trigger: "change" }]
    }, { ideologyList: p, majorList: y, getIdeology: m, getMajorList: b, updateCaseBase: x } = XC(
      a,
      i
    ), { quoteCaseInfo: D } = RC(a), S = async (q) => await o.isHasMenu({ function_id: q }), C = () => {
      r.value = !1;
    };
    Ne(
      () => r.value,
      async (q) => {
        q && (await bt(), n.fieldsForm && (u.value = Dl(n.fieldsForm), (n.fieldsForm.is_sync == 0 || n.type === 2) && (f.status = await S(f.functionId), f.status && (m(), u.value.ideologyIds = u.value.ideology_ids ? u.value.ideology_ids.split(",") : []), d.status = await S(d.functionId), d.status && (b(), u.value.majorIds = u.value.major_ids ? u.value.major_ids.split(",") : []))), l.value.clearValidate());
      }
    );
    const v = (q) => {
      u.value.course_name = q.course_name, u.value.course_id = q.id;
    }, H = j(!1), V = zt({
      ideology_name: "",
      level: 0,
      parent_id: ""
    }), R = (q) => {
      V.level = q.level, V.parent_id = q.parent.value, H.value = !0;
    }, F = (q) => {
      if (q.length > 1) {
        const G = y.value[0].id;
        q[0] == G && q.shift(), q[q.length - 1] == G && q.splice(0, q.length - 1);
      }
    }, K = () => {
      l.value.validate(async (q) => {
        if (q) {
          let G = {
            course_id: u.value.course_id,
            case_name: u.value.case_name,
            chapter_name: u.value.chapter_name,
            major_ids: u.value.majorIds ? u.value.majorIds.join(",") : "",
            ideology_ids: u.value.ideologyIds ? u.value.ideologyIds.join(",") : ""
          };
          n.type === 1 ? x({ ...G, id: u.value.id }) : n.type === 2 && D(G), C();
        }
      });
    };
    return (q, G) => {
      const te = ti, Q = Sa, Y = Ac, Z = wc, oe = Tc, he = Ca, Ae = fn, We = ni;
      return P(), L(nt, null, [
        B(We, {
          modelValue: E(r),
          "onUpdate:modelValue": G[7] || (G[7] = (ke) => Bn(r) ? r.value = ke : null),
          title: e.type == 1 ? "\u7F16\u8F91\u6848\u4F8B" : "\u5F15\u7528\u6848\u4F8B",
          width: "650px",
          "before-close": C,
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", e6e, [
              B(Ae, {
                class: "btn",
                type: "primary",
                plain: !0,
                onClick: K
              }, {
                default: N(() => [
                  t6e
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            B(he, {
              ref_key: "formRef",
              ref: l,
              model: u.value,
              "label-width": "80px",
              rules: h
            }, {
              default: N(() => [
                B(Q, {
                  label: "\u6848\u4F8B\u540D\u79F0",
                  prop: "case_name"
                }, {
                  default: N(() => [
                    B(te, {
                      modelValue: u.value.case_name,
                      "onUpdate:modelValue": G[0] || (G[0] = (ke) => u.value.case_name = ke),
                      placeholder: "\u8BF7\u8F93\u5165\u6848\u4F8B\u540D\u79F0",
                      style: { width: "100%" }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                B(Q, {
                  label: "\u8BFE\u7A0B\u540D\u79F0",
                  prop: "course_name"
                }, {
                  default: N(() => [
                    B(te, {
                      modelValue: u.value.course_name,
                      "onUpdate:modelValue": G[1] || (G[1] = (ke) => u.value.course_name = ke),
                      placeholder: "\u8BF7\u9009\u62E9\u8BFE\u7A0B",
                      readonly: !0,
                      onClick: G[2] || (G[2] = (ke) => s.value = !0),
                      disabled: e.fieldsForm.is_sync == 1 && e.type !== 2,
                      style: { width: "100%" },
                      "suffix-icon": E(W0)
                    }, null, 8, ["modelValue", "disabled", "suffix-icon"])
                  ]),
                  _: 1
                }),
                B(Q, {
                  label: "\u5E94\u7528\u7AE0\u8282",
                  prop: "chapter_name"
                }, {
                  default: N(() => [
                    B(te, {
                      modelValue: u.value.chapter_name,
                      "onUpdate:modelValue": G[3] || (G[3] = (ke) => u.value.chapter_name = ke),
                      placeholder: " \u8BF7\u8F93\u5165\u7AE0\u8282\u540D\u79F0",
                      style: { width: "100%" }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                E(f).status && (e.fieldsForm.is_sync == 0 || e.type == 2) ? (P(), ue(Q, {
                  key: 0,
                  label: "\u601D\u653F\u5143\u7D20",
                  prop: "ideologyIds"
                }, {
                  default: N(() => [
                    B(Y, {
                      modelValue: u.value.ideologyIds,
                      "onUpdate:modelValue": G[4] || (G[4] = (ke) => u.value.ideologyIds = ke),
                      options: E(p),
                      props: c,
                      "show-all-levels": !1,
                      filterable: "",
                      placeholder: "\u8BF7\u9009\u62E9\u601D\u653F\u5143\u7D20",
                      class: "ideology-cascader",
                      onChange: G[5] || (G[5] = () => {
                      })
                    }, {
                      default: N(({ node: ke, data: Re }) => [
                        Re.id === "add" ? (P(), L("span", {
                          key: 0,
                          class: "add-node-btn",
                          onClick: (ve) => R(ke)
                        }, de(Re.ideologyName), 9, J3e)) : (P(), L("span", $3e, de(Re.ideologyName), 1))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })) : re("", !0),
                E(d).status && (e.fieldsForm.is_sync == 0 || e.type == 2) ? (P(), ue(Q, {
                  key: 1,
                  label: "\u9002\u7528\u4E13\u4E1A",
                  prop: "majorIds"
                }, {
                  default: N(() => [
                    B(oe, {
                      clearable: "",
                      modelValue: u.value.majorIds,
                      "onUpdate:modelValue": G[6] || (G[6] = (ke) => u.value.majorIds = ke),
                      placeholder: "\u8BF7\u9009\u62E9\u9002\u7528\u4E13\u4E1A",
                      style: { width: "100%" },
                      multiple: "",
                      onChange: F
                    }, {
                      default: N(() => [
                        (P(!0), L(nt, null, Lt(E(y), (ke) => (P(), ue(Z, {
                          key: ke.id,
                          label: ke.major_name,
                          value: ke.id
                        }, null, 8, ["label", "value"]))), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })) : re("", !0)
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        s.value ? (P(), ue(K3e, {
          key: 0,
          show: s.value,
          "onUpdate:show": G[8] || (G[8] = (ke) => s.value = ke),
          onHandleSelectedCourse: v
        }, null, 8, ["show"])) : re("", !0),
        B(Z3e, {
          isShow: H.value,
          "onUpdate:isShow": G[9] || (G[9] = (ke) => H.value = ke),
          addForm: E(V),
          onUpdateIdeology: E(m)
        }, null, 8, ["isShow", "addForm", "onUpdateIdeology"])
      ], 64);
    };
  }
});
const i6e = /* @__PURE__ */ Ht(n6e, [["__scopeId", "data-v-233ff31e"]]), ls = (e) => (yn("data-v-3b20cf6e"), e = e(), bn(), e), r6e = { class: "header-wrapper" }, a6e = {
  key: 0,
  class: "header-box"
}, o6e = { class: "left" }, s6e = { class: "case-name" }, l6e = { class: "tag-box" }, u6e = {
  key: 0,
  class: "case-tag"
}, c6e = /* @__PURE__ */ je(" \u601D\u653F\u5143\u7D20\uFF1A "), d6e = { class: "tag-text" }, f6e = {
  key: 1,
  class: "case-tag"
}, h6e = /* @__PURE__ */ je(" \u9002\u7528\u4E13\u4E1A\uFF1A "), p6e = { class: "tag-text" }, v6e = { class: "case-info" }, m6e = { class: "info" }, g6e = { class: "info" }, y6e = /* @__PURE__ */ je(" \u5F00\u8BFE\u673A\u6784\uFF1A "), b6e = { class: "info" }, A6e = /* @__PURE__ */ je(" \u6240\u5C5E\u8BFE\u7A0B\uFF1A "), T6e = { class: "info" }, w6e = /* @__PURE__ */ je(" \u5E94\u7528\u7AE0\u8282\uFF1A "), P6e = { class: "right" }, x6e = { key: 0 }, C6e = { key: 0 }, S6e = /* @__PURE__ */ je(" \u63D0\u4EA4\u534F\u4F5C "), E6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tijiaoshenhe check-icon" }, null, -1)), k6e = /* @__PURE__ */ je(" \u63D0\u4EA4\u5BA1\u6838 "), O6e = {
  key: 1,
  class: "check-box"
}, z6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-chexiao check-icon" }, null, -1)), D6e = /* @__PURE__ */ je(" \u91CD\u65B0\u4FEE\u6539 "), M6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bohui check-icon" }, null, -1)), H6e = /* @__PURE__ */ je(" \u64A4\u56DE\u5BA1\u6838 "), I6e = {
  key: 1,
  class: "check-box"
}, L6e = { key: 2 }, B6e = {
  key: 0,
  class: "check-box"
}, N6e = { style: { "margin-right": "7px" } }, j6e = { key: 0 }, F6e = { key: 1 }, X6e = { key: 1 }, R6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bohui check-icon" }, null, -1)), V6e = /* @__PURE__ */ je(" \u5BA1\u6838\u9A73\u56DE "), U6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tongguo check-icon" }, null, -1)), q6e = /* @__PURE__ */ je(" \u5BA1\u6838\u901A\u8FC7 "), _6e = { key: 3 }, W6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-yinyong check-icon" }, null, -1)), K6e = /* @__PURE__ */ je(" \u5F15\u7528\u6848\u4F8B "), G6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tianjia check-icon" }, null, -1)), Y6e = /* @__PURE__ */ je(" \u52A0\u5165\u534F\u4F5C "), Q6e = {
  key: 4,
  class: "collaboration-box"
}, Z6e = { class: "collaboration-button" }, J6e = { class: "collaboration-text" }, $6e = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiala arrow-icon" }, null, -1)), eve = { class: "comment-box" }, tve = { class: "title" }, nve = { class: "comment-list" }, ive = { key: 1 }, rve = /* @__PURE__ */ ls(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tijiaoshenhe check-icon" }, null, -1)), ave = /* @__PURE__ */ je(" \u63D0\u4EA4 "), ove = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array
  },
  setup(e) {
    const t = j(!1), n = ce("siteId"), r = ce("caseInfo"), i = ce("caseOther"), a = ce("$bus"), o = ce("type"), s = ce("checkInfo"), u = ce("$utils").getUrlParams("progressId"), c = ce("pageMode"), f = ce("userInfo"), { caseQuoteConfig: d, isNeedQuoteCase: h } = RC(n);
    h();
    const p = j(!1), y = j(1), m = j(!1), b = (Re) => {
      y.value = Re, p.value = !0;
    }, { authList: x, authNum: D, getCooperationList: S, confirmSubmit: C, collaboratorApply: v } = w2(n, a), { submitAnnotation: H } = Wl(n), V = () => {
      t.value = !0;
    };
    S();
    const R = () => {
      H(() => {
        a.emit("updateContent", 1);
      });
    }, F = j(!1), K = j(!1), {
      handleSubmitCheck: q,
      handleCancelCheck: G,
      handleResetCheckStatus: te,
      getCheckComment: Q,
      updateCheckInfo: Y,
      creatorCheckText: Z,
      allCheckText: oe
    } = rv(s);
    u && Q(u);
    const he = j(1), Ae = j(!1), We = (Re) => {
      he.value = Re, Ae.value = !0;
    }, ke = j(!1);
    return Ne(
      () => s.isNeedCheck,
      () => {
        ke.value = !0;
      }
    ), (Re, ve) => {
      var Me;
      const Ye = Ki, Qe = fn, ot = gf, Ve = vf, Te = pf;
      return P(), L(nt, null, [
        T("div", r6e, [
          E(r).extend ? (P(), L("div", a6e, [
            T("div", o6e, [
              T("div", s6e, [
                T("div", null, de(E(r).extend.case_name), 1),
                E(c) == 1 ? (P(), L("i", {
                  key: 0,
                  class: "iconfont icon-bianji edit-icon",
                  onClick: ve[0] || (ve[0] = (Je) => b(1))
                })) : re("", !0)
              ]),
              T("div", l6e, [
                E(r).extend.ideology_names ? (P(), L("div", u6e, [
                  c6e,
                  B(Ye, {
                    placement: "top",
                    trigger: "hover",
                    effect: "dark",
                    content: E(r).extend.ideology_names
                  }, {
                    default: N(() => [
                      T("span", d6e, de(E(r).extend.ideology_names), 1)
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])) : re("", !0),
                E(r).extend.major_names ? (P(), L("div", f6e, [
                  h6e,
                  T("span", p6e, de(E(r).extend.major_names), 1)
                ])) : re("", !0)
              ]),
              T("div", v6e, [
                T("div", m6e, "\u4E3B\u8BB2\u8001\u5E08\uFF1A" + de(E(r).extend.teacher_name), 1),
                T("div", g6e, [
                  y6e,
                  T("span", null, de(E(r).extend.organ_name), 1)
                ]),
                T("div", b6e, [
                  A6e,
                  T("span", null, de(E(r).extend.course_name), 1)
                ]),
                T("div", T6e, [
                  w6e,
                  T("span", null, de(E(r).extend.chapter_name), 1)
                ])
              ])
            ]),
            T("div", P6e, [
              E(o) == 3 ? (P(), L("div", x6e, [
                E(s).checkStatus == 0 || E(s).checkStatus == 4 ? (P(), L("div", C6e, [
                  B(Qe, {
                    class: "case-btn plain-btn",
                    plain: !0,
                    onClick: V
                  }, {
                    default: N(() => [
                      je(" \u534F\u4F5C\u8005 (" + de(E(D)) + ") ", 1)
                    ]),
                    _: 1
                  }),
                  ke.value ? (P(), ue(ot, {
                    key: 0,
                    visible: E(r).sub_status === 0,
                    effect: "light",
                    content: "\u4F60\u5DF2\u7ECF\u7F16\u8F91\u4E86\u65B0\u5185\u5BB9\uFF0C\u8BB0\u5F97\u63D0\u4EA4\u534F\u4F5C\u54E6~",
                    placement: "top",
                    width: "275px"
                  }, {
                    reference: N(() => [
                      B(Qe, {
                        class: "case-btn plain-btn",
                        disabled: E(r).sub_status !== 0,
                        plain: !0,
                        onClick: E(C)
                      }, {
                        default: N(() => [
                          S6e
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["visible"])) : re("", !0),
                  E(s).isNeedCheck == 2 ? (P(), ue(Qe, {
                    key: 1,
                    class: "case-btn",
                    type: "primary",
                    onClick: ve[1] || (ve[1] = (Je) => E(q)(E(n), E(i).source, E(i).taskId))
                  }, {
                    default: N(() => [
                      E6e,
                      k6e
                    ]),
                    _: 1
                  })) : re("", !0)
                ])) : re("", !0),
                E(s).checkStatus > 0 && E(s).checkStatus < 4 ? (P(), L("div", O6e, [
                  T("span", null, de(E(Z)()), 1),
                  T("span", {
                    class: "look-check",
                    onClick: ve[2] || (ve[2] = (Je) => F.value = !0)
                  }, "\u67E5\u770B\u5BA1\u6838\u60C5\u51B5>"),
                  E(s).checkStatus == 2 ? (P(), ue(Qe, {
                    key: 0,
                    plain: !0,
                    class: "case-btn plain-btn",
                    onClick: ve[3] || (ve[3] = (Je) => E(te)(0))
                  }, {
                    default: N(() => [
                      z6e,
                      D6e
                    ]),
                    _: 1
                  })) : re("", !0),
                  E(s).checkStatus != 2 ? (P(), ue(ot, {
                    key: 1,
                    trigger: "hover",
                    effect: "light",
                    width: 365,
                    content: E(s).checkStatus == 3 ? "\u5BA1\u6838\u5458\u5DF2\u5BA1\u6838\uFF0C\u65E0\u6CD5\u64A4\u56DE\u3002\u5982\u9700\u9000\u56DE\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA1\u6838\u5458" : "\u5DF2\u5728\u5BA1\u6838\u4E2D\uFF0C\u65E0\u6CD5\u64A4\u56DE\u3002\u5982\u9700\u9000\u56DE\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA1\u6838\u5458",
                    disabled: !(E(s).checkIsStart && (E(s).checkStatus == 1 || E(s).checkStatus == 3)),
                    placement: "bottom"
                  }, {
                    reference: N(() => [
                      B(Qe, {
                        class: se(["case-btn plain-btn", { "is-disabled": E(s).checkIsStart }]),
                        plain: !0,
                        onClick: ve[4] || (ve[4] = (Je) => E(G)(E(i).taskId))
                      }, {
                        default: N(() => [
                          M6e,
                          H6e
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"])) : re("", !0)
                ])) : re("", !0)
              ])) : re("", !0),
              E(o) == 1 && E(s).isNeedCheck == 2 ? (P(), L("div", I6e, [
                T("span", null, de(E(oe)()), 1),
                T("span", {
                  class: "look-check",
                  onClick: ve[5] || (ve[5] = (Je) => F.value = !0)
                }, "\u67E5\u770B\u5BA1\u6838\u8FDB\u5EA6>")
              ])) : re("", !0),
              E(o) == 2 ? (P(), L("div", L6e, [
                E(u) ? (P(), L("div", B6e, [
                  T("span", N6e, de(E(s).checkTime), 1),
                  E(s).valid_status == 2 ? (P(), L("span", j6e, de(E(s).realname_valid) + "\u5DF2\u901A\u8FC7", 1)) : (P(), L("span", F6e, de(E(s).operation_type == 2 ? "\u5BA1\u6838\u901A\u8FC7" : "\u5BA1\u6838\u9A73\u56DE"), 1)),
                  E(s).comment || E(s).review_comments_valid ? (P(), L("span", {
                    key: 2,
                    class: "look-check",
                    onClick: ve[6] || (ve[6] = (Je) => K.value = !0)
                  }, " \u67E5\u770B\u5BA1\u6838\u610F\u89C1> ")) : re("", !0)
                ])) : (P(), L("div", X6e, [
                  B(Qe, {
                    plain: !0,
                    class: "case-btn plain-btn",
                    onClick: ve[7] || (ve[7] = (Je) => We(2))
                  }, {
                    default: N(() => [
                      R6e,
                      V6e
                    ]),
                    _: 1
                  }),
                  B(Qe, {
                    type: "primary",
                    class: "case-btn",
                    onClick: ve[8] || (ve[8] = (Je) => We(1))
                  }, {
                    default: N(() => [
                      U6e,
                      q6e
                    ]),
                    _: 1
                  })
                ]))
              ])) : re("", !0),
              E(o) == 0 ? (P(), L("div", _6e, [
                E(d) !== 3 ? (P(), ue(Qe, {
                  key: 0,
                  class: "case-btn plain-btn",
                  plain: !0,
                  onClick: ve[9] || (ve[9] = (Je) => b(2))
                }, {
                  default: N(() => [
                    W6e,
                    K6e
                  ]),
                  _: 1
                })) : re("", !0),
                E(i).caseRole == 0 ? (P(), ue(Qe, {
                  key: 1,
                  class: "case-btn",
                  type: "primary",
                  onClick: ve[10] || (ve[10] = (Je) => E(v)(E(f).id, E(i).source))
                }, {
                  default: N(() => [
                    G6e,
                    Y6e
                  ]),
                  _: 1
                })) : re("", !0)
              ])) : re("", !0),
              E(o) == 4 ? (P(), L("div", Q6e, [
                T("div", {
                  class: "tips",
                  onClick: ve[11] || (ve[11] = (Je) => m.value = !0)
                }, "\u5982\u4F55\u6DFB\u52A0\u6279\u6CE8\uFF1F"),
                T("div", Z6e, [
                  B(Te, { trigger: "hover" }, {
                    dropdown: N(() => [
                      B(Ve, null, {
                        default: N(() => {
                          var Je, mt;
                          return [
                            T("div", eve, [
                              T("div", tve, " \u5168\u90E8\u672A\u63D0\u4EA4\u6279\u6CE8 " + de(((Je = e.allUnsubmittedNoteList) == null ? void 0 : Je.length) || 0), 1),
                              T("div", nve, [
                                (mt = e.allUnsubmittedNoteList) != null && mt.length ? (P(!0), L(nt, { key: 0 }, Lt(e.allUnsubmittedNoteList, (It) => (P(), ue(av, {
                                  key: It.id,
                                  item: It
                                }, null, 8, ["item"]))), 128)) : (P(), L("div", ive, [
                                  B(E(bi), {
                                    type: "message",
                                    description: "\u6682\u65E0\u6279\u6CE8"
                                  })
                                ]))
                              ])
                            ])
                          ];
                        }),
                        _: 1
                      })
                    ]),
                    default: N(() => {
                      var Je;
                      return [
                        T("div", J6e, [
                          T("span", null, "\u5F85\u63D0\u4EA4\u6279\u6CE8 (" + de(((Je = e.allUnsubmittedNoteList) == null ? void 0 : Je.length) || 0) + ")", 1),
                          $6e
                        ])
                      ];
                    }),
                    _: 1
                  }),
                  B(Qe, {
                    type: "primary",
                    class: "submit-btn",
                    disabled: !((Me = e.allUnsubmittedNoteList) != null && Me.length),
                    onClick: R
                  }, {
                    default: N(() => [
                      rve,
                      ave
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])) : re("", !0)
            ])
          ])) : re("", !0)
        ]),
        B(i6e, {
          show: p.value,
          "onUpdate:show": ve[12] || (ve[12] = (Je) => p.value = Je),
          fieldsForm: E(r).extend,
          type: y.value
        }, null, 8, ["show", "fieldsForm", "type"]),
        B(P2, {
          showAuthListDialog: t.value,
          "onUpdate:showAuthListDialog": ve[13] || (ve[13] = (Je) => t.value = Je),
          "auth-list": E(x),
          onGetAuthList: E(S)
        }, null, 8, ["showAuthListDialog", "auth-list", "onGetAuthList"]),
        B(u3e, {
          showTipDialog: m.value,
          "onUpdate:showTipDialog": ve[14] || (ve[14] = (Je) => m.value = Je)
        }, null, 8, ["showTipDialog"]),
        F.value ? (P(), ue(NC, {
          key: 0,
          isShow: F.value,
          "onUpdate:isShow": ve[15] || (ve[15] = (Je) => F.value = Je),
          isFounder: E(o) == 3,
          taskId: E(i).taskId
        }, null, 8, ["isShow", "isFounder", "taskId"])) : re("", !0),
        B(jC, {
          show: Ae.value,
          "onUpdate:show": ve[16] || (ve[16] = (Je) => Ae.value = Je),
          checkType: he.value,
          onUpdateCheckInfo: ve[17] || (ve[17] = (Je) => E(Y)(Je, E(i).taskId))
        }, null, 8, ["show", "checkType"]),
        B(FC, {
          show: K.value,
          "onUpdate:show": ve[18] || (ve[18] = (Je) => K.value = Je),
          comment: E(s).valid_status == 2 ? E(s).review_comments_valid : E(s).comment
        }, null, 8, ["show", "comment"])
      ], 64);
    };
  }
});
const sve = /* @__PURE__ */ Ht(ove, [["__scopeId", "data-v-3b20cf6e"]]), lve = {
  key: 0,
  class: "team-situation"
}, uve = ["innerHTML"], cve = {
  key: 1,
  class: "edit-box"
}, dve = {
  class: "btn-box",
  style: { "margin-left": "auto" }
}, fve = /* @__PURE__ */ je("\u53D6\u6D88"), hve = /* @__PURE__ */ je("\u4FDD\u5B58"), pve = {
  key: 2,
  class: "empty-box"
}, vve = /* @__PURE__ */ Ee({
  props: {
    columnInfo: Object
  },
  setup(e, { expose: t }) {
    const n = e, r = ce("pageMode"), { updateCaseMenuContent: i } = ce("$http"), a = ce("$bus"), o = j(""), s = j(!1), l = () => {
      s.value = !0;
    }, u = () => {
      a.emit("updateContent"), s.value = !1;
    }, c = async () => {
      E(o).trim() && await i({
        id: n.columnInfo.id,
        column_content: E(o)
      }) && (An.success("\u4FDD\u5B58\u6210\u529F"), s.value = !1, a.emit("updateContent"));
    };
    return t({
      editColumnContent: l
    }), Ne(
      () => n.columnInfo.columnContent,
      (f) => {
        f && (o.value = f);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (f, d) => {
      const h = fn;
      return e.columnInfo ? (P(), L("div", lve, [
        !e.columnInfo.columnContent && !s.value && E(r) === 1 ? (P(), ue(sc, {
          key: 0,
          onEdit: l
        })) : re("", !0),
        T("div", null, [
          s.value ? (P(), ue(E(zs), {
            key: 0,
            ref: "editer",
            modelValue: o.value,
            "onUpdate:modelValue": d[0] || (d[0] = (p) => o.value = p),
            height: 400
          }, null, 8, ["modelValue"])) : re("", !0),
          !s.value && o.value ? (P(), L("div", {
            key: 1,
            "data-html": "",
            innerHTML: o.value
          }, null, 8, uve)) : re("", !0)
        ]),
        s.value ? (P(), L("div", cve, [
          T("div", dve, [
            B(h, {
              class: "btn",
              plain: "",
              onClick: u
            }, {
              default: N(() => [
                fve
              ]),
              _: 1
            }),
            B(h, {
              type: "primary",
              class: "btn",
              onClick: d[1] || (d[1] = (p) => c())
            }, {
              default: N(() => [
                hve
              ]),
              _: 1
            })
          ])
        ])) : re("", !0),
        !e.columnInfo.columnContent && E(r) !== 1 ? (P(), L("div", pve, [
          B(E(bi), { description: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
        ])) : re("", !0)
      ])) : re("", !0);
    };
  }
});
const mve = /* @__PURE__ */ Ht(vve, [["__scopeId", "data-v-659d8617"]]), VC = (e) => (yn("data-v-598a9613"), e = e(), bn(), e), gve = { class: "header w" }, yve = /* @__PURE__ */ VC(() => /* @__PURE__ */ T("span", { class: "title" }, "\u6DFB\u52A0\u6559\u5E08", -1)), bve = { class: "reset-box w" }, Ave = { class: "top" }, Tve = { class: "left" }, wve = { class: "right" }, Pve = /* @__PURE__ */ VC(() => /* @__PURE__ */ T("div", { class: "tips" }, [
  /* @__PURE__ */ T("div", null, "\u56FE\u7247\u5927\u5C0F\uFF1A160*160"),
  /* @__PURE__ */ T("div", null, "\u56FE\u7247\u683C\u5F0F\uFF1Ajpg\u3001gif\u3001png")
], -1)), xve = { class: "bottom" }, Cve = /* @__PURE__ */ je("\u5DF2\u5173\u95ED"), Sve = /* @__PURE__ */ je(" + \u6DFB\u52A0\u65B0\u6A21\u5757 "), Eve = { class: "dialog-footer w" }, kve = /* @__PURE__ */ je("\u53D6 \u6D88"), Ove = /* @__PURE__ */ je("\u4EC5\u4FDD\u5B58"), zve = /* @__PURE__ */ je("\u4FDD\u5B58\u5E76\u7EE7\u7EED"), Dve = /* @__PURE__ */ Ee({
  props: {
    isShow: {
      type: Boolean,
      default: !1
    },
    id: {
      type: [String, Number],
      default: 0
    }
  },
  emits: ["update:isShow"],
  setup(e, { emit: t }) {
    const n = e, {
      getTeamMemberInfo: r,
      getOrganTree: i,
      getTitleList: a,
      saveTeamMember: o,
      saveTeamMemberField: s,
      getTeamMemberFieldList: l
    } = ce("$http"), u = ce("siteId"), c = ce("columnInfo"), f = ce("$bus"), d = j([]), h = j([]), p = j(!1), y = j({
      avatar_id: "",
      avatar_url: "",
      post: "",
      user_name: "",
      organ_id: "",
      title_id: "",
      fieldsJson: "",
      fields: []
    }), m = j({
      field_title: "",
      status: 1
    }), b = j(), x = zt({
      isAdd: !0,
      index: 0,
      id: 0
    }), D = j(!1), S = Vs(n, "isShow", t), C = zt({
      user_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u6559\u5E08\u540D\u79F0", trigger: "blur" }],
      organ_id: [{ required: !0, message: "\u8BF7\u9009\u62E9\u6240\u5C5E\u673A\u6784", trigger: "change" }]
    }), v = async (oe, he) => {
      if (n.id) {
        const Ae = {
          column_id: c.id,
          member_id: n.id,
          site_id: u,
          ...oe,
          id: x.id
        };
        await s(Ae), await G();
      } else
        he ? y.value.fields.push({ ...oe }) : y.value.fields[x.index] = { ...oe };
      An.success("\u4FEE\u6539\u6210\u529F"), p.value = !1;
    }, H = async () => {
      if (await di({
        headerTitle: "\u63D0\u793A",
        tipTitle: "\u786E\u5B9A\u5220\u9664\u8FD9\u9879\u5185\u5BB9\u5417\uFF1F",
        tipText: "\u5220\u9664\u540E\uFF0C\u5C06\u65E0\u6CD5\u6062\u590D\u521D\u59CB\u72B6\u6001\u3002"
      }), n.id) {
        const oe = {
          id: x.id,
          del_flag: 1
        };
        await s(oe), await G();
      } else
        y.value.fields.splice(x.index, 1);
      An.success("\u5220\u9664\u6210\u529F"), p.value = !1;
    }, V = ({ id: oe, url: he }) => {
      y.value.avatar_id = oe, y.value.avatar_url = he, D.value = !1;
    }, R = async () => {
      Y(), S.value = !1;
    }, F = async (oe, he) => {
      oe && await oe.validate(async (Ae, We) => {
        if (Ae) {
          let ke = y.value.organ_id;
          typeof y.value.organ_id != "string" && (ke = [...y.value.organ_id].pop());
          const Re = {
            ...y.value,
            site_id: u,
            column_id: c.id,
            id: n.id || 0,
            organ_id: ke,
            fieldsJson: JSON.stringify(y.value.fields)
          };
          delete Re.fields, await o(Re), An.success("\u4FDD\u5B58\u6210\u529F"), he ? R() : (Y(), await Z()), f.emit("updateContent");
        } else
          console.log("error submit!", We);
      });
    }, K = () => {
      m.value = {
        field_title: "",
        status: 1
      }, x.id = 0, x.isAdd = !0, p.value = !0;
    }, q = ({ field_title: oe, status: he, id: Ae }, We) => {
      m.value = { field_title: oe, status: he }, x.index = We, x.isAdd = !1, x.id = Ae, p.value = !0;
    }, G = async () => {
      const oe = await r({
        id: n.id
      });
      y.value = oe;
    }, te = async () => {
      const oe = await i();
      d.value = oe;
    }, Q = async () => {
      const oe = await a({
        "_pageable.page": 0,
        "_pageable.size": 99
      });
      h.value = oe.content;
    }, Y = () => {
      y.value = {
        avatar_id: "",
        avatar_url: "",
        post: "",
        user_name: "",
        organ_id: "",
        title_id: "",
        fieldsJson: "",
        fields: []
      };
    }, Z = async () => {
      const oe = await l({
        business_type: c.columnType === 34 ? "al_course_model_member1" : "al_course_model_member2"
      });
      y.value.fields = oe;
    };
    return Ne(S, async (oe) => {
      oe && (await te(), await Q(), n.id ? await G() : await Z(), await bt(), b.value.clearValidate());
    }), (oe, he) => {
      const Ae = qt, We = ti, ke = Sa, Re = Ac, ve = wc, Ye = Tc, Qe = hf, ot = fn, Ve = Ca, Te = ni;
      return P(), L(nt, null, [
        E(S) ? (P(), ue(Te, {
          key: 0,
          modelValue: E(S),
          "onUpdate:modelValue": he[7] || (he[7] = (Me) => Bn(S) ? S.value = Me : null),
          fullscreen: "",
          "before-close": R,
          "destroy-on-close": "",
          "show-close": !1,
          "custom-class": "is-footer-border"
        }, {
          title: N(() => [
            T("div", gve, [
              yve,
              B(Ae, {
                class: "icon",
                color: "#cccc",
                size: "18px",
                onClick: R
              }, {
                default: N(() => [
                  B(E(Ete))
                ]),
                _: 1
              })
            ])
          ]),
          footer: N(() => [
            T("span", Eve, [
              B(ot, { onClick: R }, {
                default: N(() => [
                  kve
                ]),
                _: 1
              }),
              B(ot, {
                type: "primary",
                plain: "",
                onClick: he[5] || (he[5] = (Me) => F(b.value, !0))
              }, {
                default: N(() => [
                  Ove
                ]),
                _: 1
              }),
              B(ot, {
                type: "primary",
                onClick: he[6] || (he[6] = (Me) => F(b.value, !1))
              }, {
                default: N(() => [
                  zve
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", bve, [
              y.value ? (P(), ue(Ve, {
                key: 0,
                ref_key: "formRef",
                ref: b,
                model: y.value,
                rules: E(C),
                "label-width": 100,
                "label-position": "top"
              }, {
                default: N(() => [
                  T("div", Ave, [
                    T("div", Tve, [
                      B(ke, {
                        label: "\u6559\u5E08\u540D\u79F0",
                        prop: "user_name"
                      }, {
                        default: N(() => [
                          B(We, {
                            modelValue: y.value.user_name,
                            "onUpdate:modelValue": he[0] || (he[0] = (Me) => y.value.user_name = Me),
                            placeholder: "\u8BF7\u8F93\u5165\u6559\u5E08\u540D\u79F0"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      B(ke, {
                        label: "\u6240\u5C5E\u673A\u6784",
                        prop: "organ_id"
                      }, {
                        default: N(() => [
                          B(Re, {
                            modelValue: y.value.organ_id,
                            "onUpdate:modelValue": he[1] || (he[1] = (Me) => y.value.organ_id = Me),
                            placeholder: "\u8BF7\u9009\u62E9\u6240\u5C5E\u673A\u6784",
                            options: d.value,
                            props: {
                              checkStrictly: !0,
                              label: "organName",
                              value: "id"
                            },
                            style: { width: "100%" }
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      B(ke, {
                        label: "\u6821\u5185\u804C\u52A1",
                        prop: "post"
                      }, {
                        default: N(() => [
                          B(We, {
                            modelValue: y.value.post,
                            "onUpdate:modelValue": he[2] || (he[2] = (Me) => y.value.post = Me),
                            placeholder: "\u8BF7\u8F93\u5165\u6821\u5185\u804C\u52A1"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      B(ke, {
                        label: "\u804C\u79F0",
                        prop: "title_id"
                      }, {
                        default: N(() => [
                          B(Ye, {
                            modelValue: y.value.title_id,
                            "onUpdate:modelValue": he[3] || (he[3] = (Me) => y.value.title_id = Me),
                            placeholder: "\u8BF7\u9009\u62E9\u804C\u79F0",
                            style: { width: "100%" }
                          }, {
                            default: N(() => [
                              (P(!0), L(nt, null, Lt(h.value, (Me) => (P(), ue(ve, {
                                key: Me.id,
                                label: Me.name,
                                value: Me.id
                              }, null, 8, ["label", "value"]))), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    T("div", wve, [
                      B(ke, {
                        label: "\u4E0A\u4F20\u5934\u50CF",
                        prop: "avatar_id"
                      }, {
                        default: N(() => [
                          B(E(Tl), {
                            "is-hover": "",
                            src: y.value.avatar_url,
                            "is-show-mark": "",
                            onClick: he[4] || (he[4] = (Me) => D.value = !0)
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      }),
                      Pve
                    ])
                  ]),
                  T("div", xve, [
                    (P(!0), L(nt, null, Lt(y.value.fields, (Me, Je) => (P(), ue(ke, { key: Je }, {
                      label: N(() => [
                        T("span", null, de(Me.field_title), 1),
                        Me.status === 0 ? (P(), ue(Qe, {
                          key: 0,
                          type: "danger"
                        }, {
                          default: N(() => [
                            Cve
                          ]),
                          _: 1
                        })) : re("", !0),
                        B(E(qi), {
                          class: "cursor m-l",
                          name: "\u4FEE\u6539",
                          onClick: (mt) => q(Me, Je)
                        }, null, 8, ["onClick"])
                      ]),
                      default: N(() => [
                        B(E(zs), {
                          ref_for: !0,
                          ref: `editer${Je}`,
                          modelValue: Me.field_content,
                          "onUpdate:modelValue": (mt) => Me.field_content = mt,
                          width: 880,
                          height: 400
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024))), 128)),
                    B(ke, null, {
                      default: N(() => [
                        B(ot, {
                          type: "primary",
                          class: "add-btn",
                          onClick: K
                        }, {
                          default: N(() => [
                            Sve
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])) : re("", !0)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])) : re("", !0),
        B(E(Hu), {
          isShow: D.value,
          "onUpdate:isShow": he[8] || (he[8] = (Me) => D.value = Me),
          "default-img": y.value.avatar_url,
          onChangeAvatar: V
        }, null, 8, ["isShow", "default-img"]),
        B(R3, {
          "is-edit-title": p.value,
          "onUpdate:is-edit-title": he[9] || (he[9] = (Me) => p.value = Me),
          "is-add": E(x).isAdd,
          "fields-form": m.value,
          onHandleTitleSave: v,
          onHandleTitleDel: H
        }, null, 8, ["is-edit-title", "is-add", "fields-form"])
      ], 64);
    };
  }
});
const Mve = /* @__PURE__ */ Ht(Dve, [["__scopeId", "data-v-598a9613"]]), Hve = { class: "title" }, Ive = ["innerHTML"], Lve = /* @__PURE__ */ Ee({
  props: {
    fields: Array
  },
  setup(e) {
    const t = j(!1), n = () => {
      t.value = !E(t);
    }, r = J(() => E(t) ? "rotate(270deg)" : "rotate(90deg)"), i = J(() => E(t) ? "auto" : "210px");
    return (a, o) => {
      const s = Ki, l = qt;
      return P(), L("div", {
        class: "list-content",
        style: Pt({ height: E(i) })
      }, [
        (P(!0), L(nt, null, Lt(e.fields, (u) => (P(), L("div", {
          key: u.id,
          class: "item"
        }, [
          T("div", Hve, de(u.fieldTitle), 1),
          B(s, {
            "popper-class": "list-tooltip",
            placement: "top",
            disabled: !u.fieldContent,
            content: u.fieldContent,
            "raw-content": ""
          }, {
            default: N(() => [
              T("div", {
                class: "info",
                "data-html": "",
                innerHTML: u.fieldContent
              }, null, 8, Ive)
            ]),
            _: 2
          }, 1032, ["disabled", "content"])
        ]))), 128)),
        e.fields.length > 2 ? (P(), L("div", {
          key: 0,
          class: "mark",
          onClick: n
        }, [
          T("span", null, [
            je(de(t.value ? "\u6536\u8D77\u5185\u5BB9" : "\u5C55\u5F00\u9605\u8BFB\u5168\u90E8") + " ", 1),
            B(l, {
              style: Pt({ transform: E(r) })
            }, {
              default: N(() => [
                B(E(XT))
              ]),
              _: 1
            }, 8, ["style"])
          ])
        ])) : re("", !0)
      ], 4);
    };
  }
});
const Bve = /* @__PURE__ */ Ht(Lve, [["__scopeId", "data-v-0a778340"]]), qs = (e) => (yn("data-v-39297665"), e = e(), bn(), e), Nve = { class: "header" }, jve = { class: "left" }, Fve = { class: "info" }, Xve = {
  key: 0,
  class: "right"
}, Rve = ["onClick"], Vve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("i", { class: "iconfont icon-shangyi" }, null, -1)), Uve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("span", null, "\u4E0A\u79FB", -1)), qve = [
  Vve,
  Uve
], _ve = ["onClick"], Wve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiayi" }, null, -1)), Kve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("span", null, "\u4E0B\u79FB", -1)), Gve = [
  Wve,
  Kve
], Yve = ["onClick"], Qve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji1" }, null, -1)), Zve = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("span", null, "\u7F16\u8F91", -1)), Jve = [
  Qve,
  Zve
], $ve = ["onClick"], e5e = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("i", { class: "iconfont icon-wenjian-shanchu" }, null, -1)), t5e = /* @__PURE__ */ qs(() => /* @__PURE__ */ T("span", null, "\u5220\u9664", -1)), n5e = [
  e5e,
  t5e
], i5e = {
  key: 1,
  class: "empty-box"
}, r5e = /* @__PURE__ */ Ee({
  props: {
    columnInfo: Object
  },
  setup(e, { expose: t }) {
    const n = e, { deleteTeamMember: r, sortTeamMember: i } = ce("$http"), a = ce("$bus"), o = ce("pageMode"), s = j(!1), l = j([]), u = j(""), c = (m) => {
      u.value = m, s.value = !0;
    }, f = async (m) => {
      const b = n.columnInfo.columnType === 34 ? "\u8BFE\u7A0B\u8D1F\u8D23\u4EBA" : "\u56E2\u961F\u6210\u5458";
      await di({
        headerTitle: "\u63D0\u793A",
        tipTitle: `\u662F\u5426\u5220\u9664${b}\uFF1F`,
        tipText: `\u5220\u9664\u540E\u8BE5${b}\u5C06\u4E0D\u5728\u6B64\u56E2\u961F\u4E2D\u3002`
      }), await r({ id: m }), An.success("\u5220\u9664\u6210\u529F"), a.emit("updateContent");
    }, d = async (m) => {
      const b = m.map((x) => x.id).join(",");
      await i({
        member_ids: b
      }), An.success("\u79FB\u52A8\u6210\u529F");
    }, h = async (m) => {
      const b = l.value;
      b.splice(m - 1, 1, ...b.splice(m, 1, b[m - 1])), d(b);
    }, p = async (m) => {
      const b = l.value;
      b.splice(m, 1, ...b.splice(m + 1, 1, b[m])), d(b);
    }, y = () => {
      u.value = "", s.value = !0;
    };
    return t({
      isShowTearchDialog: s,
      addTeacher: y
    }), Ne(
      () => n.columnInfo.members,
      (m) => {
        m && (l.value = n.columnInfo.members);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (m, b) => (P(), L(nt, null, [
      B(Y4, {
        tag: "div",
        name: "list"
      }, {
        default: N(() => [
          l.value && l.value.length ? (P(!0), L(nt, { key: 0 }, Lt(l.value, (x, D) => (P(), L("div", {
            key: x.id,
            class: "team-item"
          }, [
            T("div", Nve, [
              T("div", jve, [
                B(E(Tl), {
                  src: x.avatarUrl,
                  "is-show-default-avatar": "",
                  class: "avatar"
                }, null, 8, ["src"]),
                T("div", Fve, [
                  T("p", null, [
                    T("span", null, de(x.userName), 1)
                  ]),
                  T("p", null, [
                    T("span", null, de(x.organName), 1),
                    T("span", null, de(x.title), 1)
                  ])
                ])
              ]),
              E(o) === 1 ? (P(), L("div", Xve, [
                T("div", {
                  class: se(["edit-btn", D === 0 ? "disabled" : ""]),
                  onClick: (S) => h(D)
                }, qve, 10, Rve),
                T("div", {
                  class: se(["edit-btn", D === l.value.length - 1 ? "disabled" : ""]),
                  onClick: (S) => p(D)
                }, Gve, 10, _ve),
                T("div", {
                  class: "edit-btn",
                  onClick: (S) => c(x.id)
                }, Jve, 8, Yve),
                T("div", {
                  class: "edit-btn",
                  onClick: (S) => f(x.id)
                }, n5e, 8, $ve)
              ])) : re("", !0)
            ]),
            x.fields && x.fields.length ? (P(), ue(Bve, {
              key: 0,
              fields: x.fields
            }, null, 8, ["fields"])) : re("", !0)
          ]))), 128)) : re("", !0)
        ]),
        _: 1
      }),
      !l.value.length && E(o) === 1 ? (P(), ue(sc, {
        key: 0,
        "btn-text": "\u6DFB\u52A0\u6559\u5E08",
        content: "\u8FD8\u672A\u6DFB\u52A0\u6559\u5E08, \u5FEB\u70B9\u6DFB\u52A0\u5427",
        onEdit: y
      })) : re("", !0),
      !l.value.length && E(o) !== 1 ? (P(), L("div", i5e, [
        B(E(bi), { description: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9" })
      ])) : re("", !0),
      B(Mve, {
        id: u.value,
        isShow: s.value,
        "onUpdate:isShow": b[0] || (b[0] = (x) => s.value = x)
      }, null, 8, ["id", "isShow"])
    ], 64));
  }
});
const a5e = /* @__PURE__ */ Ht(r5e, [["__scopeId", "data-v-39297665"]]), o5e = (e) => (yn("data-v-8b5cfe98"), e = e(), bn(), e), s5e = { class: "team" }, l5e = /* @__PURE__ */ je(" \u6DFB\u52A0\u6559\u5E08 "), u5e = /* @__PURE__ */ o5e(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji edit-icon" }, null, -1)), c5e = /* @__PURE__ */ je(" \u7F16\u8F91 "), d5e = { class: "content" }, f5e = /* @__PURE__ */ Ee({
  props: {
    columnInfo: Object
  },
  setup(e) {
    const t = e;
    _t("columnInfo", t.columnInfo);
    const n = j(), r = j(), i = () => {
      n.value.addTeacher();
    }, a = () => {
      r.value.editColumnContent();
    }, o = J(() => {
      var l, u;
      return ((l = t.columnInfo) == null ? void 0 : l.columnType) === 34 || ((u = t.columnInfo) == null ? void 0 : u.columnType) === 35;
    }), s = J(() => t.columnInfo.members.length);
    return (l, u) => {
      const c = fn, f = E3;
      return P(), L("div", s5e, [
        B(V3, { "column-info": e.columnInfo }, {
          right: N(() => [
            E(o) && E(s) ? (P(), ue(c, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: i
            }, {
              default: N(() => [
                l5e
              ]),
              _: 1
            })) : re("", !0),
            !E(o) && e.columnInfo.columnContent ? (P(), ue(f, {
              key: 1,
              underline: !1,
              type: "primary",
              size: "default",
              onClick: a
            }, {
              default: N(() => [
                u5e,
                c5e
              ]),
              _: 1
            })) : re("", !0)
          ]),
          _: 1
        }, 8, ["column-info"]),
        T("div", d5e, [
          E(o) ? (P(), ue(a5e, {
            key: 0,
            ref_key: "teamItem",
            ref: n,
            "column-info": e.columnInfo
          }, null, 8, ["column-info"])) : (P(), ue(mve, {
            key: 1,
            ref_key: "teamSituation",
            ref: r,
            "column-info": e.columnInfo
          }, null, 8, ["column-info"]))
        ])
      ]);
    };
  }
});
const h5e = /* @__PURE__ */ Ht(f5e, [["__scopeId", "data-v-8b5cfe98"]]);
const Ff = (e) => (yn("data-v-0af899f3"), e = e(), bn(), e), p5e = /* @__PURE__ */ Ff(() => /* @__PURE__ */ T("span", { class: "title" }, "\u66F4\u6362\u5C01\u9762", -1)), v5e = { class: "img_view" }, m5e = { class: "avatar-upload-preview" }, g5e = ["src"], y5e = {
  key: 1,
  class: "img-empty"
}, b5e = /* @__PURE__ */ Ff(() => /* @__PURE__ */ T("div", { class: "tip" }, [
  /* @__PURE__ */ T("div", { class: "tip1" }, "\u5C01\u9762\u9884\u89C8"),
  /* @__PURE__ */ T("div", { class: "tip2" }, "\u4EC5\u652F\u6301jpg\u3001png\u56FE\u7247\u6587\u4EF6\uFF0C\u4E14\u6587\u4EF6\u5C0F\u4E8E5M\uFF0C\u5EFA\u8BAE\u5C3A\u5BF8320*180\u50CF\u7D20")
], -1)), A5e = /* @__PURE__ */ Ff(() => /* @__PURE__ */ T("br", null, null, -1)), T5e = { class: "upload-btn" }, w5e = /* @__PURE__ */ je(" \u4E0A\u4F20\u56FE\u7247 "), P5e = { class: "dialog-footer" }, x5e = /* @__PURE__ */ Ff(() => /* @__PURE__ */ T("span", null, "\u53D6 \u6D88", -1)), C5e = /* @__PURE__ */ Ff(() => /* @__PURE__ */ T("span", null, "\u4FDD \u5B58", -1)), S5e = {
  props: {
    showDialog: {
      type: Boolean,
      default: !1
    },
    defaultImg: {
      type: String,
      default: ""
    },
    defaultTip: {
      type: String,
      default: "\u6682\u672A\u4E0A\u4F20\u56FE\u7247"
    }
  },
  emits: ["update:showDialog", "changeCover"],
  setup(e, { emit: t }) {
    const n = e, r = ce("$http"), i = () => {
      t("update:showDialog", !1);
    }, a = j(""), o = j(null), s = {
      JPG: "image/jpeg",
      PNG: "image/png"
    }, l = zt({
      id: "",
      url: ""
    });
    Ne(
      () => n.defaultImg,
      (d) => {
        l.url = d;
      },
      {
        immediate: !0
      }
    );
    const u = (d) => {
      const h = d.type === s.JPG, p = d.type === s.PNG;
      if (console.log("file", d), !h && !p) {
        An.error("\u4E0A\u4F20\u56FE\u7247\u53EA\u80FD\u662F JPG/PNG \u683C\u5F0F!");
        return;
      }
      return new Promise(async (y, m) => {
        try {
          const b = await r.getPolicy({ fileName: d.name });
          if (!b)
            return;
          const x = JSON.parse(b);
          console.log(x), a.value = x.host;
          let D = {};
          D.key = x.dir + x.fileUUID + "." + d.name.split(".")[d.name.split(".").length - 1], D.policy = x.policy, D.OSSAccessKeyId = x.accessid, D.success_action_status = 200, D.callback = x.callback, D.signature = x.signature, D["Content-Disposition"] = "attachment;filename=" + d.name, o.value = D, y(!0);
        } catch (b) {
          console.log(b), m(!1);
        }
      });
    }, c = ({ data: d }) => {
      console.log("data", d), l.id = d.id, l.url = d.fileUrl;
    }, f = () => {
      if (!l.url) {
        An.error("\u6682\u672A\u4E0A\u4F20\u56FE\u7247");
        return;
      }
      t("changeCover", l), i();
    };
    return (d, h) => {
      const p = qt, y = fn, m = yf, b = ni;
      return n.showDialog ? (P(), ue(b, {
        key: 0,
        modelValue: n.showDialog,
        "onUpdate:modelValue": h[0] || (h[0] = (x) => n.showDialog = x),
        width: "630px",
        "append-to-body": "",
        "before-close": i
      }, {
        title: N(() => [
          p5e
        ]),
        footer: N(() => [
          T("div", P5e, [
            B(y, {
              style: { width: "96px" },
              onClick: i
            }, {
              default: N(() => [
                x5e
              ]),
              _: 1
            }),
            B(y, {
              type: "primary",
              style: { width: "96px" },
              onClick: f
            }, {
              default: N(() => [
                C5e
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          T("div", v5e, [
            T("div", m5e, [
              E(l).url ? (P(), L("img", {
                key: 0,
                src: E(l).url
              }, null, 8, g5e)) : (P(), L("div", y5e, de(e.defaultTip), 1))
            ]),
            b5e
          ]),
          A5e,
          T("div", T5e, [
            B(m, {
              action: a.value,
              data: o.value,
              "show-file-list": !1,
              "before-upload": u,
              "on-success": c,
              accept: "image/*"
            }, {
              default: N(() => [
                B(y, { size: "small" }, {
                  default: N(() => [
                    B(p, { style: { "margin-right": "7px" } }, {
                      default: N(() => [
                        B(E(RT))
                      ]),
                      _: 1
                    }),
                    w5e
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "data"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])) : re("", !0);
    };
  }
}, E5e = /* @__PURE__ */ Ht(S5e, [["__scopeId", "data-v-0af899f3"]]), ov = (e) => {
  const t = ce("$http"), n = j([]), r = j([]);
  return {
    courseTypeList: n,
    teachingMethodList: r,
    updateCourse: async (o) => {
      await t.updateCourseBase(o), An.success("\u4FEE\u6539\u6210\u529F"), e.emit("contentChange", 1);
    },
    getCourseDict: async (o) => {
      const s = await t.getJJGeneralDict({ dict_type: o });
      o == "course_type" ? n.value = s : o == "teaching_methods" && (r.value = s);
    }
  };
};
const k5e = (e) => (yn("data-v-ed3ac850"), e = e(), bn(), e), O5e = { class: "term-box" }, z5e = /* @__PURE__ */ k5e(() => /* @__PURE__ */ T("div", { class: "line" }, "\u81F3", -1)), D5e = ["onClick"], M5e = /* @__PURE__ */ je(" + \u6DFB\u52A0\u5F00\u8BFE\u65F6\u95F4 "), H5e = { class: "dialog-footer" }, I5e = /* @__PURE__ */ je("\u4FDD \u5B58"), L5e = /* @__PURE__ */ Ee({
  props: {
    show: Boolean,
    fieldsForm: Object
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, r = Vs(n, "show", t), i = ce("caseOther"), a = ce("$bus"), o = j(), s = j({ id: "", students_num: 0, start_time: "" }), l = j([{ start_time: "", end_time: "" }]), u = {
      students_num: [
        { required: !0, message: "\u8BF7\u8F93\u5165\u8FD1\u4E24\u5B66\u671F\u5B66\u4E60\u4EBA\u6570", trigger: "blur" },
        { pattern: /^[1-9]\d*$/, message: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u5B66\u4E60\u4EBA\u6570", trigger: "blur" }
      ]
    }, { updateCourse: c } = ov(a), f = () => {
      r.value = !1;
    };
    Ne(
      () => r.value,
      async (y) => {
        y ? (await bt(), o.value.clearValidate(), s.value.students_num = n.fieldsForm.students_num, n.fieldsForm.runTermTime && n.fieldsForm.runTermTime.length && (l.value = n.fieldsForm.runTermTime)) : (s.value = {
          id: "",
          students_num: 0,
          start_time: ""
        }, l.value = [{ start_time: "", end_time: "" }]);
      }
    );
    const d = () => {
      l.value.push({ start_time: "", end_time: "" });
    }, h = (y) => {
      l.value.splice(y, 1);
    }, p = () => {
      o.value.validate(async (y) => {
        if (y) {
          const m = l.value.filter((b) => b.start_time || b.end_time);
          if (!m.length) {
            An.error("\u8BF7\u8F93\u5165\u5F00\u8BFE\u65F6\u95F4");
            return;
          }
          s.value.start_time = encodeURI(JSON.stringify(m)), s.value.id = i.id, c(s.value), f();
        }
      });
    };
    return (y, m) => {
      const b = ti, x = Sa, D = uK, S = fn, C = Ca, v = ni;
      return P(), ue(v, {
        modelValue: E(r),
        "onUpdate:modelValue": m[1] || (m[1] = (H) => Bn(r) ? r.value = H : null),
        title: "\u8FD0\u884C\u60C5\u51B5",
        width: "620px",
        "before-close": f,
        "close-on-click-modal": !1
      }, {
        footer: N(() => [
          T("div", H5e, [
            B(S, {
              class: "btn",
              type: "primary",
              plain: !0,
              onClick: p
            }, {
              default: N(() => [
                I5e
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(C, {
            ref_key: "formRef",
            ref: o,
            model: s.value,
            "label-width": "80px",
            rules: u
          }, {
            default: N(() => [
              B(x, {
                label: "\u5B66\u4E60\u4EBA\u6570",
                prop: "students_num"
              }, {
                default: N(() => [
                  B(b, {
                    modelValue: s.value.students_num,
                    "onUpdate:modelValue": m[0] || (m[0] = (H) => s.value.students_num = H),
                    type: "number",
                    min: 0,
                    placeholder: "\u8BF7\u8F93\u5165\u8FD1\u4E24\u5B66\u671F\u5B66\u4E60\u4EBA\u6570",
                    style: { width: "484px" }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, {
                label: "\u5F00\u8BFE\u65F6\u95F4",
                prop: "start_time"
              }, {
                default: N(() => [
                  (P(!0), L(nt, null, Lt(l.value, (H, V) => (P(), L("div", {
                    key: V,
                    class: "term-box"
                  }, [
                    T("div", O5e, [
                      B(D, {
                        modelValue: H.start_time,
                        "onUpdate:modelValue": (R) => H.start_time = R,
                        type: "datetime",
                        placeholder: "\u5F00\u8BFE\u5F00\u59CB\u65F6\u95F4"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      z5e,
                      B(D, {
                        modelValue: H.end_time,
                        "onUpdate:modelValue": (R) => H.end_time = R,
                        type: "datetime",
                        placeholder: " \u5F00\u8BFE\u7ED3\u675F\u65F6\u95F4"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    V > 0 ? (P(), L("i", {
                      key: 0,
                      class: "iconfont icon-shanchu1 delete-icon",
                      onClick: (R) => h(V)
                    }, null, 8, D5e)) : re("", !0)
                  ]))), 128)),
                  B(S, {
                    type: "primary",
                    class: "add-btn term-btn",
                    onClick: d
                  }, {
                    default: N(() => [
                      M5e
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const B5e = /* @__PURE__ */ Ht(L5e, [["__scopeId", "data-v-ed3ac850"]]), N5e = { class: "dialog-footer" }, j5e = /* @__PURE__ */ je("\u4FDD \u5B58"), F5e = /* @__PURE__ */ Ee({
  props: {
    show: Boolean,
    fieldsForm: Object
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, r = Vs(n, "show", t), i = ce("caseOther"), a = ce("$bus"), o = j(), s = j({ id: "", teaching_methods: "", course_type: "", course_url: "" }), l = {
      course_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u8BFE\u7A0B\u540D\u79F0", trigger: "blur" }],
      teacher_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u8BFE\u7A0B\u8D1F\u8D23\u4EBA", trigger: "blur" }],
      organ_name: [{ required: !0, message: "\u8BF7\u8F93\u5165\u6240\u5C5E\u673A\u6784", trigger: "blur" }]
    }, { courseTypeList: u, teachingMethodList: c, updateCourse: f, getCourseDict: d } = ov(a), h = () => {
      r.value = !1;
    };
    Ne(
      () => r.value,
      async (y) => {
        y && (d("course_type"), d("teaching_methods"), await bt(), o.value.clearValidate(), n.fieldsForm && (s.value = Dl(n.fieldsForm)));
      }
    );
    const p = () => {
      o.value.validate(async (y) => {
        if (y) {
          const m = {
            id: i.id,
            teaching_methods: s.value.teaching_methods,
            course_type: s.value.course_type,
            course_url: s.value.course_url
          };
          f(m), h();
        }
      });
    };
    return (y, m) => {
      const b = ti, x = Sa, D = wc, S = Tc, C = Ca, v = fn, H = ni;
      return P(), ue(H, {
        modelValue: E(r),
        "onUpdate:modelValue": m[6] || (m[6] = (V) => Bn(r) ? r.value = V : null),
        title: "\u7F16\u8F91\u8BFE\u7A0B",
        width: "650px",
        "before-close": h,
        "close-on-click-modal": !1
      }, {
        footer: N(() => [
          T("div", N5e, [
            B(v, {
              class: "btn",
              type: "primary",
              plain: !0,
              onClick: p
            }, {
              default: N(() => [
                j5e
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(C, {
            ref_key: "formRef",
            ref: o,
            model: s.value,
            "label-width": "100px",
            rules: l
          }, {
            default: N(() => [
              B(x, {
                label: "\u8BFE\u7A0B\u540D\u79F0",
                prop: "course_name"
              }, {
                default: N(() => [
                  B(b, {
                    modelValue: s.value.course_name,
                    "onUpdate:modelValue": m[0] || (m[0] = (V) => s.value.course_name = V),
                    placeholder: "\u8BF7\u8F93\u5165\u8BFE\u7A0B\u540D\u79F0",
                    style: { width: "480px" },
                    disabled: !0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, {
                label: "\u8BFE\u7A0B\u8D1F\u8D23\u4EBA",
                prop: "teacher_name"
              }, {
                default: N(() => [
                  B(b, {
                    modelValue: s.value.teacher_name,
                    "onUpdate:modelValue": m[1] || (m[1] = (V) => s.value.teacher_name = V),
                    placeholder: "\u8BF7\u8F93\u5165\u8BFE\u7A0B\u8D1F\u8D23\u4EBA",
                    style: { width: "480px" },
                    disabled: !0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, {
                label: "\u6240\u5C5E\u673A\u6784",
                prop: "organ_name"
              }, {
                default: N(() => [
                  B(b, {
                    modelValue: s.value.organ_name,
                    "onUpdate:modelValue": m[2] || (m[2] = (V) => s.value.organ_name = V),
                    placeholder: "\u8BF7\u8F93\u5165\u6240\u5C5E\u673A\u6784",
                    style: { width: "480px" },
                    disabled: !0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, { label: "\u8BFE\u7A0B\u7C7B\u578B" }, {
                default: N(() => [
                  B(S, {
                    modelValue: s.value.course_type,
                    "onUpdate:modelValue": m[3] || (m[3] = (V) => s.value.course_type = V),
                    clearable: "",
                    placeholder: "\u8BF7\u9009\u62E9",
                    style: { width: "480px" }
                  }, {
                    default: N(() => [
                      (P(!0), L(nt, null, Lt(E(u), (V) => (P(), ue(D, {
                        key: V.id,
                        label: V.name,
                        value: V.id
                      }, null, 8, ["label", "value"]))), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, { label: "\u6559\u5B66\u65B9\u5F0F" }, {
                default: N(() => [
                  B(S, {
                    modelValue: s.value.teaching_methods,
                    "onUpdate:modelValue": m[4] || (m[4] = (V) => s.value.teaching_methods = V),
                    clearable: "",
                    placeholder: "\u8BF7\u9009\u62E9",
                    style: { width: "480px" }
                  }, {
                    default: N(() => [
                      (P(!0), L(nt, null, Lt(E(c), (V) => (P(), ue(D, {
                        key: V.id,
                        label: V.name,
                        value: V.id
                      }, null, 8, ["label", "value"]))), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              B(x, { label: "\u8BFE\u7A0B\u94FE\u63A5" }, {
                default: N(() => [
                  B(b, {
                    modelValue: s.value.course_url,
                    "onUpdate:modelValue": m[5] || (m[5] = (V) => s.value.course_url = V),
                    placeholder: "\u8BF7\u4EE5http://\u6216https://\u5F00\u5934",
                    style: { width: "480px" },
                    clearable: !0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const X5e = /* @__PURE__ */ Ht(F5e, [["__scopeId", "data-v-dbbc091b"]]), wr = (e) => (yn("data-v-b1fa5380"), e = e(), bn(), e), R5e = {
  key: 0,
  class: "course-header"
}, V5e = { class: "container" }, U5e = ["src"], q5e = { class: "left-hover" }, _5e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("div", { class: "tip-text" }, "\u4E0A\u4F20\u8BFE\u7A0B\u5C01\u9762\u56FE\u7247", -1)), W5e = { class: "right" }, K5e = { class: "course-info" }, G5e = { class: "course-title" }, Y5e = { class: "title text-overflow" }, Q5e = { class: "info-list" }, Z5e = { class: "info-item text-overflow" }, J5e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u8BFE\u7A0B\u8D1F\u8D23\u4EBA\uFF1A", -1)), $5e = { class: "info-item text-overflow" }, e7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u6240\u5C5E\u5B66\u9662\uFF1A", -1)), t7e = { class: "info-item text-overflow" }, n7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u8BFE\u7A0B\u7C7B\u578B\uFF1A", -1)), i7e = { class: "info-item text-overflow" }, r7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u6559\u5B66\u65B9\u5F0F\uFF1A", -1)), a7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("div", { class: "split-line" }, null, -1)), o7e = { class: "info-list term-num" }, s7e = { class: "popover-content" }, l7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("div", { class: "title" }, "\u5F00\u8BFE\u65F6\u95F4:", -1)), u7e = { class: "info-item text-overflow" }, c7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u8FD0\u884C\u5B66\u671F\u2002", -1)), d7e = { class: "unit" }, f7e = /* @__PURE__ */ je(" \u5B66\u671F "), h7e = { class: "info-item text-overflow" }, p7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, "\u7D2F\u8BA1\u5B66\u4E60\u4EBA\u6570\u2002", -1)), v7e = { class: "unit" }, m7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("span", null, " \u4EBA", -1)), g7e = { class: "operate-box" }, y7e = { key: 0 }, b7e = {
  key: 0,
  class: "btn-box"
}, A7e = { class: "website-hint" }, T7e = /* @__PURE__ */ je(" \u672A\u914D\u7F6E\u8BFE\u7A0B\u94FE\u63A5\uFF0C\u70B9\u51FB "), w7e = ["href"], P7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tijiaoshenhe" }, null, -1)), x7e = /* @__PURE__ */ je(" \u63D0\u4EA4\u5BA1\u6838 "), C7e = [
  P7e,
  x7e
], S7e = {
  key: 1,
  class: "check-submit"
}, E7e = { class: "btn-box" }, k7e = { class: "website-hint" }, O7e = /* @__PURE__ */ je(" \u672A\u914D\u7F6E\u8BFE\u7A0B\u94FE\u63A5\uFF0C\u70B9\u51FB "), z7e = ["href"], D7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bohui" }, null, -1)), M7e = /* @__PURE__ */ je(" \u64A4\u56DE\u5BA1\u6838 "), H7e = [
  D7e,
  M7e
], I7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("i", { class: "iconfont icon-chexiao" }, null, -1)), L7e = /* @__PURE__ */ je(" \u91CD\u65B0\u4FEE\u6539 "), B7e = [
  I7e,
  L7e
], N7e = { class: "review-text" }, j7e = {
  key: 1,
  class: "check-submit"
}, F7e = ["href"], X7e = { class: "review-text" }, R7e = { key: 2 }, V7e = {
  key: 0,
  class: "check-submit"
}, U7e = ["href"], q7e = { class: "review-text" }, _7e = { style: { "margin-right": "7px" } }, W7e = { key: 0 }, K7e = { key: 1 }, G7e = {
  key: 1,
  class: "btn-box"
}, Y7e = ["href"], Q7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bohui" }, null, -1)), Z7e = /* @__PURE__ */ je(" \u5BA1\u6838\u9A73\u56DE "), J7e = [
  Q7e,
  Z7e
], $7e = /* @__PURE__ */ wr(() => /* @__PURE__ */ T("i", { class: "iconfont icon-tongguo" }, null, -1)), eme = /* @__PURE__ */ je(" \u5BA1\u6838\u901A\u8FC7 "), tme = [
  $7e,
  eme
], nme = {
  key: 3,
  class: "btn-box"
}, ime = ["href"], rme = /* @__PURE__ */ Ee({
  setup(e) {
    const t = ce("siteId"), n = ce("$bus"), r = ce("caseInfo"), i = ce("caseOther"), a = ce("$utils"), o = ce("type"), s = ce("pageMode"), l = ce("checkInfo"), u = a.getUrlParams("progressId"), c = j(!1), f = j(!1), {
      handleSubmitCheck: d,
      handleCancelCheck: h,
      handleResetCheckStatus: p,
      getCheckComment: y,
      updateCheckInfo: m,
      creatorCheckText: b,
      allCheckText: x
    } = rv(l);
    u && y(u);
    const D = j(1), S = j(!1), C = (q) => {
      D.value = q, S.value = !0;
    }, v = J(() => {
      const q = E(r);
      if (q.extend && q.extend.start_time)
        try {
          return JSON.parse(decodeURIComponent(q.extend.start_time));
        } catch (G) {
          console.log(G);
        }
      return [];
    }), { updateCourse: H } = ov(n), V = j(!1), R = (q) => {
      console.log("\u4E0A\u4F20\u8BFE\u7A0B\u5C01\u9762", q);
      let G = {
        id: i.id,
        cover_id: q.id
      };
      H(G);
    }, F = j(!1), K = j(!1);
    return (q, G) => {
      const te = gf, Q = Ki;
      return P(), L(nt, null, [
        E(r).extend ? (P(), L("div", R5e, [
          B(E(Ou), {
            height: "240px",
            opacity: 0.2,
            url: E(r).extend.cover_url || E(a).getImage("diffMark/bg/course_bg1.png")
          }, {
            default: N(() => [
              T("div", V5e, [
                T("div", {
                  class: se(["left", { "upload-hide": E(s) != 1 }])
                }, [
                  T("img", {
                    src: E(r).extend.cover_url || E(a).getImage("diffMark/bg/course_bg1.png"),
                    alt: ""
                  }, null, 8, U5e),
                  T("div", q5e, [
                    T("div", {
                      class: "upload-box",
                      onClick: G[0] || (G[0] = (Y) => V.value = !0)
                    }, [
                      B(E(qi), {
                        name: "upload",
                        color: "var(--el-color-primary)",
                        size: "16px"
                      })
                    ]),
                    _5e
                  ])
                ], 2),
                T("div", W5e, [
                  T("div", K5e, [
                    T("div", G5e, [
                      T("div", Y5e, de(E(r).extend.course_name), 1),
                      E(s) == 1 ? (P(), L("i", {
                        key: 0,
                        class: "iconfont icon-bianji edit-icon",
                        onClick: G[1] || (G[1] = (Y) => K.value = !0)
                      })) : re("", !0)
                    ]),
                    T("ul", Q5e, [
                      T("li", Z5e, [
                        J5e,
                        T("span", null, de(E(r).extend.teacher_name), 1)
                      ]),
                      T("li", $5e, [
                        e7e,
                        T("span", null, de(E(r).extend.organ_name), 1)
                      ]),
                      T("li", t7e, [
                        n7e,
                        T("span", null, de(E(r).extend.course_type_name || "-"), 1)
                      ]),
                      T("li", i7e, [
                        r7e,
                        T("span", null, de(E(r).extend.teaching_methods_name || "-"), 1)
                      ])
                    ]),
                    a7e,
                    T("ul", o7e, [
                      B(te, {
                        placement: "bottom-start",
                        width: "250",
                        trigger: "hover",
                        "show-arrow": "",
                        disabled: !E(v).length
                      }, {
                        reference: N(() => [
                          T("div", u7e, [
                            c7e,
                            T("span", null, [
                              T("span", d7e, de(E(v).length), 1),
                              f7e
                            ])
                          ])
                        ]),
                        default: N(() => [
                          T("div", s7e, [
                            l7e,
                            T("ul", null, [
                              (P(!0), L(nt, null, Lt(E(v), (Y, Z) => (P(), L("li", {
                                class: "content-list",
                                key: Z
                              }, de(E(a).formatDate(Y.start_time, "YYYY\u5E74MM\u6708DD\u65E5")) + "-" + de(E(a).formatDate(Y.end_time, "YYYY\u5E74MM\u6708DD\u65E5")), 1))), 128))
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      T("li", h7e, [
                        p7e,
                        T("span", v7e, de(E(r).extend.students_num), 1),
                        m7e,
                        E(s) == 1 ? (P(), L("i", {
                          key: 0,
                          class: "iconfont icon-bianji edit-icon",
                          onClick: G[2] || (G[2] = (Y) => F.value = !0)
                        })) : re("", !0)
                      ])
                    ])
                  ]),
                  T("div", g7e, [
                    E(o) == 3 ? (P(), L("div", y7e, [
                      E(l).checkStatus == 0 || E(l).checkStatus == 4 ? (P(), L("div", b7e, [
                        B(te, {
                          placement: "top",
                          trigger: "hover",
                          width: "200px",
                          disabled: !!E(r).extend.course_url,
                          teleported: !1
                        }, {
                          reference: N(() => [
                            T("a", {
                              href: E(r).extend.course_url,
                              target: "_blank",
                              class: "btn website-btn"
                            }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, w7e)
                          ]),
                          default: N(() => [
                            T("div", A7e, [
                              T7e,
                              T("span", {
                                class: "link",
                                onClick: G[3] || (G[3] = (Y) => K.value = !0)
                              }, "\u914D\u7F6E")
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        E(l).isNeedCheck == 2 ? (P(), L("div", {
                          key: 0,
                          class: "btn primary-btn",
                          onClick: G[4] || (G[4] = (Y) => E(d)(E(t), E(i).source, E(i).taskId))
                        }, C7e)) : re("", !0)
                      ])) : re("", !0),
                      E(l).checkStatus > 0 && E(l).checkStatus < 4 ? (P(), L("div", S7e, [
                        T("div", E7e, [
                          B(te, {
                            placement: "top",
                            trigger: "hover",
                            width: "200px",
                            disabled: !!E(r).extend.course_url,
                            teleported: !1
                          }, {
                            reference: N(() => [
                              T("a", {
                                href: E(r).extend.course_url,
                                target: "_blank",
                                class: "btn website-btn"
                              }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, z7e)
                            ]),
                            default: N(() => [
                              T("div", k7e, [
                                O7e,
                                T("span", {
                                  class: "link",
                                  onClick: G[5] || (G[5] = (Y) => K.value = !0)
                                }, "\u914D\u7F6E")
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          E(l).checkStatus != 2 ? (P(), ue(Q, {
                            key: 0,
                            effect: "light",
                            "raw-content": !0,
                            content: E(l).checkStatus == 3 ? "\u5BA1\u6838\u5458\u5DF2\u5BA1\u6838\uFF0C\u65E0\u6CD5\u64A4\u56DE\u3002<br />\u5982\u9700\u9000\u56DE\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA1\u6838\u5458" : "\u5DF2\u5728\u5BA1\u6838\u4E2D\uFF0C\u65E0\u6CD5\u64A4\u56DE\u3002<br />\u5982\u9700\u9000\u56DE\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA1\u6838\u5458",
                            placement: "top",
                            disabled: !(E(l).checkIsStart && (E(l).checkStatus == 1 || E(l).checkStatus == 3))
                          }, {
                            default: N(() => [
                              T("div", {
                                class: se(["btn primary-btn", { "disabled-btn": E(l).checkIsStart }]),
                                onClick: G[6] || (G[6] = (Y) => E(h)(E(i).taskId))
                              }, H7e, 2)
                            ]),
                            _: 1
                          }, 8, ["content", "disabled"])) : re("", !0),
                          E(l).checkStatus == 2 ? (P(), L("div", {
                            key: 1,
                            class: "btn primary-btn",
                            onClick: G[7] || (G[7] = (Y) => E(p)(0))
                          }, B7e)) : re("", !0)
                        ]),
                        T("div", N7e, [
                          T("span", null, de(E(b)()), 1),
                          T("span", {
                            class: "look-check",
                            onClick: G[8] || (G[8] = (Y) => c.value = !0)
                          }, "\u67E5\u770B\u5BA1\u6838\u60C5\u51B5>")
                        ])
                      ])) : re("", !0)
                    ])) : re("", !0),
                    E(o) == 1 && E(l).isNeedCheck == 2 ? (P(), L("div", j7e, [
                      E(r).extend.course_url ? (P(), L("a", {
                        key: 0,
                        href: E(r).extend.course_url,
                        target: "_blank",
                        class: "btn website-btn"
                      }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, F7e)) : re("", !0),
                      T("div", X7e, [
                        T("span", null, de(E(x)()), 1),
                        T("span", {
                          class: "look-check",
                          onClick: G[9] || (G[9] = (Y) => c.value = !0)
                        }, "\u67E5\u770B\u5BA1\u6838\u8FDB\u5EA6>")
                      ])
                    ])) : re("", !0),
                    E(o) == 2 && E(l).checkStatus ? (P(), L("div", R7e, [
                      E(u) ? (P(), L("div", V7e, [
                        E(r).extend.course_url ? (P(), L("a", {
                          key: 0,
                          href: E(r).extend.course_url,
                          target: "_blank",
                          class: "btn website-btn"
                        }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, U7e)) : re("", !0),
                        T("div", q7e, [
                          T("span", _7e, de(E(l).checkTime), 1),
                          E(l).valid_status == 2 ? (P(), L("span", W7e, de(E(l).realname_valid) + "\u5DF2\u901A\u8FC7 ", 1)) : (P(), L("span", K7e, de(E(l).operation_type == 2 ? "\u5BA1\u6838\u901A\u8FC7" : "\u5BA1\u6838\u9A73\u56DE"), 1)),
                          E(l).comment || E(l).review_comments_valid ? (P(), L("span", {
                            key: 2,
                            class: "look-check",
                            onClick: G[10] || (G[10] = (Y) => f.value = !0)
                          }, " \u67E5\u770B\u5BA1\u6838\u610F\u89C1> ")) : re("", !0)
                        ])
                      ])) : (P(), L("div", G7e, [
                        E(r).extend.course_url ? (P(), L("a", {
                          key: 0,
                          href: E(r).extend.course_url,
                          target: "_blank",
                          class: "btn website-btn"
                        }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, Y7e)) : re("", !0),
                        T("div", {
                          class: "btn primary-btn",
                          onClick: G[11] || (G[11] = (Y) => C(2))
                        }, J7e),
                        T("div", {
                          class: "btn theme-btn",
                          onClick: G[12] || (G[12] = (Y) => C(1))
                        }, tme)
                      ]))
                    ])) : re("", !0),
                    E(o) > 3 || E(o) == 0 ? (P(), L("div", nme, [
                      E(r).extend.course_url ? (P(), L("a", {
                        key: 0,
                        href: E(r).extend.course_url,
                        target: "_blank",
                        class: "btn website-btn"
                      }, " \u5B66\u4E60\u7F51\u7AD9 > ", 8, ime)) : re("", !0)
                    ])) : re("", !0)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["opacity", "url"])
        ])) : re("", !0),
        B(E5e, {
          showDialog: V.value,
          "onUpdate:showDialog": G[13] || (G[13] = (Y) => V.value = Y),
          onChangeCover: R
        }, null, 8, ["showDialog"]),
        B(X5e, {
          show: K.value,
          "onUpdate:show": G[14] || (G[14] = (Y) => K.value = Y),
          fieldsForm: E(r).extend
        }, null, 8, ["show", "fieldsForm"]),
        B(B5e, {
          show: F.value,
          "onUpdate:show": G[15] || (G[15] = (Y) => F.value = Y),
          fieldsForm: { runTermTime: E(v), students_num: E(r).extend.students_num }
        }, null, 8, ["show", "fieldsForm"]),
        c.value ? (P(), ue(NC, {
          key: 1,
          isShow: c.value,
          "onUpdate:isShow": G[16] || (G[16] = (Y) => c.value = Y),
          isFounder: E(o) == 3,
          taskId: E(i).taskId
        }, null, 8, ["isShow", "isFounder", "taskId"])) : re("", !0),
        B(jC, {
          show: S.value,
          "onUpdate:show": G[17] || (G[17] = (Y) => S.value = Y),
          checkType: D.value,
          onUpdateCheckInfo: G[18] || (G[18] = (Y) => E(m)(Y, E(i).taskId))
        }, null, 8, ["show", "checkType"]),
        B(FC, {
          show: f.value,
          "onUpdate:show": G[19] || (G[19] = (Y) => f.value = Y),
          comment: E(l).valid_status == 2 ? E(l).review_comments_valid : E(l).comment
        }, null, 8, ["show", "comment"])
      ], 64);
    };
  }
});
const ame = /* @__PURE__ */ Ht(rme, [["__scopeId", "data-v-b1fa5380"]]), ome = (e) => (yn("data-v-87593bef"), e = e(), bn(), e), sme = /* @__PURE__ */ ome(() => /* @__PURE__ */ T("div", { class: "header" }, [
  /* @__PURE__ */ T("span", { class: "title" }, "\u8BFE\u7A0B\u4FE1\u606F")
], -1)), lme = { class: "reset-box" }, ume = { class: "dialog-footer" }, cme = /* @__PURE__ */ je("\u53D6 \u6D88"), dme = /* @__PURE__ */ je("\u4FDD \u5B58"), fme = /* @__PURE__ */ Ee({
  props: {
    isShow: {
      type: Boolean,
      default: !1
    },
    id: {
      type: [String, Number],
      default: 0
    }
  },
  emits: ["update:isShow"],
  setup(e, { emit: t }) {
    const n = e, {
      getJJCourseInfo: r,
      updJJCourseInfo: i,
      getJJGeneralDict: a,
      getJJCourseResultsList: o,
      getJJSubjectList: s
    } = ce("$http"), l = ce("$bus"), u = zt({
      course_nature: [],
      courseResults: [],
      subjectList: []
    }), c = j({
      id: "",
      subject_id: null,
      subject_name: null,
      course_results: null,
      course_results_name: null,
      course_nature: null,
      course_nature_name: null,
      credit: 0,
      online_hours: 0,
      school_hours: 0
    }), f = j(), d = Vs(n, "isShow", t), h = zt({}), p = async () => {
      x(), d.value = !1;
    }, y = async (D) => {
      D && await D.validate(async (S) => {
        let C = c.value.subject_id;
        if (typeof c.value.subject_id != "string" && (C = [...c.value.subject_id].pop()), S) {
          const v = {
            ...c.value,
            subject_id: C
          };
          await i(v), An.success("\u4FDD\u5B58\u6210\u529F"), p(), l.emit("updateContent");
        }
      });
    }, m = async () => {
      const D = await r({
        id: n.id
      });
      c.value = {
        ...D,
        credit: Number(D.credit),
        online_hours: Number(D.online_hours),
        school_hours: Number(D.school_hours)
      };
    }, b = async () => {
      const D = await s(), S = await a({ dict_type: "course_nature" }), C = await o();
      u.subjectList = D, u.courseResults = C, u.course_nature = S;
    }, x = () => {
      c.value = {
        id: "",
        subject_id: null,
        subject_name: null,
        course_results: null,
        course_results_name: null,
        course_nature: null,
        course_nature_name: null,
        credit: 0,
        online_hours: 0,
        school_hours: 0
      };
    };
    return Ne(d, async (D) => {
      D && (n.id && (await b(), await m()), await bt(), f.value.clearValidate());
    }), (D, S) => {
      const C = Ac, v = Sa, H = AA, V = wc, R = Tc, F = aT, K = QA, q = Ca, G = fn, te = ni;
      return E(d) ? (P(), ue(te, {
        key: 0,
        modelValue: E(d),
        "onUpdate:modelValue": S[7] || (S[7] = (Q) => Bn(d) ? d.value = Q : null),
        width: "940px",
        "before-close": p,
        "destroy-on-close": ""
      }, {
        title: N(() => [
          sme
        ]),
        footer: N(() => [
          T("span", ume, [
            B(G, { onClick: p }, {
              default: N(() => [
                cme
              ]),
              _: 1
            }),
            B(G, {
              type: "primary",
              onClick: S[6] || (S[6] = (Q) => y(f.value))
            }, {
              default: N(() => [
                dme
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          T("div", lme, [
            c.value ? (P(), ue(q, {
              key: 0,
              ref_key: "formRef",
              ref: f,
              model: c.value,
              rules: E(h),
              "label-width": 100,
              "label-position": "top"
            }, {
              default: N(() => [
                B(F, {
                  gutter: 20,
                  style: { marginBottom: "20px" }
                }, {
                  default: N(() => [
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u6240\u5C5E\u5B66\u79D1",
                          prop: "subject_id"
                        }, {
                          default: N(() => [
                            B(C, {
                              modelValue: c.value.subject_id,
                              "onUpdate:modelValue": S[0] || (S[0] = (Q) => c.value.subject_id = Q),
                              placeholder: "\u8BF7\u9009\u62E9\u6240\u5C5E\u5B66\u79D1",
                              options: E(u).subjectList,
                              props: {
                                checkStrictly: !0,
                                label: "subjectName",
                                value: "id"
                              },
                              style: { width: "100%" }
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u8BFE\u7A0B\u6210\u679C",
                          prop: "course_results"
                        }, {
                          default: N(() => [
                            B(R, {
                              modelValue: c.value.course_results,
                              "onUpdate:modelValue": S[1] || (S[1] = (Q) => c.value.course_results = Q),
                              placeholder: "\u8BF7\u9009\u62E9\u8BFE\u7A0B\u6210\u679C",
                              style: { width: "100%" }
                            }, {
                              default: N(() => [
                                (P(!0), L(nt, null, Lt(E(u).courseResults, (Q) => (P(), ue(V, {
                                  key: Q.id,
                                  label: Q.name,
                                  value: Q.id
                                }, null, 8, ["label", "value"]))), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u8BFE\u7A0B\u6027\u8D28",
                          prop: "course_nature"
                        }, {
                          default: N(() => [
                            B(R, {
                              modelValue: c.value.course_nature,
                              "onUpdate:modelValue": S[2] || (S[2] = (Q) => c.value.course_nature = Q),
                              placeholder: "\u8BF7\u9009\u62E9\u8BFE\u7A0B\u6027\u8D28",
                              style: { width: "100%" }
                            }, {
                              default: N(() => [
                                (P(!0), L(nt, null, Lt(E(u).course_nature, (Q) => (P(), ue(V, {
                                  key: Q.id,
                                  label: Q.name,
                                  value: Q.id
                                }, null, 8, ["label", "value"]))), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                B(F, {
                  gutter: 20,
                  style: { marginBottom: "20px" }
                }, {
                  default: N(() => [
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u5B66\u5206",
                          prop: "credit"
                        }, {
                          default: N(() => [
                            B(K, {
                              modelValue: c.value.credit,
                              "onUpdate:modelValue": S[3] || (S[3] = (Q) => c.value.credit = Q),
                              controls: !1,
                              class: "num",
                              maxlength: "5",
                              placeholder: "\u8BF7\u8F93\u5165\u5B66\u5206",
                              min: 0,
                              max: 99999
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u7EBF\u4E0A\u5B66\u65F6",
                          prop: "online_hours"
                        }, {
                          default: N(() => [
                            B(K, {
                              modelValue: c.value.online_hours,
                              "onUpdate:modelValue": S[4] || (S[4] = (Q) => c.value.online_hours = Q),
                              controls: !1,
                              class: "num",
                              maxlength: "5",
                              placeholder: "\u8BF7\u8F93\u5165\u5B66\u5206",
                              min: 0,
                              max: 99999
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    B(H, { span: 8 }, {
                      default: N(() => [
                        B(v, {
                          label: "\u8BFE\u5802\u5B66\u65F6",
                          prop: "school_hours"
                        }, {
                          default: N(() => [
                            B(K, {
                              modelValue: c.value.school_hours,
                              "onUpdate:modelValue": S[5] || (S[5] = (Q) => c.value.school_hours = Q),
                              controls: !1,
                              class: "num",
                              maxlength: "5",
                              placeholder: "\u8BF7\u8F93\u5165\u5B66\u5206",
                              min: 0,
                              max: 99999
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])) : re("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])) : re("", !0);
    };
  }
});
const hme = /* @__PURE__ */ Ht(fme, [["__scopeId", "data-v-87593bef"]]), pme = { class: "course-info" }, vme = { class: "label" }, mme = {
  key: 0,
  class: "value"
}, gme = {
  key: 1,
  class: "empty"
}, yme = /* @__PURE__ */ Ee({
  props: {
    columnInfo: Object
  },
  setup(e, { expose: t }) {
    const n = e, { getJJCourseInfo: r } = ce("$http"), i = j(!1), a = zt([
      {
        label: "\u6240\u5C5E\u5B66\u79D1",
        value: ""
      },
      {
        label: "\u8BFE\u7A0B\u6210\u679C",
        value: ""
      },
      {
        label: "\u8BFE\u7A0B\u6027\u8D28",
        value: ""
      },
      {
        label: "\u5B66\u5206",
        value: ""
      },
      {
        label: "\u7EBF\u4E0A\u5B66\u65F6",
        value: ""
      },
      {
        label: "\u8BFE\u5802\u5B66\u65F6",
        value: ""
      }
    ]), o = async (l) => {
      const u = await r({ id: l });
      for (const c of a)
        switch (c.label) {
          case "\u6240\u5C5E\u5B66\u79D1":
            c.value = u.subject_name;
            break;
          case "\u8BFE\u7A0B\u6210\u679C":
            c.value = u.course_results_name;
            break;
          case "\u8BFE\u7A0B\u6027\u8D28":
            c.value = u.course_nature_name;
            break;
          case "\u5B66\u5206":
            c.value = u.credit;
            break;
          case "\u7EBF\u4E0A\u5B66\u65F6":
            c.value = u.online_hours;
            break;
          case "\u8BFE\u5802\u5B66\u65F6":
            c.value = u.school_hours;
            break;
        }
    }, s = (l) => l != null;
    return t({
      changeEidtDialog: (l) => {
        i.value = !0;
      }
    }), Ne(
      () => {
        var l;
        return (l = n.columnInfo) == null ? void 0 : l.siteId;
      },
      async (l) => {
        l && await o(l);
      },
      {
        immediate: !0,
        deep: !0
      }
    ), (l, u) => (P(), L(nt, null, [
      T("div", pme, [
        (P(!0), L(nt, null, Lt(E(a), (c, f) => (P(), L("div", {
          key: f,
          class: "item"
        }, [
          T("div", vme, de(c.label), 1),
          s(c.value) ? (P(), L("div", mme, de(c.value), 1)) : (P(), L("div", gme, "\u672A\u586B\u5199"))
        ]))), 128))
      ]),
      B(hme, {
        id: n.columnInfo.siteId,
        isShow: i.value,
        "onUpdate:isShow": u[0] || (u[0] = (c) => i.value = c)
      }, null, 8, ["id", "isShow"])
    ], 64));
  }
});
const bme = /* @__PURE__ */ Ht(yme, [["__scopeId", "data-v-775f45c8"]]), Ame = (e) => (yn("data-v-bd1441bd"), e = e(), bn(), e), Tme = {
  key: 0,
  class: "course-introduction"
}, wme = /* @__PURE__ */ Ame(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji edit-icon" }, null, -1)), Pme = /* @__PURE__ */ je(" \u7F16\u8F91 "), xme = { class: "content" }, Cme = /* @__PURE__ */ Ee({
  props: {
    columnInfo: Object
  },
  setup(e) {
    const t = e, n = j(), r = j(), i = (o) => {
      switch (console.log("\u{1F92A} number >>:", o), o) {
        case 32:
          n.value.changeEidtDialog();
          break;
        default:
          r.value.editColumnContent();
          break;
      }
    }, a = J(() => {
      var o;
      return ((o = t.columnInfo) == null ? void 0 : o.columnType) === 32;
    });
    return (o, s) => {
      const l = E3;
      return E(a) ? (P(), L("div", Tme, [
        B(V3, { "column-info": e.columnInfo }, {
          right: N(() => [
            B(l, {
              underline: !1,
              type: "primary",
              size: "default",
              onClick: s[0] || (s[0] = (u) => i(e.columnInfo.columnType))
            }, {
              default: N(() => [
                wme,
                Pme
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["column-info"]),
        T("div", xme, [
          B(bme, {
            ref_key: "courseInfoRef",
            ref: n,
            "column-info": e.columnInfo
          }, null, 8, ["column-info"])
        ])
      ])) : (P(), ue(Yx, {
        key: 1,
        "module-info": e.columnInfo
      }, null, 8, ["module-info"]));
    };
  }
});
const Sme = /* @__PURE__ */ Ht(Cme, [["__scopeId", "data-v-bd1441bd"]]);
const Eme = { class: "radio-box" }, kme = { class: "dialog-footer" }, Ome = /* @__PURE__ */ je("\u53D6\u6D88"), zme = /* @__PURE__ */ je("\u63D0\u4EA4"), Dme = {
  props: {
    show: Boolean
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = ce("$http"), r = ce("caseOther"), i = ce("styleType"), a = [
      {
        label: "\u672C\u6559\u7814\u5BA4\u53EF\u89C1\uFF0C\u53EF\u5F15\u7528",
        id: 5
      },
      {
        label: "\u672C\u6559\u7814\u5BA4\u53EF\u89C1\uFF0C\u4E0D\u53EF\u5F15\u7528",
        id: 6
      }
    ], o = zt([
      {
        label: "\u4EC5\u81EA\u5DF1\u53EF\u89C1",
        id: 0
      },
      {
        label: "\u6240\u6709\u4EBA\u53EF\u89C1\uFF0C\u53EF\u5F15\u7528",
        id: 1
      },
      {
        label: "\u6240\u6709\u4EBA\u53EF\u89C1\uFF0C\u4E0D\u53EF\u5F15\u7528",
        id: 2
      },
      {
        label: "\u672C\u673A\u6784\u6559\u5E08\u53EF\u89C1\uFF0C\u53EF\u5F15\u7528",
        id: 3
      },
      {
        label: "\u672C\u673A\u6784\u6559\u5E08\u53EF\u89C1\uFF0C\u4E0D\u53EF\u5F15\u7528",
        id: 4
      }
    ]), s = J(() => i === "v3" ? o.concat(a) : o), l = j(r.caseAuth || 1), u = () => {
      t("update:show", !1);
    }, c = async () => {
      const { ret: f } = await n.updateCaseAuth({ permission: l.value, id: r.id });
      f && (An.success("\u6743\u9650\u4FEE\u6539\u6210\u529F"), u());
    };
    return (f, d) => {
      const h = b3, p = Lq, y = fn, m = ni;
      return P(), ue(m, {
        modelValue: e.show,
        "onUpdate:modelValue": d[1] || (d[1] = (b) => Bn(show) ? show.value = b : null),
        width: "520px",
        "append-to-body": !0,
        title: `${E(r).caseTypeName}\u6743\u9650\u8BBE\u7F6E`,
        "before-close": u,
        "destroy-on-close": "",
        "close-on-click-modal": !1
      }, {
        footer: N(() => [
          T("div", kme, [
            B(y, {
              size: "large",
              onClick: u
            }, {
              default: N(() => [
                Ome
              ]),
              _: 1
            }),
            B(y, {
              type: "primary",
              size: "large",
              onClick: c
            }, {
              default: N(() => [
                zme
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          T("div", Eme, [
            B(p, {
              modelValue: l.value,
              "onUpdate:modelValue": d[0] || (d[0] = (b) => l.value = b)
            }, {
              default: N(() => [
                (P(!0), L(nt, null, Lt(E(s), (b) => (P(), ue(h, {
                  key: b.id,
                  label: b.id
                }, {
                  default: N(() => [
                    je(de(b.label), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
}, UC = /* @__PURE__ */ Ht(Dme, [["__scopeId", "data-v-ef1694c2"]]), sv = (e) => {
  const t = ce("$http"), n = j(0);
  return {
    caseQuoteAuth: n,
    getQuoteCaseAuth: async () => {
      const i = await t.getCopyCaseAuth({ site_id: e });
      n.value = i;
    }
  };
};
const Mme = { class: "case-dialog-wrapper" }, Hme = { class: "case-form" }, Ime = { class: "dialog-footer" }, Lme = /* @__PURE__ */ je("\u53D6\u6D88"), Bme = /* @__PURE__ */ je("\u4FDD\u5B58"), Nme = {
  props: {
    show: Boolean,
    type: {
      type: Number,
      default: 0
    },
    caseInfo: Object
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const n = e, r = ce("caseOther"), i = J(() => n.type === 1 ? `\u7F16\u8F91${r.caseTypeName}` : n.type === 2 ? `\u590D\u5236${r.caseTypeName}` : `\u5F15\u7528${r.caseTypeName}`), a = ce("$http"), o = ce("siteId"), s = ce("$bus"), l = j(!1), u = j(), c = j([]), f = j([]), d = zt({
      case_name: "",
      course_id: "",
      outline_id: "",
      outline_name: "",
      semseter: "",
      semester_id: "",
      schoolyear_id: ""
    }), h = zt({
      case_name: [
        { required: !0, message: `\u8BF7\u8F93\u5165${r.caseTypeName}\u540D\u79F0`, trigger: "blur" }
      ],
      course_id: [
        { required: !0, message: "\u8BF7\u9009\u62E9\u8BFE\u7A0B", trigger: "change" }
      ],
      semseter: [
        { required: !0, message: "\u8BF7\u9009\u62E9\u6240\u5C5E\u5B66\u671F", trigger: "change" }
      ]
    });
    Ne(() => n.caseInfo, (v) => {
      n.type === 1 && v && (d.case_name = v.case_name, d.course_id = v.course_id, d.outline_id = v.outline_id == 0 ? "" : v.outline_id, d.outline_name = v.outline_name || "", d.semseter = {
        schoolyear_id: v.schoolyear_id,
        semester_id: v.semester_id,
        name: v.term_name
      }, d.semester_id = v.semester_id, d.schoolyear_id = v.schoolyear_id, d.id = v.id);
    }, {
      immediate: !0
    });
    const p = () => {
      u.value.resetFields(), d.outline_name = "", t("update:show", !1);
    }, y = () => {
      if (!d.course_id) {
        An.warning("\u8BF7\u5148\u9009\u62E9\u8BFE\u7A0B");
        return;
      }
      l.value = !0;
    }, m = ({ id: v, name: H }) => {
      d.outline_id = v, d.outline_name = H;
    }, b = () => {
      d.outline_id = "", d.outline_name = "";
    }, x = (v) => {
      d.schoolyear_id = v.schoolyear_id, d.semester_id = v.semester_id;
    }, D = (v) => {
      !v || v.validate(async (H) => {
        if (H) {
          let V = {
            ...d,
            outline_id: d.outline_id || 0,
            case_type: r.caseType
          };
          if (n.type === 1)
            try {
              const { site: R } = await a.editBKTeach(V);
              R && (An.success("\u4FEE\u6539\u6210\u529F"), p(), s.emit("contentChange", 1));
            } catch (R) {
              An.error(R.message);
            }
          else
            try {
              V.site_id = o;
              const R = await a.copyCase(V);
              if (R) {
                let F = n.type === 2 ? "\u590D\u5236\u6210\u529F" : "\u5F15\u7528\u6210\u529F";
                An.success(F), p(), setTimeout(() => {
                  window.location.href = `/caseDetail.html?siteId=${R}&type=3`;
                }, 2e3);
              }
            } catch (R) {
              An.error(R.message);
            }
        }
      });
    }, S = async () => {
      const v = await a.getBKSelectCourse();
      c.value = v.map((H) => ({ value: H.id, label: H.course_name }));
    }, C = async () => {
      f.value = await a.getBKTermList();
    };
    return n.type !== 1 && S(), C(), (v, H) => {
      const V = ti, R = Sa, F = QZ, K = qt, q = wc, G = Tc, te = Ca, Q = fn, Y = ni;
      return P(), L("div", Mme, [
        B(Y, {
          modelValue: e.show,
          "onUpdate:modelValue": H[5] || (H[5] = (Z) => Bn(show) ? show.value = Z : null),
          width: "520px",
          title: E(i),
          "before-close": p,
          "destroy-on-close": "",
          "close-on-click-modal": !1
        }, {
          footer: N(() => [
            T("div", Ime, [
              B(Q, {
                size: "large",
                onClick: p
              }, {
                default: N(() => [
                  Lme
                ]),
                _: 1
              }),
              B(Q, {
                type: "primary",
                size: "large",
                onClick: H[4] || (H[4] = (Z) => D(u.value))
              }, {
                default: N(() => [
                  Bme
                ]),
                _: 1
              })
            ])
          ]),
          default: N(() => [
            T("div", Hme, [
              B(te, {
                model: E(d),
                ref_key: "caseFormRef",
                ref: u,
                rules: E(h),
                "label-position": "top"
              }, {
                default: N(() => [
                  B(R, {
                    label: "\u540D\u79F0",
                    prop: "case_name"
                  }, {
                    default: N(() => [
                      B(V, {
                        modelValue: E(d).case_name,
                        "onUpdate:modelValue": H[0] || (H[0] = (Z) => E(d).case_name = Z),
                        size: "large",
                        placeholder: `\u8BF7\u8F93\u5165${E(r).caseTypeName}\u540D\u79F0`
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  Bt(B(R, {
                    label: "\u6240\u5C5E\u8BFE\u7A0B",
                    prop: "course_id"
                  }, {
                    default: N(() => [
                      B(F, {
                        modelValue: E(d).course_id,
                        "onUpdate:modelValue": H[1] || (H[1] = (Z) => E(d).course_id = Z),
                        filterable: !0,
                        clearable: !0,
                        size: "large",
                        options: c.value,
                        style: { width: "100%" },
                        placeholder: "\u8BF7\u9009\u62E9\u8BFE\u7A0B"
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }, 512), [
                    [Cn, e.type !== 1]
                  ]),
                  B(R, {
                    label: "\u7AE0\u8282\u540D\u79F0",
                    prop: "outline_id"
                  }, {
                    default: N(() => [
                      B(V, {
                        modelValue: E(d).outline_name,
                        "onUpdate:modelValue": H[2] || (H[2] = (Z) => E(d).outline_name = Z),
                        class: "chapter-input",
                        size: "large",
                        readonly: !0,
                        placeholder: "\u8BF7\u9009\u62E9\u7AE0\u8282",
                        onClick: y
                      }, {
                        suffix: N(() => [
                          E(d).outline_name ? (P(), ue(K, {
                            key: 0,
                            onClick: wt(b, ["stop"])
                          }, {
                            default: N(() => [
                              B(E(Tte))
                            ]),
                            _: 1
                          }, 8, ["onClick"])) : (P(), ue(K, { key: 1 }, {
                            default: N(() => [
                              B(E(W0))
                            ]),
                            _: 1
                          }))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  B(R, {
                    label: "\u6240\u5C5E\u5B66\u671F",
                    prop: "semseter"
                  }, {
                    default: N(() => [
                      B(G, {
                        modelValue: E(d).semseter,
                        "onUpdate:modelValue": H[3] || (H[3] = (Z) => E(d).semseter = Z),
                        "value-key": "name",
                        clearable: !0,
                        filterable: !0,
                        placeholder: "\u8BF7\u9009\u62E9\u6240\u5C5E\u5B66\u671F",
                        size: "large",
                        onChange: x,
                        style: { width: "100%" }
                      }, {
                        default: N(() => [
                          (P(!0), L(nt, null, Lt(f.value, (Z, oe) => (P(), ue(q, {
                            label: Z.name,
                            value: Z,
                            key: oe
                          }, null, 8, ["label", "value"]))), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        l.value ? (P(), ue(Kx, {
          key: 0,
          show: l.value,
          "onUpdate:show": H[6] || (H[6] = (Z) => l.value = Z),
          type: 1,
          selected: E(d).outline_id,
          courseId: E(d).course_id,
          onHandleSelectedChapter: m
        }, null, 8, ["show", "selected", "courseId"])) : re("", !0)
      ]);
    };
  }
}, qC = /* @__PURE__ */ Ht(Nme, [["__scopeId", "data-v-e9d41e0b"]]), _s = (e) => (yn("data-v-f5ba42ae"), e = e(), bn(), e), jme = {
  key: 0,
  class: "detail-box"
}, Fme = { class: "left" }, Xme = { class: "case-name" }, Rme = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji1" }, null, -1)), Vme = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("span", null, "\u7F16\u8F91", -1)), Ume = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("i", { class: "iconfont icon-quanxian" }, null, -1)), qme = {
  key: 0,
  class: "banner-btn-group"
}, _me = { key: 0 }, Wme = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("span", null, "\u590D\u5236", -1)), Kme = /* @__PURE__ */ je(" \u63D0\u4EA4\u534F\u4F5C "), Gme = {
  key: 1,
  class: "banner-action"
}, Yme = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528", -1)), Qme = { class: "collaboration-button" }, Zme = { class: "collaboration-info" }, Jme = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiala toggle-arrow-span" }, null, -1)), $me = { class: "commemts-box" }, e9e = { class: "title" }, t9e = /* @__PURE__ */ je(" \u5168\u90E8\u672A\u63D0\u4EA4\u6279\u6CE8\u2002 "), n9e = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("div", { class: "line" }, null, -1)), i9e = { class: "comments-list" }, r9e = {
  key: 1,
  class: "empty-box"
}, a9e = /* @__PURE__ */ je(" \u63D0\u4EA4\u6279\u6CE8 "), o9e = {
  key: 2,
  class: "banner-action"
}, s9e = /* @__PURE__ */ _s(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528", -1)), l9e = /* @__PURE__ */ je(" \u52A0\u5165\u534F\u4F5C "), u9e = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array
  },
  setup(e) {
    const t = ce("type"), n = ce("siteId"), r = ce("$bus"), i = ce("caseInfo"), a = ce("userInfo"), o = ce("caseOther"), s = j(!1), l = j(!1), u = j(1), { caseQuoteAuth: c, getQuoteCaseAuth: f } = sv(n);
    f();
    const d = j(!1), { authNum: h, authList: p, getCooperationList: y, confirmSubmit: m, collaboratorApply: b } = w2(n, r);
    y();
    const { submitAnnotation: x } = Wl(n), D = () => {
      x(() => {
        r.emit("updateContent", 1);
      });
    }, S = (C) => {
      u.value = C, s.value = !0;
    };
    return (C, v) => {
      var K;
      const H = fn, V = Ki, R = vf, F = pf;
      return P(), L(nt, null, [
        E(i) && E(i).extend ? (P(), L("div", jme, [
          T("div", Fme, [
            T("span", Xme, de(E(i).extend.case_name), 1),
            E(t) == 3 ? (P(), ue(H, {
              key: 0,
              class: "edit-btn",
              size: "small",
              plane: "",
              onClick: v[0] || (v[0] = (q) => S(1))
            }, {
              default: N(() => [
                Rme,
                Vme
              ]),
              _: 1
            })) : re("", !0),
            E(t) == 3 ? (P(), ue(H, {
              key: 1,
              class: "edit-btn",
              size: "small",
              plane: "",
              onClick: v[1] || (v[1] = (q) => l.value = !0)
            }, {
              default: N(() => [
                Ume,
                T("span", null, de(E(o).caseTypeName) + "\u6743\u9650", 1)
              ]),
              _: 1
            })) : re("", !0)
          ]),
          E(t) != 5 ? (P(), L("div", qme, [
            E(t) == 3 ? (P(), L("div", _me, [
              B(H, {
                type: "text",
                class: "copy-btn",
                onClick: v[2] || (v[2] = (q) => S(2))
              }, {
                default: N(() => [
                  B(E(qi), {
                    name: "copy",
                    iconClass: "copy-icon"
                  }),
                  Wme
                ]),
                _: 1
              }),
              B(H, {
                size: "large",
                class: "banner-btn",
                onClick: v[3] || (v[3] = (q) => d.value = !0)
              }, {
                default: N(() => [
                  je(de(E(h) || 0) + "\u4EBA\u534F\u4F5C ", 1)
                ]),
                _: 1
              }),
              B(V, {
                visible: E(i).sub_status === 0,
                effect: "light",
                content: "\u4F60\u5DF2\u7ECF\u7F16\u8F91\u4E86\u65B0\u5185\u5BB9\uFF0C\u8BB0\u5F97\u63D0\u4EA4\u534F\u4F5C\u54E6~",
                placement: "top"
              }, {
                default: N(() => [
                  B(H, {
                    type: "primary",
                    size: "large",
                    class: "banner-btn",
                    disabled: E(i).sub_status !== 0,
                    onClick: E(m)
                  }, {
                    default: N(() => [
                      Kme
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }, 8, ["visible"])
            ])) : re("", !0),
            E(t) == 4 ? (P(), L("div", Gme, [
              E(c) ? (P(), ue(H, {
                key: 0,
                type: "text",
                class: "copy-btn",
                onClick: v[4] || (v[4] = (q) => S(3))
              }, {
                default: N(() => [
                  B(E(qi), {
                    name: "copy",
                    iconClass: "copy-icon"
                  }),
                  Yme
                ]),
                _: 1
              })) : re("", !0),
              T("div", Qme, [
                B(F, {
                  trigger: "hover",
                  "hide-on-click": !0
                }, {
                  dropdown: N(() => [
                    B(R, null, {
                      default: N(() => {
                        var q, G;
                        return [
                          T("div", $me, [
                            T("div", e9e, [
                              t9e,
                              T("span", null, de((q = e.allUnsubmittedNoteList) == null ? void 0 : q.length), 1),
                              n9e
                            ]),
                            T("div", i9e, [
                              (G = e.allUnsubmittedNoteList) != null && G.length ? (P(!0), L(nt, { key: 0 }, Lt(e.allUnsubmittedNoteList, (te) => (P(), ue(av, {
                                key: te.id,
                                item: te
                              }, null, 8, ["item"]))), 128)) : (P(), L("div", r9e, [
                                B(E(bi), {
                                  type: "message",
                                  text: "\u6682\u65E0\u6279\u6CE8"
                                })
                              ]))
                            ])
                          ])
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  default: N(() => {
                    var q;
                    return [
                      T("div", Zme, [
                        je(" \u5F85\u63D0\u4EA4\u6279\u6CE8(" + de((q = e.allUnsubmittedNoteList) == null ? void 0 : q.length) + ")\u2002 ", 1),
                        Jme
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              B(H, {
                disabled: !((K = e.allUnsubmittedNoteList) != null && K.length),
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: D
              }, {
                default: N(() => [
                  a9e
                ]),
                _: 1
              }, 8, ["disabled"])
            ])) : re("", !0),
            E(t) == 0 ? (P(), L("div", o9e, [
              E(c) ? (P(), ue(H, {
                key: 0,
                type: "text",
                class: "copy-btn",
                onClick: v[5] || (v[5] = (q) => S(3))
              }, {
                default: N(() => [
                  B(E(qi), {
                    name: "copy",
                    iconClass: "copy-icon"
                  }),
                  s9e
                ]),
                _: 1
              })) : re("", !0),
              E(o).caseRole == 0 ? (P(), ue(H, {
                key: 1,
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: v[6] || (v[6] = (q) => E(b)(E(a).id, E(o).source))
              }, {
                default: N(() => [
                  l9e
                ]),
                _: 1
              })) : re("", !0)
            ])) : re("", !0)
          ])) : re("", !0)
        ])) : re("", !0),
        B(P2, {
          showAuthListDialog: d.value,
          "onUpdate:showAuthListDialog": v[7] || (v[7] = (q) => d.value = q),
          authList: E(p),
          onGetAuthList: E(y)
        }, null, 8, ["showAuthListDialog", "authList", "onGetAuthList"]),
        s.value ? (P(), ue(qC, {
          key: 1,
          show: s.value,
          "onUpdate:show": v[8] || (v[8] = (q) => s.value = q),
          type: u.value,
          caseInfo: E(i).extend
        }, null, 8, ["show", "type", "caseInfo"])) : re("", !0),
        B(UC, {
          show: l.value,
          "onUpdate:show": v[9] || (v[9] = (q) => l.value = q)
        }, null, 8, ["show"])
      ], 64);
    };
  }
});
const c9e = /* @__PURE__ */ Ht(u9e, [["__scopeId", "data-v-f5ba42ae"]]), Mc = (e) => (yn("data-v-717fa3fa"), e = e(), bn(), e), d9e = { class: "course-detail-banner" }, f9e = { class: "course-detail-banner-wrapper" }, h9e = { class: "top-nav" }, p9e = /* @__PURE__ */ je(" \u60A8\u6240\u5728\u7684\u4F4D\u7F6E\uFF1A"), v9e = {
  key: 0,
  class: "case-info"
}, m9e = { class: "case-info-item" }, g9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u8BFE\u7A0B", -1)), y9e = ["title"], b9e = { class: "case-info-item" }, A9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u5B66\u671F", -1)), T9e = ["title"], w9e = { class: "case-info-item" }, P9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u7AE0\u8282", -1)), x9e = ["title"], C9e = {
  key: 0,
  class: "case-info-item"
}, S9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u6559\u7814\u5BA4", -1)), E9e = ["title"], k9e = { class: "case-info-item" }, O9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u673A\u6784", -1)), z9e = ["title"], D9e = { class: "case-info-item" }, M9e = /* @__PURE__ */ Mc(() => /* @__PURE__ */ T("div", { class: "title" }, "\u521B\u5EFA\u8001\u5E08", -1)), H9e = ["title"], I9e = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array,
    isHeadFixed: Boolean
  },
  setup(e) {
    const t = ce("caseInfo"), n = ce("caseOther"), r = zt({
      url: "",
      name: ""
    }), i = window.localStorage.getItem("currentPage");
    i ? (r.url = JSON.parse(i).url, r.name = JSON.parse(i).name) : (r.url = `${window.location.origin}/teachCenter.html`, r.name = "\u6211\u7684\u6559\u7814\u5BA4");
    const a = () => {
      window.location.href = r.url;
    };
    return (o, s) => {
      var l;
      return P(), L("div", d9e, [
        T("div", f9e, [
          T("div", h9e, [
            p9e,
            T("a", {
              class: "link",
              onClick: a
            }, de(E(r).name), 1),
            je(" > " + de((l = E(n)) == null ? void 0 : l.caseTypeName) + "\u8BE6\u60C5 ", 1)
          ]),
          B(c9e, { allUnsubmittedNoteList: e.allUnsubmittedNoteList }, null, 8, ["allUnsubmittedNoteList"]),
          E(t) && E(t).extend ? (P(), L("ul", v9e, [
            T("li", m9e, [
              g9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.course_name
              }, de(E(t).extend.course_name), 9, y9e)
            ]),
            T("li", b9e, [
              A9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.term_name
              }, de(E(t).extend.term_name), 9, T9e)
            ]),
            T("li", w9e, [
              P9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.outline_name
              }, de(E(t).extend.outline_name || "-"), 9, x9e)
            ]),
            E(t).extend.group_name ? (P(), L("li", C9e, [
              S9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.group_name
              }, de(E(t).extend.group_name || "-"), 9, E9e)
            ])) : re("", !0),
            T("li", k9e, [
              O9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.organ_name
              }, de(E(t).extend.organ_name || "-"), 9, z9e)
            ]),
            T("li", D9e, [
              M9e,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.teacher_name
              }, de(E(t).extend.teacher_name || "-"), 9, H9e)
            ])
          ])) : re("", !0)
        ])
      ]);
    };
  }
});
const L9e = /* @__PURE__ */ Ht(I9e, [["__scopeId", "data-v-717fa3fa"]]), B9e = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAARKADAAQAAAABAAAARAAAAADA2cO/AAALS0lEQVR4Ae1cXawV1RWePTP3XLBQQRvhocXWh/pgqti3vtCScgNIEROjD1eKP+0trZBWm5AANXgq+PNAIkShASn2tsQmtU1RqGDFQO1DX6TRNn1qUi22UewDVinXe7hnpt+3ZtY5c+aeWTP3h3hPwr6cs/fsvfa31/r2WnvvOecMnnc5XWbAYsBZjVXa7rh/z5xR78OFrhnXqshfKpk4cI0rrwjf/cXOTf+byhiTImTV97YviyNv0MXeLbEXL+imQIxKgjOXFKPkUMMcyaEco8ycScvMmfLtUmm8aX8MeNZz8UuhC3/54r4fvWJ06do0IUJWb3jihqg59jQG/5oYljEwjz5Rg/L91cCqBJHG7ASIYc6d8oNw45E9m/+Wxy+6rkzI6g071niRdwgTOIdg3RTQOmlPZ18NyiuQJ6yMgHx7VTxoet7Fbu2RfQ+9kO/T7boSIbdueHQgbnrHEB6BgpQZ1JqudASHCvTHe1KhZeaSlM30shVeaUixl4pQPt/fwkdb03P+LUf2bvm9jGW8lRJyxw+eWNQYi96MoniekkA8lD+CWrsC546Nxe56mPusKom2kZofX+uJM51Ph6djsSwOlikn7Rebblkzjp7jGGka6Q/mAEP7a3VBHs6qjTU+XtR08Uovcg/Ao+a2JgVdfN99UAv9m57fvflMAYJUh1Yj2xrNeDtmZp7zfVxxEfQ5yyddX3zf4V1b36bMmg2Pzeda2Jp9aPP8U1v/w7aqCRj/FTKAkyZgfH9CGOj3b7z+dNsDjx+MG95BKLtUPRD6zWuMxTvQvi7F75rRysJ0+4OPX4f5WktDOW98Bx1vLLhx/vLDu7a83eoYhPQYuo3kmVluiZQWiME/xfBbnlLaNS9A3RbcdPVyKPRGGw+aO++u2x988rq8fPbaJCS6GKwBqC+gUBBu1wjC4O7969dfzILQzSgDwZZB2faqZYwEIILx3+QJ4XjUMYSu1Fn0FyWcHzVHb5NiwZtJSOzHy5RhUdG5F3+ze9NfumFRTgxJSekmY9UJqaRhiqRmx6CusfOOqF6Se/7XszL5skkIdPucKpjMvv/HPEByjc0HfPhYX5jLq7ugUUsMepkvLyHYkK7a5FzwmtqQ5p+1+pqEBF5wjRooYL73flcwTK+SoQZ1lTMqsYSQj5aHGKITagqgMzcC2iG5511jAdBTixMQOmLZ+c1uwphb7HR0DY47aRcRUnVXmC4PwRLY9HGPwc0r0a19lhKFc28mIWIi2ZXU3g9zGMklhOHscmDq2l6xUongfjadiZ6bnHY5fcXJJCSJ6aQzzxm+VwDG8G9O0UOIISSUEF9sS9cWahylW7iS3VUwrTQJcQGMJBNIAlY4aTyHIJooSl7S8GG/6onnEEZkQizip3pXSzIIPBdFbd2w7VjJJiRjGN2tKBGkKStiKpHpV9QnXy8YWRImgZHHzF5zNZSQ4SQbqZQQ5QEHHHGAIqwOd5ykMcRQ4jsW86JBK9QnIQPXxnzKwU89sKCvSQj7kAgmKhrA/SabvlU/cNXIyMg34b4Lo8B//fpZG39brzv4cppCuHYTN6UpmcX+qB0q5hoy6hglk1W4KnA4KqcvX27uCpSAMVzFKcs8aO1Mifzg1t1LL4xc+EccR7si5232oujXf//46ZODm/fOzyIqGawLrPGynSqW1eOUl6JuJYQUdeusF7/BSEIaR8yMOrh1z1IX+Udx0r1SCIOhlIPHLfFddEJJUd/TCegcYWpXQjR00txCMwnhcZ3K80UwK2SEDIyk8hx0Hcjw4/goileoodkc9V/2vearDCfu6GzT/ixPRyLRisu8zPNMQrJKZcvjFE2nNytDMrAOtMhgn2x7q+zczY3R0RPwoqtadTnZceNNpIJrSEqu5lZ3mxD4PkH0ZQHJYOqWnutHpxYZ2h8fMp0K/PCrWKg/aNVRWefdDOy92TrBswacQJvgYnNQfKurTUiGDIJpnOcBA48Hs2RBTQb1Atw9SJjIegKbEQqnZvcFq4Yf/e5r2P74scK5RDZRFPJzea0pW9a6yeQaMhglIUQUKkYyCWE3VVpwCrbd2EVnxYDUQ1ju3HWCU/2hv2p/ff0FYg5vv/+08/sGgNlBio4lWJ47S9kpJ2EkDddUPwvTJETudWGcGlgE9IXgM38FA/8iCUKcDowcnvGHWuhaZCjG8Pah0zXXNwB4kJIsxppzYQX3x1R2anmyhrTJNk22byl91w6SZNa6q1av39kIg/AeUPcRSRFiIBr4wdGr584eR4aiHAApYV84ANbOCH5KPibiz/2z5j6kclPJaYFOlOYWnkmX8+PkE5H0tFoQMYL/04e//ersoPZFPwh+iK3tsSB03zj44++s3rlpnfld64FtQ6fnuk99CQvuevTbCfUHr3Xzv/KTLXedsxSv3JbuMlXXEPPoHnt+zA9XmJKbRJM/b2/93vcg+qR0mMDbU/W1H0J8/wS6TFiUYZjc3Nk2mIRI3OnQ4KUdQFrZG3kSjlzeuLjZOpcSore4cnsybXdctlLT2cowj3ADJXaIc9iM2IRw7UhJkNtyaxGZTisuARa9hJ+sircY+DYhmY7pJ9aZml4p8k48mdUph0wScskiRHZ7cQ3pCBk4vB0wHs7cRuLdrkIIu1ipezVNU8gg7soonfEM8aSafDAnk1qir+khZFVBejVkaL/aQRvwyY5JSSkhutMmIWNizcjG1hpCYkrIoAE2IQToILQX15AkZGgGJ7fMApsQWUTVR8hfbyY5e8AM2SNKFsUywpL4k7UER/de3HfTOUy+kwEp6Y1q0dTaHkJKNWSE3lL+isb5xOp1DREvoRYlhJgWOvy4QlMLUCt6JudJNZlVzS3VSzwEXVMwC2QmtyUegonFN49VJtUkhPGih1N+x6vlmUxAkW7y3bTYoGtAd0mTEDLa2b0dQt3hZmJt5qQqxnRalNe4hBCIp9tUz0YOdkann4fYXAg3JiFchPQUIkf3XnSQ1AXo7XJ0L5lZkxAJmNZnCWRD6UlH6YEMv6SEk7dv7sqcxCSECwiW1dRsktGbJ7Ps7jIlQpKQUYj2jtMDjtFWkXMIB6EVnFK1pi3QWdLp76zVK/w0XItEil3vHd7xZRueYCENWAC4jsivA1tWjSvYhHjufX6fwRfXE3yzYf4KeBz6DKigzqK72uD75iMnJiF+4L1Dz+Ar/dHdkhlg44RUQJgsEQ+BDczx7x0LwCQEG8wJsss/soI1ZfXWZ1640QKcSW3UlTqTCK6HzPH7txOWjiYhfjj7MDwjkl8B8C7RuZqL/eF9+17vs0BnQht1xK+ShkXn9A6XtiDuD1v6mYTsGFr+Fh6vONT2EZASx4vPeO++XH/22Oct4E+yjbr9EzrCqRerHvxeCR5yaMfQrW9pXbecsWCm+s9fWdRsjL4Z4yFEIJKQRB4PIYLNXbEfHOsPa2f85mjDBLrEjVHQXxsdayxyUXMltkZ5CJETydMpE8g4F/b3L66vGzhjqVJKCDtve+Z3A7GPx1QjPFBOUpDkm3SU5StOXOvgzKUdimidVOTeKEVVWwoo2YX4nfLaN52eHHqCqzIYBA9rupWPDK0qfdK7pc84xFzFtoPH8SBzdAiM63OmHRIkSkmSBnqSGikVeQpU3cSkzqsO6LR3MttKeF6CnpCdAB0NgXIex4a1D9+3YvoeZNbBH/nZ8RuaUSyPuuuAymiZQYpRNVfjlIC8wVVwMEn41aPbuO2eFdP/qHtWgfrw8WV4kmMQdYX/GUJWvlt5uglVPHgEf6z3Ep6beq5+9wpziy3Sq1t95br6r07O8UZHF9ZcWOOqqv9nhpZ1pWW91hFcy0XtlMmmMnkXjzU+3d//3oY7l1Z8FDyLfrl8mYGqDPwfHsrky6wWzeMAAAAASUVORK5CYII=", N9e = "data:image/png;base64,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", j9e = "data:image/png;base64,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", F9e = "data:image/png;base64,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", X9e = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAARKADAAQAAAABAAAARAAAAADA2cO/AAAQR0lEQVR4Ae1be7BVVRlfe+9zL+Cby2hpg2IvdNJqcqxGbWgsFfwDxXingYECgpen4mO0wzS8L++gERgUYhBBDHMUNEuadCxNTUzz1RjGqGkmBAn3cu/e/X7f2t8+++yz1zkXLjDTDIu5Z72+1/qtb33rcQ7GHEvHEPi/RaDf2Bnd+o75ac+jOQDvaCqrpatYjPzn3pt5oTFtvT0T9TGeuTCKjO953nPByfXf/9WcqXtqyehof6GjAjrK32/03NNaon2XR5HX508fTL/CmLAbAIBYO1dSNOabbf9pHYDGVR3VV4v/qAMyYMOGoGXbm99qazN9MPDeLVHzBZ5HJzAmojv4vuRZwz0TnpltOxL1owLINROmn36gxVxhQtNn31NvXWYi05UOEOFP/CB2A8CCLsM1ImONUPPwj7m2HQkQ0jKPCCDF4lOFFz/640VRFPbxPdP7QHP0dSqFI9ANkPtiAz2CZeaaLBQEymtDW8B2gnK00mED5KpJ87pH+w/0Nn7Y+8WPnv0+JvUkuwxiIDgijNuCYodnYwXaQIh/e4wf/caE/tb6OrOluS1c44VeL8ECfD7BPArpkLUMKG6ob/3X3y7BcPpEXtQbk3weB6wDaJftvtnuRd5WU4i2nHZuwzPLR406oHxXj5u5DTJ7aR2YPdAl6DL+/kUT/qltRyI/KECumdx0VtjSeiUG0RvTfWlozAkUQByYtJwIrWgwu+ANT5oo3NKpi791/Zyp71nOys9+jbO3RWGUeIjIR2SFlmeNF232jf/wpsW3vlXJ2bGWxPZqYq6+ec4XYMRiLzJXaqAT+syAJSZgKjUmeFgDgOslILWl4AVbzcVnPrtx4EDGhpqpX+MceEgID1ElLNkAm4opr6Jpsx+YzQ/Ov/UFgK1zU1O+i6AmIP0nzbsoamt7DO57soLBnCnHQDZ/DEyegOCtdab+8UN1cQICOb0UZArOLsm0PdC30zPBwyaINnc756TfpZef8LbzoyogAybO/xxmaXsYhQ2UlwWABmE7DAHP8wQAoG05v+uU54tFD67dsdR/wtxtYRT1Up3Q3gxEOpVLpfmcHB1GXPawNCPzGDx0c0PXEx5dXhz1aTmfu1Z1l4lM2yyoaEh2g1gx6h/ChMdD39tyXH3nJ9bMHPexqthkbtFih3Ic1gw2ZJFBULDLzELwfgQn2sHwmkFYl90tWHaiSGjhkGV1CliGomXox7v27Oo/seler/7EaRtnj9pdyyiFtoJueHHBKZ/ujj4MTVhHxZK86B3j1f1oQ1PjM4djvVYoTTUMmDSvLKgCkGkb5k8ukgSAeAOnzLuY4KA2AKH2NLZz4tJLLL2k0P1W5yjotXbhxPdJ60r2hJTTu283tlIvsmAQD/z5BW/oxnnjnz7SYFhzMA04e3CQcnZJWUr9G+dNefrB+ZPHDfz2mWf4heAyP/BWgXiX0Mb2kpd2iwzP+1KzHz7CQ2POcJMmZ2fk+1/0IoQCGgJfhOzXH5gz6Q8J5xEucExUqiHCVy/N6B1od60n0fxksbhhzGt7d16BO8EQ+EpfxLTjy8g9c8Ff97w0Fm2LytpTFScgiJWn0yBxQTtTb6b4KoqDb1m4Do29tAOH8iUPzB0/S+uaD56y4A3IPUHrfuQPW9fUyAGVJZ5MbQRBM9FJeUgZYapSLA5sQfUR/g0v3tt5//4950at4Rqgel6JzBuPZ4YlrsDvBMT3g+PT6xFu90lJaF7J64Yd6QzGm3jtnpRHheh4RhSGAghp27ywcx6d3He4f8Ue6vKQPF623Ve8fj+yl66duvja1rbwz0JHYCNz9uv7l3yNfdKW+WgH7hkOR5Uz6mNn4Bq2eb5ormde8fnHmS8U8ueEYEkMifP2eEieaWtnN74M3repS5KAEl2UR8u2fKvZAYPVeOZuypTotFKHZJEVswgoKfbcosrM7WxfY+AHr6fH40dedxdn/vTE1BTCZaPCXEKkPQhm1ZlwNR5+TIBLexjUvZpHD08aEUV+ohfG5rtugIsLby5xHDvYJZPWjSUs5w+dDORy0EzTaDkxTBs0V0NUiLa78nUzxj7l6ku3r50xbkO6Xq2suiV3eFw1fu3DEm5lXNMEefVazuZOQEioBmWZ8upjZi7ruq+5dLQ+zpi9y4pj92ZpR96x4jOt9S3JQjix4exPljReiWN5eeJJ1e65tt3lISOnQ96Bkrwe5tR/x7tNmcD2jsWJu6xvmC2CaL6T0ur9716zvq3FvK9/e1q9O8osiivNXsvbSsN894c7Lsujk6CK5UL9YoND//5Pm99N5B0w77/T+tF3s/J0yassGVuWKK67PQSG8DbBRONgVcziyEiCf3pcdlHTKMYlJhmoQxxV490l6XV5iO/xlbG0HOJXx4RPCgQ13VJlLA7cY25K0b+0wJwy4SMtt1zhcUjWWdJcHk1z5CUjKBtJJaGAGtso5ZwppinSl8orJdmWHHbbEcQ7jDKqQK1nc/YLKOhgyTkOgsYziKYgVdY25PLKLqdVnHkh2/Xqbu2y2koWpASlinLPgTOl1ae6pegERFYLtlAqVBfPMqfrhcAfEQZ+cncotLUmTwJpOq+u8zd8vCRrW0Pnup1aTuc+HtxDPKvYRwCOIt1bKtf53vltQX2CP/T+o9RrS14BC05faEjpkEVqNyDoVEQlT1SSrTKtLN6QO7As5X13Xd++d1AYjXuOsNuZzzdgRfHGqncsChBQ5XWRsYbS0jFHVCQfTkAkFoAMTwAiwrpmwnfkCxy/tb88ZnZIs4LqdhEnIBZHC0Z7bBhZXLEaU/EdHQT4l624e2RTlnfEtJWv4DnDLi0O2A9Grrzrx7/N0jFmyCajY9A8Q3jDtJVvYGerk2ahKQxbeff1v0+TyWSyLwaYY3MlJyBcZ/iiiB7WrhnC7fSziDVniyLrkbnHY4jtgZcue/234nGGq0xUiwCGDwhjUHUMAlPWA1325AlS3w+7gKkiCQgitKKrrMENCMgkoMIg5rWWjBwsUwA6dwXsHDJTsRmubVd2rGQAKCTlMvslzmnQd9noYydTGnK76NjnBEQOPIwfpW+kSV89xXanzlMV9JwpxiUmmTUXIrjcyc5AL+HMuxCBHI13IpSunZMsnvykblvLIXMDkhC7eRMSFgpBMA8H0PVJo2e2J+VUAQ9PY3y81bKJO6HfqdPLqe6kSAASYGmDww6caW6A0yWwBkGnvyRCkgKYE/6kkPSmC04P4cEM38dADgzDP1nOac5Medntw5/INOVWf37nsLW5HdnG6nYn1PfcOXxNUnEU9JCp1wq4vYOyypIhonookjuNBAmnnMPeoQcznRBXTGqX4hhcWaJgsDfpfE6nhxAOLmIVks9eah0z8xdTsRS+KstAmr2Hl952XcXbx00z1qwEtrITkLYQ1TUtuX1I7iORBD9MZrUgeNOsNatBIuNg9EAwnvWz2659pWQZS1iAyVHV1sv7SzUnIDzvY3tMKGstGfRfCsMuJwcdEoPYgawCEJx6ByHi20dmEIdB2/2gqwQEUaEU0DEkhwEY6uDQRLLtUi/sXo2sDBAChUVPtMS4as7uBERdlbOT3rIgMjfJ1wacclWaS8V+SCZNjZQEVUG3OnE1DyKnXD1Y4LMDInA19U5AuGKSuwRHUE0KlSFRMcGzdx/OS2USGn69gCRgV5LEfXZeVa/LQ+TrCvFJsMk7S86QIMp6WzyIKmPJ4XZYWKPZC/wt2Ed36OxjHp7PY8EA7kNf8i0+Vsa7eXTtbYP7rzIRfiHCxIF6/k4ppz54TuEOI5MFA1l2JScgBQjhwVNQhxC6cLW0ZPLQhdX6tW/J5CE3a7laTu8RD6LHUT/+8tLiKT8ck9ee10Y5TOUHuXLKfL+2XEJpXbKc6WjU4jlHkMwH4mBs4GQSUD5M2dwt0+khVKiISu6WIbaNn79+JeguUY/C2eeeBZMGLcgaPnH++hfgsMlDEhb36IUTh2zL0vHw6fMXWUicWJeHTJi/fjvGm1zuQDxi4cRBz6TlYTlbT5egKuE63V1WdgLCwwt/skUZ1tOqI4KJ7I412lOkgynyvFPLNMUVtH8ZQuNtl8sisDffPOJ2tEFCT+gVQMTOqPRqV8FuB8I4U9GlDU5AMCegwcEswcEtxAqzAKpgl07Zgbg910jqnTXIZEnFm5aQ5n9VTNvSSt1jcQJiD2bUQURq32VkoNbDxTDLFxdTmeBbQjnVkynCZvs1BIW6gyq5aoF3MGNxAmIV2e0K5sCkxFXYVZEQuReD5CHtQPiqPH2iM/D88Vg29oULdTyblp0qE36ok9OlNLh1I+iPw0YaTzntNK+pDM3F9sRlWXPLcwKiM54wu2WI3qbGHzyqBlTL5zb2X1WtX/vkRi+3UqvYFVSbGvuvUB5nLt7GXspiUHRSVnkPyTJl626Zh6Wn1jI4eCU6AM3zJTg9pIBtD7/uEffiyS7xlHw55talv5yM3eMr2o3fYDw66+Z+m7Su+dRlm5ZFoSe/GhLTCmbR7NHXVD4ScRGk7kbKn82nLn1oOTY1GYcdamHe7HF9y36KgV9R45DJUdQehxMQe5fhMZf7DeCoEQjRfTl88fJEqW8+AGsFINiPr4M42WopO4gk7lQAwiXCr7M4EXxylOiQRQN12DUMOu1tFwJ9r42vdmWAcCwciE6qa/lRvBsQ9sKoZBlX9zQoIz3+8GRA7GhDXqJR7GfiGSf3y2k2I5E2nUsl+wESuxshl4HnDIk0lEV9VmRWSlLP4bZ98qpEizPoJpyZgr3FqlHszNcsdAJETJuRo9Xk9yEUQzMURSWIc/EkVcU8eV0tEXKXtEJsVs3bnYAIEvhPTURWX8lLKipLuCf8Gq7LZSJYwMlfrKRCl+evwwlYYoj0+8HOXDo28h4jk4JcB50ljry1OGeUxhF472VJOBZ7MAOyDmCVpyRIW+JcDjOx4xMUcbkMTbo6/ca+Tem6qzxjdN9Rrr6ydtw/5L8VCCgypLJurcwYc9UILbtyOxaCa4GtNhbXUnfJPrrt6hWaH6L2ZEIFj+rCnB7CtZ4+Ojtd9hCNrMUmM4Wp1Ucd1y5TS470Z+JgtRji3b1yy/ciEy7FUu1BJHXbRKkOj7eEJW7jqcA7wHioGGuZeXsSDdEBkl7LzJkoV2WiUo92WfHSix89w+VbhTD+KKNP8ao92g9Y69AGWGwLxoT7IMcSn0s8MWAHgu/YAoINDzaft7GGBEwkJbutxTnBwdNf+nCjZWsC6RIlsRw1QqXakBDTi3jIsGpibZaD9LrTxPoDBHd+wRlbl6ITXfYjFiUVy0dd6l+2jDHADPuLyZI00xM4LceS8RpoJBPJWbTmlsqqREUn/RqkmDMhs4+5tmolxB22WzpUHnPVyQ4rv6RfiBOYKM1yas5+lcVyvDLirUDlcchxiu2V4Ep6MNM3dPwQ1oCnU28ROH4iLOiV9SUehBZMnXhTPIWqXPPEmqSBPCKp3R9pci1rnhXCdg5O+7XMXJP2sa5lzbMN0o6PpD8yi6Q8497HzzkQhWfhl/jGtGKZ6iuLlpkz1eq3VO3/rCWvo/1ZS6rI8+vM3++6rs8bWZZj9WMIlCPwP7qJi5535wweAAAAAElFTkSuQmCC", R9e = "data:image/png;base64,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", us = (e) => (yn("data-v-58a76ac4"), e = e(), bn(), e), V9e = {
  key: 0,
  class: "detail-box"
}, U9e = { class: "left" }, q9e = { class: "case-name" }, _9e = {
  key: 0,
  class: "banner-btn-group"
}, W9e = { key: 0 }, K9e = /* @__PURE__ */ je(" \u63D0\u4EA4\u534F\u4F5C "), G9e = /* @__PURE__ */ us(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji way-icon" }, null, -1)), Y9e = /* @__PURE__ */ us(() => /* @__PURE__ */ T("span", null, "\u7F16\u8F91", -1)), Q9e = [
  G9e,
  Y9e
], Z9e = /* @__PURE__ */ us(() => /* @__PURE__ */ T("i", { class: "iconfont icon-quanxian way-icon" }, null, -1)), J9e = /* @__PURE__ */ us(() => /* @__PURE__ */ T("span", null, "\u6559\u6848\u6743\u9650", -1)), $9e = [
  Z9e,
  J9e
], ege = /* @__PURE__ */ us(() => /* @__PURE__ */ T("span", null, "\u590D\u5236", -1)), tge = {
  key: 1,
  class: "banner-action"
}, nge = /* @__PURE__ */ us(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528", -1)), ige = { class: "collaboration-button" }, rge = { class: "collaboration-info" }, age = /* @__PURE__ */ us(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiala toggle-arrow-span" }, null, -1)), oge = { class: "commemts-box" }, sge = { class: "title" }, lge = /* @__PURE__ */ je(" \u5168\u90E8\u672A\u63D0\u4EA4\u6279\u6CE8\u2002 "), uge = /* @__PURE__ */ us(() => /* @__PURE__ */ T("div", { class: "line" }, null, -1)), cge = { class: "comments-list" }, dge = {
  key: 1,
  class: "empty-box"
}, fge = /* @__PURE__ */ je(" \u63D0\u4EA4\u6279\u6CE8 "), hge = {
  key: 2,
  class: "banner-action"
}, pge = /* @__PURE__ */ us(() => /* @__PURE__ */ T("span", null, "\u5F15\u7528", -1)), vge = /* @__PURE__ */ je(" \u52A0\u5165\u534F\u4F5C "), mge = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array
  },
  setup(e) {
    const t = ce("type"), n = ce("siteId"), r = ce("$bus"), i = ce("caseInfo"), a = ce("userInfo"), o = ce("caseOther"), s = j(!1), l = j(!1), u = j(1), { caseQuoteAuth: c, getQuoteCaseAuth: f } = sv(n);
    f();
    const d = j(!1), { authNum: h, authList: p, getCooperationList: y, confirmSubmit: m, collaboratorApply: b } = w2(n, r);
    y();
    const { submitAnnotation: x } = Wl(n), D = () => {
      x(() => {
        r.emit("updateContent", 1);
      });
    }, S = (C) => {
      u.value = C, s.value = !0;
    };
    return (C, v) => {
      var G;
      const H = fn, V = Ki, R = qt, F = gf, K = vf, q = pf;
      return P(), L(nt, null, [
        E(i) && E(i).extend ? (P(), L("div", V9e, [
          T("div", U9e, [
            T("span", q9e, de(E(i).extend.case_name), 1)
          ]),
          E(t) != 5 ? (P(), L("div", _9e, [
            E(t) == 3 ? (P(), L("div", W9e, [
              B(H, {
                size: "large",
                class: "banner-btn",
                onClick: v[0] || (v[0] = (te) => d.value = !0)
              }, {
                default: N(() => [
                  je(de(E(h) || 0) + "\u4EBA\u534F\u4F5C ", 1)
                ]),
                _: 1
              }),
              B(V, {
                visible: E(i).sub_status === 0,
                effect: "light",
                content: "\u4F60\u5DF2\u7ECF\u7F16\u8F91\u4E86\u65B0\u5185\u5BB9\uFF0C\u8BB0\u5F97\u63D0\u4EA4\u534F\u4F5C\u54E6~",
                placement: "top"
              }, {
                default: N(() => [
                  B(H, {
                    type: "primary",
                    size: "large",
                    class: "banner-btn",
                    disabled: E(i).sub_status !== 0,
                    onClick: E(m)
                  }, {
                    default: N(() => [
                      K9e
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }, 8, ["visible"]),
              B(F, {
                placement: "bottom",
                trigger: "hover",
                width: 96,
                teleported: !1
              }, {
                reference: N(() => [
                  B(R, { class: "more-btn" }, {
                    default: N(() => [
                      B(E(une))
                    ]),
                    _: 1
                  })
                ]),
                default: N(() => [
                  T("div", null, [
                    T("div", {
                      class: "operate-way",
                      onClick: v[1] || (v[1] = (te) => S(1))
                    }, Q9e),
                    T("div", {
                      class: "operate-way",
                      onClick: v[2] || (v[2] = (te) => l.value = !0)
                    }, $9e),
                    T("div", {
                      class: "operate-way",
                      onClick: v[3] || (v[3] = (te) => S(2))
                    }, [
                      B(R, { class: "way-icon" }, {
                        default: N(() => [
                          B(E(Ite))
                        ]),
                        _: 1
                      }),
                      ege
                    ])
                  ])
                ]),
                _: 1
              })
            ])) : re("", !0),
            E(t) == 4 ? (P(), L("div", tge, [
              E(c) ? (P(), ue(H, {
                key: 0,
                type: "text",
                class: "copy-btn",
                onClick: v[4] || (v[4] = (te) => S(3))
              }, {
                default: N(() => [
                  B(E(qi), {
                    name: "copy",
                    iconClass: "copy-icon"
                  }),
                  nge
                ]),
                _: 1
              })) : re("", !0),
              T("div", ige, [
                B(q, {
                  trigger: "hover",
                  "hide-on-click": !0
                }, {
                  dropdown: N(() => [
                    B(K, null, {
                      default: N(() => {
                        var te, Q;
                        return [
                          T("div", oge, [
                            T("div", sge, [
                              lge,
                              T("span", null, de((te = e.allUnsubmittedNoteList) == null ? void 0 : te.length), 1),
                              uge
                            ]),
                            T("div", cge, [
                              (Q = e.allUnsubmittedNoteList) != null && Q.length ? (P(!0), L(nt, { key: 0 }, Lt(e.allUnsubmittedNoteList, (Y) => (P(), ue(av, {
                                key: Y.id,
                                item: Y
                              }, null, 8, ["item"]))), 128)) : (P(), L("div", dge, [
                                B(E(bi), {
                                  type: "message",
                                  text: "\u6682\u65E0\u6279\u6CE8"
                                })
                              ]))
                            ])
                          ])
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  default: N(() => {
                    var te;
                    return [
                      T("div", rge, [
                        je(" \u5F85\u63D0\u4EA4\u6279\u6CE8(" + de((te = e.allUnsubmittedNoteList) == null ? void 0 : te.length) + ")\u2002 ", 1),
                        age
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              B(H, {
                disabled: !((G = e.allUnsubmittedNoteList) != null && G.length),
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: D
              }, {
                default: N(() => [
                  fge
                ]),
                _: 1
              }, 8, ["disabled"])
            ])) : re("", !0),
            E(t) == 0 ? (P(), L("div", hge, [
              E(c) ? (P(), ue(H, {
                key: 0,
                type: "text",
                class: "copy-btn",
                onClick: v[5] || (v[5] = (te) => S(3))
              }, {
                default: N(() => [
                  B(E(qi), {
                    name: "copy",
                    iconClass: "copy-icon"
                  }),
                  pge
                ]),
                _: 1
              })) : re("", !0),
              E(o).caseRole == 0 ? (P(), ue(H, {
                key: 1,
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: v[6] || (v[6] = (te) => E(b)(E(a).id, E(o).source))
              }, {
                default: N(() => [
                  vge
                ]),
                _: 1
              })) : re("", !0)
            ])) : re("", !0)
          ])) : re("", !0)
        ])) : re("", !0),
        B(P2, {
          showAuthListDialog: d.value,
          "onUpdate:showAuthListDialog": v[7] || (v[7] = (te) => d.value = te),
          authList: E(p),
          onGetAuthList: E(y)
        }, null, 8, ["showAuthListDialog", "authList", "onGetAuthList"]),
        s.value ? (P(), ue(qC, {
          key: 1,
          show: s.value,
          "onUpdate:show": v[8] || (v[8] = (te) => s.value = te),
          type: u.value,
          caseInfo: E(i).extend
        }, null, 8, ["show", "type", "caseInfo"])) : re("", !0),
        B(UC, {
          show: l.value,
          "onUpdate:show": v[9] || (v[9] = (te) => l.value = te)
        }, null, 8, ["show"])
      ], 64);
    };
  }
});
const gge = /* @__PURE__ */ Ht(mge, [["__scopeId", "data-v-58a76ac4"]]), Ea = (e) => (yn("data-v-a41ad458"), e = e(), bn(), e), yge = { class: "course-detail-banner" }, bge = { class: "course-detail-banner-wrapper" }, Age = { class: "top-nav" }, Tge = /* @__PURE__ */ je(" \u60A8\u6240\u5728\u7684\u4F4D\u7F6E\uFF1A "), wge = {
  key: 0,
  class: "case-info"
}, Pge = { class: "case-info-item" }, xge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: B9e,
  class: "item-icon",
  alt: ""
}, null, -1)), Cge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u8BFE\u7A0B", -1)), Sge = ["title"], Ege = { class: "case-info-item" }, kge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: N9e,
  class: "item-icon",
  alt: ""
}, null, -1)), Oge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u5B66\u671F", -1)), zge = ["title"], Dge = { class: "case-info-item" }, Mge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: j9e,
  class: "item-icon",
  alt: ""
}, null, -1)), Hge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u7AE0\u8282", -1)), Ige = ["title"], Lge = { class: "case-info-item" }, Bge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: F9e,
  class: "item-icon",
  alt: ""
}, null, -1)), Nge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u6559\u7814\u5BA4", -1)), jge = ["title"], Fge = { class: "case-info-item" }, Xge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: X9e,
  class: "item-icon",
  alt: ""
}, null, -1)), Rge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u673A\u6784", -1)), Vge = ["title"], Uge = { class: "case-info-item" }, qge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("img", {
  src: R9e,
  class: "item-icon",
  alt: ""
}, null, -1)), _ge = /* @__PURE__ */ Ea(() => /* @__PURE__ */ T("div", { class: "title" }, "\u521B\u5EFA\u8001\u5E08", -1)), Wge = ["title"], Kge = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array,
    isHeadFixed: Boolean
  },
  setup(e) {
    const t = ce("caseInfo"), n = ce("caseOther"), r = zt({
      url: "",
      name: ""
    }), i = window.localStorage.getItem("currentPage");
    i ? (r.url = JSON.parse(i).url, r.name = JSON.parse(i).name) : (r.url = `${window.location.origin}/teachCenter.html`, r.name = "\u6211\u7684\u6559\u7814\u5BA4");
    const a = () => {
      window.location.href = r.url;
    };
    return (o, s) => {
      var u;
      const l = Ki;
      return P(), L("div", yge, [
        T("div", bge, [
          T("div", Age, [
            Tge,
            T("a", {
              class: "link",
              onClick: a
            }, de(E(r).name), 1),
            je(" > " + de((u = E(n)) == null ? void 0 : u.caseTypeName) + "\u8BE6\u60C5 ", 1)
          ]),
          B(gge, { allUnsubmittedNoteList: e.allUnsubmittedNoteList }, null, 8, ["allUnsubmittedNoteList"]),
          E(t) && E(t).extend ? (P(), L("ul", wge, [
            T("li", Pge, [
              xge,
              T("div", null, [
                Cge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.course_name,
                  effect: "light",
                  disabled: E(t).extend.course_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.course_name
                    }, de(E(t).extend.course_name), 9, Sge)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ]),
            T("li", Ege, [
              kge,
              T("div", null, [
                Oge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.term_name,
                  effect: "light",
                  disabled: E(t).extend.term_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.term_name
                    }, de(E(t).extend.term_name), 9, zge)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ]),
            T("li", Dge, [
              Mge,
              T("div", null, [
                Hge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.outline_name,
                  effect: "light",
                  disabled: !E(t).extend.outline_name || E(t).extend.outline_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.outline_name
                    }, de(E(t).extend.outline_name || "-"), 9, Ige)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ]),
            T("li", Lge, [
              Bge,
              T("div", null, [
                Nge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.group_name,
                  effect: "light",
                  disabled: !E(t).extend.group_name || E(t).extend.group_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.group_name
                    }, de(E(t).extend.group_name || "-"), 9, jge)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ]),
            T("li", Fge, [
              Xge,
              T("div", null, [
                Rge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.organ_name,
                  effect: "light",
                  disabled: !E(t).extend.organ_name || E(t).extend.organ_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.organ_name
                    }, de(E(t).extend.organ_name || "-"), 9, Vge)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ]),
            T("li", Uge, [
              qge,
              T("div", null, [
                _ge,
                B(l, {
                  placement: "top",
                  content: E(t).extend.teacher_name,
                  effect: "light",
                  disabled: E(t).extend.teacher_name.length < 8
                }, {
                  default: N(() => [
                    T("div", {
                      class: "content text-overflow",
                      title: E(t).extend.teacher_name
                    }, de(E(t).extend.teacher_name || "-"), 9, Wge)
                  ]),
                  _: 1
                }, 8, ["content", "disabled"])
              ])
            ])
          ])) : re("", !0)
        ])
      ]);
    };
  }
});
const Gge = /* @__PURE__ */ Ht(Kge, [["__scopeId", "data-v-a41ad458"]]), Yge = { class: "unsubmitted-item-title" }, Qge = { class: "unsubmitted-item-title-avatar" }, Zge = ["src"], Jge = { class: "unsubmitted-item-title-info" }, $ge = { class: "unsubmitted-item-message" }, eye = {
  key: 0,
  class: "unsubmitted-item-content"
}, tye = {
  key: 1,
  class: "unsubmitted-item-content"
}, nye = /* @__PURE__ */ Ee({
  props: {
    item: {
      type: Object
    }
  },
  setup(e) {
    const t = ce("$utils"), n = ce("siteId"), r = ce("$bus"), i = ce("caseOther"), { delComments: a } = Wl(n), o = (u) => {
      if (u) {
        let c = u.split("-");
        return `[${i == null ? void 0 : i.caseTypeName}\u89C6\u9891] ` + t.dateTransfer(parseInt(c[0])) + "-" + t.dateTransfer(parseInt(c[1]));
      }
      return "";
    }, s = (u) => {
      a(u, function() {
        r.emit("updateContent");
      });
    }, l = (u) => {
      r.emit("goCommentPosition", u);
    };
    return (u, c) => e.item ? (P(), L("div", {
      key: 0,
      class: "unsubmitted-item",
      onClick: c[1] || (c[1] = (f) => l(e.item))
    }, [
      T("div", Yge, [
        T("div", Qge, [
          T("img", {
            src: e.item.avatar ? e.item.avatar : E(t).getImage("diffMark/user_icon.png")
          }, null, 8, Zge)
        ]),
        T("div", Jge, [
          T("div", null, de(e.item.userName), 1),
          T("div", null, de(E(t).formatDate(e.item.createTime)), 1)
        ]),
        +e.item.isMyCreate == 1 ? (P(), L("div", {
          key: 0,
          class: "unsubmitted-item-title-del",
          onClick: c[0] || (c[0] = wt((f) => s(e.item.id), ["stop"]))
        }, " \u5220\u9664 ")) : re("", !0)
      ]),
      T("div", $ge, de(e.item.annotationMessage), 1),
      +e.item.columnType == 3 ? (P(), L("div", eye, de(o(e.item.annotationText)), 1)) : (P(), L("div", tye, de(e.item.annotationText), 1))
    ])) : re("", !0);
  }
});
const iye = /* @__PURE__ */ Ht(nye, [["__scopeId", "data-v-aeac558f"]]), rye = { class: "dialog-footer" }, aye = /* @__PURE__ */ je("\u53D6\u6D88"), oye = /* @__PURE__ */ je("\u4FDD\u5B58"), sye = /* @__PURE__ */ Ee({
  props: {
    isEditTitle: Boolean,
    fieldsForm: Object,
    type: Number
  },
  emits: ["update:isEditTitle", "handleTitleSave"],
  setup(e, { emit: t }) {
    const n = e, r = Vs(n, "isEditTitle", t), i = j(), a = j({ field_title: "" }), o = {
      field_title: [{ required: !0, message: "\u8BF7\u8F93\u5165\u5927\u7EB2\u540D\u79F0", trigger: "blur" }]
    }, s = () => {
      r.value = !1;
    }, l = () => {
      i.value.validate(async (c) => {
        c && (t("handleTitleSave", a.value), s());
      });
    }, u = J(() => {
      if (n.type === 1)
        return "\u7F16\u8F91\u5927\u7EB2";
      if (n.type === 2)
        return "\u590D\u5236\u5927\u7EB2";
      if (n.type === 3)
        return "\u5F15\u7528\u5927\u7EB2";
    });
    return Ne(
      () => r.value,
      async (c) => {
        c ? (await bt(), i.value.clearValidate(), n.fieldsForm && (a.value = Dl(n.fieldsForm))) : a.value = {
          field_title: ""
        };
      }
    ), (c, f) => {
      const d = ti, h = Sa, p = Ca, y = fn, m = ni;
      return P(), ue(m, {
        modelValue: E(r),
        "onUpdate:modelValue": f[1] || (f[1] = (b) => Bn(r) ? r.value = b : null),
        title: E(u),
        width: "500px",
        "before-close": s
      }, {
        footer: N(() => [
          T("span", rye, [
            B(y, {
              class: "btn",
              onClick: s
            }, {
              default: N(() => [
                aye
              ]),
              _: 1
            }),
            B(y, {
              class: "btn",
              type: "primary",
              onClick: l
            }, {
              default: N(() => [
                oye
              ]),
              _: 1
            })
          ])
        ]),
        default: N(() => [
          B(p, {
            ref_key: "formRef",
            ref: i,
            model: a.value,
            "label-width": "80px",
            rules: o
          }, {
            default: N(() => [
              B(h, {
                label: "\u5927\u7EB2\u540D\u79F0",
                prop: "field_title"
              }, {
                default: N(() => [
                  B(d, {
                    modelValue: a.value.field_title,
                    "onUpdate:modelValue": f[0] || (f[0] = (b) => a.value.field_title = b),
                    placeholder: "\u8BF7\u8F93\u5165\u5927\u7EB2\u540D\u79F0",
                    style: { width: "380px" }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});
const eg = /* @__PURE__ */ Ht(sye, [["__scopeId", "data-v-d9f15099"]]), x2 = (e) => (yn("data-v-d5de4859"), e = e(), bn(), e), lye = {
  key: 0,
  class: "detail-box"
}, uye = { class: "left" }, cye = { class: "case-name" }, dye = /* @__PURE__ */ x2(() => /* @__PURE__ */ T("i", { class: "iconfont icon-bianji1" }, null, -1)), fye = /* @__PURE__ */ x2(() => /* @__PURE__ */ T("span", null, "\u7F16\u8F91", -1)), hye = {
  key: 0,
  class: "banner-btn-group"
}, pye = { key: 0 }, vye = /* @__PURE__ */ je(" \u63D0\u4EA4\u534F\u4F5C "), mye = {
  key: 1,
  class: "banner-action"
}, gye = { class: "collaboration-button" }, yye = { class: "collaboration-info" }, bye = /* @__PURE__ */ x2(() => /* @__PURE__ */ T("i", { class: "iconfont icon-xiala toggle-arrow-span" }, null, -1)), Aye = { class: "commemts-box" }, Tye = { class: "title" }, wye = /* @__PURE__ */ je(" \u5168\u90E8\u672A\u63D0\u4EA4\u6279\u6CE8\u2002 "), Pye = /* @__PURE__ */ x2(() => /* @__PURE__ */ T("div", { class: "line" }, null, -1)), xye = { class: "comments-list" }, Cye = {
  key: 1,
  class: "empty-box"
}, Sye = /* @__PURE__ */ je(" \u63D0\u4EA4\u6279\u6CE8 "), Eye = {
  key: 2,
  class: "banner-action"
}, kye = /* @__PURE__ */ je(" \u52A0\u5165\u534F\u4F5C "), Oye = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array
  },
  setup(e) {
    const t = ce("type"), n = ce("siteId"), r = ce("$bus"), i = ce("caseInfo"), a = ce("userInfo"), o = ce("caseOther"), s = ce("$http"), { caseQuoteAuth: l, getQuoteCaseAuth: u } = sv(n);
    u();
    const c = j(!1), { authNum: f, authList: d, getCooperationList: h, confirmSubmit: p, collaboratorApply: y } = w2(n, r);
    h();
    const { submitAnnotation: m } = Wl(n), b = () => {
      m(() => {
        r.emit("updateContent", 1);
      });
    }, x = j(!1), D = j(1), S = j(!1), C = zt({
      field_title: ""
    }), v = (R) => {
      D.value = R, R === 1 ? (C.field_title = i.value.extend.name, x.value = !0) : S.value = !0;
    }, H = async ({ field_title: R }) => {
      await s.updOutline({ id: i.value.extend.id, name: R }), An.success("\u4FEE\u6539\u6210\u529F"), r.emit("contentChange", 1);
    }, V = async ({ field_title: R }) => {
      const F = await s.copyOutline({ site_id: n, name: R });
      An.success("\u590D\u5236\u6210\u529F"), setTimeout(() => {
        window.open(`/outlineDetail.html?siteId=${F}&type=3`);
      }, 2e3);
    };
    return (R, F) => {
      var Q;
      const K = fn, q = Ki, G = vf, te = pf;
      return P(), L(nt, null, [
        E(i) && E(i).extend ? (P(), L("div", lye, [
          T("div", uye, [
            T("span", cye, de(E(i).extend.name), 1),
            E(t) == 3 ? (P(), ue(K, {
              key: 0,
              class: "edit-btn",
              size: "small",
              plane: "",
              onClick: F[0] || (F[0] = (Y) => v(1))
            }, {
              default: N(() => [
                dye,
                fye
              ]),
              _: 1
            })) : re("", !0)
          ]),
          E(t) != 5 ? (P(), L("div", hye, [
            E(t) == 3 ? (P(), L("div", pye, [
              B(K, {
                size: "large",
                class: "banner-btn",
                onClick: F[1] || (F[1] = (Y) => c.value = !0)
              }, {
                default: N(() => [
                  je(de(E(f) || 0) + "\u4EBA\u534F\u4F5C ", 1)
                ]),
                _: 1
              }),
              B(q, {
                visible: E(i).sub_status === 0,
                effect: "light",
                content: "\u4F60\u5DF2\u7ECF\u7F16\u8F91\u4E86\u65B0\u5185\u5BB9\uFF0C\u8BB0\u5F97\u63D0\u4EA4\u534F\u4F5C\u54E6~",
                placement: "top"
              }, {
                default: N(() => [
                  B(K, {
                    type: "primary",
                    size: "large",
                    class: "banner-btn",
                    disabled: E(i).sub_status !== 0,
                    onClick: E(p)
                  }, {
                    default: N(() => [
                      vye
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }, 8, ["visible"])
            ])) : re("", !0),
            E(t) == 4 ? (P(), L("div", mye, [
              T("div", gye, [
                B(te, {
                  trigger: "hover",
                  "hide-on-click": !0
                }, {
                  dropdown: N(() => [
                    B(G, null, {
                      default: N(() => {
                        var Y, Z;
                        return [
                          T("div", Aye, [
                            T("div", Tye, [
                              wye,
                              T("span", null, de((Y = e.allUnsubmittedNoteList) == null ? void 0 : Y.length), 1),
                              Pye
                            ]),
                            T("div", xye, [
                              (Z = e.allUnsubmittedNoteList) != null && Z.length ? (P(!0), L(nt, { key: 0 }, Lt(e.allUnsubmittedNoteList, (oe) => (P(), ue(iye, {
                                key: oe.id,
                                item: oe
                              }, null, 8, ["item"]))), 128)) : (P(), L("div", Cye, [
                                B(E(bi), {
                                  type: "message",
                                  text: "\u6682\u65E0\u6279\u6CE8"
                                })
                              ]))
                            ])
                          ])
                        ];
                      }),
                      _: 1
                    })
                  ]),
                  default: N(() => {
                    var Y;
                    return [
                      T("div", yye, [
                        je(" \u5F85\u63D0\u4EA4\u6279\u6CE8(" + de((Y = e.allUnsubmittedNoteList) == null ? void 0 : Y.length) + ")\u2002 ", 1),
                        bye
                      ])
                    ];
                  }),
                  _: 1
                })
              ]),
              B(K, {
                disabled: !((Q = e.allUnsubmittedNoteList) != null && Q.length),
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: b
              }, {
                default: N(() => [
                  Sye
                ]),
                _: 1
              }, 8, ["disabled"])
            ])) : re("", !0),
            E(t) == 0 ? (P(), L("div", Eye, [
              E(o).caseRole == 0 ? (P(), ue(K, {
                key: 0,
                type: "primary",
                size: "large",
                class: "banner-btn",
                onClick: F[2] || (F[2] = (Y) => E(y)(E(a).id, E(o).source))
              }, {
                default: N(() => [
                  kye
                ]),
                _: 1
              })) : re("", !0)
            ])) : re("", !0)
          ])) : re("", !0)
        ])) : re("", !0),
        B(P2, {
          showAuthListDialog: c.value,
          "onUpdate:showAuthListDialog": F[3] || (F[3] = (Y) => c.value = Y),
          authList: E(d),
          onGetAuthList: E(h)
        }, null, 8, ["showAuthListDialog", "authList", "onGetAuthList"]),
        B(eg, {
          type: D.value,
          isEditTitle: x.value,
          "onUpdate:isEditTitle": F[4] || (F[4] = (Y) => x.value = Y),
          "fields-form": E(C),
          onHandleTitleSave: H
        }, null, 8, ["type", "isEditTitle", "fields-form"]),
        B(eg, {
          type: D.value,
          isEditTitle: S.value,
          "onUpdate:isEditTitle": F[5] || (F[5] = (Y) => S.value = Y),
          onHandleTitleSave: V
        }, null, 8, ["type", "isEditTitle"])
      ], 64);
    };
  }
});
const zye = /* @__PURE__ */ Ht(Oye, [["__scopeId", "data-v-d5de4859"]]), C2 = (e) => (yn("data-v-1bbb7cc7"), e = e(), bn(), e), Dye = { class: "course-detail-banner" }, Mye = { class: "course-detail-banner-wrapper" }, Hye = { class: "top-nav" }, Iye = /* @__PURE__ */ je(" \u60A8\u6240\u5728\u7684\u4F4D\u7F6E\uFF1A "), Lye = {
  key: 0,
  class: "case-info"
}, Bye = { class: "case-info-item" }, Nye = /* @__PURE__ */ C2(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u8BFE\u7A0B", -1)), jye = ["title"], Fye = { class: "case-info-item" }, Xye = /* @__PURE__ */ C2(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u6559\u7814\u5BA4", -1)), Rye = ["title"], Vye = { class: "case-info-item" }, Uye = /* @__PURE__ */ C2(() => /* @__PURE__ */ T("div", { class: "title" }, "\u6240\u5C5E\u673A\u6784", -1)), qye = ["title"], _ye = { class: "case-info-item" }, Wye = /* @__PURE__ */ C2(() => /* @__PURE__ */ T("div", { class: "title" }, "\u521B\u5EFA\u8001\u5E08", -1)), Kye = ["title"], Gye = /* @__PURE__ */ Ee({
  props: {
    allUnsubmittedNoteList: Array,
    isHeadFixed: Boolean
  },
  setup(e) {
    const t = ce("caseInfo"), n = ce("caseOther"), r = zt({
      url: "",
      name: ""
    }), i = window.localStorage.getItem("currentPage");
    i ? (r.url = JSON.parse(i).url, r.name = JSON.parse(i).name) : (r.url = `${window.location.origin}/teachCenter.html`, r.name = "\u6211\u7684\u6559\u7814\u5BA4");
    const a = () => {
      window.location.href = r.url;
    };
    return (o, s) => {
      var l;
      return P(), L("div", Dye, [
        T("div", Mye, [
          T("div", Hye, [
            Iye,
            T("a", {
              class: "link",
              onClick: a
            }, de(E(r).name), 1),
            je(" > " + de((l = E(n)) == null ? void 0 : l.caseTypeName) + "\u5185\u5BB9 ", 1)
          ]),
          B(zye, { allUnsubmittedNoteList: e.allUnsubmittedNoteList }, null, 8, ["allUnsubmittedNoteList"]),
          E(t) && E(t).extend ? (P(), L("ul", Lye, [
            T("li", Bye, [
              Nye,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.course_name
              }, de(E(t).extend.course_name), 9, jye)
            ]),
            T("li", Fye, [
              Xye,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.group_name
              }, de(E(t).extend.group_name || "-"), 9, Rye)
            ]),
            T("li", Vye, [
              Uye,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.organ_name
              }, de(E(t).extend.organ_name || "-"), 9, qye)
            ]),
            T("li", _ye, [
              Wye,
              T("div", {
                class: "content text-overflow",
                title: E(t).extend.teacher_name
              }, de(E(t).extend.teacher_name || "-"), 9, Kye)
            ])
          ])) : re("", !0)
        ])
      ]);
    };
  }
});
const Yye = /* @__PURE__ */ Ht(Gye, [["__scopeId", "data-v-1bbb7cc7"]]);
const Qye = { class: "page-wrapper clearfix" }, Zye = { class: "main-content" }, Jye = {
  class: "course-detail-wrapper",
  id: "case-body"
}, $ye = {
  key: 0,
  class: "content"
}, ebe = { class: "course-detail-nav" }, tbe = { key: 0 }, nbe = { class: "main-container" }, ibe = ["id"], rbe = /* @__PURE__ */ je(" + \u6DFB\u52A0\u65B0\u6A21\u5757 "), abe = {
  key: 1,
  class: "child-empty-box"
}, obe = {
  key: 1,
  class: "content empty-content"
}, sbe = /* @__PURE__ */ je(" \u8BE5\u89C6\u9891\u5DF2\u88AB\u5220\u9664\uFF0C\u5982\u9700\u67E5\u770B\u8BF7\u81F3 "), lbe = /* @__PURE__ */ je(" \u67E5\u770B "), ube = {
  props: {
    headHeight: Number,
    styleType: {
      type: String,
      default: "v2"
    }
  },
  setup(e) {
    const t = e, n = X3.creatBus();
    _t("$bus", n), _t("$utils", AD);
    const r = ce("$http"), i = V1("siteId") || "", a = V1("type") || 0, o = V1("tagType") || 1, s = j([]), l = j(""), u = j(0), c = j([]), f = j([
      { title: "\u6279\u6CE8\u5217\u8868", icon: "pizhu", name: "noteList", count: 0 },
      { title: "\u4FEE\u8BA2\u8BB0\u5F55", icon: "a-xiudingjilu", name: "reviseList", count: 0 },
      { title: "\u7559\u8A00", icon: "liuyan", name: "messageList", count: 0 }
    ]), d = ce("userInfo"), h = j(!1), p = j(!1), y = j([]), m = j(null), b = j(0), x = j(!1), D = j(!1), S = zt({
      isNeedCheck: 0,
      checkStatus: 0,
      checkIsStart: !1,
      roleName: "",
      checkTime: "",
      comment: "",
      valid_status: 0,
      realname_valid: "",
      review_comments_valid: "",
      operation_type: 0
    }), { caseInfo: C, caseOther: v, getCaseInfo: H, getCaseUserRole: V } = XC(i, n), { getCaseIsNeedCheck: R, getCaseCheckStatus: F } = rv(S), { addMenuInfo: K } = KT(i, n), { allUnsubmittedNoteList: q, unsubmittedNoteList: G, getUnsubmittedNoteList: te } = Wl(i), Q = J(() => a == 3 ? S.isNeedCheck == 1 || S.checkStatus == 0 || S.checkStatus == 4 ? 1 : 0 : a == 4 ? 2 : 0), Y = J(() => {
      if (v.source == 1)
        return t.headHeight + 117 + "px";
      if (v.source == 2)
        return t.headHeight + 240 + "px";
      if (v.source == 3)
        return t.styleType === "v3" ? t.headHeight + 215 + "px" : t.headHeight + 210 + "px";
      if (v.source == 4)
        return t.headHeight + 210 + "px";
    });
    _t("topHeight", Y), _t("styleType", t.styleType), _t("siteId", i), _t("pageMode", Q), _t("type", a), _t("currentMenuId", l), _t("caseInfo", C), _t("caseOther", v), _t("checkInfo", S), _t("isHeadFixed", x);
    const Z = (Te) => Q.value == 1 ? !0 : Te == 1, oe = (Te) => {
      l.value = Te.parentId, Re(Te), Qe();
    };
    n.on("goCommentPosition", oe);
    const he = () => {
      p.value = !1, m.value.activeName = "reviseList";
    }, Ae = ({ annotationContent: Te, columnId: Me, columnType: Je, annotationText: mt }) => {
      if (Je === 3) {
        const It = c.value.find((ln) => ln.id == Me);
        It && It.columnContent == Te ? n.emit("videoAnnotation", { columnId: Me, annotationContent: Te, annotationText: mt }) : p.value = !0;
      } else if (Je === 1) {
        let It = document.createElement("div"), ln = ha(`#${Me}`).find("#anchorContent")[0];
        console.log(ln), ha(document).find(".red").length && ha(document).find(".red").removeClass("red"), It.innerHTML = Te || "", h.value = !0, bt(() => {
          const { pos: gt } = rie({
            prevContent: It,
            currContent: ln,
            shouldScroll: !0,
            offset: -70,
            isLog: !1,
            scrollParentDom: ""
          });
          try {
            gt.end - gt.begin <= 0 && An.warning("\u6807\u8BB0\u5185\u5BB9\u5DF2\u5220\u9664");
          } catch (Pe) {
            console.log(Pe);
          }
        });
      }
    };
    n.on("handleMenu", async (Te) => {
      l.value = Te.id, u.value = Te.column_type, c.value = [], await Re(), (a == 3 || a == 4) && Qe(), a == 3 && Ye(), ha("html,body").animate(
        {
          scrollTop: 0
        },
        500
      );
    });
    const We = (Te) => {
      Te === 1 ? H() : Te === 3 && Re(), [1, 3, 4].includes(v.source) && Qe();
    };
    n.on("contentChange", We), n.on("updateContent", (Te) => {
      a == 4 ? (te(l.value), te(), Te == 1 && Ve()) : a == 3 && (H(), Re()), Qe();
    }), n.on("updateMenu", (Te) => {
      ke(Te), H();
    });
    const ke = async (Te) => {
      const Me = await r.getCaseMenu({ site_id: i });
      if (console.log("menu-res==========", Me), Me.length) {
        if (s.value = Me, Te)
          return;
        const Je = Me.find((mt) => mt.status);
        l.value = Je ? Je.id : "", u.value = Je ? Je.column_type : 0, c.value = [], Je && Re(), a == 4 && te(), (a == 4 || a == 3) && Qe();
      }
    }, Re = async (Te) => {
      const Me = await r.getCaseMenuChild({ column_id: l.value });
      c.value = Me || [], bt(() => {
        Te && Ae(Te);
      });
    }, ve = async () => {
      let Te = {
        user_id: d.id,
        site_id: i
      };
      const Me = await r.unReadMessageCount(Te);
      f.value[2].count = Me, b.value = Me || 0;
    }, Ye = async () => {
      let Te = {
        site_id: i,
        column_id: l.value
      };
      const Me = await r.getUnreadAnnotation(Te);
      f.value[0].count = +Me || 0;
    }, Qe = async () => {
      const Te = {
        site_id: i,
        column_id: l.value
      }, Me = await r.getReviseList(Te) || [];
      a == 3 && (y.value = Me), a == 4 && (y.value = Me.filter((Je) => Je.isSubmit === 1));
    };
    (async () => {
      await V(), await H();
      let Te = v.source === 4 ? "outlineDetail" : "caseDetail";
      v.caseRole === 2 && a === 0 ? window.location.replace(`${window.location.origin}/${Te}.html?siteId=${i}&type=4`) : v.caseRole === 0 && a === 4 && window.location.replace(`${window.location.origin}/${Te}.html?siteId=${i}`), ke(), (a == 3 || a == 4) && (o == 3 ? m.value.tagOpen("messageList") : m.value.tagOpen("noteList"), [1, 3, 4].includes(v.source) && ve()), [1, 2].includes(v.source) && a < 4 && (await R(v.source), F(v.taskId));
    })();
    const Ve = () => {
      m.value.getsubmittedNoteList();
    };
    return (Te, Me) => {
      const Je = fn, mt = D_;
      return P(), ue(mt, { locale: E(Qne) }, {
        default: N(() => [
          T("div", Qye, [
            E(v).source == 1 ? (P(), ue(sve, {
              key: 0,
              allUnsubmittedNoteList: E(q)
            }, null, 8, ["allUnsubmittedNoteList"])) : E(v).source == 2 ? (P(), ue(ame, { key: 1 })) : re("", !0),
            E(v).source == 3 && e.styleType === "v2" ? (P(), ue(L9e, {
              key: 2,
              allUnsubmittedNoteList: E(q)
            }, null, 8, ["allUnsubmittedNoteList"])) : re("", !0),
            E(v).source == 3 && e.styleType === "v3" ? (P(), ue(Gge, {
              key: 3,
              allUnsubmittedNoteList: E(q)
            }, null, 8, ["allUnsubmittedNoteList"])) : re("", !0),
            E(v).source == 4 ? (P(), ue(Yye, {
              key: 4,
              allUnsubmittedNoteList: E(q)
            }, null, 8, ["allUnsubmittedNoteList"])) : re("", !0),
            T("div", Zye, [
              T("div", Jye, [
                s.value && s.value.length ? (P(), L("div", $ye, [
                  T("div", ebe, [
                    e.styleType === "v3" ? (P(), ue(Xhe, {
                      key: 0,
                      menuList: s.value
                    }, null, 8, ["menuList"])) : (P(), ue(Mhe, {
                      key: 1,
                      menuList: s.value
                    }, null, 8, ["menuList"]))
                  ]),
                  T("div", {
                    class: se(["main-wrapper", {
                      "main-width": [1, 3, 4].includes(E(v).source) && (E(a) == 3 || E(a) == 4)
                    }])
                  }, [
                    c.value.length ? (P(), L("div", tbe, [
                      B(gie, {
                        moduleList: c.value,
                        activeModule: `#${c.value[0].id}`
                      }, null, 8, ["moduleList", "activeModule"]),
                      T("div", nbe, [
                        (P(!0), L(nt, null, Lt(c.value, (It) => Bt((P(), L("div", {
                          class: "module-list",
                          id: It.id,
                          key: It.id
                        }, [
                          u.value == 33 ? (P(), ue(h5e, {
                            key: 0,
                            columnInfo: It
                          }, null, 8, ["columnInfo"])) : u.value == 31 ? (P(), ue(Sme, {
                            key: 1,
                            columnInfo: It
                          }, null, 8, ["columnInfo"])) : (P(), ue(Yx, {
                            key: 2,
                            moduleInfo: It,
                            isTag: h.value,
                            "onUpdate:isTag": Me[0] || (Me[0] = (ln) => h.value = ln)
                          }, null, 8, ["moduleInfo", "isTag"]))
                        ], 8, ibe)), [
                          [Cn, Z(It.status)]
                        ])), 128)),
                        E(Q) == 1 ? (P(), ue(Je, {
                          key: 0,
                          class: "add-btn",
                          onClick: Me[1] || (Me[1] = (It) => D.value = !0)
                        }, {
                          default: N(() => [
                            rbe
                          ]),
                          _: 1
                        })) : re("", !0)
                      ])
                    ])) : (P(), L("div", abe, [
                      E(Q) == 1 ? (P(), ue(sc, {
                        key: 0,
                        btnText: "+ \u6DFB\u52A0\u65B0\u6A21\u5757",
                        content: "\u8FD8\u6CA1\u6709\u65B0\u6A21\u5757\uFF0C\u5FEB\u70B9\u51FB\u6DFB\u52A0\u5427",
                        onEdit: Me[2] || (Me[2] = (It) => D.value = !0)
                      })) : (P(), ue(E(bi), {
                        key: 1,
                        description: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9"
                      }))
                    ]))
                  ], 2)
                ])) : (P(), L("div", obe, [
                  B(E(bi), {
                    type: "message",
                    description: "\u6682\u65E0\u76F8\u5173\u5185\u5BB9"
                  })
                ]))
              ]),
              B(S4e, {
                ref_key: "sideToolbar",
                ref: m,
                tagIconList: f.value,
                unsubmittedNoteList: E(G),
                reviseList: y.value,
                messageCount: b.value,
                "onUpdate:messageCount": Me[3] || (Me[3] = (It) => b.value = It),
                onContentChange: We,
                onCompareText: Ae,
                onGetUnsubmittedNoteList: E(te),
                onGetUnreadMessage: ve,
                onGetUnreadAnnotation: Ye
              }, null, 8, ["tagIconList", "unsubmittedNoteList", "reviseList", "messageCount", "onGetUnsubmittedNoteList"])
            ]),
            B(vie, {
              modelValue: p.value,
              "onUpdate:modelValue": Me[4] || (Me[4] = (It) => p.value = It),
              showCancel: !1,
              confirmText: "\u6211\u77E5\u9053\u4E86"
            }, {
              default: N(() => [
                T("div", { class: "delete-hint" }, [
                  sbe,
                  T("span", {
                    class: "link",
                    onClick: he
                  }, "\u4FEE\u8BA2\u8BB0\u5F55"),
                  lbe
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            B(R3, {
              isEditTitle: D.value,
              "onUpdate:isEditTitle": Me[5] || (Me[5] = (It) => D.value = It),
              onHandleTitleSave: Me[6] || (Me[6] = ({ field_title: It }) => E(K)(It, l.value, u.value))
            }, null, 8, ["isEditTitle"])
          ])
        ]),
        _: 1
      }, 8, ["locale"]);
    };
  }
}, Md = /* @__PURE__ */ Ht(ube, [["__scopeId", "data-v-3ba57224"]]);
(function(e) {
  var t, n, r, i, a, o = '<svg><symbol id="icon-tianjia1" viewBox="0 0 1024 1024"><path d="M559.1 299.5h-94.2v165.4H299.5v94.2h165.4v165.4h94.2V559.1h165.4v-94.2H559.1V299.5z m0 0"  ></path><path d="M857.4 723.7c-4 84-73.5 151.2-158.3 151.2H324.8c-84.8 0-154.3-67.1-158.3-151.2h-0.2V300.3h0.2c4-84.1 73.5-151.3 158.3-151.3H640l-68.3 57.7H324.9C269.3 206.9 224 252.3 224 308v408c0 55.7 45.3 101.1 100.9 101.1h374.2c55.6 0 100.9-45.4 100.9-101.1V430.5l57.6-56.8v350h-0.2zM834.9 284"  ></path><path d="M166.6 300.3c4-84.1 73.5-151.2 158.3-151.2h374.4c84.8 0 154.3 67.1 158.3 151.2h0.2v423.3h-0.2c-4 84.1-73.5 151.2-158.3 151.2H384l68.3-57.7h246.8c55.6 0 100.9-45.4 100.9-101.1V308c0-55.8-45.3-101.1-100.9-101.1H324.8C269.3 206.9 224 252.3 224 308v285.5l-57.6 56.8v-350h0.2zM189.1 740"  ></path></symbol><symbol id="icon-shouji1" viewBox="0 0 1024 1024"><path d="M778.453333 19.413333c30.293333 0 55.04 24.746667 55.04 55.04v875.221334c0 30.293333-24.746667 55.04-55.04 55.04H228.48c-30.293333 0-55.04-24.746667-55.04-55.04V74.410667c0-30.250667 24.746667-54.997333 55.04-54.997334z m-10.965333 730.624H239.488v188.544h528v-188.544zM503.466667 794.026667a55.04 55.04 0 1 1 0 110.08 55.04 55.04 0 0 1 0-110.08z m264.021333-708.608H239.488v598.741333h528V85.418667z"  ></path></symbol><symbol id="icon-yanzhengma" viewBox="0 0 1024 1024"><path d="M141.7216 227.4816V100.1472a34.9184 34.9184 0 0 1 34.816-34.816H823.808a34.9184 34.9184 0 0 1 34.816 34.816v127.3344h64.9216V69.632c0-38.2464-31.3344-69.5808-69.632-69.5808H146.3808C108.1344 0 76.8 31.3344 76.8 69.632v157.8496h64.9216z m716.8512 557.7216v138.6496a34.9184 34.9184 0 0 1-34.816 34.816H176.5888a34.9184 34.9184 0 0 1-34.816-34.816v-138.6496H76.8v169.1648C76.8 992.6656 108.1344 1024 146.432 1024h707.4816c38.2464 0 69.632-31.3344 69.632-69.632v-169.1648h-64.9728zM228.0448 681.984H162.048V433.152A228.352 228.352 0 0 1 76.8 483.2768v-59.904c17.2032-5.632 35.9424-16.384 56.1152-32.0512 20.224-15.7696 34.0992-34.0992 41.5744-55.0912h53.5552v345.8048z m368.4352-61.3376v61.3376H365.056c2.56-23.1936 10.0864-45.1584 22.5792-65.8944 12.544-20.7872 37.2736-48.2816 74.24-82.5856 29.7472-27.7504 47.9744-46.5408 54.784-56.3712 9.0112-13.6192 13.568-27.136 13.568-40.448 0-14.6944-3.9424-26.0096-11.8784-33.8944-7.936-7.8848-18.7904-11.8784-32.768-11.8784-13.7216 0-24.7296 4.1472-32.8704 12.4416-8.1408 8.2944-12.8 22.0672-14.08 41.3696l-65.792-6.5536c3.9424-36.352 16.2304-62.464 36.864-78.2336 20.6848-15.872 46.5408-23.7056 77.568-23.7056 33.9456 0 60.6208 9.1136 80.0768 27.4432 19.456 18.3296 29.1328 41.1136 29.1328 68.352 0.0512 15.1552-2.7648 30.208-8.3456 44.288-5.632 14.0288-14.336 28.672-26.4192 44.032-7.9872 10.24-22.4256 24.832-43.2128 43.9808-20.8384 19.0464-33.9968 31.7952-39.5776 38.0416-5.12 5.632-9.6256 11.776-13.5168 18.3296h131.072z m98.304-30.0544l63.8464-7.7312c2.048 16.2816 7.5264 28.7232 16.384 37.3248a45.1072 45.1072 0 0 0 32.4608 12.9024 44.544 44.544 0 0 0 34.4064-15.4624c9.3184-10.3424 13.9776-24.32 13.9776-41.8304 0-16.5888-4.4544-29.7472-13.3632-39.424a42.5984 42.5984 0 0 0-32.6656-14.6432c-8.448 0-18.5344 1.6384-30.3104 4.9664l7.2704-53.8112c17.92 0.512 31.488-3.4304 40.8576-11.6224a41.4208 41.4208 0 0 0 14.1312-32.768c0-11.5712-3.4816-20.8384-10.2912-27.6992a37.3248 37.3248 0 0 0-27.5456-10.3424 39.7824 39.7824 0 0 0-28.8768 11.776c-7.9872 7.7824-12.8 19.2-14.592 34.2528l-60.8256-10.3424c4.2496-20.7872 10.6496-37.4784 19.1488-49.92a86.528 86.528 0 0 1 35.7376-29.3376c15.2576-7.168 32.3584-10.7008 51.3024-10.7008 32.4096 0 58.368 10.3424 77.9776 31.0272 16.128 16.896 24.2176 35.9936 24.2176 57.2928 0 30.208-16.5376 54.3232-49.5616 72.3456 19.712 4.1984 35.4816 13.7216 47.3088 28.416 11.8272 14.7456 17.7664 32.512 17.7664 53.2992a103.424 103.424 0 0 1-33.1264 77.312c-22.0672 21.2992-49.5616 31.9488-82.432 31.9488-31.232 0-56.9856-9.0112-77.5168-26.88-20.5312-17.92-32.4608-41.4208-35.7376-70.3488z"  ></path></symbol><symbol id="icon-shangchuan" viewBox="0 0 1040 1024"><path d="M938.80757 410.549473l-81.94081 80.380033-278.598755-273.136035v545.881875H462.18519V217.988569l-279.639274 273.136034L101.190398 410.549473 520.259113 0z"  ></path><path d="M1040.518227 1024H0v-377.187857h115.627588v263.251111h809.263051V647.00724H1040.518227z"  ></path></symbol><symbol id="icon-tuodong" viewBox="0 0 1194 1024"><path d="M1143.466121 101.717285H51.199976c-27.98932 0-51.199976-23.039989-51.199976-50.858643C0 23.039989 23.210656 0 51.199976 0h1092.266145c27.98932 0 51.199976 23.039989 51.199976 50.858642a51.370642 51.370642 0 0 1-51.199976 50.858643z m0 461.141113H51.199976c-27.98932 0-51.199976-23.039989-51.199976-50.858642 0-27.818653 23.210656-50.858642 51.199976-50.858643h1092.266145c27.98932 0 51.199976 23.039989 51.199976 50.858643a51.370642 51.370642 0 0 1-51.199976 50.858642zM51.199976 1023.999512h1092.266145c27.98932 0 51.199976-23.039989 51.199976-50.858643a51.370642 51.370642 0 0 0-51.199976-50.858642H51.199976c-27.98932 0-51.199976 23.039989-51.199976 50.858642 0 27.818653 23.210656 50.858642 51.199976 50.858643z"  ></path></symbol><symbol id="icon-a-jianhao1" viewBox="0 0 1028 1024"><path d="M514.26632 1023.997806a512.143725 512.143725 0 0 1-363.518182-149.942108A507.608891 507.608891 0 0 1 0.001463 512.000366c0-136.849601 53.540304-265.507244 150.673532-362.055333A511.99744 511.99744 0 0 1 514.193178 0.002926a511.99744 511.99744 0 0 1 363.664467 149.942107A507.608891 507.608891 0 0 1 1028.531177 512.000366a507.608891 507.608891 0 0 1-150.673532 362.055332A511.99744 511.99744 0 0 1 514.339463 1023.997806z m0-950.559819c-117.759411 0-228.497143 45.640915-311.733298 128.511358A434.466399 434.466399 0 0 0 73.436524 512.000366a434.466399 434.466399 0 0 0 129.023355 309.977878 439.293804 439.293804 0 0 0 311.806441 128.511358 438.854949 438.854949 0 0 0 311.733299-128.511358A434.393257 434.393257 0 0 0 955.022973 512.000366a434.466399 434.466399 0 0 0-129.023354-309.977879 439.366946 439.366946 0 0 0-311.733299-128.511357zM221.988924 513.536358a36.790673 36.790673 0 0 1 35.108396-38.326665h517.483127a36.790673 36.790673 0 1 1-3.145127 73.508203H257.170463a36.790673 36.790673 0 0 1-35.108396-35.108395z"  ></path></symbol><symbol id="icon-kechengjiegoutianjia" viewBox="0 0 1028 1024"><path d="M514.26632 1023.997806a512.143725 512.143725 0 0 1-363.518182-149.942108A507.608891 507.608891 0 0 1 0.001463 512.000366c0-136.849601 53.540304-265.507244 150.673532-362.055333A511.99744 511.99744 0 0 1 514.193178 0.002926a511.99744 511.99744 0 0 1 363.664467 149.942107A507.608891 507.608891 0 0 1 1028.531177 512.000366a507.608891 507.608891 0 0 1-150.673532 362.055332A511.99744 511.99744 0 0 1 514.339463 1023.997806z m0-950.559819c-117.759411 0-228.497143 45.640915-311.733298 128.511358A434.466399 434.466399 0 0 0 73.436524 512.000366a434.466399 434.466399 0 0 0 129.023355 309.977878 439.293804 439.293804 0 0 0 311.806441 128.511358 438.854949 438.854949 0 0 0 311.733299-128.511358A434.393257 434.393257 0 0 0 955.022973 512.000366a434.466399 434.466399 0 0 0-129.023354-309.977879 439.366946 439.366946 0 0 0-311.733299-128.511357z m36.717531 401.771706h223.596596a36.790673 36.790673 0 1 1-3.145127 73.508203H550.983851v220.378327a36.790673 36.790673 0 0 1-73.435062 0V548.717896H257.170463a36.790673 36.790673 0 0 1 0-73.508203h220.378326V254.831366a36.790673 36.790673 0 0 1 73.435062 0v220.378327z"  ></path></symbol><symbol id="icon-xiaoxi" viewBox="0 0 1024 1024"><path d="M750.933381 298.461886v461.209629A25.600002 25.600002 0 0 1 725.504046 785.066717H315.562687A25.429335 25.429335 0 0 1 290.133352 759.671515V298.461886A25.600002 25.600002 0 0 1 315.562687 273.066684h409.941359c14.028801 0 25.429335 11.366401 25.429335 25.395202zM392.533358 324.266687v230.400015l89.600006-51.200003 89.600006 51.200003V324.266687H392.533358z"  ></path></symbol><symbol id="icon-xiezuoshenqing" viewBox="0 0 1024 1024"><path d="M708.266667 273.066667a25.6 25.6 0 0 1 25.6 25.6v96.187733l-230.365867 230.4-0.170667 108.475733 108.714667 0.170667L733.866667 612.0448V759.466667a25.6 25.6 0 0 1-25.6 25.6h-409.6a25.6 25.6 0 0 1-25.6-25.6v-460.8a25.6 25.6 0 0 1 25.6-25.6h409.6z m45.5168 174.2848l36.1984 36.1984L590.865067 682.666667l-36.2496-0.0512 0.0512-36.1472 199.1168-199.1168zM503.466667 529.066667H375.466667v51.2h128v-51.2z m76.8-102.4H375.466667v51.2h204.8v-51.2z"  ></path></symbol><symbol id="icon-shoucang1" viewBox="0 0 1024 1024"><path d="M773.458 1005.43c-14.403 0-30.592-4.132-45.599-11.638L513.567 886.61 297.948 993.618c-13.655 7.27-29.286 11.09-45.225 11.09a96.164 96.164 0 0 1-57.549-18.842c-30.177-22.64-45.64-61.85-38.502-97.561l44.099-228.772L31.744 501.996a104.059 104.059 0 0 1-26.281-100.66l0.338-1.162c12.288-36.828 42.772-62.633 79.734-67.584l234.839-42.7L425.779 75.811c16.932-33.895 51.37-55.675 87.788-55.675 37.99 0 73.318 22.6 88.13 56.29l105.068 213.4L941.64 330.89a95.672 95.672 0 0 1 78.264 68.373 98.97 98.97 0 0 1-24.474 101.002l-0.578 0.579-168.55 158.72L868.9 888.745c6.86 36.649-7.716 73.672-38.062 96.742a90.409 90.409 0 0 1-57.38 19.943z m-259.81-196.055l227.667 113.853c6.686 3.37 14.392 5.489 19.665 5.489 8.116 0 15.652-2.499 21.187-7.117l1.03-0.85c12.937-9.707 19.245-25.134 16.414-40.238l-45.814-246.804 181.212-170.65c11.126-11.28 14.93-27.433 9.995-42.286l-0.497-1.562a37.31 37.31 0 0 0-30.971-27.003l-1.034-0.163L661.76 348.21 548.91 118.99c-5.478-12.805-20.347-22.098-35.359-22.098-14.75 0-28.861 9.236-36.009 23.496L365.414 348.109l-252.062 45.788c-15.31 1.92-27.203 12.088-32.697 27.945-3.901 14.49 0.722 31.949 11.372 42.834l181.422 169.057-47.61 246.933c-2.863 14.28 3.9 30.714 16.409 40.1 6.272 4.715 14.397 7.316 22.917 7.316 6.569 0 12.866-1.531 18.294-4.45l0.783-0.46 229.407-113.797z" fill="#707070" ></path></symbol><symbol id="icon-yinyong" viewBox="0 0 1024 1024"><path d="M538.944 291.328a43.712 43.712 0 0 1 0 87.424H378.752v553.536h553.536v-553.6H844.8a43.712 43.712 0 0 1 0-87.36h101.952c37.568 0 68.48 28.416 72.448 64.896l0.384 7.936v582.656c0 37.568-28.416 68.48-64.896 72.448l-7.936 0.384H364.16c-37.504 0-68.48-28.352-72.384-64.896l-0.448-7.936V364.16c0-37.504 28.416-68.48 64.896-72.384l7.936-0.448h174.784zM655.488 0c37.568 0 68.48 28.416 72.448 64.896l0.384 7.936v582.656c0 37.568-28.416 68.48-64.896 72.448l-7.936 0.384H480.704a43.712 43.712 0 0 1 0-87.36h160.256v-553.6h-553.6v553.6h87.424a43.712 43.712 0 0 1 0 87.36H72.832c-37.568 0-68.48-28.416-72.384-64.896L0 655.488V72.832C0 32.64 32.64 0 72.832 0h582.656z"  ></path></symbol><symbol id="icon-back-end-condition" viewBox="0 0 1024 1024"><path d="M639.901053 0c23.537188 0 42.615468 19.07828 42.615469 42.615468v255.839005a42.615468 42.615468 0 0 1-42.615469 42.688565L548.52998 341.069941v163.517672h219.290575c63.74046 0 116.077811 48.974895 121.340785 111.399612l0.511678 10.525948v59.647036a170.608067 170.608067 0 1 1-73.096858 0v-59.647036a48.755605 48.755605 0 0 0-41.519016-48.243927l-7.236589-0.511678h-511.678008a48.755605 48.755605 0 0 0-48.243926 41.519016l-0.511678 7.236589v59.647036a170.608067 170.608067 0 1 1-73.096859 0v-59.647036c0-63.74046 48.974895-116.077811 111.326515-121.413882l10.525948-0.438581 219.290575-0.073097V341.069941H384.062049a42.615468 42.615468 0 0 1-42.615468-42.615468v-255.839005c0-23.537188 19.005183-42.615468 42.615468-42.615468h255.839004z" fill="#59CFAA" ></path></symbol><symbol id="icon-condition" viewBox="0 0 1024 1024"><path d="M639.901053 0c23.537188 0 42.615468 19.07828 42.615469 42.615468v255.839005a42.615468 42.615468 0 0 1-42.615469 42.688565L548.52998 341.069941v163.517672h219.290575c63.74046 0 116.077811 48.974895 121.340785 111.399612l0.511678 10.525948v59.647036a170.608067 170.608067 0 1 1-73.096858 0v-59.647036a48.755605 48.755605 0 0 0-41.519016-48.243927l-7.236589-0.511678h-511.678008a48.755605 48.755605 0 0 0-48.243926 41.519016l-0.511678 7.236589v59.647036a170.608067 170.608067 0 1 1-73.096859 0v-59.647036c0-63.74046 48.974895-116.077811 111.326515-121.413882l10.525948-0.438581 219.290575-0.073097V341.069941H384.062049a42.615468 42.615468 0 0 1-42.615468-42.615468v-255.839005c0-23.537188 19.005183-42.615468 42.615468-42.615468h255.839004z" fill="#5A7DED" ></path></symbol><symbol id="icon-quanping" viewBox="0 0 1024 1024"><path d="M64 104.512v269.632a34.496 34.496 0 0 0 68.928 0v-194.56L352 398.784a33.088 33.088 0 0 0 46.72-46.72L179.648 132.864h194.56a34.496 34.496 0 0 0 0-68.928H104.512C79.36 64 64 76.928 64 104.512zM921.6 64h-269.632a34.496 34.496 0 0 0 0 68.928h194.56L627.392 352a33.088 33.088 0 0 0 46.72 46.72l219.072-219.136v194.56a34.496 34.496 0 0 0 68.928 0V104.512c0-27.52-15.296-40.512-40.512-40.512zM104.512 960h269.632a34.496 34.496 0 0 0 0-68.928h-194.56L398.784 672a33.088 33.088 0 0 0-46.72-46.72l-219.136 219.136v-194.56a34.496 34.496 0 0 0-68.928 0v269.632c0 27.52 15.36 40.512 40.512 40.512z m857.6-40.512v-269.632a34.496 34.496 0 0 0-68.928 0v194.56l-219.072-219.2a33.088 33.088 0 0 0-46.72 46.72l219.136 219.136h-194.56a34.496 34.496 0 0 0 0 68.928H921.6c25.216 0 40.512-12.928 40.512-40.512z"  ></path></symbol><symbol id="icon-tianjiaziji" viewBox="0 0 1024 1024"><path d="M923.008 761.728h-89.6v-89.6a35.84 35.84 0 0 0-71.68 0v89.6h-89.6a35.84 35.84 0 0 0 0 71.68h89.6v89.6a35.84 35.84 0 0 0 71.68 0v-89.6h89.6a35.84 35.84 0 0 0 0-71.68z m-371.84 0H406.72V529.92h480.832l0.768 77.632a35.84 35.84 0 0 0 35.84 35.456h0.384A35.84 35.84 0 0 0 960 606.848l-1.152-113.152a35.84 35.84 0 0 0-36.16-35.456H370.88a35.84 35.84 0 0 0-35.84 35.84v78.4H246.528v-201.6-2.24H462.72a116.608 116.608 0 0 0 116.48-116.48V180.48A116.608 116.608 0 0 0 462.72 64H180.48A116.608 116.608 0 0 0 64 180.48v71.68c0.064 62.144 48.896 113.28 110.976 116.352a33.408 33.408 0 0 0-0.128 2.368v237.44c0 19.84 16.064 35.84 35.84 35.84h124.352v153.408c0 19.84 16 35.84 35.84 35.84h180.288a35.84 35.84 0 0 0 0-71.68zM135.68 252.16V180.48a44.8 44.8 0 0 1 44.8-44.8h282.24a44.8 44.8 0 0 1 44.8 44.8v71.68a44.8 44.8 0 0 1-44.8 44.8H180.48a44.8 44.8 0 0 1-44.8-44.8z"  ></path></symbol><symbol id="icon-huitui" viewBox="0 0 1024 1024"><path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z m230.016 309.568l0.384 7.872v270.464c0 26.368-9.28 48-32.704 57.6-16.384 6.656-31.36 4.288-47.616-4.032l-7.04-3.968-192.576-137.152-5.888-5.12c-20.928-22.4-22.528-56.96-0.192-84.48l6.08-6.656 193.344-137.728c37.056-24.96 81.6-2.752 86.208 43.2z m-211.008-38.656c5.76 12.16-0.128 32.32-11.264 40.32l-30.4 22.08-166.848 118.912 173.12 123.584c13.76 9.472 24.064 16.64 30.976 21.312 9.472 6.528 9.472 30.592 0 40.384-9.472 9.856-30.976 12.288-47.296 3.968l-7.04-3.968-192.512-137.152-5.952-5.12c-20.864-22.4-22.464-56.96-0.128-84.48l6.08-6.656 193.344-137.728c30.336-20.416 52.096-7.552 57.92 4.544z m147.328 57.92L505.216 516.224l173.12 123.584V392.832z"  ></path></symbol><symbol id="icon-chexiao" viewBox="0 0 1024 1024"><path d="M455.36 192.192c-15.488 1.536-26.112 9.216-38.592 22.4l-8.64 9.28-146.432 142.272-69.44 65.728-22.976 20.672-13.056 12.544-7.552 7.488c-17.472 17.792-25.088 33.984-18.048 56.896l2.944 7.488c10.432 18.112 21.44 30.464 34.432 40.128l13.312 12.16 166.464 159.68 28.16 27.52 31.552 31.36c11.52 11.328 20.864 19.072 31.616 24.448 23.552 11.776 50.048 6.272 60.992-21.504l2.368-7.552c4.736-31.744 5.44-59.584 3.072-87.232l-0.896-47.168 6.08 0.32c119.68 8.704 233.344 61.44 321.6 150.016L896 885.312l-0.064-73.344a470.4 470.4 0 0 0-30.272-165.76l-7.68-18.944-6.656-14.848c-64.384-137.28-189.248-229.376-330.688-245.952L504.192 364.8l0.384-71.808-0.448-39.232c0-6.4-0.064-10.24-0.64-15.36-1.728-16.64-6.848-29.888-20.352-39.168a42.368 42.368 0 0 0-27.776-7.04zM445.312 270.08l0.192 41.6-0.384 65.152v45.952h29.44c141.12 0 269.696 88.512 328.96 227.2l7.168 17.728 6.08 17.216c3.776 11.52 7.04 23.36 9.728 35.328l3.456 17.152-14.976-11.904c-98.752-75.712-217.6-116.928-340.416-116.672h-29.888l1.92 109.696 0.896 15.168 0.32 14.72-0.448 15.68-39.168-38.72-39.872-38.784-136.32-130.752-14.272-13.376-12.672-11.264-5.888-4.864a68.48 68.48 0 0 1-9.28-10.24l-0.512-0.832 20.224-19.52 26.24-23.808 48.192-45.44 86.272-83.2L445.312 270.08z"  ></path></symbol><symbol id="icon-shanchujiedian" viewBox="0 0 1024 1024"><path d="M719.168 734.272a33.92 33.92 0 0 1 48 0l59.904 59.904 59.968-59.904a33.92 33.92 0 0 1 48 47.936l-59.968 59.968 59.904 59.904 3.968 4.736a33.92 33.92 0 0 1-51.84 43.264l-60.032-59.968-59.904 59.968a33.92 33.92 0 0 1-48-48l59.968-59.904-59.968-59.968a33.92 33.92 0 0 1 0-48z m-455.04-57.472a136.512 136.512 0 0 1 128.768 91.712l3.2 10.432 224.128-0.064v68.16H396.096a136.512 136.512 0 0 1-120.96 101.76l-10.88 0.384A136.576 136.576 0 0 1 128 812.992a136.576 136.576 0 0 1 136.128-136.192z m0.064 68.096a68.288 68.288 0 0 0-68.096 68.096 68.288 68.288 0 0 0 68.096 68.096 68.288 68.288 0 0 0 68.096-68.096 68.288 68.288 0 0 0-68.096-68.096zM808.96 64a136.576 136.576 0 0 1 136.192 136.192 136.576 136.576 0 0 1-136.192 136.192 136.512 136.512 0 0 1-128.768-91.776l-3.2-10.432H315.328a119.552 119.552 0 0 0-119.168 119.232 119.552 119.552 0 0 0 109.888 118.784l9.28 0.384h442.624a187.328 187.328 0 0 1 185.6 162.176h-69.12a119.744 119.744 0 0 0-106.56-93.696l-9.92-0.384H315.264A187.264 187.264 0 0 1 304.256 166.4l11.008-0.32h361.792A136.512 136.512 0 0 1 808.896 64z m0 68.096a68.544 68.544 0 0 0-67.2 57.088l-0.896 7.616v6.784a68.48 68.48 0 0 0 68.096 64.64 68.288 68.288 0 0 0 68.096-68.032 68.288 68.288 0 0 0-68.096-68.096z"  ></path></symbol><symbol id="icon-zhanghao2" viewBox="0 0 1024 1024"><path d="M632.9856 525.0048c174.2336 44.032 292.1472 185.4976 350.208 417.8944a46.3872 46.3872 0 0 1-90.0096 22.528c-61.44-245.8624-187.8528-362.496-385.6896-362.496-197.8368 0-324.3008 116.6336-385.6384 362.496a46.4384 46.4384 0 1 1-90.112-22.528c58.112-232.3456 176.0256-373.8624 350.208-417.8944a265.0112 265.0112 0 1 1 251.0848 0h-0.0512zM507.4944 463.7696a172.288 172.288 0 1 0 0-344.576 172.288 172.288 0 0 0 0 344.576z"  ></path></symbol><symbol id="icon-mima2" viewBox="0 0 1024 1024"><path d="M853.4016 436.224L292.0448 435.3024c-0.2048-74.8032-20.5312-190.7712 43.9296-261.1712a255.4368 255.4368 0 0 1 176.128-87.04c104.3456 0 182.3744 77.824 220.16 174.1312 11.008 27.7504 20.736 42.752 43.9296 43.52 58.5216 1.792 54.8352-59.2896 43.8784-87.04C765.4912 78.6944 663.0912 0 511.8464 0c-102.912 0-159.488 20.8384-220.2112 87.04-92.928 101.1712-88.32 264.704-88.064 348.2112l-32.9728 0.9728a54.6304 54.6304 0 0 0-55.296 53.9648v456.9088c0.3072 30.208 25.0368 54.4256 55.1936 54.1184H852.5824a54.6816 54.6816 0 0 0 55.296-54.016V490.24a54.5792 54.5792 0 0 0-55.296-53.9648h0.8192z m-31.3856 434.0224a41.472 41.472 0 0 1-12.9536 30.8224 42.6496 42.6496 0 0 1-31.1808 12.8H248.4224a42.24 42.24 0 0 1-31.1296-12.8 41.8304 41.8304 0 0 1-13.0048-30.8224v-305.2544a43.9296 43.9296 0 0 1 44.1344-43.52h529.408a43.8784 43.8784 0 0 1 44.1344 43.52v305.2544z"  ></path></symbol><symbol id="icon-cha" viewBox="0 0 1024 1024"><path d="M512 3.584A507.456 507.456 0 0 0 3.584 512c0 281.6 226.816 508.416 508.416 508.416S1020.416 793.6 1020.416 512 793.6 3.584 512 3.584z m246.4 711.808c15.616 15.616 15.616 35.2 0 50.816-3.904 0-11.712 3.904-23.488 3.904-7.808 0-19.52-3.84-23.424-11.712L512 558.912 312.512 758.4c-7.808 7.808-15.616 11.712-23.424 11.712-7.872 0-19.584-3.84-23.488-11.712-7.808-7.808-11.712-15.616-11.712-23.488 0-7.808 3.84-19.52 11.712-23.424L465.088 512 265.6 312.512c-7.808-7.808-11.712-15.616-11.712-23.424 0-7.872 3.84-19.584 11.712-23.488 7.808-3.904 15.616-11.712 23.488-11.712 7.808 0 19.52 3.84 23.424 11.712L512 465.088l199.488-199.488c7.808-7.808 15.616-11.712 23.424-11.712 7.872 0 19.584 3.84 23.488 11.712 15.616 15.616 15.616 35.2 0 50.816L558.912 515.904l199.488 199.488z" fill="#ADB1B9" ></path></symbol><symbol id="icon-yk_fangkuai_fill" viewBox="0 0 1024 1024"><path d="M65.95584 66.06848v891.91936h892.032V66.06848H65.95584z"  ></path></symbol><symbol id="icon-tianjiawangluoziyuan" viewBox="0 0 1024 1024"><path d="M512 0c282.760533 0 512 229.239467 512 512 0 282.760533-229.239467 512-512 512-282.760533 0-512-229.239467-512-512C0 229.239467 229.239467 0 512 0z m0 68.266667C266.922667 68.266667 68.266667 266.922667 68.266667 512s198.656 443.733333 443.733333 443.733333 443.733333-198.656 443.733333-443.733333S757.077333 68.266667 512 68.266667z" fill="#F1F1F1" ></path><path d="M378.641067 341.333333a68.266667 68.266667 0 0 1 51.712 23.688534l32.768 37.9904a34.133333 34.133333 0 0 0 25.8048 11.844266H750.933333a34.133333 34.133333 0 0 1 34.133334 34.133334V716.8a34.133333 34.133333 0 0 1-34.133334 34.133333H307.2a34.133333 34.133333 0 0 1-34.133333-34.133333V375.466667a34.133333 34.133333 0 0 1 34.133333-34.133334h71.441067z m150.4256 153.6a17.066667 17.066667 0 0 0-17.066667 17.066667v68.266667h-68.266667l-3.072 0.273066A17.066667 17.066667 0 0 0 443.733333 614.4h68.266667v68.266667l0.273067 3.072A17.066667 17.066667 0 0 0 546.133333 682.666667v-68.266667h68.266667l3.072-0.273067A17.066667 17.066667 0 0 0 614.4 580.266667h-68.266667v-68.266667l-0.273066-3.072a17.066667 17.066667 0 0 0-16.7936-13.994667z" fill="#888888" ></path><path d="M733.866667 341.333333a17.066667 17.066667 0 0 1 3.072 33.860267L733.866667 375.466667h-204.8a17.066667 17.066667 0 0 1-3.072-33.860267L529.066667 341.333333h204.8z" fill="#D6D6D6" ></path></symbol><symbol id="icon-shangchuanziyuan" viewBox="0 0 1058 1024"><path d="M523.3664 0c282.794667 0 512 229.239467 512 512 0 282.760533-229.205333 512-512 512-282.760533 0-512-229.239467-512-512 0-282.760533 229.239467-512 512-512z m0 68.266667c-245.077333 0-443.733333 198.656-443.733333 443.733333s198.656 443.733333 443.733333 443.733333 443.733333-198.656 443.733333-443.733333-198.656-443.733333-443.733333-443.733333z" fill="#F1F1F1" ></path><path d="M384.682667 363.349333h1.9456a173.602133 173.602133 0 0 0-37.410134 106.154667 115.370667 115.370667 0 0 0-91.306666 72.840533 134.417067 134.417067 0 0 1 126.805333-178.9952z" fill="#D8D8D8" ></path><path d="M563.4048 324.949333c75.093333 0 139.093333 47.342933 163.771733 113.834667a144.1792 144.1792 0 1 1 2.184534 287.982933v0.2048h-324.266667a115.2 115.2 0 0 1-16.315733-229.239466 174.626133 174.626133 0 0 1 174.626133-172.782934z m22.289067 143.940267a17.066667 17.066667 0 0 0-24.064 2.6624l-73.386667 92.3648-1.672533 2.56a17.066667 17.066667 0 0 0 4.437333 21.435733l2.594133 1.706667a17.066667 17.066667 0 0 0 21.4016-4.471467l44.612267-56.251733v122.436267l0.3072 3.072a17.066667 17.066667 0 0 0 33.860267-3.072v-121.002667l47.377066 55.296 2.184534 2.1504a17.066667 17.066667 0 0 0 23.722666-24.337067L587.946667 471.04z" fill="#888888" ></path></symbol><symbol id="icon-yinyongziyuan" viewBox="0 0 1058 1024"><path d="M534.766933 0c282.760533 0 512 229.239467 512 512 0 282.760533-229.239467 512-512 512-282.794667 0-512-229.239467-512-512 0-282.760533 229.205333-512 512-512z m0 68.266667c-245.077333 0-443.733333 198.656-443.733333 443.733333s198.656 443.733333 443.733333 443.733333 443.733333-198.656 443.733334-443.733333-198.656-443.733333-443.733334-443.733333z" fill="#F1F1F1" ></path><path d="M700.859733 307.2a34.133333 34.133333 0 0 1 34.133334 34.133333v21.981867H352.221867a34.133333 34.133333 0 0 0-33.928534 30.139733l-0.2048 3.9936v273.8176h-22.254933a34.133333 34.133333 0 0 1-34.133333-34.133333V341.333333a34.133333 34.133333 0 0 1 34.133333-34.133333h405.026133z" fill="#D6D6D6" ></path><path d="M757.248 397.312a34.133333 34.133333 0 0 1 34.133333 34.133333v261.802667a34.133333 34.133333 0 0 1-34.133333 34.133333H383.419733a34.133333 34.133333 0 0 1-34.133333-34.133333v-261.802667a34.133333 34.133333 0 0 1 34.133333-34.133333h373.828267z m-223.163733 91.921067c-35.976533 29.832533-53.930667 62.8736-53.930667 99.157333v54.442667h63.112533v-79.701334h-31.300266c0.7168-1.706667 1.262933-3.242667 1.604266-4.539733 5.393067-13.824 15.6672-25.941333 30.754134-36.283733 2.1504-1.297067 5.051733-3.242667 8.635733-5.8368l-18.875733-27.2384z m109.226666 3.9936c-35.976533 28.2624-53.930667 59.5968-53.930666 94.0032v51.643733h63.112533v-75.605333h-31.300267c0.7168-1.6384 1.262933-3.072 1.604267-4.3008 5.393067-13.1072 15.6672-24.576 30.754133-34.4064 2.1504-1.2288 5.051733-3.072 8.635734-5.5296l-18.875734-25.8048z" fill="#888888" ></path></symbol><symbol id="icon-ziyuanguanli" viewBox="0 0 1024 1024"><path d="M739.328 559.581867a17.066667 17.066667 0 0 1 14.609067 8.2944l46.8992 78.267733a17.066667 17.066667 0 0 1 0 17.6128l-46.830934 77.5168a17.066667 17.066667 0 0 1-14.609066 8.226133h-92.603734a17.066667 17.066667 0 0 1-15.018666-8.977066L590.165333 663.210667a17.066667 17.066667 0 0 1 0-16.0768l41.642667-78.4384a17.066667 17.066667 0 0 1 15.0528-9.079467h92.398933zM734.583467 341.333333a34.133333 34.133333 0 0 1 34.133333 34.133334v159.300266a51.2 51.2 0 0 0-29.457067-9.3184h-92.398933a51.2 51.2 0 0 0-45.226667 27.204267l-41.642666 78.4384a51.2 51.2 0 0 0 0.1024 48.2304l29.457066 54.818133H311.876267a34.133333 34.133333 0 0 1-34.133334-34.133333V375.466667a34.133333 34.133333 0 0 1 34.133334-34.133334h422.741333z m-40.891734 264.874667a49.117867 49.117867 0 1 0 0 98.2016 49.117867 49.117867 0 0 0 0-98.2016z m-210.978133 5.973333h-97.1776l-3.072 0.273067a17.066667 17.066667 0 0 0 0 33.5872l3.072 0.273067h97.1776l3.072-0.273067a17.066667 17.066667 0 0 0-3.072-33.860267z m58.811733-99.054933h-155.989333l-3.072 0.273067a17.066667 17.066667 0 0 0 0 33.5872l3.072 0.273066h155.989333l3.072-0.273066a17.066667 17.066667 0 0 0-3.072-33.860267z m73.147734-99.0208h-229.137067l-3.072 0.273067a17.066667 17.066667 0 0 0 0 33.5872l3.072 0.273066h229.137067l3.072-0.273066a17.066667 17.066667 0 0 0-3.072-33.860267z" fill="#888888" ></path><path d="M512 0c282.760533 0 512 229.239467 512 512 0 282.760533-229.239467 512-512 512-282.760533 0-512-229.239467-512-512C0 229.239467 229.239467 0 512 0z m0 68.266667C266.922667 68.266667 68.266667 266.922667 68.266667 512s198.656 443.733333 443.733333 443.733333 443.733333-198.656 443.733333-443.733333S757.077333 68.266667 512 68.266667z" fill="#F1F1F1" ></path></symbol><symbol id="icon-cankaojiaocai1" viewBox="0 0 1024 1024"><path d="M445.500235 246.964706c16.564706 0 32.165647 7.649882 42.285177 20.720941l115.350588 148.841412a53.549176 53.549176 0 0 0 42.285176 20.720941h268.769883c59.151059 0 107.098353 47.947294 107.098353 107.098353v321.234823c0 59.151059-47.947294 107.098353-107.098353 107.098353H164.623059A107.098353 107.098353 0 0 1 57.524706 865.581176V354.063059c0-59.151059 47.947294-107.098353 107.098353-107.098353h280.877176z m522.24-53.549177a53.549176 53.549176 0 1 1 0 107.098353H782.456471a53.549176 53.549176 0 1 1 0-107.098353h185.344z m0-160.647529a53.549176 53.549176 0 1 1 0 107.098353H325.270588a53.549176 53.549176 0 1 1 0-107.098353h642.469647z" fill="#E55231" ></path></symbol><symbol id="icon-a-cankaojiaocaihui" viewBox="0 0 1024 1024"><path d="M443.693176 246.964706c16.564706 0 32.165647 7.649882 42.345412 20.720941l115.290353 148.841412a53.549176 53.549176 0 0 0 42.345412 20.720941h268.769882c59.151059 0 107.038118 47.947294 107.038118 107.098353v321.234823c0 59.151059-47.887059 107.098353-107.038118 107.098353H162.816A107.098353 107.098353 0 0 1 55.777882 865.581176V354.063059c0-59.151059 47.947294-107.098353 107.038118-107.098353h280.877176z m522.24-53.549177a53.549176 53.549176 0 1 1 0 107.098353H780.649412a53.549176 53.549176 0 1 1 0-107.098353h185.404235z m0-160.647529a53.549176 53.549176 0 1 1 0 107.098353H323.463529a53.549176 53.549176 0 1 1 0-107.098353h642.529883z" fill="#C1C1C1" ></path></symbol><symbol id="icon-zhishitupu" viewBox="0 0 1024 1024"><path d="M821.729882 34.936471a160.647529 160.647529 0 0 1 199.55953 155.828705v528.865883c0 73.667765-50.115765 137.938824-121.615059 155.76847l-360.207059 90.172236-360.267294-90.051765a160.647529 160.647529 0 0 1-121.675294-155.888941v-528.865883A160.647529 160.647529 0 0 1 257.204706 34.936471l282.262588 70.475294L821.729882 34.936471z m-94.930823 232.869647a80.293647 80.293647 0 0 0-61.078588 132.517647l-53.790118 89.690353a133.601882 133.601882 0 0 0-107.881412 7.228235l-41.562353-55.416471a107.098353 107.098353 0 1 0-42.887529 32.105412l42.887529 57.283765a133.842824 133.842824 0 1 0 195.162353-13.131294l54.512941-90.955294a80.293647 80.293647 0 1 0 14.637177-159.322353z" fill="#E55231" ></path></symbol><symbol id="icon-zhishitupuhui" viewBox="0 0 1024 1024"><path d="M819.922824 34.936471a160.647529 160.647529 0 0 1 199.619764 155.828705v528.865883c0 73.667765-50.176 137.938824-121.675294 155.76847l-360.207059 90.172236-360.207059-90.051765a160.647529 160.647529 0 0 1-121.675294-155.888941v-528.865883A160.647529 160.647529 0 0 1 255.337412 34.936471l282.322823 70.475294L819.922824 34.936471z m-94.870589 232.869647a80.293647 80.293647 0 0 0-61.138823 132.517647l-53.790118 89.690353a133.601882 133.601882 0 0 0-107.881412 7.228235l-41.562353-55.416471a107.098353 107.098353 0 1 0-42.887529 32.105412l42.887529 57.283765a133.842824 133.842824 0 1 0 195.162353-13.131294l54.512942-90.955294a80.293647 80.293647 0 1 0 14.697411-159.322353z" fill="#C1C1C1" ></path></symbol><symbol id="icon-kechengdagang" viewBox="0 0 1024 1024"><path d="M879.217778 0a113.777778 113.777778 0 0 1 113.777778 113.777778v796.444444a113.777778 113.777778 0 0 1-113.777778 113.777778h-682.666667a113.777778 113.777778 0 0 1-113.777778-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778h682.666667z m-113.777778 682.666667h-455.111111a56.888889 56.888889 0 1 0 0 113.777777h455.111111a56.888889 56.888889 0 1 0 0-113.777777z m-227.555556-227.555556h-227.555555a56.888889 56.888889 0 1 0 0 113.777778h227.555555a56.888889 56.888889 0 1 0 0-113.777778z m227.555556-227.555555h-455.111111a56.888889 56.888889 0 0 0 0 113.777777h455.111111a56.888889 56.888889 0 1 0 0-113.777777z" fill="#E55231" ></path></symbol><symbol id="icon-kechengdaganghui" viewBox="0 0 1024 1024"><path d="M877.568 0a113.777778 113.777778 0 0 1 113.777778 113.777778v796.444444a113.777778 113.777778 0 0 1-113.777778 113.777778h-682.666667a113.777778 113.777778 0 0 1-113.777777-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777777-113.777778h682.666667z m-113.777778 682.666667h-455.111111a56.888889 56.888889 0 1 0 0 113.777777h455.111111a56.888889 56.888889 0 1 0 0-113.777777z m-227.555555-227.555556h-227.555556a56.888889 56.888889 0 1 0 0 113.777778h227.555556a56.888889 56.888889 0 1 0 0-113.777778z m227.555555-227.555555h-455.111111a56.888889 56.888889 0 0 0 0 113.777777h455.111111a56.888889 56.888889 0 1 0 0-113.777777z" fill="#C1C1C1" ></path></symbol><symbol id="icon-guanbi" viewBox="0 0 1024 1024"><path d="M591.530667 512l417.109333-417.109333a54.613333 54.613333 0 0 0 0-76.8l-2.304-2.304a54.613333 54.613333 0 0 0-76.8 0L512.426667 433.493333 95.317333 15.786667a54.613333 54.613333 0 0 0-76.8 0L16.213333 18.090667a53.589333 53.589333 0 0 0 0 76.8L433.322667 512 16.213333 929.109333a54.613333 54.613333 0 0 0 0 76.8l2.304 2.304a54.613333 54.613333 0 0 0 76.8 0l417.109334-417.109333 417.109333 417.109333a54.613333 54.613333 0 0 0 76.8 0l2.304-2.304a54.613333 54.613333 0 0 0 0-76.8L591.530667 512z"  ></path></symbol><symbol id="icon-bianji" viewBox="0 0 1024 1024"><path d="M83.092796 1024a46.518625 46.518625 0 0 1 0-93.037249h837.627812a46.518625 46.518625 0 0 1 0 93.037249H83.092796zM628.004357 13.755908l186.147641 186.147641a46.518625 46.518625 0 0 1 0 66.04767l-511.851155 511.851155a46.518625 46.518625 0 0 1-33.060406 13.531361H83.092796A46.518625 46.518625 0 0 1 36.574171 744.81511V558.66747a46.518625 46.518625 0 0 1 13.531361-33.060407L561.956687 13.755908a46.518625 46.518625 0 0 1 66.04767 0z m-33.060406 98.669221L129.611421 577.75766v120.538826H250.150246l465.332531-465.332531-120.538826-120.538826z"  ></path></symbol><symbol id="icon-jiaoyanzhongxin" viewBox="0 0 1024 1024"><path d="M865.848889 920.689778c0 18.716444-15.189333 33.905778-33.962667 33.905778H160.199111a33.962667 33.962667 0 0 1-33.905778-33.905778V215.04h739.555556v705.649778zM126.293333 107.52c0-21.048889 17.066667-38.115556 38.115556-38.115556h588.174222v76.231112H164.352a38.115556 38.115556 0 0 1-38.058667-38.115556z m695.751111 38.115556V0H164.408889A107.633778 107.633778 0 0 0 63.943111 145.635556H56.888889v775.054222A103.424 103.424 0 0 0 160.199111 1024h671.687111a103.424 103.424 0 0 0 103.367111-103.310222V145.635556h-113.208889z m-131.811555 258.844444H253.44a34.702222 34.702222 0 0 0 0 69.404444h436.792889a34.702222 34.702222 0 0 0 0-69.404444M528.497778 550.115556h-258.844445a34.702222 34.702222 0 0 0 0 69.404444h258.844445a34.702222 34.702222 0 0 0 0-69.404444"  ></path></symbol><symbol id="icon-diandian" viewBox="0 0 1024 1024"><path d="M491.320899 957.260164a97.355161 97.355161 0 1 0 0-194.710322 97.355161 97.355161 0 0 0 0 194.710322m0-380.842056a97.355161 97.355161 0 1 0 0-194.710322 97.355161 97.355161 0 0 0 0 194.710322m0-380.763354a97.355161 97.355161 0 1 0 0-194.789025 97.355161 97.355161 0 0 0 0 194.789025"  ></path></symbol><symbol id="icon-jichushuju1" viewBox="0 0 1024 1024"><path d="M955.712 0H68.288C26.816 0 0 26.816 0 68.288V716.8c0 41.472 26.816 68.288 68.288 68.288H460.8v13.888c-21.12 12.032-37.248 31.36-45.248 54.4H204.8c-22.784 0-34.112 11.328-34.112 34.112v34.112c0 22.784 11.328 34.112 34.112 34.112h231.36c1.28 1.344 2.112 2.88 3.456 4.16A98.56 98.56 0 0 0 512 989.888c28.288 0 52.48-10.048 72.384-30.08 1.28-1.28 2.24-2.752 3.456-4.096H819.2c22.784 0 34.112-11.328 34.112-34.112v-34.112c0-22.784-11.328-34.176-34.112-34.176H608.448a100.16 100.16 0 0 0-45.248-54.336v-13.888h392.512c41.472 0 68.288-26.816 68.288-68.288V68.288C1024 26.816 997.184 0 955.712 0z m0 716.8H68.288V443.712h887.424V716.8z m0-341.312H68.288v-307.2h887.424v307.2z m-119.424-102.4c14.08 0 26.24-4.992 36.224-14.976a49.344 49.344 0 0 0 14.976-36.224c0-14.144-4.992-26.24-14.976-36.224a49.344 49.344 0 0 0-36.224-14.976c-14.144 0-26.24 4.992-36.224 14.976a49.344 49.344 0 0 0-14.976 36.224c0 14.08 4.992 26.24 14.976 36.224a49.344 49.344 0 0 0 36.224 14.976z m0 375.424c14.08 0 26.24-4.992 36.224-14.976a49.344 49.344 0 0 0 14.976-36.224c0-14.08-4.992-26.24-14.976-36.224a49.344 49.344 0 0 0-36.224-14.976c-14.144 0-26.24 4.992-36.224 14.976a49.344 49.344 0 0 0-14.976 36.224c0 14.144 4.992 26.24 14.976 36.224a49.344 49.344 0 0 0 36.224 14.976z"  ></path></symbol><symbol id="icon-liebiao" viewBox="0 0 1024 1024"><path d="M336.952889 621.397333c11.662222 0 17.521778 5.831111 17.521778 17.521778v34.986667c0 11.662222-5.859556 17.521778-17.521778 17.521778h-34.986667c-11.662222 0-17.521778-5.831111-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.493334-17.521778h35.015111z m385.109333 0c11.662222 0 17.493333 5.831111 17.493334 17.521778v34.986667c0 11.662222-5.831111 17.521778-17.493334 17.521778H406.983111c-11.662222 0-17.521778-5.831111-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.521778-17.521778h315.079111z m-385.109333-140.032c11.662222 0 17.521778 5.831111 17.521778 17.493334v35.015111c0 11.662222-5.859556 17.521778-17.521778 17.521778h-34.986667c-11.662222 0-17.521778-5.859556-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.493334-17.521778h35.015111z m385.109333 0c11.662222 0 17.493333 5.831111 17.493334 17.493334v35.015111c0 11.662222-5.831111 17.521778-17.493334 17.521778H406.983111c-11.662222 0-17.521778-5.859556-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.521778-17.521778h315.079111zM336.952889 341.333333c11.662222 0 17.521778 5.831111 17.521778 17.493334v35.015111c0 11.662222-5.859556 17.521778-17.521778 17.521778h-34.986667c-11.662222 0-17.521778-5.859556-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.493334-17.521778h35.015111z m385.109333 0c11.662222 0 17.493333 5.831111 17.493334 17.493334v35.015111c0 11.662222-5.831111 17.521778-17.493334 17.521778H406.983111c-11.662222 0-17.521778-5.859556-17.521778-17.521778v-34.986667c0-11.662222 5.831111-17.521778 17.521778-17.521778h315.079111z"  ></path></symbol><symbol id="icon-liuyan" viewBox="0 0 1092 1024"><path d="M608.256 939.758933a87.8592 87.8592 0 0 1-124.245333 0l-117.3504-117.418666H89.429333c-48.469333 0-87.8592-39.3216-87.8592-87.790934V102.1952C1.570133 53.725867 40.96 14.404267 89.429333 14.404267h913.408c48.469333 0 87.8592 39.3216 87.8592 87.790933v632.354133c0 48.469333-39.389867 87.8592-87.8592 87.8592h-277.2992l-117.418666 117.3504h0.136533z m73.659733-222.754133h303.377067V119.739733H106.973867v597.265067h303.445333L546.133333 852.650667l135.714134-135.714134zM475.818667 418.4064a70.314667 70.314667 0 1 0 140.4928 0 70.314667 70.314667 0 1 0-140.4928 0z m-281.053867 0a70.314667 70.314667 0 1 0 140.4928 0 70.314667 70.314667 0 1 0-140.4928 0z m562.107733 0a70.314667 70.314667 0 1 0 140.4928 0 70.314667 70.314667 0 1 0-140.4928 0z"  ></path></symbol><symbol id="icon-pizhu" viewBox="0 0 1092 1024"><path d="M724.5824 24.917333c27.306667 0 49.425067 24.439467 49.425067 54.545067 0 27.2384-18.2272 50.244267-42.734934 53.930667l-6.690133 0.546133H115.3024v617.540267h150.869333c24.712533 0 45.602133 20.0704 48.9472 47.104l0.477867 7.3728v57.207466l192.580267-105.949866a46.148267 46.148267 0 0 1 14.5408-5.12l7.509333-0.682667h408.439467V372.736c0-27.2384 18.2272-50.312533 42.666666-53.930667l6.7584-0.546133c24.712533 0 45.602133 20.138667 48.9472 47.104l0.4096 7.3728v396.9024c0 46.557867-31.880533 85.6064-73.864533 90.385067l-8.465067 0.4096H541.832533L288.221867 1000.106667c-24.3712 13.380267-54.0672 2.4576-66.218667-24.439467a58.709333 58.709333 0 0 1-4.778667-16.930133l-0.477866-7.441067v-90.794667H98.781867c-42.1888 0-77.6192-35.157333-81.92-81.5104l-0.4096-9.284266V115.780267C16.452267 68.744533 48.878933 30.037333 90.385067 25.3952l8.3968-0.477867h625.800533z m-197.632 447.146667c27.306667 0 49.425067 24.3712 49.425067 54.4768 0 27.2384-18.2272 50.244267-42.666667 53.930667l-6.7584 0.546133H229.7856c-27.306667 0.341333-49.629867-23.893333-49.902933-53.930667-0.273067-27.648 18.295467-51.131733 43.144533-54.613333l6.7584-0.4096h297.1648zM1022.839467 40.686933a58.709333 58.709333 0 0 1 5.051733 70.929067l-4.7104 6.144-329.386667 367.069867a46.216533 46.216533 0 0 1-69.8368 0 58.709333 58.709333 0 0 1-5.12-70.4512l4.778667-6.144L952.9344 41.028267a46.216533 46.216533 0 0 1 69.8368-0.4096h0.068267zM436.087467 242.8928c27.306667 0 49.3568 24.439467 49.3568 54.545067 0 27.170133-18.2272 50.244267-42.666667 53.930666l-6.690133 0.477867H229.7856c-27.306667 0-49.425067-24.3712-49.425067-54.4768 0-27.2384 18.2272-50.244267 42.666667-53.930667l6.7584-0.546133h206.301867z"  ></path></symbol><symbol id="icon-mima11" viewBox="0 0 1024 1024"><path d="M840.4992 436.224L279.1424 435.3024C278.9376 360.448 258.6112 244.48 323.072 174.08a255.4368 255.4368 0 0 1 176.128-87.04c104.3456 0 182.3744 77.824 220.16 174.1312 11.008 27.8016 20.736 42.752 43.9296 43.52 58.5216 1.792 54.8864-59.2384 43.8784-87.04C752.64 78.6432 650.24 0 498.944 0 395.9808 0 339.456 20.8384 278.6816 87.04c-92.928 101.1712-88.32 264.704-88.064 348.2624l-32.9728 0.9216A54.6304 54.6304 0 0 0 102.4 490.1888V947.2c0.3072 30.208 25.088 54.3744 55.2448 54.0672H839.68a54.6816 54.6816 0 0 0 55.296-54.016V490.1888a54.5792 54.5792 0 0 0-55.1936-53.9648H839.68h0.8192z m-31.3856 433.9712a41.472 41.472 0 0 1-12.9536 30.8736 42.6496 42.6496 0 0 1-31.1808 12.8H235.52a42.24 42.24 0 0 1-31.1296-12.8 41.8304 41.8304 0 0 1-13.0048-30.8736v-305.2544a43.9296 43.9296 0 0 1 44.1344-43.52h529.408a43.8784 43.8784 0 0 1 44.1344 43.52v305.2544h0.0512z"  ></path></symbol><symbol id="icon-shanchu1" viewBox="0 0 1024 1024"><path d="M799.146667 861.610667a62.464 62.464 0 0 1-62.378667 62.293333H287.146667a62.464 62.464 0 0 1-62.378667-62.293333V199.168h574.378667v662.442667zM349.525333 87.04c0-7.168 5.632-12.8 12.8-12.8h300.032c7.253333 0 12.8 5.632 12.8 12.8v37.546667H349.525333v-37.546667z m636.842667 37.546667H749.568v-37.546667A87.381333 87.381333 0 0 0 662.272 0H362.410667a87.381333 87.381333 0 0 0-87.210667 87.125333v37.632H37.546667a37.546667 37.546667 0 0 0 0 75.178667h111.957333v661.674667c0 75.946667 61.610667 137.557333 137.557333 137.557333h449.621334c75.946667 0 137.642667-61.610667 137.642666-137.642667V199.253333h111.957334a37.546667 37.546667 0 0 0 37.546666-37.546666 36.864 36.864 0 0 0-37.546666-36.864v-0.085334z m-474.453333 686.506666a37.546667 37.546667 0 0 0 37.632-37.546666V373.504a37.546667 37.546667 0 0 0-75.178667 0v399.957333c0 20.821333 16.810667 37.546667 37.546667 37.546667z m-175.104 0a37.546667 37.546667 0 0 0 37.546666-37.546666V373.504a37.546667 37.546667 0 0 0-75.178666 0v399.957333c0.853333 20.821333 17.578667 37.546667 37.546666 37.546667z m350.293333 0a37.546667 37.546667 0 0 0 37.632-37.546666V373.504a37.546667 37.546667 0 0 0-75.178667 0v399.957333c0 20.821333 16.810667 37.546667 37.546667 37.546667z"  ></path></symbol><symbol id="icon-shang11" viewBox="0 0 1457 1024"><path d="M1340.416 715.093333L756.394667 76.117333a91.989333 91.989333 0 0 0-138.24 0L34.474667 714.922667a108.202667 108.202667 0 0 0 68.949333 182.272h1167.701333a108.202667 108.202667 0 1 0 69.461334-182.272z"  ></path></symbol><symbol id="icon-tijiao" viewBox="0 0 1024 1024"><path d="M911.36 911.36V472.576a42.666667 42.666667 0 1 1 85.333333 0v452.949333a71.253333 71.253333 0 0 1-71.168 71.253334H71.338667A71.253333 71.253333 0 0 1 0 925.610667V71.338667C0 31.914667 31.914667 0 71.253333 0h455.850667a42.666667 42.666667 0 0 1 0 85.333333H85.504v826.026667h825.770667zM914.517333 45.226667a49.834667 49.834667 0 1 1 79.189334 60.501333L577.706667 650.325333a49.834667 49.834667 0 0 1-71.253334 8.192L296.106667 484.864a49.834667 49.834667 0 0 1 63.488-76.8L529.92 548.693333 914.517333 45.226667z"  ></path></symbol><symbol id="icon-quanxianshezhi1" viewBox="0 0 1024 1024"><path d="M626.4832 51.2c5.1712 0 9.728 2.1504 13.7728 5.5296l2.7136 3.072 188.3136 211.8656 1.2288 1.536c2.7648 3.072 4.3008 7.68 4.3008 12.544v143.36c-0.1536 15.6672-1.7408 29.3376-20.48 29.3376-11.9808 0-26.112-5.8368-26.112-33.6896v-109.056h-157.3376c-30.6176 0-52.9408-20.48-52.9408-48.64V92.2112H176.0768c-4.608 0-7.0656 2.7648-7.0656 3.9936v828.5184c0 1.2288 2.4576 3.9936 7.0656 3.9936l284.7232 0.3072c14.6944 0 34.9184 0 34.9184 21.7088 0 20.5312-17.7664 20.5312-34.9184 20.5312H192c-35.2256 0-64-27.5456-64-61.2352V112.4352C128 78.7456 156.7744 51.2 192 51.2z m74.3936 500.5824c11.6224 0 22.3232 6.7584 27.5456 17.7664l47.7696 101.0688 106.8544 16.2304c11.6224 1.536 21.1456 10.0864 24.7808 21.7088a30.3104 30.3104 0 0 1-8.8576 32.4608l-77.1584 78.3872 18.3808 110.848a32.9728 32.9728 0 0 1-12.288 31.5392 29.9008 29.9008 0 0 1-32.4096 2.4576l-95.232-52.3776-95.232 52.3776a29.9008 29.9008 0 0 1-32.4608-2.4576 33.4848 33.4848 0 0 1-12.288-31.5392l18.432-110.848-77.1584-78.336a32.768 32.768 0 0 1-7.68-32.768 31.0784 31.0784 0 0 1 24.832-21.76l106.8544-16.2304 47.7696-100.7616a31.0272 31.0272 0 0 1 27.5456-17.7664z m0.3072 53.248a3.8912 3.8912 0 0 0-3.3792 2.5088l-41.3184 87.552-5.2224 11.008-11.9296 1.8432-92.7744 14.08c-1.536 0.3072-2.7648 1.536-3.3792 3.3792a6.656 6.656 0 0 0 1.2288 5.8368l67.072 68.2496 8.2432 8.2944-1.8432 11.3152-15.872 96.4608a5.2736 5.2736 0 0 0 1.792 5.4784c0.6144 0.6144 1.536 0.6144 1.8432 0.6144 0.6144 0 1.2288 0 1.536-0.3072l82.6368-45.312 11.0592-5.7856 11.008 5.7856 82.944 45.312c0.3584 0.3072 1.28 0.3072 1.536 0.3072a4.352 4.352 0 0 0 1.8432-0.6144c1.536-1.2288 2.1504-3.328 1.8432-5.4784l-15.872-96.4608-1.8944-11.3152 8.2944-8.2944 67.072-68.2496a7.68 7.68 0 0 0 1.536-5.8368c-0.6656-1.8432-1.8432-3.072-3.3792-3.3792l-92.7744-14.08-11.9808-1.8432-5.1712-11.008-41.3696-87.552a3.8912 3.8912 0 0 0-3.328-2.4576zM620.032 96.8704v178.176h160.768l-160.768-178.176z"  ></path></symbol><symbol id="icon-tishi1" viewBox="0 0 1024 1024"><path d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 48.725333A463.274667 463.274667 0 1 0 512 975.36 463.274667 463.274667 0 0 0 512 48.64z m25.088 638.805334a38.4 38.4 0 0 1 11.434667 28.16 36.864 36.864 0 0 1-12.117334 28.757333 41.045333 41.045333 0 0 1-28.757333 11.349333 41.045333 41.045333 0 0 1-28.757333-11.349333 38.4 38.4 0 0 1-11.434667-28.842667 35.84 35.84 0 0 1 11.434667-28.16 38.314667 38.314667 0 0 1 28.757333-11.349333c11.349333 0 21.418667 3.413333 29.44 11.434667z m83.712-383.829334c24.746667 22.784 37.546667 54.272 37.546667 94.464 0 30.122667-8.789333 56.234667-25.514667 78.336-6.656 8.021333-24.746667 25.429333-54.186667 51.541334-14.762667 12.8-24.746667 24.746667-31.488 36.864-8.704 14.762667-12.8 30.805333-12.8 48.896v15.36h-53.504v-15.36c0-22.101333 4.010667-41.472 12.032-58.282667 9.386667-20.053333 31.573333-45.482667 67.669334-77.653333 10.752-10.752 18.773333-18.773333 22.698666-24.149334a82.858667 82.858667 0 0 0 20.138667-52.906666c0-26.794667-8.021333-47.530667-22.784-62.293334-15.36-16.042667-37.546667-23.466667-65.621333-23.466666-33.450667 0-58.197333 10.752-74.24 32.853333-14.762667 18.773333-22.186667 44.202667-22.186667 77.056h-52.906667c0-46.933333 12.8-84.48 39.594667-112.64 26.794667-29.44 64.256-44.117333 112.469333-44.117333 42.837333 0 76.970667 11.349333 103.082667 35.498666z"  ></path></symbol><symbol id="icon-paixu1" viewBox="0 0 1125 1024"><path d="M318.727799 773.088802l-85.921486 85.819199V597.768055h-85.716911v261.139946l-85.921487-85.819199-60.758765 60.758766 189.43642 189.43642L379.486565 833.847568l-60.656478-60.758766zM189.947857 0.40915L0.40915 189.947857l60.758765 60.758766 85.921487-85.921487v261.139946h85.819199V164.785136l85.921486 85.921487 60.656478-60.758766L189.947857 0.40915z m279.040256 82.239137h557.978224v85.819199H468.988113V82.648287z m0 257.559884h557.978224v85.921486H468.988113v-85.921486z m0 257.559884h557.978224v85.921487H468.988113v-85.921487z m0 257.559884h557.978224V941.044851H468.988113v-85.921487z"  ></path></symbol><symbol id="icon-sou" viewBox="0 0 1097 1024"><path d="M696.173714 222.208a319.414857 319.414857 0 0 0-451.364571-13.238857 319.122286 319.122286 0 0 0-13.238857 451.218286 319.414857 319.414857 0 0 0 458.24 6.582857 319.049143 319.049143 0 0 0 6.363428-444.562286m331.849143 783.140571a64 64 0 0 1-90.185143 0l-200.777143-200.996571A446.756571 446.756571 0 0 1 111.908571 713.874286a446.390857 446.390857 0 0 1 90.477715-624.859429 446.756571 446.756571 0 0 1 625.152 90.404572 446.317714 446.317714 0 0 1-0.146286 534.674285l201.069714 201.069715c24.868571 24.868571 24.868571 65.243429 0 90.185142"  ></path></symbol><symbol id="icon-tu" viewBox="0 0 1024 1024"><path d="M346.083556 312.888889h99.555555c22.101333 0 33.166222 11.064889 33.166222 33.194667v99.555555c0 22.101333-11.064889 33.166222-33.166222 33.166222h-99.555555c-22.129778 0-33.194667-11.064889-33.194667-33.166222v-99.555555c0-22.129778 11.064889-33.194667 33.194667-33.194667z m0 232.305778h99.555555c22.101333 0 33.166222 11.064889 33.166222 33.166222v99.555555c0 22.129778-11.064889 33.194667-33.166222 33.194667h-99.555555C323.953778 711.111111 312.888889 700.046222 312.888889 677.916444v-99.555555c0-22.101333 11.064889-33.166222 33.194667-33.166222zM578.360889 312.888889h99.555555c22.129778 0 33.194667 11.064889 33.194667 33.194667v99.555555c0 22.101333-11.064889 33.166222-33.194667 33.166222h-99.555555c-22.101333 0-33.166222-11.064889-33.166222-33.166222v-99.555555c0-22.129778 11.064889-33.194667 33.166222-33.194667z m0 232.305778h99.555555c22.129778 0 33.194667 11.064889 33.194667 33.166222v99.555555c0 22.129778-11.064889 33.194667-33.194667 33.194667h-99.555555c-22.101333 0-33.166222-11.064889-33.166222-33.194667v-99.555555c0-22.101333 11.064889-33.166222 33.166222-33.166222z"  ></path></symbol><symbol id="icon-tianjia" viewBox="0 0 1097 1024"><path d="M514.26632 1023.997806a512.143725 512.143725 0 0 1-363.518182-149.942108A507.608891 507.608891 0 0 1 0.001463 512.000366c0-136.849601 53.540304-265.507244 150.673532-362.055333A511.99744 511.99744 0 0 1 514.193178 0.002926a511.99744 511.99744 0 0 1 363.664467 149.942107A507.608891 507.608891 0 0 1 1028.531177 512.000366a507.608891 507.608891 0 0 1-150.673532 362.055332A511.99744 511.99744 0 0 1 514.339463 1023.997806z m0-950.559819c-117.759411 0-228.497143 45.640915-311.733298 128.511358A434.466399 434.466399 0 0 0 73.436524 512.000366a434.466399 434.466399 0 0 0 129.023355 309.977878 439.293804 439.293804 0 0 0 311.806441 128.511358 438.854949 438.854949 0 0 0 311.733299-128.511358A434.393257 434.393257 0 0 0 955.022973 512.000366a434.466399 434.466399 0 0 0-129.023354-309.977879 439.366946 439.366946 0 0 0-311.733299-128.511357z m257.169 401.844848H551.056993V254.831366a36.790673 36.790673 0 0 0-73.508204 0v220.451469H257.170463a36.790673 36.790673 0 0 0 0 73.435061h220.378326v220.45147a36.790673 36.790673 0 0 0 73.508204 0V548.644754h220.378327a36.790673 36.790673 0 1 0 3.21827-73.435061 36.571246 36.571246 0 0 0-3.21827 0z"  ></path></symbol><symbol id="icon-a-xiudingjilu" viewBox="0 0 1024 1024"><path d="M658.494293 304.583111V252.017778c0-4.835556-3.697778-8.760889-8.248889-8.760889H255.038293c-4.551111 0-8.248889 3.982222-8.248889 8.760889v52.565333c0 4.778667 3.697778 8.760889 8.248889 8.760889h395.207111c4.551111 0 8.248889-3.982222 8.248889-8.760889zM255.038293 400.896c-4.551111 0-8.248889 3.925333-8.248889 8.760889v52.508444c0 4.835556 3.697778 8.760889 8.248889 8.760889H444.421404c4.551111 0 8.248889-3.982222 8.248889-8.760889v-52.508444c0-4.835556-3.697778-8.760889-8.248889-8.760889H255.038293z m148.195556 494.705778H164.528071V125.041778h576.398222V419.84c0 4.835556 3.697778 8.760889 8.192 8.760889h57.628445c4.551111 0 8.248889-3.982222 8.248889-8.760889V81.351111c0-19.399111-14.734222-35.043556-32.938667-35.043555H123.283627c-18.204444 0-32.938667 15.644444-32.938667 35.043555v858.112c0 19.342222 14.734222 35.043556 32.995556 35.043556h279.893333c4.551111 0 8.248889-3.982222 8.248889-8.760889v-61.326222c0-4.778667-3.697778-8.760889-8.248889-8.760889z m73.784889-67.697778l-1.991111 130.104889c-0.056889 9.671111 7.224889 17.635556 16.327111 17.749333h0.568889l121.457777-3.185778a8.248889 8.248889 0 0 0 5.575112-2.503111l318.236444-337.521777a9.159111 9.159111 0 0 0 0-12.344889l-127.886222-135.964445a7.850667 7.850667 0 0 0-5.916445-2.503111 8.248889 8.248889 0 0 0-5.859555 2.503111l-318.179556 337.521778a9.386667 9.386667 0 0 0-2.332444 6.087111z m326.371555-250.936889l46.535111 49.379556-261.233777 276.935111-47.047111 1.194666 0.739555-50.744888 261.006222-276.764445z"  ></path></symbol><symbol id="icon-yonghuguanli" viewBox="0 0 1024 1024"><path d="M953.58496 896.32c23.168 0 38.528-12.8 38.528-32s-15.36-31.936-38.464-31.936h-21.888v63.936h21.888z m-306.88-63.936c-23.04 0-38.4 12.736-38.4 32 0 19.072 15.36 31.936 38.4 31.936h242.816v-63.936H646.70496z m89.088-96c0 19.264 14.72 32 36.672 32h183.04c21.952 0 36.608-12.736 36.608-32 0-19.2-14.72-31.936-36.672-31.936h-183.04c-18.304 0-36.608 12.736-36.608 32z m74.112-395.072C809.90496 151.616 661.10496 0 475.18496 0 289.45696 0 140.65696 151.68 140.65696 341.312c0 128.832 66.88 238.912 171.008 295.68A456.832 456.832 0 0 0 32.62496 978.304c-3.776 18.88 7.488 41.664 29.824 45.44H69.74496a36.352 36.352 0 0 0 37.248-30.336c33.408-178.176 185.856-307.008 364.288-310.912h7.424c178.688 0 331.136-155.456 331.136-341.184z m-330.88 265.344H467.82496c-141.248-7.552-252.8-125.184-252.8-265.344 0-147.968 115.2-265.472 260.352-265.472 144.96 0 260.16 117.504 260.16 265.472 0 144-115.2 261.568-256.512 265.344z m474.24 353.408H646.83296c-23.296 0-38.848 12.8-38.848 32 0 19.136 15.552 31.936 38.848 31.936h306.432c23.296 0 38.848-12.8 38.848-32 0-19.072-19.456-31.936-38.848-31.936z"  ></path></symbol><symbol id="icon-xia11" viewBox="0 0 1457 1024"><path d="M1340.416 227.328L756.394667 865.962667a91.989333 91.989333 0 0 1-138.24 0L34.474667 227.328A108.202667 108.202667 0 0 1 103.253333 45.056h1167.701334a108.202667 108.202667 0 1 1 69.461333 182.272z"  ></path></symbol><symbol id="icon-zhanghao11" viewBox="0 0 1024 1024"><path d="M634.353625 524.208155c183.149222 46.271543 307.006305 194.932325 368.020176 439.149222a48.746532 48.746532 0 0 1-94.587642 23.673813c-64.564943-258.367381-197.407314-380.933165-405.306431-380.933166-207.899117 0-340.741488 122.565784-405.252627 380.933166a48.800336 48.800336 0 1 1-94.69525-23.673813c61.067675-244.163094 185.032367-392.87768 368.07398-439.149222a278.490122 278.490122 0 1 1 263.801598 0zM502.533532 459.804624a181.050862 181.050862 0 0 0 0-362.101724 181.050862 181.050862 0 1 0 0 362.101724z"  ></path></symbol><symbol id="icon-xiezuozhe" viewBox="0 0 1024 1024"><path d="M862.427429 729.453714l106.203428 106.203429c19.529143 19.529143 19.529143 51.2 0 70.729143l-106.203428 106.203428-53.101715-53.028571 50.980572-50.980572H461.970286v-75.117714h398.262857l-50.907429-50.907428 53.101715-53.101715zM537.014857 11.410286a300.397714 300.397714 0 0 1 222.208 502.491428l1.755429-1.974857c46.811429 22.016 89.819429 50.834286 127.780571 85.065143l-50.249143 55.808a450.56 450.56 0 0 0-136.923428-84.845714l-4.827429-1.755429-6.070857 3.657143a299.008 299.008 0 0 1-153.6 42.276571c-58.733714 0-113.517714-16.822857-159.744-45.933714l-4.827429 1.828572a450.706286 450.706286 0 0 0-285.988571 419.547428H11.337143A525.750857 525.750857 0 0 1 313.051429 512 300.397714 300.397714 0 0 1 537.014857 11.410286z m0 75.044571a225.28 225.28 0 1 0 0 450.56 225.28 225.28 0 1 0 0-450.56z"  ></path></symbol><symbol id="icon-kai" viewBox="0 0 1220 1024"><path d="M5.41504 285.014043l313.098197 222.508282L5.41504 730.030606V285.078019z m49.453393-186.361881h1060.976808a49.197489 49.197489 0 1 0 0-98.331003H54.868433a49.197489 49.197489 0 1 0 0 98.331003z m1061.552591 818.124181H54.868433a49.261465 49.261465 0 0 0 0 98.394979h1060.976808c27.125794 0 49.261465-22.00772 49.389417-49.133514a48.941586 48.941586 0 0 0-48.621706-49.261465h-0.191928z m0-305.485061H451.967025a49.261465 49.261465 0 0 0 0 98.458954h663.878216c27.18977 0 49.261465-22.071696 49.453393-49.133513a48.941586 48.941586 0 0 0-48.621706-49.325441h-0.255904z m0-305.421086H451.967025a49.197489 49.197489 0 1 0 0 98.331003h663.878216c27.18977 0 49.261465-21.943744 49.453393-49.133513a48.941586 48.941586 0 0 0-48.493754-49.261466h-0.383856z"  ></path></symbol><symbol id="icon-shou1" viewBox="0 0 1219 1024"><path d="M316.49496 284.921232L3.35744 507.457458l313.13752 222.536227V284.985216zM52.881028 98.535944h1061.046075a49.203668 49.203668 0 1 0 0-98.343352H52.817044a49.203668 49.203668 0 1 0 0 98.343352z m1061.621931 818.226932H52.817044a49.267652 49.267652 0 0 0 0 98.407337h1061.110059c27.129201 0 49.267652-22.010484 49.395621-49.139684a48.947732 48.947732 0 0 0-48.627813-49.267653h-0.191952z m0-305.523428H449.965509a49.267652 49.267652 0 0 0 0 98.471321h663.961594c27.193185 0 49.267652-22.074468 49.459605-49.139685a48.947732 48.947732 0 0 0-48.627813-49.331636h-0.255936z m0-305.459444H449.965509a49.203668 49.203668 0 1 0 0 98.343353h663.961594c27.193185 0 49.267652-21.9465 49.459605-49.139685a48.947732 48.947732 0 0 0-48.499845-49.267652h-0.383904z"  ></path></symbol><symbol id="icon-yinyong1" viewBox="0 0 1109 1024"><path d="M625.487078 400.123999c18.773146 18.773146 35.412979 41.727583 47.956854 66.729999 10.410563 20.906458 0 45.908874-20.906457 56.319437-20.821125 10.495895-45.823542 0-56.319437-20.821125a167.080996 167.080996 0 0 0-31.31702-43.860895 154.878451 154.878451 0 0 0-219.048477 0L130.900024 675.491912c-60.500728 60.586061-60.500728 158.63308 0 219.133808 29.269041 29.183708 68.863311 45.908874 108.542915 45.908875 39.679603 0 81.407186-16.725166 108.457582-45.908875L485.627144 756.899098a40.362263 40.362263 0 0 1 58.452749 0 40.362263 40.362263 0 0 1 0 58.452748l-137.726623 137.726623A226.984397 226.984397 0 0 1 239.442939 1023.98976a241.832248 241.832248 0 0 1-168.958311-68.863311 238.077619 238.077619 0 0 1 0-338.001954l216.915165-217.000496a238.077619 238.077619 0 0 1 338.087285 0zM961.35572 70.399296a238.077619 238.077619 0 0 1 0 338.087286L742.392576 623.353766a238.674947 238.674947 0 0 1-168.95831 70.996624c-60.586061 0-121.086789-23.03977-169.043643-68.863312a241.832248 241.832248 0 0 1-45.908874-64.682019 41.812915 41.812915 0 0 1 18.773145-56.319437 41.812915 41.812915 0 0 1 56.319437 18.773145c8.362583 14.506522 16.725166 29.183708 29.183708 41.642251 60.586061 60.586061 158.63308 60.586061 219.133809 0l219.048476-217.000497A154.878451 154.878451 0 1 0 681.806515 128.852045L533.66933 276.98923a40.362263 40.362263 0 0 1-58.452749 0 40.362263 40.362263 0 0 1 0-58.452749L623.353766 70.399296a238.077619 238.077619 0 0 1 338.001954 0z"  ></path></symbol><symbol id="icon-shenfen1" viewBox="0 0 1117 1024"><path d="M853.457455 542.301091c125.765818 0 226.397091 103.936 226.39709 233.890909 0 129.861818-100.631273 233.844364-226.39709 233.844364s-226.397091-103.936-226.397091-233.844364c0-129.954909 100.631273-233.890909 226.397091-233.890909zM490.170182 10.984727c116.782545 5.632 164.026182 75.915636 172.357818 146.245818 2.792727 19.642182-2.792727 56.226909-8.331636 98.397091 25.041455-5.632 13.917091 56.226909 13.917091 75.869091 0 19.735273-8.378182 50.641455-30.580364 45.009455-11.170909 84.340364-44.497455 109.661091-44.497455 109.661091v87.179636s5.771636 2.885818 23.505455 10.938182a324.235636 324.235636 0 0 0-68.421818 199.912727c0 55.994182 14.103273 108.683636 38.912 154.624H64.791273a44.171636 44.171636 0 0 1-44.497455-44.962909v-1.396364c0.325818-15.918545 6.283636-164.864 116.782546-220.718545 75.031273-36.584727 47.243636-8.424727 136.238545-45.009455 91.694545-39.330909 113.989818-50.594909 113.989818-50.594909v-89.972363s-33.373091-25.320727-44.497454-109.661091c-22.248727 5.632-27.787636-25.274182-30.580364-44.962909 0-19.688727-11.170909-81.547636 13.870546-75.915637-5.538909-42.170182-8.331636-78.754909-8.331637-98.397091 5.585455-67.490909 72.285091-140.567273 172.404364-146.245818z m440.040727 654.894546l-2.792727 3.351272-90.158546 123.252364-45.568-36.072727c-5.771636-5.957818-16.570182-6.702545-23.598545-2.234182l-2.792727 2.234182-16.477091 17.035636c-6.609455 6.795636-9.728 17.501091 0 27.229091 3.770182 3.816727 16.290909 14.615273 30.254545 26.344727l12.055273 10.193455c18.106182 15.220364 34.955636 29.184 34.955636 29.184 3.025455 6.237091 23.645091 8.750545 36.352-3.816727l3.258182-3.816728 114.501818-155.461818s6.190545-14.754909 0-20.061091c-3.258182-6.842182-26.391273-20.805818-26.391272-20.805818a21.690182 21.690182 0 0 0-23.598546 3.444364z"  ></path></symbol><symbol id="icon-a-gonghaodenglu1x" viewBox="0 0 1228 1024"><path d="M1111.6544 106.1888c40.9088 0 74.0864 38.0928 74.0864 84.992v701.4912c0 46.8992-33.1776 84.992-74.0864 84.992H74.0864C33.1776 977.8176 0 939.6736 0 892.7744v-701.44c0-46.848 33.1776-84.992 74.0864-84.992h370.5856c10.1888 0 18.5344 9.5744 18.5344 21.248v84.992c0 46.848 33.2288 84.992 74.1376 84.992h111.104c40.9088 0 74.0864-38.0928 74.0864-84.992V127.488c0-11.7248 8.3456-21.2992 18.5344-21.2992h370.5856z m-645.12 545.792H238.8992a68.2496 68.2496 0 0 0-6.6048 136.192l6.6048 0.3072H466.432a68.2496 68.2496 0 1 0 0-136.5504zM819.2 660.48h-153.6a51.2 51.2 0 0 0-5.9904 102.0416L665.6 762.88h153.6a51.2 51.2 0 0 0 5.9904-102.0416L819.2 660.48z m153.6-153.6h-307.2a51.2 51.2 0 0 0-5.9904 102.0416L665.6 609.28h307.2a51.2 51.2 0 0 0 5.9904-102.0416L972.8 506.88zM352.7168 378.88l-8.1408 0.3072a113.7664 113.7664 0 0 0 0 226.9696l8.1408 0.3072 8.1408-0.3072a113.7664 113.7664 0 0 0-8.192-227.2768zM629.9136 0c10.24 0 18.5856 9.5232 18.5856 21.248v169.984c0 11.776-8.3968 21.2992-18.5856 21.2992h-74.0864c-10.24 0-18.5856-9.5232-18.5856-21.248V21.248c0-11.7248 8.3968-21.248 18.5856-21.248h74.0864z"  ></path></symbol><symbol id="icon-xueyuan1" viewBox="0 0 1024 1024"><path d="M894.559473 911.962353a42.164706 42.164706 0 0 1 5.722353 83.907765l-5.722353 0.421647H152.159473a42.164706 42.164706 0 0 1-5.722353-83.968l5.722353-0.361412H894.499238zM235.826296 460.197647c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.311059 0-42.526118-15.841882-45.598117-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019764-42.164706z m197.150118 0c23.250824 0 42.526118 15.841882 45.537882 36.442353l0.421648 5.722353v301.176471c0 23.250824-20.600471 42.164706-45.95953 42.164705-23.311059 0-42.526118-15.841882-45.598118-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019765-42.164706z m197.089882 0c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.250824 0-42.526118-15.841882-45.537882-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 45.959529-42.164706z m197.150118 0c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.250824 0-42.526118-15.841882-45.598118-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019765-42.164706zM525.256885 7.589647l436.705882 339.727059a36.141176 36.141176 0 0 1-22.106353 64.692706H66.263944a36.141176 36.141176 0 0 1-22.166589-64.692706l436.705883-339.727059a36.141176 36.141176 0 0 1 44.453647 0zM502.969826 97.159529L206.672414 327.68h592.715294l-296.357647-230.520471z"  ></path></symbol><symbol id="icon-gonghao1" viewBox="0 0 1080 1024"><path d="M869.660444 165.660444a207.075556 207.075556 0 0 1 207.075556 207.075556v414.094222a207.075556 207.075556 0 0 1-207.075556 207.075556H207.075556A207.075556 207.075556 0 0 1 0 786.773333V372.622222a207.075556 207.075556 0 0 1 207.075556-207.075555h662.584888z m0 82.830223H207.075556A124.245333 124.245333 0 0 0 83.057778 363.861333l-0.284445 8.817778v414.151111c0 68.608 55.637333 124.245333 124.245334 124.245334h662.584889a124.245333 124.245333 0 0 0 124.245333-124.245334V372.622222a124.245333 124.245333 0 0 0-124.245333-124.188444zM410.908444 398.222222v368.526222H341.333333V398.222222h69.575111z m87.04 0h119.523556C724.764444 398.222222 796.444444 428.999111 796.444444 582.542222c0 137.671111-67.128889 181.418667-168.675555 184.092445l-10.24 0.113777H497.948444V398.222222z m116.337778 58.936889h-46.705778v249.628445h46.705778c71.168 0 110.478222-27.136 110.478222-124.302223 0-98.531556-38.286222-123.448889-102.627555-125.212444l-7.850667-0.113778zM745.415111 0a41.415111 41.415111 0 0 1 0 82.830222h-414.151111a41.415111 41.415111 0 0 1-40.96-35.84L289.848889 41.472c0-22.869333 18.545778-41.415111 41.415111-41.415111h414.094222z"  ></path></symbol><symbol id="icon-shouqi11" viewBox="0 0 1024 1024"><path d="M994.517663 534.821969a40.228456 40.228456 0 0 0 0-54.710701L528.452709 13.753744A41.398739 41.398739 0 0 0 526.697286 11.705749L520.992159 7.756046A8.045691 8.045691 0 0 0 519.968162 6.732049l6.729124 4.9737A44.324445 44.324445 0 0 0 505.339632 0.880637L497.586512 0.002926a41.252454 41.252454 0 0 0-10.239971 1.170282L497.732797 0.002926a41.106168 41.106168 0 0 0-27.794206 10.825112L469.060879 11.705749 11.773043 469.578727a40.374742 40.374742 0 0 0 57.343836 57.197551L497.732797 98.014074l439.587315 439.44103a40.959883 40.959883 0 0 0 57.197551-2.633135z m-506.29341-86.893466l9.362259-1.023997a41.106168 41.106168 0 0 0-27.794207 10.825112l-0.877711 0.877712L11.773043 916.334022a40.374742 40.374742 0 0 0 57.343836 57.197551l428.615918-428.615918 439.587315 439.44103a40.959883 40.959883 0 0 0 57.197551-2.633136 40.228456 40.228456 0 0 0 0-54.7107L528.452709 460.509039a41.398739 41.398739 0 0 0-1.755423-1.901709l-4.095989-2.779421-2.340564-2.194279a36.571324 36.571324 0 0 0-1.023998-0.731427l7.314265 5.851412a39.204459 39.204459 0 0 0-21.065082-11.117683l-7.899406-0.731426-9.362259 1.023997z" fill="#333333" ></path></symbol><symbol id="icon-zhankai1" viewBox="0 0 1024 1024"><path d="M994.715063 459.922286a40.228571 40.228571 0 0 1 0 54.710857L528.648777 980.992a41.398857 41.398857 0 0 1-1.755428 2.048l-5.705143 3.949714a8.045714 8.045714 0 0 1-1.024 1.024l6.729143-4.973714a44.324571 44.324571 0 0 1-21.211429 10.825143l-7.899429 0.877714a41.252571 41.252571 0 0 1-10.24-1.170286l10.24 1.170286a41.106286 41.106286 0 0 1-27.794285-10.825143l-0.877715-0.877714L11.967634 525.165714A40.374857 40.374857 0 0 1 69.311634 468.114286l428.617143 428.617143 439.588572-439.442286a40.96 40.96 0 0 1 57.197714 2.633143z m-506.294857 86.893714l9.362285 1.024a41.106286 41.106286 0 0 1-27.794285-10.825143l-0.877715-0.877714L11.967634 78.409143A40.374857 40.374857 0 0 1 69.311634 21.211429l428.617143 428.617142L937.517349 10.386286a40.96 40.96 0 0 1 57.197714 2.633143 40.228571 40.228571 0 0 1 0 54.710857L528.648777 534.235429a41.398857 41.398857 0 0 1-1.755428 1.901714l-4.096 2.779428-2.340572 2.194286a36.571429 36.571429 0 0 1-1.024 0.731429l7.314286-5.851429a39.204571 39.204571 0 0 1-21.065143 11.117714l-7.899429 0.731429-9.362285-1.024z" fill="#333333" ></path></symbol><symbol id="icon-yicainabiaoqian" viewBox="0 0 2560 1024"><path d="M0 0h2548.16l-256 500.48 256 523.52H0z"  ></path></symbol><symbol id="icon-yicaina" viewBox="0 0 2560 1024"><path d="M0 0h2548.16l-256 500.48 256 523.52H0z" fill="#E6E9FF" ></path><path d="M708.48 813.44c26.24-1.28 46.72-8.96 62.08-23.04 13.44-14.72 24.32-62.72 32-143.36l-59.52-19.2c-3.84 67.2-10.24 105.6-20.48 115.2-8.96 7.68-19.84 11.52-31.36 11.52H371.84c-24.32 0-36.48-12.16-36.48-36.48V542.08h396.8v-268.8H247.68v58.24h422.4v152.32H335.36V396.16h-61.44v332.8c0 56.32 26.88 84.48 81.28 84.48h353.28z m203.52-480c203.52 0 367.36-12.8 490.24-37.76l-29.44-51.2c-129.92 21.76-289.92 32.64-479.36 32.64l18.56 56.32z m388.48 164.48c37.12-39.68 69.76-87.04 97.28-142.08l-55.04-26.88c-25.6 51.84-56.32 96.64-90.88 134.4l48.64 34.56z m-152.96-30.08l58.88-14.72c-15.36-42.24-32.64-79.36-51.84-112.64l-56.32 18.56c19.84 34.56 36.48 71.04 49.28 108.8z m-161.92 24.96l55.68-24.96c-17.28-39.68-37.76-77.44-60.8-112l-58.24 19.2c23.04 33.92 44.16 72.96 63.36 117.76z m196.48 337.92V595.2h1.92c42.24 78.08 114.56 148.48 216.96 211.84l43.52-54.4c-97.28-46.08-167.04-98.56-210.56-157.44h176.64v-58.88h-228.48v-55.04h-60.16v55.04h-227.84v58.88h176c-44.8 63.36-114.56 115.84-208.64 158.08l34.56 56.96c103.68-56.32 179.2-128 225.92-215.04v235.52h60.16z m604.16 4.48V400.64h81.92c-1.92 22.4-4.48 43.52-7.04 63.36-12.16 67.84-36.48 125.44-72.96 172.16l39.04 46.72c33.92-39.04 58.88-85.76 75.52-140.16 21.76 48 39.68 92.8 54.4 135.04l48-33.92c-20.48-50.56-49.92-109.44-87.04-176 3.2-20.48 5.76-42.88 8.32-67.2h82.56v351.36c0 16.64-7.68 25.6-21.76 25.6l-52.48-3.2 14.72 56.96h56.96c39.68 0 59.52-22.4 59.52-66.56v-422.4h-135.68c1.28-31.36 2.56-64.64 2.56-99.84h-58.88c0 35.2-0.64 68.48-1.92 99.84h-142.72v492.8h56.96z m-266.88-151.68c57.6-8.32 119.04-24.96 183.68-50.56v-51.84c-38.4 14.08-75.52 25.6-112.64 34.56 34.56-46.72 78.08-121.6 129.92-225.28l-55.04-20.48c-12.8 25.6-24.32 50.56-35.2 73.6-20.48 3.2-40.96 5.76-62.08 8.32 28.8-47.36 57.6-109.44 85.76-186.24l-56.96-21.76c-20.48 69.12-44.8 132.48-72.32 189.44-7.68 10.88-16.64 18.56-25.6 22.4l14.72 54.4c30.72-4.48 60.8-8.96 89.6-14.08-29.44 55.04-53.76 94.08-72.96 116.48-7.68 7.68-16.64 13.44-27.52 17.92l16.64 53.12z m-10.24 126.72c74.24-14.72 140.16-33.92 199.04-56.96v-56.96c-58.88 23.04-128 41.6-207.36 55.68l8.32 58.24z" fill="#6D79D5" ></path></symbol><symbol id="icon-tanhao" viewBox="0 0 1024 1024"><path d="M512.251611 0l17.554286 0.292571A512 512 0 0 1 512.251611 1024l-17.554285-0.292571A512 512 0 0 1 512.251611 0z m0 80.822857a431.177143 431.177143 0 0 0 0 862.354286l16.237715-0.292572A431.177143 431.177143 0 0 0 512.251611 80.822857z m10.678858 615.862857l8.923428 0.438857c14.628571 1.462857 27.209143 6.802286 37.449143 17.042286 12.361143 11.556571 19.017143 27.794286 18.432 44.617143l-0.365714 8.557714a61.44 61.44 0 0 1-18.066286 37.010286l-8.192 6.217143a68.900571 68.900571 0 0 1-38.180571 11.337143 60.854857 60.854857 0 0 1-44.690286-18.432l-5.997714-6.290286a58.221714 58.221714 0 0 1-13.312-38.326857 55.881143 55.881143 0 0 1 19.309714-44.617143l6.217143-5.485714a59.977143 59.977143 0 0 1 38.473143-12.068572zM578.080183 196.608l-20.187429 448.365714H488.845897l-20.187428-448.365714H578.080183z"  ></path></symbol><symbol id="icon-biaozhudian" viewBox="0 0 1024 1024"><path d="M206.289455 339.316364L490.589091 80.896a47.383273 47.383273 0 0 1 63.767273 0l284.299636 258.420364a47.476364 47.476364 0 0 1 15.453091 35.002181v577.722182a47.383273 47.383273 0 0 1-47.383273 47.476364H238.219636a47.383273 47.383273 0 0 1-47.476363-47.476364L190.836364 374.318545c0-13.312 5.585455-26.065455 15.453091-35.002181z"  ></path></symbol><symbol id="icon-huanyuan" viewBox="0 0 1170 1024"><path d="M650.020571 514.852571l190.683429 159.963429-45.275429 53.979429L580.022857 548.059429h-0.438857v-281.6h70.436571v248.393142z m-525.165714-37.229714a492.836571 492.836571 0 1 1 188.928 423.277714l62.902857-82.724571A387.218286 387.218286 0 1 0 229.229714 477.622857h107.008L176.420571 688.859429 16.384 477.622857h108.470857z"  ></path></symbol><symbol id="icon-tianjiapizhu" viewBox="0 0 1102 1024"><path d="M731.529846 11.657846c27.569231 0 49.860923 24.654769 49.860923 55.059692 0 27.490462-18.353231 50.727385-43.086769 54.429539l-6.774154 0.551385h-615.187692V745.156923h152.418461c24.891077 0 46.001231 20.322462 49.388308 47.576615l0.472615 7.483077v57.737847l194.481231-106.968616a46.631385 46.631385 0 0 1 14.651077-5.12l7.561846-0.708923h412.356923V362.811077c0-27.569231 18.432-50.806154 43.08677-54.508308l6.774153-0.551384c24.969846 0 46.08 20.401231 49.467077 47.655384l0.472616 7.404308v400.699077c0 47.025231-32.295385 86.409846-74.673231 91.293538l-8.507077 0.393846H547.052308l-256 140.918154c-24.654769 13.548308-54.665846 2.520615-66.953846-24.654769a59.234462 59.234462 0 0 1-4.726154-17.092923l-0.551385-7.483077v-91.687385H99.721846c-42.535385 0-78.296615-35.446154-82.707692-82.313846l-0.393846-9.373538v-660.086154c0-47.497846 32.689231-86.646154 74.594461-91.372308l8.507077-0.393846h631.808z m-199.522461 451.347692c27.569231 0 49.939692 24.733538 49.860923 55.138462 0 27.411692-18.353231 50.727385-43.008 54.429538l-6.852923 0.551385h-300.11077c-27.490462 0.315077-50.018462-24.103385-50.333538-54.508308-0.236308-27.884308 18.510769-51.593846 43.638154-55.138461l6.774154-0.393846h300.110769zM1032.664615 27.569231c17.565538 19.219692 19.692308 49.624615 5.12 71.68l-4.726153 6.144-332.563693 370.609231a46.631385 46.631385 0 0 1-70.577231 0 59.313231 59.313231 0 0 1-5.12-71.207385l4.804924-6.222769L962.087385 27.963077A46.631385 46.631385 0 0 1 1032.664615 27.569231h0.07877zM440.32 231.739077c27.490462 0 49.782154 24.654769 49.782154 54.980923 0 27.569231-18.353231 50.806154-43.086769 54.508308l-6.774154 0.551384H231.975385c-27.569231 0-49.860923-24.654769-49.860923-55.059692 0-27.490462 18.353231-50.727385 43.086769-54.508308l6.774154-0.472615h208.265846z"  ></path></symbol><symbol id="icon-xiangji1" viewBox="0 0 1142 1024"><path d="M742.4 0l102.793846 113.782154h182.744616c62.818462 0 114.215385 51.2 114.215384 113.782154v682.653538C1142.153846 972.8 1090.756923 1024 1027.938462 1024H114.215385C51.396923 1024 0 972.8 0 910.217846V227.564308c0-62.582154 51.396923-113.782154 114.215385-113.782154h182.744615L399.753846 0h342.646154zM571.076923 284.435692c-159.901538 0-285.538462 125.164308-285.538461 284.455385S411.175385 853.326769 571.076923 853.326769c159.901538 0 285.538462-125.144615 285.538462-284.435692S730.978462 284.435692 571.076923 284.435692z m0 102.4c119.926154 0 182.744615 62.582154 182.744615 182.055385 0 119.473231-62.818462 182.035692-182.744615 182.035692s-182.744615-62.562462-182.744615-182.035692 62.818462-182.055385 182.744615-182.055385z"  ></path></symbol><symbol id="icon-tihuan" viewBox="0 0 1024 1024"><path d="M364.105143 14.189714H113.810286C58.806857 14.189714 14.189714 58.806857 14.189714 113.810286v250.294857c0 54.930286 44.617143 99.474286 99.620572 99.474286h250.294857c55.003429 0 99.474286-44.470857 99.474286-99.474286V113.810286c0-55.003429-44.470857-99.620571-99.474286-99.620572zM113.810286 99.547429h250.294857c7.826286 0 14.189714 6.363429 14.189714 14.262857v250.294857a14.189714 14.189714 0 0 1-14.189714 14.189714H113.810286a14.189714 14.189714 0 0 1-14.262857-14.189714V113.810286c0-7.899429 6.363429-14.262857 14.262857-14.262857z m796.379428 460.8H659.894857c-54.930286 0-99.474286 44.617143-99.474286 99.547428v250.294857c0 55.003429 44.544 99.620571 99.474286 99.620572h250.294857c55.003429 0 99.620571-44.617143 99.620572-99.620572V659.894857c0-54.930286-44.617143-99.474286-99.620572-99.474286zM659.894857 645.705143h250.294857c7.899429 0 14.262857 6.363429 14.262857 14.189714v250.294857a14.189714 14.189714 0 0 1-14.262857 14.262857H659.894857a14.189714 14.189714 0 0 1-14.189714-14.262857V659.894857c0-7.826286 6.363429-14.189714 14.189714-14.189714zM602.989714 14.189714a378.148571 378.148571 0 0 1 378.148572 378.148572l-0.292572 15.433143-1.024 16.676571a42.642286 42.642286 0 0 1-85.211428-1.170286l0.146285-5.778285v-1.243429a292.790857 292.790857 0 0 0-291.766857-316.708571 42.642286 42.642286 0 0 1 0-85.357715zM422.546286 1009.371429A390.729143 390.729143 0 0 1 14.189714 619.081143a42.642286 42.642286 0 0 1 85.357715 0l0.292571 13.677714a305.371429 305.371429 0 0 0 306.322286 291.693714l12.507428-0.365714a42.642286 42.642286 0 1 1 10.020572 84.626286l-6.144 0.731428z"  ></path></symbol><symbol id="icon-ziyuan" viewBox="0 0 1024 1024"><path d="M512 0A512 512 0 1 0 1024 512 512.589353 512.589353 0 0 0 512 0z m223.953957 535.574101l-294.676259 221.007194a29.467626 29.467626 0 0 1-17.680576 5.893525 29.467626 29.467626 0 0 1-29.467626-29.467626v-442.014388a29.467626 29.467626 0 0 1 47.148202-23.574101l294.676259 221.007194a29.467626 29.467626 0 0 1 0 47.148202z" fill="#333333" ></path></symbol><symbol id="icon-zanting" viewBox="0 0 1024 1024"><path d="M512 0c282.760533 0 512 229.239467 512 512 0 282.760533-229.239467 512-512 512-282.760533 0-512-229.239467-512-512C0 229.239467 229.239467 0 512 0z m-102.4 341.333333a34.133333 34.133333 0 0 0-34.133333 34.133334v303.581866l0.238933 3.959467A34.133333 34.133333 0 0 0 443.733333 679.048533V375.466667l-0.238933-3.9936A34.133333 34.133333 0 0 0 409.6 341.333333z m204.8 0a34.133333 34.133333 0 0 0-34.133333 34.133334v303.581866l0.238933 3.959467A34.133333 34.133333 0 0 0 648.533333 679.048533V375.466667l-0.238933-3.9936A34.133333 34.133333 0 0 0 614.4 341.333333z"  ></path></symbol><symbol id="icon-tushi-chengse" viewBox="0 0 1024 1024"><path d="M102.11328 39.64928h243.3024c54.0672 0 81.14176 27.0336 81.14176 81.1008v243.3024c0 54.10816-27.0336 81.14176-81.1008 81.14176h-243.3024c-54.0672 0-81.14176-27.0336-81.14176-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z m0 567.74656h243.3024c54.0672 0 81.14176 27.0336 81.14176 81.1008v243.34336c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.14176-27.0336-81.14176-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008zM669.9008 39.7312h243.3024c54.0672 0 81.1008 27.0336 81.1008 81.1008v243.3024c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.1008-27.0336-81.1008-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z m0 567.7056h243.3024c54.0672 0 81.1008 27.0336 81.1008 81.1008v243.34336c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.1008-27.0336-81.1008-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z" fill="#EA461D" ></path></symbol><symbol id="icon-tushi-huise" viewBox="0 0 1024 1024"><path d="M102.11328 39.64928h243.3024c54.0672 0 81.14176 27.0336 81.14176 81.1008v243.3024c0 54.10816-27.0336 81.14176-81.1008 81.14176h-243.3024c-54.0672 0-81.14176-27.0336-81.14176-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z m0 567.74656h243.3024c54.0672 0 81.14176 27.0336 81.14176 81.1008v243.34336c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.14176-27.0336-81.14176-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008zM669.9008 39.7312h243.3024c54.0672 0 81.1008 27.0336 81.1008 81.1008v243.3024c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.1008-27.0336-81.1008-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z m0 567.7056h243.3024c54.0672 0 81.1008 27.0336 81.1008 81.1008v243.34336c0 54.0672-27.0336 81.1008-81.1008 81.1008h-243.3024c-54.0672 0-81.1008-27.0336-81.1008-81.1008v-243.3024c0-54.0672 27.0336-81.1008 81.1008-81.1008z" fill="#999999" ></path></symbol><symbol id="icon-liebiao-chengse" viewBox="0 0 1303 1024"><path d="M152.482909 801.28c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.907636-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.477091-49.384728-49.338182v-98.816c0-32.907636 16.430545-49.338182 49.338182-49.338182z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.907636-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.477091-49.384727-49.338182v-98.816c0-32.907636 16.430545-49.338182 49.338182-49.338182zM152.482909 406.202182c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.430545-49.384728-49.338182V455.540364c0-32.907636 16.430545-49.338182 49.338182-49.338182z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.430545-49.384727-49.338182V455.540364c0-32.907636 16.430545-49.338182 49.338182-49.338182zM152.482909 11.170909c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.430545-49.384728-49.338182V60.509091C4.328727 27.601455 20.759273 11.170909 53.666909 11.170909z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.430545-49.384727-49.338182V60.509091c0-32.907636 16.430545-49.338182 49.338182-49.338182z" fill="#E55231" ></path></symbol><symbol id="icon-liebiao-huise" viewBox="0 0 1303 1024"><path d="M152.482909 801.28c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.907636-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.477091-49.384728-49.338182v-98.816c0-32.907636 16.430545-49.338182 49.338182-49.338182h98.816z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.907636-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.477091-49.384727-49.338182v-98.816c0-32.907636 16.430545-49.338182 49.338182-49.338182h888.925091zM152.482909 406.202182c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.430545-49.384728-49.338182V455.540364c0-32.907636 16.430545-49.338182 49.338182-49.338182h98.816z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.430545-49.384727-49.338182V455.540364c0-32.907636 16.430545-49.338182 49.338182-49.338182h888.925091zM152.482909 11.170909c32.907636 0 49.338182 16.477091 49.338182 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H53.713455c-32.954182 0-49.384727-16.430545-49.384728-49.338182V60.509091C4.328727 27.601455 20.759273 11.170909 53.666909 11.170909h98.816z m1086.417455 0c32.954182 0 49.384727 16.477091 49.384727 49.384727v98.769455c0 32.954182-16.430545 49.384727-49.338182 49.384727H350.021818c-32.954182 0-49.384727-16.430545-49.384727-49.338182V60.509091c0-32.907636 16.430545-49.338182 49.338182-49.338182h888.925091z" fill="#999999" ></path></symbol><symbol id="icon-beikejiaoanbeifen" viewBox="0 0 1024 1024"><path d="M394.496 272.5888V10.752h494.0288c41.984 0 75.9808 33.4848 75.9808 74.752v823.2448c0 41.2672-34.048 74.752-75.9808 74.752H128.512a75.4176 75.4176 0 0 1-75.9808-74.752V347.3408H318.464c41.984 0 75.9808-33.4336 75.9808-74.752z m149.6576 81.5104c-19.712 0-35.6352 12.8-35.6352 28.5696 0 15.8208 15.9232 28.5696 35.6352 28.5696h213.76c19.6608 0 35.584-12.8 35.584-28.5696 0-15.8208-15.9232-28.5696-35.584-28.5696h-213.76z m-226.9696 171.52c-20.224 0-36.6592 12.8-36.6592 28.6208 0 15.8208 16.384 28.5696 36.6592 28.5696h439.7056c20.224 0 36.608-12.8 36.608-28.5696 0-15.8208-16.384-28.5696-36.608-28.5696H317.184z m0 228.864c-20.224 0-36.6592 12.8512-36.6592 28.6208 0 15.7696 16.384 28.6208 36.6592 28.6208h439.7056c20.224 0 36.608-12.8 36.608-28.5696 0-15.8208-16.384-28.5696-36.608-28.5696H317.184v-0.0512zM337.5616 10.752v245.248a40.7552 40.7552 0 0 1-40.6016 40.8576H52.5312L337.5616 10.752z" fill="#C1C1C1" ></path></symbol><symbol id="icon-beikejiaoan" viewBox="0 0 1024 1024"><path d="M394.496 272.5888V10.752h494.0288c41.984 0 75.9808 33.4848 75.9808 74.752v823.2448c0 41.2672-34.048 74.752-75.9808 74.752H128.512a75.4176 75.4176 0 0 1-75.9808-74.752V347.3408H318.464c41.984 0 75.9808-33.4336 75.9808-74.752z m149.6576 81.5104c-19.712 0-35.6352 12.8-35.6352 28.5696 0 15.8208 15.9232 28.5696 35.6352 28.5696h213.76c19.6608 0 35.584-12.8 35.584-28.5696 0-15.8208-15.9232-28.5696-35.584-28.5696h-213.76z m-226.9696 171.52c-20.224 0-36.6592 12.8-36.6592 28.6208 0 15.8208 16.384 28.5696 36.6592 28.5696h439.7056c20.224 0 36.608-12.8 36.608-28.5696 0-15.8208-16.384-28.5696-36.608-28.5696H317.184z m0 228.864c-20.224 0-36.6592 12.8512-36.6592 28.6208 0 15.7696 16.384 28.6208 36.6592 28.6208h439.7056c20.224 0 36.608-12.8 36.608-28.5696 0-15.8208-16.384-28.5696-36.608-28.5696H317.184v-0.0512zM337.5616 10.752v245.248a40.7552 40.7552 0 0 1-40.6016 40.8576H52.5312L337.5616 10.752z" fill="#E55231" ></path></symbol><symbol id="icon-zhuanjiazuguanli" viewBox="0 0 1243 1024"><path d="M588.967497 1024c-270.628571 0-407.625143-70.070857-407.625143-208.237714 0-104.009143 150.381714-164.717714 279.405715-185.197715l-2.121143-12.726857c-82.797714-61.44-123.465143-176.274286-123.465143-348.891428C335.161783 100.498286 428.492069 0 585.017783 0h8.045714c156.598857 0 249.929143 100.498286 249.929143 268.946286 0 63.341714 0 255.853714-125.513143 355.474285l1.974857 8.484572c126.829714 18.285714 277.211429 78.994286 277.211429 183.003428C996.59264 953.929143 859.449783 1024 588.967497 1024zM584.725211 78.262857c-80.457143 0-176.274286 32.548571-176.274285 186.88 0 151.844571 34.889143 249.197714 106.788571 298.203429 11.337143 7.826286 18.358857 21.942857 18.358857 36.790857v70.656c0.438857 21.650286-14.336 40.155429-34.377143 42.861714-150.528 16.896-246.491429 79.725714-246.491428 106.788572 0 103.424 182.857143 125.074286 336.237714 125.074285 153.234286 0 336.018286-21.796571 336.018286-125.074285 0-27.282286-95.890286-89.892571-246.345143-106.788572-20.187429-2.852571-35.328-22.089143-34.377143-43.885714l1.389714-70.436572a44.105143 44.105143 0 0 1 18.285715-35.84c71.899429-49.152 105.472-143.798857 105.472-298.203428 0-154.331429-95.890286-186.806857-176.420572-186.806857h-8.265143V78.262857z m558.518858 657.408c-19.529143-0.658286-34.816-18.066286-34.377143-38.912 0-15.36-68.900571-73.362286-161.572572-84.406857a37.668571 37.668571 0 0 1-30.793143-38.838857v-64.365714c0-13.312 5.924571-25.526857 15.798858-32.694858 67.657143-49.078857 74.971429-159.597714 74.971428-204.946285 0-100.937143-59.830857-122.148571-109.860571-122.148572-19.529143-0.512-34.889143-17.993143-34.377143-38.765714a38.692571 38.692571 0 0 1 9.581714-26.843429 32.987429 32.987429 0 0 1 24.649143-11.776c110.445714 0 178.834286 76.434286 178.834286 199.68 0 53.833143-9.069714 186.806857-93.476572 259.876572l2.340572 10.971428c73.289143 14.336 192.731429 71.606857 192.731428 154.624a38.765714 38.765714 0 0 1-9.581714 26.916572 33.938286 33.938286 0 0 1-24.649143 11.776h-0.219428v-0.146286z m-1108.699429 0a34.230857 34.230857 0 0 1-24.795429-11.702857A39.716571 39.716571 0 0 1 0.021211 696.685714c0-82.797714 119.222857-139.922286 194.267429-156.525714l-1.901714-14.774857c-81.846857-67.072-90.697143-199.972571-90.697143-253.805714 0-123.099429 68.388571-199.68 178.688-199.68 9.435429 0.292571 18.358857 4.461714 24.868571 11.702857a39.862857 39.862857 0 0 1 9.581715 27.282285c0.585143 20.48-14.848 37.888-34.230858 38.4-50.322286 0-110.08 21.211429-110.08 122.148572 0 45.348571 7.314286 155.867429 74.898286 204.946286 10.020571 7.314286 16.018286 19.675429 15.872 32.621714v64.658286a37.302857 37.302857 0 0 1-30.573714 38.619428C137.822354 623.396571 68.921783 681.691429 68.921783 696.978286c0.512 20.699429-14.774857 38.180571-34.230857 38.838857H34.54464v-0.146286z"  ></path></symbol><symbol id="icon-daochu" viewBox="0 0 1088 1024"><path d="M946.176 557.44c21.44 0 38.848 17.344 38.848 38.848v290.304A137.6 137.6 0 0 1 847.68 1024H137.408A137.6 137.6 0 0 1 0 886.592V176.384A137.6 137.6 0 0 1 137.408 38.976h393.984a38.912 38.912 0 1 1 0 77.76H137.408a59.712 59.712 0 0 0-59.648 59.648v710.272c0 32.832 26.752 59.584 59.648 59.584h710.272a59.712 59.712 0 0 0 59.584-59.584V596.288c0-21.44 17.408-38.848 38.912-38.848z m90.112-327.424a38.656 38.656 0 0 1 0 58.624l-218.176 218.112a38.912 38.912 0 0 1-55.04-55.04l150.144-150.144c-337.728 22.4-472.512 168.96-472.512 502.08a38.912 38.912 0 1 1-77.76 0c0-380.16 167.68-557.568 556.48-580.544l-156.288-156.224a38.912 38.912 0 1 1 54.976-55.04l218.176 218.176z"  ></path></symbol><symbol id="icon-caidan" viewBox="0 0 1097 1024"><path d="M993.206857 456.557714l-159.232-311.515428a121.709714 121.709714 0 0 0-108.397714-66.267429H363.008c-45.348571 0-86.966857 25.234286-107.885714 65.389714L92.598857 455.68a121.709714 121.709714 0 0 0 0 112.64l162.523429 311.515429c20.992 40.228571 62.610286 65.389714 107.885714 65.389714H725.577143c45.714286 0 87.552-25.6 108.397714-66.267429l159.232-311.588571a121.709714 121.709714 0 0 0 0-110.738286v-0.073143z m-89.088 458.24A200.411429 200.411429 0 0 1 725.577143 1024H363.008a200.411429 200.411429 0 0 1-177.737143-107.739429L22.820571 604.745143a200.411429 200.411429 0 0 1 0-185.490286l162.596572-311.588571A200.411429 200.411429 0 0 1 363.081143 0H725.577143c75.337143 0 144.237714 42.203429 178.468571 109.202286l159.305143 311.588571c29.257143 57.270857 29.257143 125.147429 0 182.418286l-159.232 311.588571z m-361.472-174.372571a228.425143 228.425143 0 0 1 0-456.850286 228.425143 228.425143 0 0 1 0 456.850286z m0-78.774857a149.650286 149.650286 0 0 0 0-299.300572 149.650286 149.650286 0 0 0 0 299.300572z"  ></path></symbol><symbol id="icon-fanhui" viewBox="0 0 1024 1024"><path d="M512 0a512 512 0 1 0 512.064 512 512 512 0 0 0-512-512z m0 972.672c-253.824 0-460.416-207.36-460.416-461.056C51.584 257.92 258.176 51.584 512 51.584s460.48 206.336 460.48 460.032c0 253.632-206.592 461.056-460.48 461.056z m230.528-486.144H324.544l152.192-163.2a25.6 25.6 0 0 0-36.224-36.16L231.808 512.704l205.504 227.136a25.6 25.6 0 1 0 36.224-36.224L322.88 537.728h419.648a25.6 25.6 0 1 0 0-51.2z"  ></path></symbol><symbol id="icon-baocun1" viewBox="0 0 1024 1024"><path d="M512 93.013333a418.986667 418.986667 0 0 0 0 837.973334 418.986667 418.986667 0 0 0 0-837.973334zM512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m200.874667 279.296l78.421333 55.808-323.413333 409.6-235.178667-167.509333 58.88-74.496L448.256 614.4l264.533333-335.104z"  ></path></symbol><symbol id="icon-quxiao1" viewBox="0 0 1024 1024"><path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM512 73.130667C283.050667 73.130667 73.130667 283.050667 73.130667 512S283.050667 950.869333 512 950.869333 950.869333 740.949333 950.869333 512 740.949333 73.130667 512 73.130667z m229.461333 672a48.64 48.64 0 0 1-68.864 0H672.426667L517.376 589.994667 362.154667 745.130667a48.725333 48.725333 0 0 1-68.949334-68.949334l155.136-155.221333-155.136-155.136a48.725333 48.725333 0 0 1 68.949334-68.949333l155.221333 155.136L672.426667 296.96a48.725333 48.725333 0 1 1 68.949333 68.949333L586.24 520.96l155.136 155.221333a48.725333 48.725333 0 0 1 0 68.949334z"  ></path></symbol><symbol id="icon-santiaoxian" viewBox="0 0 1024 1024"><path d="M127.604 187.583h766.759c17.692 0 29.49 11.797 29.49 29.491s-11.798 29.49-29.49 29.49H127.604c-17.695 0-29.492-11.796-29.492-29.49s11.797-29.491 29.492-29.491z m0 294.907h766.759c17.692 0 29.49 11.798 29.49 29.491 0 17.695-11.798 29.491-29.49 29.491H127.604c-17.695 0-29.492-11.796-29.492-29.491 0-17.693 11.797-29.491 29.492-29.491z m0 294.907h766.759c17.692 0 29.49 11.799 29.49 29.491 0 17.693-11.798 29.491-29.49 29.491H127.604c-17.695 0-29.492-11.798-29.492-29.491 0-17.692 11.797-29.491 29.492-29.491z"  ></path></symbol><symbol id="icon-tishi11" viewBox="0 0 1024 1024"><path d="M512 1024A512 512 0 1 0 512 0a512 512 0 0 0 0 1024z m310.357333-822.357333Q950.869333 330.24 950.869333 512T822.357333 822.357333Q693.76 950.869333 512 950.869333T201.642667 822.357333Q73.130667 693.76 73.130667 512t128.512-310.357333Q330.24 73.130667 512 73.130667t310.357333 128.512zM438.869333 585.130667V219.392h146.261334v365.738667H438.869333z m0 219.477333V658.261333h146.261334V804.693333H438.869333z"  ></path></symbol><symbol id="icon-anlishenhe" viewBox="0 0 1024 1024"><path d="M0 512c0-282.965333 229.034667-512 512-512s512 229.034667 512 512-229.034667 512-512 512-512-229.034667-512-512z m61.383111 0c0 248.490667 202.126222 450.616889 450.616889 450.616889S962.616889 760.490667 962.616889 512 760.490667 61.383111 512 61.383111 61.383111 263.509333 61.383111 512z m65.991111 0A385.137778 385.137778 0 0 1 512 127.374222a385.080889 385.080889 0 0 1 384.625778 383.658667V512A385.137778 385.137778 0 0 1 512 896.625778 385.137778 385.137778 0 0 1 127.374222 512z m416.142222 290.531556v31.175111a323.811556 323.811556 0 0 0 290.360889-291.669334h-28.444444c-40.561778 0-40.504889-61.44 0-61.44h28.330667a323.811556 323.811556 0 0 0-290.304-290.304v29.809778c0 40.675556-61.326222 40.561778-61.326223 0v-29.980444a323.811556 323.811556 0 0 0-291.84 290.531555h29.866667c40.618667 0 40.561778 61.383111 0 61.383111h-30.037333a323.811556 323.811556 0 0 0 292.010666 291.84v-31.345777c0-40.618667 61.383111-40.561778 61.383111 0z m147.740445-379.392l-94.947556-34.304L536.348444 310.613333a30.72 30.72 0 0 0-48.696888 0L427.690667 388.835556l-94.947556 34.304a30.72 30.72 0 0 0-14.392889 46.876444L375.466667 549.262222l1.479111 101.660445a30.72 30.72 0 0 0 40.277333 28.672L512 648.419556l94.72 31.175111a30.72 30.72 0 0 0 40.277333-28.672l1.479111-101.660445 57.173334-79.246222a30.72 30.72 0 0 0-14.392889-46.876444z m-104.049778 115.484444l-0.967111 69.575111-64.625778-21.276444a30.435556 30.435556 0 0 0-19.228444 0l-64.625778 21.276444-0.967111-69.518222a30.833778 30.833778 0 0 0-5.859556-17.521778L391.964444 467.057778l65.080889-23.552a30.72 30.72 0 0 0 13.880889-10.126222L512 379.790222l41.130667 53.475556a30.72 30.72 0 0 0 13.880889 10.24l65.080888 23.495111-39.082666 54.158222a30.890667 30.890667 0 0 0-5.802667 17.521778z"  ></path></symbol><symbol id="icon-tongguo" viewBox="0 0 1024 1024"><path d="M511.99939 0a511.99939 511.99939 0 0 0-511.99939 511.99939 511.99939 511.99939 0 0 0 511.99939 511.999389 511.99939 511.99939 0 0 0 511.999389-511.999389 511.99939 511.99939 0 0 0-511.999389-511.99939z m0 71.999914a437.439479 437.439479 0 0 1 311.103629 128.831847 437.759478 437.759478 0 0 1 94.271887 139.839833c23.039973 54.335935 34.623959 111.935867 34.623959 171.327796a437.439479 437.439479 0 0 1-128.767846 311.103629 437.759478 437.759478 0 0 1-139.903834 94.271887c-54.335935 23.039973-111.935867 34.623959-171.327795 34.623959a437.439479 437.439479 0 0 1-311.03963-128.767846 437.695478 437.695478 0 0 1-94.335887-139.903834A436.60748 436.60748 0 0 1 71.999914 511.99939a437.439479 437.439479 0 0 1 128.831847-311.03963 437.759478 437.759478 0 0 1 139.839833-94.335887A436.60748 436.60748 0 0 1 511.99939 71.999914z m-161.599808 631.039248a77.311908 77.311908 0 0 0 109.69587 0l321.599616-321.535617a35.903957 35.903957 0 1 0-50.943939-50.943939L409.087512 652.159223a5.503993 5.503993 0 0 1-7.80799 0L253.439698 504.319399a35.903957 35.903957 0 1 0-50.879939 50.943939l147.839823 147.839824z"  ></path></symbol><symbol id="icon-shezhishenheliucheng" viewBox="0 0 1024 1024"><path d="M893.37728 638.912c-11.52 0.064-22.016 7.04-26.624 17.728l-0.192 0.448a29.056 29.056 0 0 0 5.76 32.064l2.368 2.368a127.04 127.04 0 0 1-89.728 216.832h-0.128a126.08 126.08 0 0 1-89.664-37.12l-2.496-2.496a29.056 29.056 0 0 0-32.512-5.504 29.248 29.248 0 0 0-17.728 26.752v7.04c0 70.016-56.96 126.976-126.912 126.976a127.104 127.104 0 0 1-126.976-126.912v-3.264a29.056 29.056 0 0 0-19.136-26.368 40.96 40.96 0 0 1-2.432-1.024 29.12 29.12 0 0 0-32.128 5.76l-2.368 2.368a127.104 127.104 0 0 1-179.392 0.192l-0.192-0.192a126.08 126.08 0 0 1-37.184-89.728c0-33.92 13.12-65.728 36.992-89.728l0.192-0.128 2.368-2.368a29.056 29.056 0 0 0 5.76-32.128l-0.192-0.384a29.248 29.248 0 0 0-26.752-17.728h-7.104A127.104 127.104 0 0 1 0.00128 515.392C0.00128 445.44 56.96128 388.48 126.97728 388.48h3.2a29.056 29.056 0 0 0 26.432-19.136 40.96 40.96 0 0 1 0.96-2.432 29.056 29.056 0 0 0-5.76-32.064l-2.304-2.368a126.08 126.08 0 0 1-37.248-89.728c0-33.92 13.184-65.792 37.12-89.792a126.208 126.208 0 0 1 89.856-37.312c33.92 0 65.792 13.184 89.792 37.12l2.432 2.496c8.576 8.32 21.12 10.56 32.128 5.76a41.536 41.536 0 0 1 8.512-2.752 29.184 29.184 0 0 0 12.992-24.256v-7.04C385.08928 56.96 442.04928 0 512.06528 0c70.016 0 126.976 56.96 126.976 126.912v3.84c0 11.52 7.04 22.016 17.728 26.624l0.384 0.192c10.88 4.8 23.552 2.56 32.128-5.76l2.368-2.368a126.08 126.08 0 0 1 89.728-37.184h0.064c33.92 0 65.728 13.184 89.728 37.12l0.192 0.192c23.872 23.936 37.12 55.744 37.12 89.6a126.08 126.08 0 0 1-37.312 89.984l-2.304 2.24a29.056 29.056 0 0 0-5.76 32.128 41.6 41.6 0 0 1 2.752 8.512 29.248 29.248 0 0 0 24.256 13.056h7.04c70.016 0 126.976 56.96 126.976 126.912 0 70.016-56.96 126.912-126.912 126.912h-3.84z m-79.808 108.544a111.36 111.36 0 0 1-22.784-123.648 111.936 111.936 0 0 1 102.4-67.584h4.032a44.288 44.288 0 0 0 0-88.448h-7.296A112 112 0 0 1 787.20128 400a41.536 41.536 0 0 1-3.008-11.008 111.36 111.36 0 0 1 25.6-115.52l0.32-0.32 2.56-2.56 0.128-0.128a43.904 43.904 0 0 0 12.8-31.168 43.904 43.904 0 0 0-12.928-31.232l-0.128-0.192a43.904 43.904 0 0 0-62.464 0.128l-2.56 2.56a111.424 111.424 0 0 1-123.648 22.784 111.872 111.872 0 0 1-67.648-102.336v-4.032a44.288 44.288 0 0 0-88.448 0v7.296a112 112 0 0 1-67.84 102.656 41.344 41.344 0 0 1-11.072 3.008 111.36 111.36 0 0 1-115.84-25.92l-2.56-2.56a43.904 43.904 0 0 0-62.592 0 43.968 43.968 0 0 0 0 62.528l2.56 2.56 0.384 0.384a111.36 111.36 0 0 1 22.912 122.24 111.36 111.36 0 0 1-102.016 72.128h-4.8a44.288 44.288 0 0 0 0 88.384h7.232A112 112 0 0 1 236.80128 627.264a111.36 111.36 0 0 1-22.528 123.328l-0.32 0.32-2.432 2.432-0.192 0.192a43.904 43.904 0 0 0-12.928 31.232c0 11.776 4.608 22.848 12.928 31.168l0.128 0.192c17.28 17.216 45.312 17.152 62.528-0.064l2.56-2.56a111.424 111.424 0 0 1 122.624-23.232 111.36 111.36 0 0 1 72.128 101.952v4.8a44.288 44.288 0 0 0 88.384 0v-7.232a112 112 0 0 1 67.648-102.528 111.424 111.424 0 0 1 123.328 22.464l0.32 0.32 2.56 2.56a43.968 43.968 0 0 0 31.36 12.992 44.288 44.288 0 0 0 31.296-75.52l-2.56-2.56z m-301.44-405.12A169.92 169.92 0 0 0 342.27328 512 169.92 169.92 0 0 0 512.00128 681.728 169.92 169.92 0 0 0 681.79328 512a169.92 169.92 0 0 0-169.728-169.728z"  ></path></symbol><symbol id="icon-quanbuanli" viewBox="0 0 1141 1024"><path d="M948.928262 929.407003a100.095893 100.095893 0 0 1-133.695857 88.575905l-337.535638-113.471878a10.047989 10.047989 0 0 0-6.399993 0l-337.471638 113.471878A99.775893 99.775893 0 0 1 0.00128 923.583009V150.591838C0.00128 67.391928 67.073208 0 149.825119 0h649.407304c54.655941 0 102.52789 29.439968 128.639862 73.407921h63.359932A150.207839 150.207839 0 0 1 1141.056056 223.99976v630.591323a100.159893 100.159893 0 0 1-133.759857 94.463899l-58.367937-19.647979z m0.128-780.735163V849.919088l83.64791 28.28797a24.831973 24.831973 0 0 0 33.279964-20.671978l0.192-2.943997V223.99976c0-40.127957-31.231966-72.895922-70.527924-75.19992l-4.479995-0.128h-42.111955zM149.825119 75.327919h649.407304l4.415995 0.128a75.135919 75.135919 0 0 1 70.463924 75.135919v75.26392H74.9452V150.591838l0.127999-4.479995A75.071919 75.071919 0 0 1 149.761119 75.391919z m-74.879919 225.855758h799.167142v622.399332l-0.128 2.943997a25.023973 25.023973 0 0 1-33.279964 20.671978l-362.943611-122.751869a10.047989 10.047989 0 0 0-6.399993 0L108.417164 947.198984l-2.815997 0.831999a24.959973 24.959973 0 0 1-30.719967-24.447974V301.183677z"  ></path></symbol><symbol id="icon-bohui" viewBox="0 0 1024 1024"><path d="M173.567877 126.976641A509.293351 509.293351 0 0 1 510.902493 0.000731a511.63392 511.63392 0 0 1 512.292205 511.707063A512.14592 512.14592 0 0 1 510.902493 1024 511.853349 511.853349 0 0 1 0.804571 554.276907h0.512v-1.097142a40.886828 40.886828 0 1 1 81.846799 0c0 1.609142-0.585142 2.706284-0.585143 4.315425 23.186269 216.283274 206.116424 385.243153 428.324266 385.243154a430.372264 430.372264 0 0 0 430.518549-430.445407 430.372264 430.372264 0 0 0-430.518549-430.51855A426.641981 426.641981 0 0 0 212.918706 202.898872l97.938215 13.385134a40.228543 40.228543 0 0 1 34.962261 45.787395 40.228543 40.228543 0 0 1-45.787396 34.962261L127.341624 272.823394c-0.585142 0-1.097142-0.512-1.609142-0.512-1.097142-0.585142-2.706284-0.585142-3.803426-1.097142-1.609142-0.585142-2.633141-0.585142-3.730283-1.097142-1.609142-0.512-2.706284-1.609142-4.388568-2.194284-1.023999-0.512-1.535999-1.023999-2.633141-1.535999-1.609142-1.097142-3.218283-2.194284-4.315425-3.291426-1.023999-0.512-1.609142-1.023999-2.194285-1.609142-1.023999-1.023999-2.633141-2.633141-3.65714-4.242283-0.585142 0-0.585142-0.585142-1.097142-1.097142-1.097142-1.609142-2.194284-3.218283-3.218283-5.412567 0-0.512-0.585142-0.512-0.585143-1.024-0.512-2.194284-1.609142-4.388568-2.194284-6.509709-0.512-0.512-0.512-0.512-0.512-1.024a31.451406 31.451406 0 0 1-1.023999-7.021709v-10.239993s-1.609142-4.315425 0-6.436566V57.052119c0-22.67427 17.700559-40.959971 40.301686-40.95997 22.67427 0 40.959971 18.285701 40.95997 40.95997v69.924522z m570.367592 391.240863c0 22.601127-18.285701 40.886828-40.959971 40.886828H307.565495a40.886828 40.886828 0 1 1 0-81.773656h395.556289c22.601127 0 40.886828 18.285701 40.886828 40.886828z"  ></path></symbol><symbol id="icon-tijiao1" viewBox="0 0 1031 1024"><path d="M936.248609 485.481722v450.766887H87.839055V87.663727l453.659789 0.087664a43.831864 43.831864 0 1 0 0-87.751391H73.199212A73.199212 73.199212 0 0 0 0 73.286876v877.513912c0 40.500642 32.873898 73.199212 73.286876 73.199212h877.513912a73.199212 73.199212 0 0 0 73.199212-73.199212V485.481722a43.831864 43.831864 0 0 0-87.751391 0z m74.864823-449.714921a51.195617 51.195617 0 0 0-71.621265 10.694975v0.087663L544.391747 563.677767 369.414947 419.207945a51.195617 51.195617 0 0 0-65.221813 78.897354l216.178752 178.395686a51.195617 51.195617 0 0 0 73.286876-8.415718l427.185344-559.469909a51.195617 51.195617 0 0 0-9.730674-72.848557z"  ></path></symbol><symbol id="icon-tijiaoshenhe" viewBox="0 0 1025 1024"><path d="M69.919748 333.063665l-7.086461 21.023167 7.086461-20.944429m-7.086461 20.944429l-5.354215 16.220122 5.432954-16.220122m-17.637414 52.912242Q-0.236215 391.802552 0 354.638002q0.236215-36.849597 45.747042-52.046119L939.271031 4.803046q40.865258-13.621753 67.321379 11.495814 26.771075 25.196306 14.960306 66.533995L766.282645 976.199366q-12.913107 45.274612-49.998919 47.715504-36.613382 2.362154-55.668088-40.314089l-168.264078-378.731969 4.488092-39.526705 115.588052-154.091156L458.257809 526.839003l-36.062213 5.826646L45.274612 406.999074m92.675161-52.124857L427.549811 451.407563l357.945017-268.498132 55.116918 55.116919-266.923362 356.055294 133.776635 301.095852 230.624935-807.069165L137.949773 354.874217z"  ></path></symbol><symbol id="icon-xingzhuang" viewBox="0 0 1024 1024"><path d="M497.728 0c143.744 0 260.288 114.56 260.288 256 0 141.376-116.48 256-260.288 256-143.68 0-260.224-114.624-260.224-256 0-141.44 116.544-256 260.224-256z m0 0c143.744 0 260.288 114.56 260.288 256 0 141.376-116.48 256-260.288 256-143.68 0-260.224-114.624-260.224-256 0-141.44 116.544-256 260.224-256zM400.192 597.312h216.896c185.664 0 336.192 148.032 336.192 330.688v21.312c0 71.936-150.528 74.688-336.192 74.688h-216.96C214.592 1024 64 1023.872 64 949.312V928c0-182.656 150.464-330.688 336.192-330.688z"  ></path></symbol><symbol id="icon-chexiao1" viewBox="0 0 1024 1024"><path d="M396.544 135.968L73.28 459.2a44.8 44.8 0 0 0 0 63.36l323.264 323.264a35.2 35.2 0 0 0 24.896 10.304l3.84-0.192a35.2 35.2 0 0 0 31.36-35.008l-0.032-189.024 10.656 0.416c146.08 7.2 278.304 80.256 359.68 196.032l47.36 67.456 10.56-81.792c2.272-17.856 3.424-35.936 3.424-54.144l-0.096-9.792c-5.216-227.968-191.84-412.096-424.672-422.144l-6.88-0.224V160.832a35.2 35.2 0 0 0-60.096-24.864z m-3.904 94.368v163.04l33.408-1.44c5.76-0.256 11.584-0.384 17.408-0.384l9.696 0.096c189.888 4.608 345.024 143.552 368.16 321.92l1.152 10.304-2.496-2.56c-97.664-96.768-232.192-153.536-376.512-153.536-6.688 0-13.344 0.096-19.968 0.32l-30.848 1.152v182.176L132.096 490.88l260.544-260.544z"  ></path></symbol><symbol id="icon-shanchu" viewBox="0 0 1024 1024"><path d="M590.933333 512l433.322667 433.237333-78.762667 78.762667L512 590.762667 78.848 1024 0 945.237333 433.237333 512 0.085333 78.762667 78.848 0l433.237333 433.152L945.237333 0 1024 78.762667 590.933333 512z"  ></path></symbol><symbol id="icon-shouqi1" viewBox="0 0 1024 1024"><path d="M337.152 253.888v541.824c0 16.32 17.088 25.344 28.8 15.296l314.176-270.912a20.608 20.608 0 0 0 0-30.592L365.952 238.592c-11.712-10.048-28.8-0.96-28.8 15.296z"  ></path></symbol><symbol id="icon-xia2" viewBox="0 0 1024 1024"><path d="M824 327.68c12.288 11.136 13.312 30.08 2.176 42.368l-285.952 317.76A29.952 29.952 0 0 1 514.56 704h-1.536c-0.512 0-1.024 0-1.6-0.128a29.44 29.44 0 0 1-25.728-16L199.68 370.048a30.016 30.016 0 1 1 44.608-40.128l268.672 298.368 268.672-298.368a30.016 30.016 0 0 1 42.368-2.24z"  ></path></symbol><symbol id="icon-lajixiang" viewBox="0 0 1024 1024"><path d="M581.080615 10.082462v97.752615h391.089231v97.831385h-65.142154v619.283692c0 71.995077-58.368 130.363077-130.363077 130.363077H255.133538a130.363077 130.363077 0 0 1-130.363076-130.363077V205.587692H59.549538V107.835077h391.168V10.082462h130.363077z m228.115693 195.584H222.523077v619.283692c0 15.753846 11.264 29.223385 26.781538 32.059077l5.828923 0.551384h521.452308c15.753846 0 29.302154-11.264 32.137846-26.781538l0.472616-5.828923V205.587692zM450.717538 303.419077v456.310154H352.886154V303.419077h97.831384z m228.115693 0v456.310154H581.080615V303.419077h97.752616z"  ></path></symbol><symbol id="icon-sousuo3" viewBox="0 0 1097 1024"><path d="M695.954286 222.208a319.195429 319.195429 0 1 0-6.436572 444.562286 319.122286 319.122286 0 0 0 6.436572-444.562286m331.702857 783.140571a63.926857 63.926857 0 0 1-90.185143 0l-200.704-200.996571a446.464 446.464 0 1 1 90.258286-90.185143l200.996571 200.996572c24.868571 24.868571 24.868571 65.243429 0 90.185142"  ></path></symbol><symbol id="icon-bofang" viewBox="0 0 1024 1024"><path d="M511.879529 16.564706c274.371765 0 496.820706 222.780235 496.820706 497.603765 0 274.823529-222.418824 497.603765-496.820706 497.603764C237.507765 1011.772235 15.058824 788.992 15.058824 514.168471 15.058824 239.344941 237.477647 16.534588 511.879529 16.534588z m0 30.117647C254.132706 46.682353 45.176471 255.939765 45.176471 514.138353s208.956235 467.486118 466.703058 467.486118 466.703059-209.317647 466.703059-467.486118c0-258.198588-208.956235-467.516235-466.703059-467.516235z m-70.294588 315.422118c11.745882 7.68 216.786824 140.348235 224.466824 145.468235 10.24 6.625882 11.745882 24.033882-0.512 31.713882-9.728 6.686118-207.600941 134.716235-224.466824 145.468236-11.264 7.168-24.033882-1.536-24.545882-15.872v-290.936471c1.024-13.281882 13.793882-23.521882 25.057882-15.841882z"  ></path></symbol><symbol id="icon-shoucang" viewBox="0 0 1088 1024"><path d="M818.688 1024c-11.712 0-25.216-3.712-36.288-9.856l-249.536-124.8-251.392 124.8a76.16 76.16 0 0 1-80.512-5.504 79.104 79.104 0 0 1-30.72-76.8l51.648-269.248L23.936 478.208a84.096 84.096 0 0 1-20.864-80.512c9.792-28.928 32.576-49.792 63.296-54.08L341.12 293.76 464 44.16A78.592 78.592 0 0 1 533.504 0c28.864 0 57.728 17.216 69.44 44.224l122.88 249.6 274.816 47.936c28.864 3.648 53.44 25.152 61.44 54.08 9.856 28.864 1.856 59.584-19.072 80.512l-197.888 186.24 49.792 269.184c5.504 30.72-8 59.648-30.72 76.8-12.928 9.92-28.288 15.424-45.504 15.424z"  ></path></symbol><symbol id="icon-xiala" viewBox="0 0 1024 1024"><path d="M770.112 337.152H228.288c-16.32 0-25.344 17.088-15.296 28.8l270.912 314.176a20.608 20.608 0 0 0 30.592 0l270.912-314.176c10.048-11.712 0.96-28.8-15.296-28.8z"  ></path></symbol><symbol id="icon-shang2" viewBox="0 0 1024 1024"><path d="M824 696.192a30.016 30.016 0 0 0 2.176-42.368L540.224 336.064a29.952 29.952 0 0 0-25.728-16H511.36a29.44 29.44 0 0 0-25.728 16L199.68 653.824a30.016 30.016 0 1 0 44.608 40.192l268.672-298.368 268.672 298.368c11.072 12.288 30.08 13.312 42.368 2.176z"  ></path></symbol><symbol id="icon-cankaojiaocai" viewBox="0 0 1024 1024"><path d="M412.216889 227.555556a56.888889 56.888889 0 0 1 44.942222 22.016l122.538667 158.151111a56.888889 56.888889 0 0 0 44.942222 22.016H910.222222a113.777778 113.777778 0 0 1 113.777778 113.777777v341.333334a113.777778 113.777778 0 0 1-113.777778 113.777778H113.777778a113.777778 113.777778 0 0 1-113.777778-113.777778V341.333333a113.777778 113.777778 0 0 1 113.777778-113.777777h298.439111zM967.111111 170.666667a56.888889 56.888889 0 1 1 0 113.777777h-196.949333a56.888889 56.888889 0 1 1 0-113.777777H967.111111z m0-170.666667a56.888889 56.888889 0 1 1 0 113.777778H284.444444a56.888889 56.888889 0 1 1 0-113.777778h682.666667z"  ></path></symbol><symbol id="icon-jiaoxueneirong" viewBox="0 0 1024 1024"><path d="M768 896a64 64 0 1 1 0 128H256a64 64 0 1 1 0-128h512z m128-896a128 128 0 0 1 128 128v512a128 128 0 0 1-128 128H128a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h768z m-243.2 230.912l-374.016 57.92a12.8 12.8 0 0 0-3.456 24.32L458.88 398.464a12.8 12.8 0 0 1 7.104 8.832l42.752 194.752a12.8 12.8 0 0 0 24.448 1.792l133.632-355.84a12.8 12.8 0 0 0-13.888-17.152z"  ></path></symbol><symbol id="icon-jiaoxuetuandui" viewBox="0 0 1024 1024"><path d="M85.333333 0a56.888889 56.888889 0 0 1 56.888889 56.888889v910.222222a56.888889 56.888889 0 1 1-113.777778 0V56.888889a56.888889 56.888889 0 0 1 56.888889-56.888889z m803.726223 0a56.888889 56.888889 0 0 1 52.679111 78.279111L835.128889 341.333333l106.666667 263.054223A56.888889 56.888889 0 0 1 889.059556 682.666667H312.888889a113.777778 113.777778 0 0 1-113.777778-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778h576.170667zM580.551111 424.334222h-3.584a81.92 81.92 0 0 0-9.102222 0.227556l-6.542222 0.398222c-2.958222 0.227556-5.916444 0.455111-8.874667 0.853333-2.844444 0.398222-5.688889 0.682667-8.476444 1.137778l-11.036445 2.218667a177.322667 177.322667 0 0 0-25.884444 7.68 199.964444 199.964444 0 0 0-36.750223 18.204444c-10.012444 6.314667-19.399111 13.482667-28.103111 21.560889-3.754667 3.413333-7.395556 6.769778-10.808889 10.581333a12.913778 12.913778 0 0 0-3.015111 5.688889c-0.284444 1.080889-0.170667 2.161778-0.170666 3.299556 0.056889 3.356444 1.536 6.087111 3.982222 8.248889 1.877333 1.649778 113.891556 2.446222 196.721778 2.56h47.160889c23.722667 0 39.480889-0.170667 40.391111-0.341334a12.231111 12.231111 0 0 0 6.314666-4.039111 11.548444 11.548444 0 0 0-0.455111-15.928889c-4.096-4.152889-8.192-8.362667-12.686222-12.231111a291.84 291.84 0 0 0-16.952889-13.425777 189.724444 189.724444 0 0 0-37.888-21.048889 195.697778 195.697778 0 0 0-39.708444-12.060445c-2.275556-0.398222-4.551111-0.853333-6.826667-1.137778-1.251556-0.284444-2.616889-0.341333-3.925333-0.568888a45.738667 45.738667 0 0 0-5.575111-0.796445l-6.712889-0.568889-7.964445-0.455111c-2.332444-0.170667-4.721778 0-7.111111 0z m-9.216-247.466666l-6.485333 0.227555a111.729778 111.729778 0 0 0-44.942222 12.856889 116.622222 116.622222 0 0 0-35.157334 28.615111 115.882667 115.882667 0 0 0-17.635555 29.582222 116.508444 116.508444 0 0 0-7.566223 30.151111 192.568889 192.568889 0 0 0-0.455111 6.542223c-0.113778 2.332444-0.284444 4.778667-0.170666 7.168 0.113778 3.185778 0.227556 6.428444 0.568889 9.614222a108.487111 108.487111 0 0 0 14.392888 45.283555 112.64 112.64 0 0 0 35.043556 37.888 116.622222 116.622222 0 0 0 34.588444 15.815112c4.152889 1.137778 8.419556 2.048 12.686223 2.616888a121.514667 121.514667 0 0 0 29.752889 0.455112 111.331556 111.331556 0 0 0 48.355555-17.464889 115.939556 115.939556 0 0 0 35.498667-36.408889 114.119111 114.119111 0 0 0 15.928889-46.136889c0.284444-2.616889 0.568889-5.233778 0.682666-7.850667v-5.290666a117.361778 117.361778 0 0 0-9.500444-45.511112 114.403556 114.403556 0 0 0-89.884445-67.242666l-4.152888-0.455111c-1.706667-0.170667-3.356444-0.398222-5.006223-0.398223-4.380444-0.056889-8.704-0.227556-13.027555 0.170667z"  ></path></symbol><symbol id="icon-kechengjianjie" viewBox="0 0 1024 1024"><path d="M853.333333 0a113.777778 113.777778 0 0 1 113.777778 113.777778v796.444444a113.777778 113.777778 0 0 1-113.777778 113.777778H170.666667a113.777778 113.777778 0 0 1-113.777778-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778h682.666666z m-227.555555 341.333333H398.222222a56.888889 56.888889 0 1 0 0 113.777778h227.555556a56.888889 56.888889 0 1 0 0-113.777778z m113.777778-227.555555H284.444444a56.888889 56.888889 0 1 0 0 113.777778h455.111112a56.888889 56.888889 0 1 0 0-113.777778z"  ></path></symbol><symbol id="icon-kaohefangshi" viewBox="0 0 1024 1024"><path d="M231.936 0v98.417778c0 53.816889 38.4 97.621333 86.072889 98.531555h386.56c47.786667 0 86.755556-43.235556 87.495111-96.881777V0h87.552C927.971556 0 967.111111 44.088889 967.111111 98.417778v827.164444c0 54.328889-39.139556 98.417778-87.495111 98.417778H144.384C96.028444 1024 56.888889 979.911111 56.888889 925.582222V98.417778C56.888889 44.145778 96.028444 0 144.384 0h87.552zM504.035556 343.153778a17.464889 17.464889 0 0 0-7.907556 7.964444l-56.775111 115.086222a17.464889 17.464889 0 0 1-13.027556 9.500445l-127.089777 18.432a17.351111 17.351111 0 0 0-9.557334 29.582222l91.989334 89.656889c4.152889 3.982222 5.973333 9.728 5.006222 15.36l-21.674667 126.634667a17.408 17.408 0 0 0 25.258667 18.318222l113.664-59.733333a17.066667 17.066667 0 0 1 16.156444 0l113.720889 59.733333a17.351111 17.351111 0 0 0 23.381333-7.281778c1.706667-3.356444 2.389333-7.281778 1.706667-11.036444l-21.617778-126.577778c-0.967111-5.688889 0.853333-11.377778 4.949334-15.416889l92.046222-89.656889a17.294222 17.294222 0 0 0-9.671111-29.582222l-127.089778-18.432a17.180444 17.180444 0 0 1-13.084444-9.500445L527.815111 351.004444a17.863111 17.863111 0 0 0-23.665778-7.850666zM713.272889 0v98.702222c-0.056889 5.176889-3.811556 9.386667-8.419556 9.500445H319.260444c-4.608-0.113778-8.362667-4.323556-8.476444-9.500445V0h402.488889z"  ></path></symbol><symbol id="icon-shanchu-copy" viewBox="0 0 1024 1024"><path d="M590.933333 512l433.322667 433.237333-78.762667 78.762667L512 590.762667 78.848 1024 0 945.237333 433.237333 512 0.085333 78.762667 78.848 0l433.237333 433.152L945.237333 0 1024 78.762667 590.933333 512z" fill="#d81e06" ></path></symbol><symbol id="icon-shezhi" viewBox="0 0 1024 1024"><path d="M371.634286 51.314115V18.48901l35.612678-7.509382q104.676243-21.902366 209.409376-0.05689l30.492645 6.314709 4.664919 30.83398q10.240067 67.470665 69.348011 101.490444 59.164833 34.247336 122.71014 9.32984l29.013524-11.377853 20.764581 23.210819q71.282246 79.815635 104.562464 181.476748l9.671175 29.582417-24.291715 19.342349q-53.24835 42.666947-53.191461 110.877173 0 68.267115 53.305239 110.934062l24.348605 19.399238-9.784953 29.582417q-33.450886 101.547334-104.676244 181.30608l-20.76458 23.267708-29.013524-11.377852q-63.545306-24.917497-122.596361 9.21606-59.164833 34.076668-69.348012 101.490445l-4.664919 30.720202-30.435756 6.428487q-104.676243 21.959255-209.352486 0.170667l-30.549534-6.314708-4.66492-30.890869q-10.183178-67.527555-69.4049-101.604224-59.107944-34.133558-122.65325-9.272949l-29.013524 11.377852-20.764581-23.210819Q59.084677 773.409526 25.804458 671.748413l-9.671174-29.582416 24.291715-19.399239q53.24835-42.553168 53.19146-110.763394 0.056889-68.267115-53.305239-110.877173L15.962616 381.726952l9.784953-29.582416q33.450886-101.547334 104.676243-181.30608l20.764581-23.210819 29.013524 11.377852q63.545306 24.860608 122.596361-9.27295 57.742602-33.280219 68.836008-98.361535z m82.261874 42.496279q-24.462383 86.357901-106.212254 133.46221-81.80676 47.274977-168.790442 25.258833-36.124682 46.250971-58.140827 100.693995 62.578189 64.284867 62.5213 158.721042 0.056889 94.436176-62.46441 158.721043 21.902366 54.499914 58.027048 100.807774 87.040572-22.073034 168.790442 25.145054 81.920538 47.218088 106.326032 133.689767 58.083937 8.135165 116.167874-0.113779 24.462383-86.357901 106.212253-133.46221 81.80676-47.274977 168.790443-25.258832 36.124682-46.250971 58.140826-100.693995-62.5213-64.398645-62.5213-158.721043-0.113779-94.436176 62.464411-158.834821-21.902366-54.443024-58.027048-100.693995-87.040572 22.016145-168.790442-25.258833-81.863649-47.161199-106.269143-133.519099-58.140826-8.192054-116.224763 0zM381.191682 381.271838Q327.146882 435.430416 327.146882 512.003364q0 76.629837 54.158578 130.788415t130.731526 54.158578q76.629837 0 130.788415-54.158578T696.927089 512.003364q0-76.572948-54.158578-130.731526T511.980097 327.11326q-76.572948 0-130.731526 54.158578z m63.374638 198.088413q-27.875739-27.875739-27.875738-67.356887 0-39.424259 27.875738-67.356887 27.875739-27.875739 67.356887-27.875739t67.413777 27.875739q27.875739 27.875739 27.875738 67.356887t-27.875738 67.356887q-27.875739 27.875739-67.413777 27.875738-39.424259 0-67.356887-27.875738z"  ></path></symbol><symbol id="icon-xiayi" viewBox="0 0 1024 1024"><path d="M248.173714 913.993143l144.457143-184.905143a36.571429 36.571429 0 0 0-28.818286-59.099429h-64a36.571429 36.571429 0 0 1-36.571428-36.571428V109.714286a36.571429 36.571429 0 0 0-36.571429-36.571429h-14.628571a36.571429 36.571429 0 0 0-36.571429 36.571429v523.702857a36.571429 36.571429 0 0 1-36.571428 36.571428h-64a36.571429 36.571429 0 0 0-28.818286 59.099429l144.457143 184.905143a36.571429 36.571429 0 0 0 57.636571 0z m324.754286-267.922286a42.642286 42.642286 0 1 0 0 85.357714h365.714286a42.642286 42.642286 0 0 0 0-85.357714h-365.714286z m0-225.499428a42.642286 42.642286 0 0 0 0 85.357714h365.714286a42.642286 42.642286 0 1 0 0-85.357714h-365.714286z m0-225.499429a42.642286 42.642286 0 1 0 0 85.284571h365.714286a42.642286 42.642286 0 0 0 0-85.284571h-365.714286z"  ></path></symbol><symbol id="icon-shangyi" viewBox="0 0 1024 1024"><path d="M248.173714 110.006857l144.457143 184.905143a36.571429 36.571429 0 0 1-28.818286 59.099429h-64a36.571429 36.571429 0 0 0-36.571428 36.571428v523.702857a36.571429 36.571429 0 0 1-36.571429 36.571429h-14.628571a36.571429 36.571429 0 0 1-36.571429-36.571429V390.582857a36.571429 36.571429 0 0 0-36.571428-36.571428h-64a36.571429 36.571429 0 0 1-28.818286-59.099429l144.457143-184.905143a36.571429 36.571429 0 0 1 57.636571 0z m324.754286 267.922286a42.642286 42.642286 0 1 1 0-85.357714h365.714286a42.642286 42.642286 0 0 1 0 85.357714h-365.714286z m0 225.499428a42.642286 42.642286 0 0 1 0-85.357714h365.714286a42.642286 42.642286 0 1 1 0 85.357714h-365.714286z m0 225.499429a42.642286 42.642286 0 1 1 0-85.284571h365.714286a42.642286 42.642286 0 0 1 0 85.284571h-365.714286z"  ></path></symbol><symbol id="icon-bianji1" viewBox="0 0 1024 1024"><path d="M89.200111 1024a46.503721 46.503721 0 0 1 0-93.007443h837.578953a46.503721 46.503721 0 0 1 0 93.007443H89.200111zM634.104267 13.802646l186.100213 186.185541a46.503721 46.503721 0 0 1 0 66.043818L308.407561 777.828924a46.503721 46.503721 0 0 1-33.021909 13.481813H89.200111A46.503721 46.503721 0 0 1 42.696389 744.807016V558.706802c0-12.37255 4.778364-24.233132 13.481813-33.021909L568.06045 13.717318a46.503721 46.503721 0 0 1 66.043817 0z m-33.021909 98.639086L135.703832 577.73493v120.568364h120.483036L721.565394 233.010096 601.082358 112.441732z"  ></path></symbol><symbol id="icon-baocun" viewBox="0 0 1024 1024"><path d="M512 93.013333a418.986667 418.986667 0 0 0 0 837.973334 418.986667 418.986667 0 0 0 0-837.973334zM512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m200.874667 279.296l78.421333 55.808-323.413333 409.6-235.178667-167.509333 58.88-74.496L448.256 614.4l264.533333-335.104z"  ></path></symbol><symbol id="icon-quxiao" viewBox="0 0 1024 1024"><path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM512 73.130667C283.050667 73.130667 73.130667 283.050667 73.130667 512S283.050667 950.869333 512 950.869333 950.869333 740.949333 950.869333 512 740.949333 73.130667 512 73.130667z m229.461333 672a48.64 48.64 0 0 1-68.864 0H672.426667L517.376 589.994667 362.154667 745.130667a48.725333 48.725333 0 0 1-68.949334-68.949334l155.136-155.221333-155.136-155.136a48.725333 48.725333 0 0 1 68.949334-68.949333l155.221333 155.136L672.426667 296.96a48.725333 48.725333 0 1 1 68.949333 68.949333L586.24 520.96l155.136 155.221333a48.725333 48.725333 0 0 1 0 68.949334z"  ></path></symbol><symbol id="icon-shujuku" viewBox="0 0 1024 1024"><path d="M64 192V896h896V192H64zM0 128h1024v832H0V128z"  ></path><path d="M64 384h896v64H64zM64 640h896v64H64zM128 256h192v64H128zM128 512h192v64H128zM128 768h192v64H128z"  ></path></symbol><symbol id="icon-xiaoziyuan" viewBox="0 0 1024 1024"><path d="M810.667 469.333c0-23.564 19.102-42.666 42.666-42.666 23.564 0 42.667 19.102 42.667 42.666v341.334C896 857.795 857.795 896 810.667 896H213.333C166.205 896 128 857.795 128 810.667V469.333c0-23.564 19.103-42.666 42.667-42.666s42.666 19.102 42.666 42.666v341.334h597.334V469.333zM260.52 298.667h500.7l-75.727-83.338a6.095 6.095 0 0 0-4.51-1.996H337.918c-1.758 0-3.43 0.76-4.588 2.083l-72.811 83.25z m-121.97 9.837l130.548-149.266A91.429 91.429 0 0 1 337.92 128h343.063a91.429 91.429 0 0 1 67.666 29.942L884.91 307.9A42.667 42.667 0 0 1 896 336.593v4.74C896 364.897 876.897 384 853.333 384H170.667C147.103 384 128 364.897 128 341.333v-4.74a42.667 42.667 0 0 1 10.55-28.09zM384 640c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.666 42.667-42.666h256c23.564 0 42.667 19.102 42.667 42.666C682.667 620.897 663.564 640 640 640H384z"  ></path></symbol><symbol id="icon-wenjian-shanchu" viewBox="0 0 1024 1024"><path d="M806.016 320L640 153.984V320h166.016zM832 384H576V128H192v768h640V384zM160 64H640l256 256v608a31.168 31.168 0 0 1-8.96 23.04 31.168 31.168 0 0 1-23.04 8.96h-704a31.168 31.168 0 0 1-23.04-8.96 31.168 31.168 0 0 1-8.96-23.04v-832c0-9.344 3.008-17.024 8.96-23.04A31.168 31.168 0 0 1 160 64z m308.992 545.984L377.984 520l46.016-46.016 89.984 91.008 91.008-91.008 45.056 46.016L560 609.984l89.984 91.008-44.992 45.056-90.944-90.048-90.048 89.984-46.016-44.992 91.008-90.944z" fill="#000000" ></path></symbol><symbol id="icon-quanxian" viewBox="0 0 1024 1024"><path d="M267.198837 265.289384a265.289384 265.289384 0 1 1 530.578768 0v88.514905a265.289384 265.289384 0 1 1-530.578768 0v-88.514905z m88.429795 0v88.514905q0 73.195018 51.747175 125.027304 51.917396 51.832286 125.112414 51.832285t125.112414-51.832285q51.747175-51.832286 51.747175-125.112414V265.289384q0-73.195018-51.747175-125.112414-51.917396-51.747175-125.112414-51.747175t-125.112414 51.832285q-51.747175 51.832286-51.747175 125.112414z m619.093673 486.406426a132.687247 132.687247 0 0 1-139.155645 132.517026l-47.151209 110.30319a44.257453 44.257453 0 1 1-81.280513-34.810189l46.640546-108.941422a132.687247 132.687247 0 1 1 220.946821-98.983495zM90.339248 1017.070304h442.148973a44.257453 44.257453 0 0 0 0-88.514905H134.5967v-44.172342q0-54.981374 38.895492-93.791755 38.810381-38.895492 93.791755-38.895492h353.719179a44.257453 44.257453 0 1 0 0-88.429795H267.198837q-91.578883 0-156.347962 64.76908Q46.081795 792.719064 46.081795 884.383057v88.514905c0 24.341599 19.830743 44.172342 44.257453 44.172342zM886.122289 751.69581q0-18.298754-12.936794-31.235548t-31.235548-12.936794q-18.298754 0-31.235548 12.936794-13.021904 12.936794-13.021905 31.235548 0 18.383865 12.936794 31.320659 13.021904 12.936794 31.320659 12.936793t31.235548-12.936793q12.936794-12.936794 12.936794-31.320659z"  ></path></symbol><symbol id="icon-shangchuanbendi" viewBox="0 0 1024 1024"><path d="M192 85.357714c-58.88 0-106.642286 47.762286-106.642286 106.642286v640c0 58.88 47.762286 106.642286 106.642286 106.642286h640c58.88 0 106.642286-47.762286 106.642286-106.642286v-640c0-58.88-47.762286-106.642286-106.642286-106.642286h-640z m-21.357714 106.642286c0-11.776 9.581714-21.357714 21.357714-21.357714h640c11.776 0 21.357714 9.581714 21.357714 21.357714v640c0 11.776-9.508571 21.357714-21.357714 21.357714h-640a21.357714 21.357714 0 0 1-21.357714-21.357714v-640z m128 106.642286c0-23.552 19.163429-42.642286 42.715428-42.642286h341.284572a42.642286 42.642286 0 0 1 0 85.357714H341.357714a42.642286 42.642286 0 0 1-42.715428-42.715428z m243.565714 97.865143a42.642286 42.642286 0 0 0-60.342857 0L311.149714 567.149714a42.642286 42.642286 0 0 0 60.342857 60.342857l97.865143-97.792V768a42.642286 42.642286 0 1 0 85.284572 0V529.700571l97.865143 97.792a42.642286 42.642286 0 0 0 60.342857-60.342857L542.208 396.507429z"  ></path></symbol><symbol id="icon-xiangji" viewBox="0 0 1137 1024"><path d="M398.22221 0h341.333323L853.333307 113.777774h227.555549A56.888887 56.888887 0 0 1 1137.777743 170.666661v796.444421a56.888887 56.888887 0 0 1-56.888887 56.888887H56.888887A56.888887 56.888887 0 0 1 0 967.111082V170.666661a56.888887 56.888887 0 0 1 56.888887-56.888887H284.444436L398.22221 0zM568.888872 910.222195a341.333323 341.333323 0 1 0 0-682.666646 341.333323 341.333323 0 0 0 0 682.666646z m0-113.777775a227.555549 227.555549 0 1 1 0-455.111097 227.555549 227.555549 0 0 1 0 455.111097z"  ></path></symbol><symbol id="icon-tupian" viewBox="0 0 1133 1024"><path d="M665.671013 280.663837c0 45.583025 36.984199 82.567223 82.567224 82.567224V264.159639c9.107359 0 16.504199 7.39684 16.504198 16.504198h-99.071422zM748.238237 363.231061c45.583025 0 82.567223-36.984199 82.567223-82.567224h-99.071422c0-9.107359 7.39684-16.504199 16.504199-16.504198v99.071422zM830.80546 280.663837c0-45.583025-36.984199-82.567223-82.567223-82.567223v99.071422A16.504199 16.504199 0 0 1 731.734038 280.663837h99.071422zM748.238237 198.096614c-45.583025 0-82.567223 36.984199-82.567224 82.567223h99.071422c0 9.107359-7.39684 16.504199-16.504198 16.504199V198.096614zM929.876882 445.752054a49.512596 49.512596 0 1 0 99.025192 0H929.923112zM54.784512 709.957923l49.512596 0.04623v-0.04623H54.784512z m12.713318 187.509887a49.512596 49.512596 0 1 0 79.331106-59.359638L67.49783 897.46781z m961.404244-451.669526a49.512596 49.512596 0 1 0-99.025192 0h99.025192zM318.944151 974.117562v-49.512596V974.117562z m-172.068984-135.91693a49.512596 49.512596 0 1 0-79.469797 59.174718l79.516027-59.174718zM1012.675257 482.458871a49.512596 49.512596 0 1 0-66.571558-73.367404l66.571558 73.367404z m-343.675666 244.742935l-33.285779-36.706817-0.323612 0.277381 33.609391 36.429436z m-50.25228 17.290113l-4.068262 49.373905 4.068262-49.373905z m-46.692551-25.287946l39.06456-30.419503-39.06456 30.419503z m-132.680812-170.450926l39.064559-30.465733-0.09246-0.092461-38.972099 30.511964z m-53.395937-25.334176l-1.017066-49.558826 1.017066 49.558826z m-52.286411 27.506998l-40.220316-28.893905-0.09246 0.09246 40.312776 28.801445zM66.804377 838.940316a49.512596 49.512596 0 0 0 80.579322 57.64912L66.850607 838.986546z m962.051467-393.188262V313.672235H929.923112v132.079819h99.025192z m0-132.079819a313.718465 313.718465 0 0 0-313.672235-313.672235V98.978962a214.647043 214.647043 0 0 1 214.647043 214.647043h99.025192zM715.229839 0.04623H318.944151V98.978962h396.285688V0.04623z m-396.285688 0A313.718465 313.718465 0 0 0 5.318146 313.672235H104.250878a214.647043 214.647043 0 0 1 214.647043-214.647043V0.04623zM5.318146 313.672235v396.285688H104.250878V313.672235H5.318146z m0 396.193228a312.516479 312.516479 0 0 0 62.225915 187.602347l79.331106-59.359638a213.491287 213.491287 0 0 1-42.531829-128.057788l-99.025192-0.184921z m924.604966-264.113409v264.205869h99.025192V445.705824H929.923112z m0 264.205869a214.647043 214.647043 0 0 1-214.647042 214.647043v99.025192a313.718465 313.718465 0 0 0 313.672234-313.672235H929.923112z m-214.647042 214.647043H318.944151v99.025192h396.285688V924.651196z m-396.285689 0a214.230971 214.230971 0 0 1-172.068984-86.404334L67.40537 897.37535a313.302393 313.302393 0 0 0 251.585011 126.254808l-0.04623-99.025192zM946.103699 409.091467l-310.389887 281.403522 66.571558 73.367404 310.389887-281.403522-66.571558-73.367404zM635.436431 690.72614a16.504199 16.504199 0 0 1-12.574628 4.345643l-8.136524 98.747811a115.575621 115.575621 0 0 0 87.929933-30.280813l-67.218781-72.812641z m-12.574628 4.345643a16.504199 16.504199 0 0 1-11.696253-6.333544l-78.17535 60.792777a115.575621 115.575621 0 0 0 81.735079 44.288578l8.136524-98.747811z m-11.696253-6.333544l-132.680812-170.497155-78.12912 60.885237 132.680813 170.450925 78.129119-60.839007z m-132.773273-170.589616a115.575621 115.575621 0 0 0-93.385101-44.334808l2.034131 99.071422a16.504199 16.504199 0 0 1 13.360541 6.333544l77.990429-61.023928z m-93.385101-44.334808a115.575621 115.575621 0 0 0-91.535892 48.171919l80.486862 57.78781a16.504199 16.504199 0 0 1 13.083161-6.934537L384.960945 473.906275z m-91.535892 48.264379l-226.528217 316.862122 80.533093 57.602889 226.528217-316.862121-80.579323-57.60289z"  ></path></symbol><symbol id="icon-yidong" viewBox="0 0 1195 1024"><path d="M179.403947 15.786667a54.613333 54.613333 0 0 1 76.8 0l162.986666 161.706666a53.589333 53.589333 0 0 1 0 76.202667 54.613333 54.613333 0 0 1-76.8 0l-70.229333-69.717333v656.042666l70.229333-69.717333a54.613333 54.613333 0 0 1 76.8 0 53.589333 53.589333 0 0 1 0 76.202667l-162.986666 161.706666a54.613333 54.613333 0 0 1-76.8 0L16.502613 846.506667a53.589333 53.589333 0 0 1 0-76.202667 54.613333 54.613333 0 0 1 76.8 0l70.229334 69.717333V183.978667l-70.229334 69.717333a54.613333 54.613333 0 0 1-76.8 0 53.589333 53.589333 0 0 1 0-76.202667L179.48928 15.786667z m309.930666 91.989333c0-29.781333 24.32-53.845333 54.357334-53.845333h597.333333c29.952 0 54.272 24.064 54.272 53.845333a54.101333 54.101333 0 0 1-54.272 53.930667h-597.333333a54.101333 54.101333 0 0 1-54.357334-53.930667z m0 269.482667c0-29.781333 24.32-53.930667 54.357334-53.930667h380.074666c30.037333 0 54.272 24.149333 54.272 53.930667a54.101333 54.101333 0 0 1-54.272 53.930666H543.691947a54.101333 54.101333 0 0 1-54.357334-53.930666z m0 269.482666c0-29.781333 24.32-53.930667 54.357334-53.930666h597.333333c29.952 0 54.272 24.149333 54.272 53.930666a54.101333 54.101333 0 0 1-54.272 53.930667h-597.333333a54.101333 54.101333 0 0 1-54.357334-53.930667z m0 269.482667c0-29.781333 24.32-53.930667 54.357334-53.930667h380.074666c30.037333 0 54.272 24.149333 54.272 53.930667a54.101333 54.101333 0 0 1-54.272 53.845333H543.691947a54.101333 54.101333 0 0 1-54.357334-53.845333z"  ></path></symbol><symbol id="icon-wodepingshen" viewBox="0 0 1024 1024"><path d="M531.904 229.12a397.44 397.44 0 1 1 0 794.88 397.44 397.44 0 0 1 0-794.88z m29.44 192.128c-16.576-33.6-42.56-32.96-58.88 0l-48.384 98.112-108.352 15.744c-37.056 5.376-44.48 30.336-18.176 56l78.4 76.416-18.496 107.84c-6.4 36.928 15.104 51.712 47.616 34.56l96.832-50.88 96.896 50.944c33.152 17.408 53.824 1.6 47.616-34.624l-18.496-107.84 78.4-76.416c26.816-26.176 18.112-50.688-18.24-56l-108.288-15.744z" fill="#0E76FF" ></path><path d="M903.488 0h-245.76a28.032 28.032 0 0 0-27.008 21.568L554.88 170.944s162.24 9.728 258.048 102.016L926.08 44.608a27.776 27.776 0 0 0 5.76-16.256 28.416 28.416 0 0 0-28.416-28.352M504.96 170.944L429.056 21.568A27.968 27.968 0 0 0 402.112 0h-245.76A28.352 28.352 0 0 0 128 28.352c0 6.208 2.368 11.648 5.76 16.32l113.152 228.288C342.72 180.672 504.896 170.88 504.896 170.88" fill="#0E76FF" ></path></symbol><symbol id="icon-xiangmuguanli" viewBox="0 0 1024 1024"><path d="M576 0m64 0l320 0q64 0 64 64l0 0q0 64-64 64l-320 0q-64 0-64-64l0 0q0-64 64-64Z" fill="#0E76FF" ></path><path d="M399.104 64.512s37.056-8.512 65.536 42.752c31.36 45.632 48.448 74.176 48.448 74.176s14.272 11.392 37.12 11.392h402.368c6.144-0.384 70.784-2.048 70.784 71.232v641.408s11.392 76.928-62.72 76.928H71.296S0 993.92 0 899.84V145.408c0.64-11.968 7.68-80.896 88.32-80.896z m390.528 636.992H447.552a51.072 51.072 0 0 0-51.328 51.328c0 28.48 22.784 51.328 51.328 51.328h342.08a51.072 51.072 0 0 0 51.328-51.328 51.072 51.072 0 0 0-51.328-51.328z m0-202.368H447.552a51.072 51.072 0 0 0-51.328 51.264c0 28.544 22.784 51.328 51.328 51.328h342.08a51.072 51.072 0 0 0 51.328-51.328 51.072 51.072 0 0 0-51.328-51.264z" fill="#0E76FF" ></path></symbol><symbol id="icon-gongzuotai1" viewBox="0 0 1024 1024"><path d="M381.888 448H66.112C29.632 448 0 418.368 0 381.888V66.112C0 29.632 29.632 0 66.112 0h315.776C418.368 0 448 29.632 448 66.112V382.08C448 418.496 418.368 448 381.888 448zM381.888 1024H66.112C29.632 1024 0 994.368 0 957.888v-315.776C0 605.632 29.632 576 66.112 576h315.776C418.368 576 448 605.568 448 642.112v315.776C448 994.368 418.368 1024 381.888 1024zM605.76 1024c-36.48 0-66.112-29.632-66.112-66.112v-315.776c0-36.48 29.632-66.112 66.112-66.112H921.6c36.48 0 66.048 29.568 66.048 66.112v315.776c0 36.48-29.568 66.112-66.048 66.112H605.76z" fill="#0E76FF" ></path><path d="M529.984 303.232a64.704 64.704 0 0 1 0-91.456l191.36-191.36a64.704 64.704 0 0 1 91.52 0l191.36 191.36a64.704 64.704 0 0 1 0 91.456L812.8 494.592a64.512 64.512 0 0 1-91.456 0l-191.36-191.36z" fill="#0E76FF" ></path></symbol><symbol id="icon-quanxianshezhi" viewBox="0 0 1024 1024"><path d="M144.624941 144.624941v632.892235h337.558588v84.389648H102.4a42.164706 42.164706 0 0 1-42.164706-42.164706V102.4a42.164706 42.164706 0 0 1 42.164706-42.164706h675.117176a42.164706 42.164706 0 0 1 42.224942 42.164706v295.393882h-84.389647V144.624941H144.624941z m84.389647 249.133177V232.267294h425.682824v161.430588H229.014588z m0 287.141647v-240.941177h210.944v240.941177H229.014588z" fill="#0E76FF" ></path><path d="M777.517176 483.388235s-117.157647 46.863059-210.944 46.863059v187.572706c0 113.362824 90.593882 207.992471 210.944 229.677176 120.410353-21.684706 211.004235-116.254118 211.004236-229.677176V530.251294c-93.786353 0-211.004235-46.863059-211.004236-46.863059" fill="#0E76FF" ></path></symbol><symbol id="icon-zhuanjiaku" viewBox="0 0 1024 1024"><path d="M588.312699 588.512276c8.507619 0 16.503501 1.919012 23.47591 5.117365a196.378865 196.378865 0 0 1 139.000415 122.049144l-23.220042 23.220042-16.759369-16.823336-4.34976-4.157859a120.258067 120.258067 0 0 0-169.96047 169.896504l4.157859 4.34976 88.402472 88.402472H81.693608C36.724767 980.502401 0.263544 944.041179 0.263544 899.200272v-114.628966c0-91.089089 62.687716-170.152372 151.410024-190.941665a58.146055 58.146055 0 0 1 18.48648-4.861497l5.053397-0.191901h413.099254z m-220.366511 60.193001l-3.838024 3.390254-9.595058 9.659025a40.747015 40.747015 0 0 0-3.390254 53.732328l3.326287 3.838024 6.716541 6.716541-27.505835 158.190532a40.555114 40.555114 0 0 0 8.059849 32.111462l3.26232 3.646122 19.701854 19.701854c14.712423 14.712423 37.740564 15.799863 53.732328 3.390254l3.838023-3.390254 19.637887-19.637887a40.810982 40.810982 0 0 0 11.897872-30.896088l-0.575703-4.925463-27.058065-155.567883 7.292244-7.228277c14.712423-14.712423 15.799863-37.740564 3.390254-53.732328l-3.390254-3.838024-11.769938-11.769938a40.747015 40.747015 0 0 0-53.732328-3.326287z m24.307481-491.330965a195.995063 195.995063 0 1 1 0 391.990125 195.995063 195.995063 0 0 1 0-391.990125z m29.424847-151.473991l5.053397 2.17488 217.296093 100.172411a37.292794 37.292794 0 0 1-0.255869 68.188883l-3.198352 1.279341-54.052164 18.806315a238.789024 238.789024 0 0 0-384.122177-5.629101l-4.157858 5.629101-54.116131-18.870282a37.356761 37.356761 0 0 1-6.652574-67.80508l3.198353-1.599177L358.095261 8.075201c20.021689-9.275223 42.985862-10.042828 63.583255-2.17488z" fill="#0E76FF" ></path><path d="M880.386281 688.172951a48.103227 48.103227 0 0 1 70.811532 64.99053l-2.81455 3.070419-186.783807 186.783806a48.103227 48.103227 0 0 1-64.99053 2.81455l-3.070418-2.81455-101.835555-101.899522a48.103227 48.103227 0 0 1 64.99053-70.811532l3.070419 2.814551 67.80508 67.80508 152.817299-152.753332z" fill="#0E76FF" ></path></symbol><symbol id="icon-jichushuju" viewBox="0 0 1024 1024"><path d="M496.32 787.456c-194.368 0-388.8-45.44-496.32-132.416v132.48c0 113.728 221.312 206.72 496.32 206.72 275.072 0 496.384-93.056 496.384-206.72v-132.48c-107.52 86.912-301.952 132.48-496.384 132.48z m-351.616 82.688a41.472 41.472 0 0 1-41.28-41.344c0-22.72 18.624-41.344 41.28-41.344 22.784 0 41.408 18.624 41.408 41.344a41.472 41.472 0 0 1-41.408 41.344z" fill="#0E76FF" ></path><path d="M496.32 498.176c-194.368 0-388.8-45.44-496.32-132.416v153.088h2.048c24.896 105.472 235.776 186.112 494.272 186.112 258.56 0 469.44-80.64 494.272-186.112h2.112V365.824c-107.52 86.848-301.952 132.352-496.384 132.352zM144.704 580.864a41.472 41.472 0 0 1-41.28-41.344c0-22.72 18.624-41.344 41.28-41.344 22.784 0 41.408 18.56 41.408 41.344a41.472 41.472 0 0 1-41.408 41.344z" fill="#0E76FF" ></path><path d="M496.32 415.68c275.072 0 496.384-93.056 496.384-206.784 0-20.736-6.208-39.296-20.736-57.92-6.208-8.32-12.416-14.528-18.624-22.784a54.848 54.848 0 0 0-12.352-10.304 116.736 116.736 0 0 0-16.576-12.416c-4.096-2.048-8.256-6.208-12.416-8.32-8.32-6.208-18.56-10.24-26.88-16.512-18.624-10.304-41.344-18.624-64.064-28.928a633.856 633.856 0 0 0-74.496-22.72c-16.512-4.16-35.136-8.32-53.76-12.48A1061.376 1061.376 0 0 0 545.92 0c-16.512 2.048-33.152 2.048-49.664 2.048s-33.088 0-51.648 2.112c-51.776 2.048-101.376 8.32-146.88 16.576-18.624 4.096-37.248 6.208-53.76 10.24-24.832 6.272-49.6 12.48-72.32 20.736-22.784 8.32-41.408 16.576-60.032 24.832-6.208 4.096-14.464 8.32-20.672 12.416a260.992 260.992 0 0 0-51.712 39.232 165.12 165.12 0 0 0-24.896 31.104A91.52 91.52 0 0 0 0 208.896c0 113.792 221.312 206.784 496.32 206.784z" fill="#0E76FF" ></path></symbol><symbol id="icon-zuzhiguanli" viewBox="0 0 1024 1024"><path d="M512 0c23.743837 0 46.079683 6.655954 64.575556 17.855877l319.293805 189.758696c38.399736 23.039842 63.99956 65.919547 64.127559 114.943209v378.877396c0 49.023663-25.727823 91.903368-64.639556 115.327207l-318.077813 189.0547a126.143133 126.143133 0 0 1-129.919107 0.319998L128.00264 816.378387c-38.271737-23.039842-63.99956-65.919547-63.99956-114.943209V322.557782c0-49.023663 25.727823-91.903368 64.639556-115.327207L446.720449 18.175875C465.920317 6.655954 488.320163 0 512 0z m124.799142 544.636256c-31.99978 29.247799-73.599494 48.639666-121.599164 48.639665s-89.599384-19.519866-124.799142-48.639665C310.401386 586.747966 256.00176 641.915587 256.00176 742.394896h511.99648c0-100.543309-54.399626-152.382952-131.199098-197.75864zM512 255.99824C432.00055 255.99824 368.00099 324.093772 368.00099 405.117215 368.00099 489.468635 435.200528 554.23619 512 554.23619c79.99945 0 143.99901-68.031532 143.99901-149.118975C655.99901 324.093772 591.99945 255.99824 512 255.99824z" fill="#0E76FF" ></path></symbol><symbol id="icon-wodexiangmu" viewBox="0 0 1024 1024"><path d="M113.777778 284.444444v568.888889a56.888889 56.888889 0 0 0 56.888889 56.888889h568.888889a56.888889 56.888889 0 0 0 56.888888-56.888889V284.444444a56.888889 56.888889 0 0 0-56.888888-56.888888H170.666667a56.888889 56.888889 0 0 0-56.888889 56.888888z m625.777778-113.777777a113.777778 113.777778 0 0 1 113.777777 113.777777v568.888889a113.777778 113.777778 0 0 1-113.777777 113.777778H170.666667a113.777778 113.777778 0 0 1-113.777778-113.777778V284.444444a113.777778 113.777778 0 0 1 113.777778-113.777777h568.888889zM199.111111 335.018667h341.333333a28.444444 28.444444 0 1 1 0 56.888889h-341.333333a28.444444 28.444444 0 1 1 0-56.888889z m512 56.888889a28.444444 28.444444 0 1 1 0-56.888889 28.444444 28.444444 0 1 1 0 56.888889zM89.6 465.521778h729.884444v455.111111H89.543111v-455.111111z" fill="#0064FF" ></path><path d="M853.333333 853.333333l-40.391111-40.106666A56.718222 56.718222 0 0 1 853.333333 796.444444a56.888889 56.888889 0 0 0 56.888889-56.888888V170.666667a56.888889 56.888889 0 0 0-56.888889-56.888889H284.444444a56.888889 56.888889 0 0 0-56.888888 56.888889v4.835555c0 15.644444-6.257778 29.809778-16.497778 40.106667L170.666667 175.502222V170.666667a113.777778 113.777778 0 0 1 113.777777-113.777778h568.888889a113.777778 113.777778 0 0 1 113.777778 113.777778v568.888889a113.777778 113.777778 0 0 1-113.777778 113.777777z" fill="#0064FF" ></path></symbol><symbol id="icon-guanlihoutai" viewBox="0 0 1024 1024"><path d="M847.644444 396.686222c32.312889 0 58.595556 26.168889 58.595556 58.595556v113.208889a58.595556 58.595556 0 0 1-58.595556 58.595555H115.484444A58.595556 58.595556 0 0 1 56.888889 568.490667v-113.208889c0-32.426667 26.225778-58.595556 58.595555-58.595556z m-47.957333 80.099556a35.384889 35.384889 0 0 0-35.612444 35.157333l0.398222-0.113778c-0.056889 19.740444 15.758222 35.612444 35.328 35.669334a35.384889 35.384889 0 0 0-0.113778-70.712889z m-123.733333 0a35.384889 35.384889 0 0 0-35.612445 35.157333l0.284445-0.113778c0 19.740444 15.815111 35.612444 35.384889 35.669334a35.384889 35.384889 0 0 0-0.056889-70.712889z m-123.733334 0a35.384889 35.384889 0 0 0-35.612444 35.157333l0.284444-0.113778c0 19.740444 15.815111 35.612444 35.384889 35.669334a35.384889 35.384889 0 0 0-0.056889-70.712889zM847.644444 679.253333c32.312889 0 58.595556 26.282667 58.595556 58.595556v113.777778A58.595556 58.595556 0 0 1 847.644444 910.222222H115.484444A58.595556 58.595556 0 0 1 56.888889 851.626667v-113.208889c0-32.426667 26.225778-58.595556 58.595555-58.595556H847.644444zM163.271111 759.466667a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z m123.733333 0a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z m123.733334 0a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z" fill="#0064FF" ></path><path d="M847.644444 113.777778c32.312889 0 58.595556 26.225778 58.595556 58.595555v113.208889a58.595556 58.595556 0 0 1-58.595556 58.595556H115.484444A58.595556 58.595556 0 0 1 56.888889 285.582222V172.714667c0-32.369778 26.225778-58.595556 58.595555-58.595556H847.644444zM163.271111 193.649778a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z m123.733333 0a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z m123.733334 0a35.384889 35.384889 0 1 0 0 70.712889 35.384889 35.384889 0 0 0 0-70.712889z" fill="#0064FF" ></path></symbol><symbol id="icon-menhuguanli" viewBox="0 0 1024 1024"><path d="M1024 0v640c0 70.72-65.472 128-146.304 128H146.304c-77.312 0-140.608-52.48-145.92-118.848L0 640V128C0 57.28 65.472 0 146.304 0H1024zM312.128 450.56c-24.32 0-43.904 17.216-43.904 38.4v95.552l0.448 5.696c3.2 18.496 21.376 32.64 43.456 32.64l6.4-0.448c21.248-2.688 37.44-18.688 37.44-37.952V488.96l-0.448-5.696c-3.2-18.496-21.376-32.704-43.392-32.704zM507.072 192c-24.192 0-43.84 17.216-43.84 38.4v354.048l0.576 6.272c3.072 16.384 17.984 29.248 36.8 31.68l6.464 0.448 6.528-0.448c21.12-2.688 37.376-18.688 37.376-37.952V230.4l-0.448-5.696C547.328 206.208 529.152 192 507.072 192z m195.072 172.288c-24.192 0-43.84 17.216-43.84 38.4v181.76l0.448 5.696c3.2 18.496 21.376 32.704 43.392 32.704 22.08 0 40.32-14.208 43.456-32.704l0.448-5.696v-181.76l-0.448-5.696c-3.2-18.496-21.376-32.704-43.456-32.704z" fill="#0E76FF" ></path><path d="M174.08 896h675.84c25.472 0 46.08 28.672 46.08 64s-20.608 64-46.08 64H174.08c-25.472 0-46.08-28.672-46.08-64s20.608-64 46.08-64z" fill="#0E76FF" ></path></symbol><symbol id="icon-wodeshenhe" viewBox="0 0 1024 1024"><path d="M628.352 64C705.472 64 768 121.28 768 192v725.12c0 35.328-31.232 64-69.76 64a74.88 74.88 0 0 1-34.24-8.192l-269.248-138.496-292.224 142.08c-34.048 16.64-76.288 4.736-94.4-26.496A59.776 59.776 0 0 1 0 920V192c0-70.72 62.528-128 139.648-128h488.704zM562.88 332.096a43.008 43.008 0 0 0-60.864 1.024L341.056 499.84 264.128 429.12l-4.992-3.968a43.072 43.072 0 0 0-53.184 67.392l107.84 99.072 4.928 3.84c17.024 11.648 40.448 9.6 55.168-5.696l190.08-196.8 4.032-4.928a43.072 43.072 0 0 0-5.12-55.936z" fill="#0E76FF" ></path><path d="M964.48 256a59.52 59.52 0 0 1 59.52 59.52v456.96a59.52 59.52 0 0 1-119.04 0V315.52a59.52 59.52 0 0 1 59.52-59.52z" fill="#0E76FF" ></path></symbol><symbol id="icon-beike" viewBox="0 0 1194 1024"><path d="M664.746667 11.719111c144.213333 0 261.176889 115.256889 261.176889 257.422222v636.871111c0 62.179556-51.2 112.64-114.289778 112.64H267.150222C122.88 1018.652444 5.916444 903.395556 5.916444 761.173333V124.359111c0-62.179556 51.2-112.64 114.289778-112.64h544.540445z m448.284444 179.484445c35.043556 0 63.886222 25.941333 67.811556 59.448888l0.455111 7.850667v592.952889c0 37.205333-30.549333 67.299556-68.266667 67.299556-34.588444 0-63.715556-25.6-67.697778-59.505778l-0.512-7.793778V258.503111c0-37.148444 30.549333-67.299556 68.266667-67.299555z m-498.915555 177.265777l-5.859556 5.688889-172.259556 190.520889-89.486222-76.231111-6.485333-4.835556a60.302222 60.302222 0 0 0-82.602667 17.521778c-14.620444 22.300444-12.344889 51.427556 5.575111 71.168l5.461334 5.176889 133.973333 114.176 6.485333 4.778667c22.186667 14.222222 51.256889 12.401778 71.395556-4.551111l5.745778-5.575111 211.399111-233.870223 5.006222-6.314666a58.368 58.368 0 0 0-16.440889-81.692445 60.416 60.416 0 0 0-71.907555 4.039111z"  ></path></symbol><symbol id="icon-zonghepaixu" viewBox="0 0 1304 1024"><path d="M366.969018 866.769455H34.913745c-19.269818 0-34.909091 27.368727-34.90909 60.974545 0 33.512727 15.639273 60.974545 34.90909 60.974545h332.055273c19.176727 0 34.909091-27.461818 34.909091-60.974545 0-33.512727-15.732364-60.974545-34.909091-60.974545z m71.307637-440.040728H59.675927a60.322909 60.322909 0 0 0-59.578182 60.974546c0 33.512727 26.810182 60.974545 59.578182 60.974545H438.462836a60.509091 60.509091 0 0 0 59.671273-60.974545 60.322909 60.322909 0 0 0-59.578182-60.974546H438.462836zM646.334836 121.949091a60.322909 60.322909 0 0 0 59.671273-60.881455 60.322909 60.322909 0 0 0-59.578182-61.067636H59.675927a60.322909 60.322909 0 0 0-59.112727 52.037818L0.004655 60.974545a60.322909 60.322909 0 0 0 59.578181 60.974546h586.752zM944.318836 1.117091l-4.468363 0.186182 5.306182-0.186182a58.554182 58.554182 0 0 0-43.566546 18.338909L604.257745 326.097455a62.370909 62.370909 0 0 0 0.558546 86.667636l1.582545 1.582545c23.365818 22.341818 60.509091 21.410909 82.757819-2.048l196.421818-203.217454V794.996364l-196.421818-203.217455a58.647273 58.647273 0 0 0-82.85091-2.048l-0.744727 0.744727-0.744727 0.837819a62.370909 62.370909 0 0 0-0.558546 86.667636l297.332364 306.641454c11.170909 11.636364 26.624 18.245818 42.821818 18.33891 19.456 0 36.026182-8.750545 46.917818-22.43491l294.539637-299.752727a62.557091 62.557091 0 0 0-0.279273-86.946909 60.229818 60.229818 0 0 0-85.271273-0.744727l-0.558545 0.558545-194.932364 198.097455V212.340364l194.932364 198.097454a60.509091 60.509091 0 0 0 85.736727-0.186182 62.464 62.464 0 0 0 0.372364-86.946909L991.236655 23.458909a58.926545 58.926545 0 0 0-46.08-22.341818z"  ></path></symbol><symbol id="icon-jiangxu" viewBox="0 0 1303 1024"><path d="M366.969018 866.769455H34.913745c-19.269818 0-34.909091 27.368727-34.90909 60.974545 0 33.512727 15.639273 60.974545 34.90909 60.974545h332.055273c19.176727 0 34.909091-27.461818 34.909091-60.974545 0-33.512727-15.732364-60.974545-34.909091-60.974545z m71.307637-440.040728H59.675927a60.322909 60.322909 0 0 0-59.578182 60.974546c0 33.512727 26.810182 60.974545 59.578182 60.974545H438.462836a60.509091 60.509091 0 0 0 59.671273-60.974545 60.322909 60.322909 0 0 0-59.578182-60.974546H438.462836zM646.241745 0H59.675927a60.322909 60.322909 0 0 0-59.578182 60.881455v0.09309a60.322909 60.322909 0 0 0 59.578182 60.974546h586.658909a60.322909 60.322909 0 0 0 59.671273-60.881455 60.322909 60.322909 0 0 0-59.578182-61.067636h-0.093091z m639.255273 593.92a60.229818 60.229818 0 0 0-85.736727-0.279273l-194.932364 198.097455V62.464a60.509091 60.509091 0 0 0-59.578182-61.346909 60.322909 60.322909 0 0 0-59.764363 61.346909v732.625455L689.156655 591.685818a58.647273 58.647273 0 0 0-84.340364-0.465454 62.370909 62.370909 0 0 0-0.558546 86.667636l297.332364 306.641455a59.298909 59.298909 0 0 0 84.898909 0.744727l0.279273-0.279273s0.186182 0 0.186182-0.186182l298.821818-304.128a62.557091 62.557091 0 0 0-0.186182-86.946909z"  ></path></symbol><symbol id="icon-jinke" viewBox="0 0 1194 1024"><path d="M1102.171218 427.318531c11.945806 112.546554-19.454598 195.313921-94.286536 248.216774 50.385701-23.16633 114.893051-35.922744 185.287977-8.532718-80.634188 92.579993-170.227729 124.236378-268.95128 94.969154-21.331796 19.326607-43.644854 37.458633-66.896511 54.182761 55.974632-10.964543 124.49236-8.19141 187.975783 38.226578-102.307292 68.859036-197.532428 76.111847-285.504753 21.715768-21.459786 11.04987-43.431536 21.075814-65.787258 30.077832l-2.559815 0.938599 14.84693 1.877198 127.393483 14.078985 3.839723 0.725281a24.104929 24.104929 0 0 1-4.820985 47.228596l-4.39435-0.085327-51.025656-5.716922c15.91352 13.567022 29.864514 29.267224 41.426348 46.673969l-14.036322 3.285097c-83.407321 18.046699-152.778321 8.148746-208.070335-29.608533-58.44912 39.890458-132.513115 48.636494-222.14932 26.323436 11.51917-17.406745 25.470164-33.106947 41.383684-46.673969l-50.982992 5.716922-4.39435 0.085327a24.062266 24.062266 0 0 1-0.938599-47.996541l127.308157-14.078985 14.932257-1.834534-2.559816-0.938599c-22.441049-9.002018-44.370135-19.027962-65.829921-30.077832-88.014989 54.396079-183.197461 47.143268-285.46209-21.715768 63.44076-46.503315 131.915824-49.191121 187.93312-38.311905-23.294321-16.638801-45.650043-34.770827-66.981838-54.097434-98.638223 29.267224-188.274429-2.389161-268.865953-94.969154 70.394926-27.390026 134.859612-14.633612 185.245314 8.575382-74.789276-52.945517-106.232342-135.712884-94.286537-248.259438 111.223983 53.329489 137.632746 162.548283 140.363215 225.519744l3.242433 4.010377a719.30815 719.30815 0 0 0 362.000573 231.236665l17.620063-5.034304a719.137496 719.137496 0 0 0 356.070333-240.452l-8.404727 10.239262c2.73047-62.971461 29.096569-172.104927 140.363215-225.519744z m-98.638223-371.215908l2.005189 6.271548 1.493226 6.143557c1.791871 8.959354 2.13318 18.17469 1.023926 27.304698l-63.31277 506.502156a85.241855 85.241855 0 0 1-63.952723 72.10147l-273.857593 68.475064a42.620928 42.620928 0 0 1-20.691841 0l-273.900257-68.475064c-34.130873-8.532718-59.51571-37.159988-63.91006-72.10147L185.117323 95.779763A85.241855 85.241855 0 0 1 286.400689 1.706544l301.844908 60.368981c5.503603 1.109253 11.177861 1.109253 16.681465 0L906.77197 1.706544a85.241855 85.241855 0 0 1 96.761025 54.438742z m-80.634187 7.892764l-3.583742 0.426636-301.844909 60.368982a106.616315 106.616315 0 0 1-33.490919 1.322571l-8.3194-1.279908L273.900256 64.422023a21.246468 21.246468 0 0 0-25.384836 19.625252l0.12799 3.839723 63.31277 506.502156a21.246468 21.246468 0 0 0 12.457768 16.766792l3.498415 1.19458 268.695298 67.195157 268.737962-67.195157a21.246468 21.246468 0 0 0 15.145575-14.334966l0.767945-3.626406L944.571912 87.929662l0.255982-4.479677-1.023927-4.223696-1.151917-3.114442a21.289132 21.289132 0 0 0-19.667915-12.11646z m-326.33381 191.388871l38.14125 77.434418 85.497837 12.372441-61.862207 60.326319 14.590948 85.071201-76.367828-40.14644-76.453156 40.14644 14.633612-85.071201-61.862208-60.326319 85.455174-12.372441 38.226578-77.434418z"  ></path></symbol><symbol id="icon-xunijiaoyanshi" viewBox="0 0 1170 1024"><path d="M1170.285714 0v91.038476h-64.999619v624.249905c0 35.937524-29.110857 65.048381-65.048381 65.048381h-312.905143l211.285334 169.008762-56.807619 71.094857L585.142857 783.11619l-296.667428 237.324191-56.807619-71.094857 211.236571-169.008762H130.048a64.999619 64.999619 0 0 1-65.048381-65.048381V90.940952L0 91.038476V0h1170.285714z m-156.038095 91.184762H156.038095v598.113524h858.209524V91.136z m-188.562286 318.561524v90.989714H344.600381V409.746286h481.084952z m-129.999238-163.84v90.989714h-351.085714V245.906286h351.085714z"  ></path></symbol><symbol id="icon-jingpinMOOC" viewBox="0 0 1024 1024"><path d="M979.006061 12.412121v689.617455L511.689697 1021.734788 44.466424 702.029576V12.412121H979.006061z m-84.495516 84.433455H128.899879v560.624485l382.820848 261.926787 382.789818-261.926787V96.845576zM476.035879 529.904485l256.992969-235.613091 57.095758 62.246788-312.506182 286.502788-220.16-190.836364 55.327031-63.860364 163.250424 141.560243z"  ></path></symbol><symbol id="icon-jiaoxuemingshi" viewBox="0 0 1094 1024"><path d="M987.277241 939.255172h55.084138a36.722759 36.722759 0 0 1 0 73.445518H50.846897a36.722759 36.722759 0 0 1 0-73.445518H105.931034v-165.252413c0-20.268138 16.454621-36.722759 36.722759-36.722759h302.962759a137.145379 137.145379 0 0 1 100.987586 44.06731 137.145379 137.145379 0 0 1 100.987586-44.06731h302.962759c20.268138 0 36.722759 16.454621 36.722758 36.722759v165.252413z m-73.445517 0v-128.529655h-266.24a64.264828 64.264828 0 0 0-64.264827 64.264828v64.264827h330.504827z m-403.950345 0v-64.264827a64.264828 64.264828 0 0 0-64.264827-64.264828H179.376552v128.529655h330.504827z m-137.533793-312.143448a36.722759 36.722759 0 0 1-55.084138 48.09269A486.223448 486.223448 0 0 1 197.737931 370.052414C197.737931 177.363862 353.915586 21.186207 546.604138 21.186207c192.688552 0 348.866207 156.177655 348.866207 348.866207a486.223448 486.223448 0 0 1-119.172414 304.622345 36.722759 36.722759 0 1 1-55.084138-48.304552 412.212966 412.212966 0 0 0 100.811035-256.317793 275.42069 275.42069 0 0 0-550.84138 0 413.131034 413.131034 0 0 0 101.164138 257.05931z m119.172414-165.252414h110.168276a36.722759 36.722759 0 1 1 0 73.445518h-110.168276a36.722759 36.722759 0 0 1 0-73.445518z"  ></path></symbol><symbol id="icon-xia1" viewBox="0 0 1706 1024"><path d="M1640.277333 229.376L936.618667 960.341333a113.322667 113.322667 0 0 1-83.114667 35.84 113.322667 113.322667 0 0 1-83.114667-35.84L66.56 229.376a119.466667 119.466667 0 0 1-27.306667-129.024A129.877333 129.877333 0 0 1 150.016 20.48H1556.48a129.365333 129.365333 0 0 1 110.933333 79.530667 119.125333 119.125333 0 0 1-27.136 129.194666z"  ></path></symbol><symbol id="icon-yiliukecheng" viewBox="0 0 1170 1024"><path d="M1155.657143 318.756571V165.924571C1155.657143 82.541714 1087.085714 14.628571 1002.971429 14.628571H167.314286C83.053714 14.628571 14.628571 82.505143 14.628571 165.924571v562.468572c0 83.419429 68.571429 151.296 152.685715 151.296h35.401143l-67.291429 74.276571 72.045714 65.243429 126.427429-139.52h503.881143l126.464 139.52 72.045714-65.243429-67.328-74.24h34.011429c84.260571 0 152.685714-67.913143 152.685714-151.332571v-317.184h-97.170286v317.330286c0 29.842286-24.868571 54.125714-55.515428 54.125714H167.314286c-30.683429 0-55.515429-24.283429-55.515429-54.125714V165.924571c0-29.842286 24.868571-54.125714 55.515429-54.125714h835.657143c30.683429 0 55.515429 24.283429 55.515428 54.125714v152.868572H1155.657143zM476.16 213.979429a48.274286 48.274286 0 0 0-48.566857 0c-14.994286 8.740571-24.283429 24.685714-24.283429 42.057142v356.022858a48.566857 48.566857 0 0 0 72.850286 42.057142l308.297143-177.956571a48.566857 48.566857 0 0 0 0-84.114286l-308.297143-178.102857z m24.32 313.819428V340.150857l162.523429 93.842286-162.523429 93.805714z"  ></path></symbol><symbol id="icon-shang1" viewBox="0 0 1706 1024"><path d="M1609.386667 787.456L905.557333 56.32a113.322667 113.322667 0 0 0-83.285333-35.84 113.322667 113.322667 0 0 0-83.114667 35.84L35.669333 787.456a119.466667 119.466667 0 0 0-27.306666 129.024c17.92 44.373333 60.757333 75.434667 110.421333 79.530667H1525.76a129.365333 129.365333 0 0 0 110.762667-79.36 119.125333 119.125333 0 0 0-27.136-129.194667z"  ></path></symbol><symbol id="icon-peiyangfangan" viewBox="0 0 1024 1024"><path d="M829.504 0l-92.352 297.76 174.464 249.376L513.472 998.4 112 547.136l174.912-251.712h1.76L196.416 0h633.088z m-159.872 422.08H353.088l-80.224 115.424 176.768 198.656v-187.488h126.624v187.168l174.528-197.76-81.152-115.968z m-12.032-295.456H368.64l48.416 155.104h192.512l48.032-155.104z"  ></path></symbol><symbol id="icon-sousuo2" viewBox="0 0 1024 1024"><path d="M448 51.2a396.8 396.8 0 0 1 334.08 611.072l-4.544 6.656 172.8 172.8a76.8 76.8 0 0 1 10.688 95.168l-5.12 7.168-5.568 6.272a76.8 76.8 0 0 1-102.4 5.568l-6.208-5.568-172.864-172.736-6.592 4.48a394.368 394.368 0 0 1-176 60.928l-19.072 1.28-19.2 0.512A396.8 396.8 0 0 1 448 51.2z m0 89.6a307.2 307.2 0 1 0 0 614.4 307.2 307.2 0 0 0 0-614.4z"  ></path></symbol><symbol id="icon-zhuanrenjiaoshi" viewBox="0 0 1057 1024"><path d="M373.925161 783.690323l54.007742 55.692387v-327.779097h-23.188645l-30.819097 272.08671z m54.503226-272.08671v327.779097l53.97471-55.692387-30.819097-272.08671h-23.188645 0.033032z m239.946323-235.189678C668.37471 134.903742 558.146065 19.819355 422.680774 19.819355 287.149419 19.819355 177.019871 134.936774 177.019871 276.413935a260.294194 260.294194 0 0 0 94.307097 201.694968C120.369548 541.068387 13.212903 695.196903 13.212903 875.057548c4.426323 85.553548 38.845935 128.29729 103.225807 128.264258H734.637419c59.788387 0.033032 92.226065-42.71071 97.610323-128.231225 0-179.959742-107.090581-334.022194-258.180129-397.047742a260.129032 260.129032 0 0 0 94.307097-201.628904z m-67.253678 0c0 122.648774-88.064 184.650323-178.374193 184.650323-90.343226 0-177.284129-62.067613-177.284129-184.650323 0-122.549677 86.940903-185.013677 177.251096-185.013677 90.343226 0 178.407226 62.430968 178.407226 185.04671v-0.033033z m99.955613 660.645162H149.20671c-34.023226 0-61.572129-27.747097-61.572129-62.001549 0-188.614194 140.816516-357.640258 335.14529-357.640258 194.26271 0 339.901935 168.993032 339.901935 357.640258a61.803355 61.803355 0 0 1-61.605161 62.034581z m209.127226-668.341678c-20.083613-71.415742-75.181419-121.789935-144.020645-141.080774-21.867355-6.077935-40.96-7.46529-46.839742 15.260903-5.879742 22.792258 10.96671 36.864 32.768 43.041033 50.209032 14.170839 90.178065 68.773161 94.208 122.88 3.996903 54.106839-32.701935 105.372903-80.136258 127.504516-4.954839 2.246194-9.381161 5.450323-13.047742 9.447226-0.330323 0.429419-0.72671 0.627613-1.024 1.057032-2.510452 3.038968-4.624516 6.408258-6.177032 10.041806a44.263226 44.263226 0 0 0-2.312258 5.351226c-0.330323 0.990968-0.990968 1.717677-1.189162 2.77471-0.429419 1.684645 0 3.402323-0.165161 5.186064a43.041032 43.041032 0 0 0-0.330323 9.843613c0.264258 1.651613 0.594581 3.303226 1.057033 4.954839 0.495484 2.675613 0.495484 5.450323 1.651613 8.026839 5.549419 13.345032 17.672258 22.726194 31.876129 24.708129 112.706065 8.192 197.103484 144.450065 196.707096 248.435613v66.13058c0.396387 23.353806 7.300129 42.050065 29.629936 42.050065 22.362839 0 31.644903-18.696258 32.04129-42.050065v-66.13058c-0.396387-148.413935-75.47871-254.546581-188.614193-303.896775 63.917419-53.181935 84.001032-122.021161 63.917419-193.536z"  ></path></symbol><symbol id="icon-jiaoxuechengguo" viewBox="0 0 1024 1024"><path d="M512.029013 1024c61.610667 0 118.897778-15.416889 171.804445-46.307556a354.076444 354.076444 0 0 0 123.249778-123.164444A333.596444 333.596444 0 0 0 853.333902 683.804444a333.937778 333.937778 0 0 0-45.027555-169.443555 327.964444 327.964444 0 0 0-116.138667-120.974222L849.380124 9.614222A6.912 6.912 0 0 0 843.008569 0h-66.844445a6.912 6.912 0 0 0-6.343111 4.266667l-146.432 356.039111c-25.400889-8.533333-51.569778-14.506667-78.165333-17.777778L682.240569 9.528889A6.912 6.912 0 0 0 675.840569 0h-66.787556a6.912 6.912 0 0 0-6.428444 4.266667L462.222791 344.917333c-21.304889 3.185778-41.813333 8.277333-61.610667 15.416889L254.180124 4.266667A6.912 6.912 0 0 0 247.808569 0H181.049458a6.912 6.912 0 0 0-6.428445 9.528889L333.085013 392.305778a334.165333 334.165333 0 0 0-117.504 122.026666A333.909333 333.909333 0 0 0 170.667236 683.804444c0 60.814222 15.416889 117.703111 46.250666 170.666667a354.076444 354.076444 0 0 0 123.249778 123.249778 335.758222 335.758222 0 0 0 171.861333 46.193778V1024zM434.916124 234.666667l40.305778-100.750223L421.262791 4.266667A6.912 6.912 0 0 0 415.005013 0h-66.844444a6.912 6.912 0 0 0-6.371556 9.528889l93.184 225.166222H434.916124z m76.999112 713.443555c-48.184889 0-92.615111-11.832889-133.262223-35.555555a263.395556 263.395556 0 0 1-96.597333-96.568889A260.209778 260.209778 0 0 1 246.443236 682.666667c0-48.184889 11.889778-92.615111 35.584-133.347556a263.395556 263.395556 0 0 1 96.654222-96.483555A260.209778 260.209778 0 0 1 512.000569 417.251556c48.241778 0 92.615111 11.832889 133.404444 35.555555a263.395556 263.395556 0 0 1 96.512 96.568889 260.323556 260.323556 0 0 1 35.612445 133.347556 260.323556 260.323556 0 0 1-35.612445 133.347555 263.395556 263.395556 0 0 1-96.568889 96.426667A260.209778 260.209778 0 0 1 512.000569 948.053333l-0.142222 0.056889z m108.544-119.751111l-19.569778-92.615111a13.824 13.824 0 0 1 4.352-13.198222l69.973333-62.776889a13.824 13.824 0 0 0-7.765333-24.064l-93.724445-10.296889a13.824 13.824 0 0 1-11.121777-8.163556l-38.030223-86.186666a13.824 13.824 0 0 0-25.315555 0l-37.944889 86.186666a13.824 13.824 0 0 1-11.121778 8.163556l-93.724444 10.382222a13.824 13.824 0 0 0-7.765334 23.978667l69.973334 62.776889c3.697778 3.271111 5.347556 8.277333 4.352 13.112889l-19.569778 92.643555a13.824 13.824 0 0 0 20.48 14.876445l81.066667-47.217778a13.824 13.824 0 0 1 13.909333 0l81.066667 47.217778a13.824 13.824 0 0 0 20.48-14.791111z"  ></path></symbol><symbol id="icon-yiliuzhuanye" viewBox="0 0 1024 1024"><path d="M997.888 174.272c9.984 6.592 13.312 16.48 13.312 26.368v672.16c0 16.48-9.984 29.664-26.624 32.96L518.656 1011.2h-13.312l-465.92-105.44C22.784 902.464 12.8 889.28 12.8 872.8V200.64c0-9.888 3.328-19.776 13.312-26.368 6.656-6.592 16.64-6.592 26.624-6.592L512 273.12 971.264 167.68a26.048 26.048 0 0 1 26.624 6.592zM944.64 243.52l-410.752 92.096v604.672l410.752-93.792V243.488z m-865.28 0v602.976l387.168 88.448V330.304L79.36 243.488z m814.88-203.392c6.72 16.64-6.72 33.28-23.584 36.64L506.944 160h-13.44L153.312 83.392c-16.832-3.328-30.304-23.328-23.584-40 6.72-16.64 23.584-29.952 40.416-26.624l330.048 76.608L853.824 13.44c16.832-3.328 37.024 6.656 40.416 26.656z"  ></path></symbol><symbol id="icon-gengduo1" viewBox="0 0 1024 1024"><path d="M512 1024c-282.624 0-512-229.952-512-512s229.952-512 512-512 512 229.952 512 512-229.952 512-512 512zM512 47.552C256.576 47.552 47.552 256 47.552 512 47.552 768 256 976.448 512 976.448c256 0 464.448-208.448 464.448-464.448C976.448 256 768 47.552 512 47.552z m60.608 672.896l-33.984-33.984L713.6 511.36 538.624 336.448l33.92-33.984 208.512 208.96-208.448 209.024zM276.416 487.616h449.664v48.192H276.48v-48.192z"  ></path></symbol><symbol id="icon-benkezhuanye" viewBox="0 0 1094 1024"><path d="M297.313103 543.744v84.638897H238.097655a139.475862 139.475862 0 0 0-139.334621 139.33462 139.475862 139.475862 0 0 0 139.334621 139.299311H910.30069a222.914207 222.914207 0 0 1-48.798897-139.299311 222.808276 222.808276 0 0 1 48.798897-139.33462H430.362483v-84.638897H1085.44v84.638897a139.475862 139.475862 0 0 0-139.334621 139.33462 139.475862 139.475862 0 0 0 139.334621 139.299311v84.674206H238.097655a223.973517 223.973517 0 1 1 0-447.947034H297.313103z m66.52469-236.332138c23.375448 0 42.301793 18.926345 42.301793 42.301793v338.626207a42.337103 42.337103 0 1 1-84.638896 1.412414v-340.038621c0-23.375448 18.961655-42.301793 42.337103-42.301793zM861.466483 28.248276a223.973517 223.973517 0 1 1 0 447.947034h-431.139311V391.591724h431.139311a139.475862 139.475862 0 0 0 139.33462-139.334621 139.475862 139.475862 0 0 0-139.33462-139.33462H189.298759a222.878897 222.878897 0 0 1 48.798896 139.33462 222.808276 222.808276 0 0 1-48.798896 139.334621H297.313103v84.638897H14.124138V391.591724a139.475862 139.475862 0 0 0 139.334621-139.334621A139.475862 139.475862 0 0 0 14.124138 112.887172V28.248276z"  ></path></symbol><symbol id="icon-suolvetu" viewBox="0 0 1024 1024"><path d="M341.357714 597.357714c56.832 0 85.284571 28.452571 85.284572 85.284572v256c0 56.905143-28.452571 85.357714-85.284572 85.357714h-256C28.452571 1024 0 995.547429 0 938.642286v-256c0-56.832 28.452571-85.284571 85.357714-85.284572h256z m597.284572 0c56.905143 0 85.357714 28.452571 85.357714 85.284572v256c0 56.905143-28.452571 85.357714-85.357714 85.357714h-256c-56.832 0-85.284571-28.452571-85.284572-85.357714v-256c0-56.832 28.452571-85.284571 85.284572-85.284572h256zM341.357714 0c56.832 0 85.284571 28.452571 85.284572 85.357714v256c0 56.832-28.452571 85.284571-85.284572 85.284572h-256C28.452571 426.642286 0 398.189714 0 341.357714v-256C0 28.452571 28.452571 0 85.357714 0h256z m597.284572 0C995.547429 0 1024 28.452571 1024 85.357714v256c0 56.832-28.452571 85.284571-85.357714 85.284572h-256c-56.832 0-85.284571-28.452571-85.284572-85.284572v-256C597.357714 28.452571 625.810286 0 682.642286 0h256z"  ></path></symbol><symbol id="icon-gonggao" viewBox="0 0 1080 1024"><path d="M545.792 0l307.256889 266.979556h195.413333v750.023111H0V267.036444l234.894222-0.056888L545.792 0z m416.256 349.468444H86.471111v585.102223H961.991111V349.468444z m-62.805333 431.957334v93.866666H149.219556v-93.866666h750.023111z m0-176.696889v93.866667H149.219556v-93.866667h750.023111zM447.658667 428.032v93.866667H149.219556v-93.866667h298.439111z m98.133333-302.364444L383.715556 266.979556h327.566222L545.792 125.667556z"  ></path></symbol><symbol id="icon-banji" viewBox="0 0 1024 1024"><path d="M906.24 475.766154v450.56c0 16.935385-5.198769 22.212923-21.819077 22.212923H155.017846c-29.696 0-52.460308-18.510769-57.107692-46.867692a74.752 74.752 0 0 1-0.708923-11.185231V61.203692C97.201231 27.175385 121.304615 3.308308 155.254154 3.308308h730.505846c14.493538 0 20.401231 5.986462 20.401231 20.637538l0.078769 451.820308zM232.211692 811.323077c0 1.339077 1.024 2.363077 2.284308 2.363077h372.499692c74.830769 0 149.819077-0.157538 224.728616 0.078769 6.301538 0 7.640615-1.811692 7.404307-7.640615a1370.742154 1370.742154 0 0 1 0-52.932923c0.078769-5.513846-1.260308-7.325538-7.168-7.325539l-597.464615 0.393846a2.284308 2.284308 0 0 0-2.363077 2.363077v62.779077z m211.101539-403.298462h251.273846a9.137231 9.137231 0 0 0 9.058461-9.058461V282.781538a9.137231 9.137231 0 0 0-9.058461-9.13723H443.707077a9.137231 9.137231 0 0 0-9.058462 9.13723l-0.315077 116.184616a8.900923 8.900923 0 0 0 8.979693 9.137231z"  ></path></symbol><symbol id="icon-biao" viewBox="0 0 1024 1024"><path d="M170.666667 0h682.666666v1024l-346.794666-159.197867L170.666667 1024z"  ></path></symbol><symbol id="icon-xuefen" viewBox="0 0 1280 1024"><path d="M967.462512 642.111648v94.874854c0 191.54141-150.502916 281.382436-339.655391 286.757541l-18.428928 0.255957c-197.684386 0-358.084319-88.731878-358.084319-287.013498v-94.704216l338.546242 203.05949a35.834028 35.834028 0 0 0 36.51658 0l341.105816-203.230128zM627.551164 5.204466l573.344443 338.375604a35.834028 35.834028 0 0 1 0 61.6004l-18.258291 11.51808v270.802866a33.871688 33.871688 0 0 1-27.046159 33.103816l-6.825529 0.767872h-4.009998a33.871688 33.871688 0 0 1-33.274454-27.046158l-0.597234-6.82553V458.675554L627.551164 743.641393a35.834028 35.834028 0 0 1-36.51658 0L17.77546 405.265789a35.834028 35.834028 0 0 1 0-61.6004L591.034584 5.204466a35.834028 35.834028 0 0 1 36.51658 0z"  ></path></symbol><symbol id="icon-tongzhi" viewBox="0 0 1024 1024"><path d="M702.149779 238.948011c34.150058 0 60.927391 26.777332 60.92739 60.92739v524.180358c0 34.150058-26.777332 60.927391-60.92739 60.927391h-90.213498v78.079219c0 21.913381-12.185478 43.877961-34.098859 53.605864a49.151508 49.151508 0 0 1-26.828532 7.321527c-12.185478 0-24.370956-4.863951-36.556435-12.185478l-170.699093-126.769932H60.927391c-34.098859 0-60.927391-26.828532-60.927391-60.927391V299.824202c0-34.150058 26.828532-60.927391 60.927391-60.927391h641.222388z m-12.185479 73.112868H73.215268v499.809402h275.453245c12.236678 0 26.828532 4.863951 36.607634 12.185478l153.598464 114.584455v-65.791342c0-17.100629 7.321527-31.743683 17.04943-43.929161 12.185478-12.185478 26.828532-17.04943 43.877961-17.04943h90.213498V312.060879zM963.062369 0C997.161228 0 1023.98976 26.828532 1023.98976 60.927391v548.602514c0 34.098859-26.828532 60.927391-60.927391 60.92739h-102.398976a37.478025 37.478025 0 0 1-36.607634-36.556434c0-19.507005 17.100629-36.556434 36.607634-36.556434h90.162299V73.164068H260.861391v82.891971a37.478025 37.478025 0 0 1-36.556434 36.556435 37.478025 37.478025 0 0 1-36.556434-36.556435V60.927391C187.748523 26.828532 214.525855 0 248.675913 0H963.062369z"  ></path></symbol><symbol id="icon-kechengbiao" viewBox="0 0 1152 1024"><path d="M960 26.688a186.688 186.688 0 0 1 186.688 186.624v597.376A186.688 186.688 0 0 1 960 997.312H213.312a186.688 186.688 0 0 1-186.624-186.624V213.312A186.688 186.688 0 0 1 213.312 26.688z m112 266.496H101.312v517.504A112 112 0 0 0 204.16 922.24l9.152 0.384H960a112 112 0 0 0 112-112V293.12zM330.688 704a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z m256 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z m256 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z m-512-192a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z m256 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z m256 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312z"  ></path></symbol><symbol id="icon-qiehuan1" viewBox="0 0 1024 1024"><path d="M74.313143 277.211429S163.84 137.874286 305.225143 63.122286c141.531429-74.678857 315.830857-53.174857 430.08 19.236571 114.395429 72.411429 152.868571 133.558857 152.868571 133.558857l98.450286-56.539428s20.406857-10.24 20.406857 13.531428v355.474286s0 31.670857-23.771428 20.333714c-20.041143-9.508571-236.251429-133.632-304.420572-172.763428-37.449143-16.822857-4.534857-30.500571-4.534857-30.500572l95.012571-54.857143s-54.198857-68.461714-133.558857-104.740571c-84.845714-44.617143-164.425143-49.883429-261.851428-12.8-63.414857 24.137143-138.24 86.089143-192.073143 177.590857l-107.52-73.581714z m882.834286 469.577142s-89.380571 139.264-230.838858 214.016c-141.458286 74.678857-315.830857 53.174857-430.08-19.236571-114.395429-72.411429-152.868571-133.558857-152.868571-133.558857l-98.450286 56.539428s-20.406857 10.24-20.406857-13.531428v-355.474286s0-31.670857 23.771429-20.333714c20.041143 9.508571 236.251429 133.558857 304.420571 172.763428 37.449143 16.822857 4.534857 30.500571 4.534857 30.500572l-95.012571 54.857143s54.198857 68.461714 133.558857 104.740571c84.845714 44.617143 164.425143 49.883429 261.851429 12.8 63.414857-24.137143 138.24-86.089143 192.073142-177.590857l107.52 73.581714z"  ></path></symbol><symbol id="icon-daohangguanli" viewBox="0 0 1024 1024"><path d="M972.8 64H358.4c-30.72 0-51.2 20.48-51.2 51.2v51.2c0 30.72 20.48 51.2 51.2 51.2h614.4c30.72 0 51.2-20.48 51.2-51.2v-51.2c0-30.72-20.48-51.2-51.2-51.2zM102.4 64H51.2c-25.6 0-51.2 25.6-51.2 51.2v51.2c0 25.6 25.6 51.2 51.2 51.2h51.2c25.6 0 51.2-25.6 51.2-51.2v-51.2c0-25.6-25.6-51.2-51.2-51.2z m0 358.4H51.2c-25.6 0-51.2 25.6-51.2 51.2v51.2c0 25.6 25.6 51.2 51.2 51.2h51.2c25.6 0 51.2-25.6 51.2-51.2v-51.2c0-25.6-25.6-51.2-51.2-51.2z m870.4 0H358.4c-30.72 0-51.2 20.48-51.2 51.2v51.2c0 30.72 20.48 51.2 51.2 51.2h614.4c30.72 0 51.2-20.48 51.2-51.2v-51.2c0-30.72-20.48-51.2-51.2-51.2zM102.4 780.8H51.2c-25.6 0-51.2 25.6-51.2 51.2v51.2c0 25.6 25.6 51.2 51.2 51.2h51.2c25.6 0 51.2-25.6 51.2-51.2V832c0-25.6-25.6-51.2-51.2-51.2z m870.4 0H358.4c-30.72 0-51.2 20.48-51.2 51.2v51.2c0 30.72 20.48 51.2 51.2 51.2h614.4c30.72 0 51.2-20.48 51.2-51.2V832c0-30.72-20.48-51.2-51.2-51.2z"  ></path></symbol><symbol id="icon-gongzuotai" viewBox="0 0 1024 1024"><path d="M931.968 92.032v622.592H92.032V92.032h839.936m0-92.032H92.032C41.216 0 0 41.216 0 92.032v622.592c0 50.816 41.216 92.032 92.032 92.032h839.936c50.816 0 92.032-41.216 92.032-92.032V92.032C1024 41.216 982.784 0 931.968 0z m-11.84 1017.6H104.512a46.08 46.08 0 1 1 0-92.032h815.616a46.08 46.08 0 1 1 0 92.032zM307.776 632.832a46.08 46.08 0 0 1-46.08-46.08V345.216a46.08 46.08 0 1 1 92.16 0V586.88a46.08 46.08 0 0 1-46.08 46.016z m409.088 0a46.08 46.08 0 0 1-46.08-46.08V469.248a46.08 46.08 0 1 1 92.16 0v117.632a46.08 46.08 0 0 1-46.08 46.016zM512 632.832a46.08 46.08 0 0 1-46.08-46.08V223.808a46.08 46.08 0 1 1 92.16 0v363.072a46.08 46.08 0 0 1-46.08 46.016z"  ></path></symbol><symbol id="icon-zhibo" viewBox="0 0 1024 1024"><path d="M832 521.728l146.112-70.528A32 32 0 0 1 1024 480v353.6a32 32 0 0 1-45.888 28.8L832 791.808V928a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64v-512a64 64 0 0 1 64-64h704a64 64 0 0 1 64 64v105.728z m0 198.528l125.76 60.736V532.544L832 593.28v126.976zM64 416v512h704v-512H64zM512 320a128 128 0 1 1 0-256 128 128 0 1 1 0 256z m0-64a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM256 320a96 96 0 1 1 0-192 96 96 0 1 1 0 192z m0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z m64 535.104v-256a32 32 0 0 1 47.872-27.776l224 128a32 32 0 0 1 0 55.616l-224 128A32 32 0 0 1 320 791.04z m64-200.832V736l127.488-72.896L384 590.272z"  ></path></symbol><symbol id="icon-jiaoshiguanlibeifen" viewBox="0 0 1024 1024"><path d="M1007.104 429.056a39.616 39.616 0 0 0-29.184-6.656 39.744 39.744 0 0 0-25.088 16.384L747.52 745.6l-4.096-8.192a394.368 394.368 0 0 0-196.096-193.6l-8.192-3.584 7.168-5.12a262.4 262.4 0 0 0 100.864-246.272 260.992 260.992 0 0 0-100.864-172.544 256.512 256.512 0 0 0-191.488-49.664A255.936 255.936 0 0 0 184.32 168.448c-86.016 115.712-62.976 280.064 51.2 366.592l7.168 5.632-8.192 3.584A393.856 393.856 0 0 0 0 905.216v39.488h782.336v-39.424a400.512 400.512 0 0 0-6.656-65.536l-0.512-3.584 3.072-2.048a38.4 38.4 0 0 0 9.728-8.704l229.888-343.616a38.72 38.72 0 0 0-10.752-52.736zM209.92 327.168c0-100.864 81.408-183.296 181.248-183.296 99.84 0 181.248 81.92 181.248 183.296 0 101.376-81.408 183.296-181.248 183.296-99.84 0-181.248-82.432-181.248-183.296z m-130.048 539.2l1.024-6.144c19.456-138.24 129.024-248.32 265.728-268.352 171.008-25.088 330.24 95.296 354.816 268.352l1.024 6.144H79.872z m707.584-544.32h132.096a39.04 39.04 0 0 0 38.912-39.424 39.04 39.04 0 0 0-38.912-39.424h-132.096a39.04 39.04 0 0 0-38.912 39.424 39.04 39.04 0 0 0 38.912 39.424z m176.128-256.512h-220.16a39.04 39.04 0 0 0-38.912 39.424c0 21.504 17.408 39.424 38.912 39.424h220.16a39.04 39.04 0 0 0 38.912-39.424 39.04 39.04 0 0 0-38.912-39.424z"  ></path></symbol><symbol id="icon-quanxianshezhibeifen" viewBox="0 0 1024 1024"><path d="M537.327806 2.110651L535.025278 0l398.912945 119.47561c19.123773 6.587788 32.619144 22.449646 35.177509 41.253624l0.447713 4.093383-0.063959 499.584578c-13.239535 71.314403-93.380295 151.519122-218.100552 234.921797a1811.961477 1811.961477 0 0 1-136.68061 82.315369l-26.543029 14.262881c-14.198922 7.547175-26.159274 13.62329-35.241467 18.036468l-4.029424 1.982732c-20.275037 9.018234-43.684069 9.849702-64.598697 2.302528l-14.134962-5.692361-4.157342-1.726895a1208.57127 1208.57127 0 0 1-48.033289-21.49026 1207.10021 1207.10021 0 0 1-145.698844-81.164106c-109.689867-72.081913-183.754512-151.071409-206.07624-236.200979L64.286257 663.639685V165.014494c0-18.228345 13.943085-37.2242 32.107471-44.38762l3.709628-1.279182L482.770688 5.052769c11.640557-3.517751 27.566375-4.860892 42.532806-4.093382l6.395911 0.447713 5.628401 0.639591zM508.993922 66.51747l-5.052769 0.703551L134.513356 177.806315l-0.127919 478.605991c15.73394 60.12156 70.610853 123.568993 158.938379 184.969735l9.593866 6.523829 9.977621 6.715706c56.923604 37.096282 117.36496 69.203753 180.620515 95.810741l18.036468 7.419257 5.116729-0.447714a1744.868375 1744.868375 0 0 0 201.663061-116.789328c80.780351-54.812954 138.08771-106.555871 165.782004-150.303899 5.436524-8.314684 9.849702-17.14104 13.047657-25.903438l2.17461-6.395911V177.806315L530.100427 67.348939a71.634199 71.634199 0 0 0-21.106505-0.76751z m0.447714 158.938379c88.455444 0 161.816539 63.70327 168.340367 146.018639l0.319796 5.75632 0.127918 5.75632c-0.063959 73.233177-54.109404 136.744569-130.476577 153.373936v71.506281h51.103326c18.548141 0 34.218122 12.280148 37.735873 28.973475l0.575632 3.453792 0.127918 3.453791c0 18.548141-15.03039 33.898326-34.729795 35.8171l-3.709628 0.191877h-51.167285l0.063959 110.841131a36.648568 36.648568 0 0 1-31.148084 35.04959l-3.58171 0.511673-3.709628 0.127918c-19.571486 0.255836-36.136895-13.431412-38.247546-31.595798l-0.255836-4.157342 1.535018-253.853692c-90.949849-19.187732-148.001372-103.613752-127.34258-188.487486 16.885204-69.651467 81.867656-119.987283 158.234828-122.673566l6.204034-0.063959z m-53.022099 72.401708c-32.619144 17.588754-52.702303 50.016021-52.702304 85.19353 0 50.527694 40.933828 92.740704 94.851355 97.857432l5.372565 0.383755 5.372565 0.127918c58.266746 0 105.532525-44.195742 105.404606-98.624942 0-12.791821-2.686282-25.583642-7.930929-37.352118l-2.8142-5.820278-3.261915-5.75632c-29.229312-47.137861-93.828009-63.255556-144.291743-36.008977z"  ></path></symbol><symbol id="icon-zixun" viewBox="0 0 1151 1024"><path d="M940.037888 0c49.468908 0 89.530404 40.445472 89.5944 90.23436v704.787951a90.042372 90.042372 0 0 1-89.5944 90.23436H624.409614L550.302246 1005.249172a38.333604 38.333604 0 0 1-32.893944 18.750828l-3.071808-0.127992a38.3976 38.3976 0 0 1-32.63796-24.190488l-58.620336-114.360853H95.290684a90.042372 90.042372 0 0 1-89.5944-90.23436V90.23436A90.042372 90.042372 0 0 1 95.290684 0h844.747204zM95.290684 77.307168a12.991188 12.991188 0 0 0-12.7992 12.863196v704.851947c0.063996 7.03956 5.75964 12.7992 12.7992 12.863196h353.833886a38.3976 38.3976 0 0 1 35.645772 24.31848l32.63796 82.298857 52.348728-87.866509a38.269608 38.269608 0 0 1 32.95794-18.814824h337.258922a12.991188 12.991188 0 0 0 12.7992-12.7992V90.23436a12.991188 12.991188 0 0 0-12.7992-12.927192H95.290684z m95.290045 299.885257a71.483532 71.483532 0 0 1 71.931504 0c22.270608 12.927192 35.965752 36.861696 35.965752 62.780077 0 40.061496-32.189988 72.571464-71.931504 72.571464a72.251484 72.251484 0 0 1-71.9955-72.571464c0-25.91838 13.75914-49.852884 36.029748-62.780077z m290.477845 0a71.483532 71.483532 0 0 1 71.931504 0c22.270608 12.927192 36.029748 36.861696 36.029748 62.780077 0 40.061496-32.253984 72.571464-71.9955 72.571464a72.251484 72.251484 0 0 1-71.9955-72.571464c0-25.91838 13.75914-49.852884 36.029748-62.780077z m292.525717 0a71.483532 71.483532 0 0 1 71.9955 0c22.270608 12.927192 35.965752 36.861696 35.965752 62.780077s-13.695144 49.91688-35.965752 62.844072a71.483532 71.483532 0 0 1-71.9955 0 72.63546 72.63546 0 0 1-35.965752-62.844072c0-25.91838 13.75914-49.852884 35.965752-62.780077z"  ></path></symbol><symbol id="icon-yonghu" viewBox="0 0 1024 1024"><path d="M406.976 0c13.184 0 25.472 6.592 32.768 17.536L574.08 219.008h413.952c18.304 0 35.968 17.728 35.968 41.728v722.56c0 19.456-17.664 37.12-35.968 37.12H42.752c-25.088 0-42.752-17.664-42.752-37.12V39.36C0 17.6 17.664 0 39.36 0H407.04z m541.696 293.312H78.72V948.48h869.888V293.312zM581.056 384.448a149.312 149.312 0 0 1 33.664 231.936 241.792 241.792 0 0 1 133.568 216.128 40.32 40.32 0 0 1-80.64 0c0-88.96-72.32-161.28-161.28-161.28-88.896 0-161.28 72.32-161.28 161.28a40.32 40.32 0 0 1-80.576 0c0-94.464 54.4-176.448 133.568-216.256a149.312 149.312 0 0 1 182.976-231.808z m-74.624 60.672a68.608 68.608 0 1 0-0.064 137.216 68.608 68.608 0 0 0 0-137.216zM385.92 78.72h-307.2v140.224h400.704L385.92 78.784z"  ></path></symbol><symbol id="icon-kechengguanlibeifen" viewBox="0 0 1024 1024"><path d="M488.38656 69.888H356.67456a54.528 54.528 0 0 0-54.72 55.04v822.656c0 30.528 24.768 55.04 54.72 55.04h131.712a55.04 55.04 0 0 0 54.784-55.04V124.992a53.952 53.952 0 0 0-54.784-55.04z m-11.968 842.944c0 13.568-11.072 23.744-23.936 23.744h-59.84a23.808 23.808 0 0 1-24-23.68V160.512c0-13.568 11.136-23.744 24-23.744h59.84c13.696 0 23.936 11.008 23.936 23.68v752.32z m545.728-12.672l-215.552-795.52a50.432 50.432 0 0 0-25.6-33.024 55.68 55.68 0 0 0-41.984-5.952l-127.36 33.92A53.12 53.12 0 0 0 573.05856 166.4l214.656 794.688a55.36 55.36 0 0 0 53.056 40.64c4.288 0 9.408-0.832 13.696-1.664l127.424-33.92a52.928 52.928 0 0 0 40.192-66.048z m-91.52 11.84c-17.088 4.224-37.632 10.24-58.176 15.296a24.64 24.64 0 0 1-29.888-16.96c-11.968-46.592-39.36-146.56-97.536-363.52l-97.536-363.392c-3.392-12.736 4.288-25.408 17.152-29.632 17.088-4.224 37.632-10.24 58.176-15.296 12.8-3.392 26.496 4.288 29.888 16.96 11.968 46.592 39.36 146.56 97.536 363.52l98.368 363.392c2.56 13.568-5.12 26.24-17.92 29.632zM187.33056 69.888H54.72256a54.528 54.528 0 0 0-54.72 55.04v822.656c0 30.528 24.832 55.04 54.72 55.04h131.776a55.04 55.04 0 0 0 54.72-55.04V124.992a53.76 53.76 0 0 0-53.888-55.04zM175.36256 912.896c0 13.504-11.136 23.68-23.936 23.68H91.52256a23.808 23.808 0 0 1-23.936-23.68V160.576c0-13.568 11.136-23.744 23.936-23.744h59.904c13.632 0 23.936 11.008 23.936 23.68v752.384z"  ></path></symbol><symbol id="icon-jichu" viewBox="0 0 1024 1024"><path d="M0 64v938.688h1024V64H0z m938.688 853.312H85.312v-614.4h853.376v614.4zM588.8 610.112h102.4V541.888h136.512v-59.776H691.2V413.888H588.8v68.224H196.288v59.776H588.8v68.224z m-179.2 25.6H307.2V704H196.288v59.712H307.2v76.8h102.4v-68.224h426.688v-59.776H409.6v-76.8z"  ></path></symbol><symbol id="icon-shou" viewBox="0 0 1024 1024"><path d="M533.205344 6.673386l5.11959 4.223662 474.714023 470.042397c12.926966 12.798976 14.334853 32.701384 4.223662 47.100232l-4.287657 5.11959-4.607631 3.455724c-18.302536 11.263099-64.37885 17.790577-82.233422 8.575314l-4.159667-2.87977-37.117031-36.733061v481.49748a37.117031 37.117031 0 0 1-31.229501 36.477082l-6.079514 0.447964H176.36989c-18.558515 0-33.917287-13.438925-36.861051-30.973522l-0.447964-5.951524-0.063995-484.24926-39.804815 39.420846c-9.407247 9.343253-58.683305 3.839693-71.546277 0.447964a36.733061 36.733061 0 0 1-21.11831-56.699464l4.351652-5.11959L136.37309 356.533397V184.323174c0-18.174546 20.862331-32.893369 46.524278-32.893368 22.846172 0 41.788657 11.647068 45.75634 27.005839l0.703943 5.887529v80.185585L485.593153 10.897048a37.564995 37.564995 0 0 1 47.612191-4.223662zM510.679146 134.919126L236.333093 406.449404v509.271258h548.564115l-0.063995-509.207263-274.218062-271.594273zM624.590033 710.425086c25.725942 0 46.524278 20.606351 46.524278 46.076314a46.204304 46.204304 0 0 1-40.188785 45.62835l-6.335493 0.383969H398.560115a46.268299 46.268299 0 0 1-46.524278-46.076314c0-23.230142 17.470602-42.492601 40.188785-45.564355l6.335493-0.447964H624.590033z"  ></path></symbol><symbol id="icon-menhu" viewBox="0 0 1092 1024"><path d="M772.096683 866.304a56.456533 56.456533 0 0 1 7.714133 112.366933l-7.714133 0.546134H320.171349a56.456533 56.456533 0 0 1-7.714133-112.4352l7.714133-0.546134h451.925334zM1035.742549 0c31.197867 0 56.5248 25.258667 56.5248 56.456533v677.956267c0 31.266133-25.258667 56.5248-56.5248 56.5248H56.457216A56.456533 56.456533 0 0 1 0.000683 734.4128V56.5248C0.000683 25.258667 25.259349 0 56.457216 0h979.285333z m-56.5248 113.0496H113.050283V677.888h866.167466V113.0496zM455.748949 240.981333a56.456533 56.456533 0 0 1 7.645867 112.4352l-7.645867 0.546134H305.084416a56.456533 56.456533 0 0 1-7.645867-112.4352l7.645867-0.546134h150.664533z"  ></path></symbol><symbol id="icon-tishi" viewBox="0 0 1024 1024"><path d="M511.557856 0.002194A509.947265 509.947265 0 0 0 0.001463 509.071753c-0.585137 283.791651 225.058482 513.458089 505.705018 514.920933 287.81447 1.462844 517.700336-224.32706 518.285473-509.069559 0.585137-286.863622-226.448183-515.067217-512.434098-514.920933z m1.901696 958.308816c-251.609092 0.365711-448.142124-197.337596-447.33756-449.824395C66.999698 260.607774 264.776147 65.171875 513.898405 65.610728c247.805699 0.438853 443.97302 197.776449 443.97302 446.532996-0.073142 248.683405-196.386748 445.801575-444.411873 446.167286zM461.748032 427.152514c0 55.07606-0.511995 110.078978 0.219427 165.155037 0.438853 36.132236 20.114099 47.834984 56.246335 46.884137 36.863658-1.02399 36.571089-22.308364 37.375653-48.054411 3.291398-96.693959 6.217085-193.387919 12.214743-290.008736 2.559976-42.349321-4.681099-63.48741-55.880624-63.487411-51.638378 0-58.660027 22.015796-55.588055 63.999406l5.412521 125.511978z m116.588632 333.455189c-6.217085 40.447624-28.525449 62.317136-67.363946 63.048557-35.839667 0.731422-61.951425-18.79754-65.023396-53.832643-3.437682-39.496776 22.82036-61.439429 61.146861-63.926263 39.27735-2.559976 61.220003 20.552952 71.240481 54.710349z"  ></path></symbol><symbol id="icon-zhaopian" viewBox="0 0 1146 1024"><path d="M1003.52 129.39264h-107.23328L860.16 58.28608c-21.21728-41.28768-32.11264-54.4768-71.68-54.4768H358.4c-39.56736 0-52.75648 17.2032-71.68 54.4768l-36.12672 71.68H143.36A142.9504 142.9504 0 0 0 0 272.75264v571.14624a142.9504 142.9504 0 0 0 143.36 142.78656h860.16c79.13472 0 143.36-64.22528 143.36-142.78656V272.1792a143.27808 143.27808 0 0 0-143.36-142.78656z m71.68 723.10784a71.68 71.68 0 0 1-71.68 71.68h-860.16a71.68 71.68 0 0 1-71.68-71.68V280.7808c0-39.56736 32.11264-71.68 71.68-71.68H286.72l36.12672-71.68c25.23136-41.28768 32.11264-71.68 71.68-71.68h358.4c39.56736 0 46.44864 29.81888 71.68 71.68L860.16 209.1008h143.36c39.56736 0 71.68 32.11264 71.68 71.68v571.71968zM573.44 253.25568c-158.26944 0-286.72 127.87712-286.72 285.57312 0 157.696 128.45056 285.57312 286.72 285.57312s286.72-127.87712 286.72-285.57312c0-157.696-128.45056-285.57312-286.72-285.57312z m0 500.03968a214.6304 214.6304 0 0 1-215.04-214.46656c0-118.12864 96.33792-214.46656 215.04-214.46656a214.6304 214.6304 0 0 1 215.04 214.46656c0 118.12864-96.33792 214.46656-215.04 214.46656z"  ></path></symbol><symbol id="icon-suo" viewBox="0 0 1024 1024"><path d="M512 19.392c131.2 0 238.976 106.816 243.52 241.472v159.232h68.992a57.92 57.92 0 0 1 42.112 17.088 61.184 61.184 0 0 1 18.112 42.56v435.904a61.44 61.44 0 0 1-17.984 42.688 58.368 58.368 0 0 1-42.112 17.088H199.488a59.904 59.904 0 0 1-60.16-59.776v-435.84a59.904 59.904 0 0 1 60.16-59.712h68.864V260.864C272.96 126.208 380.672 19.392 512 19.392z m0 547.456c-40.832 0-74.432 33.152-75.712 74.816 0.32 28.352 16.32 54.08 41.472 66.304v95.552a8 8 0 0 0 8.064 7.872h52.288a8 8 0 0 0 7.936-7.872v-95.552c25.344-12.16 41.472-37.952 41.6-66.304A76.416 76.416 0 0 0 512 566.784zM512 118.4c-80.064 0-145.664 65.728-148.48 148.608v155.2h296.96V267.008C657.664 184.128 592.064 118.4 512 118.4z"  ></path></symbol><symbol id="icon-shouqi" viewBox="0 0 1155 1024"><path d="M314.775841 282.873745L3.87776 503.810373l310.898081 220.936627V282.873745zM53.017444 97.832121h1053.431984a48.819765 48.819765 0 1 0 0-97.639529H53.017444a48.819765 48.819765 0 1 0 0 97.639529zM1106.9613 910.108544H53.017444a48.883749 48.883749 0 0 0 0 97.703513h1053.431984c26.873265 0 48.883749-21.882516 49.0757-48.75578a48.627813 48.627813 0 0 0-48.307892-48.947733h-0.191952z m0-303.283989H447.350615a48.883749 48.883749 0 0 0 0 97.703513h659.098813a49.139684 49.139684 0 0 0 49.139684-48.819765 48.627813 48.627813 0 0 0-48.307892-48.947732h-0.255936z m0-303.28399H447.350615a48.819765 48.819765 0 1 0 0 97.575545h659.098813c27.001233 0 48.947732-21.754548 49.139684-48.75578a48.627813 48.627813 0 0 0-48.179925-48.947733h-0.383903v0.063984z"  ></path></symbol><symbol id="icon-zhankai" viewBox="0 0 1154 1024"><path d="M842.445399 282.711165L1153.411681 503.696259l-310.966282 220.985095V282.711165z m261.815818-185.082216H50.598144a48.830474 48.830474 0 1 1 0-97.660948h1053.663073a48.830474 48.830474 0 1 1 0 97.660948zM50.08616 910.08356h1054.239055a48.894472 48.894472 0 0 1 0 97.724946H50.598144A49.150464 49.150464 0 0 1 1.44768 959.106028a48.63848 48.63848 0 0 1 48.31849-48.95847h0.191994z m0-303.35052h659.819381a48.894472 48.894472 0 0 1 0 97.724946H50.662142A49.150464 49.150464 0 0 1 1.44768 655.69151a48.63848 48.63848 0 0 1 48.31849-48.95847h0.255992z m0-303.350521h659.819381a48.830474 48.830474 0 1 1 0 97.59695H50.662142A49.150464 49.150464 0 0 1 1.44768 352.276991a48.63848 48.63848 0 0 1 48.190494-48.95847H50.08616v0.063998z"  ></path></symbol><symbol id="icon-app" viewBox="0 0 1024 1024"><path d="M258.048 19.8656h505.1904c41.2672 0 74.8032 33.4848 74.8032 74.8032v854.528c0 41.2672-33.536 74.8032-74.8032 74.8032H257.9968a74.8544 74.8544 0 0 1-74.8032-74.8544V94.72c0-41.3184 33.4848-74.8032 74.8032-74.8032z m252.5696 854.4256c40.1408 0 72.7552-33.4848 72.7552-74.8032 0-41.3696-32.6144-74.8544-72.7552-74.8544-40.192 0-72.8064 33.4848-72.8064 74.8544 0 41.3184 32.6144 74.8032 72.8064 74.8032z m-65.536-723.456a43.6736 43.6736 0 0 0 0 87.296h131.0208a43.6736 43.6736 0 0 0 0-87.296H445.1328z"  ></path></symbol><symbol id="icon-a-keyanchengguoSVG" viewBox="0 0 1024 1024"><path d="M977.071301 44.676797l0.955391 0.955391 0.95539 0.955391c31.937345 32.551525 46.40469 78.000824 44.903362 131.912154-1.364844 48.451955-15.695704 104.06934-41.42301 164.258952a991.559027 991.559027 0 0 1-95.129613 168.762937c39.648713 57.528167 71.859027 114.578638 95.129613 168.762937 25.795548 60.189612 40.058166 115.806997 41.42301 164.258953 1.501328 54.457268-13.307227 100.31602-45.858752 132.935787-32.551525 32.551525-78.342035 47.36008-132.867545 45.79051-48.451955-1.364844-104.137583-15.627462-164.258953-41.42301A991.559027 991.559027 0 0 1 512.069015 886.785428a989.375277 989.375277 0 0 1-168.831179 95.061371c-60.12137 25.795548-115.738755 40.058166-164.258952 41.42301-54.457268 1.56957-100.31602-13.307227-132.867545-45.79051-32.551525-32.551525-47.36008-78.410277-45.79051-132.935787 1.364844-48.451955 15.627462-104.06934 41.423009-164.258953 23.202345-54.116057 55.412659-111.23477 95.061372-168.762937A982.619301 982.619301 0 0 1 41.812081 342.826927C16.016533 282.637315 1.753915 227.01993 0.389071 178.567975-1.112257 124.656644 13.355087 79.139103 45.292432 46.655821L46.247823 45.70043 47.203214 44.813282C79.686496 12.875936 125.135795-1.591408 179.047126-0.09008c48.451955 1.364844 104.137583 15.627462 164.258952 41.42301 54.252541 23.202345 111.303013 55.412659 168.831179 95.061371A989.375277 989.375277 0 0 1 680.900194 41.33293C741.021564 15.46914 796.638949 1.274764 845.090905-0.09008c53.979573-1.56957 99.428872 12.966016 131.912154 44.766877zM189.556423 582.698227l-0.887148 1.296602c-28.866447 44.357424-52.546487 87.895941-70.289457 129.182466-42.787853 99.906567-44.835119 173.744617-13.170742 205.408993 31.664376 31.664376 105.502426 29.617111 205.408993-13.170742a868.518358 868.518358 0 0 0 130.479068-71.108363 1548.005849 1548.005849 0 0 1-133.004029-118.604927 1548.278817 1548.278817 0 0 1-118.604927-133.072271z m645.298153 0l-2.18375 2.729688a1545.480888 1545.480888 0 0 1-116.421177 130.206099 1539.407333 1539.407333 0 0 1-133.004029 118.604927c44.835119 29.207658 88.78309 53.228909 130.479068 71.108362 99.906567 42.856096 173.744617 44.835119 205.408993 13.238985 31.664376-31.664376 29.548868-105.570669-13.170742-205.408993a866.198124 866.198124 0 0 0-71.108363-130.479068zM512.069015 239.235282l-1.637812 1.296602a1445.983774 1445.983774 0 0 0-143.445085 125.975084A1441.479789 1441.479789 0 0 0 239.782675 511.658107a1447.826313 1447.826313 0 0 0 127.271685 145.151139c47.155354 47.087111 96.221489 89.943207 145.082897 127.203443a1447.826313 1447.826313 0 0 0 145.151139-127.203443A1435.337992 1435.337992 0 0 0 784.560082 511.589864a1447.826313 1447.826313 0 0 0-127.271686-145.151139 1441.479789 1441.479789 0 0 0-145.151139-127.271685z m-0.61418 211.073095c33.575158 0 60.940276 26.750939 61.417972 59.984886v1.910781a61.145003 61.145003 0 0 1-61.417972 60.940276 61.145003 61.145003 0 0 1-61.417971-59.984885v-1.910782c0-33.711642 27.501603-60.940276 61.417971-60.940276z m-405.358611-346.670327l-0.955391 0.95539-0.95539 0.955391c-30.708986 32.210314-28.252267 105.570669 14.126133 204.453603 17.947696 41.695978 41.900705 85.712191 71.108363 130.479068A1548.005849 1548.005849 0 0 1 308.093108 307.545715 1539.407333 1539.407333 0 0 1 441.097137 188.940788c-44.835119-29.2759-88.78309-53.228909-130.479068-71.108363-98.951176-42.3784-172.311531-44.835119-204.453603-14.194375z m607.560222 14.194375c-41.627736 17.879454-85.643949 41.832463-130.479068 71.108363 45.039846 35.622423 89.806723 75.40762 133.004029 118.604927a1539.407333 1539.407333 0 0 1 118.604927 132.935787c29.207658-44.766877 53.228909-88.714848 71.108362-130.479068 42.310158-98.951176 44.766877-172.243289 14.126134-204.453603l-0.955391-0.955391-0.955391-0.95539c-32.142072-30.708986-105.502426-28.184025-204.453602 14.194375z"  ></path></symbol><symbol id="icon-a-weizhuanyeSVG" viewBox="0 0 1092 1024"><path d="M759.944533 0c23.415467 0 42.461867 21.162667 42.461867 38.638933 0 16.930133-18.0224 33.1776-40.823467 33.928534h-23.1424v246.442666l307.131734 533.435734-1.024 1.501866c8.055467 16.384 13.653333 34.2016 13.585066 54.272 0 59.118933-40.482133 108.270933-91.682133 115.5072l-2.048 0.273067H139.0592C81.237333 1024 34.542933 972.253867 34.133333 908.219733c0-22.050133 7.509333-42.1888 17.6128-59.5968l1.365334-2.389333-0.477867-1.024 302.011733-525.653333V72.635733H333.141333c-23.483733 0-42.461867-16.657067-42.461866-34.065066S308.701867 0.477867 331.5712 0h428.373333zM498.756267 513.024l-2.935467-1.4336c-21.230933-10.922667-51.2-11.8784-80.349867-8.874667l-5.12 0.546134a314.026667 314.026667 0 0 0-5.12 0.682666l-5.051733 0.682667-2.525867 0.4096-4.983466 0.750933-4.846934 0.887467-4.778666 0.887467-7.099734 1.365333-6.826666 1.501867-6.485334 1.501866-6.144 1.501867-7.645866 1.979733-6.826667 1.911467-7.441067 2.048-5.870933 1.8432-4.232533 1.365333-2.730667 0.887467-197.700267 336.759467a117.077333 117.077333 0 0 1-5.12 10.786133 56.456533 56.456533 0 0 0-9.762133 29.149867c0 27.579733 17.681067 50.7904 39.048533 51.746133H947.4048c16.930133-4.096 34.338133-23.552 33.9968-51.746133a61.8496 61.8496 0 0 0-7.236267-25.6 77.277867 77.277867 0 0 1-2.730666-6.894934l-0.8192-2.389333-207.803734-353.6896-5.393066 1.6384-6.690134 1.911467-4.232533 1.160533-6.5536 1.706667-5.461333 1.365333-4.027734 0.955733-6.280533 1.501867-4.5056 0.955733-7.031467 1.501867-7.509333 1.501867-5.12 0.955733a590.506667 590.506667 0 0 1-2.730667 0.477867l-5.3248 0.887466a579.652267 579.652267 0 0 1-2.730666 0.477867l-5.666134 0.887467-5.7344 0.8192-5.870933 0.8192a214.152533 214.152533 0 0 1-3.003733 0.4096l-6.075734 0.682666-6.144 0.682667-3.072 0.273067-6.280533 0.6144-6.3488 0.477866-6.417067 0.4096c-45.192533 2.4576-94.890667-1.570133-135.850666-21.640533z m239.138133 184.32c52.0192 0 94.071467 41.915733 94.208 93.525333 0 51.6096-42.1888 93.525333-94.208 93.525334a93.7984 93.7984 0 0 1-94.071467-93.525334c0-51.677867 42.120533-93.525333 94.071467-93.525333z m-376.490667-41.915733a107.588267 107.588267 0 0 1 107.861334 107.1104c0 59.118933-48.3328 107.1104-107.861334 107.1104-59.5968 0-107.861333-47.991467-107.861333-107.178667 0-59.118933 48.264533-107.042133 107.861333-107.042133z m376.490667 114.4832c-11.605333 0-21.0944 9.352533-21.0944 20.957866 0 11.605333 9.489067 20.957867 21.162667 20.957867 11.605333 0 21.026133-9.4208 21.0944-20.957867a21.026133 21.026133 0 0 0-21.162667-20.957866z m-376.490667-41.984a34.679467 34.679467 0 0 0-34.816 34.6112c0 19.114667 15.5648 34.542933 34.816 34.542933 19.182933 0 34.816-15.496533 34.816-34.542933a34.679467 34.679467 0 0 0-34.816-34.6112z m233.335467-137.0112a43.6224 43.6224 0 0 1 43.349333 0 43.008 43.008 0 0 1 0 74.615466 43.6224 43.6224 0 0 1-43.349333 0 43.008 43.008 0 0 1 0-74.615466z m68.266667-518.280534H429.943467V319.488c-0.068267 10.376533-2.6624 20.548267-7.509334 29.696l-1.2288 2.048-54.749866 88.405333 3.003733-1.2288 3.2768-1.297066 3.413333-1.160534 4.096-1.365333 3.549867-1.092267 5.188267-1.570133 4.3008-1.160533 4.573866-1.092267 3.2768-0.750933 5.12-1.160534 3.549867-0.682666 3.754667-0.682667 3.822933-0.682667 3.8912-0.546133 4.096-0.546133 2.048-0.273067 4.164267-0.477867 4.369066-0.4096a185.002667 185.002667 0 0 1 4.369067-0.341333l4.5056-0.273067 4.642133-0.2048 4.642134-0.136533c7.3728-0.136533 14.7456 0.136533 22.050133 0.682667l5.12 0.4096c21.2992 2.048 42.257067 7.031467 62.122667 14.882133l2.8672 1.160533c33.5872 13.858133 66.491733 17.749333 94.890666 17.066667l4.642134-0.2048 4.573866-0.2048 4.5056-0.341333 2.184534-0.136534 4.369066-0.4096 4.232534-0.477866 4.164266-0.546134 4.096-0.6144 3.8912-0.6144 3.754667-0.682666 3.6864-0.682667 3.549867-0.682667 5.12-1.092266 3.208533-0.8192 3.072-0.682667 2.935467-0.8192 4.096-1.160533 3.822933-1.092267 3.413333-1.092267 4.846934-1.6384 4.983466-1.8432 3.072-1.2288-55.773866-88.8832a63.146667 63.146667 0 0 1-8.669867-29.354666V72.704z"  ></path></symbol><symbol id="icon-a-xueshuziyuanSVG" viewBox="0 0 1087 1024"><path d="M206.373712 674.776785a39.40676 39.40676 0 0 0 0 78.685575H273.800212a39.40676 39.40676 0 0 0 0-78.685575H206.373712z m607.478228 213.794465h101.139751a39.40676 39.40676 0 0 0 0-78.749547h-101.139751a39.40676 39.40676 0 0 0 0 78.685575z m0-135.044918h67.298557a39.40676 39.40676 0 0 0 0-78.749547h-67.298557a39.40676 39.40676 0 0 0 0 78.685575z m-202.343475-78.749547h-134.980946a39.40676 39.40676 0 0 0 0 78.685575h134.980946a39.40676 39.40676 0 0 0 0-78.685575z m0 134.980946h-134.980946a39.40676 39.40676 0 0 0 0 78.813519h134.980946a39.40676 39.40676 0 0 0 0-78.749547z m-337.772225 0H172.532517a39.40676 39.40676 0 0 0 0 78.813519H273.800212a39.40676 39.40676 0 0 0 0-78.749547z m675.160618-573.573062H847.629162a39.40676 39.40676 0 0 0 0 78.813519h101.203724c15.417255 0 27.955769 12.474542 27.955769 27.891798v574.020866a27.955769 27.955769 0 0 1-27.955769 27.955769h-168.886113a27.955769 27.955769 0 0 1-27.955769-27.955769V342.889986a40.36634 40.36634 0 0 0-0.383832-5.501593V118.092335C751.671144 52.840882 698.76629 0 633.514837 0H453.625539C388.310114 0 335.533204 52.904854 335.533204 118.092335v798.370712a27.955769 27.955769 0 0 1-27.955769 27.95577h-168.886112a27.955769 27.955769 0 0 1-27.95577-27.95577V444.093709c0-15.481227 12.474542-27.955769 27.95577-27.955769h103.890547a39.40676 39.40676 0 0 0 0-78.749547H138.691323A107.089148 107.089148 0 0 0 31.986006 444.477541v472.369338c0.191916 58.854251 47.851065 106.5134 106.705317 106.705317h168.886112a106.705316 106.705316 0 0 0 70.753045-27.124133c21.174736 17.528331 47.787093 27.124133 75.295059 27.124133H633.962641a117.708503 117.708503 0 0 0 75.039171-27.252077c19.511464 17.464359 44.780409 27.188105 71.008933 27.252077h168.886113A107.089148 107.089148 0 0 0 1055.538202 916.846879V342.889986a107.025176 107.025176 0 0 0-106.641344-106.705317z m-275.975261 669.275192c0 21.750484-17.656275 39.40676-39.40676 39.40676H453.625539a39.40676 39.40676 0 0 1-39.342788-39.40676V118.092335c0-21.750484 17.592303-39.342788 39.342788-39.342788h179.95327c21.750484 0 39.342788 17.592303 39.342788 39.342788v787.367526z"  ></path></symbol><symbol id="icon-a-xunifangzhen3x1" viewBox="0 0 1024 1024"><path d="M889.192524 617.412721a105.411517 105.411517 0 0 0-98.364004 65.837022 15.119023 15.119023 0 0 1-13.974555 9.517154H753.000845c-33.189569 0-60.235152-27.045583-60.235153-60.235152v-59.331625c108.061863-8.914803 193.174134-101.556467 193.174134-214.497378 0-114.56726-92.340489-207.931746-208.714803-214.617848A210.823033 210.823033 0 0 0 488.688996 30.119986C377.735845 30.119986 287.081941 113.485437 279.191136 219.258364c-81.618631 22.527947-140.950257 91.617667-140.950257 173.477239 0 96.376244 82.582394 175.645704 186.909678 181.247574H331.354778V632.471509c0 33.189569-27.045583 60.235152-60.235152 60.235153h-23.853121a15.119023 15.119023 0 0 1-13.974555-9.517154A105.411517 105.411517 0 0 0 134.927946 617.412721a105.411517 105.411517 0 1 0 98.424239 144.865542 14.998553 14.998553 0 0 1 13.91432-9.336449H271.119626a120.470305 120.470305 0 0 0 120.470304-120.470305v-51.019174c0-4.216461 3.373169-7.529394 7.529394-7.529394h75.293941c4.156226 0 7.529394 3.373169 7.529394 7.529394v195.402835a15.119023 15.119023 0 0 1-9.517154 13.974555 105.411517 105.411517 0 0 0-65.776787 98.364004 105.411517 105.411517 0 1 0 144.865542-98.424239 14.998553 14.998553 0 0 1-9.336449-13.91432V581.512571c0-4.216461 3.373169-7.529394 7.529394-7.529394h75.293941c4.156226 0 7.529394 3.373169 7.529394 7.529394V632.471509a120.470305 120.470305 0 0 0 120.470305 120.470305h23.85312c6.08375 0 11.625384 3.614109 13.854085 9.276214a105.411517 105.411517 0 1 0 98.484474-144.805307zM135.590533 768.000602a45.176364 45.176364 0 1 1 0-90.352728 45.176364 45.176364 0 0 1 0 90.352728z m421.646066 120.470305a45.176364 45.176364 0 1 1-90.352728 0 45.176364 45.176364 0 0 1 90.352728 0zM326.837142 513.808259A145.407658 145.407658 0 0 1 234.376183 474.053059a112.82044 112.82044 0 0 1-35.960386-81.437926c0-25.479469 9.035273-49.874706 26.081821-70.595599 17.468194-21.142538 42.586253-37.044619 70.716069-44.814953l40.839433-11.263974 3.132228-42.285077a140.950257 140.950257 0 0 1 46.441302-93.966838A152.816582 152.816582 0 0 1 488.688996 90.355138c28.852638 0 56.801749 7.83057 80.775339 22.708652 23.250769 14.275731 41.923666 34.454507 54.030932 58.307628l15.721375 30.780163 34.574977 1.98776a164.441966 164.441966 0 0 1 108.423275 48.850708c28.009346 28.732168 43.550015 66.258668 43.550015 105.712693 0 85.473681-67.282665 155.045282-149.98553 155.045282H326.776906z m561.692796 254.312814a45.176364 45.176364 0 1 1 0-90.352729 45.176364 45.176364 0 0 1 0 90.352729z"  ></path></symbol><symbol id="icon-a-chanyejuece3x" viewBox="0 0 1024 1024"><path d="M749.952 358.528l95.232 52.16v193.344l7.104 9.856 54.144 73.856V991.68H961.92V662.272l-7.104-9.6-54.08-73.856V371.968l-14.016-9.728-136.832-77.184-280.192 109.44v586.56h280.256V358.528zM202.24 198.144l-53.504 17.152v102.912l53.504-12.992V198.08z m501.696 180.736V464.32l-46.336 11.2V393.792c15.104-4.736 30.4-9.728 46.336-14.912M541.76 654.272v72.64h-33.792V656.96l33.792-2.752m74.752-5.824v78.464h-39.296V651.456l39.296-3.008m87.424-6.976v85.44h-46.336V645.184l46.336-3.712M541.76 542.784V615.36c-11.52 1.28-22.848 2.688-33.792 4.096V549.376l33.792-6.592m74.752-14.912v78.4l-39.232 4.736V535.68c12.736-2.688 25.792-5.248 39.232-7.808m87.424-17.536v85.376l-46.336 5.568V519.488c15.104-2.88 30.4-6.144 46.336-9.152m-162.176-79.36v72.704c-11.52 2.752-22.848 5.376-33.792 8.192V441.856l33.792-10.88m74.752-23.936v78.656c-13.44 3.072-26.496 6.272-39.232 9.408v-75.52l39.232-12.544M321.408 159.808c-21.568 7.04-42.624 13.76-63.04 20.288v111.552l63.04-15.36v-116.48z m-221.184 375.68c-15.744 1.216-31.04 2.304-46.016 3.712v95.296h45.952l0.064-99.008m102.016-8.064l-53.504 4.288v102.656h53.504V527.424z m119.168-9.472l-63.04 5.12v111.36h63.04v-116.48zM100.224 383.168l-46.016 9.216v95.36l46.016-5.44V383.168z m102.016-20.352l-53.504 10.688v102.784l53.504-6.4V362.816z m119.168-23.744l-63.04 12.544V463.04l63.04-7.68V339.136zM100.224 230.72l-46.016 14.72v95.488l46.016-11.136V230.72zM384.128 31.68l181.568 115.84 14.144 9.792v174.72h-55.68V196.16L384.128 107.648v873.472H1.92V181.056L384.128 31.68z"  ></path></symbol><symbol id="icon-pinglun" viewBox="0 0 1092 1024"><path d="M904.533333 883.029333h-170.666666a16.7936 16.7936 0 0 0-13.243734 6.007467l-94.890666 100.352c-43.554133 46.148267-115.643733 46.148267-161.109334 0l-94.890666-100.352a16.7936 16.7936 0 0 0-13.243734-6.007467h-170.666666C102.4 883.029333 34.133333 810.8032 34.133333 722.466133V160.5632C34.133333 72.226133 102.4 0 185.821867 0h720.622933C989.866667 0 1058.133333 72.226133 1058.133333 160.5632v561.902933c-1.911467 88.337067-70.178133 160.5632-153.6 160.5632z m0-80.2816c41.710933 0 75.844267-36.181333 75.844267-80.2816V160.5632c0-44.168533-34.133333-80.2816-75.844267-80.2816H183.9104c-41.642667 0-75.776 36.113067-75.776 80.2816v561.902933c0 44.168533 34.133333 80.2816 75.776 80.2816h170.666667c24.712533 0 49.3568 10.0352 66.423466 30.037334l94.8224 100.352a35.293867 35.293867 0 0 0 53.0432 0l94.890667-100.352c17.066667-18.0224 41.642667-30.037333 66.286933-30.037334h174.4896zM316.689067 381.269333c32.221867 0 56.866133 26.146133 56.866133 60.2112v40.1408c0 34.133333-24.576 60.2112-56.866133 60.2112-32.221867 0-56.866133-26.077867-56.866134-60.2112v-40.1408c0-34.133333 24.576-60.2112 56.866134-60.2112z m227.5328 0c32.221867 0 56.9344 26.146133 56.9344 60.2112v40.1408c0 34.133333-24.712533 60.2112-56.9344 60.2112s-56.866133-26.077867-56.866134-60.2112v-40.1408c0-34.133333 24.644267-60.2112 56.866134-60.2112z m227.601066 0c32.221867 0 56.866133 26.146133 56.866134 60.2112v40.1408c0 34.133333-24.644267 60.2112-56.866134 60.2112-32.290133 0-56.9344-26.077867-56.9344-60.2112v-40.1408c0-34.133333 24.644267-60.2112 56.9344-60.2112z"  ></path></symbol><symbol id="icon-chanyetansuoyuchengguo" viewBox="0 0 1024 1024"><path d="M795.2 983.808a34.688 34.688 0 0 1-34.56-34.624v-155.52l-2.304-0.256a176.192 176.192 0 0 1-139.008-102.4c-60.352-137.024 25.536-364.608 78.08-424 24.256-29.12 59.776-46.848 97.472-48.832 37.44 1.792 72.96 19.52 97.152 48.768 53.12 59.136 140.16 286.528 78.976 424.576a176.448 176.448 0 0 1-139.008 101.632l-2.176 0.32v157.312a34.56 34.56 0 0 1-34.56 33.024zM795.008 287.744a68.608 68.608 0 0 0-45.888 25.856c-42.432 47.296-113.088 249.088-66.496 350.528 17.28 38.208 55.424 62.784 97.216 62.784h3.264a41.024 41.024 0 0 1 12.16-1.984c3.84 0 7.36 0.512 10.496 1.6l2.688 0.064c42.048 0 80.192-24.832 97.152-63.488 45.12-99.2-24-299.52-66.304-350.4a66.816 66.816 0 0 0-43.84-24.832h-0.32l-0.128-0.128zM165.888 1020.544A134.592 134.592 0 0 1 32 888.512V192.704A134.656 134.656 0 0 1 165.888 60.544h258.304C496.96 60.544 556.992 119.872 558.08 192.704v695.552c-0.256 20.48-5.312 40.704-14.656 58.944l-1.92 3.84h415.808a34.56 34.56 0 0 1 34.368 34.688c0 19.2-15.36 34.688-34.368 34.688H165.888V1020.544z m0-890.56c-35.072 0-63.488 27.52-64.576 62.592v695.68c0 35.648 29.056 64.64 64.64 64.64h171.2c3.84-1.28 7.936-1.92 12.032-1.92h90.624c29.12-7.552 48.96-33.28 48.96-62.72V192.704a64.512 64.512 0 0 0-64.64-62.72H165.952z m212.608 616.128a45.696 45.696 0 0 1 0-91.2c25.088 0 45.44 20.48 45.44 45.504a45.696 45.696 0 0 1-45.44 45.696z m-166.4-0.448a45.568 45.568 0 1 1 0.064 0h-0.064z m166.4-195.328a45.696 45.696 0 0 1-0.064-91.2 45.568 45.568 0 0 1 0 91.2h0.128z m-166.4-0.576a45.568 45.568 0 1 1 32.512-77.632 45.632 45.632 0 0 1-32.448 77.696h-0.064zM378.624 354.304a45.696 45.696 0 0 1-0.064-91.328 45.568 45.568 0 0 1 0 91.328z m-166.464-1.28a45.568 45.568 0 1 1 32.512-77.632 45.696 45.696 0 0 1-32.448 77.696l-0.064-0.064z"  ></path></symbol><symbol id="icon-sousuo1" viewBox="0 0 1024 1024"><path d="M494.976 14.528c221.44 19.456 384.832 220.672 364.8 449.6a422.912 422.912 0 0 1-113.088 254.016l198.08 242.048-60.608 49.536-196.288-239.936A393.344 393.344 0 0 1 422.4 843.584C200.896 824.128 37.568 622.848 57.536 393.984 77.568 165.056 273.408-4.864 494.976 14.528z m-6.848 77.952c-177.92-15.552-336.256 121.856-352.64 308.288-16.256 186.432 115.84 349.184 293.696 364.8 177.92 15.616 336.32-121.856 352.64-308.224 16.32-186.432-115.84-349.184-293.76-364.8z"  ></path></symbol><symbol id="icon-qiehuan" viewBox="0 0 1024 1024"><path d="M761.6 576a32 32 0 0 1 26.624 49.792l-3.392 4.224-151.68 160.192a32 32 0 0 1-50.112-39.424l3.584-4.544L687.232 640H288a32 32 0 0 1-31.488-26.24L256 608a32 32 0 0 1 26.24-31.488L288 576h473.6zM461.824 264.768a32 32 0 0 1 4.8 40.704l-3.584 4.48-100.608 106.24h399.232a32 32 0 0 1 31.488 26.24l0.512 5.76a32 32 0 0 1-26.24 31.552l-5.76 0.512h-473.6a32 32 0 0 1-26.624-49.792l3.392-4.224 151.68-160.256a32 32 0 0 1 45.312-1.216z"  ></path></symbol><symbol id="icon-chakanquanbu" viewBox="0 0 1024 1024"><path d="M384 665.088l72.32 72.32 240.64-240.704L456.32 256 384 328.32l168.384 168.384z"  ></path></symbol><symbol id="icon-jiaoxueribao" viewBox="0 0 1024 1024"><path d="M838.779921 1023.786711H187.267653C80.367257 1023.786711 0 937.575338 0 830.7176V248.182962c0-106.900396 80.367257-193.069111 187.267653-189.656488a34.552801 34.552801 0 0 1 34.510143 34.552801c0 17.10577-13.821121 38.477317-34.510143 38.477317-65.52235 0-114.920058 51.10402-114.920059 116.62637v579.079358c0 65.52235 49.397709 123.451614 114.920059 123.451615h651.512268c65.52235 0 111.720725-57.929265 111.720725-123.451615V244.727682c0-68.934972-46.198375-116.583712-111.720725-116.583712h-20.689023c-17.276401 0-34.510144-17.830952-34.510144-38.519975a34.552801 34.552801 0 0 1 34.510144-34.510144h20.689023c103.487773 0 185.220079 86.168715 185.092106 193.069111v582.534638c0 106.857738-78.19171 193.069111-185.092106 193.069111zM711.318475 165.426869c-17.276401 0-34.510144-10.408498-34.510143-27.556925V27.556926c0-13.821121 13.821121-27.556926 34.510143-27.556926 20.689023 0 34.510144 10.280525 34.510144 27.556926v110.313018c0 13.693147-13.821121 27.556926-34.510144 27.556925z m-19.196001 144.823162v485.914768c0 10.664445-7.081191 17.702979-17.702978 17.702979h-17.745636c-10.621787 0-17.702979-7.038534-17.702979-17.702979v-31.865361H383.536097v31.865361c0 10.664445-7.081191 17.702979-17.702979 17.702979h-17.702978c-10.664445 0-17.745636-7.038534-17.745637-17.702979V310.250031c0-10.621787 7.081191-17.745636 17.745637-17.745636h326.289356c10.621787 0 17.702979 7.123849 17.702978 17.745636zM638.842908 354.912727H390.659946v144.865819h248.182962V354.912727z m0 199.937013H390.659946v151.691064h248.182962v-151.691064zM607.87336 127.461446H401.068444c-13.863778 0-27.556926-13.693147-31.012206-34.510144 0-17.276401 13.735805-34.510144 31.012206-34.510144h206.804916c17.148427 0 30.969548 13.821121 30.969548 34.510144 0 17.233743-13.735805 34.510144-30.969548 34.510144z m-310.292689 37.965423c-17.276401 0-34.424828-10.408498-34.510144-27.556925V27.556926c0-13.735805 13.821121-27.556926 34.510144-27.556926 17.276401 0 34.510144 10.280525 34.510143 27.556926v110.313018c0 13.693147-13.821121 27.556926-34.510143 27.556925z"  ></path></symbol><symbol id="icon-xiazai1" viewBox="0 0 1109 1024"><path d="M119.210667 469.333333v417.194667h834.304V469.333333h119.210666v476.757334a59.562667 59.562667 0 0 1-59.562666 59.648H59.648A59.648 59.648 0 0 1 0 946.090667V469.333333h119.210667zM595.968 0v417.194667h147.797333a14.848 14.848 0 0 1 11.605334 24.234666L548.010667 700.586667a14.848 14.848 0 0 1-23.296 0L317.44 441.429333a14.848 14.848 0 0 1 11.605333-24.234666h147.797334V0h119.210666z"  ></path></symbol><symbol id="icon-paixu" viewBox="0 0 1303 1024"><path d="M366.960678 136.212177H34.912952C15.643572 136.212177 0.004655 108.844072 0.004655 75.239017 0.004655 41.727052 15.643572 14.265858 34.912952 14.265858h332.047726c19.176291 0 34.908298 27.368105 34.908298 60.973159 0 33.511966-15.732006 60.97316-34.908298 60.97316z m71.306016 440.030727H59.674571a60.321538 60.321538 0 0 1-59.576828-60.97316 60.507716 60.507716 0 0 1 59.576828-60.97316H438.452872a60.507716 60.507716 0 0 1 59.669916 60.97316 60.321538 60.321538 0 0 1-59.576828 60.97316H438.452872z m207.960365 426.719029H59.674571a60.321538 60.321538 0 0 1-59.576828-60.97316 60.321538 60.321538 0 0 1 59.576828-60.97316h586.645576a60.321538 60.321538 0 0 1 59.669917 60.880071 60.321538 60.321538 0 0 1-59.576828 61.066249h-0.093089z m639.240744-593.906502a60.228449 60.228449 0 0 1-85.734779 0.186177l-194.927933-198.092952v729.350696a60.507716 60.507716 0 0 1-59.576828 61.252426 60.321538 60.321538 0 0 1-59.763005-61.252426v-732.608804L689.140992 411.103384a58.64594 58.64594 0 0 1-84.338446 0.558533 62.369492 62.369492 0 0 1-0.558533-86.665667L901.569619 18.361765a59.297561 59.297561 0 0 1 84.89698-0.744711l0.279266 0.279267s0.186178 0 0.186178 0.186177l298.815026 304.121088c23.365287 24.203086 23.272198 62.741847-0.186177 86.851845z"  ></path></symbol><symbol id="icon-taishidaping" viewBox="0 0 1066 1024"><path d="M986.581333 0H57.429333C25.728 0 0 25.685333 0 57.429333V762.112c0.256 31.616 25.813333 57.173333 57.429333 57.429333h929.152a57.856 57.856 0 0 0 57.429334-57.429333V57.856c0-31.786667-25.6-57.6-57.429334-57.856z m-16.512 746.026667H73.941333V74.837333h896.128v671.189334zM357.546667 936.576h317.525333c14.506667 0 21.76 7.253333 21.76 21.76v43.946667c0 14.506667-7.253333 21.717333-21.76 21.717333H357.589333c-14.506667 0-21.76-7.253333-21.76-21.76v-43.946667c0-14.506667 7.253333-21.76 21.76-21.76z m90.026666-546.389333l127.018667 140.501333 11.733333 16.128 233.173334-169.216-48.298667-66.56-171.818667 124.416-145.706666-160.981333-57.002667 51.328-195.328 157.909333 51.797333 63.957333 194.432-157.44z"  ></path></symbol><symbol id="icon-suolvetubeifen" viewBox="0 0 1024 1024"><path d="M341.357714 597.357714c56.832 0 85.284571 28.452571 85.284572 85.284572v256c0 56.905143-28.452571 85.357714-85.284572 85.357714h-256C28.452571 1024 0 995.547429 0 938.642286v-256c0-56.832 28.452571-85.284571 85.357714-85.284572h256z m597.284572 0c56.905143 0 85.357714 28.452571 85.357714 85.284572v256c0 56.905143-28.452571 85.357714-85.357714 85.357714h-256c-56.832 0-85.284571-28.452571-85.284572-85.357714v-256c0-56.832 28.452571-85.284571 85.284572-85.284572h256zM341.357714 0c56.832 0 85.284571 28.452571 85.284572 85.357714v256c0 56.832-28.452571 85.284571-85.284572 85.284572h-256C28.452571 426.642286 0 398.189714 0 341.357714v-256C0 28.452571 28.452571 0 85.357714 0h256z m597.284572 0C995.547429 0 1024 28.452571 1024 85.357714v256c0 56.832-28.452571 85.284571-85.357714 85.284572h-256c-56.832 0-85.284571-28.452571-85.284572-85.284572v-256C597.357714 28.452571 625.810286 0 682.642286 0h256z"  ></path></symbol><symbol id="icon-xiangmupingshen" viewBox="0 0 1068 1024"><path d="M754.95513 421.487304a34.905043 34.905043 0 0 1 45.412174 19.366957l63.933218 159.521391 171.542261 11.575652a34.905043 34.905043 0 0 1 24.397913 57.344l-4.363131 4.274087-131.962435 110.146783 42.028522 166.733913a34.905043 34.905043 0 0 1-47.326609 40.781913l-5.12-2.760348-145.586086-91.447652-145.541566 91.447652a34.905043 34.905043 0 0 1-53.426087-32.456348l1.024-5.565217 41.939479-166.733913-131.873392-110.146783a34.905043 34.905043 0 0 1 13.979826-60.727652l6.010435-0.890435 171.497739-11.620174v0.044522l64.022261-159.521391a34.905043 34.905043 0 0 1 19.411478-19.366957zM872.626087 0c16.873739 0 31.298783 12.02087 34.326261 28.627478l0.578782 6.277565v316.994783h-69.810087V69.765565H69.810087v837.765565h382.70887v69.810087H34.905043a34.905043 34.905043 0 0 1-34.32626-28.627478L0 942.525217V34.860522C0 18.031304 12.02087 3.606261 28.627478 0.578783L34.905043 0h837.765566z m-104.71513 547.617391l-39.802435 99.06087a34.905043 34.905043 0 0 1-30.007652 21.815652l-106.674087 7.123478 82.098087 68.563479c8.45913 7.123478 13.04487 17.808696 12.421565 28.805565l-0.979478 6.544695-26.08974 103.557566 90.468174-56.854261a34.905043 34.905043 0 0 1 31.165218-2.938435l5.965913 2.938435 90.37913 56.854261-26.000695-103.557566a34.905043 34.905043 0 0 1 6.811826-30.630956l4.63026-4.674783 82.009044-68.563478-106.585044-7.123478a34.905043 34.905043 0 0 1-27.514434-16.740174l-2.493218-5.030957-39.802434-99.149913z m-267.575653-128.756869v69.854608H174.525217V418.860522h325.810087z m162.860522-209.430261v69.810087H174.525217V209.430261h488.715131z"  ></path></symbol><symbol id="icon-shouji" viewBox="0 0 1024 1024"><path d="M832.441379 726.580966c20.797793 0 28.354207 8.15669 28.036414 28.848551-0.600276 31.002483-0.388414 62.075586-0.176552 93.184l0.176552 46.609655a112.887172 112.887172 0 0 1-111.933793 113.805242h-2.048c-80.684138 0.600276-160.873931-0.211862-240.887172-0.211862l-0.388414-0.105931h-229.164138a114.193655 114.193655 0 0 1-121.079173-121.043862v-134.07338c0-19.561931 7.662345-27.012414 26.835863-27.012413h650.628413zM450.983724 858.888828a59.603862 59.603862 0 0 0 56.249379 62.781793l2.224552 0.105931h2.224552a59.603862 59.603862 0 0 0 6.532414-119.066483l-2.224552-0.070621h-2.189241a59.603862 59.603862 0 0 0-62.817104 56.24938zM859.877517 104.871724c0.459034 5.967448 0.459034 11.970207 0 17.937655 0 164.82869 0 329.551448 0.812138 494.274207 0 27.153655-7.980138 36.82869-35.416276 36.510897-106.707862-1.200552-213.451034 0-320.052965 0V653.241379c-104.801103 0-209.602207-0.706207-314.509242 0-26.65931 0-36.334345-7.874207-36.228413-35.804689 0.706207-109.885793 0.494345-219.736276 0.494344-329.551449l0.317794-164.722758A115.111724 115.111724 0 0 1 278.033655 0.282483l229.517242-0.247173 229.481931 0.247173a114.087724 114.087724 0 0 1 122.809379 104.624551z"  ></path></symbol><symbol id="icon-xueyuan" viewBox="0 0 1024 1024"><path d="M894.559473 911.962353a42.164706 42.164706 0 0 1 5.722353 83.907765l-5.722353 0.421647H152.159473a42.164706 42.164706 0 0 1-5.722353-83.968l5.722353-0.361412H894.499238zM235.826296 460.197647c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.311059 0-42.526118-15.841882-45.598117-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019764-42.164706z m197.150118 0c23.250824 0 42.526118 15.841882 45.537882 36.442353l0.421648 5.722353v301.176471c0 23.250824-20.600471 42.164706-45.95953 42.164705-23.311059 0-42.526118-15.841882-45.598118-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019765-42.164706z m197.089882 0c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.250824 0-42.526118-15.841882-45.537882-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 45.959529-42.164706z m197.150118 0c23.311059 0 42.526118 15.841882 45.598118 36.442353l0.421647 5.722353v301.176471c0 23.250824-20.600471 42.164706-46.019765 42.164705-23.250824 0-42.526118-15.841882-45.598118-36.442353l-0.421647-5.722352v-301.176471c0-23.311059 20.600471-42.164706 46.019765-42.164706zM525.256885 7.589647l436.705882 339.727059a36.141176 36.141176 0 0 1-22.106353 64.692706H66.263944a36.141176 36.141176 0 0 1-22.166589-64.692706l436.705883-339.727059a36.141176 36.141176 0 0 1 44.453647 0zM502.969826 97.159529L206.672414 327.68h592.715294l-296.357647-230.520471z"  ></path></symbol><symbol id="icon-gonghao" viewBox="0 0 1080 1024"><path d="M869.660444 165.660444a207.075556 207.075556 0 0 1 207.075556 207.075556v414.094222a207.075556 207.075556 0 0 1-207.075556 207.075556H207.075556A207.075556 207.075556 0 0 1 0 786.773333V372.622222a207.075556 207.075556 0 0 1 207.075556-207.075555h662.584888z m0 82.830223H207.075556A124.245333 124.245333 0 0 0 83.057778 363.861333l-0.284445 8.817778v414.151111c0 68.608 55.637333 124.245333 124.245334 124.245334h662.584889a124.245333 124.245333 0 0 0 124.245333-124.245334V372.622222a124.245333 124.245333 0 0 0-124.245333-124.188444zM410.908444 398.222222v368.526222H341.333333V398.222222h69.575111z m87.04 0h119.523556C724.764444 398.222222 796.444444 428.999111 796.444444 582.542222c0 137.671111-67.128889 181.418667-168.675555 184.092445l-10.24 0.113777H497.948444V398.222222z m116.337778 58.936889h-46.705778v249.628445h46.705778c71.168 0 110.478222-27.136 110.478222-124.302223 0-98.531556-38.286222-123.448889-102.627555-125.212444l-7.850667-0.113778zM745.415111 0a41.415111 41.415111 0 0 1 0 82.830222h-414.151111a41.415111 41.415111 0 0 1-40.96-35.84L289.848889 41.472c0-22.869333 18.545778-41.415111 41.415111-41.415111h414.094222z"  ></path></symbol><symbol id="icon-zhanghao1" viewBox="0 0 1024 1024"><path d="M632.9856 525.0048c174.2336 44.032 292.1472 185.4976 350.208 417.8944a46.3872 46.3872 0 0 1-90.0096 22.528c-61.44-245.8624-187.8528-362.496-385.6896-362.496-197.8368 0-324.3008 116.6336-385.6384 362.496a46.4384 46.4384 0 0 1-90.112-22.528c58.112-232.3456 176.0256-373.8624 350.208-417.8944a265.0112 265.0112 0 1 1 251.0848 0h-0.0512zM507.4944 463.7696a172.288 172.288 0 1 0 0-344.576 172.288 172.288 0 0 0 0 344.576z"  ></path></symbol><symbol id="icon-mima1" viewBox="0 0 1024 1024"><path d="M853.4016 436.224L292.0448 435.3024c-0.2048-74.8032-20.5312-190.7712 43.9296-261.1712a255.4368 255.4368 0 0 1 176.128-87.04c104.3456 0 182.3744 77.824 220.16 174.1312 11.008 27.7504 20.736 42.752 43.9296 43.52 58.5216 1.792 54.8352-59.2896 43.8784-87.04C765.4912 78.6944 663.0912 0 511.8464 0c-102.912 0-159.488 20.8384-220.2112 87.04-92.928 101.1712-88.32 264.704-88.064 348.2112l-32.9728 0.9728a54.6304 54.6304 0 0 0-55.296 53.9648v456.9088c0.3072 30.208 25.0368 54.4256 55.1936 54.1184H852.5824a54.6816 54.6816 0 0 0 55.296-54.016V490.24a54.5792 54.5792 0 0 0-55.1936-53.9648h-0.1024 0.8192z m-31.3856 434.0224a41.472 41.472 0 0 1-12.9536 30.8224 42.6496 42.6496 0 0 1-31.1808 12.8H248.4224a42.24 42.24 0 0 1-31.1296-12.8 41.8304 41.8304 0 0 1-13.0048-30.8224v-305.2544a43.9296 43.9296 0 0 1 44.1344-43.52h529.408a43.8784 43.8784 0 0 1 44.1344 43.52v305.2544z"  ></path></symbol><symbol id="icon-jianshao" viewBox="0 0 1024 1024"><path d="M652.8 32C652.8 12.8 640 0 620.8 0h-243.2C358.4 0 345.6 12.8 345.6 32V512H96c-12.8 0-25.6 6.4-32 19.2 0 12.8 0 25.6 6.4 32L473.6 1011.2c12.8 6.4 19.2 12.8 25.6 12.8 12.8 0 19.2-6.4 25.6-12.8l403.2-448c6.4-6.4 12.8-25.6 6.4-32-6.4-12.8-12.8-19.2-25.6-19.2h-256V32z"  ></path></symbol><symbol id="icon-zengjia" viewBox="0 0 1024 1024"><path d="M674.56 992c0 19.2-12.8 32-32 32h-243.2c-19.2 0-32-12.8-32-32V512H117.76c-12.8 0-25.6-6.4-32-19.2 0-12.8 0-25.6 6.4-32L495.36 12.8c12.8-6.4 19.2-12.8 25.6-12.8 12.8 0 19.2 6.4 25.6 12.8l403.2 448c6.4 6.4 12.8 25.6 6.4 32-6.4 12.8-12.8 19.2-25.6 19.2h-256v480z"  ></path></symbol><symbol id="icon-icon_notopen" viewBox="0 0 1024 1024"><path d="M390.070857 768H768v-73.142857h-36.571429v36.571428h-55.844571a219.428571 219.428571 0 1 0-327.131429 0H292.571429v-36.571428H256v73.142857h134.070857zM157.988571 0h482.742858L914.285714 290.121143V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0zM402.285714 731.428571A182.857143 182.857143 0 1 1 621.714286 731.428571H402.285714z m109.714286-109.714285a36.571429 36.571429 0 1 1 0-73.142857 36.571429 36.571429 0 0 1 0 73.142857z m0 36.571428a73.142857 73.142857 0 1 0 0-146.285714 73.142857 73.142857 0 0 0 0 146.285714z" fill="#B1B6BF" ></path><path d="M920.832 282.112h-232.338286c-12.434286 0-25.746286-4.973714-34.852571-14.921143a47.762286 47.762286 0 0 1-14.957714-34.852571V0l282.148571 282.112z" fill="#CED0DA" ></path></symbol><symbol id="icon-icon_other" viewBox="0 0 1024 1024"><path d="M194.56 0h461.641143L950.857143 292.571429v680.228571c0 12.8-4.827429 25.6-14.482286 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H194.56c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 146.285714 972.8V51.2c0-12.8 5.632-25.6 14.482286-35.84C169.618286 5.12 182.491429 0 194.56 0z m340.333714 395.264c-36.864 0-65.536 11.264-86.016 33.792-20.48 21.504-30.208 50.176-30.208 86.016h40.448c0-25.088 5.632-44.544 16.896-58.88 12.288-16.896 31.232-25.088 56.832-25.088 21.504 0 38.4 5.632 50.176 17.92 11.264 11.264 17.408 27.136 17.408 47.616 0 14.336-5.12 27.648-15.36 40.448-3.072 4.096-9.216 10.24-17.408 18.432-27.648 24.576-44.544 44.032-51.712 59.392-6.144 12.8-9.216 27.648-9.216 44.544v11.776h40.96v-11.776c0-13.824 3.072-26.112 9.728-37.376 5.12-9.216 12.8-18.432 24.064-28.16 22.528-19.968 36.352-33.28 41.472-39.424a96.548571 96.548571 0 0 0 19.456-59.904c0-30.72-9.728-54.784-28.672-72.192-19.968-18.432-46.08-27.136-78.848-27.136z m-7.68 311.808a29.330286 29.330286 0 0 0-22.016 8.704c-6.144 5.632-8.704 12.8-8.704 21.504s2.56 15.872 8.704 22.016a31.378286 31.378286 0 0 0 22.016 8.704 31.378286 31.378286 0 0 0 22.016-8.704 28.233143 28.233143 0 0 0 9.216-22.016 29.330286 29.330286 0 0 0-8.704-21.504 30.464 30.464 0 0 0-22.528-8.704z" fill="#FFB03C" ></path><path d="M950.857143 292.571429h-240.932572c-12.909714 0-26.697143-5.156571-36.132571-15.506286A49.517714 49.517714 0 0 1 658.285714 240.932571V0l292.571429 292.571429z" fill="#FFE5AB" ></path></symbol><symbol id="icon-icon_ex" viewBox="0 0 1024 1024"><path d="M157.988571 0h482.742858L914.285714 290.121143V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0z m391.424 551.424l127.012572-126.976-33.865143-33.865143-127.012571 126.976-124.16-124.16-34.633143 34.633143 124.16 124.16-126.976 127.012571 33.865143 33.865143 126.976-127.012571 124.196571 124.196571 34.633143-34.633143-124.196572-124.196571z" fill="#23D798" ></path><path d="M914.285714 279.771429h-225.28c-12.068571 0-24.941714-4.937143-33.792-14.811429a47.908571 47.908571 0 0 1-14.482285-34.56V0L914.285714 279.771429z" fill="#A2F4D7" ></path></symbol><symbol id="icon-icon_ppt" viewBox="0 0 1024 1024"><path d="M157.988571 0L621.714286 2.450286 914.285714 292.571429v680.228571c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0zM402.285714 365.714286v329.142857h65.316572v-125.622857h127.122285c69.668571 0 100.132571-51.090286 100.132572-101.339429C694.857143 415.085714 670.464 365.714286 593.846857 365.714286H402.285714z m65.316572 152.429714v-99.657143h110.592c25.234286 0 52.224 10.057143 52.224 50.249143 0 38.509714-20.041143 49.371429-57.453715 49.371429h-105.362285z" fill="#F57450" ></path><path d="M914.285714 292.571429h-240.932571c-12.909714 0-26.697143-5.156571-36.132572-15.506286A49.517714 49.517714 0 0 1 621.714286 240.932571V0l292.571428 292.571429z" fill="#FFD0C8" ></path></symbol><symbol id="icon-icon_pic" viewBox="0 0 1024 1024"><path d="M157.988571 0H658.285714l256 303.396571V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0zM672.914286 508.342857a80.457143 80.457143 0 1 0 0-160.914286 80.457143 80.457143 0 0 0 0 160.914286zM278.893714 754.176a379.904 379.904 0 0 1-0.950857-26.806857c0-132.315429 67.949714-237.312 147.090286-237.312 37.558857 0 81.115429 48.822857 126.537143 149.796571l7.314285 16.310857 3.291429-1.389714a54.052571 54.052571 0 0 0 71.68 6.948572c19.748571-14.482286 35.620571-21.321143 46.811429-21.321143 38.4 0 73.984 43.264 96.109714 113.773714H278.893714z m299.812572-146.102857l-1.28 0.548571c-48.530286-102.473143-98.121143-155.136-152.393143-155.136-103.497143 0-183.661714 123.867429-183.661714 273.883429 0 15.945143 0.914286 31.707429 2.669714 47.177143l1.865143 16.201143h578.486857L818.651429 768c-24.868571-98.340571-73.545143-164.169143-138.020572-164.169143-20.370286 0-42.934857 9.728-68.388571 28.379429a17.481143 17.481143 0 0 1-26.404572-7.314286l-7.131428-16.822857z" fill="#76D761" ></path><path d="M914.285714 292.571429h-210.834285a40.96 40.96 0 0 1-31.597715-15.506286c-9.033143-9.435429-13.568-23.222857-13.568-36.132572V0l256 292.571429z" fill="#BCFFB1" ></path></symbol><symbol id="icon-icon_txt" viewBox="0 0 1024 1024"><path d="M157.988571 0H658.285714l256 303.396571V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0z m242.102858 611.584V585.142857H237.714286v26.441143h66.121143v203.702857h29.878857v-203.702857h66.413714z m202.093714 203.702857l-72.96-116.041143L601.161143 585.142857h-34.011429l-47.542857 78.884572a188.050286 188.050286 0 0 0-8.777143 17.115428h-0.621714a157.805714 157.805714 0 0 0-8.045714-16.347428L456.777143 585.142857h-36.425143l70.436571 114.541714-76.507428 115.602286h36.242286l52.882285-86.454857a171.154286 171.154286 0 0 0 5.376-12.068571h0.731429c2.267429 5.961143 4.022857 9.947429 5.193143 11.922285l51.419428 86.601143h36.096z m184.100571-203.702857V585.142857h-162.377143v26.441143h66.084572v203.702857h29.878857v-203.702857H786.285714z" fill="#8F96A2" ></path><path d="M914.285714 292.571429h-210.834285a40.96 40.96 0 0 1-31.597715-15.506286c-9.033143-9.435429-13.568-23.222857-13.568-36.132572V0l256 292.571429z" fill="#CED0DA" ></path></symbol><symbol id="icon-icon_viedo" viewBox="0 0 1024 1024"><path d="M157.988571 0H658.285714l256 303.396571V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0z m646.546286 525.494857c0-61.622857-20.077714-66.669714-47.104-58.294857-9.508571 2.925714-19.748571 7.314286-30.939428 13.238857l-60.562286 36.754286v-41.728c0-20.224-14.738286-36.608-35.766857-36.608H332.324571C311.296 438.857143 292.571429 455.241143 292.571429 475.428571v246.930286c0 20.187429 18.724571 36.571429 39.753142 36.571429h297.837715c21.028571 0 35.766857-16.384 35.766857-36.571429v-52.516571l60.598857 36.827428c23.844571 9.837714 22.674286 9.142857 32.182857 12.470857h0.073143c26.843429 6.582857 45.787429 4.937143 45.787429-57.563428l-0.036572-136.082286z m-170.532571 148.114286h-0.109715v43.337143c0 6.582857-5.705143 10.057143-12.507428 10.057143l-284.233143-0.073143a12.288 12.288 0 0 1-12.544-11.995429v-44.105143c0.146286-37.010286 0.402286-8.228571 0-42.24v-145.737143c0-6.619429 5.632-11.995429 12.544-11.995428l286.72 0.109714c5.778286 1.462857 10.020571 3.291429 10.020571 9.874286v0.694857h0.109715v192.036571z m127.195428 10.752a24.795429 24.795429 0 0 1-12.873143-4.681143L665.965714 626.102857v-65.097143l82.651429-53.284571a23.588571 23.588571 0 0 1 12.726857-4.973714c10.349714 0 11.483429 15.433143 11.483429 22.052571v138.898286c0 6.217143-1.097143 20.699429-11.593143 20.699428z m-341.869714-183.003429c-28.050286 0-50.834286 21.869714-50.834286 48.822857 0 26.989714 22.784 48.859429 50.834286 48.859429 28.086857 0 50.834286-21.869714 50.834286-48.859429 0-26.953143-22.747429-48.822857-50.834286-48.822857z m0.182857 72.996572a24.832 24.832 0 0 1-25.307428-24.283429c0-13.458286 11.337143-24.32 25.307428-24.32 13.970286 0 25.307429 10.861714 25.307429 24.32 0 13.421714-11.337143 24.283429-25.307429 24.283429z" fill="#6F88F8" ></path><path d="M914.285714 292.571429h-210.834285a40.96 40.96 0 0 1-31.597715-15.506286c-9.033143-9.435429-13.568-23.222857-13.568-36.132572V0l256 292.571429z" fill="#BFDDFF" ></path></symbol><symbol id="icon-icon_zip" viewBox="0 0 1024 1024"><path d="M392.777143 0v90.331429H512V0h373.833143c15.725714 0 28.452571 12.726857 28.452571 28.452571v967.094858c0 15.725714-12.726857 28.452571-28.452571 28.452571H138.166857A28.452571 28.452571 0 0 1 109.714286 995.547429V28.452571C109.714286 12.726857 122.441143 0 138.166857 0h254.646857zM512 90.331429v90.368h119.222857v-90.331429H512z m-119.222857 90.368v90.331428H512v-90.331428h-119.222857zM512 271.030857v90.368h119.222857v-90.331428H512z m-119.222857 90.368v90.331429H512v-90.331429h-119.222857z m0 182.857143v90.331429H512v-90.331429h-119.222857z m119.222857-92.525714v90.404571h119.222857v-90.368H512z" fill="#F89845" ></path></symbol><symbol id="icon-icon_word" viewBox="0 0 1024 1024"><path d="M157.988571 0H658.285714l256 303.396571V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0zM329.142857 475.428571l81.846857 255.341715h56.173715l62.427428-196.059429h0.694857L592.018286 731.428571h56.173714L731.428571 475.428571h-54.125714l-56.832 198.692572L558.043429 475.428571h-54.125715l-61.732571 198.692572h-0.694857L385.316571 475.428571H329.142857z" fill="#4D97FF" ></path><path d="M914.285714 292.571429h-210.834285a40.96 40.96 0 0 1-31.597715-15.506286c-9.033143-9.435429-13.568-23.222857-13.568-36.132572V0l256 292.571429z" fill="#C4EAFF" ></path></symbol><symbol id="icon-icon_voice" viewBox="0 0 1024 1024"><path d="M157.988571 0H658.285714l256 303.396571V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0z m521.764572 412.891429a45.787429 45.787429 0 0 0-36.205714-9.618286l-227.474286 34.56c-25.965714 3.913143-46.299429 26.916571-46.299429 52.370286v220.525714a74.020571 74.020571 0 0 0-40.594285-12.068572c-40.411429 0-73.142857 32-73.142858 71.460572 0 39.497143 32.731429 71.460571 73.142858 71.460571 40.374857 0 73.106286-32 73.106285-71.460571v-202.825143l260.022857-39.424v142.153143a74.020571 74.020571 0 0 0-40.594285-12.068572c-40.411429 0-73.142857 32-73.142857 71.460572 0 39.497143 32.731429 71.460571 73.142857 71.460571 40.374857 0 73.142857-32 73.142857-71.460571v-283.574857c0-12.946286-5.485714-24.941714-15.104-32.950857zM329.216 809.801143c-22.418286 0-40.667429-17.773714-40.667429-39.68a40.228571 40.228571 0 0 1 40.667429-39.716572 40.228571 40.228571 0 0 1 40.594286 39.716572 40.228571 40.228571 0 0 1-40.594286 39.68zM402.285714 535.149714v-44.982857c0-9.691429 8.777143-19.456 18.761143-20.992l227.510857-34.486857a12.434286 12.434286 0 0 1 10.057143 2.304c2.523429 2.230857 3.876571 5.485714 3.730286 8.850286v49.92L402.285714 535.113143v0.036571z m219.428572 233.947429a40.228571 40.228571 0 0 1-40.630857-39.68 40.228571 40.228571 0 0 1 40.594285-39.68c22.418286 0 40.667429 17.810286 40.667429 39.68 0 21.906286-18.249143 39.68-40.667429 39.68z" fill="#C36FF8" ></path><path d="M914.285714 292.571429h-210.834285a40.96 40.96 0 0 1-31.597715-15.506286c-9.033143-9.435429-13.568-23.222857-13.568-36.132572V0l256 292.571429z" fill="#E1B1FF" ></path></symbol><symbol id="icon-icon_pdf" viewBox="0 0 1024 1024"><path d="M157.988571 0h482.742858L914.285714 290.121143V972.8c0 12.8-4.827429 25.6-14.482285 35.84-8.850286 10.24-21.723429 15.36-33.792 15.36H157.988571c-12.068571 0-24.137143-5.12-33.792-15.36A50.614857 50.614857 0 0 1 109.714286 972.8V51.2c0-12.8 5.632-25.6 14.482285-35.84C133.046857 5.12 145.92 0 157.988571 0z m502.491429 819.2c12.068571 0 23.332571-4.827429 33.792-13.714286 12.068571-12.141714 16.896-26.697143 13.677714-42.057143-8.045714-44.397714-80.457143-84.809143-141.604571-112.274285-15.286857-36.352-27.355429-75.922286-37.010286-113.92 42.642286-43.593143 105.398857-117.942857 91.721143-172.873143-4.022857-15.36-16.091429-35.547429-49.078857-45.238857-29.769143-8.886857-54.710857-2.413714-70.802286 17.773714-32.987429 42.020571-20.114286 133.302857-8.045714 189.842286-26.550857 25.856-56.32 50.102857-86.089143 71.094857-45.860571-11.300571-86.893714-16.969143-119.076571-16.969143-40.228571 0-66.779429 8.886857-79.652572 26.697143-6.436571 8.045714-12.068571 23.405714-5.632 45.202286 8.045714 26.697143 29.769143 42.057143 60.342857 42.057142 49.078857 0 112.64-37.193143 150.454857-62.244571a871.131429 871.131429 0 0 1 127.122286 42.825143c24.137143 56.539429 69.193143 143.798857 119.881143 143.798857z m-74.825143-122.806857c61.147429 30.72 86.893714 57.380571 90.112 73.508571 0.804571 3.254857 0.804571 7.314286-4.827428 12.946286-4.827429 4.022857-8.045714 4.864-10.459429 4.864-15.286857 0-44.251429-29.110857-74.825143-91.318857z m-297.691428-83.2c22.528 0 49.883429 3.218286 81.261714 9.691428-43.446857 25.856-80.457143 40.411429-106.203429 40.411429-20.918857 0-27.355429-9.691429-29.769143-19.382857-3.218286-11.337143 0-15.36 0.804572-16.969143 3.218286-4.022857 14.482286-13.750857 53.906286-13.750857z m159.305142-4.864a1480.009143 1480.009143 0 0 0 54.710858-45.238857c6.436571 23.442286 13.677714 47.689143 22.528 71.094857a866.413714 866.413714 0 0 0-77.238858-25.856zM547.035429 347.428571c4.827429 0 9.654857 0.804571 16.091428 3.218286 22.528 6.473143 25.746286 17.773714 26.550857 21.833143 6.436571 25.856-20.114286 74.313143-69.193143 126.829714-12.873143-67.84-11.264-121.161143 5.632-142.189714a25.892571 25.892571 0 0 1 20.918858-9.691429z" fill="#F55C68" ></path><path d="M914.285714 274.651429h-225.28c-12.068571 0-24.941714-4.827429-33.792-14.518858a46.592 46.592 0 0 1-14.482285-33.938285V0L914.285714 274.651429z" fill="#FFBBC0" ></path></symbol><symbol id="icon-denglu" viewBox="0 0 1024 1024"><path d="M179.346286 406.308571h613.668571c32.914286 0 58.88 27.062857 58.88 61.001143v446.902857c0 33.938286-26.112 61.001143-58.88 61.001143H179.346286a59.684571 59.684571 0 0 1-58.88-60.928V467.309714c0-33.938286 26.112-61.001143 58.88-61.001143zM454.217143 692.882286v96.256c0 6.875429 6.802286 6.875429 6.802286 6.875428h54.857142c6.875429 0 6.875429-6.875429 6.875429-6.875428V692.882286c25.746286-13.165714 41.691429-39.862857 41.179429-68.754286A76.214857 76.214857 0 0 0 488.374857 548.571429a76.214857 76.214857 0 0 0-75.337143 75.556571c0 34.450286 13.824 55.003429 41.179429 68.754286z m24.210286-590.409143c-92.16 0-176.786286 68.461714-176.786286 157.184v164.059428H201.728V253.074286C201.728 116.150857 324.754286 0 486.180571 0c153.746286 0 284.452571 109.421714 284.452572 252.928v234.642286H655.213714V259.730286c0-81.993143-76.726857-157.257143-176.713143-157.257143z"  ></path></symbol><symbol id="icon-gengduo" viewBox="0 0 1024 1024"><path d="M512 1024c-282.624 0-512-229.952-512-512s229.952-512 512-512 512 229.952 512 512-229.952 512-512 512zM512 47.552C256.576 47.552 47.552 256 47.552 512 47.552 768 256 976.448 512 976.448c256 0 464.448-208.448 464.448-464.448C976.448 256 768 47.552 512 47.552z m60.608 672.896l-33.984-33.984L713.6 511.36 538.624 336.448l33.92-33.984 208.512 208.96-208.448 209.024zM276.416 487.616h449.664v48.192H276.48v-48.192z"  ></path></symbol><symbol id="icon-huifang" viewBox="0 0 1024 1024"><path d="M0.711403 578.413779a40.944032 40.944032 0 1 1 81.184338-10.299983c31.987525 235.044333 247.199592 400.931637 483.0756 369.839762a429.912334 429.912334 0 0 0-112.340187-852.147662 428.568858 428.568858 0 0 0-280.850468 159.873649 42.223533 42.223533 0 0 1-57.89742 8.636632 42.223533 42.223533 0 0 1-8.636632-57.833445c0-0.959626 0.831676-0.959626 0.831675-1.791302a514.167475 514.167475 0 0 1 719.911235-84.63899c222.185348 174.523936 260.122552 496.958186 84.702966 719.079559a511.608473 511.608473 0 0 1-719.015584 84.63899A513.591699 513.591699 0 0 1 0.583452 578.413779h0.127951z m629.002689-66.534052L450.008177 386.552604v251.549896l179.76989-126.222773z m40.688131 50.092464l-179.76989 126.222773a70.69243 70.69243 0 0 1-94.235248-12.155259 65.894301 65.894301 0 0 1-13.818611-37.937205V386.552604c0-34.546527 30.324174-63.079399 67.429703-63.079399 14.714261 0 28.532872 4.350303 40.560181 12.986936l179.002189 125.327122a61.288098 61.288098 0 0 1 13.754636 88.093643c-3.838503 4.478253-8.188806 8.572657-12.92296 12.15526v-0.063975zM114.714941 229.365907l151.300993 40.560182c16.569538 4.478253 26.549646 21.431642 22.391267 38.065154a31.603675 31.603675 0 0 1-37.937204 22.455243h-0.895651l-151.237018-40.560182-60.520397-16.505562L94.882676 60.727676a31.603675 31.603675 0 0 1 38.065154-22.391267 32.0515 32.0515 0 0 1 22.391268 38.832855v0.831676L114.714941 229.429882z"  ></path></symbol><symbol id="icon-xiazai" viewBox="0 0 1024 1024"><path d="M113.834667 448v398.250667h796.330666V448H1024v455.082667a56.917333 56.917333 0 0 1-56.917333 56.917333H56.917333A56.917333 56.917333 0 0 1 0 903.082667V448h113.834667zM568.917333 0v398.250667H709.973333a14.250667 14.250667 0 0 1 11.093334 23.04l-197.973334 247.466666a14.165333 14.165333 0 0 1-22.186666 0l-197.973334-247.466666a14.250667 14.250667 0 0 1 11.093334-23.04h141.056V0h113.834666z"  ></path></symbol><symbol id="icon-mima" viewBox="0 0 1024 1024"><path d="M853.4016 436.224L292.0448 435.3024c-0.2048-74.8032-20.5312-190.7712 43.9296-261.1712a255.4368 255.4368 0 0 1 176.128-87.04c104.3456 0 182.3744 77.824 220.16 174.1312 11.008 27.7504 20.736 42.752 43.9296 43.52 58.5216 1.792 54.8352-59.2896 43.8784-87.04C765.4912 78.6944 663.0912 0 511.8464 0c-102.912 0-159.488 20.8384-220.2112 87.04-92.928 101.1712-88.32 264.704-88.064 348.2112l-32.9728 0.9728a54.6304 54.6304 0 0 0-55.296 53.9648v456.9088c0.3072 30.208 25.0368 54.4256 55.1936 54.1184H852.5824a54.6816 54.6816 0 0 0 55.296-54.016V490.24a54.5792 54.5792 0 0 0-55.1936-53.9648h-0.1024 0.8192z m-31.3856 434.0224a41.472 41.472 0 0 1-12.9536 30.8224 42.6496 42.6496 0 0 1-31.1808 12.8H248.4224a42.24 42.24 0 0 1-31.1296-12.8 41.8304 41.8304 0 0 1-13.0048-30.8224v-305.2544a43.9296 43.9296 0 0 1 44.1344-43.52h529.408a43.8784 43.8784 0 0 1 44.1344 43.52v305.2544z"  ></path></symbol><symbol id="icon-shang" viewBox="0 0 1024 1024"><path d="M548.205714 311.296c-10.24-10.971429-24.137143-21.284571-37.302857-18.139429-13.165714-2.340571-25.6 8.704-35.84 18.139429l-316.708571 343.844571a47.469714 47.469714 0 0 0 0 63.268572c16.091429 17.334857 42.422857 17.334857 58.514285 0l294.765715-327.241143 295.497143 327.241143c16.091429 17.334857 42.422857 17.334857 58.514285 0a47.469714 47.469714 0 0 0 0-63.268572l-317.44-343.771428z"  ></path></symbol><symbol id="icon-xia" viewBox="0 0 1024 1024"><path d="M548.205714 712.704c-10.24 10.971429-24.137143 21.284571-37.302857 18.139429-13.165714 2.340571-25.6-8.704-35.84-18.139429l-316.708571-343.844571a47.469714 47.469714 0 0 1 0-63.268572 39.350857 39.350857 0 0 1 58.514285 0l294.765715 327.241143 295.497143-327.241143a39.350857 39.350857 0 0 1 58.514285 0c16.091429 17.408 16.091429 45.860571 0 63.268572l-317.44 343.771428z"  ></path></symbol><symbol id="icon-zhanghao" viewBox="0 0 1024 1024"><path d="M632.9856 525.0048c174.2336 44.032 292.1472 185.4976 350.208 417.8944a46.3872 46.3872 0 0 1-90.0096 22.528c-61.44-245.8624-187.8528-362.496-385.6896-362.496-197.8368 0-324.3008 116.6336-385.6384 362.496a46.4384 46.4384 0 0 1-90.112-22.528c58.112-232.3456 176.0256-373.8624 350.208-417.8944a265.0112 265.0112 0 1 1 251.0848 0h-0.0512zM507.4944 463.7696a172.288 172.288 0 1 0 0-344.576 172.288 172.288 0 0 0 0 344.576z"  ></path></symbol><symbol id="icon-sousuo" viewBox="0 0 1024 1024"><path d="M498.432 14.528c223.36 19.584 387.968 222.464 367.808 453.248a426.304 426.304 0 0 1-113.984 256l199.616 243.968-61.12 49.92-197.888-241.792a396.48 396.48 0 0 1-267.52 74.368C201.984 830.592 37.376 627.712 57.536 396.992 77.76 166.272 275.2-4.928 498.56 14.528z m-6.848 78.592c-179.328-15.68-338.944 122.88-355.456 310.784-16.384 187.84 116.8 352 296 367.616 179.392 15.744 339.008-122.752 355.52-310.656 16.448-187.904-116.8-352-296.064-367.68z"  ></path></symbol><symbol id="icon-shenfen" viewBox="0 0 1117 1024"><path d="M587.031273 938.821818H64.791273a44.171636 44.171636 0 0 1-44.497455-44.962909s0-163.095273 116.782546-222.114909c75.031273-36.584727 47.243636-8.424727 136.238545-45.009455 91.694545-39.330909 113.989818-50.594909 113.989818-50.594909v-89.972363s-33.373091-25.320727-44.497454-109.661091c-22.248727 5.632-27.787636-25.274182-30.580364-44.962909 0-19.688727-11.170909-81.547636 13.870546-75.915637-5.538909-42.170182-8.331636-78.754909-8.331637-98.397091 5.585455-67.490909 72.285091-140.567273 172.404364-146.245818 116.782545 5.632 164.026182 75.915636 172.357818 146.245818 2.792727 19.642182-2.792727 56.226909-8.331636 98.397091 25.041455-5.632 13.917091 56.226909 13.917091 75.869091 0 19.735273-8.378182 50.641455-30.580364 45.009455-11.170909 84.340364-44.497455 109.661091-44.497455 109.661091v87.179636s5.771636 2.885818 23.505455 10.938182a324.235636 324.235636 0 0 0-68.421818 199.912727c0 55.994182 14.103273 108.683636 38.912 154.624z"  ></path><path d="M853.457455 542.301091c125.765818 0 226.397091 103.936 226.39709 233.890909 0 129.861818-100.631273 233.844364-226.39709 233.844364s-226.397091-103.936-226.397091-233.844364c0-129.954909 100.631273-233.890909 226.397091-233.890909z m100.352 120.087273c-6.562909-3.397818-19.781818-3.397818-26.391273 6.842181l-90.158546 123.252364-45.568-36.072727a19.549091 19.549091 0 0 0-26.391272 0l-16.477091 17.035636c-6.609455 6.795636-9.728 17.501091 0 27.229091 3.770182 3.816727 16.290909 14.615273 30.254545 26.344727l12.055273 10.193455c18.106182 15.220364 34.955636 29.184 34.955636 29.184 3.304727 6.795636 27.508364 9.169455 39.610182-7.633455l114.501818-155.461818s6.190545-14.754909 0-20.061091c-3.258182-6.842182-26.391273-20.805818-26.391272-20.805818z"  ></path></symbol></svg>', s = (s = document.getElementsByTagName("script"))[s.length - 1].getAttribute("data-injectcss"), l = function(f, d) {
    d.parentNode.insertBefore(f, d);
  };
  if (s && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (f) {
      console && console.log(f);
    }
  }
  function u() {
    a || (a = !0, r());
  }
  function c() {
    try {
      i.documentElement.doScroll("left");
    } catch {
      return void setTimeout(c, 50);
    }
    u();
  }
  t = function() {
    var f, d = document.createElement("div");
    d.innerHTML = o, o = null, (d = d.getElementsByTagName("svg")[0]) && (d.setAttribute("aria-hidden", "true"), d.style.position = "absolute", d.style.width = 0, d.style.height = 0, d.style.overflow = "hidden", d = d, (f = document.body).firstChild ? l(d, f.firstChild) : f.appendChild(d));
  }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(t, 0) : (n = function() {
    document.removeEventListener("DOMContentLoaded", n, !1), t();
  }, document.addEventListener("DOMContentLoaded", n, !1)) : document.attachEvent && (r = t, i = e.document, a = !1, c(), i.onreadystatechange = function() {
    i.readyState == "complete" && (i.onreadystatechange = null, u());
  });
})(window);
Md.name = "diff-mark";
Md.install = (e) => {
  e.component(Md.name, Md);
};
const cbe = { class: "couver-upload" }, dbe = { class: "upload-warp" }, fbe = ["src"], hbe = {
  key: 1,
  class: "upload-btn"
}, pbe = /* @__PURE__ */ Ee({
  props: {
    coverUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["onSuccess"],
  setup(e, { emit: t }) {
    const n = e, { getPolicy: r } = ce("$http"), i = zt({
      url: "",
      id: ""
    }), a = j(""), o = zt({}), s = ({
      data: c
    }) => {
      i.id = c.id, i.url = c.fileUrl, t("onSuccess", i);
    }, l = (c) => {
      const f = c.type === "image/jpeg", d = c.type === "image/png";
      if (!f && !d) {
        An.error("\u4E0A\u4F20\u56FE\u7247\u53EA\u80FD\u662F JPG/PNG \u683C\u5F0F!");
        return;
      }
      return new Promise(async (h, p) => {
        try {
          const y = await r({ fileName: c.name }), m = JSON.parse(y);
          a.value = m.host, o.key = m.dir + m.fileUUID + "." + c.name.substring(c.name.lastIndexOf(".") + 1, c.name.length), o.policy = m.policy, o.OSSAccessKeyId = m.accessid, o.success_action_status = 200, o.callback = m.callback, o.signature = m.signature, h(!0);
        } catch (y) {
          console.log(y), p(!1);
        }
      });
    }, u = j("");
    return Ne(() => n.coverUrl, (c) => {
      u.value = c;
    }, { immediate: !0 }), (c, f) => {
      const d = yf;
      return P(), L("div", cbe, [
        B(d, {
          class: "couver-upload",
          action: a.value,
          data: E(o),
          "show-file-list": !1,
          "on-success": s,
          "before-upload": l,
          accept: "image/*"
        }, {
          default: N(() => [
            T("div", dbe, [
              u.value ? (P(), L("img", {
                key: 0,
                src: u.value
              }, null, 8, fbe)) : re("", !0),
              u.value ? (P(), L("div", hbe, [
                tt(c.$slots, "hoverIcon", {}, void 0, !0)
              ])) : tt(c.$slots, "uploadIcon", { key: 2 }, void 0, !0)
            ])
          ]),
          _: 3
        }, 8, ["action", "data"])
      ]);
    };
  }
});
const Hd = /* @__PURE__ */ Ht(pbe, [["__scopeId", "data-v-7593d0fe"]]);
Hd.name = "image-upload";
Hd.install = (e) => {
  e.component(Hd.name, Hd);
};
const vbe = "zhs-", _C = [
  vd,
  bi,
  qi,
  zs,
  Hu,
  Tl,
  Ou,
  Md,
  Hd
], mbe = (e) => {
  _C.map((t) => e.component(vbe + t.name, t));
}, Cbe = {
  install: mbe,
  ..._C
};
export {
  wy as AUDIOTYPES,
  Tbe as PAGETYPES,
  xy as PICTYPES,
  Abe as TEXTTYPES,
  Py as VIDEOTYPES,
  Tl as ZhsAvatar,
  vd as ZhsCaptcha,
  Hu as ZhsCoverUpload,
  Md as ZhsDiffMark,
  bi as ZhsEmpty,
  Ou as ZhsGroundGlassbg,
  Hd as ZhsImageUpload,
  qi as ZhsSvgIcon,
  zs as ZhsTinymce,
  gD as converByte,
  O0 as dateTransfer,
  Dl as deepClone,
  Cbe as default,
  wbe as emailRegExp,
  Cy as formatDate,
  Sy as formatIcons,
  yD as getContentText,
  bD as getImage,
  V1 as getUrlParams,
  xbe as httpRegExp,
  kr as loadJs,
  Pbe as phoneRegExp
};
